function fne(t, e) {
  for (var n = 0; n < e.length; n++) {
    const r = e[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const i in r)
        if (i !== "default" && !(i in t)) {
          const a = Object.getOwnPropertyDescriptor(r, i);
          a && Object.defineProperty(t, i, a.get ? a : {
            enumerable: !0,
            get: () => r[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
var mC = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function J0(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function hne(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var XD = { exports: {} }, xS = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uP;
function pne() {
  if (uP)
    return xS;
  uP = 1;
  var t = Symbol.for("react.transitional.element"), e = Symbol.for("react.fragment");
  function n(r, i, a) {
    var s = null;
    if (a !== void 0 && (s = "" + a), i.key !== void 0 && (s = "" + i.key), "key" in i) {
      a = {};
      for (var c in i)
        c !== "key" && (a[c] = i[c]);
    } else
      a = i;
    return i = a.ref, {
      $$typeof: t,
      type: r,
      key: s,
      ref: i !== void 0 ? i : null,
      props: a
    };
  }
  return xS.Fragment = e, xS.jsx = n, xS.jsxs = n, xS;
}
var SS = {}, WD = { exports: {} }, dn = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dP;
function mne() {
  if (dP)
    return dn;
  dP = 1;
  var t = Symbol.for("react.transitional.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), m = Symbol.for("react.activity"), b = Symbol.iterator;
  function w(B) {
    return B === null || typeof B != "object" ? null : (B = b && B[b] || B["@@iterator"], typeof B == "function" ? B : null);
  }
  var _ = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, A = Object.assign, T = {};
  function O(B, te, ae) {
    this.props = B, this.context = te, this.refs = T, this.updater = ae || _;
  }
  O.prototype.isReactComponent = {}, O.prototype.setState = function(B, te) {
    if (typeof B != "object" && typeof B != "function" && B != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, B, te, "setState");
  }, O.prototype.forceUpdate = function(B) {
    this.updater.enqueueForceUpdate(this, B, "forceUpdate");
  };
  function R() {
  }
  R.prototype = O.prototype;
  function N(B, te, ae) {
    this.props = B, this.context = te, this.refs = T, this.updater = ae || _;
  }
  var M = N.prototype = new R();
  M.constructor = N, A(M, O.prototype), M.isPureReactComponent = !0;
  var P = Array.isArray;
  function z() {
  }
  var F = { H: null, A: null, T: null, S: null }, $ = Object.prototype.hasOwnProperty;
  function G(B, te, ae) {
    var le = ae.ref;
    return {
      $$typeof: t,
      type: B,
      key: te,
      ref: le !== void 0 ? le : null,
      props: ae
    };
  }
  function H(B, te) {
    return G(B.type, te, B.props);
  }
  function Z(B) {
    return typeof B == "object" && B !== null && B.$$typeof === t;
  }
  function V(B) {
    var te = { "=": "=0", ":": "=2" };
    return "$" + B.replace(/[=:]/g, function(ae) {
      return te[ae];
    });
  }
  var Y = /\/+/g;
  function ee(B, te) {
    return typeof B == "object" && B !== null && B.key != null ? V("" + B.key) : te.toString(36);
  }
  function K(B) {
    switch (B.status) {
      case "fulfilled":
        return B.value;
      case "rejected":
        throw B.reason;
      default:
        switch (typeof B.status == "string" ? B.then(z, z) : (B.status = "pending", B.then(
          function(te) {
            B.status === "pending" && (B.status = "fulfilled", B.value = te);
          },
          function(te) {
            B.status === "pending" && (B.status = "rejected", B.reason = te);
          }
        )), B.status) {
          case "fulfilled":
            return B.value;
          case "rejected":
            throw B.reason;
        }
    }
    throw B;
  }
  function U(B, te, ae, le, de) {
    var _e = typeof B;
    (_e === "undefined" || _e === "boolean") && (B = null);
    var ue = !1;
    if (B === null)
      ue = !0;
    else
      switch (_e) {
        case "bigint":
        case "string":
        case "number":
          ue = !0;
          break;
        case "object":
          switch (B.$$typeof) {
            case t:
            case e:
              ue = !0;
              break;
            case g:
              return ue = B._init, U(
                ue(B._payload),
                te,
                ae,
                le,
                de
              );
          }
      }
    if (ue)
      return de = de(B), ue = le === "" ? "." + ee(B, 0) : le, P(de) ? (ae = "", ue != null && (ae = ue.replace(Y, "$&/") + "/"), U(de, te, ae, "", function(Me) {
        return Me;
      })) : de != null && (Z(de) && (de = H(
        de,
        ae + (de.key == null || B && B.key === de.key ? "" : ("" + de.key).replace(
          Y,
          "$&/"
        ) + "/") + ue
      )), te.push(de)), 1;
    ue = 0;
    var Se = le === "" ? "." : le + ":";
    if (P(B))
      for (var Ne = 0; Ne < B.length; Ne++)
        le = B[Ne], _e = Se + ee(le, Ne), ue += U(
          le,
          te,
          ae,
          _e,
          de
        );
    else if (Ne = w(B), typeof Ne == "function")
      for (B = Ne.call(B), Ne = 0; !(le = B.next()).done; )
        le = le.value, _e = Se + ee(le, Ne++), ue += U(
          le,
          te,
          ae,
          _e,
          de
        );
    else if (_e === "object") {
      if (typeof B.then == "function")
        return U(
          K(B),
          te,
          ae,
          le,
          de
        );
      throw te = String(B), Error(
        "Objects are not valid as a React child (found: " + (te === "[object Object]" ? "object with keys {" + Object.keys(B).join(", ") + "}" : te) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return ue;
  }
  function q(B, te, ae) {
    if (B == null)
      return B;
    var le = [], de = 0;
    return U(B, le, "", "", function(_e) {
      return te.call(ae, _e, de++);
    }), le;
  }
  function W(B) {
    if (B._status === -1) {
      var te = B._result;
      te = te(), te.then(
        function(ae) {
          (B._status === 0 || B._status === -1) && (B._status = 1, B._result = ae);
        },
        function(ae) {
          (B._status === 0 || B._status === -1) && (B._status = 2, B._result = ae);
        }
      ), B._status === -1 && (B._status = 0, B._result = te);
    }
    if (B._status === 1)
      return B._result.default;
    throw B._result;
  }
  var ie = typeof reportError == "function" ? reportError : function(B) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var te = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof B == "object" && B !== null && typeof B.message == "string" ? String(B.message) : String(B),
        error: B
      });
      if (!window.dispatchEvent(te))
        return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", B);
      return;
    }
    console.error(B);
  }, J = {
    map: q,
    forEach: function(B, te, ae) {
      q(
        B,
        function() {
          te.apply(this, arguments);
        },
        ae
      );
    },
    count: function(B) {
      var te = 0;
      return q(B, function() {
        te++;
      }), te;
    },
    toArray: function(B) {
      return q(B, function(te) {
        return te;
      }) || [];
    },
    only: function(B) {
      if (!Z(B))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return B;
    }
  };
  return dn.Activity = m, dn.Children = J, dn.Component = O, dn.Fragment = n, dn.Profiler = i, dn.PureComponent = N, dn.StrictMode = r, dn.Suspense = d, dn.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = F, dn.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(B) {
      return F.H.useMemoCache(B);
    }
  }, dn.cache = function(B) {
    return function() {
      return B.apply(null, arguments);
    };
  }, dn.cacheSignal = function() {
    return null;
  }, dn.cloneElement = function(B, te, ae) {
    if (B == null)
      throw Error(
        "The argument must be a React element, but you passed " + B + "."
      );
    var le = A({}, B.props), de = B.key;
    if (te != null)
      for (_e in te.key !== void 0 && (de = "" + te.key), te)
        !$.call(te, _e) || _e === "key" || _e === "__self" || _e === "__source" || _e === "ref" && te.ref === void 0 || (le[_e] = te[_e]);
    var _e = arguments.length - 2;
    if (_e === 1)
      le.children = ae;
    else if (1 < _e) {
      for (var ue = Array(_e), Se = 0; Se < _e; Se++)
        ue[Se] = arguments[Se + 2];
      le.children = ue;
    }
    return G(B.type, de, le);
  }, dn.createContext = function(B) {
    return B = {
      $$typeof: s,
      _currentValue: B,
      _currentValue2: B,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, B.Provider = B, B.Consumer = {
      $$typeof: a,
      _context: B
    }, B;
  }, dn.createElement = function(B, te, ae) {
    var le, de = {}, _e = null;
    if (te != null)
      for (le in te.key !== void 0 && (_e = "" + te.key), te)
        $.call(te, le) && le !== "key" && le !== "__self" && le !== "__source" && (de[le] = te[le]);
    var ue = arguments.length - 2;
    if (ue === 1)
      de.children = ae;
    else if (1 < ue) {
      for (var Se = Array(ue), Ne = 0; Ne < ue; Ne++)
        Se[Ne] = arguments[Ne + 2];
      de.children = Se;
    }
    if (B && B.defaultProps)
      for (le in ue = B.defaultProps, ue)
        de[le] === void 0 && (de[le] = ue[le]);
    return G(B, _e, de);
  }, dn.createRef = function() {
    return { current: null };
  }, dn.forwardRef = function(B) {
    return { $$typeof: c, render: B };
  }, dn.isValidElement = Z, dn.lazy = function(B) {
    return {
      $$typeof: g,
      _payload: { _status: -1, _result: B },
      _init: W
    };
  }, dn.memo = function(B, te) {
    return {
      $$typeof: f,
      type: B,
      compare: te === void 0 ? null : te
    };
  }, dn.startTransition = function(B) {
    var te = F.T, ae = {};
    F.T = ae;
    try {
      var le = B(), de = F.S;
      de !== null && de(ae, le), typeof le == "object" && le !== null && typeof le.then == "function" && le.then(z, ie);
    } catch (_e) {
      ie(_e);
    } finally {
      te !== null && ae.types !== null && (te.types = ae.types), F.T = te;
    }
  }, dn.unstable_useCacheRefresh = function() {
    return F.H.useCacheRefresh();
  }, dn.use = function(B) {
    return F.H.use(B);
  }, dn.useActionState = function(B, te, ae) {
    return F.H.useActionState(B, te, ae);
  }, dn.useCallback = function(B, te) {
    return F.H.useCallback(B, te);
  }, dn.useContext = function(B) {
    return F.H.useContext(B);
  }, dn.useDebugValue = function() {
  }, dn.useDeferredValue = function(B, te) {
    return F.H.useDeferredValue(B, te);
  }, dn.useEffect = function(B, te) {
    return F.H.useEffect(B, te);
  }, dn.useEffectEvent = function(B) {
    return F.H.useEffectEvent(B);
  }, dn.useId = function() {
    return F.H.useId();
  }, dn.useImperativeHandle = function(B, te, ae) {
    return F.H.useImperativeHandle(B, te, ae);
  }, dn.useInsertionEffect = function(B, te) {
    return F.H.useInsertionEffect(B, te);
  }, dn.useLayoutEffect = function(B, te) {
    return F.H.useLayoutEffect(B, te);
  }, dn.useMemo = function(B, te) {
    return F.H.useMemo(B, te);
  }, dn.useOptimistic = function(B, te) {
    return F.H.useOptimistic(B, te);
  }, dn.useReducer = function(B, te, ae) {
    return F.H.useReducer(B, te, ae);
  }, dn.useRef = function(B) {
    return F.H.useRef(B);
  }, dn.useState = function(B) {
    return F.H.useState(B);
  }, dn.useSyncExternalStore = function(B, te, ae) {
    return F.H.useSyncExternalStore(
      B,
      te,
      ae
    );
  }, dn.useTransition = function() {
    return F.H.useTransition();
  }, dn.version = "19.2.0", dn;
}
var XS = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
XS.exports;
var fP;
function gne() {
  return fP || (fP = 1, function(t, e) {
    process.env.NODE_ENV !== "production" && function() {
      function n(re, Ae) {
        Object.defineProperty(a.prototype, re, {
          get: function() {
            console.warn(
              "%s(...) is deprecated in plain JavaScript React classes. %s",
              Ae[0],
              Ae[1]
            );
          }
        });
      }
      function r(re) {
        return re === null || typeof re != "object" ? null : (re = Ue && re[Ue] || re["@@iterator"], typeof re == "function" ? re : null);
      }
      function i(re, Ae) {
        re = (re = re.constructor) && (re.displayName || re.name) || "ReactClass";
        var nt = re + "." + Ae;
        rt[nt] || (console.error(
          "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",
          Ae,
          re
        ), rt[nt] = !0);
      }
      function a(re, Ae, nt) {
        this.props = re, this.context = Ae, this.refs = wt, this.updater = nt || it;
      }
      function s() {
      }
      function c(re, Ae, nt) {
        this.props = re, this.context = Ae, this.refs = wt, this.updater = nt || it;
      }
      function d() {
      }
      function f(re) {
        return "" + re;
      }
      function g(re) {
        try {
          f(re);
          var Ae = !1;
        } catch {
          Ae = !0;
        }
        if (Ae) {
          Ae = console;
          var nt = Ae.error, st = typeof Symbol == "function" && Symbol.toStringTag && re[Symbol.toStringTag] || re.constructor.name || "Object";
          return nt.call(
            Ae,
            "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
            st
          ), f(re);
        }
      }
      function m(re) {
        if (re == null)
          return null;
        if (typeof re == "function")
          return re.$$typeof === Ct ? null : re.displayName || re.name || null;
        if (typeof re == "string")
          return re;
        switch (re) {
          case B:
            return "Fragment";
          case ae:
            return "Profiler";
          case te:
            return "StrictMode";
          case ue:
            return "Suspense";
          case Se:
            return "SuspenseList";
          case Ce:
            return "Activity";
        }
        if (typeof re == "object")
          switch (typeof re.tag == "number" && console.error(
            "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
          ), re.$$typeof) {
            case J:
              return "Portal";
            case de:
              return re.displayName || "Context";
            case le:
              return (re._context.displayName || "Context") + ".Consumer";
            case _e:
              var Ae = re.render;
              return re = re.displayName, re || (re = Ae.displayName || Ae.name || "", re = re !== "" ? "ForwardRef(" + re + ")" : "ForwardRef"), re;
            case Ne:
              return Ae = re.displayName || null, Ae !== null ? Ae : m(re.type) || "Memo";
            case Me:
              Ae = re._payload, re = re._init;
              try {
                return m(re(Ae));
              } catch {
              }
          }
        return null;
      }
      function b(re) {
        if (re === B)
          return "<>";
        if (typeof re == "object" && re !== null && re.$$typeof === Me)
          return "<...>";
        try {
          var Ae = m(re);
          return Ae ? "<" + Ae + ">" : "<...>";
        } catch {
          return "<...>";
        }
      }
      function w() {
        var re = se.A;
        return re === null ? null : re.getOwner();
      }
      function _() {
        return Error("react-stack-top-frame");
      }
      function A(re) {
        if (ge.call(re, "key")) {
          var Ae = Object.getOwnPropertyDescriptor(re, "key").get;
          if (Ae && Ae.isReactWarning)
            return !1;
        }
        return re.key !== void 0;
      }
      function T(re, Ae) {
        function nt() {
          He || (He = !0, console.error(
            "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
            Ae
          ));
        }
        nt.isReactWarning = !0, Object.defineProperty(re, "key", {
          get: nt,
          configurable: !0
        });
      }
      function O() {
        var re = m(this.type);
        return Ze[re] || (Ze[re] = !0, console.error(
          "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
        )), re = this.props.ref, re !== void 0 ? re : null;
      }
      function R(re, Ae, nt, st, lt, bt) {
        var Ke = nt.ref;
        return re = {
          $$typeof: ie,
          type: re,
          key: Ae,
          props: nt,
          _owner: st
        }, (Ke !== void 0 ? Ke : null) !== null ? Object.defineProperty(re, "ref", {
          enumerable: !1,
          get: O
        }) : Object.defineProperty(re, "ref", { enumerable: !1, value: null }), re._store = {}, Object.defineProperty(re._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: 0
        }), Object.defineProperty(re, "_debugInfo", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: null
        }), Object.defineProperty(re, "_debugStack", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: lt
        }), Object.defineProperty(re, "_debugTask", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: bt
        }), Object.freeze && (Object.freeze(re.props), Object.freeze(re)), re;
      }
      function N(re, Ae) {
        return Ae = R(
          re.type,
          Ae,
          re.props,
          re._owner,
          re._debugStack,
          re._debugTask
        ), re._store && (Ae._store.validated = re._store.validated), Ae;
      }
      function M(re) {
        P(re) ? re._store && (re._store.validated = 1) : typeof re == "object" && re !== null && re.$$typeof === Me && (re._payload.status === "fulfilled" ? P(re._payload.value) && re._payload.value._store && (re._payload.value._store.validated = 1) : re._store && (re._store.validated = 1));
      }
      function P(re) {
        return typeof re == "object" && re !== null && re.$$typeof === ie;
      }
      function z(re) {
        var Ae = { "=": "=0", ":": "=2" };
        return "$" + re.replace(/[=:]/g, function(nt) {
          return Ae[nt];
        });
      }
      function F(re, Ae) {
        return typeof re == "object" && re !== null && re.key != null ? (g(re.key), z("" + re.key)) : Ae.toString(36);
      }
      function $(re) {
        switch (re.status) {
          case "fulfilled":
            return re.value;
          case "rejected":
            throw re.reason;
          default:
            switch (typeof re.status == "string" ? re.then(d, d) : (re.status = "pending", re.then(
              function(Ae) {
                re.status === "pending" && (re.status = "fulfilled", re.value = Ae);
              },
              function(Ae) {
                re.status === "pending" && (re.status = "rejected", re.reason = Ae);
              }
            )), re.status) {
              case "fulfilled":
                return re.value;
              case "rejected":
                throw re.reason;
            }
        }
        throw re;
      }
      function G(re, Ae, nt, st, lt) {
        var bt = typeof re;
        (bt === "undefined" || bt === "boolean") && (re = null);
        var Ke = !1;
        if (re === null)
          Ke = !0;
        else
          switch (bt) {
            case "bigint":
            case "string":
            case "number":
              Ke = !0;
              break;
            case "object":
              switch (re.$$typeof) {
                case ie:
                case J:
                  Ke = !0;
                  break;
                case Me:
                  return Ke = re._init, G(
                    Ke(re._payload),
                    Ae,
                    nt,
                    st,
                    lt
                  );
              }
          }
        if (Ke) {
          Ke = re, lt = lt(Ke);
          var ut = st === "" ? "." + F(Ke, 0) : st;
          return On(lt) ? (nt = "", ut != null && (nt = ut.replace(sn, "$&/") + "/"), G(lt, Ae, nt, "", function(en) {
            return en;
          })) : lt != null && (P(lt) && (lt.key != null && (Ke && Ke.key === lt.key || g(lt.key)), nt = N(
            lt,
            nt + (lt.key == null || Ke && Ke.key === lt.key ? "" : ("" + lt.key).replace(
              sn,
              "$&/"
            ) + "/") + ut
          ), st !== "" && Ke != null && P(Ke) && Ke.key == null && Ke._store && !Ke._store.validated && (nt._store.validated = 2), lt = nt), Ae.push(lt)), 1;
        }
        if (Ke = 0, ut = st === "" ? "." : st + ":", On(re))
          for (var ft = 0; ft < re.length; ft++)
            st = re[ft], bt = ut + F(st, ft), Ke += G(
              st,
              Ae,
              nt,
              bt,
              lt
            );
        else if (ft = r(re), typeof ft == "function")
          for (ft === re.entries && (Rt || console.warn(
            "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
          ), Rt = !0), re = ft.call(re), ft = 0; !(st = re.next()).done; )
            st = st.value, bt = ut + F(st, ft++), Ke += G(
              st,
              Ae,
              nt,
              bt,
              lt
            );
        else if (bt === "object") {
          if (typeof re.then == "function")
            return G(
              $(re),
              Ae,
              nt,
              st,
              lt
            );
          throw Ae = String(re), Error(
            "Objects are not valid as a React child (found: " + (Ae === "[object Object]" ? "object with keys {" + Object.keys(re).join(", ") + "}" : Ae) + "). If you meant to render a collection of children, use an array instead."
          );
        }
        return Ke;
      }
      function H(re, Ae, nt) {
        if (re == null)
          return re;
        var st = [], lt = 0;
        return G(re, st, "", "", function(bt) {
          return Ae.call(nt, bt, lt++);
        }), st;
      }
      function Z(re) {
        if (re._status === -1) {
          var Ae = re._ioInfo;
          Ae != null && (Ae.start = Ae.end = performance.now()), Ae = re._result;
          var nt = Ae();
          if (nt.then(
            function(lt) {
              if (re._status === 0 || re._status === -1) {
                re._status = 1, re._result = lt;
                var bt = re._ioInfo;
                bt != null && (bt.end = performance.now()), nt.status === void 0 && (nt.status = "fulfilled", nt.value = lt);
              }
            },
            function(lt) {
              if (re._status === 0 || re._status === -1) {
                re._status = 2, re._result = lt;
                var bt = re._ioInfo;
                bt != null && (bt.end = performance.now()), nt.status === void 0 && (nt.status = "rejected", nt.reason = lt);
              }
            }
          ), Ae = re._ioInfo, Ae != null) {
            Ae.value = nt;
            var st = nt.displayName;
            typeof st == "string" && (Ae.name = st);
          }
          re._status === -1 && (re._status = 0, re._result = nt);
        }
        if (re._status === 1)
          return Ae = re._result, Ae === void 0 && console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`,
            Ae
          ), "default" in Ae || console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`,
            Ae
          ), Ae.default;
        throw re._result;
      }
      function V() {
        var re = se.H;
        return re === null && console.error(
          `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
        ), re;
      }
      function Y() {
        se.asyncTransitions--;
      }
      function ee(re) {
        if (Wn === null)
          try {
            var Ae = ("require" + Math.random()).slice(0, 7);
            Wn = (t && t[Ae]).call(
              t,
              "timers"
            ).setImmediate;
          } catch {
            Wn = function(st) {
              hn === !1 && (hn = !0, typeof MessageChannel > "u" && console.error(
                "This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."
              ));
              var lt = new MessageChannel();
              lt.port1.onmessage = st, lt.port2.postMessage(void 0);
            };
          }
        return Wn(re);
      }
      function K(re) {
        return 1 < re.length && typeof AggregateError == "function" ? new AggregateError(re) : re[0];
      }
      function U(re, Ae) {
        Ae !== ar - 1 && console.error(
          "You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "
        ), ar = Ae;
      }
      function q(re, Ae, nt) {
        var st = se.actQueue;
        if (st !== null)
          if (st.length !== 0)
            try {
              W(st), ee(function() {
                return q(re, Ae, nt);
              });
              return;
            } catch (lt) {
              se.thrownErrors.push(lt);
            }
          else
            se.actQueue = null;
        0 < se.thrownErrors.length ? (st = K(se.thrownErrors), se.thrownErrors.length = 0, nt(st)) : Ae(re);
      }
      function W(re) {
        if (!yr) {
          yr = !0;
          var Ae = 0;
          try {
            for (; Ae < re.length; Ae++) {
              var nt = re[Ae];
              do {
                se.didUsePromise = !1;
                var st = nt(!1);
                if (st !== null) {
                  if (se.didUsePromise) {
                    re[Ae] = nt, re.splice(0, Ae);
                    return;
                  }
                  nt = st;
                } else
                  break;
              } while (1);
            }
            re.length = 0;
          } catch (lt) {
            re.splice(0, Ae + 1), se.thrownErrors.push(lt);
          } finally {
            yr = !1;
          }
        }
      }
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      var ie = Symbol.for("react.transitional.element"), J = Symbol.for("react.portal"), B = Symbol.for("react.fragment"), te = Symbol.for("react.strict_mode"), ae = Symbol.for("react.profiler"), le = Symbol.for("react.consumer"), de = Symbol.for("react.context"), _e = Symbol.for("react.forward_ref"), ue = Symbol.for("react.suspense"), Se = Symbol.for("react.suspense_list"), Ne = Symbol.for("react.memo"), Me = Symbol.for("react.lazy"), Ce = Symbol.for("react.activity"), Ue = Symbol.iterator, rt = {}, it = {
        isMounted: function() {
          return !1;
        },
        enqueueForceUpdate: function(re) {
          i(re, "forceUpdate");
        },
        enqueueReplaceState: function(re) {
          i(re, "replaceState");
        },
        enqueueSetState: function(re) {
          i(re, "setState");
        }
      }, Ft = Object.assign, wt = {};
      Object.freeze(wt), a.prototype.isReactComponent = {}, a.prototype.setState = function(re, Ae) {
        if (typeof re != "object" && typeof re != "function" && re != null)
          throw Error(
            "takes an object of state variables to update or a function which returns an object of state variables."
          );
        this.updater.enqueueSetState(this, re, Ae, "setState");
      }, a.prototype.forceUpdate = function(re) {
        this.updater.enqueueForceUpdate(this, re, "forceUpdate");
      };
      var Ot = {
        isMounted: [
          "isMounted",
          "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
          "replaceState",
          "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
      };
      for (sa in Ot)
        Ot.hasOwnProperty(sa) && n(sa, Ot[sa]);
      s.prototype = a.prototype, Ot = c.prototype = new s(), Ot.constructor = c, Ft(Ot, a.prototype), Ot.isPureReactComponent = !0;
      var On = Array.isArray, Ct = Symbol.for("react.client.reference"), se = {
        H: null,
        A: null,
        T: null,
        S: null,
        actQueue: null,
        asyncTransitions: 0,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
      }, ge = Object.prototype.hasOwnProperty, Te = console.createTask ? console.createTask : function() {
        return null;
      };
      Ot = {
        react_stack_bottom_frame: function(re) {
          return re();
        }
      };
      var He, $e, Ze = {}, ct = Ot.react_stack_bottom_frame.bind(
        Ot,
        _
      )(), Mt = Te(b(_)), Rt = !1, sn = /\/+/g, In = typeof reportError == "function" ? reportError : function(re) {
        if (typeof window == "object" && typeof window.ErrorEvent == "function") {
          var Ae = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: typeof re == "object" && re !== null && typeof re.message == "string" ? String(re.message) : String(re),
            error: re
          });
          if (!window.dispatchEvent(Ae))
            return;
        } else if (typeof process == "object" && typeof process.emit == "function") {
          process.emit("uncaughtException", re);
          return;
        }
        console.error(re);
      }, hn = !1, Wn = null, ar = 0, kn = !1, yr = !1, or = typeof queueMicrotask == "function" ? function(re) {
        queueMicrotask(function() {
          return queueMicrotask(re);
        });
      } : ee;
      Ot = Object.freeze({
        __proto__: null,
        c: function(re) {
          return V().useMemoCache(re);
        }
      });
      var sa = {
        map: H,
        forEach: function(re, Ae, nt) {
          H(
            re,
            function() {
              Ae.apply(this, arguments);
            },
            nt
          );
        },
        count: function(re) {
          var Ae = 0;
          return H(re, function() {
            Ae++;
          }), Ae;
        },
        toArray: function(re) {
          return H(re, function(Ae) {
            return Ae;
          }) || [];
        },
        only: function(re) {
          if (!P(re))
            throw Error(
              "React.Children.only expected to receive a single React element child."
            );
          return re;
        }
      };
      e.Activity = Ce, e.Children = sa, e.Component = a, e.Fragment = B, e.Profiler = ae, e.PureComponent = c, e.StrictMode = te, e.Suspense = ue, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = se, e.__COMPILER_RUNTIME = Ot, e.act = function(re) {
        var Ae = se.actQueue, nt = ar;
        ar++;
        var st = se.actQueue = Ae !== null ? Ae : [], lt = !1;
        try {
          var bt = re();
        } catch (ft) {
          se.thrownErrors.push(ft);
        }
        if (0 < se.thrownErrors.length)
          throw U(Ae, nt), re = K(se.thrownErrors), se.thrownErrors.length = 0, re;
        if (bt !== null && typeof bt == "object" && typeof bt.then == "function") {
          var Ke = bt;
          return or(function() {
            lt || kn || (kn = !0, console.error(
              "You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"
            ));
          }), {
            then: function(ft, en) {
              lt = !0, Ke.then(
                function(sr) {
                  if (U(Ae, nt), nt === 0) {
                    try {
                      W(st), ee(function() {
                        return q(
                          sr,
                          ft,
                          en
                        );
                      });
                    } catch (vn) {
                      se.thrownErrors.push(vn);
                    }
                    if (0 < se.thrownErrors.length) {
                      var jn = K(
                        se.thrownErrors
                      );
                      se.thrownErrors.length = 0, en(jn);
                    }
                  } else
                    ft(sr);
                },
                function(sr) {
                  U(Ae, nt), 0 < se.thrownErrors.length && (sr = K(
                    se.thrownErrors
                  ), se.thrownErrors.length = 0), en(sr);
                }
              );
            }
          };
        }
        var ut = bt;
        if (U(Ae, nt), nt === 0 && (W(st), st.length !== 0 && or(function() {
          lt || kn || (kn = !0, console.error(
            "A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"
          ));
        }), se.actQueue = null), 0 < se.thrownErrors.length)
          throw re = K(se.thrownErrors), se.thrownErrors.length = 0, re;
        return {
          then: function(ft, en) {
            lt = !0, nt === 0 ? (se.actQueue = st, ee(function() {
              return q(
                ut,
                ft,
                en
              );
            })) : ft(ut);
          }
        };
      }, e.cache = function(re) {
        return function() {
          return re.apply(null, arguments);
        };
      }, e.cacheSignal = function() {
        return null;
      }, e.captureOwnerStack = function() {
        var re = se.getCurrentStack;
        return re === null ? null : re();
      }, e.cloneElement = function(re, Ae, nt) {
        if (re == null)
          throw Error(
            "The argument must be a React element, but you passed " + re + "."
          );
        var st = Ft({}, re.props), lt = re.key, bt = re._owner;
        if (Ae != null) {
          var Ke;
          e: {
            if (ge.call(Ae, "ref") && (Ke = Object.getOwnPropertyDescriptor(
              Ae,
              "ref"
            ).get) && Ke.isReactWarning) {
              Ke = !1;
              break e;
            }
            Ke = Ae.ref !== void 0;
          }
          Ke && (bt = w()), A(Ae) && (g(Ae.key), lt = "" + Ae.key);
          for (ut in Ae)
            !ge.call(Ae, ut) || ut === "key" || ut === "__self" || ut === "__source" || ut === "ref" && Ae.ref === void 0 || (st[ut] = Ae[ut]);
        }
        var ut = arguments.length - 2;
        if (ut === 1)
          st.children = nt;
        else if (1 < ut) {
          Ke = Array(ut);
          for (var ft = 0; ft < ut; ft++)
            Ke[ft] = arguments[ft + 2];
          st.children = Ke;
        }
        for (st = R(
          re.type,
          lt,
          st,
          bt,
          re._debugStack,
          re._debugTask
        ), lt = 2; lt < arguments.length; lt++)
          M(arguments[lt]);
        return st;
      }, e.createContext = function(re) {
        return re = {
          $$typeof: de,
          _currentValue: re,
          _currentValue2: re,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        }, re.Provider = re, re.Consumer = {
          $$typeof: le,
          _context: re
        }, re._currentRenderer = null, re._currentRenderer2 = null, re;
      }, e.createElement = function(re, Ae, nt) {
        for (var st = 2; st < arguments.length; st++)
          M(arguments[st]);
        st = {};
        var lt = null;
        if (Ae != null)
          for (ft in $e || !("__self" in Ae) || "key" in Ae || ($e = !0, console.warn(
            "Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform"
          )), A(Ae) && (g(Ae.key), lt = "" + Ae.key), Ae)
            ge.call(Ae, ft) && ft !== "key" && ft !== "__self" && ft !== "__source" && (st[ft] = Ae[ft]);
        var bt = arguments.length - 2;
        if (bt === 1)
          st.children = nt;
        else if (1 < bt) {
          for (var Ke = Array(bt), ut = 0; ut < bt; ut++)
            Ke[ut] = arguments[ut + 2];
          Object.freeze && Object.freeze(Ke), st.children = Ke;
        }
        if (re && re.defaultProps)
          for (ft in bt = re.defaultProps, bt)
            st[ft] === void 0 && (st[ft] = bt[ft]);
        lt && T(
          st,
          typeof re == "function" ? re.displayName || re.name || "Unknown" : re
        );
        var ft = 1e4 > se.recentlyCreatedOwnerStacks++;
        return R(
          re,
          lt,
          st,
          w(),
          ft ? Error("react-stack-top-frame") : ct,
          ft ? Te(b(re)) : Mt
        );
      }, e.createRef = function() {
        var re = { current: null };
        return Object.seal(re), re;
      }, e.forwardRef = function(re) {
        re != null && re.$$typeof === Ne ? console.error(
          "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))."
        ) : typeof re != "function" ? console.error(
          "forwardRef requires a render function but was given %s.",
          re === null ? "null" : typeof re
        ) : re.length !== 0 && re.length !== 2 && console.error(
          "forwardRef render functions accept exactly two parameters: props and ref. %s",
          re.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."
        ), re != null && re.defaultProps != null && console.error(
          "forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?"
        );
        var Ae = { $$typeof: _e, render: re }, nt;
        return Object.defineProperty(Ae, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return nt;
          },
          set: function(st) {
            nt = st, re.name || re.displayName || (Object.defineProperty(re, "name", { value: st }), re.displayName = st);
          }
        }), Ae;
      }, e.isValidElement = P, e.lazy = function(re) {
        re = { _status: -1, _result: re };
        var Ae = {
          $$typeof: Me,
          _payload: re,
          _init: Z
        }, nt = {
          name: "lazy",
          start: -1,
          end: -1,
          value: null,
          owner: null,
          debugStack: Error("react-stack-top-frame"),
          debugTask: console.createTask ? console.createTask("lazy()") : null
        };
        return re._ioInfo = nt, Ae._debugInfo = [{ awaited: nt }], Ae;
      }, e.memo = function(re, Ae) {
        re == null && console.error(
          "memo: The first argument must be a component. Instead received: %s",
          re === null ? "null" : typeof re
        ), Ae = {
          $$typeof: Ne,
          type: re,
          compare: Ae === void 0 ? null : Ae
        };
        var nt;
        return Object.defineProperty(Ae, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return nt;
          },
          set: function(st) {
            nt = st, re.name || re.displayName || (Object.defineProperty(re, "name", { value: st }), re.displayName = st);
          }
        }), Ae;
      }, e.startTransition = function(re) {
        var Ae = se.T, nt = {};
        nt._updatedFibers = /* @__PURE__ */ new Set(), se.T = nt;
        try {
          var st = re(), lt = se.S;
          lt !== null && lt(nt, st), typeof st == "object" && st !== null && typeof st.then == "function" && (se.asyncTransitions++, st.then(Y, Y), st.then(d, In));
        } catch (bt) {
          In(bt);
        } finally {
          Ae === null && nt._updatedFibers && (re = nt._updatedFibers.size, nt._updatedFibers.clear(), 10 < re && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          )), Ae !== null && nt.types !== null && (Ae.types !== null && Ae.types !== nt.types && console.error(
            "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
          ), Ae.types = nt.types), se.T = Ae;
        }
      }, e.unstable_useCacheRefresh = function() {
        return V().useCacheRefresh();
      }, e.use = function(re) {
        return V().use(re);
      }, e.useActionState = function(re, Ae, nt) {
        return V().useActionState(
          re,
          Ae,
          nt
        );
      }, e.useCallback = function(re, Ae) {
        return V().useCallback(re, Ae);
      }, e.useContext = function(re) {
        var Ae = V();
        return re.$$typeof === le && console.error(
          "Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"
        ), Ae.useContext(re);
      }, e.useDebugValue = function(re, Ae) {
        return V().useDebugValue(re, Ae);
      }, e.useDeferredValue = function(re, Ae) {
        return V().useDeferredValue(re, Ae);
      }, e.useEffect = function(re, Ae) {
        return re == null && console.warn(
          "React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        ), V().useEffect(re, Ae);
      }, e.useEffectEvent = function(re) {
        return V().useEffectEvent(re);
      }, e.useId = function() {
        return V().useId();
      }, e.useImperativeHandle = function(re, Ae, nt) {
        return V().useImperativeHandle(re, Ae, nt);
      }, e.useInsertionEffect = function(re, Ae) {
        return re == null && console.warn(
          "React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        ), V().useInsertionEffect(re, Ae);
      }, e.useLayoutEffect = function(re, Ae) {
        return re == null && console.warn(
          "React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        ), V().useLayoutEffect(re, Ae);
      }, e.useMemo = function(re, Ae) {
        return V().useMemo(re, Ae);
      }, e.useOptimistic = function(re, Ae) {
        return V().useOptimistic(re, Ae);
      }, e.useReducer = function(re, Ae, nt) {
        return V().useReducer(re, Ae, nt);
      }, e.useRef = function(re) {
        return V().useRef(re);
      }, e.useState = function(re) {
        return V().useState(re);
      }, e.useSyncExternalStore = function(re, Ae, nt) {
        return V().useSyncExternalStore(
          re,
          Ae,
          nt
        );
      }, e.useTransition = function() {
        return V().useTransition();
      }, e.version = "19.2.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    }();
  }(XS, XS.exports)), XS.exports;
}
process.env.NODE_ENV === "production" ? WD.exports = mne() : WD.exports = gne();
var I = WD.exports;
const De = /* @__PURE__ */ J0(I), g_ = /* @__PURE__ */ fne({
  __proto__: null,
  default: De
}, [I]);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hP;
function vne() {
  return hP || (hP = 1, process.env.NODE_ENV !== "production" && function() {
    function t(B) {
      if (B == null)
        return null;
      if (typeof B == "function")
        return B.$$typeof === Z ? null : B.displayName || B.name || null;
      if (typeof B == "string")
        return B;
      switch (B) {
        case T:
          return "Fragment";
        case R:
          return "Profiler";
        case O:
          return "StrictMode";
        case z:
          return "Suspense";
        case F:
          return "SuspenseList";
        case H:
          return "Activity";
      }
      if (typeof B == "object")
        switch (typeof B.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), B.$$typeof) {
          case A:
            return "Portal";
          case M:
            return B.displayName || "Context";
          case N:
            return (B._context.displayName || "Context") + ".Consumer";
          case P:
            var te = B.render;
            return B = B.displayName, B || (B = te.displayName || te.name || "", B = B !== "" ? "ForwardRef(" + B + ")" : "ForwardRef"), B;
          case $:
            return te = B.displayName || null, te !== null ? te : t(B.type) || "Memo";
          case G:
            te = B._payload, B = B._init;
            try {
              return t(B(te));
            } catch {
            }
        }
      return null;
    }
    function e(B) {
      return "" + B;
    }
    function n(B) {
      try {
        e(B);
        var te = !1;
      } catch {
        te = !0;
      }
      if (te) {
        te = console;
        var ae = te.error, le = typeof Symbol == "function" && Symbol.toStringTag && B[Symbol.toStringTag] || B.constructor.name || "Object";
        return ae.call(
          te,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          le
        ), e(B);
      }
    }
    function r(B) {
      if (B === T)
        return "<>";
      if (typeof B == "object" && B !== null && B.$$typeof === G)
        return "<...>";
      try {
        var te = t(B);
        return te ? "<" + te + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var B = V.A;
      return B === null ? null : B.getOwner();
    }
    function a() {
      return Error("react-stack-top-frame");
    }
    function s(B) {
      if (Y.call(B, "key")) {
        var te = Object.getOwnPropertyDescriptor(B, "key").get;
        if (te && te.isReactWarning)
          return !1;
      }
      return B.key !== void 0;
    }
    function c(B, te) {
      function ae() {
        U || (U = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          te
        ));
      }
      ae.isReactWarning = !0, Object.defineProperty(B, "key", {
        get: ae,
        configurable: !0
      });
    }
    function d() {
      var B = t(this.type);
      return q[B] || (q[B] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), B = this.props.ref, B !== void 0 ? B : null;
    }
    function f(B, te, ae, le, de, _e) {
      var ue = ae.ref;
      return B = {
        $$typeof: _,
        type: B,
        key: te,
        props: ae,
        _owner: le
      }, (ue !== void 0 ? ue : null) !== null ? Object.defineProperty(B, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(B, "ref", { enumerable: !1, value: null }), B._store = {}, Object.defineProperty(B._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(B, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(B, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: de
      }), Object.defineProperty(B, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: _e
      }), Object.freeze && (Object.freeze(B.props), Object.freeze(B)), B;
    }
    function g(B, te, ae, le, de, _e) {
      var ue = te.children;
      if (ue !== void 0)
        if (le)
          if (ee(ue)) {
            for (le = 0; le < ue.length; le++)
              m(ue[le]);
            Object.freeze && Object.freeze(ue);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else
          m(ue);
      if (Y.call(te, "key")) {
        ue = t(B);
        var Se = Object.keys(te).filter(function(Me) {
          return Me !== "key";
        });
        le = 0 < Se.length ? "{key: someKey, " + Se.join(": ..., ") + ": ...}" : "{key: someKey}", J[ue + le] || (Se = 0 < Se.length ? "{" + Se.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          le,
          ue,
          Se,
          ue
        ), J[ue + le] = !0);
      }
      if (ue = null, ae !== void 0 && (n(ae), ue = "" + ae), s(te) && (n(te.key), ue = "" + te.key), "key" in te) {
        ae = {};
        for (var Ne in te)
          Ne !== "key" && (ae[Ne] = te[Ne]);
      } else
        ae = te;
      return ue && c(
        ae,
        typeof B == "function" ? B.displayName || B.name || "Unknown" : B
      ), f(
        B,
        ue,
        ae,
        i(),
        de,
        _e
      );
    }
    function m(B) {
      b(B) ? B._store && (B._store.validated = 1) : typeof B == "object" && B !== null && B.$$typeof === G && (B._payload.status === "fulfilled" ? b(B._payload.value) && B._payload.value._store && (B._payload.value._store.validated = 1) : B._store && (B._store.validated = 1));
    }
    function b(B) {
      return typeof B == "object" && B !== null && B.$$typeof === _;
    }
    var w = I, _ = Symbol.for("react.transitional.element"), A = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), O = Symbol.for("react.strict_mode"), R = Symbol.for("react.profiler"), N = Symbol.for("react.consumer"), M = Symbol.for("react.context"), P = Symbol.for("react.forward_ref"), z = Symbol.for("react.suspense"), F = Symbol.for("react.suspense_list"), $ = Symbol.for("react.memo"), G = Symbol.for("react.lazy"), H = Symbol.for("react.activity"), Z = Symbol.for("react.client.reference"), V = w.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Y = Object.prototype.hasOwnProperty, ee = Array.isArray, K = console.createTask ? console.createTask : function() {
      return null;
    };
    w = {
      react_stack_bottom_frame: function(B) {
        return B();
      }
    };
    var U, q = {}, W = w.react_stack_bottom_frame.bind(
      w,
      a
    )(), ie = K(r(a)), J = {};
    SS.Fragment = T, SS.jsx = function(B, te, ae) {
      var le = 1e4 > V.recentlyCreatedOwnerStacks++;
      return g(
        B,
        te,
        ae,
        !1,
        le ? Error("react-stack-top-frame") : W,
        le ? K(r(B)) : ie
      );
    }, SS.jsxs = function(B, te, ae) {
      var le = 1e4 > V.recentlyCreatedOwnerStacks++;
      return g(
        B,
        te,
        ae,
        !0,
        le ? Error("react-stack-top-frame") : W,
        le ? K(r(B)) : ie
      );
    };
  }()), SS;
}
process.env.NODE_ENV === "production" ? XD.exports = pne() : XD.exports = vne();
var C = XD.exports, QD = { exports: {} }, i6 = {};
/**
 * @license React
 * react-compiler-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pP;
function yne() {
  if (pP)
    return i6;
  pP = 1;
  var t = I.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  return i6.c = function(e) {
    return t.H.useMemoCache(e);
  }, i6;
}
var a6 = {};
/**
 * @license React
 * react-compiler-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mP;
function bne() {
  return mP || (mP = 1, process.env.NODE_ENV !== "production" && function() {
    var t = I.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    a6.c = function(e) {
      var n = t.H;
      return n === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), n.useMemoCache(e);
    };
  }()), a6;
}
process.env.NODE_ENV === "production" ? QD.exports = yne() : QD.exports = bne();
var ve = QD.exports;
function wne() {
  for (var t = 0, e, n, r = ""; t < arguments.length; )
    (e = arguments[t++]) && (n = M$(e)) && (r && (r += " "), r += n);
  return r;
}
function M$(t) {
  if (typeof t == "string")
    return t;
  for (var e, n = "", r = 0; r < t.length; r++)
    t[r] && (e = M$(t[r])) && (n && (n += " "), n += e);
  return n;
}
var mM = "-";
function xne(t) {
  var e = Ene(t), n = t.conflictingClassGroups, r = t.conflictingClassGroupModifiers, i = r === void 0 ? {} : r;
  function a(c) {
    var d = c.split(mM);
    return d[0] === "" && d.length !== 1 && d.shift(), I$(d, e) || Sne(c);
  }
  function s(c, d) {
    var f = n[c] || [];
    return d && i[c] ? [].concat(f, i[c]) : f;
  }
  return {
    getClassGroupId: a,
    getConflictingClassGroupIds: s
  };
}
function I$(t, e) {
  if (t.length === 0)
    return e.classGroupId;
  var n = t[0], r = e.nextPart.get(n), i = r ? I$(t.slice(1), r) : void 0;
  if (i)
    return i;
  if (e.validators.length !== 0) {
    var a = t.join(mM);
    return e.validators.find(function(s) {
      var c = s.validator;
      return c(a);
    })?.classGroupId;
  }
}
var gP = /^\[(.+)\]$/;
function Sne(t) {
  if (gP.test(t)) {
    var e = gP.exec(t)[1], n = e?.substring(0, e.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function Ene(t) {
  var e = t.theme, n = t.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = Ane(Object.entries(t.classGroups), n);
  return i.forEach(function(a) {
    var s = a[0], c = a[1];
    ZD(c, r, s, e);
  }), r;
}
function ZD(t, e, n, r) {
  t.forEach(function(i) {
    if (typeof i == "string") {
      var a = i === "" ? e : vP(e, i);
      a.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (_ne(i)) {
        ZD(i(r), e, n, r);
        return;
      }
      e.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(function(s) {
      var c = s[0], d = s[1];
      ZD(d, vP(e, c), n, r);
    });
  });
}
function vP(t, e) {
  var n = t;
  return e.split(mM).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function _ne(t) {
  return t.isThemeGetter;
}
function Ane(t, e) {
  return e ? t.map(function(n) {
    var r = n[0], i = n[1], a = i.map(function(s) {
      return typeof s == "string" ? e + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(function(c) {
        var d = c[0], f = c[1];
        return [e + d, f];
      })) : s;
    });
    return [r, a];
  }) : t;
}
function Cne(t) {
  if (t < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var e = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(a, s) {
    n.set(a, s), e++, e > t && (e = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(s) {
      var c = n.get(s);
      if (c !== void 0)
        return c;
      if ((c = r.get(s)) !== void 0)
        return i(s, c), c;
    },
    set: function(s, c) {
      n.has(s) ? n.set(s, c) : i(s, c);
    }
  };
}
var k$ = "!";
function Tne(t) {
  var e = t.separator || ":", n = e.length === 1, r = e[0], i = e.length;
  return function(s) {
    for (var c = [], d = 0, f = 0, g, m = 0; m < s.length; m++) {
      var b = s[m];
      if (d === 0) {
        if (b === r && (n || s.slice(m, m + i) === e)) {
          c.push(s.slice(f, m)), f = m + i;
          continue;
        }
        if (b === "/") {
          g = m;
          continue;
        }
      }
      b === "[" ? d++ : b === "]" && d--;
    }
    var w = c.length === 0 ? s : s.substring(f), _ = w.startsWith(k$), A = _ ? w.substring(1) : w, T = g && g > f ? g - f : void 0;
    return {
      modifiers: c,
      hasImportantModifier: _,
      baseClassName: A,
      maybePostfixModifierPosition: T
    };
  };
}
function One(t) {
  if (t.length <= 1)
    return t;
  var e = [], n = [];
  return t.forEach(function(r) {
    var i = r[0] === "[";
    i ? (e.push.apply(e, n.sort().concat([r])), n = []) : n.push(r);
  }), e.push.apply(e, n.sort()), e;
}
function Rne(t) {
  return {
    cache: Cne(t.cacheSize),
    splitModifiers: Tne(t),
    ...xne(t)
  };
}
var Dne = /\s+/;
function Nne(t, e) {
  var n = e.splitModifiers, r = e.getClassGroupId, i = e.getConflictingClassGroupIds, a = /* @__PURE__ */ new Set();
  return t.trim().split(Dne).map(function(s) {
    var c = n(s), d = c.modifiers, f = c.hasImportantModifier, g = c.baseClassName, m = c.maybePostfixModifierPosition, b = r(m ? g.substring(0, m) : g), w = !!m;
    if (!b) {
      if (!m)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      if (b = r(g), !b)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      w = !1;
    }
    var _ = One(d).join(":"), A = f ? _ + k$ : _;
    return {
      isTailwindClass: !0,
      modifierId: A,
      classGroupId: b,
      originalClassName: s,
      hasPostfixModifier: w
    };
  }).reverse().filter(function(s) {
    if (!s.isTailwindClass)
      return !0;
    var c = s.modifierId, d = s.classGroupId, f = s.hasPostfixModifier, g = c + d;
    return a.has(g) ? !1 : (a.add(g), i(d, f).forEach(function(m) {
      return a.add(c + m);
    }), !0);
  }).reverse().map(function(s) {
    return s.originalClassName;
  }).join(" ");
}
function Mne() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r, i, a, s = c;
  function c(f) {
    var g = e[0], m = e.slice(1), b = m.reduce(function(w, _) {
      return _(w);
    }, g());
    return r = Rne(b), i = r.cache.get, a = r.cache.set, s = d, d(f);
  }
  function d(f) {
    var g = i(f);
    if (g)
      return g;
    var m = Nne(f, r);
    return a(f, m), m;
  }
  return function() {
    return s(wne.apply(null, arguments));
  };
}
function hi(t) {
  var e = function(r) {
    return r[t] || [];
  };
  return e.isThemeGetter = !0, e;
}
var j$ = /^\[(?:([a-z-]+):)?(.+)\]$/i, Ine = /^\d+\/\d+$/, kne = /* @__PURE__ */ new Set(["px", "full", "screen"]), jne = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Pne = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Lne = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Mu(t) {
  return eg(t) || kne.has(t) || Ine.test(t) || KD(t);
}
function KD(t) {
  return Rg(t, "length", $ne);
}
function Bne(t) {
  return Rg(t, "size", P$);
}
function zne(t) {
  return Rg(t, "position", P$);
}
function Fne(t) {
  return Rg(t, "url", Hne);
}
function gC(t) {
  return Rg(t, "number", eg);
}
function eg(t) {
  return !Number.isNaN(Number(t));
}
function Vne(t) {
  return t.endsWith("%") && eg(t.slice(0, -1));
}
function ES(t) {
  return yP(t) || Rg(t, "number", yP);
}
function Yn(t) {
  return j$.test(t);
}
function _S() {
  return !0;
}
function g0(t) {
  return jne.test(t);
}
function Une(t) {
  return Rg(t, "", qne);
}
function Rg(t, e, n) {
  var r = j$.exec(t);
  return r ? r[1] ? r[1] === e : n(r[2]) : !1;
}
function $ne(t) {
  return Pne.test(t);
}
function P$() {
  return !1;
}
function Hne(t) {
  return t.startsWith("url(");
}
function yP(t) {
  return Number.isInteger(Number(t));
}
function qne(t) {
  return Lne.test(t);
}
function Gne() {
  var t = hi("colors"), e = hi("spacing"), n = hi("blur"), r = hi("brightness"), i = hi("borderColor"), a = hi("borderRadius"), s = hi("borderSpacing"), c = hi("borderWidth"), d = hi("contrast"), f = hi("grayscale"), g = hi("hueRotate"), m = hi("invert"), b = hi("gap"), w = hi("gradientColorStops"), _ = hi("gradientColorStopPositions"), A = hi("inset"), T = hi("margin"), O = hi("opacity"), R = hi("padding"), N = hi("saturate"), M = hi("scale"), P = hi("sepia"), z = hi("skew"), F = hi("space"), $ = hi("translate"), G = function() {
    return ["auto", "contain", "none"];
  }, H = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, Z = function() {
    return ["auto", Yn, e];
  }, V = function() {
    return [Yn, e];
  }, Y = function() {
    return ["", Mu];
  }, ee = function() {
    return ["auto", eg, Yn];
  }, K = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, U = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, q = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, W = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, ie = function() {
    return ["", "0", Yn];
  }, J = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, B = function() {
    return [eg, gC];
  }, te = function() {
    return [eg, Yn];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [_S],
      spacing: [Mu],
      blur: ["none", "", g0, Yn],
      brightness: B(),
      borderColor: [t],
      borderRadius: ["none", "", "full", g0, Yn],
      borderSpacing: V(),
      borderWidth: Y(),
      contrast: B(),
      grayscale: ie(),
      hueRotate: te(),
      invert: ie(),
      gap: V(),
      gradientColorStops: [t],
      gradientColorStopPositions: [Vne, KD],
      inset: Z(),
      margin: Z(),
      opacity: B(),
      padding: V(),
      saturate: B(),
      scale: B(),
      sepia: ie(),
      skew: te(),
      space: V(),
      translate: V()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Yn]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [g0]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": J()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": J()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(K(), [Yn])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: H()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": H()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": H()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: G()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": G()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": G()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [A]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [A]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [A]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [A]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [A]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [A]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [A]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [A]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [A]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", ES]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: Z()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Yn]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ie()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ie()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", ES]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [_S]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", ES]
        }, Yn]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": ee()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": ee()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [_S]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [ES]
        }, Yn]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": ee()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": ee()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Yn]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Yn]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [b]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [b]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [b]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(W())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(W(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(W(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [R]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [R]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [R]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [R]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [R]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [R]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [R]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [R]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [R]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [T]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [T]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [T]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [T]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [T]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [T]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [T]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [T]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [T]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [F]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [F]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", Yn, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", Yn, Mu]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [g0]
        }, g0, Yn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Yn, e, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", Yn, Mu]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Yn, e, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", g0, KD]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", gC]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [_S]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Yn]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", eg, gC]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Yn, Mu]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Yn]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Yn]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [O]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [O]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(U(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Mu]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Yn, Mu]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: V()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Yn]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Yn]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [O]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(K(), [zne])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Bne]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Fne]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [_]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [_]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [_]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [w]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [w]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [w]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [c]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [c]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [c]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [c]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [c]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [c]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [c]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [c]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [c]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [O]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(U(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [c]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [c]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [O]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: U()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(U())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Yn, Mu]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Mu]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: Y()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [O]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Mu]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", g0, Une]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [_S]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [O]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": q()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": q()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [d]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", g0, Yn]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [f]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [g]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [m]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [N]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [P]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [d]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [f]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [g]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [m]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [O]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [N]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [P]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Yn]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: te()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Yn]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: te()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Yn]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [M]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [M]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [M]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [ES, Yn]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [$]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [$]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [z]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [z]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Yn]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Yn]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": V()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": V()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": V()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": V()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": V()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": V()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": V()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": V()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": V()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": V()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": V()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": V()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": V()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": V()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": V()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": V()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": V()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": V()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Yn]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Mu, gC]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var Yne = /* @__PURE__ */ Mne(Gne), Xne = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"], Wne = Xne, L$ = Symbol("isTwElement?"), Qne = (t, e) => t.reduce((n, r, i) => n.concat(r || [], e[i] || []), []), Zne = (t, e = "") => {
  let n = t.join(" ").trim().replace(/\n/g, " ").replace(/\s{2,}/g, " ").split(" ").filter((i) => i !== ","), r = e ? e.split(" ") : [];
  return Yne(...n.concat(r).filter((i) => i !== " "));
}, Kne = ([t]) => t.charAt(0) !== "$", o6 = (t) => t[L$] === !0, B$ = (t) => (e, ...n) => {
  let r = (i = []) => {
    let a = De.forwardRef((s, c) => {
      let { $as: d = t, style: f = {}, ...g } = s, m = o6(t) ? t : d, b = i ? i.reduce((_, A) => Object.assign(_, typeof A == "function" ? A(s) : A), {}) : {}, w = o6(m) ? g : Object.fromEntries(Object.entries(g).filter(Kne));
      return De.createElement(m, { ...w, style: { ...b, ...f }, ref: c, className: Zne(Qne(e, n.map((_) => _({ ...g, $as: d }))), g.className), ...o6(t) ? { $as: d } : {} });
    });
    return a[L$] = !0, typeof t != "string" ? a.displayName = t.displayName || t.name || "tw.Component" : a.displayName = "tw." + t, a.withStyle = (s) => r(i.concat(s)), a;
  };
  return r();
}, Jne = Wne.reduce((t, e) => ({ ...t, [e]: B$(e) }), {}), ere = Object.assign(B$, Jne), Re = ere, nr;
(function(t) {
  t.assertEqual = (i) => {
  };
  function e(i) {
  }
  t.assertIs = e;
  function n(i) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (i) => {
    const a = {};
    for (const s of i)
      a[s] = s;
    return a;
  }, t.getValidEnumValues = (i) => {
    const a = t.objectKeys(i).filter((c) => typeof i[i[c]] != "number"), s = {};
    for (const c of a)
      s[c] = i[c];
    return t.objectValues(s);
  }, t.objectValues = (i) => t.objectKeys(i).map(function(a) {
    return i[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const a = [];
    for (const s in i)
      Object.prototype.hasOwnProperty.call(i, s) && a.push(s);
    return a;
  }, t.find = (i, a) => {
    for (const s of i)
      if (a(s))
        return s;
  }, t.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && Number.isFinite(i) && Math.floor(i) === i;
  function r(i, a = " | ") {
    return i.map((s) => typeof s == "string" ? `'${s}'` : s).join(a);
  }
  t.joinValues = r, t.jsonStringifyReplacer = (i, a) => typeof a == "bigint" ? a.toString() : a;
})(nr || (nr = {}));
var JD;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})(JD || (JD = {}));
const St = nr.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Eh = (t) => {
  switch (typeof t) {
    case "undefined":
      return St.undefined;
    case "string":
      return St.string;
    case "number":
      return Number.isNaN(t) ? St.nan : St.number;
    case "boolean":
      return St.boolean;
    case "function":
      return St.function;
    case "bigint":
      return St.bigint;
    case "symbol":
      return St.symbol;
    case "object":
      return Array.isArray(t) ? St.array : t === null ? St.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? St.promise : typeof Map < "u" && t instanceof Map ? St.map : typeof Set < "u" && t instanceof Set ? St.set : typeof Date < "u" && t instanceof Date ? St.date : St.object;
    default:
      return St.unknown;
  }
}, at = nr.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), tre = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class Gl extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const n = e || function(a) {
      return a.message;
    }, r = { _errors: [] }, i = (a) => {
      for (const s of a.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(i);
        else if (s.code === "invalid_return_type")
          i(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          i(s.argumentsError);
        else if (s.path.length === 0)
          r._errors.push(n(s));
        else {
          let c = r, d = 0;
          for (; d < s.path.length; ) {
            const f = s.path[d];
            d === s.path.length - 1 ? (c[f] = c[f] || { _errors: [] }, c[f]._errors.push(n(s))) : c[f] = c[f] || { _errors: [] }, c = c[f], d++;
          }
        }
    };
    return i(this), r;
  }
  static assert(e) {
    if (!(e instanceof Gl))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, nr.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const i of this.issues)
      if (i.path.length > 0) {
        const a = i.path[0];
        n[a] = n[a] || [], n[a].push(e(i));
      } else
        r.push(e(i));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Gl.create = (t) => new Gl(t);
const nre = (t, e) => {
  let n;
  switch (t.code) {
    case at.invalid_type:
      t.received === St.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case at.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, nr.jsonStringifyReplacer)}`;
      break;
    case at.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${nr.joinValues(t.keys, ", ")}`;
      break;
    case at.invalid_union:
      n = "Invalid input";
      break;
    case at.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${nr.joinValues(t.options)}`;
      break;
    case at.invalid_enum_value:
      n = `Invalid enum value. Expected ${nr.joinValues(t.options)}, received '${t.received}'`;
      break;
    case at.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case at.invalid_return_type:
      n = "Invalid function return type";
      break;
    case at.invalid_date:
      n = "Invalid date";
      break;
    case at.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : nr.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case at.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "bigint" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case at.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case at.custom:
      n = "Invalid input";
      break;
    case at.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case at.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case at.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, nr.assertNever(t);
  }
  return { message: n };
}, Ub = nre;
let z$ = Ub;
function rre(t) {
  z$ = t;
}
function K4() {
  return z$;
}
const J4 = (t) => {
  const { data: e, path: n, errorMaps: r, issueData: i } = t, a = [...n, ...i.path || []], s = {
    ...i,
    path: a
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: a,
      message: i.message
    };
  let c = "";
  const d = r.filter((f) => !!f).slice().reverse();
  for (const f of d)
    c = f(s, { data: e, defaultError: c }).message;
  return {
    ...i,
    path: a,
    message: c
  };
}, ire = [];
function vt(t, e) {
  const n = K4(), r = J4({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === Ub ? void 0 : Ub
      // then global default map
    ].filter((i) => !!i)
  });
  t.common.issues.push(r);
}
class Jo {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const i of n) {
      if (i.status === "aborted")
        return Zt;
      i.status === "dirty" && e.dirty(), r.push(i.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, n) {
    const r = [];
    for (const i of n) {
      const a = await i.key, s = await i.value;
      r.push({
        key: a,
        value: s
      });
    }
    return Jo.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const i of n) {
      const { key: a, value: s } = i;
      if (a.status === "aborted" || s.status === "aborted")
        return Zt;
      a.status === "dirty" && e.dirty(), s.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof s.value < "u" || i.alwaysSet) && (r[a.value] = s.value);
    }
    return { status: e.value, value: r };
  }
}
const Zt = Object.freeze({
  status: "aborted"
}), bb = (t) => ({ status: "dirty", value: t }), js = (t) => ({ status: "valid", value: t }), e8 = (t) => t.status === "aborted", t8 = (t) => t.status === "dirty", hg = (t) => t.status === "valid", CE = (t) => typeof Promise < "u" && t instanceof Promise;
var Pt;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e?.message;
})(Pt || (Pt = {}));
class ef {
  constructor(e, n, r, i) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const bP = (t, e) => {
  if (hg(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new Gl(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function Sn(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: i } = t;
  if (e && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: i } : { errorMap: (s, c) => {
    const { message: d } = t;
    return s.code === "invalid_enum_value" ? { message: d ?? c.defaultError } : typeof c.data > "u" ? { message: d ?? r ?? c.defaultError } : s.code !== "invalid_type" ? { message: c.defaultError } : { message: d ?? n ?? c.defaultError };
  }, description: i };
}
class Mn {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Eh(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: Eh(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new Jo(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Eh(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (CE(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    const r = {
      common: {
        issues: [],
        async: n?.async ?? !1,
        contextualErrorMap: n?.errorMap
      },
      path: n?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Eh(e)
    }, i = this._parseSync({ data: e, path: r.path, parent: r });
    return bP(r, i);
  }
  "~validate"(e) {
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Eh(e)
    };
    if (!this["~standard"].async)
      try {
        const r = this._parseSync({ data: e, path: [], parent: n });
        return hg(r) ? {
          value: r.value
        } : {
          issues: n.common.issues
        };
      } catch (r) {
        r?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: n }).then((r) => hg(r) ? {
      value: r.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(e, n) {
    const r = await this.safeParseAsync(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n?.errorMap,
        async: !0
      },
      path: n?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Eh(e)
    }, i = this._parse({ data: e, path: r.path, parent: r }), a = await (CE(i) ? i : Promise.resolve(i));
    return bP(r, a);
  }
  refine(e, n) {
    const r = (i) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(i) : n;
    return this._refinement((i, a) => {
      const s = e(i), c = () => a.addIssue({
        code: at.custom,
        ...r(i)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((d) => d ? !0 : (c(), !1)) : s ? !0 : (c(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, i) => e(r) ? !0 : (i.addIssue(typeof n == "function" ? n(r, i) : n), !1));
  }
  _refinement(e) {
    return new Yu({
      schema: this,
      typeName: Jt.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return Xd.create(this, this._def);
  }
  nullable() {
    return $0.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Hu.create(this);
  }
  promise() {
    return Hb.create(this, this._def);
  }
  or(e) {
    return DE.create([this, e], this._def);
  }
  and(e) {
    return NE.create(this, e, this._def);
  }
  transform(e) {
    return new Yu({
      ...Sn(this._def),
      schema: this,
      typeName: Jt.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new PE({
      ...Sn(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Jt.ZodDefault
    });
  }
  brand() {
    return new gM({
      typeName: Jt.ZodBranded,
      type: this,
      ...Sn(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new LE({
      ...Sn(this._def),
      innerType: this,
      catchValue: n,
      typeName: Jt.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return v_.create(this, e);
  }
  readonly() {
    return BE.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const are = /^c[^\s-]{8,}$/i, ore = /^[0-9a-z]+$/, sre = /^[0-9A-HJKMNP-TV-Z]{26}$/i, lre = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, cre = /^[a-z0-9_-]{21}$/i, ure = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, dre = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, fre = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, hre = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let s6;
const pre = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, mre = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, gre = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, vre = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, yre = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, bre = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, F$ = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", wre = new RegExp(`^${F$}$`);
function V$(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const n = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${n}`;
}
function xre(t) {
  return new RegExp(`^${V$(t)}$`);
}
function U$(t) {
  let e = `${F$}T${V$(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function Sre(t, e) {
  return !!((e === "v4" || !e) && pre.test(t) || (e === "v6" || !e) && gre.test(t));
}
function Ere(t, e) {
  if (!ure.test(t))
    return !1;
  try {
    const [n] = t.split(".");
    if (!n)
      return !1;
    const r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), i = JSON.parse(atob(r));
    return !(typeof i != "object" || i === null || "typ" in i && i?.typ !== "JWT" || !i.alg || e && i.alg !== e);
  } catch {
    return !1;
  }
}
function _re(t, e) {
  return !!((e === "v4" || !e) && mre.test(t) || (e === "v6" || !e) && vre.test(t));
}
class $u extends Mn {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== St.string) {
      const a = this._getOrReturnCtx(e);
      return vt(a, {
        code: at.invalid_type,
        expected: St.string,
        received: a.parsedType
      }), Zt;
    }
    const r = new Jo();
    let i;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (i = this._getOrReturnCtx(e, i), vt(i, {
          code: at.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (i = this._getOrReturnCtx(e, i), vt(i, {
          code: at.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "length") {
        const s = e.data.length > a.value, c = e.data.length < a.value;
        (s || c) && (i = this._getOrReturnCtx(e, i), s ? vt(i, {
          code: at.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : c && vt(i, {
          code: at.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), r.dirty());
      } else if (a.kind === "email")
        fre.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "email",
          code: at.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "emoji")
        s6 || (s6 = new RegExp(hre, "u")), s6.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "emoji",
          code: at.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "uuid")
        lre.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "uuid",
          code: at.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "nanoid")
        cre.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "nanoid",
          code: at.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid")
        are.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "cuid",
          code: at.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid2")
        ore.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "cuid2",
          code: at.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "ulid")
        sre.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "ulid",
          code: at.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          i = this._getOrReturnCtx(e, i), vt(i, {
            validation: "url",
            code: at.invalid_string,
            message: a.message
          }), r.dirty();
        }
      else
        a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "regex",
          code: at.invalid_string,
          message: a.message
        }), r.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (i = this._getOrReturnCtx(e, i), vt(i, {
          code: at.invalid_string,
          validation: { includes: a.value, position: a.position },
          message: a.message
        }), r.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (i = this._getOrReturnCtx(e, i), vt(i, {
          code: at.invalid_string,
          validation: { startsWith: a.value },
          message: a.message
        }), r.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (i = this._getOrReturnCtx(e, i), vt(i, {
          code: at.invalid_string,
          validation: { endsWith: a.value },
          message: a.message
        }), r.dirty()) : a.kind === "datetime" ? U$(a).test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          code: at.invalid_string,
          validation: "datetime",
          message: a.message
        }), r.dirty()) : a.kind === "date" ? wre.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          code: at.invalid_string,
          validation: "date",
          message: a.message
        }), r.dirty()) : a.kind === "time" ? xre(a).test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          code: at.invalid_string,
          validation: "time",
          message: a.message
        }), r.dirty()) : a.kind === "duration" ? dre.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "duration",
          code: at.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "ip" ? Sre(e.data, a.version) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "ip",
          code: at.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "jwt" ? Ere(e.data, a.alg) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "jwt",
          code: at.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "cidr" ? _re(e.data, a.version) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "cidr",
          code: at.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "base64" ? yre.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "base64",
          code: at.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "base64url" ? bre.test(e.data) || (i = this._getOrReturnCtx(e, i), vt(i, {
          validation: "base64url",
          code: at.invalid_string,
          message: a.message
        }), r.dirty()) : nr.assertNever(a);
    return { status: r.value, value: e.data };
  }
  _regex(e, n, r) {
    return this.refinement((i) => e.test(i), {
      validation: n,
      code: at.invalid_string,
      ...Pt.errToObj(r)
    });
  }
  _addCheck(e) {
    return new $u({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...Pt.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...Pt.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...Pt.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...Pt.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...Pt.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...Pt.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...Pt.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...Pt.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...Pt.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...Pt.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...Pt.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...Pt.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...Pt.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: e?.offset ?? !1,
      local: e?.local ?? !1,
      ...Pt.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...Pt.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...Pt.errToObj(e) });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...Pt.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n?.position,
      ...Pt.errToObj(n?.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...Pt.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...Pt.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...Pt.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...Pt.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...Pt.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, Pt.errToObj(e));
  }
  trim() {
    return new $u({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new $u({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new $u({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
$u.create = (t) => new $u({
  checks: [],
  typeName: Jt.ZodString,
  coerce: t?.coerce ?? !1,
  ...Sn(t)
});
function Are(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, i = n > r ? n : r, a = Number.parseInt(t.toFixed(i).replace(".", "")), s = Number.parseInt(e.toFixed(i).replace(".", ""));
  return a % s / 10 ** i;
}
class F0 extends Mn {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== St.number) {
      const a = this._getOrReturnCtx(e);
      return vt(a, {
        code: at.invalid_type,
        expected: St.number,
        received: a.parsedType
      }), Zt;
    }
    let r;
    const i = new Jo();
    for (const a of this._def.checks)
      a.kind === "int" ? nr.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), vt(r, {
        code: at.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), i.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (r = this._getOrReturnCtx(e, r), vt(r, {
        code: at.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (r = this._getOrReturnCtx(e, r), vt(r, {
        code: at.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? Are(e.data, a.value) !== 0 && (r = this._getOrReturnCtx(e, r), vt(r, {
        code: at.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), vt(r, {
        code: at.not_finite,
        message: a.message
      }), i.dirty()) : nr.assertNever(a);
    return { status: i.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, Pt.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, Pt.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, Pt.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, Pt.toString(n));
  }
  setLimit(e, n, r, i) {
    return new F0({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: Pt.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new F0({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: Pt.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Pt.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Pt.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Pt.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Pt.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Pt.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: Pt.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Pt.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Pt.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && nr.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
F0.create = (t) => new F0({
  checks: [],
  typeName: Jt.ZodNumber,
  coerce: t?.coerce || !1,
  ...Sn(t)
});
class V0 extends Mn {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== St.bigint)
      return this._getInvalidInput(e);
    let r;
    const i = new Jo();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (r = this._getOrReturnCtx(e, r), vt(r, {
        code: at.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (r = this._getOrReturnCtx(e, r), vt(r, {
        code: at.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), vt(r, {
        code: at.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : nr.assertNever(a);
    return { status: i.value, value: e.data };
  }
  _getInvalidInput(e) {
    const n = this._getOrReturnCtx(e);
    return vt(n, {
      code: at.invalid_type,
      expected: St.bigint,
      received: n.parsedType
    }), Zt;
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, Pt.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, Pt.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, Pt.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, Pt.toString(n));
  }
  setLimit(e, n, r, i) {
    return new V0({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: Pt.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new V0({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Pt.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Pt.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Pt.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Pt.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Pt.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
V0.create = (t) => new V0({
  checks: [],
  typeName: Jt.ZodBigInt,
  coerce: t?.coerce ?? !1,
  ...Sn(t)
});
class TE extends Mn {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== St.boolean) {
      const r = this._getOrReturnCtx(e);
      return vt(r, {
        code: at.invalid_type,
        expected: St.boolean,
        received: r.parsedType
      }), Zt;
    }
    return js(e.data);
  }
}
TE.create = (t) => new TE({
  typeName: Jt.ZodBoolean,
  coerce: t?.coerce || !1,
  ...Sn(t)
});
class pg extends Mn {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== St.date) {
      const a = this._getOrReturnCtx(e);
      return vt(a, {
        code: at.invalid_type,
        expected: St.date,
        received: a.parsedType
      }), Zt;
    }
    if (Number.isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return vt(a, {
        code: at.invalid_date
      }), Zt;
    }
    const r = new Jo();
    let i;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (i = this._getOrReturnCtx(e, i), vt(i, {
        code: at.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), r.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (i = this._getOrReturnCtx(e, i), vt(i, {
        code: at.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), r.dirty()) : nr.assertNever(a);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new pg({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: Pt.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: Pt.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
pg.create = (t) => new pg({
  checks: [],
  coerce: t?.coerce || !1,
  typeName: Jt.ZodDate,
  ...Sn(t)
});
class eT extends Mn {
  _parse(e) {
    if (this._getType(e) !== St.symbol) {
      const r = this._getOrReturnCtx(e);
      return vt(r, {
        code: at.invalid_type,
        expected: St.symbol,
        received: r.parsedType
      }), Zt;
    }
    return js(e.data);
  }
}
eT.create = (t) => new eT({
  typeName: Jt.ZodSymbol,
  ...Sn(t)
});
class OE extends Mn {
  _parse(e) {
    if (this._getType(e) !== St.undefined) {
      const r = this._getOrReturnCtx(e);
      return vt(r, {
        code: at.invalid_type,
        expected: St.undefined,
        received: r.parsedType
      }), Zt;
    }
    return js(e.data);
  }
}
OE.create = (t) => new OE({
  typeName: Jt.ZodUndefined,
  ...Sn(t)
});
class RE extends Mn {
  _parse(e) {
    if (this._getType(e) !== St.null) {
      const r = this._getOrReturnCtx(e);
      return vt(r, {
        code: at.invalid_type,
        expected: St.null,
        received: r.parsedType
      }), Zt;
    }
    return js(e.data);
  }
}
RE.create = (t) => new RE({
  typeName: Jt.ZodNull,
  ...Sn(t)
});
class $b extends Mn {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return js(e.data);
  }
}
$b.create = (t) => new $b({
  typeName: Jt.ZodAny,
  ...Sn(t)
});
class og extends Mn {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return js(e.data);
  }
}
og.create = (t) => new og({
  typeName: Jt.ZodUnknown,
  ...Sn(t)
});
class Rh extends Mn {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return vt(n, {
      code: at.invalid_type,
      expected: St.never,
      received: n.parsedType
    }), Zt;
  }
}
Rh.create = (t) => new Rh({
  typeName: Jt.ZodNever,
  ...Sn(t)
});
class tT extends Mn {
  _parse(e) {
    if (this._getType(e) !== St.undefined) {
      const r = this._getOrReturnCtx(e);
      return vt(r, {
        code: at.invalid_type,
        expected: St.void,
        received: r.parsedType
      }), Zt;
    }
    return js(e.data);
  }
}
tT.create = (t) => new tT({
  typeName: Jt.ZodVoid,
  ...Sn(t)
});
class Hu extends Mn {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), i = this._def;
    if (n.parsedType !== St.array)
      return vt(n, {
        code: at.invalid_type,
        expected: St.array,
        received: n.parsedType
      }), Zt;
    if (i.exactLength !== null) {
      const s = n.data.length > i.exactLength.value, c = n.data.length < i.exactLength.value;
      (s || c) && (vt(n, {
        code: s ? at.too_big : at.too_small,
        minimum: c ? i.exactLength.value : void 0,
        maximum: s ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), r.dirty());
    }
    if (i.minLength !== null && n.data.length < i.minLength.value && (vt(n, {
      code: at.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), r.dirty()), i.maxLength !== null && n.data.length > i.maxLength.value && (vt(n, {
      code: at.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((s, c) => i.type._parseAsync(new ef(n, s, n.path, c)))).then((s) => Jo.mergeArray(r, s));
    const a = [...n.data].map((s, c) => i.type._parseSync(new ef(n, s, n.path, c)));
    return Jo.mergeArray(r, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new Hu({
      ...this._def,
      minLength: { value: e, message: Pt.toString(n) }
    });
  }
  max(e, n) {
    return new Hu({
      ...this._def,
      maxLength: { value: e, message: Pt.toString(n) }
    });
  }
  length(e, n) {
    return new Hu({
      ...this._def,
      exactLength: { value: e, message: Pt.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Hu.create = (t, e) => new Hu({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Jt.ZodArray,
  ...Sn(e)
});
function vb(t) {
  if (t instanceof zi) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = Xd.create(vb(r));
    }
    return new zi({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof Hu ? new Hu({
      ...t._def,
      type: vb(t.element)
    }) : t instanceof Xd ? Xd.create(vb(t.unwrap())) : t instanceof $0 ? $0.create(vb(t.unwrap())) : t instanceof tf ? tf.create(t.items.map((e) => vb(e))) : t;
}
class zi extends Mn {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = nr.objectKeys(e);
    return this._cached = { shape: e, keys: n }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== St.object) {
      const f = this._getOrReturnCtx(e);
      return vt(f, {
        code: at.invalid_type,
        expected: St.object,
        received: f.parsedType
      }), Zt;
    }
    const { status: r, ctx: i } = this._processInputParams(e), { shape: a, keys: s } = this._getCached(), c = [];
    if (!(this._def.catchall instanceof Rh && this._def.unknownKeys === "strip"))
      for (const f in i.data)
        s.includes(f) || c.push(f);
    const d = [];
    for (const f of s) {
      const g = a[f], m = i.data[f];
      d.push({
        key: { status: "valid", value: f },
        value: g._parse(new ef(i, m, i.path, f)),
        alwaysSet: f in i.data
      });
    }
    if (this._def.catchall instanceof Rh) {
      const f = this._def.unknownKeys;
      if (f === "passthrough")
        for (const g of c)
          d.push({
            key: { status: "valid", value: g },
            value: { status: "valid", value: i.data[g] }
          });
      else if (f === "strict")
        c.length > 0 && (vt(i, {
          code: at.unrecognized_keys,
          keys: c
        }), r.dirty());
      else if (f !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const f = this._def.catchall;
      for (const g of c) {
        const m = i.data[g];
        d.push({
          key: { status: "valid", value: g },
          value: f._parse(
            new ef(i, m, i.path, g)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: g in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const f = [];
      for (const g of d) {
        const m = await g.key, b = await g.value;
        f.push({
          key: m,
          value: b,
          alwaysSet: g.alwaysSet
        });
      }
      return f;
    }).then((f) => Jo.mergeObjectSync(r, f)) : Jo.mergeObjectSync(r, d);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return Pt.errToObj, new zi({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, r) => {
          const i = this._def.errorMap?.(n, r).message ?? r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: Pt.errToObj(e).message ?? i
          } : {
            message: i
          };
        }
      } : {}
    });
  }
  strip() {
    return new zi({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new zi({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new zi({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new zi({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: Jt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new zi({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    for (const r of nr.objectKeys(e))
      e[r] && this.shape[r] && (n[r] = this.shape[r]);
    return new zi({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    for (const r of nr.objectKeys(this.shape))
      e[r] || (n[r] = this.shape[r]);
    return new zi({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return vb(this);
  }
  partial(e) {
    const n = {};
    for (const r of nr.objectKeys(this.shape)) {
      const i = this.shape[r];
      e && !e[r] ? n[r] = i : n[r] = i.optional();
    }
    return new zi({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    for (const r of nr.objectKeys(this.shape))
      if (e && !e[r])
        n[r] = this.shape[r];
      else {
        let a = this.shape[r];
        for (; a instanceof Xd; )
          a = a._def.innerType;
        n[r] = a;
      }
    return new zi({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return $$(nr.objectKeys(this.shape));
  }
}
zi.create = (t, e) => new zi({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Rh.create(),
  typeName: Jt.ZodObject,
  ...Sn(e)
});
zi.strictCreate = (t, e) => new zi({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Rh.create(),
  typeName: Jt.ZodObject,
  ...Sn(e)
});
zi.lazycreate = (t, e) => new zi({
  shape: t,
  unknownKeys: "strip",
  catchall: Rh.create(),
  typeName: Jt.ZodObject,
  ...Sn(e)
});
class DE extends Mn {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    function i(a) {
      for (const c of a)
        if (c.result.status === "valid")
          return c.result;
      for (const c of a)
        if (c.result.status === "dirty")
          return n.common.issues.push(...c.ctx.common.issues), c.result;
      const s = a.map((c) => new Gl(c.ctx.common.issues));
      return vt(n, {
        code: at.invalid_union,
        unionErrors: s
      }), Zt;
    }
    if (n.common.async)
      return Promise.all(r.map(async (a) => {
        const s = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: n.data,
            path: n.path,
            parent: s
          }),
          ctx: s
        };
      })).then(i);
    {
      let a;
      const s = [];
      for (const d of r) {
        const f = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, g = d._parseSync({
          data: n.data,
          path: n.path,
          parent: f
        });
        if (g.status === "valid")
          return g;
        g.status === "dirty" && !a && (a = { result: g, ctx: f }), f.common.issues.length && s.push(f.common.issues);
      }
      if (a)
        return n.common.issues.push(...a.ctx.common.issues), a.result;
      const c = s.map((d) => new Gl(d));
      return vt(n, {
        code: at.invalid_union,
        unionErrors: c
      }), Zt;
    }
  }
  get options() {
    return this._def.options;
  }
}
DE.create = (t, e) => new DE({
  options: t,
  typeName: Jt.ZodUnion,
  ...Sn(e)
});
const xh = (t) => t instanceof IE ? xh(t.schema) : t instanceof Yu ? xh(t.innerType()) : t instanceof kE ? [t.value] : t instanceof U0 ? t.options : t instanceof jE ? nr.objectValues(t.enum) : t instanceof PE ? xh(t._def.innerType) : t instanceof OE ? [void 0] : t instanceof RE ? [null] : t instanceof Xd ? [void 0, ...xh(t.unwrap())] : t instanceof $0 ? [null, ...xh(t.unwrap())] : t instanceof gM || t instanceof BE ? xh(t.unwrap()) : t instanceof LE ? xh(t._def.innerType) : [];
class w5 extends Mn {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== St.object)
      return vt(n, {
        code: at.invalid_type,
        expected: St.object,
        received: n.parsedType
      }), Zt;
    const r = this.discriminator, i = n.data[r], a = this.optionsMap.get(i);
    return a ? n.common.async ? a._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : a._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (vt(n, {
      code: at.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), Zt);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, r) {
    const i = /* @__PURE__ */ new Map();
    for (const a of n) {
      const s = xh(a.shape[e]);
      if (!s.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const c of s) {
        if (i.has(c))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(c)}`);
        i.set(c, a);
      }
    }
    return new w5({
      typeName: Jt.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: i,
      ...Sn(r)
    });
  }
}
function n8(t, e) {
  const n = Eh(t), r = Eh(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === St.object && r === St.object) {
    const i = nr.objectKeys(e), a = nr.objectKeys(t).filter((c) => i.indexOf(c) !== -1), s = { ...t, ...e };
    for (const c of a) {
      const d = n8(t[c], e[c]);
      if (!d.valid)
        return { valid: !1 };
      s[c] = d.data;
    }
    return { valid: !0, data: s };
  } else if (n === St.array && r === St.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const i = [];
    for (let a = 0; a < t.length; a++) {
      const s = t[a], c = e[a], d = n8(s, c);
      if (!d.valid)
        return { valid: !1 };
      i.push(d.data);
    }
    return { valid: !0, data: i };
  } else
    return n === St.date && r === St.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class NE extends Mn {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), i = (a, s) => {
      if (e8(a) || e8(s))
        return Zt;
      const c = n8(a.value, s.value);
      return c.valid ? ((t8(a) || t8(s)) && n.dirty(), { status: n.value, value: c.data }) : (vt(r, {
        code: at.invalid_intersection_types
      }), Zt);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([a, s]) => i(a, s)) : i(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
NE.create = (t, e, n) => new NE({
  left: t,
  right: e,
  typeName: Jt.ZodIntersection,
  ...Sn(n)
});
class tf extends Mn {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== St.array)
      return vt(r, {
        code: at.invalid_type,
        expected: St.array,
        received: r.parsedType
      }), Zt;
    if (r.data.length < this._def.items.length)
      return vt(r, {
        code: at.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Zt;
    !this._def.rest && r.data.length > this._def.items.length && (vt(r, {
      code: at.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const a = [...r.data].map((s, c) => {
      const d = this._def.items[c] || this._def.rest;
      return d ? d._parse(new ef(r, s, r.path, c)) : null;
    }).filter((s) => !!s);
    return r.common.async ? Promise.all(a).then((s) => Jo.mergeArray(n, s)) : Jo.mergeArray(n, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new tf({
      ...this._def,
      rest: e
    });
  }
}
tf.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new tf({
    items: t,
    typeName: Jt.ZodTuple,
    rest: null,
    ...Sn(e)
  });
};
class ME extends Mn {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== St.object)
      return vt(r, {
        code: at.invalid_type,
        expected: St.object,
        received: r.parsedType
      }), Zt;
    const i = [], a = this._def.keyType, s = this._def.valueType;
    for (const c in r.data)
      i.push({
        key: a._parse(new ef(r, c, r.path, c)),
        value: s._parse(new ef(r, r.data[c], r.path, c)),
        alwaysSet: c in r.data
      });
    return r.common.async ? Jo.mergeObjectAsync(n, i) : Jo.mergeObjectSync(n, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return n instanceof Mn ? new ME({
      keyType: e,
      valueType: n,
      typeName: Jt.ZodRecord,
      ...Sn(r)
    }) : new ME({
      keyType: $u.create(),
      valueType: e,
      typeName: Jt.ZodRecord,
      ...Sn(n)
    });
  }
}
class nT extends Mn {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== St.map)
      return vt(r, {
        code: at.invalid_type,
        expected: St.map,
        received: r.parsedType
      }), Zt;
    const i = this._def.keyType, a = this._def.valueType, s = [...r.data.entries()].map(([c, d], f) => ({
      key: i._parse(new ef(r, c, r.path, [f, "key"])),
      value: a._parse(new ef(r, d, r.path, [f, "value"]))
    }));
    if (r.common.async) {
      const c = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const d of s) {
          const f = await d.key, g = await d.value;
          if (f.status === "aborted" || g.status === "aborted")
            return Zt;
          (f.status === "dirty" || g.status === "dirty") && n.dirty(), c.set(f.value, g.value);
        }
        return { status: n.value, value: c };
      });
    } else {
      const c = /* @__PURE__ */ new Map();
      for (const d of s) {
        const f = d.key, g = d.value;
        if (f.status === "aborted" || g.status === "aborted")
          return Zt;
        (f.status === "dirty" || g.status === "dirty") && n.dirty(), c.set(f.value, g.value);
      }
      return { status: n.value, value: c };
    }
  }
}
nT.create = (t, e, n) => new nT({
  valueType: e,
  keyType: t,
  typeName: Jt.ZodMap,
  ...Sn(n)
});
class mg extends Mn {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== St.set)
      return vt(r, {
        code: at.invalid_type,
        expected: St.set,
        received: r.parsedType
      }), Zt;
    const i = this._def;
    i.minSize !== null && r.data.size < i.minSize.value && (vt(r, {
      code: at.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), n.dirty()), i.maxSize !== null && r.data.size > i.maxSize.value && (vt(r, {
      code: at.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), n.dirty());
    const a = this._def.valueType;
    function s(d) {
      const f = /* @__PURE__ */ new Set();
      for (const g of d) {
        if (g.status === "aborted")
          return Zt;
        g.status === "dirty" && n.dirty(), f.add(g.value);
      }
      return { status: n.value, value: f };
    }
    const c = [...r.data.values()].map((d, f) => a._parse(new ef(r, d, r.path, f)));
    return r.common.async ? Promise.all(c).then((d) => s(d)) : s(c);
  }
  min(e, n) {
    return new mg({
      ...this._def,
      minSize: { value: e, message: Pt.toString(n) }
    });
  }
  max(e, n) {
    return new mg({
      ...this._def,
      maxSize: { value: e, message: Pt.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
mg.create = (t, e) => new mg({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: Jt.ZodSet,
  ...Sn(e)
});
class Nb extends Mn {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== St.function)
      return vt(n, {
        code: at.invalid_type,
        expected: St.function,
        received: n.parsedType
      }), Zt;
    function r(c, d) {
      return J4({
        data: c,
        path: n.path,
        errorMaps: [n.common.contextualErrorMap, n.schemaErrorMap, K4(), Ub].filter((f) => !!f),
        issueData: {
          code: at.invalid_arguments,
          argumentsError: d
        }
      });
    }
    function i(c, d) {
      return J4({
        data: c,
        path: n.path,
        errorMaps: [n.common.contextualErrorMap, n.schemaErrorMap, K4(), Ub].filter((f) => !!f),
        issueData: {
          code: at.invalid_return_type,
          returnTypeError: d
        }
      });
    }
    const a = { errorMap: n.common.contextualErrorMap }, s = n.data;
    if (this._def.returns instanceof Hb) {
      const c = this;
      return js(async function(...d) {
        const f = new Gl([]), g = await c._def.args.parseAsync(d, a).catch((w) => {
          throw f.addIssue(r(d, w)), f;
        }), m = await Reflect.apply(s, this, g);
        return await c._def.returns._def.type.parseAsync(m, a).catch((w) => {
          throw f.addIssue(i(m, w)), f;
        });
      });
    } else {
      const c = this;
      return js(function(...d) {
        const f = c._def.args.safeParse(d, a);
        if (!f.success)
          throw new Gl([r(d, f.error)]);
        const g = Reflect.apply(s, this, f.data), m = c._def.returns.safeParse(g, a);
        if (!m.success)
          throw new Gl([i(g, m.error)]);
        return m.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new Nb({
      ...this._def,
      args: tf.create(e).rest(og.create())
    });
  }
  returns(e) {
    return new Nb({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, n, r) {
    return new Nb({
      args: e || tf.create([]).rest(og.create()),
      returns: n || og.create(),
      typeName: Jt.ZodFunction,
      ...Sn(r)
    });
  }
}
class IE extends Mn {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
IE.create = (t, e) => new IE({
  getter: t,
  typeName: Jt.ZodLazy,
  ...Sn(e)
});
class kE extends Mn {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return vt(n, {
        received: n.data,
        code: at.invalid_literal,
        expected: this._def.value
      }), Zt;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
kE.create = (t, e) => new kE({
  value: t,
  typeName: Jt.ZodLiteral,
  ...Sn(e)
});
function $$(t, e) {
  return new U0({
    values: t,
    typeName: Jt.ZodEnum,
    ...Sn(e)
  });
}
class U0 extends Mn {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return vt(n, {
        expected: nr.joinValues(r),
        received: n.parsedType,
        code: at.invalid_type
      }), Zt;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return vt(n, {
        received: n.data,
        code: at.invalid_enum_value,
        options: r
      }), Zt;
    }
    return js(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return U0.create(e, {
      ...this._def,
      ...n
    });
  }
  exclude(e, n = this._def) {
    return U0.create(this.options.filter((r) => !e.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
U0.create = $$;
class jE extends Mn {
  _parse(e) {
    const n = nr.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== St.string && r.parsedType !== St.number) {
      const i = nr.objectValues(n);
      return vt(r, {
        expected: nr.joinValues(i),
        received: r.parsedType,
        code: at.invalid_type
      }), Zt;
    }
    if (this._cache || (this._cache = new Set(nr.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const i = nr.objectValues(n);
      return vt(r, {
        received: r.data,
        code: at.invalid_enum_value,
        options: i
      }), Zt;
    }
    return js(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
jE.create = (t, e) => new jE({
  values: t,
  typeName: Jt.ZodNativeEnum,
  ...Sn(e)
});
class Hb extends Mn {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== St.promise && n.common.async === !1)
      return vt(n, {
        code: at.invalid_type,
        expected: St.promise,
        received: n.parsedType
      }), Zt;
    const r = n.parsedType === St.promise ? n.data : Promise.resolve(n.data);
    return js(r.then((i) => this._def.type.parseAsync(i, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
Hb.create = (t, e) => new Hb({
  type: t,
  typeName: Jt.ZodPromise,
  ...Sn(e)
});
class Yu extends Mn {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Jt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), i = this._def.effect || null, a = {
      addIssue: (s) => {
        vt(r, s), s.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), i.type === "preprocess") {
      const s = i.transform(r.data, a);
      if (r.common.async)
        return Promise.resolve(s).then(async (c) => {
          if (n.value === "aborted")
            return Zt;
          const d = await this._def.schema._parseAsync({
            data: c,
            path: r.path,
            parent: r
          });
          return d.status === "aborted" ? Zt : d.status === "dirty" || n.value === "dirty" ? bb(d.value) : d;
        });
      {
        if (n.value === "aborted")
          return Zt;
        const c = this._def.schema._parseSync({
          data: s,
          path: r.path,
          parent: r
        });
        return c.status === "aborted" ? Zt : c.status === "dirty" || n.value === "dirty" ? bb(c.value) : c;
      }
    }
    if (i.type === "refinement") {
      const s = (c) => {
        const d = i.refinement(c, a);
        if (r.common.async)
          return Promise.resolve(d);
        if (d instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return c;
      };
      if (r.common.async === !1) {
        const c = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return c.status === "aborted" ? Zt : (c.status === "dirty" && n.dirty(), s(c.value), { status: n.value, value: c.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((c) => c.status === "aborted" ? Zt : (c.status === "dirty" && n.dirty(), s(c.value).then(() => ({ status: n.value, value: c.value }))));
    }
    if (i.type === "transform")
      if (r.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!hg(s))
          return Zt;
        const c = i.transform(s.value, a);
        if (c instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: c };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((s) => hg(s) ? Promise.resolve(i.transform(s.value, a)).then((c) => ({
          status: n.value,
          value: c
        })) : Zt);
    nr.assertNever(i);
  }
}
Yu.create = (t, e, n) => new Yu({
  schema: t,
  typeName: Jt.ZodEffects,
  effect: e,
  ...Sn(n)
});
Yu.createWithPreprocess = (t, e, n) => new Yu({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: Jt.ZodEffects,
  ...Sn(n)
});
class Xd extends Mn {
  _parse(e) {
    return this._getType(e) === St.undefined ? js(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Xd.create = (t, e) => new Xd({
  innerType: t,
  typeName: Jt.ZodOptional,
  ...Sn(e)
});
class $0 extends Mn {
  _parse(e) {
    return this._getType(e) === St.null ? js(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
$0.create = (t, e) => new $0({
  innerType: t,
  typeName: Jt.ZodNullable,
  ...Sn(e)
});
class PE extends Mn {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === St.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
PE.create = (t, e) => new PE({
  innerType: t,
  typeName: Jt.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...Sn(e)
});
class LE extends Mn {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return CE(i) ? i.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Gl(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Gl(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
LE.create = (t, e) => new LE({
  innerType: t,
  typeName: Jt.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...Sn(e)
});
class rT extends Mn {
  _parse(e) {
    if (this._getType(e) !== St.nan) {
      const r = this._getOrReturnCtx(e);
      return vt(r, {
        code: at.invalid_type,
        expected: St.nan,
        received: r.parsedType
      }), Zt;
    }
    return { status: "valid", value: e.data };
  }
}
rT.create = (t) => new rT({
  typeName: Jt.ZodNaN,
  ...Sn(t)
});
const Cre = Symbol("zod_brand");
class gM extends Mn {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class v_ extends Mn {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? Zt : a.status === "dirty" ? (n.dirty(), bb(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return i.status === "aborted" ? Zt : i.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, n) {
    return new v_({
      in: e,
      out: n,
      typeName: Jt.ZodPipeline
    });
  }
}
class BE extends Mn {
  _parse(e) {
    const n = this._def.innerType._parse(e), r = (i) => (hg(i) && (i.value = Object.freeze(i.value)), i);
    return CE(n) ? n.then((i) => r(i)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
BE.create = (t, e) => new BE({
  innerType: t,
  typeName: Jt.ZodReadonly,
  ...Sn(e)
});
function wP(t, e) {
  const n = typeof t == "function" ? t(e) : typeof t == "string" ? { message: t } : t;
  return typeof n == "string" ? { message: n } : n;
}
function H$(t, e = {}, n) {
  return t ? $b.create().superRefine((r, i) => {
    const a = t(r);
    if (a instanceof Promise)
      return a.then((s) => {
        if (!s) {
          const c = wP(e, r), d = c.fatal ?? n ?? !0;
          i.addIssue({ code: "custom", ...c, fatal: d });
        }
      });
    if (!a) {
      const s = wP(e, r), c = s.fatal ?? n ?? !0;
      i.addIssue({ code: "custom", ...s, fatal: c });
    }
  }) : $b.create();
}
const Tre = {
  object: zi.lazycreate
};
var Jt;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(Jt || (Jt = {}));
const Ore = (t, e = {
  message: `Input not instance of ${t.name}`
}) => H$((n) => n instanceof t, e), Je = $u.create, Ve = F0.create, Rre = rT.create, Dre = V0.create, Sr = TE.create, vM = pg.create, Nre = eT.create, Mre = OE.create, r8 = RE.create, q$ = $b.create, G$ = og.create, Ire = Rh.create, kre = tT.create, Xr = Hu.create, Xe = zi.create, jre = zi.strictCreate, yM = DE.create, Y$ = w5.create, Pre = NE.create, Lre = tf.create, gg = ME.create, Bre = nT.create, zre = mg.create, Fre = Nb.create, Vre = IE.create, zE = kE.create, y_ = U0.create, Dg = jE.create, Ure = Hb.create, xP = Yu.create, $re = Xd.create, X$ = $0.create, x5 = Yu.createWithPreprocess, Hre = v_.create, qre = () => Je().optional(), Gre = () => Ve().optional(), Yre = () => Sr().optional(), Xre = {
  string: (t) => $u.create({ ...t, coerce: !0 }),
  number: (t) => F0.create({ ...t, coerce: !0 }),
  boolean: (t) => TE.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => V0.create({ ...t, coerce: !0 }),
  date: (t) => pg.create({ ...t, coerce: !0 })
}, Wre = Zt, Fi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BRAND: Cre,
  DIRTY: bb,
  EMPTY_PATH: ire,
  INVALID: Zt,
  NEVER: Wre,
  OK: js,
  ParseStatus: Jo,
  Schema: Mn,
  ZodAny: $b,
  ZodArray: Hu,
  ZodBigInt: V0,
  ZodBoolean: TE,
  ZodBranded: gM,
  ZodCatch: LE,
  ZodDate: pg,
  ZodDefault: PE,
  ZodDiscriminatedUnion: w5,
  ZodEffects: Yu,
  ZodEnum: U0,
  ZodError: Gl,
  get ZodFirstPartyTypeKind() {
    return Jt;
  },
  ZodFunction: Nb,
  ZodIntersection: NE,
  ZodIssueCode: at,
  ZodLazy: IE,
  ZodLiteral: kE,
  ZodMap: nT,
  ZodNaN: rT,
  ZodNativeEnum: jE,
  ZodNever: Rh,
  ZodNull: RE,
  ZodNullable: $0,
  ZodNumber: F0,
  ZodObject: zi,
  ZodOptional: Xd,
  ZodParsedType: St,
  ZodPipeline: v_,
  ZodPromise: Hb,
  ZodReadonly: BE,
  ZodRecord: ME,
  ZodSchema: Mn,
  ZodSet: mg,
  ZodString: $u,
  ZodSymbol: eT,
  ZodTransformer: Yu,
  ZodTuple: tf,
  ZodType: Mn,
  ZodUndefined: OE,
  ZodUnion: DE,
  ZodUnknown: og,
  ZodVoid: tT,
  addIssueToContext: vt,
  any: q$,
  array: Xr,
  bigint: Dre,
  boolean: Sr,
  coerce: Xre,
  custom: H$,
  date: vM,
  datetimeRegex: U$,
  defaultErrorMap: Ub,
  discriminatedUnion: Y$,
  effect: xP,
  enum: y_,
  function: Fre,
  getErrorMap: K4,
  getParsedType: Eh,
  instanceof: Ore,
  intersection: Pre,
  isAborted: e8,
  isAsync: CE,
  isDirty: t8,
  isValid: hg,
  late: Tre,
  lazy: Vre,
  literal: zE,
  makeIssue: J4,
  map: Bre,
  nan: Rre,
  nativeEnum: Dg,
  never: Ire,
  null: r8,
  nullable: X$,
  number: Ve,
  object: Xe,
  get objectUtil() {
    return JD;
  },
  oboolean: Yre,
  onumber: Gre,
  optional: $re,
  ostring: qre,
  pipeline: Hre,
  preprocess: x5,
  promise: Ure,
  quotelessJson: tre,
  record: gg,
  set: zre,
  setErrorMap: rre,
  strictObject: jre,
  string: Je,
  symbol: Nre,
  transformer: xP,
  tuple: Lre,
  undefined: Mre,
  union: yM,
  unknown: G$,
  get util() {
    return nr;
  },
  void: kre
}, Symbol.toStringTag, { value: "Module" })), Qre = Xe({
  // TODO use id
  userId: Ve(),
  username: Je(),
  email: Je(),
  sub: Je(),
  // TODO optional?
  isSuperuser: Sr(),
  organizationId: Ve(),
  hasPassword: Sr()
}), SP = (t) => {
  let e;
  const n = /* @__PURE__ */ new Set(), r = (f, g) => {
    const m = typeof f == "function" ? f(e) : f;
    if (!Object.is(m, e)) {
      const b = e;
      e = g ?? (typeof m != "object" || m === null) ? m : Object.assign({}, e, m), n.forEach((w) => w(e, b));
    }
  }, i = () => e, c = { setState: r, getState: i, getInitialState: () => d, subscribe: (f) => (n.add(f), () => n.delete(f)) }, d = e = t(r, i, c);
  return c;
}, Zre = (t) => t ? SP(t) : SP, Kre = (t) => t;
function Jre(t, e = Kre) {
  const n = De.useSyncExternalStore(
    t.subscribe,
    De.useCallback(() => e(t.getState()), [t, e]),
    De.useCallback(() => e(t.getInitialState()), [t, e])
  );
  return De.useDebugValue(n), n;
}
const EP = (t) => {
  const e = Zre(t), n = (r) => Jre(e, r);
  return Object.assign(n, e), n;
}, S5 = (t) => t ? EP(t) : EP;
var bM = { exports: {} };
const W$ = (t) => typeof t == "object" && t !== null, Q$ = Symbol("skip"), _P = (t) => W$(t) && !(t instanceof RegExp) && !(t instanceof Error) && !(t instanceof Date), i8 = (t, e, n, r = /* @__PURE__ */ new WeakMap()) => {
  if (n = {
    deep: !1,
    target: {},
    ...n
  }, r.has(t))
    return r.get(t);
  r.set(t, n.target);
  const { target: i } = n;
  delete n.target;
  const a = (s) => s.map((c) => _P(c) ? i8(c, e, n, r) : c);
  if (Array.isArray(t))
    return a(t);
  for (const [s, c] of Object.entries(t)) {
    const d = e(s, c, t);
    if (d === Q$)
      continue;
    let [f, g, { shouldRecurse: m = !0 } = {}] = d;
    f !== "__proto__" && (n.deep && m && _P(g) && (g = Array.isArray(g) ? a(g) : i8(g, e, n, r)), i[f] = g);
  }
  return i;
};
bM.exports = (t, e, n) => {
  if (!W$(t))
    throw new TypeError(`Expected an object, got \`${t}\` (${typeof t})`);
  return i8(t, e, n);
};
bM.exports.mapObjectSkip = Q$;
var Z$ = bM.exports;
const AP = /* @__PURE__ */ J0(Z$), eie = /[\p{Lu}]/u, tie = /[\p{Ll}]/u, CP = /^[\p{Lu}](?![\p{Lu}])/gu, K$ = /([\p{Alpha}\p{N}_]|$)/u, wM = /[_.\- ]+/, nie = new RegExp("^" + wM.source), TP = new RegExp(wM.source + K$.source, "gu"), OP = new RegExp("\\d+" + K$.source, "gu"), rie = (t, e, n, r) => {
  let i = !1, a = !1, s = !1, c = !1;
  for (let d = 0; d < t.length; d++) {
    const f = t[d];
    c = d > 2 ? t[d - 3] === "-" : !0, i && eie.test(f) ? (t = t.slice(0, d) + "-" + t.slice(d), i = !1, s = a, a = !0, d++) : a && s && tie.test(f) && (!c || r) ? (t = t.slice(0, d - 1) + "-" + t.slice(d - 1), s = a, a = !1, i = !0) : (i = e(f) === f && n(f) !== f, s = a, a = n(f) === f && e(f) !== f);
  }
  return t;
}, iie = (t, e) => (CP.lastIndex = 0, t.replace(CP, (n) => e(n))), aie = (t, e) => (TP.lastIndex = 0, OP.lastIndex = 0, t.replace(TP, (n, r) => e(r)).replace(OP, (n) => e(n)));
function oie(t, e) {
  if (!(typeof t == "string" || Array.isArray(t)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (e = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...e
  }, Array.isArray(t) ? t = t.map((a) => a.trim()).filter((a) => a.length).join("-") : t = t.trim(), t.length === 0)
    return "";
  const n = e.locale === !1 ? (a) => a.toLowerCase() : (a) => a.toLocaleLowerCase(e.locale), r = e.locale === !1 ? (a) => a.toUpperCase() : (a) => a.toLocaleUpperCase(e.locale);
  return t.length === 1 ? wM.test(t) ? "" : e.pascalCase ? r(t) : n(t) : (t !== n(t) && (t = rie(t, n, r, e.preserveConsecutiveUppercase)), t = t.replace(nie, ""), t = e.preserveConsecutiveUppercase ? iie(t, n) : n(t), e.pascalCase && (t = r(t.charAt(0)) + t.slice(1)), aie(t, r));
}
class sie extends Map {
  constructor(e = {}) {
    if (super(), !(e.maxSize && e.maxSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    if (typeof e.maxAge == "number" && e.maxAge === 0)
      throw new TypeError("`maxAge` must be a number greater than 0");
    this.maxSize = e.maxSize, this.maxAge = e.maxAge || Number.POSITIVE_INFINITY, this.onEviction = e.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
  }
  // TODO: Use private class methods when targeting Node.js 16.
  _emitEvictions(e) {
    if (typeof this.onEviction == "function")
      for (const [n, r] of e)
        this.onEviction(n, r.value);
  }
  _deleteIfExpired(e, n) {
    return typeof n.expiry == "number" && n.expiry <= Date.now() ? (typeof this.onEviction == "function" && this.onEviction(e, n.value), this.delete(e)) : !1;
  }
  _getOrDeleteIfExpired(e, n) {
    if (this._deleteIfExpired(e, n) === !1)
      return n.value;
  }
  _getItemValue(e, n) {
    return n.expiry ? this._getOrDeleteIfExpired(e, n) : n.value;
  }
  _peek(e, n) {
    const r = n.get(e);
    return this._getItemValue(e, r);
  }
  _set(e, n) {
    this.cache.set(e, n), this._size++, this._size >= this.maxSize && (this._size = 0, this._emitEvictions(this.oldCache), this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map());
  }
  _moveToRecent(e, n) {
    this.oldCache.delete(e), this._set(e, n);
  }
  *_entriesAscending() {
    for (const e of this.oldCache) {
      const [n, r] = e;
      this.cache.has(n) || this._deleteIfExpired(n, r) === !1 && (yield e);
    }
    for (const e of this.cache) {
      const [n, r] = e;
      this._deleteIfExpired(n, r) === !1 && (yield e);
    }
  }
  get(e) {
    if (this.cache.has(e)) {
      const n = this.cache.get(e);
      return this._getItemValue(e, n);
    }
    if (this.oldCache.has(e)) {
      const n = this.oldCache.get(e);
      if (this._deleteIfExpired(e, n) === !1)
        return this._moveToRecent(e, n), n.value;
    }
  }
  set(e, n, { maxAge: r = this.maxAge } = {}) {
    const i = typeof r == "number" && r !== Number.POSITIVE_INFINITY ? Date.now() + r : void 0;
    return this.cache.has(e) ? this.cache.set(e, {
      value: n,
      expiry: i
    }) : this._set(e, { value: n, expiry: i }), this;
  }
  has(e) {
    return this.cache.has(e) ? !this._deleteIfExpired(e, this.cache.get(e)) : this.oldCache.has(e) ? !this._deleteIfExpired(e, this.oldCache.get(e)) : !1;
  }
  peek(e) {
    if (this.cache.has(e))
      return this._peek(e, this.cache);
    if (this.oldCache.has(e))
      return this._peek(e, this.oldCache);
  }
  delete(e) {
    const n = this.cache.delete(e);
    return n && this._size--, this.oldCache.delete(e) || n;
  }
  clear() {
    this.cache.clear(), this.oldCache.clear(), this._size = 0;
  }
  resize(e) {
    if (!(e && e > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    const n = [...this._entriesAscending()], r = n.length - e;
    r < 0 ? (this.cache = new Map(n), this.oldCache = /* @__PURE__ */ new Map(), this._size = n.length) : (r > 0 && this._emitEvictions(n.slice(0, r)), this.oldCache = new Map(n.slice(r)), this.cache = /* @__PURE__ */ new Map(), this._size = 0), this.maxSize = e;
  }
  *keys() {
    for (const [e] of this)
      yield e;
  }
  *values() {
    for (const [, e] of this)
      yield e;
  }
  *[Symbol.iterator]() {
    for (const e of this.cache) {
      const [n, r] = e;
      this._deleteIfExpired(n, r) === !1 && (yield [n, r.value]);
    }
    for (const e of this.oldCache) {
      const [n, r] = e;
      this.cache.has(n) || this._deleteIfExpired(n, r) === !1 && (yield [n, r.value]);
    }
  }
  *entriesDescending() {
    let e = [...this.cache];
    for (let n = e.length - 1; n >= 0; --n) {
      const r = e[n], [i, a] = r;
      this._deleteIfExpired(i, a) === !1 && (yield [i, a.value]);
    }
    e = [...this.oldCache];
    for (let n = e.length - 1; n >= 0; --n) {
      const r = e[n], [i, a] = r;
      this.cache.has(i) || this._deleteIfExpired(i, a) === !1 && (yield [i, a.value]);
    }
  }
  *entriesAscending() {
    for (const [e, n] of this._entriesAscending())
      yield [e, n.value];
  }
  get size() {
    if (!this._size)
      return this.oldCache.size;
    let e = 0;
    for (const n of this.oldCache.keys())
      this.cache.has(n) || e++;
    return Math.min(this._size + e, this.maxSize);
  }
  entries() {
    return this.entriesAscending();
  }
  forEach(e, n = this) {
    for (const [r, i] of this.entriesAscending())
      e.call(n, i, r, this);
  }
  get [Symbol.toStringTag]() {
    return JSON.stringify([...this.entriesAscending()]);
  }
}
const lie = (t, e) => t.some((n) => typeof n == "string" ? n === e : (n.lastIndex = 0, n.test(e))), l6 = new sie({ maxSize: 1e5 }), RP = (t) => typeof t == "object" && t !== null && !(t instanceof RegExp) && !(t instanceof Error) && !(t instanceof Date), DP = (t, e) => {
  if (!RP(t))
    return t;
  e = {
    deep: !1,
    pascalCase: !1,
    ...e
  };
  const { exclude: n, pascalCase: r, stopPaths: i, deep: a } = e, s = new Set(i), c = (d) => (f, g) => {
    if (a && RP(g)) {
      const m = d === void 0 ? f : `${d}.${f}`;
      s.has(m) || (g = AP(g, c(m)));
    }
    if (!(n && lie(n, f))) {
      const m = r ? `${f}_` : f;
      if (l6.has(m))
        f = l6.get(m);
      else {
        const b = oie(f, { pascalCase: r, locale: !1 });
        f.length < 100 && l6.set(m, b), f = b;
      }
    }
    return [f, g];
  };
  return AP(t, c(void 0));
};
function cie(t, e) {
  return Array.isArray(t) ? Object.keys(t).map((n) => DP(t[n], e)) : DP(t, e);
}
const J$ = (t) => typeof t == "object" && t !== null, a8 = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    writable: !0,
    enumerable: !1,
    configurable: !0
  });
}, eH = (t) => {
  if (!(t instanceof Error))
    throw new TypeError(`First argument must be an error instance: ${t}`);
}, uie = (t, e) => {
  eH(t), die(e) && !("cause" in t && e.cause === t.cause) && a8(t, "cause", e.cause);
}, die = (t) => J$(t) && "cause" in t, fie = (t, e) => {
  eH(t), hie(e);
  const n = e.prototype;
  Object.getPrototypeOf(t) !== n && Object.setPrototypeOf(t, n), typeof n.constructor == "function" && t.constructor !== n.constructor && delete t.constructor;
}, hie = (t) => {
  if (t === void 0)
    throw new TypeError(
      "This must be called directly inside the class's constructor."
    );
  if (typeof t != "function" || !J$(t.prototype))
    throw new TypeError("The second argument must be `new.target`.");
}, tH = (t, e) => {
  pie(e), a8(t, "name", e), a8(t.prototype, "name", e);
}, pie = (t) => {
  if (typeof t != "string")
    throw new TypeError(`Error name must be a string: ${t}`);
  if (mie(t), !t.endsWith(c6) || t === c6)
    throw new Error(`Error name "${t}" must end with "${c6}"`);
  vie(t);
}, mie = (t) => {
  if (gie.has(t))
    throw new Error(`Error name "${t}" must not be a native class.`);
}, gie = /* @__PURE__ */ new Set(
  [
    "Error",
    "ReferenceError",
    "TypeError",
    "SyntaxError",
    "RangeError",
    "URIError",
    "EvalError",
    "AggregateError",
    "SystemError",
    "AssertionError",
    "Warning",
    "UnhandledPromiseRejection",
    "DOMException"
  ]
), vie = (t) => {
  if (t[0] !== t.toUpperCase()[0])
    throw new Error(
      `Error name "${t}" must start with an uppercase letter.`
    );
  if (!yie.test(t))
    throw new Error(`Error name "${t}" must only contain letters.`);
}, c6 = "Error", yie = /[A-Z][a-zA-Z]*Error$/u;
function bie(t) {
  const e = class extends Error {
    constructor(n, r) {
      super(n, r), fie(this, new.target), uie(this, r);
    }
  };
  return tH(e, t), e;
}
const vg = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, wie = (t, e) => {
  if (e !== void 0) {
    if (!Array.isArray(e))
      throw new TypeError(`"errors" option must be an array: ${e}`);
    vg(t, "errors", e);
  }
}, xie = (t) => Sie(t) || Eie(t), xM = xie, Sie = (t) => {
  try {
    return t instanceof Error;
  } catch {
    return !1;
  }
}, Eie = (t) => {
  try {
    return _ie.has(Object.prototype.toString.call(t));
  } catch {
    return !1;
  }
}, _ie = /* @__PURE__ */ new Set(
  [
    "[object Error]",
    "[object DOMException]",
    "[object DOMError]",
    "[object Exception]"
  ]
), Aie = (t) => {
  SM.forEach((e) => {
    Cie(t, e);
  });
}, SM = ["name", "message", "stack", "cause", "errors"], Cie = (t, e) => {
  const n = EM(t, e);
  if (n !== void 0) {
    if (Tie(n)) {
      Dh(t, e, t[e]);
      return;
    }
    Oie(n) && nH(t, e, n);
  }
}, EM = (t, e) => {
  const n = Object.getOwnPropertyDescriptor(t, e);
  if (n !== void 0)
    return n;
  const r = Object.getPrototypeOf(t);
  return r === null ? void 0 : EM(r, e);
}, Tie = ({ get: t, set: e }) => t !== void 0 && e === void 0, Oie = ({ enumerable: t, writable: e }) => t || !e, Dh = (t, e, n) => {
  nH(t, e, { value: n });
}, nH = (t, e, n) => {
  Object.defineProperty(t, e, {
    ...n,
    ..."get" in n || "set" in n ? {} : { writable: !0 },
    enumerable: !1,
    configurable: !0
  });
}, Rie = (t, e) => {
  if (Array.isArray(t.errors)) {
    const n = t.errors.filter(Die).map(e).filter(Boolean);
    Dh(t, "errors", n);
  } else
    Nie(t) ? Dh(t, "errors", []) : t.errors !== void 0 && Mie(t);
}, Die = (t) => t !== void 0, Nie = (t) => "AggregateError" in globalThis && (t.name === "AggregateError" || t instanceof AggregateError), Mie = (t) => {
  delete t.errors, t.errors !== void 0 && Dh(t, "errors", []);
}, Iie = (t, e) => {
  if (!("cause" in t))
    return;
  const n = t.cause === void 0 ? t.cause : e(t.cause);
  n === void 0 ? delete t.cause : Dh(t, "cause", n);
};
function Wl(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const e = Object.getPrototypeOf(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}
const kie = (t) => !Object.isExtensible(t) || SM.some(
  (e) => jie(t, e) || Pie(t, e)
), jie = (t, e) => {
  const n = Object.getOwnPropertyDescriptor(t, e);
  return n !== void 0 && !n.configurable;
}, Pie = (t, e) => {
  try {
    return t[e], !1;
  } catch {
    return !0;
  }
}, _M = (t) => {
  const e = Lie(t.message, t.name);
  Dh(t, "stack", e);
}, Lie = (t = "", e = "Error") => {
  const n = Bie(e), { stack: r } = new n(t);
  return typeof r == "string" && r !== "" ? r : `${e}: ${t}`;
}, Bie = (t) => {
  const e = {
    value: t,
    enumerable: !1,
    writable: !0,
    configurable: !0
  }, n = Object.defineProperty(
    class extends Error {
    },
    "name",
    e
  );
  return Object.defineProperty(n.prototype, "name", e), n;
}, zie = (t) => {
  const e = {};
  for (const n of Fie(t))
    try {
      const r = t[n], {
        enumerable: i,
        configurable: a,
        writable: s = !0
      } = EM(t, n);
      Object.defineProperty(e, n, {
        value: r,
        enumerable: i,
        configurable: a,
        writable: s
      });
    } catch {
    }
  return e;
}, Fie = (t) => {
  const e = Vie(t);
  for (const n of SM)
    Uie(t, n) && e.push(n);
  return e;
}, Vie = (t) => {
  try {
    return Reflect.ownKeys(t);
  } catch {
    return [];
  }
}, Uie = (t, e) => {
  try {
    return e in t && !Object.hasOwn(t, e);
  } catch {
    return !1;
  }
}, NP = (t) => {
  const { name: e, message: n, stack: r, cause: i, errors: a, ...s } = zie(t), c = $ie(n, s), d = Yie(e, c);
  return n === c && Xie(d, s), Object.entries({ name: e, stack: r, cause: i, errors: a }).forEach(
    ([f, g]) => {
      Wie(d, f, g);
    }
  ), r === void 0 && _M(d), d;
}, $ie = (t, e) => typeof t == "string" && t !== "" ? t : Gie(Hie(e)), Hie = (t) => {
  try {
    return JSON.stringify(t);
  } catch {
    return qie(t);
  }
}, qie = (t) => {
  try {
    return String(t);
  } catch {
    return "Invalid error";
  }
}, Gie = (t) => t.length < MP ? t : `${t.slice(0, MP)}...`, MP = 1e3, Yie = (t, e) => t === "AggregateError" && "AggregateError" in globalThis ? new AggregateError([], e) : t in IP ? new IP[t](e) : new Error(e), IP = {
  Error,
  ReferenceError,
  TypeError,
  SyntaxError,
  RangeError,
  URIError,
  EvalError
}, Xie = (t, e) => {
  for (const n in e)
    n in t || (t[n] = e[n]);
}, Wie = (t, e, n) => {
  n !== void 0 && Dh(t, e, n);
}, Qie = (t) => {
  try {
    const e = new Error(String(t));
    return _M(e), e;
  } catch (e) {
    return e;
  }
}, { toString: Zie } = Object.prototype, Kie = (t) => Jie(t) ? NP(t) : xM(t) ? eae(t) ? NP(t) : t : Qie(t), Jie = (t) => {
  try {
    return Wl(t);
  } catch {
    return !1;
  }
}, eae = (t) => tae(t) || kie(t) || nae(t), tae = (t) => {
  try {
    return Zie.call(t) === "[object Object]";
  } catch {
    return !0;
  }
}, nae = (t) => typeof t.constructor != "function" || typeof t.constructor.name != "string" || t.constructor.name === "" || t.constructor.prototype !== Object.getPrototypeOf(t), rae = (t, { shallow: e = !1 } = {}) => rH(t, [], e), rw = rae, rH = (t, e, n) => {
  if (e.includes(t))
    return;
  const r = n ? iae : (a) => rH(a, [...e, t], n), i = Kie(t);
  return aae(i, r), i;
}, iae = (t) => t, aae = (t, e) => {
  oae(t), sae(t), lae(t), Iie(t, e), Rie(t, e), Aie(t);
}, oae = (t) => {
  if (iT(t.name))
    return;
  const e = Object.getPrototypeOf(t).name, n = iT(e) ? e : t.constructor.name;
  Dh(t, "name", n);
}, sae = (t) => {
  iT(t.message) || Dh(t, "message", "");
}, lae = (t) => {
  iT(t.stack) || _M(t);
}, iT = (t) => typeof t == "string" && t !== "", cae = (t, e, n = t.name) => {
  if (uae(e), typeof n != "string")
    throw new TypeError(`currentName must be a string: ${n}`);
  return n;
}, uae = (t) => {
  if (!dae(t))
    throw new TypeError(`ErrorClass must be a class: ${t}`);
  if (!iH(t.prototype))
    throw new TypeError(`ErrorClass must inherit from Error: ${t}`);
  if (!fae(t))
    throw new TypeError(
      `ErrorClass must be have a valid constructor: ${t}`
    );
}, dae = (t) => typeof t == "function" && typeof t.prototype == "object" && t.prototype !== null, iH = (t) => t !== null && (t.name === "Error" || iH(Object.getPrototypeOf(t))), fae = (t) => typeof t.prototype.constructor == "function", aH = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, hae = (t, e) => {
  Object.getPrototypeOf(t) !== e.prototype && (pae(t, e), lH(t, "constructor"), mae(t, e));
}, pae = (t, e) => {
  Object.setPrototypeOf(t, e.prototype);
}, mae = (t, e) => {
  lH(t, "name");
  const n = oH(e.prototype);
  t.name !== n && aH(t, "name", n);
}, oH = (t) => gae(t) ?? vae(t) ?? oH(Object.getPrototypeOf(t)), gae = (t) => Object.hasOwn(t, "name") && sH(t.name) ? t.name : void 0, vae = (t) => typeof t.constructor == "function" && sH(t.constructor.name) ? t.constructor.name : void 0, sH = (t) => typeof t == "string" && t !== "", lH = (t, e) => {
  Object.hasOwn(t, e) && delete t[e];
}, yae = (t, e) => {
  if (!bae(t, e))
    return;
  const n = xae(t, e);
  aH(t, "stack", n);
}, bae = (t, e) => e !== t.name && e !== "" && t.stack.includes(e) && wae(), wae = () => {
  class t extends Error {
  }
  const e = {
    value: kP,
    enumerable: !1,
    writable: !0,
    configurable: !0
  };
  Object.defineProperty(t, "name", e), Object.defineProperty(t.prototype, "name", e);
  const { stack: n } = new t("");
  return typeof n == "string" && n.includes(kP);
}, kP = "SetErrorClassError", xae = ({ name: t, stack: e }, n) => {
  if (e.startsWith(`${n}: `))
    return e.replace(n, t);
  const r = Sae(n, t), [i, a] = r.find(([s]) => e.includes(s));
  return e.replace(i, a);
}, Sae = (t, e) => [
  [`
${t}: `, `
${e}: `],
  [`${t}: `, `${e}: `],
  [`${t} `, `${e} `],
  [t, e]
], Eae = (t, e, n) => {
  const r = rw(t), i = cae(r, e, n);
  return hae(r, e), yae(r, i), r;
}, _ae = Eae, Aae = (t, e) => e.configurable === !1 ? Cae(t, e) : Rae(t, e), Cae = (t, e) => ({
  ...e,
  ...Tae(t, e),
  ...Oae(t, e)
}), Tae = (t, e) => e.writable === !0 && t.writable === !1 ? { writable: !1 } : {}, Oae = (t, e) => t.hasValue && "value" in e && e.writable === !0 ? { value: t.value } : {}, Rae = (t, e) => {
  const n = cE(
    t.enumerable,
    e.enumerable,
    !0
  ), r = cE(
    t.writable,
    e.writable,
    !0
  ), i = cE(
    t.configurable,
    e.configurable,
    !0
  );
  return { ...Dae(t, e, r), enumerable: n, configurable: i };
}, Dae = (t, e, n) => t.hasValue ? { value: t.value, writable: n } : !jP(t) && !jP(e) ? { value: e.value, writable: n } : {
  get: cE(t.get, e.get),
  set: cE(t.set, e.set)
}, jP = ({ get: t, set: e }) => t !== void 0 || e !== void 0, cE = (t, e, n) => t ?? e ?? n, Nae = (t, e, n) => {
  if (!Mae(t))
    throw new TypeError(`Argument must be an object: ${t}`);
  if (!Iae(e))
    throw new TypeError(
      `Property key must be a string, a symbol or an integer: ${e}`
    );
  return kae(n);
}, Mae = (t) => typeof t == "object" && t !== null, Iae = (t) => {
  const e = typeof t;
  return e === "string" || e === "symbol" || e === "number";
}, kae = (t) => {
  if (!Wl(t))
    throw new TypeError(`Descriptor must be a plain object: ${t}`);
  const {
    enumerable: e,
    writable: n,
    configurable: r,
    value: i,
    get: a,
    set: s,
    ...c
  } = t, d = "value" in t;
  return jae({
    enumerable: e,
    writable: n,
    configurable: r,
    get: a,
    set: s,
    unknownProps: c,
    hasValue: d
  }), { enumerable: e, writable: n, configurable: r, value: i, get: a, set: s, hasValue: d };
}, jae = ({
  enumerable: t,
  writable: e,
  configurable: n,
  get: r,
  set: i,
  unknownProps: a,
  hasValue: s
}) => {
  PP(s, r, "get"), PP(s, i, "set"), u6(t, "enumerable"), u6(e, "writable"), u6(n, "configurable"), Lae(a);
}, PP = (t, e, n) => {
  if (Pae(e, n), t && e !== void 0)
    throw new TypeError(
      `Descriptor property "value" and "${n}" must not both be defined: ${e}`
    );
}, Pae = (t, e) => {
  if (t !== void 0 && typeof t != "function")
    throw new TypeError(
      `Descriptor property "${e}" must be a function: ${t}`
    );
}, u6 = (t, e) => {
  if (t !== void 0 && typeof t != "boolean")
    throw new TypeError(
      `Descriptor property "${e}" must be a boolean: ${t}`
    );
}, Lae = (t) => {
  const [e] = Object.keys(t);
  if (e !== void 0)
    throw new TypeError(
      `Unknown descriptor property "${e}": ${t[e]}`
    );
}, Bae = (t, e, n) => {
  const r = Nae(t, e, n), i = cH(t, e), a = Aae(r, i);
  return Fae(t, e, a), t;
}, zae = Bae, cH = (t, e) => {
  const n = Object.getOwnPropertyDescriptor(t, e);
  if (n !== void 0)
    return n;
  const r = Object.getPrototypeOf(t);
  return r === null ? {} : cH(r, e);
}, Fae = (t, e, n) => {
  try {
    Object.defineProperty(t, e, n);
  } catch {
  }
}, Vae = (t, e, n) => {
  if (n !== void 0)
    return LP(t, e, n);
  try {
    delete t[e];
  } catch {
  }
  if (t[e] !== void 0)
    return LP(t, e);
}, LP = (t, e, n) => {
  const r = Uae(e);
  zae(t, e, { value: n, ...r });
}, Uae = (t) => typeof t == "string" && t.startsWith("_") ? { enumerable: !1 } : {}, $ae = (t, e, n = {}) => {
  if (BP(t, "First argument"), BP(e, "Second argument"), !Wl(n))
    throw new TypeError(`Options must be a plain object: ${n}`);
  const { soft: r = !1 } = n;
  if (typeof r != "boolean")
    throw new TypeError(`Option "soft" must be a boolean: ${r}`);
  return { soft: r };
}, BP = (t, e) => {
  if (t === void 0)
    throw new TypeError(`${e} is required.`);
  if (!Hae(t))
    throw new TypeError(
      `${e} must be a plain object or an error: ${t}`
    );
}, Hae = (t) => Wl(t) || xM(t), qae = ({ error: t, props: e, propName: n, soft: r }) => Gae(n) || !Wae.call(e, n) || r && t[n] !== void 0, Gae = (t) => t in Yae || Xae.has(t), Yae = new Error("check"), Xae = /* @__PURE__ */ new Set(["prototype", "errors", "cause"]), { propertyIsEnumerable: Wae } = Object.prototype, Qae = (t, e, n) => {
  const { soft: r } = $ae(t, e, n);
  for (const i of Reflect.ownKeys(e))
    Zae({ error: t, props: e, propName: i, soft: r });
  return t;
}, uH = Qae, Zae = ({ error: t, props: e, propName: n, soft: r }) => {
  qae({ error: t, props: e, propName: n, soft: r }) || Vae(t, n, e[n]);
}, E5 = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    writable: !0,
    enumerable: !1,
    configurable: !0
  });
}, Kae = (t, e) => {
  if (t.errors === void 0)
    return;
  const n = t.errors.map((r) => e(r).error).filter(Boolean);
  E5(t, "errors", n);
}, Jae = ({ target: t, source: e, parent: n, child: r }) => {
  if (!zP(t)) {
    eoe(t, e);
    return;
  }
  zP(e) && E5(t, "errors", [...r.errors, ...n.errors]);
}, eoe = (t, e) => {
  e.errors !== void 0 && E5(t, "errors", e.errors);
}, zP = (t) => t.errors !== void 0 && t.errors.length !== 0, toe = (t, e, n = t.message) => {
  if (typeof e != "string")
    throw new TypeError(`newMessage must be a string: ${e}`);
  if (typeof n != "string")
    throw new TypeError(`currentMessage must be a string: ${n}`);
  return n;
}, noe = ({ name: t, stack: e }, n, r) => r !== "" && e.includes(r) ? roe({ name: t, stack: e, newMessage: n, currentMessage: r }) : aoe(t, e, n), roe = ({ name: t, stack: e, newMessage: n, currentMessage: r }) => {
  const i = ioe(t, n, r), [a, s] = i.find(([c]) => e.includes(c));
  return e.replace(a, s);
}, ioe = (t, e, n) => [
  [`${t}: ${n}`, `${t}: ${e}`],
  [`: ${n}`, `: ${e}`],
  [`
${n}`, `
${e}`],
  [` ${n}`, ` ${e}`],
  [n, e]
], aoe = (t, e, n) => {
  const r = `${t}: `, i = n.trimEnd();
  return e === t || e.startsWith(`${t}
`) ? e.replace(t, `${r}${i}`) : e.startsWith(r) ? e.replace(r, `${r}${i}
`) : `${r}${i}
${e}`;
}, ooe = (t, e, n) => {
  const r = rw(t), i = toe(r, e, n);
  return dH(r, "message", e), soe(r, e, i), r;
}, _5 = ooe, soe = (t, e, n) => {
  if (e === n || !loe())
    return;
  const r = noe(t, e, n);
  dH(t, "stack", r);
}, loe = () => {
  const { stack: t } = new Error(FP);
  return typeof t == "string" && t.includes(FP);
}, FP = "set-error-message test message", dH = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, coe = (t, e, n) => {
  if (typeof e != "string")
    throw new TypeError(
      `Second argument must be a message string: ${e}`
    );
  const r = rw(t), i = doe(e, r.message);
  return _5(r, i, n);
}, uoe = coe, doe = (t, e) => {
  const n = t.trim(), r = e.trim();
  return n === "" ? r : r === "" ? n : foe(n, r, t);
}, foe = (t, e, n) => t.endsWith(hoe) ? n.endsWith(poe) ? `${t}
${e}` : `${t} ${e}` : `${e}
${t}`, hoe = ":", poe = `
`, moe = ({ parent: t, child: e, target: n, stackError: r }) => {
  const i = t.message, a = r.message;
  return n.message = e.message, uoe(n, i, a);
}, goe = (t, e) => fH(t) === e, fH = (t) => typeof t == "object" && t !== null ? t.stack : void 0, voe = ({ wrap: t, target: e, source: n, childHasStack: r }) => t === r ? e : (E5(e, "stack", n.stack), n), yoe = (t) => {
  const { wrap: e, name: n } = t;
  return typeof e != "boolean" ? n === "Error" : (Object.hasOwn(t, "wrap") && delete t.wrap, e);
}, boe = (t) => hH(t, []).error, aT = boe, hH = (t, e) => {
  if (e.includes(t))
    return {};
  const n = (f) => hH(f, [...e, t]), r = fH(t), i = rw(t, { shallow: !0 }), a = goe(i, r);
  Kae(i, n);
  const { parent: s, childHasStack: c } = woe(i, n);
  return { error: s, errorHasStack: a || c };
}, woe = (t, e) => {
  const n = yoe(t);
  if (t.cause === void 0)
    return { parent: t, childHasStack: !1 };
  const { error: r, errorHasStack: i } = e(t.cause);
  return delete t.cause, { parent: xoe({ parent: t, child: r, childHasStack: i, wrap: n }), childHasStack: i };
}, xoe = ({ parent: t, child: e, childHasStack: n, wrap: r }) => {
  if (e === void 0)
    return t;
  const [i, a] = r ? [e, t] : [t, e], s = voe({ wrap: r, target: i, source: a, childHasStack: n }), c = _ae(i, i.constructor, s.name), d = moe({ parent: t, child: e, target: c, stackError: s });
  return Jae({ target: d, source: a, parent: t, child: e }), uH(d, a, { soft: !r });
}, FE = (t, e) => e === t || Soe.call(e, t), { isPrototypeOf: Soe } = Object.prototype, Eoe = (t, e) => {
  const { cause: n } = t;
  return _oe(n) && (Aoe(n, e) || n.name !== n.constructor.name);
}, _oe = (t) => typeof t.name == "string" && t.name !== "" && typeof t.constructor == "function" && typeof t.constructor.name == "string", Aoe = (t, e) => !(FE(t.constructor, e) || FE(e, t.constructor) || t.constructor.name in globalThis || t.name === e.name), Coe = (t) => {
  const e = typeof t.message == "string" ? t.message : "", n = e === "" ? t.name : `${t.name}: ${e}`;
  return _5(t, n), e;
}, Toe = (t, e) => {
  _5(t, e);
}, Ooe = (t, e) => (t.cause = e, t.wrap = !0, aT(t)), Roe = (t, e) => !xM(t.cause) || (t.wrap = FE(t.cause.constructor, e), !Eoe(t, e)) ? aT(t) : Doe(t), Doe = (t) => {
  const { cause: e } = t, n = Coe(e), r = aT(t);
  return e !== r && Toe(e, n), r;
}, pH = (t) => Object.prototype.toString.call(t) === "[object Set]";
function n4(t, e) {
  const n = {};
  if (Array.isArray(e) || pH(e))
    for (const r of e) {
      const i = Object.getOwnPropertyDescriptor(t, r);
      i?.enumerable && Object.defineProperty(n, r, i);
    }
  else
    for (const r of Reflect.ownKeys(t)) {
      const i = Object.getOwnPropertyDescriptor(t, r);
      if (!i?.enumerable)
        continue;
      const a = t[r];
      e(r, a, t) && Object.defineProperty(n, r, i);
    }
  return n;
}
function mH(t, e) {
  if (Array.isArray(e)) {
    const n = new Set(e);
    return n4(t, (r) => !n.has(r));
  }
  return pH(e) ? n4(t, (n) => !e.has(n)) : n4(t, (n, r, i) => !e(n, r, i));
}
const Nh = /* @__PURE__ */ new WeakMap(), VE = /* @__PURE__ */ new WeakMap(), b_ = (t) => Array.isArray(t) ? t.map(b_) : Wl(t) ? Noe(t) : t, Noe = (t) => {
  const e = {};
  for (const n of Reflect.ownKeys(t)) {
    const r = Object.getOwnPropertyDescriptor(t, n), i = b_(r.value);
    Object.defineProperty(e, n, { ...r, value: i });
  }
  return e;
}, A5 = (t, e, n) => Object.fromEntries(
  o8(n).map((r) => Moe(t, e, r)).filter(Boolean)
), Moe = (t, e, n) => {
  const r = Ioe(t[n], e[n]);
  return r === void 0 ? void 0 : [n, r];
}, Ioe = (t, e) => e === void 0 ? t : Wl(t) && Wl(e) ? { ...t, ...e } : e, o8 = (t) => t.map(koe), koe = ({ name: t }) => t, joe = (t, e, n = {}) => {
  Poe(t, n);
  const { errors: r, ...i } = n, a = mH(i, o8(e)), s = n4(i, o8(e)), c = Loe(e, s, a);
  return { nativeOpts: a, errors: r, pluginsOpts: c };
}, Poe = (t, e) => {
  if (!Wl(e))
    throw new TypeError(
      `Error options must be a plain object or undefined: ${e}`
    );
  if (e.custom !== void 0)
    throw new TypeError(
      `Error option "custom" must be passed to "${t.name}.subclass()", not to error constructors.`
    );
}, Loe = (t, e, { cause: n }) => {
  if (!VE.has(n))
    return e;
  const r = VE.get(n).pluginsOpts, i = A5(r, e, t);
  return b_(i);
}, Boe = (t = {}) => {
  if (!Wl(t))
    throw new TypeError(`It must be a plain object: ${t}`);
  const { message: e, ...n } = t;
  return n;
}, zoe = ({ options: t }) => t, Foe = {
  name: "props",
  getOptions: Boe,
  properties: zoe
}, Voe = [Foe], Uoe = ({
  plugin: t,
  plugin: {
    fullName: e,
    getOptions: n = $oe.bind(void 0, e)
  }
}) => ({ ...t, getOptions: n }), $oe = (t, e) => {
  if (e !== void 0)
    throw new Error(
      `The plugin "${t}" does not have any options: ${e}`
    );
}, gH = ({
  pluginsOpts: t,
  plugin: { name: e, getOptions: n },
  full: r
}) => {
  try {
    return n(t[e], r);
  } catch (i) {
    throw Ooe(new Error(`Invalid "${e}" options:`), i);
  }
}, Hoe = ({
  plugin: t,
  plugin: { getOptions: e, isOptions: n = () => e !== void 0 }
}) => ({ ...t, isOptions: n }), vH = (t, e) => {
  if (t.length === 0)
    return { args: t };
  const n = t.at(-1);
  return qoe(e, n) ? { args: t.slice(0, -1), methodOpts: { [e.name]: n } } : { args: t };
}, qoe = ({ isOptions: t, fullName: e }, n) => {
  const r = t(n);
  if (typeof r != "boolean")
    throw new TypeError(
      `The plugin "${e}"'s "isOptions()" method must return a boolean, not: ${typeof r}`
    );
  return r;
}, Goe = (t, e, n) => e === void 0 ? t : A5(t, e, n), yH = ({
  pluginsOpts: t,
  methodOpts: e,
  plugins: n,
  plugin: r
}) => {
  const i = Goe(t, e, n), a = b_(i);
  return gH({
    pluginsOpts: a,
    plugin: r,
    full: !0
  });
}, Yoe = ({ ErrorClass: t, methodOpts: e, plugins: n, plugin: r }, i) => {
  const a = t.normalize(i);
  return { ...bH({ error: a, methodOpts: e, plugins: n, plugin: r }), error: a };
}, bH = ({ error: t, methodOpts: e, plugins: n, plugin: r }) => {
  const i = t.constructor, a = wH(i), { classOpts: s } = Nh.get(i), { pluginsOpts: c } = VE.get(t), d = A5(s, c, n), f = yH({
    pluginsOpts: d,
    methodOpts: e,
    plugins: n,
    plugin: r
  });
  return { ErrorClass: i, ErrorClasses: a, options: f };
}, wH = (t) => {
  const { subclasses: e } = Nh.get(t);
  return [t, ...e];
}, xH = ({ error: t, methodOpts: e, plugins: n, plugin: r }) => {
  const { ErrorClass: i, options: a } = bH({
    error: t,
    methodOpts: e,
    plugins: n,
    plugin: r
  }), s = SH({
    options: a,
    ErrorClass: i,
    methodOpts: e,
    plugins: n,
    plugin: r
  });
  return Object.assign(s, { error: t }), s;
}, SH = ({
  options: t,
  ErrorClass: e,
  methodOpts: n,
  plugins: r,
  plugin: i
}) => {
  const a = Yoe.bind(void 0, {
    ErrorClass: e,
    methodOpts: n,
    plugins: r,
    plugin: i
  }), s = wH(e), c = { options: t, ErrorClass: e, ErrorClasses: s, errorInfo: a };
  return Xoe(c), c;
}, Xoe = (t) => {
  Object.defineProperty(t, "instancesData", {
    value: VE,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, Woe = (t, e) => {
  if (typeof e != "string")
    throw new TypeError(`Stack trace must be a string: ${e}`);
  const n = rw(t), { name: r, stack: i } = n;
  return e === i || (EH(n, "stack", e), Zoe({ error: n, newStack: e, currentStack: i, name: r })), n;
}, Qoe = Woe, Zoe = ({ error: t, newStack: e, currentStack: n, name: r }) => {
  if (VP(n, r) === void 0)
    return;
  const i = VP(e, r);
  i !== void 0 && EH(t, "message", i);
}, VP = (t, e) => {
  const n = Koe(t, e);
  if (n === -1)
    return;
  const r = t.slice(n), i = r.indexOf(`
    at `);
  if (i !== -1)
    return r.slice(0, i);
}, Koe = (t, e) => {
  const n = `${e}: `;
  if (t.startsWith(n))
    return n.length;
  const r = t.indexOf(`
${n}`);
  return r === -1 ? r : r + n.length + 1;
}, EH = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, Joe = ({
  error: t,
  methodFunc: e,
  methodName: n,
  plugin: r,
  plugins: i,
  ErrorClass: a,
  args: s
}) => {
  if (!(t instanceof a))
    throw new TypeError(
      `Missing "this" context: "${n}()" must be called using "error.${n}()"`
    );
  return _H({ methodFunc: e, plugin: r, plugins: i, error: t, args: s });
}, _H = ({ methodFunc: t, plugin: e, plugins: n, error: r, args: i }) => {
  const { args: a, methodOpts: s } = vH(i, e), c = xH({ error: r, methodOpts: s, plugins: n, plugin: e });
  return t(c, ...a);
}, ese = ({ methodFunc: t, plugin: e, plugins: n, ErrorClass: r }, i, ...a) => {
  const s = r.normalize(i);
  return _H({ methodFunc: t, plugin: e, plugins: n, error: s, args: a });
}, tse = (t, e) => {
  t.forEach((n) => {
    nse(n, t, e);
  });
}, nse = (t, e, n) => {
  Object.entries(t.instanceMethods).forEach(
    rse.bind(void 0, { plugin: t, plugins: e, ErrorClass: n })
  );
}, rse = ({ plugin: t, plugins: e, ErrorClass: n }, [r, i]) => {
  vg(
    n.prototype,
    r,
    function(...s) {
      return Joe({
        error: this,
        methodFunc: i,
        methodName: r,
        plugin: t,
        plugins: e,
        ErrorClass: n,
        args: s
      });
    }
  ), vg(
    n,
    r,
    ese.bind(void 0, {
      methodFunc: i,
      plugin: t,
      plugins: e,
      ErrorClass: n
    })
  );
}, ise = (t) => t.flatMap(ase), ase = ({ instanceMethods: t }) => Object.keys(t), ose = (t, { message: e, stack: n, ...r }, i) => {
  if (n !== void 0 && Qoe(t, n), e !== void 0 && _5(t, e), Reflect.ownKeys(r).length === 0)
    return;
  const a = mH(
    r,
    [
      ...sse,
      ...ise(i)
    ]
  );
  uH(t, a);
}, sse = ["wrap", "constructorArgs"], lse = (t, e) => e.forEach((n) => {
  cse({ error: t, plugin: n, plugins: e });
}), cse = ({
  error: t,
  plugin: e,
  plugin: { properties: n, fullName: r },
  plugins: i
}) => {
  if (n === void 0)
    return;
  const a = xH({ error: t, plugins: i, plugin: e }), s = n(a);
  if (!Wl(s))
    throw new TypeError(
      `Plugin "${r}"'s "properties()" must return a plain object: ${s}`
    );
  ose(t, s, i);
}, use = (t, e) => {
  Object.entries(t).forEach(([n, r]) => {
    dse(n, r, e);
  });
}, dse = (t, e, n) => {
  if (!n.some(({ name: r }) => r === t))
    throw new TypeError(
      `Invalid option "${t}": the plugin "${AH}${t}" must be passed to ErrorClass.subclass("...", { plugins })`
    );
}, fse = (t) => {
  if (t.name === void 0)
    throw new TypeError(`The plugin is missing a "name": ${t}`);
  const { name: e } = t;
  if (typeof e != "string")
    throw new TypeError(`The plugin "name" must be a string: ${e}`);
  return hse(e), { ...t, fullName: `${AH}${e}` };
}, hse = (t) => {
  if (pse.has(t))
    throw new TypeError(
      `The plugin "name" must not be the following reserved word: ${t}`
    );
  if (!mse.test(t))
    throw new TypeError(
      `The plugin "name" must only contain lowercase letters and digits: ${t}`
    );
}, pse = /* @__PURE__ */ new Set(
  [
    "cause",
    "errors",
    "custom",
    "wrap",
    "constructorArgs"
  ]
), mse = /^[a-z][a-z\d]*$/u, AH = "modern-errors-", gse = (t, e = {}) => {
  if (!Wl(e))
    throw new TypeError(
      `The second argument of "${t.name}.subclass()" must be a plain object, not: ${e}`
    );
  return e;
}, vse = (t, e, n) => {
  use(e, n);
  const r = A5(t, e, n), i = b_(r);
  return n.forEach((a) => {
    gH({ pluginsOpts: i, plugin: a, full: !1 });
  }), i;
}, yse = ({
  instanceMethods: t,
  staticMethods: e,
  fullName: n
}) => {
  const r = CH(e, t);
  if (r !== void 0)
    throw new TypeError(
      `The plugin "${n}" must not define "${r}()" as both "instanceMethods" and "staticMethods".`
    );
}, bse = (t, e) => {
  t.forEach((n, r) => {
    wse({ pluginA: n, indexA: r, plugins: t, ParentError: e });
  });
}, wse = ({ pluginA: t, indexA: e, plugins: n, ParentError: r }) => {
  n.forEach((i, a) => {
    xse({ pluginA: t, pluginB: i, indexA: e, indexB: a, ParentError: r });
  });
}, xse = ({
  pluginA: t,
  pluginB: e,
  indexA: n,
  indexB: r,
  ParentError: i
}) => {
  if (n === r)
    return;
  if (t.name === e.name)
    throw new TypeError(
      `The "plugins" option of "${i.name}.subclass()" must not include "${t.fullName}": this plugin has already been included.`
    );
  const a = CH(
    { ...t.instanceMethods, ...t.staticMethods },
    { ...e.instanceMethods, ...e.staticMethods }
  );
  if (a !== void 0)
    throw new TypeError(
      `The plugins "${t.fullName}" and "${e.fullName}" must not both define the same "${a}()" method.`
    );
}, CH = (t, e) => {
  const n = Object.keys(t);
  return Object.keys(e).find((r) => n.includes(r));
}, Sse = (t) => {
  const e = d6({
    ...Ese,
    plugin: t,
    propName: "instanceMethods"
  }), n = d6({
    ...UP,
    plugin: e,
    propName: "instanceMethods"
  });
  return d6({
    ...UP,
    plugin: n,
    propName: "staticMethods"
  });
}, Ese = {
  coreObject: Error.prototype,
  coreObjectName: "error",
  forbiddenNames: /* @__PURE__ */ new Set([])
}, UP = {
  coreObject: Error,
  coreObjectName: "Error",
  forbiddenNames: /* @__PURE__ */ new Set(["normalize", "subclass"])
}, d6 = ({
  plugin: t,
  propName: e,
  coreObject: n,
  coreObjectName: r,
  forbiddenNames: i
}) => {
  const a = t[e] ?? {};
  if (!Wl(a))
    throw new TypeError(
      `The plugin "${t.fullName}"'s "${e}" property must be either undefined or a plain object, not: ${a}`
    );
  return Object.entries(a).forEach(([s, c]) => {
    _se({
      methodValue: c,
      propName: e,
      methodName: s,
      plugin: t,
      coreObject: n,
      coreObjectName: r,
      forbiddenNames: i
    });
  }), { ...t, [e]: a };
}, _se = ({
  methodValue: t,
  propName: e,
  methodName: n,
  plugin: r,
  coreObject: i,
  coreObjectName: a,
  forbiddenNames: s
}) => {
  if (typeof t != "function")
    throw new TypeError(
      `The plugin "${r.fullName}"'s "${e}.${n}" property must be a function, not: ${t}`
    );
  if (s.has(n) || n in i)
    throw new TypeError(
      `The plugin "${r.fullName}"'s "${e}.${n}" property name is invalid: "${a}.${n}" already exists.`
    );
}, Ase = (t, e, n) => {
  const i = Cse(n, e).map(
    (s) => Tse(s, n)
  ), a = [...t, ...i];
  return bse(a, n), a;
}, Cse = (t, e = []) => {
  if (!Array.isArray(e))
    throw new TypeError(
      `The "plugins" option of "${t.name}.subclass()" must be an array: ${e}`
    );
  return e;
}, Tse = (t, e) => {
  if (!Wl(t))
    throw new TypeError(
      `The "plugins" option of "${e.name}.subclass()" must be an array of plugin objects: ${t}`
    );
  const n = fse(t);
  Ose(n);
  const r = Sse(n);
  yse(r);
  const i = Hoe({ plugin: r });
  return Uoe({ plugin: i });
}, Ose = (t) => {
  Rse.forEach((e) => {
    Dse(t, e);
  });
}, Rse = ["isOptions", "getOptions", "properties"], Dse = (t, e) => {
  const n = t[e];
  if (n !== void 0 && typeof n != "function")
    throw new TypeError(
      `The plugin "${t.fullName}"'s "${e}()" property must be either undefined or a function, not: ${n}`
    );
}, Nse = ({ methodFunc: t, plugin: e, plugins: n, ErrorClass: r }, ...i) => {
  const { classOpts: a } = Nh.get(r), { args: s, methodOpts: c } = vH(i, e), d = yH({
    pluginsOpts: a,
    methodOpts: c,
    plugins: n,
    plugin: e
  }), f = SH({
    options: d,
    ErrorClass: r,
    methodOpts: c,
    plugins: n,
    plugin: e
  });
  return t(f, ...s);
}, Mse = (t, e) => {
  t.forEach((n) => {
    Ise(n, t, e);
  });
}, Ise = (t, e, n) => {
  Object.entries(t.staticMethods).forEach(
    kse.bind(void 0, { plugin: t, plugins: e, ErrorClass: n })
  );
}, kse = ({ plugin: t, plugins: e, ErrorClass: n }, [r, i]) => {
  vg(
    n,
    r,
    Nse.bind(void 0, {
      methodFunc: i,
      plugin: t,
      plugins: e,
      ErrorClass: n
    })
  );
}, jse = (t, e) => {
  if (typeof t != "function")
    throw new TypeError(
      `The "custom" class of "${e.name}.subclass()" must be a class: ${t}`
    );
  Pse(t, e), Lse(t, e);
}, Pse = (t, e) => {
  if (t === e)
    throw new TypeError(
      `The "custom" class of "${e.name}.subclass()" must extend from ${e.name}, but not be ${e.name} itself.`
    );
  if (!FE(t, e))
    throw new TypeError(
      `The "custom" class of "${e.name}.subclass()" must extend from ${e.name}.`
    );
  if (Object.getPrototypeOf(t) !== e)
    throw new TypeError(
      `The "custom" class of "${e.name}.subclass()" must extend directly from ${e.name}.`
    );
}, Lse = (t, e) => {
  if (typeof t.prototype != "object" || t.prototype === null)
    throw new TypeError(
      `The "custom" class's prototype of "${e.name}.subclass()" is invalid: ${t.prototype}`
    );
  if (t.prototype.constructor !== t)
    throw new TypeError(
      `The "custom" class of "${e.name}.subclass()" has an invalid "constructor" property.`
    );
}, Bse = (t, e) => {
  const n = zse(t, e);
  return class extends n {
  };
}, zse = (t, e) => e === void 0 ? t : (jse(e, t), e), Fse = (t, e, n = t) => {
  if (!FE(n, t))
    throw new TypeError(
      `${t.name}.normalize()'s second argument should be a subclass of ${t.name}, not: ${n}`
    );
  return TH({ error: e, ErrorClass: t, UnknownError: n, parents: [] });
}, TH = ({ error: t, ErrorClass: e, UnknownError: n, parents: r }) => (Vse({ error: t, ErrorClass: e, UnknownError: n, parents: r }), Use(t, e, n) ? rw(t, { shallow: !0 }) : new n("", { cause: t })), Vse = ({
  error: t,
  ErrorClass: e,
  UnknownError: n,
  parents: r
}) => {
  if (!Array.isArray(t?.errors))
    return;
  const i = [...r, t], a = t.errors.filter((s) => !i.includes(s)).map(
    (s) => TH({
      error: s,
      ErrorClass: e,
      UnknownError: n,
      parents: i
    })
  );
  vg(t, "errors", a);
}, Use = (t, e, n) => t?.constructor === n || t instanceof e && t.constructor !== e, $se = (t, e, n) => {
  const { classOpts: r, plugins: i } = Nh.get(t), { custom: a, plugins: s, ...c } = gse(
    t,
    n
  ), d = Bse(t, a);
  return Hse(d, t), OH({
    ParentError: t,
    ErrorClass: d,
    parentOpts: r,
    classOpts: c,
    parentPlugins: i,
    plugins: s,
    className: e
  });
}, Hse = (t, e) => {
  const { subclasses: n, ...r } = Nh.get(e);
  Nh.set(e, {
    ...r,
    subclasses: [...n, t]
  });
}, OH = ({
  ParentError: t,
  ErrorClass: e,
  parentOpts: n,
  classOpts: r,
  parentPlugins: i,
  plugins: a,
  className: s
}) => {
  const c = Ase(i, a, t), d = vse(n, r, c);
  return Nh.set(e, {
    classOpts: d,
    plugins: c,
    subclasses: []
  }), tH(e, s), qse(e, c), e;
}, qse = (t, e) => {
  vg(t, "normalize", Fse.bind(void 0, t)), vg(
    t,
    "subclass",
    $se.bind(void 0, t)
  ), tse(e, t), Mse(e, t);
}, Gse = (t) => {
  if (Nh.has(t))
    return;
  const { name: e } = t, { name: n } = Object.getPrototypeOf(t);
  throw new Error(
    `"new ${e}()" must not be directly called.
This error class should be created like this instead:
  export const ${e} = ${n}.subclass('${e}')`
  );
}, Yse = bie("BaseModernError");
class Xse extends Yse {
  constructor(e, n) {
    const r = new.target;
    Gse(r);
    const { plugins: i } = Nh.get(r), { nativeOpts: a, errors: s, pluginsOpts: c } = joe(
      r,
      i,
      n
    );
    super(e, a), wie(this, s);
    const d = Roe(this, r);
    return VE.set(d, { pluginsOpts: c }), lse(d, i), d;
  }
}
const Wse = OH({
  ParentError: Error,
  ErrorClass: Xse,
  parentOpts: {},
  classOpts: {},
  parentPlugins: [],
  plugins: Voe,
  className: "ModernError"
}), Qse = Wse, qb = {
  joinSessionRefreshFailed: "organization_join.session_refresh_failed",
  leaveSessionRefreshFailed: "organization_leave.session_refresh_failed"
}, Zse = {
  // Authentication
  "auth.unauthorized": "Sign in to continue",
  "auth.forbidden": "You do not have permission to perform this action",
  "auth.token_invalid": "Your session is invalid. Sign in again",
  "auth.token_expired": "Your session has expired. Sign in again",
  // Organization invitations
  [qb.joinSessionRefreshFailed]: "Your invitation was accepted, but we could not refresh your session. Retry to continue.",
  [qb.leaveSessionRefreshFailed]: "You left the organization, but we could not refresh your session. Retry to continue.",
  // Sequence controller
  "sequence_controller.device_offline": "The device is offline",
  "sequence_controller.device_busy": "The device is busy",
  "sequence_controller.no_instructions_in_sequence": "No instructions found in the sequence table",
  "sequence_controller.no_draft_or_sequence_method": "Neither the draft nor the sequence method is configured",
  "sequence_controller.sequence_state_not_running": "The sequence state must be RUNNING",
  "sequence_controller.sequence_current_draft_none": "The sequence's current draft is not set",
  "sequence_controller.injection_not_finished": "The sequence's current injection is not marked as finished",
  "sequence_controller.already_running": "The sequence is already in the RUNNING state",
  "sequence_controller.cannot_resume_not_paused": "Unable to RESUME, sequence is not PAUSED",
  "sequence_controller.cannot_resume_no_injection": "Unable to RESUME, no injection",
  "sequence_controller.cannot_pause_not_running": "Can't PAUSE sequence that's not RUNNING",
  "sequence_controller.sequence_not_found": "Sequence is not found",
  "sequence_controller.injection_without_measurement": "Injection exists but without measurement",
  "sequence_controller.device_not_configured": "Method is not configured",
  "sequence_controller.device_not_connected": "The device is not connected",
  "sequence_controller.sample_type_unexpected": "Unexpected type of the sample",
  "sequence_controller.cannot_start_standard_not_ready": "Cannot start sequence. Define amount and time for all standards",
  "sequence_controller.method_not_compatible_with_device": "Method is not compatible with current device configuration",
  // Calibration controller
  "standard_controller.none_device_method_column": "Device, method, and column must not be None",
  "standard_controller.none_column": "Column is not selected",
  "standard_controller.device_offline": "The device is offline",
  "standard_controller.device_busy": "The device is busy",
  "standard_controller.duplicate_concentration_in_sequence": "A standard with the same compound and concentration already exists in this sequence",
  // Device controller
  "device_controller.device_offline": "The device is offline",
  "device_controller.device_busy": "The The device is busy",
  "device_controller.column_not_configured": "Column is not configured",
  "device_controller.different_device": "Device is different",
  "device_controller.method_not_configured": "Method is not configured",
  "device_controller.method_not_compatible": "Method is not compatible with the current device configuration",
  // Sample controller
  "sample_controller.device_offline": "The device is offline",
  "sample_controller.device_busy": "The device is busy",
  "sample_controller.standard_sample": "Sample is a Standard, use StandardController",
  "sample_controller.none_device_method_column": "Device, method, and column must not be None",
  "sample_controller.none_column": "Column is not selected",
  // Autosampler controller
  "autosampler_collector_controller.invalid_interval": "Fraction collector interval is invalid",
  "autosampler_collector_controller.fraction_collector_valve_required": "Configuration invalid. Fraction collector valve is required",
  "autosampler_collector_controller.not_enough_vials": "Fraction Collector error, not enough vials",
  "autosampler_collector_controller.needle_wash_not_allowed": "Needle wash not allowed with autosampler fraction collector",
  // Sequence table controller
  "sequence_table_controller.draft_not_in_sequence": "Draft not in Sequence",
  "sequence_table_controller.id_required_update_draft": "ID required to update draft",
  "sequence_table_controller.invalid_sequence_id": "Invalid Sequence ID",
  "sequence_table_controller.sample_must_be_in_sequence": "Sample must be in Sequence",
  "sequence_table_controller.invalid_draft": "Draft invalid",
  "sequence_table_controller.draft_cannot_be_enabled": "Draft cannot be enabled. Define the amount and time for the relevant standard ",
  // Measurement controller
  "measurement_controller.no_injection": "No injection",
  "measurement_controller.no_peak": "No peak",
  "measurement_controller.no_standard": "No standard",
  "measurement_controller.no_response_factor_in_standard": "No response factor in standard",
  // Method
  "method.only_method_is_changeable": "This method is already used. You can only change its name.",
  "method.hardware_configuration_mismatch": "Device configuration changed while you were editing the method. Please reopen the method editor and try again.",
  "method_invalidated.configuration_incompatible": "Hardware configuration is incompatible with the method",
  // Device
  device_not_configured: "Device is not configured",
  "device.pump_is_not_ready": "Pump is not ready",
  "device.injector_is_not_ready": "Injector is not ready",
  "device.detector_is_not_ready": "Detector is not ready",
  // Hardware key lookup
  "hardware_key_lookup.serial_required": "Device address is required",
  "hardware_key_lookup.not_found": "Device was not found",
  // Organizations
  "organization.invalid_role": "Invalid member role",
  "organization.invalid_email": "Invalid email address",
  "organization.not_found": "Organization data was not found",
  "organization.context_required": "Organization context is required. Sign in again",
  "organization.invalid_id": "Invalid identifier",
  "organization.invitation_token_required": "Invitation token is required",
  "organization.invalid_request": "Invalid request",
  "organization.name_required": "Organization name is required",
  "organization.invitation_already_exists": "A pending invitation for this email already exists",
  "organization.user_already_member": "This user already belongs to an organization",
  "organization.invitation_email_failed": "We could not send the invitation email. The invitation may still be pending; you can try sending it again.",
  // Publishers
  "standard_injection_publisher.unsupported_key_in_data": 'Not supported key "event" in property "data"',
  "standard_publisher.unsupported_key_in_data": 'Not supported key "event" in property "data"',
  "device_publisher.unsupported_key_in_data": 'Not supported key "event" in property "data"',
  "hardware_publisher.unsupported_key_in_data": 'Not supported key "event" in property "data"',
  "measurement_publisher.unsupported_key_in_data": 'Not supported key "event" in property "data"',
  "sample_injection_publisher.unsupported_key_in_data": 'Not supported key "event" in property "data"',
  "sample_publisher.unsupported_key_in_data": 'Not supported key "event" in property "data"',
  "sequence_publisher.unsupported_key_in_data": 'Not supported key "event" in property "data"',
  // Peak processing tasks
  "peak_processing_task.general_error": "General error",
  "peak_processing_task.no_peaks_found": "No peaks found",
  // Wifi adapter
  "wifi.password_wrong": "Password is wrong",
  "wifi.ssid_not_found": "Network name is not found",
  server_error: "The server was unable to execute the operation",
  timeout: "Timeout",
  // Errors from Alltesta or Cromite
  // Input/output error
  101: "Firmware error",
  // Operation was interrupted
  102: "Firmware error",
  // Network errors
  200: "Network was not found",
  201: "Password is wrong",
  202: "Connection failed",
  999: "Unknown error",
  // Hasura (UI friendly keys)
  "hasura.generic": "Unable to complete the request",
  "hasura.default.constraint-violation": "A record with these values already exists",
  "hasura.updateCalibrationLevel.constraint-violation": "Level with this nominal concentration already exists",
  // Browser / QR
  "browser.qr.NotAllowedError": "No permission to use your camera",
  "browser.qr.NotFoundError": "No suitable camera device installed",
  "browser.qr.InsecureContextError": "Use HTTPS or localhost rather than HTTP",
  "browser.qr.NotSupportedError": "Page is not served over HTTPS (or localhost)",
  "browser.qr.NotReadableError": "Maybe camera is already in use",
  "browser.qr.OverconstrainedError": "You don't seem to have a rear camera on your device",
  "browser.qr.UnknownError": "Unknown error"
}, ks = (t) => {
  const e = String(t);
  return Zse[e] ?? e;
}, lf = Qse.subclass("BaseError"), iw = lf.subclass("SchemaParseError"), qt = (t, e, n) => e != null && typeof e == "object" ? t.parse(cie(e, {
  deep: !0,
  stopPaths: n?.excludedFromCamelizationPath,
  exclude: n?.excludedFromCamelizationKeys
})) : t.parse(e), RH = (t) => {
  if (typeof t == "string" || typeof t == "number" || t instanceof Date)
    return new Date(t);
}, Kse = x5(RH, vM()), Jse = x5(RH, vM().optional()), DH = Je().or(Ve()).refine((t) => typeof t == "string" && t.length > 0 ? /^-?[0-9][0-9.]*$/.test(t) && !/^-?0[^.]+$/.test(t) && (t.match(/[.]/g) ?? []).length <= 1 : !0, "Number is not valid!"), NH = Je().min(1, "Required"), ele = Je().trim().min(1, "Required"), tle = DH.and(NH.or(Ve())), nle = Xr(Je()).optional().transform((t) => {
  if (t != null)
    return t?.[0];
}), bi = {
  date: Kse,
  dateOptional: Jse,
  numericString: DH,
  notEmptyNumericString: tle,
  notEmptyString: NH,
  trimmedNotEmptyString: ele,
  serverErrorForFormField: nle
};
var Vd = /* @__PURE__ */ ((t) => (t.DEVICE_VERSION_UPDATE_LATER = "DEVICE_VERSION_UPDATE_LATER", t.LAST_LOCATION = "LAST_LOCATION", t.ACCESS_TOKEN_KEY = "hplc-access-token", t.REFRESH_TOKEN_KEY = "hplc-refresh-token", t.EXPIRY = "hplc-expiry-time", t.CHROMATOGRAMS_COMPARE_IDS = "chromatograms-compare-ids", t.IS_DUAL_MODE = "isAllowDualMode", t.LAST_USED_APP_VERSION = "lastUsedAppVersion", t.ACTIVE_CHROMATOGRAM_ID = "ACTIVE_CHROMATOGRAM_ID", t.WAS_SUGGESTED_PWA_INSTALLATION = "wasSuggestedPWAInstallation", t.REPORT_DATA = "reportData", t.LOG_CONTROLLER = "logController", t.DEVICES_ORDER = "devicesOrder", t))(Vd || {});
const _h = {
  get userId() {
    return co.getUserId();
  },
  set(t, e, {
    isForActiveUser: n = !0,
    params: r = []
  } = {}) {
    const i = r.length ? `:${r.join(":")}` : "", a = n ? `${t}-${this.userId}${i}` : `${t}${i}`;
    return e == null ? localStorage.removeItem(a) : localStorage.setItem(a, JSON.stringify(e));
  },
  get(t, {
    isForActiveUser: e = !0,
    isJSON: n = !0,
    params: r = []
  } = {}) {
    const i = r.length ? `:${r.join(":")}` : "", a = e ? `${t}-${this.userId}${i}` : `${t}${i}`, s = localStorage.getItem(a);
    if (s != null && n)
      try {
        return JSON.parse(s);
      } catch {
        return s;
      }
    return s;
  },
  remove(t, {
    isForActiveUser: e = !0,
    params: n = []
  } = {}) {
    const r = n.length ? `:${n.join(":")}` : "", i = e ? `${t}-${this.userId}${r}` : `${t}${r}`;
    localStorage.removeItem(i);
  }
}, AM = ["%", "mg/mL", "mol", "ppm"], rle = "mg/mL", ile = (t) => AM.includes(t), ale = 60, ole = 60 * 60 * 1e3, sle = 1e3;
class $P extends Error {
  constructor(e, n, r) {
    const i = e.status || e.status === 0 ? e.status : "", a = e.statusText || "", s = `${i} ${a}`.trim(), c = s ? `status code ${s}` : "an unknown error";
    super(`Request failed with ${c}`), Object.defineProperty(this, "response", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "HTTPError", this.response = e, this.request = n, this.options = r;
  }
}
class MH extends Error {
  constructor(e) {
    super("Request timed out"), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "TimeoutError", this.request = e;
  }
}
const r4 = (t) => t !== null && typeof t == "object", vC = (...t) => {
  for (const e of t)
    if ((!r4(e) || Array.isArray(e)) && typeof e < "u")
      throw new TypeError("The `options` argument must be an object");
  return CM({}, ...t);
}, IH = (t = {}, e = {}) => {
  const n = new globalThis.Headers(t), r = e instanceof globalThis.Headers, i = new globalThis.Headers(e);
  for (const [a, s] of i.entries())
    r && s === "undefined" || s === void 0 ? n.delete(a) : n.set(a, s);
  return n;
}, CM = (...t) => {
  let e = {}, n = {};
  for (const r of t)
    if (Array.isArray(r))
      Array.isArray(e) || (e = []), e = [...e, ...r];
    else if (r4(r)) {
      for (let [i, a] of Object.entries(r))
        r4(a) && i in e && (a = CM(e[i], a)), e = { ...e, [i]: a };
      r4(r.headers) && (n = IH(n, r.headers), e.headers = n);
    }
  return e;
}, lle = (() => {
  let t = !1, e = !1;
  const n = typeof globalThis.ReadableStream == "function", r = typeof globalThis.Request == "function";
  return n && r && (e = new globalThis.Request("https://a.com", {
    body: new globalThis.ReadableStream(),
    method: "POST",
    // @ts-expect-error - Types are outdated.
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type")), t && !e;
})(), cle = typeof globalThis.AbortController == "function", ule = typeof globalThis.ReadableStream == "function", dle = typeof globalThis.FormData == "function", kH = ["get", "post", "put", "patch", "head", "delete"], fle = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, f6 = 2147483647, jH = Symbol("stop"), hle = (t) => kH.includes(t) ? t.toUpperCase() : t, ple = ["get", "put", "head", "delete", "options", "trace"], mle = [408, 413, 429, 500, 502, 503, 504], PH = [413, 429, 503], HP = {
  limit: 2,
  methods: ple,
  statusCodes: mle,
  afterStatusCodes: PH,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY
}, gle = (t = {}) => {
  if (typeof t == "number")
    return {
      ...HP,
      limit: t
    };
  if (t.methods && !Array.isArray(t.methods))
    throw new Error("retry.methods must be an array");
  if (t.statusCodes && !Array.isArray(t.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...HP,
    ...t,
    afterStatusCodes: PH
  };
};
async function vle(t, e, n) {
  return new Promise((r, i) => {
    const a = setTimeout(() => {
      e && e.abort(), i(new MH(t));
    }, n.timeout);
    n.fetch(t).then(r).catch(i).then(() => {
      clearTimeout(a);
    });
  });
}
const yle = !!globalThis.DOMException;
function qP(t) {
  if (yle)
    return new DOMException(t?.reason ?? "The operation was aborted.", "AbortError");
  const e = new Error(t?.reason ?? "The operation was aborted.");
  return e.name = "AbortError", e;
}
async function ble(t, { signal: e }) {
  return new Promise((n, r) => {
    if (e) {
      if (e.aborted) {
        r(qP(e));
        return;
      }
      e.addEventListener("abort", i, { once: !0 });
    }
    function i() {
      r(qP(e)), clearTimeout(a);
    }
    const a = setTimeout(() => {
      e?.removeEventListener("abort", i), n();
    }, t);
  });
}
class oT {
  // eslint-disable-next-line @typescript-eslint/promise-function-async
  static create(e, n) {
    const r = new oT(e, n), i = async () => {
      if (r._options.timeout > f6)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${f6}`);
      await Promise.resolve();
      let c = await r._fetch();
      for (const d of r._options.hooks.afterResponse) {
        const f = await d(r.request, r._options, r._decorateResponse(c.clone()));
        f instanceof globalThis.Response && (c = f);
      }
      if (r._decorateResponse(c), !c.ok && r._options.throwHttpErrors) {
        let d = new $P(c, r.request, r._options);
        for (const f of r._options.hooks.beforeError)
          d = await f(d);
        throw d;
      }
      if (r._options.onDownloadProgress) {
        if (typeof r._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!ule)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return r._stream(c.clone(), r._options.onDownloadProgress);
      }
      return c;
    }, s = r._options.retry.methods.includes(r.request.method.toLowerCase()) ? r._retry(i) : i();
    for (const [c, d] of Object.entries(fle))
      s[c] = async () => {
        r.request.headers.set("accept", r.request.headers.get("accept") || d);
        const g = (await s).clone();
        if (c === "json") {
          if (g.status === 204 || (await g.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (n.parseJson)
            return n.parseJson(await g.text());
        }
        return g[c]();
      };
    return s;
  }
  // eslint-disable-next-line complexity
  constructor(e, n = {}) {
    if (Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "abortController", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "_input", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._input = e, this._options = {
      // TODO: credentials can be removed when the spec change is implemented in all browsers. Context: https://www.chromestatus.com/feature/4539473312350208
      credentials: this._input.credentials || "same-origin",
      ...n,
      headers: IH(this._input.headers, n.headers),
      hooks: CM({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, n.hooks),
      method: hle(n.method ?? this._input.method),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(n.prefixUrl || ""),
      retry: gle(n.retry),
      throwHttpErrors: n.throwHttpErrors !== !1,
      timeout: typeof n.timeout > "u" ? 1e4 : n.timeout,
      fetch: n.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (cle) {
      if (this.abortController = new globalThis.AbortController(), this._options.signal) {
        const r = this._options.signal;
        this._options.signal.addEventListener("abort", () => {
          this.abortController.abort(r.reason);
        });
      }
      this._options.signal = this.abortController.signal;
    }
    if (lle && (this._options.duplex = "half"), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const i = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), a = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, i);
      (dle && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(a, { ...this.request }), this._options);
    }
    this._options.json !== void 0 && (this._options.body = JSON.stringify(this._options.json), this.request.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json"), this.request = new globalThis.Request(this.request, { body: this._options.body }));
  }
  _calculateRetryDelay(e) {
    if (this._retryCount++, this._retryCount < this._options.retry.limit && !(e instanceof MH)) {
      if (e instanceof $P) {
        if (!this._options.retry.statusCodes.includes(e.response.status))
          return 0;
        const r = e.response.headers.get("Retry-After");
        if (r && this._options.retry.afterStatusCodes.includes(e.response.status)) {
          let i = Number(r);
          return Number.isNaN(i) ? i = Date.parse(r) - Date.now() : i *= 1e3, typeof this._options.retry.maxRetryAfter < "u" && i > this._options.retry.maxRetryAfter ? 0 : i;
        }
        if (e.response.status === 413)
          return 0;
      }
      const n = 0.3;
      return Math.min(this._options.retry.backoffLimit, n * 2 ** (this._retryCount - 1) * 1e3);
    }
    return 0;
  }
  _decorateResponse(e) {
    return this._options.parseJson && (e.json = async () => this._options.parseJson(await e.text())), e;
  }
  async _retry(e) {
    try {
      return await e();
    } catch (n) {
      const r = Math.min(this._calculateRetryDelay(n), f6);
      if (r !== 0 && this._retryCount > 0) {
        await ble(r, { signal: this._options.signal });
        for (const i of this._options.hooks.beforeRetry)
          if (await i({
            request: this.request,
            options: this._options,
            error: n,
            retryCount: this._retryCount
          }) === jH)
            return;
        return this._retry(e);
      }
      throw n;
    }
  }
  async _fetch() {
    for (const e of this._options.hooks.beforeRequest) {
      const n = await e(this.request, this._options);
      if (n instanceof Request) {
        this.request = n;
        break;
      }
      if (n instanceof Response)
        return n;
    }
    return this._options.timeout === !1 ? this._options.fetch(this.request.clone()) : vle(this.request.clone(), this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(e, n) {
    const r = Number(e.headers.get("content-length")) || 0;
    let i = 0;
    return e.status === 204 ? (n && n({ percent: 1, totalBytes: r, transferredBytes: i }, new Uint8Array()), new globalThis.Response(null, {
      status: e.status,
      statusText: e.statusText,
      headers: e.headers
    })) : new globalThis.Response(new globalThis.ReadableStream({
      async start(a) {
        const s = e.body.getReader();
        n && n({ percent: 0, transferredBytes: 0, totalBytes: r }, new Uint8Array());
        async function c() {
          const { done: d, value: f } = await s.read();
          if (d) {
            a.close();
            return;
          }
          if (n) {
            i += f.byteLength;
            const g = r === 0 ? 0 : i / r;
            n({ percent: g, transferredBytes: i, totalBytes: r }, f);
          }
          a.enqueue(f), await c();
        }
        await c();
      }
    }), {
      status: e.status,
      statusText: e.statusText,
      headers: e.headers
    });
  }
}
/*! MIT License © Sindre Sorhus */
const s8 = (t) => {
  const e = (n, r) => oT.create(n, vC(t, r));
  for (const n of kH)
    e[n] = (r, i) => oT.create(r, vC(t, i, { method: n }));
  return e.create = (n) => s8(vC(n)), e.extend = (n) => s8(vC(t, n)), e.stop = jH, e;
}, wle = s8(), TM = wle, xle = Xe({
  APP_MODE: Je(),
  APP_VERSION: Je(),
  SENTRY_DSN: Je(),
  OPENREPLAY_KEY: Je(),
  SUPPORT_API_TOKEN: Je()
}), ib = (t) => (
  // @ts-ignore
  Je().parse(window[`ENV_${t}`])
), l8 = {
  APP_MODE: ib("VITE_MODE"),
  APP_VERSION: ib("APP_VERSION") ?? ib("VITE_APP_VERSION"),
  SENTRY_DSN: ib("VITE_SENTRY_DSN"),
  OPENREPLAY_KEY: ib("VITE_OPENREPLAY_KEY"),
  SUPPORT_API_TOKEN: ib("VITE_SUPPORT_API_TOKEN")
};
console.log("env raw variables", l8);
const OM = qt(xle, l8, {
  excludedFromCamelizationKeys: Object.keys(l8)
});
console.warn(OM);
const Sle = (t, e) => {
  const n = YP(t), r = YP(e), i = n.pop(), a = r.pop(), s = QP(n, r);
  return s !== 0 ? s : i && a ? QP(i.split("."), a.split(".")) : i || a ? i ? -1 : 1 : 0;
}, GP = (t) => typeof t == "string" && /^[v\d]/.test(t) && LH.test(t), LH = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i, YP = (t) => {
  if (typeof t != "string")
    throw new TypeError("Invalid argument expected string");
  const e = t.match(LH);
  if (!e)
    throw new Error(`Invalid argument not valid semver ('${t}' received)`);
  return e.shift(), e;
}, XP = (t) => t === "*" || t === "x" || t === "X", WP = (t) => {
  const e = parseInt(t, 10);
  return isNaN(e) ? t : e;
}, Ele = (t, e) => typeof t != typeof e ? [String(t), String(e)] : [t, e], _le = (t, e) => {
  if (XP(t) || XP(e))
    return 0;
  const [n, r] = Ele(WP(t), WP(e));
  return n > r ? 1 : n < r ? -1 : 0;
}, QP = (t, e) => {
  for (let n = 0; n < Math.max(t.length, e.length); n++) {
    const r = _le(t[n] || "0", e[n] || "0");
    if (r !== 0)
      return r;
  }
  return 0;
}, ZP = (t) => typeof t == "string" && t.length >= 12 && /^dev-\w{8}$/.test(t), RM = () => OM.APP_VERSION, Ale = (t, e) => {
  if (!t || !t.length || !e || !e.length)
    return !1;
  const n = ZP(t), r = ZP(e);
  if (n || r)
    return t === e;
  const i = typeof t == "string" ? t : t.join("."), a = typeof e == "string" ? e : e.join(".");
  if (GP(i) && GP(a))
    return Sle(i, a) === 0;
  throw new Error("Version is invalid! Should be a valid semver version!");
};
class Cle {
  constructor(e = RM()) {
    this.version = e;
  }
  listeners = [];
  addVersionListener(e) {
    this.listeners.push(e);
  }
  setVersion(e) {
    this.version = e, this.listeners.forEach((n) => n(this.version));
  }
}
const Tle = new Cle();
class BH extends Error {
  constructor(e) {
    super("Network request was failed!"), this.data = e, this.name = "NetworkError";
  }
}
class Ng extends BH {
  constructor(e, n, r, i) {
    super(e), this.data = e, this.response = n, this.request = r, this.options = i, this.name = "HttpError";
  }
}
const zH = Xe({
  detail: Je().optional(),
  error: Je().optional(),
  msg: Je().optional(),
  message: Je().or(Xr(Je())).optional()
}).and(gg(G$())), Ole = (t, e, n) => {
  {
    const r = n.headers.get("version");
    r && Ale(r, RM()) && Tle.setVersion(r);
  }
}, Rle = (t, e, n) => {
  n.status === 401 && (window.location.href = "/auth/login/");
}, Dle = (t) => {
  switch (t) {
    case 401:
      return "Not authorized";
    case 400:
      return "Bad request";
    case 403:
      return "Forbidden";
    case 404:
      return "Not found";
    case 408:
      return "Timeout";
    case 500:
      return "Server error";
    default:
      return `Error code ${t}`;
  }
}, Nle = async (t) => {
  const {
    response: e,
    options: n,
    request: r
  } = t, i = await e.json().catch(() => ({})), a = qt(zH, i), {
    message: s,
    detail: c,
    error: d,
    msg: f
  } = a, g = {
    // TODO check the cast
    code: e.status,
    message: c ?? (d != null ? ks(d) : null) ?? f ?? (Array.isArray(s) ? s.join(", ") : s) ?? Dle(e.status),
    payload: a
  };
  return new Ng(g, e, r, n);
}, Mle = async (t) => {
  if (!t.headers.has("is-guest-request")) {
    const e = await co.getOrRefreshAccessToken();
    e && t.headers.append("Authorization", `Bearer ${e}`);
  }
}, Ya = {
  ky: TM.create({
    prefixUrl: "/api/",
    hooks: {
      beforeRequest: [Mle],
      afterResponse: [Ole, Rle],
      beforeError: [Nle]
    },
    retry: 0
  }),
  get(t, e) {
    return this.ky.get(t, {
      headers: e?.headers,
      searchParams: e?.queryParams
    }).json();
  },
  post(t, e, n) {
    return this.ky.post(t, {
      json: e,
      headers: n?.headers,
      searchParams: n?.queryParams
    }).json();
  },
  postFormData(t, e, n) {
    const r = new FormData();
    return Object.entries(e).forEach(([i, a]) => r.append(i, a)), this.ky.post(t, {
      body: r,
      headers: n?.headers,
      searchParams: n?.queryParams
    }).json();
  },
  put(t, e, n) {
    return this.ky.put(t, {
      json: e,
      headers: n?.headers,
      searchParams: n?.queryParams
    }).json();
  },
  patch(t, e, n) {
    return this.ky.patch(t, {
      json: e,
      headers: n?.headers,
      searchParams: n?.queryParams
    }).json();
  },
  delete(t, e, n) {
    return this.ky.delete(t, {
      json: e,
      headers: n?.headers,
      searchParams: n?.queryParams
    }).json();
  }
}, KP = {
  login(t, e) {
    return Ya.post("token/", {
      username: t,
      password: e
    }, {
      headers: {
        "is-guest-request": "true"
      }
    });
  },
  refreshAccessToken(t) {
    return Ya.post("token/refresh/", {
      refresh: t
    }, {
      headers: {
        "is-guest-request": "true"
      }
    });
  }
}, JP = Xe({
  access: Je(),
  refresh: Je(),
  expiresIn: Ve()
}), eL = {
  async login(t, e) {
    const n = await KP.login(t, e);
    return qt(JP, n);
  },
  async refreshAccessToken(t) {
    const e = await KP.refreshAccessToken(t);
    return qt(JP, {
      refresh: t,
      ...e
    });
  }
}, FH = (t) => {
  if (!t)
    return null;
  const e = t.split(".")[1];
  if (!e)
    return null;
  const n = e.replace(/-/g, "+").replace(/_/g, "/"), r = decodeURIComponent(atob(n).split("").map(function(i) {
    return "%" + ("00" + i.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
  return JSON.parse(r);
}, Ile = Dg({
  CONTINUE: 100,
  SWITCHING_PROTOCOLS: 101,
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NON_AUTHORITATIVE_INFORMATION: 203,
  NO_CONTENT: 204,
  RESET_CONTENT: 205,
  PARTIAL_CONTENT: 206,
  MULTIPLE_CHOICES: 300,
  MOVED_PERMANENTLY: 301,
  FOUND: 302,
  SEE_OTHER: 303,
  NOT_MODIFIED: 304,
  USE_PROXY: 305,
  TEMPORARY_REDIRECT: 307,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  PROXY_AUTHENTICATION_REQUIRED: 407,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  GONE: 410,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  REQUEST_ENTITY_TOO_LARGE: 413,
  REQUEST_URI_TOO_LONG: 414,
  UNSUPPORTED_MEDIA_TYPE: 415,
  REQUESTED_RANGE_NOT_SATISFIABLE: 416,
  EXPECTATION_FAILED: 417,
  IM_A_TEAPOT: 418,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  HTTP_VERSION_NOT_SUPPORTED: 505
}), UE = Ile.enum, kle = (t) => new Promise((e) => {
  setTimeout(e, t);
}), yC = lf.subclass("AuthError"), jle = lf.subclass("AuthSessionExpiredError"), Ple = lf.subclass("AuthRefreshTemporaryUnavailableError"), ab = {
  isForActiveUser: !1
}, tL = 5, Lle = 1e3, nL = (t) => t instanceof Ng && (t.data.code === UE.BAD_REQUEST || t.data.code === UE.UNAUTHORIZED);
class co {
  static subscribers = /* @__PURE__ */ new Set();
  static subscribe(e) {
    return this.subscribers.add(e), () => this.subscribers.delete(e);
  }
  static notifySubscribers() {
    this.subscribers.forEach((e) => e());
  }
  // TODO why?
  static requestRefreshToken;
  static async login(e, n) {
    const r = await eL.login(e, n);
    this.setTokens(r);
  }
  static logout() {
    this.resetAuth();
  }
  /**
   * The method returns the current token if it is not expired, or refreshes it.
   */
  static async getOrRefreshAccessToken() {
    if (this.refreshToken && this.accessToken && this.isAccessTokenOutdated && await this.refreshAccessToken(), this.accessToken)
      return this.accessToken;
    throw new yC("The access token is not provided! Even after the update!");
  }
  static getUserId() {
    const e = this.accessToken;
    return e ? FH(e)?.user_id ?? null : null;
  }
  static getAccessToken() {
    return this.accessToken;
  }
  static get isLoggedIn() {
    return !!(this.accessToken && this.refreshToken);
  }
  static async refreshAccessToken() {
    const e = this.refreshToken;
    if (!e)
      throw new yC("The refresh token is not provided!");
    co.requestRefreshToken = co.requestRefreshToken ?? this.refreshAccessTokenWithRetries(e);
    try {
      const n = await co.requestRefreshToken;
      this.setTokens(n);
    } catch (n) {
      throw nL(n) ? (this.resetAuth(), new jle("The session has expired!")) : new Ple("Unable to refresh access token right now!");
    } finally {
      co.requestRefreshToken = null;
    }
  }
  static async refreshAccessTokenWithRetries(e) {
    for (let n = 0; n <= tL; n += 1)
      try {
        return await eL.refreshAccessToken(e);
      } catch (r) {
        if (nL(r) || n === tL)
          throw r;
        await kle(Lle);
      }
    throw new yC("Unable to refresh access token!");
  }
  static setTokens(e) {
    this.setRefreshToken(e.refresh), this.setAccessToken(e.access), this.setExpiryTime((/* @__PURE__ */ new Date()).getTime() + e.expiresIn * sle), this.notifySubscribers();
  }
  static get accessToken() {
    return _h.get(Vd.ACCESS_TOKEN_KEY, ab);
  }
  static get refreshToken() {
    return _h.get(Vd.REFRESH_TOKEN_KEY, ab);
  }
  static get expiryTime() {
    return _h.get(Vd.EXPIRY, ab);
  }
  static setAccessToken(e) {
    _h.set(Vd.ACCESS_TOKEN_KEY, e, ab);
  }
  static setRefreshToken(e) {
    _h.set(Vd.REFRESH_TOKEN_KEY, e, ab);
  }
  static setExpiryTime(e) {
    _h.set(Vd.EXPIRY, e, ab);
  }
  static resetAuth() {
    this.setAccessToken(null), this.setRefreshToken(null), this.setExpiryTime(null), this.notifySubscribers();
  }
  static get isAccessTokenOutdated() {
    if (this.expiryTime) {
      const e = /* @__PURE__ */ new Date();
      return this.expiryTime < e.getTime();
    }
    throw new yC("The access token expiration time is not provided!");
  }
}
const Ble = lf.subclass("AuthError");
class c8 {
  static getUser() {
    const e = co.getAccessToken();
    if (e)
      return qt(Qre, FH(e));
    throw new Ble("A user is not logged in! ");
  }
  static get isLoggedIn() {
    return co.isLoggedIn;
  }
  static async login(e, n) {
    await co.login(e, n), sT.getState().syncUser();
  }
  static logout() {
    co.logout();
  }
  static init() {
    co.subscribe(() => {
      sT.getState().syncUser();
    });
  }
}
c8.init();
const sT = S5((t) => ({
  user: null,
  init: () => {
    try {
      const e = c8.getUser();
      t({
        user: e
      });
    } catch {
      t({
        user: null
      });
    }
  },
  syncUser: () => {
    try {
      const e = c8.getUser();
      t({
        user: e
      });
    } catch {
      t({
        user: null
      });
    }
  },
  resetUser: () => {
    t({
      user: null
    });
  }
}));
sT.getState().init();
const DM = () => {
  const t = sT(zle);
  if (!t)
    throw new Error("User not found in session store");
  return t;
};
function zle(t) {
  return t.user;
}
const Fle = Re.div`
  twd-space-y-2
`, Vle = () => {
  const t = ve.c(9), e = DM();
  let n;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ C.jsx("span", { className: "twd-text-secondary", children: "Login:" }), t[0] = n) : n = t[0];
  let r;
  t[1] !== e.username ? (r = /* @__PURE__ */ C.jsxs("div", { children: [
    n,
    " ",
    e.username
  ] }), t[1] = e.username, t[2] = r) : r = t[2];
  let i;
  t[3] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ C.jsx("span", { className: "twd-text-secondary", children: "Email:" }), t[3] = i) : i = t[3];
  let a;
  t[4] !== e.email ? (a = /* @__PURE__ */ C.jsxs("div", { children: [
    i,
    " ",
    e.email
  ] }), t[4] = e.email, t[5] = a) : a = t[5];
  let s;
  return t[6] !== r || t[7] !== a ? (s = /* @__PURE__ */ C.jsxs(Fle, { children: [
    r,
    a
  ] }), t[6] = r, t[7] = a, t[8] = s) : s = t[8], s;
};
function Ule(t, e) {
  const n = I.createContext(e), r = (a) => {
    const { children: s, ...c } = a, d = I.useMemo(() => c, Object.values(c));
    return /* @__PURE__ */ C.jsx(n.Provider, { value: d, children: s });
  };
  r.displayName = t + "Provider";
  function i(a) {
    const s = I.useContext(n);
    if (s)
      return s;
    if (e !== void 0)
      return e;
    throw new Error(`\`${a}\` must be used within \`${t}\``);
  }
  return [r, i];
}
function Mg(t, e = []) {
  let n = [];
  function r(a, s) {
    const c = I.createContext(s), d = n.length;
    n = [...n, s];
    const f = (m) => {
      const { scope: b, children: w, ..._ } = m, A = b?.[t]?.[d] || c, T = I.useMemo(() => _, Object.values(_));
      return /* @__PURE__ */ C.jsx(A.Provider, { value: T, children: w });
    };
    f.displayName = a + "Provider";
    function g(m, b) {
      const w = b?.[t]?.[d] || c, _ = I.useContext(w);
      if (_)
        return _;
      if (s !== void 0)
        return s;
      throw new Error(`\`${m}\` must be used within \`${a}\``);
    }
    return [f, g];
  }
  const i = () => {
    const a = n.map((s) => I.createContext(s));
    return function(c) {
      const d = c?.[t] || a;
      return I.useMemo(
        () => ({ [`__scope${t}`]: { ...c, [t]: d } }),
        [c, d]
      );
    };
  };
  return i.scopeName = t, [r, $le(i, ...e)];
}
function $le(...t) {
  const e = t[0];
  if (t.length === 1)
    return e;
  const n = () => {
    const r = t.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(a) {
      const s = r.reduce((c, { useScope: d, scopeName: f }) => {
        const m = d(a)[`__scope${f}`];
        return { ...c, ...m };
      }, {});
      return I.useMemo(() => ({ [`__scope${e.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function rL(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function NM(...t) {
  return (e) => {
    let n = !1;
    const r = t.map((i) => {
      const a = rL(i, e);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const a = r[i];
          typeof a == "function" ? a() : rL(t[i], null);
        }
      };
  };
}
function ho(...t) {
  return I.useCallback(NM(...t), t);
}
// @__NO_SIDE_EFFECTS__
function $E(t) {
  const e = /* @__PURE__ */ qle(t), n = I.forwardRef((r, i) => {
    const { children: a, ...s } = r, c = I.Children.toArray(a), d = c.find(Yle);
    if (d) {
      const f = d.props.children, g = c.map((m) => m === d ? I.Children.count(f) > 1 ? I.Children.only(null) : I.isValidElement(f) ? f.props.children : null : m);
      return /* @__PURE__ */ C.jsx(e, { ...s, ref: i, children: I.isValidElement(f) ? I.cloneElement(f, void 0, g) : null });
    }
    return /* @__PURE__ */ C.jsx(e, { ...s, ref: i, children: a });
  });
  return n.displayName = `${t}.Slot`, n;
}
var Hle = /* @__PURE__ */ $E("Slot");
// @__NO_SIDE_EFFECTS__
function qle(t) {
  const e = I.forwardRef((n, r) => {
    const { children: i, ...a } = n;
    if (I.isValidElement(i)) {
      const s = Wle(i), c = Xle(a, i.props);
      return i.type !== I.Fragment && (c.ref = r ? NM(r, s) : s), I.cloneElement(i, c);
    }
    return I.Children.count(i) > 1 ? I.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var VH = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Gle(t) {
  const e = ({ children: n }) => /* @__PURE__ */ C.jsx(C.Fragment, { children: n });
  return e.displayName = `${t}.Slottable`, e.__radixId = VH, e;
}
function Yle(t) {
  return I.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === VH;
}
function Xle(t, e) {
  const n = { ...e };
  for (const r in e) {
    const i = t[r], a = e[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...c) => {
      const d = a(...c);
      return i(...c), d;
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...a } : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function Wle(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
function Qle(t) {
  const e = t + "CollectionProvider", [n, r] = Mg(e), [i, a] = n(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (A) => {
    const { scope: T, children: O } = A, R = De.useRef(null), N = De.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ C.jsx(i, { scope: T, itemMap: N, collectionRef: R, children: O });
  };
  s.displayName = e;
  const c = t + "CollectionSlot", d = /* @__PURE__ */ $E(c), f = De.forwardRef(
    (A, T) => {
      const { scope: O, children: R } = A, N = a(c, O), M = ho(T, N.collectionRef);
      return /* @__PURE__ */ C.jsx(d, { ref: M, children: R });
    }
  );
  f.displayName = c;
  const g = t + "CollectionItemSlot", m = "data-radix-collection-item", b = /* @__PURE__ */ $E(g), w = De.forwardRef(
    (A, T) => {
      const { scope: O, children: R, ...N } = A, M = De.useRef(null), P = ho(T, M), z = a(g, O);
      return De.useEffect(() => (z.itemMap.set(M, { ref: M, ...N }), () => void z.itemMap.delete(M))), /* @__PURE__ */ C.jsx(b, { [m]: "", ref: P, children: R });
    }
  );
  w.displayName = g;
  function _(A) {
    const T = a(t + "CollectionConsumer", A);
    return De.useCallback(() => {
      const R = T.collectionRef.current;
      if (!R)
        return [];
      const N = Array.from(R.querySelectorAll(`[${m}]`));
      return Array.from(T.itemMap.values()).sort(
        (z, F) => N.indexOf(z.ref.current) - N.indexOf(F.ref.current)
      );
    }, [T.collectionRef, T.itemMap]);
  }
  return [
    { Provider: s, Slot: f, ItemSlot: w },
    _,
    r
  ];
}
function UH(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (t?.(i), n === !1 || !i.defaultPrevented)
      return e?.(i);
  };
}
var Mh = globalThis?.document ? I.useLayoutEffect : () => {
}, Zle = g_[" useInsertionEffect ".trim().toString()] || Mh;
function aw({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  },
  caller: r
}) {
  const [i, a, s] = Kle({
    defaultProp: e,
    onChange: n
  }), c = t !== void 0, d = c ? t : i;
  {
    const g = I.useRef(t !== void 0);
    I.useEffect(() => {
      const m = g.current;
      m !== c && console.warn(
        `${r} is changing from ${m ? "controlled" : "uncontrolled"} to ${c ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), g.current = c;
    }, [c, r]);
  }
  const f = I.useCallback(
    (g) => {
      if (c) {
        const m = Jle(g) ? g(t) : g;
        m !== t && s.current?.(m);
      } else
        a(g);
    },
    [c, t, a, s]
  );
  return [d, f];
}
function Kle({
  defaultProp: t,
  onChange: e
}) {
  const [n, r] = I.useState(t), i = I.useRef(n), a = I.useRef(e);
  return Zle(() => {
    a.current = e;
  }, [e]), I.useEffect(() => {
    i.current !== n && (a.current?.(n), i.current = n);
  }, [n, i]), [n, r, a];
}
function Jle(t) {
  return typeof t == "function";
}
var bC = { exports: {} }, Xo = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var iL;
function ece() {
  if (iL)
    return Xo;
  iL = 1;
  var t = I;
  function e(d) {
    var f = "https://react.dev/errors/" + d;
    if (1 < arguments.length) {
      f += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var g = 2; g < arguments.length; g++)
        f += "&args[]=" + encodeURIComponent(arguments[g]);
    }
    return "Minified React error #" + d + "; visit " + f + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function n() {
  }
  var r = {
    d: {
      f: n,
      r: function() {
        throw Error(e(522));
      },
      D: n,
      C: n,
      L: n,
      m: n,
      X: n,
      S: n,
      M: n
    },
    p: 0,
    findDOMNode: null
  }, i = Symbol.for("react.portal");
  function a(d, f, g) {
    var m = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: i,
      key: m == null ? null : "" + m,
      children: d,
      containerInfo: f,
      implementation: g
    };
  }
  var s = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function c(d, f) {
    if (d === "font")
      return "";
    if (typeof f == "string")
      return f === "use-credentials" ? f : "";
  }
  return Xo.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r, Xo.createPortal = function(d, f) {
    var g = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!f || f.nodeType !== 1 && f.nodeType !== 9 && f.nodeType !== 11)
      throw Error(e(299));
    return a(d, f, null, g);
  }, Xo.flushSync = function(d) {
    var f = s.T, g = r.p;
    try {
      if (s.T = null, r.p = 2, d)
        return d();
    } finally {
      s.T = f, r.p = g, r.d.f();
    }
  }, Xo.preconnect = function(d, f) {
    typeof d == "string" && (f ? (f = f.crossOrigin, f = typeof f == "string" ? f === "use-credentials" ? f : "" : void 0) : f = null, r.d.C(d, f));
  }, Xo.prefetchDNS = function(d) {
    typeof d == "string" && r.d.D(d);
  }, Xo.preinit = function(d, f) {
    if (typeof d == "string" && f && typeof f.as == "string") {
      var g = f.as, m = c(g, f.crossOrigin), b = typeof f.integrity == "string" ? f.integrity : void 0, w = typeof f.fetchPriority == "string" ? f.fetchPriority : void 0;
      g === "style" ? r.d.S(
        d,
        typeof f.precedence == "string" ? f.precedence : void 0,
        {
          crossOrigin: m,
          integrity: b,
          fetchPriority: w
        }
      ) : g === "script" && r.d.X(d, {
        crossOrigin: m,
        integrity: b,
        fetchPriority: w,
        nonce: typeof f.nonce == "string" ? f.nonce : void 0
      });
    }
  }, Xo.preinitModule = function(d, f) {
    if (typeof d == "string")
      if (typeof f == "object" && f !== null) {
        if (f.as == null || f.as === "script") {
          var g = c(
            f.as,
            f.crossOrigin
          );
          r.d.M(d, {
            crossOrigin: g,
            integrity: typeof f.integrity == "string" ? f.integrity : void 0,
            nonce: typeof f.nonce == "string" ? f.nonce : void 0
          });
        }
      } else
        f == null && r.d.M(d);
  }, Xo.preload = function(d, f) {
    if (typeof d == "string" && typeof f == "object" && f !== null && typeof f.as == "string") {
      var g = f.as, m = c(g, f.crossOrigin);
      r.d.L(d, g, {
        crossOrigin: m,
        integrity: typeof f.integrity == "string" ? f.integrity : void 0,
        nonce: typeof f.nonce == "string" ? f.nonce : void 0,
        type: typeof f.type == "string" ? f.type : void 0,
        fetchPriority: typeof f.fetchPriority == "string" ? f.fetchPriority : void 0,
        referrerPolicy: typeof f.referrerPolicy == "string" ? f.referrerPolicy : void 0,
        imageSrcSet: typeof f.imageSrcSet == "string" ? f.imageSrcSet : void 0,
        imageSizes: typeof f.imageSizes == "string" ? f.imageSizes : void 0,
        media: typeof f.media == "string" ? f.media : void 0
      });
    }
  }, Xo.preloadModule = function(d, f) {
    if (typeof d == "string")
      if (f) {
        var g = c(f.as, f.crossOrigin);
        r.d.m(d, {
          as: typeof f.as == "string" && f.as !== "script" ? f.as : void 0,
          crossOrigin: g,
          integrity: typeof f.integrity == "string" ? f.integrity : void 0
        });
      } else
        r.d.m(d);
  }, Xo.requestFormReset = function(d) {
    r.d.r(d);
  }, Xo.unstable_batchedUpdates = function(d, f) {
    return d(f);
  }, Xo.useFormState = function(d, f, g) {
    return s.H.useFormState(d, f, g);
  }, Xo.useFormStatus = function() {
    return s.H.useHostTransitionStatus();
  }, Xo.version = "19.2.0", Xo;
}
var Wo = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aL;
function tce() {
  return aL || (aL = 1, process.env.NODE_ENV !== "production" && function() {
    function t() {
    }
    function e(m) {
      return "" + m;
    }
    function n(m, b, w) {
      var _ = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      try {
        e(_);
        var A = !1;
      } catch {
        A = !0;
      }
      return A && (console.error(
        "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
        typeof Symbol == "function" && Symbol.toStringTag && _[Symbol.toStringTag] || _.constructor.name || "Object"
      ), e(_)), {
        $$typeof: f,
        key: _ == null ? null : "" + _,
        children: m,
        containerInfo: b,
        implementation: w
      };
    }
    function r(m, b) {
      if (m === "font")
        return "";
      if (typeof b == "string")
        return b === "use-credentials" ? b : "";
    }
    function i(m) {
      return m === null ? "`null`" : m === void 0 ? "`undefined`" : m === "" ? "an empty string" : 'something with type "' + typeof m + '"';
    }
    function a(m) {
      return m === null ? "`null`" : m === void 0 ? "`undefined`" : m === "" ? "an empty string" : typeof m == "string" ? JSON.stringify(m) : typeof m == "number" ? "`" + m + "`" : 'something with type "' + typeof m + '"';
    }
    function s() {
      var m = g.H;
      return m === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), m;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var c = I, d = {
      d: {
        f: t,
        r: function() {
          throw Error(
            "Invalid form element. requestFormReset must be passed a form that was rendered by React."
          );
        },
        D: t,
        C: t,
        L: t,
        m: t,
        X: t,
        S: t,
        M: t
      },
      p: 0,
      findDOMNode: null
    }, f = Symbol.for("react.portal"), g = c.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
    ), Wo.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = d, Wo.createPortal = function(m, b) {
      var w = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!b || b.nodeType !== 1 && b.nodeType !== 9 && b.nodeType !== 11)
        throw Error("Target container is not a DOM element.");
      return n(m, b, null, w);
    }, Wo.flushSync = function(m) {
      var b = g.T, w = d.p;
      try {
        if (g.T = null, d.p = 2, m)
          return m();
      } finally {
        g.T = b, d.p = w, d.d.f() && console.error(
          "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
        );
      }
    }, Wo.preconnect = function(m, b) {
      typeof m == "string" && m ? b != null && typeof b != "object" ? console.error(
        "ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.",
        a(b)
      ) : b != null && typeof b.crossOrigin != "string" && console.error(
        "ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.",
        i(b.crossOrigin)
      ) : console.error(
        "ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        i(m)
      ), typeof m == "string" && (b ? (b = b.crossOrigin, b = typeof b == "string" ? b === "use-credentials" ? b : "" : void 0) : b = null, d.d.C(m, b));
    }, Wo.prefetchDNS = function(m) {
      if (typeof m != "string" || !m)
        console.error(
          "ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
          i(m)
        );
      else if (1 < arguments.length) {
        var b = arguments[1];
        typeof b == "object" && b.hasOwnProperty("crossOrigin") ? console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          a(b)
        ) : console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          a(b)
        );
      }
      typeof m == "string" && d.d.D(m);
    }, Wo.preinit = function(m, b) {
      if (typeof m == "string" && m ? b == null || typeof b != "object" ? console.error(
        "ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.",
        a(b)
      ) : b.as !== "style" && b.as !== "script" && console.error(
        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
        a(b.as)
      ) : console.error(
        "ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        i(m)
      ), typeof m == "string" && b && typeof b.as == "string") {
        var w = b.as, _ = r(w, b.crossOrigin), A = typeof b.integrity == "string" ? b.integrity : void 0, T = typeof b.fetchPriority == "string" ? b.fetchPriority : void 0;
        w === "style" ? d.d.S(
          m,
          typeof b.precedence == "string" ? b.precedence : void 0,
          {
            crossOrigin: _,
            integrity: A,
            fetchPriority: T
          }
        ) : w === "script" && d.d.X(m, {
          crossOrigin: _,
          integrity: A,
          fetchPriority: T,
          nonce: typeof b.nonce == "string" ? b.nonce : void 0
        });
      }
    }, Wo.preinitModule = function(m, b) {
      var w = "";
      if (typeof m == "string" && m || (w += " The `href` argument encountered was " + i(m) + "."), b !== void 0 && typeof b != "object" ? w += " The `options` argument encountered was " + i(b) + "." : b && "as" in b && b.as !== "script" && (w += " The `as` option encountered was " + a(b.as) + "."), w)
        console.error(
          "ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s",
          w
        );
      else
        switch (w = b && typeof b.as == "string" ? b.as : "script", w) {
          case "script":
            break;
          default:
            w = a(w), console.error(
              'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
              w,
              m
            );
        }
      typeof m == "string" && (typeof b == "object" && b !== null ? (b.as == null || b.as === "script") && (w = r(
        b.as,
        b.crossOrigin
      ), d.d.M(m, {
        crossOrigin: w,
        integrity: typeof b.integrity == "string" ? b.integrity : void 0,
        nonce: typeof b.nonce == "string" ? b.nonce : void 0
      })) : b == null && d.d.M(m));
    }, Wo.preload = function(m, b) {
      var w = "";
      if (typeof m == "string" && m || (w += " The `href` argument encountered was " + i(m) + "."), b == null || typeof b != "object" ? w += " The `options` argument encountered was " + i(b) + "." : typeof b.as == "string" && b.as || (w += " The `as` option encountered was " + i(b.as) + "."), w && console.error(
        'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
        w
      ), typeof m == "string" && typeof b == "object" && b !== null && typeof b.as == "string") {
        w = b.as;
        var _ = r(
          w,
          b.crossOrigin
        );
        d.d.L(m, w, {
          crossOrigin: _,
          integrity: typeof b.integrity == "string" ? b.integrity : void 0,
          nonce: typeof b.nonce == "string" ? b.nonce : void 0,
          type: typeof b.type == "string" ? b.type : void 0,
          fetchPriority: typeof b.fetchPriority == "string" ? b.fetchPriority : void 0,
          referrerPolicy: typeof b.referrerPolicy == "string" ? b.referrerPolicy : void 0,
          imageSrcSet: typeof b.imageSrcSet == "string" ? b.imageSrcSet : void 0,
          imageSizes: typeof b.imageSizes == "string" ? b.imageSizes : void 0,
          media: typeof b.media == "string" ? b.media : void 0
        });
      }
    }, Wo.preloadModule = function(m, b) {
      var w = "";
      typeof m == "string" && m || (w += " The `href` argument encountered was " + i(m) + "."), b !== void 0 && typeof b != "object" ? w += " The `options` argument encountered was " + i(b) + "." : b && "as" in b && typeof b.as != "string" && (w += " The `as` option encountered was " + i(b.as) + "."), w && console.error(
        'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
        w
      ), typeof m == "string" && (b ? (w = r(
        b.as,
        b.crossOrigin
      ), d.d.m(m, {
        as: typeof b.as == "string" && b.as !== "script" ? b.as : void 0,
        crossOrigin: w,
        integrity: typeof b.integrity == "string" ? b.integrity : void 0
      })) : d.d.m(m));
    }, Wo.requestFormReset = function(m) {
      d.d.r(m);
    }, Wo.unstable_batchedUpdates = function(m, b) {
      return m(b);
    }, Wo.useFormState = function(m, b, w) {
      return s().useFormState(m, b, w);
    }, Wo.useFormStatus = function() {
      return s().useHostTransitionStatus();
    }, Wo.version = "19.2.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Wo;
}
var oL;
function MM() {
  if (oL)
    return bC.exports;
  oL = 1;
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (e) {
        console.error(e);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (t(), bC.exports = ece()) : bC.exports = tce(), bC.exports;
}
var Wc = MM();
const $H = /* @__PURE__ */ J0(Wc);
var nce = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Xa = nce.reduce((t, e) => {
  const n = /* @__PURE__ */ $E(`Primitive.${e}`), r = I.forwardRef((i, a) => {
    const { asChild: s, ...c } = i, d = s ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ C.jsx(d, { ...c, ref: a });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function rce(t, e) {
  t && Wc.flushSync(() => t.dispatchEvent(e));
}
function ice(t, e) {
  return I.useReducer((n, r) => e[n][r] ?? n, t);
}
var HH = (t) => {
  const { present: e, children: n } = t, r = ace(e), i = typeof n == "function" ? n({ present: r.isPresent }) : I.Children.only(n), a = ho(r.ref, oce(i));
  return typeof n == "function" || r.isPresent ? I.cloneElement(i, { ref: a }) : null;
};
HH.displayName = "Presence";
function ace(t) {
  const [e, n] = I.useState(), r = I.useRef(null), i = I.useRef(t), a = I.useRef("none"), s = t ? "mounted" : "unmounted", [c, d] = ice(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return I.useEffect(() => {
    const f = wC(r.current);
    a.current = c === "mounted" ? f : "none";
  }, [c]), Mh(() => {
    const f = r.current, g = i.current;
    if (g !== t) {
      const b = a.current, w = wC(f);
      t ? d("MOUNT") : w === "none" || f?.display === "none" ? d("UNMOUNT") : d(g && b !== w ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [t, d]), Mh(() => {
    if (e) {
      let f;
      const g = e.ownerDocument.defaultView ?? window, m = (w) => {
        const A = wC(r.current).includes(w.animationName);
        if (w.target === e && A && (d("ANIMATION_END"), !i.current)) {
          const T = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", f = g.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = T);
          });
        }
      }, b = (w) => {
        w.target === e && (a.current = wC(r.current));
      };
      return e.addEventListener("animationstart", b), e.addEventListener("animationcancel", m), e.addEventListener("animationend", m), () => {
        g.clearTimeout(f), e.removeEventListener("animationstart", b), e.removeEventListener("animationcancel", m), e.removeEventListener("animationend", m);
      };
    } else
      d("ANIMATION_END");
  }, [e, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: I.useCallback((f) => {
      r.current = f ? getComputedStyle(f) : null, n(f);
    }, [])
  };
}
function wC(t) {
  return t?.animationName || "none";
}
function oce(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var sce = g_[" useId ".trim().toString()] || (() => {
}), lce = 0;
function uE(t) {
  const [e, n] = I.useState(sce());
  return Mh(() => {
    t || n((r) => r ?? String(lce++));
  }, [t]), t || (e ? `radix-${e}` : "");
}
var C5 = "Collapsible", [cce, qH] = Mg(C5), [uce, IM] = cce(C5), GH = I.forwardRef(
  (t, e) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: i,
      disabled: a,
      onOpenChange: s,
      ...c
    } = t, [d, f] = aw({
      prop: r,
      defaultProp: i ?? !1,
      onChange: s,
      caller: C5
    });
    return /* @__PURE__ */ C.jsx(
      uce,
      {
        scope: n,
        disabled: a,
        contentId: uE(),
        open: d,
        onOpenToggle: I.useCallback(() => f((g) => !g), [f]),
        children: /* @__PURE__ */ C.jsx(
          Xa.div,
          {
            "data-state": jM(d),
            "data-disabled": a ? "" : void 0,
            ...c,
            ref: e
          }
        )
      }
    );
  }
);
GH.displayName = C5;
var YH = "CollapsibleTrigger", XH = I.forwardRef(
  (t, e) => {
    const { __scopeCollapsible: n, ...r } = t, i = IM(YH, n);
    return /* @__PURE__ */ C.jsx(
      Xa.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": jM(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: e,
        onClick: UH(t.onClick, i.onOpenToggle)
      }
    );
  }
);
XH.displayName = YH;
var kM = "CollapsibleContent", WH = I.forwardRef(
  (t, e) => {
    const { forceMount: n, ...r } = t, i = IM(kM, t.__scopeCollapsible);
    return /* @__PURE__ */ C.jsx(HH, { present: n || i.open, children: ({ present: a }) => /* @__PURE__ */ C.jsx(dce, { ...r, ref: e, present: a }) });
  }
);
WH.displayName = kM;
var dce = I.forwardRef((t, e) => {
  const { __scopeCollapsible: n, present: r, children: i, ...a } = t, s = IM(kM, n), [c, d] = I.useState(r), f = I.useRef(null), g = ho(e, f), m = I.useRef(0), b = m.current, w = I.useRef(0), _ = w.current, A = s.open || c, T = I.useRef(A), O = I.useRef(void 0);
  return I.useEffect(() => {
    const R = requestAnimationFrame(() => T.current = !1);
    return () => cancelAnimationFrame(R);
  }, []), Mh(() => {
    const R = f.current;
    if (R) {
      O.current = O.current || {
        transitionDuration: R.style.transitionDuration,
        animationName: R.style.animationName
      }, R.style.transitionDuration = "0s", R.style.animationName = "none";
      const N = R.getBoundingClientRect();
      m.current = N.height, w.current = N.width, T.current || (R.style.transitionDuration = O.current.transitionDuration, R.style.animationName = O.current.animationName), d(r);
    }
  }, [s.open, r]), /* @__PURE__ */ C.jsx(
    Xa.div,
    {
      "data-state": jM(s.open),
      "data-disabled": s.disabled ? "" : void 0,
      id: s.contentId,
      hidden: !A,
      ...a,
      ref: g,
      style: {
        "--radix-collapsible-content-height": b ? `${b}px` : void 0,
        "--radix-collapsible-content-width": _ ? `${_}px` : void 0,
        ...t.style
      },
      children: A && i
    }
  );
});
function jM(t) {
  return t ? "open" : "closed";
}
var fce = GH, hce = XH, pce = WH, mce = I.createContext(void 0);
function gce(t) {
  const e = I.useContext(mce);
  return t || e || "ltr";
}
var Zu = "Accordion", vce = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [PM, yce, bce] = Qle(Zu), [T5, TGe] = Mg(Zu, [
  bce,
  qH
]), LM = qH(), QH = De.forwardRef(
  (t, e) => {
    const { type: n, ...r } = t, i = r, a = r;
    return /* @__PURE__ */ C.jsx(PM.Provider, { scope: t.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ C.jsx(Ece, { ...a, ref: e }) : /* @__PURE__ */ C.jsx(Sce, { ...i, ref: e }) });
  }
);
QH.displayName = Zu;
var [ZH, wce] = T5(Zu), [KH, xce] = T5(
  Zu,
  { collapsible: !1 }
), Sce = De.forwardRef(
  (t, e) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: i = () => {
      },
      collapsible: a = !1,
      ...s
    } = t, [c, d] = aw({
      prop: n,
      defaultProp: r ?? "",
      onChange: i,
      caller: Zu
    });
    return /* @__PURE__ */ C.jsx(
      ZH,
      {
        scope: t.__scopeAccordion,
        value: De.useMemo(() => c ? [c] : [], [c]),
        onItemOpen: d,
        onItemClose: De.useCallback(() => a && d(""), [a, d]),
        children: /* @__PURE__ */ C.jsx(KH, { scope: t.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ C.jsx(JH, { ...s, ref: e }) })
      }
    );
  }
), Ece = De.forwardRef((t, e) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...a
  } = t, [s, c] = aw({
    prop: n,
    defaultProp: r ?? [],
    onChange: i,
    caller: Zu
  }), d = De.useCallback(
    (g) => c((m = []) => [...m, g]),
    [c]
  ), f = De.useCallback(
    (g) => c((m = []) => m.filter((b) => b !== g)),
    [c]
  );
  return /* @__PURE__ */ C.jsx(
    ZH,
    {
      scope: t.__scopeAccordion,
      value: s,
      onItemOpen: d,
      onItemClose: f,
      children: /* @__PURE__ */ C.jsx(KH, { scope: t.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ C.jsx(JH, { ...a, ref: e }) })
    }
  );
}), [_ce, O5] = T5(Zu), JH = De.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, disabled: r, dir: i, orientation: a = "vertical", ...s } = t, c = De.useRef(null), d = ho(c, e), f = yce(n), m = gce(i) === "ltr", b = UH(t.onKeyDown, (w) => {
      if (!vce.includes(w.key))
        return;
      const _ = w.target, A = f().filter(($) => !$.ref.current?.disabled), T = A.findIndex(($) => $.ref.current === _), O = A.length;
      if (T === -1)
        return;
      w.preventDefault();
      let R = T;
      const N = 0, M = O - 1, P = () => {
        R = T + 1, R > M && (R = N);
      }, z = () => {
        R = T - 1, R < N && (R = M);
      };
      switch (w.key) {
        case "Home":
          R = N;
          break;
        case "End":
          R = M;
          break;
        case "ArrowRight":
          a === "horizontal" && (m ? P() : z());
          break;
        case "ArrowDown":
          a === "vertical" && P();
          break;
        case "ArrowLeft":
          a === "horizontal" && (m ? z() : P());
          break;
        case "ArrowUp":
          a === "vertical" && z();
          break;
      }
      const F = R % O;
      A[F].ref.current?.focus();
    });
    return /* @__PURE__ */ C.jsx(
      _ce,
      {
        scope: n,
        disabled: r,
        direction: i,
        orientation: a,
        children: /* @__PURE__ */ C.jsx(PM.Slot, { scope: n, children: /* @__PURE__ */ C.jsx(
          Xa.div,
          {
            ...s,
            "data-orientation": a,
            ref: d,
            onKeyDown: r ? void 0 : b
          }
        ) })
      }
    );
  }
), lT = "AccordionItem", [Ace, BM] = T5(lT), eq = De.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, value: r, ...i } = t, a = O5(lT, n), s = wce(lT, n), c = LM(n), d = uE(), f = r && s.value.includes(r) || !1, g = a.disabled || t.disabled;
    return /* @__PURE__ */ C.jsx(
      Ace,
      {
        scope: n,
        open: f,
        disabled: g,
        triggerId: d,
        children: /* @__PURE__ */ C.jsx(
          fce,
          {
            "data-orientation": a.orientation,
            "data-state": oq(f),
            ...c,
            ...i,
            ref: e,
            disabled: g,
            open: f,
            onOpenChange: (m) => {
              m ? s.onItemOpen(r) : s.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
eq.displayName = lT;
var tq = "AccordionHeader", nq = De.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, i = O5(Zu, n), a = BM(tq, n);
    return /* @__PURE__ */ C.jsx(
      Xa.h3,
      {
        "data-orientation": i.orientation,
        "data-state": oq(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
nq.displayName = tq;
var u8 = "AccordionTrigger", rq = De.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, i = O5(Zu, n), a = BM(u8, n), s = xce(u8, n), c = LM(n);
    return /* @__PURE__ */ C.jsx(PM.ItemSlot, { scope: n, children: /* @__PURE__ */ C.jsx(
      hce,
      {
        "aria-disabled": a.open && !s.collapsible || void 0,
        "data-orientation": i.orientation,
        id: a.triggerId,
        ...c,
        ...r,
        ref: e
      }
    ) });
  }
);
rq.displayName = u8;
var iq = "AccordionContent", aq = De.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, i = O5(Zu, n), a = BM(iq, n), s = LM(n);
    return /* @__PURE__ */ C.jsx(
      pce,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": i.orientation,
        ...s,
        ...r,
        ref: e,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...t.style
        }
      }
    );
  }
);
aq.displayName = iq;
function oq(t) {
  return t ? "open" : "closed";
}
var Cce = QH, Tce = eq, Oce = nq, sq = rq, lq = aq;
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rce = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), cq = (...t) => t.filter((e, n, r) => !!e && r.indexOf(e) === n).join(" ");
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Dce = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nce = I.forwardRef(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: a,
    iconNode: s,
    ...c
  }, d) => I.createElement(
    "svg",
    {
      ref: d,
      ...Dce,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: r ? Number(n) * 24 / Number(e) : n,
      className: cq("lucide", i),
      ...c
    },
    [
      ...s.map(([f, g]) => I.createElement(f, g)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zM = (t, e) => {
  const n = I.forwardRef(
    ({ className: r, ...i }, a) => I.createElement(Nce, {
      ref: a,
      iconNode: e,
      className: cq(`lucide-${Rce(t)}`, r),
      ...i
    })
  );
  return n.displayName = `${t}`, n;
};
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mce = zM("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ice = zM("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kce = zM("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
function uq(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t)) {
      var i = t.length;
      for (e = 0; e < i; e++)
        t[e] && (n = uq(t[e])) && (r && (r += " "), r += n);
    } else
      for (n in t)
        t[n] && (r && (r += " "), r += n);
  return r;
}
function Xc() {
  for (var t, e, n = 0, r = "", i = arguments.length; n < i; n++)
    (t = arguments[n]) && (e = uq(t)) && (r && (r += " "), r += e);
  return r;
}
const FM = "-", jce = (t) => {
  const e = Lce(t), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = t;
  return {
    getClassGroupId: (s) => {
      const c = s.split(FM);
      return c[0] === "" && c.length !== 1 && c.shift(), dq(c, e) || Pce(s);
    },
    getConflictingClassGroupIds: (s, c) => {
      const d = n[s] || [];
      return c && r[s] ? [...d, ...r[s]] : d;
    }
  };
}, dq = (t, e) => {
  if (t.length === 0)
    return e.classGroupId;
  const n = t[0], r = e.nextPart.get(n), i = r ? dq(t.slice(1), r) : void 0;
  if (i)
    return i;
  if (e.validators.length === 0)
    return;
  const a = t.join(FM);
  return e.validators.find(({
    validator: s
  }) => s(a))?.classGroupId;
}, sL = /^\[(.+)\]$/, Pce = (t) => {
  if (sL.test(t)) {
    const e = sL.exec(t)[1], n = e?.substring(0, e.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Lce = (t) => {
  const {
    theme: e,
    prefix: n
  } = t, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return zce(Object.entries(t.classGroups), n).forEach(([a, s]) => {
    d8(s, r, a, e);
  }), r;
}, d8 = (t, e, n, r) => {
  t.forEach((i) => {
    if (typeof i == "string") {
      const a = i === "" ? e : lL(e, i);
      a.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (Bce(i)) {
        d8(i(r), e, n, r);
        return;
      }
      e.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([a, s]) => {
      d8(s, lL(e, a), n, r);
    });
  });
}, lL = (t, e) => {
  let n = t;
  return e.split(FM).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Bce = (t) => t.isThemeGetter, zce = (t, e) => e ? t.map(([n, r]) => {
  const i = r.map((a) => typeof a == "string" ? e + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([s, c]) => [e + s, c])) : a);
  return [n, i];
}) : t, Fce = (t) => {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (a, s) => {
    n.set(a, s), e++, e > t && (e = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return i(a, s), s;
    },
    set(a, s) {
      n.has(a) ? n.set(a, s) : i(a, s);
    }
  };
}, fq = "!", Vce = (t) => {
  const {
    separator: e,
    experimentalParseClassName: n
  } = t, r = e.length === 1, i = e[0], a = e.length, s = (c) => {
    const d = [];
    let f = 0, g = 0, m;
    for (let T = 0; T < c.length; T++) {
      let O = c[T];
      if (f === 0) {
        if (O === i && (r || c.slice(T, T + a) === e)) {
          d.push(c.slice(g, T)), g = T + a;
          continue;
        }
        if (O === "/") {
          m = T;
          continue;
        }
      }
      O === "[" ? f++ : O === "]" && f--;
    }
    const b = d.length === 0 ? c : c.substring(g), w = b.startsWith(fq), _ = w ? b.substring(1) : b, A = m && m > g ? m - g : void 0;
    return {
      modifiers: d,
      hasImportantModifier: w,
      baseClassName: _,
      maybePostfixModifierPosition: A
    };
  };
  return n ? (c) => n({
    className: c,
    parseClassName: s
  }) : s;
}, Uce = (t) => {
  if (t.length <= 1)
    return t;
  const e = [];
  let n = [];
  return t.forEach((r) => {
    r[0] === "[" ? (e.push(...n.sort(), r), n = []) : n.push(r);
  }), e.push(...n.sort()), e;
}, $ce = (t) => ({
  cache: Fce(t.cacheSize),
  parseClassName: Vce(t),
  ...jce(t)
}), Hce = /\s+/, qce = (t, e) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = e, a = [], s = t.trim().split(Hce);
  let c = "";
  for (let d = s.length - 1; d >= 0; d -= 1) {
    const f = s[d], {
      modifiers: g,
      hasImportantModifier: m,
      baseClassName: b,
      maybePostfixModifierPosition: w
    } = n(f);
    let _ = !!w, A = r(_ ? b.substring(0, w) : b);
    if (!A) {
      if (!_) {
        c = f + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (A = r(b), !A) {
        c = f + (c.length > 0 ? " " + c : c);
        continue;
      }
      _ = !1;
    }
    const T = Uce(g).join(":"), O = m ? T + fq : T, R = O + A;
    if (a.includes(R))
      continue;
    a.push(R);
    const N = i(A, _);
    for (let M = 0; M < N.length; ++M) {
      const P = N[M];
      a.push(O + P);
    }
    c = f + (c.length > 0 ? " " + c : c);
  }
  return c;
};
function Gce() {
  let t = 0, e, n, r = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (n = hq(e)) && (r && (r += " "), r += n);
  return r;
}
const hq = (t) => {
  if (typeof t == "string")
    return t;
  let e, n = "";
  for (let r = 0; r < t.length; r++)
    t[r] && (e = hq(t[r])) && (n && (n += " "), n += e);
  return n;
};
function cL(t, ...e) {
  let n, r, i, a = s;
  function s(d) {
    const f = e.reduce((g, m) => m(g), t());
    return n = $ce(f), r = n.cache.get, i = n.cache.set, a = c, c(d);
  }
  function c(d) {
    const f = r(d);
    if (f)
      return f;
    const g = qce(d, n);
    return i(d, g), g;
  }
  return function() {
    return a(Gce.apply(null, arguments));
  };
}
const pi = (t) => {
  const e = (n) => n[t] || [];
  return e.isThemeGetter = !0, e;
}, pq = /^\[(?:([a-z-]+):)?(.+)\]$/i, Yce = /^\d+\/\d+$/, Xce = /* @__PURE__ */ new Set(["px", "full", "screen"]), Wce = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Qce = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Zce = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Kce = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Jce = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, bh = (t) => Mb(t) || Xce.has(t) || Yce.test(t), v0 = (t) => ow(t, "length", sue), Mb = (t) => !!t && !Number.isNaN(Number(t)), h6 = (t) => ow(t, "number", Mb), AS = (t) => !!t && Number.isInteger(Number(t)), eue = (t) => t.endsWith("%") && Mb(t.slice(0, -1)), An = (t) => pq.test(t), y0 = (t) => Wce.test(t), tue = /* @__PURE__ */ new Set(["length", "size", "percentage"]), nue = (t) => ow(t, tue, mq), rue = (t) => ow(t, "position", mq), iue = /* @__PURE__ */ new Set(["image", "url"]), aue = (t) => ow(t, iue, cue), oue = (t) => ow(t, "", lue), CS = () => !0, ow = (t, e, n) => {
  const r = pq.exec(t);
  return r ? r[1] ? typeof e == "string" ? r[1] === e : e.has(r[1]) : n(r[2]) : !1;
}, sue = (t) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Qce.test(t) && !Zce.test(t)
), mq = () => !1, lue = (t) => Kce.test(t), cue = (t) => Jce.test(t), uL = () => {
  const t = pi("colors"), e = pi("spacing"), n = pi("blur"), r = pi("brightness"), i = pi("borderColor"), a = pi("borderRadius"), s = pi("borderSpacing"), c = pi("borderWidth"), d = pi("contrast"), f = pi("grayscale"), g = pi("hueRotate"), m = pi("invert"), b = pi("gap"), w = pi("gradientColorStops"), _ = pi("gradientColorStopPositions"), A = pi("inset"), T = pi("margin"), O = pi("opacity"), R = pi("padding"), N = pi("saturate"), M = pi("scale"), P = pi("sepia"), z = pi("skew"), F = pi("space"), $ = pi("translate"), G = () => ["auto", "contain", "none"], H = () => ["auto", "hidden", "clip", "visible", "scroll"], Z = () => ["auto", An, e], V = () => [An, e], Y = () => ["", bh, v0], ee = () => ["auto", Mb, An], K = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], U = () => ["solid", "dashed", "dotted", "double", "none"], q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], W = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], ie = () => ["", "0", An], J = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], B = () => [Mb, An];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [CS],
      spacing: [bh, v0],
      blur: ["none", "", y0, An],
      brightness: B(),
      borderColor: [t],
      borderRadius: ["none", "", "full", y0, An],
      borderSpacing: V(),
      borderWidth: Y(),
      contrast: B(),
      grayscale: ie(),
      hueRotate: B(),
      invert: ie(),
      gap: V(),
      gradientColorStops: [t],
      gradientColorStopPositions: [eue, v0],
      inset: Z(),
      margin: Z(),
      opacity: B(),
      padding: V(),
      saturate: B(),
      scale: B(),
      sepia: ie(),
      skew: B(),
      space: V(),
      translate: V()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", An]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [y0]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": J()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": J()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...K(), An]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: H()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": H()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": H()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: G()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": G()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": G()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [A]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [A]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [A]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [A]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [A]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [A]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [A]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [A]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [A]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", AS, An]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: Z()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", An]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ie()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ie()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", AS, An]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [CS]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", AS, An]
        }, An]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": ee()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": ee()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [CS]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [AS, An]
        }, An]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": ee()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": ee()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", An]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", An]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [b]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [b]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [b]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...W()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...W(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...W(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [R]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [R]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [R]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [R]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [R]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [R]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [R]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [R]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [R]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [T]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [T]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [T]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [T]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [T]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [T]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [T]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [T]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [T]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [F]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [F]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", An, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [An, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [An, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [y0]
        }, y0]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [An, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [An, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [An, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [An, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", y0, v0]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", h6]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [CS]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", An]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Mb, h6]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", bh, An]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", An]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", An]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [O]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [O]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...U(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", bh, v0]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", bh, An]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: V()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", An]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", An]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [O]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...K(), rue]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", nue]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, aue]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [_]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [_]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [_]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [w]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [w]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [w]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [c]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [c]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [c]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [c]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [c]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [c]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [c]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [c]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [c]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [O]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...U(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [c]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [c]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [O]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: U()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...U()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [bh, An]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [bh, v0]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: Y()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [O]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [bh, v0]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", y0, oue]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [CS]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [O]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...q(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": q()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [d]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", y0, An]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [f]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [g]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [m]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [N]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [P]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [d]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [f]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [g]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [m]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [O]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [N]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [P]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", An]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: B()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", An]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: B()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", An]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [M]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [M]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [M]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [AS, An]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [$]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [$]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [z]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [z]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", An]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", An]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": V()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": V()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": V()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": V()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": V()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": V()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": V()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": V()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": V()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": V()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": V()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": V()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": V()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": V()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": V()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": V()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": V()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": V()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", An]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [bh, v0, h6]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, uue = (t, {
  cacheSize: e,
  prefix: n,
  separator: r,
  experimentalParseClassName: i,
  extend: a = {},
  override: s = {}
}) => {
  WS(t, "cacheSize", e), WS(t, "prefix", n), WS(t, "separator", r), WS(t, "experimentalParseClassName", i);
  for (const c in s)
    due(t[c], s[c]);
  for (const c in a)
    fue(t[c], a[c]);
  return t;
}, WS = (t, e, n) => {
  n !== void 0 && (t[e] = n);
}, due = (t, e) => {
  if (e)
    for (const n in e)
      WS(t, n, e[n]);
}, fue = (t, e) => {
  if (e)
    for (const n in e) {
      const r = e[n];
      r !== void 0 && (t[n] = (t[n] || []).concat(r));
    }
}, hue = (t, ...e) => typeof t == "function" ? cL(uL, t, ...e) : cL(() => uue(uL(), t), ...e), pue = "twd-", mue = {
  xs: "440px",
  sm: "575px",
  md: "767px",
  lg: "1024px",
  xl: "1200px"
}, gue = hue({
  prefix: pue
});
function un(...t) {
  return gue(Xc(t));
}
const vue = Cce, gq = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-border-b", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx(Tce, { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
gq.displayName = "AccordionItem";
const vq = I.forwardRef((t, e) => {
  const n = ve.c(12);
  let r, i, a;
  n[0] !== t ? ({
    className: i,
    children: r,
    ...a
  } = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a) : (r = n[1], i = n[2], a = n[3]);
  let s;
  n[4] !== i ? (s = un("twd-flex twd-flex-1 twd-items-center twd-justify-between twd-py-4 twd-font-bold twd-transition-all hover:twd-underline [&[data-state=open]>svg]:twd-rotate-180 twd-bg-transparent hover:twd-bg-transparent twd-p-0", i), n[4] = i, n[5] = s) : s = n[5];
  let c;
  n[6] === Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ C.jsx(Ice, { className: "twd-h-4 twd-w-4 twd-shrink-0 twd-transition-transform twd-duration-200" }), n[6] = c) : c = n[6];
  let d;
  return n[7] !== r || n[8] !== a || n[9] !== e || n[10] !== s ? (d = /* @__PURE__ */ C.jsx(Oce, { className: "twd-flex twd-m-0", children: /* @__PURE__ */ C.jsxs(sq, { ref: e, className: s, ...a, children: [
    r,
    c
  ] }) }), n[7] = r, n[8] = a, n[9] = e, n[10] = s, n[11] = d) : d = n[11], d;
});
vq.displayName = sq.displayName;
const yq = I.forwardRef((t, e) => {
  const n = ve.c(13);
  let r, i, a;
  n[0] !== t ? ({
    className: i,
    children: r,
    ...a
  } = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a) : (r = n[1], i = n[2], a = n[3]);
  let s;
  n[4] !== i ? (s = un("twd-pb-4 twd-pt-0", i), n[4] = i, n[5] = s) : s = n[5];
  let c;
  n[6] !== r || n[7] !== s ? (c = /* @__PURE__ */ C.jsx("div", { className: s, children: r }), n[6] = r, n[7] = s, n[8] = c) : c = n[8];
  let d;
  return n[9] !== a || n[10] !== e || n[11] !== c ? (d = /* @__PURE__ */ C.jsx(lq, { ref: e, className: "twd-overflow-hidden twd-text-sm twd-transition-all data-[state=closed]:twd-animate-accordion-up data-[state=open]:twd-animate-accordion-down", ...a, children: c }), n[9] = a, n[10] = e, n[11] = c, n[12] = d) : d = n[12], d;
});
yq.displayName = lq.displayName;
const yue = (t) => {
  const e = ve.c(4), {
    items: n
  } = t;
  let r;
  e[0] !== n ? (r = n.map(bue), e[0] = n, e[1] = r) : r = e[1];
  let i;
  return e[2] !== r ? (i = /* @__PURE__ */ C.jsx(vue, { type: "single", collapsible: !0, className: "w-full", children: r }), e[2] = r, e[3] = i) : i = e[3], i;
};
function bue(t) {
  return /* @__PURE__ */ C.jsxs(gq, { value: t.value, children: [
    /* @__PURE__ */ C.jsx(vq, { children: t.title }),
    /* @__PURE__ */ C.jsx(yq, { children: t.content })
  ] }, t.value);
}
function Zc(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (t?.(i), n === !1 || !i.defaultPrevented)
      return e?.(i);
  };
}
function HE(t) {
  const e = I.useRef(t);
  return I.useEffect(() => {
    e.current = t;
  }), I.useMemo(() => (...n) => e.current?.(...n), []);
}
function wue(t, e = globalThis?.document) {
  const n = HE(t);
  I.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return e.addEventListener("keydown", r, { capture: !0 }), () => e.removeEventListener("keydown", r, { capture: !0 });
  }, [n, e]);
}
var xue = "DismissableLayer", f8 = "dismissableLayer.update", Sue = "dismissableLayer.pointerDownOutside", Eue = "dismissableLayer.focusOutside", dL, bq = I.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), wq = I.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: a,
      onInteractOutside: s,
      onDismiss: c,
      ...d
    } = t, f = I.useContext(bq), [g, m] = I.useState(null), b = g?.ownerDocument ?? globalThis?.document, [, w] = I.useState({}), _ = ho(e, (F) => m(F)), A = Array.from(f.layers), [T] = [...f.layersWithOutsidePointerEventsDisabled].slice(-1), O = A.indexOf(T), R = g ? A.indexOf(g) : -1, N = f.layersWithOutsidePointerEventsDisabled.size > 0, M = R >= O, P = Cue((F) => {
      const $ = F.target, G = [...f.branches].some((H) => H.contains($));
      !M || G || (i?.(F), s?.(F), F.defaultPrevented || c?.());
    }, b), z = Tue((F) => {
      const $ = F.target;
      [...f.branches].some((H) => H.contains($)) || (a?.(F), s?.(F), F.defaultPrevented || c?.());
    }, b);
    return wue((F) => {
      R === f.layers.size - 1 && (r?.(F), !F.defaultPrevented && c && (F.preventDefault(), c()));
    }, b), I.useEffect(() => {
      if (g)
        return n && (f.layersWithOutsidePointerEventsDisabled.size === 0 && (dL = b.body.style.pointerEvents, b.body.style.pointerEvents = "none"), f.layersWithOutsidePointerEventsDisabled.add(g)), f.layers.add(g), fL(), () => {
          n && f.layersWithOutsidePointerEventsDisabled.size === 1 && (b.body.style.pointerEvents = dL);
        };
    }, [g, b, n, f]), I.useEffect(() => () => {
      g && (f.layers.delete(g), f.layersWithOutsidePointerEventsDisabled.delete(g), fL());
    }, [g, f]), I.useEffect(() => {
      const F = () => w({});
      return document.addEventListener(f8, F), () => document.removeEventListener(f8, F);
    }, []), /* @__PURE__ */ C.jsx(
      Xa.div,
      {
        ...d,
        ref: _,
        style: {
          pointerEvents: N ? M ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: Zc(t.onFocusCapture, z.onFocusCapture),
        onBlurCapture: Zc(t.onBlurCapture, z.onBlurCapture),
        onPointerDownCapture: Zc(
          t.onPointerDownCapture,
          P.onPointerDownCapture
        )
      }
    );
  }
);
wq.displayName = xue;
var _ue = "DismissableLayerBranch", Aue = I.forwardRef((t, e) => {
  const n = I.useContext(bq), r = I.useRef(null), i = ho(e, r);
  return I.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ C.jsx(Xa.div, { ...t, ref: i });
});
Aue.displayName = _ue;
function Cue(t, e = globalThis?.document) {
  const n = HE(t), r = I.useRef(!1), i = I.useRef(() => {
  });
  return I.useEffect(() => {
    const a = (c) => {
      if (c.target && !r.current) {
        let d = function() {
          xq(
            Sue,
            n,
            f,
            { discrete: !0 }
          );
        };
        const f = { originalEvent: c };
        c.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = d, e.addEventListener("click", i.current, { once: !0 })) : d();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      e.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(s), e.removeEventListener("pointerdown", a), e.removeEventListener("click", i.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Tue(t, e = globalThis?.document) {
  const n = HE(t), r = I.useRef(!1);
  return I.useEffect(() => {
    const i = (a) => {
      a.target && !r.current && xq(Eue, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [e, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function fL() {
  const t = new CustomEvent(f8);
  document.dispatchEvent(t);
}
function xq(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, a = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && i.addEventListener(t, e, { once: !0 }), r ? rce(i, a) : i.dispatchEvent(a);
}
var Oue = Symbol.for("react.lazy"), cT = g_[" use ".trim().toString()];
function Rue(t) {
  return typeof t == "object" && t !== null && "then" in t;
}
function Sq(t) {
  return t != null && typeof t == "object" && "$$typeof" in t && t.$$typeof === Oue && "_payload" in t && Rue(t._payload);
}
// @__NO_SIDE_EFFECTS__
function Due(t) {
  const e = /* @__PURE__ */ Nue(t), n = I.forwardRef((r, i) => {
    let { children: a, ...s } = r;
    Sq(a) && typeof cT == "function" && (a = cT(a._payload));
    const c = I.Children.toArray(a), d = c.find(Iue);
    if (d) {
      const f = d.props.children, g = c.map((m) => m === d ? I.Children.count(f) > 1 ? I.Children.only(null) : I.isValidElement(f) ? f.props.children : null : m);
      return /* @__PURE__ */ C.jsx(e, { ...s, ref: i, children: I.isValidElement(f) ? I.cloneElement(f, void 0, g) : null });
    }
    return /* @__PURE__ */ C.jsx(e, { ...s, ref: i, children: a });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Nue(t) {
  const e = I.forwardRef((n, r) => {
    let { children: i, ...a } = n;
    if (Sq(i) && typeof cT == "function" && (i = cT(i._payload)), I.isValidElement(i)) {
      const s = jue(i), c = kue(a, i.props);
      return i.type !== I.Fragment && (c.ref = r ? NM(r, s) : s), I.cloneElement(i, c);
    }
    return I.Children.count(i) > 1 ? I.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var Mue = Symbol("radix.slottable");
function Iue(t) {
  return I.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === Mue;
}
function kue(t, e) {
  const n = { ...e };
  for (const r in e) {
    const i = t[r], a = e[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...c) => {
      const d = a(...c);
      return i(...c), d;
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...a } : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function jue(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var Pue = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Lue = Pue.reduce((t, e) => {
  const n = /* @__PURE__ */ Due(`Primitive.${e}`), r = I.forwardRef((i, a) => {
    const { asChild: s, ...c } = i, d = s ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ C.jsx(d, { ...c, ref: a });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), p6 = "focusScope.autoFocusOnMount", m6 = "focusScope.autoFocusOnUnmount", hL = { bubbles: !1, cancelable: !0 }, Bue = "FocusScope", Eq = I.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: a,
    ...s
  } = t, [c, d] = I.useState(null), f = HE(i), g = HE(a), m = I.useRef(null), b = ho(e, (A) => d(A)), w = I.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  I.useEffect(() => {
    if (r) {
      let A = function(N) {
        if (w.paused || !c)
          return;
        const M = N.target;
        c.contains(M) ? m.current = M : S0(m.current, { select: !0 });
      }, T = function(N) {
        if (w.paused || !c)
          return;
        const M = N.relatedTarget;
        M !== null && (c.contains(M) || S0(m.current, { select: !0 }));
      }, O = function(N) {
        if (document.activeElement === document.body)
          for (const P of N)
            P.removedNodes.length > 0 && S0(c);
      };
      document.addEventListener("focusin", A), document.addEventListener("focusout", T);
      const R = new MutationObserver(O);
      return c && R.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", A), document.removeEventListener("focusout", T), R.disconnect();
      };
    }
  }, [r, c, w.paused]), I.useEffect(() => {
    if (c) {
      mL.add(w);
      const A = document.activeElement;
      if (!c.contains(A)) {
        const O = new CustomEvent(p6, hL);
        c.addEventListener(p6, f), c.dispatchEvent(O), O.defaultPrevented || (zue(Hue(_q(c)), { select: !0 }), document.activeElement === A && S0(c));
      }
      return () => {
        c.removeEventListener(p6, f), setTimeout(() => {
          const O = new CustomEvent(m6, hL);
          c.addEventListener(m6, g), c.dispatchEvent(O), O.defaultPrevented || S0(A ?? document.body, { select: !0 }), c.removeEventListener(m6, g), mL.remove(w);
        }, 0);
      };
    }
  }, [c, f, g, w]);
  const _ = I.useCallback(
    (A) => {
      if (!n && !r || w.paused)
        return;
      const T = A.key === "Tab" && !A.altKey && !A.ctrlKey && !A.metaKey, O = document.activeElement;
      if (T && O) {
        const R = A.currentTarget, [N, M] = Fue(R);
        N && M ? !A.shiftKey && O === M ? (A.preventDefault(), n && S0(N, { select: !0 })) : A.shiftKey && O === N && (A.preventDefault(), n && S0(M, { select: !0 })) : O === R && A.preventDefault();
      }
    },
    [n, r, w.paused]
  );
  return /* @__PURE__ */ C.jsx(Lue.div, { tabIndex: -1, ...s, ref: b, onKeyDown: _ });
});
Eq.displayName = Bue;
function zue(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (S0(r, { select: e }), document.activeElement !== n)
      return;
}
function Fue(t) {
  const e = _q(t), n = pL(e, t), r = pL(e.reverse(), t);
  return [n, r];
}
function _q(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function pL(t, e) {
  for (const n of t)
    if (!Vue(n, { upTo: e }))
      return n;
}
function Vue(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function Uue(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function S0(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && Uue(t) && e && t.select();
  }
}
var mL = $ue();
function $ue() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && n?.pause(), t = gL(t, e), t.unshift(e);
    },
    remove(e) {
      t = gL(t, e), t[0]?.resume();
    }
  };
}
function gL(t, e) {
  const n = [...t], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function Hue(t) {
  return t.filter((e) => e.tagName !== "A");
}
var que = "Portal", Aq = I.forwardRef((t, e) => {
  const { container: n, ...r } = t, [i, a] = I.useState(!1);
  Mh(() => a(!0), []);
  const s = n || i && globalThis?.document?.body;
  return s ? $H.createPortal(/* @__PURE__ */ C.jsx(Xa.div, { ...r, ref: e }), s) : null;
});
Aq.displayName = que;
function Gue(t, e) {
  return I.useReducer((n, r) => e[n][r] ?? n, t);
}
var w_ = (t) => {
  const { present: e, children: n } = t, r = Yue(e), i = typeof n == "function" ? n({ present: r.isPresent }) : I.Children.only(n), a = ho(r.ref, Xue(i));
  return typeof n == "function" || r.isPresent ? I.cloneElement(i, { ref: a }) : null;
};
w_.displayName = "Presence";
function Yue(t) {
  const [e, n] = I.useState(), r = I.useRef(null), i = I.useRef(t), a = I.useRef("none"), s = t ? "mounted" : "unmounted", [c, d] = Gue(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return I.useEffect(() => {
    const f = xC(r.current);
    a.current = c === "mounted" ? f : "none";
  }, [c]), Mh(() => {
    const f = r.current, g = i.current;
    if (g !== t) {
      const b = a.current, w = xC(f);
      t ? d("MOUNT") : w === "none" || f?.display === "none" ? d("UNMOUNT") : d(g && b !== w ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [t, d]), Mh(() => {
    if (e) {
      let f;
      const g = e.ownerDocument.defaultView ?? window, m = (w) => {
        const A = xC(r.current).includes(CSS.escape(w.animationName));
        if (w.target === e && A && (d("ANIMATION_END"), !i.current)) {
          const T = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", f = g.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = T);
          });
        }
      }, b = (w) => {
        w.target === e && (a.current = xC(r.current));
      };
      return e.addEventListener("animationstart", b), e.addEventListener("animationcancel", m), e.addEventListener("animationend", m), () => {
        g.clearTimeout(f), e.removeEventListener("animationstart", b), e.removeEventListener("animationcancel", m), e.removeEventListener("animationend", m);
      };
    } else
      d("ANIMATION_END");
  }, [e, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: I.useCallback((f) => {
      r.current = f ? getComputedStyle(f) : null, n(f);
    }, [])
  };
}
function xC(t) {
  return t?.animationName || "none";
}
function Xue(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var g6 = 0;
function Wue() {
  I.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? vL()), document.body.insertAdjacentElement("beforeend", t[1] ?? vL()), g6++, () => {
      g6 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), g6--;
    };
  }, []);
}
function vL() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var ol = function() {
  return ol = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, ol.apply(this, arguments);
};
function Cq(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function Que(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = e.length, a; r < i; r++)
      (a || !(r in e)) && (a || (a = Array.prototype.slice.call(e, 0, r)), a[r] = e[r]);
  return t.concat(a || Array.prototype.slice.call(e));
}
var i4 = "right-scroll-bar-position", a4 = "width-before-scroll-bar", Zue = "with-scroll-bars-hidden", Kue = "--removed-body-scroll-bar-size";
function v6(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function Jue(t, e) {
  var n = I.useState(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
var ede = typeof window < "u" ? I.useLayoutEffect : I.useEffect, yL = /* @__PURE__ */ new WeakMap();
function tde(t, e) {
  var n = Jue(e || null, function(r) {
    return t.forEach(function(i) {
      return v6(i, r);
    });
  });
  return ede(function() {
    var r = yL.get(n);
    if (r) {
      var i = new Set(r), a = new Set(t), s = n.current;
      i.forEach(function(c) {
        a.has(c) || v6(c, null);
      }), a.forEach(function(c) {
        i.has(c) || v6(c, s);
      });
    }
    yL.set(n, t);
  }, [t]), n;
}
function nde(t) {
  return t;
}
function rde(t, e) {
  e === void 0 && (e = nde);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(a) {
      var s = e(a, r);
      return n.push(s), function() {
        n = n.filter(function(c) {
          return c !== s;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(a);
      }
      n = {
        push: function(c) {
          return a(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var s = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(a), s = n;
      }
      var d = function() {
        var g = s;
        s = [], g.forEach(a);
      }, f = function() {
        return Promise.resolve().then(d);
      };
      f(), n = {
        push: function(g) {
          s.push(g), f();
        },
        filter: function(g) {
          return s = s.filter(g), n;
        }
      };
    }
  };
  return i;
}
function ide(t) {
  t === void 0 && (t = {});
  var e = rde(null);
  return e.options = ol({ async: !0, ssr: !1 }, t), e;
}
var Tq = function(t) {
  var e = t.sideCar, n = Cq(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return I.createElement(r, ol({}, n));
};
Tq.isSideCarExport = !0;
function ade(t, e) {
  return t.useMedium(e), Tq;
}
var Oq = ide(), y6 = function() {
}, R5 = I.forwardRef(function(t, e) {
  var n = I.useRef(null), r = I.useState({
    onScrollCapture: y6,
    onWheelCapture: y6,
    onTouchMoveCapture: y6
  }), i = r[0], a = r[1], s = t.forwardProps, c = t.children, d = t.className, f = t.removeScrollBar, g = t.enabled, m = t.shards, b = t.sideCar, w = t.noRelative, _ = t.noIsolation, A = t.inert, T = t.allowPinchZoom, O = t.as, R = O === void 0 ? "div" : O, N = t.gapMode, M = Cq(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), P = b, z = tde([n, e]), F = ol(ol({}, M), i);
  return I.createElement(
    I.Fragment,
    null,
    g && I.createElement(P, { sideCar: Oq, removeScrollBar: f, shards: m, noRelative: w, noIsolation: _, inert: A, setCallbacks: a, allowPinchZoom: !!T, lockRef: n, gapMode: N }),
    s ? I.cloneElement(I.Children.only(c), ol(ol({}, F), { ref: z })) : I.createElement(R, ol({}, F, { className: d, ref: z }), c)
  );
});
R5.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
R5.classNames = {
  fullWidth: a4,
  zeroRight: i4
};
var bL, ode = function() {
  if (bL)
    return bL;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function sde() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = ode();
  return e && t.setAttribute("nonce", e), t;
}
function lde(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function cde(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var ude = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = sde()) && (lde(e, n), cde(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, dde = function() {
  var t = ude();
  return function(e, n) {
    I.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, Rq = function() {
  var t = dde(), e = function(n) {
    var r = n.styles, i = n.dynamic;
    return t(r, i), null;
  };
  return e;
}, fde = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, b6 = function(t) {
  return parseInt(t || "", 10) || 0;
}, hde = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], i = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [b6(n), b6(r), b6(i)];
}, pde = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return fde;
  var e = hde(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, mde = Rq(), Ib = "data-scroll-locked", gde = function(t, e, n, r) {
  var i = t.left, a = t.top, s = t.right, c = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Zue, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(Ib, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(i4, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(a4, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(i4, " .").concat(i4, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(a4, " .").concat(a4, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Ib, `] {
    `).concat(Kue, ": ").concat(c, `px;
  }
`);
}, wL = function() {
  var t = parseInt(document.body.getAttribute(Ib) || "0", 10);
  return isFinite(t) ? t : 0;
}, vde = function() {
  I.useEffect(function() {
    return document.body.setAttribute(Ib, (wL() + 1).toString()), function() {
      var t = wL() - 1;
      t <= 0 ? document.body.removeAttribute(Ib) : document.body.setAttribute(Ib, t.toString());
    };
  }, []);
}, yde = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, i = r === void 0 ? "margin" : r;
  vde();
  var a = I.useMemo(function() {
    return pde(i);
  }, [i]);
  return I.createElement(mde, { styles: gde(a, !e, i, n ? "" : "!important") });
}, h8 = !1;
if (typeof window < "u")
  try {
    var SC = Object.defineProperty({}, "passive", {
      get: function() {
        return h8 = !0, !0;
      }
    });
    window.addEventListener("test", SC, SC), window.removeEventListener("test", SC, SC);
  } catch {
    h8 = !1;
  }
var ob = h8 ? { passive: !1 } : !1, bde = function(t) {
  return t.tagName === "TEXTAREA";
}, Dq = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !bde(t) && n[e] === "visible")
  );
}, wde = function(t) {
  return Dq(t, "overflowY");
}, xde = function(t) {
  return Dq(t, "overflowX");
}, xL = function(t, e) {
  var n = e.ownerDocument, r = e;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = Nq(t, r);
    if (i) {
      var a = Mq(t, r), s = a[1], c = a[2];
      if (s > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Sde = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, Ede = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, Nq = function(t, e) {
  return t === "v" ? wde(e) : xde(e);
}, Mq = function(t, e) {
  return t === "v" ? Sde(e) : Ede(e);
}, _de = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, Ade = function(t, e, n, r, i) {
  var a = _de(t, window.getComputedStyle(e).direction), s = a * r, c = n.target, d = e.contains(c), f = !1, g = s > 0, m = 0, b = 0;
  do {
    if (!c)
      break;
    var w = Mq(t, c), _ = w[0], A = w[1], T = w[2], O = A - T - a * _;
    (_ || O) && Nq(t, c) && (m += O, b += _);
    var R = c.parentNode;
    c = R && R.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? R.host : R;
  } while (
    // portaled content
    !d && c !== document.body || // self content
    d && (e.contains(c) || e === c)
  );
  return (g && (i && Math.abs(m) < 1 || !i && s > m) || !g && (i && Math.abs(b) < 1 || !i && -s > b)) && (f = !0), f;
}, EC = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, SL = function(t) {
  return [t.deltaX, t.deltaY];
}, EL = function(t) {
  return t && "current" in t ? t.current : t;
}, Cde = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, Tde = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, Ode = 0, sb = [];
function Rde(t) {
  var e = I.useRef([]), n = I.useRef([0, 0]), r = I.useRef(), i = I.useState(Ode++)[0], a = I.useState(Rq)[0], s = I.useRef(t);
  I.useEffect(function() {
    s.current = t;
  }, [t]), I.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var A = Que([t.lockRef.current], (t.shards || []).map(EL), !0).filter(Boolean);
      return A.forEach(function(T) {
        return T.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), A.forEach(function(T) {
          return T.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var c = I.useCallback(function(A, T) {
    if ("touches" in A && A.touches.length === 2 || A.type === "wheel" && A.ctrlKey)
      return !s.current.allowPinchZoom;
    var O = EC(A), R = n.current, N = "deltaX" in A ? A.deltaX : R[0] - O[0], M = "deltaY" in A ? A.deltaY : R[1] - O[1], P, z = A.target, F = Math.abs(N) > Math.abs(M) ? "h" : "v";
    if ("touches" in A && F === "h" && z.type === "range")
      return !1;
    var $ = window.getSelection(), G = $ && $.anchorNode, H = G ? G === z || G.contains(z) : !1;
    if (H)
      return !1;
    var Z = xL(F, z);
    if (!Z)
      return !0;
    if (Z ? P = F : (P = F === "v" ? "h" : "v", Z = xL(F, z)), !Z)
      return !1;
    if (!r.current && "changedTouches" in A && (N || M) && (r.current = P), !P)
      return !0;
    var V = r.current || P;
    return Ade(V, T, A, V === "h" ? N : M, !0);
  }, []), d = I.useCallback(function(A) {
    var T = A;
    if (!(!sb.length || sb[sb.length - 1] !== a)) {
      var O = "deltaY" in T ? SL(T) : EC(T), R = e.current.filter(function(P) {
        return P.name === T.type && (P.target === T.target || T.target === P.shadowParent) && Cde(P.delta, O);
      })[0];
      if (R && R.should) {
        T.cancelable && T.preventDefault();
        return;
      }
      if (!R) {
        var N = (s.current.shards || []).map(EL).filter(Boolean).filter(function(P) {
          return P.contains(T.target);
        }), M = N.length > 0 ? c(T, N[0]) : !s.current.noIsolation;
        M && T.cancelable && T.preventDefault();
      }
    }
  }, []), f = I.useCallback(function(A, T, O, R) {
    var N = { name: A, delta: T, target: O, should: R, shadowParent: Dde(O) };
    e.current.push(N), setTimeout(function() {
      e.current = e.current.filter(function(M) {
        return M !== N;
      });
    }, 1);
  }, []), g = I.useCallback(function(A) {
    n.current = EC(A), r.current = void 0;
  }, []), m = I.useCallback(function(A) {
    f(A.type, SL(A), A.target, c(A, t.lockRef.current));
  }, []), b = I.useCallback(function(A) {
    f(A.type, EC(A), A.target, c(A, t.lockRef.current));
  }, []);
  I.useEffect(function() {
    return sb.push(a), t.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: b
    }), document.addEventListener("wheel", d, ob), document.addEventListener("touchmove", d, ob), document.addEventListener("touchstart", g, ob), function() {
      sb = sb.filter(function(A) {
        return A !== a;
      }), document.removeEventListener("wheel", d, ob), document.removeEventListener("touchmove", d, ob), document.removeEventListener("touchstart", g, ob);
    };
  }, []);
  var w = t.removeScrollBar, _ = t.inert;
  return I.createElement(
    I.Fragment,
    null,
    _ ? I.createElement(a, { styles: Tde(i) }) : null,
    w ? I.createElement(yde, { noRelative: t.noRelative, gapMode: t.gapMode }) : null
  );
}
function Dde(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const Nde = ade(Oq, Rde);
var Iq = I.forwardRef(function(t, e) {
  return I.createElement(R5, ol({}, t, { ref: e, sideCar: Nde }));
});
Iq.classNames = R5.classNames;
const Mde = Iq;
var Ide = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, lb = /* @__PURE__ */ new WeakMap(), _C = /* @__PURE__ */ new WeakMap(), AC = {}, w6 = 0, kq = function(t) {
  return t && (t.host || kq(t.parentNode));
}, kde = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = kq(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, jde = function(t, e, n, r) {
  var i = kde(e, Array.isArray(t) ? t : [t]);
  AC[n] || (AC[n] = /* @__PURE__ */ new WeakMap());
  var a = AC[n], s = [], c = /* @__PURE__ */ new Set(), d = new Set(i), f = function(m) {
    !m || c.has(m) || (c.add(m), f(m.parentNode));
  };
  i.forEach(f);
  var g = function(m) {
    !m || d.has(m) || Array.prototype.forEach.call(m.children, function(b) {
      if (c.has(b))
        g(b);
      else
        try {
          var w = b.getAttribute(r), _ = w !== null && w !== "false", A = (lb.get(b) || 0) + 1, T = (a.get(b) || 0) + 1;
          lb.set(b, A), a.set(b, T), s.push(b), A === 1 && _ && _C.set(b, !0), T === 1 && b.setAttribute(n, "true"), _ || b.setAttribute(r, "true");
        } catch (O) {
          console.error("aria-hidden: cannot operate on ", b, O);
        }
    });
  };
  return g(e), c.clear(), w6++, function() {
    s.forEach(function(m) {
      var b = lb.get(m) - 1, w = a.get(m) - 1;
      lb.set(m, b), a.set(m, w), b || (_C.has(m) || m.removeAttribute(r), _C.delete(m)), w || m.removeAttribute(n);
    }), w6--, w6 || (lb = /* @__PURE__ */ new WeakMap(), lb = /* @__PURE__ */ new WeakMap(), _C = /* @__PURE__ */ new WeakMap(), AC = {});
  };
}, jq = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), i = e || Ide(t);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), jde(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, D5 = "Dialog", [Pq, Lq] = Mg(D5), [Pde, Ku] = Pq(D5), Bq = (t) => {
  const {
    __scopeDialog: e,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    modal: s = !0
  } = t, c = I.useRef(null), d = I.useRef(null), [f, g] = aw({
    prop: r,
    defaultProp: i ?? !1,
    onChange: a,
    caller: D5
  });
  return /* @__PURE__ */ C.jsx(
    Pde,
    {
      scope: e,
      triggerRef: c,
      contentRef: d,
      contentId: uE(),
      titleId: uE(),
      descriptionId: uE(),
      open: f,
      onOpenChange: g,
      onOpenToggle: I.useCallback(() => g((m) => !m), [g]),
      modal: s,
      children: n
    }
  );
};
Bq.displayName = D5;
var zq = "DialogTrigger", Fq = I.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Ku(zq, n), a = ho(e, i.triggerRef);
    return /* @__PURE__ */ C.jsx(
      Xa.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": $M(i.open),
        ...r,
        ref: a,
        onClick: Zc(t.onClick, i.onOpenToggle)
      }
    );
  }
);
Fq.displayName = zq;
var VM = "DialogPortal", [Lde, Vq] = Pq(VM, {
  forceMount: void 0
}), Uq = (t) => {
  const { __scopeDialog: e, forceMount: n, children: r, container: i } = t, a = Ku(VM, e);
  return /* @__PURE__ */ C.jsx(Lde, { scope: e, forceMount: n, children: I.Children.map(r, (s) => /* @__PURE__ */ C.jsx(w_, { present: n || a.open, children: /* @__PURE__ */ C.jsx(Aq, { asChild: !0, container: i, children: s }) })) });
};
Uq.displayName = VM;
var uT = "DialogOverlay", $q = I.forwardRef(
  (t, e) => {
    const n = Vq(uT, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, a = Ku(uT, t.__scopeDialog);
    return a.modal ? /* @__PURE__ */ C.jsx(w_, { present: r || a.open, children: /* @__PURE__ */ C.jsx(zde, { ...i, ref: e }) }) : null;
  }
);
$q.displayName = uT;
var Bde = /* @__PURE__ */ $E("DialogOverlay.RemoveScroll"), zde = I.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Ku(uT, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ C.jsx(Mde, { as: Bde, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ C.jsx(
        Xa.div,
        {
          "data-state": $M(i.open),
          ...r,
          ref: e,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), yg = "DialogContent", Hq = I.forwardRef(
  (t, e) => {
    const n = Vq(yg, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, a = Ku(yg, t.__scopeDialog);
    return /* @__PURE__ */ C.jsx(w_, { present: r || a.open, children: a.modal ? /* @__PURE__ */ C.jsx(Fde, { ...i, ref: e }) : /* @__PURE__ */ C.jsx(Vde, { ...i, ref: e }) });
  }
);
Hq.displayName = yg;
var Fde = I.forwardRef(
  (t, e) => {
    const n = Ku(yg, t.__scopeDialog), r = I.useRef(null), i = ho(e, n.contentRef, r);
    return I.useEffect(() => {
      const a = r.current;
      if (a)
        return jq(a);
    }, []), /* @__PURE__ */ C.jsx(
      qq,
      {
        ...t,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Zc(t.onCloseAutoFocus, (a) => {
          a.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Zc(t.onPointerDownOutside, (a) => {
          const s = a.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || c) && a.preventDefault();
        }),
        onFocusOutside: Zc(
          t.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), Vde = I.forwardRef(
  (t, e) => {
    const n = Ku(yg, t.__scopeDialog), r = I.useRef(!1), i = I.useRef(!1);
    return /* @__PURE__ */ C.jsx(
      qq,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          t.onCloseAutoFocus?.(a), a.defaultPrevented || (r.current || n.triggerRef.current?.focus(), a.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (a) => {
          t.onInteractOutside?.(a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const s = a.target;
          n.triggerRef.current?.contains(s) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
        }
      }
    );
  }
), qq = I.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...s } = t, c = Ku(yg, n), d = I.useRef(null), f = ho(e, d);
    return Wue(), /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(
        Eq,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ C.jsx(
            wq,
            {
              role: "dialog",
              id: c.contentId,
              "aria-describedby": c.descriptionId,
              "aria-labelledby": c.titleId,
              "data-state": $M(c.open),
              ...s,
              ref: f,
              onDismiss: () => c.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
        /* @__PURE__ */ C.jsx($de, { titleId: c.titleId }),
        /* @__PURE__ */ C.jsx(qde, { contentRef: d, descriptionId: c.descriptionId })
      ] })
    ] });
  }
), UM = "DialogTitle", Gq = I.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Ku(UM, n);
    return /* @__PURE__ */ C.jsx(Xa.h2, { id: i.titleId, ...r, ref: e });
  }
);
Gq.displayName = UM;
var Yq = "DialogDescription", Xq = I.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Ku(Yq, n);
    return /* @__PURE__ */ C.jsx(Xa.p, { id: i.descriptionId, ...r, ref: e });
  }
);
Xq.displayName = Yq;
var Wq = "DialogClose", Qq = I.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Ku(Wq, n);
    return /* @__PURE__ */ C.jsx(
      Xa.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: Zc(t.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
Qq.displayName = Wq;
function $M(t) {
  return t ? "open" : "closed";
}
var Zq = "DialogTitleWarning", [Ude, Kq] = Ule(Zq, {
  contentName: yg,
  titleName: UM,
  docsSlug: "dialog"
}), $de = ({ titleId: t }) => {
  const e = Kq(Zq), n = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return I.useEffect(() => {
    t && (document.getElementById(t) || console.error(n));
  }, [n, t]), null;
}, Hde = "DialogDescriptionWarning", qde = ({ contentRef: t, descriptionId: e }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Kq(Hde).contentName}}.`;
  return I.useEffect(() => {
    const i = t.current?.getAttribute("aria-describedby");
    e && i && (document.getElementById(e) || console.warn(r));
  }, [r, t, e]), null;
}, HM = Bq, Jq = Fq, qM = Uq, N5 = $q, x_ = Hq, S_ = Gq, E_ = Xq, M5 = Qq;
const _L = (t) => typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, AL = Xc, __ = (t, e) => (n) => {
  var r;
  if (e?.variants == null)
    return AL(t, n?.class, n?.className);
  const { variants: i, defaultVariants: a } = e, s = Object.keys(i).map((f) => {
    const g = n?.[f], m = a?.[f];
    if (g === null)
      return null;
    const b = _L(g) || _L(m);
    return i[f][b];
  }), c = n && Object.entries(n).reduce((f, g) => {
    let [m, b] = g;
    return b === void 0 || (f[m] = b), f;
  }, {}), d = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((f, g) => {
    let { class: m, className: b, ...w } = g;
    return Object.entries(w).every((_) => {
      let [A, T] = _;
      return Array.isArray(T) ? T.includes({
        ...a,
        ...c
      }[A]) : {
        ...a,
        ...c
      }[A] === T;
    }) ? [
      ...f,
      m,
      b
    ] : f;
  }, []);
  return AL(t, s, d, n?.class, n?.className);
};
var p8 = { exports: {} }, TS = {}, CC = { exports: {} }, x6 = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CL;
function Gde() {
  return CL || (CL = 1, function(t) {
    function e(U, q) {
      var W = U.length;
      U.push(q);
      e:
        for (; 0 < W; ) {
          var ie = W - 1 >>> 1, J = U[ie];
          if (0 < i(J, q))
            U[ie] = q, U[W] = J, W = ie;
          else
            break e;
        }
    }
    function n(U) {
      return U.length === 0 ? null : U[0];
    }
    function r(U) {
      if (U.length === 0)
        return null;
      var q = U[0], W = U.pop();
      if (W !== q) {
        U[0] = W;
        e:
          for (var ie = 0, J = U.length, B = J >>> 1; ie < B; ) {
            var te = 2 * (ie + 1) - 1, ae = U[te], le = te + 1, de = U[le];
            if (0 > i(ae, W))
              le < J && 0 > i(de, ae) ? (U[ie] = de, U[le] = W, ie = le) : (U[ie] = ae, U[te] = W, ie = te);
            else if (le < J && 0 > i(de, W))
              U[ie] = de, U[le] = W, ie = le;
            else
              break e;
          }
      }
      return q;
    }
    function i(U, q) {
      var W = U.sortIndex - q.sortIndex;
      return W !== 0 ? W : U.id - q.id;
    }
    if (t.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var a = performance;
      t.unstable_now = function() {
        return a.now();
      };
    } else {
      var s = Date, c = s.now();
      t.unstable_now = function() {
        return s.now() - c;
      };
    }
    var d = [], f = [], g = 1, m = null, b = 3, w = !1, _ = !1, A = !1, T = !1, O = typeof setTimeout == "function" ? setTimeout : null, R = typeof clearTimeout == "function" ? clearTimeout : null, N = typeof setImmediate < "u" ? setImmediate : null;
    function M(U) {
      for (var q = n(f); q !== null; ) {
        if (q.callback === null)
          r(f);
        else if (q.startTime <= U)
          r(f), q.sortIndex = q.expirationTime, e(d, q);
        else
          break;
        q = n(f);
      }
    }
    function P(U) {
      if (A = !1, M(U), !_)
        if (n(d) !== null)
          _ = !0, z || (z = !0, V());
        else {
          var q = n(f);
          q !== null && K(P, q.startTime - U);
        }
    }
    var z = !1, F = -1, $ = 5, G = -1;
    function H() {
      return T ? !0 : !(t.unstable_now() - G < $);
    }
    function Z() {
      if (T = !1, z) {
        var U = t.unstable_now();
        G = U;
        var q = !0;
        try {
          e: {
            _ = !1, A && (A = !1, R(F), F = -1), w = !0;
            var W = b;
            try {
              t: {
                for (M(U), m = n(d); m !== null && !(m.expirationTime > U && H()); ) {
                  var ie = m.callback;
                  if (typeof ie == "function") {
                    m.callback = null, b = m.priorityLevel;
                    var J = ie(
                      m.expirationTime <= U
                    );
                    if (U = t.unstable_now(), typeof J == "function") {
                      m.callback = J, M(U), q = !0;
                      break t;
                    }
                    m === n(d) && r(d), M(U);
                  } else
                    r(d);
                  m = n(d);
                }
                if (m !== null)
                  q = !0;
                else {
                  var B = n(f);
                  B !== null && K(
                    P,
                    B.startTime - U
                  ), q = !1;
                }
              }
              break e;
            } finally {
              m = null, b = W, w = !1;
            }
            q = void 0;
          }
        } finally {
          q ? V() : z = !1;
        }
      }
    }
    var V;
    if (typeof N == "function")
      V = function() {
        N(Z);
      };
    else if (typeof MessageChannel < "u") {
      var Y = new MessageChannel(), ee = Y.port2;
      Y.port1.onmessage = Z, V = function() {
        ee.postMessage(null);
      };
    } else
      V = function() {
        O(Z, 0);
      };
    function K(U, q) {
      F = O(function() {
        U(t.unstable_now());
      }, q);
    }
    t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(U) {
      U.callback = null;
    }, t.unstable_forceFrameRate = function(U) {
      0 > U || 125 < U ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : $ = 0 < U ? Math.floor(1e3 / U) : 5;
    }, t.unstable_getCurrentPriorityLevel = function() {
      return b;
    }, t.unstable_next = function(U) {
      switch (b) {
        case 1:
        case 2:
        case 3:
          var q = 3;
          break;
        default:
          q = b;
      }
      var W = b;
      b = q;
      try {
        return U();
      } finally {
        b = W;
      }
    }, t.unstable_requestPaint = function() {
      T = !0;
    }, t.unstable_runWithPriority = function(U, q) {
      switch (U) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          U = 3;
      }
      var W = b;
      b = U;
      try {
        return q();
      } finally {
        b = W;
      }
    }, t.unstable_scheduleCallback = function(U, q, W) {
      var ie = t.unstable_now();
      switch (typeof W == "object" && W !== null ? (W = W.delay, W = typeof W == "number" && 0 < W ? ie + W : ie) : W = ie, U) {
        case 1:
          var J = -1;
          break;
        case 2:
          J = 250;
          break;
        case 5:
          J = 1073741823;
          break;
        case 4:
          J = 1e4;
          break;
        default:
          J = 5e3;
      }
      return J = W + J, U = {
        id: g++,
        callback: q,
        priorityLevel: U,
        startTime: W,
        expirationTime: J,
        sortIndex: -1
      }, W > ie ? (U.sortIndex = W, e(f, U), n(d) === null && U === n(f) && (A ? (R(F), F = -1) : A = !0, K(P, W - ie))) : (U.sortIndex = J, e(d, U), _ || w || (_ = !0, z || (z = !0, V()))), U;
    }, t.unstable_shouldYield = H, t.unstable_wrapCallback = function(U) {
      var q = b;
      return function() {
        var W = b;
        b = q;
        try {
          return U.apply(this, arguments);
        } finally {
          b = W;
        }
      };
    };
  }(x6)), x6;
}
var S6 = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var TL;
function Yde() {
  return TL || (TL = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      function e() {
        if (P = !1, G) {
          var U = t.unstable_now();
          V = U;
          var q = !0;
          try {
            e: {
              N = !1, M && (M = !1, F(H), H = -1), R = !0;
              var W = O;
              try {
                t: {
                  for (s(U), T = r(w); T !== null && !(T.expirationTime > U && d()); ) {
                    var ie = T.callback;
                    if (typeof ie == "function") {
                      T.callback = null, O = T.priorityLevel;
                      var J = ie(
                        T.expirationTime <= U
                      );
                      if (U = t.unstable_now(), typeof J == "function") {
                        T.callback = J, s(U), q = !0;
                        break t;
                      }
                      T === r(w) && i(w), s(U);
                    } else
                      i(w);
                    T = r(w);
                  }
                  if (T !== null)
                    q = !0;
                  else {
                    var B = r(_);
                    B !== null && f(
                      c,
                      B.startTime - U
                    ), q = !1;
                  }
                }
                break e;
              } finally {
                T = null, O = W, R = !1;
              }
              q = void 0;
            }
          } finally {
            q ? Y() : G = !1;
          }
        }
      }
      function n(U, q) {
        var W = U.length;
        U.push(q);
        e:
          for (; 0 < W; ) {
            var ie = W - 1 >>> 1, J = U[ie];
            if (0 < a(J, q))
              U[ie] = q, U[W] = J, W = ie;
            else
              break e;
          }
      }
      function r(U) {
        return U.length === 0 ? null : U[0];
      }
      function i(U) {
        if (U.length === 0)
          return null;
        var q = U[0], W = U.pop();
        if (W !== q) {
          U[0] = W;
          e:
            for (var ie = 0, J = U.length, B = J >>> 1; ie < B; ) {
              var te = 2 * (ie + 1) - 1, ae = U[te], le = te + 1, de = U[le];
              if (0 > a(ae, W))
                le < J && 0 > a(de, ae) ? (U[ie] = de, U[le] = W, ie = le) : (U[ie] = ae, U[te] = W, ie = te);
              else if (le < J && 0 > a(de, W))
                U[ie] = de, U[le] = W, ie = le;
              else
                break e;
            }
        }
        return q;
      }
      function a(U, q) {
        var W = U.sortIndex - q.sortIndex;
        return W !== 0 ? W : U.id - q.id;
      }
      function s(U) {
        for (var q = r(_); q !== null; ) {
          if (q.callback === null)
            i(_);
          else if (q.startTime <= U)
            i(_), q.sortIndex = q.expirationTime, n(w, q);
          else
            break;
          q = r(_);
        }
      }
      function c(U) {
        if (M = !1, s(U), !N)
          if (r(w) !== null)
            N = !0, G || (G = !0, Y());
          else {
            var q = r(_);
            q !== null && f(
              c,
              q.startTime - U
            );
          }
      }
      function d() {
        return P ? !0 : !(t.unstable_now() - V < Z);
      }
      function f(U, q) {
        H = z(function() {
          U(t.unstable_now());
        }, q);
      }
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), t.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
        var g = performance;
        t.unstable_now = function() {
          return g.now();
        };
      } else {
        var m = Date, b = m.now();
        t.unstable_now = function() {
          return m.now() - b;
        };
      }
      var w = [], _ = [], A = 1, T = null, O = 3, R = !1, N = !1, M = !1, P = !1, z = typeof setTimeout == "function" ? setTimeout : null, F = typeof clearTimeout == "function" ? clearTimeout : null, $ = typeof setImmediate < "u" ? setImmediate : null, G = !1, H = -1, Z = 5, V = -1;
      if (typeof $ == "function")
        var Y = function() {
          $(e);
        };
      else if (typeof MessageChannel < "u") {
        var ee = new MessageChannel(), K = ee.port2;
        ee.port1.onmessage = e, Y = function() {
          K.postMessage(null);
        };
      } else
        Y = function() {
          z(e, 0);
        };
      t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(U) {
        U.callback = null;
      }, t.unstable_forceFrameRate = function(U) {
        0 > U || 125 < U ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : Z = 0 < U ? Math.floor(1e3 / U) : 5;
      }, t.unstable_getCurrentPriorityLevel = function() {
        return O;
      }, t.unstable_next = function(U) {
        switch (O) {
          case 1:
          case 2:
          case 3:
            var q = 3;
            break;
          default:
            q = O;
        }
        var W = O;
        O = q;
        try {
          return U();
        } finally {
          O = W;
        }
      }, t.unstable_requestPaint = function() {
        P = !0;
      }, t.unstable_runWithPriority = function(U, q) {
        switch (U) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            U = 3;
        }
        var W = O;
        O = U;
        try {
          return q();
        } finally {
          O = W;
        }
      }, t.unstable_scheduleCallback = function(U, q, W) {
        var ie = t.unstable_now();
        switch (typeof W == "object" && W !== null ? (W = W.delay, W = typeof W == "number" && 0 < W ? ie + W : ie) : W = ie, U) {
          case 1:
            var J = -1;
            break;
          case 2:
            J = 250;
            break;
          case 5:
            J = 1073741823;
            break;
          case 4:
            J = 1e4;
            break;
          default:
            J = 5e3;
        }
        return J = W + J, U = {
          id: A++,
          callback: q,
          priorityLevel: U,
          startTime: W,
          expirationTime: J,
          sortIndex: -1
        }, W > ie ? (U.sortIndex = W, n(_, U), r(w) === null && U === r(_) && (M ? (F(H), H = -1) : M = !0, f(c, W - ie))) : (U.sortIndex = J, n(w, U), N || R || (N = !0, G || (G = !0, Y()))), U;
      }, t.unstable_shouldYield = d, t.unstable_wrapCallback = function(U) {
        var q = O;
        return function() {
          var W = O;
          O = q;
          try {
            return U.apply(this, arguments);
          } finally {
            O = W;
          }
        };
      }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    }();
  }(S6)), S6;
}
var OL;
function eG() {
  return OL || (OL = 1, process.env.NODE_ENV === "production" ? CC.exports = Gde() : CC.exports = Yde()), CC.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var RL;
function Xde() {
  if (RL)
    return TS;
  RL = 1;
  var t = eG(), e = I, n = MM();
  function r(u) {
    var p = "https://react.dev/errors/" + u;
    if (1 < arguments.length) {
      p += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var v = 2; v < arguments.length; v++)
        p += "&args[]=" + encodeURIComponent(arguments[v]);
    }
    return "Minified React error #" + u + "; visit " + p + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function i(u) {
    return !(!u || u.nodeType !== 1 && u.nodeType !== 9 && u.nodeType !== 11);
  }
  function a(u) {
    var p = u, v = u;
    if (u.alternate)
      for (; p.return; )
        p = p.return;
    else {
      u = p;
      do
        p = u, p.flags & 4098 && (v = p.return), u = p.return;
      while (u);
    }
    return p.tag === 3 ? v : null;
  }
  function s(u) {
    if (u.tag === 13) {
      var p = u.memoizedState;
      if (p === null && (u = u.alternate, u !== null && (p = u.memoizedState)), p !== null)
        return p.dehydrated;
    }
    return null;
  }
  function c(u) {
    if (u.tag === 31) {
      var p = u.memoizedState;
      if (p === null && (u = u.alternate, u !== null && (p = u.memoizedState)), p !== null)
        return p.dehydrated;
    }
    return null;
  }
  function d(u) {
    if (a(u) !== u)
      throw Error(r(188));
  }
  function f(u) {
    var p = u.alternate;
    if (!p) {
      if (p = a(u), p === null)
        throw Error(r(188));
      return p !== u ? null : u;
    }
    for (var v = u, x = p; ; ) {
      var D = v.return;
      if (D === null)
        break;
      var k = D.alternate;
      if (k === null) {
        if (x = D.return, x !== null) {
          v = x;
          continue;
        }
        break;
      }
      if (D.child === k.child) {
        for (k = D.child; k; ) {
          if (k === v)
            return d(D), u;
          if (k === x)
            return d(D), p;
          k = k.sibling;
        }
        throw Error(r(188));
      }
      if (v.return !== x.return)
        v = D, x = k;
      else {
        for (var X = !1, oe = D.child; oe; ) {
          if (oe === v) {
            X = !0, v = D, x = k;
            break;
          }
          if (oe === x) {
            X = !0, x = D, v = k;
            break;
          }
          oe = oe.sibling;
        }
        if (!X) {
          for (oe = k.child; oe; ) {
            if (oe === v) {
              X = !0, v = k, x = D;
              break;
            }
            if (oe === x) {
              X = !0, x = k, v = D;
              break;
            }
            oe = oe.sibling;
          }
          if (!X)
            throw Error(r(189));
        }
      }
      if (v.alternate !== x)
        throw Error(r(190));
    }
    if (v.tag !== 3)
      throw Error(r(188));
    return v.stateNode.current === v ? u : p;
  }
  function g(u) {
    var p = u.tag;
    if (p === 5 || p === 26 || p === 27 || p === 6)
      return u;
    for (u = u.child; u !== null; ) {
      if (p = g(u), p !== null)
        return p;
      u = u.sibling;
    }
    return null;
  }
  var m = Object.assign, b = Symbol.for("react.element"), w = Symbol.for("react.transitional.element"), _ = Symbol.for("react.portal"), A = Symbol.for("react.fragment"), T = Symbol.for("react.strict_mode"), O = Symbol.for("react.profiler"), R = Symbol.for("react.consumer"), N = Symbol.for("react.context"), M = Symbol.for("react.forward_ref"), P = Symbol.for("react.suspense"), z = Symbol.for("react.suspense_list"), F = Symbol.for("react.memo"), $ = Symbol.for("react.lazy"), G = Symbol.for("react.activity"), H = Symbol.for("react.memo_cache_sentinel"), Z = Symbol.iterator;
  function V(u) {
    return u === null || typeof u != "object" ? null : (u = Z && u[Z] || u["@@iterator"], typeof u == "function" ? u : null);
  }
  var Y = Symbol.for("react.client.reference");
  function ee(u) {
    if (u == null)
      return null;
    if (typeof u == "function")
      return u.$$typeof === Y ? null : u.displayName || u.name || null;
    if (typeof u == "string")
      return u;
    switch (u) {
      case A:
        return "Fragment";
      case O:
        return "Profiler";
      case T:
        return "StrictMode";
      case P:
        return "Suspense";
      case z:
        return "SuspenseList";
      case G:
        return "Activity";
    }
    if (typeof u == "object")
      switch (u.$$typeof) {
        case _:
          return "Portal";
        case N:
          return u.displayName || "Context";
        case R:
          return (u._context.displayName || "Context") + ".Consumer";
        case M:
          var p = u.render;
          return u = u.displayName, u || (u = p.displayName || p.name || "", u = u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef"), u;
        case F:
          return p = u.displayName || null, p !== null ? p : ee(u.type) || "Memo";
        case $:
          p = u._payload, u = u._init;
          try {
            return ee(u(p));
          } catch {
          }
      }
    return null;
  }
  var K = Array.isArray, U = e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, q = n.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, W = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, ie = [], J = -1;
  function B(u) {
    return { current: u };
  }
  function te(u) {
    0 > J || (u.current = ie[J], ie[J] = null, J--);
  }
  function ae(u, p) {
    J++, ie[J] = u.current, u.current = p;
  }
  var le = B(null), de = B(null), _e = B(null), ue = B(null);
  function Se(u, p) {
    switch (ae(_e, p), ae(de, u), ae(le, null), p.nodeType) {
      case 9:
      case 11:
        u = (u = p.documentElement) && (u = u.namespaceURI) ? oA(u) : 0;
        break;
      default:
        if (u = p.tagName, p = p.namespaceURI)
          p = oA(p), u = gx(p, u);
        else
          switch (u) {
            case "svg":
              u = 1;
              break;
            case "math":
              u = 2;
              break;
            default:
              u = 0;
          }
    }
    te(le), ae(le, u);
  }
  function Ne() {
    te(le), te(de), te(_e);
  }
  function Me(u) {
    u.memoizedState !== null && ae(ue, u);
    var p = le.current, v = gx(p, u.type);
    p !== v && (ae(de, u), ae(le, v));
  }
  function Ce(u) {
    de.current === u && (te(le), te(de)), ue.current === u && (te(ue), f1._currentValue = W);
  }
  var Ue, rt;
  function it(u) {
    if (Ue === void 0)
      try {
        throw Error();
      } catch (v) {
        var p = v.stack.trim().match(/\n( *(at )?)/);
        Ue = p && p[1] || "", rt = -1 < v.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < v.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Ue + u + rt;
  }
  var Ft = !1;
  function wt(u, p) {
    if (!u || Ft)
      return "";
    Ft = !0;
    var v = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var x = {
        DetermineComponentFrameRoot: function() {
          try {
            if (p) {
              var et = function() {
                throw Error();
              };
              if (Object.defineProperty(et.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(et, []);
                } catch (Fe) {
                  var Pe = Fe;
                }
                Reflect.construct(u, [], et);
              } else {
                try {
                  et.call();
                } catch (Fe) {
                  Pe = Fe;
                }
                u.call(et.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (Fe) {
                Pe = Fe;
              }
              (et = u()) && typeof et.catch == "function" && et.catch(function() {
              });
            }
          } catch (Fe) {
            if (Fe && Pe && typeof Fe.stack == "string")
              return [Fe.stack, Pe.stack];
          }
          return [null, null];
        }
      };
      x.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var D = Object.getOwnPropertyDescriptor(
        x.DetermineComponentFrameRoot,
        "name"
      );
      D && D.configurable && Object.defineProperty(
        x.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var k = x.DetermineComponentFrameRoot(), X = k[0], oe = k[1];
      if (X && oe) {
        var me = X.split(`
`), ke = oe.split(`
`);
        for (D = x = 0; x < me.length && !me[x].includes("DetermineComponentFrameRoot"); )
          x++;
        for (; D < ke.length && !ke[D].includes(
          "DetermineComponentFrameRoot"
        ); )
          D++;
        if (x === me.length || D === ke.length)
          for (x = me.length - 1, D = ke.length - 1; 1 <= x && 0 <= D && me[x] !== ke[D]; )
            D--;
        for (; 1 <= x && 0 <= D; x--, D--)
          if (me[x] !== ke[D]) {
            if (x !== 1 || D !== 1)
              do
                if (x--, D--, 0 > D || me[x] !== ke[D]) {
                  var qe = `
` + me[x].replace(" at new ", " at ");
                  return u.displayName && qe.includes("<anonymous>") && (qe = qe.replace("<anonymous>", u.displayName)), qe;
                }
              while (1 <= x && 0 <= D);
            break;
          }
      }
    } finally {
      Ft = !1, Error.prepareStackTrace = v;
    }
    return (v = u ? u.displayName || u.name : "") ? it(v) : "";
  }
  function Ot(u, p) {
    switch (u.tag) {
      case 26:
      case 27:
      case 5:
        return it(u.type);
      case 16:
        return it("Lazy");
      case 13:
        return u.child !== p && p !== null ? it("Suspense Fallback") : it("Suspense");
      case 19:
        return it("SuspenseList");
      case 0:
      case 15:
        return wt(u.type, !1);
      case 11:
        return wt(u.type.render, !1);
      case 1:
        return wt(u.type, !0);
      case 31:
        return it("Activity");
      default:
        return "";
    }
  }
  function On(u) {
    try {
      var p = "", v = null;
      do
        p += Ot(u, v), v = u, u = u.return;
      while (u);
      return p;
    } catch (x) {
      return `
Error generating stack: ` + x.message + `
` + x.stack;
    }
  }
  var Ct = Object.prototype.hasOwnProperty, se = t.unstable_scheduleCallback, ge = t.unstable_cancelCallback, Te = t.unstable_shouldYield, He = t.unstable_requestPaint, $e = t.unstable_now, Ze = t.unstable_getCurrentPriorityLevel, ct = t.unstable_ImmediatePriority, Mt = t.unstable_UserBlockingPriority, Rt = t.unstable_NormalPriority, sn = t.unstable_LowPriority, In = t.unstable_IdlePriority, hn = t.log, Wn = t.unstable_setDisableYieldValue, ar = null, kn = null;
  function yr(u) {
    if (typeof hn == "function" && Wn(u), kn && typeof kn.setStrictMode == "function")
      try {
        kn.setStrictMode(ar, u);
      } catch {
      }
  }
  var or = Math.clz32 ? Math.clz32 : Ae, sa = Math.log, re = Math.LN2;
  function Ae(u) {
    return u >>>= 0, u === 0 ? 32 : 31 - (sa(u) / re | 0) | 0;
  }
  var nt = 256, st = 262144, lt = 4194304;
  function bt(u) {
    var p = u & 42;
    if (p !== 0)
      return p;
    switch (u & -u) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return u & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return u & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return u & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return u;
    }
  }
  function Ke(u, p, v) {
    var x = u.pendingLanes;
    if (x === 0)
      return 0;
    var D = 0, k = u.suspendedLanes, X = u.pingedLanes;
    u = u.warmLanes;
    var oe = x & 134217727;
    return oe !== 0 ? (x = oe & ~k, x !== 0 ? D = bt(x) : (X &= oe, X !== 0 ? D = bt(X) : v || (v = oe & ~u, v !== 0 && (D = bt(v))))) : (oe = x & ~k, oe !== 0 ? D = bt(oe) : X !== 0 ? D = bt(X) : v || (v = x & ~u, v !== 0 && (D = bt(v)))), D === 0 ? 0 : p !== 0 && p !== D && !(p & k) && (k = D & -D, v = p & -p, k >= v || k === 32 && (v & 4194048) !== 0) ? p : D;
  }
  function ut(u, p) {
    return (u.pendingLanes & ~(u.suspendedLanes & ~u.pingedLanes) & p) === 0;
  }
  function ft(u, p) {
    switch (u) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return p + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return p + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function en() {
    var u = lt;
    return lt <<= 1, !(lt & 62914560) && (lt = 4194304), u;
  }
  function sr(u) {
    for (var p = [], v = 0; 31 > v; v++)
      p.push(u);
    return p;
  }
  function jn(u, p) {
    u.pendingLanes |= p, p !== 268435456 && (u.suspendedLanes = 0, u.pingedLanes = 0, u.warmLanes = 0);
  }
  function vn(u, p, v, x, D, k) {
    var X = u.pendingLanes;
    u.pendingLanes = v, u.suspendedLanes = 0, u.pingedLanes = 0, u.warmLanes = 0, u.expiredLanes &= v, u.entangledLanes &= v, u.errorRecoveryDisabledLanes &= v, u.shellSuspendCounter = 0;
    var oe = u.entanglements, me = u.expirationTimes, ke = u.hiddenUpdates;
    for (v = X & ~v; 0 < v; ) {
      var qe = 31 - or(v), et = 1 << qe;
      oe[qe] = 0, me[qe] = -1;
      var Pe = ke[qe];
      if (Pe !== null)
        for (ke[qe] = null, qe = 0; qe < Pe.length; qe++) {
          var Fe = Pe[qe];
          Fe !== null && (Fe.lane &= -536870913);
        }
      v &= ~et;
    }
    x !== 0 && Ai(u, x, 0), k !== 0 && D === 0 && u.tag !== 0 && (u.suspendedLanes |= k & ~(X & ~p));
  }
  function Ai(u, p, v) {
    u.pendingLanes |= p, u.suspendedLanes &= ~p;
    var x = 31 - or(p);
    u.entangledLanes |= p, u.entanglements[x] = u.entanglements[x] | 1073741824 | v & 261930;
  }
  function Un(u, p) {
    var v = u.entangledLanes |= p;
    for (u = u.entanglements; v; ) {
      var x = 31 - or(v), D = 1 << x;
      D & p | u[x] & p && (u[x] |= p), v &= ~D;
    }
  }
  function tn(u, p) {
    var v = p & -p;
    return v = v & 42 ? 1 : $i(v), v & (u.suspendedLanes | p) ? 0 : v;
  }
  function $i(u) {
    switch (u) {
      case 2:
        u = 1;
        break;
      case 8:
        u = 4;
        break;
      case 32:
        u = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        u = 128;
        break;
      case 268435456:
        u = 134217728;
        break;
      default:
        u = 0;
    }
    return u;
  }
  function Hi(u) {
    return u &= -u, 2 < u ? 8 < u ? u & 134217727 ? 32 : 268435456 : 8 : 2;
  }
  function Ta() {
    var u = q.p;
    return u !== 0 ? u : (u = window.event, u === void 0 ? 32 : h1(u.type));
  }
  function ns(u, p) {
    var v = q.p;
    try {
      return q.p = u, p();
    } finally {
      q.p = v;
    }
  }
  var la = Math.random().toString(36).slice(2), Rn = "__reactFiber$" + la, ca = "__reactProps$" + la, pl = "__reactContainer$" + la, ff = "__reactEvents$" + la, Fh = "__reactListeners$" + la, Hg = "__reactHandles$" + la, jt = "__reactResources$" + la, we = "__reactMarker$" + la;
  function ot(u) {
    delete u[Rn], delete u[ca], delete u[ff], delete u[Fh], delete u[Hg];
  }
  function xt(u) {
    var p = u[Rn];
    if (p)
      return p;
    for (var v = u.parentNode; v; ) {
      if (p = v[pl] || v[Rn]) {
        if (v = p.alternate, p.child !== null || v !== null && v.child !== null)
          for (u = jl(u); u !== null; ) {
            if (v = u[Rn])
              return v;
            u = jl(u);
          }
        return p;
      }
      u = v, v = u.parentNode;
    }
    return null;
  }
  function Kn(u) {
    if (u = u[Rn] || u[pl]) {
      var p = u.tag;
      if (p === 5 || p === 6 || p === 13 || p === 31 || p === 26 || p === 27 || p === 3)
        return u;
    }
    return null;
  }
  function li(u) {
    var p = u.tag;
    if (p === 5 || p === 26 || p === 27 || p === 6)
      return u.stateNode;
    throw Error(r(33));
  }
  function kr(u) {
    var p = u[jt];
    return p || (p = u[jt] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), p;
  }
  function on(u) {
    u[we] = !0;
  }
  var Oa = /* @__PURE__ */ new Set(), Bo = {};
  function Bs(u, p) {
    jr(u, p), jr(u + "Capture", p);
  }
  function jr(u, p) {
    for (Bo[u] = p, u = 0; u < p.length; u++)
      Oa.add(p[u]);
  }
  var hf = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), pf = {}, Vh = {};
  function Uh(u) {
    return Ct.call(Vh, u) ? !0 : Ct.call(pf, u) ? !1 : hf.test(u) ? Vh[u] = !0 : (pf[u] = !0, !1);
  }
  function $h(u, p, v) {
    if (Uh(p))
      if (v === null)
        u.removeAttribute(p);
      else {
        switch (typeof v) {
          case "undefined":
          case "function":
          case "symbol":
            u.removeAttribute(p);
            return;
          case "boolean":
            var x = p.toLowerCase().slice(0, 5);
            if (x !== "data-" && x !== "aria-") {
              u.removeAttribute(p);
              return;
            }
        }
        u.setAttribute(p, "" + v);
      }
  }
  function qg(u, p, v) {
    if (v === null)
      u.removeAttribute(p);
    else {
      switch (typeof v) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          u.removeAttribute(p);
          return;
      }
      u.setAttribute(p, "" + v);
    }
  }
  function ru(u, p, v, x) {
    if (x === null)
      u.removeAttribute(v);
    else {
      switch (typeof x) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          u.removeAttribute(v);
          return;
      }
      u.setAttributeNS(p, v, "" + x);
    }
  }
  function rs(u) {
    switch (typeof u) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return u;
      case "object":
        return u;
      default:
        return "";
    }
  }
  function Gg(u) {
    var p = u.type;
    return (u = u.nodeName) && u.toLowerCase() === "input" && (p === "checkbox" || p === "radio");
  }
  function Dw(u, p, v) {
    var x = Object.getOwnPropertyDescriptor(
      u.constructor.prototype,
      p
    );
    if (!u.hasOwnProperty(p) && typeof x < "u" && typeof x.get == "function" && typeof x.set == "function") {
      var D = x.get, k = x.set;
      return Object.defineProperty(u, p, {
        configurable: !0,
        get: function() {
          return D.call(this);
        },
        set: function(X) {
          v = "" + X, k.call(this, X);
        }
      }), Object.defineProperty(u, p, {
        enumerable: x.enumerable
      }), {
        getValue: function() {
          return v;
        },
        setValue: function(X) {
          v = "" + X;
        },
        stopTracking: function() {
          u._valueTracker = null, delete u[p];
        }
      };
    }
  }
  function Yg(u) {
    if (!u._valueTracker) {
      var p = Gg(u) ? "checked" : "value";
      u._valueTracker = Dw(
        u,
        p,
        "" + u[p]
      );
    }
  }
  function Nw(u) {
    if (!u)
      return !1;
    var p = u._valueTracker;
    if (!p)
      return !0;
    var v = p.getValue(), x = "";
    return u && (x = Gg(u) ? u.checked ? "true" : "false" : u.value), u = x, u !== v ? (p.setValue(u), !0) : !1;
  }
  function tm(u) {
    if (u = u || (typeof document < "u" ? document : void 0), typeof u > "u")
      return null;
    try {
      return u.activeElement || u.body;
    } catch {
      return u.body;
    }
  }
  var MO = /[\n"\\]/g;
  function is(u) {
    return u.replace(
      MO,
      function(p) {
        return "\\" + p.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function nm(u, p, v, x, D, k, X, oe) {
    u.name = "", X != null && typeof X != "function" && typeof X != "symbol" && typeof X != "boolean" ? u.type = X : u.removeAttribute("type"), p != null ? X === "number" ? (p === 0 && u.value === "" || u.value != p) && (u.value = "" + rs(p)) : u.value !== "" + rs(p) && (u.value = "" + rs(p)) : X !== "submit" && X !== "reset" || u.removeAttribute("value"), p != null ? mf(u, X, rs(p)) : v != null ? mf(u, X, rs(v)) : x != null && u.removeAttribute("value"), D == null && k != null && (u.defaultChecked = !!k), D != null && (u.checked = D && typeof D != "function" && typeof D != "symbol"), oe != null && typeof oe != "function" && typeof oe != "symbol" && typeof oe != "boolean" ? u.name = "" + rs(oe) : u.removeAttribute("name");
  }
  function rm(u, p, v, x, D, k, X, oe) {
    if (k != null && typeof k != "function" && typeof k != "symbol" && typeof k != "boolean" && (u.type = k), p != null || v != null) {
      if (!(k !== "submit" && k !== "reset" || p != null)) {
        Yg(u);
        return;
      }
      v = v != null ? "" + rs(v) : "", p = p != null ? "" + rs(p) : v, oe || p === u.value || (u.value = p), u.defaultValue = p;
    }
    x = x ?? D, x = typeof x != "function" && typeof x != "symbol" && !!x, u.checked = oe ? u.checked : !!x, u.defaultChecked = !!x, X != null && typeof X != "function" && typeof X != "symbol" && typeof X != "boolean" && (u.name = X), Yg(u);
  }
  function mf(u, p, v) {
    p === "number" && tm(u.ownerDocument) === u || u.defaultValue === "" + v || (u.defaultValue = "" + v);
  }
  function Hh(u, p, v, x) {
    if (u = u.options, p) {
      p = {};
      for (var D = 0; D < v.length; D++)
        p["$" + v[D]] = !0;
      for (v = 0; v < u.length; v++)
        D = p.hasOwnProperty("$" + u[v].value), u[v].selected !== D && (u[v].selected = D), D && x && (u[v].defaultSelected = !0);
    } else {
      for (v = "" + rs(v), p = null, D = 0; D < u.length; D++) {
        if (u[D].value === v) {
          u[D].selected = !0, x && (u[D].defaultSelected = !0);
          return;
        }
        p !== null || u[D].disabled || (p = u[D]);
      }
      p !== null && (p.selected = !0);
    }
  }
  function Mw(u, p, v) {
    if (p != null && (p = "" + rs(p), p !== u.value && (u.value = p), v == null)) {
      u.defaultValue !== p && (u.defaultValue = p);
      return;
    }
    u.defaultValue = v != null ? "" + rs(v) : "";
  }
  function Iw(u, p, v, x) {
    if (p == null) {
      if (x != null) {
        if (v != null)
          throw Error(r(92));
        if (K(x)) {
          if (1 < x.length)
            throw Error(r(93));
          x = x[0];
        }
        v = x;
      }
      v == null && (v = ""), p = v;
    }
    v = rs(p), u.defaultValue = v, x = u.textContent, x === v && x !== "" && x !== null && (u.value = x), Yg(u);
  }
  function Kl(u, p) {
    if (p) {
      var v = u.firstChild;
      if (v && v === u.lastChild && v.nodeType === 3) {
        v.nodeValue = p;
        return;
      }
    }
    u.textContent = p;
  }
  var W_ = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function Q_(u, p, v) {
    var x = p.indexOf("--") === 0;
    v == null || typeof v == "boolean" || v === "" ? x ? u.setProperty(p, "") : p === "float" ? u.cssFloat = "" : u[p] = "" : x ? u.setProperty(p, v) : typeof v != "number" || v === 0 || W_.has(p) ? p === "float" ? u.cssFloat = v : u[p] = ("" + v).trim() : u[p] = v + "px";
  }
  function Z_(u, p, v) {
    if (p != null && typeof p != "object")
      throw Error(r(62));
    if (u = u.style, v != null) {
      for (var x in v)
        !v.hasOwnProperty(x) || p != null && p.hasOwnProperty(x) || (x.indexOf("--") === 0 ? u.setProperty(x, "") : x === "float" ? u.cssFloat = "" : u[x] = "");
      for (var D in p)
        x = p[D], p.hasOwnProperty(D) && v[D] !== x && Q_(u, D, x);
    } else
      for (var k in p)
        p.hasOwnProperty(k) && Q_(u, k, p[k]);
  }
  function kw(u) {
    if (u.indexOf("-") === -1)
      return !1;
    switch (u) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var IO = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), im = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function zs(u) {
    return im.test("" + u) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : u;
  }
  function ml() {
  }
  var Xg = null;
  function Wg(u) {
    return u = u.target || u.srcElement || window, u.correspondingUseElement && (u = u.correspondingUseElement), u.nodeType === 3 ? u.parentNode : u;
  }
  var Jl = null, gf = null;
  function am(u) {
    var p = Kn(u);
    if (p && (u = p.stateNode)) {
      var v = u[ca] || null;
      e:
        switch (u = p.stateNode, p.type) {
          case "input":
            if (nm(
              u,
              v.value,
              v.defaultValue,
              v.defaultValue,
              v.checked,
              v.defaultChecked,
              v.type,
              v.name
            ), p = v.name, v.type === "radio" && p != null) {
              for (v = u; v.parentNode; )
                v = v.parentNode;
              for (v = v.querySelectorAll(
                'input[name="' + is(
                  "" + p
                ) + '"][type="radio"]'
              ), p = 0; p < v.length; p++) {
                var x = v[p];
                if (x !== u && x.form === u.form) {
                  var D = x[ca] || null;
                  if (!D)
                    throw Error(r(90));
                  nm(
                    x,
                    D.value,
                    D.defaultValue,
                    D.defaultValue,
                    D.checked,
                    D.defaultChecked,
                    D.type,
                    D.name
                  );
                }
              }
              for (p = 0; p < v.length; p++)
                x = v[p], x.form === u.form && Nw(x);
            }
            break e;
          case "textarea":
            Mw(u, v.value, v.defaultValue);
            break e;
          case "select":
            p = v.value, p != null && Hh(u, !!v.multiple, p, !1);
        }
    }
  }
  var qh = !1;
  function jw(u, p, v) {
    if (qh)
      return u(p, v);
    qh = !0;
    try {
      var x = u(p);
      return x;
    } finally {
      if (qh = !1, (Jl !== null || gf !== null) && (Tp(), Jl && (p = Jl, u = gf, gf = Jl = null, am(p), u)))
        for (p = 0; p < u.length; p++)
          am(u[p]);
    }
  }
  function ua(u, p) {
    var v = u.stateNode;
    if (v === null)
      return null;
    var x = v[ca] || null;
    if (x === null)
      return null;
    v = x[p];
    e:
      switch (p) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (x = !x.disabled) || (u = u.type, x = !(u === "button" || u === "input" || u === "select" || u === "textarea")), u = !x;
          break e;
        default:
          u = !1;
      }
    if (u)
      return null;
    if (v && typeof v != "function")
      throw Error(
        r(231, p, typeof v)
      );
    return v;
  }
  var iu = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), om = !1;
  if (iu)
    try {
      var Gh = {};
      Object.defineProperty(Gh, "passive", {
        get: function() {
          om = !0;
        }
      }), window.addEventListener("test", Gh, Gh), window.removeEventListener("test", Gh, Gh);
    } catch {
      om = !1;
    }
  var au = null, Pw = null, Qg = null;
  function Lw() {
    if (Qg)
      return Qg;
    var u, p = Pw, v = p.length, x, D = "value" in au ? au.value : au.textContent, k = D.length;
    for (u = 0; u < v && p[u] === D[u]; u++)
      ;
    var X = v - u;
    for (x = 1; x <= X && p[v - x] === D[k - x]; x++)
      ;
    return Qg = D.slice(u, 1 < x ? 1 - x : void 0);
  }
  function Zg(u) {
    var p = u.keyCode;
    return "charCode" in u ? (u = u.charCode, u === 0 && p === 13 && (u = 13)) : u = p, u === 10 && (u = 13), 32 <= u || u === 13 ? u : 0;
  }
  function sm() {
    return !0;
  }
  function K_() {
    return !1;
  }
  function Ra(u) {
    function p(v, x, D, k, X) {
      this._reactName = v, this._targetInst = D, this.type = x, this.nativeEvent = k, this.target = X, this.currentTarget = null;
      for (var oe in u)
        u.hasOwnProperty(oe) && (v = u[oe], this[oe] = v ? v(k) : k[oe]);
      return this.isDefaultPrevented = (k.defaultPrevented != null ? k.defaultPrevented : k.returnValue === !1) ? sm : K_, this.isPropagationStopped = K_, this;
    }
    return m(p.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var v = this.nativeEvent;
        v && (v.preventDefault ? v.preventDefault() : typeof v.returnValue != "unknown" && (v.returnValue = !1), this.isDefaultPrevented = sm);
      },
      stopPropagation: function() {
        var v = this.nativeEvent;
        v && (v.stopPropagation ? v.stopPropagation() : typeof v.cancelBubble != "unknown" && (v.cancelBubble = !0), this.isPropagationStopped = sm);
      },
      persist: function() {
      },
      isPersistent: sm
    }), p;
  }
  var rd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(u) {
      return u.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, lm = Ra(rd), Yh = m({}, rd, { view: 0, detail: 0 }), kO = Ra(Yh), Bw, zw, cm, Kg = m({}, Yh, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Fs,
    button: 0,
    buttons: 0,
    relatedTarget: function(u) {
      return u.relatedTarget === void 0 ? u.fromElement === u.srcElement ? u.toElement : u.fromElement : u.relatedTarget;
    },
    movementX: function(u) {
      return "movementX" in u ? u.movementX : (u !== cm && (cm && u.type === "mousemove" ? (Bw = u.screenX - cm.screenX, zw = u.screenY - cm.screenY) : zw = Bw = 0, cm = u), Bw);
    },
    movementY: function(u) {
      return "movementY" in u ? u.movementY : zw;
    }
  }), Xh = Ra(Kg), J_ = m({}, Kg, { dataTransfer: 0 }), e3 = Ra(J_), t3 = m({}, Yh, { relatedTarget: 0 }), Jg = Ra(t3), Fw = m({}, rd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), n3 = Ra(Fw), vf = m({}, rd, {
    clipboardData: function(u) {
      return "clipboardData" in u ? u.clipboardData : window.clipboardData;
    }
  }), yf = Ra(vf), gl = m({}, rd, { data: 0 }), r3 = Ra(gl), Vw = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, ec = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, i3 = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function vl(u) {
    var p = this.nativeEvent;
    return p.getModifierState ? p.getModifierState(u) : (u = i3[u]) ? !!p[u] : !1;
  }
  function Fs() {
    return vl;
  }
  var ev = m({}, Yh, {
    key: function(u) {
      if (u.key) {
        var p = Vw[u.key] || u.key;
        if (p !== "Unidentified")
          return p;
      }
      return u.type === "keypress" ? (u = Zg(u), u === 13 ? "Enter" : String.fromCharCode(u)) : u.type === "keydown" || u.type === "keyup" ? ec[u.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Fs,
    charCode: function(u) {
      return u.type === "keypress" ? Zg(u) : 0;
    },
    keyCode: function(u) {
      return u.type === "keydown" || u.type === "keyup" ? u.keyCode : 0;
    },
    which: function(u) {
      return u.type === "keypress" ? Zg(u) : u.type === "keydown" || u.type === "keyup" ? u.keyCode : 0;
    }
  }), tv = Ra(ev), Uw = m({}, Kg, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), yl = Ra(Uw), jO = m({}, Yh, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Fs
  }), a3 = Ra(jO), o3 = m({}, rd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), PO = Ra(o3), $w = m({}, Kg, {
    deltaX: function(u) {
      return "deltaX" in u ? u.deltaX : "wheelDeltaX" in u ? -u.wheelDeltaX : 0;
    },
    deltaY: function(u) {
      return "deltaY" in u ? u.deltaY : "wheelDeltaY" in u ? -u.wheelDeltaY : "wheelDelta" in u ? -u.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), LO = Ra($w), s3 = m({}, rd, {
    newState: 0,
    oldState: 0
  }), Hw = Ra(s3), nv = [9, 13, 27, 32], Wh = iu && "CompositionEvent" in window, bf = null;
  iu && "documentMode" in document && (bf = document.documentMode);
  var Wa = iu && "TextEvent" in window && !bf, qw = iu && (!Wh || bf && 8 < bf && 11 >= bf), um = String.fromCharCode(32), id = !1;
  function rv(u, p) {
    switch (u) {
      case "keyup":
        return nv.indexOf(p.keyCode) !== -1;
      case "keydown":
        return p.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Gw(u) {
    return u = u.detail, typeof u == "object" && "data" in u ? u.data : null;
  }
  var wf = !1;
  function l3(u, p) {
    switch (u) {
      case "compositionend":
        return Gw(p);
      case "keypress":
        return p.which !== 32 ? null : (id = !0, um);
      case "textInput":
        return u = p.data, u === um && id ? null : u;
      default:
        return null;
    }
  }
  function BO(u, p) {
    if (wf)
      return u === "compositionend" || !Wh && rv(u, p) ? (u = Lw(), Qg = Pw = au = null, wf = !1, u) : null;
    switch (u) {
      case "paste":
        return null;
      case "keypress":
        if (!(p.ctrlKey || p.altKey || p.metaKey) || p.ctrlKey && p.altKey) {
          if (p.char && 1 < p.char.length)
            return p.char;
          if (p.which)
            return String.fromCharCode(p.which);
        }
        return null;
      case "compositionend":
        return qw && p.locale !== "ko" ? null : p.data;
      default:
        return null;
    }
  }
  var Yw = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function tc(u) {
    var p = u && u.nodeName && u.nodeName.toLowerCase();
    return p === "input" ? !!Yw[u.type] : p === "textarea";
  }
  function Xw(u, p, v, x) {
    Jl ? gf ? gf.push(x) : gf = [x] : Jl = x, p = o1(p, "onChange"), 0 < p.length && (v = new lm(
      "onChange",
      "change",
      null,
      v,
      x
    ), u.push({ event: v, listeners: p }));
  }
  var xf = null, ad = null;
  function Sf(u) {
    rA(u, 0);
  }
  function Qh(u) {
    var p = li(u);
    if (Nw(p))
      return u;
  }
  function Ww(u, p) {
    if (u === "change")
      return p;
  }
  var iv = !1;
  if (iu) {
    var po;
    if (iu) {
      var bl = "oninput" in document;
      if (!bl) {
        var Qw = document.createElement("div");
        Qw.setAttribute("oninput", "return;"), bl = typeof Qw.oninput == "function";
      }
      po = bl;
    } else
      po = !1;
    iv = po && (!document.documentMode || 9 < document.documentMode);
  }
  function av() {
    xf && (xf.detachEvent("onpropertychange", ov), ad = xf = null);
  }
  function ov(u) {
    if (u.propertyName === "value" && Qh(ad)) {
      var p = [];
      Xw(
        p,
        ad,
        u,
        Wg(u)
      ), jw(Sf, p);
    }
  }
  function c3(u, p, v) {
    u === "focusin" ? (av(), xf = p, ad = v, xf.attachEvent("onpropertychange", ov)) : u === "focusout" && av();
  }
  function u3(u) {
    if (u === "selectionchange" || u === "keyup" || u === "keydown")
      return Qh(ad);
  }
  function od(u, p) {
    if (u === "click")
      return Qh(p);
  }
  function Ef(u, p) {
    if (u === "input" || u === "change")
      return Qh(p);
  }
  function d3(u, p) {
    return u === p && (u !== 0 || 1 / u === 1 / p) || u !== u && p !== p;
  }
  var Qa = typeof Object.is == "function" ? Object.is : d3;
  function Vs(u, p) {
    if (Qa(u, p))
      return !0;
    if (typeof u != "object" || u === null || typeof p != "object" || p === null)
      return !1;
    var v = Object.keys(u), x = Object.keys(p);
    if (v.length !== x.length)
      return !1;
    for (x = 0; x < v.length; x++) {
      var D = v[x];
      if (!Ct.call(p, D) || !Qa(u[D], p[D]))
        return !1;
    }
    return !0;
  }
  function Zw(u) {
    for (; u && u.firstChild; )
      u = u.firstChild;
    return u;
  }
  function Kw(u, p) {
    var v = Zw(u);
    u = 0;
    for (var x; v; ) {
      if (v.nodeType === 3) {
        if (x = u + v.textContent.length, u <= p && x >= p)
          return { node: v, offset: p - u };
        u = x;
      }
      e: {
        for (; v; ) {
          if (v.nextSibling) {
            v = v.nextSibling;
            break e;
          }
          v = v.parentNode;
        }
        v = void 0;
      }
      v = Zw(v);
    }
  }
  function _f(u, p) {
    return u && p ? u === p ? !0 : u && u.nodeType === 3 ? !1 : p && p.nodeType === 3 ? _f(u, p.parentNode) : "contains" in u ? u.contains(p) : u.compareDocumentPosition ? !!(u.compareDocumentPosition(p) & 16) : !1 : !1;
  }
  function sd(u) {
    u = u != null && u.ownerDocument != null && u.ownerDocument.defaultView != null ? u.ownerDocument.defaultView : window;
    for (var p = tm(u.document); p instanceof u.HTMLIFrameElement; ) {
      try {
        var v = typeof p.contentWindow.location.href == "string";
      } catch {
        v = !1;
      }
      if (v)
        u = p.contentWindow;
      else
        break;
      p = tm(u.document);
    }
    return p;
  }
  function dm(u) {
    var p = u && u.nodeName && u.nodeName.toLowerCase();
    return p && (p === "input" && (u.type === "text" || u.type === "search" || u.type === "tel" || u.type === "url" || u.type === "password") || p === "textarea" || u.contentEditable === "true");
  }
  var fm = iu && "documentMode" in document && 11 >= document.documentMode, ld = null, Zh = null, Us = null, wl = !1;
  function sv(u, p, v) {
    var x = v.window === v ? v.document : v.nodeType === 9 ? v : v.ownerDocument;
    wl || ld == null || ld !== tm(x) || (x = ld, "selectionStart" in x && dm(x) ? x = { start: x.selectionStart, end: x.selectionEnd } : (x = (x.ownerDocument && x.ownerDocument.defaultView || window).getSelection(), x = {
      anchorNode: x.anchorNode,
      anchorOffset: x.anchorOffset,
      focusNode: x.focusNode,
      focusOffset: x.focusOffset
    }), Us && Vs(Us, x) || (Us = x, x = o1(Zh, "onSelect"), 0 < x.length && (p = new lm(
      "onSelect",
      "select",
      null,
      p,
      v
    ), u.push({ event: p, listeners: x }), p.target = ld)));
  }
  function ou(u, p) {
    var v = {};
    return v[u.toLowerCase()] = p.toLowerCase(), v["Webkit" + u] = "webkit" + p, v["Moz" + u] = "moz" + p, v;
  }
  var xl = {
    animationend: ou("Animation", "AnimationEnd"),
    animationiteration: ou("Animation", "AnimationIteration"),
    animationstart: ou("Animation", "AnimationStart"),
    transitionrun: ou("Transition", "TransitionRun"),
    transitionstart: ou("Transition", "TransitionStart"),
    transitioncancel: ou("Transition", "TransitionCancel"),
    transitionend: ou("Transition", "TransitionEnd")
  }, Kh = {}, cd = {};
  iu && (cd = document.createElement("div").style, "AnimationEvent" in window || (delete xl.animationend.animation, delete xl.animationiteration.animation, delete xl.animationstart.animation), "TransitionEvent" in window || delete xl.transitionend.transition);
  function lr(u) {
    if (Kh[u])
      return Kh[u];
    if (!xl[u])
      return u;
    var p = xl[u], v;
    for (v in p)
      if (p.hasOwnProperty(v) && v in cd)
        return Kh[u] = p[v];
    return u;
  }
  var hm = lr("animationend"), Jw = lr("animationiteration"), lv = lr("animationstart"), Af = lr("transitionrun"), pm = lr("transitionstart"), nc = lr("transitioncancel"), f3 = lr("transitionend"), rc = /* @__PURE__ */ new Map(), Jh = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  Jh.push("scrollEnd");
  function mo(u, p) {
    rc.set(u, p), Bs(p, [u]);
  }
  var Cf = typeof reportError == "function" ? reportError : function(u) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var p = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof u == "object" && u !== null && typeof u.message == "string" ? String(u.message) : String(u),
        error: u
      });
      if (!window.dispatchEvent(p))
        return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", u);
      return;
    }
    console.error(u);
  }, Jr = [], da = 0, $s = 0;
  function as() {
    for (var u = da, p = $s = da = 0; p < u; ) {
      var v = Jr[p];
      Jr[p++] = null;
      var x = Jr[p];
      Jr[p++] = null;
      var D = Jr[p];
      Jr[p++] = null;
      var k = Jr[p];
      if (Jr[p++] = null, x !== null && D !== null) {
        var X = x.pending;
        X === null ? D.next = D : (D.next = X.next, X.next = D), x.pending = D;
      }
      k !== 0 && cv(v, D, k);
    }
  }
  function os(u, p, v, x) {
    Jr[da++] = u, Jr[da++] = p, Jr[da++] = v, Jr[da++] = x, $s |= x, u.lanes |= x, u = u.alternate, u !== null && (u.lanes |= x);
  }
  function Hs(u, p, v, x) {
    return os(u, p, v, x), mm(u);
  }
  function su(u, p) {
    return os(u, null, null, p), mm(u);
  }
  function cv(u, p, v) {
    u.lanes |= v;
    var x = u.alternate;
    x !== null && (x.lanes |= v);
    for (var D = !1, k = u.return; k !== null; )
      k.childLanes |= v, x = k.alternate, x !== null && (x.childLanes |= v), k.tag === 22 && (u = k.stateNode, u === null || u._visibility & 1 || (D = !0)), u = k, k = k.return;
    return u.tag === 3 ? (k = u.stateNode, D && p !== null && (D = 31 - or(v), u = k.hiddenUpdates, x = u[D], x === null ? u[D] = [p] : x.push(p), p.lane = v | 536870912), k) : null;
  }
  function mm(u) {
    if (50 < Cp)
      throw Cp = 0, Zm = null, Error(r(185));
    for (var p = u.return; p !== null; )
      u = p, p = u.return;
    return u.tag === 3 ? u.stateNode : null;
  }
  var go = {};
  function h3(u, p, v, x) {
    this.tag = u, this.key = v, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = p, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = x, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Ci(u, p, v, x) {
    return new h3(u, p, v, x);
  }
  function Tf(u) {
    return u = u.prototype, !(!u || !u.isReactComponent);
  }
  function lu(u, p) {
    var v = u.alternate;
    return v === null ? (v = Ci(
      u.tag,
      p,
      u.key,
      u.mode
    ), v.elementType = u.elementType, v.type = u.type, v.stateNode = u.stateNode, v.alternate = u, u.alternate = v) : (v.pendingProps = p, v.type = u.type, v.flags = 0, v.subtreeFlags = 0, v.deletions = null), v.flags = u.flags & 65011712, v.childLanes = u.childLanes, v.lanes = u.lanes, v.child = u.child, v.memoizedProps = u.memoizedProps, v.memoizedState = u.memoizedState, v.updateQueue = u.updateQueue, p = u.dependencies, v.dependencies = p === null ? null : { lanes: p.lanes, firstContext: p.firstContext }, v.sibling = u.sibling, v.index = u.index, v.ref = u.ref, v.refCleanup = u.refCleanup, v;
  }
  function e2(u, p) {
    u.flags &= 65011714;
    var v = u.alternate;
    return v === null ? (u.childLanes = 0, u.lanes = p, u.child = null, u.subtreeFlags = 0, u.memoizedProps = null, u.memoizedState = null, u.updateQueue = null, u.dependencies = null, u.stateNode = null) : (u.childLanes = v.childLanes, u.lanes = v.lanes, u.child = v.child, u.subtreeFlags = 0, u.deletions = null, u.memoizedProps = v.memoizedProps, u.memoizedState = v.memoizedState, u.updateQueue = v.updateQueue, u.type = v.type, p = v.dependencies, u.dependencies = p === null ? null : {
      lanes: p.lanes,
      firstContext: p.firstContext
    }), u;
  }
  function uv(u, p, v, x, D, k) {
    var X = 0;
    if (x = u, typeof u == "function")
      Tf(u) && (X = 1);
    else if (typeof u == "string")
      X = Ex(
        u,
        v,
        le.current
      ) ? 26 : u === "html" || u === "head" || u === "body" ? 27 : 5;
    else
      e:
        switch (u) {
          case G:
            return u = Ci(31, v, p, D), u.elementType = G, u.lanes = k, u;
          case A:
            return cu(v.children, D, k, p);
          case T:
            X = 8, D |= 24;
            break;
          case O:
            return u = Ci(12, v, p, D | 2), u.elementType = O, u.lanes = k, u;
          case P:
            return u = Ci(13, v, p, D), u.elementType = P, u.lanes = k, u;
          case z:
            return u = Ci(19, v, p, D), u.elementType = z, u.lanes = k, u;
          default:
            if (typeof u == "object" && u !== null)
              switch (u.$$typeof) {
                case N:
                  X = 10;
                  break e;
                case R:
                  X = 9;
                  break e;
                case M:
                  X = 11;
                  break e;
                case F:
                  X = 14;
                  break e;
                case $:
                  X = 16, x = null;
                  break e;
              }
            X = 29, v = Error(
              r(130, u === null ? "null" : typeof u, "")
            ), x = null;
        }
    return p = Ci(X, v, p, D), p.elementType = u, p.type = x, p.lanes = k, p;
  }
  function cu(u, p, v, x) {
    return u = Ci(7, u, x, p), u.lanes = v, u;
  }
  function ep(u, p, v) {
    return u = Ci(6, u, null, p), u.lanes = v, u;
  }
  function t2(u) {
    var p = Ci(18, null, null, 0);
    return p.stateNode = u, p;
  }
  function dv(u, p, v) {
    return p = Ci(
      4,
      u.children !== null ? u.children : [],
      u.key,
      p
    ), p.lanes = v, p.stateNode = {
      containerInfo: u.containerInfo,
      pendingChildren: null,
      implementation: u.implementation
    }, p;
  }
  var n2 = /* @__PURE__ */ new WeakMap();
  function ss(u, p) {
    if (typeof u == "object" && u !== null) {
      var v = n2.get(u);
      return v !== void 0 ? v : (p = {
        value: u,
        source: p,
        stack: On(p)
      }, n2.set(u, p), p);
    }
    return {
      value: u,
      source: p,
      stack: On(p)
    };
  }
  var ls = [], Of = 0, gm = null, Mi = 0, zo = [], vo = 0, Sl = null, Fo = 1, El = "";
  function qs(u, p) {
    ls[Of++] = Mi, ls[Of++] = gm, gm = u, Mi = p;
  }
  function r2(u, p, v) {
    zo[vo++] = Fo, zo[vo++] = El, zo[vo++] = Sl, Sl = u;
    var x = Fo;
    u = El;
    var D = 32 - or(x) - 1;
    x &= ~(1 << D), v += 1;
    var k = 32 - or(p) + D;
    if (30 < k) {
      var X = D - D % 5;
      k = (x & (1 << X) - 1).toString(32), x >>= X, D -= X, Fo = 1 << 32 - or(p) + D | v << D | x, El = k + u;
    } else
      Fo = 1 << k | v << D | x, El = u;
  }
  function tp(u) {
    u.return !== null && (qs(u, 1), r2(u, 1, 0));
  }
  function fv(u) {
    for (; u === gm; )
      gm = ls[--Of], ls[Of] = null, Mi = ls[--Of], ls[Of] = null;
    for (; u === Sl; )
      Sl = zo[--vo], zo[vo] = null, El = zo[--vo], zo[vo] = null, Fo = zo[--vo], zo[vo] = null;
  }
  function vm(u, p) {
    zo[vo++] = Fo, zo[vo++] = El, zo[vo++] = Sl, Fo = p.id, El = p.overflow, Sl = u;
  }
  var fa = null, Fr = null, Pn = !1, ic = null, Wi = !1, ac = Error(r(519));
  function Gs(u) {
    var p = Error(
      r(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw rp(ss(p, u)), ac;
  }
  function ym(u) {
    var p = u.stateNode, v = u.type, x = u.memoizedProps;
    switch (p[Rn] = u, p[ca] = x, v) {
      case "dialog":
        Dn("cancel", p), Dn("close", p);
        break;
      case "iframe":
      case "object":
      case "embed":
        Dn("load", p);
        break;
      case "video":
      case "audio":
        for (v = 0; v < Mp.length; v++)
          Dn(Mp[v], p);
        break;
      case "source":
        Dn("error", p);
        break;
      case "img":
      case "image":
      case "link":
        Dn("error", p), Dn("load", p);
        break;
      case "details":
        Dn("toggle", p);
        break;
      case "input":
        Dn("invalid", p), rm(
          p,
          x.value,
          x.defaultValue,
          x.checked,
          x.defaultChecked,
          x.type,
          x.name,
          !0
        );
        break;
      case "select":
        Dn("invalid", p);
        break;
      case "textarea":
        Dn("invalid", p), Iw(p, x.value, x.defaultValue, x.children);
    }
    v = x.children, typeof v != "string" && typeof v != "number" && typeof v != "bigint" || p.textContent === "" + v || x.suppressHydrationWarning === !0 || fx(p.textContent, v) ? (x.popover != null && (Dn("beforetoggle", p), Dn("toggle", p)), x.onScroll != null && Dn("scroll", p), x.onScrollEnd != null && Dn("scrollend", p), x.onClick != null && (p.onclick = ml), p = !0) : p = !1, p || Gs(u, !0);
  }
  function np(u) {
    for (fa = u.return; fa; )
      switch (fa.tag) {
        case 5:
        case 31:
        case 13:
          Wi = !1;
          return;
        case 27:
        case 3:
          Wi = !0;
          return;
        default:
          fa = fa.return;
      }
  }
  function oc(u) {
    if (u !== fa)
      return !1;
    if (!Pn)
      return np(u), Pn = !0, !1;
    var p = u.tag, v;
    if ((v = p !== 3 && p !== 27) && ((v = p === 5) && (v = u.type, v = !(v !== "form" && v !== "button") || kp(u.type, u.memoizedProps)), v = !v), v && Fr && Gs(u), np(u), p === 13) {
      if (u = u.memoizedState, u = u !== null ? u.dehydrated : null, !u)
        throw Error(r(317));
      Fr = my(u);
    } else if (p === 31) {
      if (u = u.memoizedState, u = u !== null ? u.dehydrated : null, !u)
        throw Error(r(317));
      Fr = my(u);
    } else
      p === 27 ? (p = Fr, kl(u.type) ? (u = c1, c1 = null, Fr = u) : Fr = p) : Fr = fa ? To(u.stateNode.nextSibling) : null;
    return !0;
  }
  function ud() {
    Fr = fa = null, Pn = !1;
  }
  function i2() {
    var u = ic;
    return u !== null && (di === null ? di = u : di.push.apply(
      di,
      u
    ), ic = null), u;
  }
  function rp(u) {
    ic === null ? ic = [u] : ic.push(u);
  }
  var hv = B(null), uu = null, _l = null;
  function yo(u, p, v) {
    ae(hv, p._currentValue), p._currentValue = v;
  }
  function Al(u) {
    u._currentValue = hv.current, te(hv);
  }
  function pv(u, p, v) {
    for (; u !== null; ) {
      var x = u.alternate;
      if ((u.childLanes & p) !== p ? (u.childLanes |= p, x !== null && (x.childLanes |= p)) : x !== null && (x.childLanes & p) !== p && (x.childLanes |= p), u === v)
        break;
      u = u.return;
    }
  }
  function sc(u, p, v, x) {
    var D = u.child;
    for (D !== null && (D.return = u); D !== null; ) {
      var k = D.dependencies;
      if (k !== null) {
        var X = D.child;
        k = k.firstContext;
        e:
          for (; k !== null; ) {
            var oe = k;
            k = D;
            for (var me = 0; me < p.length; me++)
              if (oe.context === p[me]) {
                k.lanes |= v, oe = k.alternate, oe !== null && (oe.lanes |= v), pv(
                  k.return,
                  v,
                  u
                ), x || (X = null);
                break e;
              }
            k = oe.next;
          }
      } else if (D.tag === 18) {
        if (X = D.return, X === null)
          throw Error(r(341));
        X.lanes |= v, k = X.alternate, k !== null && (k.lanes |= v), pv(X, v, u), X = null;
      } else
        X = D.child;
      if (X !== null)
        X.return = D;
      else
        for (X = D; X !== null; ) {
          if (X === u) {
            X = null;
            break;
          }
          if (D = X.sibling, D !== null) {
            D.return = X.return, X = D;
            break;
          }
          X = X.return;
        }
      D = X;
    }
  }
  function ha(u, p, v, x) {
    u = null;
    for (var D = p, k = !1; D !== null; ) {
      if (!k) {
        if (D.flags & 524288)
          k = !0;
        else if (D.flags & 262144)
          break;
      }
      if (D.tag === 10) {
        var X = D.alternate;
        if (X === null)
          throw Error(r(387));
        if (X = X.memoizedProps, X !== null) {
          var oe = D.type;
          Qa(D.pendingProps.value, X.value) || (u !== null ? u.push(oe) : u = [oe]);
        }
      } else if (D === ue.current) {
        if (X = D.alternate, X === null)
          throw Error(r(387));
        X.memoizedState.memoizedState !== D.memoizedState.memoizedState && (u !== null ? u.push(f1) : u = [f1]);
      }
      D = D.return;
    }
    u !== null && sc(
      p,
      u,
      v,
      x
    ), p.flags |= 262144;
  }
  function Rf(u) {
    for (u = u.firstContext; u !== null; ) {
      if (!Qa(
        u.context._currentValue,
        u.memoizedValue
      ))
        return !0;
      u = u.next;
    }
    return !1;
  }
  function nn(u) {
    uu = u, _l = null, u = u.dependencies, u !== null && (u.firstContext = null);
  }
  function tt(u) {
    return bm(uu, u);
  }
  function du(u, p) {
    return uu === null && nn(u), bm(u, p);
  }
  function bm(u, p) {
    var v = p._currentValue;
    if (p = { context: p, memoizedValue: v, next: null }, _l === null) {
      if (u === null)
        throw Error(r(308));
      _l = p, u.dependencies = { lanes: 0, firstContext: p }, u.flags |= 524288;
    } else
      _l = _l.next = p;
    return v;
  }
  var Ti = typeof AbortController < "u" ? AbortController : function() {
    var u = [], p = this.signal = {
      aborted: !1,
      addEventListener: function(v, x) {
        u.push(x);
      }
    };
    this.abort = function() {
      p.aborted = !0, u.forEach(function(v) {
        return v();
      });
    };
  }, a2 = t.unstable_scheduleCallback, o2 = t.unstable_NormalPriority, Ii = {
    $$typeof: N,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function wm() {
    return {
      controller: new Ti(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function xm(u) {
    u.refCount--, u.refCount === 0 && a2(o2, function() {
      u.controller.abort();
    });
  }
  var Df = null, Sm = 0, dd = 0, qi = null;
  function fr(u, p) {
    if (Df === null) {
      var v = Df = [];
      Sm = 0, dd = sy(), qi = {
        status: "pending",
        value: void 0,
        then: function(x) {
          v.push(x);
        }
      };
    }
    return Sm++, p.then(Em, Em), p;
  }
  function Em() {
    if (--Sm === 0 && Df !== null) {
      qi !== null && (qi.status = "fulfilled");
      var u = Df;
      Df = null, dd = 0, qi = null;
      for (var p = 0; p < u.length; p++)
        (0, u[p])();
    }
  }
  function _m(u, p) {
    var v = [], x = {
      status: "pending",
      value: null,
      reason: null,
      then: function(D) {
        v.push(D);
      }
    };
    return u.then(
      function() {
        x.status = "fulfilled", x.value = p;
        for (var D = 0; D < v.length; D++)
          (0, v[D])(p);
      },
      function(D) {
        for (x.status = "rejected", x.reason = D, D = 0; D < v.length; D++)
          (0, v[D])(void 0);
      }
    ), x;
  }
  var fu = U.S;
  U.S = function(u, p) {
    J2 = $e(), typeof p == "object" && p !== null && typeof p.then == "function" && fr(u, p), fu !== null && fu(u, p);
  };
  var cs = B(null);
  function us() {
    var u = cs.current;
    return u !== null ? u : _r.pooledCache;
  }
  function ip(u, p) {
    p === null ? ae(cs, cs.current) : ae(cs, p.pool);
  }
  function Nf() {
    var u = us();
    return u === null ? null : { parent: Ii._currentValue, pool: u };
  }
  var fd = Error(r(460)), Mf = Error(r(474)), ap = Error(r(542)), If = { then: function() {
  } };
  function s2(u) {
    return u = u.status, u === "fulfilled" || u === "rejected";
  }
  function l2(u, p, v) {
    switch (v = u[v], v === void 0 ? u.push(p) : v !== p && (p.then(ml, ml), p = v), p.status) {
      case "fulfilled":
        return p.value;
      case "rejected":
        throw u = p.reason, mv(u), u;
      default:
        if (typeof p.status == "string")
          p.then(ml, ml);
        else {
          if (u = _r, u !== null && 100 < u.shellSuspendCounter)
            throw Error(r(482));
          u = p, u.status = "pending", u.then(
            function(x) {
              if (p.status === "pending") {
                var D = p;
                D.status = "fulfilled", D.value = x;
              }
            },
            function(x) {
              if (p.status === "pending") {
                var D = p;
                D.status = "rejected", D.reason = x;
              }
            }
          );
        }
        switch (p.status) {
          case "fulfilled":
            return p.value;
          case "rejected":
            throw u = p.reason, mv(u), u;
        }
        throw pd = p, fd;
    }
  }
  function hd(u) {
    try {
      var p = u._init;
      return p(u._payload);
    } catch (v) {
      throw v !== null && typeof v == "object" && typeof v.then == "function" ? (pd = v, fd) : v;
    }
  }
  var pd = null;
  function c2() {
    if (pd === null)
      throw Error(r(459));
    var u = pd;
    return pd = null, u;
  }
  function mv(u) {
    if (u === fd || u === ap)
      throw Error(r(483));
  }
  var md = null, kf = 0;
  function Am(u) {
    var p = kf;
    return kf += 1, md === null && (md = []), l2(md, u, p);
  }
  function op(u, p) {
    p = p.props.ref, u.ref = p !== void 0 ? p : null;
  }
  function Cm(u, p) {
    throw p.$$typeof === b ? Error(r(525)) : (u = Object.prototype.toString.call(p), Error(
      r(
        31,
        u === "[object Object]" ? "object with keys {" + Object.keys(p).join(", ") + "}" : u
      )
    ));
  }
  function p3(u) {
    function p(Oe, xe) {
      if (u) {
        var Ie = Oe.deletions;
        Ie === null ? (Oe.deletions = [xe], Oe.flags |= 16) : Ie.push(xe);
      }
    }
    function v(Oe, xe) {
      if (!u)
        return null;
      for (; xe !== null; )
        p(Oe, xe), xe = xe.sibling;
      return null;
    }
    function x(Oe) {
      for (var xe = /* @__PURE__ */ new Map(); Oe !== null; )
        Oe.key !== null ? xe.set(Oe.key, Oe) : xe.set(Oe.index, Oe), Oe = Oe.sibling;
      return xe;
    }
    function D(Oe, xe) {
      return Oe = lu(Oe, xe), Oe.index = 0, Oe.sibling = null, Oe;
    }
    function k(Oe, xe, Ie) {
      return Oe.index = Ie, u ? (Ie = Oe.alternate, Ie !== null ? (Ie = Ie.index, Ie < xe ? (Oe.flags |= 67108866, xe) : Ie) : (Oe.flags |= 67108866, xe)) : (Oe.flags |= 1048576, xe);
    }
    function X(Oe) {
      return u && Oe.alternate === null && (Oe.flags |= 67108866), Oe;
    }
    function oe(Oe, xe, Ie, We) {
      return xe === null || xe.tag !== 6 ? (xe = ep(Ie, Oe.mode, We), xe.return = Oe, xe) : (xe = D(xe, Ie), xe.return = Oe, xe);
    }
    function me(Oe, xe, Ie, We) {
      var Lt = Ie.type;
      return Lt === A ? qe(
        Oe,
        xe,
        Ie.props.children,
        We,
        Ie.key
      ) : xe !== null && (xe.elementType === Lt || typeof Lt == "object" && Lt !== null && Lt.$$typeof === $ && hd(Lt) === xe.type) ? (xe = D(xe, Ie.props), op(xe, Ie), xe.return = Oe, xe) : (xe = uv(
        Ie.type,
        Ie.key,
        Ie.props,
        null,
        Oe.mode,
        We
      ), op(xe, Ie), xe.return = Oe, xe);
    }
    function ke(Oe, xe, Ie, We) {
      return xe === null || xe.tag !== 4 || xe.stateNode.containerInfo !== Ie.containerInfo || xe.stateNode.implementation !== Ie.implementation ? (xe = dv(Ie, Oe.mode, We), xe.return = Oe, xe) : (xe = D(xe, Ie.children || []), xe.return = Oe, xe);
    }
    function qe(Oe, xe, Ie, We, Lt) {
      return xe === null || xe.tag !== 7 ? (xe = cu(
        Ie,
        Oe.mode,
        We,
        Lt
      ), xe.return = Oe, xe) : (xe = D(xe, Ie), xe.return = Oe, xe);
    }
    function et(Oe, xe, Ie) {
      if (typeof xe == "string" && xe !== "" || typeof xe == "number" || typeof xe == "bigint")
        return xe = ep(
          "" + xe,
          Oe.mode,
          Ie
        ), xe.return = Oe, xe;
      if (typeof xe == "object" && xe !== null) {
        switch (xe.$$typeof) {
          case w:
            return Ie = uv(
              xe.type,
              xe.key,
              xe.props,
              null,
              Oe.mode,
              Ie
            ), op(Ie, xe), Ie.return = Oe, Ie;
          case _:
            return xe = dv(
              xe,
              Oe.mode,
              Ie
            ), xe.return = Oe, xe;
          case $:
            return xe = hd(xe), et(Oe, xe, Ie);
        }
        if (K(xe) || V(xe))
          return xe = cu(
            xe,
            Oe.mode,
            Ie,
            null
          ), xe.return = Oe, xe;
        if (typeof xe.then == "function")
          return et(Oe, Am(xe), Ie);
        if (xe.$$typeof === N)
          return et(
            Oe,
            du(Oe, xe),
            Ie
          );
        Cm(Oe, xe);
      }
      return null;
    }
    function Pe(Oe, xe, Ie, We) {
      var Lt = xe !== null ? xe.key : null;
      if (typeof Ie == "string" && Ie !== "" || typeof Ie == "number" || typeof Ie == "bigint")
        return Lt !== null ? null : oe(Oe, xe, "" + Ie, We);
      if (typeof Ie == "object" && Ie !== null) {
        switch (Ie.$$typeof) {
          case w:
            return Ie.key === Lt ? me(Oe, xe, Ie, We) : null;
          case _:
            return Ie.key === Lt ? ke(Oe, xe, Ie, We) : null;
          case $:
            return Ie = hd(Ie), Pe(Oe, xe, Ie, We);
        }
        if (K(Ie) || V(Ie))
          return Lt !== null ? null : qe(Oe, xe, Ie, We, null);
        if (typeof Ie.then == "function")
          return Pe(
            Oe,
            xe,
            Am(Ie),
            We
          );
        if (Ie.$$typeof === N)
          return Pe(
            Oe,
            xe,
            du(Oe, Ie),
            We
          );
        Cm(Oe, Ie);
      }
      return null;
    }
    function Fe(Oe, xe, Ie, We, Lt) {
      if (typeof We == "string" && We !== "" || typeof We == "number" || typeof We == "bigint")
        return Oe = Oe.get(Ie) || null, oe(xe, Oe, "" + We, Lt);
      if (typeof We == "object" && We !== null) {
        switch (We.$$typeof) {
          case w:
            return Oe = Oe.get(
              We.key === null ? Ie : We.key
            ) || null, me(xe, Oe, We, Lt);
          case _:
            return Oe = Oe.get(
              We.key === null ? Ie : We.key
            ) || null, ke(xe, Oe, We, Lt);
          case $:
            return We = hd(We), Fe(
              Oe,
              xe,
              Ie,
              We,
              Lt
            );
        }
        if (K(We) || V(We))
          return Oe = Oe.get(Ie) || null, qe(xe, Oe, We, Lt, null);
        if (typeof We.then == "function")
          return Fe(
            Oe,
            xe,
            Ie,
            Am(We),
            Lt
          );
        if (We.$$typeof === N)
          return Fe(
            Oe,
            xe,
            Ie,
            du(xe, We),
            Lt
          );
        Cm(xe, We);
      }
      return null;
    }
    function Et(Oe, xe, Ie, We) {
      for (var Lt = null, Qn = null, Dt = xe, ln = xe = 0, mn = null; Dt !== null && ln < Ie.length; ln++) {
        Dt.index > ln ? (mn = Dt, Dt = null) : mn = Dt.sibling;
        var er = Pe(
          Oe,
          Dt,
          Ie[ln],
          We
        );
        if (er === null) {
          Dt === null && (Dt = mn);
          break;
        }
        u && Dt && er.alternate === null && p(Oe, Dt), xe = k(er, xe, ln), Qn === null ? Lt = er : Qn.sibling = er, Qn = er, Dt = mn;
      }
      if (ln === Ie.length)
        return v(Oe, Dt), Pn && qs(Oe, ln), Lt;
      if (Dt === null) {
        for (; ln < Ie.length; ln++)
          Dt = et(Oe, Ie[ln], We), Dt !== null && (xe = k(
            Dt,
            xe,
            ln
          ), Qn === null ? Lt = Dt : Qn.sibling = Dt, Qn = Dt);
        return Pn && qs(Oe, ln), Lt;
      }
      for (Dt = x(Dt); ln < Ie.length; ln++)
        mn = Fe(
          Dt,
          Oe,
          ln,
          Ie[ln],
          We
        ), mn !== null && (u && mn.alternate !== null && Dt.delete(
          mn.key === null ? ln : mn.key
        ), xe = k(
          mn,
          xe,
          ln
        ), Qn === null ? Lt = mn : Qn.sibling = mn, Qn = mn);
      return u && Dt.forEach(function(Ll) {
        return p(Oe, Ll);
      }), Pn && qs(Oe, ln), Lt;
    }
    function Ut(Oe, xe, Ie, We) {
      if (Ie == null)
        throw Error(r(151));
      for (var Lt = null, Qn = null, Dt = xe, ln = xe = 0, mn = null, er = Ie.next(); Dt !== null && !er.done; ln++, er = Ie.next()) {
        Dt.index > ln ? (mn = Dt, Dt = null) : mn = Dt.sibling;
        var Ll = Pe(Oe, Dt, er.value, We);
        if (Ll === null) {
          Dt === null && (Dt = mn);
          break;
        }
        u && Dt && Ll.alternate === null && p(Oe, Dt), xe = k(Ll, xe, ln), Qn === null ? Lt = Ll : Qn.sibling = Ll, Qn = Ll, Dt = mn;
      }
      if (er.done)
        return v(Oe, Dt), Pn && qs(Oe, ln), Lt;
      if (Dt === null) {
        for (; !er.done; ln++, er = Ie.next())
          er = et(Oe, er.value, We), er !== null && (xe = k(er, xe, ln), Qn === null ? Lt = er : Qn.sibling = er, Qn = er);
        return Pn && qs(Oe, ln), Lt;
      }
      for (Dt = x(Dt); !er.done; ln++, er = Ie.next())
        er = Fe(Dt, Oe, ln, er.value, We), er !== null && (u && er.alternate !== null && Dt.delete(er.key === null ? ln : er.key), xe = k(er, xe, ln), Qn === null ? Lt = er : Qn.sibling = er, Qn = er);
      return u && Dt.forEach(function(yA) {
        return p(Oe, yA);
      }), Pn && qs(Oe, ln), Lt;
    }
    function Cr(Oe, xe, Ie, We) {
      if (typeof Ie == "object" && Ie !== null && Ie.type === A && Ie.key === null && (Ie = Ie.props.children), typeof Ie == "object" && Ie !== null) {
        switch (Ie.$$typeof) {
          case w:
            e: {
              for (var Lt = Ie.key; xe !== null; ) {
                if (xe.key === Lt) {
                  if (Lt = Ie.type, Lt === A) {
                    if (xe.tag === 7) {
                      v(
                        Oe,
                        xe.sibling
                      ), We = D(
                        xe,
                        Ie.props.children
                      ), We.return = Oe, Oe = We;
                      break e;
                    }
                  } else if (xe.elementType === Lt || typeof Lt == "object" && Lt !== null && Lt.$$typeof === $ && hd(Lt) === xe.type) {
                    v(
                      Oe,
                      xe.sibling
                    ), We = D(xe, Ie.props), op(We, Ie), We.return = Oe, Oe = We;
                    break e;
                  }
                  v(Oe, xe);
                  break;
                } else
                  p(Oe, xe);
                xe = xe.sibling;
              }
              Ie.type === A ? (We = cu(
                Ie.props.children,
                Oe.mode,
                We,
                Ie.key
              ), We.return = Oe, Oe = We) : (We = uv(
                Ie.type,
                Ie.key,
                Ie.props,
                null,
                Oe.mode,
                We
              ), op(We, Ie), We.return = Oe, Oe = We);
            }
            return X(Oe);
          case _:
            e: {
              for (Lt = Ie.key; xe !== null; ) {
                if (xe.key === Lt)
                  if (xe.tag === 4 && xe.stateNode.containerInfo === Ie.containerInfo && xe.stateNode.implementation === Ie.implementation) {
                    v(
                      Oe,
                      xe.sibling
                    ), We = D(xe, Ie.children || []), We.return = Oe, Oe = We;
                    break e;
                  } else {
                    v(Oe, xe);
                    break;
                  }
                else
                  p(Oe, xe);
                xe = xe.sibling;
              }
              We = dv(Ie, Oe.mode, We), We.return = Oe, Oe = We;
            }
            return X(Oe);
          case $:
            return Ie = hd(Ie), Cr(
              Oe,
              xe,
              Ie,
              We
            );
        }
        if (K(Ie))
          return Et(
            Oe,
            xe,
            Ie,
            We
          );
        if (V(Ie)) {
          if (Lt = V(Ie), typeof Lt != "function")
            throw Error(r(150));
          return Ie = Lt.call(Ie), Ut(
            Oe,
            xe,
            Ie,
            We
          );
        }
        if (typeof Ie.then == "function")
          return Cr(
            Oe,
            xe,
            Am(Ie),
            We
          );
        if (Ie.$$typeof === N)
          return Cr(
            Oe,
            xe,
            du(Oe, Ie),
            We
          );
        Cm(Oe, Ie);
      }
      return typeof Ie == "string" && Ie !== "" || typeof Ie == "number" || typeof Ie == "bigint" ? (Ie = "" + Ie, xe !== null && xe.tag === 6 ? (v(Oe, xe.sibling), We = D(xe, Ie), We.return = Oe, Oe = We) : (v(Oe, xe), We = ep(Ie, Oe.mode, We), We.return = Oe, Oe = We), X(Oe)) : v(Oe, xe);
    }
    return function(Oe, xe, Ie, We) {
      try {
        kf = 0;
        var Lt = Cr(
          Oe,
          xe,
          Ie,
          We
        );
        return md = null, Lt;
      } catch (Dt) {
        if (Dt === fd || Dt === ap)
          throw Dt;
        var Qn = Ci(29, Dt, null, Oe.mode);
        return Qn.lanes = We, Qn.return = Oe, Qn;
      } finally {
      }
    };
  }
  var gd = p3(!0), u2 = p3(!1), hu = !1;
  function Tm(u) {
    u.updateQueue = {
      baseState: u.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function gv(u, p) {
    u = u.updateQueue, p.updateQueue === u && (p.updateQueue = {
      baseState: u.baseState,
      firstBaseUpdate: u.firstBaseUpdate,
      lastBaseUpdate: u.lastBaseUpdate,
      shared: u.shared,
      callbacks: null
    });
  }
  function pu(u) {
    return { lane: u, tag: 0, payload: null, callback: null, next: null };
  }
  function ds(u, p, v) {
    var x = u.updateQueue;
    if (x === null)
      return null;
    if (x = x.shared, Jn & 2) {
      var D = x.pending;
      return D === null ? p.next = p : (p.next = D.next, D.next = p), x.pending = p, p = mm(u), cv(u, null, v), p;
    }
    return os(u, x, p, v), mm(u);
  }
  function vd(u, p, v) {
    if (p = p.updateQueue, p !== null && (p = p.shared, (v & 4194048) !== 0)) {
      var x = p.lanes;
      x &= u.pendingLanes, v |= x, p.lanes = v, Un(u, v);
    }
  }
  function vv(u, p) {
    var v = u.updateQueue, x = u.alternate;
    if (x !== null && (x = x.updateQueue, v === x)) {
      var D = null, k = null;
      if (v = v.firstBaseUpdate, v !== null) {
        do {
          var X = {
            lane: v.lane,
            tag: v.tag,
            payload: v.payload,
            callback: null,
            next: null
          };
          k === null ? D = k = X : k = k.next = X, v = v.next;
        } while (v !== null);
        k === null ? D = k = p : k = k.next = p;
      } else
        D = k = p;
      v = {
        baseState: x.baseState,
        firstBaseUpdate: D,
        lastBaseUpdate: k,
        shared: x.shared,
        callbacks: x.callbacks
      }, u.updateQueue = v;
      return;
    }
    u = v.lastBaseUpdate, u === null ? v.firstBaseUpdate = p : u.next = p, v.lastBaseUpdate = p;
  }
  var d2 = !1;
  function yd() {
    if (d2) {
      var u = qi;
      if (u !== null)
        throw u;
    }
  }
  function lc(u, p, v, x) {
    d2 = !1;
    var D = u.updateQueue;
    hu = !1;
    var k = D.firstBaseUpdate, X = D.lastBaseUpdate, oe = D.shared.pending;
    if (oe !== null) {
      D.shared.pending = null;
      var me = oe, ke = me.next;
      me.next = null, X === null ? k = ke : X.next = ke, X = me;
      var qe = u.alternate;
      qe !== null && (qe = qe.updateQueue, oe = qe.lastBaseUpdate, oe !== X && (oe === null ? qe.firstBaseUpdate = ke : oe.next = ke, qe.lastBaseUpdate = me));
    }
    if (k !== null) {
      var et = D.baseState;
      X = 0, qe = ke = me = null, oe = k;
      do {
        var Pe = oe.lane & -536870913, Fe = Pe !== oe.lane;
        if (Fe ? (En & Pe) === Pe : (x & Pe) === Pe) {
          Pe !== 0 && Pe === dd && (d2 = !0), qe !== null && (qe = qe.next = {
            lane: 0,
            tag: oe.tag,
            payload: oe.payload,
            callback: null,
            next: null
          });
          e: {
            var Et = u, Ut = oe;
            Pe = p;
            var Cr = v;
            switch (Ut.tag) {
              case 1:
                if (Et = Ut.payload, typeof Et == "function") {
                  et = Et.call(Cr, et, Pe);
                  break e;
                }
                et = Et;
                break e;
              case 3:
                Et.flags = Et.flags & -65537 | 128;
              case 0:
                if (Et = Ut.payload, Pe = typeof Et == "function" ? Et.call(Cr, et, Pe) : Et, Pe == null)
                  break e;
                et = m({}, et, Pe);
                break e;
              case 2:
                hu = !0;
            }
          }
          Pe = oe.callback, Pe !== null && (u.flags |= 64, Fe && (u.flags |= 8192), Fe = D.callbacks, Fe === null ? D.callbacks = [Pe] : Fe.push(Pe));
        } else
          Fe = {
            lane: Pe,
            tag: oe.tag,
            payload: oe.payload,
            callback: oe.callback,
            next: null
          }, qe === null ? (ke = qe = Fe, me = et) : qe = qe.next = Fe, X |= Pe;
        if (oe = oe.next, oe === null) {
          if (oe = D.shared.pending, oe === null)
            break;
          Fe = oe, oe = Fe.next, Fe.next = null, D.lastBaseUpdate = Fe, D.shared.pending = null;
        }
      } while (1);
      qe === null && (me = et), D.baseState = me, D.firstBaseUpdate = ke, D.lastBaseUpdate = qe, k === null && (D.shared.lanes = 0), Ml |= X, u.lanes = X, u.memoizedState = et;
    }
  }
  function yv(u, p) {
    if (typeof u != "function")
      throw Error(r(191, u));
    u.call(p);
  }
  function bd(u, p) {
    var v = u.callbacks;
    if (v !== null)
      for (u.callbacks = null, u = 0; u < v.length; u++)
        yv(v[u], p);
  }
  var Qi = B(null), jf = B(0);
  function m3(u, p) {
    u = Nl, ae(jf, u), ae(Qi, p), Nl = u | p.baseLanes;
  }
  function Om() {
    ae(jf, Nl), ae(Qi, Qi.current);
  }
  function sp() {
    Nl = jf.current, te(Qi), te(jf);
  }
  var bo = B(null), fs = null;
  function cc(u) {
    var p = u.alternate;
    ae(ei, ei.current & 1), ae(bo, u), fs === null && (p === null || Qi.current !== null || p.memoizedState !== null) && (fs = u);
  }
  function lp(u) {
    ae(ei, ei.current), ae(bo, u), fs === null && (fs = u);
  }
  function bv(u) {
    u.tag === 22 ? (ae(ei, ei.current), ae(bo, u), fs === null && (fs = u)) : Cl();
  }
  function Cl() {
    ae(ei, ei.current), ae(bo, bo.current);
  }
  function wo(u) {
    te(bo), fs === u && (fs = null), te(ei);
  }
  var ei = B(0);
  function cp(u) {
    for (var p = u; p !== null; ) {
      if (p.tag === 13) {
        var v = p.memoizedState;
        if (v !== null && (v = v.dehydrated, v === null || Qs(v) || Nd(v)))
          return p;
      } else if (p.tag === 19 && (p.memoizedProps.revealOrder === "forwards" || p.memoizedProps.revealOrder === "backwards" || p.memoizedProps.revealOrder === "unstable_legacy-backwards" || p.memoizedProps.revealOrder === "together")) {
        if (p.flags & 128)
          return p;
      } else if (p.child !== null) {
        p.child.return = p, p = p.child;
        continue;
      }
      if (p === u)
        break;
      for (; p.sibling === null; ) {
        if (p.return === null || p.return === u)
          return null;
        p = p.return;
      }
      p.sibling.return = p.return, p = p.sibling;
    }
    return null;
  }
  var uc = 0, cn = null, hr = null, ki = null, Pf = !1, Lf = !1, mu = !1, Rm = 0, up = 0, wd = null, g3 = 0;
  function ci() {
    throw Error(r(321));
  }
  function gu(u, p) {
    if (p === null)
      return !1;
    for (var v = 0; v < p.length && v < u.length; v++)
      if (!Qa(u[v], p[v]))
        return !1;
    return !0;
  }
  function Dm(u, p, v, x, D, k) {
    return uc = k, cn = p, p.memoizedState = null, p.updateQueue = null, p.lanes = 0, U.H = u === null || u.memoizedState === null ? _3 : Pv, mu = !1, k = v(x, D), mu = !1, Lf && (k = v3(
      p,
      v,
      x,
      D
    )), wv(u), k;
  }
  function wv(u) {
    U.H = zm;
    var p = hr !== null && hr.next !== null;
    if (uc = 0, ki = hr = cn = null, Pf = !1, up = 0, wd = null, p)
      throw Error(r(300));
    u === null || ji || (u = u.dependencies, u !== null && Rf(u) && (ji = !0));
  }
  function v3(u, p, v, x) {
    cn = u;
    var D = 0;
    do {
      if (Lf && (wd = null), up = 0, Lf = !1, 25 <= D)
        throw Error(r(301));
      if (D += 1, ki = hr = null, u.updateQueue != null) {
        var k = u.updateQueue;
        k.lastEffect = null, k.events = null, k.stores = null, k.memoCache != null && (k.memoCache.index = 0);
      }
      U.H = A3, k = p(v, x);
    } while (Lf);
    return k;
  }
  function zO() {
    var u = U.H, p = u.useState()[0];
    return p = typeof p.then == "function" ? zf(p) : p, u = u.useState()[0], (hr !== null ? hr.memoizedState : null) !== u && (cn.flags |= 1024), p;
  }
  function xv() {
    var u = Rm !== 0;
    return Rm = 0, u;
  }
  function Bf(u, p, v) {
    p.updateQueue = u.updateQueue, p.flags &= -2053, u.lanes &= ~v;
  }
  function Nm(u) {
    if (Pf) {
      for (u = u.memoizedState; u !== null; ) {
        var p = u.queue;
        p !== null && (p.pending = null), u = u.next;
      }
      Pf = !1;
    }
    uc = 0, ki = hr = cn = null, Lf = !1, up = Rm = 0, wd = null;
  }
  function pa() {
    var u = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return ki === null ? cn.memoizedState = ki = u : ki = ki.next = u, ki;
  }
  function Oi() {
    if (hr === null) {
      var u = cn.alternate;
      u = u !== null ? u.memoizedState : null;
    } else
      u = hr.next;
    var p = ki === null ? cn.memoizedState : ki.next;
    if (p !== null)
      ki = p, hr = u;
    else {
      if (u === null)
        throw cn.alternate === null ? Error(r(467)) : Error(r(310));
      hr = u, u = {
        memoizedState: hr.memoizedState,
        baseState: hr.baseState,
        baseQueue: hr.baseQueue,
        queue: hr.queue,
        next: null
      }, ki === null ? cn.memoizedState = ki = u : ki = ki.next = u;
    }
    return ki;
  }
  function Mm() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function zf(u) {
    var p = up;
    return up += 1, wd === null && (wd = []), u = l2(wd, u, p), p = cn, (ki === null ? p.memoizedState : ki.next) === null && (p = p.alternate, U.H = p === null || p.memoizedState === null ? _3 : Pv), u;
  }
  function dp(u) {
    if (u !== null && typeof u == "object") {
      if (typeof u.then == "function")
        return zf(u);
      if (u.$$typeof === N)
        return tt(u);
    }
    throw Error(r(438, String(u)));
  }
  function Sv(u) {
    var p = null, v = cn.updateQueue;
    if (v !== null && (p = v.memoCache), p == null) {
      var x = cn.alternate;
      x !== null && (x = x.updateQueue, x !== null && (x = x.memoCache, x != null && (p = {
        data: x.data.map(function(D) {
          return D.slice();
        }),
        index: 0
      })));
    }
    if (p == null && (p = { data: [], index: 0 }), v === null && (v = Mm(), cn.updateQueue = v), v.memoCache = p, v = p.data[p.index], v === void 0)
      for (v = p.data[p.index] = Array(u), x = 0; x < u; x++)
        v[x] = H;
    return p.index++, v;
  }
  function dc(u, p) {
    return typeof p == "function" ? p(u) : p;
  }
  function fc(u) {
    var p = Oi();
    return Ev(p, hr, u);
  }
  function Ev(u, p, v) {
    var x = u.queue;
    if (x === null)
      throw Error(r(311));
    x.lastRenderedReducer = v;
    var D = u.baseQueue, k = x.pending;
    if (k !== null) {
      if (D !== null) {
        var X = D.next;
        D.next = k.next, k.next = X;
      }
      p.baseQueue = D = k, x.pending = null;
    }
    if (k = u.baseState, D === null)
      u.memoizedState = k;
    else {
      p = D.next;
      var oe = X = null, me = null, ke = p, qe = !1;
      do {
        var et = ke.lane & -536870913;
        if (et !== ke.lane ? (En & et) === et : (uc & et) === et) {
          var Pe = ke.revertLane;
          if (Pe === 0)
            me !== null && (me = me.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: ke.action,
              hasEagerState: ke.hasEagerState,
              eagerState: ke.eagerState,
              next: null
            }), et === dd && (qe = !0);
          else if ((uc & Pe) === Pe) {
            ke = ke.next, Pe === dd && (qe = !0);
            continue;
          } else
            et = {
              lane: 0,
              revertLane: ke.revertLane,
              gesture: null,
              action: ke.action,
              hasEagerState: ke.hasEagerState,
              eagerState: ke.eagerState,
              next: null
            }, me === null ? (oe = me = et, X = k) : me = me.next = et, cn.lanes |= Pe, Ml |= Pe;
          et = ke.action, mu && v(k, et), k = ke.hasEagerState ? ke.eagerState : v(k, et);
        } else
          Pe = {
            lane: et,
            revertLane: ke.revertLane,
            gesture: ke.gesture,
            action: ke.action,
            hasEagerState: ke.hasEagerState,
            eagerState: ke.eagerState,
            next: null
          }, me === null ? (oe = me = Pe, X = k) : me = me.next = Pe, cn.lanes |= et, Ml |= et;
        ke = ke.next;
      } while (ke !== null && ke !== p);
      if (me === null ? X = k : me.next = oe, !Qa(k, u.memoizedState) && (ji = !0, qe && (v = qi, v !== null)))
        throw v;
      u.memoizedState = k, u.baseState = X, u.baseQueue = me, x.lastRenderedState = k;
    }
    return D === null && (x.lanes = 0), [u.memoizedState, x.dispatch];
  }
  function _v(u) {
    var p = Oi(), v = p.queue;
    if (v === null)
      throw Error(r(311));
    v.lastRenderedReducer = u;
    var x = v.dispatch, D = v.pending, k = p.memoizedState;
    if (D !== null) {
      v.pending = null;
      var X = D = D.next;
      do
        k = u(k, X.action), X = X.next;
      while (X !== D);
      Qa(k, p.memoizedState) || (ji = !0), p.memoizedState = k, p.baseQueue === null && (p.baseState = k), v.lastRenderedState = k;
    }
    return [k, x];
  }
  function f2(u, p, v) {
    var x = cn, D = Oi(), k = Pn;
    if (k) {
      if (v === void 0)
        throw Error(r(407));
      v = v();
    } else
      v = p();
    var X = !Qa(
      (hr || D).memoizedState,
      v
    );
    if (X && (D.memoizedState = v, ji = !0), D = D.queue, Rv(Av.bind(null, x, D, u), [
      u
    ]), D.getSnapshot !== p || X || ki !== null && ki.memoizedState.tag & 1) {
      if (x.flags |= 2048, Vf(
        9,
        { destroy: void 0 },
        h2.bind(
          null,
          x,
          D,
          v,
          p
        ),
        null
      ), _r === null)
        throw Error(r(349));
      k || uc & 127 || Im(x, p, v);
    }
    return v;
  }
  function Im(u, p, v) {
    u.flags |= 16384, u = { getSnapshot: p, value: v }, p = cn.updateQueue, p === null ? (p = Mm(), cn.updateQueue = p, p.stores = [u]) : (v = p.stores, v === null ? p.stores = [u] : v.push(u));
  }
  function h2(u, p, v, x) {
    p.value = v, p.getSnapshot = x, Cv(p) && Tv(u);
  }
  function Av(u, p, v) {
    return v(function() {
      Cv(p) && Tv(u);
    });
  }
  function Cv(u) {
    var p = u.getSnapshot;
    u = u.value;
    try {
      var v = p();
      return !Qa(u, v);
    } catch {
      return !0;
    }
  }
  function Tv(u) {
    var p = su(u, 2);
    p !== null && Co(p, u, 2);
  }
  function p2(u) {
    var p = pa();
    if (typeof u == "function") {
      var v = u;
      if (u = v(), mu) {
        yr(!0);
        try {
          v();
        } finally {
          yr(!1);
        }
      }
    }
    return p.memoizedState = p.baseState = u, p.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: dc,
      lastRenderedState: u
    }, p;
  }
  function ma(u, p, v, x) {
    return u.baseState = v, Ev(
      u,
      hr,
      typeof x == "function" ? x : dc
    );
  }
  function y3(u, p, v, x, D) {
    if (Bm(u))
      throw Error(r(485));
    if (u = p.action, u !== null) {
      var k = {
        payload: D,
        action: u,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(X) {
          k.listeners.push(X);
        }
      };
      U.T !== null ? v(!0) : k.isTransition = !1, x(k), v = p.pending, v === null ? (k.next = p.pending = k, m2(p, k)) : (k.next = v.next, p.pending = v.next = k);
    }
  }
  function m2(u, p) {
    var v = p.action, x = p.payload, D = u.state;
    if (p.isTransition) {
      var k = U.T, X = {};
      U.T = X;
      try {
        var oe = v(D, x), me = U.S;
        me !== null && me(X, oe), g2(u, p, oe);
      } catch (ke) {
        Ff(u, p, ke);
      } finally {
        k !== null && X.types !== null && (k.types = X.types), U.T = k;
      }
    } else
      try {
        k = v(D, x), g2(u, p, k);
      } catch (ke) {
        Ff(u, p, ke);
      }
  }
  function g2(u, p, v) {
    v !== null && typeof v == "object" && typeof v.then == "function" ? v.then(
      function(x) {
        v2(u, p, x);
      },
      function(x) {
        return Ff(u, p, x);
      }
    ) : v2(u, p, v);
  }
  function v2(u, p, v) {
    p.status = "fulfilled", p.value = v, y2(p), u.state = v, p = u.pending, p !== null && (v = p.next, v === p ? u.pending = null : (v = v.next, p.next = v, m2(u, v)));
  }
  function Ff(u, p, v) {
    var x = u.pending;
    if (u.pending = null, x !== null) {
      x = x.next;
      do
        p.status = "rejected", p.reason = v, y2(p), p = p.next;
      while (p !== x);
    }
    u.action = null;
  }
  function y2(u) {
    u = u.listeners;
    for (var p = 0; p < u.length; p++)
      (0, u[p])();
  }
  function km(u, p) {
    return p;
  }
  function b2(u, p) {
    if (Pn) {
      var v = _r.formState;
      if (v !== null) {
        e: {
          var x = cn;
          if (Pn) {
            if (Fr) {
              t: {
                for (var D = Fr, k = Wi; D.nodeType !== 8; ) {
                  if (!k) {
                    D = null;
                    break t;
                  }
                  if (D = To(
                    D.nextSibling
                  ), D === null) {
                    D = null;
                    break t;
                  }
                }
                k = D.data, D = k === "F!" || k === "F" ? D : null;
              }
              if (D) {
                Fr = To(
                  D.nextSibling
                ), x = D.data === "F!";
                break e;
              }
            }
            Gs(x);
          }
          x = !1;
        }
        x && (p = v[0]);
      }
    }
    return v = pa(), v.memoizedState = v.baseState = p, x = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: km,
      lastRenderedState: p
    }, v.queue = x, v = kv.bind(
      null,
      cn,
      x
    ), x.dispatch = v, x = p2(!1), k = xd.bind(
      null,
      cn,
      !1,
      x.queue
    ), x = pa(), D = {
      state: p,
      dispatch: null,
      action: u,
      pending: null
    }, x.queue = D, v = y3.bind(
      null,
      cn,
      D,
      k,
      v
    ), D.dispatch = v, x.memoizedState = u, [p, v, !1];
  }
  function b3(u) {
    var p = Oi();
    return jm(p, hr, u);
  }
  function jm(u, p, v) {
    if (p = Ev(
      u,
      p,
      km
    )[0], u = fc(dc)[0], typeof p == "object" && p !== null && typeof p.then == "function")
      try {
        var x = zf(p);
      } catch (X) {
        throw X === fd ? ap : X;
      }
    else
      x = p;
    p = Oi();
    var D = p.queue, k = D.dispatch;
    return v !== p.memoizedState && (cn.flags |= 2048, Vf(
      9,
      { destroy: void 0 },
      w2.bind(null, D, v),
      null
    )), [x, k, u];
  }
  function w2(u, p) {
    u.action = p;
  }
  function x2(u) {
    var p = Oi(), v = hr;
    if (v !== null)
      return jm(p, v, u);
    Oi(), p = p.memoizedState, v = Oi();
    var x = v.queue.dispatch;
    return v.memoizedState = u, [p, x, !1];
  }
  function Vf(u, p, v, x) {
    return u = { tag: u, create: v, deps: x, inst: p, next: null }, p = cn.updateQueue, p === null && (p = Mm(), cn.updateQueue = p), v = p.lastEffect, v === null ? p.lastEffect = u.next = u : (x = v.next, v.next = u, u.next = x, p.lastEffect = u), u;
  }
  function S2() {
    return Oi().memoizedState;
  }
  function fp(u, p, v, x) {
    var D = pa();
    cn.flags |= u, D.memoizedState = Vf(
      1 | p,
      { destroy: void 0 },
      v,
      x === void 0 ? null : x
    );
  }
  function hp(u, p, v, x) {
    var D = Oi();
    x = x === void 0 ? null : x;
    var k = D.memoizedState.inst;
    hr !== null && x !== null && gu(x, hr.memoizedState.deps) ? D.memoizedState = Vf(p, k, v, x) : (cn.flags |= u, D.memoizedState = Vf(
      1 | p,
      k,
      v,
      x
    ));
  }
  function Ov(u, p) {
    fp(8390656, 8, u, p);
  }
  function Rv(u, p) {
    hp(2048, 8, u, p);
  }
  function E2(u) {
    cn.flags |= 4;
    var p = cn.updateQueue;
    if (p === null)
      p = Mm(), cn.updateQueue = p, p.events = [u];
    else {
      var v = p.events;
      v === null ? p.events = [u] : v.push(u);
    }
  }
  function Pm(u) {
    var p = Oi().memoizedState;
    return E2({ ref: p, nextImpl: u }), function() {
      if (Jn & 2)
        throw Error(r(440));
      return p.impl.apply(void 0, arguments);
    };
  }
  function Dv(u, p) {
    return hp(4, 2, u, p);
  }
  function _2(u, p) {
    return hp(4, 4, u, p);
  }
  function Nv(u, p) {
    if (typeof p == "function") {
      u = u();
      var v = p(u);
      return function() {
        typeof v == "function" ? v() : p(null);
      };
    }
    if (p != null)
      return u = u(), p.current = u, function() {
        p.current = null;
      };
  }
  function A2(u, p, v) {
    v = v != null ? v.concat([u]) : null, hp(4, 4, Nv.bind(null, p, u), v);
  }
  function Tl() {
  }
  function Mv(u, p) {
    var v = Oi();
    p = p === void 0 ? null : p;
    var x = v.memoizedState;
    return p !== null && gu(p, x[1]) ? x[0] : (v.memoizedState = [u, p], u);
  }
  function w3(u, p) {
    var v = Oi();
    p = p === void 0 ? null : p;
    var x = v.memoizedState;
    if (p !== null && gu(p, x[1]))
      return x[0];
    if (x = u(), mu) {
      yr(!0);
      try {
        u();
      } finally {
        yr(!1);
      }
    }
    return v.memoizedState = [x, p], x;
  }
  function Lm(u, p, v) {
    return v === void 0 || uc & 1073741824 && !(En & 261930) ? u.memoizedState = p : (u.memoizedState = v, u = j3(), cn.lanes |= u, Ml |= u, v);
  }
  function hc(u, p, v, x) {
    return Qa(v, p) ? v : Qi.current !== null ? (u = Lm(u, v, x), Qa(u, p) || (ji = !0), u) : !(uc & 42) || uc & 1073741824 && !(En & 261930) ? (ji = !0, u.memoizedState = v) : (u = j3(), cn.lanes |= u, Ml |= u, p);
  }
  function Iv(u, p, v, x, D) {
    var k = q.p;
    q.p = k !== 0 && 8 > k ? k : 8;
    var X = U.T, oe = {};
    U.T = oe, xd(u, !1, p, v);
    try {
      var me = D(), ke = U.S;
      if (ke !== null && ke(oe, me), me !== null && typeof me == "object" && typeof me.then == "function") {
        var qe = _m(
          me,
          x
        );
        vu(
          u,
          p,
          qe,
          Ho(u)
        );
      } else
        vu(
          u,
          p,
          x,
          Ho(u)
        );
    } catch (et) {
      vu(
        u,
        p,
        { then: function() {
        }, status: "rejected", reason: et },
        Ho()
      );
    } finally {
      q.p = k, X !== null && oe.types !== null && (X.types = oe.types), U.T = X;
    }
  }
  function x3() {
  }
  function pp(u, p, v, x) {
    if (u.tag !== 5)
      throw Error(r(476));
    var D = mp(u).queue;
    Iv(
      u,
      D,
      p,
      W,
      v === null ? x3 : function() {
        return Er(u), v(x);
      }
    );
  }
  function mp(u) {
    var p = u.memoizedState;
    if (p !== null)
      return p;
    p = {
      memoizedState: W,
      baseState: W,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: dc,
        lastRenderedState: W
      },
      next: null
    };
    var v = {};
    return p.next = {
      memoizedState: v,
      baseState: v,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: dc,
        lastRenderedState: v
      },
      next: null
    }, u.memoizedState = p, u = u.alternate, u !== null && (u.memoizedState = p), p;
  }
  function Er(u) {
    var p = mp(u);
    p.next === null && (p = u.alternate.memoizedState), vu(
      u,
      p.next.queue,
      {},
      Ho()
    );
  }
  function C2() {
    return tt(f1);
  }
  function S3() {
    return Oi().memoizedState;
  }
  function T2() {
    return Oi().memoizedState;
  }
  function pc(u) {
    for (var p = u.return; p !== null; ) {
      switch (p.tag) {
        case 24:
        case 3:
          var v = Ho();
          u = pu(v);
          var x = ds(p, u, v);
          x !== null && (Co(x, p, v), vd(x, p, v)), p = { cache: wm() }, u.payload = p;
          return;
      }
      p = p.return;
    }
  }
  function E3(u, p, v) {
    var x = Ho();
    v = {
      lane: x,
      revertLane: 0,
      gesture: null,
      action: v,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Bm(u) ? jv(p, v) : (v = Hs(u, p, v, x), v !== null && (Co(v, u, x), O2(v, p, x)));
  }
  function kv(u, p, v) {
    var x = Ho();
    vu(u, p, v, x);
  }
  function vu(u, p, v, x) {
    var D = {
      lane: x,
      revertLane: 0,
      gesture: null,
      action: v,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Bm(u))
      jv(p, D);
    else {
      var k = u.alternate;
      if (u.lanes === 0 && (k === null || k.lanes === 0) && (k = p.lastRenderedReducer, k !== null))
        try {
          var X = p.lastRenderedState, oe = k(X, v);
          if (D.hasEagerState = !0, D.eagerState = oe, Qa(oe, X))
            return os(u, p, D, 0), _r === null && as(), !1;
        } catch {
        } finally {
        }
      if (v = Hs(u, p, D, x), v !== null)
        return Co(v, u, x), O2(v, p, x), !0;
    }
    return !1;
  }
  function xd(u, p, v, x) {
    if (x = {
      lane: 2,
      revertLane: sy(),
      gesture: null,
      action: x,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Bm(u)) {
      if (p)
        throw Error(r(479));
    } else
      p = Hs(
        u,
        v,
        x,
        2
      ), p !== null && Co(p, u, 2);
  }
  function Bm(u) {
    var p = u.alternate;
    return u === cn || p !== null && p === cn;
  }
  function jv(u, p) {
    Lf = Pf = !0;
    var v = u.pending;
    v === null ? p.next = p : (p.next = v.next, v.next = p), u.pending = p;
  }
  function O2(u, p, v) {
    if (v & 4194048) {
      var x = p.lanes;
      x &= u.pendingLanes, v |= x, p.lanes = v, Un(u, v);
    }
  }
  var zm = {
    readContext: tt,
    use: dp,
    useCallback: ci,
    useContext: ci,
    useEffect: ci,
    useImperativeHandle: ci,
    useLayoutEffect: ci,
    useInsertionEffect: ci,
    useMemo: ci,
    useReducer: ci,
    useRef: ci,
    useState: ci,
    useDebugValue: ci,
    useDeferredValue: ci,
    useTransition: ci,
    useSyncExternalStore: ci,
    useId: ci,
    useHostTransitionStatus: ci,
    useFormState: ci,
    useActionState: ci,
    useOptimistic: ci,
    useMemoCache: ci,
    useCacheRefresh: ci
  };
  zm.useEffectEvent = ci;
  var _3 = {
    readContext: tt,
    use: dp,
    useCallback: function(u, p) {
      return pa().memoizedState = [
        u,
        p === void 0 ? null : p
      ], u;
    },
    useContext: tt,
    useEffect: Ov,
    useImperativeHandle: function(u, p, v) {
      v = v != null ? v.concat([u]) : null, fp(
        4194308,
        4,
        Nv.bind(null, p, u),
        v
      );
    },
    useLayoutEffect: function(u, p) {
      return fp(4194308, 4, u, p);
    },
    useInsertionEffect: function(u, p) {
      fp(4, 2, u, p);
    },
    useMemo: function(u, p) {
      var v = pa();
      p = p === void 0 ? null : p;
      var x = u();
      if (mu) {
        yr(!0);
        try {
          u();
        } finally {
          yr(!1);
        }
      }
      return v.memoizedState = [x, p], x;
    },
    useReducer: function(u, p, v) {
      var x = pa();
      if (v !== void 0) {
        var D = v(p);
        if (mu) {
          yr(!0);
          try {
            v(p);
          } finally {
            yr(!1);
          }
        }
      } else
        D = p;
      return x.memoizedState = x.baseState = D, u = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: u,
        lastRenderedState: D
      }, x.queue = u, u = u.dispatch = E3.bind(
        null,
        cn,
        u
      ), [x.memoizedState, u];
    },
    useRef: function(u) {
      var p = pa();
      return u = { current: u }, p.memoizedState = u;
    },
    useState: function(u) {
      u = p2(u);
      var p = u.queue, v = kv.bind(null, cn, p);
      return p.dispatch = v, [u.memoizedState, v];
    },
    useDebugValue: Tl,
    useDeferredValue: function(u, p) {
      var v = pa();
      return Lm(v, u, p);
    },
    useTransition: function() {
      var u = p2(!1);
      return u = Iv.bind(
        null,
        cn,
        u.queue,
        !0,
        !1
      ), pa().memoizedState = u, [!1, u];
    },
    useSyncExternalStore: function(u, p, v) {
      var x = cn, D = pa();
      if (Pn) {
        if (v === void 0)
          throw Error(r(407));
        v = v();
      } else {
        if (v = p(), _r === null)
          throw Error(r(349));
        En & 127 || Im(x, p, v);
      }
      D.memoizedState = v;
      var k = { value: v, getSnapshot: p };
      return D.queue = k, Ov(Av.bind(null, x, k, u), [
        u
      ]), x.flags |= 2048, Vf(
        9,
        { destroy: void 0 },
        h2.bind(
          null,
          x,
          k,
          v,
          p
        ),
        null
      ), v;
    },
    useId: function() {
      var u = pa(), p = _r.identifierPrefix;
      if (Pn) {
        var v = El, x = Fo;
        v = (x & ~(1 << 32 - or(x) - 1)).toString(32) + v, p = "_" + p + "R_" + v, v = Rm++, 0 < v && (p += "H" + v.toString(32)), p += "_";
      } else
        v = g3++, p = "_" + p + "r_" + v.toString(32) + "_";
      return u.memoizedState = p;
    },
    useHostTransitionStatus: C2,
    useFormState: b2,
    useActionState: b2,
    useOptimistic: function(u) {
      var p = pa();
      p.memoizedState = p.baseState = u;
      var v = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return p.queue = v, p = xd.bind(
        null,
        cn,
        !0,
        v
      ), v.dispatch = p, [u, p];
    },
    useMemoCache: Sv,
    useCacheRefresh: function() {
      return pa().memoizedState = pc.bind(
        null,
        cn
      );
    },
    useEffectEvent: function(u) {
      var p = pa(), v = { impl: u };
      return p.memoizedState = v, function() {
        if (Jn & 2)
          throw Error(r(440));
        return v.impl.apply(void 0, arguments);
      };
    }
  }, Pv = {
    readContext: tt,
    use: dp,
    useCallback: Mv,
    useContext: tt,
    useEffect: Rv,
    useImperativeHandle: A2,
    useInsertionEffect: Dv,
    useLayoutEffect: _2,
    useMemo: w3,
    useReducer: fc,
    useRef: S2,
    useState: function() {
      return fc(dc);
    },
    useDebugValue: Tl,
    useDeferredValue: function(u, p) {
      var v = Oi();
      return hc(
        v,
        hr.memoizedState,
        u,
        p
      );
    },
    useTransition: function() {
      var u = fc(dc)[0], p = Oi().memoizedState;
      return [
        typeof u == "boolean" ? u : zf(u),
        p
      ];
    },
    useSyncExternalStore: f2,
    useId: S3,
    useHostTransitionStatus: C2,
    useFormState: b3,
    useActionState: b3,
    useOptimistic: function(u, p) {
      var v = Oi();
      return ma(v, hr, u, p);
    },
    useMemoCache: Sv,
    useCacheRefresh: T2
  };
  Pv.useEffectEvent = Pm;
  var A3 = {
    readContext: tt,
    use: dp,
    useCallback: Mv,
    useContext: tt,
    useEffect: Rv,
    useImperativeHandle: A2,
    useInsertionEffect: Dv,
    useLayoutEffect: _2,
    useMemo: w3,
    useReducer: _v,
    useRef: S2,
    useState: function() {
      return _v(dc);
    },
    useDebugValue: Tl,
    useDeferredValue: function(u, p) {
      var v = Oi();
      return hr === null ? Lm(v, u, p) : hc(
        v,
        hr.memoizedState,
        u,
        p
      );
    },
    useTransition: function() {
      var u = _v(dc)[0], p = Oi().memoizedState;
      return [
        typeof u == "boolean" ? u : zf(u),
        p
      ];
    },
    useSyncExternalStore: f2,
    useId: S3,
    useHostTransitionStatus: C2,
    useFormState: x2,
    useActionState: x2,
    useOptimistic: function(u, p) {
      var v = Oi();
      return hr !== null ? ma(v, hr, u, p) : (v.baseState = u, [u, v.queue.dispatch]);
    },
    useMemoCache: Sv,
    useCacheRefresh: T2
  };
  A3.useEffectEvent = Pm;
  function Uf(u, p, v, x) {
    p = u.memoizedState, v = v(x, p), v = v == null ? p : m({}, p, v), u.memoizedState = v, u.lanes === 0 && (u.updateQueue.baseState = v);
  }
  var Ys = {
    enqueueSetState: function(u, p, v) {
      u = u._reactInternals;
      var x = Ho(), D = pu(x);
      D.payload = p, v != null && (D.callback = v), p = ds(u, D, x), p !== null && (Co(p, u, x), vd(p, u, x));
    },
    enqueueReplaceState: function(u, p, v) {
      u = u._reactInternals;
      var x = Ho(), D = pu(x);
      D.tag = 1, D.payload = p, v != null && (D.callback = v), p = ds(u, D, x), p !== null && (Co(p, u, x), vd(p, u, x));
    },
    enqueueForceUpdate: function(u, p) {
      u = u._reactInternals;
      var v = Ho(), x = pu(v);
      x.tag = 2, p != null && (x.callback = p), p = ds(u, x, v), p !== null && (Co(p, u, v), vd(p, u, v));
    }
  };
  function R2(u, p, v, x, D, k, X) {
    return u = u.stateNode, typeof u.shouldComponentUpdate == "function" ? u.shouldComponentUpdate(x, k, X) : p.prototype && p.prototype.isPureReactComponent ? !Vs(v, x) || !Vs(D, k) : !0;
  }
  function C3(u, p, v, x) {
    u = p.state, typeof p.componentWillReceiveProps == "function" && p.componentWillReceiveProps(v, x), typeof p.UNSAFE_componentWillReceiveProps == "function" && p.UNSAFE_componentWillReceiveProps(v, x), p.state !== u && Ys.enqueueReplaceState(p, p.state, null);
  }
  function Sd(u, p) {
    var v = p;
    if ("ref" in p) {
      v = {};
      for (var x in p)
        x !== "ref" && (v[x] = p[x]);
    }
    if (u = u.defaultProps) {
      v === p && (v = m({}, v));
      for (var D in u)
        v[D] === void 0 && (v[D] = u[D]);
    }
    return v;
  }
  function Lv(u) {
    Cf(u);
  }
  function D2(u) {
    console.error(u);
  }
  function Bv(u) {
    Cf(u);
  }
  function gp(u, p) {
    try {
      var v = u.onUncaughtError;
      v(p.value, { componentStack: p.stack });
    } catch (x) {
      setTimeout(function() {
        throw x;
      });
    }
  }
  function Fm(u, p, v) {
    try {
      var x = u.onCaughtError;
      x(v.value, {
        componentStack: v.stack,
        errorBoundary: p.tag === 1 ? p.stateNode : null
      });
    } catch (D) {
      setTimeout(function() {
        throw D;
      });
    }
  }
  function N2(u, p, v) {
    return v = pu(v), v.tag = 3, v.payload = { element: null }, v.callback = function() {
      gp(u, p);
    }, v;
  }
  function M2(u) {
    return u = pu(u), u.tag = 3, u;
  }
  function I2(u, p, v, x) {
    var D = v.type.getDerivedStateFromError;
    if (typeof D == "function") {
      var k = x.value;
      u.payload = function() {
        return D(k);
      }, u.callback = function() {
        Fm(p, v, x);
      };
    }
    var X = v.stateNode;
    X !== null && typeof X.componentDidCatch == "function" && (u.callback = function() {
      Fm(p, v, x), typeof D != "function" && (ti === null ? ti = /* @__PURE__ */ new Set([this]) : ti.add(this));
      var oe = x.stack;
      this.componentDidCatch(x.value, {
        componentStack: oe !== null ? oe : ""
      });
    });
  }
  function FO(u, p, v, x, D) {
    if (v.flags |= 32768, x !== null && typeof x == "object" && typeof x.then == "function") {
      if (p = v.alternate, p !== null && ha(
        p,
        v,
        D,
        !0
      ), v = bo.current, v !== null) {
        switch (v.tag) {
          case 31:
          case 13:
            return fs === null ? ry() : v.alternate === null && Ur === 0 && (Ur = 3), v.flags &= -257, v.flags |= 65536, v.lanes = D, x === If ? v.flags |= 16384 : (p = v.updateQueue, p === null ? v.updateQueue = /* @__PURE__ */ new Set([x]) : p.add(x), e1(u, x, D)), !1;
          case 22:
            return v.flags |= 65536, x === If ? v.flags |= 16384 : (p = v.updateQueue, p === null ? (p = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([x])
            }, v.updateQueue = p) : (v = p.retryQueue, v === null ? p.retryQueue = /* @__PURE__ */ new Set([x]) : v.add(x)), e1(u, x, D)), !1;
        }
        throw Error(r(435, v.tag));
      }
      return e1(u, x, D), ry(), !1;
    }
    if (Pn)
      return p = bo.current, p !== null ? (!(p.flags & 65536) && (p.flags |= 256), p.flags |= 65536, p.lanes = D, x !== ac && (u = Error(r(422), { cause: x }), rp(ss(u, v)))) : (x !== ac && (p = Error(r(423), {
        cause: x
      }), rp(
        ss(p, v)
      )), u = u.current.alternate, u.flags |= 65536, D &= -D, u.lanes |= D, x = ss(x, v), D = N2(
        u.stateNode,
        x,
        D
      ), vv(u, D), Ur !== 4 && (Ur = 2)), !1;
    var k = Error(r(520), { cause: x });
    if (k = ss(k, v), Qm === null ? Qm = [k] : Qm.push(k), Ur !== 4 && (Ur = 2), p === null)
      return !0;
    x = ss(x, v), v = p;
    do {
      switch (v.tag) {
        case 3:
          return v.flags |= 65536, u = D & -D, v.lanes |= u, u = N2(v.stateNode, x, u), vv(v, u), !1;
        case 1:
          if (p = v.type, k = v.stateNode, (v.flags & 128) === 0 && (typeof p.getDerivedStateFromError == "function" || k !== null && typeof k.componentDidCatch == "function" && (ti === null || !ti.has(k))))
            return v.flags |= 65536, D &= -D, v.lanes |= D, D = M2(D), I2(
              D,
              u,
              v,
              x
            ), vv(v, D), !1;
      }
      v = v.return;
    } while (v !== null);
    return !1;
  }
  var zv = Error(r(461)), ji = !1;
  function Wr(u, p, v, x) {
    p.child = u === null ? u2(p, null, v, x) : gd(
      p,
      u.child,
      v,
      x
    );
  }
  function k2(u, p, v, x, D) {
    v = v.render;
    var k = p.ref;
    if ("ref" in x) {
      var X = {};
      for (var oe in x)
        oe !== "ref" && (X[oe] = x[oe]);
    } else
      X = x;
    return nn(p), x = Dm(
      u,
      p,
      v,
      X,
      k,
      D
    ), oe = xv(), u !== null && !ji ? (Bf(u, p, D), ms(u, p, D)) : (Pn && oe && tp(p), p.flags |= 1, Wr(u, p, x, D), p.child);
  }
  function j2(u, p, v, x, D) {
    if (u === null) {
      var k = v.type;
      return typeof k == "function" && !Tf(k) && k.defaultProps === void 0 && v.compare === null ? (p.tag = 15, p.type = k, P2(
        u,
        p,
        k,
        x,
        D
      )) : (u = uv(
        v.type,
        null,
        x,
        p,
        p.mode,
        D
      ), u.ref = p.ref, u.return = p, p.child = u);
    }
    if (k = u.child, !Uv(u, D)) {
      var X = k.memoizedProps;
      if (v = v.compare, v = v !== null ? v : Vs, v(X, x) && u.ref === p.ref)
        return ms(u, p, D);
    }
    return p.flags |= 1, u = lu(k, x), u.ref = p.ref, u.return = p, p.child = u;
  }
  function P2(u, p, v, x, D) {
    if (u !== null) {
      var k = u.memoizedProps;
      if (Vs(k, x) && u.ref === p.ref)
        if (ji = !1, p.pendingProps = x = k, Uv(u, D))
          u.flags & 131072 && (ji = !0);
        else
          return p.lanes = u.lanes, ms(u, p, D);
    }
    return Fv(
      u,
      p,
      v,
      x,
      D
    );
  }
  function T3(u, p, v, x) {
    var D = x.children, k = u !== null ? u.memoizedState : null;
    if (u === null && p.stateNode === null && (p.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), x.mode === "hidden") {
      if (p.flags & 128) {
        if (k = k !== null ? k.baseLanes | v : v, u !== null) {
          for (x = p.child = u.child, D = 0; x !== null; )
            D = D | x.lanes | x.childLanes, x = x.sibling;
          x = D & ~k;
        } else
          x = 0, p.child = null;
        return xo(
          u,
          p,
          k,
          v,
          x
        );
      }
      if (v & 536870912)
        p.memoizedState = { baseLanes: 0, cachePool: null }, u !== null && ip(
          p,
          k !== null ? k.cachePool : null
        ), k !== null ? m3(p, k) : Om(), bv(p);
      else
        return x = p.lanes = 536870912, xo(
          u,
          p,
          k !== null ? k.baseLanes | v : v,
          v,
          x
        );
    } else
      k !== null ? (ip(p, k.cachePool), m3(p, k), Cl(), p.memoizedState = null) : (u !== null && ip(p, null), Om(), Cl());
    return Wr(u, p, D, v), p.child;
  }
  function Ed(u, p) {
    return u !== null && u.tag === 22 || p.stateNode !== null || (p.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), p.sibling;
  }
  function xo(u, p, v, x, D) {
    var k = us();
    return k = k === null ? null : { parent: Ii._currentValue, pool: k }, p.memoizedState = {
      baseLanes: v,
      cachePool: k
    }, u !== null && ip(p, null), Om(), bv(p), u !== null && ha(u, p, x, !0), p.childLanes = D, null;
  }
  function Vm(u, p) {
    return p = Hm(
      { mode: p.mode, children: p.children },
      u.mode
    ), p.ref = u.ref, u.child = p, p.return = u, p;
  }
  function So(u, p, v) {
    return gd(p, u.child, null, v), u = Vm(p, p.pendingProps), u.flags |= 2, wo(p), p.memoizedState = null, u;
  }
  function O3(u, p, v) {
    var x = p.pendingProps, D = (p.flags & 128) !== 0;
    if (p.flags &= -129, u === null) {
      if (Pn) {
        if (x.mode === "hidden")
          return u = Vm(p, x), p.lanes = 536870912, Ed(null, u);
        if (lp(p), (u = Fr) ? (u = cA(
          u,
          Wi
        ), u = u !== null && u.data === "&" ? u : null, u !== null && (p.memoizedState = {
          dehydrated: u,
          treeContext: Sl !== null ? { id: Fo, overflow: El } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, v = t2(u), v.return = p, p.child = v, fa = p, Fr = null)) : u = null, u === null)
          throw Gs(p);
        return p.lanes = 536870912, null;
      }
      return Vm(p, x);
    }
    var k = u.memoizedState;
    if (k !== null) {
      var X = k.dehydrated;
      if (lp(p), D)
        if (p.flags & 256)
          p.flags &= -257, p = So(
            u,
            p,
            v
          );
        else if (p.memoizedState !== null)
          p.child = u.child, p.flags |= 128, p = null;
        else
          throw Error(r(558));
      else if (ji || ha(u, p, v, !1), D = (v & u.childLanes) !== 0, ji || D) {
        if (x = _r, x !== null && (X = tn(x, v), X !== 0 && X !== k.retryLane))
          throw k.retryLane = X, su(u, X), Co(x, u, X), zv;
        ry(), p = So(
          u,
          p,
          v
        );
      } else
        u = k.treeContext, Fr = To(X.nextSibling), fa = p, Pn = !0, ic = null, Wi = !1, u !== null && vm(p, u), p = Vm(p, x), p.flags |= 4096;
      return p;
    }
    return u = lu(u.child, {
      mode: x.mode,
      children: x.children
    }), u.ref = p.ref, p.child = u, u.return = p, u;
  }
  function hs(u, p) {
    var v = p.ref;
    if (v === null)
      u !== null && u.ref !== null && (p.flags |= 4194816);
    else {
      if (typeof v != "function" && typeof v != "object")
        throw Error(r(284));
      (u === null || u.ref !== v) && (p.flags |= 4194816);
    }
  }
  function Fv(u, p, v, x, D) {
    return nn(p), v = Dm(
      u,
      p,
      v,
      x,
      void 0,
      D
    ), x = xv(), u !== null && !ji ? (Bf(u, p, D), ms(u, p, D)) : (Pn && x && tp(p), p.flags |= 1, Wr(u, p, v, D), p.child);
  }
  function _d(u, p, v, x, D, k) {
    return nn(p), p.updateQueue = null, v = v3(
      p,
      x,
      v,
      D
    ), wv(u), x = xv(), u !== null && !ji ? (Bf(u, p, k), ms(u, p, k)) : (Pn && x && tp(p), p.flags |= 1, Wr(u, p, v, k), p.child);
  }
  function L2(u, p, v, x, D) {
    if (nn(p), p.stateNode === null) {
      var k = go, X = v.contextType;
      typeof X == "object" && X !== null && (k = tt(X)), k = new v(x, k), p.memoizedState = k.state !== null && k.state !== void 0 ? k.state : null, k.updater = Ys, p.stateNode = k, k._reactInternals = p, k = p.stateNode, k.props = x, k.state = p.memoizedState, k.refs = {}, Tm(p), X = v.contextType, k.context = typeof X == "object" && X !== null ? tt(X) : go, k.state = p.memoizedState, X = v.getDerivedStateFromProps, typeof X == "function" && (Uf(
        p,
        v,
        X,
        x
      ), k.state = p.memoizedState), typeof v.getDerivedStateFromProps == "function" || typeof k.getSnapshotBeforeUpdate == "function" || typeof k.UNSAFE_componentWillMount != "function" && typeof k.componentWillMount != "function" || (X = k.state, typeof k.componentWillMount == "function" && k.componentWillMount(), typeof k.UNSAFE_componentWillMount == "function" && k.UNSAFE_componentWillMount(), X !== k.state && Ys.enqueueReplaceState(k, k.state, null), lc(p, x, k, D), yd(), k.state = p.memoizedState), typeof k.componentDidMount == "function" && (p.flags |= 4194308), x = !0;
    } else if (u === null) {
      k = p.stateNode;
      var oe = p.memoizedProps, me = Sd(v, oe);
      k.props = me;
      var ke = k.context, qe = v.contextType;
      X = go, typeof qe == "object" && qe !== null && (X = tt(qe));
      var et = v.getDerivedStateFromProps;
      qe = typeof et == "function" || typeof k.getSnapshotBeforeUpdate == "function", oe = p.pendingProps !== oe, qe || typeof k.UNSAFE_componentWillReceiveProps != "function" && typeof k.componentWillReceiveProps != "function" || (oe || ke !== X) && C3(
        p,
        k,
        x,
        X
      ), hu = !1;
      var Pe = p.memoizedState;
      k.state = Pe, lc(p, x, k, D), yd(), ke = p.memoizedState, oe || Pe !== ke || hu ? (typeof et == "function" && (Uf(
        p,
        v,
        et,
        x
      ), ke = p.memoizedState), (me = hu || R2(
        p,
        v,
        me,
        x,
        Pe,
        ke,
        X
      )) ? (qe || typeof k.UNSAFE_componentWillMount != "function" && typeof k.componentWillMount != "function" || (typeof k.componentWillMount == "function" && k.componentWillMount(), typeof k.UNSAFE_componentWillMount == "function" && k.UNSAFE_componentWillMount()), typeof k.componentDidMount == "function" && (p.flags |= 4194308)) : (typeof k.componentDidMount == "function" && (p.flags |= 4194308), p.memoizedProps = x, p.memoizedState = ke), k.props = x, k.state = ke, k.context = X, x = me) : (typeof k.componentDidMount == "function" && (p.flags |= 4194308), x = !1);
    } else {
      k = p.stateNode, gv(u, p), X = p.memoizedProps, qe = Sd(v, X), k.props = qe, et = p.pendingProps, Pe = k.context, ke = v.contextType, me = go, typeof ke == "object" && ke !== null && (me = tt(ke)), oe = v.getDerivedStateFromProps, (ke = typeof oe == "function" || typeof k.getSnapshotBeforeUpdate == "function") || typeof k.UNSAFE_componentWillReceiveProps != "function" && typeof k.componentWillReceiveProps != "function" || (X !== et || Pe !== me) && C3(
        p,
        k,
        x,
        me
      ), hu = !1, Pe = p.memoizedState, k.state = Pe, lc(p, x, k, D), yd();
      var Fe = p.memoizedState;
      X !== et || Pe !== Fe || hu || u !== null && u.dependencies !== null && Rf(u.dependencies) ? (typeof oe == "function" && (Uf(
        p,
        v,
        oe,
        x
      ), Fe = p.memoizedState), (qe = hu || R2(
        p,
        v,
        qe,
        x,
        Pe,
        Fe,
        me
      ) || u !== null && u.dependencies !== null && Rf(u.dependencies)) ? (ke || typeof k.UNSAFE_componentWillUpdate != "function" && typeof k.componentWillUpdate != "function" || (typeof k.componentWillUpdate == "function" && k.componentWillUpdate(x, Fe, me), typeof k.UNSAFE_componentWillUpdate == "function" && k.UNSAFE_componentWillUpdate(
        x,
        Fe,
        me
      )), typeof k.componentDidUpdate == "function" && (p.flags |= 4), typeof k.getSnapshotBeforeUpdate == "function" && (p.flags |= 1024)) : (typeof k.componentDidUpdate != "function" || X === u.memoizedProps && Pe === u.memoizedState || (p.flags |= 4), typeof k.getSnapshotBeforeUpdate != "function" || X === u.memoizedProps && Pe === u.memoizedState || (p.flags |= 1024), p.memoizedProps = x, p.memoizedState = Fe), k.props = x, k.state = Fe, k.context = me, x = qe) : (typeof k.componentDidUpdate != "function" || X === u.memoizedProps && Pe === u.memoizedState || (p.flags |= 4), typeof k.getSnapshotBeforeUpdate != "function" || X === u.memoizedProps && Pe === u.memoizedState || (p.flags |= 1024), x = !1);
    }
    return k = x, hs(u, p), x = (p.flags & 128) !== 0, k || x ? (k = p.stateNode, v = x && typeof v.getDerivedStateFromError != "function" ? null : k.render(), p.flags |= 1, u !== null && x ? (p.child = gd(
      p,
      u.child,
      null,
      D
    ), p.child = gd(
      p,
      null,
      v,
      D
    )) : Wr(u, p, v, D), p.memoizedState = k.state, u = p.child) : u = ms(
      u,
      p,
      D
    ), u;
  }
  function Ol(u, p, v, x) {
    return ud(), p.flags |= 256, Wr(u, p, v, x), p.child;
  }
  var Um = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function $m(u) {
    return { baseLanes: u, cachePool: Nf() };
  }
  function ps(u, p, v) {
    return u = u !== null ? u.childLanes & ~v : 0, p && (u |= Ao), u;
  }
  function B2(u, p, v) {
    var x = p.pendingProps, D = !1, k = (p.flags & 128) !== 0, X;
    if ((X = k) || (X = u !== null && u.memoizedState === null ? !1 : (ei.current & 2) !== 0), X && (D = !0, p.flags &= -129), X = (p.flags & 32) !== 0, p.flags &= -33, u === null) {
      if (Pn) {
        if (D ? cc(p) : Cl(), (u = Fr) ? (u = cA(
          u,
          Wi
        ), u = u !== null && u.data !== "&" ? u : null, u !== null && (p.memoizedState = {
          dehydrated: u,
          treeContext: Sl !== null ? { id: Fo, overflow: El } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, v = t2(u), v.return = p, p.child = v, fa = p, Fr = null)) : u = null, u === null)
          throw Gs(p);
        return Nd(u) ? p.lanes = 32 : p.lanes = 536870912, null;
      }
      var oe = x.children;
      return x = x.fallback, D ? (Cl(), D = p.mode, oe = Hm(
        { mode: "hidden", children: oe },
        D
      ), x = cu(
        x,
        D,
        v,
        null
      ), oe.return = p, x.return = p, oe.sibling = x, p.child = oe, x = p.child, x.memoizedState = $m(v), x.childLanes = ps(
        u,
        X,
        v
      ), p.memoizedState = Um, Ed(null, x)) : (cc(p), Ad(p, oe));
    }
    var me = u.memoizedState;
    if (me !== null && (oe = me.dehydrated, oe !== null)) {
      if (k)
        p.flags & 256 ? (cc(p), p.flags &= -257, p = $f(
          u,
          p,
          v
        )) : p.memoizedState !== null ? (Cl(), p.child = u.child, p.flags |= 128, p = null) : (Cl(), oe = x.fallback, D = p.mode, x = Hm(
          { mode: "visible", children: x.children },
          D
        ), oe = cu(
          oe,
          D,
          v,
          null
        ), oe.flags |= 2, x.return = p, oe.return = p, x.sibling = oe, p.child = x, gd(
          p,
          u.child,
          null,
          v
        ), x = p.child, x.memoizedState = $m(v), x.childLanes = ps(
          u,
          X,
          v
        ), p.memoizedState = Um, p = Ed(null, x));
      else if (cc(p), Nd(oe)) {
        if (X = oe.nextSibling && oe.nextSibling.dataset, X)
          var ke = X.dgst;
        X = ke, x = Error(r(419)), x.stack = "", x.digest = X, rp({ value: x, source: null, stack: null }), p = $f(
          u,
          p,
          v
        );
      } else if (ji || ha(u, p, v, !1), X = (v & u.childLanes) !== 0, ji || X) {
        if (X = _r, X !== null && (x = tn(X, v), x !== 0 && x !== me.retryLane))
          throw me.retryLane = x, su(u, x), Co(X, u, x), zv;
        Qs(oe) || ry(), p = $f(
          u,
          p,
          v
        );
      } else
        Qs(oe) ? (p.flags |= 192, p.child = u.child, p = null) : (u = me.treeContext, Fr = To(
          oe.nextSibling
        ), fa = p, Pn = !0, ic = null, Wi = !1, u !== null && vm(p, u), p = Ad(
          p,
          x.children
        ), p.flags |= 4096);
      return p;
    }
    return D ? (Cl(), oe = x.fallback, D = p.mode, me = u.child, ke = me.sibling, x = lu(me, {
      mode: "hidden",
      children: x.children
    }), x.subtreeFlags = me.subtreeFlags & 65011712, ke !== null ? oe = lu(
      ke,
      oe
    ) : (oe = cu(
      oe,
      D,
      v,
      null
    ), oe.flags |= 2), oe.return = p, x.return = p, x.sibling = oe, p.child = x, Ed(null, x), x = p.child, oe = u.child.memoizedState, oe === null ? oe = $m(v) : (D = oe.cachePool, D !== null ? (me = Ii._currentValue, D = D.parent !== me ? { parent: me, pool: me } : D) : D = Nf(), oe = {
      baseLanes: oe.baseLanes | v,
      cachePool: D
    }), x.memoizedState = oe, x.childLanes = ps(
      u,
      X,
      v
    ), p.memoizedState = Um, Ed(u.child, x)) : (cc(p), v = u.child, u = v.sibling, v = lu(v, {
      mode: "visible",
      children: x.children
    }), v.return = p, v.sibling = null, u !== null && (X = p.deletions, X === null ? (p.deletions = [u], p.flags |= 16) : X.push(u)), p.child = v, p.memoizedState = null, v);
  }
  function Ad(u, p) {
    return p = Hm(
      { mode: "visible", children: p },
      u.mode
    ), p.return = u, u.child = p;
  }
  function Hm(u, p) {
    return u = Ci(22, u, null, p), u.lanes = 0, u;
  }
  function $f(u, p, v) {
    return gd(p, u.child, null, v), u = Ad(
      p,
      p.pendingProps.children
    ), u.flags |= 2, p.memoizedState = null, u;
  }
  function Hf(u, p, v) {
    u.lanes |= p;
    var x = u.alternate;
    x !== null && (x.lanes |= p), pv(u.return, p, v);
  }
  function Vv(u, p, v, x, D, k) {
    var X = u.memoizedState;
    X === null ? u.memoizedState = {
      isBackwards: p,
      rendering: null,
      renderingStartTime: 0,
      last: x,
      tail: v,
      tailMode: D,
      treeForkCount: k
    } : (X.isBackwards = p, X.rendering = null, X.renderingStartTime = 0, X.last = x, X.tail = v, X.tailMode = D, X.treeForkCount = k);
  }
  function z2(u, p, v) {
    var x = p.pendingProps, D = x.revealOrder, k = x.tail;
    x = x.children;
    var X = ei.current, oe = (X & 2) !== 0;
    if (oe ? (X = X & 1 | 2, p.flags |= 128) : X &= 1, ae(ei, X), Wr(u, p, x, v), x = Pn ? Mi : 0, !oe && u !== null && u.flags & 128)
      e:
        for (u = p.child; u !== null; ) {
          if (u.tag === 13)
            u.memoizedState !== null && Hf(u, v, p);
          else if (u.tag === 19)
            Hf(u, v, p);
          else if (u.child !== null) {
            u.child.return = u, u = u.child;
            continue;
          }
          if (u === p)
            break e;
          for (; u.sibling === null; ) {
            if (u.return === null || u.return === p)
              break e;
            u = u.return;
          }
          u.sibling.return = u.return, u = u.sibling;
        }
    switch (D) {
      case "forwards":
        for (v = p.child, D = null; v !== null; )
          u = v.alternate, u !== null && cp(u) === null && (D = v), v = v.sibling;
        v = D, v === null ? (D = p.child, p.child = null) : (D = v.sibling, v.sibling = null), Vv(
          p,
          !1,
          D,
          v,
          k,
          x
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (v = null, D = p.child, p.child = null; D !== null; ) {
          if (u = D.alternate, u !== null && cp(u) === null) {
            p.child = D;
            break;
          }
          u = D.sibling, D.sibling = v, v = D, D = u;
        }
        Vv(
          p,
          !0,
          v,
          null,
          k,
          x
        );
        break;
      case "together":
        Vv(
          p,
          !1,
          null,
          null,
          void 0,
          x
        );
        break;
      default:
        p.memoizedState = null;
    }
    return p.child;
  }
  function ms(u, p, v) {
    if (u !== null && (p.dependencies = u.dependencies), Ml |= p.lanes, !(v & p.childLanes))
      if (u !== null) {
        if (ha(
          u,
          p,
          v,
          !1
        ), (v & p.childLanes) === 0)
          return null;
      } else
        return null;
    if (u !== null && p.child !== u.child)
      throw Error(r(153));
    if (p.child !== null) {
      for (u = p.child, v = lu(u, u.pendingProps), p.child = v, v.return = p; u.sibling !== null; )
        u = u.sibling, v = v.sibling = lu(u, u.pendingProps), v.return = p;
      v.sibling = null;
    }
    return p.child;
  }
  function Uv(u, p) {
    return u.lanes & p ? !0 : (u = u.dependencies, !!(u !== null && Rf(u)));
  }
  function $v(u, p, v) {
    switch (p.tag) {
      case 3:
        Se(p, p.stateNode.containerInfo), yo(p, Ii, u.memoizedState.cache), ud();
        break;
      case 27:
      case 5:
        Me(p);
        break;
      case 4:
        Se(p, p.stateNode.containerInfo);
        break;
      case 10:
        yo(
          p,
          p.type,
          p.memoizedProps.value
        );
        break;
      case 31:
        if (p.memoizedState !== null)
          return p.flags |= 128, lp(p), null;
        break;
      case 13:
        var x = p.memoizedState;
        if (x !== null)
          return x.dehydrated !== null ? (cc(p), p.flags |= 128, null) : v & p.child.childLanes ? B2(u, p, v) : (cc(p), u = ms(
            u,
            p,
            v
          ), u !== null ? u.sibling : null);
        cc(p);
        break;
      case 19:
        var D = (u.flags & 128) !== 0;
        if (x = (v & p.childLanes) !== 0, x || (ha(
          u,
          p,
          v,
          !1
        ), x = (v & p.childLanes) !== 0), D) {
          if (x)
            return z2(
              u,
              p,
              v
            );
          p.flags |= 128;
        }
        if (D = p.memoizedState, D !== null && (D.rendering = null, D.tail = null, D.lastEffect = null), ae(ei, ei.current), x)
          break;
        return null;
      case 22:
        return p.lanes = 0, T3(
          u,
          p,
          v,
          p.pendingProps
        );
      case 24:
        yo(p, Ii, u.memoizedState.cache);
    }
    return ms(u, p, v);
  }
  function F2(u, p, v) {
    if (u !== null)
      if (u.memoizedProps !== p.pendingProps)
        ji = !0;
      else {
        if (!Uv(u, v) && !(p.flags & 128))
          return ji = !1, $v(
            u,
            p,
            v
          );
        ji = !!(u.flags & 131072);
      }
    else
      ji = !1, Pn && p.flags & 1048576 && r2(p, Mi, p.index);
    switch (p.lanes = 0, p.tag) {
      case 16:
        e: {
          var x = p.pendingProps;
          if (u = hd(p.elementType), p.type = u, typeof u == "function")
            Tf(u) ? (x = Sd(u, x), p.tag = 1, p = L2(
              null,
              p,
              u,
              x,
              v
            )) : (p.tag = 0, p = Fv(
              null,
              p,
              u,
              x,
              v
            ));
          else {
            if (u != null) {
              var D = u.$$typeof;
              if (D === M) {
                p.tag = 11, p = k2(
                  null,
                  p,
                  u,
                  x,
                  v
                );
                break e;
              } else if (D === F) {
                p.tag = 14, p = j2(
                  null,
                  p,
                  u,
                  x,
                  v
                );
                break e;
              }
            }
            throw p = ee(u) || u, Error(r(306, p, ""));
          }
        }
        return p;
      case 0:
        return Fv(
          u,
          p,
          p.type,
          p.pendingProps,
          v
        );
      case 1:
        return x = p.type, D = Sd(
          x,
          p.pendingProps
        ), L2(
          u,
          p,
          x,
          D,
          v
        );
      case 3:
        e: {
          if (Se(
            p,
            p.stateNode.containerInfo
          ), u === null)
            throw Error(r(387));
          x = p.pendingProps;
          var k = p.memoizedState;
          D = k.element, gv(u, p), lc(p, x, null, v);
          var X = p.memoizedState;
          if (x = X.cache, yo(p, Ii, x), x !== k.cache && sc(
            p,
            [Ii],
            v,
            !0
          ), yd(), x = X.element, k.isDehydrated)
            if (k = {
              element: x,
              isDehydrated: !1,
              cache: X.cache
            }, p.updateQueue.baseState = k, p.memoizedState = k, p.flags & 256) {
              p = Ol(
                u,
                p,
                x,
                v
              );
              break e;
            } else if (x !== D) {
              D = ss(
                Error(r(424)),
                p
              ), rp(D), p = Ol(
                u,
                p,
                x,
                v
              );
              break e;
            } else {
              switch (u = p.stateNode.containerInfo, u.nodeType) {
                case 9:
                  u = u.body;
                  break;
                default:
                  u = u.nodeName === "HTML" ? u.ownerDocument.body : u;
              }
              for (Fr = To(u.firstChild), fa = p, Pn = !0, ic = null, Wi = !0, v = u2(
                p,
                null,
                x,
                v
              ), p.child = v; v; )
                v.flags = v.flags & -3 | 4096, v = v.sibling;
            }
          else {
            if (ud(), x === D) {
              p = ms(
                u,
                p,
                v
              );
              break e;
            }
            Wr(u, p, x, v);
          }
          p = p.child;
        }
        return p;
      case 26:
        return hs(u, p), u === null ? (v = Bp(
          p.type,
          null,
          p.pendingProps,
          null
        )) ? p.memoizedState = v : Pn || (v = p.type, u = p.pendingProps, x = Dd(
          _e.current
        ).createElement(v), x[Rn] = p, x[ca] = u, Da(x, v, u), on(x), p.stateNode = x) : p.memoizedState = Bp(
          p.type,
          u.memoizedProps,
          p.pendingProps,
          u.memoizedState
        ), null;
      case 27:
        return Me(p), u === null && Pn && (x = p.stateNode = Pp(
          p.type,
          p.pendingProps,
          _e.current
        ), fa = p, Wi = !0, D = Fr, kl(p.type) ? (c1 = D, Fr = To(x.firstChild)) : Fr = D), Wr(
          u,
          p,
          p.pendingProps.children,
          v
        ), hs(u, p), u === null && (p.flags |= 4194304), p.child;
      case 5:
        return u === null && Pn && ((D = x = Fr) && (x = $O(
          x,
          p.type,
          p.pendingProps,
          Wi
        ), x !== null ? (p.stateNode = x, fa = p, Fr = To(x.firstChild), Wi = !1, D = !0) : D = !1), D || Gs(p)), Me(p), D = p.type, k = p.pendingProps, X = u !== null ? u.memoizedProps : null, x = k.children, kp(D, k) ? x = null : X !== null && kp(D, X) && (p.flags |= 32), p.memoizedState !== null && (D = Dm(
          u,
          p,
          zO,
          null,
          null,
          v
        ), f1._currentValue = D), hs(u, p), Wr(u, p, x, v), p.child;
      case 6:
        return u === null && Pn && ((u = v = Fr) && (v = yn(
          v,
          p.pendingProps,
          Wi
        ), v !== null ? (p.stateNode = v, fa = p, Fr = null, u = !0) : u = !1), u || Gs(p)), null;
      case 13:
        return B2(u, p, v);
      case 4:
        return Se(
          p,
          p.stateNode.containerInfo
        ), x = p.pendingProps, u === null ? p.child = gd(
          p,
          null,
          x,
          v
        ) : Wr(u, p, x, v), p.child;
      case 11:
        return k2(
          u,
          p,
          p.type,
          p.pendingProps,
          v
        );
      case 7:
        return Wr(
          u,
          p,
          p.pendingProps,
          v
        ), p.child;
      case 8:
        return Wr(
          u,
          p,
          p.pendingProps.children,
          v
        ), p.child;
      case 12:
        return Wr(
          u,
          p,
          p.pendingProps.children,
          v
        ), p.child;
      case 10:
        return x = p.pendingProps, yo(p, p.type, x.value), Wr(u, p, x.children, v), p.child;
      case 9:
        return D = p.type._context, x = p.pendingProps.children, nn(p), D = tt(D), x = x(D), p.flags |= 1, Wr(u, p, x, v), p.child;
      case 14:
        return j2(
          u,
          p,
          p.type,
          p.pendingProps,
          v
        );
      case 15:
        return P2(
          u,
          p,
          p.type,
          p.pendingProps,
          v
        );
      case 19:
        return z2(u, p, v);
      case 31:
        return O3(u, p, v);
      case 22:
        return T3(
          u,
          p,
          v,
          p.pendingProps
        );
      case 24:
        return nn(p), x = tt(Ii), u === null ? (D = us(), D === null && (D = _r, k = wm(), D.pooledCache = k, k.refCount++, k !== null && (D.pooledCacheLanes |= v), D = k), p.memoizedState = { parent: x, cache: D }, Tm(p), yo(p, Ii, D)) : (u.lanes & v && (gv(u, p), lc(p, null, null, v), yd()), D = u.memoizedState, k = p.memoizedState, D.parent !== x ? (D = { parent: x, cache: x }, p.memoizedState = D, p.lanes === 0 && (p.memoizedState = p.updateQueue.baseState = D), yo(p, Ii, x)) : (x = k.cache, yo(p, Ii, x), x !== D.cache && sc(
          p,
          [Ii],
          v,
          !0
        ))), Wr(
          u,
          p,
          p.pendingProps.children,
          v
        ), p.child;
      case 29:
        throw p.pendingProps;
    }
    throw Error(r(156, p.tag));
  }
  function mc(u) {
    u.flags |= 4;
  }
  function V2(u, p, v, x, D) {
    if ((p = (u.mode & 32) !== 0) && (p = !1), p) {
      if (u.flags |= 16777216, (D & 335544128) === D)
        if (u.stateNode.complete)
          u.flags |= 8192;
        else if (B3())
          u.flags |= 8192;
        else
          throw pd = If, Mf;
    } else
      u.flags &= -16777217;
  }
  function U2(u, p) {
    if (p.type !== "stylesheet" || p.state.loading & 4)
      u.flags &= -16777217;
    else if (u.flags |= 16777216, !Go(p))
      if (B3())
        u.flags |= 8192;
      else
        throw pd = If, Mf;
  }
  function Za(u, p) {
    p !== null && (u.flags |= 4), u.flags & 16384 && (p = u.tag !== 22 ? en() : 536870912, u.lanes |= p, ui |= p);
  }
  function vp(u, p) {
    if (!Pn)
      switch (u.tailMode) {
        case "hidden":
          p = u.tail;
          for (var v = null; p !== null; )
            p.alternate !== null && (v = p), p = p.sibling;
          v === null ? u.tail = null : v.sibling = null;
          break;
        case "collapsed":
          v = u.tail;
          for (var x = null; v !== null; )
            v.alternate !== null && (x = v), v = v.sibling;
          x === null ? p || u.tail === null ? u.tail = null : u.tail.sibling = null : x.sibling = null;
      }
  }
  function Kt(u) {
    var p = u.alternate !== null && u.alternate.child === u.child, v = 0, x = 0;
    if (p)
      for (var D = u.child; D !== null; )
        v |= D.lanes | D.childLanes, x |= D.subtreeFlags & 65011712, x |= D.flags & 65011712, D.return = u, D = D.sibling;
    else
      for (D = u.child; D !== null; )
        v |= D.lanes | D.childLanes, x |= D.subtreeFlags, x |= D.flags, D.return = u, D = D.sibling;
    return u.subtreeFlags |= x, u.childLanes = v, p;
  }
  function R3(u, p, v) {
    var x = p.pendingProps;
    switch (fv(p), p.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Kt(p), null;
      case 1:
        return Kt(p), null;
      case 3:
        return v = p.stateNode, x = null, u !== null && (x = u.memoizedState.cache), p.memoizedState.cache !== x && (p.flags |= 2048), Al(Ii), Ne(), v.pendingContext && (v.context = v.pendingContext, v.pendingContext = null), (u === null || u.child === null) && (oc(p) ? mc(p) : u === null || u.memoizedState.isDehydrated && !(p.flags & 256) || (p.flags |= 1024, i2())), Kt(p), null;
      case 26:
        var D = p.type, k = p.memoizedState;
        return u === null ? (mc(p), k !== null ? (Kt(p), U2(p, k)) : (Kt(p), V2(
          p,
          D,
          null,
          x,
          v
        ))) : k ? k !== u.memoizedState ? (mc(p), Kt(p), U2(p, k)) : (Kt(p), p.flags &= -16777217) : (u = u.memoizedProps, u !== x && mc(p), Kt(p), V2(
          p,
          D,
          u,
          x,
          v
        )), null;
      case 27:
        if (Ce(p), v = _e.current, D = p.type, u !== null && p.stateNode != null)
          u.memoizedProps !== x && mc(p);
        else {
          if (!x) {
            if (p.stateNode === null)
              throw Error(r(166));
            return Kt(p), null;
          }
          u = le.current, oc(p) ? ym(p) : (u = Pp(D, x, v), p.stateNode = u, mc(p));
        }
        return Kt(p), null;
      case 5:
        if (Ce(p), D = p.type, u !== null && p.stateNode != null)
          u.memoizedProps !== x && mc(p);
        else {
          if (!x) {
            if (p.stateNode === null)
              throw Error(r(166));
            return Kt(p), null;
          }
          if (k = le.current, oc(p))
            ym(p);
          else {
            var X = Dd(
              _e.current
            );
            switch (k) {
              case 1:
                k = X.createElementNS(
                  "http://www.w3.org/2000/svg",
                  D
                );
                break;
              case 2:
                k = X.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  D
                );
                break;
              default:
                switch (D) {
                  case "svg":
                    k = X.createElementNS(
                      "http://www.w3.org/2000/svg",
                      D
                    );
                    break;
                  case "math":
                    k = X.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      D
                    );
                    break;
                  case "script":
                    k = X.createElement("div"), k.innerHTML = "<script><\/script>", k = k.removeChild(
                      k.firstChild
                    );
                    break;
                  case "select":
                    k = typeof x.is == "string" ? X.createElement("select", {
                      is: x.is
                    }) : X.createElement("select"), x.multiple ? k.multiple = !0 : x.size && (k.size = x.size);
                    break;
                  default:
                    k = typeof x.is == "string" ? X.createElement(D, { is: x.is }) : X.createElement(D);
                }
            }
            k[Rn] = p, k[ca] = x;
            e:
              for (X = p.child; X !== null; ) {
                if (X.tag === 5 || X.tag === 6)
                  k.appendChild(X.stateNode);
                else if (X.tag !== 4 && X.tag !== 27 && X.child !== null) {
                  X.child.return = X, X = X.child;
                  continue;
                }
                if (X === p)
                  break e;
                for (; X.sibling === null; ) {
                  if (X.return === null || X.return === p)
                    break e;
                  X = X.return;
                }
                X.sibling.return = X.return, X = X.sibling;
              }
            p.stateNode = k;
            e:
              switch (Da(k, D, x), D) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  x = !!x.autoFocus;
                  break e;
                case "img":
                  x = !0;
                  break e;
                default:
                  x = !1;
              }
            x && mc(p);
          }
        }
        return Kt(p), V2(
          p,
          p.type,
          u === null ? null : u.memoizedProps,
          p.pendingProps,
          v
        ), null;
      case 6:
        if (u && p.stateNode != null)
          u.memoizedProps !== x && mc(p);
        else {
          if (typeof x != "string" && p.stateNode === null)
            throw Error(r(166));
          if (u = _e.current, oc(p)) {
            if (u = p.stateNode, v = p.memoizedProps, x = null, D = fa, D !== null)
              switch (D.tag) {
                case 27:
                case 5:
                  x = D.memoizedProps;
              }
            u[Rn] = p, u = !!(u.nodeValue === v || x !== null && x.suppressHydrationWarning === !0 || fx(u.nodeValue, v)), u || Gs(p, !0);
          } else
            u = Dd(u).createTextNode(
              x
            ), u[Rn] = p, p.stateNode = u;
        }
        return Kt(p), null;
      case 31:
        if (v = p.memoizedState, u === null || u.memoizedState !== null) {
          if (x = oc(p), v !== null) {
            if (u === null) {
              if (!x)
                throw Error(r(318));
              if (u = p.memoizedState, u = u !== null ? u.dehydrated : null, !u)
                throw Error(r(557));
              u[Rn] = p;
            } else
              ud(), !(p.flags & 128) && (p.memoizedState = null), p.flags |= 4;
            Kt(p), u = !1;
          } else
            v = i2(), u !== null && u.memoizedState !== null && (u.memoizedState.hydrationErrors = v), u = !0;
          if (!u)
            return p.flags & 256 ? (wo(p), p) : (wo(p), null);
          if (p.flags & 128)
            throw Error(r(558));
        }
        return Kt(p), null;
      case 13:
        if (x = p.memoizedState, u === null || u.memoizedState !== null && u.memoizedState.dehydrated !== null) {
          if (D = oc(p), x !== null && x.dehydrated !== null) {
            if (u === null) {
              if (!D)
                throw Error(r(318));
              if (D = p.memoizedState, D = D !== null ? D.dehydrated : null, !D)
                throw Error(r(317));
              D[Rn] = p;
            } else
              ud(), !(p.flags & 128) && (p.memoizedState = null), p.flags |= 4;
            Kt(p), D = !1;
          } else
            D = i2(), u !== null && u.memoizedState !== null && (u.memoizedState.hydrationErrors = D), D = !0;
          if (!D)
            return p.flags & 256 ? (wo(p), p) : (wo(p), null);
        }
        return wo(p), p.flags & 128 ? (p.lanes = v, p) : (v = x !== null, u = u !== null && u.memoizedState !== null, v && (x = p.child, D = null, x.alternate !== null && x.alternate.memoizedState !== null && x.alternate.memoizedState.cachePool !== null && (D = x.alternate.memoizedState.cachePool.pool), k = null, x.memoizedState !== null && x.memoizedState.cachePool !== null && (k = x.memoizedState.cachePool.pool), k !== D && (x.flags |= 2048)), v !== u && v && (p.child.flags |= 8192), Za(p, p.updateQueue), Kt(p), null);
      case 4:
        return Ne(), u === null && Ip(p.stateNode.containerInfo), Kt(p), null;
      case 10:
        return Al(p.type), Kt(p), null;
      case 19:
        if (te(ei), x = p.memoizedState, x === null)
          return Kt(p), null;
        if (D = (p.flags & 128) !== 0, k = x.rendering, k === null)
          if (D)
            vp(x, !1);
          else {
            if (Ur !== 0 || u !== null && u.flags & 128)
              for (u = p.child; u !== null; ) {
                if (k = cp(u), k !== null) {
                  for (p.flags |= 128, vp(x, !1), u = k.updateQueue, p.updateQueue = u, Za(p, u), p.subtreeFlags = 0, u = v, v = p.child; v !== null; )
                    e2(v, u), v = v.sibling;
                  return ae(
                    ei,
                    ei.current & 1 | 2
                  ), Pn && qs(p, x.treeForkCount), p.child;
                }
                u = u.sibling;
              }
            x.tail !== null && $e() > cr && (p.flags |= 128, D = !0, vp(x, !1), p.lanes = 4194304);
          }
        else {
          if (!D)
            if (u = cp(k), u !== null) {
              if (p.flags |= 128, D = !0, u = u.updateQueue, p.updateQueue = u, Za(p, u), vp(x, !0), x.tail === null && x.tailMode === "hidden" && !k.alternate && !Pn)
                return Kt(p), null;
            } else
              2 * $e() - x.renderingStartTime > cr && v !== 536870912 && (p.flags |= 128, D = !0, vp(x, !1), p.lanes = 4194304);
          x.isBackwards ? (k.sibling = p.child, p.child = k) : (u = x.last, u !== null ? u.sibling = k : p.child = k, x.last = k);
        }
        return x.tail !== null ? (u = x.tail, x.rendering = u, x.tail = u.sibling, x.renderingStartTime = $e(), u.sibling = null, v = ei.current, ae(
          ei,
          D ? v & 1 | 2 : v & 1
        ), Pn && qs(p, x.treeForkCount), u) : (Kt(p), null);
      case 22:
      case 23:
        return wo(p), sp(), x = p.memoizedState !== null, u !== null ? u.memoizedState !== null !== x && (p.flags |= 8192) : x && (p.flags |= 8192), x ? v & 536870912 && !(p.flags & 128) && (Kt(p), p.subtreeFlags & 6 && (p.flags |= 8192)) : Kt(p), v = p.updateQueue, v !== null && Za(p, v.retryQueue), v = null, u !== null && u.memoizedState !== null && u.memoizedState.cachePool !== null && (v = u.memoizedState.cachePool.pool), x = null, p.memoizedState !== null && p.memoizedState.cachePool !== null && (x = p.memoizedState.cachePool.pool), x !== v && (p.flags |= 2048), u !== null && te(cs), null;
      case 24:
        return v = null, u !== null && (v = u.memoizedState.cache), p.memoizedState.cache !== v && (p.flags |= 2048), Al(Ii), Kt(p), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(r(156, p.tag));
  }
  function D3(u, p) {
    switch (fv(p), p.tag) {
      case 1:
        return u = p.flags, u & 65536 ? (p.flags = u & -65537 | 128, p) : null;
      case 3:
        return Al(Ii), Ne(), u = p.flags, u & 65536 && !(u & 128) ? (p.flags = u & -65537 | 128, p) : null;
      case 26:
      case 27:
      case 5:
        return Ce(p), null;
      case 31:
        if (p.memoizedState !== null) {
          if (wo(p), p.alternate === null)
            throw Error(r(340));
          ud();
        }
        return u = p.flags, u & 65536 ? (p.flags = u & -65537 | 128, p) : null;
      case 13:
        if (wo(p), u = p.memoizedState, u !== null && u.dehydrated !== null) {
          if (p.alternate === null)
            throw Error(r(340));
          ud();
        }
        return u = p.flags, u & 65536 ? (p.flags = u & -65537 | 128, p) : null;
      case 19:
        return te(ei), null;
      case 4:
        return Ne(), null;
      case 10:
        return Al(p.type), null;
      case 22:
      case 23:
        return wo(p), sp(), u !== null && te(cs), u = p.flags, u & 65536 ? (p.flags = u & -65537 | 128, p) : null;
      case 24:
        return Al(Ii), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function N3(u, p) {
    switch (fv(p), p.tag) {
      case 3:
        Al(Ii), Ne();
        break;
      case 26:
      case 27:
      case 5:
        Ce(p);
        break;
      case 4:
        Ne();
        break;
      case 31:
        p.memoizedState !== null && wo(p);
        break;
      case 13:
        wo(p);
        break;
      case 19:
        te(ei);
        break;
      case 10:
        Al(p.type);
        break;
      case 22:
      case 23:
        wo(p), sp(), u !== null && te(cs);
        break;
      case 24:
        Al(Ii);
    }
  }
  function Xs(u, p) {
    try {
      var v = p.updateQueue, x = v !== null ? v.lastEffect : null;
      if (x !== null) {
        var D = x.next;
        v = D;
        do {
          if ((v.tag & u) === u) {
            x = void 0;
            var k = v.create, X = v.inst;
            x = k(), X.destroy = x;
          }
          v = v.next;
        } while (v !== D);
      }
    } catch (oe) {
      mr(p, p.return, oe);
    }
  }
  function gs(u, p, v) {
    try {
      var x = p.updateQueue, D = x !== null ? x.lastEffect : null;
      if (D !== null) {
        var k = D.next;
        x = k;
        do {
          if ((x.tag & u) === u) {
            var X = x.inst, oe = X.destroy;
            if (oe !== void 0) {
              X.destroy = void 0, D = p;
              var me = v, ke = oe;
              try {
                ke();
              } catch (qe) {
                mr(
                  D,
                  me,
                  qe
                );
              }
            }
          }
          x = x.next;
        } while (x !== k);
      }
    } catch (qe) {
      mr(p, p.return, qe);
    }
  }
  function Hv(u) {
    var p = u.updateQueue;
    if (p !== null) {
      var v = u.stateNode;
      try {
        bd(p, v);
      } catch (x) {
        mr(u, u.return, x);
      }
    }
  }
  function Cd(u, p, v) {
    v.props = Sd(
      u.type,
      u.memoizedProps
    ), v.state = u.memoizedState;
    try {
      v.componentWillUnmount();
    } catch (x) {
      mr(u, p, x);
    }
  }
  function gc(u, p) {
    try {
      var v = u.ref;
      if (v !== null) {
        switch (u.tag) {
          case 26:
          case 27:
          case 5:
            var x = u.stateNode;
            break;
          case 30:
            x = u.stateNode;
            break;
          default:
            x = u.stateNode;
        }
        typeof v == "function" ? u.refCleanup = v(x) : v.current = x;
      }
    } catch (D) {
      mr(u, p, D);
    }
  }
  function Rl(u, p) {
    var v = u.ref, x = u.refCleanup;
    if (v !== null)
      if (typeof x == "function")
        try {
          x();
        } catch (D) {
          mr(u, p, D);
        } finally {
          u.refCleanup = null, u = u.alternate, u != null && (u.refCleanup = null);
        }
      else if (typeof v == "function")
        try {
          v(null);
        } catch (D) {
          mr(u, p, D);
        }
      else
        v.current = null;
  }
  function $2(u) {
    var p = u.type, v = u.memoizedProps, x = u.stateNode;
    try {
      e:
        switch (p) {
          case "button":
          case "input":
          case "select":
          case "textarea":
            v.autoFocus && x.focus();
            break e;
          case "img":
            v.src ? x.src = v.src : v.srcSet && (x.srcset = v.srcSet);
        }
    } catch (D) {
      mr(u, u.return, D);
    }
  }
  function qv(u, p, v) {
    try {
      var x = u.stateNode;
      px(x, u.type, v, p), x[ca] = p;
    } catch (D) {
      mr(u, u.return, D);
    }
  }
  function H2(u) {
    return u.tag === 5 || u.tag === 3 || u.tag === 26 || u.tag === 27 && kl(u.type) || u.tag === 4;
  }
  function yp(u) {
    e:
      for (; ; ) {
        for (; u.sibling === null; ) {
          if (u.return === null || H2(u.return))
            return null;
          u = u.return;
        }
        for (u.sibling.return = u.return, u = u.sibling; u.tag !== 5 && u.tag !== 6 && u.tag !== 18; ) {
          if (u.tag === 27 && kl(u.type) || u.flags & 2 || u.child === null || u.tag === 4)
            continue e;
          u.child.return = u, u = u.child;
        }
        if (!(u.flags & 2))
          return u.stateNode;
      }
  }
  function bp(u, p, v) {
    var x = u.tag;
    if (x === 5 || x === 6)
      u = u.stateNode, p ? (v.nodeType === 9 ? v.body : v.nodeName === "HTML" ? v.ownerDocument.body : v).insertBefore(u, p) : (p = v.nodeType === 9 ? v.body : v.nodeName === "HTML" ? v.ownerDocument.body : v, p.appendChild(u), v = v._reactRootContainer, v != null || p.onclick !== null || (p.onclick = ml));
    else if (x !== 4 && (x === 27 && kl(u.type) && (v = u.stateNode, p = null), u = u.child, u !== null))
      for (bp(u, p, v), u = u.sibling; u !== null; )
        bp(u, p, v), u = u.sibling;
  }
  function wp(u, p, v) {
    var x = u.tag;
    if (x === 5 || x === 6)
      u = u.stateNode, p ? v.insertBefore(u, p) : v.appendChild(u);
    else if (x !== 4 && (x === 27 && kl(u.type) && (v = u.stateNode), u = u.child, u !== null))
      for (wp(u, p, v), u = u.sibling; u !== null; )
        wp(u, p, v), u = u.sibling;
  }
  function q2(u) {
    var p = u.stateNode, v = u.memoizedProps;
    try {
      for (var x = u.type, D = p.attributes; D.length; )
        p.removeAttributeNode(D[0]);
      Da(p, x, v), p[Rn] = u, p[ca] = v;
    } catch (k) {
      mr(u, u.return, k);
    }
  }
  var yu = !1, Gi = !1, Gv = !1, G2 = typeof WeakSet == "function" ? WeakSet : Set, ga = null;
  function xp(u, p) {
    if (u = u.containerInfo, fy = Ki, u = sd(u), dm(u)) {
      if ("selectionStart" in u)
        var v = {
          start: u.selectionStart,
          end: u.selectionEnd
        };
      else
        e: {
          v = (v = u.ownerDocument) && v.defaultView || window;
          var x = v.getSelection && v.getSelection();
          if (x && x.rangeCount !== 0) {
            v = x.anchorNode;
            var D = x.anchorOffset, k = x.focusNode;
            x = x.focusOffset;
            try {
              v.nodeType, k.nodeType;
            } catch {
              v = null;
              break e;
            }
            var X = 0, oe = -1, me = -1, ke = 0, qe = 0, et = u, Pe = null;
            t:
              for (; ; ) {
                for (var Fe; et !== v || D !== 0 && et.nodeType !== 3 || (oe = X + D), et !== k || x !== 0 && et.nodeType !== 3 || (me = X + x), et.nodeType === 3 && (X += et.nodeValue.length), (Fe = et.firstChild) !== null; )
                  Pe = et, et = Fe;
                for (; ; ) {
                  if (et === u)
                    break t;
                  if (Pe === v && ++ke === D && (oe = X), Pe === k && ++qe === x && (me = X), (Fe = et.nextSibling) !== null)
                    break;
                  et = Pe, Pe = et.parentNode;
                }
                et = Fe;
              }
            v = oe === -1 || me === -1 ? null : { start: oe, end: me };
          } else
            v = null;
        }
      v = v || { start: 0, end: 0 };
    } else
      v = null;
    for (hy = { focusedElem: u, selectionRange: v }, Ki = !1, ga = p; ga !== null; )
      if (p = ga, u = p.child, (p.subtreeFlags & 1028) !== 0 && u !== null)
        u.return = p, ga = u;
      else
        for (; ga !== null; ) {
          switch (p = ga, k = p.alternate, u = p.flags, p.tag) {
            case 0:
              if (u & 4 && (u = p.updateQueue, u = u !== null ? u.events : null, u !== null))
                for (v = 0; v < u.length; v++)
                  D = u[v], D.ref.impl = D.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if (u & 1024 && k !== null) {
                u = void 0, v = p, D = k.memoizedProps, k = k.memoizedState, x = v.stateNode;
                try {
                  var Et = Sd(
                    v.type,
                    D
                  );
                  u = x.getSnapshotBeforeUpdate(
                    Et,
                    k
                  ), x.__reactInternalSnapshotBeforeUpdate = u;
                } catch (Ut) {
                  mr(
                    v,
                    v.return,
                    Ut
                  );
                }
              }
              break;
            case 3:
              if (u & 1024) {
                if (u = p.stateNode.containerInfo, v = u.nodeType, v === 9)
                  l1(u);
                else if (v === 1)
                  switch (u.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      l1(u);
                      break;
                    default:
                      u.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if (u & 1024)
                throw Error(r(163));
          }
          if (u = p.sibling, u !== null) {
            u.return = p.return, ga = u;
            break;
          }
          ga = p.return;
        }
  }
  function qm(u, p, v) {
    var x = v.flags;
    switch (v.tag) {
      case 0:
      case 11:
      case 15:
        bu(u, v), x & 4 && Xs(5, v);
        break;
      case 1:
        if (bu(u, v), x & 4)
          if (u = v.stateNode, p === null)
            try {
              u.componentDidMount();
            } catch (X) {
              mr(v, v.return, X);
            }
          else {
            var D = Sd(
              v.type,
              p.memoizedProps
            );
            p = p.memoizedState;
            try {
              u.componentDidUpdate(
                D,
                p,
                u.__reactInternalSnapshotBeforeUpdate
              );
            } catch (X) {
              mr(
                v,
                v.return,
                X
              );
            }
          }
        x & 64 && Hv(v), x & 512 && gc(v, v.return);
        break;
      case 3:
        if (bu(u, v), x & 64 && (u = v.updateQueue, u !== null)) {
          if (p = null, v.child !== null)
            switch (v.child.tag) {
              case 27:
              case 5:
                p = v.child.stateNode;
                break;
              case 1:
                p = v.child.stateNode;
            }
          try {
            bd(u, p);
          } catch (X) {
            mr(v, v.return, X);
          }
        }
        break;
      case 27:
        p === null && x & 4 && q2(v);
      case 26:
      case 5:
        bu(u, v), p === null && x & 4 && $2(v), x & 512 && gc(v, v.return);
        break;
      case 12:
        bu(u, v);
        break;
      case 31:
        bu(u, v), x & 4 && M3(u, v);
        break;
      case 13:
        bu(u, v), x & 4 && W2(u, v), x & 64 && (u = v.memoizedState, u !== null && (u = u.dehydrated, u !== null && (v = vs.bind(
          null,
          v
        ), jp(u, v))));
        break;
      case 22:
        if (x = v.memoizedState !== null || yu, !x) {
          p = p !== null && p.memoizedState !== null || Gi, D = yu;
          var k = Gi;
          yu = x, (Gi = p) && !k ? Dl(
            u,
            v,
            (v.subtreeFlags & 8772) !== 0
          ) : bu(u, v), yu = D, Gi = k;
        }
        break;
      case 30:
        break;
      default:
        bu(u, v);
    }
  }
  function Y2(u) {
    var p = u.alternate;
    p !== null && (u.alternate = null, Y2(p)), u.child = null, u.deletions = null, u.sibling = null, u.tag === 5 && (p = u.stateNode, p !== null && ot(p)), u.stateNode = null, u.return = null, u.dependencies = null, u.memoizedProps = null, u.memoizedState = null, u.pendingProps = null, u.stateNode = null, u.updateQueue = null;
  }
  var Vr = null, Eo = !1;
  function vc(u, p, v) {
    for (v = v.child; v !== null; )
      X2(u, p, v), v = v.sibling;
  }
  function X2(u, p, v) {
    if (kn && typeof kn.onCommitFiberUnmount == "function")
      try {
        kn.onCommitFiberUnmount(ar, v);
      } catch {
      }
    switch (v.tag) {
      case 26:
        Gi || Rl(v, p), vc(
          u,
          p,
          v
        ), v.memoizedState ? v.memoizedState.count-- : v.stateNode && (v = v.stateNode, v.parentNode.removeChild(v));
        break;
      case 27:
        Gi || Rl(v, p);
        var x = Vr, D = Eo;
        kl(v.type) && (Vr = v.stateNode, Eo = !1), vc(
          u,
          p,
          v
        ), Kf(v.stateNode), Vr = x, Eo = D;
        break;
      case 5:
        Gi || Rl(v, p);
      case 6:
        if (x = Vr, D = Eo, Vr = null, vc(
          u,
          p,
          v
        ), Vr = x, Eo = D, Vr !== null)
          if (Eo)
            try {
              (Vr.nodeType === 9 ? Vr.body : Vr.nodeName === "HTML" ? Vr.ownerDocument.body : Vr).removeChild(v.stateNode);
            } catch (k) {
              mr(
                v,
                p,
                k
              );
            }
          else
            try {
              Vr.removeChild(v.stateNode);
            } catch (k) {
              mr(
                v,
                p,
                k
              );
            }
        break;
      case 18:
        Vr !== null && (Eo ? (u = Vr, yx(
          u.nodeType === 9 ? u.body : u.nodeName === "HTML" ? u.ownerDocument.body : u,
          v.stateNode
        ), Gp(u)) : yx(Vr, v.stateNode));
        break;
      case 4:
        x = Vr, D = Eo, Vr = v.stateNode.containerInfo, Eo = !0, vc(
          u,
          p,
          v
        ), Vr = x, Eo = D;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        gs(2, v, p), Gi || gs(4, v, p), vc(
          u,
          p,
          v
        );
        break;
      case 1:
        Gi || (Rl(v, p), x = v.stateNode, typeof x.componentWillUnmount == "function" && Cd(
          v,
          p,
          x
        )), vc(
          u,
          p,
          v
        );
        break;
      case 21:
        vc(
          u,
          p,
          v
        );
        break;
      case 22:
        Gi = (x = Gi) || v.memoizedState !== null, vc(
          u,
          p,
          v
        ), Gi = x;
        break;
      default:
        vc(
          u,
          p,
          v
        );
    }
  }
  function M3(u, p) {
    if (p.memoizedState === null && (u = p.alternate, u !== null && (u = u.memoizedState, u !== null))) {
      u = u.dehydrated;
      try {
        Gp(u);
      } catch (v) {
        mr(p, p.return, v);
      }
    }
  }
  function W2(u, p) {
    if (p.memoizedState === null && (u = p.alternate, u !== null && (u = u.memoizedState, u !== null && (u = u.dehydrated, u !== null))))
      try {
        Gp(u);
      } catch (v) {
        mr(p, p.return, v);
      }
  }
  function Gm(u) {
    switch (u.tag) {
      case 31:
      case 13:
      case 19:
        var p = u.stateNode;
        return p === null && (p = u.stateNode = new G2()), p;
      case 22:
        return u = u.stateNode, p = u._retryCache, p === null && (p = u._retryCache = new G2()), p;
      default:
        throw Error(r(435, u.tag));
    }
  }
  function Ym(u, p) {
    var v = Gm(u);
    p.forEach(function(x) {
      if (!v.has(x)) {
        v.add(x);
        var D = J3.bind(null, u, x);
        x.then(D, D);
      }
    });
  }
  function _o(u, p) {
    var v = p.deletions;
    if (v !== null)
      for (var x = 0; x < v.length; x++) {
        var D = v[x], k = u, X = p, oe = X;
        e:
          for (; oe !== null; ) {
            switch (oe.tag) {
              case 27:
                if (kl(oe.type)) {
                  Vr = oe.stateNode, Eo = !1;
                  break e;
                }
                break;
              case 5:
                Vr = oe.stateNode, Eo = !1;
                break e;
              case 3:
              case 4:
                Vr = oe.stateNode.containerInfo, Eo = !0;
                break e;
            }
            oe = oe.return;
          }
        if (Vr === null)
          throw Error(r(160));
        X2(k, X, D), Vr = null, Eo = !1, k = D.alternate, k !== null && (k.return = null), D.return = null;
      }
    if (p.subtreeFlags & 13886)
      for (p = p.child; p !== null; )
        Yv(p, u), p = p.sibling;
  }
  var pn = null;
  function Yv(u, p) {
    var v = u.alternate, x = u.flags;
    switch (u.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        _o(p, u), Vo(u), x & 4 && (gs(3, u, u.return), Xs(3, u), gs(5, u, u.return));
        break;
      case 1:
        _o(p, u), Vo(u), x & 512 && (Gi || v === null || Rl(v, v.return)), x & 64 && yu && (u = u.updateQueue, u !== null && (x = u.callbacks, x !== null && (v = u.shared.hiddenCallbacks, u.shared.hiddenCallbacks = v === null ? x : v.concat(x))));
        break;
      case 26:
        var D = pn;
        if (_o(p, u), Vo(u), x & 512 && (Gi || v === null || Rl(v, v.return)), x & 4) {
          var k = v !== null ? v.memoizedState : null;
          if (x = u.memoizedState, v === null)
            if (x === null)
              if (u.stateNode === null) {
                e: {
                  x = u.type, v = u.memoizedProps, D = D.ownerDocument || D;
                  t:
                    switch (x) {
                      case "title":
                        k = D.getElementsByTagName("title")[0], (!k || k[we] || k[Rn] || k.namespaceURI === "http://www.w3.org/2000/svg" || k.hasAttribute("itemprop")) && (k = D.createElement(x), D.head.insertBefore(
                          k,
                          D.querySelector("head > title")
                        )), Da(k, x, v), k[Rn] = u, on(k), x = k;
                        break e;
                      case "link":
                        var X = Sx(
                          "link",
                          "href",
                          D
                        ).get(x + (v.href || ""));
                        if (X) {
                          for (var oe = 0; oe < X.length; oe++)
                            if (k = X[oe], k.getAttribute("href") === (v.href == null || v.href === "" ? null : v.href) && k.getAttribute("rel") === (v.rel == null ? null : v.rel) && k.getAttribute("title") === (v.title == null ? null : v.title) && k.getAttribute("crossorigin") === (v.crossOrigin == null ? null : v.crossOrigin)) {
                              X.splice(oe, 1);
                              break t;
                            }
                        }
                        k = D.createElement(x), Da(k, x, v), D.head.appendChild(k);
                        break;
                      case "meta":
                        if (X = Sx(
                          "meta",
                          "content",
                          D
                        ).get(x + (v.content || ""))) {
                          for (oe = 0; oe < X.length; oe++)
                            if (k = X[oe], k.getAttribute("content") === (v.content == null ? null : "" + v.content) && k.getAttribute("name") === (v.name == null ? null : v.name) && k.getAttribute("property") === (v.property == null ? null : v.property) && k.getAttribute("http-equiv") === (v.httpEquiv == null ? null : v.httpEquiv) && k.getAttribute("charset") === (v.charSet == null ? null : v.charSet)) {
                              X.splice(oe, 1);
                              break t;
                            }
                        }
                        k = D.createElement(x), Da(k, x, v), D.head.appendChild(k);
                        break;
                      default:
                        throw Error(r(468, x));
                    }
                  k[Rn] = u, on(k), x = k;
                }
                u.stateNode = x;
              } else
                yy(
                  D,
                  u.type,
                  u.stateNode
                );
            else
              u.stateNode = xx(
                D,
                x,
                u.memoizedProps
              );
          else
            k !== x ? (k === null ? v.stateNode !== null && (v = v.stateNode, v.parentNode.removeChild(v)) : k.count--, x === null ? yy(
              D,
              u.type,
              u.stateNode
            ) : xx(
              D,
              x,
              u.memoizedProps
            )) : x === null && u.stateNode !== null && qv(
              u,
              u.memoizedProps,
              v.memoizedProps
            );
        }
        break;
      case 27:
        _o(p, u), Vo(u), x & 512 && (Gi || v === null || Rl(v, v.return)), v !== null && x & 4 && qv(
          u,
          u.memoizedProps,
          v.memoizedProps
        );
        break;
      case 5:
        if (_o(p, u), Vo(u), x & 512 && (Gi || v === null || Rl(v, v.return)), u.flags & 32) {
          D = u.stateNode;
          try {
            Kl(D, "");
          } catch (Et) {
            mr(u, u.return, Et);
          }
        }
        x & 4 && u.stateNode != null && (D = u.memoizedProps, qv(
          u,
          D,
          v !== null ? v.memoizedProps : D
        )), x & 1024 && (Gv = !0);
        break;
      case 6:
        if (_o(p, u), Vo(u), x & 4) {
          if (u.stateNode === null)
            throw Error(r(162));
          x = u.memoizedProps, v = u.stateNode;
          try {
            v.nodeValue = x;
          } catch (Et) {
            mr(u, u.return, Et);
          }
        }
        break;
      case 3:
        if (Vp = null, D = pn, pn = Ka(p.containerInfo), _o(p, u), pn = D, Vo(u), x & 4 && v !== null && v.memoizedState.isDehydrated)
          try {
            Gp(p.containerInfo);
          } catch (Et) {
            mr(u, u.return, Et);
          }
        Gv && (Gv = !1, Q2(u));
        break;
      case 4:
        x = pn, pn = Ka(
          u.stateNode.containerInfo
        ), _o(p, u), Vo(u), pn = x;
        break;
      case 12:
        _o(p, u), Vo(u);
        break;
      case 31:
        _o(p, u), Vo(u), x & 4 && (x = u.updateQueue, x !== null && (u.updateQueue = null, Ym(u, x)));
        break;
      case 13:
        _o(p, u), Vo(u), u.child.flags & 8192 && u.memoizedState !== null != (v !== null && v.memoizedState !== null) && (Il = $e()), x & 4 && (x = u.updateQueue, x !== null && (u.updateQueue = null, Ym(u, x)));
        break;
      case 22:
        D = u.memoizedState !== null;
        var me = v !== null && v.memoizedState !== null, ke = yu, qe = Gi;
        if (yu = ke || D, Gi = qe || me, _o(p, u), Gi = qe, yu = ke, Vo(u), x & 8192)
          e:
            for (p = u.stateNode, p._visibility = D ? p._visibility & -2 : p._visibility | 1, D && (v === null || me || yu || Gi || qf(u)), v = null, p = u; ; ) {
              if (p.tag === 5 || p.tag === 26) {
                if (v === null) {
                  me = v = p;
                  try {
                    if (k = me.stateNode, D)
                      X = k.style, typeof X.setProperty == "function" ? X.setProperty("display", "none", "important") : X.display = "none";
                    else {
                      oe = me.stateNode;
                      var et = me.memoizedProps.style, Pe = et != null && et.hasOwnProperty("display") ? et.display : null;
                      oe.style.display = Pe == null || typeof Pe == "boolean" ? "" : ("" + Pe).trim();
                    }
                  } catch (Et) {
                    mr(me, me.return, Et);
                  }
                }
              } else if (p.tag === 6) {
                if (v === null) {
                  me = p;
                  try {
                    me.stateNode.nodeValue = D ? "" : me.memoizedProps;
                  } catch (Et) {
                    mr(me, me.return, Et);
                  }
                }
              } else if (p.tag === 18) {
                if (v === null) {
                  me = p;
                  try {
                    var Fe = me.stateNode;
                    D ? Pi(Fe, !0) : Pi(me.stateNode, !1);
                  } catch (Et) {
                    mr(me, me.return, Et);
                  }
                }
              } else if ((p.tag !== 22 && p.tag !== 23 || p.memoizedState === null || p === u) && p.child !== null) {
                p.child.return = p, p = p.child;
                continue;
              }
              if (p === u)
                break e;
              for (; p.sibling === null; ) {
                if (p.return === null || p.return === u)
                  break e;
                v === p && (v = null), p = p.return;
              }
              v === p && (v = null), p.sibling.return = p.return, p = p.sibling;
            }
        x & 4 && (x = u.updateQueue, x !== null && (v = x.retryQueue, v !== null && (x.retryQueue = null, Ym(u, v))));
        break;
      case 19:
        _o(p, u), Vo(u), x & 4 && (x = u.updateQueue, x !== null && (u.updateQueue = null, Ym(u, x)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        _o(p, u), Vo(u);
    }
  }
  function Vo(u) {
    var p = u.flags;
    if (p & 2) {
      try {
        for (var v, x = u.return; x !== null; ) {
          if (H2(x)) {
            v = x;
            break;
          }
          x = x.return;
        }
        if (v == null)
          throw Error(r(160));
        switch (v.tag) {
          case 27:
            var D = v.stateNode, k = yp(u);
            wp(u, k, D);
            break;
          case 5:
            var X = v.stateNode;
            v.flags & 32 && (Kl(X, ""), v.flags &= -33);
            var oe = yp(u);
            wp(u, oe, X);
            break;
          case 3:
          case 4:
            var me = v.stateNode.containerInfo, ke = yp(u);
            bp(
              u,
              ke,
              me
            );
            break;
          default:
            throw Error(r(161));
        }
      } catch (qe) {
        mr(u, u.return, qe);
      }
      u.flags &= -3;
    }
    p & 4096 && (u.flags &= -4097);
  }
  function Q2(u) {
    if (u.subtreeFlags & 1024)
      for (u = u.child; u !== null; ) {
        var p = u;
        Q2(p), p.tag === 5 && p.flags & 1024 && p.stateNode.reset(), u = u.sibling;
      }
  }
  function bu(u, p) {
    if (p.subtreeFlags & 8772)
      for (p = p.child; p !== null; )
        qm(u, p.alternate, p), p = p.sibling;
  }
  function qf(u) {
    for (u = u.child; u !== null; ) {
      var p = u;
      switch (p.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          gs(4, p, p.return), qf(p);
          break;
        case 1:
          Rl(p, p.return);
          var v = p.stateNode;
          typeof v.componentWillUnmount == "function" && Cd(
            p,
            p.return,
            v
          ), qf(p);
          break;
        case 27:
          Kf(p.stateNode);
        case 26:
        case 5:
          Rl(p, p.return), qf(p);
          break;
        case 22:
          p.memoizedState === null && qf(p);
          break;
        case 30:
          qf(p);
          break;
        default:
          qf(p);
      }
      u = u.sibling;
    }
  }
  function Dl(u, p, v) {
    for (v = v && (p.subtreeFlags & 8772) !== 0, p = p.child; p !== null; ) {
      var x = p.alternate, D = u, k = p, X = k.flags;
      switch (k.tag) {
        case 0:
        case 11:
        case 15:
          Dl(
            D,
            k,
            v
          ), Xs(4, k);
          break;
        case 1:
          if (Dl(
            D,
            k,
            v
          ), x = k, D = x.stateNode, typeof D.componentDidMount == "function")
            try {
              D.componentDidMount();
            } catch (ke) {
              mr(x, x.return, ke);
            }
          if (x = k, D = x.updateQueue, D !== null) {
            var oe = x.stateNode;
            try {
              var me = D.shared.hiddenCallbacks;
              if (me !== null)
                for (D.shared.hiddenCallbacks = null, D = 0; D < me.length; D++)
                  yv(me[D], oe);
            } catch (ke) {
              mr(x, x.return, ke);
            }
          }
          v && X & 64 && Hv(k), gc(k, k.return);
          break;
        case 27:
          q2(k);
        case 26:
        case 5:
          Dl(
            D,
            k,
            v
          ), v && x === null && X & 4 && $2(k), gc(k, k.return);
          break;
        case 12:
          Dl(
            D,
            k,
            v
          );
          break;
        case 31:
          Dl(
            D,
            k,
            v
          ), v && X & 4 && M3(D, k);
          break;
        case 13:
          Dl(
            D,
            k,
            v
          ), v && X & 4 && W2(D, k);
          break;
        case 22:
          k.memoizedState === null && Dl(
            D,
            k,
            v
          ), gc(k, k.return);
          break;
        case 30:
          break;
        default:
          Dl(
            D,
            k,
            v
          );
      }
      p = p.sibling;
    }
  }
  function Xv(u, p) {
    var v = null;
    u !== null && u.memoizedState !== null && u.memoizedState.cachePool !== null && (v = u.memoizedState.cachePool.pool), u = null, p.memoizedState !== null && p.memoizedState.cachePool !== null && (u = p.memoizedState.cachePool.pool), u !== v && (u != null && u.refCount++, v != null && xm(v));
  }
  function Wv(u, p) {
    u = null, p.alternate !== null && (u = p.alternate.memoizedState.cache), p = p.memoizedState.cache, p !== u && (p.refCount++, u != null && xm(u));
  }
  function Ws(u, p, v, x) {
    if (p.subtreeFlags & 10256)
      for (p = p.child; p !== null; )
        Sp(
          u,
          p,
          v,
          x
        ), p = p.sibling;
  }
  function Sp(u, p, v, x) {
    var D = p.flags;
    switch (p.tag) {
      case 0:
      case 11:
      case 15:
        Ws(
          u,
          p,
          v,
          x
        ), D & 2048 && Xs(9, p);
        break;
      case 1:
        Ws(
          u,
          p,
          v,
          x
        );
        break;
      case 3:
        Ws(
          u,
          p,
          v,
          x
        ), D & 2048 && (u = null, p.alternate !== null && (u = p.alternate.memoizedState.cache), p = p.memoizedState.cache, p !== u && (p.refCount++, u != null && xm(u)));
        break;
      case 12:
        if (D & 2048) {
          Ws(
            u,
            p,
            v,
            x
          ), u = p.stateNode;
          try {
            var k = p.memoizedProps, X = k.id, oe = k.onPostCommit;
            typeof oe == "function" && oe(
              X,
              p.alternate === null ? "mount" : "update",
              u.passiveEffectDuration,
              -0
            );
          } catch (me) {
            mr(p, p.return, me);
          }
        } else
          Ws(
            u,
            p,
            v,
            x
          );
        break;
      case 31:
        Ws(
          u,
          p,
          v,
          x
        );
        break;
      case 13:
        Ws(
          u,
          p,
          v,
          x
        );
        break;
      case 23:
        break;
      case 22:
        k = p.stateNode, X = p.alternate, p.memoizedState !== null ? k._visibility & 2 ? Ws(
          u,
          p,
          v,
          x
        ) : Xm(u, p) : k._visibility & 2 ? Ws(
          u,
          p,
          v,
          x
        ) : (k._visibility |= 2, Ep(
          u,
          p,
          v,
          x,
          (p.subtreeFlags & 10256) !== 0 || !1
        )), D & 2048 && Xv(X, p);
        break;
      case 24:
        Ws(
          u,
          p,
          v,
          x
        ), D & 2048 && Wv(p.alternate, p);
        break;
      default:
        Ws(
          u,
          p,
          v,
          x
        );
    }
  }
  function Ep(u, p, v, x, D) {
    for (D = D && ((p.subtreeFlags & 10256) !== 0 || !1), p = p.child; p !== null; ) {
      var k = u, X = p, oe = v, me = x, ke = X.flags;
      switch (X.tag) {
        case 0:
        case 11:
        case 15:
          Ep(
            k,
            X,
            oe,
            me,
            D
          ), Xs(8, X);
          break;
        case 23:
          break;
        case 22:
          var qe = X.stateNode;
          X.memoizedState !== null ? qe._visibility & 2 ? Ep(
            k,
            X,
            oe,
            me,
            D
          ) : Xm(
            k,
            X
          ) : (qe._visibility |= 2, Ep(
            k,
            X,
            oe,
            me,
            D
          )), D && ke & 2048 && Xv(
            X.alternate,
            X
          );
          break;
        case 24:
          Ep(
            k,
            X,
            oe,
            me,
            D
          ), D && ke & 2048 && Wv(X.alternate, X);
          break;
        default:
          Ep(
            k,
            X,
            oe,
            me,
            D
          );
      }
      p = p.sibling;
    }
  }
  function Xm(u, p) {
    if (p.subtreeFlags & 10256)
      for (p = p.child; p !== null; ) {
        var v = u, x = p, D = x.flags;
        switch (x.tag) {
          case 22:
            Xm(v, x), D & 2048 && Xv(
              x.alternate,
              x
            );
            break;
          case 24:
            Xm(v, x), D & 2048 && Wv(x.alternate, x);
            break;
          default:
            Xm(v, x);
        }
        p = p.sibling;
      }
  }
  var Uo = 8192;
  function yc(u, p, v) {
    if (u.subtreeFlags & Uo)
      for (u = u.child; u !== null; )
        I3(
          u,
          p,
          v
        ), u = u.sibling;
  }
  function I3(u, p, v) {
    switch (u.tag) {
      case 26:
        yc(
          u,
          p,
          v
        ), u.flags & Uo && u.memoizedState !== null && Ec(
          v,
          pn,
          u.memoizedState,
          u.memoizedProps
        );
        break;
      case 5:
        yc(
          u,
          p,
          v
        );
        break;
      case 3:
      case 4:
        var x = pn;
        pn = Ka(u.stateNode.containerInfo), yc(
          u,
          p,
          v
        ), pn = x;
        break;
      case 22:
        u.memoizedState === null && (x = u.alternate, x !== null && x.memoizedState !== null ? (x = Uo, Uo = 16777216, yc(
          u,
          p,
          v
        ), Uo = x) : yc(
          u,
          p,
          v
        ));
        break;
      default:
        yc(
          u,
          p,
          v
        );
    }
  }
  function Qv(u) {
    var p = u.alternate;
    if (p !== null && (u = p.child, u !== null)) {
      p.child = null;
      do
        p = u.sibling, u.sibling = null, u = p;
      while (u !== null);
    }
  }
  function _p(u) {
    var p = u.deletions;
    if (u.flags & 16) {
      if (p !== null)
        for (var v = 0; v < p.length; v++) {
          var x = p[v];
          ga = x, Zv(
            x,
            u
          );
        }
      Qv(u);
    }
    if (u.subtreeFlags & 10256)
      for (u = u.child; u !== null; )
        Z2(u), u = u.sibling;
  }
  function Z2(u) {
    switch (u.tag) {
      case 0:
      case 11:
      case 15:
        _p(u), u.flags & 2048 && gs(9, u, u.return);
        break;
      case 3:
        _p(u);
        break;
      case 12:
        _p(u);
        break;
      case 22:
        var p = u.stateNode;
        u.memoizedState !== null && p._visibility & 2 && (u.return === null || u.return.tag !== 13) ? (p._visibility &= -3, Wm(u)) : _p(u);
        break;
      default:
        _p(u);
    }
  }
  function Wm(u) {
    var p = u.deletions;
    if (u.flags & 16) {
      if (p !== null)
        for (var v = 0; v < p.length; v++) {
          var x = p[v];
          ga = x, Zv(
            x,
            u
          );
        }
      Qv(u);
    }
    for (u = u.child; u !== null; ) {
      switch (p = u, p.tag) {
        case 0:
        case 11:
        case 15:
          gs(8, p, p.return), Wm(p);
          break;
        case 22:
          v = p.stateNode, v._visibility & 2 && (v._visibility &= -3, Wm(p));
          break;
        default:
          Wm(p);
      }
      u = u.sibling;
    }
  }
  function Zv(u, p) {
    for (; ga !== null; ) {
      var v = ga;
      switch (v.tag) {
        case 0:
        case 11:
        case 15:
          gs(8, v, p);
          break;
        case 23:
        case 22:
          if (v.memoizedState !== null && v.memoizedState.cachePool !== null) {
            var x = v.memoizedState.cachePool.pool;
            x != null && x.refCount++;
          }
          break;
        case 24:
          xm(v.memoizedState.cache);
      }
      if (x = v.child, x !== null)
        x.return = v, ga = x;
      else
        e:
          for (v = u; ga !== null; ) {
            x = ga;
            var D = x.sibling, k = x.return;
            if (Y2(x), x === v) {
              ga = null;
              break e;
            }
            if (D !== null) {
              D.return = k, ga = D;
              break e;
            }
            ga = k;
          }
    }
  }
  var k3 = {
    getCacheForType: function(u) {
      var p = tt(Ii), v = p.data.get(u);
      return v === void 0 && (v = u(), p.data.set(u, v)), v;
    },
    cacheSignal: function() {
      return tt(Ii).controller.signal;
    }
  }, K2 = typeof WeakMap == "function" ? WeakMap : Map, Jn = 0, _r = null, Ln = null, En = 0, pr = 0, Xt = null, bc = !1, Td = !1, Kv = !1, Nl = 0, Ur = 0, Ml = 0, Gf = 0, Jv = 0, Ao = 0, ui = 0, Qm = null, di = null, ey = !1, Il = 0, J2 = 0, cr = 1 / 0, Ap = null, ti = null, Zi = 0, wu = null, Od = null, wc = 0, $o = 0, ty = null, ny = null, Cp = 0, Zm = null;
  function Ho() {
    return Jn & 2 && En !== 0 ? En & -En : U.T !== null ? sy() : Ta();
  }
  function j3() {
    if (Ao === 0)
      if (!(En & 536870912) || Pn) {
        var u = st;
        st <<= 1, !(st & 3932160) && (st = 262144), Ao = u;
      } else
        Ao = 536870912;
    return u = bo.current, u !== null && (u.flags |= 32), Ao;
  }
  function Co(u, p, v) {
    (u === _r && (pr === 2 || pr === 9) || u.cancelPendingCommit !== null) && (xc(u, 0), xu(
      u,
      En,
      Ao,
      !1
    )), jn(u, v), (!(Jn & 2) || u !== _r) && (u === _r && (!(Jn & 2) && (Gf |= v), Ur === 4 && xu(
      u,
      En,
      Ao,
      !1
    )), Sc(u));
  }
  function P3(u, p, v) {
    if (Jn & 6)
      throw Error(r(327));
    var x = !v && (p & 127) === 0 && (p & u.expiredLanes) === 0 || ut(u, p), D = x ? V3(u, p) : iy(u, p, !0), k = x;
    do {
      if (D === 0) {
        Td && !x && xu(u, p, 0, !1);
        break;
      } else {
        if (v = u.current.alternate, k && !L3(v)) {
          D = iy(u, p, !1), k = !1;
          continue;
        }
        if (D === 2) {
          if (k = p, u.errorRecoveryDisabledLanes & k)
            var X = 0;
          else
            X = u.pendingLanes & -536870913, X = X !== 0 ? X : X & 536870912 ? 536870912 : 0;
          if (X !== 0) {
            p = X;
            e: {
              var oe = u;
              D = Qm;
              var me = oe.current.memoizedState.isDehydrated;
              if (me && (xc(oe, X).flags |= 256), X = iy(
                oe,
                X,
                !1
              ), X !== 2) {
                if (Kv && !me) {
                  oe.errorRecoveryDisabledLanes |= k, Gf |= k, D = 4;
                  break e;
                }
                k = di, di = D, k !== null && (di === null ? di = k : di.push.apply(
                  di,
                  k
                ));
              }
              D = X;
            }
            if (k = !1, D !== 2)
              continue;
          }
        }
        if (D === 1) {
          xc(u, 0), xu(u, p, 0, !0);
          break;
        }
        e: {
          switch (x = u, k = D, k) {
            case 0:
            case 1:
              throw Error(r(345));
            case 4:
              if ((p & 4194048) !== p)
                break;
            case 6:
              xu(
                x,
                p,
                Ao,
                !bc
              );
              break e;
            case 2:
              di = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(r(329));
          }
          if ((p & 62914560) === p && (D = Il + 300 - $e(), 10 < D)) {
            if (xu(
              x,
              p,
              Ao,
              !bc
            ), Ke(x, 0, !0) !== 0)
              break e;
            wc = p, x.timeoutHandle = s1(
              Km.bind(
                null,
                x,
                v,
                di,
                Ap,
                ey,
                p,
                Ao,
                Gf,
                ui,
                bc,
                k,
                "Throttled",
                -0,
                0
              ),
              D
            );
            break e;
          }
          Km(
            x,
            v,
            di,
            Ap,
            ey,
            p,
            Ao,
            Gf,
            ui,
            bc,
            k,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (1);
    Sc(u);
  }
  function Km(u, p, v, x, D, k, X, oe, me, ke, qe, et, Pe, Fe) {
    if (u.timeoutHandle = -1, et = p.subtreeFlags, et & 8192 || (et & 16785408) === 16785408) {
      et = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: ml
      }, I3(
        p,
        k,
        et
      );
      var Et = (k & 62914560) === k ? Il - $e() : (k & 4194048) === k ? J2 - $e() : 0;
      if (Et = _x(
        et,
        Et
      ), Et !== null) {
        wc = k, u.cancelPendingCommit = Et(
          q3.bind(
            null,
            u,
            p,
            k,
            v,
            x,
            D,
            X,
            oe,
            me,
            qe,
            et,
            null,
            Pe,
            Fe
          )
        ), xu(u, k, X, !ke);
        return;
      }
    }
    q3(
      u,
      p,
      k,
      v,
      x,
      D,
      X,
      oe,
      me
    );
  }
  function L3(u) {
    for (var p = u; ; ) {
      var v = p.tag;
      if ((v === 0 || v === 11 || v === 15) && p.flags & 16384 && (v = p.updateQueue, v !== null && (v = v.stores, v !== null)))
        for (var x = 0; x < v.length; x++) {
          var D = v[x], k = D.getSnapshot;
          D = D.value;
          try {
            if (!Qa(k(), D))
              return !1;
          } catch {
            return !1;
          }
        }
      if (v = p.child, p.subtreeFlags & 16384 && v !== null)
        v.return = p, p = v;
      else {
        if (p === u)
          break;
        for (; p.sibling === null; ) {
          if (p.return === null || p.return === u)
            return !0;
          p = p.return;
        }
        p.sibling.return = p.return, p = p.sibling;
      }
    }
    return !0;
  }
  function xu(u, p, v, x) {
    p &= ~Jv, p &= ~Gf, u.suspendedLanes |= p, u.pingedLanes &= ~p, x && (u.warmLanes |= p), x = u.expirationTimes;
    for (var D = p; 0 < D; ) {
      var k = 31 - or(D), X = 1 << k;
      x[k] = -1, D &= ~X;
    }
    v !== 0 && Ai(u, v, p);
  }
  function Tp() {
    return Jn & 6 ? !0 : (Eu(0, !1), !1);
  }
  function ex() {
    if (Ln !== null) {
      if (pr === 0)
        var u = Ln.return;
      else
        u = Ln, _l = uu = null, Nm(u), md = null, kf = 0, u = Ln;
      for (; u !== null; )
        N3(u.alternate, u), u = u.return;
      Ln = null;
    }
  }
  function xc(u, p) {
    var v = u.timeoutHandle;
    v !== -1 && (u.timeoutHandle = -1, sA(v)), v = u.cancelPendingCommit, v !== null && (u.cancelPendingCommit = null, v()), wc = 0, ex(), _r = u, Ln = v = lu(u.current, null), En = p, pr = 0, Xt = null, bc = !1, Td = ut(u, p), Kv = !1, ui = Ao = Jv = Gf = Ml = Ur = 0, di = Qm = null, ey = !1, p & 8 && (p |= p & 32);
    var x = u.entangledLanes;
    if (x !== 0)
      for (u = u.entanglements, x &= p; 0 < x; ) {
        var D = 31 - or(x), k = 1 << D;
        p |= u[D], x &= ~k;
      }
    return Nl = p, as(), v;
  }
  function Op(u, p) {
    cn = null, U.H = zm, p === fd || p === ap ? (p = c2(), pr = 3) : p === Mf ? (p = c2(), pr = 4) : pr = p === zv ? 8 : p !== null && typeof p == "object" && typeof p.then == "function" ? 6 : 1, Xt = p, Ln === null && (Ur = 1, gp(
      u,
      ss(p, u.current)
    ));
  }
  function B3() {
    var u = bo.current;
    return u === null ? !0 : (En & 4194048) === En ? fs === null : (En & 62914560) === En || En & 536870912 ? u === fs : !1;
  }
  function z3() {
    var u = U.H;
    return U.H = zm, u === null ? zm : u;
  }
  function F3() {
    var u = U.A;
    return U.A = k3, u;
  }
  function ry() {
    Ur = 4, bc || (En & 4194048) !== En && bo.current !== null || (Td = !0), !(Ml & 134217727) && !(Gf & 134217727) || _r === null || xu(
      _r,
      En,
      Ao,
      !1
    );
  }
  function iy(u, p, v) {
    var x = Jn;
    Jn |= 2;
    var D = z3(), k = F3();
    (_r !== u || En !== p) && (Ap = null, xc(u, p)), p = !1;
    var X = Ur;
    e:
      do
        try {
          if (pr !== 0 && Ln !== null) {
            var oe = Ln, me = Xt;
            switch (pr) {
              case 8:
                ex(), X = 6;
                break e;
              case 3:
              case 2:
              case 9:
              case 6:
                bo.current === null && (p = !0);
                var ke = pr;
                if (pr = 0, Xt = null, Yf(u, oe, me, ke), v && Td) {
                  X = 0;
                  break e;
                }
                break;
              default:
                ke = pr, pr = 0, Xt = null, Yf(u, oe, me, ke);
            }
          }
          VO(), X = Ur;
          break;
        } catch (qe) {
          Op(u, qe);
        }
      while (1);
    return p && u.shellSuspendCounter++, _l = uu = null, Jn = x, U.H = D, U.A = k, Ln === null && (_r = null, En = 0, as()), X;
  }
  function VO() {
    for (; Ln !== null; )
      U3(Ln);
  }
  function V3(u, p) {
    var v = Jn;
    Jn |= 2;
    var x = z3(), D = F3();
    _r !== u || En !== p ? (Ap = null, cr = $e() + 500, xc(u, p)) : Td = ut(
      u,
      p
    );
    e:
      do
        try {
          if (pr !== 0 && Ln !== null) {
            p = Ln;
            var k = Xt;
            t:
              switch (pr) {
                case 1:
                  pr = 0, Xt = null, Yf(u, p, k, 1);
                  break;
                case 2:
                case 9:
                  if (s2(k)) {
                    pr = 0, Xt = null, $3(p);
                    break;
                  }
                  p = function() {
                    pr !== 2 && pr !== 9 || _r !== u || (pr = 7), Sc(u);
                  }, k.then(p, p);
                  break e;
                case 3:
                  pr = 7;
                  break e;
                case 4:
                  pr = 5;
                  break e;
                case 7:
                  s2(k) ? (pr = 0, Xt = null, $3(p)) : (pr = 0, Xt = null, Yf(u, p, k, 7));
                  break;
                case 5:
                  var X = null;
                  switch (Ln.tag) {
                    case 26:
                      X = Ln.memoizedState;
                    case 5:
                    case 27:
                      var oe = Ln;
                      if (X ? Go(X) : oe.stateNode.complete) {
                        pr = 0, Xt = null;
                        var me = oe.sibling;
                        if (me !== null)
                          Ln = me;
                        else {
                          var ke = oe.return;
                          ke !== null ? (Ln = ke, Jm(ke)) : Ln = null;
                        }
                        break t;
                      }
                  }
                  pr = 0, Xt = null, Yf(u, p, k, 5);
                  break;
                case 6:
                  pr = 0, Xt = null, Yf(u, p, k, 6);
                  break;
                case 8:
                  ex(), Ur = 6;
                  break e;
                default:
                  throw Error(r(462));
              }
          }
          Rd();
          break;
        } catch (qe) {
          Op(u, qe);
        }
      while (1);
    return _l = uu = null, U.H = x, U.A = D, Jn = v, Ln !== null ? 0 : (_r = null, En = 0, as(), Ur);
  }
  function Rd() {
    for (; Ln !== null && !Te(); )
      U3(Ln);
  }
  function U3(u) {
    var p = F2(u.alternate, u, Nl);
    u.memoizedProps = u.pendingProps, p === null ? Jm(u) : Ln = p;
  }
  function $3(u) {
    var p = u, v = p.alternate;
    switch (p.tag) {
      case 15:
      case 0:
        p = _d(
          v,
          p,
          p.pendingProps,
          p.type,
          void 0,
          En
        );
        break;
      case 11:
        p = _d(
          v,
          p,
          p.pendingProps,
          p.type.render,
          p.ref,
          En
        );
        break;
      case 5:
        Nm(p);
      default:
        N3(v, p), p = Ln = e2(p, Nl), p = F2(v, p, Nl);
    }
    u.memoizedProps = u.pendingProps, p === null ? Jm(u) : Ln = p;
  }
  function Yf(u, p, v, x) {
    _l = uu = null, Nm(p), md = null, kf = 0;
    var D = p.return;
    try {
      if (FO(
        u,
        D,
        p,
        v,
        En
      )) {
        Ur = 1, gp(
          u,
          ss(v, u.current)
        ), Ln = null;
        return;
      }
    } catch (k) {
      if (D !== null)
        throw Ln = D, k;
      Ur = 1, gp(
        u,
        ss(v, u.current)
      ), Ln = null;
      return;
    }
    p.flags & 32768 ? (Pn || x === 1 ? u = !0 : Td || En & 536870912 ? u = !1 : (bc = u = !0, (x === 2 || x === 9 || x === 3 || x === 6) && (x = bo.current, x !== null && x.tag === 13 && (x.flags |= 16384))), H3(p, u)) : Jm(p);
  }
  function Jm(u) {
    var p = u;
    do {
      if (p.flags & 32768) {
        H3(
          p,
          bc
        );
        return;
      }
      u = p.return;
      var v = R3(
        p.alternate,
        p,
        Nl
      );
      if (v !== null) {
        Ln = v;
        return;
      }
      if (p = p.sibling, p !== null) {
        Ln = p;
        return;
      }
      Ln = p = u;
    } while (p !== null);
    Ur === 0 && (Ur = 5);
  }
  function H3(u, p) {
    do {
      var v = D3(u.alternate, u);
      if (v !== null) {
        v.flags &= 32767, Ln = v;
        return;
      }
      if (v = u.return, v !== null && (v.flags |= 32768, v.subtreeFlags = 0, v.deletions = null), !p && (u = u.sibling, u !== null)) {
        Ln = u;
        return;
      }
      Ln = u = v;
    } while (u !== null);
    Ur = 6, Ln = null;
  }
  function q3(u, p, v, x, D, k, X, oe, me) {
    u.cancelPendingCommit = null;
    do
      Rp();
    while (Zi !== 0);
    if (Jn & 6)
      throw Error(r(327));
    if (p !== null) {
      if (p === u.current)
        throw Error(r(177));
      if (k = p.lanes | p.childLanes, k |= $s, vn(
        u,
        v,
        k,
        X,
        oe,
        me
      ), u === _r && (Ln = _r = null, En = 0), Od = p, wu = u, wc = v, $o = k, ty = D, ny = x, p.subtreeFlags & 10256 || p.flags & 10256 ? (u.callbackNode = null, u.callbackPriority = 0, eA(Rt, function() {
        return Q3(), null;
      })) : (u.callbackNode = null, u.callbackPriority = 0), x = (p.flags & 13878) !== 0, p.subtreeFlags & 13878 || x) {
        x = U.T, U.T = null, D = q.p, q.p = 2, X = Jn, Jn |= 4;
        try {
          xp(u, p, v);
        } finally {
          Jn = X, q.p = D, U.T = x;
        }
      }
      Zi = 1, G3(), Y3(), X3();
    }
  }
  function G3() {
    if (Zi === 1) {
      Zi = 0;
      var u = wu, p = Od, v = (p.flags & 13878) !== 0;
      if (p.subtreeFlags & 13878 || v) {
        v = U.T, U.T = null;
        var x = q.p;
        q.p = 2;
        var D = Jn;
        Jn |= 4;
        try {
          Yv(p, u);
          var k = hy, X = sd(u.containerInfo), oe = k.focusedElem, me = k.selectionRange;
          if (X !== oe && oe && oe.ownerDocument && _f(
            oe.ownerDocument.documentElement,
            oe
          )) {
            if (me !== null && dm(oe)) {
              var ke = me.start, qe = me.end;
              if (qe === void 0 && (qe = ke), "selectionStart" in oe)
                oe.selectionStart = ke, oe.selectionEnd = Math.min(
                  qe,
                  oe.value.length
                );
              else {
                var et = oe.ownerDocument || document, Pe = et && et.defaultView || window;
                if (Pe.getSelection) {
                  var Fe = Pe.getSelection(), Et = oe.textContent.length, Ut = Math.min(me.start, Et), Cr = me.end === void 0 ? Ut : Math.min(me.end, Et);
                  !Fe.extend && Ut > Cr && (X = Cr, Cr = Ut, Ut = X);
                  var Oe = Kw(
                    oe,
                    Ut
                  ), xe = Kw(
                    oe,
                    Cr
                  );
                  if (Oe && xe && (Fe.rangeCount !== 1 || Fe.anchorNode !== Oe.node || Fe.anchorOffset !== Oe.offset || Fe.focusNode !== xe.node || Fe.focusOffset !== xe.offset)) {
                    var Ie = et.createRange();
                    Ie.setStart(Oe.node, Oe.offset), Fe.removeAllRanges(), Ut > Cr ? (Fe.addRange(Ie), Fe.extend(xe.node, xe.offset)) : (Ie.setEnd(xe.node, xe.offset), Fe.addRange(Ie));
                  }
                }
              }
            }
            for (et = [], Fe = oe; Fe = Fe.parentNode; )
              Fe.nodeType === 1 && et.push({
                element: Fe,
                left: Fe.scrollLeft,
                top: Fe.scrollTop
              });
            for (typeof oe.focus == "function" && oe.focus(), oe = 0; oe < et.length; oe++) {
              var We = et[oe];
              We.element.scrollLeft = We.left, We.element.scrollTop = We.top;
            }
          }
          Ki = !!fy, hy = fy = null;
        } finally {
          Jn = D, q.p = x, U.T = v;
        }
      }
      u.current = p, Zi = 2;
    }
  }
  function Y3() {
    if (Zi === 2) {
      Zi = 0;
      var u = wu, p = Od, v = (p.flags & 8772) !== 0;
      if (p.subtreeFlags & 8772 || v) {
        v = U.T, U.T = null;
        var x = q.p;
        q.p = 2;
        var D = Jn;
        Jn |= 4;
        try {
          qm(u, p.alternate, p);
        } finally {
          Jn = D, q.p = x, U.T = v;
        }
      }
      Zi = 3;
    }
  }
  function X3() {
    if (Zi === 4 || Zi === 3) {
      Zi = 0, He();
      var u = wu, p = Od, v = wc, x = ny;
      p.subtreeFlags & 10256 || p.flags & 10256 ? Zi = 5 : (Zi = 0, Od = wu = null, W3(u, u.pendingLanes));
      var D = u.pendingLanes;
      if (D === 0 && (ti = null), Hi(v), p = p.stateNode, kn && typeof kn.onCommitFiberRoot == "function")
        try {
          kn.onCommitFiberRoot(
            ar,
            p,
            void 0,
            (p.current.flags & 128) === 128
          );
        } catch {
        }
      if (x !== null) {
        p = U.T, D = q.p, q.p = 2, U.T = null;
        try {
          for (var k = u.onRecoverableError, X = 0; X < x.length; X++) {
            var oe = x[X];
            k(oe.value, {
              componentStack: oe.stack
            });
          }
        } finally {
          U.T = p, q.p = D;
        }
      }
      wc & 3 && Rp(), Sc(u), D = u.pendingLanes, v & 261930 && D & 42 ? u === Zm ? Cp++ : (Cp = 0, Zm = u) : Cp = 0, Eu(0, !1);
    }
  }
  function W3(u, p) {
    (u.pooledCacheLanes &= p) === 0 && (p = u.pooledCache, p != null && (u.pooledCache = null, xm(p)));
  }
  function Rp() {
    return G3(), Y3(), X3(), Q3();
  }
  function Q3() {
    if (Zi !== 5)
      return !1;
    var u = wu, p = $o;
    $o = 0;
    var v = Hi(wc), x = U.T, D = q.p;
    try {
      q.p = 32 > v ? 32 : v, U.T = null, v = ty, ty = null;
      var k = wu, X = wc;
      if (Zi = 0, Od = wu = null, wc = 0, Jn & 6)
        throw Error(r(331));
      var oe = Jn;
      if (Jn |= 4, Z2(k.current), Sp(
        k,
        k.current,
        X,
        v
      ), Jn = oe, Eu(0, !1), kn && typeof kn.onPostCommitFiberRoot == "function")
        try {
          kn.onPostCommitFiberRoot(ar, k);
        } catch {
        }
      return !0;
    } finally {
      q.p = D, U.T = x, W3(u, p);
    }
  }
  function Z3(u, p, v) {
    p = ss(v, p), p = N2(u.stateNode, p, 2), u = ds(u, p, 2), u !== null && (jn(u, 2), Sc(u));
  }
  function mr(u, p, v) {
    if (u.tag === 3)
      Z3(u, u, v);
    else
      for (; p !== null; ) {
        if (p.tag === 3) {
          Z3(
            p,
            u,
            v
          );
          break;
        } else if (p.tag === 1) {
          var x = p.stateNode;
          if (typeof p.type.getDerivedStateFromError == "function" || typeof x.componentDidCatch == "function" && (ti === null || !ti.has(x))) {
            u = ss(v, u), v = M2(2), x = ds(p, v, 2), x !== null && (I2(
              v,
              x,
              p,
              u
            ), jn(x, 2), Sc(x));
            break;
          }
        }
        p = p.return;
      }
  }
  function e1(u, p, v) {
    var x = u.pingCache;
    if (x === null) {
      x = u.pingCache = new K2();
      var D = /* @__PURE__ */ new Set();
      x.set(p, D);
    } else
      D = x.get(p), D === void 0 && (D = /* @__PURE__ */ new Set(), x.set(p, D));
    D.has(v) || (Kv = !0, D.add(v), u = tx.bind(null, u, p, v), p.then(u, u));
  }
  function tx(u, p, v) {
    var x = u.pingCache;
    x !== null && x.delete(p), u.pingedLanes |= u.suspendedLanes & v, u.warmLanes &= ~v, _r === u && (En & v) === v && (Ur === 4 || Ur === 3 && (En & 62914560) === En && 300 > $e() - Il ? !(Jn & 2) && xc(u, 0) : Jv |= v, ui === En && (ui = 0)), Sc(u);
  }
  function K3(u, p) {
    p === 0 && (p = en()), u = su(u, p), u !== null && (jn(u, p), Sc(u));
  }
  function vs(u) {
    var p = u.memoizedState, v = 0;
    p !== null && (v = p.retryLane), K3(u, v);
  }
  function J3(u, p) {
    var v = 0;
    switch (u.tag) {
      case 31:
      case 13:
        var x = u.stateNode, D = u.memoizedState;
        D !== null && (v = D.retryLane);
        break;
      case 19:
        x = u.stateNode;
        break;
      case 22:
        x = u.stateNode._retryCache;
        break;
      default:
        throw Error(r(314));
    }
    x !== null && x.delete(p), K3(u, v);
  }
  function eA(u, p) {
    return se(u, p);
  }
  var Dp = null, Xf = null, nx = !1, ay = !1, rx = !1, Su = 0;
  function Sc(u) {
    u !== Xf && u.next === null && (Xf === null ? Dp = Xf = u : Xf = Xf.next = u), ay = !0, nx || (nx = !0, n1());
  }
  function Eu(u, p) {
    if (!rx && ay) {
      rx = !0;
      do
        for (var v = !1, x = Dp; x !== null; ) {
          if (!p)
            if (u !== 0) {
              var D = x.pendingLanes;
              if (D === 0)
                var k = 0;
              else {
                var X = x.suspendedLanes, oe = x.pingedLanes;
                k = (1 << 31 - or(42 | u) + 1) - 1, k &= D & ~(X & ~oe), k = k & 201326741 ? k & 201326741 | 1 : k ? k | 2 : 0;
              }
              k !== 0 && (v = !0, Wf(x, k));
            } else
              k = En, k = Ke(
                x,
                x === _r ? k : 0,
                x.cancelPendingCommit !== null || x.timeoutHandle !== -1
              ), !(k & 3) || ut(x, k) || (v = !0, Wf(x, k));
          x = x.next;
        }
      while (v);
      rx = !1;
    }
  }
  function oy() {
    ix();
  }
  function ix() {
    ay = nx = !1;
    var u = 0;
    Su !== 0 && UO() && (u = Su);
    for (var p = $e(), v = null, x = Dp; x !== null; ) {
      var D = x.next, k = ax(x, p);
      k === 0 ? (x.next = null, v === null ? Dp = D : v.next = D, D === null && (Xf = v)) : (v = x, (u !== 0 || k & 3) && (ay = !0)), x = D;
    }
    Zi !== 0 && Zi !== 5 || Eu(u, !1), Su !== 0 && (Su = 0);
  }
  function ax(u, p) {
    for (var v = u.suspendedLanes, x = u.pingedLanes, D = u.expirationTimes, k = u.pendingLanes & -62914561; 0 < k; ) {
      var X = 31 - or(k), oe = 1 << X, me = D[X];
      me === -1 ? (!(oe & v) || oe & x) && (D[X] = ft(oe, p)) : me <= p && (u.expiredLanes |= oe), k &= ~oe;
    }
    if (p = _r, v = En, v = Ke(
      u,
      u === p ? v : 0,
      u.cancelPendingCommit !== null || u.timeoutHandle !== -1
    ), x = u.callbackNode, v === 0 || u === p && (pr === 2 || pr === 9) || u.cancelPendingCommit !== null)
      return x !== null && x !== null && ge(x), u.callbackNode = null, u.callbackPriority = 0;
    if (!(v & 3) || ut(u, v)) {
      if (p = v & -v, p === u.callbackPriority)
        return p;
      switch (x !== null && ge(x), Hi(v)) {
        case 2:
        case 8:
          v = Mt;
          break;
        case 32:
          v = Rt;
          break;
        case 268435456:
          v = In;
          break;
        default:
          v = Rt;
      }
      return x = t1.bind(null, u), v = se(v, x), u.callbackPriority = p, u.callbackNode = v, p;
    }
    return x !== null && x !== null && ge(x), u.callbackPriority = 2, u.callbackNode = null, 2;
  }
  function t1(u, p) {
    if (Zi !== 0 && Zi !== 5)
      return u.callbackNode = null, u.callbackPriority = 0, null;
    var v = u.callbackNode;
    if (Rp() && u.callbackNode !== v)
      return null;
    var x = En;
    return x = Ke(
      u,
      u === _r ? x : 0,
      u.cancelPendingCommit !== null || u.timeoutHandle !== -1
    ), x === 0 ? null : (P3(u, x, p), ax(u, $e()), u.callbackNode != null && u.callbackNode === v ? t1.bind(null, u) : null);
  }
  function Wf(u, p) {
    if (Rp())
      return null;
    P3(u, p, !0);
  }
  function n1() {
    lA(function() {
      Jn & 6 ? se(
        ct,
        oy
      ) : ix();
    });
  }
  function sy() {
    if (Su === 0) {
      var u = dd;
      u === 0 && (u = nt, nt <<= 1, !(nt & 261888) && (nt = 256)), Su = u;
    }
    return Su;
  }
  function tA(u) {
    return u == null || typeof u == "symbol" || typeof u == "boolean" ? null : typeof u == "function" ? u : zs("" + u);
  }
  function Qf(u, p) {
    var v = p.ownerDocument.createElement("input");
    return v.name = p.name, v.value = p.value, u.id && v.setAttribute("form", u.id), p.parentNode.insertBefore(v, p), u = new FormData(u), v.parentNode.removeChild(v), u;
  }
  function r1(u, p, v, x, D) {
    if (p === "submit" && v && v.stateNode === D) {
      var k = tA(
        (D[ca] || null).action
      ), X = x.submitter;
      X && (p = (p = X[ca] || null) ? tA(p.formAction) : X.getAttribute("formAction"), p !== null && (k = p, X = null));
      var oe = new lm(
        "action",
        "action",
        null,
        x,
        D
      );
      u.push({
        event: oe,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (x.defaultPrevented) {
                if (Su !== 0) {
                  var me = X ? Qf(D, X) : new FormData(D);
                  pp(
                    v,
                    {
                      pending: !0,
                      data: me,
                      method: D.method,
                      action: k
                    },
                    null,
                    me
                  );
                }
              } else
                typeof k == "function" && (oe.preventDefault(), me = X ? Qf(D, X) : new FormData(D), pp(
                  v,
                  {
                    pending: !0,
                    data: me,
                    method: D.method,
                    action: k
                  },
                  k,
                  me
                ));
            },
            currentTarget: D
          }
        ]
      });
    }
  }
  for (var ly = 0; ly < Jh.length; ly++) {
    var Np = Jh[ly], ox = Np.toLowerCase(), sx = Np[0].toUpperCase() + Np.slice(1);
    mo(
      ox,
      "on" + sx
    );
  }
  mo(hm, "onAnimationEnd"), mo(Jw, "onAnimationIteration"), mo(lv, "onAnimationStart"), mo("dblclick", "onDoubleClick"), mo("focusin", "onFocus"), mo("focusout", "onBlur"), mo(Af, "onTransitionRun"), mo(pm, "onTransitionStart"), mo(nc, "onTransitionCancel"), mo(f3, "onTransitionEnd"), jr("onMouseEnter", ["mouseout", "mouseover"]), jr("onMouseLeave", ["mouseout", "mouseover"]), jr("onPointerEnter", ["pointerout", "pointerover"]), jr("onPointerLeave", ["pointerout", "pointerover"]), Bs(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), Bs(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), Bs("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), Bs(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), Bs(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), Bs(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Mp = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), nA = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Mp)
  );
  function rA(u, p) {
    p = (p & 4) !== 0;
    for (var v = 0; v < u.length; v++) {
      var x = u[v], D = x.event;
      x = x.listeners;
      e: {
        var k = void 0;
        if (p)
          for (var X = x.length - 1; 0 <= X; X--) {
            var oe = x[X], me = oe.instance, ke = oe.currentTarget;
            if (oe = oe.listener, me !== k && D.isPropagationStopped())
              break e;
            k = oe, D.currentTarget = ke;
            try {
              k(D);
            } catch (qe) {
              Cf(qe);
            }
            D.currentTarget = null, k = me;
          }
        else
          for (X = 0; X < x.length; X++) {
            if (oe = x[X], me = oe.instance, ke = oe.currentTarget, oe = oe.listener, me !== k && D.isPropagationStopped())
              break e;
            k = oe, D.currentTarget = ke;
            try {
              k(D);
            } catch (qe) {
              Cf(qe);
            }
            D.currentTarget = null, k = me;
          }
      }
    }
  }
  function Dn(u, p) {
    var v = p[ff];
    v === void 0 && (v = p[ff] = /* @__PURE__ */ new Set());
    var x = u + "__bubble";
    v.has(x) || (i1(p, u, 2, !1), v.add(x));
  }
  function lx(u, p, v) {
    var x = 0;
    p && (x |= 4), i1(
      v,
      u,
      x,
      p
    );
  }
  var cy = "_reactListening" + Math.random().toString(36).slice(2);
  function Ip(u) {
    if (!u[cy]) {
      u[cy] = !0, Oa.forEach(function(v) {
        v !== "selectionchange" && (nA.has(v) || lx(v, !1, u), lx(v, !0, u));
      });
      var p = u.nodeType === 9 ? u : u.ownerDocument;
      p === null || p[cy] || (p[cy] = !0, lx("selectionchange", !1, p));
    }
  }
  function i1(u, p, v, x) {
    switch (h1(p)) {
      case 2:
        var D = _c;
        break;
      case 8:
        D = Ac;
        break;
      default:
        D = Na;
    }
    v = D.bind(
      null,
      p,
      v,
      u
    ), D = void 0, !om || p !== "touchstart" && p !== "touchmove" && p !== "wheel" || (D = !0), x ? D !== void 0 ? u.addEventListener(p, v, {
      capture: !0,
      passive: D
    }) : u.addEventListener(p, v, !0) : D !== void 0 ? u.addEventListener(p, v, {
      passive: D
    }) : u.addEventListener(p, v, !1);
  }
  function cx(u, p, v, x, D) {
    var k = x;
    if (!(p & 1) && !(p & 2) && x !== null)
      e:
        for (; ; ) {
          if (x === null)
            return;
          var X = x.tag;
          if (X === 3 || X === 4) {
            var oe = x.stateNode.containerInfo;
            if (oe === D)
              break;
            if (X === 4)
              for (X = x.return; X !== null; ) {
                var me = X.tag;
                if ((me === 3 || me === 4) && X.stateNode.containerInfo === D)
                  return;
                X = X.return;
              }
            for (; oe !== null; ) {
              if (X = xt(oe), X === null)
                return;
              if (me = X.tag, me === 5 || me === 6 || me === 26 || me === 27) {
                x = k = X;
                continue e;
              }
              oe = oe.parentNode;
            }
          }
          x = x.return;
        }
    jw(function() {
      var ke = k, qe = Wg(v), et = [];
      e: {
        var Pe = rc.get(u);
        if (Pe !== void 0) {
          var Fe = lm, Et = u;
          switch (u) {
            case "keypress":
              if (Zg(v) === 0)
                break e;
            case "keydown":
            case "keyup":
              Fe = tv;
              break;
            case "focusin":
              Et = "focus", Fe = Jg;
              break;
            case "focusout":
              Et = "blur", Fe = Jg;
              break;
            case "beforeblur":
            case "afterblur":
              Fe = Jg;
              break;
            case "click":
              if (v.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Fe = Xh;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Fe = e3;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Fe = a3;
              break;
            case hm:
            case Jw:
            case lv:
              Fe = n3;
              break;
            case f3:
              Fe = PO;
              break;
            case "scroll":
            case "scrollend":
              Fe = kO;
              break;
            case "wheel":
              Fe = LO;
              break;
            case "copy":
            case "cut":
            case "paste":
              Fe = yf;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Fe = yl;
              break;
            case "toggle":
            case "beforetoggle":
              Fe = Hw;
          }
          var Ut = (p & 4) !== 0, Cr = !Ut && (u === "scroll" || u === "scrollend"), Oe = Ut ? Pe !== null ? Pe + "Capture" : null : Pe;
          Ut = [];
          for (var xe = ke, Ie; xe !== null; ) {
            var We = xe;
            if (Ie = We.stateNode, We = We.tag, We !== 5 && We !== 26 && We !== 27 || Ie === null || Oe === null || (We = ua(xe, Oe), We != null && Ut.push(
              a1(xe, We, Ie)
            )), Cr)
              break;
            xe = xe.return;
          }
          0 < Ut.length && (Pe = new Fe(
            Pe,
            Et,
            null,
            v,
            qe
          ), et.push({ event: Pe, listeners: Ut }));
        }
      }
      if (!(p & 7)) {
        e: {
          if (Pe = u === "mouseover" || u === "pointerover", Fe = u === "mouseout" || u === "pointerout", Pe && v !== Xg && (Et = v.relatedTarget || v.fromElement) && (xt(Et) || Et[pl]))
            break e;
          if ((Fe || Pe) && (Pe = qe.window === qe ? qe : (Pe = qe.ownerDocument) ? Pe.defaultView || Pe.parentWindow : window, Fe ? (Et = v.relatedTarget || v.toElement, Fe = ke, Et = Et ? xt(Et) : null, Et !== null && (Cr = a(Et), Ut = Et.tag, Et !== Cr || Ut !== 5 && Ut !== 27 && Ut !== 6) && (Et = null)) : (Fe = null, Et = ke), Fe !== Et)) {
            if (Ut = Xh, We = "onMouseLeave", Oe = "onMouseEnter", xe = "mouse", (u === "pointerout" || u === "pointerover") && (Ut = yl, We = "onPointerLeave", Oe = "onPointerEnter", xe = "pointer"), Cr = Fe == null ? Pe : li(Fe), Ie = Et == null ? Pe : li(Et), Pe = new Ut(
              We,
              xe + "leave",
              Fe,
              v,
              qe
            ), Pe.target = Cr, Pe.relatedTarget = Ie, We = null, xt(qe) === ke && (Ut = new Ut(
              Oe,
              xe + "enter",
              Et,
              v,
              qe
            ), Ut.target = Ie, Ut.relatedTarget = Cr, We = Ut), Cr = We, Fe && Et)
              t: {
                for (Ut = iA, Oe = Fe, xe = Et, Ie = 0, We = Oe; We; We = Ut(We))
                  Ie++;
                We = 0;
                for (var Lt = xe; Lt; Lt = Ut(Lt))
                  We++;
                for (; 0 < Ie - We; )
                  Oe = Ut(Oe), Ie--;
                for (; 0 < We - Ie; )
                  xe = Ut(xe), We--;
                for (; Ie--; ) {
                  if (Oe === xe || xe !== null && Oe === xe.alternate) {
                    Ut = Oe;
                    break t;
                  }
                  Oe = Ut(Oe), xe = Ut(xe);
                }
                Ut = null;
              }
            else
              Ut = null;
            Fe !== null && uy(
              et,
              Pe,
              Fe,
              Ut,
              !1
            ), Et !== null && Cr !== null && uy(
              et,
              Cr,
              Et,
              Ut,
              !0
            );
          }
        }
        e: {
          if (Pe = ke ? li(ke) : window, Fe = Pe.nodeName && Pe.nodeName.toLowerCase(), Fe === "select" || Fe === "input" && Pe.type === "file")
            var Qn = Ww;
          else if (tc(Pe))
            if (iv)
              Qn = Ef;
            else {
              Qn = u3;
              var Dt = c3;
            }
          else
            Fe = Pe.nodeName, !Fe || Fe.toLowerCase() !== "input" || Pe.type !== "checkbox" && Pe.type !== "radio" ? ke && kw(ke.elementType) && (Qn = Ww) : Qn = od;
          if (Qn && (Qn = Qn(u, ke))) {
            Xw(
              et,
              Qn,
              v,
              qe
            );
            break e;
          }
          Dt && Dt(u, Pe, ke), u === "focusout" && ke && Pe.type === "number" && ke.memoizedProps.value != null && mf(Pe, "number", Pe.value);
        }
        switch (Dt = ke ? li(ke) : window, u) {
          case "focusin":
            (tc(Dt) || Dt.contentEditable === "true") && (ld = Dt, Zh = ke, Us = null);
            break;
          case "focusout":
            Us = Zh = ld = null;
            break;
          case "mousedown":
            wl = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            wl = !1, sv(et, v, qe);
            break;
          case "selectionchange":
            if (fm)
              break;
          case "keydown":
          case "keyup":
            sv(et, v, qe);
        }
        var ln;
        if (Wh)
          e: {
            switch (u) {
              case "compositionstart":
                var mn = "onCompositionStart";
                break e;
              case "compositionend":
                mn = "onCompositionEnd";
                break e;
              case "compositionupdate":
                mn = "onCompositionUpdate";
                break e;
            }
            mn = void 0;
          }
        else
          wf ? rv(u, v) && (mn = "onCompositionEnd") : u === "keydown" && v.keyCode === 229 && (mn = "onCompositionStart");
        mn && (qw && v.locale !== "ko" && (wf || mn !== "onCompositionStart" ? mn === "onCompositionEnd" && wf && (ln = Lw()) : (au = qe, Pw = "value" in au ? au.value : au.textContent, wf = !0)), Dt = o1(ke, mn), 0 < Dt.length && (mn = new r3(
          mn,
          u,
          null,
          v,
          qe
        ), et.push({ event: mn, listeners: Dt }), ln ? mn.data = ln : (ln = Gw(v), ln !== null && (mn.data = ln)))), (ln = Wa ? l3(u, v) : BO(u, v)) && (mn = o1(ke, "onBeforeInput"), 0 < mn.length && (Dt = new r3(
          "onBeforeInput",
          "beforeinput",
          null,
          v,
          qe
        ), et.push({
          event: Dt,
          listeners: mn
        }), Dt.data = ln)), r1(
          et,
          u,
          ke,
          v,
          qe
        );
      }
      rA(et, p);
    });
  }
  function a1(u, p, v) {
    return {
      instance: u,
      listener: p,
      currentTarget: v
    };
  }
  function o1(u, p) {
    for (var v = p + "Capture", x = []; u !== null; ) {
      var D = u, k = D.stateNode;
      if (D = D.tag, D !== 5 && D !== 26 && D !== 27 || k === null || (D = ua(u, v), D != null && x.unshift(
        a1(u, D, k)
      ), D = ua(u, p), D != null && x.push(
        a1(u, D, k)
      )), u.tag === 3)
        return x;
      u = u.return;
    }
    return [];
  }
  function iA(u) {
    if (u === null)
      return null;
    do
      u = u.return;
    while (u && u.tag !== 5 && u.tag !== 27);
    return u || null;
  }
  function uy(u, p, v, x, D) {
    for (var k = p._reactName, X = []; v !== null && v !== x; ) {
      var oe = v, me = oe.alternate, ke = oe.stateNode;
      if (oe = oe.tag, me !== null && me === x)
        break;
      oe !== 5 && oe !== 26 && oe !== 27 || ke === null || (me = ke, D ? (ke = ua(v, k), ke != null && X.unshift(
        a1(v, ke, me)
      )) : D || (ke = ua(v, k), ke != null && X.push(
        a1(v, ke, me)
      ))), v = v.return;
    }
    X.length !== 0 && u.push({ event: p, listeners: X });
  }
  var aA = /\r\n?/g, ux = /\u0000|\uFFFD/g;
  function dx(u) {
    return (typeof u == "string" ? u : "" + u).replace(aA, `
`).replace(ux, "");
  }
  function fx(u, p) {
    return p = dx(p), dx(u) === p;
  }
  function Ar(u, p, v, x, D, k) {
    switch (v) {
      case "children":
        typeof x == "string" ? p === "body" || p === "textarea" && x === "" || Kl(u, x) : (typeof x == "number" || typeof x == "bigint") && p !== "body" && Kl(u, "" + x);
        break;
      case "className":
        qg(u, "class", x);
        break;
      case "tabIndex":
        qg(u, "tabindex", x);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        qg(u, v, x);
        break;
      case "style":
        Z_(u, x, k);
        break;
      case "data":
        if (p !== "object") {
          qg(u, "data", x);
          break;
        }
      case "src":
      case "href":
        if (x === "" && (p !== "a" || v !== "href")) {
          u.removeAttribute(v);
          break;
        }
        if (x == null || typeof x == "function" || typeof x == "symbol" || typeof x == "boolean") {
          u.removeAttribute(v);
          break;
        }
        x = zs("" + x), u.setAttribute(v, x);
        break;
      case "action":
      case "formAction":
        if (typeof x == "function") {
          u.setAttribute(
            v,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof k == "function" && (v === "formAction" ? (p !== "input" && Ar(u, p, "name", D.name, D, null), Ar(
            u,
            p,
            "formEncType",
            D.formEncType,
            D,
            null
          ), Ar(
            u,
            p,
            "formMethod",
            D.formMethod,
            D,
            null
          ), Ar(
            u,
            p,
            "formTarget",
            D.formTarget,
            D,
            null
          )) : (Ar(u, p, "encType", D.encType, D, null), Ar(u, p, "method", D.method, D, null), Ar(u, p, "target", D.target, D, null)));
        if (x == null || typeof x == "symbol" || typeof x == "boolean") {
          u.removeAttribute(v);
          break;
        }
        x = zs("" + x), u.setAttribute(v, x);
        break;
      case "onClick":
        x != null && (u.onclick = ml);
        break;
      case "onScroll":
        x != null && Dn("scroll", u);
        break;
      case "onScrollEnd":
        x != null && Dn("scrollend", u);
        break;
      case "dangerouslySetInnerHTML":
        if (x != null) {
          if (typeof x != "object" || !("__html" in x))
            throw Error(r(61));
          if (v = x.__html, v != null) {
            if (D.children != null)
              throw Error(r(60));
            u.innerHTML = v;
          }
        }
        break;
      case "multiple":
        u.multiple = x && typeof x != "function" && typeof x != "symbol";
        break;
      case "muted":
        u.muted = x && typeof x != "function" && typeof x != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (x == null || typeof x == "function" || typeof x == "boolean" || typeof x == "symbol") {
          u.removeAttribute("xlink:href");
          break;
        }
        v = zs("" + x), u.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          v
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        x != null && typeof x != "function" && typeof x != "symbol" ? u.setAttribute(v, "" + x) : u.removeAttribute(v);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        x && typeof x != "function" && typeof x != "symbol" ? u.setAttribute(v, "") : u.removeAttribute(v);
        break;
      case "capture":
      case "download":
        x === !0 ? u.setAttribute(v, "") : x !== !1 && x != null && typeof x != "function" && typeof x != "symbol" ? u.setAttribute(v, x) : u.removeAttribute(v);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        x != null && typeof x != "function" && typeof x != "symbol" && !isNaN(x) && 1 <= x ? u.setAttribute(v, x) : u.removeAttribute(v);
        break;
      case "rowSpan":
      case "start":
        x == null || typeof x == "function" || typeof x == "symbol" || isNaN(x) ? u.removeAttribute(v) : u.setAttribute(v, x);
        break;
      case "popover":
        Dn("beforetoggle", u), Dn("toggle", u), $h(u, "popover", x);
        break;
      case "xlinkActuate":
        ru(
          u,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          x
        );
        break;
      case "xlinkArcrole":
        ru(
          u,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          x
        );
        break;
      case "xlinkRole":
        ru(
          u,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          x
        );
        break;
      case "xlinkShow":
        ru(
          u,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          x
        );
        break;
      case "xlinkTitle":
        ru(
          u,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          x
        );
        break;
      case "xlinkType":
        ru(
          u,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          x
        );
        break;
      case "xmlBase":
        ru(
          u,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          x
        );
        break;
      case "xmlLang":
        ru(
          u,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          x
        );
        break;
      case "xmlSpace":
        ru(
          u,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          x
        );
        break;
      case "is":
        $h(u, "is", x);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < v.length) || v[0] !== "o" && v[0] !== "O" || v[1] !== "n" && v[1] !== "N") && (v = IO.get(v) || v, $h(u, v, x));
    }
  }
  function hx(u, p, v, x, D, k) {
    switch (v) {
      case "style":
        Z_(u, x, k);
        break;
      case "dangerouslySetInnerHTML":
        if (x != null) {
          if (typeof x != "object" || !("__html" in x))
            throw Error(r(61));
          if (v = x.__html, v != null) {
            if (D.children != null)
              throw Error(r(60));
            u.innerHTML = v;
          }
        }
        break;
      case "children":
        typeof x == "string" ? Kl(u, x) : (typeof x == "number" || typeof x == "bigint") && Kl(u, "" + x);
        break;
      case "onScroll":
        x != null && Dn("scroll", u);
        break;
      case "onScrollEnd":
        x != null && Dn("scrollend", u);
        break;
      case "onClick":
        x != null && (u.onclick = ml);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!Bo.hasOwnProperty(v))
          e: {
            if (v[0] === "o" && v[1] === "n" && (D = v.endsWith("Capture"), p = v.slice(2, D ? v.length - 7 : void 0), k = u[ca] || null, k = k != null ? k[v] : null, typeof k == "function" && u.removeEventListener(p, k, D), typeof x == "function")) {
              typeof k != "function" && k !== null && (v in u ? u[v] = null : u.hasAttribute(v) && u.removeAttribute(v)), u.addEventListener(p, x, D);
              break e;
            }
            v in u ? u[v] = x : x === !0 ? u.setAttribute(v, "") : $h(u, v, x);
          }
    }
  }
  function Da(u, p, v) {
    switch (p) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Dn("error", u), Dn("load", u);
        var x = !1, D = !1, k;
        for (k in v)
          if (v.hasOwnProperty(k)) {
            var X = v[k];
            if (X != null)
              switch (k) {
                case "src":
                  x = !0;
                  break;
                case "srcSet":
                  D = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(r(137, p));
                default:
                  Ar(u, p, k, X, v, null);
              }
          }
        D && Ar(u, p, "srcSet", v.srcSet, v, null), x && Ar(u, p, "src", v.src, v, null);
        return;
      case "input":
        Dn("invalid", u);
        var oe = k = X = D = null, me = null, ke = null;
        for (x in v)
          if (v.hasOwnProperty(x)) {
            var qe = v[x];
            if (qe != null)
              switch (x) {
                case "name":
                  D = qe;
                  break;
                case "type":
                  X = qe;
                  break;
                case "checked":
                  me = qe;
                  break;
                case "defaultChecked":
                  ke = qe;
                  break;
                case "value":
                  k = qe;
                  break;
                case "defaultValue":
                  oe = qe;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (qe != null)
                    throw Error(r(137, p));
                  break;
                default:
                  Ar(u, p, x, qe, v, null);
              }
          }
        rm(
          u,
          k,
          oe,
          me,
          ke,
          X,
          D,
          !1
        );
        return;
      case "select":
        Dn("invalid", u), x = X = k = null;
        for (D in v)
          if (v.hasOwnProperty(D) && (oe = v[D], oe != null))
            switch (D) {
              case "value":
                k = oe;
                break;
              case "defaultValue":
                X = oe;
                break;
              case "multiple":
                x = oe;
              default:
                Ar(u, p, D, oe, v, null);
            }
        p = k, v = X, u.multiple = !!x, p != null ? Hh(u, !!x, p, !1) : v != null && Hh(u, !!x, v, !0);
        return;
      case "textarea":
        Dn("invalid", u), k = D = x = null;
        for (X in v)
          if (v.hasOwnProperty(X) && (oe = v[X], oe != null))
            switch (X) {
              case "value":
                x = oe;
                break;
              case "defaultValue":
                D = oe;
                break;
              case "children":
                k = oe;
                break;
              case "dangerouslySetInnerHTML":
                if (oe != null)
                  throw Error(r(91));
                break;
              default:
                Ar(u, p, X, oe, v, null);
            }
        Iw(u, x, D, k);
        return;
      case "option":
        for (me in v)
          if (v.hasOwnProperty(me) && (x = v[me], x != null))
            switch (me) {
              case "selected":
                u.selected = x && typeof x != "function" && typeof x != "symbol";
                break;
              default:
                Ar(u, p, me, x, v, null);
            }
        return;
      case "dialog":
        Dn("beforetoggle", u), Dn("toggle", u), Dn("cancel", u), Dn("close", u);
        break;
      case "iframe":
      case "object":
        Dn("load", u);
        break;
      case "video":
      case "audio":
        for (x = 0; x < Mp.length; x++)
          Dn(Mp[x], u);
        break;
      case "image":
        Dn("error", u), Dn("load", u);
        break;
      case "details":
        Dn("toggle", u);
        break;
      case "embed":
      case "source":
      case "link":
        Dn("error", u), Dn("load", u);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (ke in v)
          if (v.hasOwnProperty(ke) && (x = v[ke], x != null))
            switch (ke) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(137, p));
              default:
                Ar(u, p, ke, x, v, null);
            }
        return;
      default:
        if (kw(p)) {
          for (qe in v)
            v.hasOwnProperty(qe) && (x = v[qe], x !== void 0 && hx(
              u,
              p,
              qe,
              x,
              v,
              void 0
            ));
          return;
        }
    }
    for (oe in v)
      v.hasOwnProperty(oe) && (x = v[oe], x != null && Ar(u, p, oe, x, v, null));
  }
  function px(u, p, v, x) {
    switch (p) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var D = null, k = null, X = null, oe = null, me = null, ke = null, qe = null;
        for (Fe in v) {
          var et = v[Fe];
          if (v.hasOwnProperty(Fe) && et != null)
            switch (Fe) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                me = et;
              default:
                x.hasOwnProperty(Fe) || Ar(u, p, Fe, null, x, et);
            }
        }
        for (var Pe in x) {
          var Fe = x[Pe];
          if (et = v[Pe], x.hasOwnProperty(Pe) && (Fe != null || et != null))
            switch (Pe) {
              case "type":
                k = Fe;
                break;
              case "name":
                D = Fe;
                break;
              case "checked":
                ke = Fe;
                break;
              case "defaultChecked":
                qe = Fe;
                break;
              case "value":
                X = Fe;
                break;
              case "defaultValue":
                oe = Fe;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (Fe != null)
                  throw Error(r(137, p));
                break;
              default:
                Fe !== et && Ar(
                  u,
                  p,
                  Pe,
                  Fe,
                  x,
                  et
                );
            }
        }
        nm(
          u,
          X,
          oe,
          me,
          ke,
          qe,
          k,
          D
        );
        return;
      case "select":
        Fe = X = oe = Pe = null;
        for (k in v)
          if (me = v[k], v.hasOwnProperty(k) && me != null)
            switch (k) {
              case "value":
                break;
              case "multiple":
                Fe = me;
              default:
                x.hasOwnProperty(k) || Ar(
                  u,
                  p,
                  k,
                  null,
                  x,
                  me
                );
            }
        for (D in x)
          if (k = x[D], me = v[D], x.hasOwnProperty(D) && (k != null || me != null))
            switch (D) {
              case "value":
                Pe = k;
                break;
              case "defaultValue":
                oe = k;
                break;
              case "multiple":
                X = k;
              default:
                k !== me && Ar(
                  u,
                  p,
                  D,
                  k,
                  x,
                  me
                );
            }
        p = oe, v = X, x = Fe, Pe != null ? Hh(u, !!v, Pe, !1) : !!x != !!v && (p != null ? Hh(u, !!v, p, !0) : Hh(u, !!v, v ? [] : "", !1));
        return;
      case "textarea":
        Fe = Pe = null;
        for (oe in v)
          if (D = v[oe], v.hasOwnProperty(oe) && D != null && !x.hasOwnProperty(oe))
            switch (oe) {
              case "value":
                break;
              case "children":
                break;
              default:
                Ar(u, p, oe, null, x, D);
            }
        for (X in x)
          if (D = x[X], k = v[X], x.hasOwnProperty(X) && (D != null || k != null))
            switch (X) {
              case "value":
                Pe = D;
                break;
              case "defaultValue":
                Fe = D;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (D != null)
                  throw Error(r(91));
                break;
              default:
                D !== k && Ar(u, p, X, D, x, k);
            }
        Mw(u, Pe, Fe);
        return;
      case "option":
        for (var Et in v)
          if (Pe = v[Et], v.hasOwnProperty(Et) && Pe != null && !x.hasOwnProperty(Et))
            switch (Et) {
              case "selected":
                u.selected = !1;
                break;
              default:
                Ar(
                  u,
                  p,
                  Et,
                  null,
                  x,
                  Pe
                );
            }
        for (me in x)
          if (Pe = x[me], Fe = v[me], x.hasOwnProperty(me) && Pe !== Fe && (Pe != null || Fe != null))
            switch (me) {
              case "selected":
                u.selected = Pe && typeof Pe != "function" && typeof Pe != "symbol";
                break;
              default:
                Ar(
                  u,
                  p,
                  me,
                  Pe,
                  x,
                  Fe
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var Ut in v)
          Pe = v[Ut], v.hasOwnProperty(Ut) && Pe != null && !x.hasOwnProperty(Ut) && Ar(u, p, Ut, null, x, Pe);
        for (ke in x)
          if (Pe = x[ke], Fe = v[ke], x.hasOwnProperty(ke) && Pe !== Fe && (Pe != null || Fe != null))
            switch (ke) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (Pe != null)
                  throw Error(r(137, p));
                break;
              default:
                Ar(
                  u,
                  p,
                  ke,
                  Pe,
                  x,
                  Fe
                );
            }
        return;
      default:
        if (kw(p)) {
          for (var Cr in v)
            Pe = v[Cr], v.hasOwnProperty(Cr) && Pe !== void 0 && !x.hasOwnProperty(Cr) && hx(
              u,
              p,
              Cr,
              void 0,
              x,
              Pe
            );
          for (qe in x)
            Pe = x[qe], Fe = v[qe], !x.hasOwnProperty(qe) || Pe === Fe || Pe === void 0 && Fe === void 0 || hx(
              u,
              p,
              qe,
              Pe,
              x,
              Fe
            );
          return;
        }
    }
    for (var Oe in v)
      Pe = v[Oe], v.hasOwnProperty(Oe) && Pe != null && !x.hasOwnProperty(Oe) && Ar(u, p, Oe, null, x, Pe);
    for (et in x)
      Pe = x[et], Fe = v[et], !x.hasOwnProperty(et) || Pe === Fe || Pe == null && Fe == null || Ar(u, p, et, Pe, x, Fe);
  }
  function dy(u) {
    switch (u) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function mx() {
    if (typeof performance.getEntriesByType == "function") {
      for (var u = 0, p = 0, v = performance.getEntriesByType("resource"), x = 0; x < v.length; x++) {
        var D = v[x], k = D.transferSize, X = D.initiatorType, oe = D.duration;
        if (k && oe && dy(X)) {
          for (X = 0, oe = D.responseEnd, x += 1; x < v.length; x++) {
            var me = v[x], ke = me.startTime;
            if (ke > oe)
              break;
            var qe = me.transferSize, et = me.initiatorType;
            qe && dy(et) && (me = me.responseEnd, X += qe * (me < oe ? 1 : (oe - ke) / (me - ke)));
          }
          if (--x, p += 8 * (k + X) / (D.duration / 1e3), u++, 10 < u)
            break;
        }
      }
      if (0 < u)
        return p / u / 1e6;
    }
    return navigator.connection && (u = navigator.connection.downlink, typeof u == "number") ? u : 5;
  }
  var fy = null, hy = null;
  function Dd(u) {
    return u.nodeType === 9 ? u : u.ownerDocument;
  }
  function oA(u) {
    switch (u) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function gx(u, p) {
    if (u === 0)
      switch (p) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return u === 1 && p === "foreignObject" ? 0 : u;
  }
  function kp(u, p) {
    return u === "textarea" || u === "noscript" || typeof p.children == "string" || typeof p.children == "number" || typeof p.children == "bigint" || typeof p.dangerouslySetInnerHTML == "object" && p.dangerouslySetInnerHTML !== null && p.dangerouslySetInnerHTML.__html != null;
  }
  var py = null;
  function UO() {
    var u = window.event;
    return u && u.type === "popstate" ? u === py ? !1 : (py = u, !0) : (py = null, !1);
  }
  var s1 = typeof setTimeout == "function" ? setTimeout : void 0, sA = typeof clearTimeout == "function" ? clearTimeout : void 0, Zf = typeof Promise == "function" ? Promise : void 0, lA = typeof queueMicrotask == "function" ? queueMicrotask : typeof Zf < "u" ? function(u) {
    return Zf.resolve(null).then(u).catch(vx);
  } : s1;
  function vx(u) {
    setTimeout(function() {
      throw u;
    });
  }
  function kl(u) {
    return u === "head";
  }
  function yx(u, p) {
    var v = p, x = 0;
    do {
      var D = v.nextSibling;
      if (u.removeChild(v), D && D.nodeType === 8)
        if (v = D.data, v === "/$" || v === "/&") {
          if (x === 0) {
            u.removeChild(D), Gp(p);
            return;
          }
          x--;
        } else if (v === "$" || v === "$?" || v === "$~" || v === "$!" || v === "&")
          x++;
        else if (v === "html")
          Kf(u.ownerDocument.documentElement);
        else if (v === "head") {
          v = u.ownerDocument.head, Kf(v);
          for (var k = v.firstChild; k; ) {
            var X = k.nextSibling, oe = k.nodeName;
            k[we] || oe === "SCRIPT" || oe === "STYLE" || oe === "LINK" && k.rel.toLowerCase() === "stylesheet" || v.removeChild(k), k = X;
          }
        } else
          v === "body" && Kf(u.ownerDocument.body);
      v = D;
    } while (v);
    Gp(p);
  }
  function Pi(u, p) {
    var v = u;
    u = 0;
    do {
      var x = v.nextSibling;
      if (v.nodeType === 1 ? p ? (v._stashedDisplay = v.style.display, v.style.display = "none") : (v.style.display = v._stashedDisplay || "", v.getAttribute("style") === "" && v.removeAttribute("style")) : v.nodeType === 3 && (p ? (v._stashedText = v.nodeValue, v.nodeValue = "") : v.nodeValue = v._stashedText || ""), x && x.nodeType === 8)
        if (v = x.data, v === "/$") {
          if (u === 0)
            break;
          u--;
        } else
          v !== "$" && v !== "$?" && v !== "$~" && v !== "$!" || u++;
      v = x;
    } while (v);
  }
  function l1(u) {
    var p = u.firstChild;
    for (p && p.nodeType === 10 && (p = p.nextSibling); p; ) {
      var v = p;
      switch (p = p.nextSibling, v.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          l1(v), ot(v);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (v.rel.toLowerCase() === "stylesheet")
            continue;
      }
      u.removeChild(v);
    }
  }
  function $O(u, p, v, x) {
    for (; u.nodeType === 1; ) {
      var D = v;
      if (u.nodeName.toLowerCase() !== p.toLowerCase()) {
        if (!x && (u.nodeName !== "INPUT" || u.type !== "hidden"))
          break;
      } else if (x) {
        if (!u[we])
          switch (p) {
            case "meta":
              if (!u.hasAttribute("itemprop"))
                break;
              return u;
            case "link":
              if (k = u.getAttribute("rel"), k === "stylesheet" && u.hasAttribute("data-precedence"))
                break;
              if (k !== D.rel || u.getAttribute("href") !== (D.href == null || D.href === "" ? null : D.href) || u.getAttribute("crossorigin") !== (D.crossOrigin == null ? null : D.crossOrigin) || u.getAttribute("title") !== (D.title == null ? null : D.title))
                break;
              return u;
            case "style":
              if (u.hasAttribute("data-precedence"))
                break;
              return u;
            case "script":
              if (k = u.getAttribute("src"), (k !== (D.src == null ? null : D.src) || u.getAttribute("type") !== (D.type == null ? null : D.type) || u.getAttribute("crossorigin") !== (D.crossOrigin == null ? null : D.crossOrigin)) && k && u.hasAttribute("async") && !u.hasAttribute("itemprop"))
                break;
              return u;
            default:
              return u;
          }
      } else if (p === "input" && u.type === "hidden") {
        var k = D.name == null ? null : "" + D.name;
        if (D.type === "hidden" && u.getAttribute("name") === k)
          return u;
      } else
        return u;
      if (u = To(u.nextSibling), u === null)
        break;
    }
    return null;
  }
  function yn(u, p, v) {
    if (p === "")
      return null;
    for (; u.nodeType !== 3; )
      if ((u.nodeType !== 1 || u.nodeName !== "INPUT" || u.type !== "hidden") && !v || (u = To(u.nextSibling), u === null))
        return null;
    return u;
  }
  function cA(u, p) {
    for (; u.nodeType !== 8; )
      if ((u.nodeType !== 1 || u.nodeName !== "INPUT" || u.type !== "hidden") && !p || (u = To(u.nextSibling), u === null))
        return null;
    return u;
  }
  function Qs(u) {
    return u.data === "$?" || u.data === "$~";
  }
  function Nd(u) {
    return u.data === "$!" || u.data === "$?" && u.ownerDocument.readyState !== "loading";
  }
  function jp(u, p) {
    var v = u.ownerDocument;
    if (u.data === "$~")
      u._reactRetry = p;
    else if (u.data !== "$?" || v.readyState !== "loading")
      p();
    else {
      var x = function() {
        p(), v.removeEventListener("DOMContentLoaded", x);
      };
      v.addEventListener("DOMContentLoaded", x), u._reactRetry = x;
    }
  }
  function To(u) {
    for (; u != null; u = u.nextSibling) {
      var p = u.nodeType;
      if (p === 1 || p === 3)
        break;
      if (p === 8) {
        if (p = u.data, p === "$" || p === "$!" || p === "$?" || p === "$~" || p === "&" || p === "F!" || p === "F")
          break;
        if (p === "/$" || p === "/&")
          return null;
      }
    }
    return u;
  }
  var c1 = null;
  function my(u) {
    u = u.nextSibling;
    for (var p = 0; u; ) {
      if (u.nodeType === 8) {
        var v = u.data;
        if (v === "/$" || v === "/&") {
          if (p === 0)
            return To(u.nextSibling);
          p--;
        } else
          v !== "$" && v !== "$!" && v !== "$?" && v !== "$~" && v !== "&" || p++;
      }
      u = u.nextSibling;
    }
    return null;
  }
  function jl(u) {
    u = u.previousSibling;
    for (var p = 0; u; ) {
      if (u.nodeType === 8) {
        var v = u.data;
        if (v === "$" || v === "$!" || v === "$?" || v === "$~" || v === "&") {
          if (p === 0)
            return u;
          p--;
        } else
          v !== "/$" && v !== "/&" || p++;
      }
      u = u.previousSibling;
    }
    return null;
  }
  function Pp(u, p, v) {
    switch (p = Dd(v), u) {
      case "html":
        if (u = p.documentElement, !u)
          throw Error(r(452));
        return u;
      case "head":
        if (u = p.head, !u)
          throw Error(r(453));
        return u;
      case "body":
        if (u = p.body, !u)
          throw Error(r(454));
        return u;
      default:
        throw Error(r(451));
    }
  }
  function Kf(u) {
    for (var p = u.attributes; p.length; )
      u.removeAttributeNode(p[0]);
    ot(u);
  }
  var qo = /* @__PURE__ */ new Map(), u1 = /* @__PURE__ */ new Set();
  function Ka(u) {
    return typeof u.getRootNode == "function" ? u.getRootNode() : u.nodeType === 9 ? u : u.ownerDocument;
  }
  var Pl = q.d;
  q.d = {
    f: HO,
    r: uA,
    D: ze,
    C: ur,
    L: qO,
    m: bx,
    X: _u,
    S: wx,
    M: Md
  };
  function HO() {
    var u = Pl.f(), p = Tp();
    return u || p;
  }
  function uA(u) {
    var p = Kn(u);
    p !== null && p.tag === 5 && p.type === "form" ? Er(p) : Pl.r(u);
  }
  var Lp = typeof document > "u" ? null : document;
  function Yi(u, p, v) {
    var x = Lp;
    if (x && typeof p == "string" && p) {
      var D = is(p);
      D = 'link[rel="' + u + '"][href="' + D + '"]', typeof v == "string" && (D += '[crossorigin="' + v + '"]'), u1.has(D) || (u1.add(D), u = { rel: u, crossOrigin: v, href: p }, x.querySelector(D) === null && (p = x.createElement("link"), Da(p, "link", u), on(p), x.head.appendChild(p)));
    }
  }
  function ze(u) {
    Pl.D(u), Yi("dns-prefetch", u, null);
  }
  function ur(u, p) {
    Pl.C(u, p), Yi("preconnect", u, p);
  }
  function qO(u, p, v) {
    Pl.L(u, p, v);
    var x = Lp;
    if (x && u && p) {
      var D = 'link[rel="preload"][as="' + is(p) + '"]';
      p === "image" && v && v.imageSrcSet ? (D += '[imagesrcset="' + is(
        v.imageSrcSet
      ) + '"]', typeof v.imageSizes == "string" && (D += '[imagesizes="' + is(
        v.imageSizes
      ) + '"]')) : D += '[href="' + is(u) + '"]';
      var k = D;
      switch (p) {
        case "style":
          k = ys(u);
          break;
        case "script":
          k = Jf(u);
      }
      qo.has(k) || (u = m(
        {
          rel: "preload",
          href: p === "image" && v && v.imageSrcSet ? void 0 : u,
          as: p
        },
        v
      ), qo.set(k, u), x.querySelector(D) !== null || p === "style" && x.querySelector(Id(k)) || p === "script" && x.querySelector(Fp(k)) || (p = x.createElement("link"), Da(p, "link", u), on(p), x.head.appendChild(p)));
    }
  }
  function bx(u, p) {
    Pl.m(u, p);
    var v = Lp;
    if (v && u) {
      var x = p && typeof p.as == "string" ? p.as : "script", D = 'link[rel="modulepreload"][as="' + is(x) + '"][href="' + is(u) + '"]', k = D;
      switch (x) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          k = Jf(u);
      }
      if (!qo.has(k) && (u = m({ rel: "modulepreload", href: u }, p), qo.set(k, u), v.querySelector(D) === null)) {
        switch (x) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (v.querySelector(Fp(k)))
              return;
        }
        x = v.createElement("link"), Da(x, "link", u), on(x), v.head.appendChild(x);
      }
    }
  }
  function wx(u, p, v) {
    Pl.S(u, p, v);
    var x = Lp;
    if (x && u) {
      var D = kr(x).hoistableStyles, k = ys(u);
      p = p || "default";
      var X = D.get(k);
      if (!X) {
        var oe = { loading: 0, preload: null };
        if (X = x.querySelector(
          Id(k)
        ))
          oe.loading = 5;
        else {
          u = m(
            { rel: "stylesheet", href: u, "data-precedence": p },
            v
          ), (v = qo.get(k)) && gy(u, v);
          var me = X = x.createElement("link");
          on(me), Da(me, "link", u), me._p = new Promise(function(ke, qe) {
            me.onload = ke, me.onerror = qe;
          }), me.addEventListener("load", function() {
            oe.loading |= 1;
          }), me.addEventListener("error", function() {
            oe.loading |= 2;
          }), oe.loading |= 4, d1(X, p, x);
        }
        X = {
          type: "stylesheet",
          instance: X,
          count: 1,
          state: oe
        }, D.set(k, X);
      }
    }
  }
  function _u(u, p) {
    Pl.X(u, p);
    var v = Lp;
    if (v && u) {
      var x = kr(v).hoistableScripts, D = Jf(u), k = x.get(D);
      k || (k = v.querySelector(Fp(D)), k || (u = m({ src: u, async: !0 }, p), (p = qo.get(D)) && vy(u, p), k = v.createElement("script"), on(k), Da(k, "link", u), v.head.appendChild(k)), k = {
        type: "script",
        instance: k,
        count: 1,
        state: null
      }, x.set(D, k));
    }
  }
  function Md(u, p) {
    Pl.M(u, p);
    var v = Lp;
    if (v && u) {
      var x = kr(v).hoistableScripts, D = Jf(u), k = x.get(D);
      k || (k = v.querySelector(Fp(D)), k || (u = m({ src: u, async: !0, type: "module" }, p), (p = qo.get(D)) && vy(u, p), k = v.createElement("script"), on(k), Da(k, "link", u), v.head.appendChild(k)), k = {
        type: "script",
        instance: k,
        count: 1,
        state: null
      }, x.set(D, k));
    }
  }
  function Bp(u, p, v, x) {
    var D = (D = _e.current) ? Ka(D) : null;
    if (!D)
      throw Error(r(446));
    switch (u) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof v.precedence == "string" && typeof v.href == "string" ? (p = ys(v.href), v = kr(
          D
        ).hoistableStyles, x = v.get(p), x || (x = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, v.set(p, x)), x) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (v.rel === "stylesheet" && typeof v.href == "string" && typeof v.precedence == "string") {
          u = ys(v.href);
          var k = kr(
            D
          ).hoistableStyles, X = k.get(u);
          if (X || (D = D.ownerDocument || D, X = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, k.set(u, X), (k = D.querySelector(
            Id(u)
          )) && !k._p && (X.instance = k, X.state.loading = 5), qo.has(u) || (v = {
            rel: "preload",
            as: "style",
            href: v.href,
            crossOrigin: v.crossOrigin,
            integrity: v.integrity,
            media: v.media,
            hrefLang: v.hrefLang,
            referrerPolicy: v.referrerPolicy
          }, qo.set(u, v), k || dA(
            D,
            u,
            v,
            X.state
          ))), p && x === null)
            throw Error(r(528, ""));
          return X;
        }
        if (p && x !== null)
          throw Error(r(529, ""));
        return null;
      case "script":
        return p = v.async, v = v.src, typeof v == "string" && p && typeof p != "function" && typeof p != "symbol" ? (p = Jf(v), v = kr(
          D
        ).hoistableScripts, x = v.get(p), x || (x = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, v.set(p, x)), x) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(r(444, u));
    }
  }
  function ys(u) {
    return 'href="' + is(u) + '"';
  }
  function Id(u) {
    return 'link[rel="stylesheet"][' + u + "]";
  }
  function zp(u) {
    return m({}, u, {
      "data-precedence": u.precedence,
      precedence: null
    });
  }
  function dA(u, p, v, x) {
    u.querySelector('link[rel="preload"][as="style"][' + p + "]") ? x.loading = 1 : (p = u.createElement("link"), x.preload = p, p.addEventListener("load", function() {
      return x.loading |= 1;
    }), p.addEventListener("error", function() {
      return x.loading |= 2;
    }), Da(p, "link", v), on(p), u.head.appendChild(p));
  }
  function Jf(u) {
    return '[src="' + is(u) + '"]';
  }
  function Fp(u) {
    return "script[async]" + u;
  }
  function xx(u, p, v) {
    if (p.count++, p.instance === null)
      switch (p.type) {
        case "style":
          var x = u.querySelector(
            'style[data-href~="' + is(v.href) + '"]'
          );
          if (x)
            return p.instance = x, on(x), x;
          var D = m({}, v, {
            "data-href": v.href,
            "data-precedence": v.precedence,
            href: null,
            precedence: null
          });
          return x = (u.ownerDocument || u).createElement(
            "style"
          ), on(x), Da(x, "style", D), d1(x, v.precedence, u), p.instance = x;
        case "stylesheet":
          D = ys(v.href);
          var k = u.querySelector(
            Id(D)
          );
          if (k)
            return p.state.loading |= 4, p.instance = k, on(k), k;
          x = zp(v), (D = qo.get(D)) && gy(x, D), k = (u.ownerDocument || u).createElement("link"), on(k);
          var X = k;
          return X._p = new Promise(function(oe, me) {
            X.onload = oe, X.onerror = me;
          }), Da(k, "link", x), p.state.loading |= 4, d1(k, v.precedence, u), p.instance = k;
        case "script":
          return k = Jf(v.src), (D = u.querySelector(
            Fp(k)
          )) ? (p.instance = D, on(D), D) : (x = v, (D = qo.get(k)) && (x = m({}, v), vy(x, D)), u = u.ownerDocument || u, D = u.createElement("script"), on(D), Da(D, "link", x), u.head.appendChild(D), p.instance = D);
        case "void":
          return null;
        default:
          throw Error(r(443, p.type));
      }
    else
      p.type === "stylesheet" && !(p.state.loading & 4) && (x = p.instance, p.state.loading |= 4, d1(x, v.precedence, u));
    return p.instance;
  }
  function d1(u, p, v) {
    for (var x = v.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), D = x.length ? x[x.length - 1] : null, k = D, X = 0; X < x.length; X++) {
      var oe = x[X];
      if (oe.dataset.precedence === p)
        k = oe;
      else if (k !== D)
        break;
    }
    k ? k.parentNode.insertBefore(u, k.nextSibling) : (p = v.nodeType === 9 ? v.head : v, p.insertBefore(u, p.firstChild));
  }
  function gy(u, p) {
    u.crossOrigin == null && (u.crossOrigin = p.crossOrigin), u.referrerPolicy == null && (u.referrerPolicy = p.referrerPolicy), u.title == null && (u.title = p.title);
  }
  function vy(u, p) {
    u.crossOrigin == null && (u.crossOrigin = p.crossOrigin), u.referrerPolicy == null && (u.referrerPolicy = p.referrerPolicy), u.integrity == null && (u.integrity = p.integrity);
  }
  var Vp = null;
  function Sx(u, p, v) {
    if (Vp === null) {
      var x = /* @__PURE__ */ new Map(), D = Vp = /* @__PURE__ */ new Map();
      D.set(v, x);
    } else
      D = Vp, x = D.get(v), x || (x = /* @__PURE__ */ new Map(), D.set(v, x));
    if (x.has(u))
      return x;
    for (x.set(u, null), v = v.getElementsByTagName(u), D = 0; D < v.length; D++) {
      var k = v[D];
      if (!(k[we] || k[Rn] || u === "link" && k.getAttribute("rel") === "stylesheet") && k.namespaceURI !== "http://www.w3.org/2000/svg") {
        var X = k.getAttribute(p) || "";
        X = u + X;
        var oe = x.get(X);
        oe ? oe.push(k) : x.set(X, [k]);
      }
    }
    return x;
  }
  function yy(u, p, v) {
    u = u.ownerDocument || u, u.head.insertBefore(
      v,
      p === "title" ? u.querySelector("head > title") : null
    );
  }
  function Ex(u, p, v) {
    if (v === 1 || p.itemProp != null)
      return !1;
    switch (u) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof p.precedence != "string" || typeof p.href != "string" || p.href === "")
          break;
        return !0;
      case "link":
        if (typeof p.rel != "string" || typeof p.href != "string" || p.href === "" || p.onLoad || p.onError)
          break;
        switch (p.rel) {
          case "stylesheet":
            return u = p.disabled, typeof p.precedence == "string" && u == null;
          default:
            return !0;
        }
      case "script":
        if (p.async && typeof p.async != "function" && typeof p.async != "symbol" && !p.onLoad && !p.onError && p.src && typeof p.src == "string")
          return !0;
    }
    return !1;
  }
  function Go(u) {
    return !(u.type === "stylesheet" && !(u.state.loading & 3));
  }
  function Ec(u, p, v, x) {
    if (v.type === "stylesheet" && (typeof x.media != "string" || matchMedia(x.media).matches !== !1) && !(v.state.loading & 4)) {
      if (v.instance === null) {
        var D = ys(x.href), k = p.querySelector(
          Id(D)
        );
        if (k) {
          p = k._p, p !== null && typeof p == "object" && typeof p.then == "function" && (u.count++, u = by.bind(u), p.then(u, u)), v.state.loading |= 4, v.instance = k, on(k);
          return;
        }
        k = p.ownerDocument || p, x = zp(x), (D = qo.get(D)) && gy(x, D), k = k.createElement("link"), on(k);
        var X = k;
        X._p = new Promise(function(oe, me) {
          X.onload = oe, X.onerror = me;
        }), Da(k, "link", x), v.instance = k;
      }
      u.stylesheets === null && (u.stylesheets = /* @__PURE__ */ new Map()), u.stylesheets.set(v, p), (p = v.state.preload) && !(v.state.loading & 3) && (u.count++, v = by.bind(u), p.addEventListener("load", v), p.addEventListener("error", v));
    }
  }
  var bs = 0;
  function _x(u, p) {
    return u.stylesheets && u.count === 0 && xy(u, u.stylesheets), 0 < u.count || 0 < u.imgCount ? function(v) {
      var x = setTimeout(function() {
        if (u.stylesheets && xy(u, u.stylesheets), u.unsuspend) {
          var k = u.unsuspend;
          u.unsuspend = null, k();
        }
      }, 6e4 + p);
      0 < u.imgBytes && bs === 0 && (bs = 62500 * mx());
      var D = setTimeout(
        function() {
          if (u.waitingForImages = !1, u.count === 0 && (u.stylesheets && xy(u, u.stylesheets), u.unsuspend)) {
            var k = u.unsuspend;
            u.unsuspend = null, k();
          }
        },
        (u.imgBytes > bs ? 50 : 800) + p
      );
      return u.unsuspend = v, function() {
        u.unsuspend = null, clearTimeout(x), clearTimeout(D);
      };
    } : null;
  }
  function by() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets)
        xy(this, this.stylesheets);
      else if (this.unsuspend) {
        var u = this.unsuspend;
        this.unsuspend = null, u();
      }
    }
  }
  var wy = null;
  function xy(u, p) {
    u.stylesheets = null, u.unsuspend !== null && (u.count++, wy = /* @__PURE__ */ new Map(), p.forEach(va, u), wy = null, by.call(u));
  }
  function va(u, p) {
    if (!(p.state.loading & 4)) {
      var v = wy.get(u);
      if (v)
        var x = v.get(null);
      else {
        v = /* @__PURE__ */ new Map(), wy.set(u, v);
        for (var D = u.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), k = 0; k < D.length; k++) {
          var X = D[k];
          (X.nodeName === "LINK" || X.getAttribute("media") !== "not all") && (v.set(X.dataset.precedence, X), x = X);
        }
        x && v.set(null, x);
      }
      D = p.instance, X = D.getAttribute("data-precedence"), k = v.get(X) || x, k === x && v.set(null, D), v.set(X, D), this.count++, x = by.bind(this), D.addEventListener("load", x), D.addEventListener("error", x), k ? k.parentNode.insertBefore(D, k.nextSibling) : (u = u.nodeType === 9 ? u.head : u, u.insertBefore(D, u.firstChild)), p.state.loading |= 4;
    }
  }
  var f1 = {
    $$typeof: N,
    Provider: null,
    Consumer: null,
    _currentValue: W,
    _currentValue2: W,
    _threadCount: 0
  };
  function Ax(u, p, v, x, D, k, X, oe, me) {
    this.tag = 1, this.containerInfo = u, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = sr(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = sr(0), this.hiddenUpdates = sr(null), this.identifierPrefix = x, this.onUncaughtError = D, this.onCaughtError = k, this.onRecoverableError = X, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = me, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function Sy(u, p, v, x, D, k, X, oe, me, ke, qe, et) {
    return u = new Ax(
      u,
      p,
      v,
      X,
      me,
      ke,
      qe,
      et,
      oe
    ), p = 1, k === !0 && (p |= 24), k = Ci(3, null, null, p), u.current = k, k.stateNode = u, p = wm(), p.refCount++, u.pooledCache = p, p.refCount++, k.memoizedState = {
      element: x,
      isDehydrated: v,
      cache: p
    }, Tm(k), u;
  }
  function eh(u) {
    return u ? (u = go, u) : go;
  }
  function fA(u, p, v, x, D, k) {
    D = eh(D), x.context === null ? x.context = D : x.pendingContext = D, x = pu(p), x.payload = { element: v }, k = k === void 0 ? null : k, k !== null && (x.callback = k), v = ds(u, x, p), v !== null && (Co(v, u, p), vd(v, u, p));
  }
  function Ey(u, p) {
    if (u = u.memoizedState, u !== null && u.dehydrated !== null) {
      var v = u.retryLane;
      u.retryLane = v !== 0 && v < p ? v : p;
    }
  }
  function Cx(u, p) {
    Ey(u, p), (u = u.alternate) && Ey(u, p);
  }
  function hA(u) {
    if (u.tag === 13 || u.tag === 31) {
      var p = su(u, 67108864);
      p !== null && Co(p, u, 67108864), Cx(u, 67108864);
    }
  }
  function th(u) {
    if (u.tag === 13 || u.tag === 31) {
      var p = Ho();
      p = $i(p);
      var v = su(u, p);
      v !== null && Co(v, u, p), Cx(u, p);
    }
  }
  var Ki = !0;
  function _c(u, p, v, x) {
    var D = U.T;
    U.T = null;
    var k = q.p;
    try {
      q.p = 2, Na(u, p, v, x);
    } finally {
      q.p = k, U.T = D;
    }
  }
  function Ac(u, p, v, x) {
    var D = U.T;
    U.T = null;
    var k = q.p;
    try {
      q.p = 8, Na(u, p, v, x);
    } finally {
      q.p = k, U.T = D;
    }
  }
  function Na(u, p, v, x) {
    if (Ki) {
      var D = Tx(x);
      if (D === null)
        cx(
          u,
          p,
          x,
          _y,
          v
        ), Au(u, x);
      else if (GO(
        D,
        u,
        p,
        v,
        x
      ))
        x.stopPropagation();
      else if (Au(u, x), p & 4 && -1 < Oo.indexOf(u)) {
        for (; D !== null; ) {
          var k = Kn(D);
          if (k !== null)
            switch (k.tag) {
              case 3:
                if (k = k.stateNode, k.current.memoizedState.isDehydrated) {
                  var X = bt(k.pendingLanes);
                  if (X !== 0) {
                    var oe = k;
                    for (oe.pendingLanes |= 2, oe.entangledLanes |= 2; X; ) {
                      var me = 1 << 31 - or(X);
                      oe.entanglements[1] |= me, X &= ~me;
                    }
                    Sc(k), !(Jn & 6) && (cr = $e() + 500, Eu(0, !1));
                  }
                }
                break;
              case 31:
              case 13:
                oe = su(k, 2), oe !== null && Co(oe, k, 2), Tp(), Cx(k, 2);
            }
          if (k = Tx(x), k === null && cx(
            u,
            p,
            x,
            _y,
            v
          ), k === D)
            break;
          D = k;
        }
        D !== null && x.stopPropagation();
      } else
        cx(
          u,
          p,
          x,
          null,
          v
        );
    }
  }
  function Tx(u) {
    return u = Wg(u), Up(u);
  }
  var _y = null;
  function Up(u) {
    if (_y = null, u = xt(u), u !== null) {
      var p = a(u);
      if (p === null)
        u = null;
      else {
        var v = p.tag;
        if (v === 13) {
          if (u = s(p), u !== null)
            return u;
          u = null;
        } else if (v === 31) {
          if (u = c(p), u !== null)
            return u;
          u = null;
        } else if (v === 3) {
          if (p.stateNode.current.memoizedState.isDehydrated)
            return p.tag === 3 ? p.stateNode.containerInfo : null;
          u = null;
        } else
          p !== u && (u = null);
      }
    }
    return _y = u, null;
  }
  function h1(u) {
    switch (u) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (Ze()) {
          case ct:
            return 2;
          case Mt:
            return 8;
          case Rt:
          case sn:
            return 32;
          case In:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var $p = !1, Ji = null, Ma = null, Ja = null, kd = /* @__PURE__ */ new Map(), Zs = /* @__PURE__ */ new Map(), ni = [], Oo = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Au(u, p) {
    switch (u) {
      case "focusin":
      case "focusout":
        Ji = null;
        break;
      case "dragenter":
      case "dragleave":
        Ma = null;
        break;
      case "mouseover":
      case "mouseout":
        Ja = null;
        break;
      case "pointerover":
      case "pointerout":
        kd.delete(p.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Zs.delete(p.pointerId);
    }
  }
  function nh(u, p, v, x, D, k) {
    return u === null || u.nativeEvent !== k ? (u = {
      blockedOn: p,
      domEventName: v,
      eventSystemFlags: x,
      nativeEvent: k,
      targetContainers: [D]
    }, p !== null && (p = Kn(p), p !== null && hA(p)), u) : (u.eventSystemFlags |= x, p = u.targetContainers, D !== null && p.indexOf(D) === -1 && p.push(D), u);
  }
  function GO(u, p, v, x, D) {
    switch (p) {
      case "focusin":
        return Ji = nh(
          Ji,
          u,
          p,
          v,
          x,
          D
        ), !0;
      case "dragenter":
        return Ma = nh(
          Ma,
          u,
          p,
          v,
          x,
          D
        ), !0;
      case "mouseover":
        return Ja = nh(
          Ja,
          u,
          p,
          v,
          x,
          D
        ), !0;
      case "pointerover":
        var k = D.pointerId;
        return kd.set(
          k,
          nh(
            kd.get(k) || null,
            u,
            p,
            v,
            x,
            D
          )
        ), !0;
      case "gotpointercapture":
        return k = D.pointerId, Zs.set(
          k,
          nh(
            Zs.get(k) || null,
            u,
            p,
            v,
            x,
            D
          )
        ), !0;
    }
    return !1;
  }
  function pA(u) {
    var p = xt(u.target);
    if (p !== null) {
      var v = a(p);
      if (v !== null) {
        if (p = v.tag, p === 13) {
          if (p = s(v), p !== null) {
            u.blockedOn = p, ns(u.priority, function() {
              th(v);
            });
            return;
          }
        } else if (p === 31) {
          if (p = c(v), p !== null) {
            u.blockedOn = p, ns(u.priority, function() {
              th(v);
            });
            return;
          }
        } else if (p === 3 && v.stateNode.current.memoizedState.isDehydrated) {
          u.blockedOn = v.tag === 3 ? v.stateNode.containerInfo : null;
          return;
        }
      }
    }
    u.blockedOn = null;
  }
  function p1(u) {
    if (u.blockedOn !== null)
      return !1;
    for (var p = u.targetContainers; 0 < p.length; ) {
      var v = Tx(u.nativeEvent);
      if (v === null) {
        v = u.nativeEvent;
        var x = new v.constructor(
          v.type,
          v
        );
        Xg = x, v.target.dispatchEvent(x), Xg = null;
      } else
        return p = Kn(v), p !== null && hA(p), u.blockedOn = v, !1;
      p.shift();
    }
    return !0;
  }
  function Hp(u, p, v) {
    p1(u) && v.delete(p);
  }
  function mA() {
    $p = !1, Ji !== null && p1(Ji) && (Ji = null), Ma !== null && p1(Ma) && (Ma = null), Ja !== null && p1(Ja) && (Ja = null), kd.forEach(Hp), Zs.forEach(Hp);
  }
  function Cc(u, p) {
    u.blockedOn === p && (u.blockedOn = null, $p || ($p = !0, t.unstable_scheduleCallback(
      t.unstable_NormalPriority,
      mA
    )));
  }
  var qp = null;
  function gA(u) {
    qp !== u && (qp = u, t.unstable_scheduleCallback(
      t.unstable_NormalPriority,
      function() {
        qp === u && (qp = null);
        for (var p = 0; p < u.length; p += 3) {
          var v = u[p], x = u[p + 1], D = u[p + 2];
          if (typeof x != "function") {
            if (Up(x || v) === null)
              continue;
            break;
          }
          var k = Kn(v);
          k !== null && (u.splice(p, 3), p -= 3, pp(
            k,
            {
              pending: !0,
              data: D,
              method: v.method,
              action: x
            },
            x,
            D
          ));
        }
      }
    ));
  }
  function Gp(u) {
    function p(me) {
      return Cc(me, u);
    }
    Ji !== null && Cc(Ji, u), Ma !== null && Cc(Ma, u), Ja !== null && Cc(Ja, u), kd.forEach(p), Zs.forEach(p);
    for (var v = 0; v < ni.length; v++) {
      var x = ni[v];
      x.blockedOn === u && (x.blockedOn = null);
    }
    for (; 0 < ni.length && (v = ni[0], v.blockedOn === null); )
      pA(v), v.blockedOn === null && ni.shift();
    if (v = (u.ownerDocument || u).$$reactFormReplay, v != null)
      for (x = 0; x < v.length; x += 3) {
        var D = v[x], k = v[x + 1], X = D[ca] || null;
        if (typeof k == "function")
          X || gA(v);
        else if (X) {
          var oe = null;
          if (k && k.hasAttribute("formAction")) {
            if (D = k, X = k[ca] || null)
              oe = X.formAction;
            else if (Up(D) !== null)
              continue;
          } else
            oe = X.action;
          typeof oe == "function" ? v[x + 1] = oe : (v.splice(x, 3), x -= 3), gA(v);
        }
      }
  }
  function Ox() {
    function u(k) {
      k.canIntercept && k.info === "react-transition" && k.intercept({
        handler: function() {
          return new Promise(function(X) {
            return D = X;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function p() {
      D !== null && (D(), D = null), x || setTimeout(v, 20);
    }
    function v() {
      if (!x && !navigation.transition) {
        var k = navigation.currentEntry;
        k && k.url != null && navigation.navigate(k.url, {
          state: k.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var x = !1, D = null;
      return navigation.addEventListener("navigate", u), navigation.addEventListener("navigatesuccess", p), navigation.addEventListener("navigateerror", p), setTimeout(v, 100), function() {
        x = !0, navigation.removeEventListener("navigate", u), navigation.removeEventListener("navigatesuccess", p), navigation.removeEventListener("navigateerror", p), D !== null && (D(), D = null);
      };
    }
  }
  function Ay(u) {
    this._internalRoot = u;
  }
  Cy.prototype.render = Ay.prototype.render = function(u) {
    var p = this._internalRoot;
    if (p === null)
      throw Error(r(409));
    var v = p.current, x = Ho();
    fA(v, x, u, p, null, null);
  }, Cy.prototype.unmount = Ay.prototype.unmount = function() {
    var u = this._internalRoot;
    if (u !== null) {
      this._internalRoot = null;
      var p = u.containerInfo;
      fA(u.current, 2, null, u, null, null), Tp(), p[pl] = null;
    }
  };
  function Cy(u) {
    this._internalRoot = u;
  }
  Cy.prototype.unstable_scheduleHydration = function(u) {
    if (u) {
      var p = Ta();
      u = { blockedOn: null, target: u, priority: p };
      for (var v = 0; v < ni.length && p !== 0 && p < ni[v].priority; v++)
        ;
      ni.splice(v, 0, u), v === 0 && pA(u);
    }
  };
  var Rx = e.version;
  if (Rx !== "19.2.0")
    throw Error(
      r(
        527,
        Rx,
        "19.2.0"
      )
    );
  q.findDOMNode = function(u) {
    var p = u._reactInternals;
    if (p === void 0)
      throw typeof u.render == "function" ? Error(r(188)) : (u = Object.keys(u).join(","), Error(r(268, u)));
    return u = f(p), u = u !== null ? g(u) : null, u = u === null ? null : u.stateNode, u;
  };
  var vA = {
    bundleType: 0,
    version: "19.2.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: U,
    reconcilerVersion: "19.2.0"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var m1 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!m1.isDisabled && m1.supportsFiber)
      try {
        ar = m1.inject(
          vA
        ), kn = m1;
      } catch {
      }
  }
  return TS.createRoot = function(u, p) {
    if (!i(u))
      throw Error(r(299));
    var v = !1, x = "", D = Lv, k = D2, X = Bv;
    return p != null && (p.unstable_strictMode === !0 && (v = !0), p.identifierPrefix !== void 0 && (x = p.identifierPrefix), p.onUncaughtError !== void 0 && (D = p.onUncaughtError), p.onCaughtError !== void 0 && (k = p.onCaughtError), p.onRecoverableError !== void 0 && (X = p.onRecoverableError)), p = Sy(
      u,
      1,
      !1,
      null,
      null,
      v,
      x,
      null,
      D,
      k,
      X,
      Ox
    ), u[pl] = p.current, Ip(u), new Ay(p);
  }, TS.hydrateRoot = function(u, p, v) {
    if (!i(u))
      throw Error(r(299));
    var x = !1, D = "", k = Lv, X = D2, oe = Bv, me = null;
    return v != null && (v.unstable_strictMode === !0 && (x = !0), v.identifierPrefix !== void 0 && (D = v.identifierPrefix), v.onUncaughtError !== void 0 && (k = v.onUncaughtError), v.onCaughtError !== void 0 && (X = v.onCaughtError), v.onRecoverableError !== void 0 && (oe = v.onRecoverableError), v.formState !== void 0 && (me = v.formState)), p = Sy(
      u,
      1,
      !0,
      p,
      v ?? null,
      x,
      D,
      me,
      k,
      X,
      oe,
      Ox
    ), p.context = eh(null), v = p.current, x = Ho(), x = $i(x), D = pu(x), D.callback = null, ds(v, D, x), v = x, p.current.lanes = v, jn(p, v), Sc(p), u[pl] = p.current, Ip(u), new Cy(p);
  }, TS.version = "19.2.0", TS;
}
var OS = {};
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var DL;
function Wde() {
  return DL || (DL = 1, process.env.NODE_ENV !== "production" && function() {
    function t(o, l) {
      for (o = o.memoizedState; o !== null && 0 < l; )
        o = o.next, l--;
      return o;
    }
    function e(o, l, h, y) {
      if (h >= l.length)
        return y;
      var S = l[h], E = Yi(o) ? o.slice() : yn({}, o);
      return E[S] = e(o[S], l, h + 1, y), E;
    }
    function n(o, l, h) {
      if (l.length !== h.length)
        console.warn("copyWithRename() expects paths of the same length");
      else {
        for (var y = 0; y < h.length - 1; y++)
          if (l[y] !== h[y]) {
            console.warn(
              "copyWithRename() expects paths to be the same except for the deepest key"
            );
            return;
          }
        return r(o, l, h, 0);
      }
    }
    function r(o, l, h, y) {
      var S = l[y], E = Yi(o) ? o.slice() : yn({}, o);
      return y + 1 === l.length ? (E[h[y]] = E[S], Yi(E) ? E.splice(S, 1) : delete E[S]) : E[S] = r(
        o[S],
        l,
        h,
        y + 1
      ), E;
    }
    function i(o, l, h) {
      var y = l[h], S = Yi(o) ? o.slice() : yn({}, o);
      return h + 1 === l.length ? (Yi(S) ? S.splice(y, 1) : delete S[y], S) : (S[y] = i(o[y], l, h + 1), S);
    }
    function a() {
      return !1;
    }
    function s() {
      return null;
    }
    function c() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function d() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function f() {
    }
    function g() {
    }
    function m(o) {
      var l = [];
      return o.forEach(function(h) {
        l.push(h);
      }), l.sort().join(", ");
    }
    function b(o, l, h, y) {
      return new BO(o, l, h, y);
    }
    function w(o, l) {
      o.context === Qp && (uy(o.current, 2, l, o, null, null), gs());
    }
    function _(o, l) {
      if (Rc !== null) {
        var h = l.staleFamilies;
        l = l.updatedFamilies, Gm(), l3(
          o.current,
          l,
          h
        ), gs();
      }
    }
    function A(o) {
      Rc = o;
    }
    function T(o) {
      return !(!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11);
    }
    function O(o) {
      var l = o, h = o;
      if (o.alternate)
        for (; l.return; )
          l = l.return;
      else {
        o = l;
        do
          l = o, l.flags & 4098 && (h = l.return), o = l.return;
        while (o);
      }
      return l.tag === 3 ? h : null;
    }
    function R(o) {
      if (o.tag === 13) {
        var l = o.memoizedState;
        if (l === null && (o = o.alternate, o !== null && (l = o.memoizedState)), l !== null)
          return l.dehydrated;
      }
      return null;
    }
    function N(o) {
      if (o.tag === 31) {
        var l = o.memoizedState;
        if (l === null && (o = o.alternate, o !== null && (l = o.memoizedState)), l !== null)
          return l.dehydrated;
      }
      return null;
    }
    function M(o) {
      if (O(o) !== o)
        throw Error("Unable to find node on an unmounted component.");
    }
    function P(o) {
      var l = o.alternate;
      if (!l) {
        if (l = O(o), l === null)
          throw Error("Unable to find node on an unmounted component.");
        return l !== o ? null : o;
      }
      for (var h = o, y = l; ; ) {
        var S = h.return;
        if (S === null)
          break;
        var E = S.alternate;
        if (E === null) {
          if (y = S.return, y !== null) {
            h = y;
            continue;
          }
          break;
        }
        if (S.child === E.child) {
          for (E = S.child; E; ) {
            if (E === h)
              return M(S), o;
            if (E === y)
              return M(S), l;
            E = E.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (h.return !== y.return)
          h = S, y = E;
        else {
          for (var j = !1, L = S.child; L; ) {
            if (L === h) {
              j = !0, h = S, y = E;
              break;
            }
            if (L === y) {
              j = !0, y = S, h = E;
              break;
            }
            L = L.sibling;
          }
          if (!j) {
            for (L = E.child; L; ) {
              if (L === h) {
                j = !0, h = E, y = S;
                break;
              }
              if (L === y) {
                j = !0, y = E, h = S;
                break;
              }
              L = L.sibling;
            }
            if (!j)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (h.alternate !== y)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (h.tag !== 3)
        throw Error("Unable to find node on an unmounted component.");
      return h.stateNode.current === h ? o : l;
    }
    function z(o) {
      var l = o.tag;
      if (l === 5 || l === 26 || l === 27 || l === 6)
        return o;
      for (o = o.child; o !== null; ) {
        if (l = z(o), l !== null)
          return l;
        o = o.sibling;
      }
      return null;
    }
    function F(o) {
      return o === null || typeof o != "object" ? null : (o = uA && o[uA] || o["@@iterator"], typeof o == "function" ? o : null);
    }
    function $(o) {
      if (o == null)
        return null;
      if (typeof o == "function")
        return o.$$typeof === Lp ? null : o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case jp:
          return "Fragment";
        case c1:
          return "Profiler";
        case To:
          return "StrictMode";
        case Kf:
          return "Suspense";
        case qo:
          return "SuspenseList";
        case Pl:
          return "Activity";
      }
      if (typeof o == "object")
        switch (typeof o.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), o.$$typeof) {
          case Nd:
            return "Portal";
          case jl:
            return o.displayName || "Context";
          case my:
            return (o._context.displayName || "Context") + ".Consumer";
          case Pp:
            var l = o.render;
            return o = o.displayName, o || (o = l.displayName || l.name || "", o = o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef"), o;
          case u1:
            return l = o.displayName || null, l !== null ? l : $(o.type) || "Memo";
          case Ka:
            l = o._payload, o = o._init;
            try {
              return $(o(l));
            } catch {
            }
        }
      return null;
    }
    function G(o) {
      return typeof o.tag == "number" ? H(o) : typeof o.name == "string" ? o.name : null;
    }
    function H(o) {
      var l = o.type;
      switch (o.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (l._context.displayName || "Context") + ".Consumer";
        case 10:
          return l.displayName || "Context";
        case 18:
          return "DehydratedFragment";
        case 11:
          return o = l.render, o = o.displayName || o.name || "", l.displayName || (o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return l;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return $(l);
        case 8:
          return l === To ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if (typeof l == "function")
            return l.displayName || l.name || null;
          if (typeof l == "string")
            return l;
          break;
        case 29:
          if (l = o._debugInfo, l != null) {
            for (var h = l.length - 1; 0 <= h; h--)
              if (typeof l[h].name == "string")
                return l[h].name;
          }
          if (o.return !== null)
            return H(o.return);
      }
      return null;
    }
    function Z(o) {
      return { current: o };
    }
    function V(o, l) {
      0 > _u ? console.error("Unexpected pop.") : (l !== wx[_u] && console.error("Unexpected Fiber popped."), o.current = bx[_u], bx[_u] = null, wx[_u] = null, _u--);
    }
    function Y(o, l, h) {
      _u++, bx[_u] = o.current, wx[_u] = h, o.current = l;
    }
    function ee(o) {
      return o === null && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      ), o;
    }
    function K(o, l) {
      Y(ys, l, o), Y(Bp, o, o), Y(Md, null, o);
      var h = l.nodeType;
      switch (h) {
        case 9:
        case 11:
          h = h === 9 ? "#document" : "#fragment", l = (l = l.documentElement) && (l = l.namespaceURI) ? L3(l) : gh;
          break;
        default:
          if (h = l.tagName, l = l.namespaceURI)
            l = L3(l), l = xu(
              l,
              h
            );
          else
            switch (h) {
              case "svg":
                l = nb;
                break;
              case "math":
                l = lC;
                break;
              default:
                l = gh;
            }
      }
      h = h.toLowerCase(), h = Nw(null, h), h = {
        context: l,
        ancestorInfo: h
      }, V(Md, o), Y(Md, h, o);
    }
    function U(o) {
      V(Md, o), V(Bp, o), V(ys, o);
    }
    function q() {
      return ee(Md.current);
    }
    function W(o) {
      o.memoizedState !== null && Y(Id, o, o);
      var l = ee(Md.current), h = o.type, y = xu(l.context, h);
      h = Nw(l.ancestorInfo, h), y = { context: y, ancestorInfo: h }, l !== y && (Y(Bp, o, o), Y(Md, y, o));
    }
    function ie(o) {
      Bp.current === o && (V(Md, o), V(Bp, o)), Id.current === o && (V(Id, o), yS._currentValue = B1);
    }
    function J() {
    }
    function B() {
      if (zp === 0) {
        dA = console.log, Jf = console.info, Fp = console.warn, xx = console.error, d1 = console.group, gy = console.groupCollapsed, vy = console.groupEnd;
        var o = {
          configurable: !0,
          enumerable: !0,
          value: J,
          writable: !0
        };
        Object.defineProperties(console, {
          info: o,
          log: o,
          warn: o,
          error: o,
          group: o,
          groupCollapsed: o,
          groupEnd: o
        });
      }
      zp++;
    }
    function te() {
      if (zp--, zp === 0) {
        var o = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: yn({}, o, { value: dA }),
          info: yn({}, o, { value: Jf }),
          warn: yn({}, o, { value: Fp }),
          error: yn({}, o, { value: xx }),
          group: yn({}, o, { value: d1 }),
          groupCollapsed: yn({}, o, { value: gy }),
          groupEnd: yn({}, o, { value: vy })
        });
      }
      0 > zp && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function ae(o) {
      var l = Error.prepareStackTrace;
      if (Error.prepareStackTrace = void 0, o = o.stack, Error.prepareStackTrace = l, o.startsWith(`Error: react-stack-top-frame
`) && (o = o.slice(29)), l = o.indexOf(`
`), l !== -1 && (o = o.slice(l + 1)), l = o.indexOf("react_stack_bottom_frame"), l !== -1 && (l = o.lastIndexOf(
        `
`,
        l
      )), l !== -1)
        o = o.slice(0, l);
      else
        return "";
      return o;
    }
    function le(o) {
      if (Vp === void 0)
        try {
          throw Error();
        } catch (h) {
          var l = h.stack.trim().match(/\n( *(at )?)/);
          Vp = l && l[1] || "", Sx = -1 < h.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < h.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + Vp + o + Sx;
    }
    function de(o, l) {
      if (!o || yy)
        return "";
      var h = Ex.get(o);
      if (h !== void 0)
        return h;
      yy = !0, h = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var y = null;
      y = ze.H, ze.H = null, B();
      try {
        var S = {
          DetermineComponentFrameRoot: function() {
            try {
              if (l) {
                var he = function() {
                  throw Error();
                };
                if (Object.defineProperty(he.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(he, []);
                  } catch (dt) {
                    var Le = dt;
                  }
                  Reflect.construct(o, [], he);
                } else {
                  try {
                    he.call();
                  } catch (dt) {
                    Le = dt;
                  }
                  o.call(he.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (dt) {
                  Le = dt;
                }
                (he = o()) && typeof he.catch == "function" && he.catch(function() {
                });
              }
            } catch (dt) {
              if (dt && Le && typeof dt.stack == "string")
                return [dt.stack, Le.stack];
            }
            return [null, null];
          }
        };
        S.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var E = Object.getOwnPropertyDescriptor(
          S.DetermineComponentFrameRoot,
          "name"
        );
        E && E.configurable && Object.defineProperty(
          S.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var j = S.DetermineComponentFrameRoot(), L = j[0], Q = j[1];
        if (L && Q) {
          var ne = L.split(`
`), be = Q.split(`
`);
          for (j = E = 0; E < ne.length && !ne[E].includes(
            "DetermineComponentFrameRoot"
          ); )
            E++;
          for (; j < be.length && !be[j].includes(
            "DetermineComponentFrameRoot"
          ); )
            j++;
          if (E === ne.length || j === be.length)
            for (E = ne.length - 1, j = be.length - 1; 1 <= E && 0 <= j && ne[E] !== be[j]; )
              j--;
          for (; 1 <= E && 0 <= j; E--, j--)
            if (ne[E] !== be[j]) {
              if (E !== 1 || j !== 1)
                do
                  if (E--, j--, 0 > j || ne[E] !== be[j]) {
                    var Ee = `
` + ne[E].replace(
                      " at new ",
                      " at "
                    );
                    return o.displayName && Ee.includes("<anonymous>") && (Ee = Ee.replace("<anonymous>", o.displayName)), typeof o == "function" && Ex.set(o, Ee), Ee;
                  }
                while (1 <= E && 0 <= j);
              break;
            }
        }
      } finally {
        yy = !1, ze.H = y, te(), Error.prepareStackTrace = h;
      }
      return ne = (ne = o ? o.displayName || o.name : "") ? le(ne) : "", typeof o == "function" && Ex.set(o, ne), ne;
    }
    function _e(o, l) {
      switch (o.tag) {
        case 26:
        case 27:
        case 5:
          return le(o.type);
        case 16:
          return le("Lazy");
        case 13:
          return o.child !== l && l !== null ? le("Suspense Fallback") : le("Suspense");
        case 19:
          return le("SuspenseList");
        case 0:
        case 15:
          return de(o.type, !1);
        case 11:
          return de(o.type.render, !1);
        case 1:
          return de(o.type, !0);
        case 31:
          return le("Activity");
        default:
          return "";
      }
    }
    function ue(o) {
      try {
        var l = "", h = null;
        do {
          l += _e(o, h);
          var y = o._debugInfo;
          if (y)
            for (var S = y.length - 1; 0 <= S; S--) {
              var E = y[S];
              if (typeof E.name == "string") {
                var j = l;
                e: {
                  var L = E.name, Q = E.env, ne = E.debugLocation;
                  if (ne != null) {
                    var be = ae(ne), Ee = be.lastIndexOf(`
`), he = Ee === -1 ? be : be.slice(Ee + 1);
                    if (he.indexOf(L) !== -1) {
                      var Le = `
` + he;
                      break e;
                    }
                  }
                  Le = le(
                    L + (Q ? " [" + Q + "]" : "")
                  );
                }
                l = j + Le;
              }
            }
          h = o, o = o.return;
        } while (o);
        return l;
      } catch (dt) {
        return `
Error generating stack: ` + dt.message + `
` + dt.stack;
      }
    }
    function Se(o) {
      return (o = o ? o.displayName || o.name : "") ? le(o) : "";
    }
    function Ne() {
      if (Go === null)
        return null;
      var o = Go._debugOwner;
      return o != null ? G(o) : null;
    }
    function Me() {
      if (Go === null)
        return "";
      var o = Go;
      try {
        var l = "";
        switch (o.tag === 6 && (o = o.return), o.tag) {
          case 26:
          case 27:
          case 5:
            l += le(o.type);
            break;
          case 13:
            l += le("Suspense");
            break;
          case 19:
            l += le("SuspenseList");
            break;
          case 31:
            l += le("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            o._debugOwner || l !== "" || (l += Se(
              o.type
            ));
            break;
          case 11:
            o._debugOwner || l !== "" || (l += Se(
              o.type.render
            ));
        }
        for (; o; )
          if (typeof o.tag == "number") {
            var h = o;
            o = h._debugOwner;
            var y = h._debugStack;
            if (o && y) {
              var S = ae(y);
              S !== "" && (l += `
` + S);
            }
          } else if (o.debugStack != null) {
            var E = o.debugStack;
            (o = o.owner) && E && (l += `
` + ae(E));
          } else
            break;
        var j = l;
      } catch (L) {
        j = `
Error generating stack: ` + L.message + `
` + L.stack;
      }
      return j;
    }
    function Ce(o, l, h, y, S, E, j) {
      var L = Go;
      Ue(o);
      try {
        return o !== null && o._debugTask ? o._debugTask.run(
          l.bind(null, h, y, S, E, j)
        ) : l(h, y, S, E, j);
      } finally {
        Ue(L);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function Ue(o) {
      ze.getCurrentStack = o === null ? null : Me, Ec = !1, Go = o;
    }
    function rt(o) {
      return typeof Symbol == "function" && Symbol.toStringTag && o[Symbol.toStringTag] || o.constructor.name || "Object";
    }
    function it(o) {
      try {
        return Ft(o), !1;
      } catch {
        return !0;
      }
    }
    function Ft(o) {
      return "" + o;
    }
    function wt(o, l) {
      if (it(o))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          l,
          rt(o)
        ), Ft(o);
    }
    function Ot(o, l) {
      if (it(o))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          l,
          rt(o)
        ), Ft(o);
    }
    function On(o) {
      if (it(o))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          rt(o)
        ), Ft(o);
    }
    function Ct(o) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var l = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (l.isDisabled)
        return !0;
      if (!l.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), !0;
      try {
        th = l.inject(o), Ki = l;
      } catch (h) {
        console.error("React instrumentation encountered an error: %o.", h);
      }
      return !!l.checkDCE;
    }
    function se(o) {
      if (typeof Cx == "function" && hA(o), Ki && typeof Ki.setStrictMode == "function")
        try {
          Ki.setStrictMode(th, o);
        } catch (l) {
          _c || (_c = !0, console.error(
            "React instrumentation encountered an error: %o",
            l
          ));
        }
    }
    function ge(o) {
      return o >>>= 0, o === 0 ? 32 : 31 - (Tx(o) / _y | 0) | 0;
    }
    function Te(o) {
      var l = o & 42;
      if (l !== 0)
        return l;
      switch (o & -o) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
          return o & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return o & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return o & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), o;
      }
    }
    function He(o, l, h) {
      var y = o.pendingLanes;
      if (y === 0)
        return 0;
      var S = 0, E = o.suspendedLanes, j = o.pingedLanes;
      o = o.warmLanes;
      var L = y & 134217727;
      return L !== 0 ? (y = L & ~E, y !== 0 ? S = Te(y) : (j &= L, j !== 0 ? S = Te(j) : h || (h = L & ~o, h !== 0 && (S = Te(h))))) : (L = y & ~E, L !== 0 ? S = Te(L) : j !== 0 ? S = Te(j) : h || (h = y & ~o, h !== 0 && (S = Te(h)))), S === 0 ? 0 : l !== 0 && l !== S && !(l & E) && (E = S & -S, h = l & -l, E >= h || E === 32 && (h & 4194048) !== 0) ? l : S;
    }
    function $e(o, l) {
      return (o.pendingLanes & ~(o.suspendedLanes & ~o.pingedLanes) & l) === 0;
    }
    function Ze(o, l) {
      switch (o) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return l + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return l + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function ct() {
      var o = $p;
      return $p <<= 1, !($p & 62914560) && ($p = 4194304), o;
    }
    function Mt(o) {
      for (var l = [], h = 0; 31 > h; h++)
        l.push(o);
      return l;
    }
    function Rt(o, l) {
      o.pendingLanes |= l, l !== 268435456 && (o.suspendedLanes = 0, o.pingedLanes = 0, o.warmLanes = 0);
    }
    function sn(o, l, h, y, S, E) {
      var j = o.pendingLanes;
      o.pendingLanes = h, o.suspendedLanes = 0, o.pingedLanes = 0, o.warmLanes = 0, o.expiredLanes &= h, o.entangledLanes &= h, o.errorRecoveryDisabledLanes &= h, o.shellSuspendCounter = 0;
      var L = o.entanglements, Q = o.expirationTimes, ne = o.hiddenUpdates;
      for (h = j & ~h; 0 < h; ) {
        var be = 31 - Na(h), Ee = 1 << be;
        L[be] = 0, Q[be] = -1;
        var he = ne[be];
        if (he !== null)
          for (ne[be] = null, be = 0; be < he.length; be++) {
            var Le = he[be];
            Le !== null && (Le.lane &= -536870913);
          }
        h &= ~Ee;
      }
      y !== 0 && In(o, y, 0), E !== 0 && S === 0 && o.tag !== 0 && (o.suspendedLanes |= E & ~(j & ~l));
    }
    function In(o, l, h) {
      o.pendingLanes |= l, o.suspendedLanes &= ~l;
      var y = 31 - Na(l);
      o.entangledLanes |= l, o.entanglements[y] = o.entanglements[y] | 1073741824 | h & 261930;
    }
    function hn(o, l) {
      var h = o.entangledLanes |= l;
      for (o = o.entanglements; h; ) {
        var y = 31 - Na(h), S = 1 << y;
        S & l | o[y] & l && (o[y] |= l), h &= ~S;
      }
    }
    function Wn(o, l) {
      var h = l & -l;
      return h = h & 42 ? 1 : ar(h), h & (o.suspendedLanes | l) ? 0 : h;
    }
    function ar(o) {
      switch (o) {
        case 2:
          o = 1;
          break;
        case 8:
          o = 4;
          break;
        case 32:
          o = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          o = 128;
          break;
        case 268435456:
          o = 134217728;
          break;
        default:
          o = 0;
      }
      return o;
    }
    function kn(o, l, h) {
      if (Ac)
        for (o = o.pendingUpdatersLaneMap; 0 < h; ) {
          var y = 31 - Na(h), S = 1 << y;
          o[y].add(l), h &= ~S;
        }
    }
    function yr(o, l) {
      if (Ac)
        for (var h = o.pendingUpdatersLaneMap, y = o.memoizedUpdaters; 0 < l; ) {
          var S = 31 - Na(l);
          o = 1 << S, S = h[S], 0 < S.size && (S.forEach(function(E) {
            var j = E.alternate;
            j !== null && y.has(j) || y.add(E);
          }), S.clear()), l &= ~o;
        }
    }
    function or(o) {
      return o &= -o, Ji < o ? Ma < o ? o & 134217727 ? Ja : kd : Ma : Ji;
    }
    function sa() {
      var o = ur.p;
      return o !== 0 ? o : (o = window.event, o === void 0 ? Ja : fy(o.type));
    }
    function re(o, l) {
      var h = ur.p;
      try {
        return ur.p = o, l();
      } finally {
        ur.p = h;
      }
    }
    function Ae(o) {
      delete o[ni], delete o[Oo], delete o[nh], delete o[GO], delete o[pA];
    }
    function nt(o) {
      var l = o[ni];
      if (l)
        return l;
      for (var h = o.parentNode; h; ) {
        if (l = h[Au] || h[ni]) {
          if (h = l.alternate, l.child !== null || h !== null && h.child !== null)
            for (o = Xf(o); o !== null; ) {
              if (h = o[ni])
                return h;
              o = Xf(o);
            }
          return l;
        }
        o = h, h = o.parentNode;
      }
      return null;
    }
    function st(o) {
      if (o = o[ni] || o[Au]) {
        var l = o.tag;
        if (l === 5 || l === 6 || l === 13 || l === 31 || l === 26 || l === 27 || l === 3)
          return o;
      }
      return null;
    }
    function lt(o) {
      var l = o.tag;
      if (l === 5 || l === 26 || l === 27 || l === 6)
        return o.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function bt(o) {
      var l = o[p1];
      return l || (l = o[p1] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), l;
    }
    function Ke(o) {
      o[Hp] = !0;
    }
    function ut(o, l) {
      ft(o, l), ft(o + "Capture", l);
    }
    function ft(o, l) {
      Cc[o] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        o
      ), Cc[o] = l;
      var h = o.toLowerCase();
      for (qp[h] = o, o === "onDoubleClick" && (qp.ondblclick = o), o = 0; o < l.length; o++)
        mA.add(l[o]);
    }
    function en(o, l) {
      gA[l.type] || l.onChange || l.onInput || l.readOnly || l.disabled || l.value == null || console.error(
        o === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ), l.onChange || l.readOnly || l.disabled || l.checked == null || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function sr(o) {
      return bs.call(Ay, o) ? !0 : bs.call(Ox, o) ? !1 : Gp.test(o) ? Ay[o] = !0 : (Ox[o] = !0, console.error("Invalid attribute name: `%s`", o), !1);
    }
    function jn(o, l, h) {
      if (sr(l)) {
        if (!o.hasAttribute(l)) {
          switch (typeof h) {
            case "symbol":
            case "object":
              return h;
            case "function":
              return h;
            case "boolean":
              if (h === !1)
                return h;
          }
          return h === void 0 ? void 0 : null;
        }
        return o = o.getAttribute(l), o === "" && h === !0 ? !0 : (wt(h, l), o === "" + h ? h : o);
      }
    }
    function vn(o, l, h) {
      if (sr(l))
        if (h === null)
          o.removeAttribute(l);
        else {
          switch (typeof h) {
            case "undefined":
            case "function":
            case "symbol":
              o.removeAttribute(l);
              return;
            case "boolean":
              var y = l.toLowerCase().slice(0, 5);
              if (y !== "data-" && y !== "aria-") {
                o.removeAttribute(l);
                return;
              }
          }
          wt(h, l), o.setAttribute(l, "" + h);
        }
    }
    function Ai(o, l, h) {
      if (h === null)
        o.removeAttribute(l);
      else {
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            o.removeAttribute(l);
            return;
        }
        wt(h, l), o.setAttribute(l, "" + h);
      }
    }
    function Un(o, l, h, y) {
      if (y === null)
        o.removeAttribute(h);
      else {
        switch (typeof y) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            o.removeAttribute(h);
            return;
        }
        wt(y, h), o.setAttributeNS(l, h, "" + y);
      }
    }
    function tn(o) {
      switch (typeof o) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return o;
        case "object":
          return On(o), o;
        default:
          return "";
      }
    }
    function $i(o) {
      var l = o.type;
      return (o = o.nodeName) && o.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
    }
    function Hi(o, l, h) {
      var y = Object.getOwnPropertyDescriptor(
        o.constructor.prototype,
        l
      );
      if (!o.hasOwnProperty(l) && typeof y < "u" && typeof y.get == "function" && typeof y.set == "function") {
        var S = y.get, E = y.set;
        return Object.defineProperty(o, l, {
          configurable: !0,
          get: function() {
            return S.call(this);
          },
          set: function(j) {
            On(j), h = "" + j, E.call(this, j);
          }
        }), Object.defineProperty(o, l, {
          enumerable: y.enumerable
        }), {
          getValue: function() {
            return h;
          },
          setValue: function(j) {
            On(j), h = "" + j;
          },
          stopTracking: function() {
            o._valueTracker = null, delete o[l];
          }
        };
      }
    }
    function Ta(o) {
      if (!o._valueTracker) {
        var l = $i(o) ? "checked" : "value";
        o._valueTracker = Hi(
          o,
          l,
          "" + o[l]
        );
      }
    }
    function ns(o) {
      if (!o)
        return !1;
      var l = o._valueTracker;
      if (!l)
        return !0;
      var h = l.getValue(), y = "";
      return o && (y = $i(o) ? o.checked ? "true" : "false" : o.value), o = y, o !== h ? (l.setValue(o), !0) : !1;
    }
    function la(o) {
      if (o = o || (typeof document < "u" ? document : void 0), typeof o > "u")
        return null;
      try {
        return o.activeElement || o.body;
      } catch {
        return o.body;
      }
    }
    function Rn(o) {
      return o.replace(
        Cy,
        function(l) {
          return "\\" + l.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function ca(o, l) {
      l.checked === void 0 || l.defaultChecked === void 0 || vA || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        Ne() || "A component",
        l.type
      ), vA = !0), l.value === void 0 || l.defaultValue === void 0 || Rx || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        Ne() || "A component",
        l.type
      ), Rx = !0);
    }
    function pl(o, l, h, y, S, E, j, L) {
      o.name = "", j != null && typeof j != "function" && typeof j != "symbol" && typeof j != "boolean" ? (wt(j, "type"), o.type = j) : o.removeAttribute("type"), l != null ? j === "number" ? (l === 0 && o.value === "" || o.value != l) && (o.value = "" + tn(l)) : o.value !== "" + tn(l) && (o.value = "" + tn(l)) : j !== "submit" && j !== "reset" || o.removeAttribute("value"), l != null ? Fh(o, j, tn(l)) : h != null ? Fh(o, j, tn(h)) : y != null && o.removeAttribute("value"), S == null && E != null && (o.defaultChecked = !!E), S != null && (o.checked = S && typeof S != "function" && typeof S != "symbol"), L != null && typeof L != "function" && typeof L != "symbol" && typeof L != "boolean" ? (wt(L, "name"), o.name = "" + tn(L)) : o.removeAttribute("name");
    }
    function ff(o, l, h, y, S, E, j, L) {
      if (E != null && typeof E != "function" && typeof E != "symbol" && typeof E != "boolean" && (wt(E, "type"), o.type = E), l != null || h != null) {
        if (!(E !== "submit" && E !== "reset" || l != null)) {
          Ta(o);
          return;
        }
        h = h != null ? "" + tn(h) : "", l = l != null ? "" + tn(l) : h, L || l === o.value || (o.value = l), o.defaultValue = l;
      }
      y = y ?? S, y = typeof y != "function" && typeof y != "symbol" && !!y, o.checked = L ? o.checked : !!y, o.defaultChecked = !!y, j != null && typeof j != "function" && typeof j != "symbol" && typeof j != "boolean" && (wt(j, "name"), o.name = j), Ta(o);
    }
    function Fh(o, l, h) {
      l === "number" && la(o.ownerDocument) === o || o.defaultValue === "" + h || (o.defaultValue = "" + h);
    }
    function Hg(o, l) {
      l.value == null && (typeof l.children == "object" && l.children !== null ? l1.Children.forEach(l.children, function(h) {
        h == null || typeof h == "string" || typeof h == "number" || typeof h == "bigint" || u || (u = !0, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : l.dangerouslySetInnerHTML == null || p || (p = !0, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      ))), l.selected == null || m1 || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), m1 = !0);
    }
    function jt() {
      var o = Ne();
      return o ? `

Check the render method of \`` + o + "`." : "";
    }
    function we(o, l, h, y) {
      if (o = o.options, l) {
        l = {};
        for (var S = 0; S < h.length; S++)
          l["$" + h[S]] = !0;
        for (h = 0; h < o.length; h++)
          S = l.hasOwnProperty("$" + o[h].value), o[h].selected !== S && (o[h].selected = S), S && y && (o[h].defaultSelected = !0);
      } else {
        for (h = "" + tn(h), l = null, S = 0; S < o.length; S++) {
          if (o[S].value === h) {
            o[S].selected = !0, y && (o[S].defaultSelected = !0);
            return;
          }
          l !== null || o[S].disabled || (l = o[S]);
        }
        l !== null && (l.selected = !0);
      }
    }
    function ot(o, l) {
      for (o = 0; o < x.length; o++) {
        var h = x[o];
        if (l[h] != null) {
          var y = Yi(l[h]);
          l.multiple && !y ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            h,
            jt()
          ) : !l.multiple && y && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            h,
            jt()
          );
        }
      }
      l.value === void 0 || l.defaultValue === void 0 || v || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), v = !0);
    }
    function xt(o, l) {
      l.value === void 0 || l.defaultValue === void 0 || D || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        Ne() || "A component"
      ), D = !0), l.children != null && l.value == null && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function Kn(o, l, h) {
      if (l != null && (l = "" + tn(l), l !== o.value && (o.value = l), h == null)) {
        o.defaultValue !== l && (o.defaultValue = l);
        return;
      }
      o.defaultValue = h != null ? "" + tn(h) : "";
    }
    function li(o, l, h, y) {
      if (l == null) {
        if (y != null) {
          if (h != null)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (Yi(y)) {
            if (1 < y.length)
              throw Error("<textarea> can only have at most one child.");
            y = y[0];
          }
          h = y;
        }
        h == null && (h = ""), l = h;
      }
      h = tn(l), o.defaultValue = h, y = o.textContent, y === h && y !== "" && y !== null && (o.value = y), Ta(o);
    }
    function kr(o, l) {
      return o.serverProps === void 0 && o.serverTail.length === 0 && o.children.length === 1 && 3 < o.distanceFromLeaf && o.distanceFromLeaf > 15 - l ? kr(o.children[0], l) : o;
    }
    function on(o) {
      return "  " + "  ".repeat(o);
    }
    function Oa(o) {
      return "+ " + "  ".repeat(o);
    }
    function Bo(o) {
      return "- " + "  ".repeat(o);
    }
    function Bs(o) {
      switch (o.tag) {
        case 26:
        case 27:
        case 5:
          return o.type;
        case 16:
          return "Lazy";
        case 31:
          return "Activity";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return o = o.type, o.displayName || o.name || null;
        case 11:
          return o = o.type.render, o.displayName || o.name || null;
        case 1:
          return o = o.type, o.displayName || o.name || null;
        default:
          return null;
      }
    }
    function jr(o, l) {
      return k.test(o) ? (o = JSON.stringify(o), o.length > l - 2 ? 8 > l ? '{"..."}' : "{" + o.slice(0, l - 7) + '..."}' : "{" + o + "}") : o.length > l ? 5 > l ? '{"..."}' : o.slice(0, l - 3) + "..." : o;
    }
    function hf(o, l, h) {
      var y = 120 - 2 * h;
      if (l === null)
        return Oa(h) + jr(o, y) + `
`;
      if (typeof l == "string") {
        for (var S = 0; S < l.length && S < o.length && l.charCodeAt(S) === o.charCodeAt(S); S++)
          ;
        return S > y - 8 && 10 < S && (o = "..." + o.slice(S - 8), l = "..." + l.slice(S - 8)), Oa(h) + jr(o, y) + `
` + Bo(h) + jr(l, y) + `
`;
      }
      return on(h) + jr(o, y) + `
`;
    }
    function pf(o) {
      return Object.prototype.toString.call(o).replace(/^\[object (.*)\]$/, function(l, h) {
        return h;
      });
    }
    function Vh(o, l) {
      switch (typeof o) {
        case "string":
          return o = JSON.stringify(o), o.length > l ? 5 > l ? '"..."' : o.slice(0, l - 4) + '..."' : o;
        case "object":
          if (o === null)
            return "null";
          if (Yi(o))
            return "[...]";
          if (o.$$typeof === Qs)
            return (l = $(o.type)) ? "<" + l + ">" : "<...>";
          var h = pf(o);
          if (h === "Object") {
            h = "", l -= 2;
            for (var y in o)
              if (o.hasOwnProperty(y)) {
                var S = JSON.stringify(y);
                if (S !== '"' + y + '"' && (y = S), l -= y.length - 2, S = Vh(
                  o[y],
                  15 > l ? l : 15
                ), l -= S.length, 0 > l) {
                  h += h === "" ? "..." : ", ...";
                  break;
                }
                h += (h === "" ? "" : ",") + y + ":" + S;
              }
            return "{" + h + "}";
          }
          return h;
        case "function":
          return (l = o.displayName || o.name) ? "function " + l : "function";
        default:
          return String(o);
      }
    }
    function Uh(o, l) {
      return typeof o != "string" || k.test(o) ? "{" + Vh(o, l - 2) + "}" : o.length > l - 2 ? 5 > l ? '"..."' : '"' + o.slice(0, l - 5) + '..."' : '"' + o + '"';
    }
    function $h(o, l, h) {
      var y = 120 - h.length - o.length, S = [], E;
      for (E in l)
        if (l.hasOwnProperty(E) && E !== "children") {
          var j = Uh(
            l[E],
            120 - h.length - E.length - 1
          );
          y -= E.length + j.length + 2, S.push(E + "=" + j);
        }
      return S.length === 0 ? h + "<" + o + `>
` : 0 < y ? h + "<" + o + " " + S.join(" ") + `>
` : h + "<" + o + `
` + h + "  " + S.join(`
` + h + "  ") + `
` + h + `>
`;
    }
    function qg(o, l, h) {
      var y = "", S = yn({}, l), E;
      for (E in o)
        if (o.hasOwnProperty(E)) {
          delete S[E];
          var j = 120 - 2 * h - E.length - 2, L = Vh(o[E], j);
          l.hasOwnProperty(E) ? (j = Vh(l[E], j), y += Oa(h) + E + ": " + L + `
`, y += Bo(h) + E + ": " + j + `
`) : y += Oa(h) + E + ": " + L + `
`;
        }
      for (var Q in S)
        S.hasOwnProperty(Q) && (o = Vh(
          S[Q],
          120 - 2 * h - Q.length - 2
        ), y += Bo(h) + Q + ": " + o + `
`);
      return y;
    }
    function ru(o, l, h, y) {
      var S = "", E = /* @__PURE__ */ new Map();
      for (ne in h)
        h.hasOwnProperty(ne) && E.set(
          ne.toLowerCase(),
          ne
        );
      if (E.size === 1 && E.has("children"))
        S += $h(
          o,
          l,
          on(y)
        );
      else {
        for (var j in l)
          if (l.hasOwnProperty(j) && j !== "children") {
            var L = 120 - 2 * (y + 1) - j.length - 1, Q = E.get(j.toLowerCase());
            if (Q !== void 0) {
              E.delete(j.toLowerCase());
              var ne = l[j];
              Q = h[Q];
              var be = Uh(
                ne,
                L
              );
              L = Uh(
                Q,
                L
              ), typeof ne == "object" && ne !== null && typeof Q == "object" && Q !== null && pf(ne) === "Object" && pf(Q) === "Object" && (2 < Object.keys(ne).length || 2 < Object.keys(Q).length || -1 < be.indexOf("...") || -1 < L.indexOf("...")) ? S += on(y + 1) + j + `={{
` + qg(
                ne,
                Q,
                y + 2
              ) + on(y + 1) + `}}
` : (S += Oa(y + 1) + j + "=" + be + `
`, S += Bo(y + 1) + j + "=" + L + `
`);
            } else
              S += on(y + 1) + j + "=" + Uh(l[j], L) + `
`;
          }
        E.forEach(function(Ee) {
          if (Ee !== "children") {
            var he = 120 - 2 * (y + 1) - Ee.length - 1;
            S += Bo(y + 1) + Ee + "=" + Uh(h[Ee], he) + `
`;
          }
        }), S = S === "" ? on(y) + "<" + o + `>
` : on(y) + "<" + o + `
` + S + on(y) + `>
`;
      }
      return o = h.children, l = l.children, typeof o == "string" || typeof o == "number" || typeof o == "bigint" ? (E = "", (typeof l == "string" || typeof l == "number" || typeof l == "bigint") && (E = "" + l), S += hf(E, "" + o, y + 1)) : (typeof l == "string" || typeof l == "number" || typeof l == "bigint") && (S = o == null ? S + hf("" + l, null, y + 1) : S + hf("" + l, void 0, y + 1)), S;
    }
    function rs(o, l) {
      var h = Bs(o);
      if (h === null) {
        for (h = "", o = o.child; o; )
          h += rs(o, l), o = o.sibling;
        return h;
      }
      return on(l) + "<" + h + `>
`;
    }
    function Gg(o, l) {
      var h = kr(o, l);
      if (h !== o && (o.children.length !== 1 || o.children[0] !== h))
        return on(l) + `...
` + Gg(h, l + 1);
      h = "";
      var y = o.fiber._debugInfo;
      if (y)
        for (var S = 0; S < y.length; S++) {
          var E = y[S].name;
          typeof E == "string" && (h += on(l) + "<" + E + `>
`, l++);
        }
      if (y = "", S = o.fiber.pendingProps, o.fiber.tag === 6)
        y = hf(S, o.serverProps, l), l++;
      else if (E = Bs(o.fiber), E !== null)
        if (o.serverProps === void 0) {
          y = l;
          var j = 120 - 2 * y - E.length - 2, L = "";
          for (ne in S)
            if (S.hasOwnProperty(ne) && ne !== "children") {
              var Q = Uh(S[ne], 15);
              if (j -= ne.length + Q.length + 2, 0 > j) {
                L += " ...";
                break;
              }
              L += " " + ne + "=" + Q;
            }
          y = on(y) + "<" + E + L + `>
`, l++;
        } else
          o.serverProps === null ? (y = $h(
            E,
            S,
            Oa(l)
          ), l++) : typeof o.serverProps == "string" ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (y = ru(
            E,
            S,
            o.serverProps,
            l
          ), l++);
      var ne = "";
      for (S = o.fiber.child, E = 0; S && E < o.children.length; )
        j = o.children[E], j.fiber === S ? (ne += Gg(j, l), E++) : ne += rs(S, l), S = S.sibling;
      for (S && 0 < o.children.length && (ne += on(l) + `...
`), S = o.serverTail, o.serverProps === null && l--, o = 0; o < S.length; o++)
        E = S[o], ne = typeof E == "string" ? ne + (Bo(l) + jr(E, 120 - 2 * l) + `
`) : ne + $h(
          E.type,
          E.props,
          Bo(l)
        );
      return h + y + ne;
    }
    function Dw(o) {
      try {
        return `

` + Gg(o, 0);
      } catch {
        return "";
      }
    }
    function Yg(o, l, h) {
      for (var y = l, S = null, E = 0; y; )
        y === o && (E = 0), S = {
          fiber: y,
          children: S !== null ? [S] : [],
          serverProps: y === l ? h : y === o ? null : void 0,
          serverTail: [],
          distanceFromLeaf: E
        }, E++, y = y.return;
      return S !== null ? Dw(S).replaceAll(/^[+-]/gm, ">") : "";
    }
    function Nw(o, l) {
      var h = yn({}, o || qe), y = { tag: l };
      return oe.indexOf(l) !== -1 && (h.aTagInScope = null, h.buttonTagInScope = null, h.nobrTagInScope = null), me.indexOf(l) !== -1 && (h.pTagInButtonScope = null), X.indexOf(l) !== -1 && l !== "address" && l !== "div" && l !== "p" && (h.listItemTagAutoclosing = null, h.dlItemTagAutoclosing = null), h.current = y, l === "form" && (h.formTag = y), l === "a" && (h.aTagInScope = y), l === "button" && (h.buttonTagInScope = y), l === "nobr" && (h.nobrTagInScope = y), l === "p" && (h.pTagInButtonScope = y), l === "li" && (h.listItemTagAutoclosing = y), (l === "dd" || l === "dt") && (h.dlItemTagAutoclosing = y), l === "#document" || l === "html" ? h.containerTagInScope = null : h.containerTagInScope || (h.containerTagInScope = y), o !== null || l !== "#document" && l !== "html" && l !== "body" ? h.implicitRootScope === !0 && (h.implicitRootScope = !1) : h.implicitRootScope = !0, h;
    }
    function tm(o, l, h) {
      switch (l) {
        case "select":
          return o === "hr" || o === "option" || o === "optgroup" || o === "script" || o === "template" || o === "#text";
        case "optgroup":
          return o === "option" || o === "#text";
        case "option":
          return o === "#text";
        case "tr":
          return o === "th" || o === "td" || o === "style" || o === "script" || o === "template";
        case "tbody":
        case "thead":
        case "tfoot":
          return o === "tr" || o === "style" || o === "script" || o === "template";
        case "colgroup":
          return o === "col" || o === "template";
        case "table":
          return o === "caption" || o === "colgroup" || o === "tbody" || o === "tfoot" || o === "thead" || o === "style" || o === "script" || o === "template";
        case "head":
          return o === "base" || o === "basefont" || o === "bgsound" || o === "link" || o === "meta" || o === "title" || o === "noscript" || o === "noframes" || o === "style" || o === "script" || o === "template";
        case "html":
          if (h)
            break;
          return o === "head" || o === "body" || o === "frameset";
        case "frameset":
          return o === "frame";
        case "#document":
          if (!h)
            return o === "html";
      }
      switch (o) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return l !== "h1" && l !== "h2" && l !== "h3" && l !== "h4" && l !== "h5" && l !== "h6";
        case "rp":
        case "rt":
          return ke.indexOf(l) === -1;
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return l == null;
        case "head":
          return h || l === null;
        case "html":
          return h && l === "#document" || l === null;
        case "body":
          return h && (l === "#document" || l === "html") || l === null;
      }
      return !0;
    }
    function MO(o, l) {
      switch (o) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return l.pTagInButtonScope;
        case "form":
          return l.formTag || l.pTagInButtonScope;
        case "li":
          return l.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return l.dlItemTagAutoclosing;
        case "button":
          return l.buttonTagInScope;
        case "a":
          return l.aTagInScope;
        case "nobr":
          return l.nobrTagInScope;
      }
      return null;
    }
    function is(o, l) {
      for (; o; ) {
        switch (o.tag) {
          case 5:
          case 26:
          case 27:
            if (o.type === l)
              return o;
        }
        o = o.return;
      }
      return null;
    }
    function nm(o, l) {
      l = l || qe;
      var h = l.current;
      if (l = (h = tm(
        o,
        h && h.tag,
        l.implicitRootScope
      ) ? null : h) ? null : MO(o, l), l = h || l, !l)
        return !0;
      var y = l.tag;
      if (l = String(!!h) + "|" + o + "|" + y, et[l])
        return !1;
      et[l] = !0;
      var S = (l = Go) ? is(l.return, y) : null, E = l !== null && S !== null ? Yg(S, l, null) : "", j = "<" + o + ">";
      return h ? (h = "", y === "table" && o === "tr" && (h += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        `In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`,
        j,
        y,
        h,
        E
      )) : console.error(
        `In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`,
        j,
        y,
        E
      ), l && (o = l.return, S === null || o === null || S === o && o._debugOwner === l._debugOwner || Ce(S, function() {
        console.error(
          `<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`,
          y,
          j
        );
      })), !1;
    }
    function rm(o, l, h) {
      if (h || tm("#text", l, !1))
        return !0;
      if (h = "#text|" + l, et[h])
        return !1;
      et[h] = !0;
      var y = (h = Go) ? is(h, l) : null;
      return h = h !== null && y !== null ? Yg(
        y,
        h,
        h.tag !== 6 ? { children: null } : null
      ) : "", /\S/.test(o) ? console.error(
        `In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`,
        l,
        h
      ) : console.error(
        `In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`,
        l,
        h
      ), !1;
    }
    function mf(o, l) {
      if (l) {
        var h = o.firstChild;
        if (h && h === o.lastChild && h.nodeType === 3) {
          h.nodeValue = l;
          return;
        }
      }
      o.textContent = l;
    }
    function Hh(o) {
      return o.replace(Oe, function(l, h) {
        return h.toUpperCase();
      });
    }
    function Mw(o, l, h) {
      var y = l.indexOf("--") === 0;
      y || (-1 < l.indexOf("-") ? Ie.hasOwnProperty(l) && Ie[l] || (Ie[l] = !0, console.error(
        "Unsupported style property %s. Did you mean %s?",
        l,
        Hh(l.replace(Cr, "ms-"))
      )) : Ut.test(l) ? Ie.hasOwnProperty(l) && Ie[l] || (Ie[l] = !0, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        l,
        l.charAt(0).toUpperCase() + l.slice(1)
      )) : !xe.test(h) || We.hasOwnProperty(h) && We[h] || (We[h] = !0, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        l,
        h.replace(xe, "")
      )), typeof h == "number" && (isNaN(h) ? Lt || (Lt = !0, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        l
      )) : isFinite(h) || Qn || (Qn = !0, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        l
      )))), h == null || typeof h == "boolean" || h === "" ? y ? o.setProperty(l, "") : l === "float" ? o.cssFloat = "" : o[l] = "" : y ? o.setProperty(l, h) : typeof h != "number" || h === 0 || Dt.has(l) ? l === "float" ? o.cssFloat = h : (Ot(h, l), o[l] = ("" + h).trim()) : o[l] = h + "px";
    }
    function Iw(o, l, h) {
      if (l != null && typeof l != "object")
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      if (l && Object.freeze(l), o = o.style, h != null) {
        if (l) {
          var y = {};
          if (h) {
            for (var S in h)
              if (h.hasOwnProperty(S) && !l.hasOwnProperty(S))
                for (var E = Pe[S] || [S], j = 0; j < E.length; j++)
                  y[E[j]] = S;
          }
          for (var L in l)
            if (l.hasOwnProperty(L) && (!h || h[L] !== l[L]))
              for (S = Pe[L] || [L], E = 0; E < S.length; E++)
                y[S[E]] = L;
          L = {};
          for (var Q in l)
            for (S = Pe[Q] || [Q], E = 0; E < S.length; E++)
              L[S[E]] = Q;
          Q = {};
          for (var ne in y)
            if (S = y[ne], (E = L[ne]) && S !== E && (j = S + "," + E, !Q[j])) {
              Q[j] = !0, j = console;
              var be = l[S];
              j.error.call(
                j,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                be == null || typeof be == "boolean" || be === "" ? "Removing" : "Updating",
                S,
                E
              );
            }
        }
        for (var Ee in h)
          !h.hasOwnProperty(Ee) || l != null && l.hasOwnProperty(Ee) || (Ee.indexOf("--") === 0 ? o.setProperty(Ee, "") : Ee === "float" ? o.cssFloat = "" : o[Ee] = "");
        for (var he in l)
          ne = l[he], l.hasOwnProperty(he) && h[he] !== ne && Mw(o, he, ne);
      } else
        for (y in l)
          l.hasOwnProperty(y) && Mw(o, y, l[y]);
    }
    function Kl(o) {
      if (o.indexOf("-") === -1)
        return !1;
      switch (o) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function W_(o) {
      return er.get(o) || o;
    }
    function Q_(o, l) {
      if (bs.call(Ty, l) && Ty[l])
        return !0;
      if (Gee.test(l)) {
        if (o = "aria-" + l.slice(4).toLowerCase(), o = yA.hasOwnProperty(o) ? o : null, o == null)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            l
          ), Ty[l] = !0;
        if (l !== o)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            l,
            o
          ), Ty[l] = !0;
      }
      if (qee.test(l)) {
        if (o = l.toLowerCase(), o = yA.hasOwnProperty(o) ? o : null, o == null)
          return Ty[l] = !0, !1;
        l !== o && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          l,
          o
        ), Ty[l] = !0);
      }
      return !0;
    }
    function Z_(o, l) {
      var h = [], y;
      for (y in l)
        Q_(o, y) || h.push(y);
      l = h.map(function(S) {
        return "`" + S + "`";
      }).join(", "), h.length === 1 ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        l,
        o
      ) : 1 < h.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        l,
        o
      );
    }
    function kw(o, l, h, y) {
      if (bs.call(ws, l) && ws[l])
        return !0;
      var S = l.toLowerCase();
      if (S === "onfocusin" || S === "onfocusout")
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), ws[l] = !0;
      if (typeof h == "function" && (o === "form" && l === "action" || o === "input" && l === "formAction" || o === "button" && l === "formAction"))
        return !0;
      if (y != null) {
        if (o = y.possibleRegistrationNames, y.registrationNameDependencies.hasOwnProperty(l))
          return !0;
        if (y = o.hasOwnProperty(S) ? o[S] : null, y != null)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            l,
            y
          ), ws[l] = !0;
        if (t9.test(l))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            l
          ), ws[l] = !0;
      } else if (t9.test(l))
        return Yee.test(l) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          l
        ), ws[l] = !0;
      if (Xee.test(l) || Wee.test(l))
        return !0;
      if (S === "innerhtml")
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), ws[l] = !0;
      if (S === "aria")
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), ws[l] = !0;
      if (S === "is" && h !== null && h !== void 0 && typeof h != "string")
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof h
        ), ws[l] = !0;
      if (typeof h == "number" && isNaN(h))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          l
        ), ws[l] = !0;
      if (Ll.hasOwnProperty(S)) {
        if (S = Ll[S], S !== l)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            l,
            S
          ), ws[l] = !0;
      } else if (l !== S)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          l,
          S
        ), ws[l] = !0;
      switch (l) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return !0;
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof h) {
        case "boolean":
          switch (l) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return S = l.toLowerCase().slice(0, 5), S === "data-" || S === "aria-" ? !0 : (h ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                h,
                l,
                l,
                h,
                l
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                h,
                l,
                l,
                h,
                l,
                l,
                l
              ), ws[l] = !0);
          }
        case "function":
        case "symbol":
          return ws[l] = !0, !1;
        case "string":
          if (h === "false" || h === "true") {
            switch (l) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              h,
              l,
              h === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              l,
              h
            ), ws[l] = !0;
          }
      }
      return !0;
    }
    function IO(o, l, h) {
      var y = [], S;
      for (S in l)
        kw(o, S, l[S], h) || y.push(S);
      l = y.map(function(E) {
        return "`" + E + "`";
      }).join(", "), y.length === 1 ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        l,
        o
      ) : 1 < y.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        l,
        o
      );
    }
    function im(o) {
      return Qee.test("" + o) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : o;
    }
    function zs() {
    }
    function ml(o) {
      return o = o.target || o.srcElement || window, o.correspondingUseElement && (o = o.correspondingUseElement), o.nodeType === 3 ? o.parentNode : o;
    }
    function Xg(o) {
      var l = st(o);
      if (l && (o = l.stateNode)) {
        var h = o[Oo] || null;
        e:
          switch (o = l.stateNode, l.type) {
            case "input":
              if (pl(
                o,
                h.value,
                h.defaultValue,
                h.defaultValue,
                h.checked,
                h.defaultChecked,
                h.type,
                h.name
              ), l = h.name, h.type === "radio" && l != null) {
                for (h = o; h.parentNode; )
                  h = h.parentNode;
                for (wt(l, "name"), h = h.querySelectorAll(
                  'input[name="' + Rn(
                    "" + l
                  ) + '"][type="radio"]'
                ), l = 0; l < h.length; l++) {
                  var y = h[l];
                  if (y !== o && y.form === o.form) {
                    var S = y[Oo] || null;
                    if (!S)
                      throw Error(
                        "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                      );
                    pl(
                      y,
                      S.value,
                      S.defaultValue,
                      S.defaultValue,
                      S.checked,
                      S.defaultChecked,
                      S.type,
                      S.name
                    );
                  }
                }
                for (l = 0; l < h.length; l++)
                  y = h[l], y.form === o.form && ns(y);
              }
              break e;
            case "textarea":
              Kn(o, h.value, h.defaultValue);
              break e;
            case "select":
              l = h.value, l != null && we(o, !!h.multiple, l, !1);
          }
      }
    }
    function Wg(o, l, h) {
      if (YO)
        return o(l, h);
      YO = !0;
      try {
        var y = o(l);
        return y;
      } finally {
        if (YO = !1, (Oy !== null || Ry !== null) && (gs(), Oy && (l = Oy, o = Ry, Ry = Oy = null, Xg(l), o)))
          for (l = 0; l < o.length; l++)
            Xg(o[l]);
      }
    }
    function Jl(o, l) {
      var h = o.stateNode;
      if (h === null)
        return null;
      var y = h[Oo] || null;
      if (y === null)
        return null;
      h = y[l];
      e:
        switch (l) {
          case "onClick":
          case "onClickCapture":
          case "onDoubleClick":
          case "onDoubleClickCapture":
          case "onMouseDown":
          case "onMouseDownCapture":
          case "onMouseMove":
          case "onMouseMoveCapture":
          case "onMouseUp":
          case "onMouseUpCapture":
          case "onMouseEnter":
            (y = !y.disabled) || (o = o.type, y = !(o === "button" || o === "input" || o === "select" || o === "textarea")), o = !y;
            break e;
          default:
            o = !1;
        }
      if (o)
        return null;
      if (h && typeof h != "function")
        throw Error(
          "Expected `" + l + "` listener to be a function, instead got a value of `" + typeof h + "` type."
        );
      return h;
    }
    function gf() {
      if (bA)
        return bA;
      var o, l = WO, h = l.length, y, S = "value" in Yp ? Yp.value : Yp.textContent, E = S.length;
      for (o = 0; o < h && l[o] === S[o]; o++)
        ;
      var j = h - o;
      for (y = 1; y <= j && l[h - y] === S[E - y]; y++)
        ;
      return bA = S.slice(o, 1 < y ? 1 - y : void 0);
    }
    function am(o) {
      var l = o.keyCode;
      return "charCode" in o ? (o = o.charCode, o === 0 && l === 13 && (o = 13)) : o = l, o === 10 && (o = 13), 32 <= o || o === 13 ? o : 0;
    }
    function qh() {
      return !0;
    }
    function jw() {
      return !1;
    }
    function ua(o) {
      function l(h, y, S, E, j) {
        this._reactName = h, this._targetInst = S, this.type = y, this.nativeEvent = E, this.target = j, this.currentTarget = null;
        for (var L in o)
          o.hasOwnProperty(L) && (h = o[L], this[L] = h ? h(E) : E[L]);
        return this.isDefaultPrevented = (E.defaultPrevented != null ? E.defaultPrevented : E.returnValue === !1) ? qh : jw, this.isPropagationStopped = jw, this;
      }
      return yn(l.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var h = this.nativeEvent;
          h && (h.preventDefault ? h.preventDefault() : typeof h.returnValue != "unknown" && (h.returnValue = !1), this.isDefaultPrevented = qh);
        },
        stopPropagation: function() {
          var h = this.nativeEvent;
          h && (h.stopPropagation ? h.stopPropagation() : typeof h.cancelBubble != "unknown" && (h.cancelBubble = !0), this.isPropagationStopped = qh);
        },
        persist: function() {
        },
        isPersistent: qh
      }), l;
    }
    function iu(o) {
      var l = this.nativeEvent;
      return l.getModifierState ? l.getModifierState(o) : (o = cte[o]) ? !!l[o] : !1;
    }
    function om() {
      return iu;
    }
    function Gh(o, l) {
      switch (o) {
        case "keyup":
          return xte.indexOf(l.keyCode) !== -1;
        case "keydown":
          return l.keyCode !== a9;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function au(o) {
      return o = o.detail, typeof o == "object" && "data" in o ? o.data : null;
    }
    function Pw(o, l) {
      switch (o) {
        case "compositionend":
          return au(l);
        case "keypress":
          return l.which !== s9 ? null : (c9 = !0, l9);
        case "textInput":
          return o = l.data, o === l9 && c9 ? null : o;
        default:
          return null;
      }
    }
    function Qg(o, l) {
      if (Dy)
        return o === "compositionend" || !JO && Gh(o, l) ? (o = gf(), bA = WO = Yp = null, Dy = !1, o) : null;
      switch (o) {
        case "paste":
          return null;
        case "keypress":
          if (!(l.ctrlKey || l.altKey || l.metaKey) || l.ctrlKey && l.altKey) {
            if (l.char && 1 < l.char.length)
              return l.char;
            if (l.which)
              return String.fromCharCode(l.which);
          }
          return null;
        case "compositionend":
          return o9 && l.locale !== "ko" ? null : l.data;
        default:
          return null;
      }
    }
    function Lw(o) {
      var l = o && o.nodeName && o.nodeName.toLowerCase();
      return l === "input" ? !!Ete[o.type] : l === "textarea";
    }
    function Zg(o) {
      if (!jd)
        return !1;
      o = "on" + o;
      var l = o in document;
      return l || (l = document.createElement("div"), l.setAttribute(o, "return;"), l = typeof l[o] == "function"), l;
    }
    function sm(o, l, h, y) {
      Oy ? Ry ? Ry.push(y) : Ry = [y] : Oy = y, l = Ml(l, "onChange"), 0 < l.length && (h = new wA(
        "onChange",
        "change",
        null,
        h,
        y
      ), o.push({ event: h, listeners: l }));
    }
    function K_(o) {
      pr(o, 0);
    }
    function Ra(o) {
      var l = lt(o);
      if (ns(l))
        return o;
    }
    function rd(o, l) {
      if (o === "change")
        return l;
    }
    function lm() {
      jx && (jx.detachEvent("onpropertychange", Yh), Px = jx = null);
    }
    function Yh(o) {
      if (o.propertyName === "value" && Ra(Px)) {
        var l = [];
        sm(
          l,
          Px,
          o,
          ml(o)
        ), Wg(K_, l);
      }
    }
    function kO(o, l, h) {
      o === "focusin" ? (lm(), jx = l, Px = h, jx.attachEvent("onpropertychange", Yh)) : o === "focusout" && lm();
    }
    function Bw(o) {
      if (o === "selectionchange" || o === "keyup" || o === "keydown")
        return Ra(Px);
    }
    function zw(o, l) {
      if (o === "click")
        return Ra(l);
    }
    function cm(o, l) {
      if (o === "input" || o === "change")
        return Ra(l);
    }
    function Kg(o, l) {
      return o === l && (o !== 0 || 1 / o === 1 / l) || o !== o && l !== l;
    }
    function Xh(o, l) {
      if (xs(o, l))
        return !0;
      if (typeof o != "object" || o === null || typeof l != "object" || l === null)
        return !1;
      var h = Object.keys(o), y = Object.keys(l);
      if (h.length !== y.length)
        return !1;
      for (y = 0; y < h.length; y++) {
        var S = h[y];
        if (!bs.call(l, S) || !xs(o[S], l[S]))
          return !1;
      }
      return !0;
    }
    function J_(o) {
      for (; o && o.firstChild; )
        o = o.firstChild;
      return o;
    }
    function e3(o, l) {
      var h = J_(o);
      o = 0;
      for (var y; h; ) {
        if (h.nodeType === 3) {
          if (y = o + h.textContent.length, o <= l && y >= l)
            return { node: h, offset: l - o };
          o = y;
        }
        e: {
          for (; h; ) {
            if (h.nextSibling) {
              h = h.nextSibling;
              break e;
            }
            h = h.parentNode;
          }
          h = void 0;
        }
        h = J_(h);
      }
    }
    function t3(o, l) {
      return o && l ? o === l ? !0 : o && o.nodeType === 3 ? !1 : l && l.nodeType === 3 ? t3(o, l.parentNode) : "contains" in o ? o.contains(l) : o.compareDocumentPosition ? !!(o.compareDocumentPosition(l) & 16) : !1 : !1;
    }
    function Jg(o) {
      o = o != null && o.ownerDocument != null && o.ownerDocument.defaultView != null ? o.ownerDocument.defaultView : window;
      for (var l = la(o.document); l instanceof o.HTMLIFrameElement; ) {
        try {
          var h = typeof l.contentWindow.location.href == "string";
        } catch {
          h = !1;
        }
        if (h)
          o = l.contentWindow;
        else
          break;
        l = la(o.document);
      }
      return l;
    }
    function Fw(o) {
      var l = o && o.nodeName && o.nodeName.toLowerCase();
      return l && (l === "input" && (o.type === "text" || o.type === "search" || o.type === "tel" || o.type === "url" || o.type === "password") || l === "textarea" || o.contentEditable === "true");
    }
    function n3(o, l, h) {
      var y = h.window === h ? h.document : h.nodeType === 9 ? h : h.ownerDocument;
      tR || Ny == null || Ny !== la(y) || (y = Ny, "selectionStart" in y && Fw(y) ? y = { start: y.selectionStart, end: y.selectionEnd } : (y = (y.ownerDocument && y.ownerDocument.defaultView || window).getSelection(), y = {
        anchorNode: y.anchorNode,
        anchorOffset: y.anchorOffset,
        focusNode: y.focusNode,
        focusOffset: y.focusOffset
      }), Lx && Xh(Lx, y) || (Lx = y, y = Ml(eR, "onSelect"), 0 < y.length && (l = new wA(
        "onSelect",
        "select",
        null,
        l,
        h
      ), o.push({ event: l, listeners: y }), l.target = Ny)));
    }
    function vf(o, l) {
      var h = {};
      return h[o.toLowerCase()] = l.toLowerCase(), h["Webkit" + o] = "webkit" + l, h["Moz" + o] = "moz" + l, h;
    }
    function yf(o) {
      if (nR[o])
        return nR[o];
      if (!My[o])
        return o;
      var l = My[o], h;
      for (h in l)
        if (l.hasOwnProperty(h) && h in d9)
          return nR[o] = l[h];
      return o;
    }
    function gl(o, l) {
      g9.set(o, l), ut(l, [o]);
    }
    function r3(o) {
      for (var l = SA, h = 0; h < o.length; h++) {
        var y = o[h];
        if (typeof y == "object" && y !== null)
          if (Yi(y) && y.length === 2 && typeof y[0] == "string") {
            if (l !== SA && l !== sR)
              return aR;
            l = sR;
          } else
            return aR;
        else {
          if (typeof y == "function" || typeof y == "string" && 50 < y.length || l !== SA && l !== oR)
            return aR;
          l = oR;
        }
      }
      return l;
    }
    function Vw(o, l, h, y) {
      for (var S in o)
        bs.call(o, S) && S[0] !== "_" && ec(S, o[S], l, h, y);
    }
    function ec(o, l, h, y, S) {
      switch (typeof l) {
        case "object":
          if (l === null) {
            l = "null";
            break;
          } else {
            if (l.$$typeof === Qs) {
              var E = $(l.type) || "…", j = l.key;
              l = l.props;
              var L = Object.keys(l), Q = L.length;
              if (j == null && Q === 0) {
                l = "<" + E + " />";
                break;
              }
              if (3 > y || Q === 1 && L[0] === "children" && j == null) {
                l = "<" + E + " … />";
                break;
              }
              h.push([
                S + "  ".repeat(y) + o,
                "<" + E
              ]), j !== null && ec(
                "key",
                j,
                h,
                y + 1,
                S
              ), o = !1;
              for (var ne in l)
                ne === "children" ? l.children != null && (!Yi(l.children) || 0 < l.children.length) && (o = !0) : bs.call(l, ne) && ne[0] !== "_" && ec(
                  ne,
                  l[ne],
                  h,
                  y + 1,
                  S
                );
              h.push([
                "",
                o ? ">…</" + E + ">" : "/>"
              ]);
              return;
            }
            if (E = Object.prototype.toString.call(l), E = E.slice(8, E.length - 1), E === "Array") {
              if (ne = r3(l), ne === oR || ne === SA) {
                l = JSON.stringify(l);
                break;
              } else if (ne === sR) {
                for (h.push([
                  S + "  ".repeat(y) + o,
                  ""
                ]), o = 0; o < l.length; o++)
                  E = l[o], ec(
                    E[0],
                    E[1],
                    h,
                    y + 1,
                    S
                  );
                return;
              }
            }
            if (E === "Promise") {
              if (l.status === "fulfilled") {
                if (E = h.length, ec(
                  o,
                  l.value,
                  h,
                  y,
                  S
                ), h.length > E) {
                  h = h[E], h[1] = "Promise<" + (h[1] || "Object") + ">";
                  return;
                }
              } else if (l.status === "rejected" && (E = h.length, ec(
                o,
                l.reason,
                h,
                y,
                S
              ), h.length > E)) {
                h = h[E], h[1] = "Rejected Promise<" + h[1] + ">";
                return;
              }
              h.push([
                "  ".repeat(y) + o,
                "Promise"
              ]);
              return;
            }
            E === "Object" && (ne = Object.getPrototypeOf(l)) && typeof ne.constructor == "function" && (E = ne.constructor.name), h.push([
              S + "  ".repeat(y) + o,
              E === "Object" ? 3 > y ? "" : "…" : E
            ]), 3 > y && Vw(l, h, y + 1, S);
            return;
          }
        case "function":
          l = l.name === "" ? "() => {}" : l.name + "() {}";
          break;
        case "string":
          l = l === Dte ? "…" : JSON.stringify(l);
          break;
        case "undefined":
          l = "undefined";
          break;
        case "boolean":
          l = l ? "true" : "false";
          break;
        default:
          l = String(l);
      }
      h.push([
        S + "  ".repeat(y) + o,
        l
      ]);
    }
    function i3(o, l, h, y) {
      var S = !0;
      for (j in o)
        j in l || (h.push([
          EA + "  ".repeat(y) + j,
          "…"
        ]), S = !1);
      for (var E in l)
        if (E in o) {
          var j = o[E], L = l[E];
          if (j !== L) {
            if (y === 0 && E === "children")
              S = "  ".repeat(y) + E, h.push(
                [EA + S, "…"],
                [_A + S, "…"]
              );
            else {
              if (!(3 <= y)) {
                if (typeof j == "object" && typeof L == "object" && j !== null && L !== null && j.$$typeof === L.$$typeof)
                  if (L.$$typeof === Qs) {
                    if (j.type === L.type && j.key === L.key) {
                      j = $(L.type) || "…", S = "  ".repeat(y) + E, j = "<" + j + " … />", h.push(
                        [EA + S, j],
                        [_A + S, j]
                      ), S = !1;
                      continue;
                    }
                  } else {
                    var Q = Object.prototype.toString.call(j), ne = Object.prototype.toString.call(L);
                    if (Q === ne && (ne === "[object Object]" || ne === "[object Array]")) {
                      Q = [
                        b9 + "  ".repeat(y) + E,
                        ne === "[object Array]" ? "Array" : ""
                      ], h.push(Q), ne = h.length, i3(
                        j,
                        L,
                        h,
                        y + 1
                      ) ? ne === h.length && (Q[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : S = !1;
                      continue;
                    }
                  }
                else if (typeof j == "function" && typeof L == "function" && j.name === L.name && j.length === L.length && (Q = Function.prototype.toString.call(j), ne = Function.prototype.toString.call(L), Q === ne)) {
                  j = L.name === "" ? "() => {}" : L.name + "() {}", h.push([
                    b9 + "  ".repeat(y) + E,
                    j + " Referentially unequal function closure. Consider memoization."
                  ]);
                  continue;
                }
              }
              ec(E, j, h, y, EA), ec(E, L, h, y, _A);
            }
            S = !1;
          }
        } else
          h.push([
            _A + "  ".repeat(y) + E,
            "…"
          ]), S = !1;
      return S;
    }
    function vl(o) {
      $n = o & 63 ? "Blocking" : o & 64 ? "Gesture" : o & 4194176 ? "Transition" : o & 62914560 ? "Suspense" : o & 2080374784 ? "Idle" : "Other";
    }
    function Fs(o, l, h, y) {
      ri && (Wp.start = l, Wp.end = h, rh.color = "warning", rh.tooltipText = y, rh.properties = null, (o = o._debugTask) ? o.run(
        performance.measure.bind(
          performance,
          y,
          Wp
        )
      ) : performance.measure(y, Wp));
    }
    function ev(o, l, h) {
      Fs(o, l, h, "Reconnect");
    }
    function tv(o, l, h, y, S) {
      var E = H(o);
      if (E !== null && ri) {
        var j = o.alternate, L = o.actualDuration;
        if (j === null || j.child !== o.child)
          for (var Q = o.child; Q !== null; Q = Q.sibling)
            L -= Q.actualDuration;
        y = 0.5 > L ? y ? "tertiary-light" : "primary-light" : 10 > L ? y ? "tertiary" : "primary" : 100 > L ? y ? "tertiary-dark" : "primary-dark" : "error";
        var ne = o.memoizedProps;
        L = o._debugTask, ne !== null && j !== null && j.memoizedProps !== ne ? (Q = [Nte], ne = i3(
          j.memoizedProps,
          ne,
          Q,
          0
        ), 1 < Q.length && (ne && !Xp && !(j.lanes & S) && 100 < o.actualDuration ? (Xp = !0, Q[0] = Mte, rh.color = "warning", rh.tooltipText = w9) : (rh.color = y, rh.tooltipText = E), rh.properties = Q, Wp.start = l, Wp.end = h, L != null ? L.run(
          performance.measure.bind(
            performance,
            "​" + E,
            Wp
          )
        ) : performance.measure(
          "​" + E,
          Wp
        ))) : L != null ? L.run(
          console.timeStamp.bind(
            console,
            E,
            l,
            h,
            Tc,
            void 0,
            y
          )
        ) : console.timeStamp(
          E,
          l,
          h,
          Tc,
          void 0,
          y
        );
      }
    }
    function Uw(o, l, h, y) {
      if (ri) {
        var S = H(o);
        if (S !== null) {
          for (var E = null, j = [], L = 0; L < y.length; L++) {
            var Q = y[L];
            E == null && Q.source !== null && (E = Q.source._debugTask), Q = Q.value, j.push([
              "Error",
              typeof Q == "object" && Q !== null && typeof Q.message == "string" ? String(Q.message) : String(Q)
            ]);
          }
          o.key !== null && ec("key", o.key, j, 0, ""), o.memoizedProps !== null && Vw(o.memoizedProps, j, 0, ""), E == null && (E = o._debugTask), o = {
            start: l,
            end: h,
            detail: {
              devtools: {
                color: "error",
                track: Tc,
                tooltipText: o.tag === 13 ? "Hydration failed" : "Error boundary caught an error",
                properties: j
              }
            }
          }, E ? E.run(
            performance.measure.bind(performance, "​" + S, o)
          ) : performance.measure("​" + S, o);
        }
      }
    }
    function yl(o, l, h, y, S) {
      if (S !== null) {
        if (ri) {
          var E = H(o);
          if (E !== null) {
            y = [];
            for (var j = 0; j < S.length; j++) {
              var L = S[j].value;
              y.push([
                "Error",
                typeof L == "object" && L !== null && typeof L.message == "string" ? String(L.message) : String(L)
              ]);
            }
            o.key !== null && ec("key", o.key, y, 0, ""), o.memoizedProps !== null && Vw(o.memoizedProps, y, 0, ""), l = {
              start: l,
              end: h,
              detail: {
                devtools: {
                  color: "error",
                  track: Tc,
                  tooltipText: "A lifecycle or effect errored",
                  properties: y
                }
              }
            }, (o = o._debugTask) ? o.run(
              performance.measure.bind(
                performance,
                "​" + E,
                l
              )
            ) : performance.measure("​" + E, l);
          }
        }
      } else
        E = H(o), E !== null && ri && (S = 1 > y ? "secondary-light" : 100 > y ? "secondary" : 500 > y ? "secondary-dark" : "error", (o = o._debugTask) ? o.run(
          console.timeStamp.bind(
            console,
            E,
            l,
            h,
            Tc,
            void 0,
            S
          )
        ) : console.timeStamp(
          E,
          l,
          h,
          Tc,
          void 0,
          S
        ));
    }
    function jO(o, l, h, y) {
      if (ri && !(l <= o)) {
        var S = (h & 738197653) === h ? "tertiary-dark" : "primary-dark";
        h = (h & 536870912) === h ? "Prepared" : (h & 201326741) === h ? "Hydrated" : "Render", y ? y.run(
          console.timeStamp.bind(
            console,
            h,
            o,
            l,
            $n,
            zn,
            S
          )
        ) : console.timeStamp(
          h,
          o,
          l,
          $n,
          zn,
          S
        );
      }
    }
    function a3(o, l, h, y) {
      !ri || l <= o || (h = (h & 738197653) === h ? "tertiary-dark" : "primary-dark", y ? y.run(
        console.timeStamp.bind(
          console,
          "Prewarm",
          o,
          l,
          $n,
          zn,
          h
        )
      ) : console.timeStamp(
        "Prewarm",
        o,
        l,
        $n,
        zn,
        h
      ));
    }
    function o3(o, l, h, y) {
      !ri || l <= o || (h = (h & 738197653) === h ? "tertiary-dark" : "primary-dark", y ? y.run(
        console.timeStamp.bind(
          console,
          "Suspended",
          o,
          l,
          $n,
          zn,
          h
        )
      ) : console.timeStamp(
        "Suspended",
        o,
        l,
        $n,
        zn,
        h
      ));
    }
    function PO(o, l, h, y, S, E) {
      if (ri && !(l <= o)) {
        h = [];
        for (var j = 0; j < y.length; j++) {
          var L = y[j].value;
          h.push([
            "Recoverable Error",
            typeof L == "object" && L !== null && typeof L.message == "string" ? String(L.message) : String(L)
          ]);
        }
        o = {
          start: o,
          end: l,
          detail: {
            devtools: {
              color: "primary-dark",
              track: $n,
              trackGroup: zn,
              tooltipText: S ? "Hydration Failed" : "Recovered after Error",
              properties: h
            }
          }
        }, E ? E.run(
          performance.measure.bind(performance, "Recovered", o)
        ) : performance.measure("Recovered", o);
      }
    }
    function $w(o, l, h, y) {
      !ri || l <= o || (y ? y.run(
        console.timeStamp.bind(
          console,
          "Errored",
          o,
          l,
          $n,
          zn,
          "error"
        )
      ) : console.timeStamp(
        "Errored",
        o,
        l,
        $n,
        zn,
        "error"
      ));
    }
    function LO(o, l, h, y) {
      !ri || l <= o || (y ? y.run(
        console.timeStamp.bind(
          console,
          h,
          o,
          l,
          $n,
          zn,
          "secondary-light"
        )
      ) : console.timeStamp(
        h,
        o,
        l,
        $n,
        zn,
        "secondary-light"
      ));
    }
    function s3(o, l, h, y, S) {
      if (ri && !(l <= o)) {
        for (var E = [], j = 0; j < h.length; j++) {
          var L = h[j].value;
          E.push([
            "Error",
            typeof L == "object" && L !== null && typeof L.message == "string" ? String(L.message) : String(L)
          ]);
        }
        o = {
          start: o,
          end: l,
          detail: {
            devtools: {
              color: "error",
              track: $n,
              trackGroup: zn,
              tooltipText: y ? "Remaining Effects Errored" : "Commit Errored",
              properties: E
            }
          }
        }, S ? S.run(
          performance.measure.bind(performance, "Errored", o)
        ) : performance.measure("Errored", o);
      }
    }
    function Hw(o, l, h) {
      !ri || l <= o || (h ? h.run(
        console.timeStamp.bind(
          console,
          "Animating",
          o,
          l,
          $n,
          zn,
          "secondary-dark"
        )
      ) : console.timeStamp(
        "Animating",
        o,
        l,
        $n,
        zn,
        "secondary-dark"
      ));
    }
    function nv() {
      for (var o = Iy, l = lR = Iy = 0; l < o; ) {
        var h = Oc[l];
        Oc[l++] = null;
        var y = Oc[l];
        Oc[l++] = null;
        var S = Oc[l];
        Oc[l++] = null;
        var E = Oc[l];
        if (Oc[l++] = null, y !== null && S !== null) {
          var j = y.pending;
          j === null ? S.next = S : (S.next = j.next, j.next = S), y.pending = S;
        }
        E !== 0 && qw(h, S, E);
      }
    }
    function Wh(o, l, h, y) {
      Oc[Iy++] = o, Oc[Iy++] = l, Oc[Iy++] = h, Oc[Iy++] = y, lR |= y, o.lanes |= y, o = o.alternate, o !== null && (o.lanes |= y);
    }
    function bf(o, l, h, y) {
      return Wh(o, l, h, y), um(o);
    }
    function Wa(o, l) {
      return Wh(o, null, null, l), um(o);
    }
    function qw(o, l, h) {
      o.lanes |= h;
      var y = o.alternate;
      y !== null && (y.lanes |= h);
      for (var S = !1, E = o.return; E !== null; )
        E.childLanes |= h, y = E.alternate, y !== null && (y.childLanes |= h), E.tag === 22 && (o = E.stateNode, o === null || o._visibility & Bx || (S = !0)), o = E, E = E.return;
      return o.tag === 3 ? (E = o.stateNode, S && l !== null && (S = 31 - Na(h), o = E.hiddenUpdates, y = o[S], y === null ? o[S] = [l] : y.push(l), l.lane = h | 536870912), E) : null;
    }
    function um(o) {
      if (dS > Yte)
        throw M1 = dS = 0, fS = UR = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      M1 > Xte && (M1 = 0, fS = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      )), o.alternate === null && o.flags & 4098 && Ws(o);
      for (var l = o, h = l.return; h !== null; )
        l.alternate === null && l.flags & 4098 && Ws(o), l = h, h = l.return;
      return l.tag === 3 ? l.stateNode : null;
    }
    function id(o) {
      if (Rc === null)
        return o;
      var l = Rc(o);
      return l === void 0 ? o : l.current;
    }
    function rv(o) {
      if (Rc === null)
        return o;
      var l = Rc(o);
      return l === void 0 ? o != null && typeof o.render == "function" && (l = id(o.render), o.render !== l) ? (l = { $$typeof: Pp, render: l }, o.displayName !== void 0 && (l.displayName = o.displayName), l) : o : l.current;
    }
    function Gw(o, l) {
      if (Rc === null)
        return !1;
      var h = o.elementType;
      l = l.type;
      var y = !1, S = typeof l == "object" && l !== null ? l.$$typeof : null;
      switch (o.tag) {
        case 1:
          typeof l == "function" && (y = !0);
          break;
        case 0:
          (typeof l == "function" || S === Ka) && (y = !0);
          break;
        case 11:
          (S === Pp || S === Ka) && (y = !0);
          break;
        case 14:
        case 15:
          (S === u1 || S === Ka) && (y = !0);
          break;
        default:
          return !1;
      }
      return !!(y && (o = Rc(h), o !== void 0 && o === Rc(l)));
    }
    function wf(o) {
      Rc !== null && typeof WeakSet == "function" && (ky === null && (ky = /* @__PURE__ */ new WeakSet()), ky.add(o));
    }
    function l3(o, l, h) {
      do {
        var y = o, S = y.alternate, E = y.child, j = y.sibling, L = y.tag;
        y = y.type;
        var Q = null;
        switch (L) {
          case 0:
          case 15:
          case 1:
            Q = y;
            break;
          case 11:
            Q = y.render;
        }
        if (Rc === null)
          throw Error("Expected resolveFamily to be set during hot reload.");
        var ne = !1;
        if (y = !1, Q !== null && (Q = Rc(Q), Q !== void 0 && (h.has(Q) ? y = !0 : l.has(Q) && (L === 1 ? y = !0 : ne = !0))), ky !== null && (ky.has(o) || S !== null && ky.has(S)) && (y = !0), y && (o._debugNeedsRemount = !0), (y || ne) && (S = Wa(o, 2), S !== null && Kt(S, o, 2)), E === null || y || l3(
          E,
          l,
          h
        ), j === null)
          break;
        o = j;
      } while (1);
    }
    function BO(o, l, h, y) {
      this.tag = o, this.key = h, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = l, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = y, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null, this.actualDuration = -0, this.actualStartTime = -1.1, this.treeBaseDuration = this.selfBaseDuration = -0, this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, x9 || typeof Object.preventExtensions != "function" || Object.preventExtensions(this);
    }
    function Yw(o) {
      return o = o.prototype, !(!o || !o.isReactComponent);
    }
    function tc(o, l) {
      var h = o.alternate;
      switch (h === null ? (h = b(
        o.tag,
        l,
        o.key,
        o.mode
      ), h.elementType = o.elementType, h.type = o.type, h.stateNode = o.stateNode, h._debugOwner = o._debugOwner, h._debugStack = o._debugStack, h._debugTask = o._debugTask, h._debugHookTypes = o._debugHookTypes, h.alternate = o, o.alternate = h) : (h.pendingProps = l, h.type = o.type, h.flags = 0, h.subtreeFlags = 0, h.deletions = null, h.actualDuration = -0, h.actualStartTime = -1.1), h.flags = o.flags & 65011712, h.childLanes = o.childLanes, h.lanes = o.lanes, h.child = o.child, h.memoizedProps = o.memoizedProps, h.memoizedState = o.memoizedState, h.updateQueue = o.updateQueue, l = o.dependencies, h.dependencies = l === null ? null : {
        lanes: l.lanes,
        firstContext: l.firstContext,
        _debugThenableState: l._debugThenableState
      }, h.sibling = o.sibling, h.index = o.index, h.ref = o.ref, h.refCleanup = o.refCleanup, h.selfBaseDuration = o.selfBaseDuration, h.treeBaseDuration = o.treeBaseDuration, h._debugInfo = o._debugInfo, h._debugNeedsRemount = o._debugNeedsRemount, h.tag) {
        case 0:
        case 15:
          h.type = id(o.type);
          break;
        case 1:
          h.type = id(o.type);
          break;
        case 11:
          h.type = rv(o.type);
      }
      return h;
    }
    function Xw(o, l) {
      o.flags &= 65011714;
      var h = o.alternate;
      return h === null ? (o.childLanes = 0, o.lanes = l, o.child = null, o.subtreeFlags = 0, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null, o.selfBaseDuration = 0, o.treeBaseDuration = 0) : (o.childLanes = h.childLanes, o.lanes = h.lanes, o.child = h.child, o.subtreeFlags = 0, o.deletions = null, o.memoizedProps = h.memoizedProps, o.memoizedState = h.memoizedState, o.updateQueue = h.updateQueue, o.type = h.type, l = h.dependencies, o.dependencies = l === null ? null : {
        lanes: l.lanes,
        firstContext: l.firstContext,
        _debugThenableState: l._debugThenableState
      }, o.selfBaseDuration = h.selfBaseDuration, o.treeBaseDuration = h.treeBaseDuration), o;
    }
    function xf(o, l, h, y, S, E) {
      var j = 0, L = o;
      if (typeof o == "function")
        Yw(o) && (j = 1), L = id(L);
      else if (typeof o == "string")
        j = q(), j = rA(o, h, j) ? 26 : o === "html" || o === "head" || o === "body" ? 27 : 5;
      else
        e:
          switch (o) {
            case Pl:
              return l = b(31, h, l, S), l.elementType = Pl, l.lanes = E, l;
            case jp:
              return Sf(
                h.children,
                S,
                E,
                l
              );
            case To:
              j = 8, S |= Yo, S |= Cu;
              break;
            case c1:
              return o = h, y = S, typeof o.id != "string" && console.error(
                'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
                typeof o.id
              ), l = b(12, o, l, y | bn), l.elementType = c1, l.lanes = E, l.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, l;
            case Kf:
              return l = b(13, h, l, S), l.elementType = Kf, l.lanes = E, l;
            case qo:
              return l = b(19, h, l, S), l.elementType = qo, l.lanes = E, l;
            default:
              if (typeof o == "object" && o !== null)
                switch (o.$$typeof) {
                  case jl:
                    j = 10;
                    break e;
                  case my:
                    j = 9;
                    break e;
                  case Pp:
                    j = 11, L = rv(L);
                    break e;
                  case u1:
                    j = 14;
                    break e;
                  case Ka:
                    j = 16, L = null;
                    break e;
                }
              L = "", (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (L += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), o === null ? h = "null" : Yi(o) ? h = "array" : o !== void 0 && o.$$typeof === Qs ? (h = "<" + ($(o.type) || "Unknown") + " />", L = " Did you accidentally export a JSX literal instead of a component?") : h = typeof o, (j = y ? G(y) : null) && (L += `

Check the render method of \`` + j + "`."), j = 29, h = Error(
                "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (h + "." + L)
              ), L = null;
          }
      return l = b(j, h, l, S), l.elementType = o, l.type = L, l.lanes = E, l._debugOwner = y, l;
    }
    function ad(o, l, h) {
      return l = xf(
        o.type,
        o.key,
        o.props,
        o._owner,
        l,
        h
      ), l._debugOwner = o._owner, l._debugStack = o._debugStack, l._debugTask = o._debugTask, l;
    }
    function Sf(o, l, h, y) {
      return o = b(7, o, y, l), o.lanes = h, o;
    }
    function Qh(o, l, h) {
      return o = b(6, o, null, l), o.lanes = h, o;
    }
    function Ww(o) {
      var l = b(18, null, null, Wt);
      return l.stateNode = o, l;
    }
    function iv(o, l, h) {
      return l = b(
        4,
        o.children !== null ? o.children : [],
        o.key,
        l
      ), l.lanes = h, l.stateNode = {
        containerInfo: o.containerInfo,
        pendingChildren: null,
        implementation: o.implementation
      }, l;
    }
    function po(o, l) {
      if (typeof o == "object" && o !== null) {
        var h = cR.get(o);
        return h !== void 0 ? h : (l = {
          value: o,
          source: l,
          stack: ue(l)
        }, cR.set(o, l), l);
      }
      return {
        value: o,
        source: l,
        stack: ue(l)
      };
    }
    function bl(o, l) {
      od(), jy[Py++] = zx, jy[Py++] = AA, AA = o, zx = l;
    }
    function Qw(o, l, h) {
      od(), Dc[Nc++] = ah, Dc[Nc++] = oh, Dc[Nc++] = v1, v1 = o;
      var y = ah;
      o = oh;
      var S = 32 - Na(y) - 1;
      y &= ~(1 << S), h += 1;
      var E = 32 - Na(l) + S;
      if (30 < E) {
        var j = S - S % 5;
        E = (y & (1 << j) - 1).toString(32), y >>= j, S -= j, ah = 1 << 32 - Na(l) + S | h << S | y, oh = E + o;
      } else
        ah = 1 << E | h << S | y, oh = o;
    }
    function av(o) {
      od(), o.return !== null && (bl(o, 1), Qw(o, 1, 0));
    }
    function ov(o) {
      for (; o === AA; )
        AA = jy[--Py], jy[Py] = null, zx = jy[--Py], jy[Py] = null;
      for (; o === v1; )
        v1 = Dc[--Nc], Dc[Nc] = null, oh = Dc[--Nc], Dc[Nc] = null, ah = Dc[--Nc], Dc[Nc] = null;
    }
    function c3() {
      return od(), v1 !== null ? { id: ah, overflow: oh } : null;
    }
    function u3(o, l) {
      od(), Dc[Nc++] = ah, Dc[Nc++] = oh, Dc[Nc++] = v1, ah = l.id, oh = l.overflow, v1 = o;
    }
    function od() {
      Fn || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function Ef(o, l) {
      if (o.return === null) {
        if (Bl === null)
          Bl = {
            fiber: o,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: l
          };
        else {
          if (Bl.fiber !== o)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          Bl.distanceFromLeaf > l && (Bl.distanceFromLeaf = l);
        }
        return Bl;
      }
      var h = Ef(
        o.return,
        l + 1
      ).children;
      return 0 < h.length && h[h.length - 1].fiber === o ? (h = h[h.length - 1], h.distanceFromLeaf > l && (h.distanceFromLeaf = l), h) : (l = {
        fiber: o,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf: l
      }, h.push(l), l);
    }
    function d3() {
      Fn && console.error(
        "We should not be hydrating here. This is a bug in React. Please file a bug."
      );
    }
    function Qa(o, l) {
      Pd || (o = Ef(o, 0), o.serverProps = null, l !== null && (l = J3(l), o.serverTail.push(l)));
    }
    function Vs(o) {
      var l = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : !1, h = "", y = Bl;
      throw y !== null && (Bl = null, h = Dw(y)), fm(
        po(
          Error(
            "Hydration failed because the server rendered " + (l ? "text" : "HTML") + ` didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + h
          ),
          o
        )
      ), uR;
    }
    function Zw(o) {
      var l = o.stateNode, h = o.type, y = o.memoizedProps;
      switch (l[ni] = o, l[Oo] = y, Ao(h, y), h) {
        case "dialog":
          Xt("cancel", l), Xt("close", l);
          break;
        case "iframe":
        case "object":
        case "embed":
          Xt("load", l);
          break;
        case "video":
        case "audio":
          for (h = 0; h < hS.length; h++)
            Xt(hS[h], l);
          break;
        case "source":
          Xt("error", l);
          break;
        case "img":
        case "image":
        case "link":
          Xt("error", l), Xt("load", l);
          break;
        case "details":
          Xt("toggle", l);
          break;
        case "input":
          en("input", y), Xt("invalid", l), ca(l, y), ff(
            l,
            y.value,
            y.defaultValue,
            y.checked,
            y.defaultChecked,
            y.type,
            y.name,
            !0
          );
          break;
        case "option":
          Hg(l, y);
          break;
        case "select":
          en("select", y), Xt("invalid", l), ot(l, y);
          break;
        case "textarea":
          en("textarea", y), Xt("invalid", l), xt(l, y), li(
            l,
            y.value,
            y.defaultValue,
            y.children
          );
      }
      h = y.children, typeof h != "string" && typeof h != "number" && typeof h != "bigint" || l.textContent === "" + h || y.suppressHydrationWarning === !0 || J2(l.textContent, h) ? (y.popover != null && (Xt("beforetoggle", l), Xt("toggle", l)), y.onScroll != null && Xt("scroll", l), y.onScrollEnd != null && Xt("scrollend", l), y.onClick != null && (l.onclick = zs), l = !0) : l = !1, l || Vs(o, !0);
    }
    function Kw(o) {
      for (Ro = o.return; Ro; )
        switch (Ro.tag) {
          case 5:
          case 31:
          case 13:
            Mc = !1;
            return;
          case 27:
          case 3:
            Mc = !0;
            return;
          default:
            Ro = Ro.return;
        }
    }
    function _f(o) {
      if (o !== Ro)
        return !1;
      if (!Fn)
        return Kw(o), Fn = !0, !1;
      var l = o.tag, h;
      if ((h = l !== 3 && l !== 27) && ((h = l === 5) && (h = o.type, h = !(h !== "form" && h !== "button") || Tp(o.type, o.memoizedProps)), h = !h), h && ii) {
        for (h = ii; h; ) {
          var y = Ef(o, 0), S = J3(h);
          y.serverTail.push(S), h = S.type === "Suspense" ? Dp(h) : vs(h.nextSibling);
        }
        Vs(o);
      }
      if (Kw(o), l === 13) {
        if (o = o.memoizedState, o = o !== null ? o.dehydrated : null, !o)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        ii = Dp(o);
      } else if (l === 31) {
        if (o = o.memoizedState, o = o !== null ? o.dehydrated : null, !o)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        ii = Dp(o);
      } else
        l === 27 ? (l = ii, Rd(o.type) ? (o = e6, e6 = null, ii = o) : ii = l) : ii = Ro ? vs(o.stateNode.nextSibling) : null;
      return !0;
    }
    function sd() {
      ii = Ro = null, Pd = Fn = !1;
    }
    function dm() {
      var o = Zp;
      return o !== null && (As === null ? As = o : As.push.apply(
        As,
        o
      ), Zp = null), o;
    }
    function fm(o) {
      Zp === null ? Zp = [o] : Zp.push(o);
    }
    function ld() {
      var o = Bl;
      if (o !== null) {
        Bl = null;
        for (var l = Dw(o); 0 < o.children.length; )
          o = o.children[0];
        Ce(o.fiber, function() {
          console.error(
            `A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`,
            "https://react.dev/link/hydration-mismatch",
            l
          );
        });
      }
    }
    function Zh() {
      Ly = CA = null, By = !1;
    }
    function Us(o, l, h) {
      Y(dR, l._currentValue, o), l._currentValue = h, Y(fR, l._currentRenderer, o), l._currentRenderer !== void 0 && l._currentRenderer !== null && l._currentRenderer !== E9 && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      ), l._currentRenderer = E9;
    }
    function wl(o, l) {
      o._currentValue = dR.current;
      var h = fR.current;
      V(fR, l), o._currentRenderer = h, V(dR, l);
    }
    function sv(o, l, h) {
      for (; o !== null; ) {
        var y = o.alternate;
        if ((o.childLanes & l) !== l ? (o.childLanes |= l, y !== null && (y.childLanes |= l)) : y !== null && (y.childLanes & l) !== l && (y.childLanes |= l), o === h)
          break;
        o = o.return;
      }
      o !== h && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function ou(o, l, h, y) {
      var S = o.child;
      for (S !== null && (S.return = o); S !== null; ) {
        var E = S.dependencies;
        if (E !== null) {
          var j = S.child;
          E = E.firstContext;
          e:
            for (; E !== null; ) {
              var L = E;
              E = S;
              for (var Q = 0; Q < l.length; Q++)
                if (L.context === l[Q]) {
                  E.lanes |= h, L = E.alternate, L !== null && (L.lanes |= h), sv(
                    E.return,
                    h,
                    o
                  ), y || (j = null);
                  break e;
                }
              E = L.next;
            }
        } else if (S.tag === 18) {
          if (j = S.return, j === null)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          j.lanes |= h, E = j.alternate, E !== null && (E.lanes |= h), sv(
            j,
            h,
            o
          ), j = null;
        } else
          j = S.child;
        if (j !== null)
          j.return = S;
        else
          for (j = S; j !== null; ) {
            if (j === o) {
              j = null;
              break;
            }
            if (S = j.sibling, S !== null) {
              S.return = j.return, j = S;
              break;
            }
            j = j.return;
          }
        S = j;
      }
    }
    function xl(o, l, h, y) {
      o = null;
      for (var S = l, E = !1; S !== null; ) {
        if (!E) {
          if (S.flags & 524288)
            E = !0;
          else if (S.flags & 262144)
            break;
        }
        if (S.tag === 10) {
          var j = S.alternate;
          if (j === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          if (j = j.memoizedProps, j !== null) {
            var L = S.type;
            xs(S.pendingProps.value, j.value) || (o !== null ? o.push(L) : o = [L]);
          }
        } else if (S === Id.current) {
          if (j = S.alternate, j === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          j.memoizedState.memoizedState !== S.memoizedState.memoizedState && (o !== null ? o.push(yS) : o = [yS]);
        }
        S = S.return;
      }
      o !== null && ou(
        l,
        o,
        h,
        y
      ), l.flags |= 262144;
    }
    function Kh(o) {
      for (o = o.firstContext; o !== null; ) {
        if (!xs(
          o.context._currentValue,
          o.memoizedValue
        ))
          return !0;
        o = o.next;
      }
      return !1;
    }
    function cd(o) {
      CA = o, Ly = null, o = o.dependencies, o !== null && (o.firstContext = null);
    }
    function lr(o) {
      return By && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      ), Jw(CA, o);
    }
    function hm(o, l) {
      return CA === null && cd(o), Jw(o, l);
    }
    function Jw(o, l) {
      var h = l._currentValue;
      if (l = { context: l, memoizedValue: h, next: null }, Ly === null) {
        if (o === null)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        Ly = l, o.dependencies = {
          lanes: 0,
          firstContext: l,
          _debugThenableState: null
        }, o.flags |= 524288;
      } else
        Ly = Ly.next = l;
      return h;
    }
    function lv() {
      return {
        controller: new jte(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function Af(o) {
      o.controller.signal.aborted && console.warn(
        "A cache instance was retained after it was already freed. This likely indicates a bug in React."
      ), o.refCount++;
    }
    function pm(o) {
      o.refCount--, 0 > o.refCount && console.warn(
        "A cache instance was released after it was already freed. This likely indicates a bug in React."
      ), o.refCount === 0 && Pte(Lte, function() {
        o.controller.abort();
      });
    }
    function nc(o, l, h) {
      o & 127 ? 0 > Ld && (Ld = ba(), Vx = TA(l), hR = l, h != null && (pR = H(h)), (Zn & (ka | Vl)) !== no && (Li = !0, Jp = Fx), o = Op(), l = xc(), o !== zy || l !== Ux ? zy = -1.1 : l !== null && (Jp = Fx), w1 = o, Ux = l) : o & 4194048 && 0 > Ic && (Ic = ba(), $x = TA(l), _9 = l, h != null && (A9 = H(h)), 0 > uh) && (o = Op(), l = xc(), (o !== t0 || l !== x1) && (t0 = -1.1), e0 = o, x1 = l);
    }
    function f3(o) {
      if (0 > Ld) {
        Ld = ba(), Vx = o._debugTask != null ? o._debugTask : null, (Zn & (ka | Vl)) !== no && (Jp = Fx);
        var l = Op(), h = xc();
        l !== zy || h !== Ux ? zy = -1.1 : h !== null && (Jp = Fx), w1 = l, Ux = h;
      }
      0 > Ic && (Ic = ba(), $x = o._debugTask != null ? o._debugTask : null, 0 > uh) && (o = Op(), l = xc(), (o !== t0 || l !== x1) && (t0 = -1.1), e0 = o, x1 = l);
    }
    function rc() {
      var o = y1;
      return y1 = 0, o;
    }
    function Jh(o) {
      var l = y1;
      return y1 = o, l;
    }
    function mo(o) {
      var l = y1;
      return y1 += o, l;
    }
    function Cf() {
      Gt = zt = -1.1;
    }
    function Jr() {
      var o = zt;
      return zt = -1.1, o;
    }
    function da(o) {
      0 <= o && (zt = o);
    }
    function $s() {
      var o = Ri;
      return Ri = -0, o;
    }
    function as(o) {
      0 <= o && (Ri = o);
    }
    function os() {
      var o = fi;
      return fi = null, o;
    }
    function Hs() {
      var o = Li;
      return Li = !1, o;
    }
    function su(o) {
      Ss = ba(), 0 > o.actualStartTime && (o.actualStartTime = Ss);
    }
    function cv(o) {
      if (0 <= Ss) {
        var l = ba() - Ss;
        o.actualDuration += l, o.selfBaseDuration = l, Ss = -1;
      }
    }
    function mm(o) {
      if (0 <= Ss) {
        var l = ba() - Ss;
        o.actualDuration += l, Ss = -1;
      }
    }
    function go() {
      if (0 <= Ss) {
        var o = ba(), l = o - Ss;
        Ss = -1, y1 += l, Ri += l, Gt = o;
      }
    }
    function h3(o) {
      fi === null && (fi = []), fi.push(o), lh === null && (lh = []), lh.push(o);
    }
    function Ci() {
      Ss = ba(), 0 > zt && (zt = Ss);
    }
    function Tf(o) {
      for (var l = o.child; l; )
        o.actualDuration += l.actualDuration, l = l.sibling;
    }
    function lu(o, l) {
      if (qx === null) {
        var h = qx = [];
        vR = 0, S1 = K2(), Fy = {
          status: "pending",
          value: void 0,
          then: function(y) {
            h.push(y);
          }
        };
      }
      return vR++, l.then(e2, e2), l;
    }
    function e2() {
      if (--vR === 0 && (-1 < Ic || (uh = -1.1), qx !== null)) {
        Fy !== null && (Fy.status = "fulfilled");
        var o = qx;
        qx = null, S1 = 0, Fy = null;
        for (var l = 0; l < o.length; l++)
          (0, o[l])();
      }
    }
    function uv(o, l) {
      var h = [], y = {
        status: "pending",
        value: null,
        reason: null,
        then: function(S) {
          h.push(S);
        }
      };
      return o.then(
        function() {
          y.status = "fulfilled", y.value = l;
          for (var S = 0; S < h.length; S++)
            (0, h[S])(l);
        },
        function(S) {
          for (y.status = "rejected", y.reason = S, S = 0; S < h.length; S++)
            (0, h[S])(void 0);
        }
      ), y;
    }
    function cu() {
      var o = E1.current;
      return o !== null ? o : Hr.pooledCache;
    }
    function ep(o, l) {
      l === null ? Y(E1, E1.current, o) : Y(E1, l.pool, o);
    }
    function t2() {
      var o = cu();
      return o === null ? null : { parent: ya._currentValue, pool: o };
    }
    function dv() {
      return { didWarnAboutUncachedPromise: !1, thenables: [] };
    }
    function n2(o) {
      return o = o.status, o === "fulfilled" || o === "rejected";
    }
    function ss(o, l, h) {
      ze.actQueue !== null && (ze.didUsePromise = !0);
      var y = o.thenables;
      if (h = y[h], h === void 0 ? y.push(l) : h !== l && (o.didWarnAboutUncachedPromise || (o.didWarnAboutUncachedPromise = !0, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), l.then(zs, zs), l = h), l._debugInfo === void 0) {
        o = performance.now(), y = l.displayName;
        var S = {
          name: typeof y == "string" ? y : "Promise",
          start: o,
          end: o,
          value: l
        };
        l._debugInfo = [{ awaited: S }], l.status !== "fulfilled" && l.status !== "rejected" && (o = function() {
          S.end = performance.now();
        }, l.then(o, o));
      }
      switch (l.status) {
        case "fulfilled":
          return l.value;
        case "rejected":
          throw o = l.reason, gm(o), o;
        default:
          if (typeof l.status == "string")
            l.then(zs, zs);
          else {
            if (o = Hr, o !== null && 100 < o.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            o = l, o.status = "pending", o.then(
              function(E) {
                if (l.status === "pending") {
                  var j = l;
                  j.status = "fulfilled", j.value = E;
                }
              },
              function(E) {
                if (l.status === "pending") {
                  var j = l;
                  j.status = "rejected", j.reason = E;
                }
              }
            );
          }
          switch (l.status) {
            case "fulfilled":
              return l.value;
            case "rejected":
              throw o = l.reason, gm(o), o;
          }
          throw A1 = l, Kx = !0, Vy;
      }
    }
    function ls(o) {
      try {
        return Vte(o);
      } catch (l) {
        throw l !== null && typeof l == "object" && typeof l.then == "function" ? (A1 = l, Kx = !0, Vy) : l;
      }
    }
    function Of() {
      if (A1 === null)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var o = A1;
      return A1 = null, Kx = !1, o;
    }
    function gm(o) {
      if (o === Vy || o === jA)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function Mi(o) {
      var l = wn;
      return o != null && (wn = l === null ? o : l.concat(o)), l;
    }
    function zo() {
      var o = wn;
      if (o != null) {
        for (var l = o.length - 1; 0 <= l; l--)
          if (o[l].name != null) {
            var h = o[l].debugTask;
            if (h != null)
              return h;
          }
      }
      return null;
    }
    function vo(o, l, h) {
      for (var y = Object.keys(o.props), S = 0; S < y.length; S++) {
        var E = y[S];
        if (E !== "children" && E !== "key") {
          l === null && (l = ad(o, h.mode, 0), l._debugInfo = wn, l.return = h), Ce(
            l,
            function(j) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                j
              );
            },
            E
          );
          break;
        }
      }
    }
    function Sl(o) {
      var l = Jx;
      return Jx += 1, Uy === null && (Uy = dv()), ss(Uy, o, l);
    }
    function Fo(o, l) {
      l = l.props.ref, o.ref = l !== void 0 ? l : null;
    }
    function El(o, l) {
      throw l.$$typeof === cA ? Error(
        `A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`
      ) : (o = Object.prototype.toString.call(l), Error(
        "Objects are not valid as a React child (found: " + (o === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : o) + "). If you meant to render a collection of children, use an array instead."
      ));
    }
    function qs(o, l) {
      var h = zo();
      h !== null ? h.run(
        El.bind(null, o, l)
      ) : El(o, l);
    }
    function r2(o, l) {
      var h = H(o) || "Component";
      q9[h] || (q9[h] = !0, l = l.displayName || l.name || "Component", o.tag === 3 ? console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`,
        l,
        l,
        l
      ) : console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`,
        l,
        l,
        h,
        l,
        h
      ));
    }
    function tp(o, l) {
      var h = zo();
      h !== null ? h.run(
        r2.bind(null, o, l)
      ) : r2(o, l);
    }
    function fv(o, l) {
      var h = H(o) || "Component";
      G9[h] || (G9[h] = !0, l = String(l), o.tag === 3 ? console.error(
        `Symbols are not valid as a React child.
  root.render(%s)`,
        l
      ) : console.error(
        `Symbols are not valid as a React child.
  <%s>%s</%s>`,
        h,
        l,
        h
      ));
    }
    function vm(o, l) {
      var h = zo();
      h !== null ? h.run(
        fv.bind(null, o, l)
      ) : fv(o, l);
    }
    function fa(o) {
      function l(fe, pe) {
        if (o) {
          var ye = fe.deletions;
          ye === null ? (fe.deletions = [pe], fe.flags |= 16) : ye.push(pe);
        }
      }
      function h(fe, pe) {
        if (!o)
          return null;
        for (; pe !== null; )
          l(fe, pe), pe = pe.sibling;
        return null;
      }
      function y(fe) {
        for (var pe = /* @__PURE__ */ new Map(); fe !== null; )
          fe.key !== null ? pe.set(fe.key, fe) : pe.set(fe.index, fe), fe = fe.sibling;
        return pe;
      }
      function S(fe, pe) {
        return fe = tc(fe, pe), fe.index = 0, fe.sibling = null, fe;
      }
      function E(fe, pe, ye) {
        return fe.index = ye, o ? (ye = fe.alternate, ye !== null ? (ye = ye.index, ye < pe ? (fe.flags |= 67108866, pe) : ye) : (fe.flags |= 67108866, pe)) : (fe.flags |= 1048576, pe);
      }
      function j(fe) {
        return o && fe.alternate === null && (fe.flags |= 67108866), fe;
      }
      function L(fe, pe, ye, Ge) {
        return pe === null || pe.tag !== 6 ? (pe = Qh(
          ye,
          fe.mode,
          Ge
        ), pe.return = fe, pe._debugOwner = fe, pe._debugTask = fe._debugTask, pe._debugInfo = wn, pe) : (pe = S(pe, ye), pe.return = fe, pe._debugInfo = wn, pe);
      }
      function Q(fe, pe, ye, Ge) {
        var mt = ye.type;
        return mt === jp ? (pe = be(
          fe,
          pe,
          ye.props.children,
          Ge,
          ye.key
        ), vo(ye, pe, fe), pe) : pe !== null && (pe.elementType === mt || Gw(pe, ye) || typeof mt == "object" && mt !== null && mt.$$typeof === Ka && ls(mt) === pe.type) ? (pe = S(pe, ye.props), Fo(pe, ye), pe.return = fe, pe._debugOwner = ye._owner, pe._debugInfo = wn, pe) : (pe = ad(ye, fe.mode, Ge), Fo(pe, ye), pe.return = fe, pe._debugInfo = wn, pe);
      }
      function ne(fe, pe, ye, Ge) {
        return pe === null || pe.tag !== 4 || pe.stateNode.containerInfo !== ye.containerInfo || pe.stateNode.implementation !== ye.implementation ? (pe = iv(ye, fe.mode, Ge), pe.return = fe, pe._debugInfo = wn, pe) : (pe = S(pe, ye.children || []), pe.return = fe, pe._debugInfo = wn, pe);
      }
      function be(fe, pe, ye, Ge, mt) {
        return pe === null || pe.tag !== 7 ? (pe = Sf(
          ye,
          fe.mode,
          Ge,
          mt
        ), pe.return = fe, pe._debugOwner = fe, pe._debugTask = fe._debugTask, pe._debugInfo = wn, pe) : (pe = S(pe, ye), pe.return = fe, pe._debugInfo = wn, pe);
      }
      function Ee(fe, pe, ye) {
        if (typeof pe == "string" && pe !== "" || typeof pe == "number" || typeof pe == "bigint")
          return pe = Qh(
            "" + pe,
            fe.mode,
            ye
          ), pe.return = fe, pe._debugOwner = fe, pe._debugTask = fe._debugTask, pe._debugInfo = wn, pe;
        if (typeof pe == "object" && pe !== null) {
          switch (pe.$$typeof) {
            case Qs:
              return ye = ad(
                pe,
                fe.mode,
                ye
              ), Fo(ye, pe), ye.return = fe, fe = Mi(pe._debugInfo), ye._debugInfo = wn, wn = fe, ye;
            case Nd:
              return pe = iv(
                pe,
                fe.mode,
                ye
              ), pe.return = fe, pe._debugInfo = wn, pe;
            case Ka:
              var Ge = Mi(pe._debugInfo);
              return pe = ls(pe), fe = Ee(fe, pe, ye), wn = Ge, fe;
          }
          if (Yi(pe) || F(pe))
            return ye = Sf(
              pe,
              fe.mode,
              ye,
              null
            ), ye.return = fe, ye._debugOwner = fe, ye._debugTask = fe._debugTask, fe = Mi(pe._debugInfo), ye._debugInfo = wn, wn = fe, ye;
          if (typeof pe.then == "function")
            return Ge = Mi(pe._debugInfo), fe = Ee(
              fe,
              Sl(pe),
              ye
            ), wn = Ge, fe;
          if (pe.$$typeof === jl)
            return Ee(
              fe,
              hm(fe, pe),
              ye
            );
          qs(fe, pe);
        }
        return typeof pe == "function" && tp(fe, pe), typeof pe == "symbol" && vm(fe, pe), null;
      }
      function he(fe, pe, ye, Ge) {
        var mt = pe !== null ? pe.key : null;
        if (typeof ye == "string" && ye !== "" || typeof ye == "number" || typeof ye == "bigint")
          return mt !== null ? null : L(fe, pe, "" + ye, Ge);
        if (typeof ye == "object" && ye !== null) {
          switch (ye.$$typeof) {
            case Qs:
              return ye.key === mt ? (mt = Mi(ye._debugInfo), fe = Q(
                fe,
                pe,
                ye,
                Ge
              ), wn = mt, fe) : null;
            case Nd:
              return ye.key === mt ? ne(fe, pe, ye, Ge) : null;
            case Ka:
              return mt = Mi(ye._debugInfo), ye = ls(ye), fe = he(
                fe,
                pe,
                ye,
                Ge
              ), wn = mt, fe;
          }
          if (Yi(ye) || F(ye))
            return mt !== null ? null : (mt = Mi(ye._debugInfo), fe = be(
              fe,
              pe,
              ye,
              Ge,
              null
            ), wn = mt, fe);
          if (typeof ye.then == "function")
            return mt = Mi(ye._debugInfo), fe = he(
              fe,
              pe,
              Sl(ye),
              Ge
            ), wn = mt, fe;
          if (ye.$$typeof === jl)
            return he(
              fe,
              pe,
              hm(fe, ye),
              Ge
            );
          qs(fe, ye);
        }
        return typeof ye == "function" && tp(fe, ye), typeof ye == "symbol" && vm(fe, ye), null;
      }
      function Le(fe, pe, ye, Ge, mt) {
        if (typeof Ge == "string" && Ge !== "" || typeof Ge == "number" || typeof Ge == "bigint")
          return fe = fe.get(ye) || null, L(pe, fe, "" + Ge, mt);
        if (typeof Ge == "object" && Ge !== null) {
          switch (Ge.$$typeof) {
            case Qs:
              return ye = fe.get(
                Ge.key === null ? ye : Ge.key
              ) || null, fe = Mi(Ge._debugInfo), pe = Q(
                pe,
                ye,
                Ge,
                mt
              ), wn = fe, pe;
            case Nd:
              return fe = fe.get(
                Ge.key === null ? ye : Ge.key
              ) || null, ne(pe, fe, Ge, mt);
            case Ka:
              var an = Mi(Ge._debugInfo);
              return Ge = ls(Ge), pe = Le(
                fe,
                pe,
                ye,
                Ge,
                mt
              ), wn = an, pe;
          }
          if (Yi(Ge) || F(Ge))
            return ye = fe.get(ye) || null, fe = Mi(Ge._debugInfo), pe = be(
              pe,
              ye,
              Ge,
              mt,
              null
            ), wn = fe, pe;
          if (typeof Ge.then == "function")
            return an = Mi(Ge._debugInfo), pe = Le(
              fe,
              pe,
              ye,
              Sl(Ge),
              mt
            ), wn = an, pe;
          if (Ge.$$typeof === jl)
            return Le(
              fe,
              pe,
              ye,
              hm(pe, Ge),
              mt
            );
          qs(pe, Ge);
        }
        return typeof Ge == "function" && tp(pe, Ge), typeof Ge == "symbol" && vm(pe, Ge), null;
      }
      function dt(fe, pe, ye, Ge) {
        if (typeof ye != "object" || ye === null)
          return Ge;
        switch (ye.$$typeof) {
          case Qs:
          case Nd:
            g(fe, pe, ye);
            var mt = ye.key;
            if (typeof mt != "string")
              break;
            if (Ge === null) {
              Ge = /* @__PURE__ */ new Set(), Ge.add(mt);
              break;
            }
            if (!Ge.has(mt)) {
              Ge.add(mt);
              break;
            }
            Ce(pe, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                mt
              );
            });
            break;
          case Ka:
            ye = ls(ye), dt(fe, pe, ye, Ge);
        }
        return Ge;
      }
      function yt(fe, pe, ye, Ge) {
        for (var mt = null, an = null, Bt = null, It = pe, gn = pe = 0, ai = null; It !== null && gn < ye.length; gn++) {
          It.index > gn ? (ai = It, It = null) : ai = It.sibling;
          var ta = he(
            fe,
            It,
            ye[gn],
            Ge
          );
          if (ta === null) {
            It === null && (It = ai);
            break;
          }
          mt = dt(
            fe,
            ta,
            ye[gn],
            mt
          ), o && It && ta.alternate === null && l(fe, It), pe = E(ta, pe, gn), Bt === null ? an = ta : Bt.sibling = ta, Bt = ta, It = ai;
        }
        if (gn === ye.length)
          return h(fe, It), Fn && bl(fe, gn), an;
        if (It === null) {
          for (; gn < ye.length; gn++)
            It = Ee(fe, ye[gn], Ge), It !== null && (mt = dt(
              fe,
              It,
              ye[gn],
              mt
            ), pe = E(
              It,
              pe,
              gn
            ), Bt === null ? an = It : Bt.sibling = It, Bt = It);
          return Fn && bl(fe, gn), an;
        }
        for (It = y(It); gn < ye.length; gn++)
          ai = Le(
            It,
            fe,
            gn,
            ye[gn],
            Ge
          ), ai !== null && (mt = dt(
            fe,
            ai,
            ye[gn],
            mt
          ), o && ai.alternate !== null && It.delete(
            ai.key === null ? gn : ai.key
          ), pe = E(
            ai,
            pe,
            gn
          ), Bt === null ? an = ai : Bt.sibling = ai, Bt = ai);
        return o && It.forEach(function(yh) {
          return l(fe, yh);
        }), Fn && bl(fe, gn), an;
      }
      function Qr(fe, pe, ye, Ge) {
        if (ye == null)
          throw Error("An iterable object provided no iterator.");
        for (var mt = null, an = null, Bt = pe, It = pe = 0, gn = null, ai = null, ta = ye.next(); Bt !== null && !ta.done; It++, ta = ye.next()) {
          Bt.index > It ? (gn = Bt, Bt = null) : gn = Bt.sibling;
          var yh = he(fe, Bt, ta.value, Ge);
          if (yh === null) {
            Bt === null && (Bt = gn);
            break;
          }
          ai = dt(
            fe,
            yh,
            ta.value,
            ai
          ), o && Bt && yh.alternate === null && l(fe, Bt), pe = E(yh, pe, It), an === null ? mt = yh : an.sibling = yh, an = yh, Bt = gn;
        }
        if (ta.done)
          return h(fe, Bt), Fn && bl(fe, It), mt;
        if (Bt === null) {
          for (; !ta.done; It++, ta = ye.next())
            Bt = Ee(fe, ta.value, Ge), Bt !== null && (ai = dt(
              fe,
              Bt,
              ta.value,
              ai
            ), pe = E(
              Bt,
              pe,
              It
            ), an === null ? mt = Bt : an.sibling = Bt, an = Bt);
          return Fn && bl(fe, It), mt;
        }
        for (Bt = y(Bt); !ta.done; It++, ta = ye.next())
          gn = Le(
            Bt,
            fe,
            It,
            ta.value,
            Ge
          ), gn !== null && (ai = dt(
            fe,
            gn,
            ta.value,
            ai
          ), o && gn.alternate !== null && Bt.delete(
            gn.key === null ? It : gn.key
          ), pe = E(
            gn,
            pe,
            It
          ), an === null ? mt = gn : an.sibling = gn, an = gn);
        return o && Bt.forEach(function(dne) {
          return l(fe, dne);
        }), Fn && bl(fe, It), mt;
      }
      function Hn(fe, pe, ye, Ge) {
        if (typeof ye == "object" && ye !== null && ye.type === jp && ye.key === null && (vo(ye, null, fe), ye = ye.props.children), typeof ye == "object" && ye !== null) {
          switch (ye.$$typeof) {
            case Qs:
              var mt = Mi(ye._debugInfo);
              e: {
                for (var an = ye.key; pe !== null; ) {
                  if (pe.key === an) {
                    if (an = ye.type, an === jp) {
                      if (pe.tag === 7) {
                        h(
                          fe,
                          pe.sibling
                        ), Ge = S(
                          pe,
                          ye.props.children
                        ), Ge.return = fe, Ge._debugOwner = ye._owner, Ge._debugInfo = wn, vo(ye, Ge, fe), fe = Ge;
                        break e;
                      }
                    } else if (pe.elementType === an || Gw(
                      pe,
                      ye
                    ) || typeof an == "object" && an !== null && an.$$typeof === Ka && ls(an) === pe.type) {
                      h(
                        fe,
                        pe.sibling
                      ), Ge = S(pe, ye.props), Fo(Ge, ye), Ge.return = fe, Ge._debugOwner = ye._owner, Ge._debugInfo = wn, fe = Ge;
                      break e;
                    }
                    h(fe, pe);
                    break;
                  } else
                    l(fe, pe);
                  pe = pe.sibling;
                }
                ye.type === jp ? (Ge = Sf(
                  ye.props.children,
                  fe.mode,
                  Ge,
                  ye.key
                ), Ge.return = fe, Ge._debugOwner = fe, Ge._debugTask = fe._debugTask, Ge._debugInfo = wn, vo(ye, Ge, fe), fe = Ge) : (Ge = ad(
                  ye,
                  fe.mode,
                  Ge
                ), Fo(Ge, ye), Ge.return = fe, Ge._debugInfo = wn, fe = Ge);
              }
              return fe = j(fe), wn = mt, fe;
            case Nd:
              e: {
                for (mt = ye, ye = mt.key; pe !== null; ) {
                  if (pe.key === ye)
                    if (pe.tag === 4 && pe.stateNode.containerInfo === mt.containerInfo && pe.stateNode.implementation === mt.implementation) {
                      h(
                        fe,
                        pe.sibling
                      ), Ge = S(
                        pe,
                        mt.children || []
                      ), Ge.return = fe, fe = Ge;
                      break e;
                    } else {
                      h(fe, pe);
                      break;
                    }
                  else
                    l(fe, pe);
                  pe = pe.sibling;
                }
                Ge = iv(
                  mt,
                  fe.mode,
                  Ge
                ), Ge.return = fe, fe = Ge;
              }
              return j(fe);
            case Ka:
              return mt = Mi(ye._debugInfo), ye = ls(ye), fe = Hn(
                fe,
                pe,
                ye,
                Ge
              ), wn = mt, fe;
          }
          if (Yi(ye))
            return mt = Mi(ye._debugInfo), fe = yt(
              fe,
              pe,
              ye,
              Ge
            ), wn = mt, fe;
          if (F(ye)) {
            if (mt = Mi(ye._debugInfo), an = F(ye), typeof an != "function")
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var Bt = an.call(ye);
            return Bt === ye ? (fe.tag !== 0 || Object.prototype.toString.call(fe.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call(Bt) !== "[object Generator]") && ($9 || console.error(
              "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
            ), $9 = !0) : ye.entries !== an || xR || (console.error(
              "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
            ), xR = !0), fe = Qr(
              fe,
              pe,
              Bt,
              Ge
            ), wn = mt, fe;
          }
          if (typeof ye.then == "function")
            return mt = Mi(ye._debugInfo), fe = Hn(
              fe,
              pe,
              Sl(ye),
              Ge
            ), wn = mt, fe;
          if (ye.$$typeof === jl)
            return Hn(
              fe,
              pe,
              hm(fe, ye),
              Ge
            );
          qs(fe, ye);
        }
        return typeof ye == "string" && ye !== "" || typeof ye == "number" || typeof ye == "bigint" ? (mt = "" + ye, pe !== null && pe.tag === 6 ? (h(
          fe,
          pe.sibling
        ), Ge = S(pe, mt), Ge.return = fe, fe = Ge) : (h(fe, pe), Ge = Qh(
          mt,
          fe.mode,
          Ge
        ), Ge.return = fe, Ge._debugOwner = fe, Ge._debugTask = fe._debugTask, Ge._debugInfo = wn, fe = Ge), j(fe)) : (typeof ye == "function" && tp(fe, ye), typeof ye == "symbol" && vm(fe, ye), h(fe, pe));
      }
      return function(fe, pe, ye, Ge) {
        var mt = wn;
        wn = null;
        try {
          Jx = 0;
          var an = Hn(
            fe,
            pe,
            ye,
            Ge
          );
          return Uy = null, an;
        } catch (ai) {
          if (ai === Vy || ai === jA)
            throw ai;
          var Bt = b(29, ai, null, fe.mode);
          Bt.lanes = Ge, Bt.return = fe;
          var It = Bt._debugInfo = wn;
          if (Bt._debugOwner = fe._debugOwner, Bt._debugTask = fe._debugTask, It != null) {
            for (var gn = It.length - 1; 0 <= gn; gn--)
              if (typeof It[gn].stack == "string") {
                Bt._debugOwner = It[gn], Bt._debugTask = It[gn].debugTask;
                break;
              }
          }
          return Bt;
        } finally {
          wn = mt;
        }
      };
    }
    function Fr(o, l) {
      var h = Yi(o);
      return o = !h && typeof F(o) == "function", h || o ? (h = h ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        h,
        l,
        h
      ), !1) : !0;
    }
    function Pn(o) {
      o.updateQueue = {
        baseState: o.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function ic(o, l) {
      o = o.updateQueue, l.updateQueue === o && (l.updateQueue = {
        baseState: o.baseState,
        firstBaseUpdate: o.firstBaseUpdate,
        lastBaseUpdate: o.lastBaseUpdate,
        shared: o.shared,
        callbacks: null
      });
    }
    function Wi(o) {
      return {
        lane: o,
        tag: X9,
        payload: null,
        callback: null,
        next: null
      };
    }
    function ac(o, l, h) {
      var y = o.updateQueue;
      if (y === null)
        return null;
      if (y = y.shared, ER === y && !Z9) {
        var S = H(o);
        console.error(
          `An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`,
          S
        ), Z9 = !0;
      }
      return (Zn & ka) !== no ? (S = y.pending, S === null ? l.next = l : (l.next = S.next, S.next = l), y.pending = l, l = um(o), qw(o, null, h), l) : (Wh(o, y, l, h), um(o));
    }
    function Gs(o, l, h) {
      if (l = l.updateQueue, l !== null && (l = l.shared, (h & 4194048) !== 0)) {
        var y = l.lanes;
        y &= o.pendingLanes, h |= y, l.lanes = h, hn(o, h);
      }
    }
    function ym(o, l) {
      var h = o.updateQueue, y = o.alternate;
      if (y !== null && (y = y.updateQueue, h === y)) {
        var S = null, E = null;
        if (h = h.firstBaseUpdate, h !== null) {
          do {
            var j = {
              lane: h.lane,
              tag: h.tag,
              payload: h.payload,
              callback: null,
              next: null
            };
            E === null ? S = E = j : E = E.next = j, h = h.next;
          } while (h !== null);
          E === null ? S = E = l : E = E.next = l;
        } else
          S = E = l;
        h = {
          baseState: y.baseState,
          firstBaseUpdate: S,
          lastBaseUpdate: E,
          shared: y.shared,
          callbacks: y.callbacks
        }, o.updateQueue = h;
        return;
      }
      o = h.lastBaseUpdate, o === null ? h.firstBaseUpdate = l : o.next = l, h.lastBaseUpdate = l;
    }
    function np() {
      if (_R) {
        var o = Fy;
        if (o !== null)
          throw o;
      }
    }
    function oc(o, l, h, y) {
      _R = !1;
      var S = o.updateQueue;
      n0 = !1, ER = S.shared;
      var E = S.firstBaseUpdate, j = S.lastBaseUpdate, L = S.shared.pending;
      if (L !== null) {
        S.shared.pending = null;
        var Q = L, ne = Q.next;
        Q.next = null, j === null ? E = ne : j.next = ne, j = Q;
        var be = o.alternate;
        be !== null && (be = be.updateQueue, L = be.lastBaseUpdate, L !== j && (L === null ? be.firstBaseUpdate = ne : L.next = ne, be.lastBaseUpdate = Q));
      }
      if (E !== null) {
        var Ee = S.baseState;
        j = 0, be = ne = Q = null, L = E;
        do {
          var he = L.lane & -536870913, Le = he !== L.lane;
          if (Le ? (xn & he) === he : (y & he) === he) {
            he !== 0 && he === S1 && (_R = !0), be !== null && (be = be.next = {
              lane: 0,
              tag: L.tag,
              payload: L.payload,
              callback: null,
              next: null
            });
            e: {
              he = o;
              var dt = L, yt = l, Qr = h;
              switch (dt.tag) {
                case W9:
                  if (dt = dt.payload, typeof dt == "function") {
                    By = !0;
                    var Hn = dt.call(
                      Qr,
                      Ee,
                      yt
                    );
                    if (he.mode & Yo) {
                      se(!0);
                      try {
                        dt.call(Qr, Ee, yt);
                      } finally {
                        se(!1);
                      }
                    }
                    By = !1, Ee = Hn;
                    break e;
                  }
                  Ee = dt;
                  break e;
                case SR:
                  he.flags = he.flags & -65537 | 128;
                case X9:
                  if (Hn = dt.payload, typeof Hn == "function") {
                    if (By = !0, dt = Hn.call(
                      Qr,
                      Ee,
                      yt
                    ), he.mode & Yo) {
                      se(!0);
                      try {
                        Hn.call(Qr, Ee, yt);
                      } finally {
                        se(!1);
                      }
                    }
                    By = !1;
                  } else
                    dt = Hn;
                  if (dt == null)
                    break e;
                  Ee = yn({}, Ee, dt);
                  break e;
                case Q9:
                  n0 = !0;
              }
            }
            he = L.callback, he !== null && (o.flags |= 64, Le && (o.flags |= 8192), Le = S.callbacks, Le === null ? S.callbacks = [he] : Le.push(he));
          } else
            Le = {
              lane: he,
              tag: L.tag,
              payload: L.payload,
              callback: L.callback,
              next: null
            }, be === null ? (ne = be = Le, Q = Ee) : be = be.next = Le, j |= he;
          if (L = L.next, L === null) {
            if (L = S.shared.pending, L === null)
              break;
            Le = L, L = Le.next, Le.next = null, S.lastBaseUpdate = Le, S.shared.pending = null;
          }
        } while (1);
        be === null && (Q = Ee), S.baseState = Q, S.firstBaseUpdate = ne, S.lastBaseUpdate = be, E === null && (S.shared.lanes = 0), a0 |= j, o.lanes = j, o.memoizedState = Ee;
      }
      ER = null;
    }
    function ud(o, l) {
      if (typeof o != "function")
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + o
        );
      o.call(l);
    }
    function i2(o, l) {
      var h = o.shared.hiddenCallbacks;
      if (h !== null)
        for (o.shared.hiddenCallbacks = null, o = 0; o < h.length; o++)
          ud(h[o], l);
    }
    function rp(o, l) {
      var h = o.callbacks;
      if (h !== null)
        for (o.callbacks = null, o = 0; o < h.length; o++)
          ud(h[o], l);
    }
    function hv(o, l) {
      var h = zd;
      Y(LA, h, o), Y($y, l, o), zd = h | l.baseLanes;
    }
    function uu(o) {
      Y(LA, zd, o), Y(
        $y,
        $y.current,
        o
      );
    }
    function _l(o) {
      zd = LA.current, V($y, o), V(LA, o);
    }
    function yo(o) {
      var l = o.alternate;
      Y(
        ea,
        ea.current & Hy,
        o
      ), Y(zl, o, o), kc === null && (l === null || $y.current !== null || l.memoizedState !== null) && (kc = o);
    }
    function Al(o) {
      Y(ea, ea.current, o), Y(zl, o, o), kc === null && (kc = o);
    }
    function pv(o) {
      o.tag === 22 ? (Y(ea, ea.current, o), Y(zl, o, o), kc === null && (kc = o)) : sc(o);
    }
    function sc(o) {
      Y(ea, ea.current, o), Y(
        zl,
        zl.current,
        o
      );
    }
    function ha(o) {
      V(zl, o), kc === o && (kc = null), V(ea, o);
    }
    function Rf(o) {
      for (var l = o; l !== null; ) {
        if (l.tag === 13) {
          var h = l.memoizedState;
          if (h !== null && (h = h.dehydrated, h === null || e1(h) || tx(h)))
            return l;
        } else if (l.tag === 19 && (l.memoizedProps.revealOrder === "forwards" || l.memoizedProps.revealOrder === "backwards" || l.memoizedProps.revealOrder === "unstable_legacy-backwards" || l.memoizedProps.revealOrder === "together")) {
          if (l.flags & 128)
            return l;
        } else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === o)
          break;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === o)
            return null;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return null;
    }
    function nn() {
      var o = Be;
      Pc === null ? Pc = [o] : Pc.push(o);
    }
    function tt() {
      var o = Be;
      if (Pc !== null && (hh++, Pc[hh] !== o)) {
        var l = H(rn);
        if (!K9.has(l) && (K9.add(l), Pc !== null)) {
          for (var h = "", y = 0; y <= hh; y++) {
            var S = Pc[y], E = y === hh ? o : S;
            for (S = y + 1 + ". " + S; 30 > S.length; )
              S += " ";
            S += E + `
`, h += S;
          }
          console.error(
            `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
            l,
            h
          );
        }
      }
    }
    function du(o) {
      o == null || Yi(o) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        Be,
        typeof o
      );
    }
    function bm() {
      var o = H(rn);
      ej.has(o) || (ej.add(o), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        o
      ));
    }
    function Ti() {
      throw Error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      );
    }
    function a2(o, l) {
      if (nS)
        return !1;
      if (l === null)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          Be
        ), !1;
      o.length !== l.length && console.error(
        `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
        Be,
        "[" + l.join(", ") + "]",
        "[" + o.join(", ") + "]"
      );
      for (var h = 0; h < l.length && h < o.length; h++)
        if (!xs(o[h], l[h]))
          return !1;
      return !0;
    }
    function o2(o, l, h, y, S, E) {
      dh = E, rn = l, Pc = o !== null ? o._debugHookTypes : null, hh = -1, nS = o !== null && o.type !== l.type, (Object.prototype.toString.call(h) === "[object AsyncFunction]" || Object.prototype.toString.call(h) === "[object AsyncGeneratorFunction]") && (E = H(rn), AR.has(E) || (AR.add(E), console.error(
        "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
        E === null ? "An unknown Component" : "<" + E + ">"
      ))), l.memoizedState = null, l.updateQueue = null, l.lanes = 0, ze.H = o !== null && o.memoizedState !== null ? TR : Pc !== null ? tj : CR, T1 = E = (l.mode & Yo) !== Wt;
      var j = yR(h, y, S);
      if (T1 = !1, Gy && (j = wm(
        l,
        h,
        y,
        S
      )), E) {
        se(!0);
        try {
          j = wm(
            l,
            h,
            y,
            S
          );
        } finally {
          se(!1);
        }
      }
      return Ii(o, l), j;
    }
    function Ii(o, l) {
      l._debugHookTypes = Pc, l.dependencies === null ? fh !== null && (l.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: fh
      }) : l.dependencies._debugThenableState = fh, ze.H = rS;
      var h = $r !== null && $r.next !== null;
      if (dh = 0, Pc = Be = wa = $r = rn = null, hh = -1, o !== null && (o.flags & 65011712) !== (l.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      ), zA = !1, tS = 0, fh = null, h)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      o === null || xa || (o = o.dependencies, o !== null && Kh(o) && (xa = !0)), Kx ? (Kx = !1, o = !0) : o = !1, o && (l = H(l) || "Unknown", J9.has(l) || AR.has(l) || (J9.add(l), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function wm(o, l, h, y) {
      rn = o;
      var S = 0;
      do {
        if (Gy && (fh = null), tS = 0, Gy = !1, S >= $te)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        if (S += 1, nS = !1, wa = $r = null, o.updateQueue != null) {
          var E = o.updateQueue;
          E.lastEffect = null, E.events = null, E.stores = null, E.memoCache != null && (E.memoCache.index = 0);
        }
        hh = -1, ze.H = nj, E = yR(l, h, y);
      } while (Gy);
      return E;
    }
    function xm() {
      var o = ze.H, l = o.useState()[0];
      return l = typeof l.then == "function" ? _m(l) : l, o = o.useState()[0], ($r !== null ? $r.memoizedState : null) !== o && (rn.flags |= 1024), l;
    }
    function Df() {
      var o = FA !== 0;
      return FA = 0, o;
    }
    function Sm(o, l, h) {
      l.updateQueue = o.updateQueue, l.flags = (l.mode & Cu) !== Wt ? l.flags & -402655237 : l.flags & -2053, o.lanes &= ~h;
    }
    function dd(o) {
      if (zA) {
        for (o = o.memoizedState; o !== null; ) {
          var l = o.queue;
          l !== null && (l.pending = null), o = o.next;
        }
        zA = !1;
      }
      dh = 0, Pc = wa = $r = rn = null, hh = -1, Be = null, Gy = !1, tS = FA = 0, fh = null;
    }
    function qi() {
      var o = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return wa === null ? rn.memoizedState = wa = o : wa = wa.next = o, wa;
    }
    function fr() {
      if ($r === null) {
        var o = rn.alternate;
        o = o !== null ? o.memoizedState : null;
      } else
        o = $r.next;
      var l = wa === null ? rn.memoizedState : wa.next;
      if (l !== null)
        wa = l, $r = o;
      else {
        if (o === null)
          throw rn.alternate === null ? Error(
            "Update hook called on initial render. This is likely a bug in React. Please file an issue."
          ) : Error("Rendered more hooks than during the previous render.");
        $r = o, o = {
          memoizedState: $r.memoizedState,
          baseState: $r.baseState,
          baseQueue: $r.baseQueue,
          queue: $r.queue,
          next: null
        }, wa === null ? rn.memoizedState = wa = o : wa = wa.next = o;
      }
      return wa;
    }
    function Em() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function _m(o) {
      var l = tS;
      return tS += 1, fh === null && (fh = dv()), o = ss(fh, o, l), l = rn, (wa === null ? l.memoizedState : wa.next) === null && (l = l.alternate, ze.H = l !== null && l.memoizedState !== null ? TR : CR), o;
    }
    function fu(o) {
      if (o !== null && typeof o == "object") {
        if (typeof o.then == "function")
          return _m(o);
        if (o.$$typeof === jl)
          return lr(o);
      }
      throw Error("An unsupported type was passed to use(): " + String(o));
    }
    function cs(o) {
      var l = null, h = rn.updateQueue;
      if (h !== null && (l = h.memoCache), l == null) {
        var y = rn.alternate;
        y !== null && (y = y.updateQueue, y !== null && (y = y.memoCache, y != null && (l = {
          data: y.data.map(function(S) {
            return S.slice();
          }),
          index: 0
        })));
      }
      if (l == null && (l = { data: [], index: 0 }), h === null && (h = Em(), rn.updateQueue = h), h.memoCache = l, h = l.data[l.index], h === void 0 || nS)
        for (h = l.data[l.index] = Array(o), y = 0; y < o; y++)
          h[y] = HO;
      else
        h.length !== o && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          h.length,
          o
        );
      return l.index++, h;
    }
    function us(o, l) {
      return typeof l == "function" ? l(o) : l;
    }
    function ip(o, l, h) {
      var y = qi();
      if (h !== void 0) {
        var S = h(l);
        if (T1) {
          se(!0);
          try {
            h(l);
          } finally {
            se(!1);
          }
        }
      } else
        S = l;
      return y.memoizedState = y.baseState = S, o = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: o,
        lastRenderedState: S
      }, y.queue = o, o = o.dispatch = zO.bind(
        null,
        rn,
        o
      ), [y.memoizedState, o];
    }
    function Nf(o) {
      var l = fr();
      return fd(l, $r, o);
    }
    function fd(o, l, h) {
      var y = o.queue;
      if (y === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      y.lastRenderedReducer = h;
      var S = o.baseQueue, E = y.pending;
      if (E !== null) {
        if (S !== null) {
          var j = S.next;
          S.next = E.next, E.next = j;
        }
        l.baseQueue !== S && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        ), l.baseQueue = S = E, y.pending = null;
      }
      if (E = o.baseState, S === null)
        o.memoizedState = E;
      else {
        l = S.next;
        var L = j = null, Q = null, ne = l, be = !1;
        do {
          var Ee = ne.lane & -536870913;
          if (Ee !== ne.lane ? (xn & Ee) === Ee : (dh & Ee) === Ee) {
            var he = ne.revertLane;
            if (he === 0)
              Q !== null && (Q = Q.next = {
                lane: 0,
                revertLane: 0,
                gesture: null,
                action: ne.action,
                hasEagerState: ne.hasEagerState,
                eagerState: ne.eagerState,
                next: null
              }), Ee === S1 && (be = !0);
            else if ((dh & he) === he) {
              ne = ne.next, he === S1 && (be = !0);
              continue;
            } else
              Ee = {
                lane: 0,
                revertLane: ne.revertLane,
                gesture: null,
                action: ne.action,
                hasEagerState: ne.hasEagerState,
                eagerState: ne.eagerState,
                next: null
              }, Q === null ? (L = Q = Ee, j = E) : Q = Q.next = Ee, rn.lanes |= he, a0 |= he;
            Ee = ne.action, T1 && h(E, Ee), E = ne.hasEagerState ? ne.eagerState : h(E, Ee);
          } else
            he = {
              lane: Ee,
              revertLane: ne.revertLane,
              gesture: ne.gesture,
              action: ne.action,
              hasEagerState: ne.hasEagerState,
              eagerState: ne.eagerState,
              next: null
            }, Q === null ? (L = Q = he, j = E) : Q = Q.next = he, rn.lanes |= Ee, a0 |= Ee;
          ne = ne.next;
        } while (ne !== null && ne !== l);
        if (Q === null ? j = E : Q.next = L, !xs(E, o.memoizedState) && (xa = !0, be && (h = Fy, h !== null)))
          throw h;
        o.memoizedState = E, o.baseState = j, o.baseQueue = Q, y.lastRenderedState = E;
      }
      return S === null && (y.lanes = 0), [o.memoizedState, y.dispatch];
    }
    function Mf(o) {
      var l = fr(), h = l.queue;
      if (h === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      h.lastRenderedReducer = o;
      var y = h.dispatch, S = h.pending, E = l.memoizedState;
      if (S !== null) {
        h.pending = null;
        var j = S = S.next;
        do
          E = o(E, j.action), j = j.next;
        while (j !== S);
        xs(E, l.memoizedState) || (xa = !0), l.memoizedState = E, l.baseQueue === null && (l.baseState = E), h.lastRenderedState = E;
      }
      return [E, y];
    }
    function ap(o, l, h) {
      var y = rn, S = qi();
      if (Fn) {
        if (h === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var E = h();
        qy || E === h() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), qy = !0);
      } else {
        if (E = l(), qy || (h = l(), xs(E, h) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), qy = !0)), Hr === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        xn & 127 || s2(y, l, E);
      }
      return S.memoizedState = E, h = { value: E, getSnapshot: l }, S.queue = h, jf(
        hd.bind(null, y, h, o),
        [o]
      ), y.flags |= 2048, lc(
        jc | _s,
        { destroy: void 0 },
        l2.bind(
          null,
          y,
          h,
          E,
          l
        ),
        null
      ), E;
    }
    function If(o, l, h) {
      var y = rn, S = fr(), E = Fn;
      if (E) {
        if (h === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        h = h();
      } else if (h = l(), !qy) {
        var j = l();
        xs(h, j) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), qy = !0);
      }
      (j = !xs(
        ($r || S).memoizedState,
        h
      )) && (S.memoizedState = h, xa = !0), S = S.queue;
      var L = hd.bind(null, y, S, o);
      if (Qi(2048, _s, L, [o]), S.getSnapshot !== l || j || wa !== null && wa.memoizedState.tag & jc) {
        if (y.flags |= 2048, lc(
          jc | _s,
          { destroy: void 0 },
          l2.bind(
            null,
            y,
            S,
            h,
            l
          ),
          null
        ), Hr === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        E || dh & 127 || s2(y, l, h);
      }
      return h;
    }
    function s2(o, l, h) {
      o.flags |= 16384, o = { getSnapshot: l, value: h }, l = rn.updateQueue, l === null ? (l = Em(), rn.updateQueue = l, l.stores = [o]) : (h = l.stores, h === null ? l.stores = [o] : h.push(o));
    }
    function l2(o, l, h, y) {
      l.value = h, l.getSnapshot = y, pd(l) && c2(o);
    }
    function hd(o, l, h) {
      return h(function() {
        pd(l) && (nc(2, "updateSyncExternalStore()", o), c2(o));
      });
    }
    function pd(o) {
      var l = o.getSnapshot;
      o = o.value;
      try {
        var h = l();
        return !xs(o, h);
      } catch {
        return !0;
      }
    }
    function c2(o) {
      var l = Wa(o, 2);
      l !== null && Kt(l, o, 2);
    }
    function mv(o) {
      var l = qi();
      if (typeof o == "function") {
        var h = o;
        if (o = h(), T1) {
          se(!0);
          try {
            h();
          } finally {
            se(!1);
          }
        }
      }
      return l.memoizedState = l.baseState = o, l.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: us,
        lastRenderedState: o
      }, l;
    }
    function md(o) {
      o = mv(o);
      var l = o.queue, h = xv.bind(null, rn, l);
      return l.dispatch = h, [o.memoizedState, h];
    }
    function kf(o) {
      var l = qi();
      l.memoizedState = l.baseState = o;
      var h = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return l.queue = h, l = Nm.bind(
        null,
        rn,
        !0,
        h
      ), h.dispatch = l, [o, l];
    }
    function Am(o, l) {
      var h = fr();
      return op(h, $r, o, l);
    }
    function op(o, l, h, y) {
      return o.baseState = h, fd(
        o,
        $r,
        typeof y == "function" ? y : us
      );
    }
    function Cm(o, l) {
      var h = fr();
      return $r !== null ? op(h, $r, o, l) : (h.baseState = o, [o, h.queue.dispatch]);
    }
    function p3(o, l, h, y, S) {
      if (pa(o))
        throw Error("Cannot update form state while rendering.");
      if (o = l.action, o !== null) {
        var E = {
          payload: S,
          action: o,
          next: null,
          isTransition: !0,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(j) {
            E.listeners.push(j);
          }
        };
        ze.T !== null ? h(!0) : E.isTransition = !1, y(E), h = l.pending, h === null ? (E.next = l.pending = E, gd(l, E)) : (E.next = h.next, l.pending = h.next = E);
      }
    }
    function gd(o, l) {
      var h = l.action, y = l.payload, S = o.state;
      if (l.isTransition) {
        var E = ze.T, j = {};
        j._updatedFibers = /* @__PURE__ */ new Set(), ze.T = j;
        try {
          var L = h(S, y), Q = ze.S;
          Q !== null && Q(j, L), u2(o, l, L);
        } catch (ne) {
          Tm(o, l, ne);
        } finally {
          E !== null && j.types !== null && (E.types !== null && E.types !== j.types && console.error(
            "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
          ), E.types = j.types), ze.T = E, E === null && j._updatedFibers && (o = j._updatedFibers.size, j._updatedFibers.clear(), 10 < o && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          ));
        }
      } else
        try {
          j = h(S, y), u2(o, l, j);
        } catch (ne) {
          Tm(o, l, ne);
        }
    }
    function u2(o, l, h) {
      h !== null && typeof h == "object" && typeof h.then == "function" ? (ze.asyncTransitions++, h.then(Pf, Pf), h.then(
        function(y) {
          hu(o, l, y);
        },
        function(y) {
          return Tm(o, l, y);
        }
      ), l.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : hu(o, l, h);
    }
    function hu(o, l, h) {
      l.status = "fulfilled", l.value = h, gv(l), o.state = h, l = o.pending, l !== null && (h = l.next, h === l ? o.pending = null : (h = h.next, l.next = h, gd(o, h)));
    }
    function Tm(o, l, h) {
      var y = o.pending;
      if (o.pending = null, y !== null) {
        y = y.next;
        do
          l.status = "rejected", l.reason = h, gv(l), l = l.next;
        while (l !== y);
      }
      o.action = null;
    }
    function gv(o) {
      o = o.listeners;
      for (var l = 0; l < o.length; l++)
        (0, o[l])();
    }
    function pu(o, l) {
      return l;
    }
    function ds(o, l) {
      if (Fn) {
        var h = Hr.formState;
        if (h !== null) {
          e: {
            var y = rn;
            if (Fn) {
              if (ii) {
                t: {
                  for (var S = ii, E = Mc; S.nodeType !== 8; ) {
                    if (!E) {
                      S = null;
                      break t;
                    }
                    if (S = vs(
                      S.nextSibling
                    ), S === null) {
                      S = null;
                      break t;
                    }
                  }
                  E = S.data, S = E === QR || E === Vj ? S : null;
                }
                if (S) {
                  ii = vs(
                    S.nextSibling
                  ), y = S.data === QR;
                  break e;
                }
              }
              Vs(y);
            }
            y = !1;
          }
          y && (l = h[0]);
        }
      }
      return h = qi(), h.memoizedState = h.baseState = l, y = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: pu,
        lastRenderedState: l
      }, h.queue = y, h = xv.bind(
        null,
        rn,
        y
      ), y.dispatch = h, y = mv(!1), E = Nm.bind(
        null,
        rn,
        !1,
        y.queue
      ), y = qi(), S = {
        state: l,
        dispatch: null,
        action: o,
        pending: null
      }, y.queue = S, h = p3.bind(
        null,
        rn,
        S,
        E,
        h
      ), S.dispatch = h, y.memoizedState = o, [l, h, !1];
    }
    function vd(o) {
      var l = fr();
      return vv(l, $r, o);
    }
    function vv(o, l, h) {
      if (l = fd(
        o,
        l,
        pu
      )[0], o = Nf(us)[0], typeof l == "object" && l !== null && typeof l.then == "function")
        try {
          var y = _m(l);
        } catch (j) {
          throw j === Vy ? jA : j;
        }
      else
        y = l;
      l = fr();
      var S = l.queue, E = S.dispatch;
      return h !== l.memoizedState && (rn.flags |= 2048, lc(
        jc | _s,
        { destroy: void 0 },
        d2.bind(null, S, h),
        null
      )), [y, E, o];
    }
    function d2(o, l) {
      o.action = l;
    }
    function yd(o) {
      var l = fr(), h = $r;
      if (h !== null)
        return vv(l, h, o);
      fr(), l = l.memoizedState, h = fr();
      var y = h.queue.dispatch;
      return h.memoizedState = o, [l, y, !1];
    }
    function lc(o, l, h, y) {
      return o = { tag: o, create: h, deps: y, inst: l, next: null }, l = rn.updateQueue, l === null && (l = Em(), rn.updateQueue = l), h = l.lastEffect, h === null ? l.lastEffect = o.next = o : (y = h.next, h.next = o, o.next = y, l.lastEffect = o), o;
    }
    function yv(o) {
      var l = qi();
      return o = { current: o }, l.memoizedState = o;
    }
    function bd(o, l, h, y) {
      var S = qi();
      rn.flags |= o, S.memoizedState = lc(
        jc | l,
        { destroy: void 0 },
        h,
        y === void 0 ? null : y
      );
    }
    function Qi(o, l, h, y) {
      var S = fr();
      y = y === void 0 ? null : y;
      var E = S.memoizedState.inst;
      $r !== null && y !== null && a2(y, $r.memoizedState.deps) ? S.memoizedState = lc(l, E, h, y) : (rn.flags |= o, S.memoizedState = lc(
        jc | l,
        E,
        h,
        y
      ));
    }
    function jf(o, l) {
      (rn.mode & Cu) !== Wt ? bd(276826112, _s, o, l) : bd(8390656, _s, o, l);
    }
    function m3(o) {
      rn.flags |= 4;
      var l = rn.updateQueue;
      if (l === null)
        l = Em(), rn.updateQueue = l, l.events = [o];
      else {
        var h = l.events;
        h === null ? l.events = [o] : h.push(o);
      }
    }
    function Om(o) {
      var l = qi(), h = { impl: o };
      return l.memoizedState = h, function() {
        if ((Zn & ka) !== no)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return h.impl.apply(void 0, arguments);
      };
    }
    function sp(o) {
      var l = fr().memoizedState;
      return m3({ ref: l, nextImpl: o }), function() {
        if ((Zn & ka) !== no)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return l.impl.apply(void 0, arguments);
      };
    }
    function bo(o, l) {
      var h = 4194308;
      return (rn.mode & Cu) !== Wt && (h |= 134217728), bd(h, Fl, o, l);
    }
    function fs(o, l) {
      if (typeof l == "function") {
        o = o();
        var h = l(o);
        return function() {
          typeof h == "function" ? h() : l(null);
        };
      }
      if (l != null)
        return l.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(l).join(", ") + "}"
        ), o = o(), l.current = o, function() {
          l.current = null;
        };
    }
    function cc(o, l, h) {
      typeof l != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        l !== null ? typeof l : "null"
      ), h = h != null ? h.concat([o]) : null;
      var y = 4194308;
      (rn.mode & Cu) !== Wt && (y |= 134217728), bd(
        y,
        Fl,
        fs.bind(null, l, o),
        h
      );
    }
    function lp(o, l, h) {
      typeof l != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        l !== null ? typeof l : "null"
      ), h = h != null ? h.concat([o]) : null, Qi(
        4,
        Fl,
        fs.bind(null, l, o),
        h
      );
    }
    function bv(o, l) {
      return qi().memoizedState = [
        o,
        l === void 0 ? null : l
      ], o;
    }
    function Cl(o, l) {
      var h = fr();
      l = l === void 0 ? null : l;
      var y = h.memoizedState;
      return l !== null && a2(l, y[1]) ? y[0] : (h.memoizedState = [o, l], o);
    }
    function wo(o, l) {
      var h = qi();
      l = l === void 0 ? null : l;
      var y = o();
      if (T1) {
        se(!0);
        try {
          o();
        } finally {
          se(!1);
        }
      }
      return h.memoizedState = [y, l], y;
    }
    function ei(o, l) {
      var h = fr();
      l = l === void 0 ? null : l;
      var y = h.memoizedState;
      if (l !== null && a2(l, y[1]))
        return y[0];
      if (y = o(), T1) {
        se(!0);
        try {
          o();
        } finally {
          se(!1);
        }
      }
      return h.memoizedState = [y, l], y;
    }
    function cp(o, l) {
      var h = qi();
      return hr(h, o, l);
    }
    function uc(o, l) {
      var h = fr();
      return ki(
        h,
        $r.memoizedState,
        o,
        l
      );
    }
    function cn(o, l) {
      var h = fr();
      return $r === null ? hr(h, o, l) : ki(
        h,
        $r.memoizedState,
        o,
        l
      );
    }
    function hr(o, l, h) {
      return h === void 0 || dh & 1073741824 && !(xn & 261930) ? o.memoizedState = l : (o.memoizedState = h, o = vp(), rn.lanes |= o, a0 |= o, h);
    }
    function ki(o, l, h, y) {
      return xs(h, l) ? h : $y.current !== null ? (o = hr(o, h, y), xs(o, l) || (xa = !0), o) : !(dh & 42) || dh & 1073741824 && !(xn & 261930) ? (xa = !0, o.memoizedState = h) : (o = vp(), rn.lanes |= o, a0 |= o, l);
    }
    function Pf() {
      ze.asyncTransitions--;
    }
    function Lf(o, l, h, y, S) {
      var E = ur.p;
      ur.p = E !== 0 && E < Ma ? E : Ma;
      var j = ze.T, L = {};
      L._updatedFibers = /* @__PURE__ */ new Set(), ze.T = L, Nm(o, !1, l, h);
      try {
        var Q = S(), ne = ze.S;
        if (ne !== null && ne(L, Q), Q !== null && typeof Q == "object" && typeof Q.then == "function") {
          ze.asyncTransitions++, Q.then(Pf, Pf);
          var be = uv(
            Q,
            y
          );
          Bf(
            o,
            l,
            be,
            Za(o)
          );
        } else
          Bf(
            o,
            l,
            y,
            Za(o)
          );
      } catch (Ee) {
        Bf(
          o,
          l,
          { then: function() {
          }, status: "rejected", reason: Ee },
          Za(o)
        );
      } finally {
        ur.p = E, j !== null && L.types !== null && (j.types !== null && j.types !== L.types && console.error(
          "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
        ), j.types = L.types), ze.T = j, j === null && L._updatedFibers && (o = L._updatedFibers.size, L._updatedFibers.clear(), 10 < o && console.warn(
          "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
        ));
      }
    }
    function mu(o, l, h, y) {
      if (o.tag !== 5)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var S = Rm(o).queue;
      f3(o), Lf(
        o,
        S,
        l,
        B1,
        h === null ? f : function() {
          return up(o), h(y);
        }
      );
    }
    function Rm(o) {
      var l = o.memoizedState;
      if (l !== null)
        return l;
      l = {
        memoizedState: B1,
        baseState: B1,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: us,
          lastRenderedState: B1
        },
        next: null
      };
      var h = {};
      return l.next = {
        memoizedState: h,
        baseState: h,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: us,
          lastRenderedState: h
        },
        next: null
      }, o.memoizedState = l, o = o.alternate, o !== null && (o.memoizedState = l), l;
    }
    function up(o) {
      ze.T === null && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var l = Rm(o);
      l.next === null && (l = o.alternate.memoizedState), Bf(
        o,
        l.next.queue,
        {},
        Za(o)
      );
    }
    function wd() {
      var o = mv(!1);
      return o = Lf.bind(
        null,
        rn,
        o.queue,
        !0,
        !1
      ), qi().memoizedState = o, [!1, o];
    }
    function g3() {
      var o = Nf(us)[0], l = fr().memoizedState;
      return [
        typeof o == "boolean" ? o : _m(o),
        l
      ];
    }
    function ci() {
      var o = Mf(us)[0], l = fr().memoizedState;
      return [
        typeof o == "boolean" ? o : _m(o),
        l
      ];
    }
    function gu() {
      return lr(yS);
    }
    function Dm() {
      var o = qi(), l = Hr.identifierPrefix;
      if (Fn) {
        var h = oh, y = ah;
        h = (y & ~(1 << 32 - Na(y) - 1)).toString(32) + h, l = "_" + l + "R_" + h, h = FA++, 0 < h && (l += "H" + h.toString(32)), l += "_";
      } else
        h = Ute++, l = "_" + l + "r_" + h.toString(32) + "_";
      return o.memoizedState = l;
    }
    function wv() {
      return qi().memoizedState = v3.bind(
        null,
        rn
      );
    }
    function v3(o, l) {
      for (var h = o.return; h !== null; ) {
        switch (h.tag) {
          case 24:
          case 3:
            var y = Za(h), S = Wi(y), E = ac(h, S, y);
            E !== null && (nc(y, "refresh()", o), Kt(E, h, y), Gs(E, h, y)), o = lv(), l != null && E !== null && console.error(
              "The seed argument is not enabled outside experimental channels."
            ), S.payload = { cache: o };
            return;
        }
        h = h.return;
      }
    }
    function zO(o, l, h) {
      var y = arguments;
      typeof y[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), y = Za(o);
      var S = {
        lane: y,
        revertLane: 0,
        gesture: null,
        action: h,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      pa(o) ? Oi(l, S) : (S = bf(o, l, S, y), S !== null && (nc(y, "dispatch()", o), Kt(S, o, y), Mm(S, l, y)));
    }
    function xv(o, l, h) {
      var y = arguments;
      typeof y[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), y = Za(o), Bf(o, l, h, y) && nc(y, "setState()", o);
    }
    function Bf(o, l, h, y) {
      var S = {
        lane: y,
        revertLane: 0,
        gesture: null,
        action: h,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (pa(o))
        Oi(l, S);
      else {
        var E = o.alternate;
        if (o.lanes === 0 && (E === null || E.lanes === 0) && (E = l.lastRenderedReducer, E !== null)) {
          var j = ze.H;
          ze.H = Ou;
          try {
            var L = l.lastRenderedState, Q = E(L, h);
            if (S.hasEagerState = !0, S.eagerState = Q, xs(Q, L))
              return Wh(o, l, S, 0), Hr === null && nv(), !1;
          } catch {
          } finally {
            ze.H = j;
          }
        }
        if (h = bf(o, l, S, y), h !== null)
          return Kt(h, o, y), Mm(h, l, y), !0;
      }
      return !1;
    }
    function Nm(o, l, h, y) {
      if (ze.T === null && S1 === 0 && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      ), y = {
        lane: 2,
        revertLane: K2(),
        gesture: null,
        action: y,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, pa(o)) {
        if (l)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        l = bf(
          o,
          h,
          y,
          2
        ), l !== null && (nc(2, "setOptimistic()", o), Kt(l, o, 2));
    }
    function pa(o) {
      var l = o.alternate;
      return o === rn || l !== null && l === rn;
    }
    function Oi(o, l) {
      Gy = zA = !0;
      var h = o.pending;
      h === null ? l.next = l : (l.next = h.next, h.next = l), o.pending = l;
    }
    function Mm(o, l, h) {
      if (h & 4194048) {
        var y = l.lanes;
        y &= o.pendingLanes, h |= y, l.lanes = h, hn(o, h);
      }
    }
    function zf(o) {
      if (o !== null && typeof o != "function") {
        var l = String(o);
        hj.has(l) || (hj.add(l), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          o
        ));
      }
    }
    function dp(o, l, h, y) {
      var S = o.memoizedState, E = h(y, S);
      if (o.mode & Yo) {
        se(!0);
        try {
          E = h(y, S);
        } finally {
          se(!1);
        }
      }
      E === void 0 && (l = $(l) || "Component", cj.has(l) || (cj.add(l), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        l
      ))), S = E == null ? S : yn({}, S, E), o.memoizedState = S, o.lanes === 0 && (o.updateQueue.baseState = S);
    }
    function Sv(o, l, h, y, S, E, j) {
      var L = o.stateNode;
      if (typeof L.shouldComponentUpdate == "function") {
        if (h = L.shouldComponentUpdate(
          y,
          E,
          j
        ), o.mode & Yo) {
          se(!0);
          try {
            h = L.shouldComponentUpdate(
              y,
              E,
              j
            );
          } finally {
            se(!1);
          }
        }
        return h === void 0 && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          $(l) || "Component"
        ), h;
      }
      return l.prototype && l.prototype.isPureReactComponent ? !Xh(h, y) || !Xh(S, E) : !0;
    }
    function dc(o, l, h, y) {
      var S = l.state;
      typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(h, y), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(h, y), l.state !== S && (o = H(o) || "Component", ij.has(o) || (ij.add(o), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        o
      )), OR.enqueueReplaceState(
        l,
        l.state,
        null
      ));
    }
    function fc(o, l) {
      var h = l;
      if ("ref" in l) {
        h = {};
        for (var y in l)
          y !== "ref" && (h[y] = l[y]);
      }
      if (o = o.defaultProps) {
        h === l && (h = yn({}, h));
        for (var S in o)
          h[S] === void 0 && (h[S] = o[S]);
      }
      return h;
    }
    function Ev(o) {
      iR(o), console.warn(
        `%s

%s
`,
        Yy ? "An error occurred in the <" + Yy + "> component." : "An error occurred in one of your React components.",
        `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://react.dev/link/error-boundaries to learn more about error boundaries.`
      );
    }
    function _v(o) {
      var l = Yy ? "The above error occurred in the <" + Yy + "> component." : "The above error occurred in one of your React components.", h = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((RR || "Anonymous") + ".");
      if (typeof o == "object" && o !== null && typeof o.environmentName == "string") {
        var y = o.environmentName;
        o = [
          `%o

%s

%s
`,
          o,
          l,
          h
        ].slice(0), typeof o[0] == "string" ? o.splice(
          0,
          1,
          Wj + " " + o[0],
          Qj,
          dC + y + dC,
          Zj
        ) : o.splice(
          0,
          0,
          Wj,
          Qj,
          dC + y + dC,
          Zj
        ), o.unshift(console), y = cne.apply(console.error, o), y();
      } else
        console.error(
          `%o

%s

%s
`,
          o,
          l,
          h
        );
    }
    function f2(o) {
      iR(o);
    }
    function Im(o, l) {
      try {
        Yy = l.source ? H(l.source) : null, RR = null;
        var h = l.value;
        if (ze.actQueue !== null)
          ze.thrownErrors.push(h);
        else {
          var y = o.onUncaughtError;
          y(h, { componentStack: l.stack });
        }
      } catch (S) {
        setTimeout(function() {
          throw S;
        });
      }
    }
    function h2(o, l, h) {
      try {
        Yy = h.source ? H(h.source) : null, RR = H(l);
        var y = o.onCaughtError;
        y(h.value, {
          componentStack: h.stack,
          errorBoundary: l.tag === 1 ? l.stateNode : null
        });
      } catch (S) {
        setTimeout(function() {
          throw S;
        });
      }
    }
    function Av(o, l, h) {
      return h = Wi(h), h.tag = SR, h.payload = { element: null }, h.callback = function() {
        Ce(l.source, Im, o, l);
      }, h;
    }
    function Cv(o) {
      return o = Wi(o), o.tag = SR, o;
    }
    function Tv(o, l, h, y) {
      var S = h.type.getDerivedStateFromError;
      if (typeof S == "function") {
        var E = y.value;
        o.payload = function() {
          return S(E);
        }, o.callback = function() {
          wf(h), Ce(
            y.source,
            h2,
            l,
            h,
            y
          );
        };
      }
      var j = h.stateNode;
      j !== null && typeof j.componentDidCatch == "function" && (o.callback = function() {
        wf(h), Ce(
          y.source,
          h2,
          l,
          h,
          y
        ), typeof S != "function" && (s0 === null ? s0 = /* @__PURE__ */ new Set([this]) : s0.add(this)), Bte(this, y), typeof S == "function" || !(h.lanes & 2) && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          H(h) || "Unknown"
        );
      });
    }
    function p2(o, l, h, y, S) {
      if (h.flags |= 32768, Ac && Sp(o, S), y !== null && typeof y == "object" && typeof y.then == "function") {
        if (l = h.alternate, l !== null && xl(
          l,
          h,
          S,
          !0
        ), Fn && (Pd = !0), h = zl.current, h !== null) {
          switch (h.tag) {
            case 31:
            case 13:
              return kc === null ? bp() : h.alternate === null && Di === mh && (Di = $A), h.flags &= -257, h.flags |= 65536, h.lanes = S, y === PA ? h.flags |= 16384 : (l = h.updateQueue, l === null ? h.updateQueue = /* @__PURE__ */ new Set([y]) : l.add(y), Yv(o, y, S)), !1;
            case 22:
              return h.flags |= 65536, y === PA ? h.flags |= 16384 : (l = h.updateQueue, l === null ? (l = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([y])
              }, h.updateQueue = l) : (h = l.retryQueue, h === null ? l.retryQueue = /* @__PURE__ */ new Set([y]) : h.add(y)), Yv(o, y, S)), !1;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + h.tag + "). This is a bug in React."
          );
        }
        return Yv(o, y, S), bp(), !1;
      }
      if (Fn)
        return Pd = !0, l = zl.current, l !== null ? (!(l.flags & 65536) && (l.flags |= 256), l.flags |= 65536, l.lanes = S, y !== uR && fm(
          po(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: y }
            ),
            h
          )
        )) : (y !== uR && fm(
          po(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: y }
            ),
            h
          )
        ), o = o.current.alternate, o.flags |= 65536, S &= -S, o.lanes |= S, y = po(y, h), S = Av(
          o.stateNode,
          y,
          S
        ), ym(o, S), Di !== r0 && (Di = O1)), !1;
      var E = po(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: y }
        ),
        h
      );
      if (cS === null ? cS = [E] : cS.push(E), Di !== r0 && (Di = O1), l === null)
        return !0;
      y = po(y, h), h = l;
      do {
        switch (h.tag) {
          case 3:
            return h.flags |= 65536, o = S & -S, h.lanes |= o, o = Av(
              h.stateNode,
              y,
              o
            ), ym(h, o), !1;
          case 1:
            if (l = h.type, E = h.stateNode, (h.flags & 128) === 0 && (typeof l.getDerivedStateFromError == "function" || E !== null && typeof E.componentDidCatch == "function" && (s0 === null || !s0.has(E))))
              return h.flags |= 65536, S &= -S, h.lanes |= S, S = Cv(S), Tv(
                S,
                o,
                h,
                y
              ), ym(h, S), !1;
        }
        h = h.return;
      } while (h !== null);
      return !1;
    }
    function ma(o, l, h, y) {
      l.child = o === null ? Y9(l, null, h, y) : C1(
        l,
        o.child,
        h,
        y
      );
    }
    function y3(o, l, h, y, S) {
      h = h.render;
      var E = l.ref;
      if ("ref" in y) {
        var j = {};
        for (var L in y)
          L !== "ref" && (j[L] = y[L]);
      } else
        j = y;
      return cd(l), y = o2(
        o,
        l,
        h,
        j,
        E,
        S
      ), L = Df(), o !== null && !xa ? (Sm(o, l, S), Tl(o, l, S)) : (Fn && L && av(l), l.flags |= 1, ma(o, l, y, S), l.child);
    }
    function m2(o, l, h, y, S) {
      if (o === null) {
        var E = h.type;
        return typeof E == "function" && !Yw(E) && E.defaultProps === void 0 && h.compare === null ? (h = id(E), l.tag = 15, l.type = h, fp(l, E), g2(
          o,
          l,
          h,
          y,
          S
        )) : (o = xf(
          h.type,
          null,
          y,
          l,
          l.mode,
          S
        ), o.ref = l.ref, o.return = l, l.child = o);
      }
      if (E = o.child, !Mv(o, S)) {
        var j = E.memoizedProps;
        if (h = h.compare, h = h !== null ? h : Xh, h(j, y) && o.ref === l.ref)
          return Tl(
            o,
            l,
            S
          );
      }
      return l.flags |= 1, o = tc(E, y), o.ref = l.ref, o.return = l, l.child = o;
    }
    function g2(o, l, h, y, S) {
      if (o !== null) {
        var E = o.memoizedProps;
        if (Xh(E, y) && o.ref === l.ref && l.type === o.type)
          if (xa = !1, l.pendingProps = y = E, Mv(o, S))
            o.flags & 131072 && (xa = !0);
          else
            return l.lanes = o.lanes, Tl(o, l, S);
      }
      return w2(
        o,
        l,
        h,
        y,
        S
      );
    }
    function v2(o, l, h, y) {
      var S = y.children, E = o !== null ? o.memoizedState : null;
      if (o === null && l.stateNode === null && (l.stateNode = {
        _visibility: Bx,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }), y.mode === "hidden") {
        if (l.flags & 128) {
          if (E = E !== null ? E.baseLanes | h : h, o !== null) {
            for (y = l.child = o.child, S = 0; y !== null; )
              S = S | y.lanes | y.childLanes, y = y.sibling;
            y = S & ~E;
          } else
            y = 0, l.child = null;
          return y2(
            o,
            l,
            E,
            h,
            y
          );
        }
        if (h & 536870912)
          l.memoizedState = { baseLanes: 0, cachePool: null }, o !== null && ep(
            l,
            E !== null ? E.cachePool : null
          ), E !== null ? hv(l, E) : uu(l), pv(l);
        else
          return y = l.lanes = 536870912, y2(
            o,
            l,
            E !== null ? E.baseLanes | h : h,
            h,
            y
          );
      } else
        E !== null ? (ep(l, E.cachePool), hv(l, E), sc(l), l.memoizedState = null) : (o !== null && ep(l, null), uu(l), sc(l));
      return ma(o, l, S, h), l.child;
    }
    function Ff(o, l) {
      return o !== null && o.tag === 22 || l.stateNode !== null || (l.stateNode = {
        _visibility: Bx,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }), l.sibling;
    }
    function y2(o, l, h, y, S) {
      var E = cu();
      return E = E === null ? null : {
        parent: ya._currentValue,
        pool: E
      }, l.memoizedState = {
        baseLanes: h,
        cachePool: E
      }, o !== null && ep(l, null), uu(l), pv(l), o !== null && xl(o, l, y, !0), l.childLanes = S, null;
    }
    function km(o, l) {
      var h = l.hidden;
      return h !== void 0 && console.error(
        `<Activity> doesn't accept a hidden prop. Use mode="hidden" instead.
- <Activity %s>
+ <Activity %s>`,
        h === !0 ? "hidden" : h === !1 ? "hidden={false}" : "hidden={...}",
        h ? 'mode="hidden"' : 'mode="visible"'
      ), l = Pm(
        { mode: l.mode, children: l.children },
        o.mode
      ), l.ref = o.ref, o.child = l, l.return = o, l;
    }
    function b2(o, l, h) {
      return C1(l, o.child, null, h), o = km(
        l,
        l.pendingProps
      ), o.flags |= 2, ha(l), l.memoizedState = null, o;
    }
    function b3(o, l, h) {
      var y = l.pendingProps, S = (l.flags & 128) !== 0;
      if (l.flags &= -129, o === null) {
        if (Fn) {
          if (y.mode === "hidden")
            return o = km(l, y), l.lanes = 536870912, Ff(null, o);
          if (Al(l), (o = ii) ? (h = mr(
            o,
            Mc
          ), h = h !== null && h.data === k1 ? h : null, h !== null && (y = {
            dehydrated: h,
            treeContext: c3(),
            retryLane: 536870912,
            hydrationErrors: null
          }, l.memoizedState = y, y = Ww(h), y.return = l, l.child = y, Ro = l, ii = null)) : h = null, h === null)
            throw Qa(l, o), Vs(l);
          return l.lanes = 536870912, null;
        }
        return km(l, y);
      }
      var E = o.memoizedState;
      if (E !== null) {
        var j = E.dehydrated;
        if (Al(l), S)
          if (l.flags & 256)
            l.flags &= -257, l = b2(
              o,
              l,
              h
            );
          else if (l.memoizedState !== null)
            l.child = o.child, l.flags |= 128, l = null;
          else
            throw Error(
              "Client rendering an Activity suspended it again. This is a bug in React."
            );
        else if (d3(), h & 536870912 && yp(l), xa || xl(
          o,
          l,
          h,
          !1
        ), S = (h & o.childLanes) !== 0, xa || S) {
          if (y = Hr, y !== null && (j = Wn(
            y,
            h
          ), j !== 0 && j !== E.retryLane))
            throw E.retryLane = j, Wa(o, j), Kt(y, o, j), DR;
          bp(), l = b2(
            o,
            l,
            h
          );
        } else
          o = E.treeContext, ii = vs(
            j.nextSibling
          ), Ro = l, Fn = !0, Zp = null, Pd = !1, Bl = null, Mc = !1, o !== null && u3(l, o), l = km(l, y), l.flags |= 4096;
        return l;
      }
      return E = o.child, y = { mode: y.mode, children: y.children }, h & 536870912 && h & o.lanes && yp(l), o = tc(E, y), o.ref = l.ref, l.child = o, o.return = l, o;
    }
    function jm(o, l) {
      var h = l.ref;
      if (h === null)
        o !== null && o.ref !== null && (l.flags |= 4194816);
      else {
        if (typeof h != "function" && typeof h != "object")
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        (o === null || o.ref !== h) && (l.flags |= 4194816);
      }
    }
    function w2(o, l, h, y, S) {
      if (h.prototype && typeof h.prototype.render == "function") {
        var E = $(h) || "Unknown";
        pj[E] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          E,
          E
        ), pj[E] = !0);
      }
      return l.mode & Yo && Tu.recordLegacyContextWarning(
        l,
        null
      ), o === null && (fp(l, l.type), h.contextTypes && (E = $(h) || "Unknown", gj[E] || (gj[E] = !0, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        E
      )))), cd(l), h = o2(
        o,
        l,
        h,
        y,
        void 0,
        S
      ), y = Df(), o !== null && !xa ? (Sm(o, l, S), Tl(o, l, S)) : (Fn && y && av(l), l.flags |= 1, ma(o, l, h, S), l.child);
    }
    function x2(o, l, h, y, S, E) {
      return cd(l), hh = -1, nS = o !== null && o.type !== l.type, l.updateQueue = null, h = wm(
        l,
        y,
        h,
        S
      ), Ii(o, l), y = Df(), o !== null && !xa ? (Sm(o, l, E), Tl(o, l, E)) : (Fn && y && av(l), l.flags |= 1, ma(o, l, h, E), l.child);
    }
    function Vf(o, l, h, y, S) {
      switch (s(l)) {
        case !1:
          var E = l.stateNode, j = new l.type(
            l.memoizedProps,
            E.context
          ).state;
          E.updater.enqueueSetState(E, j, null);
          break;
        case !0:
          l.flags |= 128, l.flags |= 65536, E = Error("Simulated error coming from DevTools");
          var L = S & -S;
          if (l.lanes |= L, j = Hr, j === null)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          L = Cv(L), Tv(
            L,
            j,
            l,
            po(E, l)
          ), ym(l, L);
      }
      if (cd(l), l.stateNode === null) {
        if (j = Qp, E = h.contextType, "contextType" in h && E !== null && (E === void 0 || E.$$typeof !== jl) && !fj.has(h) && (fj.add(h), L = E === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof E != "object" ? " However, it is set to a " + typeof E + "." : E.$$typeof === my ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(E).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          $(h) || "Component",
          L
        )), typeof E == "object" && E !== null && (j = lr(E)), E = new h(y, j), l.mode & Yo) {
          se(!0);
          try {
            E = new h(y, j);
          } finally {
            se(!1);
          }
        }
        if (j = l.memoizedState = E.state !== null && E.state !== void 0 ? E.state : null, E.updater = OR, l.stateNode = E, E._reactInternals = l, E._reactInternalInstance = rj, typeof h.getDerivedStateFromProps == "function" && j === null && (j = $(h) || "Component", aj.has(j) || (aj.add(j), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          j,
          E.state === null ? "null" : "undefined",
          j
        ))), typeof h.getDerivedStateFromProps == "function" || typeof E.getSnapshotBeforeUpdate == "function") {
          var Q = L = j = null;
          if (typeof E.componentWillMount == "function" && E.componentWillMount.__suppressDeprecationWarning !== !0 ? j = "componentWillMount" : typeof E.UNSAFE_componentWillMount == "function" && (j = "UNSAFE_componentWillMount"), typeof E.componentWillReceiveProps == "function" && E.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? L = "componentWillReceiveProps" : typeof E.UNSAFE_componentWillReceiveProps == "function" && (L = "UNSAFE_componentWillReceiveProps"), typeof E.componentWillUpdate == "function" && E.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Q = "componentWillUpdate" : typeof E.UNSAFE_componentWillUpdate == "function" && (Q = "UNSAFE_componentWillUpdate"), j !== null || L !== null || Q !== null) {
            E = $(h) || "Component";
            var ne = typeof h.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            sj.has(E) || (sj.add(E), console.error(
              `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
              E,
              ne,
              j !== null ? `
  ` + j : "",
              L !== null ? `
  ` + L : "",
              Q !== null ? `
  ` + Q : ""
            ));
          }
        }
        E = l.stateNode, j = $(h) || "Component", E.render || (h.prototype && typeof h.prototype.render == "function" ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          j
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          j
        )), !E.getInitialState || E.getInitialState.isReactClassApproved || E.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          j
        ), E.getDefaultProps && !E.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          j
        ), E.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          j
        ), h.childContextTypes && !dj.has(h) && (dj.add(h), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          j
        )), h.contextTypes && !uj.has(h) && (uj.add(h), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          j
        )), typeof E.componentShouldUpdate == "function" && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          j
        ), h.prototype && h.prototype.isPureReactComponent && typeof E.shouldComponentUpdate < "u" && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          $(h) || "A pure component"
        ), typeof E.componentDidUnmount == "function" && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          j
        ), typeof E.componentDidReceiveProps == "function" && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          j
        ), typeof E.componentWillRecieveProps == "function" && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          j
        ), typeof E.UNSAFE_componentWillRecieveProps == "function" && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          j
        ), L = E.props !== y, E.props !== void 0 && L && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          j
        ), E.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          j,
          j
        ), typeof E.getSnapshotBeforeUpdate != "function" || typeof E.componentDidUpdate == "function" || oj.has(h) || (oj.add(h), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          $(h)
        )), typeof E.getDerivedStateFromProps == "function" && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          j
        ), typeof E.getDerivedStateFromError == "function" && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          j
        ), typeof h.getSnapshotBeforeUpdate == "function" && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          j
        ), (L = E.state) && (typeof L != "object" || Yi(L)) && console.error("%s.state: must be set to an object or null", j), typeof E.getChildContext == "function" && typeof h.childContextTypes != "object" && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          j
        ), E = l.stateNode, E.props = y, E.state = l.memoizedState, E.refs = {}, Pn(l), j = h.contextType, E.context = typeof j == "object" && j !== null ? lr(j) : Qp, E.state === y && (j = $(h) || "Component", lj.has(j) || (lj.add(j), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          j
        ))), l.mode & Yo && Tu.recordLegacyContextWarning(
          l,
          E
        ), Tu.recordUnsafeLifecycleWarnings(
          l,
          E
        ), E.state = l.memoizedState, j = h.getDerivedStateFromProps, typeof j == "function" && (dp(
          l,
          h,
          j,
          y
        ), E.state = l.memoizedState), typeof h.getDerivedStateFromProps == "function" || typeof E.getSnapshotBeforeUpdate == "function" || typeof E.UNSAFE_componentWillMount != "function" && typeof E.componentWillMount != "function" || (j = E.state, typeof E.componentWillMount == "function" && E.componentWillMount(), typeof E.UNSAFE_componentWillMount == "function" && E.UNSAFE_componentWillMount(), j !== E.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          H(l) || "Component"
        ), OR.enqueueReplaceState(
          E,
          E.state,
          null
        )), oc(l, y, E, S), np(), E.state = l.memoizedState), typeof E.componentDidMount == "function" && (l.flags |= 4194308), (l.mode & Cu) !== Wt && (l.flags |= 134217728), E = !0;
      } else if (o === null) {
        E = l.stateNode;
        var be = l.memoizedProps;
        L = fc(h, be), E.props = L;
        var Ee = E.context;
        Q = h.contextType, j = Qp, typeof Q == "object" && Q !== null && (j = lr(Q)), ne = h.getDerivedStateFromProps, Q = typeof ne == "function" || typeof E.getSnapshotBeforeUpdate == "function", be = l.pendingProps !== be, Q || typeof E.UNSAFE_componentWillReceiveProps != "function" && typeof E.componentWillReceiveProps != "function" || (be || Ee !== j) && dc(
          l,
          E,
          y,
          j
        ), n0 = !1;
        var he = l.memoizedState;
        E.state = he, oc(l, y, E, S), np(), Ee = l.memoizedState, be || he !== Ee || n0 ? (typeof ne == "function" && (dp(
          l,
          h,
          ne,
          y
        ), Ee = l.memoizedState), (L = n0 || Sv(
          l,
          h,
          L,
          y,
          he,
          Ee,
          j
        )) ? (Q || typeof E.UNSAFE_componentWillMount != "function" && typeof E.componentWillMount != "function" || (typeof E.componentWillMount == "function" && E.componentWillMount(), typeof E.UNSAFE_componentWillMount == "function" && E.UNSAFE_componentWillMount()), typeof E.componentDidMount == "function" && (l.flags |= 4194308), (l.mode & Cu) !== Wt && (l.flags |= 134217728)) : (typeof E.componentDidMount == "function" && (l.flags |= 4194308), (l.mode & Cu) !== Wt && (l.flags |= 134217728), l.memoizedProps = y, l.memoizedState = Ee), E.props = y, E.state = Ee, E.context = j, E = L) : (typeof E.componentDidMount == "function" && (l.flags |= 4194308), (l.mode & Cu) !== Wt && (l.flags |= 134217728), E = !1);
      } else {
        E = l.stateNode, ic(o, l), j = l.memoizedProps, Q = fc(h, j), E.props = Q, ne = l.pendingProps, he = E.context, Ee = h.contextType, L = Qp, typeof Ee == "object" && Ee !== null && (L = lr(Ee)), be = h.getDerivedStateFromProps, (Ee = typeof be == "function" || typeof E.getSnapshotBeforeUpdate == "function") || typeof E.UNSAFE_componentWillReceiveProps != "function" && typeof E.componentWillReceiveProps != "function" || (j !== ne || he !== L) && dc(
          l,
          E,
          y,
          L
        ), n0 = !1, he = l.memoizedState, E.state = he, oc(l, y, E, S), np();
        var Le = l.memoizedState;
        j !== ne || he !== Le || n0 || o !== null && o.dependencies !== null && Kh(o.dependencies) ? (typeof be == "function" && (dp(
          l,
          h,
          be,
          y
        ), Le = l.memoizedState), (Q = n0 || Sv(
          l,
          h,
          Q,
          y,
          he,
          Le,
          L
        ) || o !== null && o.dependencies !== null && Kh(o.dependencies)) ? (Ee || typeof E.UNSAFE_componentWillUpdate != "function" && typeof E.componentWillUpdate != "function" || (typeof E.componentWillUpdate == "function" && E.componentWillUpdate(y, Le, L), typeof E.UNSAFE_componentWillUpdate == "function" && E.UNSAFE_componentWillUpdate(
          y,
          Le,
          L
        )), typeof E.componentDidUpdate == "function" && (l.flags |= 4), typeof E.getSnapshotBeforeUpdate == "function" && (l.flags |= 1024)) : (typeof E.componentDidUpdate != "function" || j === o.memoizedProps && he === o.memoizedState || (l.flags |= 4), typeof E.getSnapshotBeforeUpdate != "function" || j === o.memoizedProps && he === o.memoizedState || (l.flags |= 1024), l.memoizedProps = y, l.memoizedState = Le), E.props = y, E.state = Le, E.context = L, E = Q) : (typeof E.componentDidUpdate != "function" || j === o.memoizedProps && he === o.memoizedState || (l.flags |= 4), typeof E.getSnapshotBeforeUpdate != "function" || j === o.memoizedProps && he === o.memoizedState || (l.flags |= 1024), E = !1);
      }
      if (L = E, jm(o, l), j = (l.flags & 128) !== 0, L || j) {
        if (L = l.stateNode, Ue(l), j && typeof h.getDerivedStateFromError != "function")
          h = null, Ss = -1;
        else if (h = I9(L), l.mode & Yo) {
          se(!0);
          try {
            I9(L);
          } finally {
            se(!1);
          }
        }
        l.flags |= 1, o !== null && j ? (l.child = C1(
          l,
          o.child,
          null,
          S
        ), l.child = C1(
          l,
          null,
          h,
          S
        )) : ma(o, l, h, S), l.memoizedState = L.state, o = l.child;
      } else
        o = Tl(
          o,
          l,
          S
        );
      return S = l.stateNode, E && S.props !== y && (Xy || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        H(l) || "a component"
      ), Xy = !0), o;
    }
    function S2(o, l, h, y) {
      return sd(), l.flags |= 256, ma(o, l, h, y), l.child;
    }
    function fp(o, l) {
      l && l.childContextTypes && console.error(
        `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
        l.displayName || l.name || "Component"
      ), typeof l.getDerivedStateFromProps == "function" && (o = $(l) || "Unknown", vj[o] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        o
      ), vj[o] = !0)), typeof l.contextType == "object" && l.contextType !== null && (l = $(l) || "Unknown", mj[l] || (console.error(
        "%s: Function components do not support contextType.",
        l
      ), mj[l] = !0));
    }
    function hp(o) {
      return { baseLanes: o, cachePool: t2() };
    }
    function Ov(o, l, h) {
      return o = o !== null ? o.childLanes & ~h : 0, l && (o |= el), o;
    }
    function Rv(o, l, h) {
      var y, S = l.pendingProps;
      a(l) && (l.flags |= 128);
      var E = !1, j = (l.flags & 128) !== 0;
      if ((y = j) || (y = o !== null && o.memoizedState === null ? !1 : (ea.current & eS) !== 0), y && (E = !0, l.flags &= -129), y = (l.flags & 32) !== 0, l.flags &= -33, o === null) {
        if (Fn) {
          if (E ? yo(l) : sc(l), (o = ii) ? (h = mr(
            o,
            Mc
          ), h = h !== null && h.data !== k1 ? h : null, h !== null && (y = {
            dehydrated: h,
            treeContext: c3(),
            retryLane: 536870912,
            hydrationErrors: null
          }, l.memoizedState = y, y = Ww(h), y.return = l, l.child = y, Ro = l, ii = null)) : h = null, h === null)
            throw Qa(l, o), Vs(l);
          return tx(h) ? l.lanes = 32 : l.lanes = 536870912, null;
        }
        var L = S.children;
        if (S = S.fallback, E) {
          sc(l);
          var Q = l.mode;
          return L = Pm(
            { mode: "hidden", children: L },
            Q
          ), S = Sf(
            S,
            Q,
            h,
            null
          ), L.return = l, S.return = l, L.sibling = S, l.child = L, S = l.child, S.memoizedState = hp(h), S.childLanes = Ov(
            o,
            y,
            h
          ), l.memoizedState = NR, Ff(
            null,
            S
          );
        }
        return yo(l), E2(
          l,
          L
        );
      }
      var ne = o.memoizedState;
      if (ne !== null) {
        var be = ne.dehydrated;
        if (be !== null) {
          if (j)
            l.flags & 256 ? (yo(l), l.flags &= -257, l = Dv(
              o,
              l,
              h
            )) : l.memoizedState !== null ? (sc(l), l.child = o.child, l.flags |= 128, l = null) : (sc(l), L = S.fallback, Q = l.mode, S = Pm(
              {
                mode: "visible",
                children: S.children
              },
              Q
            ), L = Sf(
              L,
              Q,
              h,
              null
            ), L.flags |= 2, S.return = l, L.return = l, S.sibling = L, l.child = S, C1(
              l,
              o.child,
              null,
              h
            ), S = l.child, S.memoizedState = hp(h), S.childLanes = Ov(
              o,
              y,
              h
            ), l.memoizedState = NR, l = Ff(
              null,
              S
            ));
          else if (yo(l), d3(), h & 536870912 && yp(l), tx(
            be
          )) {
            if (y = be.nextSibling && be.nextSibling.dataset, y) {
              L = y.dgst;
              var Ee = y.msg;
              Q = y.stck;
              var he = y.cstck;
            }
            E = Ee, y = L, S = Q, be = he, L = E, Q = be, L = Error(L || "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), L.stack = S || "", L.digest = y, y = Q === void 0 ? null : Q, S = {
              value: L,
              source: null,
              stack: y
            }, typeof y == "string" && cR.set(
              L,
              S
            ), fm(S), l = Dv(
              o,
              l,
              h
            );
          } else if (xa || xl(
            o,
            l,
            h,
            !1
          ), y = (h & o.childLanes) !== 0, xa || y) {
            if (y = Hr, y !== null && (S = Wn(
              y,
              h
            ), S !== 0 && S !== ne.retryLane))
              throw ne.retryLane = S, Wa(
                o,
                S
              ), Kt(
                y,
                o,
                S
              ), DR;
            e1(
              be
            ) || bp(), l = Dv(
              o,
              l,
              h
            );
          } else
            e1(
              be
            ) ? (l.flags |= 192, l.child = o.child, l = null) : (o = ne.treeContext, ii = vs(
              be.nextSibling
            ), Ro = l, Fn = !0, Zp = null, Pd = !1, Bl = null, Mc = !1, o !== null && u3(l, o), l = E2(
              l,
              S.children
            ), l.flags |= 4096);
          return l;
        }
      }
      return E ? (sc(l), L = S.fallback, Q = l.mode, he = o.child, be = he.sibling, S = tc(
        he,
        {
          mode: "hidden",
          children: S.children
        }
      ), S.subtreeFlags = he.subtreeFlags & 65011712, be !== null ? L = tc(
        be,
        L
      ) : (L = Sf(
        L,
        Q,
        h,
        null
      ), L.flags |= 2), L.return = l, S.return = l, S.sibling = L, l.child = S, Ff(null, S), S = l.child, L = o.child.memoizedState, L === null ? L = hp(h) : (Q = L.cachePool, Q !== null ? (he = ya._currentValue, Q = Q.parent !== he ? { parent: he, pool: he } : Q) : Q = t2(), L = {
        baseLanes: L.baseLanes | h,
        cachePool: Q
      }), S.memoizedState = L, S.childLanes = Ov(
        o,
        y,
        h
      ), l.memoizedState = NR, Ff(
        o.child,
        S
      )) : (ne !== null && (h & 62914560) === h && h & o.lanes && yp(l), yo(l), h = o.child, o = h.sibling, h = tc(h, {
        mode: "visible",
        children: S.children
      }), h.return = l, h.sibling = null, o !== null && (y = l.deletions, y === null ? (l.deletions = [o], l.flags |= 16) : y.push(o)), l.child = h, l.memoizedState = null, h);
    }
    function E2(o, l) {
      return l = Pm(
        { mode: "visible", children: l },
        o.mode
      ), l.return = o, o.child = l;
    }
    function Pm(o, l) {
      return o = b(22, o, null, l), o.lanes = 0, o;
    }
    function Dv(o, l, h) {
      return C1(l, o.child, null, h), o = E2(
        l,
        l.pendingProps.children
      ), o.flags |= 2, l.memoizedState = null, o;
    }
    function _2(o, l, h) {
      o.lanes |= l;
      var y = o.alternate;
      y !== null && (y.lanes |= l), sv(
        o.return,
        l,
        h
      );
    }
    function Nv(o, l, h, y, S, E) {
      var j = o.memoizedState;
      j === null ? o.memoizedState = {
        isBackwards: l,
        rendering: null,
        renderingStartTime: 0,
        last: y,
        tail: h,
        tailMode: S,
        treeForkCount: E
      } : (j.isBackwards = l, j.rendering = null, j.renderingStartTime = 0, j.last = y, j.tail = h, j.tailMode = S, j.treeForkCount = E);
    }
    function A2(o, l, h) {
      var y = l.pendingProps, S = y.revealOrder, E = y.tail, j = y.children, L = ea.current;
      if ((y = (L & eS) !== 0) ? (L = L & Hy | eS, l.flags |= 128) : L &= Hy, Y(ea, L, l), L = S ?? "null", S !== "forwards" && S !== "unstable_legacy-backwards" && S !== "together" && S !== "independent" && !yj[L])
        if (yj[L] = !0, S == null)
          console.error(
            'The default for the <SuspenseList revealOrder="..."> prop is changing. To be future compatible you must explictly specify either "independent" (the current default), "together", "forwards" or "legacy_unstable-backwards".'
          );
        else if (S === "backwards")
          console.error(
            'The rendering order of <SuspenseList revealOrder="backwards"> is changing. To be future compatible you must specify revealOrder="legacy_unstable-backwards" instead.'
          );
        else if (typeof S == "string")
          switch (S.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
            case "independent":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                S,
                S.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                S,
                S.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
                S
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
            S
          );
      L = E ?? "null", UA[L] || (E == null ? (S === "forwards" || S === "backwards" || S === "unstable_legacy-backwards") && (UA[L] = !0, console.error(
        'The default for the <SuspenseList tail="..."> prop is changing. To be future compatible you must explictly specify either "visible" (the current default), "collapsed" or "hidden".'
      )) : E !== "visible" && E !== "collapsed" && E !== "hidden" ? (UA[L] = !0, console.error(
        '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?',
        E
      )) : S !== "forwards" && S !== "backwards" && S !== "unstable_legacy-backwards" && (UA[L] = !0, console.error(
        '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
        E
      )));
      e:
        if ((S === "forwards" || S === "backwards" || S === "unstable_legacy-backwards") && j !== void 0 && j !== null && j !== !1)
          if (Yi(j)) {
            for (L = 0; L < j.length; L++)
              if (!Fr(
                j[L],
                L
              ))
                break e;
          } else if (L = F(j), typeof L == "function") {
            if (L = L.call(j))
              for (var Q = L.next(), ne = 0; !Q.done; Q = L.next()) {
                if (!Fr(Q.value, ne))
                  break e;
                ne++;
              }
          } else
            console.error(
              'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
              S
            );
      if (ma(o, l, j, h), Fn ? (od(), j = zx) : j = 0, !y && o !== null && o.flags & 128)
        e:
          for (o = l.child; o !== null; ) {
            if (o.tag === 13)
              o.memoizedState !== null && _2(o, h, l);
            else if (o.tag === 19)
              _2(o, h, l);
            else if (o.child !== null) {
              o.child.return = o, o = o.child;
              continue;
            }
            if (o === l)
              break e;
            for (; o.sibling === null; ) {
              if (o.return === null || o.return === l)
                break e;
              o = o.return;
            }
            o.sibling.return = o.return, o = o.sibling;
          }
      switch (S) {
        case "forwards":
          for (h = l.child, S = null; h !== null; )
            o = h.alternate, o !== null && Rf(o) === null && (S = h), h = h.sibling;
          h = S, h === null ? (S = l.child, l.child = null) : (S = h.sibling, h.sibling = null), Nv(
            l,
            !1,
            S,
            h,
            E,
            j
          );
          break;
        case "backwards":
        case "unstable_legacy-backwards":
          for (h = null, S = l.child, l.child = null; S !== null; ) {
            if (o = S.alternate, o !== null && Rf(o) === null) {
              l.child = S;
              break;
            }
            o = S.sibling, S.sibling = h, h = S, S = o;
          }
          Nv(
            l,
            !0,
            h,
            null,
            E,
            j
          );
          break;
        case "together":
          Nv(
            l,
            !1,
            null,
            null,
            void 0,
            j
          );
          break;
        default:
          l.memoizedState = null;
      }
      return l.child;
    }
    function Tl(o, l, h) {
      if (o !== null && (l.dependencies = o.dependencies), Ss = -1, a0 |= l.lanes, !(h & l.childLanes))
        if (o !== null) {
          if (xl(
            o,
            l,
            h,
            !1
          ), (h & l.childLanes) === 0)
            return null;
        } else
          return null;
      if (o !== null && l.child !== o.child)
        throw Error("Resuming work not yet implemented.");
      if (l.child !== null) {
        for (o = l.child, h = tc(o, o.pendingProps), l.child = h, h.return = l; o.sibling !== null; )
          o = o.sibling, h = h.sibling = tc(o, o.pendingProps), h.return = l;
        h.sibling = null;
      }
      return l.child;
    }
    function Mv(o, l) {
      return o.lanes & l ? !0 : (o = o.dependencies, !!(o !== null && Kh(o)));
    }
    function w3(o, l, h) {
      switch (l.tag) {
        case 3:
          K(
            l,
            l.stateNode.containerInfo
          ), Us(
            l,
            ya,
            o.memoizedState.cache
          ), sd();
          break;
        case 27:
        case 5:
          W(l);
          break;
        case 4:
          K(
            l,
            l.stateNode.containerInfo
          );
          break;
        case 10:
          Us(
            l,
            l.type,
            l.memoizedProps.value
          );
          break;
        case 12:
          h & l.childLanes && (l.flags |= 4), l.flags |= 2048;
          var y = l.stateNode;
          y.effectDuration = -0, y.passiveEffectDuration = -0;
          break;
        case 31:
          if (l.memoizedState !== null)
            return l.flags |= 128, Al(l), null;
          break;
        case 13:
          if (y = l.memoizedState, y !== null)
            return y.dehydrated !== null ? (yo(l), l.flags |= 128, null) : h & l.child.childLanes ? Rv(
              o,
              l,
              h
            ) : (yo(l), o = Tl(
              o,
              l,
              h
            ), o !== null ? o.sibling : null);
          yo(l);
          break;
        case 19:
          var S = (o.flags & 128) !== 0;
          if (y = (h & l.childLanes) !== 0, y || (xl(
            o,
            l,
            h,
            !1
          ), y = (h & l.childLanes) !== 0), S) {
            if (y)
              return A2(
                o,
                l,
                h
              );
            l.flags |= 128;
          }
          if (S = l.memoizedState, S !== null && (S.rendering = null, S.tail = null, S.lastEffect = null), Y(
            ea,
            ea.current,
            l
          ), y)
            break;
          return null;
        case 22:
          return l.lanes = 0, v2(
            o,
            l,
            h,
            l.pendingProps
          );
        case 24:
          Us(
            l,
            ya,
            o.memoizedState.cache
          );
      }
      return Tl(o, l, h);
    }
    function Lm(o, l, h) {
      if (l._debugNeedsRemount && o !== null) {
        h = xf(
          l.type,
          l.key,
          l.pendingProps,
          l._debugOwner || null,
          l.mode,
          l.lanes
        ), h._debugStack = l._debugStack, h._debugTask = l._debugTask;
        var y = l.return;
        if (y === null)
          throw Error("Cannot swap the root fiber.");
        if (o.alternate = null, l.alternate = null, h.index = l.index, h.sibling = l.sibling, h.return = l.return, h.ref = l.ref, h._debugInfo = l._debugInfo, l === y.child)
          y.child = h;
        else {
          var S = y.child;
          if (S === null)
            throw Error("Expected parent to have a child.");
          for (; S.sibling !== l; )
            if (S = S.sibling, S === null)
              throw Error("Expected to find the previous sibling.");
          S.sibling = h;
        }
        return l = y.deletions, l === null ? (y.deletions = [o], y.flags |= 16) : l.push(o), h.flags |= 2, h;
      }
      if (o !== null)
        if (o.memoizedProps !== l.pendingProps || l.type !== o.type)
          xa = !0;
        else {
          if (!Mv(o, h) && !(l.flags & 128))
            return xa = !1, w3(
              o,
              l,
              h
            );
          xa = !!(o.flags & 131072);
        }
      else
        xa = !1, (y = Fn) && (od(), y = (l.flags & 1048576) !== 0), y && (y = l.index, od(), Qw(l, zx, y));
      switch (l.lanes = 0, l.tag) {
        case 16:
          e:
            if (y = l.pendingProps, o = ls(l.elementType), l.type = o, typeof o == "function")
              Yw(o) ? (y = fc(
                o,
                y
              ), l.tag = 1, l.type = o = id(o), l = Vf(
                null,
                l,
                o,
                y,
                h
              )) : (l.tag = 0, fp(l, o), l.type = o = id(o), l = w2(
                null,
                l,
                o,
                y,
                h
              ));
            else {
              if (o != null) {
                if (S = o.$$typeof, S === Pp) {
                  l.tag = 11, l.type = o = rv(o), l = y3(
                    null,
                    l,
                    o,
                    y,
                    h
                  );
                  break e;
                } else if (S === u1) {
                  l.tag = 14, l = m2(
                    null,
                    l,
                    o,
                    y,
                    h
                  );
                  break e;
                }
              }
              throw l = "", o !== null && typeof o == "object" && o.$$typeof === Ka && (l = " Did you wrap a component in React.lazy() more than once?"), h = $(o) || o, Error(
                "Element type is invalid. Received a promise that resolves to: " + h + ". Lazy element type must resolve to a class or function." + l
              );
            }
          return l;
        case 0:
          return w2(
            o,
            l,
            l.type,
            l.pendingProps,
            h
          );
        case 1:
          return y = l.type, S = fc(
            y,
            l.pendingProps
          ), Vf(
            o,
            l,
            y,
            S,
            h
          );
        case 3:
          e: {
            if (K(
              l,
              l.stateNode.containerInfo
            ), o === null)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            y = l.pendingProps;
            var E = l.memoizedState;
            S = E.element, ic(o, l), oc(l, y, null, h);
            var j = l.memoizedState;
            if (y = j.cache, Us(l, ya, y), y !== E.cache && ou(
              l,
              [ya],
              h,
              !0
            ), np(), y = j.element, E.isDehydrated)
              if (E = {
                element: y,
                isDehydrated: !1,
                cache: j.cache
              }, l.updateQueue.baseState = E, l.memoizedState = E, l.flags & 256) {
                l = S2(
                  o,
                  l,
                  y,
                  h
                );
                break e;
              } else if (y !== S) {
                S = po(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  l
                ), fm(S), l = S2(
                  o,
                  l,
                  y,
                  h
                );
                break e;
              } else {
                switch (o = l.stateNode.containerInfo, o.nodeType) {
                  case 9:
                    o = o.body;
                    break;
                  default:
                    o = o.nodeName === "HTML" ? o.ownerDocument.body : o;
                }
                for (ii = vs(o.firstChild), Ro = l, Fn = !0, Zp = null, Pd = !1, Bl = null, Mc = !0, h = Y9(
                  l,
                  null,
                  y,
                  h
                ), l.child = h; h; )
                  h.flags = h.flags & -3 | 4096, h = h.sibling;
              }
            else {
              if (sd(), y === S) {
                l = Tl(
                  o,
                  l,
                  h
                );
                break e;
              }
              ma(
                o,
                l,
                y,
                h
              );
            }
            l = l.child;
          }
          return l;
        case 26:
          return jm(o, l), o === null ? (h = ax(
            l.type,
            null,
            l.pendingProps,
            null
          )) ? l.memoizedState = h : Fn || (h = l.type, o = l.pendingProps, y = ee(
            ys.current
          ), y = Km(
            y
          ).createElement(h), y[ni] = l, y[Oo] = o, ti(y, h, o), Ke(y), l.stateNode = y) : l.memoizedState = ax(
            l.type,
            o.memoizedProps,
            l.pendingProps,
            o.memoizedState
          ), null;
        case 27:
          return W(l), o === null && Fn && (y = ee(ys.current), S = q(), y = l.stateNode = Su(
            l.type,
            l.pendingProps,
            y,
            S,
            !1
          ), Pd || (S = Ho(
            y,
            l.type,
            l.pendingProps,
            S
          ), S !== null && (Ef(l, 0).serverProps = S)), Ro = l, Mc = !0, S = ii, Rd(l.type) ? (e6 = S, ii = vs(
            y.firstChild
          )) : ii = S), ma(
            o,
            l,
            l.pendingProps.children,
            h
          ), jm(o, l), o === null && (l.flags |= 4194304), l.child;
        case 5:
          return o === null && Fn && (E = q(), y = nm(
            l.type,
            E.ancestorInfo
          ), S = ii, (j = !S) || (j = Q3(
            S,
            l.type,
            l.pendingProps,
            Mc
          ), j !== null ? (l.stateNode = j, Pd || (E = Ho(
            j,
            l.type,
            l.pendingProps,
            E
          ), E !== null && (Ef(l, 0).serverProps = E)), Ro = l, ii = vs(
            j.firstChild
          ), Mc = !1, E = !0) : E = !1, j = !E), j && (y && Qa(l, S), Vs(l))), W(l), S = l.type, E = l.pendingProps, j = o !== null ? o.memoizedProps : null, y = E.children, Tp(S, E) ? y = null : j !== null && Tp(S, j) && (l.flags |= 32), l.memoizedState !== null && (S = o2(
            o,
            l,
            xm,
            null,
            null,
            h
          ), yS._currentValue = S), jm(o, l), ma(
            o,
            l,
            y,
            h
          ), l.child;
        case 6:
          return o === null && Fn && (h = l.pendingProps, o = q(), y = o.ancestorInfo.current, h = y != null ? rm(
            h,
            y.tag,
            o.ancestorInfo.implicitRootScope
          ) : !0, o = ii, (y = !o) || (y = Z3(
            o,
            l.pendingProps,
            Mc
          ), y !== null ? (l.stateNode = y, Ro = l, ii = null, y = !0) : y = !1, y = !y), y && (h && Qa(l, o), Vs(l))), null;
        case 13:
          return Rv(o, l, h);
        case 4:
          return K(
            l,
            l.stateNode.containerInfo
          ), y = l.pendingProps, o === null ? l.child = C1(
            l,
            null,
            y,
            h
          ) : ma(
            o,
            l,
            y,
            h
          ), l.child;
        case 11:
          return y3(
            o,
            l,
            l.type,
            l.pendingProps,
            h
          );
        case 7:
          return ma(
            o,
            l,
            l.pendingProps,
            h
          ), l.child;
        case 8:
          return ma(
            o,
            l,
            l.pendingProps.children,
            h
          ), l.child;
        case 12:
          return l.flags |= 4, l.flags |= 2048, y = l.stateNode, y.effectDuration = -0, y.passiveEffectDuration = -0, ma(
            o,
            l,
            l.pendingProps.children,
            h
          ), l.child;
        case 10:
          return y = l.type, S = l.pendingProps, E = S.value, "value" in S || bj || (bj = !0, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), Us(l, y, E), ma(
            o,
            l,
            S.children,
            h
          ), l.child;
        case 9:
          return S = l.type._context, y = l.pendingProps.children, typeof y != "function" && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), cd(l), S = lr(S), y = yR(
            y,
            S,
            void 0
          ), l.flags |= 1, ma(
            o,
            l,
            y,
            h
          ), l.child;
        case 14:
          return m2(
            o,
            l,
            l.type,
            l.pendingProps,
            h
          );
        case 15:
          return g2(
            o,
            l,
            l.type,
            l.pendingProps,
            h
          );
        case 19:
          return A2(
            o,
            l,
            h
          );
        case 31:
          return b3(o, l, h);
        case 22:
          return v2(
            o,
            l,
            h,
            l.pendingProps
          );
        case 24:
          return cd(l), y = lr(ya), o === null ? (S = cu(), S === null && (S = Hr, E = lv(), S.pooledCache = E, Af(E), E !== null && (S.pooledCacheLanes |= h), S = E), l.memoizedState = {
            parent: y,
            cache: S
          }, Pn(l), Us(l, ya, S)) : (o.lanes & h && (ic(o, l), oc(l, null, null, h), np()), S = o.memoizedState, E = l.memoizedState, S.parent !== y ? (S = {
            parent: y,
            cache: y
          }, l.memoizedState = S, l.lanes === 0 && (l.memoizedState = l.updateQueue.baseState = S), Us(l, ya, y)) : (y = E.cache, Us(l, ya, y), y !== S.cache && ou(
            l,
            [ya],
            h,
            !0
          ))), ma(
            o,
            l,
            l.pendingProps.children,
            h
          ), l.child;
        case 29:
          throw l.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + l.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function hc(o) {
      o.flags |= 4;
    }
    function Iv(o, l, h, y, S) {
      if ((l = (o.mode & kte) !== Wt) && (l = !1), l) {
        if (o.flags |= 16777216, (S & 335544128) === S)
          if (o.stateNode.complete)
            o.flags |= 8192;
          else if ($2())
            o.flags |= 8192;
          else
            throw A1 = PA, wR;
      } else
        o.flags &= -16777217;
    }
    function x3(o, l) {
      if (l.type !== "stylesheet" || (l.state.loading & Lc) !== L1)
        o.flags &= -16777217;
      else if (o.flags |= 16777216, !Dn(l))
        if ($2())
          o.flags |= 8192;
        else
          throw A1 = PA, wR;
    }
    function pp(o, l) {
      l !== null && (o.flags |= 4), o.flags & 16384 && (l = o.tag !== 22 ? ct() : 536870912, o.lanes |= l, N1 |= l);
    }
    function mp(o, l) {
      if (!Fn)
        switch (o.tailMode) {
          case "hidden":
            l = o.tail;
            for (var h = null; l !== null; )
              l.alternate !== null && (h = l), l = l.sibling;
            h === null ? o.tail = null : h.sibling = null;
            break;
          case "collapsed":
            h = o.tail;
            for (var y = null; h !== null; )
              h.alternate !== null && (y = h), h = h.sibling;
            y === null ? l || o.tail === null ? o.tail = null : o.tail.sibling = null : y.sibling = null;
        }
    }
    function Er(o) {
      var l = o.alternate !== null && o.alternate.child === o.child, h = 0, y = 0;
      if (l)
        if ((o.mode & bn) !== Wt) {
          for (var S = o.selfBaseDuration, E = o.child; E !== null; )
            h |= E.lanes | E.childLanes, y |= E.subtreeFlags & 65011712, y |= E.flags & 65011712, S += E.treeBaseDuration, E = E.sibling;
          o.treeBaseDuration = S;
        } else
          for (S = o.child; S !== null; )
            h |= S.lanes | S.childLanes, y |= S.subtreeFlags & 65011712, y |= S.flags & 65011712, S.return = o, S = S.sibling;
      else if ((o.mode & bn) !== Wt) {
        S = o.actualDuration, E = o.selfBaseDuration;
        for (var j = o.child; j !== null; )
          h |= j.lanes | j.childLanes, y |= j.subtreeFlags, y |= j.flags, S += j.actualDuration, E += j.treeBaseDuration, j = j.sibling;
        o.actualDuration = S, o.treeBaseDuration = E;
      } else
        for (S = o.child; S !== null; )
          h |= S.lanes | S.childLanes, y |= S.subtreeFlags, y |= S.flags, S.return = o, S = S.sibling;
      return o.subtreeFlags |= y, o.childLanes = h, l;
    }
    function C2(o, l, h) {
      var y = l.pendingProps;
      switch (ov(l), l.tag) {
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return Er(l), null;
        case 1:
          return Er(l), null;
        case 3:
          return h = l.stateNode, y = null, o !== null && (y = o.memoizedState.cache), l.memoizedState.cache !== y && (l.flags |= 2048), wl(ya, l), U(l), h.pendingContext && (h.context = h.pendingContext, h.pendingContext = null), (o === null || o.child === null) && (_f(l) ? (ld(), hc(l)) : o === null || o.memoizedState.isDehydrated && !(l.flags & 256) || (l.flags |= 1024, dm())), Er(l), null;
        case 26:
          var S = l.type, E = l.memoizedState;
          return o === null ? (hc(l), E !== null ? (Er(l), x3(
            l,
            E
          )) : (Er(l), Iv(
            l,
            S,
            null,
            y,
            h
          ))) : E ? E !== o.memoizedState ? (hc(l), Er(l), x3(
            l,
            E
          )) : (Er(l), l.flags &= -16777217) : (o = o.memoizedProps, o !== y && hc(l), Er(l), Iv(
            l,
            S,
            o,
            y,
            h
          )), null;
        case 27:
          if (ie(l), h = ee(ys.current), S = l.type, o !== null && l.stateNode != null)
            o.memoizedProps !== y && hc(l);
          else {
            if (!y) {
              if (l.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return Er(l), null;
            }
            o = q(), _f(l) ? Zw(l) : (o = Su(
              S,
              y,
              h,
              o,
              !0
            ), l.stateNode = o, hc(l));
          }
          return Er(l), null;
        case 5:
          if (ie(l), S = l.type, o !== null && l.stateNode != null)
            o.memoizedProps !== y && hc(l);
          else {
            if (!y) {
              if (l.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return Er(l), null;
            }
            var j = q();
            if (_f(l))
              Zw(l);
            else {
              switch (E = ee(ys.current), nm(S, j.ancestorInfo), j = j.context, E = Km(E), j) {
                case nb:
                  E = E.createElementNS(
                    mn,
                    S
                  );
                  break;
                case lC:
                  E = E.createElementNS(
                    ln,
                    S
                  );
                  break;
                default:
                  switch (S) {
                    case "svg":
                      E = E.createElementNS(
                        mn,
                        S
                      );
                      break;
                    case "math":
                      E = E.createElementNS(
                        ln,
                        S
                      );
                      break;
                    case "script":
                      E = E.createElement("div"), E.innerHTML = "<script><\/script>", E = E.removeChild(
                        E.firstChild
                      );
                      break;
                    case "select":
                      E = typeof y.is == "string" ? E.createElement("select", {
                        is: y.is
                      }) : E.createElement("select"), y.multiple ? E.multiple = !0 : y.size && (E.size = y.size);
                      break;
                    default:
                      E = typeof y.is == "string" ? E.createElement(S, {
                        is: y.is
                      }) : E.createElement(S), S.indexOf("-") === -1 && (S !== S.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        S
                      ), Object.prototype.toString.call(E) !== "[object HTMLUnknownElement]" || bs.call($j, S) || ($j[S] = !0, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        S
                      )));
                  }
              }
              E[ni] = l, E[Oo] = y;
              e:
                for (j = l.child; j !== null; ) {
                  if (j.tag === 5 || j.tag === 6)
                    E.appendChild(j.stateNode);
                  else if (j.tag !== 4 && j.tag !== 27 && j.child !== null) {
                    j.child.return = j, j = j.child;
                    continue;
                  }
                  if (j === l)
                    break e;
                  for (; j.sibling === null; ) {
                    if (j.return === null || j.return === l)
                      break e;
                    j = j.return;
                  }
                  j.sibling.return = j.return, j = j.sibling;
                }
              l.stateNode = E;
              e:
                switch (ti(E, S, y), S) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    y = !!y.autoFocus;
                    break e;
                  case "img":
                    y = !0;
                    break e;
                  default:
                    y = !1;
                }
              y && hc(l);
            }
          }
          return Er(l), Iv(
            l,
            l.type,
            o === null ? null : o.memoizedProps,
            l.pendingProps,
            h
          ), null;
        case 6:
          if (o && l.stateNode != null)
            o.memoizedProps !== y && hc(l);
          else {
            if (typeof y != "string" && l.stateNode === null)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            if (o = ee(ys.current), h = q(), _f(l)) {
              if (o = l.stateNode, h = l.memoizedProps, S = !Pd, y = null, E = Ro, E !== null)
                switch (E.tag) {
                  case 3:
                    S && (S = eA(
                      o,
                      h,
                      y
                    ), S !== null && (Ef(l, 0).serverProps = S));
                    break;
                  case 27:
                  case 5:
                    y = E.memoizedProps, S && (S = eA(
                      o,
                      h,
                      y
                    ), S !== null && (Ef(
                      l,
                      0
                    ).serverProps = S));
                }
              o[ni] = l, o = !!(o.nodeValue === h || y !== null && y.suppressHydrationWarning === !0 || J2(o.nodeValue, h)), o || Vs(l, !0);
            } else
              S = h.ancestorInfo.current, S != null && rm(
                y,
                S.tag,
                h.ancestorInfo.implicitRootScope
              ), o = Km(o).createTextNode(
                y
              ), o[ni] = l, l.stateNode = o;
          }
          return Er(l), null;
        case 31:
          if (h = l.memoizedState, o === null || o.memoizedState !== null) {
            if (y = _f(l), h !== null) {
              if (o === null) {
                if (!y)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (o = l.memoizedState, o = o !== null ? o.dehydrated : null, !o)
                  throw Error(
                    "Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                o[ni] = l, Er(l), (l.mode & bn) !== Wt && h !== null && (o = l.child, o !== null && (l.treeBaseDuration -= o.treeBaseDuration));
              } else
                ld(), sd(), !(l.flags & 128) && (h = l.memoizedState = null), l.flags |= 4, Er(l), (l.mode & bn) !== Wt && h !== null && (o = l.child, o !== null && (l.treeBaseDuration -= o.treeBaseDuration));
              o = !1;
            } else
              h = dm(), o !== null && o.memoizedState !== null && (o.memoizedState.hydrationErrors = h), o = !0;
            if (!o)
              return l.flags & 256 ? (ha(l), l) : (ha(l), null);
            if (l.flags & 128)
              throw Error(
                "Client rendering an Activity suspended it again. This is a bug in React."
              );
          }
          return Er(l), null;
        case 13:
          if (y = l.memoizedState, o === null || o.memoizedState !== null && o.memoizedState.dehydrated !== null) {
            if (S = y, E = _f(l), S !== null && S.dehydrated !== null) {
              if (o === null) {
                if (!E)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (E = l.memoizedState, E = E !== null ? E.dehydrated : null, !E)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                E[ni] = l, Er(l), (l.mode & bn) !== Wt && S !== null && (S = l.child, S !== null && (l.treeBaseDuration -= S.treeBaseDuration));
              } else
                ld(), sd(), !(l.flags & 128) && (S = l.memoizedState = null), l.flags |= 4, Er(l), (l.mode & bn) !== Wt && S !== null && (S = l.child, S !== null && (l.treeBaseDuration -= S.treeBaseDuration));
              S = !1;
            } else
              S = dm(), o !== null && o.memoizedState !== null && (o.memoizedState.hydrationErrors = S), S = !0;
            if (!S)
              return l.flags & 256 ? (ha(l), l) : (ha(l), null);
          }
          return ha(l), l.flags & 128 ? (l.lanes = h, (l.mode & bn) !== Wt && Tf(l), l) : (h = y !== null, o = o !== null && o.memoizedState !== null, h && (y = l.child, S = null, y.alternate !== null && y.alternate.memoizedState !== null && y.alternate.memoizedState.cachePool !== null && (S = y.alternate.memoizedState.cachePool.pool), E = null, y.memoizedState !== null && y.memoizedState.cachePool !== null && (E = y.memoizedState.cachePool.pool), E !== S && (y.flags |= 2048)), h !== o && h && (l.child.flags |= 8192), pp(l, l.updateQueue), Er(l), (l.mode & bn) !== Wt && h && (o = l.child, o !== null && (l.treeBaseDuration -= o.treeBaseDuration)), null);
        case 4:
          return U(l), o === null && Td(
            l.stateNode.containerInfo
          ), Er(l), null;
        case 10:
          return wl(l.type, l), Er(l), null;
        case 19:
          if (V(ea, l), y = l.memoizedState, y === null)
            return Er(l), null;
          if (S = (l.flags & 128) !== 0, E = y.rendering, E === null)
            if (S)
              mp(y, !1);
            else {
              if (Di !== mh || o !== null && o.flags & 128)
                for (o = l.child; o !== null; ) {
                  if (E = Rf(o), E !== null) {
                    for (l.flags |= 128, mp(y, !1), o = E.updateQueue, l.updateQueue = o, pp(l, o), l.subtreeFlags = 0, o = h, h = l.child; h !== null; )
                      Xw(h, o), h = h.sibling;
                    return Y(
                      ea,
                      ea.current & Hy | eS,
                      l
                    ), Fn && bl(l, y.treeForkCount), l.child;
                  }
                  o = o.sibling;
                }
              y.tail !== null && va() > WA && (l.flags |= 128, S = !0, mp(y, !1), l.lanes = 4194304);
            }
          else {
            if (!S)
              if (o = Rf(E), o !== null) {
                if (l.flags |= 128, S = !0, o = o.updateQueue, l.updateQueue = o, pp(l, o), mp(y, !0), y.tail === null && y.tailMode === "hidden" && !E.alternate && !Fn)
                  return Er(l), null;
              } else
                2 * va() - y.renderingStartTime > WA && h !== 536870912 && (l.flags |= 128, S = !0, mp(y, !1), l.lanes = 4194304);
            y.isBackwards ? (E.sibling = l.child, l.child = E) : (o = y.last, o !== null ? o.sibling = E : l.child = E, y.last = E);
          }
          return y.tail !== null ? (o = y.tail, y.rendering = o, y.tail = o.sibling, y.renderingStartTime = va(), o.sibling = null, h = ea.current, h = S ? h & Hy | eS : h & Hy, Y(ea, h, l), Fn && bl(l, y.treeForkCount), o) : (Er(l), null);
        case 22:
        case 23:
          return ha(l), _l(l), y = l.memoizedState !== null, o !== null ? o.memoizedState !== null !== y && (l.flags |= 8192) : y && (l.flags |= 8192), y ? h & 536870912 && !(l.flags & 128) && (Er(l), l.subtreeFlags & 6 && (l.flags |= 8192)) : Er(l), h = l.updateQueue, h !== null && pp(l, h.retryQueue), h = null, o !== null && o.memoizedState !== null && o.memoizedState.cachePool !== null && (h = o.memoizedState.cachePool.pool), y = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (y = l.memoizedState.cachePool.pool), y !== h && (l.flags |= 2048), o !== null && V(E1, l), null;
        case 24:
          return h = null, o !== null && (h = o.memoizedState.cache), l.memoizedState.cache !== h && (l.flags |= 2048), wl(ya, l), Er(l), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + l.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function S3(o, l) {
      switch (ov(l), l.tag) {
        case 1:
          return o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, (l.mode & bn) !== Wt && Tf(l), l) : null;
        case 3:
          return wl(ya, l), U(l), o = l.flags, o & 65536 && !(o & 128) ? (l.flags = o & -65537 | 128, l) : null;
        case 26:
        case 27:
        case 5:
          return ie(l), null;
        case 31:
          if (l.memoizedState !== null) {
            if (ha(l), l.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            sd();
          }
          return o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, (l.mode & bn) !== Wt && Tf(l), l) : null;
        case 13:
          if (ha(l), o = l.memoizedState, o !== null && o.dehydrated !== null) {
            if (l.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            sd();
          }
          return o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, (l.mode & bn) !== Wt && Tf(l), l) : null;
        case 19:
          return V(ea, l), null;
        case 4:
          return U(l), null;
        case 10:
          return wl(l.type, l), null;
        case 22:
        case 23:
          return ha(l), _l(l), o !== null && V(E1, l), o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, (l.mode & bn) !== Wt && Tf(l), l) : null;
        case 24:
          return wl(ya, l), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function T2(o, l) {
      switch (ov(l), l.tag) {
        case 3:
          wl(ya, l), U(l);
          break;
        case 26:
        case 27:
        case 5:
          ie(l);
          break;
        case 4:
          U(l);
          break;
        case 31:
          l.memoizedState !== null && ha(l);
          break;
        case 13:
          ha(l);
          break;
        case 19:
          V(ea, l);
          break;
        case 10:
          wl(l.type, l);
          break;
        case 22:
        case 23:
          ha(l), _l(l), o !== null && V(E1, l);
          break;
        case 24:
          wl(ya, l);
      }
    }
    function pc(o) {
      return (o.mode & bn) !== Wt;
    }
    function E3(o, l) {
      pc(o) ? (Ci(), vu(l, o), go()) : vu(l, o);
    }
    function kv(o, l, h) {
      pc(o) ? (Ci(), xd(
        h,
        o,
        l
      ), go()) : xd(
        h,
        o,
        l
      );
    }
    function vu(o, l) {
      try {
        var h = l.updateQueue, y = h !== null ? h.lastEffect : null;
        if (y !== null) {
          var S = y.next;
          h = S;
          do {
            if ((h.tag & o) === o && (y = void 0, (o & Es) !== BA && (Jy = !0), y = Ce(
              l,
              zte,
              h
            ), (o & Es) !== BA && (Jy = !1), y !== void 0 && typeof y != "function")) {
              var E = void 0;
              E = h.tag & Fl ? "useLayoutEffect" : h.tag & Es ? "useInsertionEffect" : "useEffect";
              var j = void 0;
              j = y === null ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof y.then == "function" ? `

It looks like you wrote ` + E + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + E + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching` : " You returned: " + y, Ce(
                l,
                function(L, Q) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    L,
                    Q
                  );
                },
                E,
                j
              );
            }
            h = h.next;
          } while (h !== S);
        }
      } catch (L) {
        pn(l, l.return, L);
      }
    }
    function xd(o, l, h) {
      try {
        var y = l.updateQueue, S = y !== null ? y.lastEffect : null;
        if (S !== null) {
          var E = S.next;
          y = E;
          do {
            if ((y.tag & o) === o) {
              var j = y.inst, L = j.destroy;
              L !== void 0 && (j.destroy = void 0, (o & Es) !== BA && (Jy = !0), S = l, Ce(
                S,
                Fte,
                S,
                h,
                L
              ), (o & Es) !== BA && (Jy = !1));
            }
            y = y.next;
          } while (y !== E);
        }
      } catch (Q) {
        pn(l, l.return, Q);
      }
    }
    function Bm(o, l) {
      pc(o) ? (Ci(), vu(l, o), go()) : vu(l, o);
    }
    function jv(o, l, h) {
      pc(o) ? (Ci(), xd(
        h,
        o,
        l
      ), go()) : xd(
        h,
        o,
        l
      );
    }
    function O2(o) {
      var l = o.updateQueue;
      if (l !== null) {
        var h = o.stateNode;
        o.type.defaultProps || "ref" in o.memoizedProps || Xy || (h.props !== o.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          H(o) || "instance"
        ), h.state !== o.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          H(o) || "instance"
        ));
        try {
          Ce(
            o,
            rp,
            l,
            h
          );
        } catch (y) {
          pn(o, o.return, y);
        }
      }
    }
    function zm(o, l, h) {
      return o.getSnapshotBeforeUpdate(l, h);
    }
    function _3(o, l) {
      var h = l.memoizedProps, y = l.memoizedState;
      l = o.stateNode, o.type.defaultProps || "ref" in o.memoizedProps || Xy || (l.props !== o.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        H(o) || "instance"
      ), l.state !== o.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        H(o) || "instance"
      ));
      try {
        var S = fc(
          o.type,
          h
        ), E = Ce(
          o,
          zm,
          l,
          S,
          y
        );
        h = wj, E !== void 0 || h.has(o.type) || (h.add(o.type), Ce(o, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            H(o)
          );
        })), l.__reactInternalSnapshotBeforeUpdate = E;
      } catch (j) {
        pn(o, o.return, j);
      }
    }
    function Pv(o, l, h) {
      h.props = fc(
        o.type,
        o.memoizedProps
      ), h.state = o.memoizedState, pc(o) ? (Ci(), Ce(
        o,
        z9,
        o,
        l,
        h
      ), go()) : Ce(
        o,
        z9,
        o,
        l,
        h
      );
    }
    function A3(o) {
      var l = o.ref;
      if (l !== null) {
        switch (o.tag) {
          case 26:
          case 27:
          case 5:
            var h = o.stateNode;
            break;
          case 30:
            h = o.stateNode;
            break;
          default:
            h = o.stateNode;
        }
        if (typeof l == "function")
          if (pc(o))
            try {
              Ci(), o.refCleanup = l(h);
            } finally {
              go();
            }
          else
            o.refCleanup = l(h);
        else
          typeof l == "string" ? console.error("String refs are no longer supported.") : l.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            H(o)
          ), l.current = h;
      }
    }
    function Uf(o, l) {
      try {
        Ce(o, A3, o);
      } catch (h) {
        pn(o, l, h);
      }
    }
    function Ys(o, l) {
      var h = o.ref, y = o.refCleanup;
      if (h !== null)
        if (typeof y == "function")
          try {
            if (pc(o))
              try {
                Ci(), Ce(o, y);
              } finally {
                go(o);
              }
            else
              Ce(o, y);
          } catch (S) {
            pn(o, l, S);
          } finally {
            o.refCleanup = null, o = o.alternate, o != null && (o.refCleanup = null);
          }
        else if (typeof h == "function")
          try {
            if (pc(o))
              try {
                Ci(), Ce(o, h, null);
              } finally {
                go(o);
              }
            else
              Ce(o, h, null);
          } catch (S) {
            pn(o, l, S);
          }
        else
          h.current = null;
    }
    function R2(o, l, h, y) {
      var S = o.memoizedProps, E = S.id, j = S.onCommit;
      S = S.onRender, l = l === null ? "mount" : "update", MA && (l = "nested-update"), typeof S == "function" && S(
        E,
        l,
        o.actualDuration,
        o.treeBaseDuration,
        o.actualStartTime,
        h
      ), typeof j == "function" && j(E, l, y, h);
    }
    function C3(o, l, h, y) {
      var S = o.memoizedProps;
      o = S.id, S = S.onPostCommit, l = l === null ? "mount" : "update", MA && (l = "nested-update"), typeof S == "function" && S(
        o,
        l,
        y,
        h
      );
    }
    function Sd(o) {
      var l = o.type, h = o.memoizedProps, y = o.stateNode;
      try {
        Ce(
          o,
          z3,
          y,
          l,
          h,
          o
        );
      } catch (S) {
        pn(o, o.return, S);
      }
    }
    function Lv(o, l, h) {
      try {
        Ce(
          o,
          ry,
          o.stateNode,
          o.type,
          h,
          l,
          o
        );
      } catch (y) {
        pn(o, o.return, y);
      }
    }
    function D2(o) {
      return o.tag === 5 || o.tag === 3 || o.tag === 26 || o.tag === 27 && Rd(o.type) || o.tag === 4;
    }
    function Bv(o) {
      e:
        for (; ; ) {
          for (; o.sibling === null; ) {
            if (o.return === null || D2(o.return))
              return null;
            o = o.return;
          }
          for (o.sibling.return = o.return, o = o.sibling; o.tag !== 5 && o.tag !== 6 && o.tag !== 18; ) {
            if (o.tag === 27 && Rd(o.type) || o.flags & 2 || o.child === null || o.tag === 4)
              continue e;
            o.child.return = o, o = o.child;
          }
          if (!(o.flags & 2))
            return o.stateNode;
        }
    }
    function gp(o, l, h) {
      var y = o.tag;
      if (y === 5 || y === 6)
        o = o.stateNode, l ? (V3(h), (h.nodeType === 9 ? h.body : h.nodeName === "HTML" ? h.ownerDocument.body : h).insertBefore(o, l)) : (V3(h), l = h.nodeType === 9 ? h.body : h.nodeName === "HTML" ? h.ownerDocument.body : h, l.appendChild(o), h = h._reactRootContainer, h != null || l.onclick !== null || (l.onclick = zs));
      else if (y !== 4 && (y === 27 && Rd(o.type) && (h = o.stateNode, l = null), o = o.child, o !== null))
        for (gp(o, l, h), o = o.sibling; o !== null; )
          gp(o, l, h), o = o.sibling;
    }
    function Fm(o, l, h) {
      var y = o.tag;
      if (y === 5 || y === 6)
        o = o.stateNode, l ? h.insertBefore(o, l) : h.appendChild(o);
      else if (y !== 4 && (y === 27 && Rd(o.type) && (h = o.stateNode), o = o.child, o !== null))
        for (Fm(o, l, h), o = o.sibling; o !== null; )
          Fm(o, l, h), o = o.sibling;
    }
    function N2(o) {
      for (var l, h = o.return; h !== null; ) {
        if (D2(h)) {
          l = h;
          break;
        }
        h = h.return;
      }
      if (l == null)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (l.tag) {
        case 27:
          l = l.stateNode, h = Bv(o), Fm(
            o,
            h,
            l
          );
          break;
        case 5:
          h = l.stateNode, l.flags & 32 && (iy(h), l.flags &= -33), l = Bv(o), Fm(
            o,
            l,
            h
          );
          break;
        case 3:
        case 4:
          l = l.stateNode.containerInfo, h = Bv(o), gp(
            o,
            h,
            l
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function M2(o) {
      var l = o.stateNode, h = o.memoizedProps;
      try {
        Ce(
          o,
          Sc,
          o.type,
          h,
          l,
          o
        );
      } catch (y) {
        pn(o, o.return, y);
      }
    }
    function I2(o, l) {
      return l.tag === 31 ? (l = l.memoizedState, o.memoizedState !== null && l === null) : l.tag === 13 ? (o = o.memoizedState, l = l.memoizedState, o !== null && o.dehydrated !== null && (l === null || l.dehydrated === null)) : l.tag === 3 ? o.memoizedState.isDehydrated && (l.flags & 256) === 0 : !1;
    }
    function FO(o, l) {
      if (o = o.containerInfo, ZR = fC, o = Jg(o), Fw(o)) {
        if ("selectionStart" in o)
          var h = {
            start: o.selectionStart,
            end: o.selectionEnd
          };
        else
          e: {
            h = (h = o.ownerDocument) && h.defaultView || window;
            var y = h.getSelection && h.getSelection();
            if (y && y.rangeCount !== 0) {
              h = y.anchorNode;
              var S = y.anchorOffset, E = y.focusNode;
              y = y.focusOffset;
              try {
                h.nodeType, E.nodeType;
              } catch {
                h = null;
                break e;
              }
              var j = 0, L = -1, Q = -1, ne = 0, be = 0, Ee = o, he = null;
              t:
                for (; ; ) {
                  for (var Le; Ee !== h || S !== 0 && Ee.nodeType !== 3 || (L = j + S), Ee !== E || y !== 0 && Ee.nodeType !== 3 || (Q = j + y), Ee.nodeType === 3 && (j += Ee.nodeValue.length), (Le = Ee.firstChild) !== null; )
                    he = Ee, Ee = Le;
                  for (; ; ) {
                    if (Ee === o)
                      break t;
                    if (he === h && ++ne === S && (L = j), he === E && ++be === y && (Q = j), (Le = Ee.nextSibling) !== null)
                      break;
                    Ee = he, he = Ee.parentNode;
                  }
                  Ee = Le;
                }
              h = L === -1 || Q === -1 ? null : { start: L, end: Q };
            } else
              h = null;
          }
        h = h || { start: 0, end: 0 };
      } else
        h = null;
      for (KR = {
        focusedElem: o,
        selectionRange: h
      }, fC = !1, to = l; to !== null; )
        if (l = to, o = l.child, (l.subtreeFlags & 1028) !== 0 && o !== null)
          o.return = l, to = o;
        else
          for (; to !== null; ) {
            switch (o = l = to, h = o.alternate, S = o.flags, o.tag) {
              case 0:
                if (S & 4 && (o = o.updateQueue, o = o !== null ? o.events : null, o !== null))
                  for (h = 0; h < o.length; h++)
                    S = o[h], S.ref.impl = S.nextImpl;
                break;
              case 11:
              case 15:
                break;
              case 1:
                S & 1024 && h !== null && _3(o, h);
                break;
              case 3:
                if (S & 1024) {
                  if (o = o.stateNode.containerInfo, h = o.nodeType, h === 9)
                    Rp(o);
                  else if (h === 1)
                    switch (o.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        Rp(o);
                        break;
                      default:
                        o.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if (S & 1024)
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            if (o = l.sibling, o !== null) {
              o.return = l.return, to = o;
              break;
            }
            to = l.return;
          }
    }
    function zv(o, l, h) {
      var y = Jr(), S = $s(), E = os(), j = Hs(), L = h.flags;
      switch (h.tag) {
        case 0:
        case 11:
        case 15:
          hs(o, h), L & 4 && E3(h, Fl | jc);
          break;
        case 1:
          if (hs(o, h), L & 4)
            if (o = h.stateNode, l === null)
              h.type.defaultProps || "ref" in h.memoizedProps || Xy || (o.props !== h.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                H(h) || "instance"
              ), o.state !== h.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                H(h) || "instance"
              )), pc(h) ? (Ci(), Ce(
                h,
                bR,
                h,
                o
              ), go()) : Ce(
                h,
                bR,
                h,
                o
              );
            else {
              var Q = fc(
                h.type,
                l.memoizedProps
              );
              l = l.memoizedState, h.type.defaultProps || "ref" in h.memoizedProps || Xy || (o.props !== h.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                H(h) || "instance"
              ), o.state !== h.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                H(h) || "instance"
              )), pc(h) ? (Ci(), Ce(
                h,
                P9,
                h,
                o,
                Q,
                l,
                o.__reactInternalSnapshotBeforeUpdate
              ), go()) : Ce(
                h,
                P9,
                h,
                o,
                Q,
                l,
                o.__reactInternalSnapshotBeforeUpdate
              );
            }
          L & 64 && O2(h), L & 512 && Uf(h, h.return);
          break;
        case 3:
          if (l = rc(), hs(o, h), L & 64 && (L = h.updateQueue, L !== null)) {
            if (Q = null, h.child !== null)
              switch (h.child.tag) {
                case 27:
                case 5:
                  Q = h.child.stateNode;
                  break;
                case 1:
                  Q = h.child.stateNode;
              }
            try {
              Ce(
                h,
                rp,
                L,
                Q
              );
            } catch (be) {
              pn(h, h.return, be);
            }
          }
          o.effectDuration += Jh(l);
          break;
        case 27:
          l === null && L & 4 && M2(h);
        case 26:
        case 5:
          if (hs(o, h), l === null) {
            if (L & 4)
              Sd(h);
            else if (L & 64) {
              o = h.type, l = h.memoizedProps, Q = h.stateNode;
              try {
                Ce(
                  h,
                  F3,
                  Q,
                  o,
                  l,
                  h
                );
              } catch (be) {
                pn(
                  h,
                  h.return,
                  be
                );
              }
            }
          }
          L & 512 && Uf(h, h.return);
          break;
        case 12:
          if (L & 4) {
            L = rc(), hs(o, h), o = h.stateNode, o.effectDuration += mo(L);
            try {
              Ce(
                h,
                R2,
                h,
                l,
                Kp,
                o.effectDuration
              );
            } catch (be) {
              pn(h, h.return, be);
            }
          } else
            hs(o, h);
          break;
        case 31:
          hs(o, h), L & 4 && j2(o, h);
          break;
        case 13:
          hs(o, h), L & 4 && P2(o, h), L & 64 && (o = h.memoizedState, o !== null && (o = o.dehydrated, o !== null && (L = bu.bind(
            null,
            h
          ), K3(o, L))));
          break;
        case 22:
          if (L = h.memoizedState !== null || ph, !L) {
            l = l !== null && l.memoizedState !== null || Sa, Q = ph;
            var ne = Sa;
            ph = L, (Sa = l) && !ne ? (Ol(
              o,
              h,
              (h.subtreeFlags & 8772) !== 0
            ), (h.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && 0.05 < Gt - zt && ev(
              h,
              zt,
              Gt
            )) : hs(o, h), ph = Q, Sa = ne;
          }
          break;
        case 30:
          break;
        default:
          hs(o, h);
      }
      (h.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && ((Li || 0.05 < Ri) && yl(
        h,
        zt,
        Gt,
        Ri,
        fi
      ), h.alternate === null && h.return !== null && h.return.alternate !== null && 0.05 < Gt - zt && (I2(
        h.return.alternate,
        h.return
      ) || Fs(
        h,
        zt,
        Gt,
        "Mount"
      ))), da(y), as(S), fi = E, Li = j;
    }
    function ji(o) {
      var l = o.alternate;
      l !== null && (o.alternate = null, ji(l)), o.child = null, o.deletions = null, o.sibling = null, o.tag === 5 && (l = o.stateNode, l !== null && Ae(l)), o.stateNode = null, o._debugOwner = null, o.return = null, o.dependencies = null, o.memoizedProps = null, o.memoizedState = null, o.pendingProps = null, o.stateNode = null, o.updateQueue = null;
    }
    function Wr(o, l, h) {
      for (h = h.child; h !== null; )
        k2(
          o,
          l,
          h
        ), h = h.sibling;
    }
    function k2(o, l, h) {
      if (Ki && typeof Ki.onCommitFiberUnmount == "function")
        try {
          Ki.onCommitFiberUnmount(th, h);
        } catch (ne) {
          _c || (_c = !0, console.error(
            "React instrumentation encountered an error: %o",
            ne
          ));
        }
      var y = Jr(), S = $s(), E = os(), j = Hs();
      switch (h.tag) {
        case 26:
          Sa || Ys(h, l), Wr(
            o,
            l,
            h
          ), h.memoizedState ? h.memoizedState.count-- : h.stateNode && (o = h.stateNode, o.parentNode.removeChild(o));
          break;
        case 27:
          Sa || Ys(h, l);
          var L = Ea, Q = Ks;
          Rd(h.type) && (Ea = h.stateNode, Ks = !1), Wr(
            o,
            l,
            h
          ), Ce(
            h,
            Eu,
            h.stateNode
          ), Ea = L, Ks = Q;
          break;
        case 5:
          Sa || Ys(h, l);
        case 6:
          if (L = Ea, Q = Ks, Ea = null, Wr(
            o,
            l,
            h
          ), Ea = L, Ks = Q, Ea !== null)
            if (Ks)
              try {
                Ce(
                  h,
                  $3,
                  Ea,
                  h.stateNode
                );
              } catch (ne) {
                pn(
                  h,
                  l,
                  ne
                );
              }
            else
              try {
                Ce(
                  h,
                  U3,
                  Ea,
                  h.stateNode
                );
              } catch (ne) {
                pn(
                  h,
                  l,
                  ne
                );
              }
          break;
        case 18:
          Ea !== null && (Ks ? (o = Ea, Yf(
            o.nodeType === 9 ? o.body : o.nodeName === "HTML" ? o.ownerDocument.body : o,
            h.stateNode
          ), Zf(o)) : Yf(Ea, h.stateNode));
          break;
        case 4:
          L = Ea, Q = Ks, Ea = h.stateNode.containerInfo, Ks = !0, Wr(
            o,
            l,
            h
          ), Ea = L, Ks = Q;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          xd(
            Es,
            h,
            l
          ), Sa || kv(
            h,
            l,
            Fl
          ), Wr(
            o,
            l,
            h
          );
          break;
        case 1:
          Sa || (Ys(h, l), L = h.stateNode, typeof L.componentWillUnmount == "function" && Pv(
            h,
            l,
            L
          )), Wr(
            o,
            l,
            h
          );
          break;
        case 21:
          Wr(
            o,
            l,
            h
          );
          break;
        case 22:
          Sa = (L = Sa) || h.memoizedState !== null, Wr(
            o,
            l,
            h
          ), Sa = L;
          break;
        default:
          Wr(
            o,
            l,
            h
          );
      }
      (h.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && (Li || 0.05 < Ri) && yl(
        h,
        zt,
        Gt,
        Ri,
        fi
      ), da(y), as(S), fi = E, Li = j;
    }
    function j2(o, l) {
      if (l.memoizedState === null && (o = l.alternate, o !== null && (o = o.memoizedState, o !== null))) {
        o = o.dehydrated;
        try {
          Ce(
            l,
            ay,
            o
          );
        } catch (h) {
          pn(l, l.return, h);
        }
      }
    }
    function P2(o, l) {
      if (l.memoizedState === null && (o = l.alternate, o !== null && (o = o.memoizedState, o !== null && (o = o.dehydrated, o !== null))))
        try {
          Ce(
            l,
            rx,
            o
          );
        } catch (h) {
          pn(l, l.return, h);
        }
    }
    function T3(o) {
      switch (o.tag) {
        case 31:
        case 13:
        case 19:
          var l = o.stateNode;
          return l === null && (l = o.stateNode = new xj()), l;
        case 22:
          return o = o.stateNode, l = o._retryCache, l === null && (l = o._retryCache = new xj()), l;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + o.tag + "). This is a bug in React."
          );
      }
    }
    function Ed(o, l) {
      var h = T3(o);
      l.forEach(function(y) {
        if (!h.has(y)) {
          if (h.add(y), Ac)
            if (Wy !== null && Qy !== null)
              Sp(Qy, Wy);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          var S = qf.bind(null, o, y);
          y.then(S, S);
        }
      });
    }
    function xo(o, l) {
      var h = l.deletions;
      if (h !== null)
        for (var y = 0; y < h.length; y++) {
          var S = o, E = l, j = h[y], L = Jr(), Q = E;
          e:
            for (; Q !== null; ) {
              switch (Q.tag) {
                case 27:
                  if (Rd(Q.type)) {
                    Ea = Q.stateNode, Ks = !1;
                    break e;
                  }
                  break;
                case 5:
                  Ea = Q.stateNode, Ks = !1;
                  break e;
                case 3:
                case 4:
                  Ea = Q.stateNode.containerInfo, Ks = !0;
                  break e;
              }
              Q = Q.return;
            }
          if (Ea === null)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          k2(S, E, j), Ea = null, Ks = !1, (j.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && 0.05 < Gt - zt && Fs(
            j,
            zt,
            Gt,
            "Unmount"
          ), da(L), S = j, E = S.alternate, E !== null && (E.return = null), S.return = null;
        }
      if (l.subtreeFlags & 13886)
        for (l = l.child; l !== null; )
          Vm(l, o), l = l.sibling;
    }
    function Vm(o, l) {
      var h = Jr(), y = $s(), S = os(), E = Hs(), j = o.alternate, L = o.flags;
      switch (o.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          xo(l, o), So(o), L & 4 && (xd(
            Es | jc,
            o,
            o.return
          ), vu(Es | jc, o), kv(
            o,
            o.return,
            Fl | jc
          ));
          break;
        case 1:
          if (xo(l, o), So(o), L & 512 && (Sa || j === null || Ys(j, j.return)), L & 64 && ph && (L = o.updateQueue, L !== null && (j = L.callbacks, j !== null))) {
            var Q = L.shared.hiddenCallbacks;
            L.shared.hiddenCallbacks = Q === null ? j : Q.concat(j);
          }
          break;
        case 26:
          if (Q = Ru, xo(l, o), So(o), L & 512 && (Sa || j === null || Ys(j, j.return)), L & 4) {
            var ne = j !== null ? j.memoizedState : null;
            if (L = o.memoizedState, j === null)
              if (L === null)
                if (o.stateNode === null) {
                  e: {
                    L = o.type, j = o.memoizedProps, Q = Q.ownerDocument || Q;
                    t:
                      switch (L) {
                        case "title":
                          ne = Q.getElementsByTagName(
                            "title"
                          )[0], (!ne || ne[Hp] || ne[ni] || ne.namespaceURI === mn || ne.hasAttribute("itemprop")) && (ne = Q.createElement(L), Q.head.insertBefore(
                            ne,
                            Q.querySelector(
                              "head > title"
                            )
                          )), ti(ne, L, j), ne[ni] = o, Ke(ne), L = ne;
                          break e;
                        case "link":
                          var be = Mp(
                            "link",
                            "href",
                            Q
                          ).get(L + (j.href || ""));
                          if (be) {
                            for (var Ee = 0; Ee < be.length; Ee++)
                              if (ne = be[Ee], ne.getAttribute("href") === (j.href == null || j.href === "" ? null : j.href) && ne.getAttribute("rel") === (j.rel == null ? null : j.rel) && ne.getAttribute("title") === (j.title == null ? null : j.title) && ne.getAttribute("crossorigin") === (j.crossOrigin == null ? null : j.crossOrigin)) {
                                be.splice(Ee, 1);
                                break t;
                              }
                          }
                          ne = Q.createElement(L), ti(ne, L, j), Q.head.appendChild(
                            ne
                          );
                          break;
                        case "meta":
                          if (be = Mp(
                            "meta",
                            "content",
                            Q
                          ).get(L + (j.content || ""))) {
                            for (Ee = 0; Ee < be.length; Ee++)
                              if (ne = be[Ee], wt(
                                j.content,
                                "content"
                              ), ne.getAttribute("content") === (j.content == null ? null : "" + j.content) && ne.getAttribute("name") === (j.name == null ? null : j.name) && ne.getAttribute("property") === (j.property == null ? null : j.property) && ne.getAttribute("http-equiv") === (j.httpEquiv == null ? null : j.httpEquiv) && ne.getAttribute("charset") === (j.charSet == null ? null : j.charSet)) {
                                be.splice(Ee, 1);
                                break t;
                              }
                          }
                          ne = Q.createElement(L), ti(ne, L, j), Q.head.appendChild(
                            ne
                          );
                          break;
                        default:
                          throw Error(
                            'getNodesForType encountered a type it did not expect: "' + L + '". This is a bug in React.'
                          );
                      }
                    ne[ni] = o, Ke(ne), L = ne;
                  }
                  o.stateNode = L;
                } else
                  nA(
                    Q,
                    o.type,
                    o.stateNode
                  );
              else
                o.stateNode = ly(
                  Q,
                  L,
                  o.memoizedProps
                );
            else
              ne !== L ? (ne === null ? j.stateNode !== null && (j = j.stateNode, j.parentNode.removeChild(j)) : ne.count--, L === null ? nA(
                Q,
                o.type,
                o.stateNode
              ) : ly(
                Q,
                L,
                o.memoizedProps
              )) : L === null && o.stateNode !== null && Lv(
                o,
                o.memoizedProps,
                j.memoizedProps
              );
          }
          break;
        case 27:
          xo(l, o), So(o), L & 512 && (Sa || j === null || Ys(j, j.return)), j !== null && L & 4 && Lv(
            o,
            o.memoizedProps,
            j.memoizedProps
          );
          break;
        case 5:
          if (xo(l, o), So(o), L & 512 && (Sa || j === null || Ys(j, j.return)), o.flags & 32) {
            Q = o.stateNode;
            try {
              Ce(
                o,
                iy,
                Q
              );
            } catch (yt) {
              pn(o, o.return, yt);
            }
          }
          L & 4 && o.stateNode != null && (Q = o.memoizedProps, Lv(
            o,
            Q,
            j !== null ? j.memoizedProps : Q
          )), L & 1024 && (MR = !0, o.type !== "form" && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          if (xo(l, o), So(o), L & 4) {
            if (o.stateNode === null)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            L = o.memoizedProps, j = j !== null ? j.memoizedProps : L, Q = o.stateNode;
            try {
              Ce(
                o,
                VO,
                Q,
                j,
                L
              );
            } catch (yt) {
              pn(o, o.return, yt);
            }
          }
          break;
        case 3:
          if (Q = rc(), cC = null, ne = Ru, Ru = oy(l.containerInfo), xo(l, o), Ru = ne, So(o), L & 4 && j !== null && j.memoizedState.isDehydrated)
            try {
              Ce(
                o,
                nx,
                l.containerInfo
              );
            } catch (yt) {
              pn(o, o.return, yt);
            }
          MR && (MR = !1, O3(o)), l.effectDuration += Jh(
            Q
          );
          break;
        case 4:
          L = Ru, Ru = oy(
            o.stateNode.containerInfo
          ), xo(l, o), So(o), Ru = L;
          break;
        case 12:
          L = rc(), xo(l, o), So(o), o.stateNode.effectDuration += mo(L);
          break;
        case 31:
          xo(l, o), So(o), L & 4 && (L = o.updateQueue, L !== null && (o.updateQueue = null, Ed(o, L)));
          break;
        case 13:
          xo(l, o), So(o), o.child.flags & 8192 && o.memoizedState !== null != (j !== null && j.memoizedState !== null) && (XA = va()), L & 4 && (L = o.updateQueue, L !== null && (o.updateQueue = null, Ed(o, L)));
          break;
        case 22:
          Q = o.memoizedState !== null;
          var he = j !== null && j.memoizedState !== null, Le = ph, dt = Sa;
          if (ph = Le || Q, Sa = dt || he, xo(l, o), Sa = dt, ph = Le, he && !Q && !Le && !dt && (o.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && 0.05 < Gt - zt && ev(
            o,
            zt,
            Gt
          ), So(o), L & 8192)
            e:
              for (l = o.stateNode, l._visibility = Q ? l._visibility & ~Bx : l._visibility | Bx, !Q || j === null || he || ph || Sa || (_d(o), (o.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && 0.05 < Gt - zt && Fs(
                o,
                zt,
                Gt,
                "Disconnect"
              )), j = null, l = o; ; ) {
                if (l.tag === 5 || l.tag === 26) {
                  if (j === null) {
                    he = j = l;
                    try {
                      ne = he.stateNode, Q ? Ce(
                        he,
                        q3,
                        ne
                      ) : Ce(
                        he,
                        X3,
                        he.stateNode,
                        he.memoizedProps
                      );
                    } catch (yt) {
                      pn(he, he.return, yt);
                    }
                  }
                } else if (l.tag === 6) {
                  if (j === null) {
                    he = l;
                    try {
                      be = he.stateNode, Q ? Ce(
                        he,
                        G3,
                        be
                      ) : Ce(
                        he,
                        W3,
                        be,
                        he.memoizedProps
                      );
                    } catch (yt) {
                      pn(he, he.return, yt);
                    }
                  }
                } else if (l.tag === 18) {
                  if (j === null) {
                    he = l;
                    try {
                      Ee = he.stateNode, Q ? Ce(
                        he,
                        H3,
                        Ee
                      ) : Ce(
                        he,
                        Y3,
                        he.stateNode
                      );
                    } catch (yt) {
                      pn(he, he.return, yt);
                    }
                  }
                } else if ((l.tag !== 22 && l.tag !== 23 || l.memoizedState === null || l === o) && l.child !== null) {
                  l.child.return = l, l = l.child;
                  continue;
                }
                if (l === o)
                  break e;
                for (; l.sibling === null; ) {
                  if (l.return === null || l.return === o)
                    break e;
                  j === l && (j = null), l = l.return;
                }
                j === l && (j = null), l.sibling.return = l.return, l = l.sibling;
              }
          L & 4 && (L = o.updateQueue, L !== null && (j = L.retryQueue, j !== null && (L.retryQueue = null, Ed(o, j))));
          break;
        case 19:
          xo(l, o), So(o), L & 4 && (L = o.updateQueue, L !== null && (o.updateQueue = null, Ed(o, L)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          xo(l, o), So(o);
      }
      (o.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && ((Li || 0.05 < Ri) && yl(
        o,
        zt,
        Gt,
        Ri,
        fi
      ), o.alternate === null && o.return !== null && o.return.alternate !== null && 0.05 < Gt - zt && (I2(
        o.return.alternate,
        o.return
      ) || Fs(
        o,
        zt,
        Gt,
        "Mount"
      ))), da(h), as(y), fi = S, Li = E;
    }
    function So(o) {
      var l = o.flags;
      if (l & 2) {
        try {
          Ce(o, N2, o);
        } catch (h) {
          pn(o, o.return, h);
        }
        o.flags &= -3;
      }
      l & 4096 && (o.flags &= -4097);
    }
    function O3(o) {
      if (o.subtreeFlags & 1024)
        for (o = o.child; o !== null; ) {
          var l = o;
          O3(l), l.tag === 5 && l.flags & 1024 && l.stateNode.reset(), o = o.sibling;
        }
    }
    function hs(o, l) {
      if (l.subtreeFlags & 8772)
        for (l = l.child; l !== null; )
          zv(o, l.alternate, l), l = l.sibling;
    }
    function Fv(o) {
      var l = Jr(), h = $s(), y = os(), S = Hs();
      switch (o.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          kv(
            o,
            o.return,
            Fl
          ), _d(o);
          break;
        case 1:
          Ys(o, o.return);
          var E = o.stateNode;
          typeof E.componentWillUnmount == "function" && Pv(
            o,
            o.return,
            E
          ), _d(o);
          break;
        case 27:
          Ce(
            o,
            Eu,
            o.stateNode
          );
        case 26:
        case 5:
          Ys(o, o.return), _d(o);
          break;
        case 22:
          o.memoizedState === null && _d(o);
          break;
        case 30:
          _d(o);
          break;
        default:
          _d(o);
      }
      (o.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && (Li || 0.05 < Ri) && yl(
        o,
        zt,
        Gt,
        Ri,
        fi
      ), da(l), as(h), fi = y, Li = S;
    }
    function _d(o) {
      for (o = o.child; o !== null; )
        Fv(o), o = o.sibling;
    }
    function L2(o, l, h, y) {
      var S = Jr(), E = $s(), j = os(), L = Hs(), Q = h.flags;
      switch (h.tag) {
        case 0:
        case 11:
        case 15:
          Ol(
            o,
            h,
            y
          ), E3(h, Fl);
          break;
        case 1:
          if (Ol(
            o,
            h,
            y
          ), l = h.stateNode, typeof l.componentDidMount == "function" && Ce(
            h,
            bR,
            h,
            l
          ), l = h.updateQueue, l !== null) {
            o = h.stateNode;
            try {
              Ce(
                h,
                i2,
                l,
                o
              );
            } catch (ne) {
              pn(h, h.return, ne);
            }
          }
          y && Q & 64 && O2(h), Uf(h, h.return);
          break;
        case 27:
          M2(h);
        case 26:
        case 5:
          Ol(
            o,
            h,
            y
          ), y && l === null && Q & 4 && Sd(h), Uf(h, h.return);
          break;
        case 12:
          if (y && Q & 4) {
            Q = rc(), Ol(
              o,
              h,
              y
            ), y = h.stateNode, y.effectDuration += mo(Q);
            try {
              Ce(
                h,
                R2,
                h,
                l,
                Kp,
                y.effectDuration
              );
            } catch (ne) {
              pn(h, h.return, ne);
            }
          } else
            Ol(
              o,
              h,
              y
            );
          break;
        case 31:
          Ol(
            o,
            h,
            y
          ), y && Q & 4 && j2(o, h);
          break;
        case 13:
          Ol(
            o,
            h,
            y
          ), y && Q & 4 && P2(o, h);
          break;
        case 22:
          h.memoizedState === null && Ol(
            o,
            h,
            y
          ), Uf(h, h.return);
          break;
        case 30:
          break;
        default:
          Ol(
            o,
            h,
            y
          );
      }
      (h.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && (Li || 0.05 < Ri) && yl(
        h,
        zt,
        Gt,
        Ri,
        fi
      ), da(S), as(E), fi = j, Li = L;
    }
    function Ol(o, l, h) {
      for (h = h && (l.subtreeFlags & 8772) !== 0, l = l.child; l !== null; )
        L2(
          o,
          l.alternate,
          l,
          h
        ), l = l.sibling;
    }
    function Um(o, l) {
      var h = null;
      o !== null && o.memoizedState !== null && o.memoizedState.cachePool !== null && (h = o.memoizedState.cachePool.pool), o = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (o = l.memoizedState.cachePool.pool), o !== h && (o != null && Af(o), h != null && pm(h));
    }
    function $m(o, l) {
      o = null, l.alternate !== null && (o = l.alternate.memoizedState.cache), l = l.memoizedState.cache, l !== o && (Af(l), o != null && pm(o));
    }
    function ps(o, l, h, y, S) {
      if (l.subtreeFlags & 10256 || l.actualDuration !== 0 && (l.alternate === null || l.alternate.child !== l.child))
        for (l = l.child; l !== null; ) {
          var E = l.sibling;
          B2(
            o,
            l,
            h,
            y,
            E !== null ? E.actualStartTime : S
          ), l = E;
        }
    }
    function B2(o, l, h, y, S) {
      var E = Jr(), j = $s(), L = os(), Q = Hs(), ne = Xp, be = l.flags;
      switch (l.tag) {
        case 0:
        case 11:
        case 15:
          (l.mode & bn) !== Wt && 0 < l.actualStartTime && l.flags & 1 && tv(
            l,
            l.actualStartTime,
            S,
            Ia,
            h
          ), ps(
            o,
            l,
            h,
            y,
            S
          ), be & 2048 && Bm(l, _s | jc);
          break;
        case 1:
          (l.mode & bn) !== Wt && 0 < l.actualStartTime && (l.flags & 128 ? Uw(
            l,
            l.actualStartTime,
            S,
            []
          ) : l.flags & 1 && tv(
            l,
            l.actualStartTime,
            S,
            Ia,
            h
          )), ps(
            o,
            l,
            h,
            y,
            S
          );
          break;
        case 3:
          var Ee = rc(), he = Ia;
          Ia = l.alternate !== null && l.alternate.memoizedState.isDehydrated && (l.flags & 256) === 0, ps(
            o,
            l,
            h,
            y,
            S
          ), Ia = he, be & 2048 && (h = null, l.alternate !== null && (h = l.alternate.memoizedState.cache), y = l.memoizedState.cache, y !== h && (Af(y), h != null && pm(h))), o.passiveEffectDuration += Jh(
            Ee
          );
          break;
        case 12:
          if (be & 2048) {
            be = rc(), ps(
              o,
              l,
              h,
              y,
              S
            ), o = l.stateNode, o.passiveEffectDuration += mo(be);
            try {
              Ce(
                l,
                C3,
                l,
                l.alternate,
                Kp,
                o.passiveEffectDuration
              );
            } catch (Le) {
              pn(l, l.return, Le);
            }
          } else
            ps(
              o,
              l,
              h,
              y,
              S
            );
          break;
        case 31:
          be = Ia, Ee = l.alternate !== null ? l.alternate.memoizedState : null, he = l.memoizedState, Ee !== null && he === null ? (he = l.deletions, he !== null && 0 < he.length && he[0].tag === 18 ? (Ia = !1, Ee = Ee.hydrationErrors, Ee !== null && Uw(
            l,
            l.actualStartTime,
            S,
            Ee
          )) : Ia = !0) : Ia = !1, ps(
            o,
            l,
            h,
            y,
            S
          ), Ia = be;
          break;
        case 13:
          be = Ia, Ee = l.alternate !== null ? l.alternate.memoizedState : null, he = l.memoizedState, Ee === null || Ee.dehydrated === null || he !== null && he.dehydrated !== null ? Ia = !1 : (he = l.deletions, he !== null && 0 < he.length && he[0].tag === 18 ? (Ia = !1, Ee = Ee.hydrationErrors, Ee !== null && Uw(
            l,
            l.actualStartTime,
            S,
            Ee
          )) : Ia = !0), ps(
            o,
            l,
            h,
            y,
            S
          ), Ia = be;
          break;
        case 23:
          break;
        case 22:
          he = l.stateNode, Ee = l.alternate, l.memoizedState !== null ? he._visibility & ih ? ps(
            o,
            l,
            h,
            y,
            S
          ) : $f(
            o,
            l,
            h,
            y,
            S
          ) : he._visibility & ih ? ps(
            o,
            l,
            h,
            y,
            S
          ) : (he._visibility |= ih, Ad(
            o,
            l,
            h,
            y,
            (l.subtreeFlags & 10256) !== 0 || l.actualDuration !== 0 && (l.alternate === null || l.alternate.child !== l.child),
            S
          ), (l.mode & bn) === Wt || Ia || (o = l.actualStartTime, 0 <= o && 0.05 < S - o && ev(l, o, S), 0 <= zt && 0 <= Gt && 0.05 < Gt - zt && ev(
            l,
            zt,
            Gt
          ))), be & 2048 && Um(
            Ee,
            l
          );
          break;
        case 24:
          ps(
            o,
            l,
            h,
            y,
            S
          ), be & 2048 && $m(l.alternate, l);
          break;
        default:
          ps(
            o,
            l,
            h,
            y,
            S
          );
      }
      (l.mode & bn) !== Wt && ((o = !Ia && l.alternate === null && l.return !== null && l.return.alternate !== null) && (h = l.actualStartTime, 0 <= h && 0.05 < S - h && Fs(
        l,
        h,
        S,
        "Mount"
      )), 0 <= zt && 0 <= Gt && ((Li || 0.05 < Ri) && yl(
        l,
        zt,
        Gt,
        Ri,
        fi
      ), o && 0.05 < Gt - zt && Fs(
        l,
        zt,
        Gt,
        "Mount"
      ))), da(E), as(j), fi = L, Li = Q, Xp = ne;
    }
    function Ad(o, l, h, y, S, E) {
      for (S = S && ((l.subtreeFlags & 10256) !== 0 || l.actualDuration !== 0 && (l.alternate === null || l.alternate.child !== l.child)), l = l.child; l !== null; ) {
        var j = l.sibling;
        Hm(
          o,
          l,
          h,
          y,
          S,
          j !== null ? j.actualStartTime : E
        ), l = j;
      }
    }
    function Hm(o, l, h, y, S, E) {
      var j = Jr(), L = $s(), Q = os(), ne = Hs(), be = Xp;
      S && (l.mode & bn) !== Wt && 0 < l.actualStartTime && l.flags & 1 && tv(
        l,
        l.actualStartTime,
        E,
        Ia,
        h
      );
      var Ee = l.flags;
      switch (l.tag) {
        case 0:
        case 11:
        case 15:
          Ad(
            o,
            l,
            h,
            y,
            S,
            E
          ), Bm(l, _s);
          break;
        case 23:
          break;
        case 22:
          var he = l.stateNode;
          l.memoizedState !== null ? he._visibility & ih ? Ad(
            o,
            l,
            h,
            y,
            S,
            E
          ) : $f(
            o,
            l,
            h,
            y,
            E
          ) : (he._visibility |= ih, Ad(
            o,
            l,
            h,
            y,
            S,
            E
          )), S && Ee & 2048 && Um(
            l.alternate,
            l
          );
          break;
        case 24:
          Ad(
            o,
            l,
            h,
            y,
            S,
            E
          ), S && Ee & 2048 && $m(l.alternate, l);
          break;
        default:
          Ad(
            o,
            l,
            h,
            y,
            S,
            E
          );
      }
      (l.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && (Li || 0.05 < Ri) && yl(
        l,
        zt,
        Gt,
        Ri,
        fi
      ), da(j), as(L), fi = Q, Li = ne, Xp = be;
    }
    function $f(o, l, h, y, S) {
      if (l.subtreeFlags & 10256 || l.actualDuration !== 0 && (l.alternate === null || l.alternate.child !== l.child))
        for (var E = l.child; E !== null; ) {
          l = E.sibling;
          var j = o, L = h, Q = y, ne = l !== null ? l.actualStartTime : S, be = Xp;
          (E.mode & bn) !== Wt && 0 < E.actualStartTime && E.flags & 1 && tv(
            E,
            E.actualStartTime,
            ne,
            Ia,
            L
          );
          var Ee = E.flags;
          switch (E.tag) {
            case 22:
              $f(
                j,
                E,
                L,
                Q,
                ne
              ), Ee & 2048 && Um(E.alternate, E);
              break;
            case 24:
              $f(
                j,
                E,
                L,
                Q,
                ne
              ), Ee & 2048 && $m(E.alternate, E);
              break;
            default:
              $f(
                j,
                E,
                L,
                Q,
                ne
              );
          }
          Xp = be, E = l;
        }
    }
    function Hf(o, l, h) {
      if (o.subtreeFlags & iS)
        for (o = o.child; o !== null; )
          Vv(
            o,
            l,
            h
          ), o = o.sibling;
    }
    function Vv(o, l, h) {
      switch (o.tag) {
        case 26:
          Hf(
            o,
            l,
            h
          ), o.flags & iS && o.memoizedState !== null && lx(
            h,
            Ru,
            o.memoizedState,
            o.memoizedProps
          );
          break;
        case 5:
          Hf(
            o,
            l,
            h
          );
          break;
        case 3:
        case 4:
          var y = Ru;
          Ru = oy(
            o.stateNode.containerInfo
          ), Hf(
            o,
            l,
            h
          ), Ru = y;
          break;
        case 22:
          o.memoizedState === null && (y = o.alternate, y !== null && y.memoizedState !== null ? (y = iS, iS = 16777216, Hf(
            o,
            l,
            h
          ), iS = y) : Hf(
            o,
            l,
            h
          ));
          break;
        default:
          Hf(
            o,
            l,
            h
          );
      }
    }
    function z2(o) {
      var l = o.alternate;
      if (l !== null && (o = l.child, o !== null)) {
        l.child = null;
        do
          l = o.sibling, o.sibling = null, o = l;
        while (o !== null);
      }
    }
    function ms(o) {
      var l = o.deletions;
      if (o.flags & 16) {
        if (l !== null)
          for (var h = 0; h < l.length; h++) {
            var y = l[h], S = Jr();
            to = y, mc(
              y,
              o
            ), (y.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && 0.05 < Gt - zt && Fs(
              y,
              zt,
              Gt,
              "Unmount"
            ), da(S);
          }
        z2(o);
      }
      if (o.subtreeFlags & 10256)
        for (o = o.child; o !== null; )
          Uv(o), o = o.sibling;
    }
    function Uv(o) {
      var l = Jr(), h = $s(), y = os(), S = Hs();
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          ms(o), o.flags & 2048 && jv(
            o,
            o.return,
            _s | jc
          );
          break;
        case 3:
          var E = rc();
          ms(o), o.stateNode.passiveEffectDuration += Jh(E);
          break;
        case 12:
          E = rc(), ms(o), o.stateNode.passiveEffectDuration += mo(E);
          break;
        case 22:
          E = o.stateNode, o.memoizedState !== null && E._visibility & ih && (o.return === null || o.return.tag !== 13) ? (E._visibility &= ~ih, $v(o), (o.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && 0.05 < Gt - zt && Fs(
            o,
            zt,
            Gt,
            "Disconnect"
          )) : ms(o);
          break;
        default:
          ms(o);
      }
      (o.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && (Li || 0.05 < Ri) && yl(
        o,
        zt,
        Gt,
        Ri,
        fi
      ), da(l), as(h), Li = S, fi = y;
    }
    function $v(o) {
      var l = o.deletions;
      if (o.flags & 16) {
        if (l !== null)
          for (var h = 0; h < l.length; h++) {
            var y = l[h], S = Jr();
            to = y, mc(
              y,
              o
            ), (y.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && 0.05 < Gt - zt && Fs(
              y,
              zt,
              Gt,
              "Unmount"
            ), da(S);
          }
        z2(o);
      }
      for (o = o.child; o !== null; )
        F2(o), o = o.sibling;
    }
    function F2(o) {
      var l = Jr(), h = $s(), y = os(), S = Hs();
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          jv(
            o,
            o.return,
            _s
          ), $v(o);
          break;
        case 22:
          var E = o.stateNode;
          E._visibility & ih && (E._visibility &= ~ih, $v(o));
          break;
        default:
          $v(o);
      }
      (o.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && (Li || 0.05 < Ri) && yl(
        o,
        zt,
        Gt,
        Ri,
        fi
      ), da(l), as(h), Li = S, fi = y;
    }
    function mc(o, l) {
      for (; to !== null; ) {
        var h = to, y = h, S = l, E = Jr(), j = $s(), L = os(), Q = Hs();
        switch (y.tag) {
          case 0:
          case 11:
          case 15:
            jv(
              y,
              S,
              _s
            );
            break;
          case 23:
          case 22:
            y.memoizedState !== null && y.memoizedState.cachePool !== null && (S = y.memoizedState.cachePool.pool, S != null && Af(S));
            break;
          case 24:
            pm(y.memoizedState.cache);
        }
        if ((y.mode & bn) !== Wt && 0 <= zt && 0 <= Gt && (Li || 0.05 < Ri) && yl(
          y,
          zt,
          Gt,
          Ri,
          fi
        ), da(E), as(j), Li = Q, fi = L, y = h.child, y !== null)
          y.return = h, to = y;
        else
          e:
            for (h = o; to !== null; ) {
              if (y = to, E = y.sibling, j = y.return, ji(y), y === h) {
                to = null;
                break e;
              }
              if (E !== null) {
                E.return = j, to = E;
                break e;
              }
              to = j;
            }
      }
    }
    function V2() {
      qte.forEach(function(o) {
        return o();
      });
    }
    function U2() {
      var o = typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
      return o || ze.actQueue === null || console.error(
        "The current testing environment is not configured to support act(...)"
      ), o;
    }
    function Za(o) {
      if ((Zn & ka) !== no && xn !== 0)
        return xn & -xn;
      var l = ze.T;
      return l !== null ? (l._updatedFibers || (l._updatedFibers = /* @__PURE__ */ new Set()), l._updatedFibers.add(o), K2()) : sa();
    }
    function vp() {
      if (el === 0)
        if (!(xn & 536870912) || Fn) {
          var o = h1;
          h1 <<= 1, !(h1 & 3932160) && (h1 = 262144), el = o;
        } else
          el = 536870912;
      return o = zl.current, o !== null && (o.flags |= 32), el;
    }
    function Kt(o, l, h) {
      if (Jy && console.error("useInsertionEffect must not schedule updates."), $R && (KA = !0), (o === Hr && (Tr === R1 || Tr === D1) || o.cancelPendingCommit !== null) && (gc(o, 0), Xs(
        o,
        xn,
        el,
        !1
      )), Rt(o, h), (Zn & ka) !== no && o === Hr) {
        if (Ec)
          switch (l.tag) {
            case 0:
            case 11:
            case 15:
              o = _n && H(_n) || "Unknown", Pj.has(o) || (Pj.add(o), l = H(l) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                l,
                o,
                o
              ));
              break;
            case 1:
              jj || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), jj = !0);
          }
      } else
        Ac && kn(o, l, h), Xm(l), o === Hr && ((Zn & ka) === no && (o0 |= h), Di === r0 && Xs(
          o,
          xn,
          el,
          !1
        )), Uo(o);
    }
    function R3(o, l, h) {
      if ((Zn & (ka | Vl)) !== no)
        throw Error("Should not already be working.");
      if (xn !== 0 && _n !== null) {
        var y = _n, S = va();
        switch (O9) {
          case sS:
          case R1:
            var E = Hx;
            ri && ((y = y._debugTask) ? y.run(
              console.timeStamp.bind(
                console,
                "Suspended",
                E,
                S,
                Tc,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Suspended",
              E,
              S,
              Tc,
              void 0,
              "primary-light"
            ));
            break;
          case D1:
            E = Hx, ri && ((y = y._debugTask) ? y.run(
              console.timeStamp.bind(
                console,
                "Action",
                E,
                S,
                Tc,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Action",
              E,
              S,
              Tc,
              void 0,
              "primary-light"
            ));
            break;
          default:
            ri && (y = S - Hx, 3 > y || console.timeStamp(
              "Blocked",
              Hx,
              S,
              Tc,
              void 0,
              5 > y ? "primary-light" : 10 > y ? "primary" : 100 > y ? "primary-dark" : "error"
            ));
        }
      }
      E = (h = !h && (l & 127) === 0 && (l & o.expiredLanes) === 0 || $e(o, l)) ? yu(o, l) : wp(o, l, !0);
      var j = h;
      do {
        if (E === mh) {
          Zy && !h && Xs(o, l, 0, !1), l = Tr, Hx = ba(), O9 = l;
          break;
        } else {
          if (y = va(), S = o.current.alternate, j && !N3(S)) {
            vl(l), S = eo, E = y, !ri || E <= S || (Xi ? Xi.run(
              console.timeStamp.bind(
                console,
                "Teared Render",
                S,
                E,
                $n,
                zn,
                "error"
              )
            ) : console.timeStamp(
              "Teared Render",
              S,
              E,
              $n,
              zn,
              "error"
            )), Cd(l, y), E = wp(o, l, !1), j = !1;
            continue;
          }
          if (E === O1) {
            if (j = l, o.errorRecoveryDisabledLanes & j)
              var L = 0;
            else
              L = o.pendingLanes & -536870913, L = L !== 0 ? L : L & 536870912 ? 536870912 : 0;
            if (L !== 0) {
              vl(l), $w(
                eo,
                y,
                l,
                Xi
              ), Cd(l, y), l = L;
              e: {
                y = o, E = j, j = cS;
                var Q = y.current.memoizedState.isDehydrated;
                if (Q && (gc(y, L).flags |= 256), L = wp(
                  y,
                  L,
                  !1
                ), L !== O1) {
                  if (jR && !Q) {
                    y.errorRecoveryDisabledLanes |= E, o0 |= E, E = r0;
                    break e;
                  }
                  y = As, As = j, y !== null && (As === null ? As = y : As.push.apply(
                    As,
                    y
                  ));
                }
                E = L;
              }
              if (j = !1, E !== O1)
                continue;
              y = va();
            }
          }
          if (E === oS) {
            vl(l), $w(
              eo,
              y,
              l,
              Xi
            ), Cd(l, y), gc(o, 0), Xs(o, l, 0, !0);
            break;
          }
          e: {
            switch (h = o, E) {
              case mh:
              case oS:
                throw Error("Root did not complete. This is a bug in React.");
              case r0:
                if ((l & 4194048) !== l)
                  break;
              case HA:
                vl(l), a3(
                  eo,
                  y,
                  l,
                  Xi
                ), Cd(l, y), S = l, S & 127 ? RA = y : S & 4194048 && (DA = y), Xs(
                  h,
                  l,
                  el,
                  !i0
                );
                break e;
              case O1:
                As = null;
                break;
              case $A:
              case Sj:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (ze.actQueue !== null)
              Vr(
                h,
                S,
                l,
                As,
                uS,
                YA,
                el,
                o0,
                N1,
                E,
                null,
                null,
                eo,
                y
              );
            else {
              if ((l & 62914560) === l && (j = XA + Aj - va(), 10 < j)) {
                if (Xs(
                  h,
                  l,
                  el,
                  !i0
                ), He(h, 0, !0) !== 0)
                  break e;
                Du = l, h.timeoutHandle = Hj(
                  D3.bind(
                    null,
                    h,
                    S,
                    As,
                    uS,
                    YA,
                    l,
                    el,
                    o0,
                    N1,
                    i0,
                    E,
                    "Throttled",
                    eo,
                    y
                  ),
                  j
                );
                break e;
              }
              D3(
                h,
                S,
                As,
                uS,
                YA,
                l,
                el,
                o0,
                N1,
                i0,
                E,
                null,
                eo,
                y
              );
            }
          }
        }
        break;
      } while (1);
      Uo(o);
    }
    function D3(o, l, h, y, S, E, j, L, Q, ne, be, Ee, he, Le) {
      o.timeoutHandle = P1;
      var dt = l.subtreeFlags, yt = null;
      if ((dt & 8192 || (dt & 16785408) === 16785408) && (yt = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: zs
      }, Vv(l, E, yt), dt = (E & 62914560) === E ? XA - va() : (E & 4194048) === E ? _j - va() : 0, dt = cy(yt, dt), dt !== null)) {
        Du = E, o.cancelPendingCommit = dt(
          Vr.bind(
            null,
            o,
            l,
            E,
            h,
            y,
            S,
            j,
            L,
            Q,
            be,
            yt,
            yt.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < yt.count ? 0 < yt.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : yt.imgCount === 1 ? "Suspended on an Image" : 0 < yt.imgCount ? "Suspended on Images" : null,
            he,
            Le
          )
        ), Xs(
          o,
          E,
          j,
          !ne
        );
        return;
      }
      Vr(
        o,
        l,
        E,
        h,
        y,
        S,
        j,
        L,
        Q,
        be,
        yt,
        Ee,
        he,
        Le
      );
    }
    function N3(o) {
      for (var l = o; ; ) {
        var h = l.tag;
        if ((h === 0 || h === 11 || h === 15) && l.flags & 16384 && (h = l.updateQueue, h !== null && (h = h.stores, h !== null)))
          for (var y = 0; y < h.length; y++) {
            var S = h[y], E = S.getSnapshot;
            S = S.value;
            try {
              if (!xs(E(), S))
                return !1;
            } catch {
              return !1;
            }
          }
        if (h = l.child, l.subtreeFlags & 16384 && h !== null)
          h.return = l, l = h;
        else {
          if (l === o)
            break;
          for (; l.sibling === null; ) {
            if (l.return === null || l.return === o)
              return !0;
            l = l.return;
          }
          l.sibling.return = l.return, l = l.sibling;
        }
      }
      return !0;
    }
    function Xs(o, l, h, y) {
      l &= ~PR, l &= ~o0, o.suspendedLanes |= l, o.pingedLanes &= ~l, y && (o.warmLanes |= l), y = o.expirationTimes;
      for (var S = l; 0 < S; ) {
        var E = 31 - Na(S), j = 1 << E;
        y[E] = -1, S &= ~j;
      }
      h !== 0 && In(o, h, l);
    }
    function gs() {
      return (Zn & (ka | Vl)) === no ? (yc(0, !1), !1) : !0;
    }
    function Hv() {
      if (_n !== null) {
        if (Tr === Js)
          var o = _n.return;
        else
          o = _n, Zh(), dd(o), Uy = null, Jx = 0, o = _n;
        for (; o !== null; )
          T2(o.alternate, o), o = o.return;
        _n = null;
      }
    }
    function Cd(o, l) {
      o & 127 && (b1 = l), o & 4194048 && (ch = l), o & 62914560 && (C9 = l), o & 2080374784 && (T9 = l);
    }
    function gc(o, l) {
      ri && (console.timeStamp(
        "Blocking Track",
        3e-3,
        3e-3,
        "Blocking",
        zn,
        "primary-light"
      ), console.timeStamp(
        "Transition Track",
        3e-3,
        3e-3,
        "Transition",
        zn,
        "primary-light"
      ), console.timeStamp(
        "Suspense Track",
        3e-3,
        3e-3,
        "Suspense",
        zn,
        "primary-light"
      ), console.timeStamp(
        "Idle Track",
        3e-3,
        3e-3,
        "Idle",
        zn,
        "primary-light"
      ));
      var h = eo;
      if (eo = ba(), xn !== 0 && 0 < h) {
        if (vl(xn), Di === $A || Di === r0)
          a3(
            h,
            eo,
            l,
            Xi
          );
        else {
          var y = eo, S = Xi;
          if (ri && !(y <= h)) {
            var E = (l & 738197653) === l ? "tertiary-dark" : "primary-dark", j = (l & 536870912) === l ? "Prewarm" : (l & 201326741) === l ? "Interrupted Hydration" : "Interrupted Render";
            S ? S.run(
              console.timeStamp.bind(
                console,
                j,
                h,
                y,
                $n,
                zn,
                E
              )
            ) : console.timeStamp(
              j,
              h,
              y,
              $n,
              zn,
              E
            );
          }
        }
        Cd(xn, eo);
      }
      if (h = Xi, Xi = null, l & 127) {
        Xi = Vx, S = 0 <= Ld && Ld < b1 ? b1 : Ld, y = 0 <= w1 && w1 < b1 ? b1 : w1, E = 0 <= y ? y : 0 <= S ? S : eo, 0 <= RA ? (vl(2), o3(
          RA,
          E,
          l,
          h
        )) : NA & 127, h = S;
        var L = y, Q = Ux, ne = 0 < zy, be = Jp === Fx, Ee = Jp === OA;
        if (S = eo, y = Vx, E = hR, j = pR, ri) {
          if ($n = "Blocking", 0 < h ? h > S && (h = S) : h = S, 0 < L ? L > h && (L = h) : L = h, Q !== null && h > L) {
            var he = ne ? "secondary-light" : "warning";
            y ? y.run(
              console.timeStamp.bind(
                console,
                ne ? "Consecutive" : "Event: " + Q,
                L,
                h,
                $n,
                zn,
                he
              )
            ) : console.timeStamp(
              ne ? "Consecutive" : "Event: " + Q,
              L,
              h,
              $n,
              zn,
              he
            );
          }
          S > h && (L = be ? "error" : (l & 738197653) === l ? "tertiary-light" : "primary-light", be = Ee ? "Promise Resolved" : be ? "Cascading Update" : 5 < S - h ? "Update Blocked" : "Update", Ee = [], j != null && Ee.push(["Component name", j]), E != null && Ee.push(["Method name", E]), h = {
            start: h,
            end: S,
            detail: {
              devtools: {
                properties: Ee,
                track: $n,
                trackGroup: zn,
                color: L
              }
            }
          }, y ? y.run(
            performance.measure.bind(
              performance,
              be,
              h
            )
          ) : performance.measure(be, h));
        }
        Ld = -1.1, Jp = 0, pR = hR = null, RA = -1.1, zy = w1, w1 = -1.1, b1 = ba();
      }
      if (l & 4194048 && (Xi = $x, S = 0 <= uh && uh < ch ? ch : uh, h = 0 <= Ic && Ic < ch ? ch : Ic, y = 0 <= e0 && e0 < ch ? ch : e0, E = 0 <= y ? y : 0 <= h ? h : eo, 0 <= DA ? (vl(256), o3(
        DA,
        E,
        l,
        Xi
      )) : NA & 4194048, Ee = y, L = x1, Q = 0 < t0, ne = mR === OA, E = eo, y = $x, j = _9, be = A9, ri && ($n = "Transition", 0 < h ? h > E && (h = E) : h = E, 0 < S ? S > h && (S = h) : S = h, 0 < Ee ? Ee > S && (Ee = S) : Ee = S, S > Ee && L !== null && (he = Q ? "secondary-light" : "warning", y ? y.run(
        console.timeStamp.bind(
          console,
          Q ? "Consecutive" : "Event: " + L,
          Ee,
          S,
          $n,
          zn,
          he
        )
      ) : console.timeStamp(
        Q ? "Consecutive" : "Event: " + L,
        Ee,
        S,
        $n,
        zn,
        he
      )), h > S && (y ? y.run(
        console.timeStamp.bind(
          console,
          "Action",
          S,
          h,
          $n,
          zn,
          "primary-dark"
        )
      ) : console.timeStamp(
        "Action",
        S,
        h,
        $n,
        zn,
        "primary-dark"
      )), E > h && (S = ne ? "Promise Resolved" : 5 < E - h ? "Update Blocked" : "Update", Ee = [], be != null && Ee.push(["Component name", be]), j != null && Ee.push(["Method name", j]), h = {
        start: h,
        end: E,
        detail: {
          devtools: {
            properties: Ee,
            track: $n,
            trackGroup: zn,
            color: "primary-light"
          }
        }
      }, y ? y.run(
        performance.measure.bind(
          performance,
          S,
          h
        )
      ) : performance.measure(S, h))), Ic = uh = -1.1, mR = 0, DA = -1.1, t0 = e0, e0 = -1.1, ch = ba()), l & 62914560 && NA & 62914560 && (vl(4194304), Hw(C9, eo, gR)), l & 2080374784 && NA & 2080374784 && (vl(268435456), Hw(T9, eo, gR)), h = o.timeoutHandle, h !== P1 && (o.timeoutHandle = P1, ine(h)), h = o.cancelPendingCommit, h !== null && (o.cancelPendingCommit = null, h()), Du = 0, Hv(), Hr = o, _n = h = tc(
        o.current,
        null
      ), xn = l, Tr = Js, Ul = null, i0 = !1, Zy = $e(o, l), jR = !1, Di = mh, N1 = el = PR = o0 = a0 = 0, As = cS = null, YA = !1, l & 8 && (l |= l & 32), y = o.entangledLanes, y !== 0)
        for (o = o.entanglements, y &= l; 0 < y; )
          S = 31 - Na(y), E = 1 << S, l |= o[S], y &= ~E;
      return zd = l, nv(), o = y9(), 1e3 < o - v9 && (ze.recentlyCreatedOwnerStacks = 0, v9 = o), Tu.discardPendingWarnings(), h;
    }
    function Rl(o, l) {
      rn = null, ze.H = rS, ze.getCurrentStack = null, Ec = !1, Go = null, l === Vy || l === jA ? (l = Of(), Tr = sS) : l === wR ? (l = Of(), Tr = Ej) : Tr = l === DR ? kR : l !== null && typeof l == "object" && typeof l.then == "function" ? lS : qA, Ul = l;
      var h = _n;
      h === null ? (Di = oS, Im(
        o,
        po(l, o.current)
      )) : h.mode & bn && cv(h);
    }
    function $2() {
      var o = zl.current;
      return o === null ? !0 : (xn & 4194048) === xn ? kc === null : (xn & 62914560) === xn || xn & 536870912 ? o === kc : !1;
    }
    function qv() {
      var o = ze.H;
      return ze.H = rS, o === null ? rS : o;
    }
    function H2() {
      var o = ze.A;
      return ze.A = Hte, o;
    }
    function yp(o) {
      Xi === null && (Xi = o._debugTask == null ? null : o._debugTask);
    }
    function bp() {
      Di = r0, i0 || (xn & 4194048) !== xn && zl.current !== null || (Zy = !0), !(a0 & 134217727) && !(o0 & 134217727) || Hr === null || Xs(
        Hr,
        xn,
        el,
        !1
      );
    }
    function wp(o, l, h) {
      var y = Zn;
      Zn |= ka;
      var S = qv(), E = H2();
      if (Hr !== o || xn !== l) {
        if (Ac) {
          var j = o.memoizedUpdaters;
          0 < j.size && (Sp(o, xn), j.clear()), yr(o, l);
        }
        uS = null, gc(o, l);
      }
      l = !1, j = Di;
      e:
        do
          try {
            if (Tr !== Js && _n !== null) {
              var L = _n, Q = Ul;
              switch (Tr) {
                case kR:
                  Hv(), j = HA;
                  break e;
                case sS:
                case R1:
                case D1:
                case lS:
                  zl.current === null && (l = !0);
                  var ne = Tr;
                  if (Tr = Js, Ul = null, xp(o, L, Q, ne), h && Zy) {
                    j = mh;
                    break e;
                  }
                  break;
                default:
                  ne = Tr, Tr = Js, Ul = null, xp(o, L, Q, ne);
              }
            }
            q2(), j = Di;
            break;
          } catch (be) {
            Rl(o, be);
          }
        while (1);
      return l && o.shellSuspendCounter++, Zh(), Zn = y, ze.H = S, ze.A = E, _n === null && (Hr = null, xn = 0, nv()), j;
    }
    function q2() {
      for (; _n !== null; )
        Gv(_n);
    }
    function yu(o, l) {
      var h = Zn;
      Zn |= ka;
      var y = qv(), S = H2();
      if (Hr !== o || xn !== l) {
        if (Ac) {
          var E = o.memoizedUpdaters;
          0 < E.size && (Sp(o, xn), E.clear()), yr(o, l);
        }
        uS = null, WA = va() + Cj, gc(o, l);
      } else
        Zy = $e(
          o,
          l
        );
      e:
        do
          try {
            if (Tr !== Js && _n !== null)
              t:
                switch (l = _n, E = Ul, Tr) {
                  case qA:
                    Tr = Js, Ul = null, xp(
                      o,
                      l,
                      E,
                      qA
                    );
                    break;
                  case R1:
                  case D1:
                    if (n2(E)) {
                      Tr = Js, Ul = null, G2(l);
                      break;
                    }
                    l = function() {
                      Tr !== R1 && Tr !== D1 || Hr !== o || (Tr = GA), Uo(o);
                    }, E.then(l, l);
                    break e;
                  case sS:
                    Tr = GA;
                    break e;
                  case Ej:
                    Tr = IR;
                    break e;
                  case GA:
                    n2(E) ? (Tr = Js, Ul = null, G2(l)) : (Tr = Js, Ul = null, xp(
                      o,
                      l,
                      E,
                      GA
                    ));
                    break;
                  case IR:
                    var j = null;
                    switch (_n.tag) {
                      case 26:
                        j = _n.memoizedState;
                      case 5:
                      case 27:
                        var L = _n;
                        if (j ? Dn(j) : L.stateNode.complete) {
                          Tr = Js, Ul = null;
                          var Q = L.sibling;
                          if (Q !== null)
                            _n = Q;
                          else {
                            var ne = L.return;
                            ne !== null ? (_n = ne, qm(ne)) : _n = null;
                          }
                          break t;
                        }
                        break;
                      default:
                        console.error(
                          "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                        );
                    }
                    Tr = Js, Ul = null, xp(
                      o,
                      l,
                      E,
                      IR
                    );
                    break;
                  case lS:
                    Tr = Js, Ul = null, xp(
                      o,
                      l,
                      E,
                      lS
                    );
                    break;
                  case kR:
                    Hv(), Di = HA;
                    break e;
                  default:
                    throw Error(
                      "Unexpected SuspendedReason. This is a bug in React."
                    );
                }
            ze.actQueue !== null ? q2() : Gi();
            break;
          } catch (be) {
            Rl(o, be);
          }
        while (1);
      return Zh(), ze.H = y, ze.A = S, Zn = h, _n !== null ? mh : (Hr = null, xn = 0, nv(), Di);
    }
    function Gi() {
      for (; _n !== null && !wy(); )
        Gv(_n);
    }
    function Gv(o) {
      var l = o.alternate;
      (o.mode & bn) !== Wt ? (su(o), l = Ce(
        o,
        Lm,
        l,
        o,
        zd
      ), cv(o)) : l = Ce(
        o,
        Lm,
        l,
        o,
        zd
      ), o.memoizedProps = o.pendingProps, l === null ? qm(o) : _n = l;
    }
    function G2(o) {
      var l = Ce(o, ga, o);
      o.memoizedProps = o.pendingProps, l === null ? qm(o) : _n = l;
    }
    function ga(o) {
      var l = o.alternate, h = (o.mode & bn) !== Wt;
      switch (h && su(o), o.tag) {
        case 15:
        case 0:
          l = x2(
            l,
            o,
            o.pendingProps,
            o.type,
            void 0,
            xn
          );
          break;
        case 11:
          l = x2(
            l,
            o,
            o.pendingProps,
            o.type.render,
            o.ref,
            xn
          );
          break;
        case 5:
          dd(o);
        default:
          T2(l, o), o = _n = Xw(o, zd), l = Lm(l, o, zd);
      }
      return h && cv(o), l;
    }
    function xp(o, l, h, y) {
      Zh(), dd(l), Uy = null, Jx = 0;
      var S = l.return;
      try {
        if (p2(
          o,
          S,
          l,
          h,
          xn
        )) {
          Di = oS, Im(
            o,
            po(h, o.current)
          ), _n = null;
          return;
        }
      } catch (E) {
        if (S !== null)
          throw _n = S, E;
        Di = oS, Im(
          o,
          po(h, o.current)
        ), _n = null;
        return;
      }
      l.flags & 32768 ? (Fn || y === qA ? o = !0 : Zy || xn & 536870912 ? o = !1 : (i0 = o = !0, (y === R1 || y === D1 || y === sS || y === lS) && (y = zl.current, y !== null && y.tag === 13 && (y.flags |= 16384))), Y2(l, o)) : qm(l);
    }
    function qm(o) {
      var l = o;
      do {
        if (l.flags & 32768) {
          Y2(
            l,
            i0
          );
          return;
        }
        var h = l.alternate;
        if (o = l.return, su(l), h = Ce(
          l,
          C2,
          h,
          l,
          zd
        ), (l.mode & bn) !== Wt && mm(l), h !== null) {
          _n = h;
          return;
        }
        if (l = l.sibling, l !== null) {
          _n = l;
          return;
        }
        _n = l = o;
      } while (l !== null);
      Di === mh && (Di = Sj);
    }
    function Y2(o, l) {
      do {
        var h = S3(o.alternate, o);
        if (h !== null) {
          h.flags &= 32767, _n = h;
          return;
        }
        if ((o.mode & bn) !== Wt) {
          mm(o), h = o.actualDuration;
          for (var y = o.child; y !== null; )
            h += y.actualDuration, y = y.sibling;
          o.actualDuration = h;
        }
        if (h = o.return, h !== null && (h.flags |= 32768, h.subtreeFlags = 0, h.deletions = null), !l && (o = o.sibling, o !== null)) {
          _n = o;
          return;
        }
        _n = o = h;
      } while (o !== null);
      Di = HA, _n = null;
    }
    function Vr(o, l, h, y, S, E, j, L, Q, ne, be, Ee, he, Le) {
      o.cancelPendingCommit = null;
      do
        Gm();
      while (_a !== l0);
      if (Tu.flushLegacyContextWarning(), Tu.flushPendingUnsafeLifecycleWarnings(), (Zn & (ka | Vl)) !== no)
        throw Error("Should not already be working.");
      if (vl(h), ne === O1 ? $w(
        he,
        Le,
        h,
        Xi
      ) : y !== null ? PO(
        he,
        Le,
        h,
        y,
        l !== null && l.alternate !== null && l.alternate.memoizedState.isDehydrated && (l.flags & 256) !== 0,
        Xi
      ) : jO(
        he,
        Le,
        h,
        Xi
      ), l !== null) {
        if (h === 0 && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        ), l === o.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        if (E = l.lanes | l.childLanes, E |= lR, sn(
          o,
          h,
          E,
          j,
          L,
          Q
        ), o === Hr && (_n = Hr = null, xn = 0), Ky = l, c0 = o, Du = h, zR = E, VR = S, Mj = y, FR = Le, Ij = Ee, Nu = QA, kj = null, l.actualDuration !== 0 || l.subtreeFlags & 10256 || l.flags & 10256 ? (o.callbackNode = null, o.callbackPriority = 0, Ep(eh, function() {
          return gS = window.event, Nu === QA && (Nu = BR), Ym(), null;
        })) : (o.callbackNode = null, o.callbackPriority = 0), lh = null, Kp = ba(), Ee !== null && LO(
          Le,
          Kp,
          Ee,
          Xi
        ), y = (l.flags & 13878) !== 0, l.subtreeFlags & 13878 || y) {
          y = ze.T, ze.T = null, S = ur.p, ur.p = Ji, j = Zn, Zn |= Vl;
          try {
            FO(o, l, h);
          } finally {
            Zn = j, ur.p = S, ze.T = y;
          }
        }
        _a = Oj, Eo(), vc(), X2();
      }
    }
    function Eo() {
      if (_a === Oj) {
        _a = l0;
        var o = c0, l = Ky, h = Du, y = (l.flags & 13878) !== 0;
        if (l.subtreeFlags & 13878 || y) {
          y = ze.T, ze.T = null;
          var S = ur.p;
          ur.p = Ji;
          var E = Zn;
          Zn |= Vl;
          try {
            Wy = h, Qy = o, Cf(), Vm(l, o), Qy = Wy = null, h = KR;
            var j = Jg(o.containerInfo), L = h.focusedElem, Q = h.selectionRange;
            if (j !== L && L && L.ownerDocument && t3(
              L.ownerDocument.documentElement,
              L
            )) {
              if (Q !== null && Fw(L)) {
                var ne = Q.start, be = Q.end;
                if (be === void 0 && (be = ne), "selectionStart" in L)
                  L.selectionStart = ne, L.selectionEnd = Math.min(
                    be,
                    L.value.length
                  );
                else {
                  var Ee = L.ownerDocument || document, he = Ee && Ee.defaultView || window;
                  if (he.getSelection) {
                    var Le = he.getSelection(), dt = L.textContent.length, yt = Math.min(
                      Q.start,
                      dt
                    ), Qr = Q.end === void 0 ? yt : Math.min(Q.end, dt);
                    !Le.extend && yt > Qr && (j = Qr, Qr = yt, yt = j);
                    var Hn = e3(
                      L,
                      yt
                    ), fe = e3(
                      L,
                      Qr
                    );
                    if (Hn && fe && (Le.rangeCount !== 1 || Le.anchorNode !== Hn.node || Le.anchorOffset !== Hn.offset || Le.focusNode !== fe.node || Le.focusOffset !== fe.offset)) {
                      var pe = Ee.createRange();
                      pe.setStart(Hn.node, Hn.offset), Le.removeAllRanges(), yt > Qr ? (Le.addRange(pe), Le.extend(fe.node, fe.offset)) : (pe.setEnd(fe.node, fe.offset), Le.addRange(pe));
                    }
                  }
                }
              }
              for (Ee = [], Le = L; Le = Le.parentNode; )
                Le.nodeType === 1 && Ee.push({
                  element: Le,
                  left: Le.scrollLeft,
                  top: Le.scrollTop
                });
              for (typeof L.focus == "function" && L.focus(), L = 0; L < Ee.length; L++) {
                var ye = Ee[L];
                ye.element.scrollLeft = ye.left, ye.element.scrollTop = ye.top;
              }
            }
            fC = !!ZR, KR = ZR = null;
          } finally {
            Zn = E, ur.p = S, ze.T = y;
          }
        }
        o.current = l, _a = Rj;
      }
    }
    function vc() {
      if (_a === Rj) {
        _a = l0;
        var o = kj;
        if (o !== null) {
          Kp = ba();
          var l = sh, h = Kp;
          !ri || h <= l || console.timeStamp(
            o,
            l,
            h,
            $n,
            zn,
            "secondary-light"
          );
        }
        o = c0, l = Ky, h = Du;
        var y = (l.flags & 8772) !== 0;
        if (l.subtreeFlags & 8772 || y) {
          y = ze.T, ze.T = null;
          var S = ur.p;
          ur.p = Ji;
          var E = Zn;
          Zn |= Vl;
          try {
            Wy = h, Qy = o, Cf(), zv(
              o,
              l.alternate,
              l
            ), Qy = Wy = null;
          } finally {
            Zn = E, ur.p = S, ze.T = y;
          }
        }
        o = FR, l = Ij, sh = ba(), o = l === null ? o : Kp, l = sh, h = Nu === LR, y = Xi, lh !== null ? s3(
          o,
          l,
          lh,
          !1,
          y
        ) : !ri || l <= o || (y ? y.run(
          console.timeStamp.bind(
            console,
            h ? "Commit Interrupted View Transition" : "Commit",
            o,
            l,
            $n,
            zn,
            h ? "error" : "secondary-dark"
          )
        ) : console.timeStamp(
          h ? "Commit Interrupted View Transition" : "Commit",
          o,
          l,
          $n,
          zn,
          h ? "error" : "secondary-dark"
        )), _a = Dj;
      }
    }
    function X2() {
      if (_a === Nj || _a === Dj) {
        if (_a === Nj) {
          var o = sh;
          sh = ba();
          var l = sh, h = Nu === LR;
          !ri || l <= o || console.timeStamp(
            h ? "Interrupted View Transition" : "Starting Animation",
            o,
            l,
            $n,
            zn,
            h ? " error" : "secondary-light"
          ), Nu !== LR && (Nu = Tj);
        }
        _a = l0, xy(), o = c0;
        var y = Ky;
        l = Du, h = Mj;
        var S = y.actualDuration !== 0 || (y.subtreeFlags & 10256) !== 0 || (y.flags & 10256) !== 0;
        S ? _a = ZA : (_a = l0, Ky = c0 = null, W2(
          o,
          o.pendingLanes
        ), M1 = 0, fS = null);
        var E = o.pendingLanes;
        if (E === 0 && (s0 = null), S || Wv(o), E = or(l), y = y.stateNode, Ki && typeof Ki.onCommitFiberRoot == "function")
          try {
            var j = (y.current.flags & 128) === 128;
            switch (E) {
              case Ji:
                var L = Ax;
                break;
              case Ma:
                L = Sy;
                break;
              case Ja:
                L = eh;
                break;
              case kd:
                L = Ey;
                break;
              default:
                L = eh;
            }
            Ki.onCommitFiberRoot(
              th,
              y,
              L,
              j
            );
          } catch (Ee) {
            _c || (_c = !0, console.error(
              "React instrumentation encountered an error: %o",
              Ee
            ));
          }
        if (Ac && o.memoizedUpdaters.clear(), V2(), h !== null) {
          j = ze.T, L = ur.p, ur.p = Ji, ze.T = null;
          try {
            var Q = o.onRecoverableError;
            for (y = 0; y < h.length; y++) {
              var ne = h[y], be = M3(ne.stack);
              Ce(
                ne.source,
                Q,
                ne.value,
                be
              );
            }
          } finally {
            ze.T = j, ur.p = L;
          }
        }
        Du & 3 && Gm(), Uo(o), E = o.pendingLanes, l & 261930 && E & 42 ? (IA = !0, o === UR ? dS++ : (dS = 0, UR = o)) : dS = 0, S || Cd(l, sh), yc(0, !1);
      }
    }
    function M3(o) {
      return o = { componentStack: o }, Object.defineProperty(o, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      }), o;
    }
    function W2(o, l) {
      (o.pooledCacheLanes &= l) === 0 && (l = o.pooledCache, l != null && (o.pooledCache = null, pm(l)));
    }
    function Gm() {
      return Eo(), vc(), X2(), Ym();
    }
    function Ym() {
      if (_a !== ZA)
        return !1;
      var o = c0, l = zR;
      zR = 0;
      var h = or(Du), y = Ja > h ? Ja : h;
      h = ze.T;
      var S = ur.p;
      try {
        ur.p = y, ze.T = null;
        var E = VR;
        VR = null, y = c0;
        var j = Du;
        if (_a = l0, Ky = c0 = null, Du = 0, (Zn & (ka | Vl)) !== no)
          throw Error("Cannot flush passive effects while already rendering.");
        vl(j), $R = !0, KA = !1;
        var L = 0;
        if (lh = null, L = va(), Nu === Tj)
          Hw(
            sh,
            L,
            gR
          );
        else {
          var Q = sh, ne = L, be = Nu === BR;
          !ri || ne <= Q || (Xi ? Xi.run(
            console.timeStamp.bind(
              console,
              be ? "Waiting for Paint" : "Waiting",
              Q,
              ne,
              $n,
              zn,
              "secondary-light"
            )
          ) : console.timeStamp(
            be ? "Waiting for Paint" : "Waiting",
            Q,
            ne,
            $n,
            zn,
            "secondary-light"
          ));
        }
        Q = Zn, Zn |= Vl;
        var Ee = y.current;
        Cf(), Uv(Ee);
        var he = y.current;
        Ee = FR, Cf(), B2(
          y,
          he,
          j,
          E,
          Ee
        ), Wv(y), Zn = Q;
        var Le = va();
        if (he = L, Ee = Xi, lh !== null ? s3(
          he,
          Le,
          lh,
          !0,
          Ee
        ) : !ri || Le <= he || (Ee ? Ee.run(
          console.timeStamp.bind(
            console,
            "Remaining Effects",
            he,
            Le,
            $n,
            zn,
            "secondary-dark"
          )
        ) : console.timeStamp(
          "Remaining Effects",
          he,
          Le,
          $n,
          zn,
          "secondary-dark"
        )), Cd(j, Le), yc(0, !1), KA ? y === fS ? M1++ : (M1 = 0, fS = y) : M1 = 0, KA = $R = !1, Ki && typeof Ki.onPostCommitFiberRoot == "function")
          try {
            Ki.onPostCommitFiberRoot(th, y);
          } catch (yt) {
            _c || (_c = !0, console.error(
              "React instrumentation encountered an error: %o",
              yt
            ));
          }
        var dt = y.current.stateNode;
        return dt.effectDuration = 0, dt.passiveEffectDuration = 0, !0;
      } finally {
        ur.p = S, ze.T = h, W2(o, l);
      }
    }
    function _o(o, l, h) {
      l = po(h, l), h3(l), l = Av(o.stateNode, l, 2), o = ac(o, l, 2), o !== null && (Rt(o, 2), Uo(o));
    }
    function pn(o, l, h) {
      if (Jy = !1, o.tag === 3)
        _o(o, o, h);
      else {
        for (; l !== null; ) {
          if (l.tag === 3) {
            _o(
              l,
              o,
              h
            );
            return;
          }
          if (l.tag === 1) {
            var y = l.stateNode;
            if (typeof l.type.getDerivedStateFromError == "function" || typeof y.componentDidCatch == "function" && (s0 === null || !s0.has(y))) {
              o = po(h, o), h3(o), h = Cv(2), y = ac(l, h, 2), y !== null && (Tv(
                h,
                y,
                l,
                o
              ), Rt(y, 2), Uo(y));
              return;
            }
          }
          l = l.return;
        }
        console.error(
          `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
          h
        );
      }
    }
    function Yv(o, l, h) {
      var y = o.pingCache;
      if (y === null) {
        y = o.pingCache = new Gte();
        var S = /* @__PURE__ */ new Set();
        y.set(l, S);
      } else
        S = y.get(l), S === void 0 && (S = /* @__PURE__ */ new Set(), y.set(l, S));
      S.has(h) || (jR = !0, S.add(h), y = Vo.bind(null, o, l, h), Ac && Sp(o, h), l.then(y, y));
    }
    function Vo(o, l, h) {
      var y = o.pingCache;
      y !== null && y.delete(l), o.pingedLanes |= o.suspendedLanes & h, o.warmLanes &= ~h, h & 127 ? 0 > Ld && (b1 = Ld = ba(), Vx = TA("Promise Resolved"), Jp = OA) : h & 4194048 && 0 > Ic && (ch = Ic = ba(), $x = TA("Promise Resolved"), mR = OA), U2() && ze.actQueue === null && console.error(
        `A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`
      ), Hr === o && (xn & h) === h && (Di === r0 || Di === $A && (xn & 62914560) === xn && va() - XA < Aj ? (Zn & ka) === no && gc(o, 0) : PR |= h, N1 === xn && (N1 = 0)), Uo(o);
    }
    function Q2(o, l) {
      l === 0 && (l = ct()), o = Wa(o, l), o !== null && (Rt(o, l), Uo(o));
    }
    function bu(o) {
      var l = o.memoizedState, h = 0;
      l !== null && (h = l.retryLane), Q2(o, h);
    }
    function qf(o, l) {
      var h = 0;
      switch (o.tag) {
        case 31:
        case 13:
          var y = o.stateNode, S = o.memoizedState;
          S !== null && (h = S.retryLane);
          break;
        case 19:
          y = o.stateNode;
          break;
        case 22:
          y = o.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      y !== null && y.delete(l), Q2(o, h);
    }
    function Dl(o, l, h) {
      if (l.subtreeFlags & 67117056)
        for (l = l.child; l !== null; ) {
          var y = o, S = l, E = S.type === To;
          E = h || E, S.tag !== 22 ? S.flags & 67108864 ? E && Ce(
            S,
            Xv,
            y,
            S
          ) : Dl(
            y,
            S,
            E
          ) : S.memoizedState === null && (E && S.flags & 8192 ? Ce(
            S,
            Xv,
            y,
            S
          ) : S.subtreeFlags & 67108864 && Ce(
            S,
            Dl,
            y,
            S,
            E
          )), l = l.sibling;
        }
    }
    function Xv(o, l) {
      se(!0);
      try {
        Fv(l), F2(l), L2(o, l.alternate, l, !1), Hm(o, l, 0, null, !1, 0);
      } finally {
        se(!1);
      }
    }
    function Wv(o) {
      var l = !0;
      o.current.mode & (Yo | Cu) || (l = !1), Dl(
        o,
        o.current,
        l
      );
    }
    function Ws(o) {
      if ((Zn & ka) === no) {
        var l = o.tag;
        if (l === 3 || l === 1 || l === 0 || l === 11 || l === 14 || l === 15) {
          if (l = H(o) || "ReactComponent", JA !== null) {
            if (JA.has(l))
              return;
            JA.add(l);
          } else
            JA = /* @__PURE__ */ new Set([l]);
          Ce(o, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function Sp(o, l) {
      Ac && o.memoizedUpdaters.forEach(function(h) {
        kn(o, h, l);
      });
    }
    function Ep(o, l) {
      var h = ze.actQueue;
      return h !== null ? (h.push(l), Wte) : _x(o, l);
    }
    function Xm(o) {
      U2() && ze.actQueue === null && Ce(o, function() {
        console.error(
          `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`,
          H(o)
        );
      });
    }
    function Uo(o) {
      o !== eb && o.next === null && (eb === null ? eC = eb = o : eb = eb.next = o), tC = !0, ze.actQueue !== null ? qR || (qR = !0, k3()) : HR || (HR = !0, k3());
    }
    function yc(o, l) {
      if (!GR && tC) {
        GR = !0;
        do
          for (var h = !1, y = eC; y !== null; ) {
            if (!l)
              if (o !== 0) {
                var S = y.pendingLanes;
                if (S === 0)
                  var E = 0;
                else {
                  var j = y.suspendedLanes, L = y.pingedLanes;
                  E = (1 << 31 - Na(42 | o) + 1) - 1, E &= S & ~(j & ~L), E = E & 201326741 ? E & 201326741 | 1 : E ? E | 2 : 0;
                }
                E !== 0 && (h = !0, Wm(y, E));
              } else
                E = xn, E = He(
                  y,
                  y === Hr ? E : 0,
                  y.cancelPendingCommit !== null || y.timeoutHandle !== P1
                ), !(E & 3) || $e(y, E) || (h = !0, Wm(y, E));
            y = y.next;
          }
        while (h);
        GR = !1;
      }
    }
    function I3() {
      gS = window.event, Qv();
    }
    function Qv() {
      tC = qR = HR = !1;
      var o = 0;
      u0 !== 0 && ex() && (o = u0);
      for (var l = va(), h = null, y = eC; y !== null; ) {
        var S = y.next, E = _p(y, l);
        E === 0 ? (y.next = null, h === null ? eC = S : h.next = S, S === null && (eb = h)) : (h = y, (o !== 0 || E & 3) && (tC = !0)), y = S;
      }
      _a !== l0 && _a !== ZA || yc(o, !1), u0 !== 0 && (u0 = 0);
    }
    function _p(o, l) {
      for (var h = o.suspendedLanes, y = o.pingedLanes, S = o.expirationTimes, E = o.pendingLanes & -62914561; 0 < E; ) {
        var j = 31 - Na(E), L = 1 << j, Q = S[j];
        Q === -1 ? (!(L & h) || L & y) && (S[j] = Ze(L, l)) : Q <= l && (o.expiredLanes |= L), E &= ~L;
      }
      if (l = Hr, h = xn, h = He(
        o,
        o === l ? h : 0,
        o.cancelPendingCommit !== null || o.timeoutHandle !== P1
      ), y = o.callbackNode, h === 0 || o === l && (Tr === R1 || Tr === D1) || o.cancelPendingCommit !== null)
        return y !== null && Zv(y), o.callbackNode = null, o.callbackPriority = 0;
      if (!(h & 3) || $e(o, h)) {
        if (l = h & -h, l !== o.callbackPriority || ze.actQueue !== null && y !== YR)
          Zv(y);
        else
          return l;
        switch (or(h)) {
          case Ji:
          case Ma:
            h = Sy;
            break;
          case Ja:
            h = eh;
            break;
          case kd:
            h = Ey;
            break;
          default:
            h = eh;
        }
        return y = Z2.bind(null, o), ze.actQueue !== null ? (ze.actQueue.push(y), h = YR) : h = _x(h, y), o.callbackPriority = l, o.callbackNode = h, l;
      }
      return y !== null && Zv(y), o.callbackPriority = 2, o.callbackNode = null, 2;
    }
    function Z2(o, l) {
      if (IA = MA = !1, gS = window.event, _a !== l0 && _a !== ZA)
        return o.callbackNode = null, o.callbackPriority = 0, null;
      var h = o.callbackNode;
      if (Nu === QA && (Nu = BR), Gm() && o.callbackNode !== h)
        return null;
      var y = xn;
      return y = He(
        o,
        o === Hr ? y : 0,
        o.cancelPendingCommit !== null || o.timeoutHandle !== P1
      ), y === 0 ? null : (R3(
        o,
        y,
        l
      ), _p(o, va()), o.callbackNode != null && o.callbackNode === h ? Z2.bind(null, o) : null);
    }
    function Wm(o, l) {
      if (Gm())
        return null;
      MA = IA, IA = !1, R3(o, l, !0);
    }
    function Zv(o) {
      o !== YR && o !== null && by(o);
    }
    function k3() {
      ze.actQueue !== null && ze.actQueue.push(function() {
        return Qv(), null;
      }), ane(function() {
        (Zn & (ka | Vl)) !== no ? _x(
          Ax,
          I3
        ) : Qv();
      });
    }
    function K2() {
      if (u0 === 0) {
        var o = S1;
        o === 0 && (o = Up, Up <<= 1, !(Up & 261888) && (Up = 256)), u0 = o;
      }
      return u0;
    }
    function Jn(o) {
      return o == null || typeof o == "symbol" || typeof o == "boolean" ? null : typeof o == "function" ? o : (wt(o, "action"), im("" + o));
    }
    function _r(o, l) {
      var h = l.ownerDocument.createElement("input");
      return h.name = l.name, h.value = l.value, o.id && h.setAttribute("form", o.id), l.parentNode.insertBefore(h, l), o = new FormData(o), h.parentNode.removeChild(h), o;
    }
    function Ln(o, l, h, y, S) {
      if (l === "submit" && h && h.stateNode === S) {
        var E = Jn(
          (S[Oo] || null).action
        ), j = y.submitter;
        j && (l = (l = j[Oo] || null) ? Jn(l.formAction) : j.getAttribute("formAction"), l !== null && (E = l, j = null));
        var L = new wA(
          "action",
          "action",
          null,
          y,
          S
        );
        o.push({
          event: L,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (y.defaultPrevented) {
                  if (u0 !== 0) {
                    var Q = j ? _r(
                      S,
                      j
                    ) : new FormData(S), ne = {
                      pending: !0,
                      data: Q,
                      method: S.method,
                      action: E
                    };
                    Object.freeze(ne), mu(
                      h,
                      ne,
                      null,
                      Q
                    );
                  }
                } else
                  typeof E == "function" && (L.preventDefault(), Q = j ? _r(
                    S,
                    j
                  ) : new FormData(S), ne = {
                    pending: !0,
                    data: Q,
                    method: S.method,
                    action: E
                  }, Object.freeze(ne), mu(
                    h,
                    ne,
                    E,
                    Q
                  ));
              },
              currentTarget: S
            }
          ]
        });
      }
    }
    function En(o, l, h) {
      o.currentTarget = h;
      try {
        l(o);
      } catch (y) {
        iR(y);
      }
      o.currentTarget = null;
    }
    function pr(o, l) {
      l = (l & 4) !== 0;
      for (var h = 0; h < o.length; h++) {
        var y = o[h];
        e: {
          var S = void 0, E = y.event;
          if (y = y.listeners, l)
            for (var j = y.length - 1; 0 <= j; j--) {
              var L = y[j], Q = L.instance, ne = L.currentTarget;
              if (L = L.listener, Q !== S && E.isPropagationStopped())
                break e;
              Q !== null ? Ce(
                Q,
                En,
                E,
                L,
                ne
              ) : En(E, L, ne), S = Q;
            }
          else
            for (j = 0; j < y.length; j++) {
              if (L = y[j], Q = L.instance, ne = L.currentTarget, L = L.listener, Q !== S && E.isPropagationStopped())
                break e;
              Q !== null ? Ce(
                Q,
                En,
                E,
                L,
                ne
              ) : En(E, L, ne), S = Q;
            }
        }
      }
    }
    function Xt(o, l) {
      XR.has(o) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        o
      );
      var h = l[nh];
      h === void 0 && (h = l[nh] = /* @__PURE__ */ new Set());
      var y = o + "__bubble";
      h.has(y) || (Kv(l, o, 2, !1), h.add(y));
    }
    function bc(o, l, h) {
      XR.has(o) && !l && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        o
      );
      var y = 0;
      l && (y |= 4), Kv(
        h,
        o,
        y,
        l
      );
    }
    function Td(o) {
      if (!o[nC]) {
        o[nC] = !0, mA.forEach(function(h) {
          h !== "selectionchange" && (XR.has(h) || bc(h, !1, o), bc(h, !0, o));
        });
        var l = o.nodeType === 9 ? o : o.ownerDocument;
        l === null || l[nC] || (l[nC] = !0, bc("selectionchange", !1, l));
      }
    }
    function Kv(o, l, h, y) {
      switch (fy(l)) {
        case Ji:
          var S = hx;
          break;
        case Ma:
          S = Da;
          break;
        default:
          S = px;
      }
      h = S.bind(
        null,
        l,
        h,
        o
      ), S = void 0, !XO || l !== "touchstart" && l !== "touchmove" && l !== "wheel" || (S = !0), y ? S !== void 0 ? o.addEventListener(l, h, {
        capture: !0,
        passive: S
      }) : o.addEventListener(l, h, !0) : S !== void 0 ? o.addEventListener(l, h, {
        passive: S
      }) : o.addEventListener(
        l,
        h,
        !1
      );
    }
    function Nl(o, l, h, y, S) {
      var E = y;
      if (!(l & 1) && !(l & 2) && y !== null)
        e:
          for (; ; ) {
            if (y === null)
              return;
            var j = y.tag;
            if (j === 3 || j === 4) {
              var L = y.stateNode.containerInfo;
              if (L === S)
                break;
              if (j === 4)
                for (j = y.return; j !== null; ) {
                  var Q = j.tag;
                  if ((Q === 3 || Q === 4) && j.stateNode.containerInfo === S)
                    return;
                  j = j.return;
                }
              for (; L !== null; ) {
                if (j = nt(L), j === null)
                  return;
                if (Q = j.tag, Q === 5 || Q === 6 || Q === 26 || Q === 27) {
                  y = E = j;
                  continue e;
                }
                L = L.parentNode;
              }
            }
            y = y.return;
          }
      Wg(function() {
        var ne = E, be = ml(h), Ee = [];
        e: {
          var he = g9.get(o);
          if (he !== void 0) {
            var Le = wA, dt = o;
            switch (o) {
              case "keypress":
                if (am(h) === 0)
                  break e;
              case "keydown":
              case "keyup":
                Le = dte;
                break;
              case "focusin":
                dt = "focus", Le = KO;
                break;
              case "focusout":
                dt = "blur", Le = KO;
                break;
              case "beforeblur":
              case "afterblur":
                Le = KO;
                break;
              case "click":
                if (h.button === 2)
                  break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                Le = n9;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                Le = Jee;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                Le = pte;
                break;
              case f9:
              case h9:
              case p9:
                Le = nte;
                break;
              case m9:
                Le = gte;
                break;
              case "scroll":
              case "scrollend":
                Le = Zee;
                break;
              case "wheel":
                Le = yte;
                break;
              case "copy":
              case "cut":
              case "paste":
                Le = ite;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                Le = i9;
                break;
              case "toggle":
              case "beforetoggle":
                Le = wte;
            }
            var yt = (l & 4) !== 0, Qr = !yt && (o === "scroll" || o === "scrollend"), Hn = yt ? he !== null ? he + "Capture" : null : he;
            yt = [];
            for (var fe = ne, pe; fe !== null; ) {
              var ye = fe;
              if (pe = ye.stateNode, ye = ye.tag, ye !== 5 && ye !== 26 && ye !== 27 || pe === null || Hn === null || (ye = Jl(fe, Hn), ye != null && yt.push(
                Ur(
                  fe,
                  ye,
                  pe
                )
              )), Qr)
                break;
              fe = fe.return;
            }
            0 < yt.length && (he = new Le(
              he,
              dt,
              null,
              h,
              be
            ), Ee.push({
              event: he,
              listeners: yt
            }));
          }
        }
        if (!(l & 7)) {
          e: {
            if (he = o === "mouseover" || o === "pointerover", Le = o === "mouseout" || o === "pointerout", he && h !== Dx && (dt = h.relatedTarget || h.fromElement) && (nt(dt) || dt[Au]))
              break e;
            if ((Le || he) && (he = be.window === be ? be : (he = be.ownerDocument) ? he.defaultView || he.parentWindow : window, Le ? (dt = h.relatedTarget || h.toElement, Le = ne, dt = dt ? nt(dt) : null, dt !== null && (Qr = O(dt), yt = dt.tag, dt !== Qr || yt !== 5 && yt !== 27 && yt !== 6) && (dt = null)) : (Le = null, dt = ne), Le !== dt)) {
              if (yt = n9, ye = "onMouseLeave", Hn = "onMouseEnter", fe = "mouse", (o === "pointerout" || o === "pointerover") && (yt = i9, ye = "onPointerLeave", Hn = "onPointerEnter", fe = "pointer"), Qr = Le == null ? he : lt(Le), pe = dt == null ? he : lt(dt), he = new yt(
                ye,
                fe + "leave",
                Le,
                h,
                be
              ), he.target = Qr, he.relatedTarget = pe, ye = null, nt(be) === ne && (yt = new yt(
                Hn,
                fe + "enter",
                dt,
                h,
                be
              ), yt.target = pe, yt.relatedTarget = Qr, ye = yt), Qr = ye, Le && dt)
                t: {
                  for (yt = Gf, Hn = Le, fe = dt, pe = 0, ye = Hn; ye; ye = yt(ye))
                    pe++;
                  ye = 0;
                  for (var Ge = fe; Ge; Ge = yt(Ge))
                    ye++;
                  for (; 0 < pe - ye; )
                    Hn = yt(Hn), pe--;
                  for (; 0 < ye - pe; )
                    fe = yt(fe), ye--;
                  for (; pe--; ) {
                    if (Hn === fe || fe !== null && Hn === fe.alternate) {
                      yt = Hn;
                      break t;
                    }
                    Hn = yt(Hn), fe = yt(fe);
                  }
                  yt = null;
                }
              else
                yt = null;
              Le !== null && Jv(
                Ee,
                he,
                Le,
                yt,
                !1
              ), dt !== null && Qr !== null && Jv(
                Ee,
                Qr,
                dt,
                yt,
                !0
              );
            }
          }
          e: {
            if (he = ne ? lt(ne) : window, Le = he.nodeName && he.nodeName.toLowerCase(), Le === "select" || Le === "input" && he.type === "file")
              var mt = rd;
            else if (Lw(he))
              if (u9)
                mt = cm;
              else {
                mt = Bw;
                var an = kO;
              }
            else
              Le = he.nodeName, !Le || Le.toLowerCase() !== "input" || he.type !== "checkbox" && he.type !== "radio" ? ne && Kl(ne.elementType) && (mt = rd) : mt = zw;
            if (mt && (mt = mt(o, ne))) {
              sm(
                Ee,
                mt,
                h,
                be
              );
              break e;
            }
            an && an(o, he, ne), o === "focusout" && ne && he.type === "number" && ne.memoizedProps.value != null && Fh(he, "number", he.value);
          }
          switch (an = ne ? lt(ne) : window, o) {
            case "focusin":
              (Lw(an) || an.contentEditable === "true") && (Ny = an, eR = ne, Lx = null);
              break;
            case "focusout":
              Lx = eR = Ny = null;
              break;
            case "mousedown":
              tR = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              tR = !1, n3(
                Ee,
                h,
                be
              );
              break;
            case "selectionchange":
              if (_te)
                break;
            case "keydown":
            case "keyup":
              n3(
                Ee,
                h,
                be
              );
          }
          var Bt;
          if (JO)
            e: {
              switch (o) {
                case "compositionstart":
                  var It = "onCompositionStart";
                  break e;
                case "compositionend":
                  It = "onCompositionEnd";
                  break e;
                case "compositionupdate":
                  It = "onCompositionUpdate";
                  break e;
              }
              It = void 0;
            }
          else
            Dy ? Gh(o, h) && (It = "onCompositionEnd") : o === "keydown" && h.keyCode === a9 && (It = "onCompositionStart");
          It && (o9 && h.locale !== "ko" && (Dy || It !== "onCompositionStart" ? It === "onCompositionEnd" && Dy && (Bt = gf()) : (Yp = be, WO = "value" in Yp ? Yp.value : Yp.textContent, Dy = !0)), an = Ml(
            ne,
            It
          ), 0 < an.length && (It = new r9(
            It,
            o,
            null,
            h,
            be
          ), Ee.push({
            event: It,
            listeners: an
          }), Bt ? It.data = Bt : (Bt = au(h), Bt !== null && (It.data = Bt)))), (Bt = Ste ? Pw(o, h) : Qg(o, h)) && (It = Ml(
            ne,
            "onBeforeInput"
          ), 0 < It.length && (an = new ote(
            "onBeforeInput",
            "beforeinput",
            null,
            h,
            be
          ), Ee.push({
            event: an,
            listeners: It
          }), an.data = Bt)), Ln(
            Ee,
            o,
            ne,
            h,
            be
          );
        }
        pr(Ee, l);
      });
    }
    function Ur(o, l, h) {
      return {
        instance: o,
        listener: l,
        currentTarget: h
      };
    }
    function Ml(o, l) {
      for (var h = l + "Capture", y = []; o !== null; ) {
        var S = o, E = S.stateNode;
        if (S = S.tag, S !== 5 && S !== 26 && S !== 27 || E === null || (S = Jl(o, h), S != null && y.unshift(
          Ur(o, S, E)
        ), S = Jl(o, l), S != null && y.push(
          Ur(o, S, E)
        )), o.tag === 3)
          return y;
        o = o.return;
      }
      return [];
    }
    function Gf(o) {
      if (o === null)
        return null;
      do
        o = o.return;
      while (o && o.tag !== 5 && o.tag !== 27);
      return o || null;
    }
    function Jv(o, l, h, y, S) {
      for (var E = l._reactName, j = []; h !== null && h !== y; ) {
        var L = h, Q = L.alternate, ne = L.stateNode;
        if (L = L.tag, Q !== null && Q === y)
          break;
        L !== 5 && L !== 26 && L !== 27 || ne === null || (Q = ne, S ? (ne = Jl(h, E), ne != null && j.unshift(
          Ur(h, ne, Q)
        )) : S || (ne = Jl(h, E), ne != null && j.push(
          Ur(h, ne, Q)
        ))), h = h.return;
      }
      j.length !== 0 && o.push({ event: l, listeners: j });
    }
    function Ao(o, l) {
      Z_(o, l), o !== "input" && o !== "textarea" && o !== "select" || l == null || l.value !== null || e9 || (e9 = !0, o === "select" && l.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        o
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        o
      ));
      var h = {
        registrationNameDependencies: Cc,
        possibleRegistrationNames: qp
      };
      Kl(o) || typeof l.is == "string" || IO(o, l, h), l.contentEditable && !l.suppressContentEditableWarning && l.children != null && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function ui(o, l, h, y) {
      l !== h && (h = Il(h), Il(l) !== h && (y[o] = l));
    }
    function Qm(o, l, h) {
      l.forEach(function(y) {
        h[wu(y)] = y === "style" ? Od(o) : o.getAttribute(y);
      });
    }
    function di(o, l) {
      l === !1 ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        o,
        o,
        o
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        o,
        typeof l
      );
    }
    function ey(o, l) {
      return o = o.namespaceURI === ln || o.namespaceURI === mn ? o.ownerDocument.createElementNS(
        o.namespaceURI,
        o.tagName
      ) : o.ownerDocument.createElement(o.tagName), o.innerHTML = l, o.innerHTML;
    }
    function Il(o) {
      return it(o) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        rt(o)
      ), Ft(o)), (typeof o == "string" ? o : "" + o).replace(Qte, `
`).replace(Zte, "");
    }
    function J2(o, l) {
      return l = Il(l), Il(o) === l;
    }
    function cr(o, l, h, y, S, E) {
      switch (h) {
        case "children":
          typeof y == "string" ? (rm(y, l, !1), l === "body" || l === "textarea" && y === "" || mf(o, y)) : (typeof y == "number" || typeof y == "bigint") && (rm("" + y, l, !1), l !== "body" && mf(o, "" + y));
          break;
        case "className":
          Ai(o, "class", y);
          break;
        case "tabIndex":
          Ai(o, "tabindex", y);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          Ai(o, h, y);
          break;
        case "style":
          Iw(o, y, E);
          break;
        case "data":
          if (l !== "object") {
            Ai(o, "data", y);
            break;
          }
        case "src":
        case "href":
          if (y === "" && (l !== "a" || h !== "href")) {
            console.error(
              h === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              h,
              h
            ), o.removeAttribute(h);
            break;
          }
          if (y == null || typeof y == "function" || typeof y == "symbol" || typeof y == "boolean") {
            o.removeAttribute(h);
            break;
          }
          wt(y, h), y = im("" + y), o.setAttribute(h, y);
          break;
        case "action":
        case "formAction":
          if (y != null && (l === "form" ? h === "formAction" ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : typeof y == "function" && (S.encType == null && S.method == null || aC || (aC = !0, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), S.target == null || iC || (iC = !0, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : l === "input" || l === "button" ? h === "action" ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : l !== "input" || S.type === "submit" || S.type === "image" || rC ? l !== "button" || S.type == null || S.type === "submit" || rC ? typeof y == "function" && (S.name == null || zj || (zj = !0, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), S.formEncType == null && S.formMethod == null || aC || (aC = !0, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), S.formTarget == null || iC || (iC = !0, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (rC = !0, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (rC = !0, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : console.error(
            h === "action" ? "You can only pass the action prop to <form>." : "You can only pass the formAction prop to <input> or <button>."
          )), typeof y == "function") {
            o.setAttribute(
              h,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            typeof E == "function" && (h === "formAction" ? (l !== "input" && cr(o, l, "name", S.name, S, null), cr(
              o,
              l,
              "formEncType",
              S.formEncType,
              S,
              null
            ), cr(
              o,
              l,
              "formMethod",
              S.formMethod,
              S,
              null
            ), cr(
              o,
              l,
              "formTarget",
              S.formTarget,
              S,
              null
            )) : (cr(
              o,
              l,
              "encType",
              S.encType,
              S,
              null
            ), cr(o, l, "method", S.method, S, null), cr(
              o,
              l,
              "target",
              S.target,
              S,
              null
            )));
          if (y == null || typeof y == "symbol" || typeof y == "boolean") {
            o.removeAttribute(h);
            break;
          }
          wt(y, h), y = im("" + y), o.setAttribute(h, y);
          break;
        case "onClick":
          y != null && (typeof y != "function" && di(h, y), o.onclick = zs);
          break;
        case "onScroll":
          y != null && (typeof y != "function" && di(h, y), Xt("scroll", o));
          break;
        case "onScrollEnd":
          y != null && (typeof y != "function" && di(h, y), Xt("scrollend", o));
          break;
        case "dangerouslySetInnerHTML":
          if (y != null) {
            if (typeof y != "object" || !("__html" in y))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (h = y.__html, h != null) {
              if (S.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              o.innerHTML = h;
            }
          }
          break;
        case "multiple":
          o.multiple = y && typeof y != "function" && typeof y != "symbol";
          break;
        case "muted":
          o.muted = y && typeof y != "function" && typeof y != "symbol";
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (y == null || typeof y == "function" || typeof y == "boolean" || typeof y == "symbol") {
            o.removeAttribute("xlink:href");
            break;
          }
          wt(y, h), h = im("" + y), o.setAttributeNS(I1, "xlink:href", h);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          y != null && typeof y != "function" && typeof y != "symbol" ? (wt(y, h), o.setAttribute(h, "" + y)) : o.removeAttribute(h);
          break;
        case "inert":
          y !== "" || oC[h] || (oC[h] = !0, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            h
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          y && typeof y != "function" && typeof y != "symbol" ? o.setAttribute(h, "") : o.removeAttribute(h);
          break;
        case "capture":
        case "download":
          y === !0 ? o.setAttribute(h, "") : y !== !1 && y != null && typeof y != "function" && typeof y != "symbol" ? (wt(y, h), o.setAttribute(h, y)) : o.removeAttribute(h);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          y != null && typeof y != "function" && typeof y != "symbol" && !isNaN(y) && 1 <= y ? (wt(y, h), o.setAttribute(h, y)) : o.removeAttribute(h);
          break;
        case "rowSpan":
        case "start":
          y == null || typeof y == "function" || typeof y == "symbol" || isNaN(y) ? o.removeAttribute(h) : (wt(y, h), o.setAttribute(h, y));
          break;
        case "popover":
          Xt("beforetoggle", o), Xt("toggle", o), vn(o, "popover", y);
          break;
        case "xlinkActuate":
          Un(
            o,
            I1,
            "xlink:actuate",
            y
          );
          break;
        case "xlinkArcrole":
          Un(
            o,
            I1,
            "xlink:arcrole",
            y
          );
          break;
        case "xlinkRole":
          Un(
            o,
            I1,
            "xlink:role",
            y
          );
          break;
        case "xlinkShow":
          Un(
            o,
            I1,
            "xlink:show",
            y
          );
          break;
        case "xlinkTitle":
          Un(
            o,
            I1,
            "xlink:title",
            y
          );
          break;
        case "xlinkType":
          Un(
            o,
            I1,
            "xlink:type",
            y
          );
          break;
        case "xmlBase":
          Un(
            o,
            WR,
            "xml:base",
            y
          );
          break;
        case "xmlLang":
          Un(
            o,
            WR,
            "xml:lang",
            y
          );
          break;
        case "xmlSpace":
          Un(
            o,
            WR,
            "xml:space",
            y
          );
          break;
        case "is":
          E != null && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          ), vn(o, "is", y);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          Fj || y == null || typeof y != "object" || (Fj = !0, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            y
          ));
        default:
          !(2 < h.length) || h[0] !== "o" && h[0] !== "O" || h[1] !== "n" && h[1] !== "N" ? (h = W_(h), vn(o, h, y)) : Cc.hasOwnProperty(h) && y != null && typeof y != "function" && di(h, y);
      }
    }
    function Ap(o, l, h, y, S, E) {
      switch (h) {
        case "style":
          Iw(o, y, E);
          break;
        case "dangerouslySetInnerHTML":
          if (y != null) {
            if (typeof y != "object" || !("__html" in y))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (h = y.__html, h != null) {
              if (S.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              o.innerHTML = h;
            }
          }
          break;
        case "children":
          typeof y == "string" ? mf(o, y) : (typeof y == "number" || typeof y == "bigint") && mf(o, "" + y);
          break;
        case "onScroll":
          y != null && (typeof y != "function" && di(h, y), Xt("scroll", o));
          break;
        case "onScrollEnd":
          y != null && (typeof y != "function" && di(h, y), Xt("scrollend", o));
          break;
        case "onClick":
          y != null && (typeof y != "function" && di(h, y), o.onclick = zs);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (Cc.hasOwnProperty(h))
            y != null && typeof y != "function" && di(h, y);
          else
            e: {
              if (h[0] === "o" && h[1] === "n" && (S = h.endsWith("Capture"), l = h.slice(2, S ? h.length - 7 : void 0), E = o[Oo] || null, E = E != null ? E[h] : null, typeof E == "function" && o.removeEventListener(l, E, S), typeof y == "function")) {
                typeof E != "function" && E !== null && (h in o ? o[h] = null : o.hasAttribute(h) && o.removeAttribute(h)), o.addEventListener(l, y, S);
                break e;
              }
              h in o ? o[h] = y : y === !0 ? o.setAttribute(h, "") : vn(o, h, y);
            }
      }
    }
    function ti(o, l, h) {
      switch (Ao(l, h), l) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          Xt("error", o), Xt("load", o);
          var y = !1, S = !1, E;
          for (E in h)
            if (h.hasOwnProperty(E)) {
              var j = h[E];
              if (j != null)
                switch (E) {
                  case "src":
                    y = !0;
                    break;
                  case "srcSet":
                    S = !0;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    cr(o, l, E, j, h, null);
                }
            }
          S && cr(o, l, "srcSet", h.srcSet, h, null), y && cr(o, l, "src", h.src, h, null);
          return;
        case "input":
          en("input", h), Xt("invalid", o);
          var L = E = j = S = null, Q = null, ne = null;
          for (y in h)
            if (h.hasOwnProperty(y)) {
              var be = h[y];
              if (be != null)
                switch (y) {
                  case "name":
                    S = be;
                    break;
                  case "type":
                    j = be;
                    break;
                  case "checked":
                    Q = be;
                    break;
                  case "defaultChecked":
                    ne = be;
                    break;
                  case "value":
                    E = be;
                    break;
                  case "defaultValue":
                    L = be;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (be != null)
                      throw Error(
                        l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    cr(o, l, y, be, h, null);
                }
            }
          ca(o, h), ff(
            o,
            E,
            L,
            Q,
            ne,
            j,
            S,
            !1
          );
          return;
        case "select":
          en("select", h), Xt("invalid", o), y = j = E = null;
          for (S in h)
            if (h.hasOwnProperty(S) && (L = h[S], L != null))
              switch (S) {
                case "value":
                  E = L;
                  break;
                case "defaultValue":
                  j = L;
                  break;
                case "multiple":
                  y = L;
                default:
                  cr(
                    o,
                    l,
                    S,
                    L,
                    h,
                    null
                  );
              }
          ot(o, h), l = E, h = j, o.multiple = !!y, l != null ? we(o, !!y, l, !1) : h != null && we(o, !!y, h, !0);
          return;
        case "textarea":
          en("textarea", h), Xt("invalid", o), E = S = y = null;
          for (j in h)
            if (h.hasOwnProperty(j) && (L = h[j], L != null))
              switch (j) {
                case "value":
                  y = L;
                  break;
                case "defaultValue":
                  S = L;
                  break;
                case "children":
                  E = L;
                  break;
                case "dangerouslySetInnerHTML":
                  if (L != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  cr(
                    o,
                    l,
                    j,
                    L,
                    h,
                    null
                  );
              }
          xt(o, h), li(o, y, S, E);
          return;
        case "option":
          Hg(o, h);
          for (Q in h)
            if (h.hasOwnProperty(Q) && (y = h[Q], y != null))
              switch (Q) {
                case "selected":
                  o.selected = y && typeof y != "function" && typeof y != "symbol";
                  break;
                default:
                  cr(o, l, Q, y, h, null);
              }
          return;
        case "dialog":
          Xt("beforetoggle", o), Xt("toggle", o), Xt("cancel", o), Xt("close", o);
          break;
        case "iframe":
        case "object":
          Xt("load", o);
          break;
        case "video":
        case "audio":
          for (y = 0; y < hS.length; y++)
            Xt(hS[y], o);
          break;
        case "image":
          Xt("error", o), Xt("load", o);
          break;
        case "details":
          Xt("toggle", o);
          break;
        case "embed":
        case "source":
        case "link":
          Xt("error", o), Xt("load", o);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (ne in h)
            if (h.hasOwnProperty(ne) && (y = h[ne], y != null))
              switch (ne) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  cr(o, l, ne, y, h, null);
              }
          return;
        default:
          if (Kl(l)) {
            for (be in h)
              h.hasOwnProperty(be) && (y = h[be], y !== void 0 && Ap(
                o,
                l,
                be,
                y,
                h,
                void 0
              ));
            return;
          }
      }
      for (L in h)
        h.hasOwnProperty(L) && (y = h[L], y != null && cr(o, l, L, y, h, null));
    }
    function Zi(o, l, h, y) {
      switch (Ao(l, y), l) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var S = null, E = null, j = null, L = null, Q = null, ne = null, be = null;
          for (Le in h) {
            var Ee = h[Le];
            if (h.hasOwnProperty(Le) && Ee != null)
              switch (Le) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  Q = Ee;
                default:
                  y.hasOwnProperty(Le) || cr(
                    o,
                    l,
                    Le,
                    null,
                    y,
                    Ee
                  );
              }
          }
          for (var he in y) {
            var Le = y[he];
            if (Ee = h[he], y.hasOwnProperty(he) && (Le != null || Ee != null))
              switch (he) {
                case "type":
                  E = Le;
                  break;
                case "name":
                  S = Le;
                  break;
                case "checked":
                  ne = Le;
                  break;
                case "defaultChecked":
                  be = Le;
                  break;
                case "value":
                  j = Le;
                  break;
                case "defaultValue":
                  L = Le;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (Le != null)
                    throw Error(
                      l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  Le !== Ee && cr(
                    o,
                    l,
                    he,
                    Le,
                    y,
                    Ee
                  );
              }
          }
          l = h.type === "checkbox" || h.type === "radio" ? h.checked != null : h.value != null, y = y.type === "checkbox" || y.type === "radio" ? y.checked != null : y.value != null, l || !y || Bj || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), Bj = !0), !l || y || Lj || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), Lj = !0), pl(
            o,
            j,
            L,
            Q,
            ne,
            be,
            E,
            S
          );
          return;
        case "select":
          Le = j = L = he = null;
          for (E in h)
            if (Q = h[E], h.hasOwnProperty(E) && Q != null)
              switch (E) {
                case "value":
                  break;
                case "multiple":
                  Le = Q;
                default:
                  y.hasOwnProperty(E) || cr(
                    o,
                    l,
                    E,
                    null,
                    y,
                    Q
                  );
              }
          for (S in y)
            if (E = y[S], Q = h[S], y.hasOwnProperty(S) && (E != null || Q != null))
              switch (S) {
                case "value":
                  he = E;
                  break;
                case "defaultValue":
                  L = E;
                  break;
                case "multiple":
                  j = E;
                default:
                  E !== Q && cr(
                    o,
                    l,
                    S,
                    E,
                    y,
                    Q
                  );
              }
          y = L, l = j, h = Le, he != null ? we(o, !!l, he, !1) : !!h != !!l && (y != null ? we(o, !!l, y, !0) : we(o, !!l, l ? [] : "", !1));
          return;
        case "textarea":
          Le = he = null;
          for (L in h)
            if (S = h[L], h.hasOwnProperty(L) && S != null && !y.hasOwnProperty(L))
              switch (L) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  cr(o, l, L, null, y, S);
              }
          for (j in y)
            if (S = y[j], E = h[j], y.hasOwnProperty(j) && (S != null || E != null))
              switch (j) {
                case "value":
                  he = S;
                  break;
                case "defaultValue":
                  Le = S;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (S != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  S !== E && cr(o, l, j, S, y, E);
              }
          Kn(o, he, Le);
          return;
        case "option":
          for (var dt in h)
            if (he = h[dt], h.hasOwnProperty(dt) && he != null && !y.hasOwnProperty(dt))
              switch (dt) {
                case "selected":
                  o.selected = !1;
                  break;
                default:
                  cr(
                    o,
                    l,
                    dt,
                    null,
                    y,
                    he
                  );
              }
          for (Q in y)
            if (he = y[Q], Le = h[Q], y.hasOwnProperty(Q) && he !== Le && (he != null || Le != null))
              switch (Q) {
                case "selected":
                  o.selected = he && typeof he != "function" && typeof he != "symbol";
                  break;
                default:
                  cr(
                    o,
                    l,
                    Q,
                    he,
                    y,
                    Le
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var yt in h)
            he = h[yt], h.hasOwnProperty(yt) && he != null && !y.hasOwnProperty(yt) && cr(
              o,
              l,
              yt,
              null,
              y,
              he
            );
          for (ne in y)
            if (he = y[ne], Le = h[ne], y.hasOwnProperty(ne) && he !== Le && (he != null || Le != null))
              switch (ne) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (he != null)
                    throw Error(
                      l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  cr(
                    o,
                    l,
                    ne,
                    he,
                    y,
                    Le
                  );
              }
          return;
        default:
          if (Kl(l)) {
            for (var Qr in h)
              he = h[Qr], h.hasOwnProperty(Qr) && he !== void 0 && !y.hasOwnProperty(Qr) && Ap(
                o,
                l,
                Qr,
                void 0,
                y,
                he
              );
            for (be in y)
              he = y[be], Le = h[be], !y.hasOwnProperty(be) || he === Le || he === void 0 && Le === void 0 || Ap(
                o,
                l,
                be,
                he,
                y,
                Le
              );
            return;
          }
      }
      for (var Hn in h)
        he = h[Hn], h.hasOwnProperty(Hn) && he != null && !y.hasOwnProperty(Hn) && cr(o, l, Hn, null, y, he);
      for (Ee in y)
        he = y[Ee], Le = h[Ee], !y.hasOwnProperty(Ee) || he === Le || he == null && Le == null || cr(o, l, Ee, he, y, Le);
    }
    function wu(o) {
      switch (o) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return o;
      }
    }
    function Od(o) {
      var l = {};
      o = o.style;
      for (var h = 0; h < o.length; h++) {
        var y = o[h];
        l[y] = o.getPropertyValue(y);
      }
      return l;
    }
    function wc(o, l, h) {
      if (l != null && typeof l != "object")
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var y, S = y = "", E;
        for (E in l)
          if (l.hasOwnProperty(E)) {
            var j = l[E];
            j != null && typeof j != "boolean" && j !== "" && (E.indexOf("--") === 0 ? (Ot(j, E), y += S + E + ":" + ("" + j).trim()) : typeof j != "number" || j === 0 || Dt.has(E) ? (Ot(j, E), y += S + E.replace(Fe, "-$1").toLowerCase().replace(Et, "-ms-") + ":" + ("" + j).trim()) : y += S + E.replace(Fe, "-$1").toLowerCase().replace(Et, "-ms-") + ":" + j + "px", S = ";");
          }
        y = y || null, l = o.getAttribute("style"), l !== y && (y = Il(y), Il(l) !== y && (h.style = Od(o)));
      }
    }
    function $o(o, l, h, y, S, E) {
      if (S.delete(h), o = o.getAttribute(h), o === null)
        switch (typeof y) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (y != null)
        switch (typeof y) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (wt(y, l), o === "" + y)
              return;
        }
      ui(l, o, y, E);
    }
    function ty(o, l, h, y, S, E) {
      if (S.delete(h), o = o.getAttribute(h), o === null) {
        switch (typeof y) {
          case "function":
          case "symbol":
            return;
        }
        if (!y)
          return;
      } else
        switch (typeof y) {
          case "function":
          case "symbol":
            break;
          default:
            if (y)
              return;
        }
      ui(l, o, y, E);
    }
    function ny(o, l, h, y, S, E) {
      if (S.delete(h), o = o.getAttribute(h), o === null)
        switch (typeof y) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (y != null)
        switch (typeof y) {
          case "function":
          case "symbol":
            break;
          default:
            if (wt(y, h), o === "" + y)
              return;
        }
      ui(l, o, y, E);
    }
    function Cp(o, l, h, y, S, E) {
      if (S.delete(h), o = o.getAttribute(h), o === null)
        switch (typeof y) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(y))
              return;
        }
      else if (y != null)
        switch (typeof y) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(y) && (wt(y, l), o === "" + y))
              return;
        }
      ui(l, o, y, E);
    }
    function Zm(o, l, h, y, S, E) {
      if (S.delete(h), o = o.getAttribute(h), o === null)
        switch (typeof y) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (y != null)
        switch (typeof y) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (wt(y, l), h = im("" + y), o === h)
              return;
        }
      ui(l, o, y, E);
    }
    function Ho(o, l, h, y) {
      for (var S = {}, E = /* @__PURE__ */ new Set(), j = o.attributes, L = 0; L < j.length; L++)
        switch (j[L].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            E.add(j[L].name);
        }
      if (Kl(l)) {
        for (var Q in h)
          if (h.hasOwnProperty(Q)) {
            var ne = h[Q];
            if (ne != null) {
              if (Cc.hasOwnProperty(Q))
                typeof ne != "function" && di(Q, ne);
              else if (h.suppressHydrationWarning !== !0)
                switch (Q) {
                  case "children":
                    typeof ne != "string" && typeof ne != "number" || ui(
                      "children",
                      o.textContent,
                      ne,
                      S
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    j = o.innerHTML, ne = ne ? ne.__html : void 0, ne != null && (ne = ey(o, ne), ui(
                      Q,
                      j,
                      ne,
                      S
                    ));
                    continue;
                  case "style":
                    E.delete(Q), wc(o, ne, S);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    E.delete(Q.toLowerCase()), console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      Q
                    );
                    continue;
                  case "className":
                    E.delete("class"), j = jn(
                      o,
                      "class",
                      ne
                    ), ui(
                      "className",
                      j,
                      ne,
                      S
                    );
                    continue;
                  default:
                    y.context === gh && l !== "svg" && l !== "math" ? E.delete(Q.toLowerCase()) : E.delete(Q), j = jn(
                      o,
                      Q,
                      ne
                    ), ui(
                      Q,
                      j,
                      ne,
                      S
                    );
                }
            }
          }
      } else
        for (ne in h)
          if (h.hasOwnProperty(ne) && (Q = h[ne], Q != null)) {
            if (Cc.hasOwnProperty(ne))
              typeof Q != "function" && di(ne, Q);
            else if (h.suppressHydrationWarning !== !0)
              switch (ne) {
                case "children":
                  typeof Q != "string" && typeof Q != "number" || ui(
                    "children",
                    o.textContent,
                    Q,
                    S
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  j = o.innerHTML, Q = Q ? Q.__html : void 0, Q != null && (Q = ey(o, Q), j !== Q && (S[ne] = { __html: j }));
                  continue;
                case "className":
                  $o(
                    o,
                    ne,
                    "class",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "tabIndex":
                  $o(
                    o,
                    ne,
                    "tabindex",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "style":
                  E.delete(ne), wc(o, Q, S);
                  continue;
                case "multiple":
                  E.delete(ne), ui(
                    ne,
                    o.multiple,
                    Q,
                    S
                  );
                  continue;
                case "muted":
                  E.delete(ne), ui(
                    ne,
                    o.muted,
                    Q,
                    S
                  );
                  continue;
                case "autoFocus":
                  E.delete("autofocus"), ui(
                    ne,
                    o.autofocus,
                    Q,
                    S
                  );
                  continue;
                case "data":
                  if (l !== "object") {
                    E.delete(ne), j = o.getAttribute("data"), ui(
                      ne,
                      j,
                      Q,
                      S
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!(Q !== "" || l === "a" && ne === "href" || l === "object" && ne === "data")) {
                    console.error(
                      ne === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      ne,
                      ne
                    );
                    continue;
                  }
                  Zm(
                    o,
                    ne,
                    ne,
                    Q,
                    E,
                    S
                  );
                  continue;
                case "action":
                case "formAction":
                  if (j = o.getAttribute(ne), typeof Q == "function") {
                    E.delete(ne.toLowerCase()), ne === "formAction" ? (E.delete("name"), E.delete("formenctype"), E.delete("formmethod"), E.delete("formtarget")) : (E.delete("enctype"), E.delete("method"), E.delete("target"));
                    continue;
                  } else if (j === Kte) {
                    E.delete(ne.toLowerCase()), ui(
                      ne,
                      "function",
                      Q,
                      S
                    );
                    continue;
                  }
                  Zm(
                    o,
                    ne,
                    ne.toLowerCase(),
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xlinkHref":
                  Zm(
                    o,
                    ne,
                    "xlink:href",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "contentEditable":
                  ny(
                    o,
                    ne,
                    "contenteditable",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "spellCheck":
                  ny(
                    o,
                    ne,
                    "spellcheck",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  ny(
                    o,
                    ne,
                    ne,
                    Q,
                    E,
                    S
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  ty(
                    o,
                    ne,
                    ne.toLowerCase(),
                    Q,
                    E,
                    S
                  );
                  continue;
                case "capture":
                case "download":
                  e: {
                    L = o;
                    var be = j = ne, Ee = S;
                    if (E.delete(be), L = L.getAttribute(be), L === null)
                      switch (typeof Q) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break e;
                        default:
                          if (Q === !1)
                            break e;
                      }
                    else if (Q != null)
                      switch (typeof Q) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (Q === !0 && L === "")
                            break e;
                          break;
                        default:
                          if (wt(Q, j), L === "" + Q)
                            break e;
                      }
                    ui(
                      j,
                      L,
                      Q,
                      Ee
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  e: {
                    if (L = o, be = j = ne, Ee = S, E.delete(be), L = L.getAttribute(be), L === null)
                      switch (typeof Q) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break e;
                        default:
                          if (isNaN(Q) || 1 > Q)
                            break e;
                      }
                    else if (Q != null)
                      switch (typeof Q) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(Q) || 1 > Q) && (wt(Q, j), L === "" + Q))
                            break e;
                      }
                    ui(
                      j,
                      L,
                      Q,
                      Ee
                    );
                  }
                  continue;
                case "rowSpan":
                  Cp(
                    o,
                    ne,
                    "rowspan",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "start":
                  Cp(
                    o,
                    ne,
                    ne,
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xHeight":
                  $o(
                    o,
                    ne,
                    "x-height",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xlinkActuate":
                  $o(
                    o,
                    ne,
                    "xlink:actuate",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xlinkArcrole":
                  $o(
                    o,
                    ne,
                    "xlink:arcrole",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xlinkRole":
                  $o(
                    o,
                    ne,
                    "xlink:role",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xlinkShow":
                  $o(
                    o,
                    ne,
                    "xlink:show",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xlinkTitle":
                  $o(
                    o,
                    ne,
                    "xlink:title",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xlinkType":
                  $o(
                    o,
                    ne,
                    "xlink:type",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xmlBase":
                  $o(
                    o,
                    ne,
                    "xml:base",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xmlLang":
                  $o(
                    o,
                    ne,
                    "xml:lang",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "xmlSpace":
                  $o(
                    o,
                    ne,
                    "xml:space",
                    Q,
                    E,
                    S
                  );
                  continue;
                case "inert":
                  Q !== "" || oC[ne] || (oC[ne] = !0, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    ne
                  )), ty(
                    o,
                    ne,
                    ne,
                    Q,
                    E,
                    S
                  );
                  continue;
                default:
                  if (!(2 < ne.length) || ne[0] !== "o" && ne[0] !== "O" || ne[1] !== "n" && ne[1] !== "N") {
                    L = W_(ne), j = !1, y.context === gh && l !== "svg" && l !== "math" ? E.delete(L.toLowerCase()) : (be = ne.toLowerCase(), be = Ll.hasOwnProperty(
                      be
                    ) && Ll[be] || null, be !== null && be !== ne && (j = !0, E.delete(be)), E.delete(L));
                    e:
                      if (be = o, Ee = L, L = Q, sr(Ee))
                        if (be.hasAttribute(Ee))
                          be = be.getAttribute(
                            Ee
                          ), wt(
                            L,
                            Ee
                          ), L = be === "" + L ? L : be;
                        else {
                          switch (typeof L) {
                            case "function":
                            case "symbol":
                              break e;
                            case "boolean":
                              if (be = Ee.toLowerCase().slice(0, 5), be !== "data-" && be !== "aria-")
                                break e;
                          }
                          L = L === void 0 ? void 0 : null;
                        }
                      else
                        L = void 0;
                    j || ui(
                      ne,
                      L,
                      Q,
                      S
                    );
                  }
              }
          }
      return 0 < E.size && h.suppressHydrationWarning !== !0 && Qm(o, E, S), Object.keys(S).length === 0 ? null : S;
    }
    function j3(o, l) {
      switch (o.length) {
        case 0:
          return "";
        case 1:
          return o[0];
        case 2:
          return o[0] + " " + l + " " + o[1];
        default:
          return o.slice(0, -1).join(", ") + ", " + l + " " + o[o.length - 1];
      }
    }
    function Co(o) {
      switch (o) {
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
          return !0;
        default:
          return !1;
      }
    }
    function P3() {
      if (typeof performance.getEntriesByType == "function") {
        for (var o = 0, l = 0, h = performance.getEntriesByType("resource"), y = 0; y < h.length; y++) {
          var S = h[y], E = S.transferSize, j = S.initiatorType, L = S.duration;
          if (E && L && Co(j)) {
            for (j = 0, L = S.responseEnd, y += 1; y < h.length; y++) {
              var Q = h[y], ne = Q.startTime;
              if (ne > L)
                break;
              var be = Q.transferSize, Ee = Q.initiatorType;
              be && Co(Ee) && (Q = Q.responseEnd, j += be * (Q < L ? 1 : (L - ne) / (Q - ne)));
            }
            if (--y, l += 8 * (E + j) / (S.duration / 1e3), o++, 10 < o)
              break;
          }
        }
        if (0 < o)
          return l / o / 1e6;
      }
      return navigator.connection && (o = navigator.connection.downlink, typeof o == "number") ? o : 5;
    }
    function Km(o) {
      return o.nodeType === 9 ? o : o.ownerDocument;
    }
    function L3(o) {
      switch (o) {
        case mn:
          return nb;
        case ln:
          return lC;
        default:
          return gh;
      }
    }
    function xu(o, l) {
      if (o === gh)
        switch (l) {
          case "svg":
            return nb;
          case "math":
            return lC;
          default:
            return gh;
        }
      return o === nb && l === "foreignObject" ? gh : o;
    }
    function Tp(o, l) {
      return o === "textarea" || o === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.children == "bigint" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
    }
    function ex() {
      var o = window.event;
      return o && o.type === "popstate" ? o === JR ? !1 : (JR = o, !0) : (JR = null, !1);
    }
    function xc() {
      var o = window.event;
      return o && o !== gS ? o.type : null;
    }
    function Op() {
      var o = window.event;
      return o && o !== gS ? o.timeStamp : -1.1;
    }
    function B3(o) {
      setTimeout(function() {
        throw o;
      });
    }
    function z3(o, l, h) {
      switch (l) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          h.autoFocus && o.focus();
          break;
        case "img":
          h.src ? o.src = h.src : h.srcSet && (o.srcset = h.srcSet);
      }
    }
    function F3() {
    }
    function ry(o, l, h, y) {
      Zi(o, l, h, y), o[Oo] = y;
    }
    function iy(o) {
      mf(o, "");
    }
    function VO(o, l, h) {
      o.nodeValue = h;
    }
    function V3(o) {
      if (!o.__reactWarnedAboutChildrenConflict) {
        var l = o[Oo] || null;
        if (l !== null) {
          var h = st(o);
          h !== null && (typeof l.children == "string" || typeof l.children == "number" ? (o.__reactWarnedAboutChildrenConflict = !0, Ce(h, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })) : l.dangerouslySetInnerHTML != null && (o.__reactWarnedAboutChildrenConflict = !0, Ce(h, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })));
        }
      }
    }
    function Rd(o) {
      return o === "head";
    }
    function U3(o, l) {
      o.removeChild(l);
    }
    function $3(o, l) {
      (o.nodeType === 9 ? o.body : o.nodeName === "HTML" ? o.ownerDocument.body : o).removeChild(l);
    }
    function Yf(o, l) {
      var h = l, y = 0;
      do {
        var S = h.nextSibling;
        if (o.removeChild(h), S && S.nodeType === 8)
          if (h = S.data, h === mS || h === sC) {
            if (y === 0) {
              o.removeChild(S), Zf(l);
              return;
            }
            y--;
          } else if (h === pS || h === d0 || h === j1 || h === tb || h === k1)
            y++;
          else if (h === ene)
            Eu(
              o.ownerDocument.documentElement
            );
          else if (h === nne) {
            h = o.ownerDocument.head, Eu(h);
            for (var E = h.firstChild; E; ) {
              var j = E.nextSibling, L = E.nodeName;
              E[Hp] || L === "SCRIPT" || L === "STYLE" || L === "LINK" && E.rel.toLowerCase() === "stylesheet" || h.removeChild(E), E = j;
            }
          } else
            h === tne && Eu(o.ownerDocument.body);
        h = S;
      } while (h);
      Zf(l);
    }
    function Jm(o, l) {
      var h = o;
      o = 0;
      do {
        var y = h.nextSibling;
        if (h.nodeType === 1 ? l ? (h._stashedDisplay = h.style.display, h.style.display = "none") : (h.style.display = h._stashedDisplay || "", h.getAttribute("style") === "" && h.removeAttribute("style")) : h.nodeType === 3 && (l ? (h._stashedText = h.nodeValue, h.nodeValue = "") : h.nodeValue = h._stashedText || ""), y && y.nodeType === 8)
          if (h = y.data, h === mS) {
            if (o === 0)
              break;
            o--;
          } else
            h !== pS && h !== d0 && h !== j1 && h !== tb || o++;
        h = y;
      } while (h);
    }
    function H3(o) {
      Jm(o, !0);
    }
    function q3(o) {
      o = o.style, typeof o.setProperty == "function" ? o.setProperty("display", "none", "important") : o.display = "none";
    }
    function G3(o) {
      o.nodeValue = "";
    }
    function Y3(o) {
      Jm(o, !1);
    }
    function X3(o, l) {
      l = l[rne], l = l != null && l.hasOwnProperty("display") ? l.display : null, o.style.display = l == null || typeof l == "boolean" ? "" : ("" + l).trim();
    }
    function W3(o, l) {
      o.nodeValue = l;
    }
    function Rp(o) {
      var l = o.firstChild;
      for (l && l.nodeType === 10 && (l = l.nextSibling); l; ) {
        var h = l;
        switch (l = l.nextSibling, h.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            Rp(h), Ae(h);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if (h.rel.toLowerCase() === "stylesheet")
              continue;
        }
        o.removeChild(h);
      }
    }
    function Q3(o, l, h, y) {
      for (; o.nodeType === 1; ) {
        var S = h;
        if (o.nodeName.toLowerCase() !== l.toLowerCase()) {
          if (!y && (o.nodeName !== "INPUT" || o.type !== "hidden"))
            break;
        } else if (y) {
          if (!o[Hp])
            switch (l) {
              case "meta":
                if (!o.hasAttribute("itemprop"))
                  break;
                return o;
              case "link":
                if (E = o.getAttribute("rel"), E === "stylesheet" && o.hasAttribute("data-precedence"))
                  break;
                if (E !== S.rel || o.getAttribute("href") !== (S.href == null || S.href === "" ? null : S.href) || o.getAttribute("crossorigin") !== (S.crossOrigin == null ? null : S.crossOrigin) || o.getAttribute("title") !== (S.title == null ? null : S.title))
                  break;
                return o;
              case "style":
                if (o.hasAttribute("data-precedence"))
                  break;
                return o;
              case "script":
                if (E = o.getAttribute("src"), (E !== (S.src == null ? null : S.src) || o.getAttribute("type") !== (S.type == null ? null : S.type) || o.getAttribute("crossorigin") !== (S.crossOrigin == null ? null : S.crossOrigin)) && E && o.hasAttribute("async") && !o.hasAttribute("itemprop"))
                  break;
                return o;
              default:
                return o;
            }
        } else if (l === "input" && o.type === "hidden") {
          wt(S.name, "name");
          var E = S.name == null ? null : "" + S.name;
          if (S.type === "hidden" && o.getAttribute("name") === E)
            return o;
        } else
          return o;
        if (o = vs(o.nextSibling), o === null)
          break;
      }
      return null;
    }
    function Z3(o, l, h) {
      if (l === "")
        return null;
      for (; o.nodeType !== 3; )
        if ((o.nodeType !== 1 || o.nodeName !== "INPUT" || o.type !== "hidden") && !h || (o = vs(o.nextSibling), o === null))
          return null;
      return o;
    }
    function mr(o, l) {
      for (; o.nodeType !== 8; )
        if ((o.nodeType !== 1 || o.nodeName !== "INPUT" || o.type !== "hidden") && !l || (o = vs(o.nextSibling), o === null))
          return null;
      return o;
    }
    function e1(o) {
      return o.data === d0 || o.data === j1;
    }
    function tx(o) {
      return o.data === tb || o.data === d0 && o.ownerDocument.readyState !== Uj;
    }
    function K3(o, l) {
      var h = o.ownerDocument;
      if (o.data === j1)
        o._reactRetry = l;
      else if (o.data !== d0 || h.readyState !== Uj)
        l();
      else {
        var y = function() {
          l(), h.removeEventListener("DOMContentLoaded", y);
        };
        h.addEventListener("DOMContentLoaded", y), o._reactRetry = y;
      }
    }
    function vs(o) {
      for (; o != null; o = o.nextSibling) {
        var l = o.nodeType;
        if (l === 1 || l === 3)
          break;
        if (l === 8) {
          if (l = o.data, l === pS || l === tb || l === d0 || l === j1 || l === k1 || l === QR || l === Vj)
            break;
          if (l === mS || l === sC)
            return null;
        }
      }
      return o;
    }
    function J3(o) {
      if (o.nodeType === 1) {
        for (var l = o.nodeName.toLowerCase(), h = {}, y = o.attributes, S = 0; S < y.length; S++) {
          var E = y[S];
          h[wu(E.name)] = E.name.toLowerCase() === "style" ? Od(o) : E.value;
        }
        return { type: l, props: h };
      }
      return o.nodeType === 8 ? o.data === k1 ? { type: "Activity", props: {} } : { type: "Suspense", props: {} } : o.nodeValue;
    }
    function eA(o, l, h) {
      return h === null || h[Jte] !== !0 ? (o.nodeValue === l ? o = null : (l = Il(l), o = Il(o.nodeValue) === l ? null : o.nodeValue), o) : null;
    }
    function Dp(o) {
      o = o.nextSibling;
      for (var l = 0; o; ) {
        if (o.nodeType === 8) {
          var h = o.data;
          if (h === mS || h === sC) {
            if (l === 0)
              return vs(o.nextSibling);
            l--;
          } else
            h !== pS && h !== tb && h !== d0 && h !== j1 && h !== k1 || l++;
        }
        o = o.nextSibling;
      }
      return null;
    }
    function Xf(o) {
      o = o.previousSibling;
      for (var l = 0; o; ) {
        if (o.nodeType === 8) {
          var h = o.data;
          if (h === pS || h === tb || h === d0 || h === j1 || h === k1) {
            if (l === 0)
              return o;
            l--;
          } else
            h !== mS && h !== sC || l++;
        }
        o = o.previousSibling;
      }
      return null;
    }
    function nx(o) {
      Zf(o);
    }
    function ay(o) {
      Zf(o);
    }
    function rx(o) {
      Zf(o);
    }
    function Su(o, l, h, y, S) {
      switch (S && nm(o, y.ancestorInfo), l = Km(h), o) {
        case "html":
          if (o = l.documentElement, !o)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return o;
        case "head":
          if (o = l.head, !o)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return o;
        case "body":
          if (o = l.body, !o)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return o;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function Sc(o, l, h, y) {
      if (!h[Au] && st(h)) {
        var S = h.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          S,
          S,
          S
        );
      }
      switch (o) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (S = h.attributes; S.length; )
        h.removeAttributeNode(S[0]);
      ti(h, o, l), h[ni] = y, h[Oo] = l;
    }
    function Eu(o) {
      for (var l = o.attributes; l.length; )
        o.removeAttributeNode(l[0]);
      Ae(o);
    }
    function oy(o) {
      return typeof o.getRootNode == "function" ? o.getRootNode() : o.nodeType === 9 ? o : o.ownerDocument;
    }
    function ix(o, l, h) {
      var y = rb;
      if (y && typeof l == "string" && l) {
        var S = Rn(l);
        S = 'link[rel="' + o + '"][href="' + S + '"]', typeof h == "string" && (S += '[crossorigin="' + h + '"]'), Xj.has(S) || (Xj.add(S), o = { rel: o, crossOrigin: h, href: l }, y.querySelector(S) === null && (l = y.createElement("link"), ti(l, "link", o), Ke(l), y.head.appendChild(l)));
      }
    }
    function ax(o, l, h, y) {
      var S = (S = ys.current) ? oy(S) : null;
      if (!S)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (o) {
        case "meta":
        case "title":
          return null;
        case "style":
          return typeof h.precedence == "string" && typeof h.href == "string" ? (h = Wf(h.href), l = bt(S).hoistableStyles, y = l.get(h), y || (y = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, l.set(h, y)), y) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if (h.rel === "stylesheet" && typeof h.href == "string" && typeof h.precedence == "string") {
            o = Wf(h.href);
            var E = bt(S).hoistableStyles, j = E.get(o);
            if (!j && (S = S.ownerDocument || S, j = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: L1, preload: null }
            }, E.set(o, j), (E = S.querySelector(
              n1(o)
            )) && !E._p && (j.instance = E, j.state.loading = vS | Lc), !Bc.has(o))) {
              var L = {
                rel: "preload",
                as: "style",
                href: h.href,
                crossOrigin: h.crossOrigin,
                integrity: h.integrity,
                media: h.media,
                hrefLang: h.hrefLang,
                referrerPolicy: h.referrerPolicy
              };
              Bc.set(o, L), E || tA(
                S,
                o,
                L,
                j.state
              );
            }
            if (l && y === null)
              throw h = `

  - ` + t1(l) + `
  + ` + t1(h), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + h
              );
            return j;
          }
          if (l && y !== null)
            throw h = `

  - ` + t1(l) + `
  + ` + t1(h), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + h
            );
          return null;
        case "script":
          return l = h.async, h = h.src, typeof h == "string" && l && typeof l != "function" && typeof l != "symbol" ? (h = Qf(h), l = bt(S).hoistableScripts, y = l.get(h), y || (y = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, l.set(h, y)), y) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + o + '". this is a bug in React.'
          );
      }
    }
    function t1(o) {
      var l = 0, h = "<link";
      return typeof o.rel == "string" ? (l++, h += ' rel="' + o.rel + '"') : bs.call(o, "rel") && (l++, h += ' rel="' + (o.rel === null ? "null" : "invalid type " + typeof o.rel) + '"'), typeof o.href == "string" ? (l++, h += ' href="' + o.href + '"') : bs.call(o, "href") && (l++, h += ' href="' + (o.href === null ? "null" : "invalid type " + typeof o.href) + '"'), typeof o.precedence == "string" ? (l++, h += ' precedence="' + o.precedence + '"') : bs.call(o, "precedence") && (l++, h += " precedence={" + (o.precedence === null ? "null" : "invalid type " + typeof o.precedence) + "}"), Object.getOwnPropertyNames(o).length > l && (h += " ..."), h + " />";
    }
    function Wf(o) {
      return 'href="' + Rn(o) + '"';
    }
    function n1(o) {
      return 'link[rel="stylesheet"][' + o + "]";
    }
    function sy(o) {
      return yn({}, o, {
        "data-precedence": o.precedence,
        precedence: null
      });
    }
    function tA(o, l, h, y) {
      o.querySelector(
        'link[rel="preload"][as="style"][' + l + "]"
      ) ? y.loading = vS : (l = o.createElement("link"), y.preload = l, l.addEventListener("load", function() {
        return y.loading |= vS;
      }), l.addEventListener("error", function() {
        return y.loading |= Gj;
      }), ti(l, "link", h), Ke(l), o.head.appendChild(l));
    }
    function Qf(o) {
      return '[src="' + Rn(o) + '"]';
    }
    function r1(o) {
      return "script[async]" + o;
    }
    function ly(o, l, h) {
      if (l.count++, l.instance === null)
        switch (l.type) {
          case "style":
            var y = o.querySelector(
              'style[data-href~="' + Rn(h.href) + '"]'
            );
            if (y)
              return l.instance = y, Ke(y), y;
            var S = yn({}, h, {
              "data-href": h.href,
              "data-precedence": h.precedence,
              href: null,
              precedence: null
            });
            return y = (o.ownerDocument || o).createElement("style"), Ke(y), ti(y, "style", S), Np(y, h.precedence, o), l.instance = y;
          case "stylesheet":
            S = Wf(h.href);
            var E = o.querySelector(
              n1(S)
            );
            if (E)
              return l.state.loading |= Lc, l.instance = E, Ke(E), E;
            y = sy(h), (S = Bc.get(S)) && ox(y, S), E = (o.ownerDocument || o).createElement("link"), Ke(E);
            var j = E;
            return j._p = new Promise(function(L, Q) {
              j.onload = L, j.onerror = Q;
            }), ti(E, "link", y), l.state.loading |= Lc, Np(E, h.precedence, o), l.instance = E;
          case "script":
            return E = Qf(h.src), (S = o.querySelector(
              r1(E)
            )) ? (l.instance = S, Ke(S), S) : (y = h, (S = Bc.get(E)) && (y = yn({}, h), sx(y, S)), o = o.ownerDocument || o, S = o.createElement("script"), Ke(S), ti(S, "link", y), o.head.appendChild(S), l.instance = S);
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + l.type + '". this is a bug in React.'
            );
        }
      else
        l.type === "stylesheet" && (l.state.loading & Lc) === L1 && (y = l.instance, l.state.loading |= Lc, Np(y, h.precedence, o));
      return l.instance;
    }
    function Np(o, l, h) {
      for (var y = h.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), S = y.length ? y[y.length - 1] : null, E = S, j = 0; j < y.length; j++) {
        var L = y[j];
        if (L.dataset.precedence === l)
          E = L;
        else if (E !== S)
          break;
      }
      E ? E.parentNode.insertBefore(o, E.nextSibling) : (l = h.nodeType === 9 ? h.head : h, l.insertBefore(o, l.firstChild));
    }
    function ox(o, l) {
      o.crossOrigin == null && (o.crossOrigin = l.crossOrigin), o.referrerPolicy == null && (o.referrerPolicy = l.referrerPolicy), o.title == null && (o.title = l.title);
    }
    function sx(o, l) {
      o.crossOrigin == null && (o.crossOrigin = l.crossOrigin), o.referrerPolicy == null && (o.referrerPolicy = l.referrerPolicy), o.integrity == null && (o.integrity = l.integrity);
    }
    function Mp(o, l, h) {
      if (cC === null) {
        var y = /* @__PURE__ */ new Map(), S = cC = /* @__PURE__ */ new Map();
        S.set(h, y);
      } else
        S = cC, y = S.get(h), y || (y = /* @__PURE__ */ new Map(), S.set(h, y));
      if (y.has(o))
        return y;
      for (y.set(o, null), h = h.getElementsByTagName(o), S = 0; S < h.length; S++) {
        var E = h[S];
        if (!(E[Hp] || E[ni] || o === "link" && E.getAttribute("rel") === "stylesheet") && E.namespaceURI !== mn) {
          var j = E.getAttribute(l) || "";
          j = o + j;
          var L = y.get(j);
          L ? L.push(E) : y.set(j, [E]);
        }
      }
      return y;
    }
    function nA(o, l, h) {
      o = o.ownerDocument || o, o.head.insertBefore(
        h,
        l === "title" ? o.querySelector("head > title") : null
      );
    }
    function rA(o, l, h) {
      var y = !h.ancestorInfo.containerTagInScope;
      if (h.context === nb || l.itemProp != null)
        return !y || l.itemProp == null || o !== "meta" && o !== "title" && o !== "style" && o !== "link" && o !== "script" || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          o,
          o
        ), !1;
      switch (o) {
        case "meta":
        case "title":
          return !0;
        case "style":
          if (typeof l.precedence != "string" || typeof l.href != "string" || l.href === "") {
            y && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return !0;
        case "link":
          if (typeof l.rel != "string" || typeof l.href != "string" || l.href === "" || l.onLoad || l.onError) {
            if (l.rel === "stylesheet" && typeof l.precedence == "string") {
              o = l.href;
              var S = l.onError, E = l.disabled;
              h = [], l.onLoad && h.push("`onLoad`"), S && h.push("`onError`"), E != null && h.push("`disabled`"), S = j3(h, "and"), S += h.length === 1 ? " prop" : " props", E = h.length === 1 ? "an " + S : "the " + S, h.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                o,
                E,
                S
              );
            }
            y && (typeof l.rel != "string" || typeof l.href != "string" || l.href === "" ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (l.onError || l.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (l.rel) {
            case "stylesheet":
              return o = l.precedence, l = l.disabled, typeof o != "string" && y && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), typeof o == "string" && l == null;
            default:
              return !0;
          }
        case "script":
          if (o = l.async && typeof l.async != "function" && typeof l.async != "symbol", !o || l.onLoad || l.onError || !l.src || typeof l.src != "string") {
            y && (o ? l.onLoad || l.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return !0;
        case "noscript":
        case "template":
          y && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            o
          );
      }
      return !1;
    }
    function Dn(o) {
      return !(o.type === "stylesheet" && (o.state.loading & Yj) === L1);
    }
    function lx(o, l, h, y) {
      if (h.type === "stylesheet" && (typeof y.media != "string" || matchMedia(y.media).matches !== !1) && (h.state.loading & Lc) === L1) {
        if (h.instance === null) {
          var S = Wf(y.href), E = l.querySelector(
            n1(S)
          );
          if (E) {
            l = E._p, l !== null && typeof l == "object" && typeof l.then == "function" && (o.count++, o = Ip.bind(o), l.then(o, o)), h.state.loading |= Lc, h.instance = E, Ke(E);
            return;
          }
          E = l.ownerDocument || l, y = sy(y), (S = Bc.get(S)) && ox(y, S), E = E.createElement("link"), Ke(E);
          var j = E;
          j._p = new Promise(function(L, Q) {
            j.onload = L, j.onerror = Q;
          }), ti(E, "link", y), h.instance = E;
        }
        o.stylesheets === null && (o.stylesheets = /* @__PURE__ */ new Map()), o.stylesheets.set(h, l), (l = h.state.preload) && (h.state.loading & Yj) === L1 && (o.count++, h = Ip.bind(o), l.addEventListener("load", h), l.addEventListener("error", h));
      }
    }
    function cy(o, l) {
      return o.stylesheets && o.count === 0 && i1(o, o.stylesheets), 0 < o.count || 0 < o.imgCount ? function(h) {
        var y = setTimeout(function() {
          if (o.stylesheets && i1(o, o.stylesheets), o.unsuspend) {
            var E = o.unsuspend;
            o.unsuspend = null, E();
          }
        }, one + l);
        0 < o.imgBytes && t6 === 0 && (t6 = 125 * P3() * lne);
        var S = setTimeout(
          function() {
            if (o.waitingForImages = !1, o.count === 0 && (o.stylesheets && i1(o, o.stylesheets), o.unsuspend)) {
              var E = o.unsuspend;
              o.unsuspend = null, E();
            }
          },
          (o.imgBytes > t6 ? 50 : sne) + l
        );
        return o.unsuspend = h, function() {
          o.unsuspend = null, clearTimeout(y), clearTimeout(S);
        };
      } : null;
    }
    function Ip() {
      if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
        if (this.stylesheets)
          i1(this, this.stylesheets);
        else if (this.unsuspend) {
          var o = this.unsuspend;
          this.unsuspend = null, o();
        }
      }
    }
    function i1(o, l) {
      o.stylesheets = null, o.unsuspend !== null && (o.count++, uC = /* @__PURE__ */ new Map(), l.forEach(cx, o), uC = null, Ip.call(o));
    }
    function cx(o, l) {
      if (!(l.state.loading & Lc)) {
        var h = uC.get(o);
        if (h)
          var y = h.get(n6);
        else {
          h = /* @__PURE__ */ new Map(), uC.set(o, h);
          for (var S = o.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), E = 0; E < S.length; E++) {
            var j = S[E];
            (j.nodeName === "LINK" || j.getAttribute("media") !== "not all") && (h.set(j.dataset.precedence, j), y = j);
          }
          y && h.set(n6, y);
        }
        S = l.instance, j = S.getAttribute("data-precedence"), E = h.get(j) || y, E === y && h.set(n6, S), h.set(j, S), this.count++, y = Ip.bind(this), S.addEventListener("load", y), S.addEventListener("error", y), E ? E.parentNode.insertBefore(S, E.nextSibling) : (o = o.nodeType === 9 ? o.head : o, o.insertBefore(S, o.firstChild)), l.state.loading |= Lc;
      }
    }
    function a1(o, l, h, y, S, E, j, L, Q) {
      for (this.tag = 1, this.containerInfo = o, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = P1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Mt(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Mt(0), this.hiddenUpdates = Mt(null), this.identifierPrefix = y, this.onUncaughtError = S, this.onCaughtError = E, this.onRecoverableError = j, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = Q, this.incompleteTransitions = /* @__PURE__ */ new Map(), this.passiveEffectDuration = this.effectDuration = -0, this.memoizedUpdaters = /* @__PURE__ */ new Set(), o = this.pendingUpdatersLaneMap = [], l = 0; 31 > l; l++)
        o.push(/* @__PURE__ */ new Set());
      this._debugRootType = h ? "hydrateRoot()" : "createRoot()";
    }
    function o1(o, l, h, y, S, E, j, L, Q, ne, be, Ee) {
      return o = new a1(
        o,
        l,
        h,
        j,
        Q,
        ne,
        be,
        Ee,
        L
      ), l = Ite, E === !0 && (l |= Yo | Cu), l |= bn, E = b(3, null, null, l), o.current = E, E.stateNode = o, l = lv(), Af(l), o.pooledCache = l, Af(l), E.memoizedState = {
        element: y,
        isDehydrated: h,
        cache: l
      }, Pn(E), o;
    }
    function iA(o) {
      return o ? (o = Qp, o) : Qp;
    }
    function uy(o, l, h, y, S, E) {
      if (Ki && typeof Ki.onScheduleFiberRoot == "function")
        try {
          Ki.onScheduleFiberRoot(th, y, h);
        } catch (j) {
          _c || (_c = !0, console.error(
            "React instrumentation encountered an error: %o",
            j
          ));
        }
      S = iA(S), y.context === null ? y.context = S : y.pendingContext = S, Ec && Go !== null && !Kj && (Kj = !0, console.error(
        `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
        H(Go) || "Unknown"
      )), y = Wi(l), y.payload = { element: h }, E = E === void 0 ? null : E, E !== null && (typeof E != "function" && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        E
      ), y.callback = E), h = ac(o, y, l), h !== null && (nc(l, "root.render()", null), Kt(h, o, l), Gs(h, o, l));
    }
    function aA(o, l) {
      if (o = o.memoizedState, o !== null && o.dehydrated !== null) {
        var h = o.retryLane;
        o.retryLane = h !== 0 && h < l ? h : l;
      }
    }
    function ux(o, l) {
      aA(o, l), (o = o.alternate) && aA(o, l);
    }
    function dx(o) {
      if (o.tag === 13 || o.tag === 31) {
        var l = Wa(o, 67108864);
        l !== null && Kt(l, o, 67108864), ux(o, 67108864);
      }
    }
    function fx(o) {
      if (o.tag === 13 || o.tag === 31) {
        var l = Za(o);
        l = ar(l);
        var h = Wa(o, l);
        h !== null && Kt(h, o, l), ux(o, l);
      }
    }
    function Ar() {
      return Go;
    }
    function hx(o, l, h, y) {
      var S = ze.T;
      ze.T = null;
      var E = ur.p;
      try {
        ur.p = Ji, px(o, l, h, y);
      } finally {
        ur.p = E, ze.T = S;
      }
    }
    function Da(o, l, h, y) {
      var S = ze.T;
      ze.T = null;
      var E = ur.p;
      try {
        ur.p = Ma, px(o, l, h, y);
      } finally {
        ur.p = E, ze.T = S;
      }
    }
    function px(o, l, h, y) {
      if (fC) {
        var S = dy(y);
        if (S === null)
          Nl(
            o,
            l,
            y,
            hC,
            h
          ), hy(o, y);
        else if (oA(
          S,
          o,
          l,
          h,
          y
        ))
          y.stopPropagation();
        else if (hy(o, y), l & 4 && -1 < une.indexOf(o)) {
          for (; S !== null; ) {
            var E = st(S);
            if (E !== null)
              switch (E.tag) {
                case 3:
                  if (E = E.stateNode, E.current.memoizedState.isDehydrated) {
                    var j = Te(E.pendingLanes);
                    if (j !== 0) {
                      var L = E;
                      for (L.pendingLanes |= 2, L.entangledLanes |= 2; j; ) {
                        var Q = 1 << 31 - Na(j);
                        L.entanglements[1] |= Q, j &= ~Q;
                      }
                      Uo(E), (Zn & (ka | Vl)) === no && (WA = va() + Cj, yc(0, !1));
                    }
                  }
                  break;
                case 31:
                case 13:
                  L = Wa(E, 2), L !== null && Kt(L, E, 2), gs(), ux(E, 2);
              }
            if (E = dy(y), E === null && Nl(
              o,
              l,
              y,
              hC,
              h
            ), E === S)
              break;
            S = E;
          }
          S !== null && y.stopPropagation();
        } else
          Nl(
            o,
            l,
            y,
            null,
            h
          );
      }
    }
    function dy(o) {
      return o = ml(o), mx(o);
    }
    function mx(o) {
      if (hC = null, o = nt(o), o !== null) {
        var l = O(o);
        if (l === null)
          o = null;
        else {
          var h = l.tag;
          if (h === 13) {
            if (o = R(l), o !== null)
              return o;
            o = null;
          } else if (h === 31) {
            if (o = N(l), o !== null)
              return o;
            o = null;
          } else if (h === 3) {
            if (l.stateNode.current.memoizedState.isDehydrated)
              return l.tag === 3 ? l.stateNode.containerInfo : null;
            o = null;
          } else
            l !== o && (o = null);
        }
      }
      return hC = o, null;
    }
    function fy(o) {
      switch (o) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Ji;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Ma;
        case "message":
          switch (f1()) {
            case Ax:
              return Ji;
            case Sy:
              return Ma;
            case eh:
            case fA:
              return Ja;
            case Ey:
              return kd;
            default:
              return Ja;
          }
        default:
          return Ja;
      }
    }
    function hy(o, l) {
      switch (o) {
        case "focusin":
        case "focusout":
          f0 = null;
          break;
        case "dragenter":
        case "dragleave":
          h0 = null;
          break;
        case "mouseover":
        case "mouseout":
          p0 = null;
          break;
        case "pointerover":
        case "pointerout":
          bS.delete(l.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          wS.delete(l.pointerId);
      }
    }
    function Dd(o, l, h, y, S, E) {
      return o === null || o.nativeEvent !== E ? (o = {
        blockedOn: l,
        domEventName: h,
        eventSystemFlags: y,
        nativeEvent: E,
        targetContainers: [S]
      }, l !== null && (l = st(l), l !== null && dx(l)), o) : (o.eventSystemFlags |= y, l = o.targetContainers, S !== null && l.indexOf(S) === -1 && l.push(S), o);
    }
    function oA(o, l, h, y, S) {
      switch (l) {
        case "focusin":
          return f0 = Dd(
            f0,
            o,
            l,
            h,
            y,
            S
          ), !0;
        case "dragenter":
          return h0 = Dd(
            h0,
            o,
            l,
            h,
            y,
            S
          ), !0;
        case "mouseover":
          return p0 = Dd(
            p0,
            o,
            l,
            h,
            y,
            S
          ), !0;
        case "pointerover":
          var E = S.pointerId;
          return bS.set(
            E,
            Dd(
              bS.get(E) || null,
              o,
              l,
              h,
              y,
              S
            )
          ), !0;
        case "gotpointercapture":
          return E = S.pointerId, wS.set(
            E,
            Dd(
              wS.get(E) || null,
              o,
              l,
              h,
              y,
              S
            )
          ), !0;
      }
      return !1;
    }
    function gx(o) {
      var l = nt(o.target);
      if (l !== null) {
        var h = O(l);
        if (h !== null) {
          if (l = h.tag, l === 13) {
            if (l = R(h), l !== null) {
              o.blockedOn = l, re(o.priority, function() {
                fx(h);
              });
              return;
            }
          } else if (l === 31) {
            if (l = N(h), l !== null) {
              o.blockedOn = l, re(o.priority, function() {
                fx(h);
              });
              return;
            }
          } else if (l === 3 && h.stateNode.current.memoizedState.isDehydrated) {
            o.blockedOn = h.tag === 3 ? h.stateNode.containerInfo : null;
            return;
          }
        }
      }
      o.blockedOn = null;
    }
    function kp(o) {
      if (o.blockedOn !== null)
        return !1;
      for (var l = o.targetContainers; 0 < l.length; ) {
        var h = dy(o.nativeEvent);
        if (h === null) {
          h = o.nativeEvent;
          var y = new h.constructor(
            h.type,
            h
          ), S = y;
          Dx !== null && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          ), Dx = S, h.target.dispatchEvent(y), Dx === null && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          ), Dx = null;
        } else
          return l = st(h), l !== null && dx(l), o.blockedOn = h, !1;
        l.shift();
      }
      return !0;
    }
    function py(o, l, h) {
      kp(o) && h.delete(l);
    }
    function UO() {
      r6 = !1, f0 !== null && kp(f0) && (f0 = null), h0 !== null && kp(h0) && (h0 = null), p0 !== null && kp(p0) && (p0 = null), bS.forEach(py), wS.forEach(py);
    }
    function s1(o, l) {
      o.blockedOn === l && (o.blockedOn = null, r6 || (r6 = !0, Pi.unstable_scheduleCallback(
        Pi.unstable_NormalPriority,
        UO
      )));
    }
    function sA(o) {
      pC !== o && (pC = o, Pi.unstable_scheduleCallback(
        Pi.unstable_NormalPriority,
        function() {
          pC === o && (pC = null);
          for (var l = 0; l < o.length; l += 3) {
            var h = o[l], y = o[l + 1], S = o[l + 2];
            if (typeof y != "function") {
              if (mx(y || h) === null)
                continue;
              break;
            }
            var E = st(h);
            E !== null && (o.splice(l, 3), l -= 3, h = {
              pending: !0,
              data: S,
              method: h.method,
              action: y
            }, Object.freeze(h), mu(
              E,
              h,
              y,
              S
            ));
          }
        }
      ));
    }
    function Zf(o) {
      function l(Q) {
        return s1(Q, o);
      }
      f0 !== null && s1(f0, o), h0 !== null && s1(h0, o), p0 !== null && s1(p0, o), bS.forEach(l), wS.forEach(l);
      for (var h = 0; h < m0.length; h++) {
        var y = m0[h];
        y.blockedOn === o && (y.blockedOn = null);
      }
      for (; 0 < m0.length && (h = m0[0], h.blockedOn === null); )
        gx(h), h.blockedOn === null && m0.shift();
      if (h = (o.ownerDocument || o).$$reactFormReplay, h != null)
        for (y = 0; y < h.length; y += 3) {
          var S = h[y], E = h[y + 1], j = S[Oo] || null;
          if (typeof E == "function")
            j || sA(h);
          else if (j) {
            var L = null;
            if (E && E.hasAttribute("formAction")) {
              if (S = E, j = E[Oo] || null)
                L = j.formAction;
              else if (mx(S) !== null)
                continue;
            } else
              L = j.action;
            typeof L == "function" ? h[y + 1] = L : (h.splice(y, 3), y -= 3), sA(h);
          }
        }
    }
    function lA() {
      function o(E) {
        E.canIntercept && E.info === "react-transition" && E.intercept({
          handler: function() {
            return new Promise(function(j) {
              return S = j;
            });
          },
          focusReset: "manual",
          scroll: "manual"
        });
      }
      function l() {
        S !== null && (S(), S = null), y || setTimeout(h, 20);
      }
      function h() {
        if (!y && !navigation.transition) {
          var E = navigation.currentEntry;
          E && E.url != null && navigation.navigate(E.url, {
            state: E.getState(),
            info: "react-transition",
            history: "replace"
          });
        }
      }
      if (typeof navigation == "object") {
        var y = !1, S = null;
        return navigation.addEventListener("navigate", o), navigation.addEventListener("navigatesuccess", l), navigation.addEventListener("navigateerror", l), setTimeout(h, 100), function() {
          y = !0, navigation.removeEventListener("navigate", o), navigation.removeEventListener(
            "navigatesuccess",
            l
          ), navigation.removeEventListener(
            "navigateerror",
            l
          ), S !== null && (S(), S = null);
        };
      }
    }
    function vx(o) {
      this._internalRoot = o;
    }
    function kl(o) {
      this._internalRoot = o;
    }
    function yx(o) {
      o[Au] && (o._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Pi = eG(), l1 = I, $O = MM(), yn = Object.assign, cA = Symbol.for("react.element"), Qs = Symbol.for("react.transitional.element"), Nd = Symbol.for("react.portal"), jp = Symbol.for("react.fragment"), To = Symbol.for("react.strict_mode"), c1 = Symbol.for("react.profiler"), my = Symbol.for("react.consumer"), jl = Symbol.for("react.context"), Pp = Symbol.for("react.forward_ref"), Kf = Symbol.for("react.suspense"), qo = Symbol.for("react.suspense_list"), u1 = Symbol.for("react.memo"), Ka = Symbol.for("react.lazy"), Pl = Symbol.for("react.activity"), HO = Symbol.for("react.memo_cache_sentinel"), uA = Symbol.iterator, Lp = Symbol.for("react.client.reference"), Yi = Array.isArray, ze = l1.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ur = $O.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, qO = Object.freeze({
      pending: !1,
      data: null,
      method: null,
      action: null
    }), bx = [], wx = [], _u = -1, Md = Z(null), Bp = Z(null), ys = Z(null), Id = Z(null), zp = 0, dA, Jf, Fp, xx, d1, gy, vy;
    J.__reactDisabledLog = !0;
    var Vp, Sx, yy = !1, Ex = new (typeof WeakMap == "function" ? WeakMap : Map)(), Go = null, Ec = !1, bs = Object.prototype.hasOwnProperty, _x = Pi.unstable_scheduleCallback, by = Pi.unstable_cancelCallback, wy = Pi.unstable_shouldYield, xy = Pi.unstable_requestPaint, va = Pi.unstable_now, f1 = Pi.unstable_getCurrentPriorityLevel, Ax = Pi.unstable_ImmediatePriority, Sy = Pi.unstable_UserBlockingPriority, eh = Pi.unstable_NormalPriority, fA = Pi.unstable_LowPriority, Ey = Pi.unstable_IdlePriority, Cx = Pi.log, hA = Pi.unstable_setDisableYieldValue, th = null, Ki = null, _c = !1, Ac = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u", Na = Math.clz32 ? Math.clz32 : ge, Tx = Math.log, _y = Math.LN2, Up = 256, h1 = 262144, $p = 4194304, Ji = 2, Ma = 8, Ja = 32, kd = 268435456, Zs = Math.random().toString(36).slice(2), ni = "__reactFiber$" + Zs, Oo = "__reactProps$" + Zs, Au = "__reactContainer$" + Zs, nh = "__reactEvents$" + Zs, GO = "__reactListeners$" + Zs, pA = "__reactHandles$" + Zs, p1 = "__reactResources$" + Zs, Hp = "__reactMarker$" + Zs, mA = /* @__PURE__ */ new Set(), Cc = {}, qp = {}, gA = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    }, Gp = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Ox = {}, Ay = {}, Cy = /[\n"\\]/g, Rx = !1, vA = !1, m1 = !1, u = !1, p = !1, v = !1, x = ["value", "defaultValue"], D = !1, k = /["'&<>\n\t]|^\s|\s$/, X = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), oe = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), me = oe.concat(["button"]), ke = "dd dt li option optgroup p rp rt".split(" "), qe = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: !1
    }, et = {}, Pe = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, Fe = /([A-Z])/g, Et = /^ms-/, Ut = /^(?:webkit|moz|o)[A-Z]/, Cr = /^-ms-/, Oe = /-(.)/g, xe = /;\s*$/, Ie = {}, We = {}, Lt = !1, Qn = !1, Dt = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), ln = "http://www.w3.org/1998/Math/MathML", mn = "http://www.w3.org/2000/svg", er = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), Ll = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, yA = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0,
      "aria-braillelabel": 0,
      "aria-brailleroledescription": 0,
      "aria-colindextext": 0,
      "aria-rowindextext": 0
    }, Ty = {}, qee = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Gee = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), e9 = !1, ws = {}, t9 = /^on./, Yee = /^on[^A-Z]/, Xee = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Wee = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Qee = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, Dx = null, Oy = null, Ry = null, YO = !1, jd = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), XO = !1;
    if (jd)
      try {
        var Nx = {};
        Object.defineProperty(Nx, "passive", {
          get: function() {
            XO = !0;
          }
        }), window.addEventListener("test", Nx, Nx), window.removeEventListener("test", Nx, Nx);
      } catch {
        XO = !1;
      }
    var Yp = null, WO = null, bA = null, g1 = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(o) {
        return o.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, wA = ua(g1), Mx = yn({}, g1, { view: 0, detail: 0 }), Zee = ua(Mx), QO, ZO, Ix, xA = yn({}, Mx, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: om,
      button: 0,
      buttons: 0,
      relatedTarget: function(o) {
        return o.relatedTarget === void 0 ? o.fromElement === o.srcElement ? o.toElement : o.fromElement : o.relatedTarget;
      },
      movementX: function(o) {
        return "movementX" in o ? o.movementX : (o !== Ix && (Ix && o.type === "mousemove" ? (QO = o.screenX - Ix.screenX, ZO = o.screenY - Ix.screenY) : ZO = QO = 0, Ix = o), QO);
      },
      movementY: function(o) {
        return "movementY" in o ? o.movementY : ZO;
      }
    }), n9 = ua(xA), Kee = yn({}, xA, { dataTransfer: 0 }), Jee = ua(Kee), ete = yn({}, Mx, { relatedTarget: 0 }), KO = ua(ete), tte = yn({}, g1, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), nte = ua(tte), rte = yn({}, g1, {
      clipboardData: function(o) {
        return "clipboardData" in o ? o.clipboardData : window.clipboardData;
      }
    }), ite = ua(rte), ate = yn({}, g1, { data: 0 }), r9 = ua(
      ate
    ), ote = r9, ste = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, lte = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, cte = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, ute = yn({}, Mx, {
      key: function(o) {
        if (o.key) {
          var l = ste[o.key] || o.key;
          if (l !== "Unidentified")
            return l;
        }
        return o.type === "keypress" ? (o = am(o), o === 13 ? "Enter" : String.fromCharCode(o)) : o.type === "keydown" || o.type === "keyup" ? lte[o.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: om,
      charCode: function(o) {
        return o.type === "keypress" ? am(o) : 0;
      },
      keyCode: function(o) {
        return o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
      },
      which: function(o) {
        return o.type === "keypress" ? am(o) : o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
      }
    }), dte = ua(ute), fte = yn({}, xA, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), i9 = ua(fte), hte = yn({}, Mx, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: om
    }), pte = ua(hte), mte = yn({}, g1, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), gte = ua(mte), vte = yn({}, xA, {
      deltaX: function(o) {
        return "deltaX" in o ? o.deltaX : "wheelDeltaX" in o ? -o.wheelDeltaX : 0;
      },
      deltaY: function(o) {
        return "deltaY" in o ? o.deltaY : "wheelDeltaY" in o ? -o.wheelDeltaY : "wheelDelta" in o ? -o.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), yte = ua(vte), bte = yn({}, g1, {
      newState: 0,
      oldState: 0
    }), wte = ua(bte), xte = [9, 13, 27, 32], a9 = 229, JO = jd && "CompositionEvent" in window, kx = null;
    jd && "documentMode" in document && (kx = document.documentMode);
    var Ste = jd && "TextEvent" in window && !kx, o9 = jd && (!JO || kx && 8 < kx && 11 >= kx), s9 = 32, l9 = String.fromCharCode(s9), c9 = !1, Dy = !1, Ete = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    }, jx = null, Px = null, u9 = !1;
    jd && (u9 = Zg("input") && (!document.documentMode || 9 < document.documentMode));
    var xs = typeof Object.is == "function" ? Object.is : Kg, _te = jd && "documentMode" in document && 11 >= document.documentMode, Ny = null, eR = null, Lx = null, tR = !1, My = {
      animationend: vf("Animation", "AnimationEnd"),
      animationiteration: vf("Animation", "AnimationIteration"),
      animationstart: vf("Animation", "AnimationStart"),
      transitionrun: vf("Transition", "TransitionRun"),
      transitionstart: vf("Transition", "TransitionStart"),
      transitioncancel: vf("Transition", "TransitionCancel"),
      transitionend: vf("Transition", "TransitionEnd")
    }, nR = {}, d9 = {};
    jd && (d9 = document.createElement("div").style, "AnimationEvent" in window || (delete My.animationend.animation, delete My.animationiteration.animation, delete My.animationstart.animation), "TransitionEvent" in window || delete My.transitionend.transition);
    var f9 = yf("animationend"), h9 = yf("animationiteration"), p9 = yf("animationstart"), Ate = yf("transitionrun"), Cte = yf("transitionstart"), Tte = yf("transitioncancel"), m9 = yf("transitionend"), g9 = /* @__PURE__ */ new Map(), rR = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    rR.push("scrollEnd");
    var v9 = 0;
    if (typeof performance == "object" && typeof performance.now == "function")
      var Ote = performance, y9 = function() {
        return Ote.now();
      };
    else {
      var Rte = Date;
      y9 = function() {
        return Rte.now();
      };
    }
    var iR = typeof reportError == "function" ? reportError : function(o) {
      if (typeof window == "object" && typeof window.ErrorEvent == "function") {
        var l = new window.ErrorEvent("error", {
          bubbles: !0,
          cancelable: !0,
          message: typeof o == "object" && o !== null && typeof o.message == "string" ? String(o.message) : String(o),
          error: o
        });
        if (!window.dispatchEvent(l))
          return;
      } else if (typeof process == "object" && typeof process.emit == "function") {
        process.emit("uncaughtException", o);
        return;
      }
      console.error(o);
    }, Dte = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", SA = 0, aR = 1, oR = 2, sR = 3, EA = "– ", _A = "+ ", b9 = "  ", ri = typeof console < "u" && typeof console.timeStamp == "function" && typeof performance < "u" && typeof performance.measure == "function", Tc = "Components ⚛", zn = "Scheduler ⚛", $n = "Blocking", Xp = !1, rh = {
      color: "primary",
      properties: null,
      tooltipText: "",
      track: Tc
    }, Wp = {
      start: -0,
      end: -0,
      detail: { devtools: rh }
    }, Nte = ["Changed Props", ""], w9 = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", Mte = ["Changed Props", w9], Bx = 1, ih = 2, Oc = [], Iy = 0, lR = 0, Qp = {};
    Object.freeze(Qp);
    var Rc = null, ky = null, Wt = 0, Ite = 1, bn = 2, Yo = 8, Cu = 16, kte = 32, x9 = !1;
    try {
      var S9 = Object.preventExtensions({});
    } catch {
      x9 = !0;
    }
    var cR = /* @__PURE__ */ new WeakMap(), jy = [], Py = 0, AA = null, zx = 0, Dc = [], Nc = 0, v1 = null, ah = 1, oh = "", Ro = null, ii = null, Fn = !1, Pd = !1, Bl = null, Zp = null, Mc = !1, uR = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), dR = Z(null), fR = Z(null), E9 = {}, CA = null, Ly = null, By = !1, jte = typeof AbortController < "u" ? AbortController : function() {
      var o = [], l = this.signal = {
        aborted: !1,
        addEventListener: function(h, y) {
          o.push(y);
        }
      };
      this.abort = function() {
        l.aborted = !0, o.forEach(function(h) {
          return h();
        });
      };
    }, Pte = Pi.unstable_scheduleCallback, Lte = Pi.unstable_NormalPriority, ya = {
      $$typeof: jl,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, ba = Pi.unstable_now, TA = console.createTask ? console.createTask : function() {
      return null;
    }, Fx = 1, OA = 2, eo = -0, Kp = -0, sh = -0, lh = null, Ss = -1.1, y1 = -0, Ri = -0, zt = -1.1, Gt = -1.1, fi = null, Li = !1, b1 = -0, Ld = -1.1, Vx = null, Jp = 0, hR = null, pR = null, w1 = -1.1, Ux = null, zy = -1.1, RA = -1.1, ch = -0, uh = -1.1, Ic = -1.1, mR = 0, $x = null, _9 = null, A9 = null, e0 = -1.1, x1 = null, t0 = -1.1, DA = -1.1, C9 = -0, T9 = -0, NA = 0, gR = null, O9 = 0, Hx = -1.1, MA = !1, IA = !1, qx = null, vR = 0, S1 = 0, Fy = null, R9 = ze.S;
    ze.S = function(o, l) {
      if (_j = va(), typeof l == "object" && l !== null && typeof l.then == "function") {
        if (0 > uh && 0 > Ic) {
          uh = ba();
          var h = Op(), y = xc();
          (h !== t0 || y !== x1) && (t0 = -1.1), e0 = h, x1 = y;
        }
        lu(o, l);
      }
      R9 !== null && R9(o, l);
    };
    var E1 = Z(null), Tu = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, Gx = [], Yx = [], Xx = [], Wx = [], Qx = [], Zx = [], _1 = /* @__PURE__ */ new Set();
    Tu.recordUnsafeLifecycleWarnings = function(o, l) {
      _1.has(o.type) || (typeof l.componentWillMount == "function" && l.componentWillMount.__suppressDeprecationWarning !== !0 && Gx.push(o), o.mode & Yo && typeof l.UNSAFE_componentWillMount == "function" && Yx.push(o), typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Xx.push(o), o.mode & Yo && typeof l.UNSAFE_componentWillReceiveProps == "function" && Wx.push(o), typeof l.componentWillUpdate == "function" && l.componentWillUpdate.__suppressDeprecationWarning !== !0 && Qx.push(o), o.mode & Yo && typeof l.UNSAFE_componentWillUpdate == "function" && Zx.push(o));
    }, Tu.flushPendingUnsafeLifecycleWarnings = function() {
      var o = /* @__PURE__ */ new Set();
      0 < Gx.length && (Gx.forEach(function(L) {
        o.add(
          H(L) || "Component"
        ), _1.add(L.type);
      }), Gx = []);
      var l = /* @__PURE__ */ new Set();
      0 < Yx.length && (Yx.forEach(function(L) {
        l.add(
          H(L) || "Component"
        ), _1.add(L.type);
      }), Yx = []);
      var h = /* @__PURE__ */ new Set();
      0 < Xx.length && (Xx.forEach(function(L) {
        h.add(
          H(L) || "Component"
        ), _1.add(L.type);
      }), Xx = []);
      var y = /* @__PURE__ */ new Set();
      0 < Wx.length && (Wx.forEach(
        function(L) {
          y.add(
            H(L) || "Component"
          ), _1.add(L.type);
        }
      ), Wx = []);
      var S = /* @__PURE__ */ new Set();
      0 < Qx.length && (Qx.forEach(function(L) {
        S.add(
          H(L) || "Component"
        ), _1.add(L.type);
      }), Qx = []);
      var E = /* @__PURE__ */ new Set();
      if (0 < Zx.length && (Zx.forEach(function(L) {
        E.add(
          H(L) || "Component"
        ), _1.add(L.type);
      }), Zx = []), 0 < l.size) {
        var j = m(
          l
        );
        console.error(
          `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
          j
        );
      }
      0 < y.size && (j = m(
        y
      ), console.error(
        `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`,
        j
      )), 0 < E.size && (j = m(
        E
      ), console.error(
        `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
        j
      )), 0 < o.size && (j = m(o), console.warn(
        `componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        j
      )), 0 < h.size && (j = m(
        h
      ), console.warn(
        `componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        j
      )), 0 < S.size && (j = m(S), console.warn(
        `componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        j
      ));
    };
    var kA = /* @__PURE__ */ new Map(), D9 = /* @__PURE__ */ new Set();
    Tu.recordLegacyContextWarning = function(o, l) {
      for (var h = null, y = o; y !== null; )
        y.mode & Yo && (h = y), y = y.return;
      h === null ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !D9.has(o.type) && (y = kA.get(h), o.type.contextTypes != null || o.type.childContextTypes != null || l !== null && typeof l.getChildContext == "function") && (y === void 0 && (y = [], kA.set(h, y)), y.push(o));
    }, Tu.flushLegacyContextWarning = function() {
      kA.forEach(function(o) {
        if (o.length !== 0) {
          var l = o[0], h = /* @__PURE__ */ new Set();
          o.forEach(function(S) {
            h.add(H(S) || "Component"), D9.add(S.type);
          });
          var y = m(h);
          Ce(l, function() {
            console.error(
              `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`,
              y
            );
          });
        }
      });
    }, Tu.discardPendingWarnings = function() {
      Gx = [], Yx = [], Xx = [], Wx = [], Qx = [], Zx = [], kA = /* @__PURE__ */ new Map();
    };
    var N9 = {
      react_stack_bottom_frame: function(o, l, h) {
        var y = Ec;
        Ec = !0;
        try {
          return o(l, h);
        } finally {
          Ec = y;
        }
      }
    }, yR = N9.react_stack_bottom_frame.bind(N9), M9 = {
      react_stack_bottom_frame: function(o) {
        var l = Ec;
        Ec = !0;
        try {
          return o.render();
        } finally {
          Ec = l;
        }
      }
    }, I9 = M9.react_stack_bottom_frame.bind(M9), k9 = {
      react_stack_bottom_frame: function(o, l) {
        try {
          l.componentDidMount();
        } catch (h) {
          pn(o, o.return, h);
        }
      }
    }, bR = k9.react_stack_bottom_frame.bind(
      k9
    ), j9 = {
      react_stack_bottom_frame: function(o, l, h, y, S) {
        try {
          l.componentDidUpdate(h, y, S);
        } catch (E) {
          pn(o, o.return, E);
        }
      }
    }, P9 = j9.react_stack_bottom_frame.bind(
      j9
    ), L9 = {
      react_stack_bottom_frame: function(o, l) {
        var h = l.stack;
        o.componentDidCatch(l.value, {
          componentStack: h !== null ? h : ""
        });
      }
    }, Bte = L9.react_stack_bottom_frame.bind(
      L9
    ), B9 = {
      react_stack_bottom_frame: function(o, l, h) {
        try {
          h.componentWillUnmount();
        } catch (y) {
          pn(o, l, y);
        }
      }
    }, z9 = B9.react_stack_bottom_frame.bind(
      B9
    ), F9 = {
      react_stack_bottom_frame: function(o) {
        var l = o.create;
        return o = o.inst, l = l(), o.destroy = l;
      }
    }, zte = F9.react_stack_bottom_frame.bind(F9), V9 = {
      react_stack_bottom_frame: function(o, l, h) {
        try {
          h();
        } catch (y) {
          pn(o, l, y);
        }
      }
    }, Fte = V9.react_stack_bottom_frame.bind(V9), U9 = {
      react_stack_bottom_frame: function(o) {
        var l = o._init;
        return l(o._payload);
      }
    }, Vte = U9.react_stack_bottom_frame.bind(U9), Vy = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), wR = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), jA = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), PA = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, A1 = null, Kx = !1, Uy = null, Jx = 0, wn = null, xR, $9 = xR = !1, H9 = {}, q9 = {}, G9 = {};
    g = function(o, l, h) {
      if (h !== null && typeof h == "object" && h._store && (!h._store.validated && h.key == null || h._store.validated === 2)) {
        if (typeof h._store != "object")
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        h._store.validated = 1;
        var y = H(o), S = y || "null";
        if (!H9[S]) {
          H9[S] = !0, h = h._owner, o = o._debugOwner;
          var E = "";
          o && typeof o.tag == "number" && (S = H(o)) && (E = `

Check the render method of \`` + S + "`."), E || y && (E = `

Check the top-level render call using <` + y + ">.");
          var j = "";
          h != null && o !== h && (y = null, typeof h.tag == "number" ? y = H(h) : typeof h.name == "string" && (y = h.name), y && (j = " It was passed a child from " + y + ".")), Ce(l, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              E,
              j
            );
          });
        }
      }
    };
    var C1 = fa(!0), Y9 = fa(!1), X9 = 0, W9 = 1, Q9 = 2, SR = 3, n0 = !1, Z9 = !1, ER = null, _R = !1, $y = Z(null), LA = Z(0), zl = Z(null), kc = null, Hy = 1, eS = 2, ea = Z(0), BA = 0, jc = 1, Es = 2, Fl = 4, _s = 8, qy, K9 = /* @__PURE__ */ new Set(), J9 = /* @__PURE__ */ new Set(), AR = /* @__PURE__ */ new Set(), ej = /* @__PURE__ */ new Set(), dh = 0, rn = null, $r = null, wa = null, zA = !1, Gy = !1, T1 = !1, FA = 0, tS = 0, fh = null, Ute = 0, $te = 25, Be = null, Pc = null, hh = -1, nS = !1, rS = {
      readContext: lr,
      use: fu,
      useCallback: Ti,
      useContext: Ti,
      useEffect: Ti,
      useImperativeHandle: Ti,
      useLayoutEffect: Ti,
      useInsertionEffect: Ti,
      useMemo: Ti,
      useReducer: Ti,
      useRef: Ti,
      useState: Ti,
      useDebugValue: Ti,
      useDeferredValue: Ti,
      useTransition: Ti,
      useSyncExternalStore: Ti,
      useId: Ti,
      useHostTransitionStatus: Ti,
      useFormState: Ti,
      useActionState: Ti,
      useOptimistic: Ti,
      useMemoCache: Ti,
      useCacheRefresh: Ti
    };
    rS.useEffectEvent = Ti;
    var CR = null, tj = null, TR = null, nj = null, Bd = null, Ou = null, VA = null;
    CR = {
      readContext: function(o) {
        return lr(o);
      },
      use: fu,
      useCallback: function(o, l) {
        return Be = "useCallback", nn(), du(l), bv(o, l);
      },
      useContext: function(o) {
        return Be = "useContext", nn(), lr(o);
      },
      useEffect: function(o, l) {
        return Be = "useEffect", nn(), du(l), jf(o, l);
      },
      useImperativeHandle: function(o, l, h) {
        return Be = "useImperativeHandle", nn(), du(h), cc(o, l, h);
      },
      useInsertionEffect: function(o, l) {
        Be = "useInsertionEffect", nn(), du(l), bd(4, Es, o, l);
      },
      useLayoutEffect: function(o, l) {
        return Be = "useLayoutEffect", nn(), du(l), bo(o, l);
      },
      useMemo: function(o, l) {
        Be = "useMemo", nn(), du(l);
        var h = ze.H;
        ze.H = Bd;
        try {
          return wo(o, l);
        } finally {
          ze.H = h;
        }
      },
      useReducer: function(o, l, h) {
        Be = "useReducer", nn();
        var y = ze.H;
        ze.H = Bd;
        try {
          return ip(o, l, h);
        } finally {
          ze.H = y;
        }
      },
      useRef: function(o) {
        return Be = "useRef", nn(), yv(o);
      },
      useState: function(o) {
        Be = "useState", nn();
        var l = ze.H;
        ze.H = Bd;
        try {
          return md(o);
        } finally {
          ze.H = l;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", nn();
      },
      useDeferredValue: function(o, l) {
        return Be = "useDeferredValue", nn(), cp(o, l);
      },
      useTransition: function() {
        return Be = "useTransition", nn(), wd();
      },
      useSyncExternalStore: function(o, l, h) {
        return Be = "useSyncExternalStore", nn(), ap(
          o,
          l,
          h
        );
      },
      useId: function() {
        return Be = "useId", nn(), Dm();
      },
      useFormState: function(o, l) {
        return Be = "useFormState", nn(), bm(), ds(o, l);
      },
      useActionState: function(o, l) {
        return Be = "useActionState", nn(), ds(o, l);
      },
      useOptimistic: function(o) {
        return Be = "useOptimistic", nn(), kf(o);
      },
      useHostTransitionStatus: gu,
      useMemoCache: cs,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", nn(), wv();
      },
      useEffectEvent: function(o) {
        return Be = "useEffectEvent", nn(), Om(o);
      }
    }, tj = {
      readContext: function(o) {
        return lr(o);
      },
      use: fu,
      useCallback: function(o, l) {
        return Be = "useCallback", tt(), bv(o, l);
      },
      useContext: function(o) {
        return Be = "useContext", tt(), lr(o);
      },
      useEffect: function(o, l) {
        return Be = "useEffect", tt(), jf(o, l);
      },
      useImperativeHandle: function(o, l, h) {
        return Be = "useImperativeHandle", tt(), cc(o, l, h);
      },
      useInsertionEffect: function(o, l) {
        Be = "useInsertionEffect", tt(), bd(4, Es, o, l);
      },
      useLayoutEffect: function(o, l) {
        return Be = "useLayoutEffect", tt(), bo(o, l);
      },
      useMemo: function(o, l) {
        Be = "useMemo", tt();
        var h = ze.H;
        ze.H = Bd;
        try {
          return wo(o, l);
        } finally {
          ze.H = h;
        }
      },
      useReducer: function(o, l, h) {
        Be = "useReducer", tt();
        var y = ze.H;
        ze.H = Bd;
        try {
          return ip(o, l, h);
        } finally {
          ze.H = y;
        }
      },
      useRef: function(o) {
        return Be = "useRef", tt(), yv(o);
      },
      useState: function(o) {
        Be = "useState", tt();
        var l = ze.H;
        ze.H = Bd;
        try {
          return md(o);
        } finally {
          ze.H = l;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", tt();
      },
      useDeferredValue: function(o, l) {
        return Be = "useDeferredValue", tt(), cp(o, l);
      },
      useTransition: function() {
        return Be = "useTransition", tt(), wd();
      },
      useSyncExternalStore: function(o, l, h) {
        return Be = "useSyncExternalStore", tt(), ap(
          o,
          l,
          h
        );
      },
      useId: function() {
        return Be = "useId", tt(), Dm();
      },
      useActionState: function(o, l) {
        return Be = "useActionState", tt(), ds(o, l);
      },
      useFormState: function(o, l) {
        return Be = "useFormState", tt(), bm(), ds(o, l);
      },
      useOptimistic: function(o) {
        return Be = "useOptimistic", tt(), kf(o);
      },
      useHostTransitionStatus: gu,
      useMemoCache: cs,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", tt(), wv();
      },
      useEffectEvent: function(o) {
        return Be = "useEffectEvent", tt(), Om(o);
      }
    }, TR = {
      readContext: function(o) {
        return lr(o);
      },
      use: fu,
      useCallback: function(o, l) {
        return Be = "useCallback", tt(), Cl(o, l);
      },
      useContext: function(o) {
        return Be = "useContext", tt(), lr(o);
      },
      useEffect: function(o, l) {
        Be = "useEffect", tt(), Qi(2048, _s, o, l);
      },
      useImperativeHandle: function(o, l, h) {
        return Be = "useImperativeHandle", tt(), lp(o, l, h);
      },
      useInsertionEffect: function(o, l) {
        return Be = "useInsertionEffect", tt(), Qi(4, Es, o, l);
      },
      useLayoutEffect: function(o, l) {
        return Be = "useLayoutEffect", tt(), Qi(4, Fl, o, l);
      },
      useMemo: function(o, l) {
        Be = "useMemo", tt();
        var h = ze.H;
        ze.H = Ou;
        try {
          return ei(o, l);
        } finally {
          ze.H = h;
        }
      },
      useReducer: function(o, l, h) {
        Be = "useReducer", tt();
        var y = ze.H;
        ze.H = Ou;
        try {
          return Nf(o, l, h);
        } finally {
          ze.H = y;
        }
      },
      useRef: function() {
        return Be = "useRef", tt(), fr().memoizedState;
      },
      useState: function() {
        Be = "useState", tt();
        var o = ze.H;
        ze.H = Ou;
        try {
          return Nf(us);
        } finally {
          ze.H = o;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", tt();
      },
      useDeferredValue: function(o, l) {
        return Be = "useDeferredValue", tt(), uc(o, l);
      },
      useTransition: function() {
        return Be = "useTransition", tt(), g3();
      },
      useSyncExternalStore: function(o, l, h) {
        return Be = "useSyncExternalStore", tt(), If(
          o,
          l,
          h
        );
      },
      useId: function() {
        return Be = "useId", tt(), fr().memoizedState;
      },
      useFormState: function(o) {
        return Be = "useFormState", tt(), bm(), vd(o);
      },
      useActionState: function(o) {
        return Be = "useActionState", tt(), vd(o);
      },
      useOptimistic: function(o, l) {
        return Be = "useOptimistic", tt(), Am(o, l);
      },
      useHostTransitionStatus: gu,
      useMemoCache: cs,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", tt(), fr().memoizedState;
      },
      useEffectEvent: function(o) {
        return Be = "useEffectEvent", tt(), sp(o);
      }
    }, nj = {
      readContext: function(o) {
        return lr(o);
      },
      use: fu,
      useCallback: function(o, l) {
        return Be = "useCallback", tt(), Cl(o, l);
      },
      useContext: function(o) {
        return Be = "useContext", tt(), lr(o);
      },
      useEffect: function(o, l) {
        Be = "useEffect", tt(), Qi(2048, _s, o, l);
      },
      useImperativeHandle: function(o, l, h) {
        return Be = "useImperativeHandle", tt(), lp(o, l, h);
      },
      useInsertionEffect: function(o, l) {
        return Be = "useInsertionEffect", tt(), Qi(4, Es, o, l);
      },
      useLayoutEffect: function(o, l) {
        return Be = "useLayoutEffect", tt(), Qi(4, Fl, o, l);
      },
      useMemo: function(o, l) {
        Be = "useMemo", tt();
        var h = ze.H;
        ze.H = VA;
        try {
          return ei(o, l);
        } finally {
          ze.H = h;
        }
      },
      useReducer: function(o, l, h) {
        Be = "useReducer", tt();
        var y = ze.H;
        ze.H = VA;
        try {
          return Mf(o, l, h);
        } finally {
          ze.H = y;
        }
      },
      useRef: function() {
        return Be = "useRef", tt(), fr().memoizedState;
      },
      useState: function() {
        Be = "useState", tt();
        var o = ze.H;
        ze.H = VA;
        try {
          return Mf(us);
        } finally {
          ze.H = o;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", tt();
      },
      useDeferredValue: function(o, l) {
        return Be = "useDeferredValue", tt(), cn(o, l);
      },
      useTransition: function() {
        return Be = "useTransition", tt(), ci();
      },
      useSyncExternalStore: function(o, l, h) {
        return Be = "useSyncExternalStore", tt(), If(
          o,
          l,
          h
        );
      },
      useId: function() {
        return Be = "useId", tt(), fr().memoizedState;
      },
      useFormState: function(o) {
        return Be = "useFormState", tt(), bm(), yd(o);
      },
      useActionState: function(o) {
        return Be = "useActionState", tt(), yd(o);
      },
      useOptimistic: function(o, l) {
        return Be = "useOptimistic", tt(), Cm(o, l);
      },
      useHostTransitionStatus: gu,
      useMemoCache: cs,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", tt(), fr().memoizedState;
      },
      useEffectEvent: function(o) {
        return Be = "useEffectEvent", tt(), sp(o);
      }
    }, Bd = {
      readContext: function(o) {
        return d(), lr(o);
      },
      use: function(o) {
        return c(), fu(o);
      },
      useCallback: function(o, l) {
        return Be = "useCallback", c(), nn(), bv(o, l);
      },
      useContext: function(o) {
        return Be = "useContext", c(), nn(), lr(o);
      },
      useEffect: function(o, l) {
        return Be = "useEffect", c(), nn(), jf(o, l);
      },
      useImperativeHandle: function(o, l, h) {
        return Be = "useImperativeHandle", c(), nn(), cc(o, l, h);
      },
      useInsertionEffect: function(o, l) {
        Be = "useInsertionEffect", c(), nn(), bd(4, Es, o, l);
      },
      useLayoutEffect: function(o, l) {
        return Be = "useLayoutEffect", c(), nn(), bo(o, l);
      },
      useMemo: function(o, l) {
        Be = "useMemo", c(), nn();
        var h = ze.H;
        ze.H = Bd;
        try {
          return wo(o, l);
        } finally {
          ze.H = h;
        }
      },
      useReducer: function(o, l, h) {
        Be = "useReducer", c(), nn();
        var y = ze.H;
        ze.H = Bd;
        try {
          return ip(o, l, h);
        } finally {
          ze.H = y;
        }
      },
      useRef: function(o) {
        return Be = "useRef", c(), nn(), yv(o);
      },
      useState: function(o) {
        Be = "useState", c(), nn();
        var l = ze.H;
        ze.H = Bd;
        try {
          return md(o);
        } finally {
          ze.H = l;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", c(), nn();
      },
      useDeferredValue: function(o, l) {
        return Be = "useDeferredValue", c(), nn(), cp(o, l);
      },
      useTransition: function() {
        return Be = "useTransition", c(), nn(), wd();
      },
      useSyncExternalStore: function(o, l, h) {
        return Be = "useSyncExternalStore", c(), nn(), ap(
          o,
          l,
          h
        );
      },
      useId: function() {
        return Be = "useId", c(), nn(), Dm();
      },
      useFormState: function(o, l) {
        return Be = "useFormState", c(), nn(), ds(o, l);
      },
      useActionState: function(o, l) {
        return Be = "useActionState", c(), nn(), ds(o, l);
      },
      useOptimistic: function(o) {
        return Be = "useOptimistic", c(), nn(), kf(o);
      },
      useMemoCache: function(o) {
        return c(), cs(o);
      },
      useHostTransitionStatus: gu,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", nn(), wv();
      },
      useEffectEvent: function(o) {
        return Be = "useEffectEvent", c(), nn(), Om(o);
      }
    }, Ou = {
      readContext: function(o) {
        return d(), lr(o);
      },
      use: function(o) {
        return c(), fu(o);
      },
      useCallback: function(o, l) {
        return Be = "useCallback", c(), tt(), Cl(o, l);
      },
      useContext: function(o) {
        return Be = "useContext", c(), tt(), lr(o);
      },
      useEffect: function(o, l) {
        Be = "useEffect", c(), tt(), Qi(2048, _s, o, l);
      },
      useImperativeHandle: function(o, l, h) {
        return Be = "useImperativeHandle", c(), tt(), lp(o, l, h);
      },
      useInsertionEffect: function(o, l) {
        return Be = "useInsertionEffect", c(), tt(), Qi(4, Es, o, l);
      },
      useLayoutEffect: function(o, l) {
        return Be = "useLayoutEffect", c(), tt(), Qi(4, Fl, o, l);
      },
      useMemo: function(o, l) {
        Be = "useMemo", c(), tt();
        var h = ze.H;
        ze.H = Ou;
        try {
          return ei(o, l);
        } finally {
          ze.H = h;
        }
      },
      useReducer: function(o, l, h) {
        Be = "useReducer", c(), tt();
        var y = ze.H;
        ze.H = Ou;
        try {
          return Nf(o, l, h);
        } finally {
          ze.H = y;
        }
      },
      useRef: function() {
        return Be = "useRef", c(), tt(), fr().memoizedState;
      },
      useState: function() {
        Be = "useState", c(), tt();
        var o = ze.H;
        ze.H = Ou;
        try {
          return Nf(us);
        } finally {
          ze.H = o;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", c(), tt();
      },
      useDeferredValue: function(o, l) {
        return Be = "useDeferredValue", c(), tt(), uc(o, l);
      },
      useTransition: function() {
        return Be = "useTransition", c(), tt(), g3();
      },
      useSyncExternalStore: function(o, l, h) {
        return Be = "useSyncExternalStore", c(), tt(), If(
          o,
          l,
          h
        );
      },
      useId: function() {
        return Be = "useId", c(), tt(), fr().memoizedState;
      },
      useFormState: function(o) {
        return Be = "useFormState", c(), tt(), vd(o);
      },
      useActionState: function(o) {
        return Be = "useActionState", c(), tt(), vd(o);
      },
      useOptimistic: function(o, l) {
        return Be = "useOptimistic", c(), tt(), Am(o, l);
      },
      useMemoCache: function(o) {
        return c(), cs(o);
      },
      useHostTransitionStatus: gu,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", tt(), fr().memoizedState;
      },
      useEffectEvent: function(o) {
        return Be = "useEffectEvent", c(), tt(), sp(o);
      }
    }, VA = {
      readContext: function(o) {
        return d(), lr(o);
      },
      use: function(o) {
        return c(), fu(o);
      },
      useCallback: function(o, l) {
        return Be = "useCallback", c(), tt(), Cl(o, l);
      },
      useContext: function(o) {
        return Be = "useContext", c(), tt(), lr(o);
      },
      useEffect: function(o, l) {
        Be = "useEffect", c(), tt(), Qi(2048, _s, o, l);
      },
      useImperativeHandle: function(o, l, h) {
        return Be = "useImperativeHandle", c(), tt(), lp(o, l, h);
      },
      useInsertionEffect: function(o, l) {
        return Be = "useInsertionEffect", c(), tt(), Qi(4, Es, o, l);
      },
      useLayoutEffect: function(o, l) {
        return Be = "useLayoutEffect", c(), tt(), Qi(4, Fl, o, l);
      },
      useMemo: function(o, l) {
        Be = "useMemo", c(), tt();
        var h = ze.H;
        ze.H = Ou;
        try {
          return ei(o, l);
        } finally {
          ze.H = h;
        }
      },
      useReducer: function(o, l, h) {
        Be = "useReducer", c(), tt();
        var y = ze.H;
        ze.H = Ou;
        try {
          return Mf(o, l, h);
        } finally {
          ze.H = y;
        }
      },
      useRef: function() {
        return Be = "useRef", c(), tt(), fr().memoizedState;
      },
      useState: function() {
        Be = "useState", c(), tt();
        var o = ze.H;
        ze.H = Ou;
        try {
          return Mf(us);
        } finally {
          ze.H = o;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", c(), tt();
      },
      useDeferredValue: function(o, l) {
        return Be = "useDeferredValue", c(), tt(), cn(o, l);
      },
      useTransition: function() {
        return Be = "useTransition", c(), tt(), ci();
      },
      useSyncExternalStore: function(o, l, h) {
        return Be = "useSyncExternalStore", c(), tt(), If(
          o,
          l,
          h
        );
      },
      useId: function() {
        return Be = "useId", c(), tt(), fr().memoizedState;
      },
      useFormState: function(o) {
        return Be = "useFormState", c(), tt(), yd(o);
      },
      useActionState: function(o) {
        return Be = "useActionState", c(), tt(), yd(o);
      },
      useOptimistic: function(o, l) {
        return Be = "useOptimistic", c(), tt(), Cm(o, l);
      },
      useMemoCache: function(o) {
        return c(), cs(o);
      },
      useHostTransitionStatus: gu,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", tt(), fr().memoizedState;
      },
      useEffectEvent: function(o) {
        return Be = "useEffectEvent", c(), tt(), sp(o);
      }
    };
    var rj = {}, ij = /* @__PURE__ */ new Set(), aj = /* @__PURE__ */ new Set(), oj = /* @__PURE__ */ new Set(), sj = /* @__PURE__ */ new Set(), lj = /* @__PURE__ */ new Set(), cj = /* @__PURE__ */ new Set(), uj = /* @__PURE__ */ new Set(), dj = /* @__PURE__ */ new Set(), fj = /* @__PURE__ */ new Set(), hj = /* @__PURE__ */ new Set();
    Object.freeze(rj);
    var OR = {
      enqueueSetState: function(o, l, h) {
        o = o._reactInternals;
        var y = Za(o), S = Wi(y);
        S.payload = l, h != null && (zf(h), S.callback = h), l = ac(o, S, y), l !== null && (nc(y, "this.setState()", o), Kt(l, o, y), Gs(l, o, y));
      },
      enqueueReplaceState: function(o, l, h) {
        o = o._reactInternals;
        var y = Za(o), S = Wi(y);
        S.tag = W9, S.payload = l, h != null && (zf(h), S.callback = h), l = ac(o, S, y), l !== null && (nc(y, "this.replaceState()", o), Kt(l, o, y), Gs(l, o, y));
      },
      enqueueForceUpdate: function(o, l) {
        o = o._reactInternals;
        var h = Za(o), y = Wi(h);
        y.tag = Q9, l != null && (zf(l), y.callback = l), l = ac(o, y, h), l !== null && (nc(h, "this.forceUpdate()", o), Kt(l, o, h), Gs(l, o, h));
      }
    }, Yy = null, RR = null, DR = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), xa = !1, pj = {}, mj = {}, gj = {}, vj = {}, Xy = !1, yj = {}, UA = {}, NR = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, bj = !1, wj = null;
    wj = /* @__PURE__ */ new Set();
    var ph = !1, Sa = !1, MR = !1, xj = typeof WeakSet == "function" ? WeakSet : Set, to = null, Wy = null, Qy = null, Ea = null, Ks = !1, Ru = null, Ia = !1, iS = 8192, Hte = {
      getCacheForType: function(o) {
        var l = lr(ya), h = l.data.get(o);
        return h === void 0 && (h = o(), l.data.set(o, h)), h;
      },
      cacheSignal: function() {
        return lr(ya).controller.signal;
      },
      getOwner: function() {
        return Go;
      }
    };
    if (typeof Symbol == "function" && Symbol.for) {
      var aS = Symbol.for;
      aS("selector.component"), aS("selector.has_pseudo_class"), aS("selector.role"), aS("selector.test_id"), aS("selector.text");
    }
    var qte = [], Gte = typeof WeakMap == "function" ? WeakMap : Map, no = 0, ka = 2, Vl = 4, mh = 0, oS = 1, O1 = 2, $A = 3, r0 = 4, HA = 6, Sj = 5, Zn = no, Hr = null, _n = null, xn = 0, Js = 0, qA = 1, R1 = 2, sS = 3, Ej = 4, IR = 5, lS = 6, GA = 7, kR = 8, D1 = 9, Tr = Js, Ul = null, i0 = !1, Zy = !1, jR = !1, zd = 0, Di = mh, a0 = 0, o0 = 0, PR = 0, el = 0, N1 = 0, cS = null, As = null, YA = !1, XA = 0, _j = 0, Aj = 300, WA = 1 / 0, Cj = 500, uS = null, Xi = null, s0 = null, QA = 0, LR = 1, BR = 2, Tj = 3, l0 = 0, Oj = 1, Rj = 2, Dj = 3, Nj = 4, ZA = 5, _a = 0, c0 = null, Ky = null, Du = 0, zR = 0, FR = -0, VR = null, Mj = null, Ij = null, Nu = QA, kj = null, Yte = 50, dS = 0, UR = null, $R = !1, KA = !1, Xte = 50, M1 = 0, fS = null, Jy = !1, JA = null, jj = !1, Pj = /* @__PURE__ */ new Set(), Wte = {}, eC = null, eb = null, HR = !1, qR = !1, tC = !1, GR = !1, u0 = 0, YR = {};
    (function() {
      for (var o = 0; o < rR.length; o++) {
        var l = rR[o], h = l.toLowerCase();
        l = l[0].toUpperCase() + l.slice(1), gl(h, "on" + l);
      }
      gl(f9, "onAnimationEnd"), gl(h9, "onAnimationIteration"), gl(p9, "onAnimationStart"), gl("dblclick", "onDoubleClick"), gl("focusin", "onFocus"), gl("focusout", "onBlur"), gl(Ate, "onTransitionRun"), gl(Cte, "onTransitionStart"), gl(Tte, "onTransitionCancel"), gl(m9, "onTransitionEnd");
    })(), ft("onMouseEnter", ["mouseout", "mouseover"]), ft("onMouseLeave", ["mouseout", "mouseover"]), ft("onPointerEnter", ["pointerout", "pointerover"]), ft("onPointerLeave", ["pointerout", "pointerover"]), ut(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    ), ut(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    ), ut("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]), ut(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    ), ut(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    ), ut(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var hS = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), XR = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(hS)
    ), nC = "_reactListening" + Math.random().toString(36).slice(2), Lj = !1, Bj = !1, rC = !1, zj = !1, iC = !1, aC = !1, Fj = !1, oC = {}, Qte = /\r\n?/g, Zte = /\u0000|\uFFFD/g, I1 = "http://www.w3.org/1999/xlink", WR = "http://www.w3.org/XML/1998/namespace", Kte = "javascript:throw new Error('React form unexpectedly submitted.')", Jte = "suppressHydrationWarning", k1 = "&", sC = "/&", pS = "$", mS = "/$", d0 = "$?", j1 = "$~", tb = "$!", ene = "html", tne = "body", nne = "head", QR = "F!", Vj = "F", Uj = "loading", rne = "style", gh = 0, nb = 1, lC = 2, ZR = null, KR = null, $j = { dialog: !0, webview: !0 }, JR = null, gS = void 0, Hj = typeof setTimeout == "function" ? setTimeout : void 0, ine = typeof clearTimeout == "function" ? clearTimeout : void 0, P1 = -1, qj = typeof Promise == "function" ? Promise : void 0, ane = typeof queueMicrotask == "function" ? queueMicrotask : typeof qj < "u" ? function(o) {
      return qj.resolve(null).then(o).catch(B3);
    } : Hj, e6 = null, L1 = 0, vS = 1, Gj = 2, Yj = 3, Lc = 4, Bc = /* @__PURE__ */ new Map(), Xj = /* @__PURE__ */ new Set(), vh = ur.d;
    ur.d = {
      f: function() {
        var o = vh.f(), l = gs();
        return o || l;
      },
      r: function(o) {
        var l = st(o);
        l !== null && l.tag === 5 && l.type === "form" ? up(l) : vh.r(o);
      },
      D: function(o) {
        vh.D(o), ix("dns-prefetch", o, null);
      },
      C: function(o, l) {
        vh.C(o, l), ix("preconnect", o, l);
      },
      L: function(o, l, h) {
        vh.L(o, l, h);
        var y = rb;
        if (y && o && l) {
          var S = 'link[rel="preload"][as="' + Rn(l) + '"]';
          l === "image" && h && h.imageSrcSet ? (S += '[imagesrcset="' + Rn(
            h.imageSrcSet
          ) + '"]', typeof h.imageSizes == "string" && (S += '[imagesizes="' + Rn(
            h.imageSizes
          ) + '"]')) : S += '[href="' + Rn(o) + '"]';
          var E = S;
          switch (l) {
            case "style":
              E = Wf(o);
              break;
            case "script":
              E = Qf(o);
          }
          Bc.has(E) || (o = yn(
            {
              rel: "preload",
              href: l === "image" && h && h.imageSrcSet ? void 0 : o,
              as: l
            },
            h
          ), Bc.set(E, o), y.querySelector(S) !== null || l === "style" && y.querySelector(
            n1(E)
          ) || l === "script" && y.querySelector(r1(E)) || (l = y.createElement("link"), ti(l, "link", o), Ke(l), y.head.appendChild(l)));
        }
      },
      m: function(o, l) {
        vh.m(o, l);
        var h = rb;
        if (h && o) {
          var y = l && typeof l.as == "string" ? l.as : "script", S = 'link[rel="modulepreload"][as="' + Rn(y) + '"][href="' + Rn(o) + '"]', E = S;
          switch (y) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              E = Qf(o);
          }
          if (!Bc.has(E) && (o = yn({ rel: "modulepreload", href: o }, l), Bc.set(E, o), h.querySelector(S) === null)) {
            switch (y) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (h.querySelector(r1(E)))
                  return;
            }
            y = h.createElement("link"), ti(y, "link", o), Ke(y), h.head.appendChild(y);
          }
        }
      },
      X: function(o, l) {
        vh.X(o, l);
        var h = rb;
        if (h && o) {
          var y = bt(h).hoistableScripts, S = Qf(o), E = y.get(S);
          E || (E = h.querySelector(
            r1(S)
          ), E || (o = yn({ src: o, async: !0 }, l), (l = Bc.get(S)) && sx(o, l), E = h.createElement("script"), Ke(E), ti(E, "link", o), h.head.appendChild(E)), E = {
            type: "script",
            instance: E,
            count: 1,
            state: null
          }, y.set(S, E));
        }
      },
      S: function(o, l, h) {
        vh.S(o, l, h);
        var y = rb;
        if (y && o) {
          var S = bt(y).hoistableStyles, E = Wf(o);
          l = l || "default";
          var j = S.get(E);
          if (!j) {
            var L = { loading: L1, preload: null };
            if (j = y.querySelector(
              n1(E)
            ))
              L.loading = vS | Lc;
            else {
              o = yn(
                {
                  rel: "stylesheet",
                  href: o,
                  "data-precedence": l
                },
                h
              ), (h = Bc.get(E)) && ox(o, h);
              var Q = j = y.createElement("link");
              Ke(Q), ti(Q, "link", o), Q._p = new Promise(function(ne, be) {
                Q.onload = ne, Q.onerror = be;
              }), Q.addEventListener("load", function() {
                L.loading |= vS;
              }), Q.addEventListener("error", function() {
                L.loading |= Gj;
              }), L.loading |= Lc, Np(j, l, y);
            }
            j = {
              type: "stylesheet",
              instance: j,
              count: 1,
              state: L
            }, S.set(E, j);
          }
        }
      },
      M: function(o, l) {
        vh.M(o, l);
        var h = rb;
        if (h && o) {
          var y = bt(h).hoistableScripts, S = Qf(o), E = y.get(S);
          E || (E = h.querySelector(
            r1(S)
          ), E || (o = yn({ src: o, async: !0, type: "module" }, l), (l = Bc.get(S)) && sx(o, l), E = h.createElement("script"), Ke(E), ti(E, "link", o), h.head.appendChild(E)), E = {
            type: "script",
            instance: E,
            count: 1,
            state: null
          }, y.set(S, E));
        }
      }
    };
    var rb = typeof document > "u" ? null : document, cC = null, one = 6e4, sne = 800, lne = 500, t6 = 0, n6 = null, uC = null, B1 = qO, yS = {
      $$typeof: jl,
      Provider: null,
      Consumer: null,
      _currentValue: B1,
      _currentValue2: B1,
      _threadCount: 0
    }, Wj = "%c%s%c", Qj = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", Zj = "", dC = " ", cne = Function.prototype.bind, Kj = !1, Jj = null, eP = null, tP = null, nP = null, rP = null, iP = null, aP = null, oP = null, sP = null, lP = null;
    Jj = function(o, l, h, y) {
      l = t(o, l), l !== null && (h = e(l.memoizedState, h, 0, y), l.memoizedState = h, l.baseState = h, o.memoizedProps = yn({}, o.memoizedProps), h = Wa(o, 2), h !== null && Kt(h, o, 2));
    }, eP = function(o, l, h) {
      l = t(o, l), l !== null && (h = i(l.memoizedState, h, 0), l.memoizedState = h, l.baseState = h, o.memoizedProps = yn({}, o.memoizedProps), h = Wa(o, 2), h !== null && Kt(h, o, 2));
    }, tP = function(o, l, h, y) {
      l = t(o, l), l !== null && (h = n(l.memoizedState, h, y), l.memoizedState = h, l.baseState = h, o.memoizedProps = yn({}, o.memoizedProps), h = Wa(o, 2), h !== null && Kt(h, o, 2));
    }, nP = function(o, l, h) {
      o.pendingProps = e(o.memoizedProps, l, 0, h), o.alternate && (o.alternate.pendingProps = o.pendingProps), l = Wa(o, 2), l !== null && Kt(l, o, 2);
    }, rP = function(o, l) {
      o.pendingProps = i(o.memoizedProps, l, 0), o.alternate && (o.alternate.pendingProps = o.pendingProps), l = Wa(o, 2), l !== null && Kt(l, o, 2);
    }, iP = function(o, l, h) {
      o.pendingProps = n(
        o.memoizedProps,
        l,
        h
      ), o.alternate && (o.alternate.pendingProps = o.pendingProps), l = Wa(o, 2), l !== null && Kt(l, o, 2);
    }, aP = function(o) {
      var l = Wa(o, 2);
      l !== null && Kt(l, o, 2);
    }, oP = function(o) {
      var l = ct(), h = Wa(o, l);
      h !== null && Kt(h, o, l);
    }, sP = function(o) {
      s = o;
    }, lP = function(o) {
      a = o;
    };
    var fC = !0, hC = null, r6 = !1, f0 = null, h0 = null, p0 = null, bS = /* @__PURE__ */ new Map(), wS = /* @__PURE__ */ new Map(), m0 = [], une = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), pC = null;
    if (kl.prototype.render = vx.prototype.render = function(o) {
      var l = this._internalRoot;
      if (l === null)
        throw Error("Cannot update an unmounted root.");
      var h = arguments;
      typeof h[1] == "function" ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : T(h[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : typeof h[1] < "u" && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      ), h = o;
      var y = l.current, S = Za(y);
      uy(y, S, h, l, null, null);
    }, kl.prototype.unmount = vx.prototype.unmount = function() {
      var o = arguments;
      if (typeof o[0] == "function" && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ), o = this._internalRoot, o !== null) {
        this._internalRoot = null;
        var l = o.containerInfo;
        (Zn & (ka | Vl)) !== no && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        ), uy(o.current, 2, null, o, null, null), gs(), l[Au] = null;
      }
    }, kl.prototype.unstable_scheduleHydration = function(o) {
      if (o) {
        var l = sa();
        o = { blockedOn: null, target: o, priority: l };
        for (var h = 0; h < m0.length && l !== 0 && l < m0[h].priority; h++)
          ;
        m0.splice(h, 0, o), h === 0 && gx(o);
      }
    }, function() {
      var o = l1.version;
      if (o !== "19.2.0")
        throw Error(
          `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` + (o + `
  - react-dom:  19.2.0
Learn more: https://react.dev/warnings/version-mismatch`)
        );
    }(), typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    ), ur.findDOMNode = function(o) {
      var l = o._reactInternals;
      if (l === void 0)
        throw typeof o.render == "function" ? Error("Unable to find node on an unmounted component.") : (o = Object.keys(o).join(","), Error(
          "Argument appears to not be a ReactComponent. Keys: " + o
        ));
      return o = P(l), o = o !== null ? z(o) : null, o = o === null ? null : o.stateNode, o;
    }, !function() {
      var o = {
        bundleType: 1,
        version: "19.2.0",
        rendererPackageName: "react-dom",
        currentDispatcherRef: ze,
        reconcilerVersion: "19.2.0"
      };
      return o.overrideHookState = Jj, o.overrideHookStateDeletePath = eP, o.overrideHookStateRenamePath = tP, o.overrideProps = nP, o.overridePropsDeletePath = rP, o.overridePropsRenamePath = iP, o.scheduleUpdate = aP, o.scheduleRetry = oP, o.setErrorHandler = sP, o.setSuspenseHandler = lP, o.scheduleRefresh = _, o.scheduleRoot = w, o.setRefreshHandler = A, o.getCurrentFiber = Ar, Ct(o);
    }() && jd && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && navigator.userAgent.indexOf("Edge") === -1 || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var cP = window.location.protocol;
      /^(https?|file):$/.test(cP) && console.info(
        "%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + (cP === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq` : ""),
        "font-weight:bold"
      );
    }
    OS.createRoot = function(o, l) {
      if (!T(o))
        throw Error("Target container is not a DOM element.");
      yx(o);
      var h = !1, y = "", S = Ev, E = _v, j = f2;
      return l != null && (l.hydrate ? console.warn(
        "hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."
      ) : typeof l == "object" && l !== null && l.$$typeof === Qs && console.error(
        `You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`
      ), l.unstable_strictMode === !0 && (h = !0), l.identifierPrefix !== void 0 && (y = l.identifierPrefix), l.onUncaughtError !== void 0 && (S = l.onUncaughtError), l.onCaughtError !== void 0 && (E = l.onCaughtError), l.onRecoverableError !== void 0 && (j = l.onRecoverableError)), l = o1(
        o,
        1,
        !1,
        null,
        null,
        h,
        y,
        null,
        S,
        E,
        j,
        lA
      ), o[Au] = l.current, Td(o), new vx(l);
    }, OS.hydrateRoot = function(o, l, h) {
      if (!T(o))
        throw Error("Target container is not a DOM element.");
      yx(o), l === void 0 && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var y = !1, S = "", E = Ev, j = _v, L = f2, Q = null;
      return h != null && (h.unstable_strictMode === !0 && (y = !0), h.identifierPrefix !== void 0 && (S = h.identifierPrefix), h.onUncaughtError !== void 0 && (E = h.onUncaughtError), h.onCaughtError !== void 0 && (j = h.onCaughtError), h.onRecoverableError !== void 0 && (L = h.onRecoverableError), h.formState !== void 0 && (Q = h.formState)), l = o1(
        o,
        1,
        !0,
        l,
        h ?? null,
        y,
        S,
        Q,
        E,
        j,
        L,
        lA
      ), l.context = iA(null), h = l.current, y = Za(h), y = ar(y), S = Wi(y), S.callback = null, ac(h, S, y), nc(y, "hydrateRoot()", null), h = y, l.current.lanes = h, Rt(l, h), Uo(l), o[Au] = l.current, Td(o), new kl(l);
    }, OS.version = "19.2.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), OS;
}
function tG() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(tG);
    } catch (t) {
      console.error(t);
    }
  }
}
process.env.NODE_ENV === "production" ? (tG(), p8.exports = Xde()) : p8.exports = Wde();
var Qde = p8.exports;
function Mr() {
  return Mr = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Mr.apply(this, arguments);
}
function Zde(t, e) {
  const n = e.width, r = e.height, i = e.inlineSize, a = e.blockSize;
  switch (t) {
    case 1:
      return n != null ? { type: 3, value: n, unit: "px" } : { type: 1 };
    case 3:
      return i != null ? { type: 3, value: i, unit: "px" } : { type: 1 };
    case 2:
      return r != null ? { type: 3, value: r, unit: "px" } : { type: 1 };
    case 4:
      return a != null ? { type: 3, value: a, unit: "px" } : { type: 1 };
    case 5:
      return n != null && r != null && r > 0 ? { type: 2, value: n / r } : { type: 1 };
    case 6:
      return n != null && r != null ? { type: 4, value: r >= n ? "portrait" : "landscape" } : { type: 1 };
  }
}
function E6(t, e) {
  switch (t.type) {
    case 1:
    case 2:
    case 3:
    case 4:
      return J1(t, e);
    case 5: {
      const n = e.sizeFeatures.get(t.feature);
      return n ?? { type: 1 };
    }
    case 6:
      return t.value;
  }
}
function nG(t) {
  return { type: 5, value: t };
}
function NL(t, e, n) {
  return nG(function(r, i, a) {
    switch (a) {
      case 1:
        return r === i;
      case 2:
        return r > i;
      case 3:
        return r >= i;
      case 4:
        return r < i;
      case 5:
        return r <= i;
    }
  }(t, e, n));
}
function m8(t, e, n) {
  return t == null ? e : e == null ? t : n(t, e);
}
function QS(t, e) {
  switch (t) {
    case "cqw":
      return e.cqw;
    case "cqh":
      return e.cqh;
    case "cqi":
      return e.writingAxis === 0 ? e.cqw : e.cqh;
    case "cqb":
      return e.writingAxis === 1 ? e.cqw : e.cqh;
    case "cqmin":
      return m8(QS("cqi", e), QS("cqb", e), Math.min);
    case "cqmax":
      return m8(QS("cqi", e), QS("cqb", e), Math.max);
  }
}
function Kde(t, { treeContext: e }) {
  switch (t.unit) {
    case "px":
      return t.value;
    case "rem":
      return t.value * e.rootFontSize;
    case "em":
      return t.value * e.fontSize;
    case "cqw":
    case "cqh":
    case "cqi":
    case "cqb":
    case "cqmin":
    case "cqmax":
      return m8(t.value, QS(t.unit, e), (n, r) => n * r);
  }
  return null;
}
function ML(t, e) {
  switch (t.type) {
    case 2:
      return t.value === 0 ? 0 : null;
    case 3:
      return Kde(t, e);
  }
  return null;
}
function J1(t, e) {
  switch (t.type) {
    case 4:
      return function(n, r) {
        const i = E6(n.left, r), a = E6(n.right, r), s = n.operator;
        if (i.type === 4 && a.type === 4 || i.type === 5 && a.type === 5)
          return function(c, d, f) {
            return f === 1 ? nG(c.value === d.value) : { type: 1 };
          }(i, a, s);
        if (i.type === 3 || a.type === 3) {
          const c = ML(i, r), d = ML(a, r);
          if (c != null && d != null)
            return NL(c, d, s);
        } else if (i.type === 2 && a.type === 2)
          return NL(i.value, a.value, s);
        return { type: 1 };
      }(t, e);
    case 2:
      return function(n, r) {
        const i = J1(n.left, r);
        return i.type !== 5 || i.value !== !0 ? i : J1(n.right, r);
      }(t, e);
    case 3:
      return function(n, r) {
        const i = J1(n.left, r);
        return i.type === 5 && i.value === !0 ? i : J1(n.right, r);
      }(t, e);
    case 1: {
      const n = J1(t.value, e);
      return n.type === 5 ? { type: 5, value: !n.value } : { type: 1 };
    }
    case 5:
      return IL(E6(t, e));
    case 6:
      return IL(t.value);
  }
}
function IL(t) {
  switch (t.type) {
    case 5:
      return t;
    case 2:
    case 3:
      return { type: 5, value: t.value > 0 };
  }
  return { type: 1 };
}
const A_ = Array.from({ length: 4 }, () => Math.floor(256 * Math.random()).toString(16)).join(""), rG = Ig("container"), qE = Ig("container-type"), GE = Ig("container-name"), o4 = `data-cqs-${A_}`, s4 = `data-cqc-${A_}`, ZS = Ig("cqw"), KS = Ig("cqh"), dT = Ig("cqi"), fT = Ig("cqb");
function Ig(t) {
  return `--cq-${t}-${A_}`;
}
const pt = Symbol();
function iG(t, e) {
  const n = { value: e, errorIndices: [], index: -1, at(r) {
    const i = n.index + r;
    return i >= t.length ? e : t[i];
  }, consume: (r) => (n.index += r, n.value = n.at(0), n.value), reconsume() {
    n.index -= 1;
  }, error() {
    n.errorIndices.push(n.index);
  } };
  return n;
}
function Lo(t) {
  return iG(t, { type: 0 });
}
function* GM(t) {
  const e = [];
  let n = !1;
  for (const M of t) {
    const P = M.codePointAt(0);
    n && P !== 10 && (n = !1, e.push(10)), P === 0 || P >= 55296 && P <= 57343 ? e.push(65533) : P === 13 ? n = !0 : e.push(P);
  }
  const r = iG(e, -1), { at: i, consume: a, error: s, reconsume: c } = r;
  function d() {
    return String.fromCodePoint(r.value);
  }
  function f() {
    return { type: 13, value: d() };
  }
  function g() {
    for (; z1(i(1)); )
      a(1);
  }
  function m() {
    for (; r.value !== -1; )
      if (a(1), i(0) === 42 && i(1) === 47)
        return void a(1);
    s();
  }
  function b() {
    const [M, P] = function() {
      let F = 0, $ = "", G = i(1);
      for (G !== 43 && G !== 45 || (a(1), $ += d()); rl(i(1)); )
        a(1), $ += d();
      if (i(1) === 46 && rl(i(2)))
        for (F = 1, a(1), $ += d(); rl(i(1)); )
          a(1), $ += d();
      if (G = i(1), G === 69 || G === 101) {
        const H = i(2);
        if (rl(H))
          for (F = 1, a(1), $ += d(); rl(i(1)); )
            a(1), $ += d();
        else if ((H === 45 || H === 43) && rl(i(3)))
          for (F = 1, a(1), $ += d(), a(1), $ += d(); rl(i(1)); )
            a(1), $ += d();
      }
      return [$, F];
    }(), z = i(1);
    return T(z, i(1), i(2)) ? { type: 15, value: M, flag: P, unit: R() } : z === 37 ? (a(1), { type: 16, value: M }) : { type: 17, value: M, flag: P };
  }
  function w() {
    const M = R();
    let P = i(1);
    if (M.toLowerCase() === "url" && P === 40) {
      for (a(1); z1(i(1)) && z1(i(2)); )
        a(1);
      P = i(1);
      const z = i(2);
      return P === 34 || P === 39 ? { type: 23, value: M } : !z1(P) || z !== 34 && z !== 39 ? function() {
        let F = "";
        for (g(); ; ) {
          const G = a(1);
          if (G === 41)
            return { type: 20, value: F };
          if (G === -1)
            return s(), { type: 20, value: F };
          if (z1(G)) {
            g();
            const H = i(1);
            return H === 41 || H === -1 ? (a(1), G === -1 && s(), { type: 20, value: F }) : (N(), { type: 21 });
          }
          if (G === 34 || G === 39 || G === 40 || ($ = G) >= 0 && $ <= 8 || $ === 11 || $ >= 14 && $ <= 31 || $ === 127)
            return s(), N(), { type: 21 };
          if (G === 92) {
            if (!cb(G, i(1)))
              return s(), { type: 21 };
            F += A();
          } else
            F += d();
        }
        var $;
      }() : { type: 23, value: M };
    }
    return P === 40 ? (a(1), { type: 23, value: M }) : { type: 24, value: M };
  }
  function _(M) {
    let P = "";
    for (; ; ) {
      const z = a(1);
      if (z === -1 || z === M)
        return z === -1 && s(), { type: 2, value: P };
      if (hT(z))
        return s(), c(), { type: 3 };
      if (z === 92) {
        const F = i(1);
        if (F === -1)
          continue;
        hT(F) ? a(1) : P += A();
      } else
        P += d();
    }
  }
  function A() {
    const M = a(1);
    if (kL(M)) {
      const P = [M];
      for (let F = 0; F < 5; F++) {
        const $ = i(1);
        if (!kL($))
          break;
        P.push($), a(1);
      }
      z1(i(1)) && a(1);
      let z = parseInt(String.fromCodePoint(...P), 16);
      return (z === 0 || z >= 55296 && z <= 57343 || z > 1114111) && (z = 65533), String.fromCodePoint(z);
    }
    return M === -1 ? (s(), String.fromCodePoint(65533)) : d();
  }
  function T(M, P, z) {
    return M === 45 ? l4(P) || P === 45 || cb(P, z) : !!l4(M);
  }
  function O(M, P, z) {
    return M === 43 || M === 45 ? rl(P) || P === 46 && rl(z) : !(M !== 46 || !rl(P)) || !!rl(M);
  }
  function R() {
    let M = "";
    for (; ; ) {
      const P = a(1);
      if (jL(P))
        M += d();
      else {
        if (!cb(P, i(1)))
          return c(), M;
        M += A();
      }
    }
  }
  function N() {
    for (; ; ) {
      const M = a(1);
      if (M === -1)
        return;
      cb(M, i(1)) && A();
    }
  }
  for (; ; ) {
    const M = a(1);
    if (M === 47 && i(1) === 42)
      a(2), m();
    else if (z1(M))
      g(), yield { type: 1 };
    else if (M === 34)
      yield _(M);
    else if (M === 35) {
      const P = i(1);
      jL(P) || cb(P, i(2)) ? yield { type: 14, flag: T(i(1), i(2), i(3)) ? 1 : 0, value: R() } : yield f();
    } else if (M === 39)
      yield _(M);
    else if (M === 40)
      yield { type: 4 };
    else if (M === 41)
      yield { type: 5 };
    else if (M === 43)
      O(M, i(1), i(2)) ? (c(), yield b()) : yield f();
    else if (M === 44)
      yield { type: 6 };
    else if (M === 45) {
      const P = i(1), z = i(2);
      O(M, P, z) ? (c(), yield b()) : P === 45 && z === 62 ? (a(2), yield { type: 19 }) : T(M, P, z) ? (c(), yield w()) : yield f();
    } else if (M === 46)
      O(M, i(1), i(2)) ? (c(), yield b()) : yield f();
    else if (M === 58)
      yield { type: 7 };
    else if (M === 59)
      yield { type: 8 };
    else if (M === 60)
      i(1) === 33 && i(2) === 45 && i(3) === 45 ? yield { type: 18 } : yield f();
    else if (M === 64)
      T(i(1), i(2), i(3)) ? yield { type: 22, value: R() } : yield f();
    else if (M === 91)
      yield { type: 9 };
    else if (M === 92)
      cb(M, i(1)) ? (c(), yield w()) : (s(), yield f());
    else if (M === 93)
      yield { type: 10 };
    else if (M === 123)
      yield { type: 11 };
    else if (M === 125)
      yield { type: 12 };
    else if (rl(M))
      c(), yield b();
    else if (l4(M))
      c(), yield w();
    else {
      if (M === -1)
        return yield { type: 0 }, r.errorIndices;
      yield { type: 13, value: d() };
    }
  }
}
function rl(t) {
  return t >= 48 && t <= 57;
}
function kL(t) {
  return rl(t) || t >= 65 && t <= 70 || t >= 97 && t <= 102;
}
function hT(t) {
  return t === 10 || t === 13 || t === 12;
}
function z1(t) {
  return hT(t) || t === 9 || t === 32;
}
function l4(t) {
  return t >= 65 && t <= 90 || t >= 97 && t <= 122 || t >= 128 || t === 95;
}
function cb(t, e) {
  return t === 92 && !hT(e);
}
function jL(t) {
  return l4(t) || rl(t) || t === 45;
}
const Jde = { 11: 12, 9: 10, 4: 5 };
function dE(t, e) {
  const n = function(r, i) {
    const a = [];
    for (; ; )
      switch (r.consume(1).type) {
        case 1:
          break;
        case 0:
          return { type: 3, value: a };
        case 18:
        case 19:
          if (i !== !1) {
            r.reconsume();
            const s = g8(r);
            s !== pt && a.push(s);
          }
          break;
        case 22:
          r.reconsume(), a.push(oG(r));
          break;
        default: {
          r.reconsume();
          const s = g8(r);
          s !== pt && a.push(s);
          break;
        }
      }
  }(Lo(t), e === !0);
  return Mr({}, n, { value: n.value.map((r) => r.type === 26 ? function(i, a) {
    return i.value.value.type === 0 ? Mr({}, i, { value: Mr({}, i.value, { value: efe(i.value.value.value) }) }) : i;
  }(r) : r) });
}
function aG(t) {
  const e = Lo(t), n = [];
  for (; ; ) {
    if (e.consume(1).type === 0)
      return n;
    e.reconsume(), n.push(H0(e));
  }
}
function efe(t) {
  return function(e) {
    const n = [], r = [];
    for (; ; ) {
      const i = e.consume(1);
      switch (i.type) {
        case 1:
        case 8:
          break;
        case 0:
          return { type: 1, value: [...r, ...n] };
        case 22:
          e.reconsume(), n.push(oG(e));
          break;
        case 24: {
          const a = [i];
          let s = e.at(1);
          for (; s.type !== 8 && s.type !== 0; )
            a.push(H0(e)), s = e.at(1);
          const c = sG(Lo(a));
          c !== pt && r.push(c);
          break;
        }
        case 13:
          if (i.value === "&") {
            e.reconsume();
            const a = g8(e);
            a !== pt && n.push(a);
            break;
          }
        default: {
          e.error(), e.reconsume();
          let a = e.at(1);
          for (; a.type !== 8 && a.type !== 0; )
            H0(e), a = e.at(1);
          break;
        }
      }
    }
  }(Lo(t));
}
function ko(t) {
  for (; t.at(1).type === 1; )
    t.consume(1);
}
function oG(t) {
  let e = t.consume(1);
  if (e.type !== 22)
    throw new Error(`Unexpected type ${e.type}`);
  const n = e.value, r = [];
  for (; ; )
    switch (e = t.consume(1), e.type) {
      case 8:
        return { type: 25, name: n, prelude: r, value: null };
      case 0:
        return t.error(), { type: 25, name: n, prelude: r, value: null };
      case 11:
        return { type: 25, name: n, prelude: r, value: YM(t) };
      case 28:
        if (e.source.type === 11)
          return { type: 25, name: n, prelude: r, value: e };
      default:
        t.reconsume(), r.push(H0(t));
    }
}
function g8(t) {
  let e = t.value;
  const n = [];
  for (; ; )
    switch (e = t.consume(1), e.type) {
      case 0:
        return t.error(), pt;
      case 11:
        return { type: 26, prelude: n, value: YM(t) };
      case 28:
        if (e.source.type === 11)
          return { type: 26, prelude: n, value: e };
      default:
        t.reconsume(), n.push(H0(t));
    }
}
function sG(t) {
  const e = t.consume(1);
  if (e.type !== 24)
    throw new Error(`Unexpected type ${e.type}`);
  const n = e.value, r = [];
  let i = !1;
  if (ko(t), t.at(1).type !== 7)
    return t.error(), pt;
  for (t.consume(1), ko(t); t.at(1).type !== 0; )
    r.push(H0(t));
  const a = r[r.length - 2], s = r[r.length - 1];
  return a && a.type === 13 && a.value === "!" && s.type === 24 && s.value.toLowerCase() === "important" && (i = !0, r.splice(r.length - 2)), { type: 29, name: n, value: r, important: i };
}
function H0(t) {
  const e = t.consume(1);
  switch (e.type) {
    case 11:
    case 9:
    case 4:
      return YM(t);
    case 23:
      return function(n) {
        let r = n.value;
        if (r.type !== 23)
          throw new Error(`Unexpected type ${r.type}`);
        const i = r.value, a = [];
        for (; ; )
          switch (r = n.consume(1), r.type) {
            case 5:
              return { type: 27, name: i, value: a };
            case 0:
              return n.error(), { type: 27, name: i, value: a };
            default:
              n.reconsume(), a.push(H0(n));
          }
      }(t);
    default:
      return e;
  }
}
function YM(t) {
  let e = t.value;
  const n = e, r = Jde[n.type];
  if (!r)
    throw new Error(`Unexpected type ${e.type}`);
  const i = [];
  for (; ; )
    switch (e = t.consume(1), e.type) {
      case r:
        return { type: 28, source: n, value: { type: 0, value: i } };
      case 0:
        return t.error(), { type: 28, source: n, value: { type: 0, value: i } };
      default:
        t.reconsume(), i.push(H0(t));
    }
}
function kg(t) {
  return ko(t), t.at(1).type === 0;
}
const tfe = { 11: ["{", "}"], 9: ["[", "]"], 4: ["(", ")"] };
function A0(t, e) {
  switch (t.type) {
    case 25:
      return `@${CSS.escape(t.name)} ${t.prelude.map((n) => A0(n)).join("")}${t.value ? A0(t.value) : ";"}`;
    case 26:
      return `${t.prelude.map((n) => A0(n)).join("")}${A0(t.value)}`;
    case 28: {
      const [n, r] = tfe[t.source.type];
      return `${n}${lG(t.value)}${r}`;
    }
    case 27:
      return `${CSS.escape(t.name)}(${t.value.map((n) => A0(n)).join("")})`;
    case 29:
      return `${CSS.escape(t.name)}:${t.value.map((n) => A0(n)).join("")}${t.important ? " !important" : ""}`;
    case 1:
      return " ";
    case 8:
      return ";";
    case 7:
      return ":";
    case 14:
      return "#" + CSS.escape(t.value);
    case 24:
      return CSS.escape(t.value);
    case 15:
      return t.value + CSS.escape(t.unit);
    case 13:
    case 17:
      return t.value;
    case 2:
      return `"${CSS.escape(t.value)}"`;
    case 6:
      return ",";
    case 20:
      return "url(" + CSS.escape(t.value) + ")";
    case 22:
      return "@" + CSS.escape(t.value);
    case 16:
      return t.value + "%";
    default:
      throw new Error(`Unsupported token ${t.type}`);
  }
}
function lG(t, e) {
  return t.value.map((n) => {
    let r = A0(n);
    return n.type === 29 && t.type !== 0 && (r += ";"), r;
  }).join("");
}
function PL(t) {
  return A0(t);
}
function LL(t) {
  const e = t.at(1);
  return e.type === 13 && e.value === "=" && (t.consume(1), !0);
}
function TC(t, e) {
  const n = [];
  for (; ; ) {
    const r = t.at(1);
    if (r.type === 0 || e && r.type === 7 || r.type === 13 && (r.value === ">" || r.value === "<" || r.value === "="))
      break;
    n.push(t.consume(1));
  }
  return n;
}
function BL(t) {
  ko(t);
  const e = t.consume(1);
  return e.type !== 13 ? pt : e.value === ">" ? LL(t) ? 3 : 2 : e.value === "<" ? LL(t) ? 5 : 4 : e.value === "=" ? 1 : pt;
}
function zL(t) {
  return t === 4 || t === 5;
}
function FL(t) {
  return t === 2 || t === 3;
}
function RS(t, e, n) {
  const r = function(a) {
    ko(a);
    const s = a.consume(1);
    return ko(a), s.type !== 24 || a.at(1).type !== 0 ? pt : s.value;
  }(Lo(t));
  if (r === pt)
    return pt;
  let i = r.toLowerCase();
  return i = n ? n(i) : i, e.has(i) ? i : pt;
}
function JS(t) {
  return { type: 13, value: t };
}
function VL(t, e) {
  return { type: 29, name: t, value: e, important: !1 };
}
function bg(t) {
  return { type: 24, value: t };
}
function I5(t, e) {
  return { type: 27, name: t, value: e };
}
function _6(t) {
  return I5("var", [bg(t)]);
}
function v8(t, e) {
  ko(t);
  let n = !1, r = t.at(1);
  if (r.type === 24) {
    if (r.value.toLowerCase() !== "not")
      return pt;
    t.consume(1), ko(t), n = !0;
  }
  let i = function(s) {
    const c = s.consume(1);
    switch (c.type) {
      case 28: {
        if (c.source.type !== 4)
          return pt;
        const d = v8(Lo(c.value.value), null);
        return d !== pt ? d : { type: 4, value: c };
      }
      case 27:
        return { type: 4, value: c };
      default:
        return pt;
    }
  }(t);
  if (i === pt)
    return pt;
  i = n ? { type: 1, value: i } : i, ko(t), r = t.at(1);
  const a = r.type === 24 ? r.value.toLowerCase() : null;
  if (a !== null) {
    if (t.consume(1), ko(t), a !== "and" && a !== "or" || e !== null && a !== e)
      return pt;
    const s = v8(t, a);
    return s === pt ? pt : { type: a === "and" ? 2 : 3, left: i, right: s };
  }
  return kg(t) ? i : pt;
}
function cG(t) {
  return v8(t, null);
}
function c4(t) {
  switch (t.type) {
    case 1:
      return [bg("not"), { type: 1 }, ...c4(t.value)];
    case 2:
    case 3:
      return [...c4(t.left), { type: 1 }, bg(t.type === 2 ? "and" : "or"), { type: 1 }, ...c4(t.right)];
    case 4:
      return [t.value];
  }
}
const uG = { width: 1, height: 2, "inline-size": 3, "block-size": 4, "aspect-ratio": 5, orientation: 6 }, nfe = new Set(Object.keys(uG)), rfe = /* @__PURE__ */ new Set(["none", "and", "not", "or", "normal", "auto"]), ife = /* @__PURE__ */ new Set(["initial", "inherit", "revert", "revert-layer", "unset"]), afe = /* @__PURE__ */ new Set(["size", "inline-size"]);
function dG(t, e, n, r) {
  const i = n();
  if (i === pt)
    return pt;
  let a = [i, null];
  ko(t);
  const s = t.at(1);
  if (s.type === 13) {
    if (s.value !== e)
      return pt;
    t.consume(1), ko(t);
    const c = r();
    ko(t), c !== pt && (a = [i, c]);
  }
  return kg(t) ? a : pt;
}
function UL(t) {
  const e = t.consume(1);
  return e.type === 17 ? parseInt(e.value) : pt;
}
function $L(t) {
  const e = Lo(t);
  ko(e);
  const n = e.consume(1);
  let r = pt;
  switch (n.type) {
    case 17:
      e.reconsume(), r = function(i) {
        const a = dG(i, "/", () => UL(i), () => UL(i));
        return a === pt ? pt : { type: 2, value: a[0] / (a[1] !== null ? a[1] : 1) };
      }(e);
      break;
    case 15:
      r = { type: 3, value: parseInt(n.value), unit: n.unit.toLowerCase() };
      break;
    case 24: {
      const i = n.value.toLowerCase();
      switch (i) {
        case "landscape":
        case "portrait":
          r = { type: 4, value: i };
      }
    }
  }
  return r === pt ? pt : kg(e) ? { type: 6, value: r } : pt;
}
function ofe(t) {
  return !k5(t = t.toLowerCase()) && !rfe.has(t);
}
function pT(t, e) {
  const n = [];
  for (; ; ) {
    ko(t);
    const r = t.at(1);
    if (r.type !== 24 || !e(r.value))
      return n;
    t.consume(1), n.push(r.value);
  }
}
function fG(t) {
  const e = [];
  for (; ; ) {
    ko(t);
    const n = t.at(1);
    if (n.type !== 24)
      break;
    const r = n.value;
    if (!ofe(r))
      break;
    t.consume(1), e.push(r);
  }
  return e;
}
function k5(t) {
  return ife.has(t);
}
function XM(t) {
  return t.map((e) => "cq-" + e);
}
function WM(t) {
  const e = pT(t, (n) => k5(n));
  return e.length === 1 ? XM(e) : pt;
}
function QM(t, e) {
  const n = pT(t, (i) => i === "none");
  if (n.length === 1)
    return XM(n);
  if (n.length !== 0)
    return pt;
  if (e) {
    const i = WM(t);
    if (i !== pt)
      return i;
  }
  const r = fG(t);
  return r.length > 0 && (!e || kg(t)) ? r : pt;
}
function ZM(t, e) {
  if (e) {
    const n = WM(t);
    if (n !== pt)
      return n;
  }
  return function(n) {
    const r = pT(n, (a) => a === "normal");
    if (r.length === 1)
      return XM(r);
    if (r.length !== 0)
      return pt;
    const i = pT(n, (a) => afe.has(a));
    return i.length > 0 && kg(n) ? i : pt;
  }(t);
}
function hG(t) {
  const e = Lo(t), n = WM(e);
  if (n !== pt)
    return [n, n];
  const r = dG(e, "/", () => QM(e, !1), () => ZM(e, !1));
  return r !== pt && kg(e) ? [r[0], r[1] || []] : pt;
}
function sfe(t) {
  const e = Lo(t), n = fG(e);
  if (!n || n.length > 1)
    return pt;
  const r = cG(e);
  if (r === pt)
    return pt;
  const i = { features: /* @__PURE__ */ new Set() }, a = u4(r, i);
  return kg(e) ? { name: n.length > 0 ? n[0] : null, condition: a, features: i.features } : pt;
}
function u4(t, e) {
  switch (t.type) {
    case 1:
      return { type: 1, value: u4(t.value, e) };
    case 2:
    case 3:
      return { type: t.type === 2 ? 2 : 3, left: u4(t.left, e), right: u4(t.right, e) };
    case 4:
      if (t.value.type === 28) {
        const n = function(r, i) {
          const a = function(c, d) {
            const f = TC(c, !0), g = c.at(1);
            if (g.type === 0) {
              const T = RS(f, d);
              return T !== pt && d.has(T) ? { type: 1, feature: T } : pt;
            }
            if (g.type === 7) {
              c.consume(1);
              const T = TC(c, !1);
              let O = 1;
              const R = RS(f, d, (N) => N.startsWith("min-") ? (O = 3, N.substring(4)) : N.startsWith("max-") ? (O = 5, N.substring(4)) : N);
              return R !== pt ? { type: 2, feature: R, bounds: [null, [O, T]] } : pt;
            }
            const m = BL(c);
            if (m === pt)
              return pt;
            const b = TC(c, !1);
            if (c.at(1).type === 0) {
              const T = RS(f, d);
              if (T !== pt)
                return { type: 2, feature: T, bounds: [null, [m, b]] };
              const O = RS(b, d);
              return O !== pt ? { type: 2, feature: O, bounds: [[m, f], null] } : pt;
            }
            const w = BL(c);
            if (w === pt || !(FL(m) && FL(w) || zL(m) && zL(w)))
              return pt;
            const _ = TC(c, !1), A = RS(b, d);
            return A !== pt ? { type: 2, feature: A, bounds: [[m, f], [w, _]] } : pt;
          }(r, nfe);
          if (a === pt)
            return pt;
          const s = uG[a.feature];
          if (s == null)
            return pt;
          if (i.features.add(s), a.type === 1)
            return { type: 5, feature: s };
          {
            const c = { type: 5, feature: s };
            let d = pt;
            if (a.bounds[0] !== null) {
              const f = $L(a.bounds[0][1]);
              if (f === pt)
                return pt;
              d = { type: 4, operator: a.bounds[0][0], left: f, right: c };
            }
            if (a.bounds[1] !== null) {
              const f = $L(a.bounds[1][1]);
              if (f === pt)
                return pt;
              const g = { type: 4, operator: a.bounds[1][0], left: c, right: f };
              d = d !== pt ? { type: 2, left: d, right: g } : g;
            }
            return d;
          }
        }(Lo(t.value.value.value), e);
        if (n !== pt)
          return n;
      }
      return { type: 6, value: { type: 1 } };
  }
}
let lfe = 0;
const cfe = { cqw: ZS, cqh: KS, cqi: dT, cqb: fT }, ufe = CSS.supports("selector(:where(div))"), d4 = ":not(.container-query-polyfill)";
aG(Array.from(GM(d4)));
const dfe = document.createElement("div"), ffe = /* @__PURE__ */ new Set(["before", "after", "first-line", "first-letter"]);
function HL(t, e) {
  return I5("calc", [{ type: 17, flag: t.flag, value: t.value }, JS("*"), e]);
}
function pG(t) {
  return t.map((e) => {
    switch (e.type) {
      case 15:
        return function(n) {
          const r = n.unit, i = cfe[r];
          return i != null ? HL(n, _6(i)) : r === "cqmin" || r === "cqmax" ? HL(n, I5(n.unit.slice(2), [_6(dT), { type: 6 }, _6(fT)])) : n;
        }(e);
      case 27:
        return Mr({}, e, { value: pG(e.value) });
    }
    return e;
  });
}
function mG(t) {
  switch (t.name) {
    case "container":
      return hG(t.value) ? Mr({}, t, { name: rG }) : t;
    case "container-name":
      return QM(Lo(t.value), !0) ? Mr({}, t, { name: GE }) : t;
    case "container-type":
      return ZM(Lo(t.value), !0) != null ? Mr({}, t, { name: qE }) : t;
  }
  return Mr({}, t, { value: pG(t.value) });
}
function mT(t, e) {
  return Mr({}, t, { value: t.value.map((n) => {
    switch (n.type) {
      case 25:
        return KM(n, e);
      case 26:
        return function(r, i) {
          return i.transformStyleRule(Mr({}, r, { value: gG(r.value, i) }));
        }(n, e);
      default:
        return n;
    }
  }) });
}
function qL(t) {
  return t.type === 0 || t.type === 6;
}
function hfe(t) {
  for (let e = t.length - 1; e >= 0; e--)
    if (t[e].type !== 1)
      return t.slice(0, e + 1);
  return t;
}
function gG(t, e) {
  return function(n, r) {
    const i = [];
    let a = null, s = null;
    for (const c of n.value.value)
      switch (c.type) {
        case 25:
          {
            const d = r ? r(c) : c;
            d && i.push(d);
          }
          break;
        case 29: {
          const d = mG(c);
          switch (d.name) {
            case rG: {
              const f = hG(c.value);
              f !== pt && (a = f[0], s = f[1]);
              break;
            }
            case GE: {
              const f = QM(Lo(c.value), !0);
              f !== pt && (a = f);
              break;
            }
            case qE: {
              const f = ZM(Lo(c.value), !0);
              f !== pt && (s = f);
              break;
            }
            default:
              i.push(d);
          }
        }
      }
    return a && a.length > 0 && i.push(VL(GE, [bg(a.join(" "))])), s && s.length > 0 && i.push(VL(qE, [bg(s.join(" "))])), Mr({}, n, { value: { type: 2, value: i } });
  }(t, (n) => KM(n, e));
}
function f4(t) {
  if (t.type === 1)
    return Mr({}, t, { value: f4(t.value) });
  if (t.type === 2 || t.type === 3)
    return Mr({}, t, { left: f4(t.left), right: f4(t.right) });
  if (t.type === 4 && t.value.type === 28) {
    const e = function(n) {
      const r = Lo(n);
      return ko(r), r.at(1).type !== 24 ? pt : sG(r) || pt;
    }(t.value.value.value);
    if (e !== pt)
      return Mr({}, t, { value: Mr({}, t.value, { value: { type: 0, value: [mG(e)] } }) });
  }
  return t;
}
function pfe(t, e) {
  let n = cG(Lo(t.prelude));
  return n = n !== pt ? f4(n) : pt, Mr({}, t, { prelude: n !== pt ? c4(n) : t.prelude, value: t.value ? Mr({}, t.value, { value: mT(dE(t.value.value.value), e) }) : null });
}
function KM(t, e) {
  switch (t.name.toLocaleLowerCase()) {
    case "media":
    case "layer":
      return function(n, r) {
        return Mr({}, n, { value: n.value ? Mr({}, n.value, { value: mT(dE(n.value.value.value), r) }) : null });
      }(t, e);
    case "keyframes":
      return function(n, r) {
        let i = null;
        return n.value && (i = Mr({}, n.value, { value: { type: 3, value: dE(n.value.value.value).value.map((a) => {
          switch (a.type) {
            case 26:
              return function(s, c) {
                return Mr({}, s, { value: gG(s.value, c) });
              }(a, r);
            case 25:
              return KM(a, r);
          }
        }) } })), Mr({}, n, { value: i });
      }(t, e);
    case "supports":
      return pfe(t, e);
    case "container":
      return function(n, r) {
        if (n.value) {
          const i = sfe(n.prelude);
          if (i !== pt) {
            const a = { rule: i, selector: null, parent: r.parent, uid: "c" + lfe++ }, s = /* @__PURE__ */ new Set(), c = [], d = mT(dE(n.value.value.value), { descriptors: r.descriptors, parent: a, transformStyleRule: (f) => {
              const [g, m] = function(w, _, A) {
                const T = Lo(w), O = [], R = [];
                for (; ; ) {
                  if (T.at(1).type === 0)
                    return [O, R];
                  const P = Math.max(0, T.index);
                  for (; N = T.at(1), M = T.at(2), !(qL(N) || N.type === 7 && (M.type === 7 || M.type === 24 && ffe.has(M.value.toLowerCase()))); )
                    T.consume(1);
                  const z = T.index + 1, F = w.slice(P, z), $ = F.length > 0 ? hfe(F) : [JS("*")];
                  for (; !qL(T.at(1)); )
                    T.consume(1);
                  const G = w.slice(z, Math.max(0, T.index + 1));
                  let H = $, Z = [{ type: 28, source: { type: 9 }, value: { type: 0, value: [bg(G.length > 0 ? o4 : s4), JS("~"), JS("="), { type: 2, value: _ }] } }];
                  if (ufe)
                    Z = [JS(":"), I5("where", Z)];
                  else {
                    const V = $.map(PL).join("");
                    V.endsWith(d4) ? H = aG(Array.from(GM(V.substring(0, V.length - d4.length)))) : c.push({ actual: V, expected: V + d4 });
                  }
                  O.push(...$), R.push(...H), R.push(...Z), R.push(...G), T.consume(1);
                }
                var N, M;
              }(f.prelude, a.uid);
              if (c.length > 0)
                return f;
              const b = g.map(PL).join("");
              try {
                dfe.matches(b), s.add(b);
              } catch {
              }
              return Mr({}, f, { prelude: m });
            } }).value;
            if (c.length > 0) {
              const f = /* @__PURE__ */ new Set(), g = [];
              let m = 0;
              for (const { actual: w } of c)
                m = Math.max(m, w.length);
              const b = Array.from({ length: m }, () => " ").join("");
              for (const { actual: w, expected: _ } of c)
                f.has(w) || (g.push(`${w}${b.substring(0, m - w.length)} => ${_}`), f.add(w));
              console.warn(`The :where() pseudo-class is not supported by this browser. To use the Container Query Polyfill, you must modify the selectors under your @container rules:

${g.join(`
`)}`);
            }
            return s.size > 0 && (a.selector = Array.from(s).join(", ")), r.descriptors.push(a), { type: 25, name: "media", prelude: [bg("all")], value: Mr({}, n.value, { value: { type: 3, value: d } }) };
          }
        }
        return n;
      }(t, e);
  }
  return t;
}
class gT {
  constructor(e) {
    this.value = void 0, this.value = e;
  }
}
function vT(t, e) {
  if (t === e)
    return !0;
  if (typeof t == typeof e && t !== null && e !== null && typeof t == "object") {
    if (Array.isArray(t)) {
      if (!Array.isArray(e) || e.length !== t.length)
        return !1;
      for (let n = 0, r = t.length; n < r; n++)
        if (!vT(t[n], e[n]))
          return !1;
      return !0;
    }
    if (t instanceof gT)
      return e instanceof gT && t.value === e.value;
    {
      const n = Object.keys(t);
      if (n.length !== Object.keys(e).length)
        return !1;
      for (let r = 0, i = n.length; r < i; r++) {
        const a = n[r];
        if (!vT(t[a], e[a]))
          return !1;
      }
      return !0;
    }
  }
  return !1;
}
const A6 = Symbol("CQ_INSTANCE"), vG = Symbol("CQ_STYLESHEET"), mfe = CSS.supports("width: 1svh"), gfe = /* @__PURE__ */ new Set(["vertical-lr", "vertical-rl", "sideways-rl", "sideways-lr", "tb", "tb-lr", "tb-rl"]), vfe = ["padding-left", "padding-right", "border-left-width", "border-right-width"], yfe = ["padding-top", "padding-bottom", "border-top-width", "border-bottom-width"], bfe = /(\w*(\s|-))?(table|ruby)(-\w*)?/;
class Gb {
  constructor(e) {
    this.node = void 0, this.node = e;
  }
  connected() {
  }
  disconnected() {
  }
  updated() {
  }
}
class wfe extends Gb {
  constructor(e, n) {
    super(e), this.context = void 0, this.controller = null, this.styleSheet = null, this.context = n;
  }
  connected() {
    var e = this;
    const n = this.node;
    if (n.rel === "stylesheet") {
      const r = new URL(n.href, document.baseURI);
      r.origin === location.origin && (this.controller = yG(async function(i) {
        const a = await fetch(r.toString(), { signal: i }), s = await a.text(), c = e.styleSheet = await e.context.registerStyleSheet({ source: s, url: r, signal: i }), d = new Blob([c.source], { type: "text/css" }), f = new Image();
        f.onload = f.onerror = c.refresh, f.src = n.href = URL.createObjectURL(d);
      }));
    }
  }
  disconnected() {
    var e, n;
    (e = this.controller) == null || e.abort(), this.controller = null, (n = this.styleSheet) == null || n.dispose(), this.styleSheet = null;
  }
}
class xfe extends Gb {
  constructor(e, n) {
    super(e), this.context = void 0, this.controller = null, this.styleSheet = null, this.context = n;
  }
  connected() {
    var e = this;
    this.controller = yG(async function(n) {
      const r = e.node, i = e.styleSheet = await e.context.registerStyleSheet({ source: r.innerHTML, signal: n });
      r.innerHTML = i.source, i.refresh();
    });
  }
  disconnected() {
    var e, n;
    (e = this.controller) == null || e.abort(), this.controller = null, (n = this.styleSheet) == null || n.dispose(), this.styleSheet = null;
  }
}
class Sfe extends Gb {
  connected() {
    const e = `* { ${qE}: cq-normal; ${GE}: cq-none; }`;
    this.node.innerHTML = window.CSSLayerBlockRule === void 0 ? e : `@layer cq-polyfill-${A_} { ${e} }`;
  }
}
class Efe extends Gb {
  constructor(e, n) {
    super(e), this.context = void 0, this.styles = void 0, this.context = n, this.styles = window.getComputedStyle(e);
  }
  connected() {
    this.node.style.cssText = "position: fixed; top: 0; left: 0; visibility: hidden; " + (mfe ? "width: 1svw; height: 1svh;" : "width: 1%; height: 1%;");
  }
  updated() {
    const e = y8((n) => this.styles.getPropertyValue(n));
    this.context.viewportChanged({ width: e.width, height: e.height });
  }
}
function yG(t) {
  const e = new AbortController();
  return t(e.signal).catch((n) => {
    if (!(n instanceof DOMException && n.message === "AbortError"))
      throw n;
  }), e;
}
function _fe(t) {
  let e = 0;
  if (t.length === 0 || t.startsWith("cq-") && ((t = t.substring(3)) === "normal" || k5(t)))
    return e;
  const n = t.split(" ");
  for (const r of n)
    switch (r) {
      case "size":
        e |= 3;
        break;
      case "inline-size":
        e |= 1;
        break;
      default:
        return 0;
    }
  return e;
}
function Afe(t) {
  let e = 0;
  return t !== "none" && (e |= 1, t === "contents" || t === "inline" || bfe.test(t) || (e |= 2)), e;
}
function h4(t, e) {
  return parseFloat(t(e));
}
function GL(t, e) {
  return e.reduce((n, r) => n + h4(t, r), 0);
}
function y8(t) {
  let e = 0, n = 0;
  return t("box-sizing") === "border-box" && (e = GL(t, vfe), n = GL(t, yfe)), { fontSize: h4(t, "font-size"), width: h4(t, "width") - e, height: h4(t, "height") - n };
}
function YL(t) {
  return { containerType: _fe(t(qE).trim()), containerNames: (n = t(GE).trim(), n.startsWith("cq-") && ((n = n.substring(3)) === "none" || k5(n)) ? /* @__PURE__ */ new Set([]) : new Set(n.length === 0 ? [] : n.split(" "))), writingAxis: (e = t("writing-mode").trim(), gfe.has(e) ? 1 : 0), displayFlags: Afe(t("display").trim()) };
  var e, n;
}
function OC(t, e, n) {
  n != null ? n != t.getPropertyValue(e) && t.setProperty(e, n) : t.removeProperty(e);
}
function Cfe(t) {
  const e = t[vG];
  return e ?? [];
}
function XL(t, e) {
  t[vG] = e;
}
new Promise((t) => {
}), window.CQPolyfill = { version: "1.0.2" }, "container" in document.documentElement.style || function(t) {
  function e(O) {
    return O[A6] || null;
  }
  const n = document.documentElement;
  if (e(n))
    return;
  const r = document.createElement(`cq-polyfill-${A_}`), i = document.createElement("style");
  new MutationObserver((O) => {
    for (const R of O) {
      for (const N of R.removedNodes) {
        const M = e(N);
        M?.disconnect();
      }
      R.target.nodeType !== Node.DOCUMENT_NODE && R.target.nodeType !== Node.DOCUMENT_FRAGMENT_NODE && R.target.parentNode === null || R.type === "attributes" && R.attributeName && (R.attributeName === o4 || R.attributeName === s4 || R.target instanceof Element && R.target.getAttribute(R.attributeName) === R.oldValue) || (T(R.target).mutate(), m());
    }
  }).observe(n, { childList: !0, subtree: !0, attributes: !0, attributeOldValue: !0 });
  const a = new ResizeObserver((O) => {
    for (const R of O)
      T(R.target).resize();
    T(n).update(_());
  }), s = new Gb(n);
  async function c(O, { source: R, url: N, signal: M }) {
    const P = function(H, Z) {
      try {
        const V = Array.from(GM(H));
        if (Z)
          for (let ee = 0; ee < V.length; ee++) {
            const K = V[ee];
            if (K.type === 20)
              K.value = new URL(K.value, Z).toString();
            else if (K.type === 23 && K.value.toLowerCase() === "url") {
              const U = ee + 1 < V.length ? V[ee + 1] : null;
              U && U.type === 2 && (U.value = new URL(U.value, Z).toString());
            }
          }
        const Y = { descriptors: [], parent: null, transformStyleRule: (ee) => ee };
        return { source: lG(mT(dE(V, !0), Y)), descriptors: Y.descriptors };
      } catch (V) {
        return console.warn("An error occurred while transpiling stylesheet: " + V), { source: H, descriptors: [] };
      }
    }(R, N ? N.toString() : void 0);
    let z = () => {
    }, F = () => {
    };
    const $ = T(n);
    let G = !1;
    return M != null && M.aborted || (F = () => {
      if (!G) {
        const { sheet: H } = O;
        H != null && (XL(H, P.descriptors), G = !0, z = () => {
          XL(H), $.mutate(), m();
        }, $.mutate(), m());
      }
    }), { source: P.source, dispose: z, refresh: F };
  }
  const d = { cqw: null, cqh: null };
  function f({ width: O, height: R }) {
    d.cqw = O, d.cqh = R;
  }
  function g(O, R, N) {
    if (O instanceof Element && R) {
      let M = "";
      for (const [P, z] of R.conditions) {
        const F = P.value;
        F.selector != null && z != null && (2 & z) == 2 && O.matches(F.selector) && (M.length > 0 && (M += " "), M += F.uid);
      }
      M.length > 0 ? O.setAttribute(N, M) : O.removeAttribute(N);
    }
  }
  function m() {
    a.unobserve(n), a.observe(n);
  }
  const b = () => {
    const O = [];
    for (const R of document.styleSheets)
      for (const N of Cfe(R))
        O.push([new gT(N), 0]);
    return O;
  }, w = window.getComputedStyle(n), _ = () => {
    const O = (M) => w.getPropertyValue(M), R = YL(O), N = y8(O);
    return { parentState: null, conditions: b(), context: Mr({}, d, { fontSize: N.fontSize, rootFontSize: N.fontSize, writingAxis: R.writingAxis }), displayFlags: R.displayFlags, isQueryContainer: !1 };
  }, A = (O) => O;
  function T(O) {
    let R = e(O);
    if (!R) {
      let N, M = null, P = !1;
      O === n ? (N = s, M = A) : O === r ? (P = !0, N = new Efe(r, { viewportChanged: f })) : N = O === i ? new Sfe(i) : O instanceof HTMLLinkElement ? new wfe(O, { registerStyleSheet: (V) => c(O, Mr({}, V)) }) : O instanceof HTMLStyleElement ? new xfe(O, { registerStyleSheet: (V) => c(O, Mr({}, V)) }) : new Gb(O);
      let z = Symbol();
      if (M == null && O instanceof Element) {
        const V = function(Y) {
          const ee = window.getComputedStyle(Y);
          return function(K) {
            let U = null;
            return (...q) => {
              if (U == null || !vT(U[0], q)) {
                const W = ((ie, J) => {
                  const { context: B, conditions: te } = ie, ae = (Ce) => ee.getPropertyValue(Ce), le = YL(ae), de = Mr({}, B, { writingAxis: le.writingAxis });
                  let _e = te, ue = !1, Se = le.displayFlags;
                  !(1 & ie.displayFlags) && (Se = 0);
                  const { containerType: Ne, containerNames: Me } = le;
                  if (Ne > 0) {
                    const Ce = Ne > 0 && (2 & Se) == 2, Ue = new Map(te.map((rt) => [rt[0].value, rt[1]]));
                    if (_e = [], ue = !0, Ce) {
                      const rt = y8(ae);
                      de.fontSize = rt.fontSize;
                      const it = function(Ct, se) {
                        const ge = { value: se.width }, Te = { value: se.height };
                        let He = ge, $e = Te;
                        if (Ct.writingAxis === 1) {
                          const Ze = He;
                          He = $e, $e = Ze;
                        }
                        return (2 & Ct.containerType) != 2 && ($e.value = void 0), { width: ge.value, height: Te.value, inlineSize: He.value, blockSize: $e.value };
                      }(le, rt), Ft = { sizeFeatures: it, treeContext: de }, wt = (Ct) => {
                        const { rule: se } = Ct, ge = se.name, Te = ge == null || Me.has(ge) ? function($e, Ze) {
                          const ct = /* @__PURE__ */ new Map(), Mt = Ze.sizeFeatures;
                          for (const sn of $e.features) {
                            const In = Zde(sn, Mt);
                            if (In.type === 1)
                              return null;
                            ct.set(sn, In);
                          }
                          const Rt = J1($e.condition, { sizeFeatures: ct, treeContext: Ze.treeContext });
                          return Rt.type === 5 ? Rt.value : null;
                        }(se, Ft) : null;
                        var He;
                        return Te == null ? (((He = Ue.get(Ct)) != null ? He : 0) && 1) === 1 : Te === !0;
                      }, Ot = (Ct, se) => {
                        let ge = Ct.get(se);
                        if (ge == null) {
                          const Te = wt(se);
                          ge = (Te ? 1 : 0) | (Te !== !0 || se.parent != null && (1 & Ot(Ct, se.parent)) != 1 ? 0 : 2), Ct.set(se, ge);
                        }
                        return ge;
                      }, On = /* @__PURE__ */ new Map();
                      for (const Ct of te)
                        _e.push([Ct[0], Ot(On, Ct[0].value)]);
                      de.cqw = it.width != null ? it.width / 100 : B.cqw, de.cqh = it.height != null ? it.height / 100 : B.cqh;
                    }
                  }
                  return { parentState: new gT(ie), conditions: _e, context: de, displayFlags: Se, isQueryContainer: ue };
                })(...q);
                U != null && vT(U[1], W) || (U = [q, W]);
              }
              return U[1];
            };
          }();
        }(O);
        M = (Y) => V(Y, z);
      }
      const F = M || A;
      let $ = null;
      const G = (V) => {
        const Y = $;
        return $ = F(V), [$, $ !== Y];
      }, H = O instanceof HTMLElement || O instanceof SVGElement ? O.style : null;
      let Z = !1;
      R = { connect() {
        for (let V = O.firstChild; V != null; V = V.nextSibling)
          T(V);
        N.connected();
      }, disconnect() {
        O instanceof Element && (a.unobserve(O), O.removeAttribute(o4), O.removeAttribute(s4)), H && (H.removeProperty(dT), H.removeProperty(fT), H.removeProperty(ZS), H.removeProperty(KS));
        for (let V = O.firstChild; V != null; V = V.nextSibling) {
          const Y = e(V);
          Y?.disconnect();
        }
        N.disconnected(), delete O[A6];
      }, update(V) {
        const [Y, ee] = G(V);
        if (ee) {
          if (g(O, V, s4), g(O, Y, o4), O instanceof Element) {
            const K = P || Y.isQueryContainer;
            K && !Z ? (a.observe(O), Z = !0) : !K && Z && (a.unobserve(O), Z = !1);
          }
          if (H) {
            const K = Y.context, U = K.writingAxis;
            let q = null, W = null, ie = null, J = null;
            (U !== V.context.writingAxis || Y.isQueryContainer) && (q = `var(${U === 0 ? ZS : KS})`, W = `var(${U === 1 ? ZS : KS})`), V && !Y.isQueryContainer || (K.cqw && (ie = K.cqw + "px"), K.cqh && (J = K.cqh + "px")), OC(H, dT, q), OC(H, fT, W), OC(H, ZS, ie), OC(H, KS, J);
          }
          N.updated();
        }
        for (let K = O.firstChild; K != null; K = K.nextSibling)
          T(K).update(Y);
      }, resize() {
        z = Symbol();
      }, mutate() {
        z = Symbol();
        for (let V = O.firstChild; V != null; V = V.nextSibling)
          T(V).mutate();
      } }, O[A6] = R, R.connect();
    }
    return R;
  }
  n.prepend(i, r), T(n), m();
}();
var sw = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    return this.listeners.add(t), this.onSubscribe(), () => {
      this.listeners.delete(t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, Tfe = {
  // We need the wrapper function syntax below instead of direct references to
  // global setTimeout etc.
  //
  // BAD: `setTimeout: setTimeout`
  // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
  //
  // If we use direct references here, then anything that wants to spy on or
  // replace the global setTimeout (like tests) won't work since we'll already
  // have a hard reference to the original implementation at the time when this
  // file was imported.
  setTimeout: (t, e) => setTimeout(t, e),
  clearTimeout: (t) => clearTimeout(t),
  setInterval: (t, e) => setInterval(t, e),
  clearInterval: (t) => clearInterval(t)
}, Ofe = class {
  // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
  // type at app boot; and if we leave that type, then any new timer provider
  // would need to support ReturnType<typeof setTimeout>, which is infeasible.
  //
  // We settle for type safety for the TimeoutProvider type, and accept that
  // this class is unsafe internally to allow for extension.
  #e = Tfe;
  #t = !1;
  setTimeoutProvider(t) {
    process.env.NODE_ENV !== "production" && this.#t && t !== this.#e && console.error(
      "[timeoutManager]: Switching provider after calls to previous provider might result in unexpected behavior.",
      { previous: this.#e, provider: t }
    ), this.#e = t, process.env.NODE_ENV !== "production" && (this.#t = !1);
  }
  setTimeout(t, e) {
    return process.env.NODE_ENV !== "production" && (this.#t = !0), this.#e.setTimeout(t, e);
  }
  clearTimeout(t) {
    this.#e.clearTimeout(t);
  }
  setInterval(t, e) {
    return process.env.NODE_ENV !== "production" && (this.#t = !0), this.#e.setInterval(t, e);
  }
  clearInterval(t) {
    this.#e.clearInterval(t);
  }
}, tg = new Ofe();
function Rfe(t) {
  setTimeout(t, 0);
}
var wg = typeof window > "u" || "Deno" in globalThis;
function Ds() {
}
function Dfe(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function b8(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function bG(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function k0(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function $c(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function WL(t, e) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: i,
    predicate: a,
    queryKey: s,
    stale: c
  } = t;
  if (s) {
    if (r) {
      if (e.queryHash !== JM(s, e.options))
        return !1;
    } else if (!YE(e.queryKey, s))
      return !1;
  }
  if (n !== "all") {
    const d = e.isActive();
    if (n === "active" && !d || n === "inactive" && d)
      return !1;
  }
  return !(typeof c == "boolean" && e.isStale() !== c || i && i !== e.state.fetchStatus || a && !a(e));
}
function QL(t, e) {
  const { exact: n, status: r, predicate: i, mutationKey: a } = t;
  if (a) {
    if (!e.options.mutationKey)
      return !1;
    if (n) {
      if (xg(e.options.mutationKey) !== xg(a))
        return !1;
    } else if (!YE(e.options.mutationKey, a))
      return !1;
  }
  return !(r && e.state.status !== r || i && !i(e));
}
function JM(t, e) {
  return (e?.queryKeyHashFn || xg)(t);
}
function xg(t) {
  return JSON.stringify(
    t,
    (e, n) => x8(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : n
  );
}
function YE(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? Object.keys(e).every((n) => YE(t[n], e[n])) : !1;
}
var Nfe = Object.prototype.hasOwnProperty;
function w8(t, e) {
  if (t === e)
    return t;
  const n = ZL(t) && ZL(e);
  if (!n && !(x8(t) && x8(e)))
    return e;
  const i = (n ? t : Object.keys(t)).length, a = n ? e : Object.keys(e), s = a.length, c = n ? new Array(s) : {};
  let d = 0;
  for (let f = 0; f < s; f++) {
    const g = n ? f : a[f], m = t[g], b = e[g];
    if (m === b) {
      c[g] = m, (n ? f < i : Nfe.call(t, g)) && d++;
      continue;
    }
    if (m === null || b === null || typeof m != "object" || typeof b != "object") {
      c[g] = b;
      continue;
    }
    const w = w8(m, b);
    c[g] = w, w === m && d++;
  }
  return i === s && d === i ? t : c;
}
function yT(t, e) {
  if (!e || Object.keys(t).length !== Object.keys(e).length)
    return !1;
  for (const n in t)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function ZL(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function x8(t) {
  if (!KL(t))
    return !1;
  const e = t.constructor;
  if (e === void 0)
    return !0;
  const n = e.prototype;
  return !(!KL(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(t) !== Object.prototype);
}
function KL(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Mfe(t) {
  return new Promise((e) => {
    tg.setTimeout(e, t);
  });
}
function S8(t, e, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(t, e);
  if (n.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return w8(t, e);
      } catch (r) {
        throw console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${r}`
        ), r;
      }
    return w8(t, e);
  }
  return e;
}
function Ife(t, e, n = 0) {
  const r = [...t, e];
  return n && r.length > n ? r.slice(1) : r;
}
function kfe(t, e, n = 0) {
  const r = [e, ...t];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var XE = Symbol();
function wG(t, e) {
  return process.env.NODE_ENV !== "production" && t.queryFn === XE && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${t.queryHash}'`
  ), !t.queryFn && e?.initialPromise ? () => e.initialPromise : !t.queryFn || t.queryFn === XE ? () => Promise.reject(new Error(`Missing queryFn: '${t.queryHash}'`)) : t.queryFn;
}
function xG(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
var jfe = class extends sw {
  #e;
  #t;
  #n;
  constructor() {
    super(), this.#n = (t) => {
      if (!wg && window.addEventListener) {
        const e = () => t();
        return window.addEventListener("visibilitychange", e, !1), () => {
          window.removeEventListener("visibilitychange", e);
        };
      }
    };
  }
  onSubscribe() {
    this.#t || this.setEventListener(this.#n);
  }
  onUnsubscribe() {
    this.hasListeners() || (this.#t?.(), this.#t = void 0);
  }
  setEventListener(t) {
    this.#n = t, this.#t?.(), this.#t = t((e) => {
      typeof e == "boolean" ? this.setFocused(e) : this.onFocus();
    });
  }
  setFocused(t) {
    this.#e !== t && (this.#e = t, this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((e) => {
      e(t);
    });
  }
  isFocused() {
    return typeof this.#e == "boolean" ? this.#e : globalThis.document?.visibilityState !== "hidden";
  }
}, eI = new jfe();
function E8() {
  let t, e;
  const n = new Promise((i, a) => {
    t = i, e = a;
  });
  n.status = "pending", n.catch(() => {
  });
  function r(i) {
    Object.assign(n, i), delete n.resolve, delete n.reject;
  }
  return n.resolve = (i) => {
    r({
      status: "fulfilled",
      value: i
    }), t(i);
  }, n.reject = (i) => {
    r({
      status: "rejected",
      reason: i
    }), e(i);
  }, n;
}
var Pfe = Rfe;
function Lfe() {
  let t = [], e = 0, n = (c) => {
    c();
  }, r = (c) => {
    c();
  }, i = Pfe;
  const a = (c) => {
    e ? t.push(c) : i(() => {
      n(c);
    });
  }, s = () => {
    const c = t;
    t = [], c.length && i(() => {
      r(() => {
        c.forEach((d) => {
          n(d);
        });
      });
    });
  };
  return {
    batch: (c) => {
      let d;
      e++;
      try {
        d = c();
      } finally {
        e--, e || s();
      }
      return d;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (c) => (...d) => {
      a(() => {
        c(...d);
      });
    },
    schedule: a,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (c) => {
      n = c;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (c) => {
      r = c;
    },
    setScheduler: (c) => {
      i = c;
    }
  };
}
var Ua = Lfe(), Bfe = class extends sw {
  #e = !0;
  #t;
  #n;
  constructor() {
    super(), this.#n = (t) => {
      if (!wg && window.addEventListener) {
        const e = () => t(!0), n = () => t(!1);
        return window.addEventListener("online", e, !1), window.addEventListener("offline", n, !1), () => {
          window.removeEventListener("online", e), window.removeEventListener("offline", n);
        };
      }
    };
  }
  onSubscribe() {
    this.#t || this.setEventListener(this.#n);
  }
  onUnsubscribe() {
    this.hasListeners() || (this.#t?.(), this.#t = void 0);
  }
  setEventListener(t) {
    this.#n = t, this.#t?.(), this.#t = t(this.setOnline.bind(this));
  }
  setOnline(t) {
    this.#e !== t && (this.#e = t, this.listeners.forEach((n) => {
      n(t);
    }));
  }
  isOnline() {
    return this.#e;
  }
}, bT = new Bfe();
function zfe(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function SG(t) {
  return (t ?? "online") === "online" ? bT.isOnline() : !0;
}
var _8 = class extends Error {
  constructor(t) {
    super("CancelledError"), this.revert = t?.revert, this.silent = t?.silent;
  }
};
function EG(t) {
  let e = !1, n = 0, r;
  const i = E8(), a = () => i.status !== "pending", s = (A) => {
    if (!a()) {
      const T = new _8(A);
      b(T), t.onCancel?.(T);
    }
  }, c = () => {
    e = !0;
  }, d = () => {
    e = !1;
  }, f = () => eI.isFocused() && (t.networkMode === "always" || bT.isOnline()) && t.canRun(), g = () => SG(t.networkMode) && t.canRun(), m = (A) => {
    a() || (r?.(), i.resolve(A));
  }, b = (A) => {
    a() || (r?.(), i.reject(A));
  }, w = () => new Promise((A) => {
    r = (T) => {
      (a() || f()) && A(T);
    }, t.onPause?.();
  }).then(() => {
    r = void 0, a() || t.onContinue?.();
  }), _ = () => {
    if (a())
      return;
    let A;
    const T = n === 0 ? t.initialPromise : void 0;
    try {
      A = T ?? t.fn();
    } catch (O) {
      A = Promise.reject(O);
    }
    Promise.resolve(A).then(m).catch((O) => {
      if (a())
        return;
      const R = t.retry ?? (wg ? 0 : 3), N = t.retryDelay ?? zfe, M = typeof N == "function" ? N(n, O) : N, P = R === !0 || typeof R == "number" && n < R || typeof R == "function" && R(n, O);
      if (e || !P) {
        b(O);
        return;
      }
      n++, t.onFail?.(n, O), Mfe(M).then(() => f() ? void 0 : w()).then(() => {
        e ? b(O) : _();
      });
    });
  };
  return {
    promise: i,
    status: () => i.status,
    cancel: s,
    continue: () => (r?.(), i),
    cancelRetry: c,
    continueRetry: d,
    canStart: g,
    start: () => (g() ? _() : w().then(_), i)
  };
}
var _G = class {
  #e;
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), b8(this.gcTime) && (this.#e = tg.setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(t) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      t ?? (wg ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    this.#e && (tg.clearTimeout(this.#e), this.#e = void 0);
  }
}, Ffe = class extends _G {
  #e;
  #t;
  #n;
  #i;
  #r;
  #o;
  #s;
  constructor(t) {
    super(), this.#s = !1, this.#o = t.defaultOptions, this.setOptions(t.options), this.observers = [], this.#i = t.client, this.#n = this.#i.getQueryCache(), this.queryKey = t.queryKey, this.queryHash = t.queryHash, this.#e = eB(this.options), this.state = t.state ?? this.#e, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    return this.#r?.promise;
  }
  setOptions(t) {
    if (this.options = { ...this.#o, ...t }, this.updateGcTime(this.options.gcTime), this.state && this.state.data === void 0) {
      const e = eB(this.options);
      e.data !== void 0 && (this.setState(
        JL(e.data, e.dataUpdatedAt)
      ), this.#e = e);
    }
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.#n.remove(this);
  }
  setData(t, e) {
    const n = S8(this.state.data, t, this.options);
    return this.#a({
      data: n,
      type: "success",
      dataUpdatedAt: e?.updatedAt,
      manual: e?.manual
    }), n;
  }
  setState(t, e) {
    this.#a({ type: "setState", state: t, setStateOptions: e });
  }
  cancel(t) {
    const e = this.#r?.promise;
    return this.#r?.cancel(t), e ? e.then(Ds).catch(Ds) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(this.#e);
  }
  isActive() {
    return this.observers.some(
      (t) => $c(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === XE || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStatic() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (t) => k0(t.options.staleTime, this) === "static"
    ) : !1;
  }
  isStale() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0 || this.state.isInvalidated;
  }
  isStaleByTime(t = 0) {
    return this.state.data === void 0 ? !0 : t === "static" ? !1 : this.state.isInvalidated ? !0 : !bG(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    this.observers.find((e) => e.shouldFetchOnWindowFocus())?.refetch({ cancelRefetch: !1 }), this.#r?.continue();
  }
  onOnline() {
    this.observers.find((e) => e.shouldFetchOnReconnect())?.refetch({ cancelRefetch: !1 }), this.#r?.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), this.#n.notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((e) => e !== t), this.observers.length || (this.#r && (this.#s ? this.#r.cancel({ revert: !0 }) : this.#r.cancelRetry()), this.scheduleGc()), this.#n.notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.#a({ type: "invalidate" });
  }
  async fetch(t, e) {
    if (this.state.fetchStatus !== "idle" && // If the promise in the retyer is already rejected, we have to definitely
    // re-start the fetch; there is a chance that the query is still in a
    // pending state when that happens
    this.#r?.status() !== "rejected") {
      if (this.state.data !== void 0 && e?.cancelRefetch)
        this.cancel({ silent: !0 });
      else if (this.#r)
        return this.#r.continueRetry(), this.#r.promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const c = this.observers.find((d) => d.options.queryFn);
      c && this.setOptions(c.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const n = new AbortController(), r = (c) => {
      Object.defineProperty(c, "signal", {
        enumerable: !0,
        get: () => (this.#s = !0, n.signal)
      });
    }, i = () => {
      const c = wG(this.options, e), f = (() => {
        const g = {
          client: this.#i,
          queryKey: this.queryKey,
          meta: this.meta
        };
        return r(g), g;
      })();
      return this.#s = !1, this.options.persister ? this.options.persister(
        c,
        f,
        this
      ) : c(f);
    }, s = (() => {
      const c = {
        fetchOptions: e,
        options: this.options,
        queryKey: this.queryKey,
        client: this.#i,
        state: this.state,
        fetchFn: i
      };
      return r(c), c;
    })();
    this.options.behavior?.onFetch(s, this), this.#t = this.state, (this.state.fetchStatus === "idle" || this.state.fetchMeta !== s.fetchOptions?.meta) && this.#a({ type: "fetch", meta: s.fetchOptions?.meta }), this.#r = EG({
      initialPromise: e?.initialPromise,
      fn: s.fetchFn,
      onCancel: (c) => {
        c instanceof _8 && c.revert && this.setState({
          ...this.#t,
          fetchStatus: "idle"
        }), n.abort();
      },
      onFail: (c, d) => {
        this.#a({ type: "failed", failureCount: c, error: d });
      },
      onPause: () => {
        this.#a({ type: "pause" });
      },
      onContinue: () => {
        this.#a({ type: "continue" });
      },
      retry: s.options.retry,
      retryDelay: s.options.retryDelay,
      networkMode: s.options.networkMode,
      canRun: () => !0
    });
    try {
      const c = await this.#r.start();
      if (c === void 0)
        throw process.env.NODE_ENV !== "production" && console.error(
          `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
        ), new Error(`${this.queryHash} data is undefined`);
      return this.setData(c), this.#n.config.onSuccess?.(c, this), this.#n.config.onSettled?.(
        c,
        this.state.error,
        this
      ), c;
    } catch (c) {
      if (c instanceof _8) {
        if (c.silent)
          return this.#r.promise;
        if (c.revert) {
          if (this.state.data === void 0)
            throw c;
          return this.state.data;
        }
      }
      throw this.#a({
        type: "error",
        error: c
      }), this.#n.config.onError?.(
        c,
        this
      ), this.#n.config.onSettled?.(
        this.state.data,
        c,
        this
      ), c;
    } finally {
      this.scheduleGc();
    }
  }
  #a(t) {
    const e = (n) => {
      switch (t.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            ...AG(n.data, this.options),
            fetchMeta: t.meta ?? null
          };
        case "success":
          const r = {
            ...n,
            ...JL(t.data, t.dataUpdatedAt),
            dataUpdateCount: n.dataUpdateCount + 1,
            ...!t.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
          return this.#t = t.manual ? r : void 0, r;
        case "error":
          const i = t.error;
          return {
            ...n,
            error: i,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: i,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...t.state
          };
      }
    };
    this.state = e(this.state), Ua.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate();
      }), this.#n.notify({ query: this, type: "updated", action: t });
    });
  }
};
function AG(t, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: SG(e.networkMode) ? "fetching" : "paused",
    ...t === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function JL(t, e) {
  return {
    data: t,
    dataUpdatedAt: e ?? Date.now(),
    error: null,
    isInvalidated: !1,
    status: "success"
  };
}
function eB(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, n = e !== void 0, r = n ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var CG = class extends sw {
  constructor(t, e) {
    super(), this.options = e, this.#e = t, this.#a = null, this.#s = E8(), this.bindMethods(), this.setOptions(e);
  }
  #e;
  #t = void 0;
  #n = void 0;
  #i = void 0;
  #r;
  #o;
  #s;
  #a;
  #m;
  #f;
  // This property keeps track of the last query with defined data.
  // It will be used to pass the previous data and query to the placeholder function between renders.
  #h;
  #c;
  #u;
  #l;
  #p = /* @__PURE__ */ new Set();
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.#t.addObserver(this), tB(this.#t, this.options) ? this.#d() : this.updateResult(), this.#b());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return A8(
      this.#t,
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return A8(
      this.#t,
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.#w(), this.#x(), this.#t.removeObserver(this);
  }
  setOptions(t) {
    const e = this.options, n = this.#t;
    if (this.options = this.#e.defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof $c(this.options.enabled, this.#t) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    this.#S(), this.#t.setOptions(this.options), e._defaulted && !yT(this.options, e) && this.#e.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.#t,
      observer: this
    });
    const r = this.hasListeners();
    r && nB(
      this.#t,
      n,
      this.options,
      e
    ) && this.#d(), this.updateResult(), r && (this.#t !== n || $c(this.options.enabled, this.#t) !== $c(e.enabled, this.#t) || k0(this.options.staleTime, this.#t) !== k0(e.staleTime, this.#t)) && this.#g();
    const i = this.#v();
    r && (this.#t !== n || $c(this.options.enabled, this.#t) !== $c(e.enabled, this.#t) || i !== this.#l) && this.#y(i);
  }
  getOptimisticResult(t) {
    const e = this.#e.getQueryCache().build(this.#e, t), n = this.createResult(e, t);
    return Ufe(this, n) && (this.#i = n, this.#o = this.options, this.#r = this.#t.state), n;
  }
  getCurrentResult() {
    return this.#i;
  }
  trackResult(t, e) {
    return new Proxy(t, {
      get: (n, r) => (this.trackProp(r), e?.(r), r === "promise" && (this.trackProp("data"), !this.options.experimental_prefetchInRender && this.#s.status === "pending" && this.#s.reject(
        new Error(
          "experimental_prefetchInRender feature flag is not enabled"
        )
      )), Reflect.get(n, r))
    });
  }
  trackProp(t) {
    this.#p.add(t);
  }
  getCurrentQuery() {
    return this.#t;
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const e = this.#e.defaultQueryOptions(t), n = this.#e.getQueryCache().build(this.#e, e);
    return n.fetch().then(() => this.createResult(n, e));
  }
  fetch(t) {
    return this.#d({
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), this.#i));
  }
  #d(t) {
    this.#S();
    let e = this.#t.fetch(
      this.options,
      t
    );
    return t?.throwOnError || (e = e.catch(Ds)), e;
  }
  #g() {
    this.#w();
    const t = k0(
      this.options.staleTime,
      this.#t
    );
    if (wg || this.#i.isStale || !b8(t))
      return;
    const n = bG(this.#i.dataUpdatedAt, t) + 1;
    this.#c = tg.setTimeout(() => {
      this.#i.isStale || this.updateResult();
    }, n);
  }
  #v() {
    return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.#t) : this.options.refetchInterval) ?? !1;
  }
  #y(t) {
    this.#x(), this.#l = t, !(wg || $c(this.options.enabled, this.#t) === !1 || !b8(this.#l) || this.#l === 0) && (this.#u = tg.setInterval(() => {
      (this.options.refetchIntervalInBackground || eI.isFocused()) && this.#d();
    }, this.#l));
  }
  #b() {
    this.#g(), this.#y(this.#v());
  }
  #w() {
    this.#c && (tg.clearTimeout(this.#c), this.#c = void 0);
  }
  #x() {
    this.#u && (tg.clearInterval(this.#u), this.#u = void 0);
  }
  createResult(t, e) {
    const n = this.#t, r = this.options, i = this.#i, a = this.#r, s = this.#o, d = t !== n ? t.state : this.#n, { state: f } = t;
    let g = { ...f }, m = !1, b;
    if (e._optimisticResults) {
      const $ = this.hasListeners(), G = !$ && tB(t, e), H = $ && nB(t, n, e, r);
      (G || H) && (g = {
        ...g,
        ...AG(f.data, t.options)
      }), e._optimisticResults === "isRestoring" && (g.fetchStatus = "idle");
    }
    let { error: w, errorUpdatedAt: _, status: A } = g;
    b = g.data;
    let T = !1;
    if (e.placeholderData !== void 0 && b === void 0 && A === "pending") {
      let $;
      i?.isPlaceholderData && e.placeholderData === s?.placeholderData ? ($ = i.data, T = !0) : $ = typeof e.placeholderData == "function" ? e.placeholderData(
        this.#h?.state.data,
        this.#h
      ) : e.placeholderData, $ !== void 0 && (A = "success", b = S8(
        i?.data,
        $,
        e
      ), m = !0);
    }
    if (e.select && b !== void 0 && !T)
      if (i && b === a?.data && e.select === this.#m)
        b = this.#f;
      else
        try {
          this.#m = e.select, b = e.select(b), b = S8(i?.data, b, e), this.#f = b, this.#a = null;
        } catch ($) {
          this.#a = $;
        }
    this.#a && (w = this.#a, b = this.#f, _ = Date.now(), A = "error");
    const O = g.fetchStatus === "fetching", R = A === "pending", N = A === "error", M = R && O, P = b !== void 0, F = {
      status: A,
      fetchStatus: g.fetchStatus,
      isPending: R,
      isSuccess: A === "success",
      isError: N,
      isInitialLoading: M,
      isLoading: M,
      data: b,
      dataUpdatedAt: g.dataUpdatedAt,
      error: w,
      errorUpdatedAt: _,
      failureCount: g.fetchFailureCount,
      failureReason: g.fetchFailureReason,
      errorUpdateCount: g.errorUpdateCount,
      isFetched: g.dataUpdateCount > 0 || g.errorUpdateCount > 0,
      isFetchedAfterMount: g.dataUpdateCount > d.dataUpdateCount || g.errorUpdateCount > d.errorUpdateCount,
      isFetching: O,
      isRefetching: O && !R,
      isLoadingError: N && !P,
      isPaused: g.fetchStatus === "paused",
      isPlaceholderData: m,
      isRefetchError: N && P,
      isStale: tI(t, e),
      refetch: this.refetch,
      promise: this.#s,
      isEnabled: $c(e.enabled, t) !== !1
    };
    if (this.options.experimental_prefetchInRender) {
      const $ = (Z) => {
        F.status === "error" ? Z.reject(F.error) : F.data !== void 0 && Z.resolve(F.data);
      }, G = () => {
        const Z = this.#s = F.promise = E8();
        $(Z);
      }, H = this.#s;
      switch (H.status) {
        case "pending":
          t.queryHash === n.queryHash && $(H);
          break;
        case "fulfilled":
          (F.status === "error" || F.data !== H.value) && G();
          break;
        case "rejected":
          (F.status !== "error" || F.error !== H.reason) && G();
          break;
      }
    }
    return F;
  }
  updateResult() {
    const t = this.#i, e = this.createResult(this.#t, this.options);
    if (this.#r = this.#t.state, this.#o = this.options, this.#r.data !== void 0 && (this.#h = this.#t), yT(e, t))
      return;
    this.#i = e;
    const n = () => {
      if (!t)
        return !0;
      const { notifyOnChangeProps: r } = this.options, i = typeof r == "function" ? r() : r;
      if (i === "all" || !i && !this.#p.size)
        return !0;
      const a = new Set(
        i ?? this.#p
      );
      return this.options.throwOnError && a.add("error"), Object.keys(this.#i).some((s) => {
        const c = s;
        return this.#i[c] !== t[c] && a.has(c);
      });
    };
    this.#E({ listeners: n() });
  }
  #S() {
    const t = this.#e.getQueryCache().build(this.#e, this.options);
    if (t === this.#t)
      return;
    const e = this.#t;
    this.#t = t, this.#n = t.state, this.hasListeners() && (e?.removeObserver(this), t.addObserver(this));
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && this.#b();
  }
  #E(t) {
    Ua.batch(() => {
      t.listeners && this.listeners.forEach((e) => {
        e(this.#i);
      }), this.#e.getQueryCache().notify({
        query: this.#t,
        type: "observerResultsUpdated"
      });
    });
  }
};
function Vfe(t, e) {
  return $c(e.enabled, t) !== !1 && t.state.data === void 0 && !(t.state.status === "error" && e.retryOnMount === !1);
}
function tB(t, e) {
  return Vfe(t, e) || t.state.data !== void 0 && A8(t, e, e.refetchOnMount);
}
function A8(t, e, n) {
  if ($c(e.enabled, t) !== !1 && k0(e.staleTime, t) !== "static") {
    const r = typeof n == "function" ? n(t) : n;
    return r === "always" || r !== !1 && tI(t, e);
  }
  return !1;
}
function nB(t, e, n, r) {
  return (t !== e || $c(r.enabled, t) === !1) && (!n.suspense || t.state.status !== "error") && tI(t, n);
}
function tI(t, e) {
  return $c(e.enabled, t) !== !1 && t.isStaleByTime(k0(e.staleTime, t));
}
function Ufe(t, e) {
  return !yT(t.getCurrentResult(), e);
}
function rB(t) {
  return {
    onFetch: (e, n) => {
      const r = e.options, i = e.fetchOptions?.meta?.fetchMore?.direction, a = e.state.data?.pages || [], s = e.state.data?.pageParams || [];
      let c = { pages: [], pageParams: [] }, d = 0;
      const f = async () => {
        let g = !1;
        const m = (_) => {
          Object.defineProperty(_, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? g = !0 : e.signal.addEventListener("abort", () => {
              g = !0;
            }), e.signal)
          });
        }, b = wG(e.options, e.fetchOptions), w = async (_, A, T) => {
          if (g)
            return Promise.reject();
          if (A == null && _.pages.length)
            return Promise.resolve(_);
          const R = (() => {
            const z = {
              client: e.client,
              queryKey: e.queryKey,
              pageParam: A,
              direction: T ? "backward" : "forward",
              meta: e.options.meta
            };
            return m(z), z;
          })(), N = await b(R), { maxPages: M } = e.options, P = T ? kfe : Ife;
          return {
            pages: P(_.pages, N, M),
            pageParams: P(_.pageParams, A, M)
          };
        };
        if (i && a.length) {
          const _ = i === "backward", A = _ ? $fe : iB, T = {
            pages: a,
            pageParams: s
          }, O = A(r, T);
          c = await w(T, O, _);
        } else {
          const _ = t ?? a.length;
          do {
            const A = d === 0 ? s[0] ?? r.initialPageParam : iB(r, c);
            if (d > 0 && A == null)
              break;
            c = await w(c, A), d++;
          } while (d < _);
        }
        return c;
      };
      e.options.persister ? e.fetchFn = () => e.options.persister?.(
        f,
        {
          client: e.client,
          queryKey: e.queryKey,
          meta: e.options.meta,
          signal: e.signal
        },
        n
      ) : e.fetchFn = f;
    }
  };
}
function iB(t, { pages: e, pageParams: n }) {
  const r = e.length - 1;
  return e.length > 0 ? t.getNextPageParam(
    e[r],
    e,
    n[r],
    n
  ) : void 0;
}
function $fe(t, { pages: e, pageParams: n }) {
  return e.length > 0 ? t.getPreviousPageParam?.(e[0], e, n[0], n) : void 0;
}
var Hfe = class extends _G {
  #e;
  #t;
  #n;
  #i;
  constructor(t) {
    super(), this.#e = t.client, this.mutationId = t.mutationId, this.#n = t.mutationCache, this.#t = [], this.state = t.state || TG(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    this.#t.includes(t) || (this.#t.push(t), this.clearGcTimeout(), this.#n.notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.#t = this.#t.filter((e) => e !== t), this.scheduleGc(), this.#n.notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    this.#t.length || (this.state.status === "pending" ? this.scheduleGc() : this.#n.remove(this));
  }
  continue() {
    return this.#i?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    const e = () => {
      this.#r({ type: "continue" });
    }, n = {
      client: this.#e,
      meta: this.options.meta,
      mutationKey: this.options.mutationKey
    };
    this.#i = EG({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t, n) : Promise.reject(new Error("No mutationFn found")),
      onFail: (a, s) => {
        this.#r({ type: "failed", failureCount: a, error: s });
      },
      onPause: () => {
        this.#r({ type: "pause" });
      },
      onContinue: e,
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => this.#n.canRun(this)
    });
    const r = this.state.status === "pending", i = !this.#i.canStart();
    try {
      if (r)
        e();
      else {
        this.#r({ type: "pending", variables: t, isPaused: i }), await this.#n.config.onMutate?.(
          t,
          this,
          n
        );
        const s = await this.options.onMutate?.(
          t,
          n
        );
        s !== this.state.context && this.#r({
          type: "pending",
          context: s,
          variables: t,
          isPaused: i
        });
      }
      const a = await this.#i.start();
      return await this.#n.config.onSuccess?.(
        a,
        t,
        this.state.context,
        this,
        n
      ), await this.options.onSuccess?.(
        a,
        t,
        this.state.context,
        n
      ), await this.#n.config.onSettled?.(
        a,
        null,
        this.state.variables,
        this.state.context,
        this,
        n
      ), await this.options.onSettled?.(
        a,
        null,
        t,
        this.state.context,
        n
      ), this.#r({ type: "success", data: a }), a;
    } catch (a) {
      try {
        throw await this.#n.config.onError?.(
          a,
          t,
          this.state.context,
          this,
          n
        ), await this.options.onError?.(
          a,
          t,
          this.state.context,
          n
        ), await this.#n.config.onSettled?.(
          void 0,
          a,
          this.state.variables,
          this.state.context,
          this,
          n
        ), await this.options.onSettled?.(
          void 0,
          a,
          t,
          this.state.context,
          n
        ), a;
      } finally {
        this.#r({ type: "error", error: a });
      }
    } finally {
      this.#n.runNext(this);
    }
  }
  #r(t) {
    const e = (n) => {
      switch (t.type) {
        case "failed":
          return {
            ...n,
            failureCount: t.failureCount,
            failureReason: t.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "pending":
          return {
            ...n,
            context: t.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: t.isPaused,
            status: "pending",
            variables: t.variables,
            submittedAt: Date.now()
          };
        case "success":
          return {
            ...n,
            data: t.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: t.error,
            failureCount: n.failureCount + 1,
            failureReason: t.error,
            isPaused: !1,
            status: "error"
          };
      }
    };
    this.state = e(this.state), Ua.batch(() => {
      this.#t.forEach((n) => {
        n.onMutationUpdate(t);
      }), this.#n.notify({
        mutation: this,
        type: "updated",
        action: t
      });
    });
  }
};
function TG() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var qfe = class extends sw {
  constructor(t = {}) {
    super(), this.config = t, this.#e = /* @__PURE__ */ new Set(), this.#t = /* @__PURE__ */ new Map(), this.#n = 0;
  }
  #e;
  #t;
  #n;
  build(t, e, n) {
    const r = new Hfe({
      client: t,
      mutationCache: this,
      mutationId: ++this.#n,
      options: t.defaultMutationOptions(e),
      state: n
    });
    return this.add(r), r;
  }
  add(t) {
    this.#e.add(t);
    const e = RC(t);
    if (typeof e == "string") {
      const n = this.#t.get(e);
      n ? n.push(t) : this.#t.set(e, [t]);
    }
    this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    if (this.#e.delete(t)) {
      const e = RC(t);
      if (typeof e == "string") {
        const n = this.#t.get(e);
        if (n)
          if (n.length > 1) {
            const r = n.indexOf(t);
            r !== -1 && n.splice(r, 1);
          } else
            n[0] === t && this.#t.delete(e);
      }
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    const e = RC(t);
    if (typeof e == "string") {
      const r = this.#t.get(e)?.find(
        (i) => i.state.status === "pending"
      );
      return !r || r === t;
    } else
      return !0;
  }
  runNext(t) {
    const e = RC(t);
    return typeof e == "string" ? this.#t.get(e)?.find((r) => r !== t && r.state.isPaused)?.continue() ?? Promise.resolve() : Promise.resolve();
  }
  clear() {
    Ua.batch(() => {
      this.#e.forEach((t) => {
        this.notify({ type: "removed", mutation: t });
      }), this.#e.clear(), this.#t.clear();
    });
  }
  getAll() {
    return Array.from(this.#e);
  }
  find(t) {
    const e = { exact: !0, ...t };
    return this.getAll().find(
      (n) => QL(e, n)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((e) => QL(t, e));
  }
  notify(t) {
    Ua.batch(() => {
      this.listeners.forEach((e) => {
        e(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((e) => e.state.isPaused);
    return Ua.batch(
      () => Promise.all(
        t.map((e) => e.continue().catch(Ds))
      )
    );
  }
};
function RC(t) {
  return t.options.scope?.id;
}
var Gfe = class extends sw {
  #e;
  #t = void 0;
  #n;
  #i;
  constructor(e, n) {
    super(), this.#e = e, this.setOptions(n), this.bindMethods(), this.#r();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(e) {
    const n = this.options;
    this.options = this.#e.defaultMutationOptions(e), yT(this.options, n) || this.#e.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.#n,
      observer: this
    }), n?.mutationKey && this.options.mutationKey && xg(n.mutationKey) !== xg(this.options.mutationKey) ? this.reset() : this.#n?.state.status === "pending" && this.#n.setOptions(this.options);
  }
  onUnsubscribe() {
    this.hasListeners() || this.#n?.removeObserver(this);
  }
  onMutationUpdate(e) {
    this.#r(), this.#o(e);
  }
  getCurrentResult() {
    return this.#t;
  }
  reset() {
    this.#n?.removeObserver(this), this.#n = void 0, this.#r(), this.#o();
  }
  mutate(e, n) {
    return this.#i = n, this.#n?.removeObserver(this), this.#n = this.#e.getMutationCache().build(this.#e, this.options), this.#n.addObserver(this), this.#n.execute(e);
  }
  #r() {
    const e = this.#n?.state ?? TG();
    this.#t = {
      ...e,
      isPending: e.status === "pending",
      isSuccess: e.status === "success",
      isError: e.status === "error",
      isIdle: e.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
  }
  #o(e) {
    Ua.batch(() => {
      if (this.#i && this.hasListeners()) {
        const n = this.#t.variables, r = this.#t.context, i = {
          client: this.#e,
          meta: this.options.meta,
          mutationKey: this.options.mutationKey
        };
        e?.type === "success" ? (this.#i.onSuccess?.(
          e.data,
          n,
          r,
          i
        ), this.#i.onSettled?.(
          e.data,
          null,
          n,
          r,
          i
        )) : e?.type === "error" && (this.#i.onError?.(
          e.error,
          n,
          r,
          i
        ), this.#i.onSettled?.(
          void 0,
          e.error,
          n,
          r,
          i
        ));
      }
      this.listeners.forEach((n) => {
        n(this.#t);
      });
    });
  }
}, Yfe = class extends sw {
  constructor(t = {}) {
    super(), this.config = t, this.#e = /* @__PURE__ */ new Map();
  }
  #e;
  build(t, e, n) {
    const r = e.queryKey, i = e.queryHash ?? JM(r, e);
    let a = this.get(i);
    return a || (a = new Ffe({
      client: t,
      queryKey: r,
      queryHash: i,
      options: t.defaultQueryOptions(e),
      state: n,
      defaultOptions: t.getQueryDefaults(r)
    }), this.add(a)), a;
  }
  add(t) {
    this.#e.has(t.queryHash) || (this.#e.set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const e = this.#e.get(t.queryHash);
    e && (t.destroy(), e === t && this.#e.delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    Ua.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return this.#e.get(t);
  }
  getAll() {
    return [...this.#e.values()];
  }
  find(t) {
    const e = { exact: !0, ...t };
    return this.getAll().find(
      (n) => WL(e, n)
    );
  }
  findAll(t = {}) {
    const e = this.getAll();
    return Object.keys(t).length > 0 ? e.filter((n) => WL(t, n)) : e;
  }
  notify(t) {
    Ua.batch(() => {
      this.listeners.forEach((e) => {
        e(t);
      });
    });
  }
  onFocus() {
    Ua.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    Ua.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, Xfe = class {
  #e;
  #t;
  #n;
  #i;
  #r;
  #o;
  #s;
  #a;
  constructor(t = {}) {
    this.#e = t.queryCache || new Yfe(), this.#t = t.mutationCache || new qfe(), this.#n = t.defaultOptions || {}, this.#i = /* @__PURE__ */ new Map(), this.#r = /* @__PURE__ */ new Map(), this.#o = 0;
  }
  mount() {
    this.#o++, this.#o === 1 && (this.#s = eI.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), this.#e.onFocus());
    }), this.#a = bT.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), this.#e.onOnline());
    }));
  }
  unmount() {
    this.#o--, this.#o === 0 && (this.#s?.(), this.#s = void 0, this.#a?.(), this.#a = void 0);
  }
  isFetching(t) {
    return this.#e.findAll({ ...t, fetchStatus: "fetching" }).length;
  }
  isMutating(t) {
    return this.#t.findAll({ ...t, status: "pending" }).length;
  }
  /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */
  getQueryData(t) {
    const e = this.defaultQueryOptions({ queryKey: t });
    return this.#e.get(e.queryHash)?.state.data;
  }
  ensureQueryData(t) {
    const e = this.defaultQueryOptions(t), n = this.#e.build(this, e), r = n.state.data;
    return r === void 0 ? this.fetchQuery(t) : (t.revalidateIfStale && n.isStaleByTime(k0(e.staleTime, n)) && this.prefetchQuery(e), Promise.resolve(r));
  }
  getQueriesData(t) {
    return this.#e.findAll(t).map(({ queryKey: e, state: n }) => {
      const r = n.data;
      return [e, r];
    });
  }
  setQueryData(t, e, n) {
    const r = this.defaultQueryOptions({ queryKey: t }), a = this.#e.get(
      r.queryHash
    )?.state.data, s = Dfe(e, a);
    if (s !== void 0)
      return this.#e.build(this, r).setData(s, { ...n, manual: !0 });
  }
  setQueriesData(t, e, n) {
    return Ua.batch(
      () => this.#e.findAll(t).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, e, n)
      ])
    );
  }
  getQueryState(t) {
    const e = this.defaultQueryOptions({ queryKey: t });
    return this.#e.get(
      e.queryHash
    )?.state;
  }
  removeQueries(t) {
    const e = this.#e;
    Ua.batch(() => {
      e.findAll(t).forEach((n) => {
        e.remove(n);
      });
    });
  }
  resetQueries(t, e) {
    const n = this.#e;
    return Ua.batch(() => (n.findAll(t).forEach((r) => {
      r.reset();
    }), this.refetchQueries(
      {
        type: "active",
        ...t
      },
      e
    )));
  }
  cancelQueries(t, e = {}) {
    const n = { revert: !0, ...e }, r = Ua.batch(
      () => this.#e.findAll(t).map((i) => i.cancel(n))
    );
    return Promise.all(r).then(Ds).catch(Ds);
  }
  invalidateQueries(t, e = {}) {
    return Ua.batch(() => (this.#e.findAll(t).forEach((n) => {
      n.invalidate();
    }), t?.refetchType === "none" ? Promise.resolve() : this.refetchQueries(
      {
        ...t,
        type: t?.refetchType ?? t?.type ?? "active"
      },
      e
    )));
  }
  refetchQueries(t, e = {}) {
    const n = {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }, r = Ua.batch(
      () => this.#e.findAll(t).filter((i) => !i.isDisabled() && !i.isStatic()).map((i) => {
        let a = i.fetch(void 0, n);
        return n.throwOnError || (a = a.catch(Ds)), i.state.fetchStatus === "paused" ? Promise.resolve() : a;
      })
    );
    return Promise.all(r).then(Ds);
  }
  fetchQuery(t) {
    const e = this.defaultQueryOptions(t);
    e.retry === void 0 && (e.retry = !1);
    const n = this.#e.build(this, e);
    return n.isStaleByTime(
      k0(e.staleTime, n)
    ) ? n.fetch(e) : Promise.resolve(n.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(Ds).catch(Ds);
  }
  fetchInfiniteQuery(t) {
    return t.behavior = rB(t.pages), this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(Ds).catch(Ds);
  }
  ensureInfiniteQueryData(t) {
    return t.behavior = rB(t.pages), this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return bT.isOnline() ? this.#t.resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return this.#e;
  }
  getMutationCache() {
    return this.#t;
  }
  getDefaultOptions() {
    return this.#n;
  }
  setDefaultOptions(t) {
    this.#n = t;
  }
  setQueryDefaults(t, e) {
    this.#i.set(xg(t), {
      queryKey: t,
      defaultOptions: e
    });
  }
  getQueryDefaults(t) {
    const e = [...this.#i.values()], n = {};
    return e.forEach((r) => {
      YE(t, r.queryKey) && Object.assign(n, r.defaultOptions);
    }), n;
  }
  setMutationDefaults(t, e) {
    this.#r.set(xg(t), {
      mutationKey: t,
      defaultOptions: e
    });
  }
  getMutationDefaults(t) {
    const e = [...this.#r.values()], n = {};
    return e.forEach((r) => {
      YE(t, r.mutationKey) && Object.assign(n, r.defaultOptions);
    }), n;
  }
  defaultQueryOptions(t) {
    if (t._defaulted)
      return t;
    const e = {
      ...this.#n.queries,
      ...this.getQueryDefaults(t.queryKey),
      ...t,
      _defaulted: !0
    };
    return e.queryHash || (e.queryHash = JM(
      e.queryKey,
      e
    )), e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"), e.throwOnError === void 0 && (e.throwOnError = !!e.suspense), !e.networkMode && e.persister && (e.networkMode = "offlineFirst"), e.queryFn === XE && (e.enabled = !1), e;
  }
  defaultMutationOptions(t) {
    return t?._defaulted ? t : {
      ...this.#n.mutations,
      ...t?.mutationKey && this.getMutationDefaults(t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    this.#e.clear(), this.#t.clear();
  }
}, OG = I.createContext(
  void 0
), Ju = (t) => {
  const e = I.useContext(OG);
  if (t)
    return t;
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, Wfe = ({
  client: t,
  children: e
}) => (I.useEffect(() => (t.mount(), () => {
  t.unmount();
}), [t]), /* @__PURE__ */ C.jsx(OG.Provider, { value: t, children: e })), RG = I.createContext(!1), Qfe = () => I.useContext(RG);
RG.Provider;
function Zfe() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
var Kfe = I.createContext(Zfe()), Jfe = () => I.useContext(Kfe), ehe = (t, e) => {
  (t.suspense || t.throwOnError || t.experimental_prefetchInRender) && (e.isReset() || (t.retryOnMount = !1));
}, the = (t) => {
  I.useEffect(() => {
    t.clearReset();
  }, [t]);
}, nhe = ({
  result: t,
  errorResetBoundary: e,
  throwOnError: n,
  query: r,
  suspense: i
}) => t.isError && !e.isReset() && !t.isFetching && r && (i && t.data === void 0 || xG(n, [t.error, r])), rhe = (t, e) => e.state.data === void 0, ihe = (t) => {
  if (t.suspense) {
    const n = (i) => i === "static" ? i : Math.max(i ?? 1e3, 1e3), r = t.staleTime;
    t.staleTime = typeof r == "function" ? (...i) => n(r(...i)) : n(r), typeof t.gcTime == "number" && (t.gcTime = Math.max(
      t.gcTime,
      1e3
    ));
  }
}, ahe = (t, e) => t.isLoading && t.isFetching && !e, ohe = (t, e) => t?.suspense && e.isPending, aB = (t, e, n) => e.fetchOptimistic(t).catch(() => {
  n.clearReset();
});
function DG(t, e, n) {
  if (process.env.NODE_ENV !== "production" && (typeof t != "object" || Array.isArray(t)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = Qfe(), i = Jfe(), a = Ju(n), s = a.defaultQueryOptions(t);
  a.getDefaultOptions().queries?._experimental_beforeQuery?.(
    s
  ), process.env.NODE_ENV !== "production" && (s.queryFn || console.error(
    `[${s.queryHash}]: No queryFn was passed as an option, and no default queryFn was found. The queryFn parameter is only optional when using a default queryFn. More info here: https://tanstack.com/query/latest/docs/framework/react/guides/default-query-function`
  )), s._optimisticResults = r ? "isRestoring" : "optimistic", ihe(s), ehe(s, i), the(i);
  const c = !a.getQueryCache().get(s.queryHash), [d] = I.useState(
    () => new e(
      a,
      s
    )
  ), f = d.getOptimisticResult(s), g = !r && t.subscribed !== !1;
  if (I.useSyncExternalStore(
    I.useCallback(
      (m) => {
        const b = g ? d.subscribe(Ua.batchCalls(m)) : Ds;
        return d.updateResult(), b;
      },
      [d, g]
    ),
    () => d.getCurrentResult(),
    () => d.getCurrentResult()
  ), I.useEffect(() => {
    d.setOptions(s);
  }, [s, d]), ohe(s, f))
    throw aB(s, d, i);
  if (nhe({
    result: f,
    errorResetBoundary: i,
    throwOnError: s.throwOnError,
    query: a.getQueryCache().get(s.queryHash),
    suspense: s.suspense
  }))
    throw f.error;
  return a.getDefaultOptions().queries?._experimental_afterQuery?.(
    s,
    f
  ), s.experimental_prefetchInRender && !wg && ahe(f, r) && (c ? (
    // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
    aB(s, d, i)
  ) : (
    // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
    a.getQueryCache().get(s.queryHash)?.promise
  ))?.catch(Ds).finally(() => {
    d.updateResult();
  }), s.notifyOnChangeProps ? f : d.trackResult(f);
}
function kh(t, e) {
  return DG(t, CG, e);
}
function she(t, e) {
  return process.env.NODE_ENV !== "production" && t.queryFn === XE && console.error("skipToken is not allowed for useSuspenseQuery"), DG(
    {
      ...t,
      enabled: !0,
      suspense: !0,
      throwOnError: rhe,
      placeholderData: void 0
    },
    CG,
    e
  );
}
function Ei(t, e) {
  const n = Ju(e), [r] = I.useState(
    () => new Gfe(
      n,
      t
    )
  );
  I.useEffect(() => {
    r.setOptions(t);
  }, [r, t]);
  const i = I.useSyncExternalStore(
    I.useCallback(
      (s) => r.subscribe(Ua.batchCalls(s)),
      [r]
    ),
    () => r.getCurrentResult(),
    () => r.getCurrentResult()
  ), a = I.useCallback(
    (s, c) => {
      r.mutate(s, c).catch(Ds);
    },
    [r]
  );
  if (i.error && xG(r.options.throwOnError, [i.error]))
    throw i.error;
  return { ...i, mutate: a, mutateAsync: i.mutate };
}
const NG = I.createContext(null), lhe = (t) => {
  const e = ve.c(3), {
    environment: n,
    children: r
  } = t;
  let i;
  return e[0] !== r || e[1] !== n ? (i = /* @__PURE__ */ C.jsx(NG.Provider, { value: n, children: r }), e[0] = r, e[1] = n, e[2] = i) : i = e[2], i;
}, nI = () => {
  const t = ve.c(1), e = I.useContext(NG);
  if (!e) {
    let n;
    return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = {
      mode: "dom",
      rootNode: document
    }, t[0] = n) : n = t[0], n;
  }
  return e;
}, MG = I.createContext(null), che = (t) => {
  const e = ve.c(6), {
    router: n,
    route: r,
    children: i
  } = t;
  let a;
  e[0] !== r || e[1] !== n ? (a = {
    router: n,
    route: r
  }, e[0] = r, e[1] = n, e[2] = a) : a = e[2];
  let s;
  return e[3] !== i || e[4] !== a ? (s = /* @__PURE__ */ C.jsx(MG.Provider, { value: a, children: i }), e[3] = i, e[4] = a, e[5] = s) : s = e[5], s;
}, uhe = (t) => t.metaKey || t.altKey || t.ctrlKey || t.shiftKey || t.button !== 0, IG = (t) => typeof window > "u" ? !0 : t.origin !== window.location.origin, dhe = (t) => t.pathname.startsWith("/auth/"), kG = () => {
  const t = ve.c(2), n = I.useContext(MG)?.router ?? null;
  let r;
  return t[0] !== n ? (r = (i, a) => {
    if (!(typeof window > "u")) {
      if (typeof i == "string") {
        const s = new URL(i, window.location.origin), c = IG(s);
        if (n && !c && !dhe(s)) {
          const d = {
            path: s.pathname + s.search + s.hash
          }, f = a?.replace ? "replace" : "push";
          n[f](d);
          return;
        }
        a?.replace ? window.location.replace(s.toString()) : window.location.assign(s.toString());
        return;
      }
      if (n) {
        const s = a?.replace ? "replace" : "push";
        n[s](i);
      }
    }
  }, t[0] = n, t[1] = r) : r = t[1], r;
}, fhe = (t) => {
  const e = ve.c(17), {
    to: n,
    replace: r,
    onClick: i,
    target: a,
    children: s,
    ...c
  } = t, d = kG(), f = Object.fromEntries(Object.entries(c).filter(hhe));
  let g;
  e[0] !== d || e[1] !== i || e[2] !== r || e[3] !== a || e[4] !== n ? (g = (w) => {
    if (i && i(w), !(w.defaultPrevented || uhe(w)) && !(a && a !== "_self") && !(typeof window > "u")) {
      if (typeof n == "string") {
        const _ = new URL(n, window.location.origin);
        if (IG(_))
          return;
      }
      w.preventDefault(), d(n, {
        replace: r
      });
    }
  }, e[0] = d, e[1] = i, e[2] = r, e[3] = a, e[4] = n, e[5] = g) : g = e[5];
  const m = g;
  if (typeof n != "string") {
    let w;
    return e[6] !== f || e[7] !== s || e[8] !== m || e[9] !== a ? (w = /* @__PURE__ */ C.jsx("a", { onClick: m, target: a, ...f, children: s }), e[6] = f, e[7] = s, e[8] = m, e[9] = a, e[10] = w) : w = e[10], w;
  }
  let b;
  return e[11] !== f || e[12] !== s || e[13] !== m || e[14] !== a || e[15] !== n ? (b = /* @__PURE__ */ C.jsx("a", { href: n, onClick: m, target: a, ...f, children: s }), e[11] = f, e[12] = s, e[13] = m, e[14] = a, e[15] = n, e[16] = b) : b = e[16], b;
};
function hhe(t) {
  const [e] = t;
  return !e.startsWith("$");
}
function phe(t) {
  if (!t || typeof document > "u")
    return;
  let e = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", e.appendChild(n), n.styleSheet ? n.styleSheet.cssText = t : n.appendChild(document.createTextNode(t));
}
const mhe = (t) => {
  switch (t) {
    case "success":
      return yhe;
    case "info":
      return whe;
    case "warning":
      return bhe;
    case "error":
      return xhe;
    default:
      return null;
  }
}, ghe = Array(12).fill(0), vhe = ({ visible: t, className: e }) => /* @__PURE__ */ De.createElement("div", {
  className: [
    "sonner-loading-wrapper",
    e
  ].filter(Boolean).join(" "),
  "data-visible": t
}, /* @__PURE__ */ De.createElement("div", {
  className: "sonner-spinner"
}, ghe.map((n, r) => /* @__PURE__ */ De.createElement("div", {
  className: "sonner-loading-bar",
  key: `spinner-bar-${r}`
})))), yhe = /* @__PURE__ */ De.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ De.createElement("path", {
  fillRule: "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  clipRule: "evenodd"
})), bhe = /* @__PURE__ */ De.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ De.createElement("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
})), whe = /* @__PURE__ */ De.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ De.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  clipRule: "evenodd"
})), xhe = /* @__PURE__ */ De.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ De.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  clipRule: "evenodd"
})), She = /* @__PURE__ */ De.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /* @__PURE__ */ De.createElement("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /* @__PURE__ */ De.createElement("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})), Ehe = () => {
  const [t, e] = De.useState(document.hidden);
  return De.useEffect(() => {
    const n = () => {
      e(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), t;
};
let C8 = 1;
class _he {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      const n = this.subscribers.indexOf(e);
      this.subscribers.splice(n, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((n) => n(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [
        ...this.toasts,
        e
      ];
    }, this.create = (e) => {
      var n;
      const { message: r, ...i } = e, a = typeof e?.id == "number" || ((n = e.id) == null ? void 0 : n.length) > 0 ? e.id : C8++, s = this.toasts.find((d) => d.id === a), c = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(a) && this.dismissedToasts.delete(a), s ? this.toasts = this.toasts.map((d) => d.id === a ? (this.publish({
        ...d,
        ...e,
        id: a,
        title: r
      }), {
        ...d,
        ...e,
        id: a,
        dismissible: c,
        title: r
      }) : d) : this.addToast({
        title: r,
        ...i,
        dismissible: c,
        id: a
      }), a;
    }, this.dismiss = (e) => (e ? (this.dismissedToasts.add(e), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: e,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((r) => r({
        id: n.id,
        dismiss: !0
      }));
    }), e), this.message = (e, n) => this.create({
      ...n,
      message: e
    }), this.error = (e, n) => this.create({
      ...n,
      message: e,
      type: "error"
    }), this.success = (e, n) => this.create({
      ...n,
      type: "success",
      message: e
    }), this.info = (e, n) => this.create({
      ...n,
      type: "info",
      message: e
    }), this.warning = (e, n) => this.create({
      ...n,
      type: "warning",
      message: e
    }), this.loading = (e, n) => this.create({
      ...n,
      type: "loading",
      message: e
    }), this.promise = (e, n) => {
      if (!n)
        return;
      let r;
      n.loading !== void 0 && (r = this.create({
        ...n,
        promise: e,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const i = Promise.resolve(e instanceof Function ? e() : e);
      let a = r !== void 0, s;
      const c = i.then(async (f) => {
        if (s = [
          "resolve",
          f
        ], De.isValidElement(f))
          a = !1, this.create({
            id: r,
            type: "default",
            message: f
          });
        else if (Che(f) && !f.ok) {
          a = !1;
          const m = typeof n.error == "function" ? await n.error(`HTTP error! status: ${f.status}`) : n.error, b = typeof n.description == "function" ? await n.description(`HTTP error! status: ${f.status}`) : n.description, _ = typeof m == "object" && !De.isValidElement(m) ? m : {
            message: m
          };
          this.create({
            id: r,
            type: "error",
            description: b,
            ..._
          });
        } else if (f instanceof Error) {
          a = !1;
          const m = typeof n.error == "function" ? await n.error(f) : n.error, b = typeof n.description == "function" ? await n.description(f) : n.description, _ = typeof m == "object" && !De.isValidElement(m) ? m : {
            message: m
          };
          this.create({
            id: r,
            type: "error",
            description: b,
            ..._
          });
        } else if (n.success !== void 0) {
          a = !1;
          const m = typeof n.success == "function" ? await n.success(f) : n.success, b = typeof n.description == "function" ? await n.description(f) : n.description, _ = typeof m == "object" && !De.isValidElement(m) ? m : {
            message: m
          };
          this.create({
            id: r,
            type: "success",
            description: b,
            ..._
          });
        }
      }).catch(async (f) => {
        if (s = [
          "reject",
          f
        ], n.error !== void 0) {
          a = !1;
          const g = typeof n.error == "function" ? await n.error(f) : n.error, m = typeof n.description == "function" ? await n.description(f) : n.description, w = typeof g == "object" && !De.isValidElement(g) ? g : {
            message: g
          };
          this.create({
            id: r,
            type: "error",
            description: m,
            ...w
          });
        }
      }).finally(() => {
        a && (this.dismiss(r), r = void 0), n.finally == null || n.finally.call(n);
      }), d = () => new Promise((f, g) => c.then(() => s[0] === "reject" ? g(s[1]) : f(s[1])).catch(g));
      return typeof r != "string" && typeof r != "number" ? {
        unwrap: d
      } : Object.assign(r, {
        unwrap: d
      });
    }, this.custom = (e, n) => {
      const r = n?.id || C8++;
      return this.create({
        jsx: e(r),
        id: r,
        ...n
      }), r;
    }, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}
const al = new _he(), Ahe = (t, e) => {
  const n = e?.id || C8++;
  return al.addToast({
    title: t,
    ...e,
    id: n
  }), n;
}, Che = (t) => t && typeof t == "object" && "ok" in t && typeof t.ok == "boolean" && "status" in t && typeof t.status == "number", The = Ahe, Ohe = () => al.toasts, Rhe = () => al.getActiveToasts(), R0 = Object.assign(The, {
  success: al.success,
  info: al.info,
  warning: al.warning,
  error: al.error,
  custom: al.custom,
  message: al.message,
  promise: al.promise,
  dismiss: al.dismiss,
  loading: al.loading
}, {
  getHistory: Ohe,
  getToasts: Rhe
});
phe("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function DC(t) {
  return t.label !== void 0;
}
const Dhe = 3, Nhe = "24px", Mhe = "16px", oB = 4e3, Ihe = 356, khe = 14, jhe = 45, Phe = 200;
function Fd(...t) {
  return t.filter(Boolean).join(" ");
}
function Lhe(t) {
  const [e, n] = t.split("-"), r = [];
  return e && r.push(e), n && r.push(n), r;
}
const Bhe = (t) => {
  var e, n, r, i, a, s, c, d, f;
  const { invert: g, toast: m, unstyled: b, interacting: w, setHeights: _, visibleToasts: A, heights: T, index: O, toasts: R, expanded: N, removeToast: M, defaultRichColors: P, closeButton: z, style: F, cancelButtonStyle: $, actionButtonStyle: G, className: H = "", descriptionClassName: Z = "", duration: V, position: Y, gap: ee, expandByDefault: K, classNames: U, icons: q, closeButtonAriaLabel: W = "Close toast" } = t, [ie, J] = De.useState(null), [B, te] = De.useState(null), [ae, le] = De.useState(!1), [de, _e] = De.useState(!1), [ue, Se] = De.useState(!1), [Ne, Me] = De.useState(!1), [Ce, Ue] = De.useState(!1), [rt, it] = De.useState(0), [Ft, wt] = De.useState(0), Ot = De.useRef(m.duration || V || oB), On = De.useRef(null), Ct = De.useRef(null), se = O === 0, ge = O + 1 <= A, Te = m.type, He = m.dismissible !== !1, $e = m.className || "", Ze = m.descriptionClassName || "", ct = De.useMemo(() => T.findIndex((Ke) => Ke.toastId === m.id) || 0, [
    T,
    m.id
  ]), Mt = De.useMemo(() => {
    var Ke;
    return (Ke = m.closeButton) != null ? Ke : z;
  }, [
    m.closeButton,
    z
  ]), Rt = De.useMemo(() => m.duration || V || oB, [
    m.duration,
    V
  ]), sn = De.useRef(0), In = De.useRef(0), hn = De.useRef(0), Wn = De.useRef(null), [ar, kn] = Y.split("-"), yr = De.useMemo(() => T.reduce((Ke, ut, ft) => ft >= ct ? Ke : Ke + ut.height, 0), [
    T,
    ct
  ]), or = Ehe(), sa = m.invert || g, re = Te === "loading";
  In.current = De.useMemo(() => ct * ee + yr, [
    ct,
    yr
  ]), De.useEffect(() => {
    Ot.current = Rt;
  }, [
    Rt
  ]), De.useEffect(() => {
    le(!0);
  }, []), De.useEffect(() => {
    const Ke = Ct.current;
    if (Ke) {
      const ut = Ke.getBoundingClientRect().height;
      return wt(ut), _((ft) => [
        {
          toastId: m.id,
          height: ut,
          position: m.position
        },
        ...ft
      ]), () => _((ft) => ft.filter((en) => en.toastId !== m.id));
    }
  }, [
    _,
    m.id
  ]), De.useLayoutEffect(() => {
    if (!ae)
      return;
    const Ke = Ct.current, ut = Ke.style.height;
    Ke.style.height = "auto";
    const ft = Ke.getBoundingClientRect().height;
    Ke.style.height = ut, wt(ft), _((en) => en.find((jn) => jn.toastId === m.id) ? en.map((jn) => jn.toastId === m.id ? {
      ...jn,
      height: ft
    } : jn) : [
      {
        toastId: m.id,
        height: ft,
        position: m.position
      },
      ...en
    ]);
  }, [
    ae,
    m.title,
    m.description,
    _,
    m.id,
    m.jsx,
    m.action,
    m.cancel
  ]);
  const Ae = De.useCallback(() => {
    _e(!0), it(In.current), _((Ke) => Ke.filter((ut) => ut.toastId !== m.id)), setTimeout(() => {
      M(m);
    }, Phe);
  }, [
    m,
    M,
    _,
    In
  ]);
  De.useEffect(() => {
    if (m.promise && Te === "loading" || m.duration === 1 / 0 || m.type === "loading")
      return;
    let Ke;
    return N || w || or ? (() => {
      if (hn.current < sn.current) {
        const en = (/* @__PURE__ */ new Date()).getTime() - sn.current;
        Ot.current = Ot.current - en;
      }
      hn.current = (/* @__PURE__ */ new Date()).getTime();
    })() : (() => {
      Ot.current !== 1 / 0 && (sn.current = (/* @__PURE__ */ new Date()).getTime(), Ke = setTimeout(() => {
        m.onAutoClose == null || m.onAutoClose.call(m, m), Ae();
      }, Ot.current));
    })(), () => clearTimeout(Ke);
  }, [
    N,
    w,
    m,
    Te,
    or,
    Ae
  ]), De.useEffect(() => {
    m.delete && (Ae(), m.onDismiss == null || m.onDismiss.call(m, m));
  }, [
    Ae,
    m.delete
  ]);
  function nt() {
    var Ke;
    if (q?.loading) {
      var ut;
      return /* @__PURE__ */ De.createElement("div", {
        className: Fd(U?.loader, m == null || (ut = m.classNames) == null ? void 0 : ut.loader, "sonner-loader"),
        "data-visible": Te === "loading"
      }, q.loading);
    }
    return /* @__PURE__ */ De.createElement(vhe, {
      className: Fd(U?.loader, m == null || (Ke = m.classNames) == null ? void 0 : Ke.loader),
      visible: Te === "loading"
    });
  }
  const st = m.icon || q?.[Te] || mhe(Te);
  var lt, bt;
  return /* @__PURE__ */ De.createElement("li", {
    tabIndex: 0,
    ref: Ct,
    className: Fd(H, $e, U?.toast, m == null || (e = m.classNames) == null ? void 0 : e.toast, U?.default, U?.[Te], m == null || (n = m.classNames) == null ? void 0 : n[Te]),
    "data-sonner-toast": "",
    "data-rich-colors": (lt = m.richColors) != null ? lt : P,
    "data-styled": !(m.jsx || m.unstyled || b),
    "data-mounted": ae,
    "data-promise": !!m.promise,
    "data-swiped": Ce,
    "data-removed": de,
    "data-visible": ge,
    "data-y-position": ar,
    "data-x-position": kn,
    "data-index": O,
    "data-front": se,
    "data-swiping": ue,
    "data-dismissible": He,
    "data-type": Te,
    "data-invert": sa,
    "data-swipe-out": Ne,
    "data-swipe-direction": B,
    "data-expanded": !!(N || K && ae),
    "data-testid": m.testId,
    style: {
      "--index": O,
      "--toasts-before": O,
      "--z-index": R.length - O,
      "--offset": `${de ? rt : In.current}px`,
      "--initial-height": K ? "auto" : `${Ft}px`,
      ...F,
      ...m.style
    },
    onDragEnd: () => {
      Se(!1), J(null), Wn.current = null;
    },
    onPointerDown: (Ke) => {
      Ke.button !== 2 && (re || !He || (On.current = /* @__PURE__ */ new Date(), it(In.current), Ke.target.setPointerCapture(Ke.pointerId), Ke.target.tagName !== "BUTTON" && (Se(!0), Wn.current = {
        x: Ke.clientX,
        y: Ke.clientY
      })));
    },
    onPointerUp: () => {
      var Ke, ut, ft;
      if (Ne || !He)
        return;
      Wn.current = null;
      const en = Number(((Ke = Ct.current) == null ? void 0 : Ke.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), sr = Number(((ut = Ct.current) == null ? void 0 : ut.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), jn = (/* @__PURE__ */ new Date()).getTime() - ((ft = On.current) == null ? void 0 : ft.getTime()), vn = ie === "x" ? en : sr, Ai = Math.abs(vn) / jn;
      if (Math.abs(vn) >= jhe || Ai > 0.11) {
        it(In.current), m.onDismiss == null || m.onDismiss.call(m, m), te(ie === "x" ? en > 0 ? "right" : "left" : sr > 0 ? "down" : "up"), Ae(), Me(!0);
        return;
      } else {
        var Un, tn;
        (Un = Ct.current) == null || Un.style.setProperty("--swipe-amount-x", "0px"), (tn = Ct.current) == null || tn.style.setProperty("--swipe-amount-y", "0px");
      }
      Ue(!1), Se(!1), J(null);
    },
    onPointerMove: (Ke) => {
      var ut, ft, en;
      if (!Wn.current || !He || ((ut = window.getSelection()) == null ? void 0 : ut.toString().length) > 0)
        return;
      const jn = Ke.clientY - Wn.current.y, vn = Ke.clientX - Wn.current.x;
      var Ai;
      const Un = (Ai = t.swipeDirections) != null ? Ai : Lhe(Y);
      !ie && (Math.abs(vn) > 1 || Math.abs(jn) > 1) && J(Math.abs(vn) > Math.abs(jn) ? "x" : "y");
      let tn = {
        x: 0,
        y: 0
      };
      const $i = (Hi) => 1 / (1.5 + Math.abs(Hi) / 20);
      if (ie === "y") {
        if (Un.includes("top") || Un.includes("bottom"))
          if (Un.includes("top") && jn < 0 || Un.includes("bottom") && jn > 0)
            tn.y = jn;
          else {
            const Hi = jn * $i(jn);
            tn.y = Math.abs(Hi) < Math.abs(jn) ? Hi : jn;
          }
      } else if (ie === "x" && (Un.includes("left") || Un.includes("right")))
        if (Un.includes("left") && vn < 0 || Un.includes("right") && vn > 0)
          tn.x = vn;
        else {
          const Hi = vn * $i(vn);
          tn.x = Math.abs(Hi) < Math.abs(vn) ? Hi : vn;
        }
      (Math.abs(tn.x) > 0 || Math.abs(tn.y) > 0) && Ue(!0), (ft = Ct.current) == null || ft.style.setProperty("--swipe-amount-x", `${tn.x}px`), (en = Ct.current) == null || en.style.setProperty("--swipe-amount-y", `${tn.y}px`);
    }
  }, Mt && !m.jsx && Te !== "loading" ? /* @__PURE__ */ De.createElement("button", {
    "aria-label": W,
    "data-disabled": re,
    "data-close-button": !0,
    onClick: re || !He ? () => {
    } : () => {
      Ae(), m.onDismiss == null || m.onDismiss.call(m, m);
    },
    className: Fd(U?.closeButton, m == null || (r = m.classNames) == null ? void 0 : r.closeButton)
  }, (bt = q?.close) != null ? bt : She) : null, (Te || m.icon || m.promise) && m.icon !== null && (q?.[Te] !== null || m.icon) ? /* @__PURE__ */ De.createElement("div", {
    "data-icon": "",
    className: Fd(U?.icon, m == null || (i = m.classNames) == null ? void 0 : i.icon)
  }, m.promise || m.type === "loading" && !m.icon ? m.icon || nt() : null, m.type !== "loading" ? st : null) : null, /* @__PURE__ */ De.createElement("div", {
    "data-content": "",
    className: Fd(U?.content, m == null || (a = m.classNames) == null ? void 0 : a.content)
  }, /* @__PURE__ */ De.createElement("div", {
    "data-title": "",
    className: Fd(U?.title, m == null || (s = m.classNames) == null ? void 0 : s.title)
  }, m.jsx ? m.jsx : typeof m.title == "function" ? m.title() : m.title), m.description ? /* @__PURE__ */ De.createElement("div", {
    "data-description": "",
    className: Fd(Z, Ze, U?.description, m == null || (c = m.classNames) == null ? void 0 : c.description)
  }, typeof m.description == "function" ? m.description() : m.description) : null), /* @__PURE__ */ De.isValidElement(m.cancel) ? m.cancel : m.cancel && DC(m.cancel) ? /* @__PURE__ */ De.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: m.cancelButtonStyle || $,
    onClick: (Ke) => {
      DC(m.cancel) && He && (m.cancel.onClick == null || m.cancel.onClick.call(m.cancel, Ke), Ae());
    },
    className: Fd(U?.cancelButton, m == null || (d = m.classNames) == null ? void 0 : d.cancelButton)
  }, m.cancel.label) : null, /* @__PURE__ */ De.isValidElement(m.action) ? m.action : m.action && DC(m.action) ? /* @__PURE__ */ De.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: m.actionButtonStyle || G,
    onClick: (Ke) => {
      DC(m.action) && (m.action.onClick == null || m.action.onClick.call(m.action, Ke), !Ke.defaultPrevented && Ae());
    },
    className: Fd(U?.actionButton, m == null || (f = m.classNames) == null ? void 0 : f.actionButton)
  }, m.action.label) : null);
};
function sB() {
  if (typeof window > "u" || typeof document > "u")
    return "ltr";
  const t = document.documentElement.getAttribute("dir");
  return t === "auto" || !t ? window.getComputedStyle(document.documentElement).direction : t;
}
function zhe(t, e) {
  const n = {};
  return [
    t,
    e
  ].forEach((r, i) => {
    const a = i === 1, s = a ? "--mobile-offset" : "--offset", c = a ? Mhe : Nhe;
    function d(f) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((g) => {
        n[`${s}-${g}`] = typeof f == "number" ? `${f}px` : f;
      });
    }
    typeof r == "number" || typeof r == "string" ? d(r) : typeof r == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((f) => {
      r[f] === void 0 ? n[`${s}-${f}`] = c : n[`${s}-${f}`] = typeof r[f] == "number" ? `${r[f]}px` : r[f];
    }) : d(c);
  }), n;
}
const Fhe = /* @__PURE__ */ De.forwardRef(function(e, n) {
  const { id: r, invert: i, position: a = "bottom-right", hotkey: s = [
    "altKey",
    "KeyT"
  ], expand: c, closeButton: d, className: f, offset: g, mobileOffset: m, theme: b = "light", richColors: w, duration: _, style: A, visibleToasts: T = Dhe, toastOptions: O, dir: R = sB(), gap: N = khe, icons: M, containerAriaLabel: P = "Notifications" } = e, [z, F] = De.useState([]), $ = De.useMemo(() => r ? z.filter((ae) => ae.toasterId === r) : z.filter((ae) => !ae.toasterId), [
    z,
    r
  ]), G = De.useMemo(() => Array.from(new Set([
    a
  ].concat($.filter((ae) => ae.position).map((ae) => ae.position)))), [
    $,
    a
  ]), [H, Z] = De.useState([]), [V, Y] = De.useState(!1), [ee, K] = De.useState(!1), [U, q] = De.useState(b !== "system" ? b : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), W = De.useRef(null), ie = s.join("+").replace(/Key/g, "").replace(/Digit/g, ""), J = De.useRef(null), B = De.useRef(!1), te = De.useCallback((ae) => {
    F((le) => {
      var de;
      return (de = le.find((_e) => _e.id === ae.id)) != null && de.delete || al.dismiss(ae.id), le.filter(({ id: _e }) => _e !== ae.id);
    });
  }, []);
  return De.useEffect(() => al.subscribe((ae) => {
    if (ae.dismiss) {
      requestAnimationFrame(() => {
        F((le) => le.map((de) => de.id === ae.id ? {
          ...de,
          delete: !0
        } : de));
      });
      return;
    }
    setTimeout(() => {
      $H.flushSync(() => {
        F((le) => {
          const de = le.findIndex((_e) => _e.id === ae.id);
          return de !== -1 ? [
            ...le.slice(0, de),
            {
              ...le[de],
              ...ae
            },
            ...le.slice(de + 1)
          ] : [
            ae,
            ...le
          ];
        });
      });
    });
  }), [
    z
  ]), De.useEffect(() => {
    if (b !== "system") {
      q(b);
      return;
    }
    if (b === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? q("dark") : q("light")), typeof window > "u")
      return;
    const ae = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      ae.addEventListener("change", ({ matches: le }) => {
        q(le ? "dark" : "light");
      });
    } catch {
      ae.addListener(({ matches: de }) => {
        try {
          q(de ? "dark" : "light");
        } catch (_e) {
          console.error(_e);
        }
      });
    }
  }, [
    b
  ]), De.useEffect(() => {
    z.length <= 1 && Y(!1);
  }, [
    z
  ]), De.useEffect(() => {
    const ae = (le) => {
      var de;
      if (s.every((Se) => le[Se] || le.code === Se)) {
        var ue;
        Y(!0), (ue = W.current) == null || ue.focus();
      }
      le.code === "Escape" && (document.activeElement === W.current || (de = W.current) != null && de.contains(document.activeElement)) && Y(!1);
    };
    return document.addEventListener("keydown", ae), () => document.removeEventListener("keydown", ae);
  }, [
    s
  ]), De.useEffect(() => {
    if (W.current)
      return () => {
        J.current && (J.current.focus({
          preventScroll: !0
        }), J.current = null, B.current = !1);
      };
  }, [
    W.current
  ]), // Remove item from normal navigation flow, only available via hotkey
  /* @__PURE__ */ De.createElement("section", {
    ref: n,
    "aria-label": `${P} ${ie}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, G.map((ae, le) => {
    var de;
    const [_e, ue] = ae.split("-");
    return $.length ? /* @__PURE__ */ De.createElement("ol", {
      key: ae,
      dir: R === "auto" ? sB() : R,
      tabIndex: -1,
      ref: W,
      className: f,
      "data-sonner-toaster": !0,
      "data-sonner-theme": U,
      "data-y-position": _e,
      "data-x-position": ue,
      style: {
        "--front-toast-height": `${((de = H[0]) == null ? void 0 : de.height) || 0}px`,
        "--width": `${Ihe}px`,
        "--gap": `${N}px`,
        ...A,
        ...zhe(g, m)
      },
      onBlur: (Se) => {
        B.current && !Se.currentTarget.contains(Se.relatedTarget) && (B.current = !1, J.current && (J.current.focus({
          preventScroll: !0
        }), J.current = null));
      },
      onFocus: (Se) => {
        Se.target instanceof HTMLElement && Se.target.dataset.dismissible === "false" || B.current || (B.current = !0, J.current = Se.relatedTarget);
      },
      onMouseEnter: () => Y(!0),
      onMouseMove: () => Y(!0),
      onMouseLeave: () => {
        ee || Y(!1);
      },
      onDragEnd: () => Y(!1),
      onPointerDown: (Se) => {
        Se.target instanceof HTMLElement && Se.target.dataset.dismissible === "false" || K(!0);
      },
      onPointerUp: () => K(!1)
    }, $.filter((Se) => !Se.position && le === 0 || Se.position === ae).map((Se, Ne) => {
      var Me, Ce;
      return /* @__PURE__ */ De.createElement(Bhe, {
        key: Se.id,
        icons: M,
        index: Ne,
        toast: Se,
        defaultRichColors: w,
        duration: (Me = O?.duration) != null ? Me : _,
        className: O?.className,
        descriptionClassName: O?.descriptionClassName,
        invert: i,
        visibleToasts: T,
        closeButton: (Ce = O?.closeButton) != null ? Ce : d,
        interacting: ee,
        position: ae,
        style: O?.style,
        unstyled: O?.unstyled,
        classNames: O?.classNames,
        cancelButtonStyle: O?.cancelButtonStyle,
        actionButtonStyle: O?.actionButtonStyle,
        closeButtonAriaLabel: O?.closeButtonAriaLabel,
        removeToast: te,
        toasts: $.filter((Ue) => Ue.position == Se.position),
        heights: H.filter((Ue) => Ue.position == Se.position),
        setHeights: Z,
        expandByDefault: c,
        gap: N,
        expanded: V,
        swipeDirections: e.swipeDirections
      });
    })) : null;
  }));
}), Vhe = new Xfe(), Uhe = (t) => {
  const e = ve.c(10), {
    environment: n,
    router: r,
    route: i,
    children: a
  } = t, s = r ?? null, c = i ?? null;
  let d;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (d = /* @__PURE__ */ C.jsx(Fhe, { position: "top-right", richColors: !0, expand: !0 }), e[0] = d) : d = e[0];
  let f;
  e[1] !== a ? (f = /* @__PURE__ */ C.jsx(Xhe, { children: /* @__PURE__ */ C.jsxs("div", { className: "App frontend-v2", children: [
    a,
    d
  ] }) }), e[1] = a, e[2] = f) : f = e[2];
  let g;
  e[3] !== s || e[4] !== c || e[5] !== f ? (g = /* @__PURE__ */ C.jsx(che, { router: s, route: c, children: f }), e[3] = s, e[4] = c, e[5] = f, e[6] = g) : g = e[6];
  let m;
  return e[7] !== n || e[8] !== g ? (m = /* @__PURE__ */ C.jsx(Wfe, { client: Vhe, children: /* @__PURE__ */ C.jsx(lhe, { environment: n, children: g }) }), e[7] = n, e[8] = g, e[9] = m) : m = e[9], m;
}, $he = `*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:PT Sans,Helvetica,Verdana,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}.twd-container{width:100%}@media (min-width: 440px){.twd-container{max-width:440px}}@media (min-width: 575px){.twd-container{max-width:575px}}@media (min-width: 767px){.twd-container{max-width:767px}}@media (min-width: 1024px){.twd-container{max-width:1024px}}@media (min-width: 1200px){.twd-container{max-width:1200px}}.twd-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.twd-pointer-events-none{pointer-events:none}.twd-pointer-events-auto{pointer-events:auto}.twd-visible{visibility:visible}.twd-invisible{visibility:hidden}.twd-fixed{position:fixed}.twd-absolute{position:absolute}.twd-relative{position:relative}.twd-sticky{position:sticky}.twd-inset-0{inset:0}.twd-inset-x-0{left:0;right:0}.twd-inset-x-1{left:.25rem;right:.25rem}.twd-inset-y-0{top:0;bottom:0}.twd-inset-y-1{top:.25rem;bottom:.25rem}.-twd-left-\\[10px\\]{left:-10px}.-twd-right-\\[10px\\]{right:-10px}.-twd-top-2{top:-.5rem}.twd-bottom-0{bottom:0}.twd-bottom-5{bottom:1.25rem}.twd-left-0{left:0}.twd-left-1\\/2{left:50%}.twd-left-3{left:.75rem}.twd-left-\\[50\\%\\]{left:50%}.twd-left-px{left:1px}.twd-right-0{right:0}.twd-right-4{right:1rem}.twd-right-5{right:1.25rem}.twd-top-0{top:0}.twd-top-1\\/2{top:50%}.twd-top-2{top:.5rem}.twd-top-4{top:1rem}.twd-top-\\[50\\%\\]{top:50%}.twd-z-0{z-index:0}.twd-z-10{z-index:1100}.twd-z-20{z-index:1200}.twd-z-50{z-index:1500}.twd-z-9{z-index:901}.twd-m-0{margin:0}.twd-m-3{margin:.75rem}.twd-mx-auto{margin-left:auto;margin-right:auto}.twd-my-2{margin-top:.5rem;margin-bottom:.5rem}.twd-my-4{margin-top:1rem;margin-bottom:1rem}.twd-my-auto{margin-top:auto;margin-bottom:auto}.twd-mb-1{margin-bottom:.25rem}.twd-mb-2{margin-bottom:.5rem}.twd-mb-4{margin-bottom:1rem}.twd-mb-\\[5px\\]{margin-bottom:5px}.twd-ml-0\\.5{margin-left:.125rem}.twd-ml-1{margin-left:.25rem}.twd-ml-2{margin-left:.5rem}.twd-ml-auto{margin-left:auto}.twd-mr-1{margin-right:.25rem}.twd-mr-2{margin-right:.5rem}.twd-mt-2{margin-top:.5rem}.twd-mt-3{margin-top:.75rem}.twd-mt-4{margin-top:1rem}.twd-mt-6{margin-top:1.5rem}.twd-block{display:block}.twd-inline-block{display:inline-block}.twd-inline{display:inline}.twd-flex{display:flex}.twd-inline-flex{display:inline-flex}.twd-grid{display:grid}.twd-hidden{display:none}.twd-aspect-square{aspect-ratio:1 / 1}.twd-h-0\\.5{height:.125rem}.twd-h-10{height:2.5rem}.twd-h-11{height:2.75rem}.twd-h-12{height:3rem}.twd-h-14{height:54px}.twd-h-2{height:.5rem}.twd-h-2\\.5{height:.625rem}.twd-h-4{height:1rem}.twd-h-5{height:1.25rem}.twd-h-7{height:1.75rem}.twd-h-8{height:2rem}.twd-h-9{height:2.25rem}.twd-h-\\[10px\\]{height:10px}.twd-h-\\[300px\\]{height:300px}.twd-h-\\[34px\\]{height:34px}.twd-h-\\[42px\\]{height:42px}.twd-h-\\[58\\.8px\\]{height:58.8px}.twd-h-\\[58px\\]{height:58px}.twd-h-auto{height:auto}.twd-h-fit{height:-moz-fit-content;height:fit-content}.twd-h-full{height:100%}.twd-h-px{height:1px}.twd-max-h-52{max-height:13rem}.twd-min-h-12{min-height:3rem}.twd-min-h-16{min-height:4rem}.twd-min-h-20{min-height:5rem}.twd-min-h-64{min-height:16rem}.twd-min-h-7{min-height:1.75rem}.twd-min-h-96{min-height:24rem}.twd-min-h-\\[34px\\]{min-height:34px}.twd-min-h-full{min-height:100%}.twd-w-10{width:2.5rem}.twd-w-11\\/12{width:91.666667%}.twd-w-14{width:54px}.twd-w-2\\.5{width:.625rem}.twd-w-3\\/4{width:75%}.twd-w-4{width:1rem}.twd-w-48{width:12rem}.twd-w-5{width:1.25rem}.twd-w-8{width:2rem}.twd-w-80{width:20rem}.twd-w-\\[10px\\]{width:10px}.twd-w-\\[96px\\]{width:96px}.twd-w-auto{width:auto}.twd-w-fit{width:-moz-fit-content;width:fit-content}.twd-w-full{width:100%}.twd-w-max{width:-moz-max-content;width:max-content}.twd-w-px{width:1px}.twd-min-w-0{min-width:0px}.twd-min-w-10{min-width:2.5rem}.twd-min-w-11{min-width:2.75rem}.twd-min-w-64{min-width:16rem}.twd-min-w-9{min-width:2.25rem}.twd-min-w-\\[240px\\]{min-width:240px}.twd-min-w-\\[320px\\]{min-width:320px}.twd-min-w-\\[80px\\]{min-width:80px}.twd-min-w-\\[90px\\]{min-width:90px}.twd-min-w-full{min-width:100%}.twd-max-w-2xl{max-width:42rem}.twd-max-w-\\[300px\\]{max-width:300px}.twd-max-w-\\[45\\%\\]{max-width:45%}.twd-max-w-full{max-width:100%}.twd-max-w-lg{max-width:32rem}.twd-max-w-md{max-width:28rem}.twd-max-w-screen-lg{max-width:1024px}.twd-max-w-xl{max-width:36rem}.twd-max-w-xs{max-width:20rem}.twd-flex-1{flex:1 1 0%}.twd-flex-none{flex:none}.twd-flex-shrink-0,.twd-shrink-0{flex-shrink:0}.twd-caption-bottom{caption-side:bottom}.twd-origin-left{transform-origin:left}.-twd-translate-x-1\\/2{--tw-translate-x: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-twd-translate-y-1\\/2{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.twd--translate-x-1\\/2{--tw-translate-x: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.twd--translate-y-1\\/2{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.twd-translate-x-\\[-50\\%\\]{--tw-translate-x: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.twd-translate-y-\\[-50\\%\\]{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-twd-scale-x-100{--tw-scale-x: -1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.twd-transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.twd-cursor-default{cursor:default}.twd-cursor-move{cursor:move}.twd-cursor-not-allowed{cursor:not-allowed}.twd-cursor-pointer{cursor:pointer}.twd-cursor-wait{cursor:wait}.twd-touch-none{touch-action:none}.twd-select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.twd-resize-none{resize:none}.twd-appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.twd-flex-row{flex-direction:row}.twd-flex-col{flex-direction:column}.twd-flex-col-reverse{flex-direction:column-reverse}.twd-flex-wrap{flex-wrap:wrap}.twd-place-content-center{place-content:center}.twd-items-start{align-items:flex-start}.twd-items-end{align-items:flex-end}.twd-items-center{align-items:center}.twd-items-stretch{align-items:stretch}.twd-justify-start{justify-content:flex-start}.twd-justify-end{justify-content:flex-end}.twd-justify-center{justify-content:center}.twd-justify-between{justify-content:space-between}.twd-gap-0{gap:0px}.twd-gap-1{gap:.25rem}.twd-gap-2{gap:.5rem}.twd-gap-3{gap:.75rem}.twd-gap-4{gap:1rem}.twd-space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * calc(1 - var(--tw-space-x-reverse)))}.twd-space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * calc(1 - var(--tw-space-x-reverse)))}.twd-space-y-1>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.25rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.25rem * var(--tw-space-y-reverse))}.twd-space-y-1\\.5>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.375rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.375rem * var(--tw-space-y-reverse))}.twd-space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.twd-space-y-3>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.75rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.75rem * var(--tw-space-y-reverse))}.twd-space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem * var(--tw-space-y-reverse))}.twd-space-y-5>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.25rem * var(--tw-space-y-reverse))}.twd-space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.5rem * var(--tw-space-y-reverse))}.twd-self-center{align-self:center}.twd-overflow-auto{overflow:auto}.twd-overflow-hidden{overflow:hidden}.twd-overflow-x-auto{overflow-x:auto}.twd-overflow-y-auto{overflow-y:auto}.twd-overflow-x-hidden{overflow-x:hidden}.twd-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.twd-whitespace-nowrap{white-space:nowrap}.twd-break-words{overflow-wrap:break-word}.twd-break-all{word-break:break-all}.twd-rounded{border-radius:.25rem}.twd-rounded-\\[inherit\\]{border-radius:inherit}.twd-rounded-full{border-radius:9999px}.twd-rounded-lg{border-radius:var(--radius)}.twd-rounded-md{border-radius:calc(var(--radius) - 2px)}.twd-rounded-sm{border-radius:calc(var(--radius) - 4px)}.twd-rounded-t-lg{border-top-left-radius:var(--radius);border-top-right-radius:var(--radius)}.twd-border{border-width:1px}.twd-border-0{border-width:0px}.twd-border-2{border-width:2px}.twd-border-b,.twd-border-b-1{border-bottom-width:1px}.twd-border-l{border-left-width:1px}.twd-border-l-4{border-left-width:4px}.twd-border-r{border-right-width:1px}.twd-border-t{border-top-width:1px}.twd-border-dashed{border-style:dashed}.twd-border-none{border-style:none}.twd-border-border{border-color:hsl(var(--border))}.twd-border-error{--tw-border-opacity: 1;border-color:rgb(234 24 0 / var(--tw-border-opacity, 1))}.twd-border-error\\/20{border-color:#ea180033}.twd-border-info{--tw-border-opacity: 1;border-color:rgb(1 153 179 / var(--tw-border-opacity, 1))}.twd-border-input{border-color:hsl(var(--input))}.twd-border-secondary{--tw-border-opacity: 1;border-color:rgb(119 119 119 / var(--tw-border-opacity, 1))}.twd-border-secondary-light{--tw-border-opacity: 1;border-color:rgb(217 216 216 / var(--tw-border-opacity, 1))}.twd-border-secondary-light2{--tw-border-opacity: 1;border-color:rgb(233 233 233 / var(--tw-border-opacity, 1))}.twd-border-success{--tw-border-opacity: 1;border-color:rgb(94 202 0 / var(--tw-border-opacity, 1))}.twd-border-transparent{border-color:transparent}.twd-border-warning{--tw-border-opacity: 1;border-color:rgb(230 173 0 / var(--tw-border-opacity, 1))}.twd-border-b-secondary-light{--tw-border-opacity: 1;border-bottom-color:rgb(217 216 216 / var(--tw-border-opacity, 1))}.twd-border-b-transparent{border-bottom-color:transparent}.twd-border-l-error{--tw-border-opacity: 1;border-left-color:rgb(234 24 0 / var(--tw-border-opacity, 1))}.twd-border-l-info{--tw-border-opacity: 1;border-left-color:rgb(1 153 179 / var(--tw-border-opacity, 1))}.twd-border-l-success{--tw-border-opacity: 1;border-left-color:rgb(94 202 0 / var(--tw-border-opacity, 1))}.twd-border-l-transparent{border-left-color:transparent}.twd-border-l-warning{--tw-border-opacity: 1;border-left-color:rgb(230 173 0 / var(--tw-border-opacity, 1))}.twd-border-t-secondary-light{--tw-border-opacity: 1;border-top-color:rgb(217 216 216 / var(--tw-border-opacity, 1))}.twd-border-t-transparent{border-top-color:transparent}.twd-bg-\\[\\#ffeccc\\]{--tw-bg-opacity: 1;background-color:rgb(255 236 204 / var(--tw-bg-opacity, 1))}.twd-bg-\\[rgba\\(255\\,255\\,255\\,0\\.9\\)\\]{background-color:#ffffffe6}.twd-bg-background{background-color:hsl(var(--background))}.twd-bg-black\\/80{background-color:#000c}.twd-bg-border{background-color:hsl(var(--border))}.twd-bg-destructive{background-color:hsl(var(--destructive))}.twd-bg-destructive\\/10{background-color:hsl(var(--destructive) / .1)}.twd-bg-error{--tw-bg-opacity: 1;background-color:rgb(234 24 0 / var(--tw-bg-opacity, 1))}.twd-bg-error-light2{--tw-bg-opacity: 1;background-color:rgb(255 230 236 / var(--tw-bg-opacity, 1))}.twd-bg-info{--tw-bg-opacity: 1;background-color:rgb(1 153 179 / var(--tw-bg-opacity, 1))}.twd-bg-info\\/10{background-color:#0199b31a}.twd-bg-muted\\/5{background-color:hsl(var(--muted) / .05)}.twd-bg-muted\\/50{background-color:hsl(var(--muted) / .5)}.twd-bg-popover{background-color:hsl(var(--popover))}.twd-bg-primary{--tw-bg-opacity: 1;background-color:rgb(42 76 255 / var(--tw-bg-opacity, 1))}.twd-bg-primary-dark{--tw-bg-opacity: 1;background-color:rgb(18 36 129 / var(--tw-bg-opacity, 1))}.twd-bg-primary-light2{--tw-bg-opacity: 1;background-color:rgb(188 196 252 / var(--tw-bg-opacity, 1))}.twd-bg-process{--tw-bg-opacity: 1;background-color:rgb(255 8 214 / var(--tw-bg-opacity, 1))}.twd-bg-secondary{--tw-bg-opacity: 1;background-color:rgb(119 119 119 / var(--tw-bg-opacity, 1))}.twd-bg-secondary-light{--tw-bg-opacity: 1;background-color:rgb(217 216 216 / var(--tw-bg-opacity, 1))}.twd-bg-secondary-light2{--tw-bg-opacity: 1;background-color:rgb(233 233 233 / var(--tw-bg-opacity, 1))}.twd-bg-secondary-light3{--tw-bg-opacity: 1;background-color:rgb(244 244 244 / var(--tw-bg-opacity, 1))}.twd-bg-secondary-light4{--tw-bg-opacity: 1;background-color:rgb(248 248 248 / var(--tw-bg-opacity, 1))}.twd-bg-secondary\\/30{background-color:#7777774d}.twd-bg-success{--tw-bg-opacity: 1;background-color:rgb(94 202 0 / var(--tw-bg-opacity, 1))}.twd-bg-success\\/10{background-color:#5eca001a}.twd-bg-transparent{background-color:transparent}.twd-bg-warning{--tw-bg-opacity: 1;background-color:rgb(230 173 0 / var(--tw-bg-opacity, 1))}.twd-bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.twd-bg-opacity-10{--tw-bg-opacity: .1}.twd-object-contain{-o-object-fit:contain;object-fit:contain}.twd-object-cover{-o-object-fit:cover;object-fit:cover}.twd-p-0{padding:0}.twd-p-1{padding:.25rem}.twd-p-2{padding:.5rem}.twd-p-3{padding:.75rem}.twd-p-4{padding:1rem}.twd-p-6{padding:1.5rem}.twd-p-\\[1px\\]{padding:1px}.twd-px-0{padding-left:0;padding-right:0}.twd-px-1{padding-left:.25rem;padding-right:.25rem}.twd-px-2{padding-left:.5rem;padding-right:.5rem}.twd-px-2\\.5{padding-left:.625rem;padding-right:.625rem}.twd-px-3{padding-left:.75rem;padding-right:.75rem}.twd-px-4{padding-left:1rem;padding-right:1rem}.twd-px-5{padding-left:1.25rem;padding-right:1.25rem}.twd-px-6{padding-left:1.5rem;padding-right:1.5rem}.twd-px-8{padding-left:2rem;padding-right:2rem}.twd-px-\\[10px\\]{padding-left:10px;padding-right:10px}.twd-py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.twd-py-1{padding-top:.25rem;padding-bottom:.25rem}.twd-py-2{padding-top:.5rem;padding-bottom:.5rem}.twd-py-3{padding-top:.75rem;padding-bottom:.75rem}.twd-py-4{padding-top:1rem;padding-bottom:1rem}.twd-py-8{padding-top:2rem;padding-bottom:2rem}.twd-pb-1\\.5{padding-bottom:.375rem}.twd-pb-2{padding-bottom:.5rem}.twd-pb-4{padding-bottom:1rem}.twd-pb-6{padding-bottom:1.5rem}.twd-pl-1{padding-left:.25rem}.twd-pr-2{padding-right:.5rem}.twd-pt-0{padding-top:0}.twd-pt-2{padding-top:.5rem}.twd-pt-3{padding-top:.75rem}.twd-pt-4{padding-top:1rem}.twd-pt-\\[1px\\]{padding-top:1px}.twd-text-left{text-align:left}.twd-text-center{text-align:center}.twd-text-right{text-align:right}.twd-indent-0{text-indent:0px}.twd-align-middle{vertical-align:middle}.twd-align-bottom{vertical-align:bottom}.twd-align-text-bottom{vertical-align:text-bottom}.twd-text-2xl{font-size:2rem;line-height:2.4rem}.twd-text-\\[11px\\]{font-size:11px}.twd-text-\\[12px\\]{font-size:12px}.twd-text-base{font-size:.8125rem;line-height:1.05625rem}.twd-text-lg{font-size:1.0625rem;line-height:1.38125rem}.twd-text-xl{font-size:1.375rem;line-height:1.65rem}.twd-font-bold{font-weight:700}.twd-font-medium{font-weight:500}.twd-font-normal{font-weight:400}.twd-font-semibold{font-weight:600}.twd-uppercase{text-transform:uppercase}.twd-italic{font-style:italic}.twd-leading-none{line-height:1}.twd-tracking-tight{letter-spacing:-.025em}.twd-text-current{color:currentColor}.twd-text-destructive-foreground{color:hsl(var(--destructive-foreground))}.twd-text-error{--tw-text-opacity: 1;color:rgb(234 24 0 / var(--tw-text-opacity, 1))}.twd-text-error-contrast{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.twd-text-error-dark{--tw-text-opacity: 1;color:rgb(153 13 57 / var(--tw-text-opacity, 1))}.twd-text-foreground{color:hsl(var(--foreground))}.twd-text-info{--tw-text-opacity: 1;color:rgb(1 153 179 / var(--tw-text-opacity, 1))}.twd-text-info-contrast{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.twd-text-muted-foreground{color:hsl(var(--muted-foreground))}.twd-text-popover-foreground{color:hsl(var(--popover-foreground))}.twd-text-primary{--tw-text-opacity: 1;color:rgb(42 76 255 / var(--tw-text-opacity, 1))}.twd-text-primary-contrast{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.twd-text-primary-foreground{color:hsl(var(--primary-foreground))}.twd-text-secondary{--tw-text-opacity: 1;color:rgb(119 119 119 / var(--tw-text-opacity, 1))}.twd-text-secondary-contrast{--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity, 1))}.twd-text-success{--tw-text-opacity: 1;color:rgb(94 202 0 / var(--tw-text-opacity, 1))}.twd-text-warning{--tw-text-opacity: 1;color:rgb(230 173 0 / var(--tw-text-opacity, 1))}.twd-text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.twd-line-through{text-decoration-line:line-through}.twd-no-underline{text-decoration-line:none}.twd-underline-offset-4{text-underline-offset:4px}.twd-opacity-0{opacity:0}.twd-opacity-50{opacity:.5}.twd-opacity-60{opacity:.6}.twd-opacity-70{opacity:.7}.twd-shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.twd-shadow-\\[0_2px_10px_0_rgba\\(0\\,_0\\,_0\\,_0\\.1\\)\\,_0_4px_24px_0_rgba\\(0\\,_0\\,_0\\,_0\\.09\\)\\]{--tw-shadow: 0 2px 10px 0 rgba(0, 0, 0, .1), 0 4px 24px 0 rgba(0, 0, 0, .09);--tw-shadow-colored: 0 2px 10px 0 var(--tw-shadow-color), 0 4px 24px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.twd-shadow-\\[0_2px_8px_0_rgb\\(0_0_0_\\/_10\\%\\)\\,_0_3px_20px_0_rgb\\(0_0_0_\\/_9\\%\\)\\]{--tw-shadow: 0 2px 8px 0 rgb(0 0 0 / 10%), 0 3px 20px 0 rgb(0 0 0 / 9%);--tw-shadow-colored: 0 2px 8px 0 var(--tw-shadow-color), 0 3px 20px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.twd-shadow-\\[0_4px_12px_\\#00000047\\]{--tw-shadow: 0 4px 12px #00000047;--tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.twd-shadow-lg{--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.twd-shadow-md{--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.twd-shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.twd-outline-none{outline:2px solid transparent;outline-offset:2px}.twd-ring-0{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.twd-ring-1{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.twd-ring-warning{--tw-ring-opacity: 1;--tw-ring-color: rgb(230 173 0 / var(--tw-ring-opacity, 1))}.twd-ring-offset-background{--tw-ring-offset-color: hsl(var(--background))}.twd-transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.twd-transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.twd-transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.twd-transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.twd-transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.twd-duration-100{transition-duration:.1s}.twd-duration-150{transition-duration:.15s}.twd-duration-200{transition-duration:.2s}.twd-duration-75{transition-duration:75ms}.twd-ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.twd-ease-linear{transition-timing-function:linear}.twd-ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.twd-\\@container\\/state-title{container-type:inline-size;container-name:state-title}.twd-hyphens-auto{-webkit-hyphens:auto;hyphens:auto}@keyframes enter{0%{opacity:var(--tw-enter-opacity, 1);transform:translate3d(var(--tw-enter-translate-x, 0),var(--tw-enter-translate-y, 0),0) scale3d(var(--tw-enter-scale, 1),var(--tw-enter-scale, 1),var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))}}@keyframes exit{to{opacity:var(--tw-exit-opacity, 1);transform:translate3d(var(--tw-exit-translate-x, 0),var(--tw-exit-translate-y, 0),0) scale3d(var(--tw-exit-scale, 1),var(--tw-exit-scale, 1),var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))}}.twd-duration-100{animation-duration:.1s}.twd-duration-150{animation-duration:.15s}.twd-duration-200{animation-duration:.2s}.twd-duration-75{animation-duration:75ms}.twd-ease-in-out{animation-timing-function:cubic-bezier(.4,0,.2,1)}.twd-ease-linear{animation-timing-function:linear}.twd-ease-out{animation-timing-function:cubic-bezier(0,0,.2,1)}.\\[-moz-appearance\\:textfield\\]{-moz-appearance:textfield}*:focus-visible{outline:none}:root{--background: 0 0% 100%;--foreground: 222.2 47.4% 11.2%;--muted: 210 40% 96.1%;--muted-foreground: 215.4 16.3% 46.9%;--card: 0 0% 100%;--card-foreground: 222.2 47.4% 11.2%;--popover: 0 0% 100%;--popover-foreground: 222.2 47.4% 11.2%;--border: 214.3 31.8% 91.4%;--input: 214.3 31.8% 91.4%;--primary: 222.2 47.4% 11.2%;--primary-foreground: 210 40% 98%;--secondary: 210 40% 96.1%;--secondary-foreground: 222.2 47.4% 11.2%;--accent: 210 40% 96.1%;--accent-foreground: 222.2 47.4% 11.2%;--destructive: 0 100% 50%;--destructive-foreground: 210 40% 98%;--ring: 215 20.2% 65.1%;--radius: .5rem;--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000}.placeholder\\:twd-text-secondary::-moz-placeholder{--tw-text-opacity: 1;color:rgb(119 119 119 / var(--tw-text-opacity, 1))}.placeholder\\:twd-text-secondary::placeholder{--tw-text-opacity: 1;color:rgb(119 119 119 / var(--tw-text-opacity, 1))}.focus-within\\:twd-bg-secondary-light4:focus-within{--tw-bg-opacity: 1;background-color:rgb(248 248 248 / var(--tw-bg-opacity, 1))}.hover\\:twd-border-primary:hover{--tw-border-opacity: 1;border-color:rgb(42 76 255 / var(--tw-border-opacity, 1))}.hover\\:twd-border-b-primary-light:hover{--tw-border-opacity: 1;border-bottom-color:rgb(64 118 255 / var(--tw-border-opacity, 1))}.hover\\:twd-bg-accent:hover{background-color:hsl(var(--accent))}.hover\\:twd-bg-destructive\\/90:hover{background-color:hsl(var(--destructive) / .9)}.hover\\:twd-bg-muted:hover{background-color:hsl(var(--muted))}.hover\\:twd-bg-muted\\/50:hover{background-color:hsl(var(--muted) / .5)}.hover\\:twd-bg-primary-dark:hover{--tw-bg-opacity: 1;background-color:rgb(18 36 129 / var(--tw-bg-opacity, 1))}.hover\\:twd-bg-primary-light3:hover{--tw-bg-opacity: 1;background-color:rgb(236 239 255 / var(--tw-bg-opacity, 1))}.hover\\:twd-bg-primary\\/90:hover{background-color:#2a4cffe6}.hover\\:twd-bg-secondary-contrast\\/5:hover{background-color:#0000000d}.hover\\:twd-bg-secondary-light:hover{--tw-bg-opacity: 1;background-color:rgb(217 216 216 / var(--tw-bg-opacity, 1))}.hover\\:twd-bg-secondary-light2:hover{--tw-bg-opacity: 1;background-color:rgb(233 233 233 / var(--tw-bg-opacity, 1))}.hover\\:twd-bg-secondary-light3:hover{--tw-bg-opacity: 1;background-color:rgb(244 244 244 / var(--tw-bg-opacity, 1))}.hover\\:twd-bg-secondary-light4:hover{--tw-bg-opacity: 1;background-color:rgb(248 248 248 / var(--tw-bg-opacity, 1))}.hover\\:twd-bg-secondary\\/80:hover{background-color:#777c}.hover\\:twd-bg-transparent:hover{background-color:transparent}.hover\\:twd-bg-white:hover{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.hover\\:twd-text-accent-foreground:hover{color:hsl(var(--accent-foreground))}.hover\\:twd-text-muted-foreground:hover{color:hsl(var(--muted-foreground))}.hover\\:twd-text-primary:hover{--tw-text-opacity: 1;color:rgb(42 76 255 / var(--tw-text-opacity, 1))}.hover\\:twd-text-primary-light:hover{--tw-text-opacity: 1;color:rgb(64 118 255 / var(--tw-text-opacity, 1))}.hover\\:twd-underline:hover{text-decoration-line:underline}.hover\\:twd-opacity-100:hover{opacity:1}.hover\\:focus-within\\:twd-bg-secondary-light4:focus-within:hover{--tw-bg-opacity: 1;background-color:rgb(248 248 248 / var(--tw-bg-opacity, 1))}.focus\\:twd-outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:twd-ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus\\:twd-ring-ring:focus{--tw-ring-color: hsl(var(--ring))}.focus\\:twd-ring-offset-2:focus{--tw-ring-offset-width: 2px}.focus-visible\\:twd-outline-none:focus-visible{outline:2px solid transparent;outline-offset:2px}.focus-visible\\:twd-ring-2:focus-visible{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus-visible\\:twd-ring-ring:focus-visible{--tw-ring-color: hsl(var(--ring))}.focus-visible\\:twd-ring-offset-2:focus-visible{--tw-ring-offset-width: 2px}.focus-visible\\:twd-ring-offset-background:focus-visible{--tw-ring-offset-color: hsl(var(--background))}.active\\:twd-border-b-primary-dark:active{--tw-border-opacity: 1;border-bottom-color:rgb(18 36 129 / var(--tw-border-opacity, 1))}.active\\:twd-bg-primary-light2:active{--tw-bg-opacity: 1;background-color:rgb(188 196 252 / var(--tw-bg-opacity, 1))}.active\\:twd-bg-secondary-light2:active{--tw-bg-opacity: 1;background-color:rgb(233 233 233 / var(--tw-bg-opacity, 1))}.active\\:twd-bg-secondary-light4:active{--tw-bg-opacity: 1;background-color:rgb(248 248 248 / var(--tw-bg-opacity, 1))}.active\\:twd-text-primary-dark:active{--tw-text-opacity: 1;color:rgb(18 36 129 / var(--tw-text-opacity, 1))}.enabled\\:twd-cursor-wait:enabled{cursor:wait}.enabled\\:hover\\:twd-bg-error-light:hover:enabled{--tw-bg-opacity: 1;background-color:rgb(255 52 18 / var(--tw-bg-opacity, 1))}.enabled\\:hover\\:twd-bg-info-light:hover:enabled{--tw-bg-opacity: 1;background-color:rgb(0 189 186 / var(--tw-bg-opacity, 1))}.enabled\\:hover\\:twd-bg-primary-light:hover:enabled{--tw-bg-opacity: 1;background-color:rgb(64 118 255 / var(--tw-bg-opacity, 1))}.enabled\\:hover\\:twd-bg-primary-light3:hover:enabled{--tw-bg-opacity: 1;background-color:rgb(236 239 255 / var(--tw-bg-opacity, 1))}.enabled\\:hover\\:twd-bg-secondary-light:hover:enabled{--tw-bg-opacity: 1;background-color:rgb(217 216 216 / var(--tw-bg-opacity, 1))}.enabled\\:hover\\:twd-bg-secondary-light2:hover:enabled{--tw-bg-opacity: 1;background-color:rgb(233 233 233 / var(--tw-bg-opacity, 1))}.enabled\\:hover\\:twd-text-primary-contrast:hover:enabled{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.enabled\\:hover\\:twd-text-primary-light:hover:enabled{--tw-text-opacity: 1;color:rgb(64 118 255 / var(--tw-text-opacity, 1))}.enabled\\:hover\\:twd-shadow-\\[0_2px_8px_0_rgba\\(0\\,_0\\,_0\\,_0\\.17\\)\\,_0_3px_20px_0_rgba\\(0\\,_0\\,_0\\,_0\\.15\\)\\]:hover:enabled{--tw-shadow: 0 2px 8px 0 rgba(0, 0, 0, .17), 0 3px 20px 0 rgba(0, 0, 0, .15);--tw-shadow-colored: 0 2px 8px 0 var(--tw-shadow-color), 0 3px 20px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.enabled\\:active\\:twd-scale-\\[0\\.97\\,0\\.97\\]:active:enabled{--tw-scale-x: .97,.97;--tw-scale-y: .97,.97;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.enabled\\:active\\:twd-bg-error-dark:active:enabled{--tw-bg-opacity: 1;background-color:rgb(153 13 57 / var(--tw-bg-opacity, 1))}.enabled\\:active\\:twd-bg-info-dark:active:enabled{--tw-bg-opacity: 1;background-color:rgb(5 104 103 / var(--tw-bg-opacity, 1))}.enabled\\:active\\:twd-bg-primary-dark:active:enabled{--tw-bg-opacity: 1;background-color:rgb(18 36 129 / var(--tw-bg-opacity, 1))}.enabled\\:active\\:twd-bg-primary-light2:active:enabled{--tw-bg-opacity: 1;background-color:rgb(188 196 252 / var(--tw-bg-opacity, 1))}.enabled\\:active\\:twd-bg-secondary-light:active:enabled{--tw-bg-opacity: 1;background-color:rgb(217 216 216 / var(--tw-bg-opacity, 1))}.enabled\\:active\\:twd-bg-secondary-light2:active:enabled{--tw-bg-opacity: 1;background-color:rgb(233 233 233 / var(--tw-bg-opacity, 1))}.enabled\\:active\\:twd-text-primary-contrast:active:enabled{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.enabled\\:active\\:twd-text-primary-dark:active:enabled{--tw-text-opacity: 1;color:rgb(18 36 129 / var(--tw-text-opacity, 1))}.enabled\\:active\\:twd-shadow-\\[0_1px_4px_0_rgba\\(0\\,_0\\,_0\\,_0\\.17\\)\\,_0_1px_10px_0_rgba\\(0\\,_0\\,_0\\,_0\\.15\\)\\]:active:enabled{--tw-shadow: 0 1px 4px 0 rgba(0, 0, 0, .17), 0 1px 10px 0 rgba(0, 0, 0, .15);--tw-shadow-colored: 0 1px 4px 0 var(--tw-shadow-color), 0 1px 10px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.disabled\\:twd-pointer-events-none:disabled{pointer-events:none}.disabled\\:twd-cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:twd-cursor-wait:disabled{cursor:wait}.disabled\\:twd-bg-info-light2:disabled{--tw-bg-opacity: 1;background-color:rgb(140 232 232 / var(--tw-bg-opacity, 1))}.disabled\\:twd-bg-secondary:disabled{--tw-bg-opacity: 1;background-color:rgb(119 119 119 / var(--tw-bg-opacity, 1))}.disabled\\:twd-bg-secondary-light3:disabled{--tw-bg-opacity: 1;background-color:rgb(244 244 244 / var(--tw-bg-opacity, 1))}.disabled\\:twd-bg-transparent:disabled{background-color:transparent}.disabled\\:twd-text-info-contrast:disabled{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.disabled\\:twd-text-primary-light:disabled{--tw-text-opacity: 1;color:rgb(64 118 255 / var(--tw-text-opacity, 1))}.disabled\\:twd-text-secondary:disabled{--tw-text-opacity: 1;color:rgb(119 119 119 / var(--tw-text-opacity, 1))}.disabled\\:twd-text-secondary-light:disabled{--tw-text-opacity: 1;color:rgb(217 216 216 / var(--tw-text-opacity, 1))}.disabled\\:twd-opacity-50:disabled{opacity:.5}.disabled\\:hover\\:twd-bg-info-light2:hover:disabled{--tw-bg-opacity: 1;background-color:rgb(140 232 232 / var(--tw-bg-opacity, 1))}.disabled\\:hover\\:twd-bg-secondary-light2:hover:disabled{--tw-bg-opacity: 1;background-color:rgb(233 233 233 / var(--tw-bg-opacity, 1))}.disabled\\:hover\\:twd-bg-secondary-light3:hover:disabled{--tw-bg-opacity: 1;background-color:rgb(244 244 244 / var(--tw-bg-opacity, 1))}.disabled\\:hover\\:twd-bg-transparent:hover:disabled{background-color:transparent}.disabled\\:active\\:twd-bg-info-light2:active:disabled{--tw-bg-opacity: 1;background-color:rgb(140 232 232 / var(--tw-bg-opacity, 1))}.disabled\\:active\\:twd-bg-secondary-light2:active:disabled{--tw-bg-opacity: 1;background-color:rgb(233 233 233 / var(--tw-bg-opacity, 1))}.disabled\\:active\\:twd-bg-secondary-light3:active:disabled{--tw-bg-opacity: 1;background-color:rgb(244 244 244 / var(--tw-bg-opacity, 1))}.disabled\\:active\\:twd-bg-transparent:active:disabled{background-color:transparent}.twd-group:hover .group-hover\\:twd-bg-secondary-contrast\\/5{background-color:#0000000d}.twd-group:hover .group-hover\\:twd-text-foreground{color:hsl(var(--foreground))}.twd-group:hover .group-hover\\:twd-opacity-100{opacity:1}.twd-peer:disabled~.peer-disabled\\:twd-cursor-not-allowed{cursor:not-allowed}.twd-peer:disabled~.peer-disabled\\:twd-opacity-70{opacity:.7}.data-\\[state\\=checked\\]\\:twd-translate-x-4[data-state=checked]{--tw-translate-x: 1rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.data-\\[state\\=unchecked\\]\\:twd-translate-x-0[data-state=unchecked]{--tw-translate-x: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.data-\\[state\\=checked\\]\\:twd-border-primary[data-state=checked]{--tw-border-opacity: 1;border-color:rgb(42 76 255 / var(--tw-border-opacity, 1))}.data-\\[state\\=checked\\]\\:twd-bg-primary[data-state=checked]{--tw-bg-opacity: 1;background-color:rgb(42 76 255 / var(--tw-bg-opacity, 1))}.data-\\[state\\=on\\]\\:twd-bg-accent[data-state=on]{background-color:hsl(var(--accent))}.data-\\[state\\=open\\]\\:twd-bg-transparent[data-state=open]{background-color:transparent}.data-\\[state\\=selected\\]\\:twd-bg-muted[data-state=selected]{background-color:hsl(var(--muted))}.data-\\[state\\=unchecked\\]\\:twd-bg-input[data-state=unchecked]{background-color:hsl(var(--input))}.data-\\[state\\=checked\\]\\:twd-text-primary-foreground[data-state=checked]{color:hsl(var(--primary-foreground))}.data-\\[state\\=on\\]\\:twd-text-accent-foreground[data-state=on]{color:hsl(var(--accent-foreground))}.data-\\[state\\=closed\\]\\:twd-duration-300[data-state=closed]{transition-duration:.3s}.data-\\[state\\=open\\]\\:twd-duration-500[data-state=open]{transition-duration:.5s}.data-\\[state\\=open\\]\\:twd-animate-in[data-state=open]{animation-name:enter;animation-duration:.15s;--tw-enter-opacity: initial;--tw-enter-scale: initial;--tw-enter-rotate: initial;--tw-enter-translate-x: initial;--tw-enter-translate-y: initial}.data-\\[state\\=closed\\]\\:twd-animate-out[data-state=closed]{animation-name:exit;animation-duration:.15s;--tw-exit-opacity: initial;--tw-exit-scale: initial;--tw-exit-rotate: initial;--tw-exit-translate-x: initial;--tw-exit-translate-y: initial}.data-\\[state\\=closed\\]\\:twd-fade-out-0[data-state=closed]{--tw-exit-opacity: 0}.data-\\[state\\=open\\]\\:twd-fade-in-0[data-state=open]{--tw-enter-opacity: 0}.data-\\[state\\=closed\\]\\:twd-zoom-out-95[data-state=closed]{--tw-exit-scale: .95}.data-\\[state\\=open\\]\\:twd-zoom-in-95[data-state=open]{--tw-enter-scale: .95}.data-\\[state\\=closed\\]\\:twd-slide-out-to-bottom[data-state=closed]{--tw-exit-translate-y: 100%}.data-\\[state\\=closed\\]\\:twd-slide-out-to-left[data-state=closed]{--tw-exit-translate-x: -100%}.data-\\[state\\=closed\\]\\:twd-slide-out-to-left-1\\/2[data-state=closed]{--tw-exit-translate-x: -50%}.data-\\[state\\=closed\\]\\:twd-slide-out-to-right[data-state=closed]{--tw-exit-translate-x: 100%}.data-\\[state\\=closed\\]\\:twd-slide-out-to-top[data-state=closed]{--tw-exit-translate-y: -100%}.data-\\[state\\=closed\\]\\:twd-slide-out-to-top-\\[48\\%\\][data-state=closed]{--tw-exit-translate-y: -48%}.data-\\[state\\=open\\]\\:twd-slide-in-from-bottom[data-state=open]{--tw-enter-translate-y: 100%}.data-\\[state\\=open\\]\\:twd-slide-in-from-left[data-state=open]{--tw-enter-translate-x: -100%}.data-\\[state\\=open\\]\\:twd-slide-in-from-left-1\\/2[data-state=open]{--tw-enter-translate-x: -50%}.data-\\[state\\=open\\]\\:twd-slide-in-from-right[data-state=open]{--tw-enter-translate-x: 100%}.data-\\[state\\=open\\]\\:twd-slide-in-from-top[data-state=open]{--tw-enter-translate-y: -100%}.data-\\[state\\=open\\]\\:twd-slide-in-from-top-\\[48\\%\\][data-state=open]{--tw-enter-translate-y: -48%}.data-\\[state\\=closed\\]\\:twd-duration-300[data-state=closed]{animation-duration:.3s}.data-\\[state\\=open\\]\\:twd-duration-500[data-state=open]{animation-duration:.5s}@container state-title (min-width: 575px){.\\@sm\\/state-title\\:twd-inline{display:inline}}@media (min-width: 440px){.xs\\:twd-inline{display:inline}}@media (min-width: 575px){.sm\\:twd-mt-0{margin-top:0}.sm\\:twd-flex{display:flex}.sm\\:twd-hidden{display:none}.sm\\:twd-w-3\\/4{width:75%}.sm\\:twd-w-auto{width:auto}.sm\\:twd-max-w-sm{max-width:24rem}.sm\\:twd-flex-row{flex-direction:row}.sm\\:twd-flex-wrap{flex-wrap:wrap}.sm\\:twd-flex-nowrap{flex-wrap:nowrap}.sm\\:twd-items-center{align-items:center}.sm\\:twd-justify-end{justify-content:flex-end}.sm\\:twd-justify-between{justify-content:space-between}.sm\\:twd-gap-0{gap:0px}.sm\\:twd-space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * calc(1 - var(--tw-space-x-reverse)))}.sm\\:twd-rounded-lg{border-radius:var(--radius)}.sm\\:twd-border{border-width:1px}.sm\\:twd-p-4{padding:1rem}.sm\\:twd-px-2{padding-left:.5rem;padding-right:.5rem}.sm\\:twd-py-8{padding-top:2rem;padding-bottom:2rem}.sm\\:twd-py-\\[20px\\]{padding-top:20px;padding-bottom:20px}.sm\\:twd-text-left{text-align:left}.sm\\:twd-text-\\[41px\\]{font-size:41px}}@media (min-width: 767px){.md\\:twd-aspect-auto{aspect-ratio:auto}.md\\:twd-h-\\[500px\\]{height:500px}.md\\:twd-w-\\[500px\\]{width:500px}.md\\:twd-grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.md\\:twd-flex-row{flex-direction:row}.md\\:twd-items-end{align-items:flex-end}.md\\:twd-items-center{align-items:center}.md\\:twd-justify-between{justify-content:space-between}.md\\:twd-gap-4{gap:1rem}.md\\:twd-p-4{padding:1rem}.md\\:twd-pl-4{padding-left:1rem}}@media (min-width: 1024px){.lg\\:twd-right-20{right:5rem}}@media print{.print\\:twd-block{display:block}.print\\:twd-hidden{display:none}}.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:twd-appearance-none::-webkit-inner-spin-button{-webkit-appearance:none;appearance:none}.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:twd-appearance-none::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none}.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:twd-pr-0:has([role=checkbox]){padding-right:0}.active\\:\\[\\&\\:not\\(\\:focus-within\\)\\]\\:twd-bg-secondary-light:not(:focus-within):active{--tw-bg-opacity: 1;background-color:rgb(217 216 216 / var(--tw-bg-opacity, 1))}.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:twd-rotate-180[data-state=open]>svg{--tw-rotate: 180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.\\[\\&_svg\\]\\:twd-pointer-events-none svg{pointer-events:none}.\\[\\&_svg\\]\\:twd-size-4 svg{width:1rem;height:1rem}.\\[\\&_svg\\]\\:twd-shrink-0 svg{flex-shrink:0}
`, Hhe = `html[dir=ltr],[data-sonner-toaster][dir=ltr]{--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}html[dir=rtl],[data-sonner-toaster][dir=rtl]{--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999;transition:transform .4s ease}@media (hover: none) and (pointer: coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translate(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}[data-sonner-toast][data-y-position=top]{top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px #0006}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]:before{content:"";position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]:before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]:before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]:before{content:"";position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]:after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y: translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y: translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]:before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y, 0px)) translate(var(--swipe-amount-x, 0px));transition:none}[data-sonner-toast][data-swiped=true]{-webkit-user-select:none;-moz-user-select:none;user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 87%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 93%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 84%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg: #000;--normal-bg-hover: hsl(0, 0%, 12%);--normal-border: hsl(0, 0%, 20%);--normal-border-hover: hsl(0, 0%, 25%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 43%, 17%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 9%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`, qhe = (t) => t();
class Do {
  constructor(e, n) {
    this.component = e, this.routerContext = n?.routerContext ?? null;
  }
  container = null;
  shadowRoot = null;
  reactHostElement = null;
  routerContext = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props;
  // Global portal container for modals and overlays
  static portalContainerElement = null;
  static portalShadowRoot = null;
  static portalInitPromise = null;
  get isMounted() {
    return this.container != null;
  }
  /**
   * Get CSS styles from the imported bundle
   */
  static loadStyles() {
    return $he;
  }
  /**
   * Inject styles into Shadow DOM
   */
  injectStyles(e) {
    const n = Do.loadStyles();
    if ("adoptedStyleSheets" in Document.prototype && "CSSStyleSheet" in window)
      try {
        const i = new CSSStyleSheet();
        i.replaceSync(n), e.adoptedStyleSheets = [i];
        return;
      } catch (i) {
        console.warn("Constructable Stylesheets failed, falling back to <style> tag:", i);
      }
    const r = document.createElement("style");
    r.textContent = n, e.appendChild(r);
  }
  /**
   * Ensure Sonner styles are available when rendering inside a Shadow DOM.
   * Sonner injects its CSS into document.head, so we need to duplicate those rules.
   */
  static appendSonnerStyles(e) {
    if (e.querySelector('style[data-sonner-style="true"]'))
      return;
    const n = document.createElement("style");
    n.setAttribute("data-sonner-style", "true"), n.textContent = Hhe, e.appendChild(n);
  }
  /**
   * Ensure global portal container exists for modals and overlays
   * Creates a Shadow DOM container in body for isolated portal rendering
   */
  static async ensurePortalContainer() {
    return Do.portalContainerElement != null ? Do.portalContainerElement : (Do.portalInitPromise != null || (Do.portalInitPromise = qhe(async () => {
      try {
        const e = document.createElement("div");
        e.id = "react-portals-root", document.body.appendChild(e);
        const n = e.attachShadow({
          mode: "open"
        });
        Do.portalShadowRoot = n;
        const r = Do.loadStyles();
        if ("adoptedStyleSheets" in Document.prototype && "CSSStyleSheet" in window)
          try {
            const a = new CSSStyleSheet();
            a.replaceSync(r), n.adoptedStyleSheets = [a], console.log("Portal Shadow DOM: Using Constructable Stylesheets");
          } catch (a) {
            console.warn("Portal Shadow DOM: Constructable Stylesheets failed:", a);
            const s = document.createElement("style");
            s.textContent = r, n.appendChild(s), console.log("Portal Shadow DOM: Using <style> element as fallback");
          }
        else {
          const a = document.createElement("style");
          a.textContent = r, n.appendChild(a), console.log("Portal Shadow DOM: Using <style> element (no Constructable Stylesheets support)");
        }
        const i = document.createElement("div");
        return i.id = "portals-container", n.appendChild(i), Do.appendSonnerStyles(n), Do.portalContainerElement = i, i;
      } catch (e) {
        throw console.error("Failed to create portal container:", e), e;
      } finally {
        Do.portalInitPromise = null;
      }
    })), Do.portalInitPromise);
  }
  // The main method to render a React component into a given container with Shadow DOM
  async mount(e, n, r) {
    this.ensureUnmounted(), r?.routerContext !== void 0 && (this.routerContext = r.routerContext ?? null), await Do.ensurePortalContainer(), this.shadowRoot = e.attachShadow({
      mode: "open"
    }), this.injectStyles(this.shadowRoot), Do.appendSonnerStyles(this.shadowRoot), this.reactHostElement = document.createElement("div"), this.reactHostElement.id = "react-root", this.shadowRoot.appendChild(this.reactHostElement), this.container = Qde.createRoot(this.reactHostElement), this.props = n, this.render();
  }
  unmount() {
    this.ensureMounted(), this.container?.unmount(), this.container = null, this.shadowRoot && this.reactHostElement && this.reactHostElement.remove(), this.shadowRoot = null, this.reactHostElement = null;
  }
  updateProps(e) {
    this.ensureMounted(), Object.assign(this.props, e), this.render();
  }
  /**
   * Build rendering environment based on whether we're in Shadow DOM or regular DOM
   */
  buildEnvironment() {
    return this.shadowRoot && this.reactHostElement ? {
      mode: "shadow",
      shadowRoot: this.shadowRoot,
      hostElement: this.reactHostElement,
      portalShadowRoot: Do.portalShadowRoot
    } : {
      mode: "dom",
      rootNode: document
    };
  }
  render() {
    const e = De.createElement(this.component, this.props), n = this.buildEnvironment();
    this.container?.render(/* @__PURE__ */ C.jsx(De.StrictMode, { children: /* @__PURE__ */ C.jsx(Uhe, { environment: n, router: this.routerContext?.router ?? null, route: this.routerContext?.route ?? null, children: e }) }));
  }
  ensureMounted() {
    if (!this.isMounted)
      throw new Error(`The component "${this.component.name}" is not mounted`);
  }
  ensureUnmounted() {
    if (this.isMounted)
      throw new Error(`The component "${this.component.name}" is already mounted`);
  }
}
const jG = I.createContext(null), Ghe = Do.ensurePortalContainer(), Yhe = (t) => {
  const e = ve.c(3), {
    children: n
  } = t, r = I.use(Ghe);
  let i;
  return e[0] !== n || e[1] !== r ? (i = /* @__PURE__ */ C.jsx(jG.Provider, { value: r, children: n }), e[0] = n, e[1] = r, e[2] = i) : i = e[2], i;
}, Xhe = (t) => {
  const e = ve.c(2), {
    children: n
  } = t;
  let r;
  return e[0] !== n ? (r = /* @__PURE__ */ C.jsx(Yhe, { children: n }), e[0] = n, e[1] = r) : r = e[1], r;
}, PG = () => I.useContext(jG), Whe = HM, Qhe = Jq, Zhe = qM, LG = I.forwardRef((t, e) => {
  const n = ve.c(4), {
    className: r
  } = t;
  let i;
  n[0] !== r ? (i = un("twd-fixed twd-inset-0 twd-z-50 twd-bg-black/80 twd-pointer-events-auto data-[state=open]:twd-animate-in data-[state=closed]:twd-animate-out data-[state=closed]:twd-fade-out-0 data-[state=open]:twd-fade-in-0", r), n[0] = r, n[1] = i) : i = n[1];
  let a;
  return n[2] !== i ? (a = /* @__PURE__ */ C.jsx("div", { className: i }), n[2] = i, n[3] = a) : a = n[3], a;
});
LG.displayName = N5.displayName;
const Khe = __("twd-fixed twd-z-50 twd-gap-4 twd-bg-background twd-p-6 twd-shadow-lg twd-transition twd-ease-in-out twd-pointer-events-auto data-[state=open]:twd-animate-in data-[state=closed]:twd-animate-out data-[state=closed]:twd-duration-300 data-[state=open]:twd-duration-500", {
  variants: {
    side: {
      top: "twd-inset-x-0 twd-top-0 twd-border-b data-[state=closed]:twd-slide-out-to-top data-[state=open]:twd-slide-in-from-top",
      bottom: "twd-inset-x-0 twd-bottom-0 twd-border-t data-[state=closed]:twd-slide-out-to-bottom data-[state=open]:twd-slide-in-from-bottom",
      left: "twd-inset-y-0 twd-left-0 twd-h-full twd-w-3/4 twd-border-r data-[state=closed]:twd-slide-out-to-left data-[state=open]:twd-slide-in-from-left sm:twd-max-w-sm",
      // Right was edited to adjust sizes
      right: (
        // TODO add twd-border-l after refactoring
        "twd-inset-y-0 twd-right-0 twd-h-full twd-w-11/12 sm:twd-w-3/4 data-[state=closed]:twd-slide-out-to-right data-[state=open]:twd-slide-in-from-right sm:twd-max-w-sm twd-overflow-y-auto"
      )
    }
  },
  defaultVariants: {
    side: "right"
  }
}), BG = I.forwardRef((t, e) => {
  const n = ve.c(18);
  let r, i, a, s;
  n[0] !== t ? ({
    side: s,
    className: i,
    children: r,
    ...a
  } = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = s) : (r = n[1], i = n[2], a = n[3], s = n[4]);
  const c = s === void 0 ? "right" : s, d = PG() ?? void 0;
  let f;
  n[5] === Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ C.jsx(LG, {}), n[5] = f) : f = n[5];
  let g;
  n[6] !== i || n[7] !== c ? (g = un(Khe({
    side: c
  }), i), n[6] = i, n[7] = c, n[8] = g) : g = n[8];
  let m;
  n[9] === Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ C.jsxs(M5, { className: "twd-absolute twd-right-4 twd-top-4 twd-rounded-sm twd-opacity-70 twd-ring-offset-background twd-transition-opacity hover:twd-opacity-100 focus:twd-outline-none focus:twd-ring-2 focus:twd-ring-ring focus:twd-ring-offset-2 disabled:twd-pointer-events-none data-[state=open]:twd-bg-transparent twd-bg-transparent", children: [
    /* @__PURE__ */ C.jsx(kce, { className: "twd-h-4 twd-w-4" }),
    /* @__PURE__ */ C.jsx("span", { className: "twd-sr-only", children: "Close" })
  ] }), n[9] = m) : m = n[9];
  let b;
  n[10] !== r || n[11] !== a || n[12] !== e || n[13] !== g ? (b = /* @__PURE__ */ C.jsxs(x_, { ref: e, className: g, ...a, children: [
    r,
    m
  ] }), n[10] = r, n[11] = a, n[12] = e, n[13] = g, n[14] = b) : b = n[14];
  let w;
  return n[15] !== d || n[16] !== b ? (w = /* @__PURE__ */ C.jsxs(Zhe, { container: d, children: [
    f,
    b
  ] }), n[15] = d, n[16] = b, n[17] = w) : w = n[17], w;
});
BG.displayName = x_.displayName;
const zG = (t) => {
  const e = ve.c(8);
  let n, r;
  e[0] !== t ? ({
    className: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = r) : (n = e[1], r = e[2]);
  let i;
  e[3] !== n ? (i = un("twd-flex twd-flex-col twd-space-y-2 twd-text-center sm:twd-text-left", n), e[3] = n, e[4] = i) : i = e[4];
  let a;
  return e[5] !== r || e[6] !== i ? (a = /* @__PURE__ */ C.jsx("div", { className: i, ...r }), e[5] = r, e[6] = i, e[7] = a) : a = e[7], a;
};
zG.displayName = "SheetHeader";
const FG = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-text-lg twd-font-semibold twd-text-foreground", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx(S_, { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
FG.displayName = S_.displayName;
const Jhe = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-text-sm twd-text-muted-foreground", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx(E_, { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
Jhe.displayName = E_.displayName;
const epe = (t) => {
  const e = ve.c(15), {
    trigger: n,
    onOpenChange: r,
    title: i,
    children: a
  } = t;
  let s;
  e[0] !== n ? (s = /* @__PURE__ */ C.jsx(Qhe, { asChild: !0, children: n }), e[0] = n, e[1] = s) : s = e[1];
  let c;
  e[2] !== i ? (c = i != null && /* @__PURE__ */ C.jsx(FG, { children: i }), e[2] = i, e[3] = c) : c = e[3];
  let d;
  e[4] !== c ? (d = /* @__PURE__ */ C.jsx(zG, { children: c }), e[4] = c, e[5] = d) : d = e[5];
  let f;
  e[6] !== a ? (f = /* @__PURE__ */ C.jsx("div", { className: "twd-mt-4", children: a }), e[6] = a, e[7] = f) : f = e[7];
  let g;
  e[8] !== d || e[9] !== f ? (g = /* @__PURE__ */ C.jsxs(BG, { children: [
    d,
    f
  ] }), e[8] = d, e[9] = f, e[10] = g) : g = e[10];
  let m;
  return e[11] !== r || e[12] !== s || e[13] !== g ? (m = /* @__PURE__ */ C.jsxs(Whe, { onOpenChange: r, children: [
    s,
    g
  ] }), e[11] = r, e[12] = s, e[13] = g, e[14] = m) : m = e[14], m;
};
function Ud(t, e) {
  if (t == null)
    return {};
  var n = {};
  for (var r in t)
    if ({}.hasOwnProperty.call(t, r)) {
      if (e.indexOf(r) !== -1)
        continue;
      n[r] = t[r];
    }
  return n;
}
function Nn() {
  return Nn = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Nn.apply(null, arguments);
}
function lB(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function T8(t, e) {
  return T8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, T8(t, e);
}
function tpe(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, T8(t, e);
}
var O8 = { exports: {} }, NC = { exports: {} }, Or = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cB;
function npe() {
  if (cB)
    return Or;
  cB = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, a = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, d = t ? Symbol.for("react.async_mode") : 60111, f = t ? Symbol.for("react.concurrent_mode") : 60111, g = t ? Symbol.for("react.forward_ref") : 60112, m = t ? Symbol.for("react.suspense") : 60113, b = t ? Symbol.for("react.suspense_list") : 60120, w = t ? Symbol.for("react.memo") : 60115, _ = t ? Symbol.for("react.lazy") : 60116, A = t ? Symbol.for("react.block") : 60121, T = t ? Symbol.for("react.fundamental") : 60117, O = t ? Symbol.for("react.responder") : 60118, R = t ? Symbol.for("react.scope") : 60119;
  function N(P) {
    if (typeof P == "object" && P !== null) {
      var z = P.$$typeof;
      switch (z) {
        case e:
          switch (P = P.type, P) {
            case d:
            case f:
            case r:
            case a:
            case i:
            case m:
              return P;
            default:
              switch (P = P && P.$$typeof, P) {
                case c:
                case g:
                case _:
                case w:
                case s:
                  return P;
                default:
                  return z;
              }
          }
        case n:
          return z;
      }
    }
  }
  function M(P) {
    return N(P) === f;
  }
  return Or.AsyncMode = d, Or.ConcurrentMode = f, Or.ContextConsumer = c, Or.ContextProvider = s, Or.Element = e, Or.ForwardRef = g, Or.Fragment = r, Or.Lazy = _, Or.Memo = w, Or.Portal = n, Or.Profiler = a, Or.StrictMode = i, Or.Suspense = m, Or.isAsyncMode = function(P) {
    return M(P) || N(P) === d;
  }, Or.isConcurrentMode = M, Or.isContextConsumer = function(P) {
    return N(P) === c;
  }, Or.isContextProvider = function(P) {
    return N(P) === s;
  }, Or.isElement = function(P) {
    return typeof P == "object" && P !== null && P.$$typeof === e;
  }, Or.isForwardRef = function(P) {
    return N(P) === g;
  }, Or.isFragment = function(P) {
    return N(P) === r;
  }, Or.isLazy = function(P) {
    return N(P) === _;
  }, Or.isMemo = function(P) {
    return N(P) === w;
  }, Or.isPortal = function(P) {
    return N(P) === n;
  }, Or.isProfiler = function(P) {
    return N(P) === a;
  }, Or.isStrictMode = function(P) {
    return N(P) === i;
  }, Or.isSuspense = function(P) {
    return N(P) === m;
  }, Or.isValidElementType = function(P) {
    return typeof P == "string" || typeof P == "function" || P === r || P === f || P === a || P === i || P === m || P === b || typeof P == "object" && P !== null && (P.$$typeof === _ || P.$$typeof === w || P.$$typeof === s || P.$$typeof === c || P.$$typeof === g || P.$$typeof === T || P.$$typeof === O || P.$$typeof === R || P.$$typeof === A);
  }, Or.typeOf = N, Or;
}
var Rr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uB;
function rpe() {
  return uB || (uB = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, a = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, d = t ? Symbol.for("react.async_mode") : 60111, f = t ? Symbol.for("react.concurrent_mode") : 60111, g = t ? Symbol.for("react.forward_ref") : 60112, m = t ? Symbol.for("react.suspense") : 60113, b = t ? Symbol.for("react.suspense_list") : 60120, w = t ? Symbol.for("react.memo") : 60115, _ = t ? Symbol.for("react.lazy") : 60116, A = t ? Symbol.for("react.block") : 60121, T = t ? Symbol.for("react.fundamental") : 60117, O = t ? Symbol.for("react.responder") : 60118, R = t ? Symbol.for("react.scope") : 60119;
    function N(Ue) {
      return typeof Ue == "string" || typeof Ue == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Ue === r || Ue === f || Ue === a || Ue === i || Ue === m || Ue === b || typeof Ue == "object" && Ue !== null && (Ue.$$typeof === _ || Ue.$$typeof === w || Ue.$$typeof === s || Ue.$$typeof === c || Ue.$$typeof === g || Ue.$$typeof === T || Ue.$$typeof === O || Ue.$$typeof === R || Ue.$$typeof === A);
    }
    function M(Ue) {
      if (typeof Ue == "object" && Ue !== null) {
        var rt = Ue.$$typeof;
        switch (rt) {
          case e:
            var it = Ue.type;
            switch (it) {
              case d:
              case f:
              case r:
              case a:
              case i:
              case m:
                return it;
              default:
                var Ft = it && it.$$typeof;
                switch (Ft) {
                  case c:
                  case g:
                  case _:
                  case w:
                  case s:
                    return Ft;
                  default:
                    return rt;
                }
            }
          case n:
            return rt;
        }
      }
    }
    var P = d, z = f, F = c, $ = s, G = e, H = g, Z = r, V = _, Y = w, ee = n, K = a, U = i, q = m, W = !1;
    function ie(Ue) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), J(Ue) || M(Ue) === d;
    }
    function J(Ue) {
      return M(Ue) === f;
    }
    function B(Ue) {
      return M(Ue) === c;
    }
    function te(Ue) {
      return M(Ue) === s;
    }
    function ae(Ue) {
      return typeof Ue == "object" && Ue !== null && Ue.$$typeof === e;
    }
    function le(Ue) {
      return M(Ue) === g;
    }
    function de(Ue) {
      return M(Ue) === r;
    }
    function _e(Ue) {
      return M(Ue) === _;
    }
    function ue(Ue) {
      return M(Ue) === w;
    }
    function Se(Ue) {
      return M(Ue) === n;
    }
    function Ne(Ue) {
      return M(Ue) === a;
    }
    function Me(Ue) {
      return M(Ue) === i;
    }
    function Ce(Ue) {
      return M(Ue) === m;
    }
    Rr.AsyncMode = P, Rr.ConcurrentMode = z, Rr.ContextConsumer = F, Rr.ContextProvider = $, Rr.Element = G, Rr.ForwardRef = H, Rr.Fragment = Z, Rr.Lazy = V, Rr.Memo = Y, Rr.Portal = ee, Rr.Profiler = K, Rr.StrictMode = U, Rr.Suspense = q, Rr.isAsyncMode = ie, Rr.isConcurrentMode = J, Rr.isContextConsumer = B, Rr.isContextProvider = te, Rr.isElement = ae, Rr.isForwardRef = le, Rr.isFragment = de, Rr.isLazy = _e, Rr.isMemo = ue, Rr.isPortal = Se, Rr.isProfiler = Ne, Rr.isStrictMode = Me, Rr.isSuspense = Ce, Rr.isValidElementType = N, Rr.typeOf = M;
  }()), Rr;
}
var dB;
function VG() {
  return dB || (dB = 1, process.env.NODE_ENV === "production" ? NC.exports = npe() : NC.exports = rpe()), NC.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var C6, fB;
function ipe() {
  if (fB)
    return C6;
  fB = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var s = {}, c = 0; c < 10; c++)
        s["_" + String.fromCharCode(c)] = c;
      var d = Object.getOwnPropertyNames(s).map(function(g) {
        return s[g];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(g) {
        f[g] = g;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return C6 = i() ? Object.assign : function(a, s) {
    for (var c, d = r(a), f, g = 1; g < arguments.length; g++) {
      c = Object(arguments[g]);
      for (var m in c)
        e.call(c, m) && (d[m] = c[m]);
      if (t) {
        f = t(c);
        for (var b = 0; b < f.length; b++)
          n.call(c, f[b]) && (d[f[b]] = c[f[b]]);
      }
    }
    return d;
  }, C6;
}
var T6, hB;
function rI() {
  if (hB)
    return T6;
  hB = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return T6 = t, T6;
}
var O6, pB;
function UG() {
  return pB || (pB = 1, O6 = Function.call.bind(Object.prototype.hasOwnProperty)), O6;
}
var R6, mB;
function ape() {
  if (mB)
    return R6;
  mB = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = rI(), n = {}, r = UG();
    t = function(a) {
      var s = "Warning: " + a;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(a, s, c, d, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var g in a)
        if (r(a, g)) {
          var m;
          try {
            if (typeof a[g] != "function") {
              var b = Error(
                (d || "React class") + ": " + c + " type `" + g + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[g] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw b.name = "Invariant Violation", b;
            }
            m = a[g](s, g, d, c, null, e);
          } catch (_) {
            m = _;
          }
          if (m && !(m instanceof Error) && t(
            (d || "React class") + ": type specification of " + c + " `" + g + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in n)) {
            n[m.message] = !0;
            var w = f ? f() : "";
            t(
              "Failed " + c + " type: " + m.message + (w ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, R6 = i, R6;
}
var D6, gB;
function ope() {
  if (gB)
    return D6;
  gB = 1;
  var t = VG(), e = ipe(), n = rI(), r = UG(), i = ape(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(c) {
    var d = "Warning: " + c;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return D6 = function(c, d) {
    var f = typeof Symbol == "function" && Symbol.iterator, g = "@@iterator";
    function m(J) {
      var B = J && (f && J[f] || J[g]);
      if (typeof B == "function")
        return B;
    }
    var b = "<<anonymous>>", w = {
      array: O("array"),
      bigint: O("bigint"),
      bool: O("boolean"),
      func: O("function"),
      number: O("number"),
      object: O("object"),
      string: O("string"),
      symbol: O("symbol"),
      any: R(),
      arrayOf: N,
      element: M(),
      elementType: P(),
      instanceOf: z,
      node: H(),
      objectOf: $,
      oneOf: F,
      oneOfType: G,
      shape: V,
      exact: Y
    };
    function _(J, B) {
      return J === B ? J !== 0 || 1 / J === 1 / B : J !== J && B !== B;
    }
    function A(J, B) {
      this.message = J, this.data = B && typeof B == "object" ? B : {}, this.stack = "";
    }
    A.prototype = Error.prototype;
    function T(J) {
      if (process.env.NODE_ENV !== "production")
        var B = {}, te = 0;
      function ae(de, _e, ue, Se, Ne, Me, Ce) {
        if (Se = Se || b, Me = Me || ue, Ce !== n) {
          if (d) {
            var Ue = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Ue.name = "Invariant Violation", Ue;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var rt = Se + ":" + ue;
            !B[rt] && // Avoid spamming the console because they are often not actionable except for lib authors
            te < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Me + "` prop on `" + Se + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), B[rt] = !0, te++);
          }
        }
        return _e[ue] == null ? de ? _e[ue] === null ? new A("The " + Ne + " `" + Me + "` is marked as required " + ("in `" + Se + "`, but its value is `null`.")) : new A("The " + Ne + " `" + Me + "` is marked as required in " + ("`" + Se + "`, but its value is `undefined`.")) : null : J(_e, ue, Se, Ne, Me);
      }
      var le = ae.bind(null, !1);
      return le.isRequired = ae.bind(null, !0), le;
    }
    function O(J) {
      function B(te, ae, le, de, _e, ue) {
        var Se = te[ae], Ne = U(Se);
        if (Ne !== J) {
          var Me = q(Se);
          return new A(
            "Invalid " + de + " `" + _e + "` of type " + ("`" + Me + "` supplied to `" + le + "`, expected ") + ("`" + J + "`."),
            { expectedType: J }
          );
        }
        return null;
      }
      return T(B);
    }
    function R() {
      return T(s);
    }
    function N(J) {
      function B(te, ae, le, de, _e) {
        if (typeof J != "function")
          return new A("Property `" + _e + "` of component `" + le + "` has invalid PropType notation inside arrayOf.");
        var ue = te[ae];
        if (!Array.isArray(ue)) {
          var Se = U(ue);
          return new A("Invalid " + de + " `" + _e + "` of type " + ("`" + Se + "` supplied to `" + le + "`, expected an array."));
        }
        for (var Ne = 0; Ne < ue.length; Ne++) {
          var Me = J(ue, Ne, le, de, _e + "[" + Ne + "]", n);
          if (Me instanceof Error)
            return Me;
        }
        return null;
      }
      return T(B);
    }
    function M() {
      function J(B, te, ae, le, de) {
        var _e = B[te];
        if (!c(_e)) {
          var ue = U(_e);
          return new A("Invalid " + le + " `" + de + "` of type " + ("`" + ue + "` supplied to `" + ae + "`, expected a single ReactElement."));
        }
        return null;
      }
      return T(J);
    }
    function P() {
      function J(B, te, ae, le, de) {
        var _e = B[te];
        if (!t.isValidElementType(_e)) {
          var ue = U(_e);
          return new A("Invalid " + le + " `" + de + "` of type " + ("`" + ue + "` supplied to `" + ae + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return T(J);
    }
    function z(J) {
      function B(te, ae, le, de, _e) {
        if (!(te[ae] instanceof J)) {
          var ue = J.name || b, Se = ie(te[ae]);
          return new A("Invalid " + de + " `" + _e + "` of type " + ("`" + Se + "` supplied to `" + le + "`, expected ") + ("instance of `" + ue + "`."));
        }
        return null;
      }
      return T(B);
    }
    function F(J) {
      if (!Array.isArray(J))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), s;
      function B(te, ae, le, de, _e) {
        for (var ue = te[ae], Se = 0; Se < J.length; Se++)
          if (_(ue, J[Se]))
            return null;
        var Ne = JSON.stringify(J, function(Ce, Ue) {
          var rt = q(Ue);
          return rt === "symbol" ? String(Ue) : Ue;
        });
        return new A("Invalid " + de + " `" + _e + "` of value `" + String(ue) + "` " + ("supplied to `" + le + "`, expected one of " + Ne + "."));
      }
      return T(B);
    }
    function $(J) {
      function B(te, ae, le, de, _e) {
        if (typeof J != "function")
          return new A("Property `" + _e + "` of component `" + le + "` has invalid PropType notation inside objectOf.");
        var ue = te[ae], Se = U(ue);
        if (Se !== "object")
          return new A("Invalid " + de + " `" + _e + "` of type " + ("`" + Se + "` supplied to `" + le + "`, expected an object."));
        for (var Ne in ue)
          if (r(ue, Ne)) {
            var Me = J(ue, Ne, le, de, _e + "." + Ne, n);
            if (Me instanceof Error)
              return Me;
          }
        return null;
      }
      return T(B);
    }
    function G(J) {
      if (!Array.isArray(J))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var B = 0; B < J.length; B++) {
        var te = J[B];
        if (typeof te != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + W(te) + " at index " + B + "."
          ), s;
      }
      function ae(le, de, _e, ue, Se) {
        for (var Ne = [], Me = 0; Me < J.length; Me++) {
          var Ce = J[Me], Ue = Ce(le, de, _e, ue, Se, n);
          if (Ue == null)
            return null;
          Ue.data && r(Ue.data, "expectedType") && Ne.push(Ue.data.expectedType);
        }
        var rt = Ne.length > 0 ? ", expected one of type [" + Ne.join(", ") + "]" : "";
        return new A("Invalid " + ue + " `" + Se + "` supplied to " + ("`" + _e + "`" + rt + "."));
      }
      return T(ae);
    }
    function H() {
      function J(B, te, ae, le, de) {
        return ee(B[te]) ? null : new A("Invalid " + le + " `" + de + "` supplied to " + ("`" + ae + "`, expected a ReactNode."));
      }
      return T(J);
    }
    function Z(J, B, te, ae, le) {
      return new A(
        (J || "React class") + ": " + B + " type `" + te + "." + ae + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + le + "`."
      );
    }
    function V(J) {
      function B(te, ae, le, de, _e) {
        var ue = te[ae], Se = U(ue);
        if (Se !== "object")
          return new A("Invalid " + de + " `" + _e + "` of type `" + Se + "` " + ("supplied to `" + le + "`, expected `object`."));
        for (var Ne in J) {
          var Me = J[Ne];
          if (typeof Me != "function")
            return Z(le, de, _e, Ne, q(Me));
          var Ce = Me(ue, Ne, le, de, _e + "." + Ne, n);
          if (Ce)
            return Ce;
        }
        return null;
      }
      return T(B);
    }
    function Y(J) {
      function B(te, ae, le, de, _e) {
        var ue = te[ae], Se = U(ue);
        if (Se !== "object")
          return new A("Invalid " + de + " `" + _e + "` of type `" + Se + "` " + ("supplied to `" + le + "`, expected `object`."));
        var Ne = e({}, te[ae], J);
        for (var Me in Ne) {
          var Ce = J[Me];
          if (r(J, Me) && typeof Ce != "function")
            return Z(le, de, _e, Me, q(Ce));
          if (!Ce)
            return new A(
              "Invalid " + de + " `" + _e + "` key `" + Me + "` supplied to `" + le + "`.\nBad object: " + JSON.stringify(te[ae], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(J), null, "  ")
            );
          var Ue = Ce(ue, Me, le, de, _e + "." + Me, n);
          if (Ue)
            return Ue;
        }
        return null;
      }
      return T(B);
    }
    function ee(J) {
      switch (typeof J) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !J;
        case "object":
          if (Array.isArray(J))
            return J.every(ee);
          if (J === null || c(J))
            return !0;
          var B = m(J);
          if (B) {
            var te = B.call(J), ae;
            if (B !== J.entries) {
              for (; !(ae = te.next()).done; )
                if (!ee(ae.value))
                  return !1;
            } else
              for (; !(ae = te.next()).done; ) {
                var le = ae.value;
                if (le && !ee(le[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function K(J, B) {
      return J === "symbol" ? !0 : B ? B["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && B instanceof Symbol : !1;
    }
    function U(J) {
      var B = typeof J;
      return Array.isArray(J) ? "array" : J instanceof RegExp ? "object" : K(B, J) ? "symbol" : B;
    }
    function q(J) {
      if (typeof J > "u" || J === null)
        return "" + J;
      var B = U(J);
      if (B === "object") {
        if (J instanceof Date)
          return "date";
        if (J instanceof RegExp)
          return "regexp";
      }
      return B;
    }
    function W(J) {
      var B = q(J);
      switch (B) {
        case "array":
        case "object":
          return "an " + B;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + B;
        default:
          return B;
      }
    }
    function ie(J) {
      return !J.constructor || !J.constructor.name ? b : J.constructor.name;
    }
    return w.checkPropTypes = i, w.resetWarningCache = i.resetWarningCache, w.PropTypes = w, w;
  }, D6;
}
var N6, vB;
function spe() {
  if (vB)
    return N6;
  vB = 1;
  var t = rI();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, N6 = function() {
    function r(s, c, d, f, g, m) {
      if (m !== t) {
        var b = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw b.name = "Invariant Violation", b;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return a.PropTypes = a, a;
  }, N6;
}
if (process.env.NODE_ENV !== "production") {
  var lpe = VG(), cpe = !0;
  O8.exports = ope()(lpe.isElement, cpe);
} else
  O8.exports = spe()();
var upe = O8.exports;
const Qe = /* @__PURE__ */ J0(upe);
var R8 = { exports: {} }, qr = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yB;
function dpe() {
  if (yB)
    return qr;
  yB = 1;
  var t = 60103, e = 60106, n = 60107, r = 60108, i = 60114, a = 60109, s = 60110, c = 60112, d = 60113, f = 60120, g = 60115, m = 60116, b = 60121, w = 60122, _ = 60117, A = 60129, T = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var O = Symbol.for;
    t = O("react.element"), e = O("react.portal"), n = O("react.fragment"), r = O("react.strict_mode"), i = O("react.profiler"), a = O("react.provider"), s = O("react.context"), c = O("react.forward_ref"), d = O("react.suspense"), f = O("react.suspense_list"), g = O("react.memo"), m = O("react.lazy"), b = O("react.block"), w = O("react.server.block"), _ = O("react.fundamental"), A = O("react.debug_trace_mode"), T = O("react.legacy_hidden");
  }
  function R(Y) {
    if (typeof Y == "object" && Y !== null) {
      var ee = Y.$$typeof;
      switch (ee) {
        case t:
          switch (Y = Y.type, Y) {
            case n:
            case i:
            case r:
            case d:
            case f:
              return Y;
            default:
              switch (Y = Y && Y.$$typeof, Y) {
                case s:
                case c:
                case m:
                case g:
                case a:
                  return Y;
                default:
                  return ee;
              }
          }
        case e:
          return ee;
      }
    }
  }
  var N = a, M = t, P = c, z = n, F = m, $ = g, G = e, H = i, Z = r, V = d;
  return qr.ContextConsumer = s, qr.ContextProvider = N, qr.Element = M, qr.ForwardRef = P, qr.Fragment = z, qr.Lazy = F, qr.Memo = $, qr.Portal = G, qr.Profiler = H, qr.StrictMode = Z, qr.Suspense = V, qr.isAsyncMode = function() {
    return !1;
  }, qr.isConcurrentMode = function() {
    return !1;
  }, qr.isContextConsumer = function(Y) {
    return R(Y) === s;
  }, qr.isContextProvider = function(Y) {
    return R(Y) === a;
  }, qr.isElement = function(Y) {
    return typeof Y == "object" && Y !== null && Y.$$typeof === t;
  }, qr.isForwardRef = function(Y) {
    return R(Y) === c;
  }, qr.isFragment = function(Y) {
    return R(Y) === n;
  }, qr.isLazy = function(Y) {
    return R(Y) === m;
  }, qr.isMemo = function(Y) {
    return R(Y) === g;
  }, qr.isPortal = function(Y) {
    return R(Y) === e;
  }, qr.isProfiler = function(Y) {
    return R(Y) === i;
  }, qr.isStrictMode = function(Y) {
    return R(Y) === r;
  }, qr.isSuspense = function(Y) {
    return R(Y) === d;
  }, qr.isValidElementType = function(Y) {
    return typeof Y == "string" || typeof Y == "function" || Y === n || Y === i || Y === A || Y === r || Y === d || Y === f || Y === T || typeof Y == "object" && Y !== null && (Y.$$typeof === m || Y.$$typeof === g || Y.$$typeof === a || Y.$$typeof === s || Y.$$typeof === c || Y.$$typeof === _ || Y.$$typeof === b || Y[0] === w);
  }, qr.typeOf = R, qr;
}
var Gr = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bB;
function fpe() {
  return bB || (bB = 1, process.env.NODE_ENV !== "production" && function() {
    var t = 60103, e = 60106, n = 60107, r = 60108, i = 60114, a = 60109, s = 60110, c = 60112, d = 60113, f = 60120, g = 60115, m = 60116, b = 60121, w = 60122, _ = 60117, A = 60129, T = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var O = Symbol.for;
      t = O("react.element"), e = O("react.portal"), n = O("react.fragment"), r = O("react.strict_mode"), i = O("react.profiler"), a = O("react.provider"), s = O("react.context"), c = O("react.forward_ref"), d = O("react.suspense"), f = O("react.suspense_list"), g = O("react.memo"), m = O("react.lazy"), b = O("react.block"), w = O("react.server.block"), _ = O("react.fundamental"), O("react.scope"), O("react.opaque.id"), A = O("react.debug_trace_mode"), O("react.offscreen"), T = O("react.legacy_hidden");
    }
    var R = !1;
    function N(Ce) {
      return !!(typeof Ce == "string" || typeof Ce == "function" || Ce === n || Ce === i || Ce === A || Ce === r || Ce === d || Ce === f || Ce === T || R || typeof Ce == "object" && Ce !== null && (Ce.$$typeof === m || Ce.$$typeof === g || Ce.$$typeof === a || Ce.$$typeof === s || Ce.$$typeof === c || Ce.$$typeof === _ || Ce.$$typeof === b || Ce[0] === w));
    }
    function M(Ce) {
      if (typeof Ce == "object" && Ce !== null) {
        var Ue = Ce.$$typeof;
        switch (Ue) {
          case t:
            var rt = Ce.type;
            switch (rt) {
              case n:
              case i:
              case r:
              case d:
              case f:
                return rt;
              default:
                var it = rt && rt.$$typeof;
                switch (it) {
                  case s:
                  case c:
                  case m:
                  case g:
                  case a:
                    return it;
                  default:
                    return Ue;
                }
            }
          case e:
            return Ue;
        }
      }
    }
    var P = s, z = a, F = t, $ = c, G = n, H = m, Z = g, V = e, Y = i, ee = r, K = d, U = !1, q = !1;
    function W(Ce) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ie(Ce) {
      return q || (q = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function J(Ce) {
      return M(Ce) === s;
    }
    function B(Ce) {
      return M(Ce) === a;
    }
    function te(Ce) {
      return typeof Ce == "object" && Ce !== null && Ce.$$typeof === t;
    }
    function ae(Ce) {
      return M(Ce) === c;
    }
    function le(Ce) {
      return M(Ce) === n;
    }
    function de(Ce) {
      return M(Ce) === m;
    }
    function _e(Ce) {
      return M(Ce) === g;
    }
    function ue(Ce) {
      return M(Ce) === e;
    }
    function Se(Ce) {
      return M(Ce) === i;
    }
    function Ne(Ce) {
      return M(Ce) === r;
    }
    function Me(Ce) {
      return M(Ce) === d;
    }
    Gr.ContextConsumer = P, Gr.ContextProvider = z, Gr.Element = F, Gr.ForwardRef = $, Gr.Fragment = G, Gr.Lazy = H, Gr.Memo = Z, Gr.Portal = V, Gr.Profiler = Y, Gr.StrictMode = ee, Gr.Suspense = K, Gr.isAsyncMode = W, Gr.isConcurrentMode = ie, Gr.isContextConsumer = J, Gr.isContextProvider = B, Gr.isElement = te, Gr.isForwardRef = ae, Gr.isFragment = le, Gr.isLazy = de, Gr.isMemo = _e, Gr.isPortal = ue, Gr.isProfiler = Se, Gr.isStrictMode = Ne, Gr.isSuspense = Me, Gr.isValidElementType = N, Gr.typeOf = M;
  }()), Gr;
}
process.env.NODE_ENV === "production" ? R8.exports = dpe() : R8.exports = fpe();
var wB = R8.exports;
let xB = (t) => typeof t == "object" && t != null && t.nodeType === 1, SB = (t, e) => (!e || t !== "hidden") && t !== "visible" && t !== "clip", M6 = (t, e) => {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    let n = getComputedStyle(t, null);
    return SB(n.overflowY, e) || SB(n.overflowX, e) || ((r) => {
      let i = ((a) => {
        if (!a.ownerDocument || !a.ownerDocument.defaultView)
          return null;
        try {
          return a.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!i && (i.clientHeight < r.scrollHeight || i.clientWidth < r.scrollWidth);
    })(t);
  }
  return !1;
}, MC = (t, e, n, r, i, a, s, c) => a < t && s > e || a > t && s < e ? 0 : a <= t && c <= n || s >= e && c >= n ? a - t - r : s > e && c < n || a < t && c > n ? s - e + i : 0, hpe = (t) => {
  let e = t.parentElement;
  return e ?? (t.getRootNode().host || null);
};
var ppe = (t, e) => {
  var n, r, i, a, s, c;
  if (typeof document > "u")
    return [];
  let { scrollMode: d, block: f, inline: g, boundary: m, skipOverflowHiddenElements: b } = e, w = typeof m == "function" ? m : (ee) => ee !== m;
  if (!xB(t))
    throw new TypeError("Invalid target");
  let _ = document.scrollingElement || document.documentElement, A = [], T = t;
  for (; xB(T) && w(T); ) {
    if (T = hpe(T), T === _) {
      A.push(T);
      break;
    }
    T != null && T === document.body && M6(T) && !M6(document.documentElement) || T != null && M6(T, b) && A.push(T);
  }
  let O = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, R = (a = (i = window.visualViewport) == null ? void 0 : i.height) != null ? a : innerHeight, N = (s = window.scrollX) != null ? s : pageXOffset, M = (c = window.scrollY) != null ? c : pageYOffset, { height: P, width: z, top: F, right: $, bottom: G, left: H } = t.getBoundingClientRect(), Z = f === "start" || f === "nearest" ? F : f === "end" ? G : F + P / 2, V = g === "center" ? H + z / 2 : g === "end" ? $ : H, Y = [];
  for (let ee = 0; ee < A.length; ee++) {
    let K = A[ee], { height: U, width: q, top: W, right: ie, bottom: J, left: B } = K.getBoundingClientRect();
    if (d === "if-needed" && F >= 0 && H >= 0 && G <= R && $ <= O && F >= W && G <= J && H >= B && $ <= ie)
      return Y;
    let te = getComputedStyle(K), ae = parseInt(te.borderLeftWidth, 10), le = parseInt(te.borderTopWidth, 10), de = parseInt(te.borderRightWidth, 10), _e = parseInt(te.borderBottomWidth, 10), ue = 0, Se = 0, Ne = "offsetWidth" in K ? K.offsetWidth - K.clientWidth - ae - de : 0, Me = "offsetHeight" in K ? K.offsetHeight - K.clientHeight - le - _e : 0, Ce = "offsetWidth" in K ? K.offsetWidth === 0 ? 0 : q / K.offsetWidth : 0, Ue = "offsetHeight" in K ? K.offsetHeight === 0 ? 0 : U / K.offsetHeight : 0;
    if (_ === K)
      ue = f === "start" ? Z : f === "end" ? Z - R : f === "nearest" ? MC(M, M + R, R, le, _e, M + Z, M + Z + P, P) : Z - R / 2, Se = g === "start" ? V : g === "center" ? V - O / 2 : g === "end" ? V - O : MC(N, N + O, O, ae, de, N + V, N + V + z, z), ue = Math.max(0, ue + M), Se = Math.max(0, Se + N);
    else {
      ue = f === "start" ? Z - W - le : f === "end" ? Z - J + _e + Me : f === "nearest" ? MC(W, J, U, le, _e + Me, Z, Z + P, P) : Z - (W + U / 2) + Me / 2, Se = g === "start" ? V - B - ae : g === "center" ? V - (B + q / 2) + Ne / 2 : g === "end" ? V - ie + de + Ne : MC(B, ie, q, ae, de + Ne, V, V + z, z);
      let { scrollLeft: rt, scrollTop: it } = K;
      ue = Math.max(0, Math.min(it + ue / Ue, K.scrollHeight - U / Ue + Me)), Se = Math.max(0, Math.min(rt + Se / Ce, K.scrollWidth - q / Ce + Ne)), Z += it - ue, V += rt - Se;
    }
    Y.push({ el: K, top: ue, left: Se });
  }
  return Y;
}, mpe = 0;
function EB(t) {
  return typeof t == "function" ? t : Hc;
}
function Hc() {
}
function $G(t, e) {
  if (t) {
    var n = ppe(t, {
      boundary: e,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var i = r.el, a = r.top, s = r.left;
      i.scrollTop = a, i.scrollLeft = s;
    });
  }
}
function _B(t, e, n) {
  var r = t === e || e instanceof n.Node && t.contains && t.contains(e);
  return r;
}
function iI(t, e) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function i() {
    for (var a = arguments.length, s = new Array(a), c = 0; c < a; c++)
      s[c] = arguments[c];
    r(), n = setTimeout(function() {
      n = null, t.apply(void 0, s);
    }, e);
  }
  return i.cancel = r, i;
}
function za() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
      a[s - 1] = arguments[s];
    return e.some(function(c) {
      return c && c.apply(void 0, [r].concat(a)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function wb() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    e.forEach(function(i) {
      typeof i == "function" ? i(r) : i && (i.current = r);
    });
  };
}
function HG() {
  return String(mpe++);
}
function qG(t) {
  var e = t.isOpen, n = t.resultCount, r = t.previousResultCount;
  return e ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function AB(t, e) {
  return t = Array.isArray(t) ? (
    /* istanbul ignore next (preact) */
    t[0]
  ) : t, !t && e ? e : t;
}
function GG(t) {
  return typeof t.type == "string";
}
function YG(t) {
  return t.props;
}
function gpe(t, e) {
  console.error('The property "' + e + '" is required in "' + t + '"');
}
var vpe = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function IC(t) {
  t === void 0 && (t = {});
  var e = {};
  return vpe.forEach(function(n) {
    t.hasOwnProperty(n) && (e[n] = t[n]);
  }), e;
}
function wT(t, e) {
  return Object.keys(t).reduce(function(n, r) {
    return n[r] = xT(e, r) ? e[r] : t[r], n;
  }, {});
}
function xT(t, e) {
  return t[e] !== void 0;
}
function D8(t) {
  var e = t.key, n = t.keyCode;
  return n >= 37 && n <= 40 && e.indexOf("Arrow") !== 0 ? "Arrow" + e : e;
}
function ype(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function ng(t, e, n, r, i) {
  if (i === void 0 && (i = !0), n === 0)
    return -1;
  var a = n - 1;
  (typeof e != "number" || e < 0 || e >= n) && (e = t > 0 ? -1 : a + 1);
  var s = e + t;
  s < 0 ? s = i ? a : 0 : s > a && (s = i ? 0 : a);
  var c = Sg(t, s, n, r, i);
  return c === -1 ? e >= n ? -1 : e : c;
}
function Sg(t, e, n, r, i) {
  var a = r(e);
  if (!a || !a.hasAttribute("disabled"))
    return e;
  if (t > 0) {
    for (var s = e + 1; s < n; s++)
      if (!r(s).hasAttribute("disabled"))
        return s;
  } else
    for (var c = e - 1; c >= 0; c--)
      if (!r(c).hasAttribute("disabled"))
        return c;
  return i ? t > 0 ? Sg(1, 0, n, r, !1) : Sg(-1, n - 1, n, r, !1) : -1;
}
function ST(t, e, n, r) {
  return r === void 0 && (r = !0), e.some(function(i) {
    return i && (_B(i, t, n) || r && _B(i, n.document.activeElement, n));
  });
}
var aI = Hc;
process.env.NODE_ENV !== "production" && (aI = function(e, n, r) {
  var i = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(e).forEach(function(a) {
    n[a] !== void 0 && r[a] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + a + '" to be uncontrolled. ' + i) : n[a] === void 0 && r[a] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + a + '" to be controlled. ' + i);
  });
});
var bpe = iI(function(t) {
  WG(t).textContent = "";
}, 500);
function XG(t, e) {
  var n = WG(e);
  t && (n.textContent = t, bpe(e));
}
function WG(t) {
  t === void 0 && (t = document);
  var e = t.getElementById("a11y-status-message");
  return e || (e = t.createElement("div"), e.setAttribute("id", "a11y-status-message"), e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-relevant", "additions text"), Object.assign(e.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), t.body.appendChild(e), e);
}
var QG = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, ZG = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, KG = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, p4 = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, m4 = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, JG = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, eY = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, tY = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, nY = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, rY = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, iY = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, aY = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, oY = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, N8 = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, sY = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, lY = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, cY = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, wpe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: QG,
  mouseUp: ZG,
  itemMouseEnter: KG,
  keyDownArrowUp: p4,
  keyDownArrowDown: m4,
  keyDownEscape: JG,
  keyDownEnter: eY,
  keyDownHome: tY,
  keyDownEnd: nY,
  clickItem: rY,
  blurInput: iY,
  changeInput: aY,
  keyDownSpaceButton: oY,
  clickButton: N8,
  blurButton: sY,
  controlledPropUpdatedSelectedItem: lY,
  touchEnd: cY
}), xpe = ["refKey", "ref"], Spe = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], Epe = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], _pe = ["refKey", "ref"], Ape = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], Cpe = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ function(e) {
    tpe(n, e);
    function n(i) {
      var a;
      a = e.call(this, i) || this, a.id = a.props.id || "downshift-" + HG(), a.menuId = a.props.menuId || a.id + "-menu", a.labelId = a.props.labelId || a.id + "-label", a.inputId = a.props.inputId || a.id + "-input", a.getItemId = a.props.getItemId || function(R) {
        return a.id + "-item-" + R;
      }, a.input = null, a.items = [], a.itemCount = null, a.previousResultCount = 0, a.timeoutIds = [], a.internalSetTimeout = function(R, N) {
        var M = setTimeout(function() {
          a.timeoutIds = a.timeoutIds.filter(function(P) {
            return P !== M;
          }), R();
        }, N);
        a.timeoutIds.push(M);
      }, a.setItemCount = function(R) {
        a.itemCount = R;
      }, a.unsetItemCount = function() {
        a.itemCount = null;
      }, a.setHighlightedIndex = function(R, N) {
        R === void 0 && (R = a.props.defaultHighlightedIndex), N === void 0 && (N = {}), N = IC(N), a.internalSetState(Nn({
          highlightedIndex: R
        }, N));
      }, a.clearSelection = function(R) {
        a.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: a.props.defaultHighlightedIndex,
          isOpen: a.props.defaultIsOpen
        }, R);
      }, a.selectItem = function(R, N, M) {
        N = IC(N), a.internalSetState(Nn({
          isOpen: a.props.defaultIsOpen,
          highlightedIndex: a.props.defaultHighlightedIndex,
          selectedItem: R,
          inputValue: a.props.itemToString(R)
        }, N), M);
      }, a.selectItemAtIndex = function(R, N, M) {
        var P = a.items[R];
        P != null && a.selectItem(P, N, M);
      }, a.selectHighlightedItem = function(R, N) {
        return a.selectItemAtIndex(a.getState().highlightedIndex, R, N);
      }, a.internalSetState = function(R, N) {
        var M, P, z = {}, F = typeof R == "function";
        return !F && R.hasOwnProperty("inputValue") && a.props.onInputValueChange(R.inputValue, Nn({}, a.getStateAndHelpers(), R)), a.setState(function($) {
          $ = a.getState($);
          var G = F ? R($) : R;
          G = a.props.stateReducer($, G), M = G.hasOwnProperty("selectedItem");
          var H = {};
          return M && G.selectedItem !== $.selectedItem && (P = G.selectedItem), G.type = G.type || QG, Object.keys(G).forEach(function(Z) {
            $[Z] !== G[Z] && (z[Z] = G[Z]), Z !== "type" && (G[Z], xT(a.props, Z) || (H[Z] = G[Z]));
          }), F && G.hasOwnProperty("inputValue") && a.props.onInputValueChange(G.inputValue, Nn({}, a.getStateAndHelpers(), G)), H;
        }, function() {
          EB(N)();
          var $ = Object.keys(z).length > 1;
          $ && a.props.onStateChange(z, a.getStateAndHelpers()), M && a.props.onSelect(R.selectedItem, a.getStateAndHelpers()), P !== void 0 && a.props.onChange(P, a.getStateAndHelpers()), a.props.onUserAction(z, a.getStateAndHelpers());
        });
      }, a.rootRef = function(R) {
        return a._rootNode = R;
      }, a.getRootProps = function(R, N) {
        var M, P = R === void 0 ? {} : R, z = P.refKey, F = z === void 0 ? "ref" : z, $ = P.ref, G = Ud(P, xpe), H = N === void 0 ? {} : N, Z = H.suppressRefError, V = Z === void 0 ? !1 : Z;
        a.getRootProps.called = !0, a.getRootProps.refKey = F, a.getRootProps.suppressRefError = V;
        var Y = a.getState(), ee = Y.isOpen;
        return Nn((M = {}, M[F] = wb($, a.rootRef), M.role = "combobox", M["aria-expanded"] = ee, M["aria-haspopup"] = "listbox", M["aria-owns"] = ee ? a.menuId : null, M["aria-labelledby"] = a.labelId, M), G);
      }, a.keyDownHandlers = {
        ArrowDown: function(N) {
          var M = this;
          if (N.preventDefault(), this.getState().isOpen) {
            var P = N.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(P, {
              type: m4
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: m4
            }, function() {
              var z = M.getItemCount();
              if (z > 0) {
                var F = M.getState(), $ = F.highlightedIndex, G = ng(1, $, z, function(H) {
                  return M.getItemNodeFromIndex(H);
                });
                M.setHighlightedIndex(G, {
                  type: m4
                });
              }
            });
        },
        ArrowUp: function(N) {
          var M = this;
          if (N.preventDefault(), this.getState().isOpen) {
            var P = N.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(P, {
              type: p4
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: p4
            }, function() {
              var z = M.getItemCount();
              if (z > 0) {
                var F = M.getState(), $ = F.highlightedIndex, G = ng(-1, $, z, function(H) {
                  return M.getItemNodeFromIndex(H);
                });
                M.setHighlightedIndex(G, {
                  type: p4
                });
              }
            });
        },
        Enter: function(N) {
          if (N.which !== 229) {
            var M = this.getState(), P = M.isOpen, z = M.highlightedIndex;
            if (P && z != null) {
              N.preventDefault();
              var F = this.items[z], $ = this.getItemNodeFromIndex(z);
              if (F == null || $ && $.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: eY
              });
            }
          }
        },
        Escape: function(N) {
          N.preventDefault(), this.reset(Nn({
            type: JG
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, a.buttonKeyDownHandlers = Nn({}, a.keyDownHandlers, {
        " ": function(N) {
          N.preventDefault(), this.toggleMenu({
            type: oY
          });
        }
      }), a.inputKeyDownHandlers = Nn({}, a.keyDownHandlers, {
        Home: function(N) {
          var M = this, P = this.getState(), z = P.isOpen;
          if (z) {
            N.preventDefault();
            var F = this.getItemCount();
            if (!(F <= 0 || !z)) {
              var $ = Sg(1, 0, F, function(G) {
                return M.getItemNodeFromIndex(G);
              }, !1);
              this.setHighlightedIndex($, {
                type: tY
              });
            }
          }
        },
        End: function(N) {
          var M = this, P = this.getState(), z = P.isOpen;
          if (z) {
            N.preventDefault();
            var F = this.getItemCount();
            if (!(F <= 0 || !z)) {
              var $ = Sg(-1, F - 1, F, function(G) {
                return M.getItemNodeFromIndex(G);
              }, !1);
              this.setHighlightedIndex($, {
                type: nY
              });
            }
          }
        }
      }), a.getToggleButtonProps = function(R) {
        var N = R === void 0 ? {} : R, M = N.onClick;
        N.onPress;
        var P = N.onKeyDown, z = N.onKeyUp, F = N.onBlur, $ = Ud(N, Spe), G = a.getState(), H = G.isOpen, Z = {
          onClick: za(M, a.buttonHandleClick),
          onKeyDown: za(P, a.buttonHandleKeyDown),
          onKeyUp: za(z, a.buttonHandleKeyUp),
          onBlur: za(F, a.buttonHandleBlur)
        }, V = $.disabled ? {} : Z;
        return Nn({
          type: "button",
          role: "button",
          "aria-label": H ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, V, $);
      }, a.buttonHandleKeyUp = function(R) {
        R.preventDefault();
      }, a.buttonHandleKeyDown = function(R) {
        var N = D8(R);
        a.buttonKeyDownHandlers[N] && a.buttonKeyDownHandlers[N].call(lB(a), R);
      }, a.buttonHandleClick = function(R) {
        R.preventDefault(), a.props.environment.document.activeElement === a.props.environment.document.body && R.target.focus(), process.env.NODE_ENV === "test" ? a.toggleMenu({
          type: N8
        }) : a.internalSetTimeout(function() {
          return a.toggleMenu({
            type: N8
          });
        });
      }, a.buttonHandleBlur = function(R) {
        var N = R.target;
        a.internalSetTimeout(function() {
          !a.isMouseDown && (a.props.environment.document.activeElement == null || a.props.environment.document.activeElement.id !== a.inputId) && a.props.environment.document.activeElement !== N && a.reset({
            type: sY
          });
        });
      }, a.getLabelProps = function(R) {
        return Nn({
          htmlFor: a.inputId,
          id: a.labelId
        }, R);
      }, a.getInputProps = function(R) {
        var N = R === void 0 ? {} : R, M = N.onKeyDown, P = N.onBlur, z = N.onChange, F = N.onInput;
        N.onChangeText;
        var $ = Ud(N, Epe), G, H = {};
        G = "onChange";
        var Z = a.getState(), V = Z.inputValue, Y = Z.isOpen, ee = Z.highlightedIndex;
        if (!$.disabled) {
          var K;
          H = (K = {}, K[G] = za(z, F, a.inputHandleChange), K.onKeyDown = za(M, a.inputHandleKeyDown), K.onBlur = za(P, a.inputHandleBlur), K);
        }
        return Nn({
          "aria-autocomplete": "list",
          "aria-activedescendant": Y && typeof ee == "number" && ee >= 0 ? a.getItemId(ee) : null,
          "aria-controls": Y ? a.menuId : null,
          "aria-labelledby": $ && $["aria-label"] ? void 0 : a.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: V,
          id: a.inputId
        }, H, $);
      }, a.inputHandleKeyDown = function(R) {
        var N = D8(R);
        N && a.inputKeyDownHandlers[N] && a.inputKeyDownHandlers[N].call(lB(a), R);
      }, a.inputHandleChange = function(R) {
        a.internalSetState({
          type: aY,
          isOpen: !0,
          inputValue: R.target.value,
          highlightedIndex: a.props.defaultHighlightedIndex
        });
      }, a.inputHandleBlur = function() {
        a.internalSetTimeout(function() {
          var R = a.props.environment.document && !!a.props.environment.document.activeElement && !!a.props.environment.document.activeElement.dataset && a.props.environment.document.activeElement.dataset.toggle && a._rootNode && a._rootNode.contains(a.props.environment.document.activeElement);
          !a.isMouseDown && !R && a.reset({
            type: iY
          });
        });
      }, a.menuRef = function(R) {
        a._menuNode = R;
      }, a.getMenuProps = function(R, N) {
        var M, P = R === void 0 ? {} : R, z = P.refKey, F = z === void 0 ? "ref" : z, $ = P.ref, G = Ud(P, _pe), H = N === void 0 ? {} : N, Z = H.suppressRefError, V = Z === void 0 ? !1 : Z;
        return a.getMenuProps.called = !0, a.getMenuProps.refKey = F, a.getMenuProps.suppressRefError = V, Nn((M = {}, M[F] = wb($, a.menuRef), M.role = "listbox", M["aria-labelledby"] = G && G["aria-label"] ? null : a.labelId, M.id = a.menuId, M), G);
      }, a.getItemProps = function(R) {
        var N, M = R === void 0 ? {} : R, P = M.onMouseMove, z = M.onMouseDown, F = M.onClick;
        M.onPress;
        var $ = M.index, G = M.item, H = G === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : gpe("getItemProps", "item") : G, Z = Ud(M, Ape);
        $ === void 0 ? (a.items.push(H), $ = a.items.indexOf(H)) : a.items[$] = H;
        var V = "onClick", Y = F, ee = (N = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: za(P, function() {
            $ !== a.getState().highlightedIndex && (a.setHighlightedIndex($, {
              type: KG
            }), a.avoidScrolling = !0, a.internalSetTimeout(function() {
              return a.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: za(z, function(U) {
            U.preventDefault();
          })
        }, N[V] = za(Y, function() {
          a.selectItemAtIndex($, {
            type: rY
          });
        }), N), K = Z.disabled ? {
          onMouseDown: ee.onMouseDown
        } : ee;
        return Nn({
          id: a.getItemId($),
          role: "option",
          "aria-selected": a.getState().highlightedIndex === $
        }, K, Z);
      }, a.clearItems = function() {
        a.items = [];
      }, a.reset = function(R, N) {
        R === void 0 && (R = {}), R = IC(R), a.internalSetState(function(M) {
          var P = M.selectedItem;
          return Nn({
            isOpen: a.props.defaultIsOpen,
            highlightedIndex: a.props.defaultHighlightedIndex,
            inputValue: a.props.itemToString(P)
          }, R);
        }, N);
      }, a.toggleMenu = function(R, N) {
        R === void 0 && (R = {}), R = IC(R), a.internalSetState(function(M) {
          var P = M.isOpen;
          return Nn({
            isOpen: !P
          }, P && {
            highlightedIndex: a.props.defaultHighlightedIndex
          }, R);
        }, function() {
          var M = a.getState(), P = M.isOpen, z = M.highlightedIndex;
          P && a.getItemCount() > 0 && typeof z == "number" && a.setHighlightedIndex(z, R), EB(N)();
        });
      }, a.openMenu = function(R) {
        a.internalSetState({
          isOpen: !0
        }, R);
      }, a.closeMenu = function(R) {
        a.internalSetState({
          isOpen: !1
        }, R);
      }, a.updateStatus = iI(function() {
        var R = a.getState(), N = a.items[R.highlightedIndex], M = a.getItemCount(), P = a.props.getA11yStatusMessage(Nn({
          itemToString: a.props.itemToString,
          previousResultCount: a.previousResultCount,
          resultCount: M,
          highlightedItem: N
        }, R));
        a.previousResultCount = M, XG(P, a.props.environment.document);
      }, 200);
      var s = a.props, c = s.defaultHighlightedIndex, d = s.initialHighlightedIndex, f = d === void 0 ? c : d, g = s.defaultIsOpen, m = s.initialIsOpen, b = m === void 0 ? g : m, w = s.initialInputValue, _ = w === void 0 ? "" : w, A = s.initialSelectedItem, T = A === void 0 ? null : A, O = a.getState({
        highlightedIndex: f,
        isOpen: b,
        inputValue: _,
        selectedItem: T
      });
      return O.selectedItem != null && a.props.initialInputValue === void 0 && (O.inputValue = a.props.itemToString(O.selectedItem)), a.state = O, a;
    }
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(a) {
        clearTimeout(a);
      }), this.timeoutIds = [];
    }, r.getState = function(a) {
      return a === void 0 && (a = this.state), wT(a, this.props);
    }, r.getItemCount = function() {
      var a = this.items.length;
      return this.itemCount != null ? a = this.itemCount : this.props.itemCount !== void 0 && (a = this.props.itemCount), a;
    }, r.getItemNodeFromIndex = function(a) {
      return this.props.environment.document.getElementById(this.getItemId(a));
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var a = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(a, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(a, s) {
      var c = this, d = this.getItemCount(), f = this.getState(), g = f.highlightedIndex;
      if (d > 0) {
        var m = ng(a, g, d, function(b) {
          return c.getItemNodeFromIndex(b);
        });
        this.setHighlightedIndex(m, s);
      }
    }, r.getStateAndHelpers = function() {
      var a = this.getState(), s = a.highlightedIndex, c = a.inputValue, d = a.selectedItem, f = a.isOpen, g = this.props.itemToString, m = this.id, b = this.getRootProps, w = this.getToggleButtonProps, _ = this.getLabelProps, A = this.getMenuProps, T = this.getInputProps, O = this.getItemProps, R = this.openMenu, N = this.closeMenu, M = this.toggleMenu, P = this.selectItem, z = this.selectItemAtIndex, F = this.selectHighlightedItem, $ = this.setHighlightedIndex, G = this.clearSelection, H = this.clearItems, Z = this.reset, V = this.setItemCount, Y = this.unsetItemCount, ee = this.internalSetState;
      return {
        // prop getters
        getRootProps: b,
        getToggleButtonProps: w,
        getLabelProps: _,
        getMenuProps: A,
        getInputProps: T,
        getItemProps: O,
        // actions
        reset: Z,
        openMenu: R,
        closeMenu: N,
        toggleMenu: M,
        selectItem: P,
        selectItemAtIndex: z,
        selectHighlightedItem: F,
        setHighlightedIndex: $,
        clearSelection: G,
        clearItems: H,
        setItemCount: V,
        unsetItemCount: Y,
        setState: ee,
        // props
        itemToString: g,
        // derived
        id: m,
        // state
        highlightedIndex: s,
        inputValue: c,
        isOpen: f,
        selectedItem: d
      };
    }, r.componentDidMount = function() {
      var a = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && CB(this._menuNode, this.getMenuProps);
      {
        var s = function() {
          a.isMouseDown = !0;
        }, c = function(w) {
          a.isMouseDown = !1;
          var _ = ST(w.target, [a._rootNode, a._menuNode], a.props.environment);
          !_ && a.getState().isOpen && a.reset({
            type: ZG
          }, function() {
            return a.props.onOuterClick(a.getStateAndHelpers());
          });
        }, d = function() {
          a.isTouchMove = !1;
        }, f = function() {
          a.isTouchMove = !0;
        }, g = function(w) {
          var _ = ST(w.target, [a._rootNode, a._menuNode], a.props.environment, !1);
          !a.isTouchMove && !_ && a.getState().isOpen && a.reset({
            type: cY
          }, function() {
            return a.props.onOuterClick(a.getStateAndHelpers());
          });
        }, m = this.props.environment;
        m.addEventListener("mousedown", s), m.addEventListener("mouseup", c), m.addEventListener("touchstart", d), m.addEventListener("touchmove", f), m.addEventListener("touchend", g), this.cleanup = function() {
          a.internalClearTimeouts(), a.updateStatus.cancel(), m.removeEventListener("mousedown", s), m.removeEventListener("mouseup", c), m.removeEventListener("touchstart", d), m.removeEventListener("touchmove", f), m.removeEventListener("touchend", g);
        };
      }
    }, r.shouldScroll = function(a, s) {
      var c = this.props.highlightedIndex === void 0 ? this.getState() : this.props, d = c.highlightedIndex, f = s.highlightedIndex === void 0 ? a : s, g = f.highlightedIndex, m = d && this.getState().isOpen && !a.isOpen, b = d !== g;
      return m || b;
    }, r.componentDidUpdate = function(a, s) {
      process.env.NODE_ENV !== "production" && (aI(this.state, a, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && CB(this._menuNode, this.getMenuProps)), xT(this.props, "selectedItem") && this.props.selectedItemChanged(a.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: lY,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(s, a) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var a = AB(this.props.children, Hc);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var s = AB(a(this.getStateAndHelpers()));
      if (!s)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && Tpe(s, this.getRootProps), s;
      if (GG(s))
        return /* @__PURE__ */ I.cloneElement(s, this.getRootProps(YG(s)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(I.Component);
  return t.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: qG,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && ype(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: Hc,
    onInputValueChange: Hc,
    onUserAction: Hc,
    onChange: Hc,
    onSelect: Hc,
    onOuterClick: Hc,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: $G
  }, t.stateChangeTypes = wpe, t;
}();
process.env.NODE_ENV !== "production" && (Cpe.propTypes = {
  children: Qe.func,
  defaultHighlightedIndex: Qe.number,
  defaultIsOpen: Qe.bool,
  initialHighlightedIndex: Qe.number,
  initialSelectedItem: Qe.any,
  initialInputValue: Qe.string,
  initialIsOpen: Qe.bool,
  getA11yStatusMessage: Qe.func,
  itemToString: Qe.func,
  onChange: Qe.func,
  onSelect: Qe.func,
  onStateChange: Qe.func,
  onInputValueChange: Qe.func,
  onUserAction: Qe.func,
  onOuterClick: Qe.func,
  selectedItemChanged: Qe.func,
  stateReducer: Qe.func,
  itemCount: Qe.number,
  id: Qe.string,
  environment: Qe.shape({
    addEventListener: Qe.func,
    removeEventListener: Qe.func,
    document: Qe.shape({
      getElementById: Qe.func,
      activeElement: Qe.any,
      body: Qe.any
    })
  }),
  suppressRefError: Qe.bool,
  scrollIntoView: Qe.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: Qe.any,
  isOpen: Qe.bool,
  inputValue: Qe.string,
  highlightedIndex: Qe.number,
  labelId: Qe.string,
  inputId: Qe.string,
  menuId: Qe.string,
  getItemId: Qe.func
  /* eslint-enable react/no-unused-prop-types */
});
function CB(t, e) {
  var n = e.refKey;
  t || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function Tpe(t, e) {
  var n = e.refKey, r = n !== "ref", i = !GG(t);
  i && !r && !wB.isForwardRef(t) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !i && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !wB.isForwardRef(t) && !YG(t)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var Ope = ["isInitialMount", "highlightedIndex", "items", "environment"], uY = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function Rpe(t, e, n) {
  var r = t.props, i = t.type, a = {};
  Object.keys(e).forEach(function(s) {
    Dpe(s, t, e, n), n[s] !== e[s] && (a[s] = n[s]);
  }), r.onStateChange && Object.keys(a).length && r.onStateChange(Nn({
    type: i
  }, a));
}
function Dpe(t, e, n, r) {
  var i = e.props, a = e.type, s = "on" + oI(t) + "Change";
  i[s] && r[t] !== void 0 && r[t] !== n[t] && i[s](Nn({
    type: a
  }, r));
}
function Npe(t, e) {
  return e.changes;
}
function Mpe(t) {
  var e = t.selectedItem, n = t.itemToString;
  return e ? n(e) + " has been selected." : "";
}
var Ipe = iI(function(t, e) {
  XG(t(), e);
}, 200), kpe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? I.useLayoutEffect : I.useEffect;
function jpe(t) {
  var e = t.id, n = e === void 0 ? "downshift-" + HG() : e, r = t.labelId, i = t.menuId, a = t.getItemId, s = t.toggleButtonId, c = t.inputId, d = I.useRef({
    labelId: r || n + "-label",
    menuId: i || n + "-menu",
    getItemId: a || function(f) {
      return n + "-item-" + f;
    },
    toggleButtonId: s || n + "-toggle-button",
    inputId: c || n + "-input"
  });
  return d.current;
}
function Ppe(t, e, n, r) {
  var i, a;
  if (t === void 0) {
    if (e === void 0)
      throw new Error(r);
    i = n[e], a = e;
  } else
    a = e === void 0 ? n.indexOf(t) : e, i = t;
  return [i, a];
}
function Lpe(t) {
  return t ? String(t) : "";
}
function oI(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function dY(t) {
  var e = I.useRef(t);
  return e.current = t, e;
}
function Bpe(t, e, n) {
  var r = I.useRef(), i = I.useRef(), a = I.useCallback(function(b, w) {
    i.current = w, b = wT(b, w.props);
    var _ = t(b, w), A = w.props.stateReducer(b, Nn({}, w, {
      changes: _
    }));
    return A;
  }, [t]), s = I.useReducer(a, e), c = s[0], d = s[1], f = dY(n), g = I.useCallback(function(b) {
    return d(Nn({
      props: f.current
    }, b));
  }, [f]), m = i.current;
  return I.useEffect(function() {
    m && r.current && r.current !== c && Rpe(m, wT(r.current, m.props), c), r.current = c;
  }, [c, n, m]), [c, g];
}
var fE = {
  itemToString: Lpe,
  stateReducer: Npe,
  getA11ySelectionMessage: Mpe,
  scrollIntoView: $G,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
function $d(t, e, n) {
  n === void 0 && (n = uY);
  var r = t["default" + oI(e)];
  return r !== void 0 ? r : n[e];
}
function kC(t, e, n) {
  n === void 0 && (n = uY);
  var r = t[e];
  if (r !== void 0)
    return r;
  var i = t["initial" + oI(e)];
  return i !== void 0 ? i : $d(t, e, n);
}
function zpe(t) {
  var e = kC(t, "selectedItem"), n = kC(t, "isOpen"), r = kC(t, "highlightedIndex"), i = kC(t, "inputValue");
  return {
    highlightedIndex: r < 0 && e && n ? t.items.indexOf(e) : r,
    isOpen: n,
    selectedItem: e,
    inputValue: i
  };
}
function hE(t, e, n) {
  var r = t.items, i = t.initialHighlightedIndex, a = t.defaultHighlightedIndex, s = e.selectedItem, c = e.highlightedIndex;
  return r.length === 0 ? -1 : i !== void 0 && c === i ? i : a !== void 0 ? a : s ? r.indexOf(s) : n === 0 ? -1 : n < 0 ? r.length - 1 : 0;
}
function Fpe(t, e, n, r) {
  var i = I.useRef({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return I.useEffect(function() {
    if (n?.addEventListener != null) {
      var a = function() {
        i.current.isMouseDown = !0;
      }, s = function(m) {
        i.current.isMouseDown = !1, t && !ST(m.target, e.map(function(b) {
          return b.current;
        }), n) && r();
      }, c = function() {
        i.current.isTouchMove = !1;
      }, d = function() {
        i.current.isTouchMove = !0;
      }, f = function(m) {
        t && !i.current.isTouchMove && !ST(m.target, e.map(function(b) {
          return b.current;
        }), n, !1) && r();
      };
      return n.addEventListener("mousedown", a), n.addEventListener("mouseup", s), n.addEventListener("touchstart", c), n.addEventListener("touchmove", d), n.addEventListener("touchend", f), function() {
        n.removeEventListener("mousedown", a), n.removeEventListener("mouseup", s), n.removeEventListener("touchstart", c), n.removeEventListener("touchmove", d), n.removeEventListener("touchend", f);
      };
    }
  }, [t, n]), i;
}
var fY = function() {
  return Hc;
};
process.env.NODE_ENV !== "production" && (fY = function() {
  for (var e = I.useRef(!0), n = arguments.length, r = new Array(n), i = 0; i < n; i++)
    r[i] = arguments[i];
  var a = I.useRef(r.reduce(function(c, d) {
    return c[d] = {}, c;
  }, {}));
  I.useEffect(function() {
    Object.keys(a.current).forEach(function(c) {
      var d = a.current[c];
      if (e.current && !Object.keys(d).length) {
        console.error("downshift: You forgot to call the " + c + " getter function on your component / element.");
        return;
      }
      var f = d.suppressRefError, g = d.refKey, m = d.elementRef;
      (!m || !m.current) && !f && console.error('downshift: The ref prop "' + g + '" from ' + c + " was not applied correctly on your element.");
    }), e.current = !1;
  });
  var s = I.useCallback(function(c, d, f, g) {
    a.current[c] = {
      suppressRefError: d,
      refKey: f,
      elementRef: g
    };
  }, []);
  return s;
});
function TB(t, e, n) {
  var r = n.isInitialMount, i = n.highlightedIndex, a = n.items, s = n.environment, c = Ud(n, Ope);
  I.useEffect(function() {
    r || Ipe(function() {
      return t(Nn({
        highlightedIndex: i,
        highlightedItem: a[i],
        resultCount: a.length
      }, c));
    }, s.document);
  }, e);
}
function Vpe(t) {
  var e = t.highlightedIndex, n = t.isOpen, r = t.itemRefs, i = t.getItemNodeFromIndex, a = t.menuElement, s = t.scrollIntoView, c = I.useRef(!0);
  return kpe(function() {
    e < 0 || !n || !Object.keys(r.current).length || (c.current === !1 ? c.current = !0 : s(i(e), a));
  }, [e]), c;
}
var hY = Hc;
process.env.NODE_ENV !== "production" && (hY = function(e) {
  var n = e.isInitialMount, r = e.props, i = e.state, a = I.useRef(r);
  I.useEffect(function() {
    n || (aI(i, a.current, r), a.current = r);
  }, [i, r, n]);
});
function OB(t, e, n) {
  var r;
  n === void 0 && (n = !0);
  var i = ((r = t.items) == null ? void 0 : r.length) && e >= 0;
  return Nn({
    isOpen: !1,
    highlightedIndex: -1
  }, i && Nn({
    selectedItem: t.items[e],
    isOpen: $d(t, "isOpen"),
    highlightedIndex: $d(t, "highlightedIndex")
  }, n && {
    inputValue: t.itemToString(t.items[e])
  }));
}
function Upe(t, e, n) {
  var r = e.type, i = e.props, a;
  switch (r) {
    case n.ItemMouseMove:
      a = {
        highlightedIndex: e.disabled ? -1 : e.index
      };
      break;
    case n.MenuMouseLeave:
      a = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      a = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : hE(i, t, 0)
      };
      break;
    case n.FunctionOpenMenu:
      a = {
        isOpen: !0,
        highlightedIndex: hE(i, t, 0)
      };
      break;
    case n.FunctionCloseMenu:
      a = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      a = {
        highlightedIndex: e.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      a = {
        inputValue: e.inputValue
      };
      break;
    case n.FunctionReset:
      a = {
        highlightedIndex: $d(i, "highlightedIndex"),
        isOpen: $d(i, "isOpen"),
        selectedItem: $d(i, "selectedItem"),
        inputValue: $d(i, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return Nn({}, t, a);
}
Qe.array.isRequired, Qe.func, Qe.func, Qe.func, Qe.number, Qe.number, Qe.number, Qe.bool, Qe.bool, Qe.bool, Qe.any, Qe.any, Qe.any, Qe.string, Qe.string, Qe.string, Qe.func, Qe.string, Qe.func, Qe.func, Qe.func, Qe.func, Qe.func, Qe.shape({
  addEventListener: Qe.func,
  removeEventListener: Qe.func,
  document: Qe.shape({
    getElementById: Qe.func,
    activeElement: Qe.any,
    body: Qe.any
  })
});
function $pe(t) {
  var e = t.isOpen, n = t.resultCount, r = t.previousResultCount;
  return e ? n ? n !== r ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
ol(ol({}, fE), { getA11yStatusMessage: $pe });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var sI = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, lI = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, cI = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, uI = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, dI = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, fI = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, hI = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, pI = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, mI = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, ET = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, gI = process.env.NODE_ENV !== "production" ? "__input_focus__" : 10, pY = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, mY = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, vI = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, gY = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, vY = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, yY = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, bY = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, wY = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, yI = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, xY = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, SY = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, bI = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, EY = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: sI,
  InputKeyDownArrowUp: lI,
  InputKeyDownEscape: cI,
  InputKeyDownHome: uI,
  InputKeyDownEnd: dI,
  InputKeyDownPageUp: fI,
  InputKeyDownPageDown: hI,
  InputKeyDownEnter: pI,
  InputChange: mI,
  InputBlur: ET,
  InputFocus: gI,
  MenuMouseLeave: pY,
  ItemMouseMove: mY,
  ItemClick: vI,
  ToggleButtonClick: gY,
  FunctionToggleMenu: vY,
  FunctionOpenMenu: yY,
  FunctionCloseMenu: bY,
  FunctionSetHighlightedIndex: wY,
  FunctionSelectItem: yI,
  FunctionSetInputValue: xY,
  FunctionReset: SY,
  ControlledPropUpdatedSelectedItem: bI
});
function Hpe(t) {
  var e = zpe(t), n = e.selectedItem, r = e.inputValue;
  return r === "" && n && t.defaultInputValue === void 0 && t.initialInputValue === void 0 && t.inputValue === void 0 && (r = t.itemToString(n)), Nn({}, e, {
    inputValue: r
  });
}
var qpe = {
  items: Qe.array.isRequired,
  itemToString: Qe.func,
  selectedItemChanged: Qe.func,
  getA11yStatusMessage: Qe.func,
  getA11ySelectionMessage: Qe.func,
  highlightedIndex: Qe.number,
  defaultHighlightedIndex: Qe.number,
  initialHighlightedIndex: Qe.number,
  isOpen: Qe.bool,
  defaultIsOpen: Qe.bool,
  initialIsOpen: Qe.bool,
  selectedItem: Qe.any,
  initialSelectedItem: Qe.any,
  defaultSelectedItem: Qe.any,
  inputValue: Qe.string,
  defaultInputValue: Qe.string,
  initialInputValue: Qe.string,
  id: Qe.string,
  labelId: Qe.string,
  menuId: Qe.string,
  getItemId: Qe.func,
  inputId: Qe.string,
  toggleButtonId: Qe.string,
  stateReducer: Qe.func,
  onSelectedItemChange: Qe.func,
  onHighlightedIndexChange: Qe.func,
  onStateChange: Qe.func,
  onIsOpenChange: Qe.func,
  onInputValueChange: Qe.func,
  environment: Qe.shape({
    addEventListener: Qe.func,
    removeEventListener: Qe.func,
    document: Qe.shape({
      getElementById: Qe.func,
      activeElement: Qe.any,
      body: Qe.any
    })
  })
};
function Gpe(t, e, n) {
  var r = I.useRef(), i = Bpe(t, e, n), a = i[0], s = i[1];
  return I.useEffect(function() {
    xT(n, "selectedItem") && (n.selectedItemChanged(r.current, n.selectedItem) && s({
      type: bI,
      inputValue: n.itemToString(n.selectedItem)
    }), r.current = a.selectedItem === r.current ? n.selectedItem : a.selectedItem);
  }, [a.selectedItem, n.selectedItem]), [wT(a, n), s];
}
var _Y = Hc;
process.env.NODE_ENV !== "production" && (_Y = function(e, n) {
  Qe.checkPropTypes(qpe, e, "prop", n.name);
});
var Ype = Nn({}, fE, {
  selectedItemChanged: function(e, n) {
    return e !== n;
  },
  getA11yStatusMessage: qG
});
function Xpe(t, e) {
  var n, r = e.type, i = e.props, a = e.altKey, s;
  switch (r) {
    case vI:
      s = {
        isOpen: $d(i, "isOpen"),
        highlightedIndex: $d(i, "highlightedIndex"),
        selectedItem: i.items[e.index],
        inputValue: i.itemToString(i.items[e.index])
      };
      break;
    case sI:
      t.isOpen ? s = {
        highlightedIndex: ng(1, t.highlightedIndex, i.items.length, e.getItemNodeFromIndex, !0)
      } : s = {
        highlightedIndex: a && t.selectedItem == null ? -1 : hE(i, t, 1, e.getItemNodeFromIndex),
        isOpen: i.items.length >= 0
      };
      break;
    case lI:
      t.isOpen ? a ? s = OB(i, t.highlightedIndex) : s = {
        highlightedIndex: ng(-1, t.highlightedIndex, i.items.length, e.getItemNodeFromIndex, !0)
      } : s = {
        highlightedIndex: hE(i, t, -1, e.getItemNodeFromIndex),
        isOpen: i.items.length >= 0
      };
      break;
    case pI:
      s = OB(i, t.highlightedIndex);
      break;
    case cI:
      s = Nn({
        isOpen: !1,
        highlightedIndex: -1
      }, !t.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case fI:
      s = {
        highlightedIndex: ng(-10, t.highlightedIndex, i.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case hI:
      s = {
        highlightedIndex: ng(10, t.highlightedIndex, i.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case uI:
      s = {
        highlightedIndex: Sg(1, 0, i.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case dI:
      s = {
        highlightedIndex: Sg(-1, i.items.length - 1, i.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case ET:
      s = Nn({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && ((n = i.items) == null ? void 0 : n.length) && e.selectItem && {
        selectedItem: i.items[t.highlightedIndex],
        inputValue: i.itemToString(i.items[t.highlightedIndex])
      });
      break;
    case mI:
      s = {
        isOpen: !0,
        highlightedIndex: $d(i, "highlightedIndex"),
        inputValue: e.inputValue
      };
      break;
    case gI:
      s = {
        isOpen: !0,
        highlightedIndex: hE(i, t, 0)
      };
      break;
    case yI:
      s = {
        selectedItem: e.selectedItem,
        inputValue: i.itemToString(e.selectedItem)
      };
      break;
    case bI:
      s = {
        inputValue: e.inputValue
      };
      break;
    default:
      return Upe(t, e, EY);
  }
  return Nn({}, t, s);
}
var Wpe = ["onMouseLeave", "refKey", "ref"], Qpe = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], Zpe = ["onClick", "onPress", "refKey", "ref"], Kpe = ["onKeyDown", "onChange", "onInput", "onFocus", "onBlur", "onChangeText", "refKey", "ref"];
j5.stateChangeTypes = EY;
function j5(t) {
  t === void 0 && (t = {}), _Y(t, j5);
  var e = Nn({}, Ype, t), n = e.initialIsOpen, r = e.defaultIsOpen, i = e.items, a = e.scrollIntoView, s = e.environment, c = e.getA11yStatusMessage, d = e.getA11ySelectionMessage, f = e.itemToString, g = Hpe(e), m = Gpe(Xpe, g, e), b = m[0], w = m[1], _ = b.isOpen, A = b.highlightedIndex, T = b.selectedItem, O = b.inputValue, R = I.useRef(null), N = I.useRef({}), M = I.useRef(null), P = I.useRef(null), z = I.useRef(!0), F = jpe(e), $ = I.useRef(), G = dY({
    state: b,
    props: e
  }), H = I.useCallback(function(ue) {
    return N.current[F.getItemId(ue)];
  }, [F]);
  TB(c, [_, A, O, i], Nn({
    isInitialMount: z.current,
    previousResultCount: $.current,
    items: i,
    environment: s,
    itemToString: f
  }, b)), TB(d, [T], Nn({
    isInitialMount: z.current,
    previousResultCount: $.current,
    items: i,
    environment: s,
    itemToString: f
  }, b));
  var Z = Vpe({
    menuElement: R.current,
    highlightedIndex: A,
    isOpen: _,
    itemRefs: N,
    scrollIntoView: a,
    getItemNodeFromIndex: H
  });
  hY({
    isInitialMount: z.current,
    props: e,
    state: b
  }), I.useEffect(function() {
    var ue = n || r || _;
    ue && M.current && M.current.focus();
  }, []), I.useEffect(function() {
    z.current || ($.current = i.length);
  });
  var V = Fpe(_, [M, R, P], s, function() {
    w({
      type: ET,
      selectItem: !1
    });
  }), Y = fY("getInputProps", "getMenuProps");
  I.useEffect(function() {
    return z.current = !1, function() {
      z.current = !0;
    };
  }, []), I.useEffect(function() {
    var ue;
    if (!_)
      N.current = {};
    else if (((ue = s.document) == null ? void 0 : ue.activeElement) !== M.current) {
      var Se;
      M == null || (Se = M.current) == null || Se.focus();
    }
  }, [_, s]);
  var ee = I.useMemo(function() {
    return {
      ArrowDown: function(Se) {
        Se.preventDefault(), w({
          type: sI,
          altKey: Se.altKey,
          getItemNodeFromIndex: H
        });
      },
      ArrowUp: function(Se) {
        Se.preventDefault(), w({
          type: lI,
          altKey: Se.altKey,
          getItemNodeFromIndex: H
        });
      },
      Home: function(Se) {
        G.current.state.isOpen && (Se.preventDefault(), w({
          type: uI,
          getItemNodeFromIndex: H
        }));
      },
      End: function(Se) {
        G.current.state.isOpen && (Se.preventDefault(), w({
          type: dI,
          getItemNodeFromIndex: H
        }));
      },
      Escape: function(Se) {
        var Ne = G.current.state;
        (Ne.isOpen || Ne.inputValue || Ne.selectedItem || Ne.highlightedIndex > -1) && (Se.preventDefault(), w({
          type: cI
        }));
      },
      Enter: function(Se) {
        var Ne = G.current.state;
        !Ne.isOpen || Se.which === 229 || (Se.preventDefault(), w({
          type: pI,
          getItemNodeFromIndex: H
        }));
      },
      PageUp: function(Se) {
        G.current.state.isOpen && (Se.preventDefault(), w({
          type: fI,
          getItemNodeFromIndex: H
        }));
      },
      PageDown: function(Se) {
        G.current.state.isOpen && (Se.preventDefault(), w({
          type: hI,
          getItemNodeFromIndex: H
        }));
      }
    };
  }, [w, G, H]), K = I.useCallback(function(ue) {
    return Nn({
      id: F.labelId,
      htmlFor: F.inputId
    }, ue);
  }, [F]), U = I.useCallback(function(ue, Se) {
    var Ne, Me = ue === void 0 ? {} : ue, Ce = Me.onMouseLeave, Ue = Me.refKey, rt = Ue === void 0 ? "ref" : Ue, it = Me.ref, Ft = Ud(Me, Wpe), wt = Se === void 0 ? {} : Se, Ot = wt.suppressRefError, On = Ot === void 0 ? !1 : Ot;
    return Y("getMenuProps", On, rt, R), Nn((Ne = {}, Ne[rt] = wb(it, function(Ct) {
      R.current = Ct;
    }), Ne.id = F.menuId, Ne.role = "listbox", Ne["aria-labelledby"] = Ft && Ft["aria-label"] ? void 0 : "" + F.labelId, Ne.onMouseLeave = za(Ce, function() {
      w({
        type: pY
      });
    }), Ne), Ft);
  }, [w, Y, F]), q = I.useCallback(function(ue) {
    var Se, Ne, Me = ue === void 0 ? {} : ue, Ce = Me.item, Ue = Me.index, rt = Me.refKey, it = rt === void 0 ? "ref" : rt, Ft = Me.ref, wt = Me.onMouseMove, Ot = Me.onMouseDown, On = Me.onClick;
    Me.onPress;
    var Ct = Me.disabled, se = Ud(Me, Qpe), ge = G.current, Te = ge.props, He = ge.state, $e = Ppe(Ce, Ue, Te.items, "Pass either item or index to getItemProps!"), Ze = $e[1], ct = "onClick", Mt = On, Rt = function() {
      Ze !== He.highlightedIndex && (Z.current = !1, w({
        type: mY,
        index: Ze,
        disabled: Ct
      }));
    }, sn = function() {
      w({
        type: vI,
        index: Ze
      });
    }, In = function(Wn) {
      return Wn.preventDefault();
    };
    return Nn((Se = {}, Se[it] = wb(Ft, function(hn) {
      hn && (N.current[F.getItemId(Ze)] = hn);
    }), Se.disabled = Ct, Se.role = "option", Se["aria-selected"] = "" + (Ze === He.highlightedIndex), Se.id = F.getItemId(Ze), Se), !Ct && (Ne = {}, Ne[ct] = za(Mt, sn), Ne), {
      onMouseMove: za(wt, Rt),
      onMouseDown: za(Ot, In)
    }, se);
  }, [w, G, Z, F]), W = I.useCallback(function(ue) {
    var Se, Ne = ue === void 0 ? {} : ue, Me = Ne.onClick;
    Ne.onPress;
    var Ce = Ne.refKey, Ue = Ce === void 0 ? "ref" : Ce, rt = Ne.ref, it = Ud(Ne, Zpe), Ft = G.current.state, wt = function() {
      w({
        type: gY
      });
    };
    return Nn((Se = {}, Se[Ue] = wb(rt, function(Ot) {
      P.current = Ot;
    }), Se["aria-controls"] = F.menuId, Se["aria-expanded"] = Ft.isOpen, Se.id = F.toggleButtonId, Se.tabIndex = -1, Se), !it.disabled && Nn({}, {
      onClick: za(Me, wt)
    }), it);
  }, [w, G, F]), ie = I.useCallback(function(ue, Se) {
    var Ne, Me = ue === void 0 ? {} : ue, Ce = Me.onKeyDown, Ue = Me.onChange, rt = Me.onInput, it = Me.onFocus, Ft = Me.onBlur;
    Me.onChangeText;
    var wt = Me.refKey, Ot = wt === void 0 ? "ref" : wt, On = Me.ref, Ct = Ud(Me, Kpe), se = Se === void 0 ? {} : Se, ge = se.suppressRefError, Te = ge === void 0 ? !1 : ge;
    Y("getInputProps", Te, Ot, M);
    var He = G.current.state, $e = function(Wn) {
      var ar = D8(Wn);
      ar && ee[ar] && ee[ar](Wn);
    }, Ze = function(Wn) {
      w({
        type: mI,
        inputValue: Wn.target.value
      });
    }, ct = function(Wn) {
      if (He.isOpen && !V.current.isMouseDown) {
        var ar = Wn.relatedTarget === null && s.document.activeElement !== s.document.body;
        w({
          type: ET,
          selectItem: !ar
        });
      }
    }, Mt = function() {
      He.isOpen || w({
        type: gI
      });
    }, Rt = "onChange", sn = {};
    if (!Ct.disabled) {
      var In;
      sn = (In = {}, In[Rt] = za(Ue, rt, Ze), In.onKeyDown = za(Ce, $e), In.onBlur = za(Ft, ct), In.onFocus = za(it, Mt), In);
    }
    return Nn((Ne = {}, Ne[Ot] = wb(On, function(hn) {
      M.current = hn;
    }), Ne["aria-activedescendant"] = He.isOpen && He.highlightedIndex > -1 ? F.getItemId(He.highlightedIndex) : "", Ne["aria-autocomplete"] = "list", Ne["aria-controls"] = F.menuId, Ne["aria-expanded"] = He.isOpen, Ne["aria-labelledby"] = Ct && Ct["aria-label"] ? void 0 : "" + F.labelId, Ne.autoComplete = "off", Ne.id = F.inputId, Ne.role = "combobox", Ne.value = He.inputValue, Ne), sn, Ct);
  }, [Y, G, F, ee, w, V, s]), J = I.useCallback(function() {
    w({
      type: vY
    });
  }, [w]), B = I.useCallback(function() {
    w({
      type: bY
    });
  }, [w]), te = I.useCallback(function() {
    w({
      type: yY
    });
  }, [w]), ae = I.useCallback(function(ue) {
    w({
      type: wY,
      highlightedIndex: ue
    });
  }, [w]), le = I.useCallback(function(ue) {
    w({
      type: yI,
      selectedItem: ue
    });
  }, [w]), de = I.useCallback(function(ue) {
    w({
      type: xY,
      inputValue: ue
    });
  }, [w]), _e = I.useCallback(function() {
    w({
      type: SY
    });
  }, [w]);
  return {
    // prop getters.
    getItemProps: q,
    getLabelProps: K,
    getMenuProps: U,
    getInputProps: ie,
    getToggleButtonProps: W,
    // actions.
    toggleMenu: J,
    openMenu: te,
    closeMenu: B,
    setHighlightedIndex: ae,
    setInputValue: de,
    selectItem: le,
    reset: _e,
    // state.
    highlightedIndex: A,
    isOpen: _,
    selectedItem: T,
    inputValue: O
  };
}
function Jpe(t) {
  var e = t.removedSelectedItem, n = t.itemToString;
  return n(e) + " has been removed.";
}
Qe.array, Qe.array, Qe.array, Qe.func, Qe.func, Qe.func, Qe.number, Qe.number, Qe.number, Qe.func, Qe.func, Qe.string, Qe.string, Qe.shape({
  addEventListener: Qe.func,
  removeEventListener: Qe.func,
  document: Qe.shape({
    getElementById: Qe.func,
    activeElement: Qe.any,
    body: Qe.any
  })
});
fE.itemToString, fE.stateReducer, fE.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const I6 = {
  xs: 10,
  sm: 14,
  md: 18,
  lg: 22,
  xl: 26,
  "2xl": 32
}, AY = ({
  icon: t,
  size: e = "md",
  className: n = ""
}) => I.cloneElement(t, {
  size: I6[e],
  width: I6[e],
  height: I6[e],
  className: `twd-inline-block twd-align-bottom ${t.props.className} ${n}`
});
var CY = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, RB = De.createContext && De.createContext(CY), j0 = globalThis && globalThis.__assign || function() {
  return j0 = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, j0.apply(this, arguments);
}, e0e = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function TY(t) {
  return t && t.map(function(e, n) {
    return De.createElement(e.tag, j0({
      key: n
    }, e.attr), TY(e.child));
  });
}
function _t(t) {
  return function(e) {
    return De.createElement(t0e, j0({
      attr: j0({}, t.attr)
    }, e), TY(t.child));
  };
}
function t0e(t) {
  var e = function(n) {
    var r = t.attr, i = t.size, a = t.title, s = e0e(t, ["attr", "size", "title"]), c = i || n.size || "1em", d;
    return n.className && (d = n.className), t.className && (d = (d ? d + " " : "") + t.className), De.createElement("svg", j0({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, r, s, {
      className: d,
      style: j0(j0({
        color: t.color || n.color
      }, n.style), t.style),
      height: c,
      width: c,
      xmlns: "http://www.w3.org/2000/svg"
    }), a && De.createElement("title", null, a), t.children);
  };
  return RB !== void 0 ? De.createElement(RB.Consumer, null, function(n) {
    return e(n);
  }) : e(CY);
}
function n0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M4 10h3v7H4zM10.5 10h3v7h-3zM2 19h20v3H2zM17 10h3v7h-3zM12 1L2 6v2h20V6z" } }] })(t);
}
function r0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0112.28 0C16.43 19.18 14.03 20 12 20z" } }] })(t);
}
function i0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" } }] })(t);
}
function a0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" } }] })(t);
}
function o0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" } }] })(t);
}
function s0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5zM9.5 8a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0zm6.5 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z" } }] })(t);
}
function l0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" } }] })(t);
}
function c0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z" } }] })(t);
}
function u0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" } }] })(t);
}
function d0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14a2 2 0 00-2-2zM11 16l4-4-4-4v3H1v2h10v3z" } }] })(t);
}
function f0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M24 0H0v24h24V0zm0 0H0v24h24V0zM0 24h24V0H0v24z" } }, { tag: "path", attr: { d: "M17.66 8L12 2.35 6.34 8A8.02 8.02 0 004 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0011.32 0c1.56-1.56 2.34-3.67 2.34-5.67S19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z" } }] })(t);
}
function h0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" } }] })(t);
}
function p0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" } }] })(t);
}
function m0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" } }] })(t);
}
function g0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42a.353.353 0 01.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16a.353.353 0 01-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z" } }] })(t);
}
function v0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z" } }] })(t);
}
function y0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.488.488 0 00-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 00-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" } }] })(t);
}
function b0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M18 12l4-4-4-4v3H3v2h15zM6 12l-4 4 4 4v-3h15v-2H6z" } }] })(t);
}
function w0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19 13H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM19 3H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" } }] })(t);
}
function x0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" } }] })(t);
}
function S0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M24 24H0V0h24v24z" } }, { tag: "circle", attr: { cx: "12", cy: "12", r: "8" } }] })(t);
}
function E0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z" } }] })(t);
}
function _0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M8 5v14l11-7z" } }] })(t);
}
function A0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M6 6h12v12H6z" } }] })(t);
}
function C0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" } }] })(t);
}
function T0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M9.5 6.5v3h-3v-3h3M11 5H5v6h6V5zm-1.5 9.5v3h-3v-3h3M11 13H5v6h6v-6zm6.5-6.5v3h-3v-3h3M19 5h-6v6h6V5zm-6 8h1.5v1.5H13V13zm1.5 1.5H16V16h-1.5v-1.5zM16 13h1.5v1.5H16V13zm-3 3h1.5v1.5H13V16zm1.5 1.5H16V19h-1.5v-1.5zM16 16h1.5v1.5H16V16zm1.5-1.5H19V16h-1.5v-1.5zm0 3H19V19h-1.5v-1.5zM22 7h-2V4h-3V2h5v5zm0 15v-5h-2v3h-3v2h5zM2 22h5v-2H4v-3H2v5zM2 2v5h2V4h3V2H2z" } }] })(t);
}
function O0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" } }] })(t);
}
function R0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { fillRule: "evenodd", d: "M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z" } }] })(t);
}
function D0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" } }] })(t);
}
function N0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 8V4l8 8-8 8v-4H4V8z" } }] })(t);
}
function M0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" } }] })(t);
}
function I0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" } }] })(t);
}
function k0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z" } }] })(t);
}
function j0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z" } }] })(t);
}
function P0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z" } }] })(t);
}
function L0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z" } }] })(t);
}
function B0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z" } }] })(t);
}
function z0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" } }] })(t);
}
function F0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z" } }] })(t);
}
function V0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z" } }] })(t);
}
function U0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z" } }] })(t);
}
function $0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z" } }] })(t);
}
function H0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" } }] })(t);
}
function q0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z" } }] })(t);
}
function G0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z" } }] })(t);
}
function Y0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z" } }] })(t);
}
function X0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" } }] })(t);
}
function W0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z" } }] })(t);
}
function Q0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M9 1h6v2H9zM19.03 7.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4a9 9 0 00-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 007.03-14.61zM13 14h-2V8h2v6z" } }] })(t);
}
function Z0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5z" } }] })(t);
}
function K0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" } }] })(t);
}
function J0e(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" } }] })(t);
}
function eme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" } }] })(t);
}
function tme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" } }] })(t);
}
function nme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" } }] })(t);
}
function rme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" } }] })(t);
}
function ime(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" } }] })(t);
}
function ame(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "circle", attr: { cx: "12", cy: "19", r: "2" } }, { tag: "path", attr: { d: "M10 3h4v12h-4z" } }] })(t);
}
function ome(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z" } }] })(t);
}
function sme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3a4.237 4.237 0 00-6 0zm-4-4l2 2a7.074 7.074 0 0110 0l2-2C15.14 9.14 8.87 9.14 5 13z" } }] })(t);
}
function lme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" } }] })(t);
}
function cme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" } }] })(t);
}
function ume(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" } }] })(t);
}
function dme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M11.07 12.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 6.96C7.25 4.83 9.18 3 11.99 3c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15zM14 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z" } }] })(t);
}
function fme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M12 6.5a9.77 9.77 0 018.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0112 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5a2.5 2.5 0 010 5 2.5 2.5 0 010-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z" } }] })(t);
}
function hme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12 16L6 10H18L12 16Z" } }] })(t);
}
function pme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12 8L18 14H6L12 8Z" } }] })(t);
}
function mme(t) {
  return _t({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", strokeWidth: "2", d: "M4,4 L20,20 M22,12 C22,12 16.7200572,17.2799437 16.7200572,17.2799437 M15,19 C15,19 13.7932491,20.2067517 13.0000004,21.0000004 C6.99999996,27.0000004 -2.00000007,18.0000004 3.99999994,12.0000004 C4.88551518,11.1144851 6,10 6,10 M8,8 C8,8 10.1615592,5.83844087 13,3.00000008 C17,-0.999999955 23,4.99999994 19,9.00000005 C16.9873313,11.0126688 14,14 14,14 M12,16 C12,16 10.6478339,17.3521667 9.99999995,18.0000004 C7.99999952,20 5,17 6.99999995,15.0000004 C7.50049504,14.4995054 9,13 9,13 M11,11 C10.7388543,11.261146 16,6 16,6" } }] })(t);
}
const At = (t) => (e) => /* @__PURE__ */ C.jsx(AY, { icon: /* @__PURE__ */ C.jsx(t, {}), ...e }), gme = At($0e), vme = At(s0e), OY = At(W0e), yme = At(G0e), bme = At(b0e), wme = At(Z0e), xme = At(q0e), Sme = At(V0e), Eme = At(m0e), _me = At(f0e), Ame = At(j0e), wI = At(ume), RY = At(cme), Cme = At(U0e), Tme = At(ame), Ome = At(E0e), Rme = At(_0e), DY = At(u0e), Dme = At(l0e), lw = At(H0e), q0 = At(O0e), C_ = At(D0e), Nme = At(w0e), Yb = At(a0e), Mme = At(F0e), Ime = At(A0e), NY = At(o0e), MY = At(x0e), kme = At(ome), P5 = At(eme), jme = At(r0e), IY = At(d0e), Pme = At(rme), Lme = At(nme), Bme = At(g0e), zme = At(K0e), Fme = At(tme), Vme = At(lme), Ume = At(ime), $me = At(P0e), Hme = At(C0e), qme = At(h0e), xI = At(p0e), Gme = At(k0e), Yme = At(R0e), Xme = At(c0e), kY = At(T0e), jY = At(hme), PY = At(pme), LY = At(Y0e), Wme = At(i0e), Qme = At(B0e), Zme = At(M0e), Kme = At(L0e), Jme = At(I0e), e1e = At(z0e), t1e = At(N0e), n1e = At(Q0e), r1e = At(S0e), SI = At(J0e), i1e = At(n0e), BY = At(dme), T_ = At(fme), EI = At(X0e), a1e = At(mme), zY = At(y0e), o1e = At(sme), s1e = At(v0e), l1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Icon360: wme,
  IconAccountBalance: i1e,
  IconAccountCircle: jme,
  IconAdd: q0,
  IconAdjust: Sme,
  IconArrowForward: zme,
  IconAssignment: Wme,
  IconBallot: Yme,
  IconBrightness7: Cme,
  IconCallMade: Hme,
  IconCancel: SI,
  IconCheck: P5,
  IconClear: C_,
  IconClose: Fme,
  IconColorize: gme,
  IconComputer: Qme,
  IconDelete: Yb,
  IconDetach: a1e,
  IconDone: NY,
  IconDownload: Kme,
  IconEdit: lw,
  IconEthernet: s1e,
  IconExpandLess: Lme,
  IconExpandMore: Pme,
  IconFiberManualRecord: r1e,
  IconFlare: xme,
  IconForward: t1e,
  IconGradient: yme,
  IconGroupWork: vme,
  IconHighlightOff: Dme,
  IconHourglassEmpty: Xme,
  IconInfo: DY,
  IconInput: IY,
  IconKeyboardArrowUp: e1e,
  IconKeyboardBackspace: Mme,
  IconMoreVert: Ume,
  IconNotes: Gme,
  IconOpacity: _me,
  IconOpenInNew: qme,
  IconOutlineQuestionMark: BY,
  IconOutlineRemoveRedEye: T_,
  IconPause: Ome,
  IconPictureAsPdf: LY,
  IconPlayArrow: Rme,
  IconPriorityHigh: Tme,
  IconQrCodeScanner: kY,
  IconRemoveRedEye: EI,
  IconRestore: xI,
  IconRiArrowDownSFill: jY,
  IconRiArrowUpSFill: PY,
  IconRotateLeft: OY,
  IconSave: Zme,
  IconSearch: Eme,
  IconSettings: zY,
  IconSettingsApplications: Bme,
  IconShare: Vme,
  IconShowChart: Ame,
  IconStar: wI,
  IconStarBorder: RY,
  IconStop: Ime,
  IconSyncAlt: bme,
  IconSystemUpdate: kme,
  IconTimer: n1e,
  IconUndo: Jme,
  IconVerticalAlignTop: $me,
  IconViewAgenda: Nme,
  IconWarning: MY,
  IconWifi: o1e
}, Symbol.toStringTag, { value: "Module" })), c1e = "data:image/gif;base64,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", O_ = (t) => {
  const e = ve.c(4), {
    className: n,
    size: r
  } = t, i = r === void 0 ? "sm" : r;
  let a;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ C.jsx("img", { src: c1e, className: "twd-object-contain" }), e[0] = a) : a = e[0];
  let s;
  return e[1] !== n || e[2] !== i ? (s = /* @__PURE__ */ C.jsx(AY, { size: i, icon: a, className: n }), e[1] = n, e[2] = i, e[3] = s) : s = e[3], s;
}, u1e = Re.button`
  twd-relative
  twd-inline-flex
  twd-h-fit
  twd-w-fit
  twd-cursor-pointer
  twd-items-center
  twd-justify-center
  twd-rounded-full
  twd-border-none
  twd-bg-transparent
  twd-p-1
  twd-outline-none
  hover:twd-bg-secondary-light
  active:twd-bg-secondary-light2
  disabled:twd-cursor-not-allowed
  disabled:twd-opacity-50
  disabled:hover:twd-bg-transparent
  disabled:active:twd-bg-transparent
  ${({
  $isLoading: t
}) => t && "enabled:twd-cursor-wait disabled:twd-cursor-wait"}
`, d1e = Re.span`
  twd-inline-flex
  twd-items-center
  ${({
  $isVisible: t
}) => t ? "twd-visible" : "twd-invisible"}
`, f1e = Re(O_)`
  twd-absolute
  twd-left-1/2
  twd-top-1/2
  twd--translate-x-1/2
  twd--translate-y-1/2
`, cl = I.forwardRef((t, e) => {
  const n = ve.c(15), {
    icon: r,
    className: i,
    onClick: a,
    isDisabled: s,
    isLoading: c,
    title: d,
    "aria-label": f
  } = t, g = c ?? !1, m = s || c;
  let b;
  n[0] !== c ? (b = c && /* @__PURE__ */ C.jsx(f1e, {}), n[0] = c, n[1] = b) : b = n[1];
  const w = !c;
  let _;
  n[2] !== r || n[3] !== w ? (_ = /* @__PURE__ */ C.jsx(d1e, { $isVisible: w, children: r }), n[2] = r, n[3] = w, n[4] = _) : _ = n[4];
  let A;
  return n[5] !== f || n[6] !== i || n[7] !== a || n[8] !== e || n[9] !== g || n[10] !== m || n[11] !== b || n[12] !== _ || n[13] !== d ? (A = /* @__PURE__ */ C.jsxs(u1e, { $isLoading: g, ref: e, className: i, onClick: a, disabled: m, type: "button", title: d, "aria-label": f, children: [
    b,
    _
  ] }), n[5] = f, n[6] = i, n[7] = a, n[8] = e, n[9] = g, n[10] = m, n[11] = b, n[12] = _, n[13] = d, n[14] = A) : A = n[14], A;
}), jg = typeof document < "u" ? De.useLayoutEffect : () => {
};
function sg(t) {
  const e = I.useRef(null);
  return jg(() => {
    e.current = t;
  }, [
    t
  ]), I.useCallback((...n) => {
    const r = e.current;
    return r?.(...n);
  }, []);
}
function h1e(t) {
  let [e, n] = I.useState(t), r = I.useRef(null), i = sg(() => {
    if (!r.current)
      return;
    let s = r.current.next();
    if (s.done) {
      r.current = null;
      return;
    }
    e === s.value ? i() : n(s.value);
  });
  jg(() => {
    r.current && i();
  });
  let a = sg((s) => {
    r.current = s(e), i();
  });
  return [
    e,
    a
  ];
}
const _T = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, FY = /* @__PURE__ */ De.createContext(_T), p1e = /* @__PURE__ */ De.createContext(!1);
let m1e = !!(typeof window < "u" && window.document && window.document.createElement), k6 = /* @__PURE__ */ new WeakMap();
function g1e(t = !1) {
  let e = I.useContext(FY), n = I.useRef(null);
  if (n.current === null && !t) {
    var r, i;
    let a = (i = De.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || i === void 0 || (r = i.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (a) {
      let s = k6.get(a);
      s == null ? k6.set(a, {
        id: e.current,
        state: a.memoizedState
      }) : a.memoizedState !== s.state && (e.current = s.id, k6.delete(a));
    }
    n.current = ++e.current;
  }
  return n.current;
}
function v1e(t) {
  let e = I.useContext(FY);
  e === _T && !m1e && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = g1e(!!t), r = e === _T && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${e.prefix}`;
  return t || `${r}-${n}`;
}
function y1e(t) {
  let e = De.useId(), [n] = I.useState(E1e()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${_T.prefix}`;
  return t || `${r}-${e}`;
}
const b1e = typeof De.useId == "function" ? y1e : v1e;
function w1e() {
  return !1;
}
function x1e() {
  return !0;
}
function S1e(t) {
  return () => {
  };
}
function E1e() {
  return typeof De.useSyncExternalStore == "function" ? De.useSyncExternalStore(S1e, w1e, x1e) : I.useContext(p1e);
}
let _1e = !!(typeof window < "u" && window.document && window.document.createElement), kb = /* @__PURE__ */ new Map(), eE;
typeof FinalizationRegistry < "u" && (eE = new FinalizationRegistry((t) => {
  kb.delete(t);
}));
function AT(t) {
  let [e, n] = I.useState(t), r = I.useRef(null), i = b1e(e), a = I.useRef(null);
  if (eE && eE.register(a, i), _1e) {
    const s = kb.get(i);
    s && !s.includes(r) ? s.push(r) : kb.set(i, [
      r
    ]);
  }
  return jg(() => {
    let s = i;
    return () => {
      eE && eE.unregister(a), kb.delete(s);
    };
  }, [
    i
  ]), I.useEffect(() => {
    let s = r.current;
    return s && n(s), () => {
      s && (r.current = null);
    };
  }), i;
}
function A1e(t, e) {
  if (t === e)
    return t;
  let n = kb.get(t);
  if (n)
    return n.forEach((i) => i.current = e), e;
  let r = kb.get(e);
  return r ? (r.forEach((i) => i.current = t), t) : e;
}
function DB(t = []) {
  let e = AT(), [n, r] = h1e(e), i = I.useCallback(() => {
    r(function* () {
      yield e, yield document.getElementById(e) ? e : void 0;
    });
  }, [
    e,
    r
  ]);
  return jg(i, [
    e,
    i,
    ...t
  ]), n;
}
function C1e(...t) {
  return (...e) => {
    for (let n of t)
      typeof n == "function" && n(...e);
  };
}
const cw = (t) => {
  var e;
  return (e = t?.ownerDocument) !== null && e !== void 0 ? e : document;
}, CT = (t) => t && "window" in t && t.window === t ? t : cw(t).defaultView || window;
let T1e = !1;
function VY() {
  return T1e;
}
const TT = (t = document) => {
  var e;
  if (!VY())
    return t.activeElement;
  let n = t.activeElement;
  for (; n && "shadowRoot" in n && (!((e = n.shadowRoot) === null || e === void 0) && e.activeElement); )
    n = n.shadowRoot.activeElement;
  return n;
};
function O1e(t) {
  return VY() && t.target.shadowRoot && t.composedPath ? t.composedPath()[0] : t.target;
}
function OT(...t) {
  let e = {
    ...t[0]
  };
  for (let n = 1; n < t.length; n++) {
    let r = t[n];
    for (let i in r) {
      let a = e[i], s = r[i];
      typeof a == "function" && typeof s == "function" && // This is a lot faster than a regex.
      i[0] === "o" && i[1] === "n" && i.charCodeAt(2) >= /* 'A' */
      65 && i.charCodeAt(2) <= /* 'Z' */
      90 ? e[i] = C1e(a, s) : (i === "className" || i === "UNSAFE_className") && typeof a == "string" && typeof s == "string" ? e[i] = Xc(a, s) : i === "id" && a && s ? e.id = A1e(a, s) : e[i] = s !== void 0 ? s : a;
    }
  }
  return e;
}
const R1e = /* @__PURE__ */ new Set([
  "id"
]), D1e = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), N1e = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), M1e = /^(data-.*)$/;
function I1e(t, e = {}) {
  let { labelable: n, isLink: r, propNames: i } = e, a = {};
  for (const s in t)
    Object.prototype.hasOwnProperty.call(t, s) && (R1e.has(s) || n && D1e.has(s) || r && N1e.has(s) || i?.has(s) || M1e.test(s)) && (a[s] = t[s]);
  return a;
}
function NB(t) {
  if (k1e())
    t.focus({
      preventScroll: !0
    });
  else {
    let e = j1e(t);
    t.focus(), P1e(e);
  }
}
let jC = null;
function k1e() {
  if (jC == null) {
    jC = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return jC = !0, !0;
        }
      });
    } catch {
    }
  }
  return jC;
}
function j1e(t) {
  let e = t.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; e instanceof HTMLElement && e !== r; )
    (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) && n.push({
      element: e,
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft
    }), e = e.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function P1e(t) {
  for (let { element: e, scrollTop: n, scrollLeft: r } of t)
    e.scrollTop = n, e.scrollLeft = r;
}
function L5(t) {
  var e;
  return typeof window > "u" || window.navigator == null ? !1 : ((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.brands.some((n) => t.test(n.brand))) || t.test(window.navigator.userAgent);
}
function _I(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function jh(t) {
  if (process.env.NODE_ENV === "test")
    return t;
  let e = null;
  return () => (e == null && (e = t()), e);
}
const AI = jh(function() {
  return _I(/^Mac/i);
}), L1e = jh(function() {
  return _I(/^iPhone/i);
}), B1e = jh(function() {
  return _I(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  AI() && navigator.maxTouchPoints > 1;
}), z1e = jh(function() {
  return L1e() || B1e();
});
jh(function() {
  return AI() || z1e();
});
jh(function() {
  return L5(/AppleWebKit/i) && !F1e();
});
const F1e = jh(function() {
  return L5(/Chrome/i);
}), V1e = jh(function() {
  return L5(/Android/i);
});
jh(function() {
  return L5(/Firefox/i);
});
let D0 = /* @__PURE__ */ new Map(), M8 = /* @__PURE__ */ new Set();
function MB() {
  if (typeof window > "u")
    return;
  function t(r) {
    return "propertyName" in r;
  }
  let e = (r) => {
    if (!t(r) || !r.target)
      return;
    let i = D0.get(r.target);
    i || (i = /* @__PURE__ */ new Set(), D0.set(r.target, i), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), i.add(r.propertyName);
  }, n = (r) => {
    if (!t(r) || !r.target)
      return;
    let i = D0.get(r.target);
    if (i && (i.delete(r.propertyName), i.size === 0 && (r.target.removeEventListener("transitioncancel", n), D0.delete(r.target)), D0.size === 0)) {
      for (let a of M8)
        a();
      M8.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? MB() : document.addEventListener("DOMContentLoaded", MB));
function U1e() {
  for (const [t] of D0)
    "isConnected" in t && !t.isConnected && D0.delete(t);
}
function $1e(t) {
  requestAnimationFrame(() => {
    U1e(), D0.size === 0 ? t() : M8.add(t);
  });
}
function H1e(t, e) {
  let { id: n, "aria-label": r, "aria-labelledby": i } = t;
  return n = AT(n), i && r ? i = [
    .../* @__PURE__ */ new Set([
      n,
      ...i.trim().split(/\s+/)
    ])
  ].join(" ") : i && (i = i.trim().split(/\s+/).join(" ")), !r && !i && e && (r = e), {
    id: n,
    "aria-label": r,
    "aria-labelledby": i
  };
}
function UY(t) {
  const e = I.useRef(null), n = I.useRef(void 0), r = I.useCallback((i) => {
    if (typeof t == "function") {
      const a = t, s = a(i);
      return () => {
        typeof s == "function" ? s() : a(null);
      };
    } else if (t)
      return t.current = i, () => {
        t.current = null;
      };
  }, [
    t
  ]);
  return I.useMemo(() => ({
    get current() {
      return e.current;
    },
    set current(i) {
      e.current = i, n.current && (n.current(), n.current = void 0), i != null && (n.current = r(i));
    }
  }), [
    r
  ]);
}
function q1e(t, e) {
  jg(() => {
    if (t && t.ref && e)
      return t.ref.current = e.current, () => {
        t.ref && (t.ref.current = null);
      };
  });
}
function G1e(t) {
  return t.mozInputSource === 0 && t.isTrusted ? !0 : V1e() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function Y1e(t, e, n) {
  let r = I.useRef(e), i = sg(() => {
    n && n(r.current);
  });
  I.useEffect(() => {
    var a;
    let s = t == null || (a = t.current) === null || a === void 0 ? void 0 : a.form;
    return s?.addEventListener("reset", i), () => {
      s?.removeEventListener("reset", i);
    };
  }, [
    t,
    i
  ]);
}
function X1e(t, e, n) {
  let [r, i] = I.useState(t || e), a = I.useRef(t !== void 0), s = t !== void 0;
  I.useEffect(() => {
    let f = a.current;
    f !== s && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}.`), a.current = s;
  }, [
    s
  ]);
  let c = s ? t : r, d = I.useCallback((f, ...g) => {
    let m = (b, ...w) => {
      n && (Object.is(c, b) || n(b, ...w)), s || (c = b);
    };
    typeof f == "function" ? (process.env.NODE_ENV !== "production" && console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), i((w, ..._) => {
      let A = f(s ? c : w, ..._);
      return m(A, ...g), s ? w : A;
    })) : (s || i(f), m(f, ...g));
  }, [
    s,
    c,
    n
  ]);
  return [
    c,
    d
  ];
}
function W1e(t) {
  let e = t;
  return e.nativeEvent = t, e.isDefaultPrevented = () => e.defaultPrevented, e.isPropagationStopped = () => e.cancelBubble, e.persist = () => {
  }, e;
}
function Q1e(t) {
  let e = I.useRef({
    isFocused: !1,
    observer: null
  });
  jg(() => {
    const r = e.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = sg((r) => {
    t?.(r);
  });
  return I.useCallback((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      e.current.isFocused = !0;
      let i = r.target, a = (s) => {
        if (e.current.isFocused = !1, i.disabled) {
          let c = W1e(s);
          n(c);
        }
        e.current.observer && (e.current.observer.disconnect(), e.current.observer = null);
      };
      i.addEventListener("focusout", a, {
        once: !0
      }), e.current.observer = new MutationObserver(() => {
        if (e.current.isFocused && i.disabled) {
          var s;
          (s = e.current.observer) === null || s === void 0 || s.disconnect();
          let c = i === document.activeElement ? null : document.activeElement;
          i.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: c
          })), i.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: c
          }));
        }
      }), e.current.observer.observe(i, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let Z1e = !1, uw = null, K1e = /* @__PURE__ */ new Set(), pE = /* @__PURE__ */ new Map(), Eg = !1, I8 = !1;
function B5(t, e) {
  for (let n of K1e)
    n(t, e);
}
function J1e(t) {
  return !(t.metaKey || !AI() && t.altKey || t.ctrlKey || t.key === "Control" || t.key === "Shift" || t.key === "Meta");
}
function RT(t) {
  Eg = !0, J1e(t) && (uw = "keyboard", B5("keyboard", t));
}
function Yc(t) {
  uw = "pointer", (t.type === "mousedown" || t.type === "pointerdown") && (Eg = !0, B5("pointer", t));
}
function $Y(t) {
  G1e(t) && (Eg = !0, uw = "virtual");
}
function HY(t) {
  t.target === window || t.target === document || Z1e || !t.isTrusted || (!Eg && !I8 && (uw = "virtual", B5("virtual", t)), Eg = !1, I8 = !1);
}
function qY() {
  Eg = !1, I8 = !0;
}
function IB(t) {
  if (typeof window > "u" || typeof document > "u" || pE.get(CT(t)))
    return;
  const e = CT(t), n = cw(t);
  let r = e.HTMLElement.prototype.focus;
  e.HTMLElement.prototype.focus = function() {
    Eg = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", RT, !0), n.addEventListener("keyup", RT, !0), n.addEventListener("click", $Y, !0), e.addEventListener("focus", HY, !0), e.addEventListener("blur", qY, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Yc, !0), n.addEventListener("pointermove", Yc, !0), n.addEventListener("pointerup", Yc, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", Yc, !0), n.addEventListener("mousemove", Yc, !0), n.addEventListener("mouseup", Yc, !0)), e.addEventListener("beforeunload", () => {
    GY(t);
  }, {
    once: !0
  }), pE.set(e, {
    focus: r
  });
}
const GY = (t, e) => {
  const n = CT(t), r = cw(t);
  e && r.removeEventListener("DOMContentLoaded", e), pE.has(n) && (n.HTMLElement.prototype.focus = pE.get(n).focus, r.removeEventListener("keydown", RT, !0), r.removeEventListener("keyup", RT, !0), r.removeEventListener("click", $Y, !0), n.removeEventListener("focus", HY, !0), n.removeEventListener("blur", qY, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Yc, !0), r.removeEventListener("pointermove", Yc, !0), r.removeEventListener("pointerup", Yc, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", Yc, !0), r.removeEventListener("mousemove", Yc, !0), r.removeEventListener("mouseup", Yc, !0)), pE.delete(n));
};
function ege(t) {
  const e = cw(t);
  let n;
  return e.readyState !== "loading" ? IB(t) : (n = () => {
    IB(t);
  }, e.addEventListener("DOMContentLoaded", n)), () => GY(t, n);
}
typeof document < "u" && ege();
function tge() {
  return uw;
}
function nge(t) {
  uw = t, B5(t, null);
}
function rge(t) {
  const e = cw(t), n = TT(e);
  if (tge() === "virtual") {
    let r = n;
    $1e(() => {
      TT(e) === r && t.isConnected && NB(t);
    });
  } else
    NB(t);
}
function ige(t) {
  let { isDisabled: e, onFocus: n, onBlur: r, onFocusChange: i } = t;
  const a = I.useCallback((d) => {
    if (d.target === d.currentTarget)
      return r && r(d), i && i(!1), !0;
  }, [
    r,
    i
  ]), s = Q1e(a), c = I.useCallback((d) => {
    const f = cw(d.target), g = f ? TT(f) : TT();
    d.target === d.currentTarget && g === O1e(d.nativeEvent) && (n && n(d), i && i(!0), s(d));
  }, [
    i,
    n,
    s
  ]);
  return {
    focusProps: {
      onFocus: !e && (n || i || r) ? c : void 0,
      onBlur: !e && (r || i) ? a : void 0
    }
  };
}
function kB(t) {
  if (!t)
    return;
  let e = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        e && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : e = !0;
      },
      continuePropagation() {
        e = !1;
      },
      isPropagationStopped() {
        return e;
      }
    };
    t(r), e && n.stopPropagation();
  };
}
function age(t) {
  return {
    keyboardProps: t.isDisabled ? {} : {
      onKeyDown: kB(t.onKeyDown),
      onKeyUp: kB(t.onKeyUp)
    }
  };
}
let oge = /* @__PURE__ */ De.createContext(null);
function sge(t) {
  let e = I.useContext(oge) || {};
  q1e(e, t);
  let { ref: n, ...r } = e;
  return r;
}
function lge(t, e) {
  let { focusProps: n } = ige(t), { keyboardProps: r } = age(t), i = OT(n, r), a = sge(e), s = t.isDisabled ? {} : a, c = I.useRef(t.autoFocus);
  I.useEffect(() => {
    c.current && e.current && rge(e.current), c.current = !1;
  }, [
    e
  ]);
  let d = t.excludeFromTabOrder ? -1 : 0;
  return t.isDisabled && (d = void 0), {
    focusableProps: OT({
      ...i,
      tabIndex: d
    }, s)
  };
}
const YY = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, XY = {
  ...YY,
  customError: !0,
  valid: !1
}, DS = {
  isInvalid: !1,
  validationDetails: YY,
  validationErrors: []
}, cge = I.createContext({}), jB = "__formValidationState" + Date.now();
function uge(t) {
  if (t[jB]) {
    let { realtimeValidation: e, displayValidation: n, updateValidation: r, resetValidation: i, commitValidation: a } = t[jB];
    return {
      realtimeValidation: e,
      displayValidation: n,
      updateValidation: r,
      resetValidation: i,
      commitValidation: a
    };
  }
  return dge(t);
}
function dge(t) {
  let { isInvalid: e, validationState: n, name: r, value: i, builtinValidation: a, validate: s, validationBehavior: c = "aria" } = t;
  n && (e || (e = n === "invalid"));
  let d = e !== void 0 ? {
    isInvalid: e,
    validationErrors: [],
    validationDetails: XY
  } : null, f = I.useMemo(() => {
    if (!s || i == null)
      return null;
    let H = fge(s, i);
    return PB(H);
  }, [
    s,
    i
  ]);
  a?.validationDetails.valid && (a = void 0);
  let g = I.useContext(cge), m = I.useMemo(() => r ? Array.isArray(r) ? r.flatMap((H) => k8(g[H])) : k8(g[r]) : [], [
    g,
    r
  ]), [b, w] = I.useState(g), [_, A] = I.useState(!1);
  g !== b && (w(g), A(!1));
  let T = I.useMemo(() => PB(_ ? [] : m), [
    _,
    m
  ]), O = I.useRef(DS), [R, N] = I.useState(DS), M = I.useRef(DS), P = () => {
    if (!z)
      return;
    F(!1);
    let H = f || a || O.current;
    j6(H, M.current) || (M.current = H, N(H));
  }, [z, F] = I.useState(!1);
  return I.useEffect(P), {
    realtimeValidation: d || T || f || a || DS,
    displayValidation: c === "native" ? d || T || R : d || T || f || a || R,
    updateValidation(H) {
      c === "aria" && !j6(R, H) ? N(H) : O.current = H;
    },
    resetValidation() {
      let H = DS;
      j6(H, M.current) || (M.current = H, N(H)), c === "native" && F(!1), A(!0);
    },
    commitValidation() {
      c === "native" && F(!0), A(!0);
    }
  };
}
function k8(t) {
  return t ? Array.isArray(t) ? t : [
    t
  ] : [];
}
function fge(t, e) {
  if (typeof t == "function") {
    let n = t(e);
    if (n && typeof n != "boolean")
      return k8(n);
  }
  return [];
}
function PB(t) {
  return t.length ? {
    isInvalid: !0,
    validationErrors: t,
    validationDetails: XY
  } : null;
}
function j6(t, e) {
  return t === e ? !0 : !!t && !!e && t.isInvalid === e.isInvalid && t.validationErrors.length === e.validationErrors.length && t.validationErrors.every((n, r) => n === e.validationErrors[r]) && Object.entries(t.validationDetails).every(([n, r]) => e.validationDetails[n] === r);
}
function hge(t, e, n) {
  let { validationBehavior: r, focus: i } = t;
  jg(() => {
    if (r === "native" && n?.current && !n.current.disabled) {
      let d = e.realtimeValidation.isInvalid ? e.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(d), n.current.hasAttribute("title") || (n.current.title = ""), e.realtimeValidation.isInvalid || e.updateValidation(mge(n.current));
    }
  });
  let a = sg(() => {
    e.resetValidation();
  }), s = sg((d) => {
    var f;
    e.displayValidation.isInvalid || e.commitValidation();
    let g = n == null || (f = n.current) === null || f === void 0 ? void 0 : f.form;
    if (!d.defaultPrevented && n && g && gge(g) === n.current) {
      var m;
      i ? i() : (m = n.current) === null || m === void 0 || m.focus(), nge("keyboard");
    }
    d.preventDefault();
  }), c = sg(() => {
    e.commitValidation();
  });
  I.useEffect(() => {
    let d = n?.current;
    if (!d)
      return;
    let f = d.form;
    return d.addEventListener("invalid", s), d.addEventListener("change", c), f?.addEventListener("reset", a), () => {
      d.removeEventListener("invalid", s), d.removeEventListener("change", c), f?.removeEventListener("reset", a);
    };
  }, [
    n,
    s,
    c,
    a,
    r
  ]);
}
function pge(t) {
  let e = t.validity;
  return {
    badInput: e.badInput,
    customError: e.customError,
    patternMismatch: e.patternMismatch,
    rangeOverflow: e.rangeOverflow,
    rangeUnderflow: e.rangeUnderflow,
    stepMismatch: e.stepMismatch,
    tooLong: e.tooLong,
    tooShort: e.tooShort,
    typeMismatch: e.typeMismatch,
    valueMissing: e.valueMissing,
    valid: e.valid
  };
}
function mge(t) {
  return {
    isInvalid: !t.validity.valid,
    validationDetails: pge(t),
    validationErrors: t.validationMessage ? [
      t.validationMessage
    ] : []
  };
}
function gge(t) {
  for (let e = 0; e < t.elements.length; e++) {
    let n = t.elements[e];
    if (!n.validity.valid)
      return n;
  }
  return null;
}
function vge(t) {
  let { id: e, label: n, "aria-labelledby": r, "aria-label": i, labelElementType: a = "label" } = t;
  e = AT(e);
  let s = AT(), c = {};
  n ? (r = r ? `${s} ${r}` : s, c = {
    id: s,
    htmlFor: a === "label" ? e : void 0
  }) : !r && !i && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let d = H1e({
    id: e,
    "aria-label": i,
    "aria-labelledby": r
  });
  return {
    labelProps: c,
    fieldProps: d
  };
}
function yge(t) {
  let { description: e, errorMessage: n, isInvalid: r, validationState: i } = t, { labelProps: a, fieldProps: s } = vge(t), c = DB([
    !!e,
    !!n,
    r,
    i
  ]), d = DB([
    !!e,
    !!n,
    r,
    i
  ]);
  return s = OT(s, {
    "aria-describedby": [
      c,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      d,
      t["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: a,
    fieldProps: s,
    descriptionProps: {
      id: c
    },
    errorMessageProps: {
      id: d
    }
  };
}
function WY(t, e) {
  let { inputElementType: n = "input", isDisabled: r = !1, isRequired: i = !1, isReadOnly: a = !1, type: s = "text", validationBehavior: c = "aria" } = t, [d, f] = X1e(t.value, t.defaultValue || "", t.onChange), { focusableProps: g } = lge(t, e), m = uge({
    ...t,
    value: d
  }), { isInvalid: b, validationErrors: w, validationDetails: _ } = m.displayValidation, { labelProps: A, fieldProps: T, descriptionProps: O, errorMessageProps: R } = yge({
    ...t,
    isInvalid: b,
    errorMessage: t.errorMessage || w
  }), N = I1e(t, {
    labelable: !0
  });
  const M = {
    type: s,
    pattern: t.pattern
  };
  return Y1e(e, d, f), hge(t, m, e), I.useEffect(() => {
    if (e.current instanceof CT(e.current).HTMLTextAreaElement) {
      let P = e.current;
      Object.defineProperty(P, "defaultValue", {
        get: () => P.value,
        set: () => {
        },
        configurable: !0
      });
    }
  }, [
    e
  ]), {
    labelProps: A,
    inputProps: OT(N, n === "input" ? M : void 0, {
      disabled: r,
      readOnly: a,
      required: i && c === "native",
      "aria-required": i && c === "aria" || void 0,
      "aria-invalid": b || void 0,
      "aria-errormessage": t["aria-errormessage"],
      "aria-activedescendant": t["aria-activedescendant"],
      "aria-autocomplete": t["aria-autocomplete"],
      "aria-haspopup": t["aria-haspopup"],
      "aria-controls": t["aria-controls"],
      value: d,
      onChange: (P) => f(P.target.value),
      autoComplete: t.autoComplete,
      autoCapitalize: t.autoCapitalize,
      maxLength: t.maxLength,
      minLength: t.minLength,
      name: t.name,
      placeholder: t.placeholder,
      inputMode: t.inputMode,
      autoCorrect: t.autoCorrect,
      spellCheck: t.spellCheck,
      [parseInt(De.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: t.enterKeyHint,
      // Clipboard events
      onCopy: t.onCopy,
      onCut: t.onCut,
      onPaste: t.onPaste,
      // Composition events
      onCompositionEnd: t.onCompositionEnd,
      onCompositionStart: t.onCompositionStart,
      onCompositionUpdate: t.onCompositionUpdate,
      // Selection events
      onSelect: t.onSelect,
      // Input events
      onBeforeInput: t.onBeforeInput,
      onInput: t.onInput,
      ...g,
      ...T
    }),
    descriptionProps: O,
    errorMessageProps: R,
    isInvalid: b,
    validationErrors: w,
    validationDetails: _
  };
}
const QY = I.createContext(null), ZY = () => {
  const t = I.useContext(QY);
  if (t == null)
    throw new Error("Popover components must be wrapped in <Popover />");
  return t;
}, DT = Math.min, lg = Math.max, NT = Math.round, PC = Math.floor, Wd = (t) => ({
  x: t,
  y: t
}), bge = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, wge = {
  start: "end",
  end: "start"
};
function LB(t, e, n) {
  return lg(t, DT(e, n));
}
function z5(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function _g(t) {
  return t.split("-")[0];
}
function F5(t) {
  return t.split("-")[1];
}
function KY(t) {
  return t === "x" ? "y" : "x";
}
function JY(t) {
  return t === "y" ? "height" : "width";
}
const xge = /* @__PURE__ */ new Set(["top", "bottom"]);
function I0(t) {
  return xge.has(_g(t)) ? "y" : "x";
}
function eX(t) {
  return KY(I0(t));
}
function Sge(t, e, n) {
  n === void 0 && (n = !1);
  const r = F5(t), i = eX(t), a = JY(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (s = MT(s)), [s, MT(s)];
}
function Ege(t) {
  const e = MT(t);
  return [j8(t), e, j8(e)];
}
function j8(t) {
  return t.replace(/start|end/g, (e) => wge[e]);
}
const BB = ["left", "right"], zB = ["right", "left"], _ge = ["top", "bottom"], Age = ["bottom", "top"];
function Cge(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? zB : BB : e ? BB : zB;
    case "left":
    case "right":
      return e ? _ge : Age;
    default:
      return [];
  }
}
function Tge(t, e, n, r) {
  const i = F5(t);
  let a = Cge(_g(t), n === "start", r);
  return i && (a = a.map((s) => s + "-" + i), e && (a = a.concat(a.map(j8)))), a;
}
function MT(t) {
  return t.replace(/left|right|bottom|top/g, (e) => bge[e]);
}
function Oge(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Rge(t) {
  return typeof t != "number" ? Oge(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function IT(t) {
  const {
    x: e,
    y: n,
    width: r,
    height: i
  } = t;
  return {
    width: r,
    height: i,
    top: n,
    left: e,
    right: e + r,
    bottom: n + i,
    x: e,
    y: n
  };
}
function FB(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const a = I0(e), s = eX(e), c = JY(s), d = _g(e), f = a === "y", g = r.x + r.width / 2 - i.width / 2, m = r.y + r.height / 2 - i.height / 2, b = r[c] / 2 - i[c] / 2;
  let w;
  switch (d) {
    case "top":
      w = {
        x: g,
        y: r.y - i.height
      };
      break;
    case "bottom":
      w = {
        x: g,
        y: r.y + r.height
      };
      break;
    case "right":
      w = {
        x: r.x + r.width,
        y: m
      };
      break;
    case "left":
      w = {
        x: r.x - i.width,
        y: m
      };
      break;
    default:
      w = {
        x: r.x,
        y: r.y
      };
  }
  switch (F5(e)) {
    case "start":
      w[s] -= b * (n && f ? -1 : 1);
      break;
    case "end":
      w[s] += b * (n && f ? -1 : 1);
      break;
  }
  return w;
}
const Dge = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: s
  } = n, c = a.filter(Boolean), d = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let f = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: g,
    y: m
  } = FB(f, r, d), b = r, w = {}, _ = 0;
  for (let A = 0; A < c.length; A++) {
    const {
      name: T,
      fn: O
    } = c[A], {
      x: R,
      y: N,
      data: M,
      reset: P
    } = await O({
      x: g,
      y: m,
      initialPlacement: r,
      placement: b,
      strategy: i,
      middlewareData: w,
      rects: f,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    g = R ?? g, m = N ?? m, w = {
      ...w,
      [T]: {
        ...w[T],
        ...M
      }
    }, P && _ <= 50 && (_++, typeof P == "object" && (P.placement && (b = P.placement), P.rects && (f = P.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : P.rects), {
      x: g,
      y: m
    } = FB(f, b, d)), A = -1);
  }
  return {
    x: g,
    y: m,
    placement: b,
    strategy: i,
    middlewareData: w
  };
};
async function tX(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: a,
    rects: s,
    elements: c,
    strategy: d
  } = t, {
    boundary: f = "clippingAncestors",
    rootBoundary: g = "viewport",
    elementContext: m = "floating",
    altBoundary: b = !1,
    padding: w = 0
  } = z5(e, t), _ = Rge(w), T = c[b ? m === "floating" ? "reference" : "floating" : m], O = IT(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(T))) == null || n ? T : T.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(c.floating)),
    boundary: f,
    rootBoundary: g,
    strategy: d
  })), R = m === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, N = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c.floating)), M = await (a.isElement == null ? void 0 : a.isElement(N)) ? await (a.getScale == null ? void 0 : a.getScale(N)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, P = IT(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: R,
    offsetParent: N,
    strategy: d
  }) : R);
  return {
    top: (O.top - P.top + _.top) / M.y,
    bottom: (P.bottom - O.bottom + _.bottom) / M.y,
    left: (O.left - P.left + _.left) / M.x,
    right: (P.right - O.right + _.right) / M.x
  };
}
const Nge = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: i,
        middlewareData: a,
        rects: s,
        initialPlacement: c,
        platform: d,
        elements: f
      } = e, {
        mainAxis: g = !0,
        crossAxis: m = !0,
        fallbackPlacements: b,
        fallbackStrategy: w = "bestFit",
        fallbackAxisSideDirection: _ = "none",
        flipAlignment: A = !0,
        ...T
      } = z5(t, e);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const O = _g(i), R = I0(c), N = _g(c) === c, M = await (d.isRTL == null ? void 0 : d.isRTL(f.floating)), P = b || (N || !A ? [MT(c)] : Ege(c)), z = _ !== "none";
      !b && z && P.push(...Tge(c, A, _, M));
      const F = [c, ...P], $ = await tX(e, T), G = [];
      let H = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (g && G.push($[O]), m) {
        const ee = Sge(i, s, M);
        G.push($[ee[0]], $[ee[1]]);
      }
      if (H = [...H, {
        placement: i,
        overflows: G
      }], !G.every((ee) => ee <= 0)) {
        var Z, V;
        const ee = (((Z = a.flip) == null ? void 0 : Z.index) || 0) + 1, K = F[ee];
        if (K && (!(m === "alignment" ? R !== I0(K) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        H.every((W) => W.overflows[0] > 0 && I0(W.placement) === R)))
          return {
            data: {
              index: ee,
              overflows: H
            },
            reset: {
              placement: K
            }
          };
        let U = (V = H.filter((q) => q.overflows[0] <= 0).sort((q, W) => q.overflows[1] - W.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!U)
          switch (w) {
            case "bestFit": {
              var Y;
              const q = (Y = H.filter((W) => {
                if (z) {
                  const ie = I0(W.placement);
                  return ie === R || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ie === "y";
                }
                return !0;
              }).map((W) => [W.placement, W.overflows.filter((ie) => ie > 0).reduce((ie, J) => ie + J, 0)]).sort((W, ie) => W[1] - ie[1])[0]) == null ? void 0 : Y[0];
              q && (U = q);
              break;
            }
            case "initialPlacement":
              U = c;
              break;
          }
        if (i !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
}, Mge = /* @__PURE__ */ new Set(["left", "top"]);
async function Ige(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = _g(n), c = F5(n), d = I0(n) === "y", f = Mge.has(s) ? -1 : 1, g = a && d ? -1 : 1, m = z5(e, t);
  let {
    mainAxis: b,
    crossAxis: w,
    alignmentAxis: _
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return c && typeof _ == "number" && (w = c === "end" ? _ * -1 : _), d ? {
    x: w * g,
    y: b * f
  } : {
    x: b * f,
    y: w * g
  };
}
const kge = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: i,
        y: a,
        placement: s,
        middlewareData: c
      } = e, d = await Ige(e, t);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: i + d.x,
        y: a + d.y,
        data: {
          ...d,
          placement: s
        }
      };
    }
  };
}, jge = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: a = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (T) => {
            let {
              x: O,
              y: R
            } = T;
            return {
              x: O,
              y: R
            };
          }
        },
        ...d
      } = z5(t, e), f = {
        x: n,
        y: r
      }, g = await tX(e, d), m = I0(_g(i)), b = KY(m);
      let w = f[b], _ = f[m];
      if (a) {
        const T = b === "y" ? "top" : "left", O = b === "y" ? "bottom" : "right", R = w + g[T], N = w - g[O];
        w = LB(R, w, N);
      }
      if (s) {
        const T = m === "y" ? "top" : "left", O = m === "y" ? "bottom" : "right", R = _ + g[T], N = _ - g[O];
        _ = LB(R, _, N);
      }
      const A = c.fn({
        ...e,
        [b]: w,
        [m]: _
      });
      return {
        ...A,
        data: {
          x: A.x - n,
          y: A.y - r,
          enabled: {
            [b]: a,
            [m]: s
          }
        }
      };
    }
  };
};
function V5() {
  return typeof window < "u";
}
function dw(t) {
  return nX(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Yl(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function cf(t) {
  var e;
  return (e = (nX(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function nX(t) {
  return V5() ? t instanceof Node || t instanceof Yl(t).Node : !1;
}
function Xu(t) {
  return V5() ? t instanceof Element || t instanceof Yl(t).Element : !1;
}
function nf(t) {
  return V5() ? t instanceof HTMLElement || t instanceof Yl(t).HTMLElement : !1;
}
function VB(t) {
  return !V5() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Yl(t).ShadowRoot;
}
const Pge = /* @__PURE__ */ new Set(["inline", "contents"]);
function R_(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = Wu(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !Pge.has(i);
}
const Lge = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Bge(t) {
  return Lge.has(dw(t));
}
const zge = [":popover-open", ":modal"];
function U5(t) {
  return zge.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
const Fge = ["transform", "translate", "scale", "rotate", "perspective"], Vge = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Uge = ["paint", "layout", "strict", "content"];
function CI(t) {
  const e = TI(), n = Xu(t) ? Wu(t) : t;
  return Fge.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || Vge.some((r) => (n.willChange || "").includes(r)) || Uge.some((r) => (n.contain || "").includes(r));
}
function $ge(t) {
  let e = G0(t);
  for (; nf(e) && !Xb(e); ) {
    if (CI(e))
      return e;
    if (U5(e))
      return null;
    e = G0(e);
  }
  return null;
}
function TI() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Hge = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Xb(t) {
  return Hge.has(dw(t));
}
function Wu(t) {
  return Yl(t).getComputedStyle(t);
}
function $5(t) {
  return Xu(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function G0(t) {
  if (dw(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    VB(t) && t.host || // Fallback.
    cf(t)
  );
  return VB(e) ? e.host : e;
}
function rX(t) {
  const e = G0(t);
  return Xb(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : nf(e) && R_(e) ? e : rX(e);
}
function P0(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = rX(t), a = i === ((r = t.ownerDocument) == null ? void 0 : r.body), s = Yl(i);
  if (a) {
    const c = P8(s);
    return e.concat(s, s.visualViewport || [], R_(i) ? i : [], c && n ? P0(c) : []);
  }
  return e.concat(i, P0(i, [], n));
}
function P8(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function iX(t) {
  const e = Wu(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = nf(t), a = i ? t.offsetWidth : n, s = i ? t.offsetHeight : r, c = NT(n) !== a || NT(r) !== s;
  return c && (n = a, r = s), {
    width: n,
    height: r,
    $: c
  };
}
function OI(t) {
  return Xu(t) ? t : t.contextElement;
}
function jb(t) {
  const e = OI(t);
  if (!nf(e))
    return Wd(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: a
  } = iX(e);
  let s = (a ? NT(n.width) : n.width) / r, c = (a ? NT(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const qge = /* @__PURE__ */ Wd(0);
function aX(t) {
  const e = Yl(t);
  return !TI() || !e.visualViewport ? qge : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Gge(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Yl(t) ? !1 : e;
}
function Ag(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), a = OI(t);
  let s = Wd(1);
  e && (r ? Xu(r) && (s = jb(r)) : s = jb(t));
  const c = Gge(a, n, r) ? aX(a) : Wd(0);
  let d = (i.left + c.x) / s.x, f = (i.top + c.y) / s.y, g = i.width / s.x, m = i.height / s.y;
  if (a) {
    const b = Yl(a), w = r && Xu(r) ? Yl(r) : r;
    let _ = b, A = P8(_);
    for (; A && r && w !== _; ) {
      const T = jb(A), O = A.getBoundingClientRect(), R = Wu(A), N = O.left + (A.clientLeft + parseFloat(R.paddingLeft)) * T.x, M = O.top + (A.clientTop + parseFloat(R.paddingTop)) * T.y;
      d *= T.x, f *= T.y, g *= T.x, m *= T.y, d += N, f += M, _ = Yl(A), A = P8(_);
    }
  }
  return IT({
    width: g,
    height: m,
    x: d,
    y: f
  });
}
function RI(t, e) {
  const n = $5(t).scrollLeft;
  return e ? e.left + n : Ag(cf(t)).left + n;
}
function oX(t, e, n) {
  n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = r.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    RI(t, r)
  )), a = r.top + e.scrollTop;
  return {
    x: i,
    y: a
  };
}
function Yge(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: r,
    strategy: i
  } = t;
  const a = i === "fixed", s = cf(r), c = e ? U5(e.floating) : !1;
  if (r === s || c && a)
    return n;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, f = Wd(1);
  const g = Wd(0), m = nf(r);
  if ((m || !m && !a) && ((dw(r) !== "body" || R_(s)) && (d = $5(r)), nf(r))) {
    const w = Ag(r);
    f = jb(r), g.x = w.x + r.clientLeft, g.y = w.y + r.clientTop;
  }
  const b = s && !m && !a ? oX(s, d, !0) : Wd(0);
  return {
    width: n.width * f.x,
    height: n.height * f.y,
    x: n.x * f.x - d.scrollLeft * f.x + g.x + b.x,
    y: n.y * f.y - d.scrollTop * f.y + g.y + b.y
  };
}
function Xge(t) {
  return Array.from(t.getClientRects());
}
function Wge(t) {
  const e = cf(t), n = $5(t), r = t.ownerDocument.body, i = lg(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), a = lg(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + RI(t);
  const c = -n.scrollTop;
  return Wu(r).direction === "rtl" && (s += lg(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: s,
    y: c
  };
}
function Qge(t, e) {
  const n = Yl(t), r = cf(t), i = n.visualViewport;
  let a = r.clientWidth, s = r.clientHeight, c = 0, d = 0;
  if (i) {
    a = i.width, s = i.height;
    const f = TI();
    (!f || f && e === "fixed") && (c = i.offsetLeft, d = i.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: c,
    y: d
  };
}
const Zge = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Kge(t, e) {
  const n = Ag(t, !0, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, a = nf(t) ? jb(t) : Wd(1), s = t.clientWidth * a.x, c = t.clientHeight * a.y, d = i * a.x, f = r * a.y;
  return {
    width: s,
    height: c,
    x: d,
    y: f
  };
}
function UB(t, e, n) {
  let r;
  if (e === "viewport")
    r = Qge(t, n);
  else if (e === "document")
    r = Wge(cf(t));
  else if (Xu(e))
    r = Kge(e, n);
  else {
    const i = aX(t);
    r = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return IT(r);
}
function sX(t, e) {
  const n = G0(t);
  return n === e || !Xu(n) || Xb(n) ? !1 : Wu(n).position === "fixed" || sX(n, e);
}
function Jge(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = P0(t, [], !1).filter((c) => Xu(c) && dw(c) !== "body"), i = null;
  const a = Wu(t).position === "fixed";
  let s = a ? G0(t) : t;
  for (; Xu(s) && !Xb(s); ) {
    const c = Wu(s), d = CI(s);
    !d && c.position === "fixed" && (i = null), (a ? !d && !i : !d && c.position === "static" && !!i && Zge.has(i.position) || R_(s) && !d && sX(t, s)) ? r = r.filter((g) => g !== s) : i = c, s = G0(s);
  }
  return e.set(t, r), r;
}
function eve(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const s = [...n === "clippingAncestors" ? U5(e) ? [] : Jge(e, this._c) : [].concat(n), r], c = s[0], d = s.reduce((f, g) => {
    const m = UB(e, g, i);
    return f.top = lg(m.top, f.top), f.right = DT(m.right, f.right), f.bottom = DT(m.bottom, f.bottom), f.left = lg(m.left, f.left), f;
  }, UB(e, c, i));
  return {
    width: d.right - d.left,
    height: d.bottom - d.top,
    x: d.left,
    y: d.top
  };
}
function tve(t) {
  const {
    width: e,
    height: n
  } = iX(t);
  return {
    width: e,
    height: n
  };
}
function nve(t, e, n) {
  const r = nf(e), i = cf(e), a = n === "fixed", s = Ag(t, !0, a, e);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = Wd(0);
  function f() {
    d.x = RI(i);
  }
  if (r || !r && !a)
    if ((dw(e) !== "body" || R_(i)) && (c = $5(e)), r) {
      const w = Ag(e, !0, a, e);
      d.x = w.x + e.clientLeft, d.y = w.y + e.clientTop;
    } else
      i && f();
  a && !r && i && f();
  const g = i && !r && !a ? oX(i, c) : Wd(0), m = s.left + c.scrollLeft - d.x - g.x, b = s.top + c.scrollTop - d.y - g.y;
  return {
    x: m,
    y: b,
    width: s.width,
    height: s.height
  };
}
function P6(t) {
  return Wu(t).position === "static";
}
function $B(t, e) {
  if (!nf(t) || Wu(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return cf(t) === n && (n = n.ownerDocument.body), n;
}
function lX(t, e) {
  const n = Yl(t);
  if (U5(t))
    return n;
  if (!nf(t)) {
    let i = G0(t);
    for (; i && !Xb(i); ) {
      if (Xu(i) && !P6(i))
        return i;
      i = G0(i);
    }
    return n;
  }
  let r = $B(t, e);
  for (; r && Bge(r) && P6(r); )
    r = $B(r, e);
  return r && Xb(r) && P6(r) && !CI(r) ? n : r || $ge(t) || n;
}
const rve = async function(t) {
  const e = this.getOffsetParent || lX, n = this.getDimensions, r = await n(t.floating);
  return {
    reference: nve(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function ive(t) {
  return Wu(t).direction === "rtl";
}
const ave = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Yge,
  getDocumentElement: cf,
  getClippingRect: eve,
  getOffsetParent: lX,
  getElementRects: rve,
  getClientRects: Xge,
  getDimensions: tve,
  getScale: jb,
  isElement: Xu,
  isRTL: ive
};
function cX(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function ove(t, e) {
  let n = null, r;
  const i = cf(t);
  function a() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, d) {
    c === void 0 && (c = !1), d === void 0 && (d = 1), a();
    const f = t.getBoundingClientRect(), {
      left: g,
      top: m,
      width: b,
      height: w
    } = f;
    if (c || e(), !b || !w)
      return;
    const _ = PC(m), A = PC(i.clientWidth - (g + b)), T = PC(i.clientHeight - (m + w)), O = PC(g), N = {
      rootMargin: -_ + "px " + -A + "px " + -T + "px " + -O + "px",
      threshold: lg(0, DT(1, d)) || 1
    };
    let M = !0;
    function P(z) {
      const F = z[0].intersectionRatio;
      if (F !== d) {
        if (!M)
          return s();
        F ? s(!1, F) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      F === 1 && !cX(f, t.getBoundingClientRect()) && s(), M = !1;
    }
    try {
      n = new IntersectionObserver(P, {
        ...N,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(P, N);
    }
    n.observe(t);
  }
  return s(!0), a;
}
function sve(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = r, f = OI(t), g = i || a ? [...f ? P0(f) : [], ...P0(e)] : [];
  g.forEach((O) => {
    i && O.addEventListener("scroll", n, {
      passive: !0
    }), a && O.addEventListener("resize", n);
  });
  const m = f && c ? ove(f, n) : null;
  let b = -1, w = null;
  s && (w = new ResizeObserver((O) => {
    let [R] = O;
    R && R.target === f && w && (w.unobserve(e), cancelAnimationFrame(b), b = requestAnimationFrame(() => {
      var N;
      (N = w) == null || N.observe(e);
    })), n();
  }), f && !d && w.observe(f), w.observe(e));
  let _, A = d ? Ag(t) : null;
  d && T();
  function T() {
    const O = Ag(t);
    A && !cX(A, O) && n(), A = O, _ = requestAnimationFrame(T);
  }
  return n(), () => {
    var O;
    g.forEach((R) => {
      i && R.removeEventListener("scroll", n), a && R.removeEventListener("resize", n);
    }), m?.(), (O = w) == null || O.disconnect(), w = null, d && cancelAnimationFrame(_);
  };
}
const lve = kge, cve = jge, uve = Nge, dve = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: ave,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return Dge(t, e, {
    ...i,
    platform: a
  });
};
var g4 = typeof document < "u" ? I.useLayoutEffect : I.useEffect;
function kT(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, i;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!kT(t[r], e[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = i[r];
      if (!(a === "_owner" && t.$$typeof) && !kT(t[a], e[a]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function HB(t) {
  const e = I.useRef(t);
  return g4(() => {
    e.current = t;
  }), e;
}
function fve(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    whileElementsMounted: a,
    open: s
  } = t, [c, d] = I.useState({
    x: null,
    y: null,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, g] = I.useState(r);
  kT(f, r) || g(r);
  const m = I.useRef(null), b = I.useRef(null), w = I.useRef(c), _ = HB(a), A = HB(i), [T, O] = I.useState(null), [R, N] = I.useState(null), M = I.useCallback((H) => {
    m.current !== H && (m.current = H, O(H));
  }, []), P = I.useCallback((H) => {
    b.current !== H && (b.current = H, N(H));
  }, []), z = I.useCallback(() => {
    if (!m.current || !b.current)
      return;
    const H = {
      placement: e,
      strategy: n,
      middleware: f
    };
    A.current && (H.platform = A.current), dve(m.current, b.current, H).then((Z) => {
      const V = {
        ...Z,
        isPositioned: !0
      };
      F.current && !kT(w.current, V) && (w.current = V, Wc.flushSync(() => {
        d(V);
      }));
    });
  }, [f, e, n, A]);
  g4(() => {
    s === !1 && w.current.isPositioned && (w.current.isPositioned = !1, d((H) => ({
      ...H,
      isPositioned: !1
    })));
  }, [s]);
  const F = I.useRef(!1);
  g4(() => (F.current = !0, () => {
    F.current = !1;
  }), []), g4(() => {
    if (T && R) {
      if (_.current)
        return _.current(T, R, z);
      z();
    }
  }, [T, R, z, _]);
  const $ = I.useMemo(() => ({
    reference: m,
    floating: b,
    setReference: M,
    setFloating: P
  }), [M, P]), G = I.useMemo(() => ({
    reference: T,
    floating: R
  }), [T, R]);
  return I.useMemo(() => ({
    ...c,
    update: z,
    refs: $,
    elements: G,
    reference: M,
    floating: P
  }), [c, z, $, G, M, P]);
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var hve = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], L8 = /* @__PURE__ */ hve.join(","), uX = typeof Element > "u", WE = uX ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, jT = !uX && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t?.ownerDocument;
}, PT = function t(e, n) {
  var r;
  n === void 0 && (n = !0);
  var i = e == null || (r = e.getAttribute) === null || r === void 0 ? void 0 : r.call(e, "inert"), a = i === "" || i === "true", s = a || n && e && t(e.parentNode);
  return s;
}, pve = function(e) {
  var n, r = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
  return r === "" || r === "true";
}, mve = function(e, n, r) {
  if (PT(e))
    return [];
  var i = Array.prototype.slice.apply(e.querySelectorAll(L8));
  return n && WE.call(e, L8) && i.unshift(e), i = i.filter(r), i;
}, gve = function t(e, n, r) {
  for (var i = [], a = Array.from(e); a.length; ) {
    var s = a.shift();
    if (!PT(s, !1))
      if (s.tagName === "SLOT") {
        var c = s.assignedElements(), d = c.length ? c : s.children, f = t(d, !0, r);
        r.flatten ? i.push.apply(i, f) : i.push({
          scopeParent: s,
          candidates: f
        });
      } else {
        var g = WE.call(s, L8);
        g && r.filter(s) && (n || !e.includes(s)) && i.push(s);
        var m = s.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(s), b = !PT(m, !1) && (!r.shadowRootFilter || r.shadowRootFilter(s));
        if (m && b) {
          var w = t(m === !0 ? s.children : m.children, !0, r);
          r.flatten ? i.push.apply(i, w) : i.push({
            scopeParent: s,
            candidates: w
          });
        } else
          a.unshift.apply(a, s.children);
      }
  }
  return i;
}, dX = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, fX = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || pve(e)) && !dX(e) ? 0 : e.tabIndex;
}, vve = function(e, n) {
  var r = fX(e);
  return r < 0 && n && !dX(e) ? 0 : r;
}, yve = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, hX = function(e) {
  return e.tagName === "INPUT";
}, bve = function(e) {
  return hX(e) && e.type === "hidden";
}, wve = function(e) {
  var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, xve = function(e, n) {
  for (var r = 0; r < e.length; r++)
    if (e[r].checked && e[r].form === n)
      return e[r];
}, Sve = function(e) {
  if (!e.name)
    return !0;
  var n = e.form || jT(e), r = function(c) {
    return n.querySelectorAll('input[type="radio"][name="' + c + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(e.name));
  else
    try {
      i = r(e.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var a = xve(i, e.form);
  return !a || a === e;
}, Eve = function(e) {
  return hX(e) && e.type === "radio";
}, _ve = function(e) {
  return Eve(e) && !Sve(e);
}, Ave = function(e) {
  var n, r = e && jT(e), i = (n = r) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (r && r !== e) {
    var s, c, d;
    for (a = !!((s = i) !== null && s !== void 0 && (c = s.ownerDocument) !== null && c !== void 0 && c.contains(i) || e != null && (d = e.ownerDocument) !== null && d !== void 0 && d.contains(e)); !a && i; ) {
      var f, g, m;
      r = jT(i), i = (f = r) === null || f === void 0 ? void 0 : f.host, a = !!((g = i) !== null && g !== void 0 && (m = g.ownerDocument) !== null && m !== void 0 && m.contains(i));
    }
  }
  return a;
}, qB = function(e) {
  var n = e.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, Cve = function(e, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var a = WE.call(e, "details>summary:first-of-type"), s = a ? e.parentElement : e;
  if (WE.call(s, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var c = e; e; ) {
        var d = e.parentElement, f = jT(e);
        if (d && !d.shadowRoot && i(d) === !0)
          return qB(e);
        e.assignedSlot ? e = e.assignedSlot : !d && f !== e.ownerDocument ? e = f.host : e = d;
      }
      e = c;
    }
    if (Ave(e))
      return !e.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return qB(e);
  return !1;
}, Tve = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return WE.call(n, "fieldset[disabled] *") ? !0 : !i.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Ove = function(e, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  PT(n) || bve(n) || Cve(n, e) || // For a details element with a summary, the summary element gets the focus
  wve(n) || Tve(n));
}, GB = function(e, n) {
  return !(_ve(n) || fX(n) < 0 || !Ove(e, n));
}, Rve = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Dve = function t(e) {
  var n = [], r = [];
  return e.forEach(function(i, a) {
    var s = !!i.scopeParent, c = s ? i.scopeParent : i, d = vve(c, s), f = s ? t(i.candidates) : c;
    d === 0 ? s ? n.push.apply(n, f) : n.push(c) : r.push({
      documentOrder: a,
      tabIndex: d,
      item: i,
      isScope: s,
      content: f
    });
  }), r.sort(yve).reduce(function(i, a) {
    return a.isScope ? i.push.apply(i, a.content) : i.push(a.content), i;
  }, []).concat(n);
}, LT = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = gve([e], n.includeContainer, {
    filter: GB.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Rve
  }) : r = mve(e, n.includeContainer, GB.bind(null, n)), Dve(r);
};
function BT() {
  return BT = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, BT.apply(this, arguments);
}
var Qd = typeof document < "u" ? I.useLayoutEffect : I.useEffect;
let L6 = !1, Nve = 0;
const YB = () => "floating-ui-" + Nve++;
function Mve() {
  const [t, e] = I.useState(() => L6 ? YB() : void 0);
  return Qd(() => {
    t == null && e(YB());
  }, []), I.useEffect(() => {
    L6 || (L6 = !0);
  }, []), t;
}
const Ive = g_[/* @__PURE__ */ "useId".toString()], B8 = Ive || Mve;
function kve() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      var r;
      (r = t.get(e)) == null || r.forEach((i) => i(n));
    },
    on(e, n) {
      t.set(e, [...t.get(e) || [], n]);
    },
    off(e, n) {
      t.set(e, (t.get(e) || []).filter((r) => r !== n));
    }
  };
}
const jve = /* @__PURE__ */ I.createContext(null), Pve = /* @__PURE__ */ I.createContext(null), pX = () => {
  var t;
  return ((t = I.useContext(jve)) == null ? void 0 : t.id) || null;
}, H5 = () => I.useContext(Pve);
function Hd(t) {
  return t?.ownerDocument || document;
}
function mX() {
  const t = navigator.userAgentData;
  return t != null && t.platform ? t.platform : navigator.platform;
}
function Lve() {
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map((e) => {
    let {
      brand: n,
      version: r
    } = e;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function DI(t) {
  return Hd(t).defaultView || window;
}
function Ch(t) {
  return t ? t instanceof DI(t).Element : !1;
}
function QE(t) {
  return t ? t instanceof DI(t).HTMLElement : !1;
}
function Bve(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  const e = DI(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function zve(t) {
  if (t.mozInputSource === 0 && t.isTrusted)
    return !0;
  const e = /Android/i;
  return (e.test(mX()) || e.test(Lve())) && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function Fve(t) {
  return t.width === 0 && t.height === 0 || t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0;
}
function XB() {
  return /apple/i.test(navigator.vendor);
}
function Vve() {
  return mX().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function zT(t, e) {
  const n = ["mouse", "pen"];
  return e || n.push("", void 0), n.includes(t);
}
function z8(t) {
  const e = I.useRef(t);
  return Qd(() => {
    e.current = t;
  }), e;
}
const WB = "data-floating-ui-safe-polygon";
function B6(t, e, n) {
  return n && !zT(n) ? 0 : typeof t == "number" ? t : t?.[e];
}
const Uve = function(t, e) {
  let {
    enabled: n = !0,
    delay: r = 0,
    handleClose: i = null,
    mouseOnly: a = !1,
    restMs: s = 0,
    move: c = !0
  } = e === void 0 ? {} : e;
  const {
    open: d,
    onOpenChange: f,
    dataRef: g,
    events: m,
    elements: {
      domReference: b,
      floating: w
    },
    refs: _
  } = t, A = H5(), T = pX(), O = z8(i), R = z8(r), N = I.useRef(), M = I.useRef(), P = I.useRef(), z = I.useRef(), F = I.useRef(!0), $ = I.useRef(!1), G = I.useRef(() => {
  }), H = I.useCallback(() => {
    var ee;
    const K = (ee = g.current.openEvent) == null ? void 0 : ee.type;
    return K?.includes("mouse") && K !== "mousedown";
  }, [g]);
  I.useEffect(() => {
    if (!n)
      return;
    function ee() {
      clearTimeout(M.current), clearTimeout(z.current), F.current = !0;
    }
    return m.on("dismiss", ee), () => {
      m.off("dismiss", ee);
    };
  }, [n, m]), I.useEffect(() => {
    if (!n || !O.current || !d)
      return;
    function ee() {
      H() && f(!1);
    }
    const K = Hd(w).documentElement;
    return K.addEventListener("mouseleave", ee), () => {
      K.removeEventListener("mouseleave", ee);
    };
  }, [w, d, f, n, O, g, H]);
  const Z = I.useCallback(function(ee) {
    ee === void 0 && (ee = !0);
    const K = B6(R.current, "close", N.current);
    K && !P.current ? (clearTimeout(M.current), M.current = setTimeout(() => f(!1), K)) : ee && (clearTimeout(M.current), f(!1));
  }, [R, f]), V = I.useCallback(() => {
    G.current(), P.current = void 0;
  }, []), Y = I.useCallback(() => {
    if ($.current) {
      const ee = Hd(_.floating.current).body;
      ee.style.pointerEvents = "", ee.removeAttribute(WB), $.current = !1;
    }
  }, [_]);
  return I.useEffect(() => {
    if (!n)
      return;
    function ee() {
      return g.current.openEvent ? ["click", "mousedown"].includes(g.current.openEvent.type) : !1;
    }
    function K(W) {
      if (clearTimeout(M.current), F.current = !1, a && !zT(N.current) || s > 0 && B6(R.current, "open") === 0)
        return;
      g.current.openEvent = W;
      const ie = B6(R.current, "open", N.current);
      ie ? M.current = setTimeout(() => {
        f(!0);
      }, ie) : f(!0);
    }
    function U(W) {
      if (ee())
        return;
      G.current();
      const ie = Hd(w);
      if (clearTimeout(z.current), O.current) {
        d || clearTimeout(M.current), P.current = O.current({
          ...t,
          tree: A,
          x: W.clientX,
          y: W.clientY,
          onClose() {
            Y(), V(), Z();
          }
        });
        const J = P.current;
        ie.addEventListener("mousemove", J), G.current = () => {
          ie.removeEventListener("mousemove", J);
        };
        return;
      }
      Z();
    }
    function q(W) {
      ee() || O.current == null || O.current({
        ...t,
        tree: A,
        x: W.clientX,
        y: W.clientY,
        onClose() {
          Y(), V(), Z();
        }
      })(W);
    }
    if (Ch(b)) {
      const W = b;
      return d && W.addEventListener("mouseleave", q), w?.addEventListener("mouseleave", q), c && W.addEventListener("mousemove", K, {
        once: !0
      }), W.addEventListener("mouseenter", K), W.addEventListener("mouseleave", U), () => {
        d && W.removeEventListener("mouseleave", q), w?.removeEventListener("mouseleave", q), c && W.removeEventListener("mousemove", K), W.removeEventListener("mouseenter", K), W.removeEventListener("mouseleave", U);
      };
    }
  }, [b, w, n, t, a, s, c, Z, V, Y, f, d, A, R, O, g]), Qd(() => {
    var ee;
    if (n && d && (ee = O.current) != null && ee.__options.blockPointerEvents && H()) {
      const q = Hd(w).body;
      if (q.setAttribute(WB, ""), q.style.pointerEvents = "none", $.current = !0, Ch(b) && w) {
        var K, U;
        const W = b, ie = A == null || (K = A.nodesRef.current.find((J) => J.id === T)) == null || (U = K.context) == null ? void 0 : U.elements.floating;
        return ie && (ie.style.pointerEvents = ""), W.style.pointerEvents = "auto", w.style.pointerEvents = "auto", () => {
          W.style.pointerEvents = "", w.style.pointerEvents = "";
        };
      }
    }
  }, [n, d, T, w, b, A, O, g, H]), Qd(() => {
    d || (N.current = void 0, V(), Y());
  }, [d, V, Y]), I.useEffect(() => () => {
    V(), clearTimeout(M.current), clearTimeout(z.current), Y();
  }, [n, V, Y]), I.useMemo(() => {
    if (!n)
      return {};
    function ee(K) {
      N.current = K.pointerType;
    }
    return {
      reference: {
        onPointerDown: ee,
        onPointerEnter: ee,
        onMouseMove() {
          d || s === 0 || (clearTimeout(z.current), z.current = setTimeout(() => {
            F.current || f(!0);
          }, s));
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(M.current);
        },
        onMouseLeave() {
          m.emit("dismiss", {
            type: "mouseLeave",
            data: {
              returnFocus: !1
            }
          }), Z(!1);
        }
      }
    };
  }, [m, n, s, d, f, Z]);
};
function F8(t) {
  let e = t.activeElement;
  for (; ((n = e) == null || (r = n.shadowRoot) == null ? void 0 : r.activeElement) != null; ) {
    var n, r;
    e = e.shadowRoot.activeElement;
  }
  return e;
}
function E0(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && Bve(n)) {
    let r = e;
    do {
      if (r && t === r)
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
let QB = 0;
function F1(t, e) {
  e === void 0 && (e = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: i = !1
  } = e;
  r && cancelAnimationFrame(QB);
  const a = () => t?.focus({
    preventScroll: n
  });
  i ? a() : QB = requestAnimationFrame(a);
}
function $ve(t, e) {
  var n;
  let r = [], i = (n = t.find((a) => a.id === e)) == null ? void 0 : n.parentId;
  for (; i; ) {
    const a = t.find((s) => s.id === i);
    i = a?.parentId, a && (r = r.concat(a));
  }
  return r;
}
function v4(t, e) {
  let n = t.filter((i) => {
    var a;
    return i.parentId === e && ((a = i.context) == null ? void 0 : a.open);
  }) || [], r = n;
  for (; r.length; )
    r = t.filter((i) => {
      var a;
      return (a = r) == null ? void 0 : a.some((s) => {
        var c;
        return i.parentId === s.id && ((c = i.context) == null ? void 0 : c.open);
      });
    }) || [], n = n.concat(r);
  return n;
}
function gX(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
const Hve = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function vX(t) {
  return QE(t) && t.matches(Hve);
}
function z6(t) {
  t.preventDefault(), t.stopPropagation();
}
const FT = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function yX(t, e) {
  const n = LT(t, FT());
  e === "prev" && n.reverse();
  const r = n.indexOf(F8(Hd(t)));
  return n.slice(r + 1)[0];
}
function bX() {
  return yX(document.body, "next");
}
function wX() {
  return yX(document.body, "prev");
}
function mE(t, e) {
  const n = e || t.currentTarget, r = t.relatedTarget;
  return !r || !E0(n, r);
}
function qve(t) {
  LT(t, FT()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function Gve(t) {
  t.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const Yve = g_[/* @__PURE__ */ "useInsertionEffect".toString()], Xve = Yve || ((t) => t());
function NI(t) {
  const e = I.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Xve(() => {
    e.current = t;
  }), I.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return e.current == null ? void 0 : e.current(...r);
  }, []);
}
const MI = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let V8, II;
function ZB(t) {
  t.key === "Tab" && (V8 = t.target, clearTimeout(II));
}
function Wve(t) {
  const e = V8 === t.relatedTarget;
  return V8 = t.relatedTarget, clearTimeout(II), e;
}
const VT = /* @__PURE__ */ I.forwardRef(function(e, n) {
  const r = NI(e.onFocus), [i, a] = I.useState();
  return Qd(() => (XB() && a("button"), document.addEventListener("keydown", ZB), () => {
    document.removeEventListener("keydown", ZB);
  }), []), /* @__PURE__ */ I.createElement("span", BT({}, e, {
    ref: n,
    tabIndex: 0,
    role: i,
    "aria-hidden": i ? void 0 : !0,
    "data-floating-ui-focus-guard": "",
    style: MI,
    onFocus: (s) => {
      XB() && Vve() && !Wve(s) ? (s.persist(), II = window.setTimeout(() => {
        r(s);
      }, 50)) : r(s);
    }
  }));
}), xX = /* @__PURE__ */ I.createContext(null), Qve = function(t) {
  let {
    id: e,
    enabled: n = !0
  } = t === void 0 ? {} : t;
  const [r, i] = I.useState(null), a = B8(), s = SX();
  return Qd(() => {
    if (!n)
      return;
    const c = e ? document.getElementById(e) : null;
    if (c)
      c.setAttribute("data-floating-ui-portal", ""), i(c);
    else {
      const d = document.createElement("div");
      e !== "" && (d.id = e || a), d.setAttribute("data-floating-ui-portal", ""), i(d);
      const f = s?.portalNode || document.body;
      return f.appendChild(d), () => {
        f.removeChild(d);
      };
    }
  }, [e, s, a, n]), r;
}, Zve = (t) => {
  let {
    children: e,
    id: n,
    root: r = null,
    preserveTabOrder: i = !0
  } = t;
  const a = Qve({
    id: n,
    enabled: !r
  }), [s, c] = I.useState(null), d = I.useRef(null), f = I.useRef(null), g = I.useRef(null), m = I.useRef(null), b = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!s && // Guards are only for non-modal focus management.
    !s.modal && !!(r || a) && i
  );
  return I.useEffect(() => {
    if (!a || !i || s != null && s.modal)
      return;
    function w(_) {
      a && mE(_) && (_.type === "focusin" ? Gve : qve)(a);
    }
    return a.addEventListener("focusin", w, !0), a.addEventListener("focusout", w, !0), () => {
      a.removeEventListener("focusin", w, !0), a.removeEventListener("focusout", w, !0);
    };
  }, [a, i, s?.modal]), /* @__PURE__ */ I.createElement(xX.Provider, {
    value: I.useMemo(() => ({
      preserveTabOrder: i,
      beforeOutsideRef: d,
      afterOutsideRef: f,
      beforeInsideRef: g,
      afterInsideRef: m,
      portalNode: a,
      setFocusManagerState: c
    }), [i, a])
  }, b && a && /* @__PURE__ */ I.createElement(VT, {
    "data-type": "outside",
    ref: d,
    onFocus: (w) => {
      if (mE(w, a)) {
        var _;
        (_ = g.current) == null || _.focus();
      } else {
        const A = wX() || s?.refs.domReference.current;
        A?.focus();
      }
    }
  }), b && a && /* @__PURE__ */ I.createElement("span", {
    "aria-owns": a.id,
    style: MI
  }), r ? /* @__PURE__ */ Wc.createPortal(e, r) : a ? /* @__PURE__ */ Wc.createPortal(e, a) : null, b && a && /* @__PURE__ */ I.createElement(VT, {
    "data-type": "outside",
    ref: f,
    onFocus: (w) => {
      if (mE(w, a)) {
        var _;
        (_ = m.current) == null || _.focus();
      } else {
        const A = bX() || s?.refs.domReference.current;
        A?.focus(), s?.closeOnFocusOut && s?.onOpenChange(!1);
      }
    }
  }));
}, SX = () => I.useContext(xX), Kve = /* @__PURE__ */ I.forwardRef(function(e, n) {
  return /* @__PURE__ */ I.createElement("button", BT({}, e, {
    type: "button",
    ref: n,
    tabIndex: -1,
    style: MI
  }));
});
function Jve(t) {
  let {
    context: e,
    children: n,
    order: r = ["content"],
    guards: i = !0,
    initialFocus: a = 0,
    returnFocus: s = !0,
    modal: c = !0,
    visuallyHiddenDismiss: d = !1,
    closeOnFocusOut: f = !0
  } = t;
  const {
    refs: g,
    nodeId: m,
    onOpenChange: b,
    events: w,
    dataRef: _,
    elements: {
      domReference: A,
      floating: T
    }
  } = e, O = z8(r), R = H5(), N = SX(), [M, P] = I.useState(null), z = typeof a == "number" && a < 0, F = I.useRef(null), $ = I.useRef(null), G = I.useRef(!1), H = I.useRef(null), Z = I.useRef(!1), V = N != null, Y = A && A.getAttribute("role") === "combobox" && vX(A), ee = I.useCallback(function(W) {
    return W === void 0 && (W = T), W ? LT(W, FT()) : [];
  }, [T]), K = I.useCallback((W) => {
    const ie = ee(W);
    return O.current.map((J) => A && J === "reference" ? A : T && J === "floating" ? T : ie).filter(Boolean).flat();
  }, [A, T, O, ee]);
  I.useEffect(() => {
    if (!c)
      return;
    function W(J) {
      if (J.key === "Tab") {
        ee().length === 0 && !Y && z6(J);
        const B = K(), te = gX(J);
        O.current[0] === "reference" && te === A && (z6(J), J.shiftKey ? F1(B[B.length - 1]) : F1(B[1])), O.current[1] === "floating" && te === T && J.shiftKey && (z6(J), F1(B[0]));
      }
    }
    const ie = Hd(T);
    return ie.addEventListener("keydown", W), () => {
      ie.removeEventListener("keydown", W);
    };
  }, [A, T, c, O, g, Y, ee, K]), I.useEffect(() => {
    if (!f)
      return;
    function W() {
      Z.current = !0, setTimeout(() => {
        Z.current = !1;
      });
    }
    function ie(J) {
      const B = J.relatedTarget, te = !(E0(A, B) || E0(T, B) || E0(B, T) || E0(N?.portalNode, B) || B != null && B.hasAttribute("data-floating-ui-focus-guard") || R && (v4(R.nodesRef.current, m).find((ae) => {
        var le, de;
        return E0((le = ae.context) == null ? void 0 : le.elements.floating, B) || E0((de = ae.context) == null ? void 0 : de.elements.domReference, B);
      }) || $ve(R.nodesRef.current, m).find((ae) => {
        var le, de;
        return ((le = ae.context) == null ? void 0 : le.elements.floating) === B || ((de = ae.context) == null ? void 0 : de.elements.domReference) === B;
      })));
      B && te && !Z.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
      B !== H.current && (G.current = !0, setTimeout(() => b(!1)));
    }
    if (T && QE(A))
      return A.addEventListener("focusout", ie), A.addEventListener("pointerdown", W), !c && T.addEventListener("focusout", ie), () => {
        A.removeEventListener("focusout", ie), A.removeEventListener("pointerdown", W), !c && T.removeEventListener("focusout", ie);
      };
  }, [A, T, c, m, R, N, b, f]), I.useEffect(() => {
    var W;
    const ie = Array.from((N == null || (W = N.portalNode) == null ? void 0 : W.querySelectorAll("[data-floating-ui-portal]")) || []);
    function J() {
      return [F.current, $.current].filter(Boolean);
    }
    if (T && c) {
      const B = [T, ...ie, ...J()], te = jq(O.current.includes("reference") || Y ? B.concat(A || []) : B);
      return () => {
        te();
      };
    }
  }, [A, T, c, O, N, Y]), I.useEffect(() => {
    if (c && !i && T) {
      const W = [], ie = FT(), J = LT(Hd(T).body, ie), B = K(), te = J.filter((ae) => !B.includes(ae));
      return te.forEach((ae, le) => {
        W[le] = ae.getAttribute("tabindex"), ae.setAttribute("tabindex", "-1");
      }), () => {
        te.forEach((ae, le) => {
          const de = W[le];
          de == null ? ae.removeAttribute("tabindex") : ae.setAttribute("tabindex", de);
        });
      };
    }
  }, [T, c, i, K]), Qd(() => {
    if (!T)
      return;
    const W = Hd(T);
    let ie = s, J = !1;
    const B = F8(W), te = _.current;
    H.current = B;
    const ae = K(T), le = (typeof a == "number" ? ae[a] : a.current) || T;
    !z && F1(le, {
      preventScroll: le === T
    });
    function de(_e) {
      if (_e.type === "escapeKey" && g.domReference.current && (H.current = g.domReference.current), ["referencePress", "escapeKey"].includes(_e.type))
        return;
      const ue = _e.data.returnFocus;
      typeof ue == "object" ? (ie = !0, J = ue.preventScroll) : ie = ue;
    }
    return w.on("dismiss", de), () => {
      if (w.off("dismiss", de), E0(T, F8(W)) && g.domReference.current && (H.current = g.domReference.current), ie && QE(H.current) && !G.current)
        if (!g.domReference.current || Z.current)
          F1(H.current, {
            // When dismissing nested floating elements, by the time the rAF has
            // executed, the menus will all have been unmounted. When they try
            // to get focused, the calls get ignored — leaving the root
            // reference focused as desired.
            cancelPrevious: !1,
            preventScroll: J
          });
        else {
          var _e;
          te.__syncReturnFocus = !0, (_e = H.current) == null || _e.focus({
            preventScroll: J
          }), setTimeout(() => {
            delete te.__syncReturnFocus;
          });
        }
    };
  }, [T, K, a, s, _, g, w, z]), Qd(() => {
    if (N)
      return N.setFocusManagerState({
        ...e,
        modal: c,
        closeOnFocusOut: f
        // Not concerned about the <RT> generic type.
      }), () => {
        N.setFocusManagerState(null);
      };
  }, [N, c, f, e]), Qd(() => {
    if (z || !T)
      return;
    function W() {
      P(ee().length);
    }
    if (W(), typeof MutationObserver == "function") {
      const ie = new MutationObserver(W);
      return ie.observe(T, {
        childList: !0,
        subtree: !0
      }), () => {
        ie.disconnect();
      };
    }
  }, [T, ee, z, g]);
  const U = i && (V || c) && !Y;
  function q(W) {
    return d && c ? /* @__PURE__ */ I.createElement(Kve, {
      ref: W === "start" ? F : $,
      onClick: () => b(!1)
    }, typeof d == "string" ? d : "Dismiss") : null;
  }
  return /* @__PURE__ */ I.createElement(I.Fragment, null, U && /* @__PURE__ */ I.createElement(VT, {
    "data-type": "inside",
    ref: N?.beforeInsideRef,
    onFocus: (W) => {
      if (c) {
        const J = K();
        F1(r[0] === "reference" ? J[0] : J[J.length - 1]);
      } else if (N != null && N.preserveTabOrder && N.portalNode)
        if (G.current = !1, mE(W, N.portalNode)) {
          const J = bX() || A;
          J?.focus();
        } else {
          var ie;
          (ie = N.beforeOutsideRef.current) == null || ie.focus();
        }
    }
  }), Y ? null : q("start"), /* @__PURE__ */ I.cloneElement(n, M === 0 || r.includes("floating") ? {
    tabIndex: 0
  } : {}), q("end"), U && /* @__PURE__ */ I.createElement(VT, {
    "data-type": "inside",
    ref: N?.afterInsideRef,
    onFocus: (W) => {
      if (c)
        F1(K()[0]);
      else if (N != null && N.preserveTabOrder && N.portalNode)
        if (G.current = !0, mE(W, N.portalNode)) {
          const J = wX() || A;
          J?.focus();
        } else {
          var ie;
          (ie = N.afterOutsideRef.current) == null || ie.focus();
        }
    }
  }));
}
function KB(t) {
  return QE(t.target) && t.target.tagName === "BUTTON";
}
function JB(t) {
  return vX(t);
}
const eye = function(t, e) {
  let {
    open: n,
    onOpenChange: r,
    dataRef: i,
    elements: {
      domReference: a
    }
  } = t, {
    enabled: s = !0,
    event: c = "click",
    toggle: d = !0,
    ignoreMouse: f = !1,
    keyboardHandlers: g = !0
  } = e === void 0 ? {} : e;
  const m = I.useRef();
  return I.useMemo(() => s ? {
    reference: {
      onPointerDown(b) {
        m.current = b.pointerType;
      },
      onMouseDown(b) {
        b.button === 0 && (zT(m.current, !0) && f || c !== "click" && (n ? d && (!i.current.openEvent || i.current.openEvent.type === "mousedown") && r(!1) : (b.preventDefault(), r(!0)), i.current.openEvent = b.nativeEvent));
      },
      onClick(b) {
        if (!i.current.__syncReturnFocus) {
          if (c === "mousedown" && m.current) {
            m.current = void 0;
            return;
          }
          zT(m.current, !0) && f || (n ? d && (!i.current.openEvent || i.current.openEvent.type === "click") && r(!1) : r(!0), i.current.openEvent = b.nativeEvent);
        }
      },
      onKeyDown(b) {
        m.current = void 0, g && (KB(b) || (b.key === " " && !JB(a) && b.preventDefault(), b.key === "Enter" && (n ? d && r(!1) : r(!0))));
      },
      onKeyUp(b) {
        g && (KB(b) || JB(a) || b.key === " " && (n ? d && r(!1) : r(!0)));
      }
    }
  } : {}, [s, i, c, f, g, a, d, n, r]);
};
function F6(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const n = t;
  return n.target != null && e.contains(n.target);
}
const tye = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, nye = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, rye = function(t) {
  var e, n;
  return t === void 0 && (t = !0), {
    escapeKeyBubbles: typeof t == "boolean" ? t : (e = t.escapeKey) != null ? e : !0,
    outsidePressBubbles: typeof t == "boolean" ? t : (n = t.outsidePress) != null ? n : !0
  };
}, iye = function(t, e) {
  let {
    open: n,
    onOpenChange: r,
    events: i,
    nodeId: a,
    elements: {
      reference: s,
      domReference: c,
      floating: d
    },
    dataRef: f
  } = t, {
    enabled: g = !0,
    escapeKey: m = !0,
    outsidePress: b = !0,
    outsidePressEvent: w = "pointerdown",
    referencePress: _ = !1,
    referencePressEvent: A = "pointerdown",
    ancestorScroll: T = !1,
    bubbles: O = !0
  } = e === void 0 ? {} : e;
  const R = H5(), N = pX() != null, M = NI(typeof b == "function" ? b : () => !1), P = typeof b == "function" ? M : b, z = I.useRef(!1), {
    escapeKeyBubbles: F,
    outsidePressBubbles: $
  } = rye(O);
  return I.useEffect(() => {
    if (!n || !g)
      return;
    f.current.__escapeKeyBubbles = F, f.current.__outsidePressBubbles = $;
    function G(ee) {
      if (ee.key === "Escape") {
        const K = R ? v4(R.nodesRef.current, a) : [];
        if (K.length > 0) {
          let U = !0;
          if (K.forEach((q) => {
            var W;
            if ((W = q.context) != null && W.open && !q.context.dataRef.current.__escapeKeyBubbles) {
              U = !1;
              return;
            }
          }), !U)
            return;
        }
        i.emit("dismiss", {
          type: "escapeKey",
          data: {
            returnFocus: {
              preventScroll: !1
            }
          }
        }), r(!1);
      }
    }
    function H(ee) {
      const K = z.current;
      if (z.current = !1, K || typeof P == "function" && !P(ee))
        return;
      const U = gX(ee);
      if (QE(U) && d) {
        const ie = d.ownerDocument.defaultView || window, J = U.scrollWidth > U.clientWidth, B = U.scrollHeight > U.clientHeight;
        let te = B && ee.offsetX > U.clientWidth;
        if (B && ie.getComputedStyle(U).direction === "rtl" && (te = ee.offsetX <= U.offsetWidth - U.clientWidth), te || J && ee.offsetY > U.clientHeight)
          return;
      }
      const q = R && v4(R.nodesRef.current, a).some((ie) => {
        var J;
        return F6(ee, (J = ie.context) == null ? void 0 : J.elements.floating);
      });
      if (F6(ee, d) || F6(ee, c) || q)
        return;
      const W = R ? v4(R.nodesRef.current, a) : [];
      if (W.length > 0) {
        let ie = !0;
        if (W.forEach((J) => {
          var B;
          if ((B = J.context) != null && B.open && !J.context.dataRef.current.__outsidePressBubbles) {
            ie = !1;
            return;
          }
        }), !ie)
          return;
      }
      i.emit("dismiss", {
        type: "outsidePress",
        data: {
          returnFocus: N ? {
            preventScroll: !0
          } : zve(ee) || Fve(ee)
        }
      }), r(!1);
    }
    function Z() {
      r(!1);
    }
    const V = Hd(d);
    m && V.addEventListener("keydown", G), P && V.addEventListener(w, H);
    let Y = [];
    return T && (Ch(c) && (Y = P0(c)), Ch(d) && (Y = Y.concat(P0(d))), !Ch(s) && s && s.contextElement && (Y = Y.concat(P0(s.contextElement)))), Y = Y.filter((ee) => {
      var K;
      return ee !== ((K = V.defaultView) == null ? void 0 : K.visualViewport);
    }), Y.forEach((ee) => {
      ee.addEventListener("scroll", Z, {
        passive: !0
      });
    }), () => {
      m && V.removeEventListener("keydown", G), P && V.removeEventListener(w, H), Y.forEach((ee) => {
        ee.removeEventListener("scroll", Z);
      });
    };
  }, [f, d, c, s, m, P, w, i, R, a, n, r, T, g, F, $, N]), I.useEffect(() => {
    z.current = !1;
  }, [P, w]), I.useMemo(() => g ? {
    reference: {
      [tye[A]]: () => {
        _ && (i.emit("dismiss", {
          type: "referencePress",
          data: {
            returnFocus: !1
          }
        }), r(!1));
      }
    },
    floating: {
      [nye[w]]: () => {
        z.current = !0;
      }
    }
  } : {}, [g, i, _, w, A, r]);
};
function EX(t) {
  return I.useMemo(() => t.every((e) => e == null) ? null : (e) => {
    t.forEach((n) => {
      typeof n == "function" ? n(e) : n != null && (n.current = e);
    });
  }, t);
}
const aye = function(t, e) {
  let {
    open: n
  } = t, {
    enabled: r = !0,
    role: i = "dialog"
  } = e === void 0 ? {} : e;
  const a = B8(), s = B8();
  return I.useMemo(() => {
    const c = {
      id: a,
      role: i
    };
    return r ? i === "tooltip" ? {
      reference: {
        "aria-describedby": n ? a : void 0
      },
      floating: c
    } : {
      reference: {
        "aria-expanded": n ? "true" : "false",
        "aria-haspopup": i === "alertdialog" ? "dialog" : i,
        "aria-controls": n ? a : void 0,
        ...i === "listbox" && {
          role: "combobox"
        },
        ...i === "menu" && {
          id: s
        }
      },
      floating: {
        ...c,
        ...i === "menu" && {
          "aria-labelledby": s
        }
      }
    } : {};
  }, [r, i, n, a, s]);
};
function oye(t) {
  t === void 0 && (t = {});
  const {
    open: e = !1,
    onOpenChange: n,
    nodeId: r
  } = t, i = fve(t), a = H5(), s = I.useRef(null), c = I.useRef({}), d = I.useState(() => kve())[0], [f, g] = I.useState(null), m = I.useCallback((O) => {
    const R = Ch(O) ? {
      getBoundingClientRect: () => O.getBoundingClientRect(),
      contextElement: O
    } : O;
    i.refs.setReference(R);
  }, [i.refs]), b = I.useCallback((O) => {
    (Ch(O) || O === null) && (s.current = O, g(O)), (Ch(i.refs.reference.current) || i.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    O !== null && !Ch(O)) && i.refs.setReference(O);
  }, [i.refs]), w = I.useMemo(() => ({
    ...i.refs,
    setReference: b,
    setPositionReference: m,
    domReference: s
  }), [i.refs, b, m]), _ = I.useMemo(() => ({
    ...i.elements,
    domReference: f
  }), [i.elements, f]), A = NI(n), T = I.useMemo(() => ({
    ...i,
    refs: w,
    elements: _,
    dataRef: c,
    nodeId: r,
    events: d,
    open: e,
    onOpenChange: A
  }), [i, r, d, e, A, w, _]);
  return Qd(() => {
    const O = a?.nodesRef.current.find((R) => R.id === r);
    O && (O.context = T);
  }), I.useMemo(() => ({
    ...i,
    context: T,
    refs: w,
    reference: b,
    positionReference: m
  }), [i, w, T, b, m]);
}
function V6(t, e, n) {
  const r = /* @__PURE__ */ new Map();
  return {
    ...n === "floating" && {
      tabIndex: -1
    },
    ...t,
    ...e.map((i) => i ? i[n] : null).concat(t).reduce((i, a) => (a && Object.entries(a).forEach((s) => {
      let [c, d] = s;
      if (c.indexOf("on") === 0) {
        if (r.has(c) || r.set(c, []), typeof d == "function") {
          var f;
          (f = r.get(c)) == null || f.push(d), i[c] = function() {
            for (var g, m = arguments.length, b = new Array(m), w = 0; w < m; w++)
              b[w] = arguments[w];
            (g = r.get(c)) == null || g.forEach((_) => _(...b));
          };
        }
      } else
        i[c] = d;
    }), i), {})
  };
}
const sye = function(t) {
  t === void 0 && (t = []);
  const e = t, n = I.useCallback(
    (a) => V6(a, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), r = I.useCallback(
    (a) => V6(a, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), i = I.useCallback(
    (a) => V6(a, t, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t.map((a) => a?.item)
  );
  return I.useMemo(() => ({
    getReferenceProps: n,
    getFloatingProps: r,
    getItemProps: i
  }), [n, r, i]);
}, lye = ({
  initialOpen: t = !1,
  placement: e = "bottom",
  modal: n,
  open: r,
  onOpenChange: i,
  boundary: a,
  canShowOnHover: s,
  isAllowShifting: c = !0
} = {}) => {
  const [d, f] = I.useState(t), [g, m] = I.useState(), [b, w] = I.useState(), _ = r ?? d, A = i ?? f, T = oye({
    placement: e,
    open: _,
    onOpenChange: A,
    whileElementsMounted: sve,
    middleware: [lve(5), uve({
      altBoundary: !0,
      boundary: a ?? void 0
      // fallbackAxisSideDirection: 'end',
    }), c ? cve({
      padding: 5,
      mainAxis: !0,
      crossAxis: !0,
      boundary: a ?? void 0,
      altBoundary: !0
    }) : null]
  }), O = T.context, R = eye(O, {
    enabled: r == null
  }), N = iye(O), M = aye(O), P = Uve(O, {
    enabled: r == null && s
  }), z = sye([P, R, N, M]);
  return I.useMemo(() => ({
    open: _,
    setOpen: A,
    ...z,
    ...T,
    modal: n,
    labelId: g,
    descriptionId: b,
    setLabelId: m,
    setDescriptionId: w
  }), [_, A, z, T, n, g, b]);
}, cye = Re.div`
  twd-text-base
  ${({
  $isInteractive: t
}) => t ? "" : "twd-pointer-events-none"}
`, uye = I.forwardRef((t, e) => {
  const n = ve.c(3), {
    children: r,
    hasInitialFocus: i,
    isInteractive: a,
    ...s
  } = t, c = a === void 0 ? !0 : a, {
    context: d,
    ...f
  } = ZY(), g = EX([f.refs.setFloating, e]), m = Zve, b = f.open && /* @__PURE__ */ C.jsx(Jve, { context: d, modal: f.modal, order: ["reference", "content"], returnFocus: !1, initialFocus: i ? 1 : -1, children: /* @__PURE__ */ C.jsx(cye, { $isInteractive: c, ref: g, style: {
    position: f.strategy,
    top: f.y ?? 0,
    left: f.x ?? 0,
    width: "max-content",
    zIndex: 2e3,
    ...s.style
  }, "aria-labelledby": f.labelId, "aria-describedby": f.descriptionId, ...f.getFloatingProps(s), children: r }) });
  let w;
  return n[0] !== m || n[1] !== b ? (w = /* @__PURE__ */ C.jsx(m, { children: b }), n[0] = m, n[1] = b, n[2] = w) : w = n[2], w;
}), dye = I.forwardRef((t, e) => {
  const n = ve.c(9), {
    children: r
  } = t, i = ZY(), a = I.isValidElement(r), s = a ? r : null, c = s?.ref ?? null;
  let d;
  n[0] !== c || n[1] !== i.refs.setReference || n[2] !== e ? (d = [i.refs.setReference, e, c], n[0] = c, n[1] = i.refs.setReference, n[2] = e, n[3] = d) : d = n[3];
  const f = EX(d);
  if (!a || s == null)
    return null;
  let g;
  if (n[4] !== s.props || n[5] !== r || n[6] !== i || n[7] !== f) {
    const m = Object.assign({
      ref: f
    }, s.props), b = i.getReferenceProps(m);
    g = I.cloneElement(r, b), n[4] = s.props, n[5] = r, n[6] = i, n[7] = f, n[8] = g;
  } else
    g = n[8];
  return g;
}), fye = (t) => {
  const e = ve.c(16), {
    children: n,
    content: r,
    isOpen: i,
    onOpenChange: a,
    placement: s,
    canShowOnHover: c,
    isAllowShifting: d,
    hasInitialFocus: f,
    isInteractive: g
  } = t, m = g === void 0 ? !0 : g;
  let b;
  e[0] !== c || e[1] !== d || e[2] !== i || e[3] !== a || e[4] !== s ? (b = {
    open: i,
    onOpenChange: a,
    placement: s,
    canShowOnHover: c,
    isAllowShifting: d
  }, e[0] = c, e[1] = d, e[2] = i, e[3] = a, e[4] = s, e[5] = b) : b = e[5];
  const w = lye(b);
  let _;
  e[6] !== n ? (_ = /* @__PURE__ */ C.jsx(dye, { children: n }), e[6] = n, e[7] = _) : _ = e[7];
  let A;
  e[8] !== r || e[9] !== f || e[10] !== m ? (A = /* @__PURE__ */ C.jsx(uye, { hasInitialFocus: f, isInteractive: m, children: r }), e[8] = r, e[9] = f, e[10] = m, e[11] = A) : A = e[11];
  let T;
  return e[12] !== w || e[13] !== _ || e[14] !== A ? (T = /* @__PURE__ */ C.jsxs(QY.Provider, { value: w, children: [
    _,
    A
  ] }), e[12] = w, e[13] = _, e[14] = A, e[15] = T) : T = e[15], T;
}, hye = (t) => {
  const e = ve.c(8), {
    content: n,
    children: r,
    isDisabled: i,
    isAllowShifting: a,
    placement: s,
    isInteractive: c
  } = t, d = i === void 0 ? !1 : i, f = s === void 0 ? "bottom" : s, g = c === void 0 ? !0 : c, m = d ? !1 : null, b = !d;
  let w;
  return e[0] !== r || e[1] !== n || e[2] !== a || e[3] !== g || e[4] !== f || e[5] !== m || e[6] !== b ? (w = /* @__PURE__ */ C.jsx(fye, { isOpen: m, content: n, placement: f, canShowOnHover: b, isAllowShifting: a, hasInitialFocus: !1, isInteractive: g, children: r }), e[0] = r, e[1] = n, e[2] = a, e[3] = g, e[4] = f, e[5] = m, e[6] = b, e[7] = w) : w = e[7], w;
}, pye = Re.div`
  twd-max-w-[300px]
  twd-rounded
  twd-bg-[#ffeccc]
  twd-p-3
  twd-shadow-[0_2px_10px_0_rgba(0,_0,_0,_0.1),_0_4px_24px_0_rgba(0,_0,_0,_0.09)]
`, nu = (t) => {
  const e = ve.c(7), {
    children: n,
    isDisabled: r,
    message: i,
    placement: a
  } = t, s = r === void 0 ? !1 : r;
  let c;
  e[0] !== i ? (c = /* @__PURE__ */ C.jsx(pye, { children: i }), e[0] = i, e[1] = c) : c = e[1];
  let d;
  return e[2] !== n || e[3] !== s || e[4] !== a || e[5] !== c ? (d = /* @__PURE__ */ C.jsx(hye, { content: c, isDisabled: s, placement: a, isInteractive: !1, children: n }), e[2] = n, e[3] = s, e[4] = a, e[5] = c, e[6] = d) : d = e[6], d;
}, mye = Re.div`
  ${({
  $isFullWidth: t
}) => t ? "twd-w-full" : "twd-w-auto"}
`, gye = Re.label`
  twd-text-secondary
`, vye = Re.div`
  twd-flex
  ${({
  $isBig: t
}) => t ? "twd-h-[58px] twd-text-2xl twd-font-bold" : "twd-h-[34px]"}
  twd-items-center
  twd-rounded-sm
  twd-bg-secondary-light3
  twd-text-secondary-contrast
  focus-within:twd-bg-secondary-light4
  ${({
  $isWarning: t
}) => t ? "twd-ring-1 twd-ring-warning twd-bg-warning twd-bg-opacity-10" : ""}
  ${({
  $isDisabled: t
}) => t ? "twd-cursor-not-allowed" : "hover:twd-bg-secondary-light2 hover:focus-within:twd-bg-secondary-light4 active:twd-bg-secondary-light4"}
`, yye = Re.input`
  twd-h-full
  twd-flex-1
  twd-bg-transparent
  twd-px-2
  twd-indent-0
  twd-outline-none
  placeholder:twd-text-secondary
  disabled:twd-cursor-not-allowed
`, bye = Re.div`
  twd-text-error
`, kI = I.forwardRef((t, e) => {
  const n = ve.c(69);
  let r, i, a, s, c, d, f, g, m, b, w, _, A, T, O, R, N, M, P;
  n[0] !== t ? ({
    canClear: i,
    onChange: m,
    onPress: _,
    onClear: b,
    isFullWidth: d,
    rightIcon: T,
    leftIcon: f,
    className: a,
    error: s,
    type: P,
    onFocus: w,
    onBlur: g,
    size: O,
    isDisabled: R,
    hint: c,
    isAllowEmpty: N,
    autoComplete: r,
    isWarning: M,
    ...A
  } = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = s, n[5] = c, n[6] = d, n[7] = f, n[8] = g, n[9] = m, n[10] = b, n[11] = w, n[12] = _, n[13] = A, n[14] = T, n[15] = O, n[16] = R, n[17] = N, n[18] = M, n[19] = P) : (r = n[1], i = n[2], a = n[3], s = n[4], c = n[5], d = n[6], f = n[7], g = n[8], m = n[9], b = n[10], w = n[11], _ = n[12], A = n[13], T = n[14], O = n[15], R = n[16], N = n[17], M = n[18], P = n[19]);
  const z = O === void 0 ? "md" : O, F = R === void 0 ? !1 : R, $ = N === void 0 ? !0 : N, G = M === void 0 ? !1 : M, H = UY(e), Z = P === "password" ? "password" : "text";
  let V;
  n[20] !== F || n[21] !== A || n[22] !== Z ? (V = {
    "aria-label": "input",
    isDisabled: F,
    type: Z,
    ...A
  }, n[20] = F, n[21] = A, n[22] = Z, n[23] = V) : V = n[23];
  const {
    labelProps: Y,
    inputProps: ee,
    errorMessageProps: K
  } = WY(V, H);
  let U;
  n[24] !== $ || n[25] !== m || n[26] !== P ? (U = (Ne) => {
    const {
      value: Me
    } = Ne.target;
    P === "integer" ? /^0[1-9]+$/.test(Me) ? m?.(Me.slice(1)) : /^[0-9]*$/.test(Me) && !/^0.+$/.test(Me) && m?.($ ? Me : Me || "0") : P === "float" ? /^0[1-9]+$/.test(Me) ? m?.(Me.slice(1)) : (Me === "" || /^[0-9][0-9.]*$/.test(Me) && !/^0[^.]+$/.test(Me) && (Me.match(/[.]/g) ?? []).length <= 1) && m?.($ ? Me : Me || "0") : m?.(Me);
  }, n[24] = $, n[25] = m, n[26] = P, n[27] = U) : U = n[27];
  const q = U;
  let W;
  n[28] !== Y || n[29] !== A.label ? (W = A.label && /* @__PURE__ */ C.jsx(gye, { ...Y, children: A.label }), n[28] = Y, n[29] = A.label, n[30] = W) : W = n[30];
  const ie = W;
  let J;
  n[31] !== c || n[32] !== ie ? (J = c != null ? /* @__PURE__ */ C.jsx(nu, { message: c, placement: "top-start", children: ie }) : ie, n[31] = c, n[32] = ie, n[33] = J) : J = n[33];
  const B = z === "lg";
  let te;
  n[34] !== f ? (te = f && /* @__PURE__ */ C.jsx("div", { className: "twd-ml-1", children: f }), n[34] = f, n[35] = te) : te = n[35];
  let ae;
  n[36] !== q || n[37] !== H || n[38] !== r || n[39] !== ee || n[40] !== g || n[41] !== w || n[42] !== A ? (ae = /* @__PURE__ */ C.jsx(yye, { ...ee, ...A, onFocus: w, onBlur: g, onChange: q, ref: H, size: 10, autoComplete: r }), n[36] = q, n[37] = H, n[38] = r, n[39] = ee, n[40] = g, n[41] = w, n[42] = A, n[43] = ae) : ae = n[43];
  let le;
  n[44] !== i || n[45] !== m || n[46] !== b || n[47] !== A.value ? (le = i && A.value && /* @__PURE__ */ C.jsx(cl, { onClick: () => {
    b?.(), m?.("");
  }, icon: /* @__PURE__ */ C.jsx(C_, {}), className: "twd-mr-1" }), n[44] = i, n[45] = m, n[46] = b, n[47] = A.value, n[48] = le) : le = n[48];
  let de;
  n[49] !== T ? (de = T && /* @__PURE__ */ C.jsx("div", { className: "twd-mr-1", children: T }), n[49] = T, n[50] = de) : de = n[50];
  let _e;
  n[51] !== F || n[52] !== G || n[53] !== B || n[54] !== te || n[55] !== ae || n[56] !== le || n[57] !== de ? (_e = /* @__PURE__ */ C.jsxs(vye, { $isBig: B, $isDisabled: F, $isWarning: G, children: [
    te,
    ae,
    le,
    de
  ] }), n[51] = F, n[52] = G, n[53] = B, n[54] = te, n[55] = ae, n[56] = le, n[57] = de, n[58] = _e) : _e = n[58];
  let ue;
  n[59] !== s || n[60] !== K ? (ue = s && /* @__PURE__ */ C.jsx(bye, { ...K, children: s }), n[59] = s, n[60] = K, n[61] = ue) : ue = n[61];
  let Se;
  return n[62] !== a || n[63] !== d || n[64] !== _ || n[65] !== _e || n[66] !== ue || n[67] !== J ? (Se = /* @__PURE__ */ C.jsxs(mye, { onClick: _, $isFullWidth: d, className: a, children: [
    J,
    _e,
    ue
  ] }), n[62] = a, n[63] = d, n[64] = _, n[65] = _e, n[66] = ue, n[67] = J, n[68] = Se) : Se = n[68], Se;
}), wye = Re.div`
  twd-m-3
  twd-text-center
`, xye = Re.div`
  twd-mt-3
  twd-text-secondary
`, aa = (t) => {
  const e = ve.c(6), {
    message: n,
    className: r
  } = t, i = n === void 0 ? "Loading" : n;
  let a;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ C.jsx(O_, { size: "md" }), e[0] = a) : a = e[0];
  let s;
  e[1] !== i ? (s = /* @__PURE__ */ C.jsx(xye, { children: i }), e[1] = i, e[2] = s) : s = e[2];
  let c;
  return e[3] !== r || e[4] !== s ? (c = /* @__PURE__ */ C.jsxs(wye, { className: r, children: [
    a,
    s
  ] }), e[3] = r, e[4] = s, e[5] = c) : c = e[5], c;
}, Sye = Re.div`
  twd-p-1
  twd-text-secondary
`, Eye = Re.span`
  twd-flex
  twd-flex-1
  twd-justify-between
  twd-truncate
`, _ye = Re.span`
  twd-truncate
`, Aye = Re.span`
  twd-ml-1
  twd-flex-none
`, Cye = Re.li`
  twd-relative
  twd-flex
  twd-h-7
  twd-cursor-pointer
  twd-items-center
  twd-justify-between
  twd-px-3
  ${({
  $isSelected: t
}) => !t && "hover:twd-bg-white"}
  active:twd-bg-secondary-light2
  ${({
  $isHighlighted: t,
  $isSelected: e
}) => t && !e && "twd-bg-white"}
  ${({
  $isSelected: t
}) => t && "twd-text-primary-contrast twd-bg-primary twd-font-bold hover:twd-bg-primary-dark"}
  ${({
  $isHighlighted: t,
  $isSelected: e
}) => e && t && "twd-text-primary-contrast twd-bg-primary-dark twd-font-bold"}
`, Tye = Re.ul`
  twd-absolute
  twd-z-20
  twd-max-h-52
  twd-min-w-full
  twd-max-w-full
  twd-overflow-y-auto
  twd-overflow-x-hidden
  twd-rounded-sm
  twd-bg-secondary-light3
  twd-shadow-[0_4px_12px_#00000047]
`, _X = (t) => {
  const e = ve.c(16), {
    itemSelected: n,
    items: r,
    labelProp: i,
    asideLabel: a,
    getMenuProps: s,
    getItemProps: c,
    highlightedIndex: d,
    hasNoItemsMessage: f,
    isLoading: g,
    loadingMessage: m,
    className: b
  } = t, w = f === void 0 ? !0 : f;
  let _;
  e[0] !== s ? (_ = s?.() ?? {}, e[0] = s, e[1] = _) : _ = e[1];
  let A;
  e[2] !== a || e[3] !== c || e[4] !== w || e[5] !== d || e[6] !== g || e[7] !== n || e[8] !== r || e[9] !== i || e[10] !== m ? (A = g ? /* @__PURE__ */ C.jsx(aa, { message: m }) : r.length > 0 ? r.map((O, R) => /* @__PURE__ */ C.jsx(Cye, { $isHighlighted: d === R, $isSelected: n === O, ...c?.(O, R) ?? {}, children: /* @__PURE__ */ C.jsxs(Eye, { children: [
    /* @__PURE__ */ C.jsx(_ye, { children: String(O[i]) }),
    a && /* @__PURE__ */ C.jsx(Aye, { children: a(O, n === O) })
  ] }) }, R)) : w && /* @__PURE__ */ C.jsx(Sye, { children: "No items" }), e[2] = a, e[3] = c, e[4] = w, e[5] = d, e[6] = g, e[7] = n, e[8] = r, e[9] = i, e[10] = m, e[11] = A) : A = e[11];
  let T;
  return e[12] !== b || e[13] !== _ || e[14] !== A ? (T = /* @__PURE__ */ C.jsx(Tye, { ..._, className: b, children: A }), e[12] = b, e[13] = _, e[14] = A, e[15] = T) : T = e[15], T;
}, Oye = I.memo, ez = Re.div`
  twd-flex
  twd-items-center
`, Rye = ({
  value: t,
  onChange: e,
  onSearchValueChange: n,
  filterFn: r,
  isLoading: i,
  loadingMessage: a,
  items: s,
  label: c,
  placeholder: d,
  className: f,
  labelProp: g,
  asideSelectedLabel: m,
  asideItemLabel: b,
  error: w,
  onOpen: _,
  onClose: A,
  isDisabled: T,
  forwardedRef: O
}) => {
  const R = (B) => {
    if (!B)
      return "";
    const te = B[g];
    if (typeof te == "number" || typeof te == "string")
      return String(te);
    throw new Error("Label prop should be string or number");
  }, [N, M] = I.useState(""), P = I.useRef(null), z = nI();
  I.useImperativeHandle(O, () => ({
    focusInput: () => {
      P.current?.focus();
    }
  }));
  const F = s.filter((B) => r ? r(B, N, R) : R(B).toLowerCase().includes(N.toLowerCase())), $ = I.useMemo(() => {
    if (z.mode === "shadow" && z.shadowRoot) {
      const B = z.shadowRoot.ownerDocument;
      return B ? {
        addEventListener: z.shadowRoot.addEventListener.bind(z.shadowRoot),
        removeEventListener: z.shadowRoot.removeEventListener.bind(z.shadowRoot),
        document: B,
        Node: B.defaultView?.Node,
        window: B.defaultView ?? void 0
      } : void 0;
    }
  }, [z]), {
    isOpen: G,
    getMenuProps: H,
    getInputProps: Z,
    highlightedIndex: V,
    getItemProps: Y,
    selectedItem: ee,
    setHighlightedIndex: K,
    toggleMenu: U
  } = j5({
    inputValue: N,
    onInputValueChange({
      inputValue: B = ""
    }) {
      M(B), n?.(B);
    },
    onSelectedItemChange(B) {
      B.selectedItem && (e?.(B.selectedItem), M?.(R(B.selectedItem)));
    },
    onIsOpenChange(B) {
      B.isOpen ? (_?.(), M(""), K(-1)) : (A?.(), M(R(t)), P.current?.blur());
    },
    selectedItem: t,
    items: F,
    itemToString: (B) => R(B),
    environment: $
  }), {
    onChange: q,
    ...W
  } = Z(), ie = (B) => {
    B.preventDefault(), B.stopPropagation(), T || U();
  }, J = T ? null : G ? /* @__PURE__ */ C.jsx(ez, { onClick: ie, className: "twd-cursor-pointer", children: /* @__PURE__ */ C.jsx(PY, { className: "twd-text-secondary twd-ml-1" }) }) : /* @__PURE__ */ C.jsxs(ez, { onClick: ie, className: "twd-cursor-pointer", children: [
    t && m?.(t),
    /* @__PURE__ */ C.jsx(jY, { className: "twd-text-secondary twd-ml-1" })
  ] });
  return /* @__PURE__ */ C.jsxs("div", { className: `twd-relative ${f}`, children: [
    /* @__PURE__ */ C.jsx(kI, { error: w, placeholder: d, label: c, onChange: (B) => q({
      target: {
        value: B
      }
    }), ...W, ref: (B) => {
      P.current = B, W?.ref(B);
    }, isFullWidth: !0, rightIcon: J, isDisabled: T }),
    /* @__PURE__ */ C.jsx(_X, { items: F, itemSelected: ee, labelProp: g, highlightedIndex: V, isLoading: i, loadingMessage: a, getMenuProps: () => H(), getItemProps: (B, te) => Y({
      item: B,
      index: te
    }), asideLabel: b, className: G ? "" : "twd-hidden" })
  ] });
}, Dye = Oye(I.forwardRef((t, e) => /* @__PURE__ */ C.jsx(Rye, { ...t, forwardedRef: e })));
Re.div`
  twd-flex
  twd-items-center
  twd-truncate
`;
Re.span`
  twd-ml-0.5
  twd-hidden
  twd-truncate
  twd-font-bold
  @sm/state-title:twd-inline
`;
const Nye = __("twd-text-sm twd-w-full twd-rounded twd-border twd-px-4 twd-py-2", {
  variants: {
    variant: {
      warning: "twd-border-warning twd-bg-warning twd-bg-opacity-10 twd-text-warning",
      error: "twd-border-error twd-bg-error twd-bg-opacity-10 twd-text-error",
      info: "twd-border-info twd-bg-info twd-bg-opacity-10 twd-text-info",
      success: "twd-border-success twd-bg-success twd-bg-opacity-10 twd-text-success",
      neutral: "twd-border-secondary twd-bg-secondary-light4 twd-text-secondary"
    }
  },
  defaultVariants: {
    variant: "neutral"
  }
}), ZE = (t) => {
  const e = ve.c(6), {
    variant: n,
    children: r,
    className: i
  } = t;
  let a;
  e[0] !== i || e[1] !== n ? (a = Nye({
    variant: n,
    className: i
  }), e[0] = i, e[1] = n, e[2] = a) : a = e[2];
  let s;
  return e[3] !== r || e[4] !== a ? (s = /* @__PURE__ */ C.jsx("div", { className: a, children: r }), e[3] = r, e[4] = a, e[5] = s) : s = e[5], s;
}, Mye = Re.div`
  twd-absolute
  twd-z-20
  twd-h-full
  twd-w-full
  twd-bg-[rgba(255,255,255,0.9)]
`, Iye = Re(aa)`
  twd-sticky
  twd-top-1/2
`, kye = (t) => {
  const e = ve.c(5), {
    message: n,
    className: r
  } = t;
  let i;
  e[0] !== n ? (i = /* @__PURE__ */ C.jsx(Iye, { message: n }), e[0] = n, e[1] = i) : i = e[1];
  let a;
  return e[2] !== r || e[3] !== i ? (a = /* @__PURE__ */ C.jsx(Mye, { className: r, children: i }), e[2] = r, e[3] = i, e[4] = a) : a = e[4], a;
}, jye = HM, Pye = qM, Lye = M5, AX = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-fixed twd-inset-0 twd-z-50 twd-bg-black/80 twd-overflow-y-auto sm:twd-p-4 data-[state=open]:twd-animate-in data-[state=closed]:twd-animate-out data-[state=closed]:twd-fade-out-0 data-[state=open]:twd-fade-in-0", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx(N5, { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
AX.displayName = N5.displayName;
const CX = I.forwardRef((t, e) => {
  const n = ve.c(15);
  let r, i, a, s;
  n[0] !== t ? ({
    className: i,
    children: r,
    container: a,
    ...s
  } = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = s) : (r = n[1], i = n[2], a = n[3], s = n[4]);
  const c = a ?? void 0;
  let d;
  n[5] !== i ? (d = un("twd-relative twd-z-50 twd-grid twd-w-full twd-max-w-lg twd-gap-4 sm:twd-border twd-bg-background twd-shadow-lg twd-duration-200 twd-my-auto data-[state=open]:twd-animate-in data-[state=closed]:twd-animate-out data-[state=closed]:twd-fade-out-0 data-[state=open]:twd-fade-in-0 data-[state=closed]:twd-zoom-out-95 data-[state=open]:twd-zoom-in-95 sm:twd-rounded-lg", i), n[5] = i, n[6] = d) : d = n[6];
  let f;
  n[7] !== r || n[8] !== s || n[9] !== e || n[10] !== d ? (f = /* @__PURE__ */ C.jsx(AX, { className: "twd-flex twd-items-start twd-justify-center twd-min-h-full sm:twd-py-8", children: /* @__PURE__ */ C.jsx(x_, { ref: e, className: d, ...s, children: r }) }), n[7] = r, n[8] = s, n[9] = e, n[10] = d, n[11] = f) : f = n[11];
  let g;
  return n[12] !== c || n[13] !== f ? (g = /* @__PURE__ */ C.jsx(Pye, { container: c, children: f }), n[12] = c, n[13] = f, n[14] = g) : g = n[14], g;
});
CX.displayName = x_.displayName;
const TX = (t) => {
  const e = ve.c(8);
  let n, r;
  e[0] !== t ? ({
    className: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = r) : (n = e[1], r = e[2]);
  let i;
  e[3] !== n ? (i = un("twd-flex twd-flex-col twd-space-y-1.5 twd-text-center sm:twd-text-left", n), e[3] = n, e[4] = i) : i = e[4];
  let a;
  return e[5] !== r || e[6] !== i ? (a = /* @__PURE__ */ C.jsx("div", { className: i, ...r }), e[5] = r, e[6] = i, e[7] = a) : a = e[7], a;
};
TX.displayName = "DialogHeader";
const OX = (t) => {
  const e = ve.c(8);
  let n, r;
  e[0] !== t ? ({
    className: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = r) : (n = e[1], r = e[2]);
  let i;
  e[3] !== n ? (i = un("twd-flex twd-flex-col-reverse sm:twd-flex-row sm:twd-justify-end sm:twd-space-x-2", n), e[3] = n, e[4] = i) : i = e[4];
  let a;
  return e[5] !== r || e[6] !== i ? (a = /* @__PURE__ */ C.jsx("div", { className: i, ...r }), e[5] = r, e[6] = i, e[7] = a) : a = e[7], a;
};
OX.displayName = "DialogFooter";
const RX = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-text-lg twd-font-semibold twd-leading-none twd-tracking-tight", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx(S_, { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
RX.displayName = S_.displayName;
const Bye = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-text-sm twd-text-muted-foreground", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx(E_, { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
Bye.displayName = E_.displayName;
const zye = Re.div`
  twd-flex
  twd-min-h-16
  twd-flex-col
  twd-items-stretch
  twd-justify-center
  twd-gap-3
  twd-border-b
  twd-border-b-secondary-light
  twd-px-4
  twd-py-3
  sm:twd-flex-row
  sm:twd-items-center
  sm:twd-justify-between
  sm:twd-gap-0
`, Fye = Re.div`
  twd-flex
  twd-items-center
  twd-gap-3
  twd-text-left
`, Vye = Re.div`
  twd-flex
  twd-w-full
  twd-flex-wrap
  twd-items-center
  twd-justify-end
  twd-gap-3
  sm:twd-w-auto
  sm:twd-flex-nowrap
`, Uye = Re.div`
  twd-text-lg
  twd-font-bold
`, tz = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ C.jsx(Lye, { asChild: !0, children: /* @__PURE__ */ C.jsx(cl, { icon: /* @__PURE__ */ C.jsx(C_, { size: "md" }) }) }), t[0] = e) : e = t[0], e;
}, Ph = (t) => {
  const e = ve.c(33), {
    isOpen: n,
    onClose: r,
    children: i,
    title: a,
    footer: s,
    hasPadding: c,
    className: d,
    headerLeft: f,
    headerRight: g
  } = t, m = c === void 0 ? !0 : c, b = PG(), w = typeof i == "function";
  let _;
  e[0] !== i || e[1] !== w || e[2] !== r ? (_ = w ? i?.(r) : i, e[0] = i, e[1] = w, e[2] = r, e[3] = _) : _ = e[3];
  const A = _;
  let T;
  e[4] !== f || e[5] !== a ? (T = f ?? (a ? /* @__PURE__ */ C.jsx(Uye, { children: a }) : null), e[4] = f, e[5] = a, e[6] = T) : T = e[6];
  const O = T, R = !!(O || g);
  let N;
  e[7] !== r ? (N = (V) => !V && r?.(), e[7] = r, e[8] = N) : N = e[8];
  let M;
  e[9] !== d ? (M = un("twd-p-0 twd-w-fit twd-min-w-[320px] twd-max-w-2xl twd-gap-0", d), e[9] = d, e[10] = M) : M = e[10];
  const P = a || "";
  let z;
  e[11] !== P ? (z = /* @__PURE__ */ C.jsx(TX, { className: "twd-sr-only", children: /* @__PURE__ */ C.jsx(RX, { children: P }) }), e[11] = P, e[12] = z) : z = e[12];
  let F;
  e[13] !== O || e[14] !== g || e[15] !== R ? (F = R && /* @__PURE__ */ C.jsxs(zye, { children: [
    /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-w-full twd-items-center twd-justify-between", children: [
      /* @__PURE__ */ C.jsx(Fye, { className: "twd-text-lg twd-font-bold", children: O }),
      /* @__PURE__ */ C.jsx("div", { className: "twd-flex sm:twd-hidden", children: /* @__PURE__ */ C.jsx(tz, {}) })
    ] }),
    /* @__PURE__ */ C.jsxs(Vye, { children: [
      g,
      /* @__PURE__ */ C.jsx("div", { className: "twd-hidden sm:twd-flex", children: /* @__PURE__ */ C.jsx(tz, {}) })
    ] })
  ] }), e[13] = O, e[14] = g, e[15] = R, e[16] = F) : F = e[16];
  let $;
  e[17] !== A || e[18] !== m ? ($ = m ? /* @__PURE__ */ C.jsx("div", { className: "twd-p-4", children: A }) : A, e[17] = A, e[18] = m, e[19] = $) : $ = e[19];
  let G;
  e[20] !== s ? (G = s && /* @__PURE__ */ C.jsx(OX, { className: "twd-border-t twd-border-t-secondary-light twd-p-4", children: s }), e[20] = s, e[21] = G) : G = e[21];
  let H;
  e[22] !== b || e[23] !== G || e[24] !== M || e[25] !== z || e[26] !== F || e[27] !== $ ? (H = /* @__PURE__ */ C.jsxs(CX, { container: b, className: M, onOpenAutoFocus: $ye, children: [
    z,
    F,
    $,
    G
  ] }), e[22] = b, e[23] = G, e[24] = M, e[25] = z, e[26] = F, e[27] = $, e[28] = H) : H = e[28];
  let Z;
  return e[29] !== n || e[30] !== H || e[31] !== N ? (Z = /* @__PURE__ */ C.jsx(jye, { open: n, onOpenChange: N, children: H }), e[29] = n, e[30] = H, e[31] = N, e[32] = Z) : Z = e[32], Z;
};
function $ye(t) {
  return t.preventDefault();
}
const y4 = Re.div`
  ${({
  $isInModal: t = !1
}) => t && "twd-px-4"}
`, Hye = Re.div`
  twd-mt-4
  twd-h-px
  twd-bg-secondary-light
`;
var DX = "AlertDialog", [qye, RGe] = Mg(DX, [
  Lq
]), Lh = Lq(), NX = (t) => {
  const { __scopeAlertDialog: e, ...n } = t, r = Lh(e);
  return /* @__PURE__ */ C.jsx(HM, { ...r, ...n, modal: !0 });
};
NX.displayName = DX;
var Gye = "AlertDialogTrigger", MX = I.forwardRef(
  (t, e) => {
    const { __scopeAlertDialog: n, ...r } = t, i = Lh(n);
    return /* @__PURE__ */ C.jsx(Jq, { ...i, ...r, ref: e });
  }
);
MX.displayName = Gye;
var Yye = "AlertDialogPortal", IX = (t) => {
  const { __scopeAlertDialog: e, ...n } = t, r = Lh(e);
  return /* @__PURE__ */ C.jsx(qM, { ...r, ...n });
};
IX.displayName = Yye;
var Xye = "AlertDialogOverlay", kX = I.forwardRef(
  (t, e) => {
    const { __scopeAlertDialog: n, ...r } = t, i = Lh(n);
    return /* @__PURE__ */ C.jsx(N5, { ...i, ...r, ref: e });
  }
);
kX.displayName = Xye;
var Pb = "AlertDialogContent", [Wye, Qye] = qye(Pb), Zye = /* @__PURE__ */ Gle("AlertDialogContent"), jX = I.forwardRef(
  (t, e) => {
    const { __scopeAlertDialog: n, children: r, ...i } = t, a = Lh(n), s = I.useRef(null), c = ho(e, s), d = I.useRef(null);
    return /* @__PURE__ */ C.jsx(
      Ude,
      {
        contentName: Pb,
        titleName: PX,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ C.jsx(Wye, { scope: n, cancelRef: d, children: /* @__PURE__ */ C.jsxs(
          x_,
          {
            role: "alertdialog",
            ...a,
            ...i,
            ref: c,
            onOpenAutoFocus: Zc(i.onOpenAutoFocus, (f) => {
              f.preventDefault(), d.current?.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (f) => f.preventDefault(),
            onInteractOutside: (f) => f.preventDefault(),
            children: [
              /* @__PURE__ */ C.jsx(Zye, { children: r }),
              /* @__PURE__ */ C.jsx(Jye, { contentRef: s })
            ]
          }
        ) })
      }
    );
  }
);
jX.displayName = Pb;
var PX = "AlertDialogTitle", LX = I.forwardRef(
  (t, e) => {
    const { __scopeAlertDialog: n, ...r } = t, i = Lh(n);
    return /* @__PURE__ */ C.jsx(S_, { ...i, ...r, ref: e });
  }
);
LX.displayName = PX;
var BX = "AlertDialogDescription", zX = I.forwardRef((t, e) => {
  const { __scopeAlertDialog: n, ...r } = t, i = Lh(n);
  return /* @__PURE__ */ C.jsx(E_, { ...i, ...r, ref: e });
});
zX.displayName = BX;
var Kye = "AlertDialogAction", FX = I.forwardRef(
  (t, e) => {
    const { __scopeAlertDialog: n, ...r } = t, i = Lh(n);
    return /* @__PURE__ */ C.jsx(M5, { ...i, ...r, ref: e });
  }
);
FX.displayName = Kye;
var VX = "AlertDialogCancel", UX = I.forwardRef(
  (t, e) => {
    const { __scopeAlertDialog: n, ...r } = t, { cancelRef: i } = Qye(VX, n), a = Lh(n), s = ho(e, i);
    return /* @__PURE__ */ C.jsx(M5, { ...a, ...r, ref: s });
  }
);
UX.displayName = VX;
var Jye = ({ contentRef: t }) => {
  const e = `\`${Pb}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${Pb}\` by passing a \`${BX}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${Pb}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return I.useEffect(() => {
    document.getElementById(
      t.current?.getAttribute("aria-describedby")
    ) || console.warn(e);
  }, [e, t]), null;
}, ebe = NX, tbe = MX, nbe = IX, $X = kX, HX = jX, qX = FX, GX = UX, YX = LX, XX = zX;
const jI = __("twd-inline-flex twd-items-center twd-justify-center twd-gap-2 twd-whitespace-nowrap twd-rounded-md twd-text-sm twd-font-medium twd-ring-offset-background twd-transition-colors focus-visible:twd-outline-none focus-visible:twd-ring-2 focus-visible:twd-ring-ring focus-visible:twd-ring-offset-2 disabled:twd-pointer-events-none disabled:twd-opacity-50 [&_svg]:twd-pointer-events-none [&_svg]:twd-size-4 [&_svg]:twd-shrink-0", {
  variants: {
    variant: {
      default: "twd-bg-primary twd-text-primary-foreground hover:twd-bg-primary/90",
      destructive: "twd-bg-destructive twd-text-destructive-foreground hover:twd-bg-destructive/90",
      outline: "twd-border twd-border-input twd-bg-background hover:twd-bg-accent hover:twd-text-accent-foreground",
      secondary: "twd-bg-secondary twd-text-secondary-foreground hover:twd-bg-secondary/80",
      ghost: "hover:twd-bg-accent hover:twd-text-accent-foreground",
      link: "twd-text-primary twd-underline-offset-4 hover:twd-underline"
    },
    size: {
      default: "twd-h-10 twd-px-4 twd-py-2",
      sm: "twd-h-9 twd-rounded-md twd-px-3",
      lg: "twd-h-11 twd-rounded-md twd-px-8",
      icon: "twd-h-10 twd-w-10"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), rbe = I.forwardRef((t, e) => {
  const n = ve.c(15);
  let r, i, a, s, c;
  n[0] !== t ? ({
    className: r,
    variant: c,
    size: a,
    asChild: s,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = s, n[5] = c) : (r = n[1], i = n[2], a = n[3], s = n[4], c = n[5]);
  const f = (s === void 0 ? !1 : s) ? Hle : "button";
  let g;
  n[6] !== r || n[7] !== a || n[8] !== c ? (g = un(jI({
    variant: c,
    size: a,
    className: r
  })), n[6] = r, n[7] = a, n[8] = c, n[9] = g) : g = n[9];
  let m;
  return n[10] !== f || n[11] !== i || n[12] !== e || n[13] !== g ? (m = /* @__PURE__ */ C.jsx(f, { className: g, ref: e, ...i }), n[10] = f, n[11] = i, n[12] = e, n[13] = g, n[14] = m) : m = n[14], m;
});
rbe.displayName = "Button";
const ibe = ebe, abe = tbe, obe = nbe, WX = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-fixed twd-inset-0 twd-z-50 twd-bg-black/80 twd- data-[state=open]:twd-animate-in data-[state=closed]:twd-animate-out data-[state=closed]:twd-fade-out-0 data-[state=open]:twd-fade-in-0", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx($X, { className: a, ...i, ref: e }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
WX.displayName = $X.displayName;
const QX = I.forwardRef((t, e) => {
  const n = ve.c(10);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ C.jsx(WX, {}), n[3] = a) : a = n[3];
  let s;
  n[4] !== r ? (s = un("twd-fixed twd-left-[50%] twd-top-[50%] twd-z-50 twd-grid twd-w-full twd-max-w-lg twd-translate-x-[-50%] twd-translate-y-[-50%] twd-gap-4 twd-border twd-bg-background twd-p-6 twd-shadow-lg twd-duration-200 data-[state=open]:twd-animate-in data-[state=closed]:twd-animate-out data-[state=closed]:twd-fade-out-0 data-[state=open]:twd-fade-in-0 data-[state=closed]:twd-zoom-out-95 data-[state=open]:twd-zoom-in-95 data-[state=closed]:twd-slide-out-to-left-1/2 data-[state=closed]:twd-slide-out-to-top-[48%] data-[state=open]:twd-slide-in-from-left-1/2 data-[state=open]:twd-slide-in-from-top-[48%] sm:twd-rounded-lg", r), n[4] = r, n[5] = s) : s = n[5];
  let c;
  return n[6] !== i || n[7] !== e || n[8] !== s ? (c = /* @__PURE__ */ C.jsxs(obe, { children: [
    a,
    /* @__PURE__ */ C.jsx(HX, { ref: e, className: s, ...i })
  ] }), n[6] = i, n[7] = e, n[8] = s, n[9] = c) : c = n[9], c;
});
QX.displayName = HX.displayName;
const ZX = (t) => {
  const e = ve.c(8);
  let n, r;
  e[0] !== t ? ({
    className: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = r) : (n = e[1], r = e[2]);
  let i;
  e[3] !== n ? (i = un("twd-flex twd-flex-col twd-space-y-2 twd-text-center sm:twd-text-left", n), e[3] = n, e[4] = i) : i = e[4];
  let a;
  return e[5] !== r || e[6] !== i ? (a = /* @__PURE__ */ C.jsx("div", { className: i, ...r }), e[5] = r, e[6] = i, e[7] = a) : a = e[7], a;
};
ZX.displayName = "AlertDialogHeader";
const KX = (t) => {
  const e = ve.c(8);
  let n, r;
  e[0] !== t ? ({
    className: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = r) : (n = e[1], r = e[2]);
  let i;
  e[3] !== n ? (i = un("twd-flex twd-flex-col-reverse sm:twd-flex-row sm:twd-justify-end sm:twd-space-x-2", n), e[3] = n, e[4] = i) : i = e[4];
  let a;
  return e[5] !== r || e[6] !== i ? (a = /* @__PURE__ */ C.jsx("div", { className: i, ...r }), e[5] = r, e[6] = i, e[7] = a) : a = e[7], a;
};
KX.displayName = "AlertDialogFooter";
const JX = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-text-lg twd-font-semibold", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx(YX, { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
JX.displayName = YX.displayName;
const eW = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-text-sm twd-text-muted-foreground", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx(XX, { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
eW.displayName = XX.displayName;
const U8 = I.forwardRef((t, e) => {
  const n = ve.c(12);
  let r, i, a;
  n[0] !== t ? ({
    className: i,
    asChild: r,
    ...a
  } = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a) : (r = n[1], i = n[2], a = n[3]);
  let s;
  n[4] !== r || n[5] !== i ? (s = un(!r && jI(), i), n[4] = r, n[5] = i, n[6] = s) : s = n[6];
  let c;
  return n[7] !== r || n[8] !== a || n[9] !== e || n[10] !== s ? (c = /* @__PURE__ */ C.jsx(qX, { ref: e, className: s, asChild: r, ...a }), n[7] = r, n[8] = a, n[9] = e, n[10] = s, n[11] = c) : c = n[11], c;
});
U8.displayName = qX.displayName;
const tW = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un(jI({
    variant: "outline"
  }), "twd-mt-2 sm:twd-mt-0", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx(GX, { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
tW.displayName = GX.displayName;
const qu = (t) => {
  const e = ve.c(38), {
    open: n,
    onOpenChange: r,
    title: i,
    description: a,
    trigger: s,
    confirmLabel: c,
    confirmVariant: d,
    cancelLabel: f,
    onConfirm: g,
    onCancel: m,
    loading: b,
    confirmButton: w
  } = t, _ = c === void 0 ? "Confirm" : c, A = d === void 0 ? "primaryContained" : d, T = f === void 0 ? "Cancel" : f, O = b === void 0 ? !1 : b;
  let R;
  e[0] !== r ? (R = () => r?.(!1), e[0] = r, e[1] = R) : R = e[1];
  const N = R;
  let M;
  e[2] !== N || e[3] !== g ? (M = () => {
    g?.(), N();
  }, e[2] = N, e[3] = g, e[4] = M) : M = e[4];
  const P = M;
  let z;
  e[5] !== s ? (z = s && /* @__PURE__ */ C.jsx(abe, { asChild: !0, children: s }), e[5] = s, e[6] = z) : z = e[6];
  let F;
  e[7] !== i ? (F = /* @__PURE__ */ C.jsx(JX, { children: i }), e[7] = i, e[8] = F) : F = e[8];
  let $;
  e[9] !== a ? ($ = /* @__PURE__ */ C.jsx(eW, { children: a }), e[9] = a, e[10] = $) : $ = e[10];
  let G;
  e[11] !== F || e[12] !== $ ? (G = /* @__PURE__ */ C.jsxs(ZX, { children: [
    F,
    $
  ] }), e[11] = F, e[12] = $, e[13] = G) : G = e[13];
  let H;
  e[14] !== T ? (H = /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", children: T }), e[14] = T, e[15] = H) : H = e[15];
  let Z;
  e[16] !== m || e[17] !== H ? (Z = /* @__PURE__ */ C.jsx(tW, { onClick: m, asChild: !0, children: H }), e[16] = m, e[17] = H, e[18] = Z) : Z = e[18];
  let V;
  e[19] !== w || e[20] !== _ || e[21] !== A || e[22] !== N || e[23] !== P || e[24] !== O || e[25] !== g ? (V = w ? /* @__PURE__ */ C.jsx(U8, { asChild: !0, children: typeof w == "function" ? w({
    onClick: g || sbe,
    disabled: O,
    close: N
  }) : w }) : /* @__PURE__ */ C.jsx(U8, { onClick: P, disabled: O, asChild: !0, children: /* @__PURE__ */ C.jsx(Vt, { variant: A, children: _ }) }), e[19] = w, e[20] = _, e[21] = A, e[22] = N, e[23] = P, e[24] = O, e[25] = g, e[26] = V) : V = e[26];
  let Y;
  e[27] !== Z || e[28] !== V ? (Y = /* @__PURE__ */ C.jsxs(KX, { children: [
    Z,
    V
  ] }), e[27] = Z, e[28] = V, e[29] = Y) : Y = e[29];
  let ee;
  e[30] !== G || e[31] !== Y ? (ee = /* @__PURE__ */ C.jsxs(QX, { children: [
    G,
    Y
  ] }), e[30] = G, e[31] = Y, e[32] = ee) : ee = e[32];
  let K;
  return e[33] !== r || e[34] !== n || e[35] !== ee || e[36] !== z ? (K = /* @__PURE__ */ C.jsxs(ibe, { open: n, onOpenChange: r, children: [
    z,
    ee
  ] }), e[33] = r, e[34] = n, e[35] = ee, e[36] = z, e[37] = K) : K = e[37], K;
};
function sbe() {
}
const PI = (t) => {
  const e = ve.c(3), {
    id: n,
    className: r
  } = t, i = `twd-text-secondary ${r}`;
  let a;
  return e[0] !== n || e[1] !== i ? (a = /* @__PURE__ */ C.jsxs("span", { className: i, children: [
    "#",
    n
  ] }), e[0] = n, e[1] = i, e[2] = a) : a = e[2], a;
}, lbe = Re.button`
  twd-text-sm
  twd-relative
  twd-inline-flex
  twd-h-7
  twd-max-w-full
  twd-cursor-pointer
  twd-items-center
  twd-justify-center
  twd-whitespace-nowrap
  twd-rounded
  twd-border-none
  twd-outline-none
  disabled:twd-cursor-not-allowed
  disabled:twd-opacity-50
  ${({
  $isLoading: t
}) => t && "twd-cursor-wait"}
  ${({
  $isFullWidth: t
}) => t && "twd-w-full"}
  ${({
  padding: t = "md"
}) => {
  switch (t) {
    case "sm":
      return "twd-px-1";
    case "md":
      return "twd-px-2";
    case "lg":
      return "twd-px-3";
    case "xl":
      return "twd-px-4";
    default:
      throw new H8("Unknown padding size!");
  }
}}
  ${({
  variant: t
}) => {
  switch (t) {
    case "primary":
      return "twd-text-primary twd-font-bold enabled:hover:twd-bg-primary-light3 enabled:active:twd-bg-primary-light2 disabled:twd-text-primary-light disabled:hover:twd-bg-transparent disabled:active:twd-bg-transparent";
    case "primaryContained":
      return "twd-text-primary-contrast twd-bg-primary enabled:hover:twd-bg-primary-light enabled:active:twd-bg-primary-dark disabled:twd-text-secondary-light disabled:twd-bg-secondary";
    case "secondary":
      return "twd-text-secondary-contrast twd-bg-secondary-light2 disabled:twd-bg-secondary-light3 enabled:hover:twd-bg-secondary-light enabled:active:twd-bg-secondary-light2 disabled:hover:twd-bg-secondary-light3 disabled:active:twd-bg-secondary-light3";
    case "transparent":
      return "twd-bg-transparent enabled:hover:twd-bg-secondary-light enabled:active:twd-bg-secondary-light2 disabled:hover:twd-bg-transparent disabled:active:twd-bg-transparent";
    case "error":
      return "twd-text-error-contrast twd-font-bold twd-bg-error enabled:hover:twd-bg-error-light enabled:active:twd-bg-error-dark disabled:twd-text-secondary disabled:hover:twd-bg-secondary-light2 disabled:active:twd-bg-secondary-light2";
    case "accent":
      return "twd-text-info-contrast twd-bg-info enabled:hover:twd-bg-info-light enabled:active:twd-bg-info-dark disabled:twd-text-info-contrast disabled:twd-bg-info-light2 disabled:hover:twd-bg-info-light2 disabled:active:twd-bg-info-light2";
    default:
      throw new H8("Unknown variant!");
  }
}}
`, cbe = Re.span`
  twd-inline-flex
  twd-items-center
  ${(t) => t.$isVisible ? "twd-visible" : "twd-invisible"}
`, ube = Re.span`
  twd-mr-1
  twd-flex
  twd-items-center
`, dbe = Re(O_)`
  twd-absolute
  twd-left-1/2
  twd-top-1/2
  -twd-translate-x-1/2
  -twd-translate-y-1/2
`, Vt = I.forwardRef((t, e) => {
  const n = ve.c(21), {
    icon: r,
    variant: i,
    padding: a,
    className: s,
    isLoading: c,
    children: d,
    onClick: f,
    isDisabled: g,
    isSubmit: m,
    isFullWidth: b,
    title: w
  } = t, _ = i === void 0 ? "primary" : i, A = m ? "submit" : "button", T = g || c;
  let O;
  n[0] !== c ? (O = c && /* @__PURE__ */ C.jsx(dbe, {}), n[0] = c, n[1] = O) : O = n[1];
  const R = !c;
  let N;
  n[2] !== r ? (N = r && /* @__PURE__ */ C.jsx(ube, { children: r }), n[2] = r, n[3] = N) : N = n[3];
  let M;
  n[4] !== d || n[5] !== R || n[6] !== N ? (M = /* @__PURE__ */ C.jsxs(cbe, { $isVisible: R, children: [
    N,
    d
  ] }), n[4] = d, n[5] = R, n[6] = N, n[7] = M) : M = n[7];
  let P;
  return n[8] !== s || n[9] !== b || n[10] !== c || n[11] !== f || n[12] !== a || n[13] !== e || n[14] !== A || n[15] !== T || n[16] !== O || n[17] !== M || n[18] !== w || n[19] !== _ ? (P = /* @__PURE__ */ C.jsxs(lbe, { variant: _, padding: a, $isLoading: c, $isFullWidth: b, className: s, onClick: f, title: w, type: A, ref: e, disabled: T, children: [
    O,
    M
  ] }), n[8] = s, n[9] = b, n[10] = c, n[11] = f, n[12] = a, n[13] = e, n[14] = A, n[15] = T, n[16] = O, n[17] = M, n[18] = w, n[19] = _, n[20] = P) : P = n[20], P;
});
Re.button`
  twd-focus:outline-none
  twd-h-14
  twd-w-14
  twd-flex-none
  twd-cursor-pointer
  twd-rounded
  twd-border-none
  twd-bg-transparent
  twd-p-0
  twd-text-[11px]
  twd-font-bold
  enabled:hover:twd-shadow-[0_2px_8px_0_rgba(0,_0,_0,_0.17),_0_3px_20px_0_rgba(0,_0,_0,_0.15)]
  enabled:active:twd-scale-[0.97,0.97]
  enabled:active:twd-shadow-[0_1px_4px_0_rgba(0,_0,_0,_0.17),_0_1px_10px_0_rgba(0,_0,_0,_0.15)]
  disabled:twd-cursor-not-allowed
  disabled:twd-bg-secondary-light3
  disabled:twd-text-secondary-light
  ${({
  $isLoading: t
}) => t && "twd-cursor-wait"}
  ${({
  $variant: t
}) => {
  switch (t) {
    case "primary":
      return "twd-text-primary enabled:hover:twd-bg-secondary-light2 enabled:hover:twd-text-primary-light enabled:active:twd-bg-secondary-light enabled:active:twd-bg-secondary-light enabled:active:twd-text-primary-dark";
    case "primaryContained":
      return "twd-text-primary-contrast twd-bg-primary enabled:hover:twd-text-primary-contrast enabled:active:twd-text-primary-contrast enabled:hover:twd-bg-primary-light enabled:active:twd-bg-primary-dark disabled:twd-text-secondary-light disabled:twd-bg-secondary";
    case "secondary":
      return "TODO";
    case "transparent":
      return "TODO";
    case "error":
      return "TODO";
    default:
      throw new H8("Unknown variant!");
  }
}}
`;
Re.div`
  twd-flex
  twd-flex-col
  twd-items-center
`;
var D_ = (t) => t.type === "checkbox", rg = (t) => t instanceof Date, Ns = (t) => t == null;
const nW = (t) => typeof t == "object";
var oa = (t) => !Ns(t) && !Array.isArray(t) && nW(t) && !rg(t), rW = (t) => oa(t) && t.target ? D_(t.target) ? t.target.checked : t.target.value : t, fbe = (t) => t.substring(0, t.search(/\.\d+(\.|$)/)) || t, iW = (t, e) => t.has(fbe(e)), hbe = (t) => {
  const e = t.constructor && t.constructor.prototype;
  return oa(e) && e.hasOwnProperty("isPrototypeOf");
}, LI = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function ja(t) {
  let e;
  const n = Array.isArray(t), r = typeof FileList < "u" ? t instanceof FileList : !1;
  if (t instanceof Date)
    e = new Date(t);
  else if (!(LI && (t instanceof Blob || r)) && (n || oa(t)))
    if (e = n ? [] : {}, !n && !hbe(t))
      e = t;
    else
      for (const i in t)
        t.hasOwnProperty(i) && (e[i] = ja(t[i]));
  else
    return t;
  return e;
}
var q5 = (t) => /^\w*$/.test(t), ia = (t) => t === void 0, BI = (t) => Array.isArray(t) ? t.filter(Boolean) : [], zI = (t) => BI(t.replace(/["|']|\]/g, "").split(/\.|\[/)), gt = (t, e, n) => {
  if (!e || !oa(t))
    return n;
  const r = (q5(e) ? [e] : zI(e)).reduce((i, a) => Ns(i) ? i : i[a], t);
  return ia(r) || r === t ? ia(t[e]) ? n : t[e] : r;
}, Hl = (t) => typeof t == "boolean", Lr = (t, e, n) => {
  let r = -1;
  const i = q5(e) ? [e] : zI(e), a = i.length, s = a - 1;
  for (; ++r < a; ) {
    const c = i[r];
    let d = n;
    if (r !== s) {
      const f = t[c];
      d = oa(f) || Array.isArray(f) ? f : isNaN(+i[r + 1]) ? {} : [];
    }
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return;
    t[c] = d, t = t[c];
  }
};
const UT = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, zu = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, wh = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, aW = De.createContext(null);
aW.displayName = "HookFormContext";
const FI = () => De.useContext(aW);
var oW = (t, e, n, r = !0) => {
  const i = {
    defaultValues: e._defaultValues
  };
  for (const a in t)
    Object.defineProperty(i, a, {
      get: () => {
        const s = a;
        return e._proxyFormState[s] !== zu.all && (e._proxyFormState[s] = !r || zu.all), n && (n[s] = !0), t[s];
      }
    });
  return i;
};
const VI = typeof window < "u" ? I.useLayoutEffect : I.useEffect;
function UI(t) {
  const e = FI(), { control: n = e.control, disabled: r, name: i, exact: a } = t || {}, [s, c] = De.useState(n._formState), d = De.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return VI(() => n._subscribe({
    name: i,
    formState: d.current,
    exact: a,
    callback: (f) => {
      !r && c({
        ...n._formState,
        ...f
      });
    }
  }), [i, r, a]), De.useEffect(() => {
    d.current.isValid && n._setValid(!0);
  }, [n]), De.useMemo(() => oW(s, n, d.current, !1), [s, n]);
}
var qd = (t) => typeof t == "string", sW = (t, e, n, r, i) => qd(t) ? (r && e.watch.add(t), gt(n, t, i)) : Array.isArray(t) ? t.map((a) => (r && e.watch.add(a), gt(n, a))) : (r && (e.watchAll = !0), n);
function Wb(t) {
  const e = FI(), { control: n = e.control, name: r, defaultValue: i, disabled: a, exact: s } = t || {}, c = De.useRef(i), [d, f] = De.useState(n._getWatch(r, c.current));
  return VI(() => n._subscribe({
    name: r,
    formState: {
      values: !0
    },
    exact: s,
    callback: (g) => !a && f(sW(r, n._names, g.values || n._formValues, !1, c.current))
  }), [r, n, a, s]), De.useEffect(() => n._removeUnmounted()), d;
}
function G5(t) {
  const e = FI(), { name: n, disabled: r, control: i = e.control, shouldUnregister: a } = t, s = iW(i._names.array, n), c = Wb({
    control: i,
    name: n,
    defaultValue: gt(i._formValues, n, gt(i._defaultValues, n, t.defaultValue)),
    exact: !0
  }), d = UI({
    control: i,
    name: n,
    exact: !0
  }), f = De.useRef(t), g = De.useRef(i.register(n, {
    ...t.rules,
    value: c,
    ...Hl(t.disabled) ? { disabled: t.disabled } : {}
  })), m = De.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!gt(d.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!gt(d.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!gt(d.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!gt(d.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => gt(d.errors, n)
    }
  }), [d, n]), b = De.useCallback((T) => g.current.onChange({
    target: {
      value: rW(T),
      name: n
    },
    type: UT.CHANGE
  }), [n]), w = De.useCallback(() => g.current.onBlur({
    target: {
      value: gt(i._formValues, n),
      name: n
    },
    type: UT.BLUR
  }), [n, i._formValues]), _ = De.useCallback((T) => {
    const O = gt(i._fields, n);
    O && T && (O._f.ref = {
      focus: () => T.focus && T.focus(),
      select: () => T.select && T.select(),
      setCustomValidity: (R) => T.setCustomValidity(R),
      reportValidity: () => T.reportValidity()
    });
  }, [i._fields, n]), A = De.useMemo(() => ({
    name: n,
    value: c,
    ...Hl(r) || d.disabled ? { disabled: d.disabled || r } : {},
    onChange: b,
    onBlur: w,
    ref: _
  }), [n, r, d.disabled, b, w, _, c]);
  return De.useEffect(() => {
    const T = i._options.shouldUnregister || a;
    i.register(n, {
      ...f.current.rules,
      ...Hl(f.current.disabled) ? { disabled: f.current.disabled } : {}
    });
    const O = (R, N) => {
      const M = gt(i._fields, R);
      M && M._f && (M._f.mount = N);
    };
    if (O(n, !0), T) {
      const R = ja(gt(i._options.defaultValues, n));
      Lr(i._defaultValues, n, R), ia(gt(i._formValues, n)) && Lr(i._formValues, n, R);
    }
    return !s && i.register(n), () => {
      (s ? T && !i._state.action : T) ? i.unregister(n) : O(n, !1);
    };
  }, [n, i, s, a]), De.useEffect(() => {
    i._setDisabledField({
      disabled: r,
      name: n
    });
  }, [r, n, i]), De.useMemo(() => ({
    field: A,
    formState: d,
    fieldState: m
  }), [A, d, m]);
}
const $I = (t) => t.render(G5(t));
var lW = (t, e, n, r, i) => e ? {
  ...n[t],
  types: {
    ...n[t] && n[t].types ? n[t].types : {},
    [r]: i || !0
  }
} : {}, gE = (t) => Array.isArray(t) ? t : [t], nz = () => {
  let t = [];
  return {
    get observers() {
      return t;
    },
    next: (i) => {
      for (const a of t)
        a.next && a.next(i);
    },
    subscribe: (i) => (t.push(i), {
      unsubscribe: () => {
        t = t.filter((a) => a !== i);
      }
    }),
    unsubscribe: () => {
      t = [];
    }
  };
}, $8 = (t) => Ns(t) || !nW(t);
function N0(t, e, n = /* @__PURE__ */ new WeakSet()) {
  if ($8(t) || $8(e))
    return t === e;
  if (rg(t) && rg(e))
    return t.getTime() === e.getTime();
  const r = Object.keys(t), i = Object.keys(e);
  if (r.length !== i.length)
    return !1;
  if (n.has(t) || n.has(e))
    return !0;
  n.add(t), n.add(e);
  for (const a of r) {
    const s = t[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const c = e[a];
      if (rg(s) && rg(c) || oa(s) && oa(c) || Array.isArray(s) && Array.isArray(c) ? !N0(s, c, n) : s !== c)
        return !1;
    }
  }
  return !0;
}
var il = (t) => oa(t) && !Object.keys(t).length, HI = (t) => t.type === "file", Fu = (t) => typeof t == "function", $T = (t) => {
  if (!LI)
    return !1;
  const e = t ? t.ownerDocument : 0;
  return t instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, cW = (t) => t.type === "select-multiple", qI = (t) => t.type === "radio", pbe = (t) => qI(t) || D_(t), U6 = (t) => $T(t) && t.isConnected;
function mbe(t, e) {
  const n = e.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    t = ia(t) ? r++ : t[e[r++]];
  return t;
}
function gbe(t) {
  for (const e in t)
    if (t.hasOwnProperty(e) && !ia(t[e]))
      return !1;
  return !0;
}
function Aa(t, e) {
  const n = Array.isArray(e) ? e : q5(e) ? [e] : zI(e), r = n.length === 1 ? t : mbe(t, n), i = n.length - 1, a = n[i];
  return r && delete r[a], i !== 0 && (oa(r) && il(r) || Array.isArray(r) && gbe(r)) && Aa(t, n.slice(0, -1)), t;
}
var uW = (t) => {
  for (const e in t)
    if (Fu(t[e]))
      return !0;
  return !1;
};
function HT(t, e = {}) {
  const n = Array.isArray(t);
  if (oa(t) || n)
    for (const r in t)
      Array.isArray(t[r]) || oa(t[r]) && !uW(t[r]) ? (e[r] = Array.isArray(t[r]) ? [] : {}, HT(t[r], e[r])) : Ns(t[r]) || (e[r] = !0);
  return e;
}
function dW(t, e, n) {
  const r = Array.isArray(t);
  if (oa(t) || r)
    for (const i in t)
      Array.isArray(t[i]) || oa(t[i]) && !uW(t[i]) ? ia(e) || $8(n[i]) ? n[i] = Array.isArray(t[i]) ? HT(t[i], []) : { ...HT(t[i]) } : dW(t[i], Ns(e) ? {} : e[i], n[i]) : n[i] = !N0(t[i], e[i]);
  return n;
}
var NS = (t, e) => dW(t, e, HT(e));
const rz = {
  value: !1,
  isValid: !1
}, iz = { value: !0, isValid: !0 };
var fW = (t) => {
  if (Array.isArray(t)) {
    if (t.length > 1) {
      const e = t.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: e, isValid: !!e.length };
    }
    return t[0].checked && !t[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      t[0].attributes && !ia(t[0].attributes.value) ? ia(t[0].value) || t[0].value === "" ? iz : { value: t[0].value, isValid: !0 } : iz
    ) : rz;
  }
  return rz;
}, hW = (t, { valueAsNumber: e, valueAsDate: n, setValueAs: r }) => ia(t) ? t : e ? t === "" ? NaN : t && +t : n && qd(t) ? new Date(t) : r ? r(t) : t;
const az = {
  isValid: !1,
  value: null
};
var pW = (t) => Array.isArray(t) ? t.reduce((e, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : e, az) : az;
function oz(t) {
  const e = t.ref;
  return HI(e) ? e.files : qI(e) ? pW(t.refs).value : cW(e) ? [...e.selectedOptions].map(({ value: n }) => n) : D_(e) ? fW(t.refs).value : hW(ia(e.value) ? t.ref.value : e.value, t);
}
var vbe = (t, e, n, r) => {
  const i = {};
  for (const a of t) {
    const s = gt(e, a);
    s && Lr(i, a, s._f);
  }
  return {
    criteriaMode: n,
    names: [...t],
    fields: i,
    shouldUseNativeValidation: r
  };
}, qT = (t) => t instanceof RegExp, MS = (t) => ia(t) ? t : qT(t) ? t.source : oa(t) ? qT(t.value) ? t.value.source : t.value : t, sz = (t) => ({
  isOnSubmit: !t || t === zu.onSubmit,
  isOnBlur: t === zu.onBlur,
  isOnChange: t === zu.onChange,
  isOnAll: t === zu.all,
  isOnTouch: t === zu.onTouched
});
const lz = "AsyncFunction";
var ybe = (t) => !!t && !!t.validate && !!(Fu(t.validate) && t.validate.constructor.name === lz || oa(t.validate) && Object.values(t.validate).find((e) => e.constructor.name === lz)), bbe = (t) => t.mount && (t.required || t.min || t.max || t.maxLength || t.minLength || t.pattern || t.validate), cz = (t, e, n) => !n && (e.watchAll || e.watch.has(t) || [...e.watch].some((r) => t.startsWith(r) && /^\.\w+/.test(t.slice(r.length))));
const vE = (t, e, n, r) => {
  for (const i of n || Object.keys(t)) {
    const a = gt(t, i);
    if (a) {
      const { _f: s, ...c } = a;
      if (s) {
        if (s.refs && s.refs[0] && e(s.refs[0], i) && !r)
          return !0;
        if (s.ref && e(s.ref, s.name) && !r)
          return !0;
        if (vE(c, e))
          break;
      } else if (oa(c) && vE(c, e))
        break;
    }
  }
};
function uz(t, e, n) {
  const r = gt(t, n);
  if (r || q5(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const a = i.join("."), s = gt(e, a), c = gt(t, a);
    if (s && !Array.isArray(s) && n !== a)
      return { name: n };
    if (c && c.type)
      return {
        name: a,
        error: c
      };
    if (c && c.root && c.root.type)
      return {
        name: `${a}.root`,
        error: c.root
      };
    i.pop();
  }
  return {
    name: n
  };
}
var wbe = (t, e, n, r) => {
  n(t);
  const { name: i, ...a } = t;
  return il(a) || Object.keys(a).length >= Object.keys(e).length || Object.keys(a).find((s) => e[s] === (!r || zu.all));
}, xbe = (t, e, n) => !t || !e || t === e || gE(t).some((r) => r && (n ? r === e : r.startsWith(e) || e.startsWith(r))), Sbe = (t, e, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(e || t) : (n ? r.isOnBlur : i.isOnBlur) ? !t : (n ? r.isOnChange : i.isOnChange) ? t : !0, Ebe = (t, e) => !BI(gt(t, e)).length && Aa(t, e), _be = (t, e, n) => {
  const r = gE(gt(t, n));
  return Lr(r, "root", e[n]), Lr(t, n, r), t;
}, b4 = (t) => qd(t);
function dz(t, e, n = "validate") {
  if (b4(t) || Array.isArray(t) && t.every(b4) || Hl(t) && !t)
    return {
      type: n,
      message: b4(t) ? t : "",
      ref: e
    };
}
var ub = (t) => oa(t) && !qT(t) ? t : {
  value: t,
  message: ""
}, fz = async (t, e, n, r, i, a) => {
  const { ref: s, refs: c, required: d, maxLength: f, minLength: g, min: m, max: b, pattern: w, validate: _, name: A, valueAsNumber: T, mount: O } = t._f, R = gt(n, A);
  if (!O || e.has(A))
    return {};
  const N = c ? c[0] : s, M = (V) => {
    i && N.reportValidity && (N.setCustomValidity(Hl(V) ? "" : V || ""), N.reportValidity());
  }, P = {}, z = qI(s), F = D_(s), $ = z || F, G = (T || HI(s)) && ia(s.value) && ia(R) || $T(s) && s.value === "" || R === "" || Array.isArray(R) && !R.length, H = lW.bind(null, A, r, P), Z = (V, Y, ee, K = wh.maxLength, U = wh.minLength) => {
    const q = V ? Y : ee;
    P[A] = {
      type: V ? K : U,
      message: q,
      ref: s,
      ...H(V ? K : U, q)
    };
  };
  if (a ? !Array.isArray(R) || !R.length : d && (!$ && (G || Ns(R)) || Hl(R) && !R || F && !fW(c).isValid || z && !pW(c).isValid)) {
    const { value: V, message: Y } = b4(d) ? { value: !!d, message: d } : ub(d);
    if (V && (P[A] = {
      type: wh.required,
      message: Y,
      ref: N,
      ...H(wh.required, Y)
    }, !r))
      return M(Y), P;
  }
  if (!G && (!Ns(m) || !Ns(b))) {
    let V, Y;
    const ee = ub(b), K = ub(m);
    if (!Ns(R) && !isNaN(R)) {
      const U = s.valueAsNumber || R && +R;
      Ns(ee.value) || (V = U > ee.value), Ns(K.value) || (Y = U < K.value);
    } else {
      const U = s.valueAsDate || new Date(R), q = (J) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + J), W = s.type == "time", ie = s.type == "week";
      qd(ee.value) && R && (V = W ? q(R) > q(ee.value) : ie ? R > ee.value : U > new Date(ee.value)), qd(K.value) && R && (Y = W ? q(R) < q(K.value) : ie ? R < K.value : U < new Date(K.value));
    }
    if ((V || Y) && (Z(!!V, ee.message, K.message, wh.max, wh.min), !r))
      return M(P[A].message), P;
  }
  if ((f || g) && !G && (qd(R) || a && Array.isArray(R))) {
    const V = ub(f), Y = ub(g), ee = !Ns(V.value) && R.length > +V.value, K = !Ns(Y.value) && R.length < +Y.value;
    if ((ee || K) && (Z(ee, V.message, Y.message), !r))
      return M(P[A].message), P;
  }
  if (w && !G && qd(R)) {
    const { value: V, message: Y } = ub(w);
    if (qT(V) && !R.match(V) && (P[A] = {
      type: wh.pattern,
      message: Y,
      ref: s,
      ...H(wh.pattern, Y)
    }, !r))
      return M(Y), P;
  }
  if (_) {
    if (Fu(_)) {
      const V = await _(R, n), Y = dz(V, N);
      if (Y && (P[A] = {
        ...Y,
        ...H(wh.validate, Y.message)
      }, !r))
        return M(Y.message), P;
    } else if (oa(_)) {
      let V = {};
      for (const Y in _) {
        if (!il(V) && !r)
          break;
        const ee = dz(await _[Y](R, n), N, Y);
        ee && (V = {
          ...ee,
          ...H(Y, ee.message)
        }, M(ee.message), r && (P[A] = V));
      }
      if (!il(V) && (P[A] = {
        ref: N,
        ...V
      }, !r))
        return P;
    }
  }
  return M(!0), P;
};
const Abe = {
  mode: zu.onSubmit,
  reValidateMode: zu.onChange,
  shouldFocusError: !0
};
function Cbe(t = {}) {
  let e = {
    ...Abe,
    ...t
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: Fu(e.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1
  }, r = {}, i = oa(e.defaultValues) || oa(e.values) ? ja(e.defaultValues || e.values) || {} : {}, a = e.shouldUnregister ? {} : ja(i), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, c = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, f = 0;
  const g = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let m = {
    ...g
  };
  const b = {
    array: nz(),
    state: nz()
  }, w = e.criteriaMode === zu.all, _ = (se) => (ge) => {
    clearTimeout(f), f = setTimeout(se, ge);
  }, A = async (se) => {
    if (!e.disabled && (g.isValid || m.isValid || se)) {
      const ge = e.resolver ? il((await F()).errors) : await G(r, !0);
      ge !== n.isValid && b.state.next({
        isValid: ge
      });
    }
  }, T = (se, ge) => {
    !e.disabled && (g.isValidating || g.validatingFields || m.isValidating || m.validatingFields) && ((se || Array.from(c.mount)).forEach((Te) => {
      Te && (ge ? Lr(n.validatingFields, Te, ge) : Aa(n.validatingFields, Te));
    }), b.state.next({
      validatingFields: n.validatingFields,
      isValidating: !il(n.validatingFields)
    }));
  }, O = (se, ge = [], Te, He, $e = !0, Ze = !0) => {
    if (He && Te && !e.disabled) {
      if (s.action = !0, Ze && Array.isArray(gt(r, se))) {
        const ct = Te(gt(r, se), He.argA, He.argB);
        $e && Lr(r, se, ct);
      }
      if (Ze && Array.isArray(gt(n.errors, se))) {
        const ct = Te(gt(n.errors, se), He.argA, He.argB);
        $e && Lr(n.errors, se, ct), Ebe(n.errors, se);
      }
      if ((g.touchedFields || m.touchedFields) && Ze && Array.isArray(gt(n.touchedFields, se))) {
        const ct = Te(gt(n.touchedFields, se), He.argA, He.argB);
        $e && Lr(n.touchedFields, se, ct);
      }
      (g.dirtyFields || m.dirtyFields) && (n.dirtyFields = NS(i, a)), b.state.next({
        name: se,
        isDirty: Z(se, ge),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      Lr(a, se, ge);
  }, R = (se, ge) => {
    Lr(n.errors, se, ge), b.state.next({
      errors: n.errors
    });
  }, N = (se) => {
    n.errors = se, b.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, M = (se, ge, Te, He) => {
    const $e = gt(r, se);
    if ($e) {
      const Ze = gt(a, se, ia(Te) ? gt(i, se) : Te);
      ia(Ze) || He && He.defaultChecked || ge ? Lr(a, se, ge ? Ze : oz($e._f)) : ee(se, Ze), s.mount && A();
    }
  }, P = (se, ge, Te, He, $e) => {
    let Ze = !1, ct = !1;
    const Mt = {
      name: se
    };
    if (!e.disabled) {
      if (!Te || He) {
        (g.isDirty || m.isDirty) && (ct = n.isDirty, n.isDirty = Mt.isDirty = Z(), Ze = ct !== Mt.isDirty);
        const Rt = N0(gt(i, se), ge);
        ct = !!gt(n.dirtyFields, se), Rt ? Aa(n.dirtyFields, se) : Lr(n.dirtyFields, se, !0), Mt.dirtyFields = n.dirtyFields, Ze = Ze || (g.dirtyFields || m.dirtyFields) && ct !== !Rt;
      }
      if (Te) {
        const Rt = gt(n.touchedFields, se);
        Rt || (Lr(n.touchedFields, se, Te), Mt.touchedFields = n.touchedFields, Ze = Ze || (g.touchedFields || m.touchedFields) && Rt !== Te);
      }
      Ze && $e && b.state.next(Mt);
    }
    return Ze ? Mt : {};
  }, z = (se, ge, Te, He) => {
    const $e = gt(n.errors, se), Ze = (g.isValid || m.isValid) && Hl(ge) && n.isValid !== ge;
    if (e.delayError && Te ? (d = _(() => R(se, Te)), d(e.delayError)) : (clearTimeout(f), d = null, Te ? Lr(n.errors, se, Te) : Aa(n.errors, se)), (Te ? !N0($e, Te) : $e) || !il(He) || Ze) {
      const ct = {
        ...He,
        ...Ze && Hl(ge) ? { isValid: ge } : {},
        errors: n.errors,
        name: se
      };
      n = {
        ...n,
        ...ct
      }, b.state.next(ct);
    }
  }, F = async (se) => {
    T(se, !0);
    const ge = await e.resolver(a, e.context, vbe(se || c.mount, r, e.criteriaMode, e.shouldUseNativeValidation));
    return T(se), ge;
  }, $ = async (se) => {
    const { errors: ge } = await F(se);
    if (se)
      for (const Te of se) {
        const He = gt(ge, Te);
        He ? Lr(n.errors, Te, He) : Aa(n.errors, Te);
      }
    else
      n.errors = ge;
    return ge;
  }, G = async (se, ge, Te = {
    valid: !0
  }) => {
    for (const He in se) {
      const $e = se[He];
      if ($e) {
        const { _f: Ze, ...ct } = $e;
        if (Ze) {
          const Mt = c.array.has(Ze.name), Rt = $e._f && ybe($e._f);
          Rt && g.validatingFields && T([He], !0);
          const sn = await fz($e, c.disabled, a, w, e.shouldUseNativeValidation && !ge, Mt);
          if (Rt && g.validatingFields && T([He]), sn[Ze.name] && (Te.valid = !1, ge))
            break;
          !ge && (gt(sn, Ze.name) ? Mt ? _be(n.errors, sn, Ze.name) : Lr(n.errors, Ze.name, sn[Ze.name]) : Aa(n.errors, Ze.name));
        }
        !il(ct) && await G(ct, ge, Te);
      }
    }
    return Te.valid;
  }, H = () => {
    for (const se of c.unMount) {
      const ge = gt(r, se);
      ge && (ge._f.refs ? ge._f.refs.every((Te) => !U6(Te)) : !U6(ge._f.ref)) && ue(se);
    }
    c.unMount = /* @__PURE__ */ new Set();
  }, Z = (se, ge) => !e.disabled && (se && ge && Lr(a, se, ge), !N0(J(), i)), V = (se, ge, Te) => sW(se, c, {
    ...s.mount ? a : ia(ge) ? i : qd(se) ? { [se]: ge } : ge
  }, Te, ge), Y = (se) => BI(gt(s.mount ? a : i, se, e.shouldUnregister ? gt(i, se, []) : [])), ee = (se, ge, Te = {}) => {
    const He = gt(r, se);
    let $e = ge;
    if (He) {
      const Ze = He._f;
      Ze && (!Ze.disabled && Lr(a, se, hW(ge, Ze)), $e = $T(Ze.ref) && Ns(ge) ? "" : ge, cW(Ze.ref) ? [...Ze.ref.options].forEach((ct) => ct.selected = $e.includes(ct.value)) : Ze.refs ? D_(Ze.ref) ? Ze.refs.forEach((ct) => {
        (!ct.defaultChecked || !ct.disabled) && (Array.isArray($e) ? ct.checked = !!$e.find((Mt) => Mt === ct.value) : ct.checked = $e === ct.value || !!$e);
      }) : Ze.refs.forEach((ct) => ct.checked = ct.value === $e) : HI(Ze.ref) ? Ze.ref.value = "" : (Ze.ref.value = $e, Ze.ref.type || b.state.next({
        name: se,
        values: ja(a)
      })));
    }
    (Te.shouldDirty || Te.shouldTouch) && P(se, $e, Te.shouldTouch, Te.shouldDirty, !0), Te.shouldValidate && ie(se);
  }, K = (se, ge, Te) => {
    for (const He in ge) {
      if (!ge.hasOwnProperty(He))
        return;
      const $e = ge[He], Ze = se + "." + He, ct = gt(r, Ze);
      (c.array.has(se) || oa($e) || ct && !ct._f) && !rg($e) ? K(Ze, $e, Te) : ee(Ze, $e, Te);
    }
  }, U = (se, ge, Te = {}) => {
    const He = gt(r, se), $e = c.array.has(se), Ze = ja(ge);
    Lr(a, se, Ze), $e ? (b.array.next({
      name: se,
      values: ja(a)
    }), (g.isDirty || g.dirtyFields || m.isDirty || m.dirtyFields) && Te.shouldDirty && b.state.next({
      name: se,
      dirtyFields: NS(i, a),
      isDirty: Z(se, Ze)
    })) : He && !He._f && !Ns(Ze) ? K(se, Ze, Te) : ee(se, Ze, Te), cz(se, c) && b.state.next({ ...n }), b.state.next({
      name: s.mount ? se : void 0,
      values: ja(a)
    });
  }, q = async (se) => {
    s.mount = !0;
    const ge = se.target;
    let Te = ge.name, He = !0;
    const $e = gt(r, Te), Ze = (Rt) => {
      He = Number.isNaN(Rt) || rg(Rt) && isNaN(Rt.getTime()) || N0(Rt, gt(a, Te, Rt));
    }, ct = sz(e.mode), Mt = sz(e.reValidateMode);
    if ($e) {
      let Rt, sn;
      const In = ge.type ? oz($e._f) : rW(se), hn = se.type === UT.BLUR || se.type === UT.FOCUS_OUT, Wn = !bbe($e._f) && !e.resolver && !gt(n.errors, Te) && !$e._f.deps || Sbe(hn, gt(n.touchedFields, Te), n.isSubmitted, Mt, ct), ar = cz(Te, c, hn);
      Lr(a, Te, In), hn ? ($e._f.onBlur && $e._f.onBlur(se), d && d(0)) : $e._f.onChange && $e._f.onChange(se);
      const kn = P(Te, In, hn), yr = !il(kn) || ar;
      if (!hn && b.state.next({
        name: Te,
        type: se.type,
        values: ja(a)
      }), Wn)
        return (g.isValid || m.isValid) && (e.mode === "onBlur" ? hn && A() : hn || A()), yr && b.state.next({ name: Te, ...ar ? {} : kn });
      if (!hn && ar && b.state.next({ ...n }), e.resolver) {
        const { errors: or } = await F([Te]);
        if (Ze(In), He) {
          const sa = uz(n.errors, r, Te), re = uz(or, r, sa.name || Te);
          Rt = re.error, Te = re.name, sn = il(or);
        }
      } else
        T([Te], !0), Rt = (await fz($e, c.disabled, a, w, e.shouldUseNativeValidation))[Te], T([Te]), Ze(In), He && (Rt ? sn = !1 : (g.isValid || m.isValid) && (sn = await G(r, !0)));
      He && ($e._f.deps && ie($e._f.deps), z(Te, sn, Rt, kn));
    }
  }, W = (se, ge) => {
    if (gt(n.errors, ge) && se.focus)
      return se.focus(), 1;
  }, ie = async (se, ge = {}) => {
    let Te, He;
    const $e = gE(se);
    if (e.resolver) {
      const Ze = await $(ia(se) ? se : $e);
      Te = il(Ze), He = se ? !$e.some((ct) => gt(Ze, ct)) : Te;
    } else
      se ? (He = (await Promise.all($e.map(async (Ze) => {
        const ct = gt(r, Ze);
        return await G(ct && ct._f ? { [Ze]: ct } : ct);
      }))).every(Boolean), !(!He && !n.isValid) && A()) : He = Te = await G(r);
    return b.state.next({
      ...!qd(se) || (g.isValid || m.isValid) && Te !== n.isValid ? {} : { name: se },
      ...e.resolver || !se ? { isValid: Te } : {},
      errors: n.errors
    }), ge.shouldFocus && !He && vE(r, W, se ? $e : c.mount), He;
  }, J = (se) => {
    const ge = {
      ...s.mount ? a : i
    };
    return ia(se) ? ge : qd(se) ? gt(ge, se) : se.map((Te) => gt(ge, Te));
  }, B = (se, ge) => ({
    invalid: !!gt((ge || n).errors, se),
    isDirty: !!gt((ge || n).dirtyFields, se),
    error: gt((ge || n).errors, se),
    isValidating: !!gt(n.validatingFields, se),
    isTouched: !!gt((ge || n).touchedFields, se)
  }), te = (se) => {
    se && gE(se).forEach((ge) => Aa(n.errors, ge)), b.state.next({
      errors: se ? n.errors : {}
    });
  }, ae = (se, ge, Te) => {
    const He = (gt(r, se, { _f: {} })._f || {}).ref, $e = gt(n.errors, se) || {}, { ref: Ze, message: ct, type: Mt, ...Rt } = $e;
    Lr(n.errors, se, {
      ...Rt,
      ...ge,
      ref: He
    }), b.state.next({
      name: se,
      errors: n.errors,
      isValid: !1
    }), Te && Te.shouldFocus && He && He.focus && He.focus();
  }, le = (se, ge) => Fu(se) ? b.state.subscribe({
    next: (Te) => se(V(void 0, ge), Te)
  }) : V(se, ge, !0), de = (se) => b.state.subscribe({
    next: (ge) => {
      xbe(se.name, ge.name, se.exact) && wbe(ge, se.formState || g, Ot, se.reRenderRoot) && se.callback({
        values: { ...a },
        ...n,
        ...ge
      });
    }
  }).unsubscribe, _e = (se) => (s.mount = !0, m = {
    ...m,
    ...se.formState
  }, de({
    ...se,
    formState: m
  })), ue = (se, ge = {}) => {
    for (const Te of se ? gE(se) : c.mount)
      c.mount.delete(Te), c.array.delete(Te), ge.keepValue || (Aa(r, Te), Aa(a, Te)), !ge.keepError && Aa(n.errors, Te), !ge.keepDirty && Aa(n.dirtyFields, Te), !ge.keepTouched && Aa(n.touchedFields, Te), !ge.keepIsValidating && Aa(n.validatingFields, Te), !e.shouldUnregister && !ge.keepDefaultValue && Aa(i, Te);
    b.state.next({
      values: ja(a)
    }), b.state.next({
      ...n,
      ...ge.keepDirty ? { isDirty: Z() } : {}
    }), !ge.keepIsValid && A();
  }, Se = ({ disabled: se, name: ge }) => {
    (Hl(se) && s.mount || se || c.disabled.has(ge)) && (se ? c.disabled.add(ge) : c.disabled.delete(ge));
  }, Ne = (se, ge = {}) => {
    let Te = gt(r, se);
    const He = Hl(ge.disabled) || Hl(e.disabled);
    return Lr(r, se, {
      ...Te || {},
      _f: {
        ...Te && Te._f ? Te._f : { ref: { name: se } },
        name: se,
        mount: !0,
        ...ge
      }
    }), c.mount.add(se), Te ? Se({
      disabled: Hl(ge.disabled) ? ge.disabled : e.disabled,
      name: se
    }) : M(se, !0, ge.value), {
      ...He ? { disabled: ge.disabled || e.disabled } : {},
      ...e.progressive ? {
        required: !!ge.required,
        min: MS(ge.min),
        max: MS(ge.max),
        minLength: MS(ge.minLength),
        maxLength: MS(ge.maxLength),
        pattern: MS(ge.pattern)
      } : {},
      name: se,
      onChange: q,
      onBlur: q,
      ref: ($e) => {
        if ($e) {
          Ne(se, ge), Te = gt(r, se);
          const Ze = ia($e.value) && $e.querySelectorAll && $e.querySelectorAll("input,select,textarea")[0] || $e, ct = pbe(Ze), Mt = Te._f.refs || [];
          if (ct ? Mt.find((Rt) => Rt === Ze) : Ze === Te._f.ref)
            return;
          Lr(r, se, {
            _f: {
              ...Te._f,
              ...ct ? {
                refs: [
                  ...Mt.filter(U6),
                  Ze,
                  ...Array.isArray(gt(i, se)) ? [{}] : []
                ],
                ref: { type: Ze.type, name: se }
              } : { ref: Ze }
            }
          }), M(se, !1, void 0, Ze);
        } else
          Te = gt(r, se, {}), Te._f && (Te._f.mount = !1), (e.shouldUnregister || ge.shouldUnregister) && !(iW(c.array, se) && s.action) && c.unMount.add(se);
      }
    };
  }, Me = () => e.shouldFocusError && vE(r, W, c.mount), Ce = (se) => {
    Hl(se) && (b.state.next({ disabled: se }), vE(r, (ge, Te) => {
      const He = gt(r, Te);
      He && (ge.disabled = He._f.disabled || se, Array.isArray(He._f.refs) && He._f.refs.forEach(($e) => {
        $e.disabled = He._f.disabled || se;
      }));
    }, 0, !1));
  }, Ue = (se, ge) => async (Te) => {
    let He;
    Te && (Te.preventDefault && Te.preventDefault(), Te.persist && Te.persist());
    let $e = ja(a);
    if (b.state.next({
      isSubmitting: !0
    }), e.resolver) {
      const { errors: Ze, values: ct } = await F();
      n.errors = Ze, $e = ja(ct);
    } else
      await G(r);
    if (c.disabled.size)
      for (const Ze of c.disabled)
        Aa($e, Ze);
    if (Aa(n.errors, "root"), il(n.errors)) {
      b.state.next({
        errors: {}
      });
      try {
        await se($e, Te);
      } catch (Ze) {
        He = Ze;
      }
    } else
      ge && await ge({ ...n.errors }, Te), Me(), setTimeout(Me);
    if (b.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: il(n.errors) && !He,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), He)
      throw He;
  }, rt = (se, ge = {}) => {
    gt(r, se) && (ia(ge.defaultValue) ? U(se, ja(gt(i, se))) : (U(se, ge.defaultValue), Lr(i, se, ja(ge.defaultValue))), ge.keepTouched || Aa(n.touchedFields, se), ge.keepDirty || (Aa(n.dirtyFields, se), n.isDirty = ge.defaultValue ? Z(se, ja(gt(i, se))) : Z()), ge.keepError || (Aa(n.errors, se), g.isValid && A()), b.state.next({ ...n }));
  }, it = (se, ge = {}) => {
    const Te = se ? ja(se) : i, He = ja(Te), $e = il(se), Ze = $e ? i : He;
    if (ge.keepDefaultValues || (i = Te), !ge.keepValues) {
      if (ge.keepDirtyValues) {
        const ct = /* @__PURE__ */ new Set([
          ...c.mount,
          ...Object.keys(NS(i, a))
        ]);
        for (const Mt of Array.from(ct))
          gt(n.dirtyFields, Mt) ? Lr(Ze, Mt, gt(a, Mt)) : U(Mt, gt(Ze, Mt));
      } else {
        if (LI && ia(se))
          for (const ct of c.mount) {
            const Mt = gt(r, ct);
            if (Mt && Mt._f) {
              const Rt = Array.isArray(Mt._f.refs) ? Mt._f.refs[0] : Mt._f.ref;
              if ($T(Rt)) {
                const sn = Rt.closest("form");
                if (sn) {
                  sn.reset();
                  break;
                }
              }
            }
          }
        if (ge.keepFieldsRef)
          for (const ct of c.mount)
            U(ct, gt(Ze, ct));
        else
          r = {};
      }
      a = e.shouldUnregister ? ge.keepDefaultValues ? ja(i) : {} : ja(Ze), b.array.next({
        values: { ...Ze }
      }), b.state.next({
        values: { ...Ze }
      });
    }
    c = {
      mount: ge.keepDirtyValues ? c.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !g.isValid || !!ge.keepIsValid || !!ge.keepDirtyValues, s.watch = !!e.shouldUnregister, b.state.next({
      submitCount: ge.keepSubmitCount ? n.submitCount : 0,
      isDirty: $e ? !1 : ge.keepDirty ? n.isDirty : !!(ge.keepDefaultValues && !N0(se, i)),
      isSubmitted: ge.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: $e ? {} : ge.keepDirtyValues ? ge.keepDefaultValues && a ? NS(i, a) : n.dirtyFields : ge.keepDefaultValues && se ? NS(i, se) : ge.keepDirty ? n.dirtyFields : {},
      touchedFields: ge.keepTouched ? n.touchedFields : {},
      errors: ge.keepErrors ? n.errors : {},
      isSubmitSuccessful: ge.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ft = (se, ge) => it(Fu(se) ? se(a) : se, ge), wt = (se, ge = {}) => {
    const Te = gt(r, se), He = Te && Te._f;
    if (He) {
      const $e = He.refs ? He.refs[0] : He.ref;
      $e.focus && ($e.focus(), ge.shouldSelect && Fu($e.select) && $e.select());
    }
  }, Ot = (se) => {
    n = {
      ...n,
      ...se
    };
  }, Ct = {
    control: {
      register: Ne,
      unregister: ue,
      getFieldState: B,
      handleSubmit: Ue,
      setError: ae,
      _subscribe: de,
      _runSchema: F,
      _focusError: Me,
      _getWatch: V,
      _getDirty: Z,
      _setValid: A,
      _setFieldArray: O,
      _setDisabledField: Se,
      _setErrors: N,
      _getFieldArray: Y,
      _reset: it,
      _resetDefaultValues: () => Fu(e.defaultValues) && e.defaultValues().then((se) => {
        Ft(se, e.resetOptions), b.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: H,
      _disableForm: Ce,
      _subjects: b,
      _proxyFormState: g,
      get _fields() {
        return r;
      },
      get _formValues() {
        return a;
      },
      get _state() {
        return s;
      },
      set _state(se) {
        s = se;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return c;
      },
      set _names(se) {
        c = se;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return e;
      },
      set _options(se) {
        e = {
          ...e,
          ...se
        };
      }
    },
    subscribe: _e,
    trigger: ie,
    register: Ne,
    handleSubmit: Ue,
    watch: le,
    setValue: U,
    getValues: J,
    reset: Ft,
    resetField: rt,
    clearErrors: te,
    unregister: ue,
    setError: ae,
    setFocus: wt,
    getFieldState: B
  };
  return {
    ...Ct,
    formControl: Ct
  };
}
function ed(t = {}) {
  const e = De.useRef(void 0), n = De.useRef(void 0), [r, i] = De.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Fu(t.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1,
    isReady: !1,
    defaultValues: Fu(t.defaultValues) ? void 0 : t.defaultValues
  });
  if (!e.current)
    if (t.formControl)
      e.current = {
        ...t.formControl,
        formState: r
      }, t.defaultValues && !Fu(t.defaultValues) && t.formControl.reset(t.defaultValues, t.resetOptions);
    else {
      const { formControl: s, ...c } = Cbe(t);
      e.current = {
        ...c,
        formState: r
      };
    }
  const a = e.current.control;
  return a._options = t, VI(() => {
    const s = a._subscribe({
      formState: a._proxyFormState,
      callback: () => i({ ...a._formState }),
      reRenderRoot: !0
    });
    return i((c) => ({
      ...c,
      isReady: !0
    })), a._formState.isReady = !0, s;
  }, [a]), De.useEffect(() => a._disableForm(t.disabled), [a, t.disabled]), De.useEffect(() => {
    t.mode && (a._options.mode = t.mode), t.reValidateMode && (a._options.reValidateMode = t.reValidateMode);
  }, [a, t.mode, t.reValidateMode]), De.useEffect(() => {
    t.errors && (a._setErrors(t.errors), a._focusError());
  }, [a, t.errors]), De.useEffect(() => {
    t.shouldUnregister && a._subjects.state.next({
      values: a._getWatch()
    });
  }, [a, t.shouldUnregister]), De.useEffect(() => {
    if (a._proxyFormState.isDirty) {
      const s = a._getDirty();
      s !== r.isDirty && a._subjects.state.next({
        isDirty: s
      });
    }
  }, [a, r.isDirty]), De.useEffect(() => {
    t.values && !N0(t.values, n.current) ? (a._reset(t.values, {
      keepFieldsRef: !0,
      ...a._options.resetOptions
    }), n.current = t.values, i((s) => ({ ...s }))) : a._resetDefaultValues();
  }, [a, t.values]), De.useEffect(() => {
    a._state.mount || (a._setValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
  }), e.current.formState = oW(r, a), e.current;
}
function mW(t) {
  const e = I.useRef({ value: t, previous: t });
  return I.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
function gW(t) {
  const [e, n] = I.useState(void 0);
  return Mh(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const a = i[0];
        let s, c;
        if ("borderBoxSize" in a) {
          const d = a.borderBoxSize, f = Array.isArray(d) ? d[0] : d;
          s = f.inlineSize, c = f.blockSize;
        } else
          s = t.offsetWidth, c = t.offsetHeight;
        n({ width: s, height: c });
      });
      return r.observe(t, { box: "border-box" }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
var Y5 = "Checkbox", [Tbe, DGe] = Mg(Y5), [Obe, GI] = Tbe(Y5);
function Rbe(t) {
  const {
    __scopeCheckbox: e,
    checked: n,
    children: r,
    defaultChecked: i,
    disabled: a,
    form: s,
    name: c,
    onCheckedChange: d,
    required: f,
    value: g = "on",
    // @ts-expect-error
    internal_do_not_use_render: m
  } = t, [b, w] = aw({
    prop: n,
    defaultProp: i ?? !1,
    onChange: d,
    caller: Y5
  }), [_, A] = I.useState(null), [T, O] = I.useState(null), R = I.useRef(!1), N = _ ? !!s || !!_.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), M = {
    checked: b,
    disabled: a,
    setChecked: w,
    control: _,
    setControl: A,
    name: c,
    form: s,
    value: g,
    hasConsumerStoppedPropagationRef: R,
    required: f,
    defaultChecked: L0(i) ? !1 : i,
    isFormControl: N,
    bubbleInput: T,
    setBubbleInput: O
  };
  return /* @__PURE__ */ C.jsx(
    Obe,
    {
      scope: e,
      ...M,
      children: Dbe(m) ? m(M) : r
    }
  );
}
var vW = "CheckboxTrigger", yW = I.forwardRef(
  ({ __scopeCheckbox: t, onKeyDown: e, onClick: n, ...r }, i) => {
    const {
      control: a,
      value: s,
      disabled: c,
      checked: d,
      required: f,
      setControl: g,
      setChecked: m,
      hasConsumerStoppedPropagationRef: b,
      isFormControl: w,
      bubbleInput: _
    } = GI(vW, t), A = ho(i, g), T = I.useRef(d);
    return I.useEffect(() => {
      const O = a?.form;
      if (O) {
        const R = () => m(T.current);
        return O.addEventListener("reset", R), () => O.removeEventListener("reset", R);
      }
    }, [a, m]), /* @__PURE__ */ C.jsx(
      Xa.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": L0(d) ? "mixed" : d,
        "aria-required": f,
        "data-state": EW(d),
        "data-disabled": c ? "" : void 0,
        disabled: c,
        value: s,
        ...r,
        ref: A,
        onKeyDown: Zc(e, (O) => {
          O.key === "Enter" && O.preventDefault();
        }),
        onClick: Zc(n, (O) => {
          m((R) => L0(R) ? !0 : !R), _ && w && (b.current = O.isPropagationStopped(), b.current || O.stopPropagation());
        })
      }
    );
  }
);
yW.displayName = vW;
var YI = I.forwardRef(
  (t, e) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: i,
      defaultChecked: a,
      required: s,
      disabled: c,
      value: d,
      onCheckedChange: f,
      form: g,
      ...m
    } = t;
    return /* @__PURE__ */ C.jsx(
      Rbe,
      {
        __scopeCheckbox: n,
        checked: i,
        defaultChecked: a,
        disabled: c,
        required: s,
        onCheckedChange: f,
        name: r,
        form: g,
        value: d,
        internal_do_not_use_render: ({ isFormControl: b }) => /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsx(
            yW,
            {
              ...m,
              ref: e,
              __scopeCheckbox: n
            }
          ),
          b && /* @__PURE__ */ C.jsx(
            SW,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
YI.displayName = Y5;
var bW = "CheckboxIndicator", wW = I.forwardRef(
  (t, e) => {
    const { __scopeCheckbox: n, forceMount: r, ...i } = t, a = GI(bW, n);
    return /* @__PURE__ */ C.jsx(
      w_,
      {
        present: r || L0(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ C.jsx(
          Xa.span,
          {
            "data-state": EW(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...i,
            ref: e,
            style: { pointerEvents: "none", ...t.style }
          }
        )
      }
    );
  }
);
wW.displayName = bW;
var xW = "CheckboxBubbleInput", SW = I.forwardRef(
  ({ __scopeCheckbox: t, ...e }, n) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: i,
      checked: a,
      defaultChecked: s,
      required: c,
      disabled: d,
      name: f,
      value: g,
      form: m,
      bubbleInput: b,
      setBubbleInput: w
    } = GI(xW, t), _ = ho(n, w), A = mW(a), T = gW(r);
    I.useEffect(() => {
      const R = b;
      if (!R)
        return;
      const N = window.HTMLInputElement.prototype, P = Object.getOwnPropertyDescriptor(
        N,
        "checked"
      ).set, z = !i.current;
      if (A !== a && P) {
        const F = new Event("click", { bubbles: z });
        R.indeterminate = L0(a), P.call(R, L0(a) ? !1 : a), R.dispatchEvent(F);
      }
    }, [b, A, a, i]);
    const O = I.useRef(L0(a) ? !1 : a);
    return /* @__PURE__ */ C.jsx(
      Xa.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: s ?? O.current,
        required: c,
        disabled: d,
        name: f,
        value: g,
        form: m,
        ...e,
        tabIndex: -1,
        ref: _,
        style: {
          ...e.style,
          ...T,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
SW.displayName = xW;
function Dbe(t) {
  return typeof t == "function";
}
function L0(t) {
  return t === "indeterminate";
}
function EW(t) {
  return L0(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
const Nbe = I.forwardRef((t, e) => {
  const n = ve.c(10);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-grid twd-place-content-center twd-peer twd-h-4 twd-w-4 twd-shrink-0 twd-rounded-sm twd-border twd-border-secondary twd-ring-offset-background focus-visible:twd-outline-none focus-visible:twd-ring-2 focus-visible:twd-ring-ring focus-visible:twd-ring-offset-2 disabled:twd-cursor-not-allowed disabled:twd-opacity-50 data-[state=checked]:twd-bg-primary data-[state=checked]:twd-border-primary data-[state=checked]:twd-text-primary-foreground", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  n[5] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ C.jsx(wW, { className: un("twd-grid twd-place-content-center twd-text-current"), children: /* @__PURE__ */ C.jsx(Mce, { className: "twd-h-4 twd-w-4" }) }), n[5] = s) : s = n[5];
  let c;
  return n[6] !== i || n[7] !== e || n[8] !== a ? (c = /* @__PURE__ */ C.jsx(YI, { ref: e, className: a, ...i, children: s }), n[6] = i, n[7] = e, n[8] = a, n[9] = c) : c = n[9], c;
});
Nbe.displayName = YI.displayName;
var Mbe = "Label", _W = I.forwardRef((t, e) => /* @__PURE__ */ C.jsx(
  Xa.label,
  {
    ...t,
    ref: e,
    onMouseDown: (n) => {
      n.target.closest("button, input, select, textarea") || (t.onMouseDown?.(n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
_W.displayName = Mbe;
var AW = _W;
const Ibe = __("twd-text-sm twd-font-medium twd-leading-none peer-disabled:twd-cursor-not-allowed peer-disabled:twd-opacity-70 twd-text-secondary"), CW = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un(Ibe(), r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx(AW, { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
CW.displayName = AW.displayName;
const kbe = ({
  value: t,
  onChange: e,
  items: n,
  label: r,
  placeholder: i,
  className: a,
  labelProp: s,
  isLoading: c,
  loadingMessage: d,
  hasNoItemsMessage: f,
  type: g,
  error: m,
  hint: b,
  isFullWidth: w = !0,
  isDisabled: _ = !1,
  isWarning: A = !1
}) => {
  const T = nI(), O = (V) => {
    const Y = V[s];
    if (typeof Y == "number" || typeof Y == "string")
      return String(Y);
    throw new Error("Label prop should be string or number");
  }, R = n.filter((V) => {
    const Y = O(V).toLowerCase(), ee = String(t).toLowerCase();
    return String(Y).includes(ee) && ee !== Y;
  }), N = I.useMemo(() => {
    if (T.mode === "shadow" && T.shadowRoot) {
      const V = T.shadowRoot.ownerDocument;
      return V ? {
        addEventListener: T.shadowRoot.addEventListener.bind(T.shadowRoot),
        removeEventListener: T.shadowRoot.removeEventListener.bind(T.shadowRoot),
        document: V,
        Node: V.defaultView?.Node,
        window: V.defaultView ?? void 0
      } : void 0;
    }
  }, [T]), {
    isOpen: M,
    getMenuProps: P,
    getInputProps: z,
    highlightedIndex: F,
    getItemProps: $,
    selectedItem: G
  } = j5({
    inputValue: String(t),
    onInputValueChange({
      inputValue: V = ""
    }) {
      e?.(V);
    },
    items: R,
    itemToString: (V) => String(V ? O(V) : ""),
    environment: N,
    stateReducer: (V, Y) => _ ? {
      ...Y.changes,
      isOpen: !1
    } : Y.changes
  }), {
    onChange: H,
    ...Z
  } = z();
  return /* @__PURE__ */ C.jsxs("div", { className: `twd-relative ${a}`, children: [
    /* @__PURE__ */ C.jsx(kI, { placeholder: i, label: r, isFullWidth: w, type: g, onChange: (V) => H({
      target: {
        value: V
      }
    }), error: m, hint: b, isDisabled: _, isWarning: A, ...Z }),
    /* @__PURE__ */ C.jsx(_X, { items: R, itemSelected: G, labelProp: s, hasNoItemsMessage: f, highlightedIndex: F, isLoading: c, loadingMessage: d, getMenuProps: () => P(), getItemProps: (V, Y) => $({
      item: V,
      index: Y
    }), className: M && !_ ? "" : "twd-hidden" })
  ] });
}, jbe = (t) => {
  const e = ve.c(15), {
    label: n,
    className: r,
    hints: i,
    placeholder: a,
    value: s,
    onChange: c,
    error: d,
    type: f,
    hint: g,
    isFullWidth: m,
    isDisabled: b,
    isWarning: w
  } = t;
  let _;
  e[0] !== i ? (_ = i.map(Pbe), e[0] = i, e[1] = _) : _ = e[1];
  const A = _;
  let T;
  return e[2] !== r || e[3] !== d || e[4] !== g || e[5] !== b || e[6] !== m || e[7] !== w || e[8] !== A || e[9] !== n || e[10] !== c || e[11] !== a || e[12] !== f || e[13] !== s ? (T = /* @__PURE__ */ C.jsx(kbe, { value: s, onChange: c, placeholder: a, items: A, error: d, labelProp: "value", hasNoItemsMessage: !1, label: n, type: f, hint: g, isFullWidth: m, className: r, isDisabled: b, isWarning: w }), e[2] = r, e[3] = d, e[4] = g, e[5] = b, e[6] = m, e[7] = w, e[8] = A, e[9] = n, e[10] = c, e[11] = a, e[12] = f, e[13] = s, e[14] = T) : T = e[14], T;
};
function Pbe(t) {
  return {
    value: t
  };
}
const Lbe = Re.div`
  twd-h-8.5
  ${({
  $isFullWidth: t
}) => t ? "twd-w-full" : "twd-w-max"}
`, Bbe = Re.label`
  twd-text-secondary
`, zbe = Re.select`
  twd-flex
  twd-h-[34px]
  twd-w-full
  twd-max-w-full
  twd-flex-1
  ${({
  $isDisabled: t
}) => t ? "twd-cursor-not-allowed" : "twd-cursor-pointer"}
  twd-appearance-none
  twd-items-center
  twd-truncate
  twd-rounded-sm
  twd-bg-secondary-light3
  twd-px-2
  ${({
  $isNotSelected: t
}) => t ? "twd-text-secondary" : "text-secondary-contrast"}
  twd-outline-none
  placeholder:twd-text-secondary
  ${({
  $isDisabled: t
}) => t ? "" : "hover:twd-bg-secondary-light2 active:twd-bg-secondary-light4"}
`, Fbe = Re.div`
  text-error
`, TW = I.forwardRef((t, e) => {
  const n = ve.c(24), {
    isFullWidth: r,
    value: i,
    onChange: a,
    onBlur: s,
    name: c,
    label: d,
    children: f,
    isNotSelected: g,
    className: m,
    error: b,
    hint: w,
    isDisabled: _
  } = t, A = g === void 0 ? !1 : g, T = _ === void 0 ? !1 : _;
  let O;
  n[0] !== d ? (O = d && /* @__PURE__ */ C.jsx(Bbe, { children: d }), n[0] = d, n[1] = O) : O = n[1];
  const R = O;
  let N;
  n[2] !== R || n[3] !== w ? (N = w != null ? /* @__PURE__ */ C.jsx(nu, { message: w, placement: "top-start", children: R }) : R, n[2] = R, n[3] = w, n[4] = N) : N = n[4];
  let M;
  n[5] !== a ? (M = ($) => a?.($.target.value, $), n[5] = a, n[6] = M) : M = n[6];
  let P;
  n[7] !== T || n[8] !== A || n[9] !== c || n[10] !== s || n[11] !== f || n[12] !== e || n[13] !== M || n[14] !== i ? (P = /* @__PURE__ */ C.jsx(zbe, { name: c, $isNotSelected: A, $isDisabled: T, value: i, onChange: M, onBlur: s, ref: e, disabled: T, children: f }), n[7] = T, n[8] = A, n[9] = c, n[10] = s, n[11] = f, n[12] = e, n[13] = M, n[14] = i, n[15] = P) : P = n[15];
  let z;
  n[16] !== b ? (z = b && /* @__PURE__ */ C.jsx(Fbe, { children: b }), n[16] = b, n[17] = z) : z = n[17];
  let F;
  return n[18] !== m || n[19] !== r || n[20] !== N || n[21] !== P || n[22] !== z ? (F = /* @__PURE__ */ C.jsxs(Lbe, { $isFullWidth: r, className: m, children: [
    N,
    P,
    z
  ] }), n[18] = m, n[19] = r, n[20] = N, n[21] = P, n[22] = z, n[23] = F) : F = n[23], F;
}), Zr = (t) => {
  const e = ve.c(26), {
    name: n,
    label: r,
    isFullWidth: i,
    className: a,
    isWarning: s,
    type: c,
    size: d,
    control: f,
    placeholder: g,
    hint: m,
    rightIcon: b,
    onFocus: w,
    autoComplete: _,
    onValueChange: A,
    "data-test-id": T
  } = t;
  let O;
  e[0] !== f || e[1] !== n ? (O = {
    control: f,
    name: n
  }, e[0] = f, e[1] = n, e[2] = O) : O = e[2];
  const {
    fieldState: R,
    field: N
  } = G5(O), {
    onChange: M,
    onBlur: P,
    ref: z,
    value: F,
    disabled: $
  } = N;
  let G;
  e[3] !== M || e[4] !== A ? (G = (Y) => {
    const ee = A?.(Y);
    M(ee ?? Y);
  }, e[3] = M, e[4] = A, e[5] = G) : G = e[5];
  const H = G, Z = R.error?.message;
  let V;
  return e[6] !== _ || e[7] !== a || e[8] !== T || e[9] !== $ || e[10] !== H || e[11] !== m || e[12] !== i || e[13] !== s || e[14] !== r || e[15] !== n || e[16] !== P || e[17] !== w || e[18] !== g || e[19] !== z || e[20] !== b || e[21] !== d || e[22] !== Z || e[23] !== c || e[24] !== F ? (V = /* @__PURE__ */ C.jsx(kI, { className: a, label: r, isFullWidth: i, type: c, error: Z, size: d, value: F, onBlur: P, onFocus: w, placeholder: g, onChange: H, ref: z, hint: m, rightIcon: b, name: n, autoComplete: _, isDisabled: $, isWarning: s, "data-test-id": T }), e[6] = _, e[7] = a, e[8] = T, e[9] = $, e[10] = H, e[11] = m, e[12] = i, e[13] = s, e[14] = r, e[15] = n, e[16] = P, e[17] = w, e[18] = g, e[19] = z, e[20] = b, e[21] = d, e[22] = Z, e[23] = c, e[24] = F, e[25] = V) : V = e[25], V;
}, Uc = (t) => {
  const e = ve.c(19), {
    name: n,
    label: r,
    className: i,
    control: a,
    hints: s,
    placeholder: c,
    type: d,
    hint: f,
    isFullWidth: g,
    isWarning: m,
    onValueChange: b
  } = t;
  let w;
  e[0] !== a || e[1] !== n ? (w = {
    name: n,
    control: a
  }, e[0] = a, e[1] = n, e[2] = w) : w = e[2];
  const {
    field: _,
    fieldState: A
  } = G5(w), {
    value: T,
    onChange: O,
    disabled: R
  } = _;
  let N;
  e[3] !== O || e[4] !== b ? (N = (F) => {
    O(F), b?.(F);
  }, e[3] = O, e[4] = b, e[5] = N) : N = e[5];
  const M = N, P = A.error?.message;
  let z;
  return e[6] !== i || e[7] !== R || e[8] !== M || e[9] !== f || e[10] !== s || e[11] !== g || e[12] !== m || e[13] !== r || e[14] !== c || e[15] !== P || e[16] !== d || e[17] !== T ? (z = /* @__PURE__ */ C.jsx(jbe, { value: T, onChange: M, placeholder: c, hints: s, error: P, label: r, type: d, hint: f, isFullWidth: g, className: i, isDisabled: R, isWarning: m }), e[6] = i, e[7] = R, e[8] = M, e[9] = f, e[10] = s, e[11] = g, e[12] = m, e[13] = r, e[14] = c, e[15] = P, e[16] = d, e[17] = T, e[18] = z) : z = e[18], z;
}, Qb = ({
  name: t,
  label: e,
  children: n,
  isFullWidth: r,
  className: i,
  control: a,
  hint: s,
  disabled: c,
  onChange: d
}) => {
  const {
    field: f,
    fieldState: g
  } = G5({
    name: t,
    control: a
  });
  return /* @__PURE__ */ C.jsx(TW, { className: i, label: e, isFullWidth: r, value: f.value, error: g.error?.message, onChange: (m) => {
    f.onChange(m), d?.(m);
  }, ref: f.ref, hint: s, isDisabled: c ?? f.disabled, children: n });
}, Vbe = Re.div`
  ${({
  $isFullWidth: t
}) => t ? "twd-w-full" : "twd-w-auto"}
`, Ube = Re.label`
  twd-text-secondary
`, $be = Re.textarea`
  twd-block
  twd-h-[34px]
  twd-h-full
  twd-min-h-[34px]
  twd-w-full
  twd-flex-1
  twd-resize-none
  twd-rounded-sm
  twd-bg-secondary-light3
  twd-p-2
  twd-text-secondary-contrast
  twd-outline-none
  placeholder:twd-text-secondary
  focus-within:twd-bg-secondary-light4
  active:twd-bg-secondary-light4
  ${({
  $isDisabled: t
}) => t ? "twd-cursor-not-allowed" : "hover:twd-bg-secondary-light2 hover:focus-within:twd-bg-secondary-light4 active:twd-bg-secondary-light4"}
`, Hbe = Re.div`
  twd-text-error
`, qbe = I.forwardRef((t, e) => {
  const n = ve.c(32);
  let r, i, a, s, c, d, f;
  n[0] !== t ? ({
    onChange: s,
    onPress: c,
    isFullWidth: a,
    className: r,
    error: i,
    isDisabled: f,
    ...d
  } = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = s, n[5] = c, n[6] = d, n[7] = f) : (r = n[1], i = n[2], a = n[3], s = n[4], c = n[5], d = n[6], f = n[7]);
  const g = f === void 0 ? !1 : f, m = UY(e);
  let b;
  n[8] !== g || n[9] !== d ? (b = {
    "aria-label": "input",
    isDisabled: g,
    ...d,
    inputElementType: "textarea"
  }, n[8] = g, n[9] = d, n[10] = b) : b = n[10];
  const {
    labelProps: w,
    inputProps: _,
    errorMessageProps: A
  } = WY(b, m);
  let T;
  n[11] !== s ? (T = (z) => {
    const {
      value: F
    } = z.target;
    s?.(F);
  }, n[11] = s, n[12] = T) : T = n[12];
  const O = T;
  let R;
  n[13] !== w || n[14] !== d.label ? (R = d.label && /* @__PURE__ */ C.jsx(Ube, { ...w, children: d.label }), n[13] = w, n[14] = d.label, n[15] = R) : R = n[15];
  let N;
  n[16] !== O || n[17] !== m || n[18] !== _ || n[19] !== g || n[20] !== d ? (N = /* @__PURE__ */ C.jsx($be, { ..._, ...d, onChange: O, ref: m, $isDisabled: g }), n[16] = O, n[17] = m, n[18] = _, n[19] = g, n[20] = d, n[21] = N) : N = n[21];
  let M;
  n[22] !== i || n[23] !== A ? (M = i && /* @__PURE__ */ C.jsx(Hbe, { ...A, children: i }), n[22] = i, n[23] = A, n[24] = M) : M = n[24];
  let P;
  return n[25] !== r || n[26] !== a || n[27] !== c || n[28] !== R || n[29] !== N || n[30] !== M ? (P = /* @__PURE__ */ C.jsxs(Vbe, { onClick: c, $isFullWidth: a, className: r, children: [
    R,
    N,
    M
  ] }), n[25] = r, n[26] = a, n[27] = c, n[28] = R, n[29] = N, n[30] = M, n[31] = P) : P = n[31], P;
}), Gbe = (t) => {
  const e = ve.c(10), {
    name: n,
    label: r,
    isFullWidth: i,
    className: a,
    placeholder: s,
    control: c
  } = t;
  let d;
  e[0] !== a || e[1] !== i || e[2] !== r || e[3] !== n || e[4] !== s ? (d = (g) => {
    const {
      field: m,
      fieldState: b
    } = g, {
      onChange: w,
      value: _,
      onBlur: A,
      ref: T
    } = m;
    return /* @__PURE__ */ C.jsx(qbe, { value: _, className: a, label: r, isFullWidth: i, error: b.error?.message, placeholder: s, onBlur: A, onChange: (O) => w({
      target: {
        value: O,
        name: n
      }
    }), ref: T });
  }, e[0] = a, e[1] = i, e[2] = r, e[3] = n, e[4] = s, e[5] = d) : d = e[5];
  let f;
  return e[6] !== c || e[7] !== n || e[8] !== d ? (f = /* @__PURE__ */ C.jsx($I, { render: d, name: n, control: c }), e[6] = c, e[7] = n, e[8] = d, e[9] = f) : f = e[9], f;
};
var X5 = "Switch", [Ybe, NGe] = Mg(X5), [Xbe, Wbe] = Ybe(X5), OW = I.forwardRef(
  (t, e) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: i,
      defaultChecked: a,
      required: s,
      disabled: c,
      value: d = "on",
      onCheckedChange: f,
      form: g,
      ...m
    } = t, [b, w] = I.useState(null), _ = ho(e, (N) => w(N)), A = I.useRef(!1), T = b ? g || !!b.closest("form") : !0, [O, R] = aw({
      prop: i,
      defaultProp: a ?? !1,
      onChange: f,
      caller: X5
    });
    return /* @__PURE__ */ C.jsxs(Xbe, { scope: n, checked: O, disabled: c, children: [
      /* @__PURE__ */ C.jsx(
        Xa.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": O,
          "aria-required": s,
          "data-state": MW(O),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: d,
          ...m,
          ref: _,
          onClick: Zc(t.onClick, (N) => {
            R((M) => !M), T && (A.current = N.isPropagationStopped(), A.current || N.stopPropagation());
          })
        }
      ),
      T && /* @__PURE__ */ C.jsx(
        NW,
        {
          control: b,
          bubbles: !A.current,
          name: r,
          value: d,
          checked: O,
          required: s,
          disabled: c,
          form: g,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
OW.displayName = X5;
var RW = "SwitchThumb", DW = I.forwardRef(
  (t, e) => {
    const { __scopeSwitch: n, ...r } = t, i = Wbe(RW, n);
    return /* @__PURE__ */ C.jsx(
      Xa.span,
      {
        "data-state": MW(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
DW.displayName = RW;
var Qbe = "SwitchBubbleInput", NW = I.forwardRef(
  ({
    __scopeSwitch: t,
    control: e,
    checked: n,
    bubbles: r = !0,
    ...i
  }, a) => {
    const s = I.useRef(null), c = ho(s, a), d = mW(n), f = gW(e);
    return I.useEffect(() => {
      const g = s.current;
      if (!g)
        return;
      const m = window.HTMLInputElement.prototype, w = Object.getOwnPropertyDescriptor(
        m,
        "checked"
      ).set;
      if (d !== n && w) {
        const _ = new Event("click", { bubbles: r });
        w.call(g, n), g.dispatchEvent(_);
      }
    }, [d, n, r]), /* @__PURE__ */ C.jsx(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...i,
        tabIndex: -1,
        ref: c,
        style: {
          ...i.style,
          ...f,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
NW.displayName = Qbe;
function MW(t) {
  return t ? "checked" : "unchecked";
}
var IW = OW, Zbe = DW;
const kW = I.forwardRef((t, e) => {
  const n = ve.c(10);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-peer twd-inline-flex twd-h-5 twd-w-10 twd-shrink-0 twd-cursor-pointer twd-items-center twd-rounded-full twd-border-2 twd-border-transparent twd-transition-colors focus-visible:twd-outline-none focus-visible:twd-ring-2 focus-visible:twd-ring-ring focus-visible:twd-ring-offset-2 focus-visible:twd-ring-offset-background disabled:twd-cursor-not-allowed disabled:twd-opacity-50 data-[state=checked]:twd-bg-primary data-[state=unchecked]:twd-bg-input", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  n[5] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ C.jsx(Zbe, { className: un("twd-pointer-events-none twd-block twd-h-4 twd-w-5 twd-rounded-full twd-bg-background twd-shadow-lg twd-ring-0 twd-transition-transform data-[state=checked]:twd-translate-x-4 data-[state=unchecked]:twd-translate-x-0") }), n[5] = s) : s = n[5];
  let c;
  return n[6] !== i || n[7] !== e || n[8] !== a ? (c = /* @__PURE__ */ C.jsx(IW, { className: a, ...i, ref: e, children: s }), n[6] = i, n[7] = e, n[8] = a, n[9] = c) : c = n[9], c;
});
kW.displayName = IW.displayName;
const Kbe = (t) => {
  const e = ve.c(19), {
    isChecked: n,
    isDisabled: r,
    onChange: i,
    name: a,
    children: s,
    className: c,
    hint: d,
    hintPlacement: f
  } = t, g = f === void 0 ? "top-start" : f, m = I.useId(), b = s != null, w = d != null;
  let _;
  e[0] !== s || e[1] !== b || e[2] !== m ? (_ = b ? /* @__PURE__ */ C.jsx(CW, { htmlFor: m, className: "twd-ml-2", children: s }) : null, e[0] = s, e[1] = b, e[2] = m, e[3] = _) : _ = e[3];
  const A = _;
  let T;
  e[4] !== n || e[5] !== r || e[6] !== a || e[7] !== i || e[8] !== m ? (T = /* @__PURE__ */ C.jsx(kW, { id: m, name: a, checked: n, onCheckedChange: i, disabled: r }), e[4] = n, e[5] = r, e[6] = a, e[7] = i, e[8] = m, e[9] = T) : T = e[9];
  const O = T, R = b ? A : O;
  let N;
  e[10] !== w || e[11] !== d || e[12] !== g || e[13] !== R ? (N = w ? /* @__PURE__ */ C.jsx(nu, { message: d, placement: g, children: R }) : R, e[10] = w, e[11] = d, e[12] = g, e[13] = R, e[14] = N) : N = e[14];
  const M = N, P = b ? O : M, z = b ? M : null, F = b ? `twd-flex twd-items-center ${c || ""}` : `twd-inline-flex twd-items-center twd-justify-center ${c || ""}`;
  let $;
  return e[15] !== z || e[16] !== P || e[17] !== F ? ($ = /* @__PURE__ */ C.jsxs("div", { className: F, children: [
    P,
    z
  ] }), e[15] = z, e[16] = P, e[17] = F, e[18] = $) : $ = e[18], $;
}, Pg = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-w-full twd-caption-bottom twd-text-sm", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx("div", { className: "twd-relative twd-w-full twd-overflow-auto", children: /* @__PURE__ */ C.jsx("table", { ref: e, className: a, ...i }) }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
Pg.displayName = "Table";
const Lg = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un(r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx("thead", { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
Lg.displayName = "TableHeader";
const Bg = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un(r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx("tbody", { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
Bg.displayName = "TableBody";
const jW = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-bg-muted/50 twd-font-medium", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx("tfoot", { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
jW.displayName = "TableFooter";
const rf = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-transition-colors hover:twd-bg-muted/50 data-[state=selected]:twd-bg-muted", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx("tr", { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
rf.displayName = "TableRow";
const wi = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-h-12 twd-px-2 twd-text-left twd-whitespace-nowrap twd-align-middle twd-font-medium twd-text-muted-foreground [&:has([role=checkbox])]:twd-pr-0", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx("th", { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
wi.displayName = "TableHead";
const Ir = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-p-2 twd-align-middle [&:has([role=checkbox])]:twd-pr-0", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx("td", { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
Ir.displayName = "TableCell";
const PW = I.forwardRef((t, e) => {
  const n = ve.c(9);
  let r, i;
  n[0] !== t ? ({
    className: r,
    ...i
  } = t, n[0] = t, n[1] = r, n[2] = i) : (r = n[1], i = n[2]);
  let a;
  n[3] !== r ? (a = un("twd-mt-4 twd-text-sm twd-text-muted-foreground", r), n[3] = r, n[4] = a) : a = n[4];
  let s;
  return n[5] !== i || n[6] !== e || n[7] !== a ? (s = /* @__PURE__ */ C.jsx("caption", { ref: e, className: a, ...i }), n[5] = i, n[6] = e, n[7] = a, n[8] = s) : s = n[8], s;
});
PW.displayName = "TableCaption";
const LW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Table: Pg,
  TableBody: Bg,
  TableCaption: PW,
  TableCell: Ir,
  TableFooter: jW,
  TableHead: wi,
  TableHeader: Lg,
  TableRow: rf
}, Symbol.toStringTag, { value: "Module" }));
class H8 extends Error {
  constructor(e = "Component's props are invalid!", n) {
    const r = n && Object.entries(n).reduce((a, [s, c]) => a + `${s} - ${c}
`, `Details:
`), i = `${e}
${r}`;
    super(i), this.details = n, this.name = "InvalidPropsError";
  }
}
const Jbe = () => {
  const t = ve.c(6), e = nI();
  let n;
  t[0] !== e.mode || t[1] !== e.portalShadowRoot || t[2] !== e.shadowRoot ? (n = () => {
    const i = twe, a = [];
    return e.mode === "shadow" && (e.shadowRoot && a.push(e.shadowRoot), e.portalShadowRoot && a.push(e.portalShadowRoot)), a.length === 0 && a.push(window), a.forEach((s) => {
      s.addEventListener("wheel", i, {
        passive: !0
      });
    }), () => {
      a.forEach((s) => {
        s.removeEventListener("wheel", i);
      });
    };
  }, t[0] = e.mode, t[1] = e.portalShadowRoot, t[2] = e.shadowRoot, t[3] = n) : n = t[3];
  let r;
  t[4] !== e ? (r = [e], t[4] = e, t[5] = r) : r = t[5], I.useEffect(n, r);
};
function ewe(t) {
  return t instanceof ShadowRoot || t instanceof Document;
}
function twe(t) {
  const n = t.composedPath().find(ewe), r = n?.activeElement instanceof HTMLElement ? n.activeElement : null;
  !r || !((r.tagName || "").toUpperCase() === "INPUT") || r.getAttribute("type") !== "number" || r.blur();
}
const hz = (t, e, n) => {
  if (t && "reportValidity" in t) {
    const r = gt(n, e);
    t.setCustomValidity(r && r.message || ""), t.reportValidity();
  }
}, BW = (t, e) => {
  for (const n in e.fields) {
    const r = e.fields[n];
    r && r.ref && "reportValidity" in r.ref ? hz(r.ref, n, t) : r.refs && r.refs.forEach((i) => hz(i, n, t));
  }
}, nwe = (t, e) => {
  e.shouldUseNativeValidation && BW(t, e);
  const n = {};
  for (const r in t) {
    const i = gt(e.fields, r), a = Object.assign(t[r] || {}, { ref: i && i.ref });
    if (rwe(e.names || Object.keys(t), r)) {
      const s = Object.assign({}, gt(n, r));
      Lr(s, "root", a), Lr(n, r, s);
    } else
      Lr(n, r, a);
  }
  return n;
}, rwe = (t, e) => t.some((n) => n.startsWith(e + "."));
var iwe = function(t, e) {
  for (var n = {}; t.length; ) {
    var r = t[0], i = r.code, a = r.message, s = r.path.join(".");
    if (!n[s])
      if ("unionErrors" in r) {
        var c = r.unionErrors[0].errors[0];
        n[s] = { message: c.message, type: c.code };
      } else
        n[s] = { message: a, type: i };
    if ("unionErrors" in r && r.unionErrors.forEach(function(g) {
      return g.errors.forEach(function(m) {
        return t.push(m);
      });
    }), e) {
      var d = n[s].types, f = d && d[r.code];
      n[s] = lW(s, e, n, i, f ? [].concat(f, r.message) : r.message);
    }
    t.shift();
  }
  return n;
}, td = function(t, e, n) {
  return n === void 0 && (n = {}), function(r, i, a) {
    try {
      return Promise.resolve(function(s, c) {
        try {
          var d = Promise.resolve(t[n.mode === "sync" ? "parse" : "parseAsync"](r, e)).then(function(f) {
            return a.shouldUseNativeValidation && BW({}, a), { errors: {}, values: n.raw ? r : f };
          });
        } catch (f) {
          return c(f);
        }
        return d && d.then ? d.then(void 0, c) : d;
      }(0, function(s) {
        if (function(c) {
          return Array.isArray(c?.errors);
        }(s))
          return { values: {}, errors: nwe(iwe(s.errors, !a.shouldUseNativeValidation && a.criteriaMode === "all"), a) };
        throw s;
      }));
    } catch (s) {
      return Promise.reject(s);
    }
  };
};
const awe = ({
  currentPassword: t,
  newPassword: e
}) => Ya.post("accounts/:change-password/", {
  current_password: t,
  new_password: e
}), owe = "EditUserPassword", swe = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationKey: [owe],
    mutationFn: lwe
  }, t[0] = e) : e = t[0], Ei(e);
};
async function lwe(t) {
  const {
    currentPassword: e,
    newPassword: n
  } = t;
  return awe({
    currentPassword: e,
    newPassword: n
  });
}
const cwe = Xe({
  currentPassword: bi.notEmptyString.min(8),
  newPassword: bi.notEmptyString,
  currentPasswordRepeat: bi.notEmptyString.min(8)
}).refine((t) => t.currentPassword === t.currentPasswordRepeat, {
  message: "Passwords don't match",
  path: ["currentPassword"]
}), $6 = {
  default: (t, e) => R0(t, e),
  success: (t, e) => R0.success(t, e),
  info: (t, e) => R0.info(t, e),
  warning: (t, e) => R0.warning(t, e),
  error: (t, e) => R0.error(t, e)
}, uwe = {
  default: "",
  success: "twd-border-success twd-border-l-success",
  info: "twd-border-info twd-border-l-info",
  warning: "twd-border-warning twd-border-l-warning",
  error: "twd-border-error twd-border-l-error"
}, dwe = {
  default: "",
  success: "twd-text-success",
  info: "twd-text-info",
  warning: "twd-text-warning",
  error: "twd-text-error"
}, fwe = 60 * 60 * 1e3, hwe = (t) => t ? fwe : void 0, nd = () => ({
  showDefaultNotification: (a) => $6.default(a),
  showSuccessNotification: (a) => $6.success(a),
  showErrorNotification: (a) => $6.error(a),
  showNotificationWithActions: (a, s, c) => {
    const d = c?.variant ?? "default", f = hwe(c?.isPersist);
    return R0.custom((g) => /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-flex-col twd-gap-2 twd-text-sm", "data-variant": d, children: [
      /* @__PURE__ */ C.jsx("span", { className: Xc("twd-font-medium", dwe[d]), children: a }),
      /* @__PURE__ */ C.jsx("div", { className: "twd-flex twd-flex-wrap twd-items-center twd-gap-2", children: typeof s == "function" ? s(g) : s })
    ] }), {
      duration: f,
      className: Xc("twd-rounded-lg twd-border twd-border-border twd-border-l-4 twd-bg-popover twd-text-popover-foreground twd-shadow-lg", uwe[d])
    });
  },
  closeSnackbar: (a) => {
    a == null ? R0.dismiss() : R0.dismiss(a);
  }
}), es = () => {
  const t = ve.c(2), {
    showErrorNotification: e
  } = nd();
  let n;
  return t[0] !== e ? (n = (r, i) => {
    if (r instanceof BH)
      i != null ? i(r, e) : e(r.data.message);
    else
      throw r;
  }, t[0] = e, t[1] = n) : n = t[1], n;
}, pwe = Re.div``, mwe = Re.form`
  twd-max-w-xs
  twd-space-y-2
`, gwe = Re.div`
  twd-text-lg
  twd-font-bold
`, vwe = Re.div`
  twd-space-y-1
`, ywe = Re.div`
  twd-space-x-2
`, bwe = (t) => {
  const e = ve.c(23), {
    onClose: n
  } = t, {
    mutateAsync: r
  } = swe(), i = es(), {
    showDefaultNotification: a
  } = nd();
  let s;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (s = {
    defaultValues: {
      currentPassword: "",
      newPassword: "",
      currentPasswordRepeat: ""
    },
    resolver: td(cwe)
  }, e[0] = s) : s = e[0];
  const {
    handleSubmit: c,
    control: d,
    formState: f
  } = ed(s);
  let g;
  e[1] !== r || e[2] !== i || e[3] !== n || e[4] !== a ? (g = async (R) => {
    try {
      await r({
        currentPassword: R.currentPassword.trim(),
        newPassword: R.newPassword.trim()
      }), a("Password changed!"), n();
    } catch (N) {
      i(N);
    }
  }, e[1] = r, e[2] = i, e[3] = n, e[4] = a, e[5] = g) : g = e[5];
  let m;
  e[6] !== c || e[7] !== g ? (m = c(g), e[6] = c, e[7] = g, e[8] = m) : m = e[8];
  let b;
  e[9] === Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ C.jsx(gwe, { children: "Change password" }), e[9] = b) : b = e[9];
  let w;
  e[10] !== d ? (w = /* @__PURE__ */ C.jsxs(vwe, { children: [
    /* @__PURE__ */ C.jsx(Zr, { name: "currentPassword", label: "Current password", control: d, type: "password" }),
    /* @__PURE__ */ C.jsx(Zr, { name: "currentPasswordRepeat", label: "Repeat current password", control: d, type: "password" }),
    /* @__PURE__ */ C.jsx(Zr, { name: "newPassword", label: "New password", control: d, type: "password" })
  ] }), e[10] = d, e[11] = w) : w = e[11];
  let _;
  e[12] !== n ? (_ = /* @__PURE__ */ C.jsx(Vt, { onClick: n, children: "Cancel" }), e[12] = n, e[13] = _) : _ = e[13];
  let A;
  e[14] !== f.isSubmitting ? (A = /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", isSubmit: !0, isLoading: f.isSubmitting, children: "Save" }), e[14] = f.isSubmitting, e[15] = A) : A = e[15];
  let T;
  e[16] !== _ || e[17] !== A ? (T = /* @__PURE__ */ C.jsxs(ywe, { children: [
    _,
    A
  ] }), e[16] = _, e[17] = A, e[18] = T) : T = e[18];
  let O;
  return e[19] !== m || e[20] !== w || e[21] !== T ? (O = /* @__PURE__ */ C.jsx(pwe, { children: /* @__PURE__ */ C.jsxs(mwe, { onSubmit: m, children: [
    b,
    w,
    T
  ] }) }), e[19] = m, e[20] = w, e[21] = T, e[22] = O) : O = e[22], O;
}, wwe = Re.div``, xwe = () => {
  const t = ve.c(3), [e, n] = I.useState(!1), r = DM();
  let i;
  return t[0] !== e || t[1] !== r ? (i = /* @__PURE__ */ C.jsx(wwe, { children: e ? /* @__PURE__ */ C.jsx(bwe, { onClose: () => n(!1) }) : r.hasPassword ? /* @__PURE__ */ C.jsx(Vt, { onClick: () => n(!0), children: "Change password" }) : /* @__PURE__ */ C.jsx("div", { children: "You signed in with a third party service, and don't have a password." }) }), t[0] = e, t[1] = r, t[2] = i) : i = t[2], i;
}, Swe = Re.div`
  twd-space-y-2
`, Ewe = Re.span`
  twd-cursor-pointer
  twd-border-b-1
  twd-border-b-transparent
  twd-text-primary
  hover:twd-border-b-primary-light
  hover:twd-text-primary-light
  active:twd-border-b-primary-dark
  active:twd-text-primary-dark
`, _we = (t) => {
  const e = ve.c(4), {
    onShowVersionHistory: n
  } = t;
  let r;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (r = RM()?.split("-")?.[0] ?? "Unknown", e[0] = r) : r = e[0];
  const i = r;
  let a;
  e[1] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ C.jsxs("div", { children: [
    /* @__PURE__ */ C.jsx("span", { className: "twd-text-secondary", children: "Current version: " }),
    " ",
    i
  ] }), e[1] = a) : a = e[1];
  let s;
  return e[2] !== n ? (s = /* @__PURE__ */ C.jsxs(Swe, { children: [
    a,
    /* @__PURE__ */ C.jsx("div", { children: /* @__PURE__ */ C.jsx(Ewe, { onClick: n, children: "Show version history" }) })
  ] }), e[2] = n, e[3] = s) : s = e[3], s;
}, Awe = Re.div`
  twd-space-y-3
`, Cwe = (t) => {
  const e = ve.c(5), {
    onShowVersionHistory: n
  } = t;
  let r, i, a;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ C.jsx(Vle, {}), i = /* @__PURE__ */ C.jsx(xwe, {}), a = /* @__PURE__ */ C.jsx("hr", { className: "twd-my-2" }), e[0] = r, e[1] = i, e[2] = a) : (r = e[0], i = e[1], a = e[2]);
  let s;
  return e[3] !== n ? (s = /* @__PURE__ */ C.jsxs(Awe, { children: [
    r,
    i,
    a,
    /* @__PURE__ */ C.jsx(_we, { onShowVersionHistory: n })
  ] }), e[3] = n, e[4] = s) : s = e[4], s;
}, MGe = (t) => {
  const e = ve.c(2), {
    onShowVersionHistory: n
  } = t;
  let r;
  return e[0] !== n ? (r = /* @__PURE__ */ C.jsx(Cwe, { onShowVersionHistory: n }), e[0] = n, e[1] = r) : r = e[1], r;
};
function pz(t) {
  return t === 9 || t === 32;
}
function Twe(t, e) {
  const n = t.replace(/"""/g, '\\"""'), r = n.split(/\r\n|[\n\r]/g), i = r.length === 1, a = r.length > 1 && r.slice(1).every((w) => w.length === 0 || pz(w.charCodeAt(0))), s = n.endsWith('\\"""'), c = t.endsWith('"') && !s, d = t.endsWith("\\"), f = c || d, g = !(e != null && e.minimize) && // add leading and trailing new lines only if it improves readability
  (!i || t.length > 70 || f || a || s);
  let m = "";
  const b = i && pz(t.charCodeAt(0));
  return (g && !b || a) && (m += `
`), m += n, (g || f) && (m += `
`), '"""' + m + '"""';
}
function Owe(t) {
  return `"${t.replace(Rwe, Dwe)}"`;
}
const Rwe = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function Dwe(t) {
  return Nwe[t.charCodeAt(0)];
}
const Nwe = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
];
function Mwe(t, e) {
  if (!!!t)
    throw new Error(e);
}
const Iwe = 10, zW = 2;
function kwe(t) {
  return W5(t, []);
}
function W5(t, e) {
  switch (typeof t) {
    case "string":
      return JSON.stringify(t);
    case "function":
      return t.name ? `[function ${t.name}]` : "[function]";
    case "object":
      return jwe(t, e);
    default:
      return String(t);
  }
}
function jwe(t, e) {
  if (t === null)
    return "null";
  if (e.includes(t))
    return "[Circular]";
  const n = [...e, t];
  if (Pwe(t)) {
    const r = t.toJSON();
    if (r !== t)
      return typeof r == "string" ? r : W5(r, n);
  } else if (Array.isArray(t))
    return Bwe(t, n);
  return Lwe(t, n);
}
function Pwe(t) {
  return typeof t.toJSON == "function";
}
function Lwe(t, e) {
  const n = Object.entries(t);
  return n.length === 0 ? "{}" : e.length > zW ? "[" + zwe(t) + "]" : "{ " + n.map(
    ([i, a]) => i + ": " + W5(a, e)
  ).join(", ") + " }";
}
function Bwe(t, e) {
  if (t.length === 0)
    return "[]";
  if (e.length > zW)
    return "[Array]";
  const n = Math.min(Iwe, t.length), r = t.length - n, i = [];
  for (let a = 0; a < n; ++a)
    i.push(W5(t[a], e));
  return r === 1 ? i.push("... 1 more item") : r > 1 && i.push(`... ${r} more items`), "[" + i.join(", ") + "]";
}
function zwe(t) {
  const e = Object.prototype.toString.call(t).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof t.constructor == "function") {
    const n = t.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return e;
}
const FW = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Fwe = new Set(Object.keys(FW));
function mz(t) {
  const e = t?.kind;
  return typeof e == "string" && Fwe.has(e);
}
var gz;
(function(t) {
  t.QUERY = "query", t.MUTATION = "mutation", t.SUBSCRIPTION = "subscription";
})(gz || (gz = {}));
var q8;
(function(t) {
  t.NAME = "Name", t.DOCUMENT = "Document", t.OPERATION_DEFINITION = "OperationDefinition", t.VARIABLE_DEFINITION = "VariableDefinition", t.SELECTION_SET = "SelectionSet", t.FIELD = "Field", t.ARGUMENT = "Argument", t.FRAGMENT_SPREAD = "FragmentSpread", t.INLINE_FRAGMENT = "InlineFragment", t.FRAGMENT_DEFINITION = "FragmentDefinition", t.VARIABLE = "Variable", t.INT = "IntValue", t.FLOAT = "FloatValue", t.STRING = "StringValue", t.BOOLEAN = "BooleanValue", t.NULL = "NullValue", t.ENUM = "EnumValue", t.LIST = "ListValue", t.OBJECT = "ObjectValue", t.OBJECT_FIELD = "ObjectField", t.DIRECTIVE = "Directive", t.NAMED_TYPE = "NamedType", t.LIST_TYPE = "ListType", t.NON_NULL_TYPE = "NonNullType", t.SCHEMA_DEFINITION = "SchemaDefinition", t.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", t.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", t.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", t.FIELD_DEFINITION = "FieldDefinition", t.INPUT_VALUE_DEFINITION = "InputValueDefinition", t.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", t.UNION_TYPE_DEFINITION = "UnionTypeDefinition", t.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", t.ENUM_VALUE_DEFINITION = "EnumValueDefinition", t.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", t.DIRECTIVE_DEFINITION = "DirectiveDefinition", t.SCHEMA_EXTENSION = "SchemaExtension", t.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", t.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", t.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", t.UNION_TYPE_EXTENSION = "UnionTypeExtension", t.ENUM_TYPE_EXTENSION = "EnumTypeExtension", t.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(q8 || (q8 = {}));
const Vwe = Object.freeze({});
function Uwe(t, e, n = FW) {
  const r = /* @__PURE__ */ new Map();
  for (const O of Object.values(q8))
    r.set(O, $we(e, O));
  let i, a = Array.isArray(t), s = [t], c = -1, d = [], f = t, g, m;
  const b = [], w = [];
  do {
    c++;
    const O = c === s.length, R = O && d.length !== 0;
    if (O) {
      if (g = w.length === 0 ? void 0 : b[b.length - 1], f = m, m = w.pop(), R)
        if (a) {
          f = f.slice();
          let M = 0;
          for (const [P, z] of d) {
            const F = P - M;
            z === null ? (f.splice(F, 1), M++) : f[F] = z;
          }
        } else {
          f = { ...f };
          for (const [M, P] of d)
            f[M] = P;
        }
      c = i.index, s = i.keys, d = i.edits, a = i.inArray, i = i.prev;
    } else if (m) {
      if (g = a ? c : s[c], f = m[g], f == null)
        continue;
      b.push(g);
    }
    let N;
    if (!Array.isArray(f)) {
      var _, A;
      mz(f) || Mwe(!1, `Invalid AST Node: ${kwe(f)}.`);
      const M = O ? (_ = r.get(f.kind)) === null || _ === void 0 ? void 0 : _.leave : (A = r.get(f.kind)) === null || A === void 0 ? void 0 : A.enter;
      if (N = M?.call(e, f, g, m, b, w), N === Vwe)
        break;
      if (N === !1) {
        if (!O) {
          b.pop();
          continue;
        }
      } else if (N !== void 0 && (d.push([g, N]), !O))
        if (mz(N))
          f = N;
        else {
          b.pop();
          continue;
        }
    }
    if (N === void 0 && R && d.push([g, f]), O)
      b.pop();
    else {
      var T;
      i = {
        inArray: a,
        index: c,
        keys: s,
        edits: d,
        prev: i
      }, a = Array.isArray(f), s = a ? f : (T = n[f.kind]) !== null && T !== void 0 ? T : [], c = -1, d = [], m && w.push(m), m = f;
    }
  } while (i !== void 0);
  return d.length !== 0 ? d[d.length - 1][1] : t;
}
function $we(t, e) {
  const n = t[e];
  return typeof n == "object" ? n : typeof n == "function" ? {
    enter: n,
    leave: void 0
  } : {
    enter: t.enter,
    leave: t.leave
  };
}
function VW(t) {
  return Uwe(t, qwe);
}
const Hwe = 80, qwe = {
  Name: {
    leave: (t) => t.value
  },
  Variable: {
    leave: (t) => "$" + t.name
  },
  // Document
  Document: {
    leave: (t) => Nt(t.definitions, `

`)
  },
  OperationDefinition: {
    leave(t) {
      const e = Xn("(", Nt(t.variableDefinitions, ", "), ")"), n = Nt(
        [
          t.operation,
          Nt([t.name, e]),
          Nt(t.directives, " ")
        ],
        " "
      );
      return (n === "query" ? "" : n + " ") + t.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: t, type: e, defaultValue: n, directives: r }) => t + ": " + e + Xn(" = ", n) + Xn(" ", Nt(r, " "))
  },
  SelectionSet: {
    leave: ({ selections: t }) => Iu(t)
  },
  Field: {
    leave({ alias: t, name: e, arguments: n, directives: r, selectionSet: i }) {
      const a = Xn("", t, ": ") + e;
      let s = a + Xn("(", Nt(n, ", "), ")");
      return s.length > Hwe && (s = a + Xn(`(
`, w4(Nt(n, `
`)), `
)`)), Nt([s, Nt(r, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: t, value: e }) => t + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: t, directives: e }) => "..." + t + Xn(" ", Nt(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: t, directives: e, selectionSet: n }) => Nt(
      [
        "...",
        Xn("on ", t),
        Nt(e, " "),
        n
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: t, typeCondition: e, variableDefinitions: n, directives: r, selectionSet: i }) => (
      // or removed in the future.
      `fragment ${t}${Xn("(", Nt(n, ", "), ")")} on ${e} ${Xn("", Nt(r, " "), " ")}` + i
    )
  },
  // Value
  IntValue: {
    leave: ({ value: t }) => t
  },
  FloatValue: {
    leave: ({ value: t }) => t
  },
  StringValue: {
    leave: ({ value: t, block: e }) => e ? Twe(t) : Owe(t)
  },
  BooleanValue: {
    leave: ({ value: t }) => t ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: t }) => t
  },
  ListValue: {
    leave: ({ values: t }) => "[" + Nt(t, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: t }) => "{" + Nt(t, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: t, value: e }) => t + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: t, arguments: e }) => "@" + t + Xn("(", Nt(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: t }) => t
  },
  ListType: {
    leave: ({ type: t }) => "[" + t + "]"
  },
  NonNullType: {
    leave: ({ type: t }) => t + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: t, directives: e, operationTypes: n }) => Xn("", t, `
`) + Nt(["schema", Nt(e, " "), Iu(n)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: t, type: e }) => t + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: t, name: e, directives: n }) => Xn("", t, `
`) + Nt(["scalar", e, Nt(n, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: t, name: e, interfaces: n, directives: r, fields: i }) => Xn("", t, `
`) + Nt(
      [
        "type",
        e,
        Xn("implements ", Nt(n, " & ")),
        Nt(r, " "),
        Iu(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: t, name: e, arguments: n, type: r, directives: i }) => Xn("", t, `
`) + e + (vz(n) ? Xn(`(
`, w4(Nt(n, `
`)), `
)`) : Xn("(", Nt(n, ", "), ")")) + ": " + r + Xn(" ", Nt(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: t, name: e, type: n, defaultValue: r, directives: i }) => Xn("", t, `
`) + Nt(
      [e + ": " + n, Xn("= ", r), Nt(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: t, name: e, interfaces: n, directives: r, fields: i }) => Xn("", t, `
`) + Nt(
      [
        "interface",
        e,
        Xn("implements ", Nt(n, " & ")),
        Nt(r, " "),
        Iu(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: t, name: e, directives: n, types: r }) => Xn("", t, `
`) + Nt(
      ["union", e, Nt(n, " "), Xn("= ", Nt(r, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: t, name: e, directives: n, values: r }) => Xn("", t, `
`) + Nt(["enum", e, Nt(n, " "), Iu(r)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: t, name: e, directives: n }) => Xn("", t, `
`) + Nt([e, Nt(n, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: t, name: e, directives: n, fields: r }) => Xn("", t, `
`) + Nt(["input", e, Nt(n, " "), Iu(r)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: t, name: e, arguments: n, repeatable: r, locations: i }) => Xn("", t, `
`) + "directive @" + e + (vz(n) ? Xn(`(
`, w4(Nt(n, `
`)), `
)`) : Xn("(", Nt(n, ", "), ")")) + (r ? " repeatable" : "") + " on " + Nt(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: t, operationTypes: e }) => Nt(
      ["extend schema", Nt(t, " "), Iu(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: t, directives: e }) => Nt(["extend scalar", t, Nt(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: t, interfaces: e, directives: n, fields: r }) => Nt(
      [
        "extend type",
        t,
        Xn("implements ", Nt(e, " & ")),
        Nt(n, " "),
        Iu(r)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: t, interfaces: e, directives: n, fields: r }) => Nt(
      [
        "extend interface",
        t,
        Xn("implements ", Nt(e, " & ")),
        Nt(n, " "),
        Iu(r)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: t, directives: e, types: n }) => Nt(
      [
        "extend union",
        t,
        Nt(e, " "),
        Xn("= ", Nt(n, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: t, directives: e, values: n }) => Nt(["extend enum", t, Nt(e, " "), Iu(n)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: t, directives: e, fields: n }) => Nt(["extend input", t, Nt(e, " "), Iu(n)], " ")
  }
};
function Nt(t, e = "") {
  var n;
  return (n = t?.filter((r) => r).join(e)) !== null && n !== void 0 ? n : "";
}
function Iu(t) {
  return Xn(`{
`, w4(Nt(t, `
`)), `
}`);
}
function Xn(t, e, n = "") {
  return e != null && e !== "" ? t + e + n : "";
}
function w4(t) {
  return Xn("  ", t.replace(/\n/g, `
  `));
}
function vz(t) {
  var e;
  return (e = t?.some((n) => n.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
const Gwe = Xe({
  errors: Xr(Xe({
    message: Je(),
    extensions: Xe({
      code: Je().optional(),
      path: Je().optional()
    }).optional()
  })).optional()
}), yz = {
  updateCalibrationLevel: {
    "constraint-violation": "hasura.updateCalibrationLevel.constraint-violation"
  },
  default: {
    "constraint-violation": "hasura.default.constraint-violation"
  }
}, Ywe = ks("hasura.generic"), Xwe = ({
  operationId: t,
  code: e
}) => {
  if (e == null)
    return null;
  const n = t ? yz[t]?.[e] : null;
  if (n != null)
    return ks(n);
  const r = yz.default?.[e];
  return r != null ? ks(r) : null;
}, Wwe = ["updateCalibrationLevel"], Qwe = (t) => typeof t == "string" && Wwe.includes(t), Zwe = (t, e, n) => {
  n.status === 401 && (window.location.href = "/auth/login/");
}, Kwe = async (t, e, n) => {
  const r = await n.clone().json().catch(() => ({})), i = qt(Gwe, r);
  if (i.errors != null) {
    const [a] = i.errors, s = n2e(t), c = Xwe({
      operationId: s,
      code: a?.extensions?.code
    }), d = {
      // TODO add a specific code for graphql
      code: n.status,
      message: c ?? Ywe,
      payload: i
    };
    throw new Ng(d, n, t, e);
  }
}, Jwe = async (t) => {
  if (!t.headers.has("is-guest-request")) {
    const e = await co.getOrRefreshAccessToken();
    e && t.headers.append("Authorization", `Bearer ${e}`);
  }
}, e2e = TM.create({
  prefixUrl: "/hasura/v1/graphql",
  hooks: {
    beforeRequest: [Jwe],
    afterResponse: [Zwe, Kwe]
  },
  retry: 0
}), t2e = {
  async fetch(t, e, n) {
    const i = await (await e2e.post("", {
      json: {
        query: VW(t),
        variables: e
      },
      headers: n?.operationId ? {
        "x-hplc-operation-id": n.operationId
      } : void 0
    })).json();
    if (typeof i == "object" && i != null && "data" in i)
      return i.data;
    throw new Error("No data was received!");
  }
}, n2e = (t) => {
  const e = t.headers.get("x-hplc-operation-id");
  return Qwe(e) ? e : void 0;
}, r2e = (t) => {
  switch (t) {
    case 401:
      return "Not authorized";
    case 400:
      return "Bad request";
    case 403:
      return "Forbidden";
    case 404:
      return "Not found";
    case 408:
      return "Timeout";
    case 500:
      return "Server error";
    default:
      return `Error code ${t}`;
  }
}, i2e = async (t) => {
  const {
    response: e,
    options: n,
    request: r
  } = t, i = await e.json().catch(() => ({})), a = qt(zH, i), {
    message: s,
    detail: c,
    error: d,
    msg: f
  } = a, g = {
    // TODO check the cast
    code: e.status,
    message: c ?? d ?? f ?? (Array.isArray(s) ? s.join(", ") : s) ?? r2e(e.status),
    payload: a
  };
  return new Ng(g, e, r, n);
}, a2e = {
  ky: TM.create({
    prefixUrl: "https://n8n.hplc.cloud/webhook/",
    hooks: {
      beforeError: [i2e]
    },
    retry: 0
  }),
  get(t, e) {
    return this.ky.get(t, {
      headers: e?.headers,
      searchParams: e?.queryParams
    }).json();
  },
  post(t, e, n) {
    return this.ky.post(t, {
      json: e,
      headers: n?.headers,
      searchParams: n?.queryParams
    }).json();
  }
};
function nl(t) {
  return t === null ? "null" : Array.isArray(t) ? "array" : typeof t;
}
function q1(t) {
  return nl(t) === "object";
}
function o2e(t) {
  return Array.isArray(t) && // must be at least one error
  t.length > 0 && // error has at least a message
  t.every((e) => "message" in e);
}
function bz(t, e) {
  return t.length < 124 ? t : e;
}
const s2e = "graphql-transport-ws";
var $l;
(function(t) {
  t[t.InternalServerError = 4500] = "InternalServerError", t[t.InternalClientError = 4005] = "InternalClientError", t[t.BadRequest = 4400] = "BadRequest", t[t.BadResponse = 4004] = "BadResponse", t[t.Unauthorized = 4401] = "Unauthorized", t[t.Forbidden = 4403] = "Forbidden", t[t.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", t[t.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", t[t.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", t[t.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", t[t.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})($l || ($l = {}));
var ra;
(function(t) {
  t.ConnectionInit = "connection_init", t.ConnectionAck = "connection_ack", t.Ping = "ping", t.Pong = "pong", t.Subscribe = "subscribe", t.Next = "next", t.Error = "error", t.Complete = "complete";
})(ra || (ra = {}));
function UW(t) {
  if (!q1(t))
    throw new Error(`Message is expected to be an object, but got ${nl(t)}`);
  if (!t.type)
    throw new Error("Message is missing the 'type' property");
  if (typeof t.type != "string")
    throw new Error(`Message is expects the 'type' property to be a string, but got ${nl(t.type)}`);
  switch (t.type) {
    case ra.ConnectionInit:
    case ra.ConnectionAck:
    case ra.Ping:
    case ra.Pong: {
      if (t.payload != null && !q1(t.payload))
        throw new Error(`"${t.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${t.payload}"`);
      break;
    }
    case ra.Subscribe: {
      if (typeof t.id != "string")
        throw new Error(`"${t.type}" message expects the 'id' property to be a string, but got ${nl(t.id)}`);
      if (!t.id)
        throw new Error(`"${t.type}" message requires a non-empty 'id' property`);
      if (!q1(t.payload))
        throw new Error(`"${t.type}" message expects the 'payload' property to be an object, but got ${nl(t.payload)}`);
      if (typeof t.payload.query != "string")
        throw new Error(`"${t.type}" message payload expects the 'query' property to be a string, but got ${nl(t.payload.query)}`);
      if (t.payload.variables != null && !q1(t.payload.variables))
        throw new Error(`"${t.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${nl(t.payload.variables)}`);
      if (t.payload.operationName != null && nl(t.payload.operationName) !== "string")
        throw new Error(`"${t.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${nl(t.payload.operationName)}`);
      if (t.payload.extensions != null && !q1(t.payload.extensions))
        throw new Error(`"${t.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${nl(t.payload.extensions)}`);
      break;
    }
    case ra.Next: {
      if (typeof t.id != "string")
        throw new Error(`"${t.type}" message expects the 'id' property to be a string, but got ${nl(t.id)}`);
      if (!t.id)
        throw new Error(`"${t.type}" message requires a non-empty 'id' property`);
      if (!q1(t.payload))
        throw new Error(`"${t.type}" message expects the 'payload' property to be an object, but got ${nl(t.payload)}`);
      break;
    }
    case ra.Error: {
      if (typeof t.id != "string")
        throw new Error(`"${t.type}" message expects the 'id' property to be a string, but got ${nl(t.id)}`);
      if (!t.id)
        throw new Error(`"${t.type}" message requires a non-empty 'id' property`);
      if (!o2e(t.payload))
        throw new Error(`"${t.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(t.payload)}`);
      break;
    }
    case ra.Complete: {
      if (typeof t.id != "string")
        throw new Error(`"${t.type}" message expects the 'id' property to be a string, but got ${nl(t.id)}`);
      if (!t.id)
        throw new Error(`"${t.type}" message requires a non-empty 'id' property`);
      break;
    }
    default:
      throw new Error(`Invalid message 'type' property "${t.type}"`);
  }
  return t;
}
function l2e(t, e) {
  return UW(typeof t == "string" ? JSON.parse(t, e) : t);
}
function IS(t, e) {
  return UW(t), JSON.stringify(t, e);
}
var Lb = globalThis && globalThis.__await || function(t) {
  return this instanceof Lb ? (this.v = t, this) : new Lb(t);
}, c2e = globalThis && globalThis.__asyncGenerator || function(t, e, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(t, e || []), i, a = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), c("next"), c("throw"), c("return", s), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function s(w) {
    return function(_) {
      return Promise.resolve(_).then(w, m);
    };
  }
  function c(w, _) {
    r[w] && (i[w] = function(A) {
      return new Promise(function(T, O) {
        a.push([w, A, T, O]) > 1 || d(w, A);
      });
    }, _ && (i[w] = _(i[w])));
  }
  function d(w, _) {
    try {
      f(r[w](_));
    } catch (A) {
      b(a[0][3], A);
    }
  }
  function f(w) {
    w.value instanceof Lb ? Promise.resolve(w.value.v).then(g, m) : b(a[0][2], w);
  }
  function g(w) {
    d("next", w);
  }
  function m(w) {
    d("throw", w);
  }
  function b(w, _) {
    w(_), a.shift(), a.length && d(a[0][0], a[0][1]);
  }
};
function u2e(t) {
  const {
    url: e,
    connectionParams: n,
    lazy: r = !0,
    onNonLazyError: i = console.error,
    lazyCloseTimeout: a = 0,
    keepAlive: s = 0,
    disablePong: c,
    connectionAckWaitTimeout: d = 0,
    retryAttempts: f = 5,
    retryWait: g = async function(U) {
      let q = 1e3;
      for (let W = 0; W < U; W++)
        q *= 2;
      await new Promise((W) => setTimeout(W, q + // add random timeout from 300ms to 3s
      Math.floor(Math.random() * (3e3 - 300) + 300)));
    },
    shouldRetry: m = H6,
    isFatalConnectionProblem: b,
    on: w,
    webSocketImpl: _,
    /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */
    generateID: A = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (U) => {
        const q = Math.random() * 16 | 0;
        return (U == "x" ? q : q & 3 | 8).toString(16);
      });
    },
    jsonMessageReplacer: T,
    jsonMessageReviver: O
  } = t;
  let R;
  if (_) {
    if (!f2e(_))
      throw new Error("Invalid WebSocket implementation provided");
    R = _;
  } else
    typeof WebSocket < "u" ? R = WebSocket : typeof global < "u" ? R = global.WebSocket || // @ts-expect-error: Support more browsers
    global.MozWebSocket : typeof window < "u" && (R = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket);
  if (!R)
    throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
  const N = R, M = (() => {
    const K = (() => {
      const q = {};
      return {
        on(W, ie) {
          return q[W] = ie, () => {
            delete q[W];
          };
        },
        emit(W) {
          var ie;
          "id" in W && ((ie = q[W.id]) === null || ie === void 0 || ie.call(q, W));
        }
      };
    })(), U = {
      connecting: w?.connecting ? [w.connecting] : [],
      opened: w?.opened ? [w.opened] : [],
      connected: w?.connected ? [w.connected] : [],
      ping: w?.ping ? [w.ping] : [],
      pong: w?.pong ? [w.pong] : [],
      message: w?.message ? [K.emit, w.message] : [K.emit],
      closed: w?.closed ? [w.closed] : [],
      error: w?.error ? [w.error] : []
    };
    return {
      onMessage: K.on,
      on(q, W) {
        const ie = U[q];
        return ie.push(W), () => {
          ie.splice(ie.indexOf(W), 1);
        };
      },
      emit(q, ...W) {
        for (const ie of [...U[q]])
          ie(...W);
      }
    };
  })();
  function P(K) {
    const U = [
      // errors are fatal and more critical than close events, throw them first
      M.on("error", (q) => {
        U.forEach((W) => W()), K(q);
      }),
      // closes can be graceful and not fatal, throw them second (if error didnt throw)
      M.on("closed", (q) => {
        U.forEach((W) => W()), K(q);
      })
    ];
  }
  let z, F = 0, $, G = !1, H = 0, Z = !1;
  async function V() {
    clearTimeout($);
    const [K, U] = await (z ?? (z = new Promise((ie, J) => (async () => {
      if (G) {
        if (await g(H), !F)
          return z = void 0, J({ code: 1e3, reason: "All Subscriptions Gone" });
        H++;
      }
      M.emit("connecting", G);
      const B = new N(typeof e == "function" ? await e() : e, s2e);
      let te, ae;
      function le() {
        isFinite(s) && s > 0 && (clearTimeout(ae), ae = setTimeout(() => {
          B.readyState === N.OPEN && (B.send(IS({ type: ra.Ping })), M.emit("ping", !1, void 0));
        }, s));
      }
      P((_e) => {
        z = void 0, clearTimeout(te), clearTimeout(ae), J(_e), _e instanceof wz && (B.close(4499, "Terminated"), B.onerror = null, B.onclose = null);
      }), B.onerror = (_e) => M.emit("error", _e), B.onclose = (_e) => M.emit("closed", _e), B.onopen = async () => {
        try {
          M.emit("opened", B);
          const _e = typeof n == "function" ? await n() : n;
          if (B.readyState !== N.OPEN)
            return;
          B.send(IS(_e ? {
            type: ra.ConnectionInit,
            payload: _e
          } : {
            type: ra.ConnectionInit
            // payload is completely absent if not provided
          }, T)), isFinite(d) && d > 0 && (te = setTimeout(() => {
            B.close($l.ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
          }, d)), le();
        } catch (_e) {
          M.emit("error", _e), B.close($l.InternalClientError, bz(_e instanceof Error ? _e.message : new Error(_e).message, "Internal client error"));
        }
      };
      let de = !1;
      B.onmessage = ({ data: _e }) => {
        try {
          const ue = l2e(_e, O);
          if (M.emit("message", ue), ue.type === "ping" || ue.type === "pong") {
            M.emit(ue.type, !0, ue.payload), ue.type === "pong" ? le() : c || (B.send(IS(ue.payload ? {
              type: ra.Pong,
              payload: ue.payload
            } : {
              type: ra.Pong
              // payload is completely absent if not provided
            })), M.emit("pong", !1, ue.payload));
            return;
          }
          if (de)
            return;
          if (ue.type !== ra.ConnectionAck)
            throw new Error(`First message cannot be of type ${ue.type}`);
          clearTimeout(te), de = !0, M.emit("connected", B, ue.payload, G), G = !1, H = 0, ie([
            B,
            new Promise((Se, Ne) => P(Ne))
          ]);
        } catch (ue) {
          B.onmessage = null, M.emit("error", ue), B.close($l.BadResponse, bz(ue instanceof Error ? ue.message : new Error(ue).message, "Bad response"));
        }
      };
    })())));
    K.readyState === N.CLOSING && await U;
    let q = () => {
    };
    const W = new Promise((ie) => q = ie);
    return [
      K,
      q,
      Promise.race([
        // wait for
        W.then(() => {
          if (!F) {
            const ie = () => K.close(1e3, "Normal Closure");
            isFinite(a) && a > 0 ? $ = setTimeout(() => {
              K.readyState === N.OPEN && ie();
            }, a) : ie();
          }
        }),
        // or
        U
      ])
    ];
  }
  function Y(K) {
    if (H6(K) && (d2e(K.code) || [
      $l.InternalServerError,
      $l.InternalClientError,
      $l.BadRequest,
      $l.BadResponse,
      $l.Unauthorized,
      // CloseCode.Forbidden, might grant access out after retry
      $l.SubprotocolNotAcceptable,
      // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
      // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
      $l.SubscriberAlreadyExists,
      $l.TooManyInitialisationRequests
      // 4499, // Terminated, probably because the socket froze, we want to retry
    ].includes(K.code)))
      throw K;
    if (Z)
      return !1;
    if (H6(K) && K.code === 1e3)
      return F > 0;
    if (!f || H >= f || !m(K) || b?.(K))
      throw K;
    return G = !0;
  }
  r || (async () => {
    for (F++; ; )
      try {
        const [, , K] = await V();
        await K;
      } catch (K) {
        try {
          if (!Y(K))
            return;
        } catch (U) {
          return i?.(U);
        }
      }
  })();
  function ee(K, U) {
    const q = A(K);
    let W = !1, ie = !1, J = () => {
      F--, W = !0;
    };
    return (async () => {
      for (F++; ; )
        try {
          const [B, te, ae] = await V();
          if (W)
            return te();
          const le = M.onMessage(q, (de) => {
            switch (de.type) {
              case ra.Next: {
                U.next(de.payload);
                return;
              }
              case ra.Error: {
                ie = !0, W = !0, U.error(de.payload), J();
                return;
              }
              case ra.Complete: {
                W = !0, J();
                return;
              }
            }
          });
          B.send(IS({
            id: q,
            type: ra.Subscribe,
            payload: K
          }, T)), J = () => {
            !W && B.readyState === N.OPEN && B.send(IS({
              id: q,
              type: ra.Complete
            }, T)), F--, W = !0, te();
          }, await ae.finally(le);
          return;
        } catch (B) {
          if (!Y(B))
            return;
        }
    })().then(() => {
      ie || U.complete();
    }).catch((B) => {
      U.error(B);
    }), () => {
      W || J();
    };
  }
  return {
    on: M.on,
    subscribe: ee,
    iterate(K) {
      const U = [], q = {
        done: !1,
        error: null,
        resolve: () => {
        }
      }, W = ee(K, {
        next(J) {
          U.push(J), q.resolve();
        },
        error(J) {
          q.done = !0, q.error = J, q.resolve();
        },
        complete() {
          q.done = !0, q.resolve();
        }
      }), ie = function() {
        return c2e(this, arguments, function* () {
          for (; ; ) {
            for (U.length || (yield Lb(new Promise((te) => q.resolve = te))); U.length; )
              yield yield Lb(U.shift());
            if (q.error)
              throw q.error;
            if (q.done)
              return yield Lb(void 0);
          }
        });
      }();
      return ie.throw = async (J) => (q.done || (q.done = !0, q.error = J, q.resolve()), { done: !0, value: void 0 }), ie.return = async () => (W(), { done: !0, value: void 0 }), ie;
    },
    async dispose() {
      if (Z = !0, z) {
        const [K] = await z;
        K.close(1e3, "Normal Closure");
      }
    },
    terminate() {
      z && M.emit("closed", new wz());
    }
  };
}
class wz extends Error {
  constructor() {
    super(...arguments), this.name = "TerminatedCloseEvent", this.message = "4499: Terminated", this.code = 4499, this.reason = "Terminated", this.wasClean = !1;
  }
}
function H6(t) {
  return q1(t) && "code" in t && "reason" in t;
}
function d2e(t) {
  return [
    1e3,
    // Normal Closure is not an erroneous close code
    1001,
    // Going Away
    1006,
    // Abnormal Closure
    1005,
    // No Status Received
    1012,
    // Service Restart
    1013,
    // Try Again Later
    1014
    // Bad Gateway
  ].includes(t) ? !1 : t >= 1e3 && t <= 1999;
}
function f2e(t) {
  return typeof t == "function" && "constructor" in t && "CLOSED" in t && "CLOSING" in t && "CONNECTING" in t && "OPEN" in t;
}
const h2e = () => {
  const t = window.location.protocol === "https:" ? "wss" : "ws", e = window.location.host;
  return `${t}://${e}/hasura/v1/graphql`;
}, $W = {
  client: u2e({
    url: h2e(),
    lazy: !1,
    lazyCloseTimeout: 5e3,
    retryAttempts: 3,
    // shouldRetry: () => false,
    async connectionParams() {
      return {
        headers: {
          // TODO replace
          // TODO why
          "Hasura-Client-Name": "hasura-console",
          "content-type": "application/json",
          Authorization: `Bearer ${await co.getOrRefreshAccessToken()}`
        }
      };
    },
    on: {
      connected: (t) => {
        $W.restart = () => {
          t instanceof WebSocket && t.readyState === WebSocket.OPEN && t.close(4205, "Client Restart");
        };
      }
    }
  }),
  restart: () => {
    console.warn("The function will be replaced when the socket is connected");
  }
}, GT = /* @__PURE__ */ new Map(), p2e = (t, e) => e ? [t, e] : [t], m2e = (t) => JSON.stringify(t), xz = (t, e, n, r, i) => {
  const a = GT.get(t);
  if (a)
    return a;
  let s, c;
  const d = {
    subscribers: 0,
    wsUnsubscribe: () => {
    },
    firstResultPromise: new Promise((b, w) => {
      s = b, c = w;
    }),
    hasFirstResult: !1,
    resolveFirst: () => {
      d.hasFirstResult || (d.hasFirstResult = !0, s());
    },
    rejectFirst: (b) => {
      d.hasFirstResult || (d.hasFirstResult = !0, c(b));
    }
  }, f = VW(n);
  let g = !0;
  const m = $W.client.subscribe({
    query: f,
    variables: r
  }, {
    next(b) {
      g && (i.setQueryData(e, b.data ?? null), d.resolveFirst());
    },
    error(b) {
      g && (console.error("WS subscription error", b), d.rejectFirst(b));
    },
    complete() {
    }
  });
  return d.wsUnsubscribe = () => {
    g && (g = !1, m());
  }, GT.set(t, d), d;
}, HW = (t, e, n) => {
  const r = Ju(), i = I.useMemo(() => n === void 0 ? "undefined" : JSON.stringify(n ?? null), [n]), a = I.useMemo(() => n, [i]), s = I.useMemo(() => p2e(t, a), [t, a]), c = I.useMemo(() => m2e(s), [s]), d = I.useCallback(async () => {
    const f = r.getQueryData(s);
    return f !== void 0 ? f : (await xz(c, s, e, a, r).firstResultPromise, r.getQueryData(s) ?? null);
  }, [r, s, e, a, c]);
  return I.useEffect(() => {
    const f = xz(c, s, e, a, r);
    return f.subscribers += 1, () => {
      const g = GT.get(c);
      g && (g.subscribers -= 1, g.subscribers <= 0 && (g.wsUnsubscribe(), GT.delete(c)));
    };
  }, [r, s, a, e, c]), {
    queryKey: s,
    queryFn: d
  };
}, Q5 = (t, e, n) => {
  const r = ve.c(8), {
    queryKey: i,
    queryFn: a
  } = HW(t, e, n);
  let s;
  r[0] !== a || r[1] !== i ? (s = {
    queryKey: i,
    queryFn: a,
    staleTime: 1 / 0,
    refetchOnMount: !1,
    refetchOnWindowFocus: !1,
    refetchOnReconnect: !1
  }, r[0] = a, r[1] = i, r[2] = s) : s = r[2];
  const c = kh(s), d = c.data ?? null, f = c.error ? String(c.error) : null;
  let g;
  return r[3] !== c.isFetching || r[4] !== c.isPending || r[5] !== d || r[6] !== f ? (g = {
    data: d,
    isLoading: c.isPending,
    isFetching: c.isFetching,
    error: f
  }, r[3] = c.isFetching, r[4] = c.isPending, r[5] = d, r[6] = f, r[7] = g) : g = r[7], g;
}, Z5 = (t, e, n) => {
  const r = ve.c(7), {
    queryKey: i,
    queryFn: a
  } = HW(t, e, n);
  let s;
  r[0] !== a || r[1] !== i ? (s = {
    queryKey: i,
    queryFn: a,
    staleTime: 1 / 0,
    refetchOnMount: !1,
    refetchOnWindowFocus: !1,
    refetchOnReconnect: !1
  }, r[0] = a, r[1] = i, r[2] = s) : s = r[2];
  const c = she(s), d = c.data ?? null, f = c.error ? String(c.error) : null;
  let g;
  return r[3] !== c.isFetching || r[4] !== d || r[5] !== f ? (g = {
    data: d,
    isLoading: !1,
    isFetching: c.isFetching,
    error: f
  }, r[3] = c.isFetching, r[4] = d, r[5] = f, r[6] = g) : g = r[6], g;
}, lo = {
  httpClientForHasura: t2e,
  httpClientForCloud: Ya,
  httpClientForN8N: a2e
};
function g2e(t) {
  return t.toLowerCase();
}
var v2e = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], y2e = /[^A-Z0-9]+/gi;
function b2e(t, e) {
  e === void 0 && (e = {});
  for (var n = e.splitRegexp, r = n === void 0 ? v2e : n, i = e.stripRegexp, a = i === void 0 ? y2e : i, s = e.transform, c = s === void 0 ? g2e : s, d = e.delimiter, f = d === void 0 ? " " : d, g = Sz(Sz(t, r, "$1\0$2"), a, "\0"), m = 0, b = g.length; g.charAt(m) === "\0"; )
    m++;
  for (; g.charAt(b - 1) === "\0"; )
    b--;
  return g.slice(m, b).split("\0").map(c).join(f);
}
function Sz(t, e, n) {
  return e instanceof RegExp ? t.replace(e, n) : e.reduce(function(r, i) {
    return r.replace(i, n);
  }, t);
}
function w2e(t, e) {
  return e === void 0 && (e = {}), b2e(t, ol({ delimiter: "." }, e));
}
function x2e(t, e) {
  return e === void 0 && (e = {}), w2e(t, ol({ delimiter: "_" }, e));
}
const S2e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  snakeCase: x2e
}, Symbol.toStringTag, { value: "Module" })), E2e = /* @__PURE__ */ hne(S2e), _2e = Z$, { snakeCase: A2e } = E2e;
var C2e = function(t, e) {
  return e = Object.assign({ deep: !0, exclude: [], parsingOptions: {} }, e), _2e(t, function(n, r) {
    return [
      T2e(e.exclude, n) ? n : A2e(n, e.parsingOptions),
      r
    ];
  }, e);
};
function T2e(t, e) {
  return t.some(function(n) {
    return typeof n == "string" ? n === e : n.test(e);
  });
}
const YT = /* @__PURE__ */ J0(C2e), qW = {
  askSupport(t) {
    return lo.httpClientForN8N.post("support-email", YT({
      ...t,
      api_token: OM.SUPPORT_API_TOKEN
    }));
  },
  getQuestions() {
    return lo.httpClientForN8N.get("cms/faq");
  }
}, O2e = "AskSupport", R2e = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationKey: [O2e],
    mutationFn: D2e
  }, t[0] = e) : e = t[0], Ei(e);
};
function D2e(t) {
  return qW.askSupport(t);
}
const N2e = Xr(Xe({
  question: Je(),
  answer: Je()
})), M2e = "Questions", I2e = () => {
  const t = ve.c(7);
  let e;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    queryKey: [M2e],
    queryFn: k2e
  }, t[0] = e) : e = t[0];
  const {
    data: n,
    isLoading: r,
    error: i
  } = kh(e);
  let a;
  t[1] !== n ? (a = n != null ? qt(N2e, n) : null, t[1] = n, t[2] = a) : a = t[2];
  const s = a;
  let c;
  return t[3] !== i || t[4] !== r || t[5] !== s ? (c = {
    data: s,
    isLoading: r,
    error: i
  }, t[3] = i, t[4] = r, t[5] = s, t[6] = c) : c = t[6], c;
};
function k2e() {
  return qW.getQuestions();
}
const j2e = Xe({
  name: bi.notEmptyString,
  subject: Je(),
  text: bi.notEmptyString,
  contactEmail: bi.notEmptyString.email()
});
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
const {
  entries: GW,
  setPrototypeOf: Ez,
  isFrozen: P2e,
  getPrototypeOf: L2e,
  getOwnPropertyDescriptor: B2e
} = Object;
let {
  freeze: Ps,
  seal: eu,
  create: YW
} = Object, {
  apply: G8,
  construct: Y8
} = typeof Reflect < "u" && Reflect;
Ps || (Ps = function(e) {
  return e;
});
eu || (eu = function(e) {
  return e;
});
G8 || (G8 = function(e, n, r) {
  return e.apply(n, r);
});
Y8 || (Y8 = function(e, n) {
  return new e(...n);
});
const LC = Ls(Array.prototype.forEach), z2e = Ls(Array.prototype.lastIndexOf), _z = Ls(Array.prototype.pop), kS = Ls(Array.prototype.push), F2e = Ls(Array.prototype.splice), x4 = Ls(String.prototype.toLowerCase), q6 = Ls(String.prototype.toString), Az = Ls(String.prototype.match), jS = Ls(String.prototype.replace), V2e = Ls(String.prototype.indexOf), U2e = Ls(String.prototype.trim), Pu = Ls(Object.prototype.hasOwnProperty), Cs = Ls(RegExp.prototype.test), PS = $2e(TypeError);
function Ls(t) {
  return function(e) {
    e instanceof RegExp && (e.lastIndex = 0);
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return G8(t, e, r);
  };
}
function $2e(t) {
  return function() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return Y8(t, n);
  };
}
function qn(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : x4;
  Ez && Ez(t, null);
  let r = e.length;
  for (; r--; ) {
    let i = e[r];
    if (typeof i == "string") {
      const a = n(i);
      a !== i && (P2e(e) || (e[r] = a), i = a);
    }
    t[i] = !0;
  }
  return t;
}
function H2e(t) {
  for (let e = 0; e < t.length; e++)
    Pu(t, e) || (t[e] = null);
  return t;
}
function Sh(t) {
  const e = YW(null);
  for (const [n, r] of GW(t))
    Pu(t, n) && (Array.isArray(r) ? e[n] = H2e(r) : r && typeof r == "object" && r.constructor === Object ? e[n] = Sh(r) : e[n] = r);
  return e;
}
function LS(t, e) {
  for (; t !== null; ) {
    const r = B2e(t, e);
    if (r) {
      if (r.get)
        return Ls(r.get);
      if (typeof r.value == "function")
        return Ls(r.value);
    }
    t = L2e(t);
  }
  function n() {
    return null;
  }
  return n;
}
const Cz = Ps(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), G6 = Ps(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Y6 = Ps(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), q2e = Ps(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), X6 = Ps(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), G2e = Ps(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Tz = Ps(["#text"]), Oz = Ps(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), W6 = Ps(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Rz = Ps(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), BC = Ps(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Y2e = eu(/\{\{[\w\W]*|[\w\W]*\}\}/gm), X2e = eu(/<%[\w\W]*|[\w\W]*%>/gm), W2e = eu(/\$\{[\w\W]*/gm), Q2e = eu(/^data-[\-\w.\u00B7-\uFFFF]+$/), Z2e = eu(/^aria-[\-\w]+$/), XW = eu(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), K2e = eu(/^(?:\w+script|data):/i), J2e = eu(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), WW = eu(/^html$/i), exe = eu(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Dz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Z2e,
  ATTR_WHITESPACE: J2e,
  CUSTOM_ELEMENT: exe,
  DATA_ATTR: Q2e,
  DOCTYPE_NAME: WW,
  ERB_EXPR: X2e,
  IS_ALLOWED_URI: XW,
  IS_SCRIPT_OR_DATA: K2e,
  MUSTACHE_EXPR: Y2e,
  TMPLIT_EXPR: W2e
});
const BS = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, txe = function() {
  return typeof window > "u" ? null : window;
}, nxe = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, Nz = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function QW() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : txe();
  const e = (jt) => QW(jt);
  if (e.version = "3.2.6", e.removed = [], !t || !t.document || t.document.nodeType !== BS.document || !t.Element)
    return e.isSupported = !1, e;
  let {
    document: n
  } = t;
  const r = n, i = r.currentScript, {
    DocumentFragment: a,
    HTMLTemplateElement: s,
    Node: c,
    Element: d,
    NodeFilter: f,
    NamedNodeMap: g = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: m,
    DOMParser: b,
    trustedTypes: w
  } = t, _ = d.prototype, A = LS(_, "cloneNode"), T = LS(_, "remove"), O = LS(_, "nextSibling"), R = LS(_, "childNodes"), N = LS(_, "parentNode");
  if (typeof s == "function") {
    const jt = n.createElement("template");
    jt.content && jt.content.ownerDocument && (n = jt.content.ownerDocument);
  }
  let M, P = "";
  const {
    implementation: z,
    createNodeIterator: F,
    createDocumentFragment: $,
    getElementsByTagName: G
  } = n, {
    importNode: H
  } = r;
  let Z = Nz();
  e.isSupported = typeof GW == "function" && typeof N == "function" && z && z.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: V,
    ERB_EXPR: Y,
    TMPLIT_EXPR: ee,
    DATA_ATTR: K,
    ARIA_ATTR: U,
    IS_SCRIPT_OR_DATA: q,
    ATTR_WHITESPACE: W,
    CUSTOM_ELEMENT: ie
  } = Dz;
  let {
    IS_ALLOWED_URI: J
  } = Dz, B = null;
  const te = qn({}, [...Cz, ...G6, ...Y6, ...X6, ...Tz]);
  let ae = null;
  const le = qn({}, [...Oz, ...W6, ...Rz, ...BC]);
  let de = Object.seal(YW(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), _e = null, ue = null, Se = !0, Ne = !0, Me = !1, Ce = !0, Ue = !1, rt = !0, it = !1, Ft = !1, wt = !1, Ot = !1, On = !1, Ct = !1, se = !0, ge = !1;
  const Te = "user-content-";
  let He = !0, $e = !1, Ze = {}, ct = null;
  const Mt = qn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Rt = null;
  const sn = qn({}, ["audio", "video", "img", "source", "image", "track"]);
  let In = null;
  const hn = qn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Wn = "http://www.w3.org/1998/Math/MathML", ar = "http://www.w3.org/2000/svg", kn = "http://www.w3.org/1999/xhtml";
  let yr = kn, or = !1, sa = null;
  const re = qn({}, [Wn, ar, kn], q6);
  let Ae = qn({}, ["mi", "mo", "mn", "ms", "mtext"]), nt = qn({}, ["annotation-xml"]);
  const st = qn({}, ["title", "style", "font", "a", "script"]);
  let lt = null;
  const bt = ["application/xhtml+xml", "text/html"], Ke = "text/html";
  let ut = null, ft = null;
  const en = n.createElement("form"), sr = function(we) {
    return we instanceof RegExp || we instanceof Function;
  }, jn = function() {
    let we = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(ft && ft === we)) {
      if ((!we || typeof we != "object") && (we = {}), we = Sh(we), lt = // eslint-disable-next-line unicorn/prefer-includes
      bt.indexOf(we.PARSER_MEDIA_TYPE) === -1 ? Ke : we.PARSER_MEDIA_TYPE, ut = lt === "application/xhtml+xml" ? q6 : x4, B = Pu(we, "ALLOWED_TAGS") ? qn({}, we.ALLOWED_TAGS, ut) : te, ae = Pu(we, "ALLOWED_ATTR") ? qn({}, we.ALLOWED_ATTR, ut) : le, sa = Pu(we, "ALLOWED_NAMESPACES") ? qn({}, we.ALLOWED_NAMESPACES, q6) : re, In = Pu(we, "ADD_URI_SAFE_ATTR") ? qn(Sh(hn), we.ADD_URI_SAFE_ATTR, ut) : hn, Rt = Pu(we, "ADD_DATA_URI_TAGS") ? qn(Sh(sn), we.ADD_DATA_URI_TAGS, ut) : sn, ct = Pu(we, "FORBID_CONTENTS") ? qn({}, we.FORBID_CONTENTS, ut) : Mt, _e = Pu(we, "FORBID_TAGS") ? qn({}, we.FORBID_TAGS, ut) : Sh({}), ue = Pu(we, "FORBID_ATTR") ? qn({}, we.FORBID_ATTR, ut) : Sh({}), Ze = Pu(we, "USE_PROFILES") ? we.USE_PROFILES : !1, Se = we.ALLOW_ARIA_ATTR !== !1, Ne = we.ALLOW_DATA_ATTR !== !1, Me = we.ALLOW_UNKNOWN_PROTOCOLS || !1, Ce = we.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ue = we.SAFE_FOR_TEMPLATES || !1, rt = we.SAFE_FOR_XML !== !1, it = we.WHOLE_DOCUMENT || !1, Ot = we.RETURN_DOM || !1, On = we.RETURN_DOM_FRAGMENT || !1, Ct = we.RETURN_TRUSTED_TYPE || !1, wt = we.FORCE_BODY || !1, se = we.SANITIZE_DOM !== !1, ge = we.SANITIZE_NAMED_PROPS || !1, He = we.KEEP_CONTENT !== !1, $e = we.IN_PLACE || !1, J = we.ALLOWED_URI_REGEXP || XW, yr = we.NAMESPACE || kn, Ae = we.MATHML_TEXT_INTEGRATION_POINTS || Ae, nt = we.HTML_INTEGRATION_POINTS || nt, de = we.CUSTOM_ELEMENT_HANDLING || {}, we.CUSTOM_ELEMENT_HANDLING && sr(we.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (de.tagNameCheck = we.CUSTOM_ELEMENT_HANDLING.tagNameCheck), we.CUSTOM_ELEMENT_HANDLING && sr(we.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (de.attributeNameCheck = we.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), we.CUSTOM_ELEMENT_HANDLING && typeof we.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (de.allowCustomizedBuiltInElements = we.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ue && (Ne = !1), On && (Ot = !0), Ze && (B = qn({}, Tz), ae = [], Ze.html === !0 && (qn(B, Cz), qn(ae, Oz)), Ze.svg === !0 && (qn(B, G6), qn(ae, W6), qn(ae, BC)), Ze.svgFilters === !0 && (qn(B, Y6), qn(ae, W6), qn(ae, BC)), Ze.mathMl === !0 && (qn(B, X6), qn(ae, Rz), qn(ae, BC))), we.ADD_TAGS && (B === te && (B = Sh(B)), qn(B, we.ADD_TAGS, ut)), we.ADD_ATTR && (ae === le && (ae = Sh(ae)), qn(ae, we.ADD_ATTR, ut)), we.ADD_URI_SAFE_ATTR && qn(In, we.ADD_URI_SAFE_ATTR, ut), we.FORBID_CONTENTS && (ct === Mt && (ct = Sh(ct)), qn(ct, we.FORBID_CONTENTS, ut)), He && (B["#text"] = !0), it && qn(B, ["html", "head", "body"]), B.table && (qn(B, ["tbody"]), delete _e.tbody), we.TRUSTED_TYPES_POLICY) {
        if (typeof we.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw PS('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof we.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw PS('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        M = we.TRUSTED_TYPES_POLICY, P = M.createHTML("");
      } else
        M === void 0 && (M = nxe(w, i)), M !== null && typeof P == "string" && (P = M.createHTML(""));
      Ps && Ps(we), ft = we;
    }
  }, vn = qn({}, [...G6, ...Y6, ...q2e]), Ai = qn({}, [...X6, ...G2e]), Un = function(we) {
    let ot = N(we);
    (!ot || !ot.tagName) && (ot = {
      namespaceURI: yr,
      tagName: "template"
    });
    const xt = x4(we.tagName), Kn = x4(ot.tagName);
    return sa[we.namespaceURI] ? we.namespaceURI === ar ? ot.namespaceURI === kn ? xt === "svg" : ot.namespaceURI === Wn ? xt === "svg" && (Kn === "annotation-xml" || Ae[Kn]) : !!vn[xt] : we.namespaceURI === Wn ? ot.namespaceURI === kn ? xt === "math" : ot.namespaceURI === ar ? xt === "math" && nt[Kn] : !!Ai[xt] : we.namespaceURI === kn ? ot.namespaceURI === ar && !nt[Kn] || ot.namespaceURI === Wn && !Ae[Kn] ? !1 : !Ai[xt] && (st[xt] || !vn[xt]) : !!(lt === "application/xhtml+xml" && sa[we.namespaceURI]) : !1;
  }, tn = function(we) {
    kS(e.removed, {
      element: we
    });
    try {
      N(we).removeChild(we);
    } catch {
      T(we);
    }
  }, $i = function(we, ot) {
    try {
      kS(e.removed, {
        attribute: ot.getAttributeNode(we),
        from: ot
      });
    } catch {
      kS(e.removed, {
        attribute: null,
        from: ot
      });
    }
    if (ot.removeAttribute(we), we === "is")
      if (Ot || On)
        try {
          tn(ot);
        } catch {
        }
      else
        try {
          ot.setAttribute(we, "");
        } catch {
        }
  }, Hi = function(we) {
    let ot = null, xt = null;
    if (wt)
      we = "<remove></remove>" + we;
    else {
      const kr = Az(we, /^[\r\n\t ]+/);
      xt = kr && kr[0];
    }
    lt === "application/xhtml+xml" && yr === kn && (we = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + we + "</body></html>");
    const Kn = M ? M.createHTML(we) : we;
    if (yr === kn)
      try {
        ot = new b().parseFromString(Kn, lt);
      } catch {
      }
    if (!ot || !ot.documentElement) {
      ot = z.createDocument(yr, "template", null);
      try {
        ot.documentElement.innerHTML = or ? P : Kn;
      } catch {
      }
    }
    const li = ot.body || ot.documentElement;
    return we && xt && li.insertBefore(n.createTextNode(xt), li.childNodes[0] || null), yr === kn ? G.call(ot, it ? "html" : "body")[0] : it ? ot.documentElement : li;
  }, Ta = function(we) {
    return F.call(
      we.ownerDocument || we,
      we,
      // eslint-disable-next-line no-bitwise
      f.SHOW_ELEMENT | f.SHOW_COMMENT | f.SHOW_TEXT | f.SHOW_PROCESSING_INSTRUCTION | f.SHOW_CDATA_SECTION,
      null
    );
  }, ns = function(we) {
    return we instanceof m && (typeof we.nodeName != "string" || typeof we.textContent != "string" || typeof we.removeChild != "function" || !(we.attributes instanceof g) || typeof we.removeAttribute != "function" || typeof we.setAttribute != "function" || typeof we.namespaceURI != "string" || typeof we.insertBefore != "function" || typeof we.hasChildNodes != "function");
  }, la = function(we) {
    return typeof c == "function" && we instanceof c;
  };
  function Rn(jt, we, ot) {
    LC(jt, (xt) => {
      xt.call(e, we, ot, ft);
    });
  }
  const ca = function(we) {
    let ot = null;
    if (Rn(Z.beforeSanitizeElements, we, null), ns(we))
      return tn(we), !0;
    const xt = ut(we.nodeName);
    if (Rn(Z.uponSanitizeElement, we, {
      tagName: xt,
      allowedTags: B
    }), rt && we.hasChildNodes() && !la(we.firstElementChild) && Cs(/<[/\w!]/g, we.innerHTML) && Cs(/<[/\w!]/g, we.textContent) || we.nodeType === BS.progressingInstruction || rt && we.nodeType === BS.comment && Cs(/<[/\w]/g, we.data))
      return tn(we), !0;
    if (!B[xt] || _e[xt]) {
      if (!_e[xt] && ff(xt) && (de.tagNameCheck instanceof RegExp && Cs(de.tagNameCheck, xt) || de.tagNameCheck instanceof Function && de.tagNameCheck(xt)))
        return !1;
      if (He && !ct[xt]) {
        const Kn = N(we) || we.parentNode, li = R(we) || we.childNodes;
        if (li && Kn) {
          const kr = li.length;
          for (let on = kr - 1; on >= 0; --on) {
            const Oa = A(li[on], !0);
            Oa.__removalCount = (we.__removalCount || 0) + 1, Kn.insertBefore(Oa, O(we));
          }
        }
      }
      return tn(we), !0;
    }
    return we instanceof d && !Un(we) || (xt === "noscript" || xt === "noembed" || xt === "noframes") && Cs(/<\/no(script|embed|frames)/i, we.innerHTML) ? (tn(we), !0) : (Ue && we.nodeType === BS.text && (ot = we.textContent, LC([V, Y, ee], (Kn) => {
      ot = jS(ot, Kn, " ");
    }), we.textContent !== ot && (kS(e.removed, {
      element: we.cloneNode()
    }), we.textContent = ot)), Rn(Z.afterSanitizeElements, we, null), !1);
  }, pl = function(we, ot, xt) {
    if (se && (ot === "id" || ot === "name") && (xt in n || xt in en))
      return !1;
    if (!(Ne && !ue[ot] && Cs(K, ot))) {
      if (!(Se && Cs(U, ot))) {
        if (!ae[ot] || ue[ot]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(ff(we) && (de.tagNameCheck instanceof RegExp && Cs(de.tagNameCheck, we) || de.tagNameCheck instanceof Function && de.tagNameCheck(we)) && (de.attributeNameCheck instanceof RegExp && Cs(de.attributeNameCheck, ot) || de.attributeNameCheck instanceof Function && de.attributeNameCheck(ot)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            ot === "is" && de.allowCustomizedBuiltInElements && (de.tagNameCheck instanceof RegExp && Cs(de.tagNameCheck, xt) || de.tagNameCheck instanceof Function && de.tagNameCheck(xt)))
          )
            return !1;
        } else if (!In[ot]) {
          if (!Cs(J, jS(xt, W, ""))) {
            if (!((ot === "src" || ot === "xlink:href" || ot === "href") && we !== "script" && V2e(xt, "data:") === 0 && Rt[we])) {
              if (!(Me && !Cs(q, jS(xt, W, "")))) {
                if (xt)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, ff = function(we) {
    return we !== "annotation-xml" && Az(we, ie);
  }, Fh = function(we) {
    Rn(Z.beforeSanitizeAttributes, we, null);
    const {
      attributes: ot
    } = we;
    if (!ot || ns(we))
      return;
    const xt = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: ae,
      forceKeepAttr: void 0
    };
    let Kn = ot.length;
    for (; Kn--; ) {
      const li = ot[Kn], {
        name: kr,
        namespaceURI: on,
        value: Oa
      } = li, Bo = ut(kr), Bs = Oa;
      let jr = kr === "value" ? Bs : U2e(Bs);
      if (xt.attrName = Bo, xt.attrValue = jr, xt.keepAttr = !0, xt.forceKeepAttr = void 0, Rn(Z.uponSanitizeAttribute, we, xt), jr = xt.attrValue, ge && (Bo === "id" || Bo === "name") && ($i(kr, we), jr = Te + jr), rt && Cs(/((--!?|])>)|<\/(style|title)/i, jr)) {
        $i(kr, we);
        continue;
      }
      if (xt.forceKeepAttr)
        continue;
      if (!xt.keepAttr) {
        $i(kr, we);
        continue;
      }
      if (!Ce && Cs(/\/>/i, jr)) {
        $i(kr, we);
        continue;
      }
      Ue && LC([V, Y, ee], (pf) => {
        jr = jS(jr, pf, " ");
      });
      const hf = ut(we.nodeName);
      if (!pl(hf, Bo, jr)) {
        $i(kr, we);
        continue;
      }
      if (M && typeof w == "object" && typeof w.getAttributeType == "function" && !on)
        switch (w.getAttributeType(hf, Bo)) {
          case "TrustedHTML": {
            jr = M.createHTML(jr);
            break;
          }
          case "TrustedScriptURL": {
            jr = M.createScriptURL(jr);
            break;
          }
        }
      if (jr !== Bs)
        try {
          on ? we.setAttributeNS(on, kr, jr) : we.setAttribute(kr, jr), ns(we) ? tn(we) : _z(e.removed);
        } catch {
          $i(kr, we);
        }
    }
    Rn(Z.afterSanitizeAttributes, we, null);
  }, Hg = function jt(we) {
    let ot = null;
    const xt = Ta(we);
    for (Rn(Z.beforeSanitizeShadowDOM, we, null); ot = xt.nextNode(); )
      Rn(Z.uponSanitizeShadowNode, ot, null), ca(ot), Fh(ot), ot.content instanceof a && jt(ot.content);
    Rn(Z.afterSanitizeShadowDOM, we, null);
  };
  return e.sanitize = function(jt) {
    let we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ot = null, xt = null, Kn = null, li = null;
    if (or = !jt, or && (jt = "<!-->"), typeof jt != "string" && !la(jt))
      if (typeof jt.toString == "function") {
        if (jt = jt.toString(), typeof jt != "string")
          throw PS("dirty is not a string, aborting");
      } else
        throw PS("toString is not a function");
    if (!e.isSupported)
      return jt;
    if (Ft || jn(we), e.removed = [], typeof jt == "string" && ($e = !1), $e) {
      if (jt.nodeName) {
        const Oa = ut(jt.nodeName);
        if (!B[Oa] || _e[Oa])
          throw PS("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (jt instanceof c)
      ot = Hi("<!---->"), xt = ot.ownerDocument.importNode(jt, !0), xt.nodeType === BS.element && xt.nodeName === "BODY" || xt.nodeName === "HTML" ? ot = xt : ot.appendChild(xt);
    else {
      if (!Ot && !Ue && !it && // eslint-disable-next-line unicorn/prefer-includes
      jt.indexOf("<") === -1)
        return M && Ct ? M.createHTML(jt) : jt;
      if (ot = Hi(jt), !ot)
        return Ot ? null : Ct ? P : "";
    }
    ot && wt && tn(ot.firstChild);
    const kr = Ta($e ? jt : ot);
    for (; Kn = kr.nextNode(); )
      ca(Kn), Fh(Kn), Kn.content instanceof a && Hg(Kn.content);
    if ($e)
      return jt;
    if (Ot) {
      if (On)
        for (li = $.call(ot.ownerDocument); ot.firstChild; )
          li.appendChild(ot.firstChild);
      else
        li = ot;
      return (ae.shadowroot || ae.shadowrootmode) && (li = H.call(r, li, !0)), li;
    }
    let on = it ? ot.outerHTML : ot.innerHTML;
    return it && B["!doctype"] && ot.ownerDocument && ot.ownerDocument.doctype && ot.ownerDocument.doctype.name && Cs(WW, ot.ownerDocument.doctype.name) && (on = "<!DOCTYPE " + ot.ownerDocument.doctype.name + `>
` + on), Ue && LC([V, Y, ee], (Oa) => {
      on = jS(on, Oa, " ");
    }), M && Ct ? M.createHTML(on) : on;
  }, e.setConfig = function() {
    let jt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    jn(jt), Ft = !0;
  }, e.clearConfig = function() {
    ft = null, Ft = !1;
  }, e.isValidAttribute = function(jt, we, ot) {
    ft || jn({});
    const xt = ut(jt), Kn = ut(we);
    return pl(xt, Kn, ot);
  }, e.addHook = function(jt, we) {
    typeof we == "function" && kS(Z[jt], we);
  }, e.removeHook = function(jt, we) {
    if (we !== void 0) {
      const ot = z2e(Z[jt], we);
      return ot === -1 ? void 0 : F2e(Z[jt], ot, 1)[0];
    }
    return _z(Z[jt]);
  }, e.removeHooks = function(jt) {
    Z[jt] = [];
  }, e.removeAllHooks = function() {
    Z = Nz();
  }, e;
}
var rxe = QW();
const ixe = Re.div`
  twd-space-y-4
`, axe = Re.div`
  twd-text-center
`, oxe = () => {
  const t = ve.c(5), {
    data: e,
    isLoading: n
  } = I2e();
  if (n) {
    let s;
    return t[0] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ C.jsx(axe, { children: /* @__PURE__ */ C.jsx(aa, {}) }), t[0] = s) : s = t[0], s;
  }
  if (e == null)
    return null;
  let r;
  t[1] !== e ? (r = e.map(sxe), t[1] = e, t[2] = r) : r = t[2];
  const i = r;
  let a;
  return t[3] !== i ? (a = /* @__PURE__ */ C.jsx(ixe, { children: /* @__PURE__ */ C.jsx(yue, { items: i }) }), t[3] = i, t[4] = a) : a = t[4], a;
};
function sxe(t, e) {
  const {
    question: n,
    answer: r
  } = t;
  return {
    value: String(e),
    title: n,
    content: /* @__PURE__ */ C.jsx("div", { dangerouslySetInnerHTML: {
      __html: rxe.sanitize(r)
    } })
  };
}
const lxe = Re.form`
  twd-mt-4
  twd-w-full
  twd-space-y-4
`, cxe = Re.div`
  twd-text-lg
  twd-font-bold
`, uxe = ({
  onSuccess: t
}) => {
  const {
    mutateAsync: e
  } = R2e(), n = es(), {
    showDefaultNotification: r
  } = nd(), {
    handleSubmit: i,
    control: a,
    formState: s
  } = ed({
    defaultValues: {
      name: "",
      subject: "",
      text: "",
      contactEmail: ""
    },
    resolver: td(j2e)
  });
  return /* @__PURE__ */ C.jsxs(lxe, { onSubmit: i(async (c) => {
    try {
      await e({
        ...c,
        subject: c.subject.trim().length === 0 ? "Question from application" : `${c.subject} from application`
      }), t(), r("We've received your message and we will get back to you soon!");
    } catch (d) {
      n(d);
    }
  }), children: [
    /* @__PURE__ */ C.jsx(cxe, { children: "Ask support" }),
    /* @__PURE__ */ C.jsx(Zr, { name: "name", control: a, label: "Name" }),
    /* @__PURE__ */ C.jsx(Zr, { name: "contactEmail", control: a, label: "Email" }),
    /* @__PURE__ */ C.jsx(Zr, { name: "subject", control: a, label: "Subject" }),
    /* @__PURE__ */ C.jsx(Gbe, { name: "text", control: a, label: "Question" }),
    /* @__PURE__ */ C.jsx(Vt, { isFullWidth: !0, isLoading: s.isSubmitting, variant: "primaryContained", isSubmit: !0, children: "Send" })
  ] });
}, dxe = Re.div`
  twd-flex
  twd-justify-center
`, fxe = () => {
  const t = ve.c(2), [e, n] = I.useState(!1);
  let r;
  return t[0] !== e ? (r = /* @__PURE__ */ C.jsx(dxe, { children: e ? /* @__PURE__ */ C.jsx(uxe, { onSuccess: () => n(!1) }) : /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", onClick: () => n(!0), children: "Ask question" }) }), t[0] = e, t[1] = r) : r = t[1], r;
}, hxe = Re.button`
  twd-fixed
  twd-bottom-5
  twd-right-5
  twd-z-10
  twd-h-10
  twd-w-10
  twd-cursor-pointer
  twd-rounded-full
  twd-border-none
  twd-bg-primary-light2
  twd-p-0
  twd-shadow-md
  twd-outline-none
  twd-transition-colors
  hover:twd-bg-primary-light3
  active:twd-bg-primary-light2
  lg:twd-right-20
`, pxe = Re.div`
  twd-space-y-4
`, mxe = () => {
  const t = ve.c(6), [e, n] = I.useState(!1);
  let r;
  t[0] !== e ? (r = e ? null : /* @__PURE__ */ C.jsx(hxe, { children: /* @__PURE__ */ C.jsx(BY, { size: "xl" }) }), t[0] = e, t[1] = r) : r = t[1];
  let i;
  t[2] === Symbol.for("react.memo_cache_sentinel") ? (i = (c) => n(c), t[2] = i) : i = t[2];
  let a;
  t[3] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ C.jsxs(pxe, { children: [
    /* @__PURE__ */ C.jsx(oxe, {}),
    /* @__PURE__ */ C.jsx(fxe, {})
  ] }), t[3] = a) : a = t[3];
  let s;
  return t[4] !== r ? (s = /* @__PURE__ */ C.jsx(epe, { trigger: r, onOpenChange: i, title: "FAQ", children: a }), t[4] = r, t[5] = s) : s = t[5], s;
}, IGe = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ C.jsx(mxe, {}), t[0] = e) : e = t[0], e;
};
var gxe = typeof window < "u";
function vxe(t, e) {
  e === void 0 && (e = 0);
  var n = I.useRef(!1), r = I.useRef(), i = I.useRef(t), a = I.useCallback(function() {
    return n.current;
  }, []), s = I.useCallback(function() {
    n.current = !1, r.current && clearTimeout(r.current), r.current = setTimeout(function() {
      n.current = !0, i.current();
    }, e);
  }, [e]), c = I.useCallback(function() {
    n.current = null, r.current && clearTimeout(r.current);
  }, []);
  return I.useEffect(function() {
    i.current = t;
  }, [t]), I.useEffect(function() {
    return s(), c;
  }, [e]), [a, c, s];
}
function yxe(t, e, n) {
  e === void 0 && (e = 0), n === void 0 && (n = []);
  var r = vxe(t, e), i = r[0], a = r[1], s = r[2];
  return I.useEffect(s, n), [i, a];
}
var bxe = function(t) {
  I.useEffect(t, []);
};
const wxe = bxe;
var xxe = function(t, e) {
  return e !== void 0 ? e : gxe ? window.matchMedia(t).matches : (process.env.NODE_ENV !== "production" && console.warn("`useMedia` When server side rendering, defaultState should be defined to prevent a hydration mismatches."), !1);
}, Sxe = function(t, e) {
  var n = I.useState(xxe(t, e)), r = n[0], i = n[1];
  return I.useEffect(function() {
    var a = !0, s = window.matchMedia(t), c = function() {
      a && i(!!s.matches);
    };
    return s.addEventListener("change", c), i(s.matches), function() {
      a = !1, s.removeEventListener("change", c);
    };
  }, [t]), r;
};
const Exe = Sxe;
var _xe = function(t) {
  wxe(function() {
    t();
  });
};
const XI = _xe;
function ZW(t) {
  var e = I.useRef();
  return I.useEffect(function() {
    e.current = t;
  }), e.current;
}
var Axe = {
  restoreOnUnmount: !1
};
function Cxe(t, e) {
  e === void 0 && (e = Axe);
  var n = I.useRef(document.title);
  document.title !== t && (document.title = t), I.useEffect(function() {
    if (e && e.restoreOnUnmount)
      return function() {
        document.title = n.current;
      };
  }, []);
}
const KW = typeof document < "u" ? Cxe : function(t) {
}, JW = Re.div`
  twd-container
  twd-mx-auto
  twd-max-w-screen-lg
  ${({
  $hasGutterOnMobile: t = !1
}) => t ? "twd-px-2" : "twd-px-0"}
  sm:twd-px-2
`, Txe = {
  id: "no",
  name: "No"
}, Oxe = {
  id: "wpa",
  name: "WPA/WPA2/WPA3"
}, xb = {
  NO: Txe,
  WPA: Oxe
}, Rxe = Y$("security", [Xe({
  security: zE(xb.NO.id),
  id: bi.notEmptyString,
  p: Je()
}), Xe({
  security: zE(xb.WPA.id),
  id: bi.notEmptyString,
  p: Je().min(8)
})]), eQ = (t, e) => {
  const n = window.URL.createObjectURL(t), r = document.createElement("a");
  r.href = n, r.download = e, document.body.appendChild(r), r.click(), r.remove(), window.URL.revokeObjectURL(n);
}, Dxe = Re.form`
  twd-mx-auto
  twd-flex
  twd-max-w-xs
  twd-flex-col
  twd-items-center
  twd-gap-4
`, Nxe = Re.div`
  twd-my-2
  twd-text-lg
`, Mxe = () => {
  const t = ve.c(32), [e, n] = I.useState(!1), [r, i] = I.useState(!1);
  let a;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = {
    defaultValues: {
      id: "",
      p: "",
      security: xb.WPA.id
    },
    resolver: td(Rxe)
  }, t[0] = a) : a = t[0];
  const {
    handleSubmit: s,
    control: c,
    formState: d,
    resetField: f
  } = ed(a);
  let g;
  t[1] !== c ? (g = {
    control: c,
    name: "security"
  }, t[1] = c, t[2] = g) : g = t[2];
  const m = Wb(g);
  let b, w;
  t[3] !== f || t[4] !== m ? (b = () => {
    m === xb.NO.id && f("p");
  }, w = [m, f], t[3] = f, t[4] = m, t[5] = b, t[6] = w) : (b = t[5], w = t[6]), I.useEffect(b, w);
  let _;
  t[7] !== s ? (_ = s(Ixe), t[7] = s, t[8] = _) : _ = t[8];
  let A, T, O;
  t[9] === Symbol.for("react.memo_cache_sentinel") ? (A = /* @__PURE__ */ C.jsx(Nxe, { children: "Enter your Wi-Fi network name and password to generate a file for connecting to the network" }), T = /* @__PURE__ */ C.jsx("input", { name: "username", className: "twd-hidden" }), O = /* @__PURE__ */ C.jsx("input", { name: "email", className: "twd-hidden" }), t[9] = A, t[10] = T, t[11] = O) : (A = t[9], T = t[10], O = t[11]);
  let R;
  t[12] !== c ? (R = /* @__PURE__ */ C.jsx(Zr, { name: "id", control: c, label: "Network name", isFullWidth: !0, autoComplete: "new-network-name" }), t[12] = c, t[13] = R) : R = t[13];
  let N;
  t[14] === Symbol.for("react.memo_cache_sentinel") ? (N = Object.values(xb).map(kxe), t[14] = N) : N = t[14];
  let M;
  t[15] !== c ? (M = /* @__PURE__ */ C.jsx(Qb, { name: "security", label: "Security", control: c, isFullWidth: !0, children: N }), t[15] = c, t[16] = M) : M = t[16];
  let P;
  t[17] === Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ C.jsx("input", { name: "password", className: "twd-hidden" }), t[17] = P) : P = t[17];
  let z;
  t[18] !== c || t[19] !== e || t[20] !== m || t[21] !== r ? (z = m === xb.WPA.id && /* @__PURE__ */ C.jsx(Zr, { name: "p", control: c, label: "Password", type: !r || e ? "text" : "password", isFullWidth: !0, rightIcon: /* @__PURE__ */ C.jsx(cl, { icon: e ? /* @__PURE__ */ C.jsx(EI, {}) : /* @__PURE__ */ C.jsx(T_, {}), onClick: () => n(!e) }), onFocus: () => i(!0), autoComplete: "new-password" }), t[18] = c, t[19] = e, t[20] = m, t[21] = r, t[22] = z) : z = t[22];
  let F;
  t[23] !== d.isSubmitting ? (F = /* @__PURE__ */ C.jsx(Vt, { isLoading: d.isSubmitting, variant: "primaryContained", isSubmit: !0, isFullWidth: !0, children: "Generate file" }), t[23] = d.isSubmitting, t[24] = F) : F = t[24];
  let $;
  t[25] === Symbol.for("react.memo_cache_sentinel") ? ($ = /* @__PURE__ */ C.jsx(Vt, { variant: "primary", isSubmit: !1, isFullWidth: !0, onClick: jxe, children: "Go to main page" }), t[25] = $) : $ = t[25];
  let G;
  return t[26] !== M || t[27] !== z || t[28] !== F || t[29] !== _ || t[30] !== R ? (G = /* @__PURE__ */ C.jsxs(Dxe, { autoComplete: "off", onSubmit: _, children: [
    A,
    T,
    O,
    R,
    M,
    P,
    z,
    F,
    $
  ] }), t[26] = M, t[27] = z, t[28] = F, t[29] = _, t[30] = R, t[31] = G) : G = t[31], G;
};
function Ixe(t) {
  eQ(new Blob([`ssid=${t.id}
password=${t.p}`], {
    type: "text/plain"
  }), "credentials.txt");
}
function kxe(t) {
  return /* @__PURE__ */ C.jsx("option", { value: t.id, children: t.name }, t.id);
}
function jxe() {
  window.location.href = "/";
}
const Pxe = Re.div`
  twd-my-4
`, Lxe = () => {
  const t = ve.c(1);
  KW("Generate credentials for wifi adapter");
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ C.jsx(JW, { $hasGutterOnMobile: !0, children: /* @__PURE__ */ C.jsx(Pxe, { children: /* @__PURE__ */ C.jsx(Mxe, {}) }) }), t[0] = e) : e = t[0], e;
}, kGe = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ C.jsx(Lxe, {}), t[0] = e) : e = t[0], e;
}, WI = Dg({
  D: "D",
  D2: "D2",
  D3: "D3",
  D4: "D4"
});
WI.enum;
const QI = Fi.array(Fi.object({
  id: Fi.string(),
  time: Fi.number().nonnegative().finite(),
  fractions: Fi.tuple([Fi.number(), Fi.number()])
})), KE = 0.1, Bxe = () => [{
  time: 0,
  position: 1
}];
var K5 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "MethodFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "methods" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "runTimeMin" }, name: { kind: "Name", value: "run_time_min" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "injectionSec" }, name: { kind: "Name", value: "injection_sec" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "shakingDurationSec" }, name: { kind: "Name", value: "shaking_duration_sec" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "comment" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "pressureReachSec" }, name: { kind: "Name", value: "pressure_reach_sec" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "gradient" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "flowRateMlPerMin" }, name: { kind: "Name", value: "flow_rate_ml_per_min" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "solvents" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "pressureMin" }, name: { kind: "Name", value: "pressure_min" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "injectionUl" }, name: { kind: "Name", value: "injection_ul" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "needleDepthMm" }, name: { kind: "Name", value: "needle_depth_mm" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "syringeRefillSpeed" }, name: { kind: "Name", value: "syringe_refill_speed" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "analogSignalType" }, name: { kind: "Name", value: "analog_signal_type" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "analogSignalDescription" }, name: { kind: "Name", value: "analog_signal_description" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "refillFlowRateMlPerMin" }, name: { kind: "Name", value: "refill_flow_rate_ml_per_min" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "washAfterInjection" }, name: { kind: "Name", value: "wash_after_injection" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "washAfterInjectionVial" }, name: { kind: "Name", value: "wash_after_injection_vial" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "washAfterInjectionTimeSec" }, name: { kind: "Name", value: "wash_after_injection_time_sec" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "reportEmails" }, name: { kind: "Name", value: "report_emails" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "detectorSingleChannel" }, name: { kind: "Name", value: "detector_single_channel" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "isArchived" }, name: { kind: "Name", value: "archived" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "isFavorite" }, name: { kind: "Name", value: "favorite" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "isEditable" }, name: { kind: "Name", value: "editable" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "calibrationDelaySec" }, name: { kind: "Name", value: "calibration_delay_sec" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "valvePositionPlan" }, name: { kind: "Name", value: "valve_position_plan" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "hardwareConfiguration" }, name: { kind: "Name", value: "hardware_configuration" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "is_advanced_mode" }, arguments: [], directives: [] }] } }], loc: { start: 0, end: 1351 } };
K5.loc.source = { body: `fragment MethodFragment on methods {
    id
    name
    runTimeMin: run_time_min
    injectionSec: injection_sec
    shakingDurationSec: shaking_duration_sec
    comment
    pressureReachSec: pressure_reach_sec
    gradient
    flowRateMlPerMin: flow_rate_ml_per_min
    solvents
    pressureMin: pressure_min
    injectionUl: injection_ul
    needleDepthMm: needle_depth_mm
    syringeRefillSpeed: syringe_refill_speed
    #        TODO changed after postprocessing
    #  shakingMode: shaking_mode
    #  defaultMeasurement: default_measurement
    #  detectionTimeStartSec: detection_time_start_sec
    #  detectionTimeEndSec: detection_time_end_sec
    analogSignalType: analog_signal_type
    analogSignalDescription: analog_signal_description
    refillFlowRateMlPerMin: refill_flow_rate_ml_per_min
    washAfterInjection: wash_after_injection
    washAfterInjectionVial: wash_after_injection_vial
    washAfterInjectionTimeSec: wash_after_injection_time_sec
    #  autoBaseline: auto_baseline
    #  autoPeaks: auto_peaks
    reportEmails: report_emails
    detectorSingleChannel: detector_single_channel
    isArchived: archived
    isFavorite: favorite
    isEditable: editable
    calibrationDelaySec: calibration_delay_sec
    valvePositionPlan: valve_position_plan
    hardwareConfiguration: hardware_configuration
    is_advanced_mode
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function S4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    S4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    S4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    S4(r, e);
  });
}
var X8 = {};
(function() {
  K5.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      S4(e, n), X8[e.name.value] = n;
    }
  });
})();
function Mz(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function zxe(t, e) {
  var n = {
    kind: t.kind,
    definitions: [Mz(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = X8[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = X8[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = Mz(t, c);
    d && n.definitions.push(d);
  }), n;
}
zxe(K5, "MethodFragment");
var JE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "MethodQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "methodId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "method" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "methodId" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "MethodFragment" }, directives: [] }] } }] } }], loc: { start: 0, end: 138 } };
JE.loc.source = { body: `#import "../fragments/MethodFragment.graphql"

query MethodQuery($methodId: Int!) {
  method(id: $methodId) {
    ...MethodFragment
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
var Iz = {};
function Fxe(t) {
  return t.filter(
    function(e) {
      if (e.kind !== "FragmentDefinition")
        return !0;
      var n = e.name.value;
      return Iz[n] ? !1 : (Iz[n] = !0, !0);
    }
  );
}
JE.definitions = JE.definitions.concat(Fxe(K5.definitions));
function E4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    E4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    E4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    E4(r, e);
  });
}
var W8 = {};
(function() {
  JE.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      E4(e, n), W8[e.name.value] = n;
    }
  });
})();
function kz(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function Vxe(t, e) {
  var n = {
    kind: t.kind,
    definitions: [kz(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = W8[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = W8[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = kz(t, c);
    d && n.definitions.push(d);
  }), n;
}
const tQ = Vxe(JE, "MethodQuery");
var ZI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "subscription", name: { kind: "Name", value: "MethodWithNameList" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "where" } }, type: { kind: "NamedType", name: { kind: "Name", value: "methods_bool_exp" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }, defaultValue: { kind: "IntValue", value: "20" }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "methods" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "where" }, value: { kind: "Variable", name: { kind: "Name", value: "where" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "order_by" }, value: { kind: "ListValue", values: [{ kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "favorite" }, value: { kind: "EnumValue", value: "desc" } }] }, { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "EnumValue", value: "desc" } }] }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "isFavorite" }, name: { kind: "Name", value: "favorite" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 213 } };
ZI.loc.source = { body: `subscription MethodWithNameList($where: methods_bool_exp, $limit: Int = 20) {
  methods(where: $where, limit: $limit, order_by: [{ favorite: desc }, { id: desc }]) {
    id
    name
    isFavorite: favorite
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function _4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    _4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    _4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    _4(r, e);
  });
}
var Q8 = {};
(function() {
  ZI.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      _4(e, n), Q8[e.name.value] = n;
    }
  });
})();
function jz(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function Uxe(t, e) {
  var n = {
    kind: t.kind,
    definitions: [jz(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = Q8[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = Q8[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = jz(t, c);
    d && n.definitions.push(d);
  }), n;
}
const $xe = Uxe(ZI, "MethodWithNameList"), Hxe = (t) => {
  const e = t.trim();
  if (!e)
    return;
  const n = Number(e), r = Number.isInteger(n) && n > 0 ? n : void 0;
  return {
    _or: [{
      name: {
        _ilike: `%${e}%`
      }
    }, ...r != null ? [{
      id: {
        _eq: r
      }
    }] : []]
  };
}, qxe = "methodWithNameList", Gxe = 20, nQ = {
  getMethod(t) {
    return lo.httpClientForHasura.fetch(tQ, {
      methodId: t
    });
  },
  useSubscriptionToMethodWithNameList(t) {
    return Q5(qxe, $xe, {
      limit: Gxe,
      where: Hxe(t)
    });
  }
}, Yxe = Xe({
  id: Ve(),
  name: Je().nullable(),
  isFavorite: Sr()
}), Xxe = Xr(Yxe), Wxe = (t) => {
  const e = ve.c(7), n = t === void 0 ? "" : t, {
    data: r,
    isLoading: i,
    isFetching: a,
    error: s
  } = nQ.useSubscriptionToMethodWithNameList(n), c = r?.methods;
  let d;
  e[0] !== c ? (d = c ? qt(Xxe, c) : void 0, e[0] = c, e[1] = d) : d = e[1];
  const g = d ?? null, m = s ?? null;
  let b;
  return e[2] !== a || e[3] !== i || e[4] !== g || e[5] !== m ? (b = {
    data: g,
    isLoading: i,
    isFetching: a,
    error: m
  }, e[2] = a, e[3] = i, e[4] = g, e[5] = m, e[6] = b) : b = e[6], b;
}, rQ = Fi.nativeEnum({
  ALLTESTA: "ALLTESTA",
  CROMITE: "CROMITE"
}), Bb = rQ.enum, Y0 = {
  excludedFromCamelizationKeys: ["D", "D2", "D3", "D4"]
}, zC = Fi.object({
  name: Fi.string(),
  version: Fi.coerce.number()
}), Qxe = Fi.object({
  pump: Fi.array(zC),
  valve: Fi.array(zC),
  detector: Fi.array(zC.extend({
    channels: Fi.object({
      D: Fi.number().nullable(),
      D2: Fi.number().nullable(),
      D3: Fi.number().nullable(),
      D4: Fi.number().nullable()
    }).optional()
  })),
  autosampler: Fi.array(zC),
  deviceType: rQ
}), iQ = Fi.tuple([]), J5 = Fi.union([Qxe, iQ]), aQ = (t) => iQ.safeParse(t).success, fw = (t) => {
  if (aQ(t))
    return {
      pumpCount: 2,
      hasGradient: !0,
      hasDetector: !0,
      hasValve: !0,
      isValvePositionPlanSupported: !0,
      hasAutosampler: !0,
      deviceType: Bb.ALLTESTA
    };
  const e = t.pump.length > 0 ? t.pump.length : 1, n = t.valve.length > 0, r = t.detector[0];
  return {
    pumpCount: e,
    hasGradient: e > 1,
    hasDetector: r != null && (r.channels == null || Object.values(r.channels).some((i) => i != null)),
    hasValve: n,
    isValvePositionPlanSupported: n && t.deviceType !== Bb.CROMITE,
    hasAutosampler: t.autosampler.length > 0,
    deviceType: t.deviceType
  };
}, oQ = yM([zE(1), zE(2)]), Zxe = Xe({
  time: Ve().nonnegative().finite(),
  position: oQ
}), KI = Xr(Zxe), Pz = Xe({
  name: Je().nullable().optional()
}), Kxe = Xe({
  a: Pz.optional(),
  b: Pz.optional()
}).transform((t) => ({
  a: {
    name: t.a?.name ?? null
  },
  b: {
    name: t.b?.name ?? null
  }
})), N_ = Xe({
  id: Ve(),
  // TODO Can be nullable? I found an injection. The example injection was created with this method
  name: Je().nullable(),
  isArchived: Sr(),
  isFavorite: Sr(),
  isEditable: Sr(),
  runTimeMin: Ve(),
  shakingDurationSec: Ve().nullable(),
  comment: Je().nullable(),
  gradient: QI.nullable(),
  flowRateMlPerMin: Ve(),
  solvents: Kxe.nullable().optional().transform((t) => t ?? null),
  pressureMin: Ve().nullable(),
  injectionUl: Ve(),
  needleDepthMm: Ve().nullable(),
  syringeRefillSpeed: Ve().nullable(),
  calibrationDelaySec: Ve().nullable(),
  refillFlowRateMlPerMin: Ve().nullable(),
  washAfterInjection: Sr().nullable(),
  washAfterInjectionVial: Ve().nullable(),
  washAfterInjectionTimeSec: Ve().nullable(),
  valvePositionPlan: KI.nullable().optional().transform((t) => t ?? null),
  detectorSingleChannel: WI.nullable(),
  pressureReachSec: Ve().nullable(),
  hardwareConfiguration: J5,
  isAdvancedMode: Sr()
}), Jxe = "Method", eSe = (t) => {
  const e = ve.c(15);
  let n, r;
  e[0] !== t ? (n = [Jxe, t], r = async () => {
    if (t == null)
      throw new Error("Method id should be defined!");
    return await lo.httpClientForHasura.fetch(tQ, {
      methodId: t
    });
  }, e[0] = t, e[1] = n, e[2] = r) : (n = e[1], r = e[2]);
  const i = t != null;
  let a;
  e[3] !== n || e[4] !== r || e[5] !== i ? (a = {
    queryKey: n,
    queryFn: r,
    enabled: i
  }, e[3] = n, e[4] = r, e[5] = i, e[6] = a) : a = e[6];
  const {
    data: s,
    isLoading: c,
    error: d,
    fetchStatus: f,
    refetch: g
  } = kh(a);
  let m;
  e[7] !== s ? (m = s?.method ? qt(N_, s.method, Y0) : null, e[7] = s, e[8] = m) : m = e[8];
  const b = m, w = f === "idle", _ = d ?? null;
  let A;
  return e[9] !== c || e[10] !== b || e[11] !== g || e[12] !== w || e[13] !== _ ? (A = {
    data: b,
    isLoading: c,
    isIdle: w,
    error: _,
    refetch: g
  }, e[9] = c, e[10] = b, e[11] = g, e[12] = w, e[13] = _, e[14] = A) : A = e[14], A;
}, tSe = 200, sQ = (t) => {
  const e = ve.c(9), {
    method: n,
    isSelected: r
  } = t;
  let i;
  e[0] !== r || e[1] !== n.isFavorite ? (i = n.isFavorite && /* @__PURE__ */ C.jsx(wI, { className: `twd-mr-1 ${r ? "twd-text-white" : "twd-text-primary"}` }), e[0] = r, e[1] = n.isFavorite, e[2] = i) : i = e[2];
  const a = r ? "twd-text-white" : "";
  let s;
  e[3] !== n.id || e[4] !== a ? (s = /* @__PURE__ */ C.jsx(PI, { id: n.id, className: a }), e[3] = n.id, e[4] = a, e[5] = s) : s = e[5];
  let c;
  return e[6] !== i || e[7] !== s ? (c = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    i,
    s
  ] }), e[6] = i, e[7] = s, e[8] = c) : c = e[8], c;
}, nSe = I.forwardRef((t, e) => {
  const n = ve.c(38), {
    methodId: r,
    onOpen: i,
    onClose: a,
    onChange: s,
    className: c,
    error: d,
    label: f,
    isDisabled: g,
    placeholder: m
  } = t, b = m === void 0 ? "Search method" : m, [w, _] = I.useState(""), [A, T] = I.useState(w);
  let O;
  n[0] !== w ? (O = () => {
    T(w);
  }, n[0] = w, n[1] = O) : O = n[1];
  let R;
  n[2] !== w ? (R = [w], n[2] = w, n[3] = R) : R = n[3], yxe(O, tSe, R);
  const {
    data: N,
    isLoading: M,
    isFetching: P
  } = Wxe(A), {
    data: z
  } = eSe(r);
  let F;
  n[4] !== A || n[5] !== w ? (F = w.trim().length > 0 || A.trim().length > 0, n[4] = A, n[5] = w, n[6] = F) : F = n[6];
  const H = w !== A || F && (M || !!P);
  let Z;
  n[7] !== N ? (Z = N ?? [], n[7] = N, n[8] = Z) : Z = n[8];
  let V;
  n[9] !== Z ? (V = Z.map(rSe), n[9] = Z, n[10] = V) : V = n[10];
  const Y = V;
  let ee;
  e: {
    if (!z) {
      ee = null;
      break e;
    }
    const le = z.name ?? `Unnamed method #${z.id}`;
    let de;
    n[11] !== z.id || n[12] !== z.isFavorite || n[13] !== le ? (de = {
      id: z.id,
      name: le,
      isFavorite: z.isFavorite
    }, n[11] = z.id, n[12] = z.isFavorite, n[13] = le, n[14] = de) : de = n[14], ee = de;
  }
  const K = ee;
  let U;
  n[15] !== r || n[16] !== Y || n[17] !== K ? (U = Y.find((le) => le.id === r) ?? K ?? null, n[15] = r, n[16] = Y, n[17] = K, n[18] = U) : U = n[18];
  const q = U;
  let W;
  e: {
    if (!K || Y.some((de) => de.id === K.id)) {
      W = Y;
      break e;
    }
    let le;
    n[19] !== Y || n[20] !== K ? (le = [K, ...Y], n[19] = Y, n[20] = K, n[21] = le) : le = n[21], W = le;
  }
  const ie = W, J = I.useRef(null);
  let B;
  n[22] === Symbol.for("react.memo_cache_sentinel") ? (B = () => ({
    focusInput: () => {
      J.current?.focusInput();
    }
  }), n[22] = B) : B = n[22], I.useImperativeHandle(e, B);
  let te;
  n[23] !== s || n[24] !== a ? (te = (le) => {
    s(le.id), a?.();
  }, n[23] = s, n[24] = a, n[25] = te) : te = n[25];
  let ae;
  return n[26] !== c || n[27] !== d || n[28] !== g || n[29] !== H || n[30] !== f || n[31] !== ie || n[32] !== a || n[33] !== i || n[34] !== b || n[35] !== q || n[36] !== te ? (ae = /* @__PURE__ */ C.jsx(Dye, { value: q, items: ie, labelProp: "name", onSearchValueChange: _, isLoading: H, loadingMessage: "Loading methods", filterFn: iSe, onChange: te, placeholder: b, error: d, onOpen: i, onClose: a, className: c, label: f, isDisabled: g, asideSelectedLabel: aSe, asideItemLabel: oSe, ref: J }), n[26] = c, n[27] = d, n[28] = g, n[29] = H, n[30] = f, n[31] = ie, n[32] = a, n[33] = i, n[34] = b, n[35] = q, n[36] = te, n[37] = ae) : ae = n[37], ae;
});
function rSe(t) {
  return {
    ...t,
    name: t.name ?? `Unnamed method #${t.id}`
  };
}
function iSe(t, e, n) {
  const r = e.trim().toLowerCase();
  if (!r || n(t).toLowerCase().includes(r))
    return !0;
  const i = Number(r);
  return Number.isInteger(i) && i > 0 && t.id === i;
}
function aSe(t) {
  return /* @__PURE__ */ C.jsx(sQ, { method: t });
}
function oSe(t, e) {
  return /* @__PURE__ */ C.jsx(sQ, { method: t, isSelected: e });
}
const Lz = Xe({
  name: Je().nullable(),
  sielcSolventId: Ve(),
  type: Je()
}), sSe = Xe({
  a: Lz,
  b: Lz
}), lSe = async (t) => {
  const e = await nQ.getMethod(t);
  if (!e.method)
    throw new Error("Method not found!");
  return qt(N_, e.method, Y0);
}, lQ = N_.omit({
  isArchived: !0,
  isFavorite: !0,
  isEditable: !0
}).extend({
  archived: Sr(),
  favorite: Sr(),
  editable: Sr()
}).transform((t) => ({
  ...t,
  // Преобразуем обратно в формат Method (с префиксом is)
  isArchived: t.archived,
  isFavorite: t.favorite,
  isEditable: t.editable
})), cQ = Dg({
  ALL: "",
  D: "D",
  // Red channel
  D2: "D2",
  // Green channel
  D3: "D3",
  // Blue channel
  D4: "D4"
  // UV channel
}), JI = cQ.enum, uQ = Xe({
  deviceId: Je().optional(),
  name: Je(),
  runTimeMin: Ve(),
  injectionSec: Ve(),
  shakingDurationSec: Ve().nullable(),
  comment: Je().nullable(),
  flowRateMlPerMin: Ve(),
  refillFlowRateMlPerMin: Ve(),
  pressureMin: Ve().nullable(),
  injectionUl: Ve(),
  needleDepthMm: Ve().nullable(),
  washAfterInjection: Sr(),
  washAfterInjectionVial: Ve().nullable(),
  washAfterInjectionTimeSec: Ve().nullable(),
  syringeRefillSpeed: Ve().nullable(),
  calibrationDelaySec: Ve().nullable(),
  valvePositionPlan: KI.nullable(),
  detectorSingleChannel: WI.nullable(),
  solvents: sSe.nullable(),
  gradient: QI,
  fractionCollectorIntervalSec: r8(),
  fractionCollectorStartDelaySec: r8(),
  pressureReachSec: Ve().nullable(),
  hardwareConfiguration: J5,
  isAdvancedMode: Sr()
}), b0 = (t) => typeof t == "string" && t.length === 0 ? null : Number(t), Q6 = (t, e, n) => {
  const r = b0(t.washAfterInjectionVial), {
    isValvePositionPlanSupported: i
  } = fw(e);
  return {
    deviceId: n,
    name: t.name.trim(),
    comment: t.comment.trim(),
    detectorSingleChannel: t.detectorSingleChannel === JI.ALL ? null : t.detectorSingleChannel,
    flowRateMlPerMin: Number(t.flowRateMlPerMin),
    gradient: t.gradient,
    injectionUl: Number(t.injectionUl),
    needleDepthMm: b0(t.needleDepthMm),
    pressureMin: b0(t.pressureMin),
    refillFlowRateMlPerMin: Number(t.refillFlowRateMlPerMin),
    runTimeMin: Number(t.runTimeMin),
    injectionSec: Number(t.runTimeMin) * ale,
    shakingDurationSec: b0(t.shakingDurationSec),
    syringeRefillSpeed: b0(t.syringeRefillSpeed),
    washAfterInjection: r != null,
    washAfterInjectionVial: r,
    washAfterInjectionTimeSec: b0(t.washAfterInjectionTimeSec),
    calibrationDelaySec: b0(t.calibrationDelaySec),
    valvePositionPlan: i ? t.valvePositionPlan : null,
    solvents: {
      a: {
        name: t.solventA ?? null,
        sielcSolventId: 111,
        type: "type_stub"
      },
      b: {
        name: t.solventB ?? null,
        sielcSolventId: 111,
        type: "type_stub"
      }
    },
    fractionCollectorIntervalSec: null,
    fractionCollectorStartDelaySec: null,
    pressureReachSec: b0(t.pressureReachSec),
    hardwareConfiguration: e,
    isAdvancedMode: t.isAdvancedMode ?? !1
  };
}, dQ = uQ.pick({
  injectionUl: !0,
  runTimeMin: !0
}).partial();
function cSe() {
  this.__data__ = [], this.size = 0;
}
var uSe = cSe;
function dSe(t, e) {
  return t === e || t !== t && e !== e;
}
var fQ = dSe, fSe = fQ;
function hSe(t, e) {
  for (var n = t.length; n--; )
    if (fSe(t[n][0], e))
      return n;
  return -1;
}
var eO = hSe, pSe = eO, mSe = Array.prototype, gSe = mSe.splice;
function vSe(t) {
  var e = this.__data__, n = pSe(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : gSe.call(e, n, 1), --this.size, !0;
}
var ySe = vSe, bSe = eO;
function wSe(t) {
  var e = this.__data__, n = bSe(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var xSe = wSe, SSe = eO;
function ESe(t) {
  return SSe(this.__data__, t) > -1;
}
var _Se = ESe, ASe = eO;
function CSe(t, e) {
  var n = this.__data__, r = ASe(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
var TSe = CSe, OSe = uSe, RSe = ySe, DSe = xSe, NSe = _Se, MSe = TSe;
function hw(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
hw.prototype.clear = OSe;
hw.prototype.delete = RSe;
hw.prototype.get = DSe;
hw.prototype.has = NSe;
hw.prototype.set = MSe;
var tO = hw, ISe = tO;
function kSe() {
  this.__data__ = new ISe(), this.size = 0;
}
var jSe = kSe;
function PSe(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var LSe = PSe;
function BSe(t) {
  return this.__data__.get(t);
}
var zSe = BSe;
function FSe(t) {
  return this.__data__.has(t);
}
var VSe = FSe, USe = typeof mC == "object" && mC && mC.Object === Object && mC, hQ = USe, $Se = hQ, HSe = typeof self == "object" && self && self.Object === Object && self, qSe = $Se || HSe || Function("return this")(), uf = qSe, GSe = uf, YSe = GSe.Symbol, e7 = YSe, Bz = e7, pQ = Object.prototype, XSe = pQ.hasOwnProperty, WSe = pQ.toString, zS = Bz ? Bz.toStringTag : void 0;
function QSe(t) {
  var e = XSe.call(t, zS), n = t[zS];
  try {
    t[zS] = void 0;
    var r = !0;
  } catch {
  }
  var i = WSe.call(t);
  return r && (e ? t[zS] = n : delete t[zS]), i;
}
var ZSe = QSe, KSe = Object.prototype, JSe = KSe.toString;
function eEe(t) {
  return JSe.call(t);
}
var tEe = eEe, zz = e7, nEe = ZSe, rEe = tEe, iEe = "[object Null]", aEe = "[object Undefined]", Fz = zz ? zz.toStringTag : void 0;
function oEe(t) {
  return t == null ? t === void 0 ? aEe : iEe : Fz && Fz in Object(t) ? nEe(t) : rEe(t);
}
var nO = oEe;
function sEe(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var M_ = sEe, lEe = nO, cEe = M_, uEe = "[object AsyncFunction]", dEe = "[object Function]", fEe = "[object GeneratorFunction]", hEe = "[object Proxy]";
function pEe(t) {
  if (!cEe(t))
    return !1;
  var e = lEe(t);
  return e == dEe || e == fEe || e == uEe || e == hEe;
}
var mQ = pEe, mEe = uf, gEe = mEe["__core-js_shared__"], vEe = gEe, Z6 = vEe, Vz = function() {
  var t = /[^.]+$/.exec(Z6 && Z6.keys && Z6.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function yEe(t) {
  return !!Vz && Vz in t;
}
var bEe = yEe, wEe = Function.prototype, xEe = wEe.toString;
function SEe(t) {
  if (t != null) {
    try {
      return xEe.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var gQ = SEe, EEe = mQ, _Ee = bEe, AEe = M_, CEe = gQ, TEe = /[\\^$.*+?()[\]{}|]/g, OEe = /^\[object .+?Constructor\]$/, REe = Function.prototype, DEe = Object.prototype, NEe = REe.toString, MEe = DEe.hasOwnProperty, IEe = RegExp(
  "^" + NEe.call(MEe).replace(TEe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function kEe(t) {
  if (!AEe(t) || _Ee(t))
    return !1;
  var e = EEe(t) ? IEe : OEe;
  return e.test(CEe(t));
}
var jEe = kEe;
function PEe(t, e) {
  return t?.[e];
}
var LEe = PEe, BEe = jEe, zEe = LEe;
function FEe(t, e) {
  var n = zEe(t, e);
  return BEe(n) ? n : void 0;
}
var zg = FEe, VEe = zg, UEe = uf, $Ee = VEe(UEe, "Map"), t7 = $Ee, HEe = zg, qEe = HEe(Object, "create"), rO = qEe, Uz = rO;
function GEe() {
  this.__data__ = Uz ? Uz(null) : {}, this.size = 0;
}
var YEe = GEe;
function XEe(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var WEe = XEe, QEe = rO, ZEe = "__lodash_hash_undefined__", KEe = Object.prototype, JEe = KEe.hasOwnProperty;
function e_e(t) {
  var e = this.__data__;
  if (QEe) {
    var n = e[t];
    return n === ZEe ? void 0 : n;
  }
  return JEe.call(e, t) ? e[t] : void 0;
}
var t_e = e_e, n_e = rO, r_e = Object.prototype, i_e = r_e.hasOwnProperty;
function a_e(t) {
  var e = this.__data__;
  return n_e ? e[t] !== void 0 : i_e.call(e, t);
}
var o_e = a_e, s_e = rO, l_e = "__lodash_hash_undefined__";
function c_e(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = s_e && e === void 0 ? l_e : e, this;
}
var u_e = c_e, d_e = YEe, f_e = WEe, h_e = t_e, p_e = o_e, m_e = u_e;
function pw(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
pw.prototype.clear = d_e;
pw.prototype.delete = f_e;
pw.prototype.get = h_e;
pw.prototype.has = p_e;
pw.prototype.set = m_e;
var g_e = pw, $z = g_e, v_e = tO, y_e = t7;
function b_e() {
  this.size = 0, this.__data__ = {
    hash: new $z(),
    map: new (y_e || v_e)(),
    string: new $z()
  };
}
var w_e = b_e;
function x_e(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var S_e = x_e, E_e = S_e;
function __e(t, e) {
  var n = t.__data__;
  return E_e(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var iO = __e, A_e = iO;
function C_e(t) {
  var e = A_e(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var T_e = C_e, O_e = iO;
function R_e(t) {
  return O_e(this, t).get(t);
}
var D_e = R_e, N_e = iO;
function M_e(t) {
  return N_e(this, t).has(t);
}
var I_e = M_e, k_e = iO;
function j_e(t, e) {
  var n = k_e(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
var P_e = j_e, L_e = w_e, B_e = T_e, z_e = D_e, F_e = I_e, V_e = P_e;
function mw(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
mw.prototype.clear = L_e;
mw.prototype.delete = B_e;
mw.prototype.get = z_e;
mw.prototype.has = F_e;
mw.prototype.set = V_e;
var vQ = mw, U_e = tO, $_e = t7, H_e = vQ, q_e = 200;
function G_e(t, e) {
  var n = this.__data__;
  if (n instanceof U_e) {
    var r = n.__data__;
    if (!$_e || r.length < q_e - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new H_e(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
var Y_e = G_e, X_e = tO, W_e = jSe, Q_e = LSe, Z_e = zSe, K_e = VSe, J_e = Y_e;
function gw(t) {
  var e = this.__data__ = new X_e(t);
  this.size = e.size;
}
gw.prototype.clear = W_e;
gw.prototype.delete = Q_e;
gw.prototype.get = Z_e;
gw.prototype.has = K_e;
gw.prototype.set = J_e;
var e3e = gw;
function t3e(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var n3e = t3e, r3e = zg, i3e = function() {
  try {
    var t = r3e(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), a3e = i3e, Hz = a3e;
function o3e(t, e, n) {
  e == "__proto__" && Hz ? Hz(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var yQ = o3e, s3e = yQ, l3e = fQ, c3e = Object.prototype, u3e = c3e.hasOwnProperty;
function d3e(t, e, n) {
  var r = t[e];
  (!(u3e.call(t, e) && l3e(r, n)) || n === void 0 && !(e in t)) && s3e(t, e, n);
}
var bQ = d3e, f3e = bQ, h3e = yQ;
function p3e(t, e, n, r) {
  var i = !n;
  n || (n = {});
  for (var a = -1, s = e.length; ++a < s; ) {
    var c = e[a], d = r ? r(n[c], t[c], c, n, t) : void 0;
    d === void 0 && (d = t[c]), i ? h3e(n, c, d) : f3e(n, c, d);
  }
  return n;
}
var aO = p3e;
function m3e(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var g3e = m3e;
function v3e(t) {
  return t != null && typeof t == "object";
}
var I_ = v3e, y3e = nO, b3e = I_, w3e = "[object Arguments]";
function x3e(t) {
  return b3e(t) && y3e(t) == w3e;
}
var S3e = x3e, qz = S3e, E3e = I_, wQ = Object.prototype, _3e = wQ.hasOwnProperty, A3e = wQ.propertyIsEnumerable, C3e = qz(function() {
  return arguments;
}()) ? qz : function(t) {
  return E3e(t) && _3e.call(t, "callee") && !A3e.call(t, "callee");
}, T3e = C3e, O3e = Array.isArray, n7 = O3e, XT = { exports: {} };
function R3e() {
  return !1;
}
var D3e = R3e;
XT.exports;
(function(t, e) {
  var n = uf, r = D3e, i = e && !e.nodeType && e, a = i && !0 && t && !t.nodeType && t, s = a && a.exports === i, c = s ? n.Buffer : void 0, d = c ? c.isBuffer : void 0, f = d || r;
  t.exports = f;
})(XT, XT.exports);
var xQ = XT.exports, N3e = 9007199254740991, M3e = /^(?:0|[1-9]\d*)$/;
function I3e(t, e) {
  var n = typeof t;
  return e = e ?? N3e, !!e && (n == "number" || n != "symbol" && M3e.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var k3e = I3e, j3e = 9007199254740991;
function P3e(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= j3e;
}
var SQ = P3e, L3e = nO, B3e = SQ, z3e = I_, F3e = "[object Arguments]", V3e = "[object Array]", U3e = "[object Boolean]", $3e = "[object Date]", H3e = "[object Error]", q3e = "[object Function]", G3e = "[object Map]", Y3e = "[object Number]", X3e = "[object Object]", W3e = "[object RegExp]", Q3e = "[object Set]", Z3e = "[object String]", K3e = "[object WeakMap]", J3e = "[object ArrayBuffer]", eAe = "[object DataView]", tAe = "[object Float32Array]", nAe = "[object Float64Array]", rAe = "[object Int8Array]", iAe = "[object Int16Array]", aAe = "[object Int32Array]", oAe = "[object Uint8Array]", sAe = "[object Uint8ClampedArray]", lAe = "[object Uint16Array]", cAe = "[object Uint32Array]", gi = {};
gi[tAe] = gi[nAe] = gi[rAe] = gi[iAe] = gi[aAe] = gi[oAe] = gi[sAe] = gi[lAe] = gi[cAe] = !0;
gi[F3e] = gi[V3e] = gi[J3e] = gi[U3e] = gi[eAe] = gi[$3e] = gi[H3e] = gi[q3e] = gi[G3e] = gi[Y3e] = gi[X3e] = gi[W3e] = gi[Q3e] = gi[Z3e] = gi[K3e] = !1;
function uAe(t) {
  return z3e(t) && B3e(t.length) && !!gi[L3e(t)];
}
var dAe = uAe;
function fAe(t) {
  return function(e) {
    return t(e);
  };
}
var r7 = fAe, WT = { exports: {} };
WT.exports;
(function(t, e) {
  var n = hQ, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, a = i && i.exports === r, s = a && n.process, c = function() {
    try {
      var d = i && i.require && i.require("util").types;
      return d || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  t.exports = c;
})(WT, WT.exports);
var i7 = WT.exports, hAe = dAe, pAe = r7, Gz = i7, Yz = Gz && Gz.isTypedArray, mAe = Yz ? pAe(Yz) : hAe, gAe = mAe, vAe = g3e, yAe = T3e, bAe = n7, wAe = xQ, xAe = k3e, SAe = gAe, EAe = Object.prototype, _Ae = EAe.hasOwnProperty;
function AAe(t, e) {
  var n = bAe(t), r = !n && yAe(t), i = !n && !r && wAe(t), a = !n && !r && !i && SAe(t), s = n || r || i || a, c = s ? vAe(t.length, String) : [], d = c.length;
  for (var f in t)
    (e || _Ae.call(t, f)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    xAe(f, d))) && c.push(f);
  return c;
}
var EQ = AAe, CAe = Object.prototype;
function TAe(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || CAe;
  return t === n;
}
var a7 = TAe;
function OAe(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var _Q = OAe, RAe = _Q, DAe = RAe(Object.keys, Object), NAe = DAe, MAe = a7, IAe = NAe, kAe = Object.prototype, jAe = kAe.hasOwnProperty;
function PAe(t) {
  if (!MAe(t))
    return IAe(t);
  var e = [];
  for (var n in Object(t))
    jAe.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var LAe = PAe, BAe = mQ, zAe = SQ;
function FAe(t) {
  return t != null && zAe(t.length) && !BAe(t);
}
var AQ = FAe, VAe = EQ, UAe = LAe, $Ae = AQ;
function HAe(t) {
  return $Ae(t) ? VAe(t) : UAe(t);
}
var o7 = HAe, qAe = aO, GAe = o7;
function YAe(t, e) {
  return t && qAe(e, GAe(e), t);
}
var XAe = YAe;
function WAe(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var QAe = WAe, ZAe = M_, KAe = a7, JAe = QAe, eCe = Object.prototype, tCe = eCe.hasOwnProperty;
function nCe(t) {
  if (!ZAe(t))
    return JAe(t);
  var e = KAe(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !tCe.call(t, r)) || n.push(r);
  return n;
}
var rCe = nCe, iCe = EQ, aCe = rCe, oCe = AQ;
function sCe(t) {
  return oCe(t) ? iCe(t, !0) : aCe(t);
}
var s7 = sCe, lCe = aO, cCe = s7;
function uCe(t, e) {
  return t && lCe(e, cCe(e), t);
}
var dCe = uCe, QT = { exports: {} };
QT.exports;
(function(t, e) {
  var n = uf, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, a = i && i.exports === r, s = a ? n.Buffer : void 0, c = s ? s.allocUnsafe : void 0;
  function d(f, g) {
    if (g)
      return f.slice();
    var m = f.length, b = c ? c(m) : new f.constructor(m);
    return f.copy(b), b;
  }
  t.exports = d;
})(QT, QT.exports);
var fCe = QT.exports;
function hCe(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var pCe = hCe;
function mCe(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, a = []; ++n < r; ) {
    var s = t[n];
    e(s, n, t) && (a[i++] = s);
  }
  return a;
}
var gCe = mCe;
function vCe() {
  return [];
}
var CQ = vCe, yCe = gCe, bCe = CQ, wCe = Object.prototype, xCe = wCe.propertyIsEnumerable, Xz = Object.getOwnPropertySymbols, SCe = Xz ? function(t) {
  return t == null ? [] : (t = Object(t), yCe(Xz(t), function(e) {
    return xCe.call(t, e);
  }));
} : bCe, l7 = SCe, ECe = aO, _Ce = l7;
function ACe(t, e) {
  return ECe(t, _Ce(t), e);
}
var CCe = ACe;
function TCe(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var TQ = TCe, OCe = _Q, RCe = OCe(Object.getPrototypeOf, Object), OQ = RCe, DCe = TQ, NCe = OQ, MCe = l7, ICe = CQ, kCe = Object.getOwnPropertySymbols, jCe = kCe ? function(t) {
  for (var e = []; t; )
    DCe(e, MCe(t)), t = NCe(t);
  return e;
} : ICe, RQ = jCe, PCe = aO, LCe = RQ;
function BCe(t, e) {
  return PCe(t, LCe(t), e);
}
var zCe = BCe, FCe = TQ, VCe = n7;
function UCe(t, e, n) {
  var r = e(t);
  return VCe(t) ? r : FCe(r, n(t));
}
var DQ = UCe, $Ce = DQ, HCe = l7, qCe = o7;
function GCe(t) {
  return $Ce(t, qCe, HCe);
}
var YCe = GCe, XCe = DQ, WCe = RQ, QCe = s7;
function ZCe(t) {
  return XCe(t, QCe, WCe);
}
var KCe = ZCe, JCe = zg, e4e = uf, t4e = JCe(e4e, "DataView"), n4e = t4e, r4e = zg, i4e = uf, a4e = r4e(i4e, "Promise"), o4e = a4e, s4e = zg, l4e = uf, c4e = s4e(l4e, "Set"), u4e = c4e, d4e = zg, f4e = uf, h4e = d4e(f4e, "WeakMap"), p4e = h4e, Z8 = n4e, K8 = t7, J8 = o4e, eN = u4e, tN = p4e, NQ = nO, vw = gQ, Wz = "[object Map]", m4e = "[object Object]", Qz = "[object Promise]", Zz = "[object Set]", Kz = "[object WeakMap]", Jz = "[object DataView]", g4e = vw(Z8), v4e = vw(K8), y4e = vw(J8), b4e = vw(eN), w4e = vw(tN), G1 = NQ;
(Z8 && G1(new Z8(new ArrayBuffer(1))) != Jz || K8 && G1(new K8()) != Wz || J8 && G1(J8.resolve()) != Qz || eN && G1(new eN()) != Zz || tN && G1(new tN()) != Kz) && (G1 = function(t) {
  var e = NQ(t), n = e == m4e ? t.constructor : void 0, r = n ? vw(n) : "";
  if (r)
    switch (r) {
      case g4e:
        return Jz;
      case v4e:
        return Wz;
      case y4e:
        return Qz;
      case b4e:
        return Zz;
      case w4e:
        return Kz;
    }
  return e;
});
var c7 = G1, x4e = Object.prototype, S4e = x4e.hasOwnProperty;
function E4e(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && S4e.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var _4e = E4e, A4e = uf, C4e = A4e.Uint8Array, T4e = C4e, eF = T4e;
function O4e(t) {
  var e = new t.constructor(t.byteLength);
  return new eF(e).set(new eF(t)), e;
}
var u7 = O4e, R4e = u7;
function D4e(t, e) {
  var n = e ? R4e(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var N4e = D4e, M4e = /\w*$/;
function I4e(t) {
  var e = new t.constructor(t.source, M4e.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var k4e = I4e, tF = e7, nF = tF ? tF.prototype : void 0, rF = nF ? nF.valueOf : void 0;
function j4e(t) {
  return rF ? Object(rF.call(t)) : {};
}
var P4e = j4e, L4e = u7;
function B4e(t, e) {
  var n = e ? L4e(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var z4e = B4e, F4e = u7, V4e = N4e, U4e = k4e, $4e = P4e, H4e = z4e, q4e = "[object Boolean]", G4e = "[object Date]", Y4e = "[object Map]", X4e = "[object Number]", W4e = "[object RegExp]", Q4e = "[object Set]", Z4e = "[object String]", K4e = "[object Symbol]", J4e = "[object ArrayBuffer]", eTe = "[object DataView]", tTe = "[object Float32Array]", nTe = "[object Float64Array]", rTe = "[object Int8Array]", iTe = "[object Int16Array]", aTe = "[object Int32Array]", oTe = "[object Uint8Array]", sTe = "[object Uint8ClampedArray]", lTe = "[object Uint16Array]", cTe = "[object Uint32Array]";
function uTe(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case J4e:
      return F4e(t);
    case q4e:
    case G4e:
      return new r(+t);
    case eTe:
      return V4e(t, n);
    case tTe:
    case nTe:
    case rTe:
    case iTe:
    case aTe:
    case oTe:
    case sTe:
    case lTe:
    case cTe:
      return H4e(t, n);
    case Y4e:
      return new r();
    case X4e:
    case Z4e:
      return new r(t);
    case W4e:
      return U4e(t);
    case Q4e:
      return new r();
    case K4e:
      return $4e(t);
  }
}
var dTe = uTe, fTe = M_, iF = Object.create, hTe = function() {
  function t() {
  }
  return function(e) {
    if (!fTe(e))
      return {};
    if (iF)
      return iF(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}(), pTe = hTe, mTe = pTe, gTe = OQ, vTe = a7;
function yTe(t) {
  return typeof t.constructor == "function" && !vTe(t) ? mTe(gTe(t)) : {};
}
var bTe = yTe, wTe = c7, xTe = I_, STe = "[object Map]";
function ETe(t) {
  return xTe(t) && wTe(t) == STe;
}
var _Te = ETe, ATe = _Te, CTe = r7, aF = i7, oF = aF && aF.isMap, TTe = oF ? CTe(oF) : ATe, OTe = TTe, RTe = c7, DTe = I_, NTe = "[object Set]";
function MTe(t) {
  return DTe(t) && RTe(t) == NTe;
}
var ITe = MTe, kTe = ITe, jTe = r7, sF = i7, lF = sF && sF.isSet, PTe = lF ? jTe(lF) : kTe, LTe = PTe, BTe = e3e, zTe = n3e, FTe = bQ, VTe = XAe, UTe = dCe, $Te = fCe, HTe = pCe, qTe = CCe, GTe = zCe, YTe = YCe, XTe = KCe, WTe = c7, QTe = _4e, ZTe = dTe, KTe = bTe, JTe = n7, e5e = xQ, t5e = OTe, n5e = M_, r5e = LTe, i5e = o7, a5e = s7, o5e = 1, s5e = 2, l5e = 4, MQ = "[object Arguments]", c5e = "[object Array]", u5e = "[object Boolean]", d5e = "[object Date]", f5e = "[object Error]", IQ = "[object Function]", h5e = "[object GeneratorFunction]", p5e = "[object Map]", m5e = "[object Number]", kQ = "[object Object]", g5e = "[object RegExp]", v5e = "[object Set]", y5e = "[object String]", b5e = "[object Symbol]", w5e = "[object WeakMap]", x5e = "[object ArrayBuffer]", S5e = "[object DataView]", E5e = "[object Float32Array]", _5e = "[object Float64Array]", A5e = "[object Int8Array]", C5e = "[object Int16Array]", T5e = "[object Int32Array]", O5e = "[object Uint8Array]", R5e = "[object Uint8ClampedArray]", D5e = "[object Uint16Array]", N5e = "[object Uint32Array]", oi = {};
oi[MQ] = oi[c5e] = oi[x5e] = oi[S5e] = oi[u5e] = oi[d5e] = oi[E5e] = oi[_5e] = oi[A5e] = oi[C5e] = oi[T5e] = oi[p5e] = oi[m5e] = oi[kQ] = oi[g5e] = oi[v5e] = oi[y5e] = oi[b5e] = oi[O5e] = oi[R5e] = oi[D5e] = oi[N5e] = !0;
oi[f5e] = oi[IQ] = oi[w5e] = !1;
function A4(t, e, n, r, i, a) {
  var s, c = e & o5e, d = e & s5e, f = e & l5e;
  if (n && (s = i ? n(t, r, i, a) : n(t)), s !== void 0)
    return s;
  if (!n5e(t))
    return t;
  var g = JTe(t);
  if (g) {
    if (s = QTe(t), !c)
      return HTe(t, s);
  } else {
    var m = WTe(t), b = m == IQ || m == h5e;
    if (e5e(t))
      return $Te(t, c);
    if (m == kQ || m == MQ || b && !i) {
      if (s = d || b ? {} : KTe(t), !c)
        return d ? GTe(t, UTe(s, t)) : qTe(t, VTe(s, t));
    } else {
      if (!oi[m])
        return i ? t : {};
      s = ZTe(t, m, c);
    }
  }
  a || (a = new BTe());
  var w = a.get(t);
  if (w)
    return w;
  a.set(t, s), r5e(t) ? t.forEach(function(T) {
    s.add(A4(T, e, n, T, t, a));
  }) : t5e(t) && t.forEach(function(T, O) {
    s.set(O, A4(T, e, n, O, t, a));
  });
  var _ = f ? d ? XTe : YTe : d ? a5e : i5e, A = g ? void 0 : _(t);
  return zTe(A || t, function(T, O) {
    A && (O = T, T = t[O]), FTe(s, O, A4(T, e, n, O, t, a));
  }), s;
}
var M5e = A4, I5e = M5e, k5e = 1, j5e = 4;
function P5e(t) {
  return I5e(t, k5e | j5e);
}
var L5e = P5e;
const cF = /* @__PURE__ */ J0(L5e), B5e = Dg({
  ALLTESTA_UVVIS_DETECTOR_1: "alltesta-uvvis-detector_1",
  ALLTESTA_UVVIS_DETECTOR_2: "alltesta-uvvis-detector_2",
  CROMITE_DETECTOR: "cromite-detector"
}), K6 = B5e.enum, uF = {
  D: 630,
  D2: 520,
  D3: 460,
  D4: 275
}, z5e = {
  D: 310,
  D2: 365,
  D3: 365,
  D4: 310
}, d7 = (t) => {
  if (Array.isArray(t))
    return uF;
  const e = t.detector[0];
  if (e?.channels != null)
    return Object.fromEntries(Object.entries(e.channels).filter(([, n]) => n != null));
  switch (e?.name) {
    case K6.ALLTESTA_UVVIS_DETECTOR_1:
    case K6.CROMITE_DETECTOR:
      return uF;
    case K6.ALLTESTA_UVVIS_DETECTOR_2:
      return z5e;
    default:
      return {};
  }
}, f7 = I.createContext({});
function h7(t) {
  const e = I.useRef(null);
  return e.current === null && (e.current = t()), e.current;
}
const oO = I.createContext(null), p7 = I.createContext({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
class F5e extends I.Component {
  getSnapshotBeforeUpdate(e) {
    const n = this.props.childRef.current;
    if (n && e.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function V5e({ children: t, isPresent: e }) {
  const n = I.useId(), r = I.useRef(null), i = I.useRef({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: a } = I.useContext(p7);
  return I.useInsertionEffect(() => {
    const { width: s, height: c, top: d, left: f } = i.current;
    if (e || !r.current || !s || !c)
      return;
    r.current.dataset.motionPopId = n;
    const g = document.createElement("style");
    return a && (g.nonce = a), document.head.appendChild(g), g.sheet && g.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${s}px !important;
            height: ${c}px !important;
            top: ${d}px !important;
            left: ${f}px !important;
          }
        `), () => {
      document.head.removeChild(g);
    };
  }, [e]), C.jsx(F5e, { isPresent: e, childRef: r, sizeRef: i, children: I.cloneElement(t, { ref: r }) });
}
const U5e = ({ children: t, initial: e, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: a, mode: s }) => {
  const c = h7($5e), d = I.useId(), f = I.useCallback((m) => {
    c.set(m, !0);
    for (const b of c.values())
      if (!b)
        return;
    r && r();
  }, [c, r]), g = I.useMemo(
    () => ({
      id: d,
      initial: e,
      isPresent: n,
      custom: i,
      onExitComplete: f,
      register: (m) => (c.set(m, !1), () => c.delete(m))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? [Math.random(), f] : [n, f]
  );
  return I.useMemo(() => {
    c.forEach((m, b) => c.set(b, !1));
  }, [n]), I.useEffect(() => {
    !n && !c.size && r && r();
  }, [n]), s === "popLayout" && (t = C.jsx(V5e, { isPresent: n, children: t })), C.jsx(oO.Provider, { value: g, children: t });
};
function $5e() {
  return /* @__PURE__ */ new Map();
}
function jQ(t = !0) {
  const e = I.useContext(oO);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: i } = e, a = I.useId();
  I.useEffect(() => {
    t && i(a);
  }, [t]);
  const s = I.useCallback(() => t && r && r(a), [a, r, t]);
  return !n && r ? [!1, s] : [!0];
}
const FC = (t) => t.key || "";
function dF(t) {
  const e = [];
  return I.Children.forEach(t, (n) => {
    I.isValidElement(n) && e.push(n);
  }), e;
}
const m7 = typeof window < "u", PQ = m7 ? I.useLayoutEffect : I.useEffect, LQ = ({ children: t, custom: e, initial: n = !0, onExitComplete: r, presenceAffectsLayout: i = !0, mode: a = "sync", propagate: s = !1 }) => {
  const [c, d] = jQ(s), f = I.useMemo(() => dF(t), [t]), g = s && !c ? [] : f.map(FC), m = I.useRef(!0), b = I.useRef(f), w = h7(() => /* @__PURE__ */ new Map()), [_, A] = I.useState(f), [T, O] = I.useState(f);
  PQ(() => {
    m.current = !1, b.current = f;
    for (let M = 0; M < T.length; M++) {
      const P = FC(T[M]);
      g.includes(P) ? w.delete(P) : w.get(P) !== !0 && w.set(P, !1);
    }
  }, [T, g.length, g.join("-")]);
  const R = [];
  if (f !== _) {
    let M = [...f];
    for (let P = 0; P < T.length; P++) {
      const z = T[P], F = FC(z);
      g.includes(F) || (M.splice(P, 0, z), R.push(z));
    }
    a === "wait" && R.length && (M = R), O(dF(M)), A(f);
    return;
  }
  process.env.NODE_ENV !== "production" && a === "wait" && T.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: N } = I.useContext(f7);
  return C.jsx(C.Fragment, { children: T.map((M) => {
    const P = FC(M), z = s && !c ? !1 : f === T || g.includes(P), F = () => {
      if (w.has(P))
        w.set(P, !0);
      else
        return;
      let $ = !0;
      w.forEach((G) => {
        G || ($ = !1);
      }), $ && (N?.(), O(b.current), s && d?.(), r && r());
    };
    return C.jsx(U5e, { isPresent: z, initial: !m.current || n ? void 0 : !1, custom: z ? void 0 : e, presenceAffectsLayout: i, mode: a, onExitComplete: z ? void 0 : F, children: M }, P);
  }) });
}, ll = /* @__NO_SIDE_EFFECTS__ */ (t) => t;
let yw = ll, X0 = ll;
process.env.NODE_ENV !== "production" && (yw = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, X0 = (t, e) => {
  if (!t)
    throw new Error(e);
});
// @__NO_SIDE_EFFECTS__
function g7(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const Zb = /* @__NO_SIDE_EFFECTS__ */ (t, e, n) => {
  const r = e - t;
  return r === 0 ? 1 : (n - t) / r;
}, Zd = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, Th = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3, H5e = {
  skipAnimations: !1,
  useManualTiming: !1
};
function q5e(t) {
  let e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function c(f) {
    a.has(f) && (d.schedule(f), t()), f(s);
  }
  const d = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (f, g = !1, m = !1) => {
      const w = m && r ? e : n;
      return g && a.add(f), w.has(f) || w.add(f), f;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (f) => {
      n.delete(f), a.delete(f);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (f) => {
      if (s = f, r) {
        i = !0;
        return;
      }
      r = !0, [e, n] = [n, e], e.forEach(c), e.clear(), r = !1, i && (i = !1, d.process(f));
    }
  };
  return d;
}
const VC = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], G5e = 40;
function BQ(t, e) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = () => n = !0, s = VC.reduce((O, R) => (O[R] = q5e(a), O), {}), { read: c, resolveKeyframes: d, update: f, preRender: g, render: m, postRender: b } = s, w = () => {
    const O = performance.now();
    n = !1, i.delta = r ? 1e3 / 60 : Math.max(Math.min(O - i.timestamp, G5e), 1), i.timestamp = O, i.isProcessing = !0, c.process(i), d.process(i), f.process(i), g.process(i), m.process(i), b.process(i), i.isProcessing = !1, n && e && (r = !1, t(w));
  }, _ = () => {
    n = !0, r = !0, i.isProcessing || t(w);
  };
  return { schedule: VC.reduce((O, R) => {
    const N = s[R];
    return O[R] = (M, P = !1, z = !1) => (n || _(), N.schedule(M, P, z)), O;
  }, {}), cancel: (O) => {
    for (let R = 0; R < VC.length; R++)
      s[VC[R]].cancel(O);
  }, state: i, steps: s };
}
const { schedule: xi, cancel: W0, state: Io, steps: J6 } = BQ(typeof requestAnimationFrame < "u" ? requestAnimationFrame : ll, !0), zQ = I.createContext({ strict: !1 }), fF = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Kb = {};
for (const t in fF)
  Kb[t] = {
    isEnabled: (e) => fF[t].some((n) => !!e[n])
  };
function Y5e(t) {
  for (const e in t)
    Kb[e] = {
      ...Kb[e],
      ...t[e]
    };
}
const X5e = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function ZT(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || X5e.has(t);
}
let FQ = (t) => !ZT(t);
function W5e(t) {
  t && (FQ = (e) => e.startsWith("on") ? !ZT(e) : t(e));
}
try {
  W5e(require("@emotion/is-prop-valid").default);
} catch {
}
function Q5e(t, e, n) {
  const r = {};
  for (const i in t)
    i === "values" && typeof t.values == "object" || (FQ(i) || n === !0 && ZT(i) || !e && !ZT(i) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && i.startsWith("onDrag")) && (r[i] = t[i]);
  return r;
}
const hF = /* @__PURE__ */ new Set();
function sO(t, e, n) {
  t || hF.has(e) || (console.warn(e), n && console.warn(n), hF.add(e));
}
function Z5e(t) {
  if (typeof Proxy > "u")
    return t;
  const e = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && sO(!1, "motion() is deprecated. Use motion.create() instead."), t(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, i) => i === "create" ? t : (e.has(i) || e.set(i, t(i)), e.get(i))
  });
}
const lO = I.createContext({});
function e_(t) {
  return typeof t == "string" || Array.isArray(t);
}
function cO(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
const v7 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], y7 = ["initial", ...v7];
function uO(t) {
  return cO(t.animate) || y7.some((e) => e_(t[e]));
}
function VQ(t) {
  return !!(uO(t) || t.variants);
}
function K5e(t, e) {
  if (uO(t)) {
    const { initial: n, animate: r } = t;
    return {
      initial: n === !1 || e_(n) ? n : void 0,
      animate: e_(r) ? r : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function J5e(t) {
  const { initial: e, animate: n } = K5e(t, I.useContext(lO));
  return I.useMemo(() => ({ initial: e, animate: n }), [pF(e), pF(n)]);
}
function pF(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const eOe = Symbol.for("motionComponentSymbol");
function Sb(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function tOe(t, e, n) {
  return I.useCallback(
    (r) => {
      r && t.onMount && t.onMount(r), e && (r ? e.mount(r) : e.unmount()), n && (typeof n == "function" ? n(r) : Sb(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
const b7 = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), nOe = "framerAppearId", UQ = "data-" + b7(nOe), { schedule: w7, cancel: jGe } = BQ(queueMicrotask, !1), $Q = I.createContext({});
function rOe(t, e, n, r, i) {
  var a, s;
  const { visualElement: c } = I.useContext(lO), d = I.useContext(zQ), f = I.useContext(oO), g = I.useContext(p7).reducedMotion, m = I.useRef(null);
  r = r || d.renderer, !m.current && r && (m.current = r(t, {
    visualState: e,
    parent: c,
    props: n,
    presenceContext: f,
    blockInitialAnimation: f ? f.initial === !1 : !1,
    reducedMotionConfig: g
  }));
  const b = m.current, w = I.useContext($Q);
  b && !b.projection && i && (b.type === "html" || b.type === "svg") && iOe(m.current, n, i, w);
  const _ = I.useRef(!1);
  I.useInsertionEffect(() => {
    b && _.current && b.update(n, f);
  });
  const A = n[UQ], T = I.useRef(!!A && !(!((a = window.MotionHandoffIsComplete) === null || a === void 0) && a.call(window, A)) && ((s = window.MotionHasOptimisedAnimation) === null || s === void 0 ? void 0 : s.call(window, A)));
  return PQ(() => {
    b && (_.current = !0, window.MotionIsMounted = !0, b.updateFeatures(), w7.render(b.render), T.current && b.animationState && b.animationState.animateChanges());
  }), I.useEffect(() => {
    b && (!T.current && b.animationState && b.animationState.animateChanges(), T.current && (queueMicrotask(() => {
      var O;
      (O = window.MotionHandoffMarkAsComplete) === null || O === void 0 || O.call(window, A);
    }), T.current = !1));
  }), b;
}
function iOe(t, e, n, r) {
  const { layoutId: i, layout: a, drag: s, dragConstraints: c, layoutScroll: d, layoutRoot: f } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : HQ(t.parent)), t.projection.setOptions({
    layoutId: i,
    layout: a,
    alwaysMeasureLayout: !!s || c && Sb(c),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: r,
    layoutScroll: d,
    layoutRoot: f
  });
}
function HQ(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : HQ(t.parent);
}
function aOe({ preloadedFeatures: t, createVisualElement: e, useRender: n, useVisualState: r, Component: i }) {
  var a, s;
  t && Y5e(t);
  function c(f, g) {
    let m;
    const b = {
      ...I.useContext(p7),
      ...f,
      layoutId: oOe(f)
    }, { isStatic: w } = b, _ = J5e(f), A = r(f, w);
    if (!w && m7) {
      sOe(b, t);
      const T = lOe(b);
      m = T.MeasureLayout, _.visualElement = rOe(i, A, b, e, T.ProjectionNode);
    }
    return C.jsxs(lO.Provider, { value: _, children: [m && _.visualElement ? C.jsx(m, { visualElement: _.visualElement, ...b }) : null, n(i, f, tOe(A, _.visualElement, g), A, w, _.visualElement)] });
  }
  c.displayName = `motion.${typeof i == "string" ? i : `create(${(s = (a = i.displayName) !== null && a !== void 0 ? a : i.name) !== null && s !== void 0 ? s : ""})`}`;
  const d = I.forwardRef(c);
  return d[eOe] = i, d;
}
function oOe({ layoutId: t }) {
  const e = I.useContext(f7).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function sOe(t, e) {
  const n = I.useContext(zQ).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? yw(!1, r) : X0(!1, r);
  }
}
function lOe(t) {
  const { drag: e, layout: n } = Kb;
  if (!e && !n)
    return {};
  const r = { ...e, ...n };
  return {
    MeasureLayout: e?.isEnabled(t) || n?.isEnabled(t) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const cOe = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function x7(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(cOe.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
function mF(t) {
  const e = [{}, {}];
  return t?.values.forEach((n, r) => {
    e[0][r] = n.get(), e[1][r] = n.getVelocity();
  }), e;
}
function S7(t, e, n, r) {
  if (typeof e == "function") {
    const [i, a] = mF(r);
    e = e(n !== void 0 ? n : t.custom, i, a);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [i, a] = mF(r);
    e = e(n !== void 0 ? n : t.custom, i, a);
  }
  return e;
}
const nN = (t) => Array.isArray(t), uOe = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), dOe = (t) => nN(t) ? t[t.length - 1] || 0 : t, Ko = (t) => !!(t && t.getVelocity);
function C4(t) {
  const e = Ko(t) ? t.get() : t;
  return uOe(e) ? e.toValue() : e;
}
function fOe({ scrapeMotionValuesFromProps: t, createRenderState: e, onUpdate: n }, r, i, a) {
  const s = {
    latestValues: hOe(r, i, a, t),
    renderState: e()
  };
  return n && (s.onMount = (c) => n({ props: r, current: c, ...s }), s.onUpdate = (c) => n(c)), s;
}
const qQ = (t) => (e, n) => {
  const r = I.useContext(lO), i = I.useContext(oO), a = () => fOe(t, e, r, i);
  return n ? a() : h7(a);
};
function hOe(t, e, n, r) {
  const i = {}, a = r(t, {});
  for (const b in a)
    i[b] = C4(a[b]);
  let { initial: s, animate: c } = t;
  const d = uO(t), f = VQ(t);
  e && f && !d && t.inherit !== !1 && (s === void 0 && (s = e.initial), c === void 0 && (c = e.animate));
  let g = n ? n.initial === !1 : !1;
  g = g || s === !1;
  const m = g ? c : s;
  if (m && typeof m != "boolean" && !cO(m)) {
    const b = Array.isArray(m) ? m : [m];
    for (let w = 0; w < b.length; w++) {
      const _ = S7(t, b[w]);
      if (_) {
        const { transitionEnd: A, transition: T, ...O } = _;
        for (const R in O) {
          let N = O[R];
          if (Array.isArray(N)) {
            const M = g ? N.length - 1 : 0;
            N = N[M];
          }
          N !== null && (i[R] = N);
        }
        for (const R in A)
          i[R] = A[R];
      }
    }
  }
  return i;
}
const bw = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Fg = new Set(bw), GQ = (t) => (e) => typeof e == "string" && e.startsWith(t), YQ = /* @__PURE__ */ GQ("--"), pOe = /* @__PURE__ */ GQ("var(--"), E7 = (t) => pOe(t) ? mOe.test(t.split("/*")[0].trim()) : !1, mOe = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, XQ = (t, e) => e && typeof t == "number" ? e.transform(t) : t, Ih = (t, e, n) => n > e ? e : n < t ? t : n, ww = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, t_ = {
  ...ww,
  transform: (t) => Ih(0, 1, t)
}, UC = {
  ...ww,
  default: 1
}, k_ = (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), _0 = /* @__PURE__ */ k_("deg"), Kd = /* @__PURE__ */ k_("%"), Qt = /* @__PURE__ */ k_("px"), gOe = /* @__PURE__ */ k_("vh"), vOe = /* @__PURE__ */ k_("vw"), gF = {
  ...Kd,
  parse: (t) => Kd.parse(t) / 100,
  transform: (t) => Kd.transform(t * 100)
}, yOe = {
  // Border props
  borderWidth: Qt,
  borderTopWidth: Qt,
  borderRightWidth: Qt,
  borderBottomWidth: Qt,
  borderLeftWidth: Qt,
  borderRadius: Qt,
  radius: Qt,
  borderTopLeftRadius: Qt,
  borderTopRightRadius: Qt,
  borderBottomRightRadius: Qt,
  borderBottomLeftRadius: Qt,
  // Positioning props
  width: Qt,
  maxWidth: Qt,
  height: Qt,
  maxHeight: Qt,
  top: Qt,
  right: Qt,
  bottom: Qt,
  left: Qt,
  // Spacing props
  padding: Qt,
  paddingTop: Qt,
  paddingRight: Qt,
  paddingBottom: Qt,
  paddingLeft: Qt,
  margin: Qt,
  marginTop: Qt,
  marginRight: Qt,
  marginBottom: Qt,
  marginLeft: Qt,
  // Misc
  backgroundPositionX: Qt,
  backgroundPositionY: Qt
}, bOe = {
  rotate: _0,
  rotateX: _0,
  rotateY: _0,
  rotateZ: _0,
  scale: UC,
  scaleX: UC,
  scaleY: UC,
  scaleZ: UC,
  skew: _0,
  skewX: _0,
  skewY: _0,
  distance: Qt,
  translateX: Qt,
  translateY: Qt,
  translateZ: Qt,
  x: Qt,
  y: Qt,
  z: Qt,
  perspective: Qt,
  transformPerspective: Qt,
  opacity: t_,
  originX: gF,
  originY: gF,
  originZ: Qt
}, vF = {
  ...ww,
  transform: Math.round
}, _7 = {
  ...yOe,
  ...bOe,
  zIndex: vF,
  size: Qt,
  // SVG
  fillOpacity: t_,
  strokeOpacity: t_,
  numOctaves: vF
}, wOe = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, xOe = bw.length;
function SOe(t, e, n) {
  let r = "", i = !0;
  for (let a = 0; a < xOe; a++) {
    const s = bw[a], c = t[s];
    if (c === void 0)
      continue;
    let d = !0;
    if (typeof c == "number" ? d = c === (s.startsWith("scale") ? 1 : 0) : d = parseFloat(c) === 0, !d || n) {
      const f = XQ(c, _7[s]);
      if (!d) {
        i = !1;
        const g = wOe[s] || s;
        r += `${g}(${f}) `;
      }
      n && (e[s] = f);
    }
  }
  return r = r.trim(), n ? r = n(e, i ? "" : r) : i && (r = "none"), r;
}
function A7(t, e, n) {
  const { style: r, vars: i, transformOrigin: a } = t;
  let s = !1, c = !1;
  for (const d in e) {
    const f = e[d];
    if (Fg.has(d)) {
      s = !0;
      continue;
    } else if (YQ(d)) {
      i[d] = f;
      continue;
    } else {
      const g = XQ(f, _7[d]);
      d.startsWith("origin") ? (c = !0, a[d] = g) : r[d] = g;
    }
  }
  if (e.transform || (s || n ? r.transform = SOe(e, t.transform, n) : r.transform && (r.transform = "none")), c) {
    const { originX: d = "50%", originY: f = "50%", originZ: g = 0 } = a;
    r.transformOrigin = `${d} ${f} ${g}`;
  }
}
const EOe = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, _Oe = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function AOe(t, e, n = 1, r = 0, i = !0) {
  t.pathLength = 1;
  const a = i ? EOe : _Oe;
  t[a.offset] = Qt.transform(-r);
  const s = Qt.transform(e), c = Qt.transform(n);
  t[a.array] = `${s} ${c}`;
}
function yF(t, e, n) {
  return typeof t == "string" ? t : Qt.transform(e + n * t);
}
function COe(t, e, n) {
  const r = yF(e, t.x, t.width), i = yF(n, t.y, t.height);
  return `${r} ${i}`;
}
function C7(t, {
  attrX: e,
  attrY: n,
  attrScale: r,
  originX: i,
  originY: a,
  pathLength: s,
  pathSpacing: c = 1,
  pathOffset: d = 0,
  // This is object creation, which we try to avoid per-frame.
  ...f
}, g, m) {
  if (A7(t, f, m), g) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: b, style: w, dimensions: _ } = t;
  b.transform && (_ && (w.transform = b.transform), delete b.transform), _ && (i !== void 0 || a !== void 0 || w.transform) && (w.transformOrigin = COe(_, i !== void 0 ? i : 0.5, a !== void 0 ? a : 0.5)), e !== void 0 && (b.x = e), n !== void 0 && (b.y = n), r !== void 0 && (b.scale = r), s !== void 0 && AOe(b, s, c, d, !1);
}
const T7 = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), WQ = () => ({
  ...T7(),
  attrs: {}
}), O7 = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function QQ(t, { style: e, vars: n }, r, i) {
  Object.assign(t.style, e, i && i.getProjectionStyles(r));
  for (const a in n)
    t.style.setProperty(a, n[a]);
}
const ZQ = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function KQ(t, e, n, r) {
  QQ(t, e, void 0, r);
  for (const i in e.attrs)
    t.setAttribute(ZQ.has(i) ? i : b7(i), e.attrs[i]);
}
const KT = {};
function TOe(t) {
  Object.assign(KT, t);
}
function JQ(t, { layout: e, layoutId: n }) {
  return Fg.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!KT[t] || t === "opacity");
}
function R7(t, e, n) {
  var r;
  const { style: i } = t, a = {};
  for (const s in i)
    (Ko(i[s]) || e.style && Ko(e.style[s]) || JQ(s, t) || ((r = n?.getValue(s)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (a[s] = i[s]);
  return a;
}
function eZ(t, e, n) {
  const r = R7(t, e, n);
  for (const i in t)
    if (Ko(t[i]) || Ko(e[i])) {
      const a = bw.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[a] = t[i];
    }
  return r;
}
function OOe(t, e) {
  try {
    e.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
  } catch {
    e.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
const bF = ["x", "y", "width", "height", "cx", "cy", "r"], ROe = {
  useVisualState: qQ({
    scrapeMotionValuesFromProps: eZ,
    createRenderState: WQ,
    onUpdate: ({ props: t, prevProps: e, current: n, renderState: r, latestValues: i }) => {
      if (!n)
        return;
      let a = !!t.drag;
      if (!a) {
        for (const c in i)
          if (Fg.has(c)) {
            a = !0;
            break;
          }
      }
      if (!a)
        return;
      let s = !e;
      if (e)
        for (let c = 0; c < bF.length; c++) {
          const d = bF[c];
          t[d] !== e[d] && (s = !0);
        }
      s && xi.read(() => {
        OOe(n, r), xi.render(() => {
          C7(r, i, O7(n.tagName), t.transformTemplate), KQ(n, r);
        });
      });
    }
  })
}, DOe = {
  useVisualState: qQ({
    scrapeMotionValuesFromProps: R7,
    createRenderState: T7
  })
};
function tZ(t, e, n) {
  for (const r in e)
    !Ko(e[r]) && !JQ(r, n) && (t[r] = e[r]);
}
function NOe({ transformTemplate: t }, e) {
  return I.useMemo(() => {
    const n = T7();
    return A7(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function MOe(t, e) {
  const n = t.style || {}, r = {};
  return tZ(r, n, t), Object.assign(r, NOe(t, e)), r;
}
function IOe(t, e) {
  const n = {}, r = MOe(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
function kOe(t, e, n, r) {
  const i = I.useMemo(() => {
    const a = WQ();
    return C7(a, e, O7(r), t.transformTemplate), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [e]);
  if (t.style) {
    const a = {};
    tZ(a, t.style, t), i.style = { ...a, ...i.style };
  }
  return i;
}
function jOe(t = !1) {
  return (n, r, i, { latestValues: a }, s) => {
    const d = (x7(n) ? kOe : IOe)(r, a, s, n), f = Q5e(r, typeof n == "string", t), g = n !== I.Fragment ? { ...f, ...d, ref: i } : {}, { children: m } = r, b = I.useMemo(() => Ko(m) ? m.get() : m, [m]);
    return I.createElement(n, {
      ...g,
      children: b
    });
  };
}
function POe(t, e) {
  return function(r, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const s = {
      ...x7(r) ? ROe : DOe,
      preloadedFeatures: t,
      useRender: jOe(i),
      createVisualElement: e,
      Component: r
    };
    return aOe(s);
  };
}
function nZ(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function dO(t, e, n) {
  const r = t.getProps();
  return S7(r, e, n !== void 0 ? n : r.custom, t);
}
const LOe = /* @__PURE__ */ g7(() => window.ScrollTimeline !== void 0);
class BOe {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => "finished" in e ? e.finished : e));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][e] = n;
  }
  attachTimeline(e, n) {
    const r = this.animations.map((i) => {
      if (LOe() && i.attachTimeline)
        return i.attachTimeline(e);
      if (typeof n == "function")
        return n(i);
    });
    return () => {
      r.forEach((i, a) => {
        i && i(), this.animations[a].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let e = 0;
    for (let n = 0; n < this.animations.length; n++)
      e = Math.max(e, this.animations[n].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class zOe extends BOe {
  then(e, n) {
    return Promise.all(this.animations).then(e).catch(n);
  }
}
function D7(t, e) {
  return t ? t[e] || t.default || t : void 0;
}
const rN = 2e4;
function rZ(t) {
  let e = 0;
  const n = 50;
  let r = t.next(e);
  for (; !r.done && e < rN; )
    e += n, r = t.next(e);
  return e >= rN ? 1 / 0 : e;
}
function N7(t) {
  return typeof t == "function";
}
function wF(t, e) {
  t.timeline = e, t.onfinish = null;
}
const M7 = (t) => Array.isArray(t) && typeof t[0] == "number", FOe = {
  linearEasing: void 0
};
function VOe(t, e) {
  const n = /* @__PURE__ */ g7(t);
  return () => {
    var r;
    return (r = FOe[e]) !== null && r !== void 0 ? r : n();
  };
}
const JT = /* @__PURE__ */ VOe(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), iZ = (t, e, n = 10) => {
  let r = "";
  const i = Math.max(Math.round(e / n), 2);
  for (let a = 0; a < i; a++)
    r += t(/* @__PURE__ */ Zb(0, i - 1, a)) + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
};
function aZ(t) {
  return !!(typeof t == "function" && JT() || !t || typeof t == "string" && (t in iN || JT()) || M7(t) || Array.isArray(t) && t.every(aZ));
}
const tE = ([t, e, n, r]) => `cubic-bezier(${t}, ${e}, ${n}, ${r})`, iN = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ tE([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ tE([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ tE([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ tE([0.33, 1.53, 0.69, 0.99])
};
function oZ(t, e) {
  if (t)
    return typeof t == "function" && JT() ? iZ(t, e) : M7(t) ? tE(t) : Array.isArray(t) ? t.map((n) => oZ(n, e) || iN.easeOut) : iN[t];
}
const Lu = {
  x: !1,
  y: !1
};
function sZ() {
  return Lu.x || Lu.y;
}
function UOe(t, e, n) {
  var r;
  if (t instanceof Element)
    return [t];
  if (typeof t == "string") {
    let i = document;
    e && (i = e.current);
    const a = (r = n?.[t]) !== null && r !== void 0 ? r : i.querySelectorAll(t);
    return a ? Array.from(a) : [];
  }
  return Array.from(t);
}
function lZ(t, e) {
  const n = UOe(t), r = new AbortController(), i = {
    passive: !0,
    ...e,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function xF(t) {
  return (e) => {
    e.pointerType === "touch" || sZ() || t(e);
  };
}
function $Oe(t, e, n = {}) {
  const [r, i, a] = lZ(t, n), s = xF((c) => {
    const { target: d } = c, f = e(c);
    if (typeof f != "function" || !d)
      return;
    const g = xF((m) => {
      f(m), d.removeEventListener("pointerleave", g);
    });
    d.addEventListener("pointerleave", g, i);
  });
  return r.forEach((c) => {
    c.addEventListener("pointerenter", s, i);
  }), a;
}
const cZ = (t, e) => e ? t === e ? !0 : cZ(t, e.parentElement) : !1, I7 = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1, HOe = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function qOe(t) {
  return HOe.has(t.tagName) || t.tabIndex !== -1;
}
const nE = /* @__PURE__ */ new WeakSet();
function SF(t) {
  return (e) => {
    e.key === "Enter" && t(e);
  };
}
function eD(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const GOe = (t, e) => {
  const n = t.currentTarget;
  if (!n)
    return;
  const r = SF(() => {
    if (nE.has(n))
      return;
    eD(n, "down");
    const i = SF(() => {
      eD(n, "up");
    }), a = () => eD(n, "cancel");
    n.addEventListener("keyup", i, e), n.addEventListener("blur", a, e);
  });
  n.addEventListener("keydown", r, e), n.addEventListener("blur", () => n.removeEventListener("keydown", r), e);
};
function EF(t) {
  return I7(t) && !sZ();
}
function YOe(t, e, n = {}) {
  const [r, i, a] = lZ(t, n), s = (c) => {
    const d = c.currentTarget;
    if (!EF(c) || nE.has(d))
      return;
    nE.add(d);
    const f = e(c), g = (w, _) => {
      window.removeEventListener("pointerup", m), window.removeEventListener("pointercancel", b), !(!EF(w) || !nE.has(d)) && (nE.delete(d), typeof f == "function" && f(w, { success: _ }));
    }, m = (w) => {
      g(w, n.useGlobalTarget || cZ(d, w.target));
    }, b = (w) => {
      g(w, !1);
    };
    window.addEventListener("pointerup", m, i), window.addEventListener("pointercancel", b, i);
  };
  return r.forEach((c) => {
    !qOe(c) && c.getAttribute("tabindex") === null && (c.tabIndex = 0), (n.useGlobalTarget ? window : c).addEventListener("pointerdown", s, i), c.addEventListener("focus", (f) => GOe(f, i), i);
  }), a;
}
function XOe(t) {
  return t === "x" || t === "y" ? Lu[t] ? null : (Lu[t] = !0, () => {
    Lu[t] = !1;
  }) : Lu.x || Lu.y ? null : (Lu.x = Lu.y = !0, () => {
    Lu.x = Lu.y = !1;
  });
}
const uZ = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...bw
]);
let T4;
function WOe() {
  T4 = void 0;
}
const Jd = {
  now: () => (T4 === void 0 && Jd.set(Io.isProcessing || H5e.useManualTiming ? Io.timestamp : performance.now()), T4),
  set: (t) => {
    T4 = t, queueMicrotask(WOe);
  }
};
function k7(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function j7(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
class P7 {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return k7(this.subscriptions, e), () => j7(this.subscriptions, e);
  }
  notify(e, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, n, r);
      else
        for (let a = 0; a < i; a++) {
          const s = this.subscriptions[a];
          s && s(e, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function dZ(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const _F = 30, QOe = (t) => !isNaN(parseFloat(t));
class ZOe {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, n = {}) {
    this.version = "11.18.2", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      const a = Jd.now();
      this.updatedAt !== a && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = Jd.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = QOe(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && sO(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new P7());
    const r = this.events[e].add(n);
    return e === "change" ? () => {
      r(), xi.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = Jd.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > _F)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, _F);
    return dZ(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function n_(t, e) {
  return new ZOe(t, e);
}
function KOe(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, n_(n));
}
function JOe(t, e) {
  const n = dO(t, e);
  let { transitionEnd: r = {}, transition: i = {}, ...a } = n || {};
  a = { ...a, ...r };
  for (const s in a) {
    const c = dOe(a[s]);
    KOe(t, s, c);
  }
}
function eRe(t) {
  return !!(Ko(t) && t.add);
}
function aN(t, e) {
  const n = t.getValue("willChange");
  if (eRe(n))
    return n.add(e);
}
function fZ(t) {
  return t.props[UQ];
}
const hZ = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, tRe = 1e-7, nRe = 12;
function rRe(t, e, n, r, i) {
  let a, s, c = 0;
  do
    s = e + (n - e) / 2, a = hZ(s, r, i) - t, a > 0 ? n = s : e = s;
  while (Math.abs(a) > tRe && ++c < nRe);
  return s;
}
function j_(t, e, n, r) {
  if (t === e && n === r)
    return ll;
  const i = (a) => rRe(a, 0, 1, t, n);
  return (a) => a === 0 || a === 1 ? a : hZ(i(a), e, r);
}
const pZ = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, mZ = (t) => (e) => 1 - t(1 - e), gZ = /* @__PURE__ */ j_(0.33, 1.53, 0.69, 0.99), L7 = /* @__PURE__ */ mZ(gZ), vZ = /* @__PURE__ */ pZ(L7), yZ = (t) => (t *= 2) < 1 ? 0.5 * L7(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), B7 = (t) => 1 - Math.sin(Math.acos(t)), bZ = mZ(B7), wZ = pZ(B7), xZ = (t) => /^0[^.\s]+$/u.test(t);
function iRe(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || xZ(t) : !0;
}
const yE = (t) => Math.round(t * 1e5) / 1e5, z7 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function aRe(t) {
  return t == null;
}
const oRe = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, F7 = (t, e) => (n) => !!(typeof n == "string" && oRe.test(n) && n.startsWith(t) || e && !aRe(n) && Object.prototype.hasOwnProperty.call(n, e)), SZ = (t, e, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, a, s, c] = r.match(z7);
  return {
    [t]: parseFloat(i),
    [e]: parseFloat(a),
    [n]: parseFloat(s),
    alpha: c !== void 0 ? parseFloat(c) : 1
  };
}, sRe = (t) => Ih(0, 255, t), tD = {
  ...ww,
  transform: (t) => Math.round(sRe(t))
}, ig = {
  test: /* @__PURE__ */ F7("rgb", "red"),
  parse: /* @__PURE__ */ SZ("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: r = 1 }) => "rgba(" + tD.transform(t) + ", " + tD.transform(e) + ", " + tD.transform(n) + ", " + yE(t_.transform(r)) + ")"
};
function lRe(t) {
  let e = "", n = "", r = "", i = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7), i = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), r = t.substring(3, 4), i = t.substring(4, 5), e += e, n += n, r += r, i += i), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const oN = {
  test: /* @__PURE__ */ F7("#"),
  parse: lRe,
  transform: ig.transform
}, Eb = {
  test: /* @__PURE__ */ F7("hsl", "hue"),
  parse: /* @__PURE__ */ SZ("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(t) + ", " + Kd.transform(yE(e)) + ", " + Kd.transform(yE(n)) + ", " + yE(t_.transform(r)) + ")"
}, Zo = {
  test: (t) => ig.test(t) || oN.test(t) || Eb.test(t),
  parse: (t) => ig.test(t) ? ig.parse(t) : Eb.test(t) ? Eb.parse(t) : oN.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? ig.transform(t) : Eb.transform(t)
}, cRe = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function uRe(t) {
  var e, n;
  return isNaN(t) && typeof t == "string" && (((e = t.match(z7)) === null || e === void 0 ? void 0 : e.length) || 0) + (((n = t.match(cRe)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const EZ = "number", _Z = "color", dRe = "var", fRe = "var(", AF = "${}", hRe = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function r_(t) {
  const e = t.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let a = 0;
  const c = e.replace(hRe, (d) => (Zo.test(d) ? (r.color.push(a), i.push(_Z), n.push(Zo.parse(d))) : d.startsWith(fRe) ? (r.var.push(a), i.push(dRe), n.push(d)) : (r.number.push(a), i.push(EZ), n.push(parseFloat(d))), ++a, AF)).split(AF);
  return { values: n, split: c, indexes: r, types: i };
}
function AZ(t) {
  return r_(t).values;
}
function CZ(t) {
  const { split: e, types: n } = r_(t), r = e.length;
  return (i) => {
    let a = "";
    for (let s = 0; s < r; s++)
      if (a += e[s], i[s] !== void 0) {
        const c = n[s];
        c === EZ ? a += yE(i[s]) : c === _Z ? a += Zo.transform(i[s]) : a += i[s];
      }
    return a;
  };
}
const pRe = (t) => typeof t == "number" ? 0 : t;
function mRe(t) {
  const e = AZ(t);
  return CZ(t)(e.map(pRe));
}
const Q0 = {
  test: uRe,
  parse: AZ,
  createTransformer: CZ,
  getAnimatableNone: mRe
}, gRe = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function vRe(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [r] = n.match(z7) || [];
  if (!r)
    return t;
  const i = n.replace(r, "");
  let a = gRe.has(e) ? 1 : 0;
  return r !== n && (a *= 100), e + "(" + a + i + ")";
}
const yRe = /\b([a-z-]*)\(.*?\)/gu, sN = {
  ...Q0,
  getAnimatableNone: (t) => {
    const e = t.match(yRe);
    return e ? e.map(vRe).join(" ") : t;
  }
}, bRe = {
  ..._7,
  // Color props
  color: Zo,
  backgroundColor: Zo,
  outlineColor: Zo,
  fill: Zo,
  stroke: Zo,
  // Border props
  borderColor: Zo,
  borderTopColor: Zo,
  borderRightColor: Zo,
  borderBottomColor: Zo,
  borderLeftColor: Zo,
  filter: sN,
  WebkitFilter: sN
}, V7 = (t) => bRe[t];
function TZ(t, e) {
  let n = V7(t);
  return n !== sN && (n = Q0), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const wRe = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function xRe(t, e, n) {
  let r = 0, i;
  for (; r < t.length && !i; ) {
    const a = t[r];
    typeof a == "string" && !wRe.has(a) && r_(a).values.length && (i = t[r]), r++;
  }
  if (i && n)
    for (const a of e)
      t[a] = TZ(n, i);
}
const CF = (t) => t === ww || t === Qt, TF = (t, e) => parseFloat(t.split(", ")[e]), OF = (t, e) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const i = r.match(/^matrix3d\((.+)\)$/u);
  if (i)
    return TF(i[1], e);
  {
    const a = r.match(/^matrix\((.+)\)$/u);
    return a ? TF(a[1], t) : 0;
  }
}, SRe = /* @__PURE__ */ new Set(["x", "y", "z"]), ERe = bw.filter((t) => !SRe.has(t));
function _Re(t) {
  const e = [];
  return ERe.forEach((n) => {
    const r = t.getValue(n);
    r !== void 0 && (e.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const Jb = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: OF(4, 13),
  y: OF(5, 14)
};
Jb.translateX = Jb.x;
Jb.translateY = Jb.y;
const cg = /* @__PURE__ */ new Set();
let lN = !1, cN = !1;
function OZ() {
  if (cN) {
    const t = Array.from(cg).filter((r) => r.needsMeasurement), e = new Set(t.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    e.forEach((r) => {
      const i = _Re(r);
      i.length && (n.set(r, i), r.render());
    }), t.forEach((r) => r.measureInitialState()), e.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([a, s]) => {
        var c;
        (c = r.getValue(a)) === null || c === void 0 || c.set(s);
      });
    }), t.forEach((r) => r.measureEndState()), t.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  cN = !1, lN = !1, cg.forEach((t) => t.complete()), cg.clear();
}
function RZ() {
  cg.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (cN = !0);
  });
}
function ARe() {
  RZ(), OZ();
}
class U7 {
  constructor(e, n, r, i, a, s = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = r, this.motionValue = i, this.element = a, this.isAsync = s;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (cg.add(this), lN || (lN = !0, xi.read(RZ), xi.resolveKeyframes(OZ))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: r, motionValue: i } = this;
    for (let a = 0; a < e.length; a++)
      if (e[a] === null)
        if (a === 0) {
          const s = i?.get(), c = e[e.length - 1];
          if (s !== void 0)
            e[0] = s;
          else if (r && n) {
            const d = r.readValue(n, c);
            d != null && (e[0] = d);
          }
          e[0] === void 0 && (e[0] = c), i && s === void 0 && i.set(e[0]);
        } else
          e[a] = e[a - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), cg.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, cg.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const DZ = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), CRe = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function TRe(t) {
  const e = CRe.exec(t);
  if (!e)
    return [,];
  const [, n, r, i] = e;
  return [`--${n ?? r}`, i];
}
const ORe = 4;
function NZ(t, e, n = 1) {
  X0(n <= ORe, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [r, i] = TRe(t);
  if (!r)
    return;
  const a = window.getComputedStyle(e).getPropertyValue(r);
  if (a) {
    const s = a.trim();
    return DZ(s) ? parseFloat(s) : s;
  }
  return E7(i) ? NZ(i, e, n + 1) : i;
}
const MZ = (t) => (e) => e.test(t), RRe = {
  test: (t) => t === "auto",
  parse: (t) => t
}, IZ = [ww, Qt, Kd, _0, vOe, gOe, RRe], RF = (t) => IZ.find(MZ(t));
class kZ extends U7 {
  constructor(e, n, r, i, a) {
    super(e, n, r, i, a, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let d = 0; d < e.length; d++) {
      let f = e[d];
      if (typeof f == "string" && (f = f.trim(), E7(f))) {
        const g = NZ(f, n.current);
        g !== void 0 && (e[d] = g), d === e.length - 1 && (this.finalKeyframe = f);
      }
    }
    if (this.resolveNoneKeyframes(), !uZ.has(r) || e.length !== 2)
      return;
    const [i, a] = e, s = RF(i), c = RF(a);
    if (s !== c)
      if (CF(s) && CF(c))
        for (let d = 0; d < e.length; d++) {
          const f = e[d];
          typeof f == "string" && (e[d] = parseFloat(f));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, r = [];
    for (let i = 0; i < e.length; i++)
      iRe(e[i]) && r.push(i);
    r.length && xRe(e, r, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: r } = this;
    if (!e || !e.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Jb[r](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && e.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var e;
    const { element: n, name: r, unresolvedKeyframes: i } = this;
    if (!n || !n.current)
      return;
    const a = n.getValue(r);
    a && a.jump(this.measuredOrigin, !1);
    const s = i.length - 1, c = i[s];
    i[s] = Jb[r](n.measureViewportBox(), window.getComputedStyle(n.current)), c !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = c), !((e = this.removedTransforms) === null || e === void 0) && e.length && this.removedTransforms.forEach(([d, f]) => {
      n.getValue(d).set(f);
    }), this.resolveNoneKeyframes();
  }
}
const DF = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(Q0.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function DRe(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function NRe(t, e, n, r) {
  const i = t[0];
  if (i === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const a = t[t.length - 1], s = DF(i, e), c = DF(a, e);
  return yw(s === c, `You are trying to animate ${e} from "${i}" to "${a}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${a} via the \`style\` property.`), !s || !c ? !1 : DRe(t) || (n === "spring" || N7(n)) && r;
}
const MRe = (t) => t !== null;
function fO(t, { repeat: e, repeatType: n = "loop" }, r) {
  const i = t.filter(MRe), a = e && n !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return !a || r === void 0 ? i[a] : r;
}
const IRe = 40;
class jZ {
  constructor({ autoplay: e = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: s = "loop", ...c }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = Jd.now(), this.options = {
      autoplay: e,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: a,
      repeatType: s,
      ...c
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > IRe ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && ARe(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(e, n) {
    this.resolvedAt = Jd.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: i, velocity: a, delay: s, onComplete: c, onUpdate: d, isGenerator: f } = this.options;
    if (!f && !NRe(e, r, i, a))
      if (s)
        this.options.duration = 0;
      else {
        d && d(fO(e, this.options, n)), c && c(), this.resolveFinishedPromise();
        return;
      }
    const g = this.initPlayback(e, n);
    g !== !1 && (this._resolved = {
      keyframes: e,
      finalKeyframe: n,
      ...g
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.currentFinishedPromise.then(e, n);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((e) => {
      this.resolveFinishedPromise = e;
    });
  }
}
const Vi = (t, e, n) => t + (e - t) * n;
function nD(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function kRe({ hue: t, saturation: e, lightness: n, alpha: r }) {
  t /= 360, e /= 100, n /= 100;
  let i = 0, a = 0, s = 0;
  if (!e)
    i = a = s = n;
  else {
    const c = n < 0.5 ? n * (1 + e) : n + e - n * e, d = 2 * n - c;
    i = nD(d, c, t + 1 / 3), a = nD(d, c, t), s = nD(d, c, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(a * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
function e5(t, e) {
  return (n) => n > 0 ? e : t;
}
const rD = (t, e, n) => {
  const r = t * t, i = n * (e * e - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, jRe = [oN, ig, Eb], PRe = (t) => jRe.find((e) => e.test(t));
function NF(t) {
  const e = PRe(t);
  if (yw(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let n = e.parse(t);
  return e === Eb && (n = kRe(n)), n;
}
const MF = (t, e) => {
  const n = NF(t), r = NF(e);
  if (!n || !r)
    return e5(t, e);
  const i = { ...n };
  return (a) => (i.red = rD(n.red, r.red, a), i.green = rD(n.green, r.green, a), i.blue = rD(n.blue, r.blue, a), i.alpha = Vi(n.alpha, r.alpha, a), ig.transform(i));
}, LRe = (t, e) => (n) => e(t(n)), P_ = (...t) => t.reduce(LRe), uN = /* @__PURE__ */ new Set(["none", "hidden"]);
function BRe(t, e) {
  return uN.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function zRe(t, e) {
  return (n) => Vi(t, e, n);
}
function $7(t) {
  return typeof t == "number" ? zRe : typeof t == "string" ? E7(t) ? e5 : Zo.test(t) ? MF : URe : Array.isArray(t) ? PZ : typeof t == "object" ? Zo.test(t) ? MF : FRe : e5;
}
function PZ(t, e) {
  const n = [...t], r = n.length, i = t.map((a, s) => $7(a)(a, e[s]));
  return (a) => {
    for (let s = 0; s < r; s++)
      n[s] = i[s](a);
    return n;
  };
}
function FRe(t, e) {
  const n = { ...t, ...e }, r = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (r[i] = $7(t[i])(t[i], e[i]));
  return (i) => {
    for (const a in r)
      n[a] = r[a](i);
    return n;
  };
}
function VRe(t, e) {
  var n;
  const r = [], i = { color: 0, var: 0, number: 0 };
  for (let a = 0; a < e.values.length; a++) {
    const s = e.types[a], c = t.indexes[s][i[s]], d = (n = t.values[c]) !== null && n !== void 0 ? n : 0;
    r[a] = d, i[s]++;
  }
  return r;
}
const URe = (t, e) => {
  const n = Q0.createTransformer(e), r = r_(t), i = r_(e);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? uN.has(t) && !i.values.length || uN.has(e) && !r.values.length ? BRe(t, e) : P_(PZ(VRe(r, i), i.values), n) : (yw(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), e5(t, e));
};
function LZ(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? Vi(t, e, n) : $7(t)(t, e);
}
const $Re = 5;
function BZ(t, e, n) {
  const r = Math.max(e - $Re, 0);
  return dZ(n - t(r), e - r);
}
const Bi = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, iD = 1e-3;
function HRe({ duration: t = Bi.duration, bounce: e = Bi.bounce, velocity: n = Bi.velocity, mass: r = Bi.mass }) {
  let i, a;
  yw(t <= /* @__PURE__ */ Zd(Bi.maxDuration), "Spring duration must be 10 seconds or less");
  let s = 1 - e;
  s = Ih(Bi.minDamping, Bi.maxDamping, s), t = Ih(Bi.minDuration, Bi.maxDuration, /* @__PURE__ */ Th(t)), s < 1 ? (i = (f) => {
    const g = f * s, m = g * t, b = g - n, w = dN(f, s), _ = Math.exp(-m);
    return iD - b / w * _;
  }, a = (f) => {
    const m = f * s * t, b = m * n + n, w = Math.pow(s, 2) * Math.pow(f, 2) * t, _ = Math.exp(-m), A = dN(Math.pow(f, 2), s);
    return (-i(f) + iD > 0 ? -1 : 1) * ((b - w) * _) / A;
  }) : (i = (f) => {
    const g = Math.exp(-f * t), m = (f - n) * t + 1;
    return -iD + g * m;
  }, a = (f) => {
    const g = Math.exp(-f * t), m = (n - f) * (t * t);
    return g * m;
  });
  const c = 5 / t, d = GRe(i, a, c);
  if (t = /* @__PURE__ */ Zd(t), isNaN(d))
    return {
      stiffness: Bi.stiffness,
      damping: Bi.damping,
      duration: t
    };
  {
    const f = Math.pow(d, 2) * r;
    return {
      stiffness: f,
      damping: s * 2 * Math.sqrt(r * f),
      duration: t
    };
  }
}
const qRe = 12;
function GRe(t, e, n) {
  let r = n;
  for (let i = 1; i < qRe; i++)
    r = r - t(r) / e(r);
  return r;
}
function dN(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const YRe = ["duration", "bounce"], XRe = ["stiffness", "damping", "mass"];
function IF(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function WRe(t) {
  let e = {
    velocity: Bi.velocity,
    stiffness: Bi.stiffness,
    damping: Bi.damping,
    mass: Bi.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!IF(t, XRe) && IF(t, YRe))
    if (t.visualDuration) {
      const n = t.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, a = 2 * Ih(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(i);
      e = {
        ...e,
        mass: Bi.mass,
        stiffness: i,
        damping: a
      };
    } else {
      const n = HRe(t);
      e = {
        ...e,
        ...n,
        mass: Bi.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function zZ(t = Bi.visualDuration, e = Bi.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: r, restDelta: i } = n;
  const a = n.keyframes[0], s = n.keyframes[n.keyframes.length - 1], c = { done: !1, value: a }, { stiffness: d, damping: f, mass: g, duration: m, velocity: b, isResolvedFromDuration: w } = WRe({
    ...n,
    velocity: -/* @__PURE__ */ Th(n.velocity || 0)
  }), _ = b || 0, A = f / (2 * Math.sqrt(d * g)), T = s - a, O = /* @__PURE__ */ Th(Math.sqrt(d / g)), R = Math.abs(T) < 5;
  r || (r = R ? Bi.restSpeed.granular : Bi.restSpeed.default), i || (i = R ? Bi.restDelta.granular : Bi.restDelta.default);
  let N;
  if (A < 1) {
    const P = dN(O, A);
    N = (z) => {
      const F = Math.exp(-A * O * z);
      return s - F * ((_ + A * O * T) / P * Math.sin(P * z) + T * Math.cos(P * z));
    };
  } else if (A === 1)
    N = (P) => s - Math.exp(-O * P) * (T + (_ + O * T) * P);
  else {
    const P = O * Math.sqrt(A * A - 1);
    N = (z) => {
      const F = Math.exp(-A * O * z), $ = Math.min(P * z, 300);
      return s - F * ((_ + A * O * T) * Math.sinh($) + P * T * Math.cosh($)) / P;
    };
  }
  const M = {
    calculatedDuration: w && m || null,
    next: (P) => {
      const z = N(P);
      if (w)
        c.done = P >= m;
      else {
        let F = 0;
        A < 1 && (F = P === 0 ? /* @__PURE__ */ Zd(_) : BZ(N, P, z));
        const $ = Math.abs(F) <= r, G = Math.abs(s - z) <= i;
        c.done = $ && G;
      }
      return c.value = c.done ? s : z, c;
    },
    toString: () => {
      const P = Math.min(rZ(M), rN), z = iZ((F) => M.next(P * F).value, P, 30);
      return P + "ms " + z;
    }
  };
  return M;
}
function kF({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: a = 500, modifyTarget: s, min: c, max: d, restDelta: f = 0.5, restSpeed: g }) {
  const m = t[0], b = {
    done: !1,
    value: m
  }, w = ($) => c !== void 0 && $ < c || d !== void 0 && $ > d, _ = ($) => c === void 0 ? d : d === void 0 || Math.abs(c - $) < Math.abs(d - $) ? c : d;
  let A = n * e;
  const T = m + A, O = s === void 0 ? T : s(T);
  O !== T && (A = O - m);
  const R = ($) => -A * Math.exp(-$ / r), N = ($) => O + R($), M = ($) => {
    const G = R($), H = N($);
    b.done = Math.abs(G) <= f, b.value = b.done ? O : H;
  };
  let P, z;
  const F = ($) => {
    w(b.value) && (P = $, z = zZ({
      keyframes: [b.value, _(b.value)],
      velocity: BZ(N, $, b.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: a,
      restDelta: f,
      restSpeed: g
    }));
  };
  return F(0), {
    calculatedDuration: null,
    next: ($) => {
      let G = !1;
      return !z && P === void 0 && (G = !0, M($), F($)), P !== void 0 && $ >= P ? z.next($ - P) : (!G && M($), b);
    }
  };
}
const QRe = /* @__PURE__ */ j_(0.42, 0, 1, 1), ZRe = /* @__PURE__ */ j_(0, 0, 0.58, 1), FZ = /* @__PURE__ */ j_(0.42, 0, 0.58, 1), KRe = (t) => Array.isArray(t) && typeof t[0] != "number", jF = {
  linear: ll,
  easeIn: QRe,
  easeInOut: FZ,
  easeOut: ZRe,
  circIn: B7,
  circInOut: wZ,
  circOut: bZ,
  backIn: L7,
  backInOut: vZ,
  backOut: gZ,
  anticipate: yZ
}, PF = (t) => {
  if (M7(t)) {
    X0(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, n, r, i] = t;
    return j_(e, n, r, i);
  } else if (typeof t == "string")
    return X0(jF[t] !== void 0, `Invalid easing type '${t}'`), jF[t];
  return t;
};
function JRe(t, e, n) {
  const r = [], i = n || LZ, a = t.length - 1;
  for (let s = 0; s < a; s++) {
    let c = i(t[s], t[s + 1]);
    if (e) {
      const d = Array.isArray(e) ? e[s] || ll : e;
      c = P_(d, c);
    }
    r.push(c);
  }
  return r;
}
function e6e(t, e, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const a = t.length;
  if (X0(a === e.length, "Both input and output ranges must be the same length"), a === 1)
    return () => e[0];
  if (a === 2 && e[0] === e[1])
    return () => e[1];
  const s = t[0] === t[1];
  t[0] > t[a - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const c = JRe(e, r, i), d = c.length, f = (g) => {
    if (s && g < t[0])
      return e[0];
    let m = 0;
    if (d > 1)
      for (; m < t.length - 2 && !(g < t[m + 1]); m++)
        ;
    const b = /* @__PURE__ */ Zb(t[m], t[m + 1], g);
    return c[m](b);
  };
  return n ? (g) => f(Ih(t[0], t[a - 1], g)) : f;
}
function t6e(t, e) {
  const n = t[t.length - 1];
  for (let r = 1; r <= e; r++) {
    const i = /* @__PURE__ */ Zb(0, e, r);
    t.push(Vi(n, 1, i));
  }
}
function n6e(t) {
  const e = [0];
  return t6e(e, t.length - 1), e;
}
function r6e(t, e) {
  return t.map((n) => n * e);
}
function i6e(t, e) {
  return t.map(() => e || FZ).splice(0, t.length - 1);
}
function t5({ duration: t = 300, keyframes: e, times: n, ease: r = "easeInOut" }) {
  const i = KRe(r) ? r.map(PF) : PF(r), a = {
    done: !1,
    value: e[0]
  }, s = r6e(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : n6e(e),
    t
  ), c = e6e(s, e, {
    ease: Array.isArray(i) ? i : i6e(e, i)
  });
  return {
    calculatedDuration: t,
    next: (d) => (a.value = c(d), a.done = d >= t, a)
  };
}
const a6e = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: () => xi.update(e, !0),
    stop: () => W0(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Io.isProcessing ? Io.timestamp : Jd.now()
  };
}, o6e = {
  decay: kF,
  inertia: kF,
  tween: t5,
  keyframes: t5,
  spring: zZ
}, s6e = (t) => t / 100;
class H7 extends jZ {
  constructor(e) {
    super(e), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: d } = this.options;
      d && d();
    };
    const { name: n, motionValue: r, element: i, keyframes: a } = this.options, s = i?.KeyframeResolver || U7, c = (d, f) => this.onKeyframesResolved(d, f);
    this.resolver = new s(a, c, n, r, i), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(e) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: a, velocity: s = 0 } = this.options, c = N7(n) ? n : o6e[n] || t5;
    let d, f;
    c !== t5 && typeof e[0] != "number" && (process.env.NODE_ENV !== "production" && X0(e.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${e}`), d = P_(s6e, LZ(e[0], e[1])), e = [0, 100]);
    const g = c({ ...this.options, keyframes: e });
    a === "mirror" && (f = c({
      ...this.options,
      keyframes: [...e].reverse(),
      velocity: -s
    })), g.calculatedDuration === null && (g.calculatedDuration = rZ(g));
    const { calculatedDuration: m } = g, b = m + i, w = b * (r + 1) - i;
    return {
      generator: g,
      mirroredGenerator: f,
      mapPercentToKeyframes: d,
      calculatedDuration: m,
      resolvedDuration: b,
      totalDuration: w
    };
  }
  onPostResolved() {
    const { autoplay: e = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !e ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(e, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: $ } = this.options;
      return { done: !0, value: $[$.length - 1] };
    }
    const { finalKeyframe: i, generator: a, mirroredGenerator: s, mapPercentToKeyframes: c, keyframes: d, calculatedDuration: f, totalDuration: g, resolvedDuration: m } = r;
    if (this.startTime === null)
      return a.next(0);
    const { delay: b, repeat: w, repeatType: _, repeatDelay: A, onUpdate: T } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - g / this.speed, this.startTime)), n ? this.currentTime = e : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
    const O = this.currentTime - b * (this.speed >= 0 ? 1 : -1), R = this.speed >= 0 ? O < 0 : O > g;
    this.currentTime = Math.max(O, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = g);
    let N = this.currentTime, M = a;
    if (w) {
      const $ = Math.min(this.currentTime, g) / m;
      let G = Math.floor($), H = $ % 1;
      !H && $ >= 1 && (H = 1), H === 1 && G--, G = Math.min(G, w + 1), !!(G % 2) && (_ === "reverse" ? (H = 1 - H, A && (H -= A / m)) : _ === "mirror" && (M = s)), N = Ih(0, 1, H) * m;
    }
    const P = R ? { done: !1, value: d[0] } : M.next(N);
    c && (P.value = c(P.value));
    let { done: z } = P;
    !R && f !== null && (z = this.speed >= 0 ? this.currentTime >= g : this.currentTime <= 0);
    const F = this.holdTime === null && (this.state === "finished" || this.state === "running" && z);
    return F && i !== void 0 && (P.value = fO(d, this.options, i)), T && T(P.value), F && this.finish(), P;
  }
  get duration() {
    const { resolved: e } = this;
    return e ? /* @__PURE__ */ Th(e.calculatedDuration) : 0;
  }
  get time() {
    return /* @__PURE__ */ Th(this.currentTime);
  }
  set time(e) {
    e = /* @__PURE__ */ Zd(e), this.currentTime = e, this.holdTime !== null || this.speed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = /* @__PURE__ */ Th(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: e = a6e, onPlay: n, startTime: r } = this.options;
    this.driver || (this.driver = e((a) => this.tick(a))), n && n();
    const i = this.driver.now();
    this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = i) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var e;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (e = this.currentTime) !== null && e !== void 0 ? e : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: e } = this.options;
    e && e();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
}
const l6e = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function c6e(t, e, n, { delay: r = 0, duration: i = 300, repeat: a = 0, repeatType: s = "loop", ease: c = "easeInOut", times: d } = {}) {
  const f = { [e]: n };
  d && (f.offset = d);
  const g = oZ(c, i);
  return Array.isArray(g) && (f.easing = g), t.animate(f, {
    delay: r,
    duration: i,
    easing: Array.isArray(g) ? "linear" : g,
    fill: "both",
    iterations: a + 1,
    direction: s === "reverse" ? "alternate" : "normal"
  });
}
const u6e = /* @__PURE__ */ g7(() => Object.hasOwnProperty.call(Element.prototype, "animate")), n5 = 10, d6e = 2e4;
function f6e(t) {
  return N7(t.type) || t.type === "spring" || !aZ(t.ease);
}
function h6e(t, e) {
  const n = new H7({
    ...e,
    keyframes: t,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: t[0] };
  const i = [];
  let a = 0;
  for (; !r.done && a < d6e; )
    r = n.sample(a), i.push(r.value), a += n5;
  return {
    times: void 0,
    keyframes: i,
    duration: a - n5,
    ease: "linear"
  };
}
const VZ = {
  anticipate: yZ,
  backInOut: vZ,
  circInOut: wZ
};
function p6e(t) {
  return t in VZ;
}
class LF extends jZ {
  constructor(e) {
    super(e);
    const { name: n, motionValue: r, element: i, keyframes: a } = this.options;
    this.resolver = new kZ(a, (s, c) => this.onKeyframesResolved(s, c), n, r, i), this.resolver.scheduleResolve();
  }
  initPlayback(e, n) {
    let { duration: r = 300, times: i, ease: a, type: s, motionValue: c, name: d, startTime: f } = this.options;
    if (!c.owner || !c.owner.current)
      return !1;
    if (typeof a == "string" && JT() && p6e(a) && (a = VZ[a]), f6e(this.options)) {
      const { onComplete: m, onUpdate: b, motionValue: w, element: _, ...A } = this.options, T = h6e(e, A);
      e = T.keyframes, e.length === 1 && (e[1] = e[0]), r = T.duration, i = T.times, a = T.ease, s = "keyframes";
    }
    const g = c6e(c.owner.current, d, e, { ...this.options, duration: r, times: i, ease: a });
    return g.startTime = f ?? this.calcStartTime(), this.pendingTimeline ? (wF(g, this.pendingTimeline), this.pendingTimeline = void 0) : g.onfinish = () => {
      const { onComplete: m } = this.options;
      c.set(fO(e, this.options, n)), m && m(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: g,
      duration: r,
      times: i,
      type: s,
      ease: a,
      keyframes: e
    };
  }
  get duration() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { duration: n } = e;
    return /* @__PURE__ */ Th(n);
  }
  get time() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { animation: n } = e;
    return /* @__PURE__ */ Th(n.currentTime || 0);
  }
  set time(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = /* @__PURE__ */ Zd(e);
  }
  get speed() {
    const { resolved: e } = this;
    if (!e)
      return 1;
    const { animation: n } = e;
    return n.playbackRate;
  }
  set speed(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = e;
  }
  get state() {
    const { resolved: e } = this;
    if (!e)
      return "idle";
    const { animation: n } = e;
    return n.playState;
  }
  get startTime() {
    const { resolved: e } = this;
    if (!e)
      return null;
    const { animation: n } = e;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(e) {
    if (!this._resolved)
      this.pendingTimeline = e;
    else {
      const { resolved: n } = this;
      if (!n)
        return ll;
      const { animation: r } = n;
      wF(r, e);
    }
    return ll;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n, keyframes: r, duration: i, type: a, ease: s, times: c } = e;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: f, onUpdate: g, onComplete: m, element: b, ...w } = this.options, _ = new H7({
        ...w,
        keyframes: r,
        duration: i,
        type: a,
        ease: s,
        times: c,
        isGenerator: !0
      }), A = /* @__PURE__ */ Zd(this.time);
      f.setWithVelocity(_.sample(A - n5).value, _.sample(A).value, n5);
    }
    const { onStop: d } = this.options;
    d && d(), this.cancel();
  }
  complete() {
    const { resolved: e } = this;
    e && e.animation.finish();
  }
  cancel() {
    const { resolved: e } = this;
    e && e.animation.cancel();
  }
  static supports(e) {
    const { motionValue: n, name: r, repeatDelay: i, repeatType: a, damping: s, type: c } = e;
    if (!n || !n.owner || !(n.owner.current instanceof HTMLElement))
      return !1;
    const { onUpdate: d, transformTemplate: f } = n.owner.getProps();
    return u6e() && r && l6e.has(r) && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !d && !f && !i && a !== "mirror" && s !== 0 && c !== "inertia";
  }
}
const m6e = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, g6e = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), v6e = {
  type: "keyframes",
  duration: 0.8
}, y6e = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, b6e = (t, { keyframes: e }) => e.length > 2 ? v6e : Fg.has(t) ? t.startsWith("scale") ? g6e(e[1]) : m6e : y6e;
function w6e({ when: t, delay: e, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: a, repeatType: s, repeatDelay: c, from: d, elapsed: f, ...g }) {
  return !!Object.keys(g).length;
}
const q7 = (t, e, n, r = {}, i, a) => (s) => {
  const c = D7(r, t) || {}, d = c.delay || r.delay || 0;
  let { elapsed: f = 0 } = r;
  f = f - /* @__PURE__ */ Zd(d);
  let g = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...c,
    delay: -f,
    onUpdate: (b) => {
      e.set(b), c.onUpdate && c.onUpdate(b);
    },
    onComplete: () => {
      s(), c.onComplete && c.onComplete();
    },
    name: t,
    motionValue: e,
    element: a ? void 0 : i
  };
  w6e(c) || (g = {
    ...g,
    ...b6e(t, g)
  }), g.duration && (g.duration = /* @__PURE__ */ Zd(g.duration)), g.repeatDelay && (g.repeatDelay = /* @__PURE__ */ Zd(g.repeatDelay)), g.from !== void 0 && (g.keyframes[0] = g.from);
  let m = !1;
  if ((g.type === !1 || g.duration === 0 && !g.repeatDelay) && (g.duration = 0, g.delay === 0 && (m = !0)), m && !a && e.get() !== void 0) {
    const b = fO(g.keyframes, c);
    if (b !== void 0)
      return xi.update(() => {
        g.onUpdate(b), g.onComplete();
      }), new zOe([]);
  }
  return !a && LF.supports(g) ? new LF(g) : new H7(g);
};
function x6e({ protectedKeys: t, needsAnimating: e }, n) {
  const r = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, r;
}
function UZ(t, e, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  var a;
  let { transition: s = t.getDefaultTransition(), transitionEnd: c, ...d } = e;
  r && (s = r);
  const f = [], g = i && t.animationState && t.animationState.getState()[i];
  for (const m in d) {
    const b = t.getValue(m, (a = t.latestValues[m]) !== null && a !== void 0 ? a : null), w = d[m];
    if (w === void 0 || g && x6e(g, m))
      continue;
    const _ = {
      delay: n,
      ...D7(s || {}, m)
    };
    let A = !1;
    if (window.MotionHandoffAnimation) {
      const O = fZ(t);
      if (O) {
        const R = window.MotionHandoffAnimation(O, m, xi);
        R !== null && (_.startTime = R, A = !0);
      }
    }
    aN(t, m), b.start(q7(m, b, w, t.shouldReduceMotion && uZ.has(m) ? { type: !1 } : _, t, A));
    const T = b.animation;
    T && f.push(T);
  }
  return c && Promise.all(f).then(() => {
    xi.update(() => {
      c && JOe(t, c);
    });
  }), f;
}
function fN(t, e, n = {}) {
  var r;
  const i = dO(t, e, n.type === "exit" ? (r = t.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: a = t.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (a = n.transitionOverride);
  const s = i ? () => Promise.all(UZ(t, i, n)) : () => Promise.resolve(), c = t.variantChildren && t.variantChildren.size ? (f = 0) => {
    const { delayChildren: g = 0, staggerChildren: m, staggerDirection: b } = a;
    return S6e(t, e, g + f, m, b, n);
  } : () => Promise.resolve(), { when: d } = a;
  if (d) {
    const [f, g] = d === "beforeChildren" ? [s, c] : [c, s];
    return f().then(() => g());
  } else
    return Promise.all([s(), c(n.delay)]);
}
function S6e(t, e, n = 0, r = 0, i = 1, a) {
  const s = [], c = (t.variantChildren.size - 1) * r, d = i === 1 ? (f = 0) => f * r : (f = 0) => c - f * r;
  return Array.from(t.variantChildren).sort(E6e).forEach((f, g) => {
    f.notify("AnimationStart", e), s.push(fN(f, e, {
      ...a,
      delay: n + d(g)
    }).then(() => f.notify("AnimationComplete", e)));
  }), Promise.all(s);
}
function E6e(t, e) {
  return t.sortNodePosition(e);
}
function _6e(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let r;
  if (Array.isArray(e)) {
    const i = e.map((a) => fN(t, a, n));
    r = Promise.all(i);
  } else if (typeof e == "string")
    r = fN(t, e, n);
  else {
    const i = typeof e == "function" ? dO(t, e, n.custom) : e;
    r = Promise.all(UZ(t, i, n));
  }
  return r.then(() => {
    t.notify("AnimationComplete", e);
  });
}
const A6e = y7.length;
function $Z(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const n = t.parent ? $Z(t.parent) || {} : {};
    return t.props.initial !== void 0 && (n.initial = t.props.initial), n;
  }
  const e = {};
  for (let n = 0; n < A6e; n++) {
    const r = y7[n], i = t.props[r];
    (e_(i) || i === !1) && (e[r] = i);
  }
  return e;
}
const C6e = [...v7].reverse(), T6e = v7.length;
function O6e(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: r }) => _6e(t, n, r)));
}
function R6e(t) {
  let e = O6e(t), n = BF(), r = !0;
  const i = (d) => (f, g) => {
    var m;
    const b = dO(t, g, d === "exit" ? (m = t.presenceContext) === null || m === void 0 ? void 0 : m.custom : void 0);
    if (b) {
      const { transition: w, transitionEnd: _, ...A } = b;
      f = { ...f, ...A, ..._ };
    }
    return f;
  };
  function a(d) {
    e = d(t);
  }
  function s(d) {
    const { props: f } = t, g = $Z(t.parent) || {}, m = [], b = /* @__PURE__ */ new Set();
    let w = {}, _ = 1 / 0;
    for (let T = 0; T < T6e; T++) {
      const O = C6e[T], R = n[O], N = f[O] !== void 0 ? f[O] : g[O], M = e_(N), P = O === d ? R.isActive : null;
      P === !1 && (_ = T);
      let z = N === g[O] && N !== f[O] && M;
      if (z && r && t.manuallyAnimateOnMount && (z = !1), R.protectedKeys = { ...w }, // If it isn't active and hasn't *just* been set as inactive
      !R.isActive && P === null || // If we didn't and don't have any defined prop for this animation type
      !N && !R.prevProp || // Or if the prop doesn't define an animation
      cO(N) || typeof N == "boolean")
        continue;
      const F = D6e(R.prevProp, N);
      let $ = F || // If we're making this variant active, we want to always make it active
      O === d && R.isActive && !z && M || // If we removed a higher-priority variant (i is in reverse order)
      T > _ && M, G = !1;
      const H = Array.isArray(N) ? N : [N];
      let Z = H.reduce(i(O), {});
      P === !1 && (Z = {});
      const { prevResolvedValues: V = {} } = R, Y = {
        ...V,
        ...Z
      }, ee = (q) => {
        $ = !0, b.has(q) && (G = !0, b.delete(q)), R.needsAnimating[q] = !0;
        const W = t.getValue(q);
        W && (W.liveStyle = !1);
      };
      for (const q in Y) {
        const W = Z[q], ie = V[q];
        if (w.hasOwnProperty(q))
          continue;
        let J = !1;
        nN(W) && nN(ie) ? J = !nZ(W, ie) : J = W !== ie, J ? W != null ? ee(q) : b.add(q) : W !== void 0 && b.has(q) ? ee(q) : R.protectedKeys[q] = !0;
      }
      R.prevProp = N, R.prevResolvedValues = Z, R.isActive && (w = { ...w, ...Z }), r && t.blockInitialAnimation && ($ = !1), $ && (!(z && F) || G) && m.push(...H.map((q) => ({
        animation: q,
        options: { type: O }
      })));
    }
    if (b.size) {
      const T = {};
      b.forEach((O) => {
        const R = t.getBaseTarget(O), N = t.getValue(O);
        N && (N.liveStyle = !0), T[O] = R ?? null;
      }), m.push({ animation: T });
    }
    let A = !!m.length;
    return r && (f.initial === !1 || f.initial === f.animate) && !t.manuallyAnimateOnMount && (A = !1), r = !1, A ? e(m) : Promise.resolve();
  }
  function c(d, f) {
    var g;
    if (n[d].isActive === f)
      return Promise.resolve();
    (g = t.variantChildren) === null || g === void 0 || g.forEach((b) => {
      var w;
      return (w = b.animationState) === null || w === void 0 ? void 0 : w.setActive(d, f);
    }), n[d].isActive = f;
    const m = s(d);
    for (const b in n)
      n[b].protectedKeys = {};
    return m;
  }
  return {
    animateChanges: s,
    setActive: c,
    setAnimateFunction: a,
    getState: () => n,
    reset: () => {
      n = BF(), r = !0;
    }
  };
}
function D6e(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !nZ(e, t) : !1;
}
function V1(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function BF() {
  return {
    animate: V1(!0),
    whileInView: V1(),
    whileHover: V1(),
    whileTap: V1(),
    whileDrag: V1(),
    whileFocus: V1(),
    exit: V1()
  };
}
class em {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
class N6e extends em {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = R6e(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    cO(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) === null || e === void 0 || e.call(this);
  }
}
let M6e = 0;
class I6e extends em {
  constructor() {
    super(...arguments), this.id = M6e++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === r)
      return;
    const i = this.node.animationState.setActive("exit", !e);
    n && !e && i.then(() => n(this.id));
  }
  mount() {
    const { register: e } = this.node.presenceContext || {};
    e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const k6e = {
  animation: {
    Feature: N6e
  },
  exit: {
    Feature: I6e
  }
};
function i_(t, e, n, r = { passive: !0 }) {
  return t.addEventListener(e, n, r), () => t.removeEventListener(e, n);
}
function L_(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const j6e = (t) => (e) => I7(e) && t(e, L_(e));
function bE(t, e, n, r) {
  return i_(t, e, j6e(n), r);
}
const zF = (t, e) => Math.abs(t - e);
function P6e(t, e) {
  const n = zF(t.x, e.x), r = zF(t.y, e.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class HZ {
  constructor(e, n, { transformPagePoint: r, contextWindow: i, dragSnapToOrigin: a = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const m = oD(this.lastMoveEventInfo, this.history), b = this.startEvent !== null, w = P6e(m.offset, { x: 0, y: 0 }) >= 3;
      if (!b && !w)
        return;
      const { point: _ } = m, { timestamp: A } = Io;
      this.history.push({ ..._, timestamp: A });
      const { onStart: T, onMove: O } = this.handlers;
      b || (T && T(this.lastMoveEvent, m), this.startEvent = this.lastMoveEvent), O && O(this.lastMoveEvent, m);
    }, this.handlePointerMove = (m, b) => {
      this.lastMoveEvent = m, this.lastMoveEventInfo = aD(b, this.transformPagePoint), xi.update(this.updatePoint, !0);
    }, this.handlePointerUp = (m, b) => {
      this.end();
      const { onEnd: w, onSessionEnd: _, resumeAnimation: A } = this.handlers;
      if (this.dragSnapToOrigin && A && A(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const T = oD(m.type === "pointercancel" ? this.lastMoveEventInfo : aD(b, this.transformPagePoint), this.history);
      this.startEvent && w && w(m, T), _ && _(m, T);
    }, !I7(e))
      return;
    this.dragSnapToOrigin = a, this.handlers = n, this.transformPagePoint = r, this.contextWindow = i || window;
    const s = L_(e), c = aD(s, this.transformPagePoint), { point: d } = c, { timestamp: f } = Io;
    this.history = [{ ...d, timestamp: f }];
    const { onSessionStart: g } = n;
    g && g(e, oD(c, this.history)), this.removeListeners = P_(bE(this.contextWindow, "pointermove", this.handlePointerMove), bE(this.contextWindow, "pointerup", this.handlePointerUp), bE(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), W0(this.updatePoint);
  }
}
function aD(t, e) {
  return e ? { point: e(t.point) } : t;
}
function FF(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function oD({ point: t }, e) {
  return {
    point: t,
    delta: FF(t, qZ(e)),
    offset: FF(t, L6e(e)),
    velocity: B6e(e, 0.1)
  };
}
function L6e(t) {
  return t[0];
}
function qZ(t) {
  return t[t.length - 1];
}
function B6e(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, r = null;
  const i = qZ(t);
  for (; n >= 0 && (r = t[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ Zd(e))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const a = /* @__PURE__ */ Th(i.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const s = {
    x: (i.x - r.x) / a,
    y: (i.y - r.y) / a
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
const GZ = 1e-4, z6e = 1 - GZ, F6e = 1 + GZ, YZ = 0.01, V6e = 0 - YZ, U6e = 0 + YZ;
function Ql(t) {
  return t.max - t.min;
}
function $6e(t, e, n) {
  return Math.abs(t - e) <= n;
}
function VF(t, e, n, r = 0.5) {
  t.origin = r, t.originPoint = Vi(e.min, e.max, t.origin), t.scale = Ql(n) / Ql(e), t.translate = Vi(n.min, n.max, t.origin) - t.originPoint, (t.scale >= z6e && t.scale <= F6e || isNaN(t.scale)) && (t.scale = 1), (t.translate >= V6e && t.translate <= U6e || isNaN(t.translate)) && (t.translate = 0);
}
function wE(t, e, n, r) {
  VF(t.x, e.x, n.x, r ? r.originX : void 0), VF(t.y, e.y, n.y, r ? r.originY : void 0);
}
function UF(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + Ql(e);
}
function H6e(t, e, n) {
  UF(t.x, e.x, n.x), UF(t.y, e.y, n.y);
}
function $F(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + Ql(e);
}
function xE(t, e, n) {
  $F(t.x, e.x, n.x), $F(t.y, e.y, n.y);
}
function q6e(t, { min: e, max: n }, r) {
  return e !== void 0 && t < e ? t = r ? Vi(e, t, r.min) : Math.max(t, e) : n !== void 0 && t > n && (t = r ? Vi(n, t, r.max) : Math.min(t, n)), t;
}
function HF(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function G6e(t, { top: e, left: n, bottom: r, right: i }) {
  return {
    x: HF(t.x, n, i),
    y: HF(t.y, e, r)
  };
}
function qF(t, e) {
  let n = e.min - t.min, r = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, r] = [r, n]), { min: n, max: r };
}
function Y6e(t, e) {
  return {
    x: qF(t.x, e.x),
    y: qF(t.y, e.y)
  };
}
function X6e(t, e) {
  let n = 0.5;
  const r = Ql(t), i = Ql(e);
  return i > r ? n = /* @__PURE__ */ Zb(e.min, e.max - r, t.min) : r > i && (n = /* @__PURE__ */ Zb(t.min, t.max - i, e.min)), Ih(0, 1, n);
}
function W6e(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const hN = 0.35;
function Q6e(t = hN) {
  return t === !1 ? t = 0 : t === !0 && (t = hN), {
    x: GF(t, "left", "right"),
    y: GF(t, "top", "bottom")
  };
}
function GF(t, e, n) {
  return {
    min: YF(t, e),
    max: YF(t, n)
  };
}
function YF(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const XF = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), _b = () => ({
  x: XF(),
  y: XF()
}), WF = () => ({ min: 0, max: 0 }), na = () => ({
  x: WF(),
  y: WF()
});
function Fc(t) {
  return [t("x"), t("y")];
}
function XZ({ top: t, left: e, right: n, bottom: r }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: r }
  };
}
function Z6e({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function K6e(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), r = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function sD(t) {
  return t === void 0 || t === 1;
}
function pN({ scale: t, scaleX: e, scaleY: n }) {
  return !sD(t) || !sD(e) || !sD(n);
}
function Y1(t) {
  return pN(t) || WZ(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function WZ(t) {
  return QF(t.x) || QF(t.y);
}
function QF(t) {
  return t && t !== "0%";
}
function r5(t, e, n) {
  const r = t - n, i = e * r;
  return n + i;
}
function ZF(t, e, n, r, i) {
  return i !== void 0 && (t = r5(t, i, r)), r5(t, n, r) + e;
}
function mN(t, e = 0, n = 1, r, i) {
  t.min = ZF(t.min, e, n, r, i), t.max = ZF(t.max, e, n, r, i);
}
function QZ(t, { x: e, y: n }) {
  mN(t.x, e.translate, e.scale, e.originPoint), mN(t.y, n.translate, n.scale, n.originPoint);
}
const KF = 0.999999999999, JF = 1.0000000000001;
function J6e(t, e, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  e.x = e.y = 1;
  let a, s;
  for (let c = 0; c < i; c++) {
    a = n[c], s = a.projectionDelta;
    const { visualElement: d } = a.options;
    d && d.props.style && d.props.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && Cb(t, {
      x: -a.scroll.offset.x,
      y: -a.scroll.offset.y
    }), s && (e.x *= s.x.scale, e.y *= s.y.scale, QZ(t, s)), r && Y1(a.latestValues) && Cb(t, a.latestValues));
  }
  e.x < JF && e.x > KF && (e.x = 1), e.y < JF && e.y > KF && (e.y = 1);
}
function Ab(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function eV(t, e, n, r, i = 0.5) {
  const a = Vi(t.min, t.max, i);
  mN(t, e, n, a, r);
}
function Cb(t, e) {
  eV(t.x, e.x, e.scaleX, e.scale, e.originX), eV(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function ZZ(t, e) {
  return XZ(K6e(t.getBoundingClientRect(), e));
}
function eDe(t, e, n) {
  const r = ZZ(t, n), { scroll: i } = e;
  return i && (Ab(r.x, i.offset.x), Ab(r.y, i.offset.y)), r;
}
const KZ = ({ current: t }) => t ? t.ownerDocument.defaultView : null, tDe = /* @__PURE__ */ new WeakMap();
class nDe {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = na(), this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const i = (g) => {
      const { dragSnapToOrigin: m } = this.getProps();
      m ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(L_(g).point);
    }, a = (g, m) => {
      const { drag: b, dragPropagation: w, onDragStart: _ } = this.getProps();
      if (b && !w && (this.openDragLock && this.openDragLock(), this.openDragLock = XOe(b), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Fc((T) => {
        let O = this.getAxisMotionValue(T).get() || 0;
        if (Kd.test(O)) {
          const { projection: R } = this.visualElement;
          if (R && R.layout) {
            const N = R.layout.layoutBox[T];
            N && (O = Ql(N) * (parseFloat(O) / 100));
          }
        }
        this.originPoint[T] = O;
      }), _ && xi.postRender(() => _(g, m)), aN(this.visualElement, "transform");
      const { animationState: A } = this.visualElement;
      A && A.setActive("whileDrag", !0);
    }, s = (g, m) => {
      const { dragPropagation: b, dragDirectionLock: w, onDirectionLock: _, onDrag: A } = this.getProps();
      if (!b && !this.openDragLock)
        return;
      const { offset: T } = m;
      if (w && this.currentDirection === null) {
        this.currentDirection = rDe(T), this.currentDirection !== null && _ && _(this.currentDirection);
        return;
      }
      this.updateAxis("x", m.point, T), this.updateAxis("y", m.point, T), this.visualElement.render(), A && A(g, m);
    }, c = (g, m) => this.stop(g, m), d = () => Fc((g) => {
      var m;
      return this.getAnimationState(g) === "paused" && ((m = this.getAxisMotionValue(g).animation) === null || m === void 0 ? void 0 : m.play());
    }), { dragSnapToOrigin: f } = this.getProps();
    this.panSession = new HZ(e, {
      onSessionStart: i,
      onStart: a,
      onMove: s,
      onSessionEnd: c,
      resumeAnimation: d
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: f,
      contextWindow: KZ(this.visualElement)
    });
  }
  stop(e, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: i } = n;
    this.startAnimation(i);
    const { onDragEnd: a } = this.getProps();
    a && xi.postRender(() => a(e, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !$C(e, i, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(e);
    let s = this.originPoint[e] + r[e];
    this.constraints && this.constraints[e] && (s = q6e(s, this.constraints[e], this.elastic[e])), a.set(s);
  }
  resolveConstraints() {
    var e;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (e = this.visualElement.projection) === null || e === void 0 ? void 0 : e.layout, a = this.constraints;
    n && Sb(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = G6e(i.layoutBox, n) : this.constraints = !1, this.elastic = Q6e(r), a !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && Fc((s) => {
      this.constraints !== !1 && this.getAxisMotionValue(s) && (this.constraints[s] = W6e(i.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !Sb(e))
      return !1;
    const r = e.current;
    X0(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const a = eDe(r, i.root, this.visualElement.getTransformPagePoint());
    let s = Y6e(i.layout.layoutBox, a);
    if (n) {
      const c = n(Z6e(s));
      this.hasMutatedConstraints = !!c, c && (s = XZ(c));
    }
    return s;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: a, dragSnapToOrigin: s, onDragTransitionEnd: c } = this.getProps(), d = this.constraints || {}, f = Fc((g) => {
      if (!$C(g, n, this.currentDirection))
        return;
      let m = d && d[g] || {};
      s && (m = { min: 0, max: 0 });
      const b = i ? 200 : 1e6, w = i ? 40 : 1e7, _ = {
        type: "inertia",
        velocity: r ? e[g] : 0,
        bounceStiffness: b,
        bounceDamping: w,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...m
      };
      return this.startAxisValueAnimation(g, _);
    });
    return Promise.all(f).then(c);
  }
  startAxisValueAnimation(e, n) {
    const r = this.getAxisMotionValue(e);
    return aN(this.visualElement, e), r.start(q7(e, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    Fc((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    Fc((e) => {
      var n;
      return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(e) {
    var n;
    return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, r = this.visualElement.getProps(), i = r[n];
    return i || this.visualElement.getValue(e, (r.initial ? r.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    Fc((n) => {
      const { drag: r } = this.getProps();
      if (!$C(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, a = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: s, max: c } = i.layout.layoutBox[n];
        a.set(e[n] - Vi(s, c, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!Sb(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    Fc((s) => {
      const c = this.getAxisMotionValue(s);
      if (c && this.constraints !== !1) {
        const d = c.get();
        i[s] = X6e({ min: d, max: d }, this.constraints[s]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), Fc((s) => {
      if (!$C(s, e, null))
        return;
      const c = this.getAxisMotionValue(s), { min: d, max: f } = this.constraints[s];
      c.set(Vi(d, f, i[s]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    tDe.set(this.visualElement, this);
    const e = this.visualElement.current, n = bE(e, "pointerdown", (d) => {
      const { drag: f, dragListener: g = !0 } = this.getProps();
      f && g && this.start(d);
    }), r = () => {
      const { dragConstraints: d } = this.getProps();
      Sb(d) && d.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, a = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), xi.read(r);
    const s = i_(window, "resize", () => this.scalePositionWithinConstraints()), c = i.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: f }) => {
      this.isDragging && f && (Fc((g) => {
        const m = this.getAxisMotionValue(g);
        m && (this.originPoint[g] += d[g].translate, m.set(m.get() + d[g].translate));
      }), this.visualElement.render());
    });
    return () => {
      s(), n(), a(), c && c();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: a = !1, dragElastic: s = hN, dragMomentum: c = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: a,
      dragElastic: s,
      dragMomentum: c
    };
  }
}
function $C(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function rDe(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class iDe extends em {
  constructor(e) {
    super(e), this.removeGroupControls = ll, this.removeListeners = ll, this.controls = new nDe(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || ll;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const tV = (t) => (e, n) => {
  t && xi.postRender(() => t(e, n));
};
class aDe extends em {
  constructor() {
    super(...arguments), this.removePointerDownListener = ll;
  }
  onPointerDown(e) {
    this.session = new HZ(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: KZ(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: tV(e),
      onStart: tV(n),
      onMove: r,
      onEnd: (a, s) => {
        delete this.session, i && xi.postRender(() => i(a, s));
      }
    };
  }
  mount() {
    this.removePointerDownListener = bE(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const O4 = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function nV(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const FS = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (Qt.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = nV(t, e.target.x), r = nV(t, e.target.y);
    return `${n}% ${r}%`;
  }
}, oDe = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const r = t, i = Q0.parse(t);
    if (i.length > 5)
      return r;
    const a = Q0.createTransformer(t), s = typeof i[0] != "number" ? 1 : 0, c = n.x.scale * e.x, d = n.y.scale * e.y;
    i[0 + s] /= c, i[1 + s] /= d;
    const f = Vi(c, d, 0.5);
    return typeof i[2 + s] == "number" && (i[2 + s] /= f), typeof i[3 + s] == "number" && (i[3 + s] /= f), a(i);
  }
};
class sDe extends I.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: a } = e;
    TOe(lDe), a && (n.group && n.group.add(a), r && r.register && i && r.register(a), a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      onExitComplete: () => this.safeToRemove()
    })), O4.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: a } = this.props, s = r.projection;
    return s && (s.isPresent = a, i || e.layoutDependency !== n || n === void 0 ? s.willUpdate() : this.safeToRemove(), e.isPresent !== a && (a ? s.promote() : s.relegate() || xi.postRender(() => {
      const c = s.getStack();
      (!c || !c.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), w7.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = e;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function JZ(t) {
  const [e, n] = jQ(), r = I.useContext(f7);
  return C.jsx(sDe, { ...t, layoutGroup: r, switchLayoutGroup: I.useContext($Q), isPresent: e, safeToRemove: n });
}
const lDe = {
  borderRadius: {
    ...FS,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: FS,
  borderTopRightRadius: FS,
  borderBottomLeftRadius: FS,
  borderBottomRightRadius: FS,
  boxShadow: oDe
};
function cDe(t, e, n) {
  const r = Ko(t) ? t : n_(t);
  return r.start(q7("", r, e, n)), r.animation;
}
function uDe(t) {
  return t instanceof SVGElement && t.tagName !== "svg";
}
const dDe = (t, e) => t.depth - e.depth;
class fDe {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    k7(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    j7(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(dDe), this.isDirty = !1, this.children.forEach(e);
  }
}
function hDe(t, e) {
  const n = Jd.now(), r = ({ timestamp: i }) => {
    const a = i - n;
    a >= e && (W0(r), t(a - e));
  };
  return xi.read(r, !0), () => W0(r);
}
const eK = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], pDe = eK.length, rV = (t) => typeof t == "string" ? parseFloat(t) : t, iV = (t) => typeof t == "number" || Qt.test(t);
function mDe(t, e, n, r, i, a) {
  i ? (t.opacity = Vi(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    gDe(r)
  ), t.opacityExit = Vi(e.opacity !== void 0 ? e.opacity : 1, 0, vDe(r))) : a && (t.opacity = Vi(e.opacity !== void 0 ? e.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let s = 0; s < pDe; s++) {
    const c = `border${eK[s]}Radius`;
    let d = aV(e, c), f = aV(n, c);
    if (d === void 0 && f === void 0)
      continue;
    d || (d = 0), f || (f = 0), d === 0 || f === 0 || iV(d) === iV(f) ? (t[c] = Math.max(Vi(rV(d), rV(f), r), 0), (Kd.test(f) || Kd.test(d)) && (t[c] += "%")) : t[c] = f;
  }
  (e.rotate || n.rotate) && (t.rotate = Vi(e.rotate || 0, n.rotate || 0, r));
}
function aV(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const gDe = /* @__PURE__ */ tK(0, 0.5, bZ), vDe = /* @__PURE__ */ tK(0.5, 0.95, ll);
function tK(t, e, n) {
  return (r) => r < t ? 0 : r > e ? 1 : n(/* @__PURE__ */ Zb(t, e, r));
}
function oV(t, e) {
  t.min = e.min, t.max = e.max;
}
function zc(t, e) {
  oV(t.x, e.x), oV(t.y, e.y);
}
function sV(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function lV(t, e, n, r, i) {
  return t -= e, t = r5(t, 1 / n, r), i !== void 0 && (t = r5(t, 1 / i, r)), t;
}
function yDe(t, e = 0, n = 1, r = 0.5, i, a = t, s = t) {
  if (Kd.test(e) && (e = parseFloat(e), e = Vi(s.min, s.max, e / 100) - s.min), typeof e != "number")
    return;
  let c = Vi(a.min, a.max, r);
  t === a && (c -= e), t.min = lV(t.min, e, n, c, i), t.max = lV(t.max, e, n, c, i);
}
function cV(t, e, [n, r, i], a, s) {
  yDe(t, e[n], e[r], e[i], e.scale, a, s);
}
const bDe = ["x", "scaleX", "originX"], wDe = ["y", "scaleY", "originY"];
function uV(t, e, n, r) {
  cV(t.x, e, bDe, n ? n.x : void 0, r ? r.x : void 0), cV(t.y, e, wDe, n ? n.y : void 0, r ? r.y : void 0);
}
function dV(t) {
  return t.translate === 0 && t.scale === 1;
}
function nK(t) {
  return dV(t.x) && dV(t.y);
}
function fV(t, e) {
  return t.min === e.min && t.max === e.max;
}
function xDe(t, e) {
  return fV(t.x, e.x) && fV(t.y, e.y);
}
function hV(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function rK(t, e) {
  return hV(t.x, e.x) && hV(t.y, e.y);
}
function pV(t) {
  return Ql(t.x) / Ql(t.y);
}
function mV(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class SDe {
  constructor() {
    this.members = [];
  }
  add(e) {
    k7(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (j7(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((i) => e === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const a = this.members[i];
      if (a.isPresent !== !1) {
        r = a;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(e, n) {
    const r = this.lead;
    if (e !== r && (this.prevLead = r, this.lead = e, e.show(), r)) {
      r.instance && r.scheduleRender(), e.scheduleRender(), e.resumeFrom = r, n && (e.resumeFrom.preserveOpacity = !0), r.snapshot && (e.snapshot = r.snapshot, e.snapshot.latestValues = r.animationValues || r.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: i } = e.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: r } = e;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function EDe(t, e, n) {
  let r = "";
  const i = t.x.translate / e.x, a = t.y.translate / e.y, s = n?.z || 0;
  if ((i || a || s) && (r = `translate3d(${i}px, ${a}px, ${s}px) `), (e.x !== 1 || e.y !== 1) && (r += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: f, rotate: g, rotateX: m, rotateY: b, skewX: w, skewY: _ } = n;
    f && (r = `perspective(${f}px) ${r}`), g && (r += `rotate(${g}deg) `), m && (r += `rotateX(${m}deg) `), b && (r += `rotateY(${b}deg) `), w && (r += `skewX(${w}deg) `), _ && (r += `skewY(${_}deg) `);
  }
  const c = t.x.scale * e.x, d = t.y.scale * e.y;
  return (c !== 1 || d !== 1) && (r += `scale(${c}, ${d})`), r || "none";
}
const X1 = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, rE = typeof window < "u" && window.MotionDebug !== void 0, lD = ["", "X", "Y", "Z"], _De = { visibility: "hidden" }, gV = 1e3;
let ADe = 0;
function cD(t, e, n, r) {
  const { latestValues: i } = e;
  i[t] && (n[t] = i[t], e.setStaticValue(t, 0), r && (r[t] = 0));
}
function iK(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const n = fZ(e);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: a } = t.options;
    window.MotionCancelOptimisedAnimation(n, "transform", xi, !(i || a));
  }
  const { parent: r } = t;
  r && !r.hasCheckedOptimisedAppear && iK(r);
}
function aK({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(s = {}, c = e?.()) {
      this.id = ADe++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, rE && (X1.totalNodes = X1.resolvedTargetDeltas = X1.recalculatedProjection = 0), this.nodes.forEach(ODe), this.nodes.forEach(IDe), this.nodes.forEach(kDe), this.nodes.forEach(RDe), rE && window.MotionDebug.record(X1);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = s, this.root = c ? c.root || c : this, this.path = c ? [...c.path, c] : [], this.parent = c, this.depth = c ? c.depth + 1 : 0;
      for (let d = 0; d < this.path.length; d++)
        this.path[d].shouldResetTransform = !0;
      this.root === this && (this.nodes = new fDe());
    }
    addEventListener(s, c) {
      return this.eventHandlers.has(s) || this.eventHandlers.set(s, new P7()), this.eventHandlers.get(s).add(c);
    }
    notifyListeners(s, ...c) {
      const d = this.eventHandlers.get(s);
      d && d.notify(...c);
    }
    hasListeners(s) {
      return this.eventHandlers.has(s);
    }
    /**
     * Lifecycles
     */
    mount(s, c = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = uDe(s), this.instance = s;
      const { layoutId: d, layout: f, visualElement: g } = this.options;
      if (g && !g.current && g.mount(s), this.root.nodes.add(this), this.parent && this.parent.children.add(this), c && (f || d) && (this.isLayoutDirty = !0), t) {
        let m;
        const b = () => this.root.updateBlockedByResize = !1;
        t(s, () => {
          this.root.updateBlockedByResize = !0, m && m(), m = hDe(b, 250), O4.hasAnimatedSinceResize && (O4.hasAnimatedSinceResize = !1, this.nodes.forEach(yV));
        });
      }
      d && this.root.registerSharedNode(d, this), this.options.animate !== !1 && g && (d || f) && this.addEventListener("didUpdate", ({ delta: m, hasLayoutChanged: b, hasRelativeTargetChanged: w, layout: _ }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const A = this.options.transition || g.getDefaultTransition() || zDe, { onLayoutAnimationStart: T, onLayoutAnimationComplete: O } = g.getProps(), R = !this.targetLayout || !rK(this.targetLayout, _) || w, N = !b && w;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || N || b && (R || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(m, N);
          const M = {
            ...D7(A, "layout"),
            onPlay: T,
            onComplete: O
          };
          (g.shouldReduceMotion || this.options.layoutRoot) && (M.delay = 0, M.type = !1), this.startAnimation(M);
        } else
          b || yV(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = _;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const s = this.getStack();
      s && s.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, W0(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(jDe), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: s } = this.options;
      return s && s.getProps().transformTemplate;
    }
    willUpdate(s = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && iK(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let g = 0; g < this.path.length; g++) {
        const m = this.path[g];
        m.shouldResetTransform = !0, m.updateScroll("snapshot"), m.options.layoutRoot && m.willUpdate(!1);
      }
      const { layoutId: c, layout: d } = this.options;
      if (c === void 0 && !d)
        return;
      const f = this.getTransformTemplate();
      this.prevTransformTemplateValue = f ? f(this.latestValues, "") : void 0, this.updateSnapshot(), s && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(vV);
        return;
      }
      this.isUpdating || this.nodes.forEach(NDe), this.isUpdating = !1, this.nodes.forEach(MDe), this.nodes.forEach(CDe), this.nodes.forEach(TDe), this.clearAllSnapshots();
      const c = Jd.now();
      Io.delta = Ih(0, 1e3 / 60, c - Io.timestamp), Io.timestamp = c, Io.isProcessing = !0, J6.update.process(Io), J6.preRender.process(Io), J6.render.process(Io), Io.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, w7.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(DDe), this.sharedNodes.forEach(PDe);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, xi.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      xi.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let d = 0; d < this.path.length; d++)
          this.path[d].updateScroll();
      const s = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = na(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: c } = this.options;
      c && c.notify("LayoutMeasure", this.layout.layoutBox, s ? s.layoutBox : void 0);
    }
    updateScroll(s = "measure") {
      let c = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === s && (c = !1), c) {
        const d = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: s,
          isRoot: d,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : d
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const s = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, c = this.projectionDelta && !nK(this.projectionDelta), d = this.getTransformTemplate(), f = d ? d(this.latestValues, "") : void 0, g = f !== this.prevTransformTemplateValue;
      s && (c || Y1(this.latestValues) || g) && (i(this.instance, f), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(s = !0) {
      const c = this.measurePageBox();
      let d = this.removeElementScroll(c);
      return s && (d = this.removeTransform(d)), FDe(d), {
        animationId: this.root.animationId,
        measuredBox: c,
        layoutBox: d,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var s;
      const { visualElement: c } = this.options;
      if (!c)
        return na();
      const d = c.measureViewportBox();
      if (!(((s = this.scroll) === null || s === void 0 ? void 0 : s.wasRoot) || this.path.some(VDe))) {
        const { scroll: g } = this.root;
        g && (Ab(d.x, g.offset.x), Ab(d.y, g.offset.y));
      }
      return d;
    }
    removeElementScroll(s) {
      var c;
      const d = na();
      if (zc(d, s), !((c = this.scroll) === null || c === void 0) && c.wasRoot)
        return d;
      for (let f = 0; f < this.path.length; f++) {
        const g = this.path[f], { scroll: m, options: b } = g;
        g !== this.root && m && b.layoutScroll && (m.wasRoot && zc(d, s), Ab(d.x, m.offset.x), Ab(d.y, m.offset.y));
      }
      return d;
    }
    applyTransform(s, c = !1) {
      const d = na();
      zc(d, s);
      for (let f = 0; f < this.path.length; f++) {
        const g = this.path[f];
        !c && g.options.layoutScroll && g.scroll && g !== g.root && Cb(d, {
          x: -g.scroll.offset.x,
          y: -g.scroll.offset.y
        }), Y1(g.latestValues) && Cb(d, g.latestValues);
      }
      return Y1(this.latestValues) && Cb(d, this.latestValues), d;
    }
    removeTransform(s) {
      const c = na();
      zc(c, s);
      for (let d = 0; d < this.path.length; d++) {
        const f = this.path[d];
        if (!f.instance || !Y1(f.latestValues))
          continue;
        pN(f.latestValues) && f.updateSnapshot();
        const g = na(), m = f.measurePageBox();
        zc(g, m), uV(c, f.latestValues, f.snapshot ? f.snapshot.layoutBox : void 0, g);
      }
      return Y1(this.latestValues) && uV(c, this.latestValues), c;
    }
    setTargetDelta(s) {
      this.targetDelta = s, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(s) {
      this.options = {
        ...this.options,
        ...s,
        crossfade: s.crossfade !== void 0 ? s.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Io.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(s = !1) {
      var c;
      const d = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = d.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = d.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = d.isSharedProjectionDirty);
      const f = !!this.resumingFrom || this !== d;
      if (!(s || f && this.isSharedProjectionDirty || this.isProjectionDirty || !((c = this.parent) === null || c === void 0) && c.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: m, layoutId: b } = this.options;
      if (!(!this.layout || !(m || b))) {
        if (this.resolvedRelativeTargetAt = Io.timestamp, !this.targetDelta && !this.relativeTarget) {
          const w = this.getClosestProjectingParent();
          w && w.layout && this.animationProgress !== 1 ? (this.relativeParent = w, this.forceRelativeParentToResolveTarget(), this.relativeTarget = na(), this.relativeTargetOrigin = na(), xE(this.relativeTargetOrigin, this.layout.layoutBox, w.layout.layoutBox), zc(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = na(), this.targetWithTransforms = na()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), H6e(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : zc(this.target, this.layout.layoutBox), QZ(this.target, this.targetDelta)) : zc(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const w = this.getClosestProjectingParent();
            w && !!w.resumingFrom == !!this.resumingFrom && !w.options.layoutScroll && w.target && this.animationProgress !== 1 ? (this.relativeParent = w, this.forceRelativeParentToResolveTarget(), this.relativeTarget = na(), this.relativeTargetOrigin = na(), xE(this.relativeTargetOrigin, this.target, w.target), zc(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          rE && X1.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || pN(this.parent.latestValues) || WZ(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var s;
      const c = this.getLead(), d = !!this.resumingFrom || this !== c;
      let f = !0;
      if ((this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty) && (f = !1), d && (this.isSharedProjectionDirty || this.isTransformDirty) && (f = !1), this.resolvedRelativeTargetAt === Io.timestamp && (f = !1), f)
        return;
      const { layout: g, layoutId: m } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(g || m))
        return;
      zc(this.layoutCorrected, this.layout.layoutBox);
      const b = this.treeScale.x, w = this.treeScale.y;
      J6e(this.layoutCorrected, this.treeScale, this.path, d), c.layout && !c.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (c.target = c.layout.layoutBox, c.targetWithTransforms = na());
      const { target: _ } = c;
      if (!_) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (sV(this.prevProjectionDelta.x, this.projectionDelta.x), sV(this.prevProjectionDelta.y, this.projectionDelta.y)), wE(this.projectionDelta, this.layoutCorrected, _, this.latestValues), (this.treeScale.x !== b || this.treeScale.y !== w || !mV(this.projectionDelta.x, this.prevProjectionDelta.x) || !mV(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", _)), rE && X1.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(s = !0) {
      var c;
      if ((c = this.options.visualElement) === null || c === void 0 || c.scheduleRender(), s) {
        const d = this.getStack();
        d && d.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = _b(), this.projectionDelta = _b(), this.projectionDeltaWithTransform = _b();
    }
    setAnimationOrigin(s, c = !1) {
      const d = this.snapshot, f = d ? d.latestValues : {}, g = { ...this.latestValues }, m = _b();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !c;
      const b = na(), w = d ? d.source : void 0, _ = this.layout ? this.layout.source : void 0, A = w !== _, T = this.getStack(), O = !T || T.members.length <= 1, R = !!(A && !O && this.options.crossfade === !0 && !this.path.some(BDe));
      this.animationProgress = 0;
      let N;
      this.mixTargetDelta = (M) => {
        const P = M / 1e3;
        bV(m.x, s.x, P), bV(m.y, s.y, P), this.setTargetDelta(m), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (xE(b, this.layout.layoutBox, this.relativeParent.layout.layoutBox), LDe(this.relativeTarget, this.relativeTargetOrigin, b, P), N && xDe(this.relativeTarget, N) && (this.isProjectionDirty = !1), N || (N = na()), zc(N, this.relativeTarget)), A && (this.animationValues = g, mDe(g, f, this.latestValues, P, R, O)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = P;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(s) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (W0(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = xi.update(() => {
        O4.hasAnimatedSinceResize = !0, this.currentAnimation = cDe(0, gV, {
          ...s,
          onUpdate: (c) => {
            this.mixTargetDelta(c), s.onUpdate && s.onUpdate(c);
          },
          onComplete: () => {
            s.onComplete && s.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const s = this.getStack();
      s && s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(gV), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const s = this.getLead();
      let { targetWithTransforms: c, target: d, layout: f, latestValues: g } = s;
      if (!(!c || !d || !f)) {
        if (this !== s && this.layout && f && oK(this.options.animationType, this.layout.layoutBox, f.layoutBox)) {
          d = this.target || na();
          const m = Ql(this.layout.layoutBox.x);
          d.x.min = s.target.x.min, d.x.max = d.x.min + m;
          const b = Ql(this.layout.layoutBox.y);
          d.y.min = s.target.y.min, d.y.max = d.y.min + b;
        }
        zc(c, d), Cb(c, g), wE(this.projectionDeltaWithTransform, this.layoutCorrected, c, g);
      }
    }
    registerSharedNode(s, c) {
      this.sharedNodes.has(s) || this.sharedNodes.set(s, new SDe()), this.sharedNodes.get(s).add(c);
      const f = c.options.initialPromotionConfig;
      c.promote({
        transition: f ? f.transition : void 0,
        preserveFollowOpacity: f && f.shouldPreserveFollowOpacity ? f.shouldPreserveFollowOpacity(c) : void 0
      });
    }
    isLead() {
      const s = this.getStack();
      return s ? s.lead === this : !0;
    }
    getLead() {
      var s;
      const { layoutId: c } = this.options;
      return c ? ((s = this.getStack()) === null || s === void 0 ? void 0 : s.lead) || this : this;
    }
    getPrevLead() {
      var s;
      const { layoutId: c } = this.options;
      return c ? (s = this.getStack()) === null || s === void 0 ? void 0 : s.prevLead : void 0;
    }
    getStack() {
      const { layoutId: s } = this.options;
      if (s)
        return this.root.sharedNodes.get(s);
    }
    promote({ needsReset: s, transition: c, preserveFollowOpacity: d } = {}) {
      const f = this.getStack();
      f && f.promote(this, d), s && (this.projectionDelta = void 0, this.needsReset = !0), c && this.setOptions({ transition: c });
    }
    relegate() {
      const s = this.getStack();
      return s ? s.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: s } = this.options;
      if (!s)
        return;
      let c = !1;
      const { latestValues: d } = s;
      if ((d.z || d.rotate || d.rotateX || d.rotateY || d.rotateZ || d.skewX || d.skewY) && (c = !0), !c)
        return;
      const f = {};
      d.z && cD("z", s, f, this.animationValues);
      for (let g = 0; g < lD.length; g++)
        cD(`rotate${lD[g]}`, s, f, this.animationValues), cD(`skew${lD[g]}`, s, f, this.animationValues);
      s.render();
      for (const g in f)
        s.setStaticValue(g, f[g]), this.animationValues && (this.animationValues[g] = f[g]);
      s.scheduleRender();
    }
    getProjectionStyles(s) {
      var c, d;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return _De;
      const f = {
        visibility: ""
      }, g = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, f.opacity = "", f.pointerEvents = C4(s?.pointerEvents) || "", f.transform = g ? g(this.latestValues, "") : "none", f;
      const m = this.getLead();
      if (!this.projectionDelta || !this.layout || !m.target) {
        const A = {};
        return this.options.layoutId && (A.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, A.pointerEvents = C4(s?.pointerEvents) || ""), this.hasProjected && !Y1(this.latestValues) && (A.transform = g ? g({}, "") : "none", this.hasProjected = !1), A;
      }
      const b = m.animationValues || m.latestValues;
      this.applyTransformsToTarget(), f.transform = EDe(this.projectionDeltaWithTransform, this.treeScale, b), g && (f.transform = g(b, f.transform));
      const { x: w, y: _ } = this.projectionDelta;
      f.transformOrigin = `${w.origin * 100}% ${_.origin * 100}% 0`, m.animationValues ? f.opacity = m === this ? (d = (c = b.opacity) !== null && c !== void 0 ? c : this.latestValues.opacity) !== null && d !== void 0 ? d : 1 : this.preserveOpacity ? this.latestValues.opacity : b.opacityExit : f.opacity = m === this ? b.opacity !== void 0 ? b.opacity : "" : b.opacityExit !== void 0 ? b.opacityExit : 0;
      for (const A in KT) {
        if (b[A] === void 0)
          continue;
        const { correct: T, applyTo: O } = KT[A], R = f.transform === "none" ? b[A] : T(b[A], m);
        if (O) {
          const N = O.length;
          for (let M = 0; M < N; M++)
            f[O[M]] = R;
        } else
          f[A] = R;
      }
      return this.options.layoutId && (f.pointerEvents = m === this ? C4(s?.pointerEvents) || "" : "none"), f;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((s) => {
        var c;
        return (c = s.currentAnimation) === null || c === void 0 ? void 0 : c.stop();
      }), this.root.nodes.forEach(vV), this.root.sharedNodes.clear();
    }
  };
}
function CDe(t) {
  t.updateLayout();
}
function TDe(t) {
  var e;
  const n = ((e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && n && t.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = t.layout, { animationType: a } = t.options, s = n.source !== t.layout.source;
    a === "size" ? Fc((m) => {
      const b = s ? n.measuredBox[m] : n.layoutBox[m], w = Ql(b);
      b.min = r[m].min, b.max = b.min + w;
    }) : oK(a, n.layoutBox, r) && Fc((m) => {
      const b = s ? n.measuredBox[m] : n.layoutBox[m], w = Ql(r[m]);
      b.max = b.min + w, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[m].max = t.relativeTarget[m].min + w);
    });
    const c = _b();
    wE(c, r, n.layoutBox);
    const d = _b();
    s ? wE(d, t.applyTransform(i, !0), n.measuredBox) : wE(d, r, n.layoutBox);
    const f = !nK(c);
    let g = !1;
    if (!t.resumeFrom) {
      const m = t.getClosestProjectingParent();
      if (m && !m.resumeFrom) {
        const { snapshot: b, layout: w } = m;
        if (b && w) {
          const _ = na();
          xE(_, n.layoutBox, b.layoutBox);
          const A = na();
          xE(A, r, w.layoutBox), rK(_, A) || (g = !0), m.options.layoutRoot && (t.relativeTarget = A, t.relativeTargetOrigin = _, t.relativeParent = m);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: d,
      layoutDelta: c,
      hasLayoutChanged: f,
      hasRelativeTargetChanged: g
    });
  } else if (t.isLead()) {
    const { onExitComplete: r } = t.options;
    r && r();
  }
  t.options.transition = void 0;
}
function ODe(t) {
  rE && X1.totalNodes++, t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function RDe(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function DDe(t) {
  t.clearSnapshot();
}
function vV(t) {
  t.clearMeasurements();
}
function NDe(t) {
  t.isLayoutDirty = !1;
}
function MDe(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function yV(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function IDe(t) {
  t.resolveTargetDelta();
}
function kDe(t) {
  t.calcProjection();
}
function jDe(t) {
  t.resetSkewAndRotation();
}
function PDe(t) {
  t.removeLeadSnapshot();
}
function bV(t, e, n) {
  t.translate = Vi(e.translate, 0, n), t.scale = Vi(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function wV(t, e, n, r) {
  t.min = Vi(e.min, n.min, r), t.max = Vi(e.max, n.max, r);
}
function LDe(t, e, n, r) {
  wV(t.x, e.x, n.x, r), wV(t.y, e.y, n.y, r);
}
function BDe(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const zDe = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, xV = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), SV = xV("applewebkit/") && !xV("chrome/") ? Math.round : ll;
function EV(t) {
  t.min = SV(t.min), t.max = SV(t.max);
}
function FDe(t) {
  EV(t.x), EV(t.y);
}
function oK(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !$6e(pV(e), pV(n), 0.2);
}
function VDe(t) {
  var e;
  return t !== t.root && ((e = t.scroll) === null || e === void 0 ? void 0 : e.wasRoot);
}
const UDe = aK({
  attachResizeListener: (t, e) => i_(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), uD = {
  current: void 0
}, sK = aK({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!uD.current) {
      const t = new UDe({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), uD.current = t;
    }
    return uD.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), $De = {
  pan: {
    Feature: aDe
  },
  drag: {
    Feature: iDe,
    ProjectionNode: sK,
    MeasureLayout: JZ
  }
};
function _V(t, e, n) {
  const { props: r } = t;
  t.animationState && r.whileHover && t.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, a = r[i];
  a && xi.postRender(() => a(e, L_(e)));
}
class HDe extends em {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = $Oe(e, (n) => (_V(this.node, n, "Start"), (r) => _V(this.node, r, "End"))));
  }
  unmount() {
  }
}
class qDe extends em {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = P_(i_(this.node.current, "focus", () => this.onFocus()), i_(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function AV(t, e, n) {
  const { props: r } = t;
  t.animationState && r.whileTap && t.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), a = r[i];
  a && xi.postRender(() => a(e, L_(e)));
}
class GDe extends em {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = YOe(e, (n) => (AV(this.node, n, "Start"), (r, { success: i }) => AV(this.node, r, i ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const gN = /* @__PURE__ */ new WeakMap(), dD = /* @__PURE__ */ new WeakMap(), YDe = (t) => {
  const e = gN.get(t.target);
  e && e(t);
}, XDe = (t) => {
  t.forEach(YDe);
};
function WDe({ root: t, ...e }) {
  const n = t || document;
  dD.has(n) || dD.set(n, {});
  const r = dD.get(n), i = JSON.stringify(e);
  return r[i] || (r[i] = new IntersectionObserver(XDe, { root: t, ...e })), r[i];
}
function QDe(t, e, n) {
  const r = WDe(e);
  return gN.set(t, n), r.observe(t), () => {
    gN.delete(t), r.unobserve(t);
  };
}
const ZDe = {
  some: 0,
  all: 1
};
class KDe extends em {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: a } = e, s = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : ZDe[i]
    }, c = (d) => {
      const { isIntersecting: f } = d;
      if (this.isInView === f || (this.isInView = f, a && !f && this.hasEnteredView))
        return;
      f && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", f);
      const { onViewportEnter: g, onViewportLeave: m } = this.node.getProps(), b = f ? g : m;
      b && b(d);
    };
    return QDe(this.node.current, s, c);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(JDe(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function JDe({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const e8e = {
  inView: {
    Feature: KDe
  },
  tap: {
    Feature: GDe
  },
  focus: {
    Feature: qDe
  },
  hover: {
    Feature: HDe
  }
}, t8e = {
  layout: {
    ProjectionNode: sK,
    MeasureLayout: JZ
  }
}, vN = { current: null }, lK = { current: !1 };
function n8e() {
  if (lK.current = !0, !!m7)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => vN.current = t.matches;
      t.addListener(e), e();
    } else
      vN.current = !1;
}
const r8e = [...IZ, Zo, Q0], i8e = (t) => r8e.find(MZ(t)), CV = /* @__PURE__ */ new WeakMap();
function a8e(t, e, n) {
  for (const r in e) {
    const i = e[r], a = n[r];
    if (Ko(i))
      t.addValue(r, i), process.env.NODE_ENV === "development" && sO(i.version === "11.18.2", `Attempting to mix Motion versions ${i.version} with 11.18.2 may not work as expected.`);
    else if (Ko(a))
      t.addValue(r, n_(i, { owner: t }));
    else if (a !== i)
      if (t.hasValue(r)) {
        const s = t.getValue(r);
        s.liveStyle === !0 ? s.jump(i) : s.hasAnimated || s.set(i);
      } else {
        const s = t.getStaticValue(r);
        t.addValue(r, n_(s !== void 0 ? s : i, { owner: t }));
      }
  }
  for (const r in n)
    e[r] === void 0 && t.removeValue(r);
  return e;
}
const TV = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class o8e {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, r) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: a, visualState: s }, c = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = U7, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const w = Jd.now();
      this.renderScheduledAt < w && (this.renderScheduledAt = w, xi.render(this.render, !1, !0));
    };
    const { latestValues: d, renderState: f, onUpdate: g } = s;
    this.onUpdate = g, this.latestValues = d, this.baseTarget = { ...d }, this.initialValues = n.initial ? { ...d } : {}, this.renderState = f, this.parent = e, this.props = n, this.presenceContext = r, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = c, this.blockInitialAnimation = !!a, this.isControllingVariants = uO(n), this.isVariantNode = VQ(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: m, ...b } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const w in b) {
      const _ = b[w];
      d[w] !== void 0 && Ko(_) && _.set(d[w], !1);
    }
  }
  mount(e) {
    this.current = e, CV.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), lK.current || n8e(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : vN.current, process.env.NODE_ENV !== "production" && sO(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    CV.delete(this.current), this.projection && this.projection.unmount(), W0(this.notifyUpdate), W0(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, n) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const r = Fg.has(e), i = n.on("change", (c) => {
      this.latestValues[e] = c, this.props.onUpdate && xi.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), a = n.on("renderRequest", this.scheduleRender);
    let s;
    window.MotionCheckAppearSync && (s = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      i(), a(), s && s(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in Kb) {
      const n = Kb[e];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[e] && i && r(this.props) && (this.features[e] = new i(this)), this.features[e]) {
        const a = this.features[e];
        a.isMounted ? a.update() : (a.mount(), a.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : na();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < TV.length; r++) {
      const i = TV[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const a = "on" + i, s = e[a];
      s && (this.propEventSubscriptions[i] = this.on(i, s));
    }
    this.prevMotionValues = a8e(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue(), this.onUpdate && this.onUpdate(this);
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const r = this.values.get(e);
    n !== r && (r && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let r = this.values.get(e);
    return r === void 0 && n !== void 0 && (r = n_(n === null ? void 0 : n, { owner: this }), this.addValue(e, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    var r;
    let i = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (r = this.getBaseTargetFromProps(this.props, e)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, e, this.options);
    return i != null && (typeof i == "string" && (DZ(i) || xZ(i)) ? i = parseFloat(i) : !i8e(i) && Q0.test(n) && (i = TZ(e, n)), this.setBaseTarget(e, Ko(i) ? i.get() : i)), Ko(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var n;
    const { initial: r } = this.props;
    let i;
    if (typeof r == "string" || typeof r == "object") {
      const s = S7(this.props, r, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      s && (i = s[e]);
    }
    if (r && i !== void 0)
      return i;
    const a = this.getBaseTargetFromProps(this.props, e);
    return a !== void 0 && !Ko(a) ? a : this.initialValues[e] !== void 0 && i === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new P7()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
class cK extends o8e {
  constructor() {
    super(...arguments), this.KeyframeResolver = kZ;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: r }) {
    delete n[e], delete r[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    Ko(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function s8e(t) {
  return window.getComputedStyle(t);
}
class l8e extends cK {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = QQ;
  }
  readValueFromInstance(e, n) {
    if (Fg.has(n)) {
      const r = V7(n);
      return r && r.default || 0;
    } else {
      const r = s8e(e), i = (YQ(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return ZZ(e, n);
  }
  build(e, n, r) {
    A7(e, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, r) {
    return R7(e, n, r);
  }
}
class c8e extends cK {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = na;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (Fg.has(n)) {
      const r = V7(n);
      return r && r.default || 0;
    }
    return n = ZQ.has(n) ? n : b7(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, r) {
    return eZ(e, n, r);
  }
  build(e, n, r) {
    C7(e, n, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(e, n, r, i) {
    KQ(e, n, r, i);
  }
  mount(e) {
    this.isSVGTag = O7(e.tagName), super.mount(e);
  }
}
const u8e = (t, e) => x7(t) ? new c8e(e) : new l8e(e, {
  allowProjection: t !== I.Fragment
}), d8e = /* @__PURE__ */ POe({
  ...k6e,
  ...e8e,
  ...$De,
  ...t8e
}, u8e), uK = /* @__PURE__ */ Z5e(d8e);
var xw = 1e9, f8e = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Y7, Ni = !0, tu = "[DecimalError] ", ug = tu + "Invalid argument: ", G7 = tu + "Exponent out of range: ", Sw = Math.floor, W1 = Math.pow, h8e = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ql, oo = 1e7, yi = 7, dK = 9007199254740991, i5 = Sw(dK / yi), Tt = {};
Tt.absoluteValue = Tt.abs = function() {
  var t = new this.constructor(this);
  return t.s && (t.s = 1), t;
};
Tt.comparedTo = Tt.cmp = function(t) {
  var e, n, r, i, a = this;
  if (t = new a.constructor(t), a.s !== t.s)
    return a.s || -t.s;
  if (a.e !== t.e)
    return a.e > t.e ^ a.s < 0 ? 1 : -1;
  for (r = a.d.length, i = t.d.length, e = 0, n = r < i ? r : i; e < n; ++e)
    if (a.d[e] !== t.d[e])
      return a.d[e] > t.d[e] ^ a.s < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ a.s < 0 ? 1 : -1;
};
Tt.decimalPlaces = Tt.dp = function() {
  var t = this, e = t.d.length - 1, n = (e - t.e) * yi;
  if (e = t.d[e], e)
    for (; e % 10 == 0; e /= 10)
      n--;
  return n < 0 ? 0 : n;
};
Tt.dividedBy = Tt.div = function(t) {
  return Oh(this, new this.constructor(t));
};
Tt.dividedToIntegerBy = Tt.idiv = function(t) {
  var e = this, n = e.constructor;
  return Kr(Oh(e, new n(t), 0, 1), n.precision);
};
Tt.equals = Tt.eq = function(t) {
  return !this.cmp(t);
};
Tt.exponent = function() {
  return Ca(this);
};
Tt.greaterThan = Tt.gt = function(t) {
  return this.cmp(t) > 0;
};
Tt.greaterThanOrEqualTo = Tt.gte = function(t) {
  return this.cmp(t) >= 0;
};
Tt.isInteger = Tt.isint = function() {
  return this.e > this.d.length - 2;
};
Tt.isNegative = Tt.isneg = function() {
  return this.s < 0;
};
Tt.isPositive = Tt.ispos = function() {
  return this.s > 0;
};
Tt.isZero = function() {
  return this.s === 0;
};
Tt.lessThan = Tt.lt = function(t) {
  return this.cmp(t) < 0;
};
Tt.lessThanOrEqualTo = Tt.lte = function(t) {
  return this.cmp(t) < 1;
};
Tt.logarithm = Tt.log = function(t) {
  var e, n = this, r = n.constructor, i = r.precision, a = i + 5;
  if (t === void 0)
    t = new r(10);
  else if (t = new r(t), t.s < 1 || t.eq(ql))
    throw Error(tu + "NaN");
  if (n.s < 1)
    throw Error(tu + (n.s ? "NaN" : "-Infinity"));
  return n.eq(ql) ? new r(0) : (Ni = !1, e = Oh(a_(n, a), a_(t, a), a), Ni = !0, Kr(e, i));
};
Tt.minus = Tt.sub = function(t) {
  var e = this;
  return t = new e.constructor(t), e.s == t.s ? pK(e, t) : fK(e, (t.s = -t.s, t));
};
Tt.modulo = Tt.mod = function(t) {
  var e, n = this, r = n.constructor, i = r.precision;
  if (t = new r(t), !t.s)
    throw Error(tu + "NaN");
  return n.s ? (Ni = !1, e = Oh(n, t, 0, 1).times(t), Ni = !0, n.minus(e)) : Kr(new r(n), i);
};
Tt.naturalExponential = Tt.exp = function() {
  return hK(this);
};
Tt.naturalLogarithm = Tt.ln = function() {
  return a_(this);
};
Tt.negated = Tt.neg = function() {
  var t = new this.constructor(this);
  return t.s = -t.s || 0, t;
};
Tt.plus = Tt.add = function(t) {
  var e = this;
  return t = new e.constructor(t), e.s == t.s ? fK(e, t) : pK(e, (t.s = -t.s, t));
};
Tt.precision = Tt.sd = function(t) {
  var e, n, r, i = this;
  if (t !== void 0 && t !== !!t && t !== 1 && t !== 0)
    throw Error(ug + t);
  if (e = Ca(i) + 1, r = i.d.length - 1, n = r * yi + 1, r = i.d[r], r) {
    for (; r % 10 == 0; r /= 10)
      n--;
    for (r = i.d[0]; r >= 10; r /= 10)
      n++;
  }
  return t && e > n ? e : n;
};
Tt.squareRoot = Tt.sqrt = function() {
  var t, e, n, r, i, a, s, c = this, d = c.constructor;
  if (c.s < 1) {
    if (!c.s)
      return new d(0);
    throw Error(tu + "NaN");
  }
  for (t = Ca(c), Ni = !1, i = Math.sqrt(+c), i == 0 || i == 1 / 0 ? (e = Gd(c.d), (e.length + t) % 2 == 0 && (e += "0"), i = Math.sqrt(e), t = Sw((t + 1) / 2) - (t < 0 || t % 2), i == 1 / 0 ? e = "5e" + t : (e = i.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + t), r = new d(e)) : r = new d(i.toString()), n = d.precision, i = s = n + 3; ; )
    if (a = r, r = a.plus(Oh(c, a, s + 2)).times(0.5), Gd(a.d).slice(0, s) === (e = Gd(r.d)).slice(0, s)) {
      if (e = e.slice(s - 3, s + 1), i == s && e == "4999") {
        if (Kr(a, n + 1, 0), a.times(a).eq(c)) {
          r = a;
          break;
        }
      } else if (e != "9999")
        break;
      s += 4;
    }
  return Ni = !0, Kr(r, n);
};
Tt.times = Tt.mul = function(t) {
  var e, n, r, i, a, s, c, d, f, g = this, m = g.constructor, b = g.d, w = (t = new m(t)).d;
  if (!g.s || !t.s)
    return new m(0);
  for (t.s *= g.s, n = g.e + t.e, d = b.length, f = w.length, d < f && (a = b, b = w, w = a, s = d, d = f, f = s), a = [], s = d + f, r = s; r--; )
    a.push(0);
  for (r = f; --r >= 0; ) {
    for (e = 0, i = d + r; i > r; )
      c = a[i] + w[r] * b[i - r - 1] + e, a[i--] = c % oo | 0, e = c / oo | 0;
    a[i] = (a[i] + e) % oo | 0;
  }
  for (; !a[--s]; )
    a.pop();
  return e ? ++n : a.shift(), t.d = a, t.e = n, Ni ? Kr(t, m.precision) : t;
};
Tt.toDecimalPlaces = Tt.todp = function(t, e) {
  var n = this, r = n.constructor;
  return n = new r(n), t === void 0 ? n : (af(t, 0, xw), e === void 0 ? e = r.rounding : af(e, 0, 8), Kr(n, t + Ca(n) + 1, e));
};
Tt.toExponential = function(t, e) {
  var n, r = this, i = r.constructor;
  return t === void 0 ? n = Cg(r, !0) : (af(t, 0, xw), e === void 0 ? e = i.rounding : af(e, 0, 8), r = Kr(new i(r), t + 1, e), n = Cg(r, !0, t + 1)), n;
};
Tt.toFixed = function(t, e) {
  var n, r, i = this, a = i.constructor;
  return t === void 0 ? Cg(i) : (af(t, 0, xw), e === void 0 ? e = a.rounding : af(e, 0, 8), r = Kr(new a(i), t + Ca(i) + 1, e), n = Cg(r.abs(), !1, t + Ca(r) + 1), i.isneg() && !i.isZero() ? "-" + n : n);
};
Tt.toInteger = Tt.toint = function() {
  var t = this, e = t.constructor;
  return Kr(new e(t), Ca(t) + 1, e.rounding);
};
Tt.toNumber = function() {
  return +this;
};
Tt.toPower = Tt.pow = function(t) {
  var e, n, r, i, a, s, c = this, d = c.constructor, f = 12, g = +(t = new d(t));
  if (!t.s)
    return new d(ql);
  if (c = new d(c), !c.s) {
    if (t.s < 1)
      throw Error(tu + "Infinity");
    return c;
  }
  if (c.eq(ql))
    return c;
  if (r = d.precision, t.eq(ql))
    return Kr(c, r);
  if (e = t.e, n = t.d.length - 1, s = e >= n, a = c.s, s) {
    if ((n = g < 0 ? -g : g) <= dK) {
      for (i = new d(ql), e = Math.ceil(r / yi + 4), Ni = !1; n % 2 && (i = i.times(c), RV(i.d, e)), n = Sw(n / 2), n !== 0; )
        c = c.times(c), RV(c.d, e);
      return Ni = !0, t.s < 0 ? new d(ql).div(i) : Kr(i, r);
    }
  } else if (a < 0)
    throw Error(tu + "NaN");
  return a = a < 0 && t.d[Math.max(e, n)] & 1 ? -1 : 1, c.s = 1, Ni = !1, i = t.times(a_(c, r + f)), Ni = !0, i = hK(i), i.s = a, i;
};
Tt.toPrecision = function(t, e) {
  var n, r, i = this, a = i.constructor;
  return t === void 0 ? (n = Ca(i), r = Cg(i, n <= a.toExpNeg || n >= a.toExpPos)) : (af(t, 1, xw), e === void 0 ? e = a.rounding : af(e, 0, 8), i = Kr(new a(i), t, e), n = Ca(i), r = Cg(i, t <= n || n <= a.toExpNeg, t)), r;
};
Tt.toSignificantDigits = Tt.tosd = function(t, e) {
  var n = this, r = n.constructor;
  return t === void 0 ? (t = r.precision, e = r.rounding) : (af(t, 1, xw), e === void 0 ? e = r.rounding : af(e, 0, 8)), Kr(new r(n), t, e);
};
Tt.toString = Tt.valueOf = Tt.val = Tt.toJSON = Tt[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var t = this, e = Ca(t), n = t.constructor;
  return Cg(t, e <= n.toExpNeg || e >= n.toExpPos);
};
function fK(t, e) {
  var n, r, i, a, s, c, d, f, g = t.constructor, m = g.precision;
  if (!t.s || !e.s)
    return e.s || (e = new g(t)), Ni ? Kr(e, m) : e;
  if (d = t.d, f = e.d, s = t.e, i = e.e, d = d.slice(), a = s - i, a) {
    for (a < 0 ? (r = d, a = -a, c = f.length) : (r = f, i = s, c = d.length), s = Math.ceil(m / yi), c = s > c ? s + 1 : c + 1, a > c && (a = c, r.length = 1), r.reverse(); a--; )
      r.push(0);
    r.reverse();
  }
  for (c = d.length, a = f.length, c - a < 0 && (a = c, r = f, f = d, d = r), n = 0; a; )
    n = (d[--a] = d[a] + f[a] + n) / oo | 0, d[a] %= oo;
  for (n && (d.unshift(n), ++i), c = d.length; d[--c] == 0; )
    d.pop();
  return e.d = d, e.e = i, Ni ? Kr(e, m) : e;
}
function af(t, e, n) {
  if (t !== ~~t || t < e || t > n)
    throw Error(ug + t);
}
function Gd(t) {
  var e, n, r, i = t.length - 1, a = "", s = t[0];
  if (i > 0) {
    for (a += s, e = 1; e < i; e++)
      r = t[e] + "", n = yi - r.length, n && (a += C0(n)), a += r;
    s = t[e], r = s + "", n = yi - r.length, n && (a += C0(n));
  } else if (s === 0)
    return "0";
  for (; s % 10 === 0; )
    s /= 10;
  return a + s;
}
var Oh = function() {
  function t(r, i) {
    var a, s = 0, c = r.length;
    for (r = r.slice(); c--; )
      a = r[c] * i + s, r[c] = a % oo | 0, s = a / oo | 0;
    return s && r.unshift(s), r;
  }
  function e(r, i, a, s) {
    var c, d;
    if (a != s)
      d = a > s ? 1 : -1;
    else
      for (c = d = 0; c < a; c++)
        if (r[c] != i[c]) {
          d = r[c] > i[c] ? 1 : -1;
          break;
        }
    return d;
  }
  function n(r, i, a) {
    for (var s = 0; a--; )
      r[a] -= s, s = r[a] < i[a] ? 1 : 0, r[a] = s * oo + r[a] - i[a];
    for (; !r[0] && r.length > 1; )
      r.shift();
  }
  return function(r, i, a, s) {
    var c, d, f, g, m, b, w, _, A, T, O, R, N, M, P, z, F, $, G = r.constructor, H = r.s == i.s ? 1 : -1, Z = r.d, V = i.d;
    if (!r.s)
      return new G(r);
    if (!i.s)
      throw Error(tu + "Division by zero");
    for (d = r.e - i.e, F = V.length, P = Z.length, w = new G(H), _ = w.d = [], f = 0; V[f] == (Z[f] || 0); )
      ++f;
    if (V[f] > (Z[f] || 0) && --d, a == null ? R = a = G.precision : s ? R = a + (Ca(r) - Ca(i)) + 1 : R = a, R < 0)
      return new G(0);
    if (R = R / yi + 2 | 0, f = 0, F == 1)
      for (g = 0, V = V[0], R++; (f < P || g) && R--; f++)
        N = g * oo + (Z[f] || 0), _[f] = N / V | 0, g = N % V | 0;
    else {
      for (g = oo / (V[0] + 1) | 0, g > 1 && (V = t(V, g), Z = t(Z, g), F = V.length, P = Z.length), M = F, A = Z.slice(0, F), T = A.length; T < F; )
        A[T++] = 0;
      $ = V.slice(), $.unshift(0), z = V[0], V[1] >= oo / 2 && ++z;
      do
        g = 0, c = e(V, A, F, T), c < 0 ? (O = A[0], F != T && (O = O * oo + (A[1] || 0)), g = O / z | 0, g > 1 ? (g >= oo && (g = oo - 1), m = t(V, g), b = m.length, T = A.length, c = e(m, A, b, T), c == 1 && (g--, n(m, F < b ? $ : V, b))) : (g == 0 && (c = g = 1), m = V.slice()), b = m.length, b < T && m.unshift(0), n(A, m, T), c == -1 && (T = A.length, c = e(V, A, F, T), c < 1 && (g++, n(A, F < T ? $ : V, T))), T = A.length) : c === 0 && (g++, A = [0]), _[f++] = g, c && A[0] ? A[T++] = Z[M] || 0 : (A = [Z[M]], T = 1);
      while ((M++ < P || A[0] !== void 0) && R--);
    }
    return _[0] || _.shift(), w.e = d, Kr(w, s ? a + Ca(w) + 1 : a);
  };
}();
function hK(t, e) {
  var n, r, i, a, s, c, d = 0, f = 0, g = t.constructor, m = g.precision;
  if (Ca(t) > 16)
    throw Error(G7 + Ca(t));
  if (!t.s)
    return new g(ql);
  for (e == null ? (Ni = !1, c = m) : c = e, s = new g(0.03125); t.abs().gte(0.1); )
    t = t.times(s), f += 5;
  for (r = Math.log(W1(2, f)) / Math.LN10 * 2 + 5 | 0, c += r, n = i = a = new g(ql), g.precision = c; ; ) {
    if (i = Kr(i.times(t), c), n = n.times(++d), s = a.plus(Oh(i, n, c)), Gd(s.d).slice(0, c) === Gd(a.d).slice(0, c)) {
      for (; f--; )
        a = Kr(a.times(a), c);
      return g.precision = m, e == null ? (Ni = !0, Kr(a, m)) : a;
    }
    a = s;
  }
}
function Ca(t) {
  for (var e = t.e * yi, n = t.d[0]; n >= 10; n /= 10)
    e++;
  return e;
}
function fD(t, e, n) {
  if (e > t.LN10.sd())
    throw Ni = !0, n && (t.precision = n), Error(tu + "LN10 precision limit exceeded");
  return Kr(new t(t.LN10), e);
}
function C0(t) {
  for (var e = ""; t--; )
    e += "0";
  return e;
}
function a_(t, e) {
  var n, r, i, a, s, c, d, f, g, m = 1, b = 10, w = t, _ = w.d, A = w.constructor, T = A.precision;
  if (w.s < 1)
    throw Error(tu + (w.s ? "NaN" : "-Infinity"));
  if (w.eq(ql))
    return new A(0);
  if (e == null ? (Ni = !1, f = T) : f = e, w.eq(10))
    return e == null && (Ni = !0), fD(A, f);
  if (f += b, A.precision = f, n = Gd(_), r = n.charAt(0), a = Ca(w), Math.abs(a) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      w = w.times(t), n = Gd(w.d), r = n.charAt(0), m++;
    a = Ca(w), r > 1 ? (w = new A("0." + n), a++) : w = new A(r + "." + n.slice(1));
  } else
    return d = fD(A, f + 2, T).times(a + ""), w = a_(new A(r + "." + n.slice(1)), f - b).plus(d), A.precision = T, e == null ? (Ni = !0, Kr(w, T)) : w;
  for (c = s = w = Oh(w.minus(ql), w.plus(ql), f), g = Kr(w.times(w), f), i = 3; ; ) {
    if (s = Kr(s.times(g), f), d = c.plus(Oh(s, new A(i), f)), Gd(d.d).slice(0, f) === Gd(c.d).slice(0, f))
      return c = c.times(2), a !== 0 && (c = c.plus(fD(A, f + 2, T).times(a + ""))), c = Oh(c, new A(m), f), A.precision = T, e == null ? (Ni = !0, Kr(c, T)) : c;
    c = d, i += 2;
  }
}
function OV(t, e) {
  var n, r, i;
  for ((n = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (r = e.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +e.slice(r + 1), e = e.substring(0, r)) : n < 0 && (n = e.length), r = 0; e.charCodeAt(r) === 48; )
    ++r;
  for (i = e.length; e.charCodeAt(i - 1) === 48; )
    --i;
  if (e = e.slice(r, i), e) {
    if (i -= r, n = n - r - 1, t.e = Sw(n / yi), t.d = [], r = (n + 1) % yi, n < 0 && (r += yi), r < i) {
      for (r && t.d.push(+e.slice(0, r)), i -= yi; r < i; )
        t.d.push(+e.slice(r, r += yi));
      e = e.slice(r), r = yi - e.length;
    } else
      r -= i;
    for (; r--; )
      e += "0";
    if (t.d.push(+e), Ni && (t.e > i5 || t.e < -i5))
      throw Error(G7 + n);
  } else
    t.s = 0, t.e = 0, t.d = [0];
  return t;
}
function Kr(t, e, n) {
  var r, i, a, s, c, d, f, g, m = t.d;
  for (s = 1, a = m[0]; a >= 10; a /= 10)
    s++;
  if (r = e - s, r < 0)
    r += yi, i = e, f = m[g = 0];
  else {
    if (g = Math.ceil((r + 1) / yi), a = m.length, g >= a)
      return t;
    for (f = a = m[g], s = 1; a >= 10; a /= 10)
      s++;
    r %= yi, i = r - yi + s;
  }
  if (n !== void 0 && (a = W1(10, s - i - 1), c = f / a % 10 | 0, d = e < 0 || m[g + 1] !== void 0 || f % a, d = n < 4 ? (c || d) && (n == 0 || n == (t.s < 0 ? 3 : 2)) : c > 5 || c == 5 && (n == 4 || d || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (r > 0 ? i > 0 ? f / W1(10, s - i) : 0 : m[g - 1]) % 10 & 1 || n == (t.s < 0 ? 8 : 7))), e < 1 || !m[0])
    return d ? (a = Ca(t), m.length = 1, e = e - a - 1, m[0] = W1(10, (yi - e % yi) % yi), t.e = Sw(-e / yi) || 0) : (m.length = 1, m[0] = t.e = t.s = 0), t;
  if (r == 0 ? (m.length = g, a = 1, g--) : (m.length = g + 1, a = W1(10, yi - r), m[g] = i > 0 ? (f / W1(10, s - i) % W1(10, i) | 0) * a : 0), d)
    for (; ; )
      if (g == 0) {
        (m[0] += a) == oo && (m[0] = 1, ++t.e);
        break;
      } else {
        if (m[g] += a, m[g] != oo)
          break;
        m[g--] = 0, a = 1;
      }
  for (r = m.length; m[--r] === 0; )
    m.pop();
  if (Ni && (t.e > i5 || t.e < -i5))
    throw Error(G7 + Ca(t));
  return t;
}
function pK(t, e) {
  var n, r, i, a, s, c, d, f, g, m, b = t.constructor, w = b.precision;
  if (!t.s || !e.s)
    return e.s ? e.s = -e.s : e = new b(t), Ni ? Kr(e, w) : e;
  if (d = t.d, m = e.d, r = e.e, f = t.e, d = d.slice(), s = f - r, s) {
    for (g = s < 0, g ? (n = d, s = -s, c = m.length) : (n = m, r = f, c = d.length), i = Math.max(Math.ceil(w / yi), c) + 2, s > i && (s = i, n.length = 1), n.reverse(), i = s; i--; )
      n.push(0);
    n.reverse();
  } else {
    for (i = d.length, c = m.length, g = i < c, g && (c = i), i = 0; i < c; i++)
      if (d[i] != m[i]) {
        g = d[i] < m[i];
        break;
      }
    s = 0;
  }
  for (g && (n = d, d = m, m = n, e.s = -e.s), c = d.length, i = m.length - c; i > 0; --i)
    d[c++] = 0;
  for (i = m.length; i > s; ) {
    if (d[--i] < m[i]) {
      for (a = i; a && d[--a] === 0; )
        d[a] = oo - 1;
      --d[a], d[i] += oo;
    }
    d[i] -= m[i];
  }
  for (; d[--c] === 0; )
    d.pop();
  for (; d[0] === 0; d.shift())
    --r;
  return d[0] ? (e.d = d, e.e = r, Ni ? Kr(e, w) : e) : new b(0);
}
function Cg(t, e, n) {
  var r, i = Ca(t), a = Gd(t.d), s = a.length;
  return e ? (n && (r = n - s) > 0 ? a = a.charAt(0) + "." + a.slice(1) + C0(r) : s > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (i < 0 ? "e" : "e+") + i) : i < 0 ? (a = "0." + C0(-i - 1) + a, n && (r = n - s) > 0 && (a += C0(r))) : i >= s ? (a += C0(i + 1 - s), n && (r = n - i - 1) > 0 && (a = a + "." + C0(r))) : ((r = i + 1) < s && (a = a.slice(0, r) + "." + a.slice(r)), n && (r = n - s) > 0 && (i + 1 === s && (a += "."), a += C0(r))), t.s < 0 ? "-" + a : a;
}
function RV(t, e) {
  if (t.length > e)
    return t.length = e, !0;
}
function mK(t) {
  var e, n, r;
  function i(a) {
    var s = this;
    if (!(s instanceof i))
      return new i(a);
    if (s.constructor = i, a instanceof i) {
      s.s = a.s, s.e = a.e, s.d = (a = a.d) ? a.slice() : a;
      return;
    }
    if (typeof a == "number") {
      if (a * 0 !== 0)
        throw Error(ug + a);
      if (a > 0)
        s.s = 1;
      else if (a < 0)
        a = -a, s.s = -1;
      else {
        s.s = 0, s.e = 0, s.d = [0];
        return;
      }
      if (a === ~~a && a < 1e7) {
        s.e = 0, s.d = [a];
        return;
      }
      return OV(s, a.toString());
    } else if (typeof a != "string")
      throw Error(ug + a);
    if (a.charCodeAt(0) === 45 ? (a = a.slice(1), s.s = -1) : s.s = 1, h8e.test(a))
      OV(s, a);
    else
      throw Error(ug + a);
  }
  if (i.prototype = Tt, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = mK, i.config = i.set = p8e, t === void 0 && (t = {}), t)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], e = 0; e < r.length; )
      t.hasOwnProperty(n = r[e++]) || (t[n] = this[n]);
  return i.config(t), i;
}
function p8e(t) {
  if (!t || typeof t != "object")
    throw Error(tu + "Object expected");
  var e, n, r, i = [
    "precision",
    1,
    xw,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (e = 0; e < i.length; e += 3)
    if ((r = t[n = i[e]]) !== void 0)
      if (Sw(r) === r && r >= i[e + 1] && r <= i[e + 2])
        this[n] = r;
      else
        throw Error(ug + n + ": " + r);
  if ((r = t[n = "LN10"]) !== void 0)
    if (r == Math.LN10)
      this[n] = new this(r);
    else
      throw Error(ug + n + ": " + r);
  return this;
}
var Y7 = mK(f8e);
ql = new Y7(1);
const Kc = Y7;
var o_ = /* @__PURE__ */ ((t) => (t.TIME = "time", t.PERCENT = "percent", t))(o_ || {}), yb = /* @__PURE__ */ ((t) => (t.MAX_ALLOWED_TIME = "Time exceed maximum allowed value", t.NEGATIVE_TIME = "Time should not be negative", t.INVALID_TIME_STEP = "Time values have an invalid step", t.DUPLICATE_TIME = "Cells with time have the same values", t.PERCENTS_NOT_100 = "Sum of percents in one row must be 100%", t))(yb || {});
class hD {
  static toRows(e) {
    const n = {}, r = e.reduce((a, {
      time: s
    }) => a[s] ? {
      ...a,
      [s]: a[s] + 1
    } : (a[s] = 1, a), n), i = [...e].sort((a, s) => a.time - s.time);
    return e.map(({
      time: a,
      fractions: s,
      id: c
    }) => {
      const f = (r[a] ?? 0) <= 1, g = i.findIndex((O) => O.id === c), m = g > 0 ? i[g - 1] : null, b = g === 0 || m && a > m.time, w = f && b, _ = {
        value: a,
        type: o_.TIME,
        isUnique: w
      }, A = s.map((O) => ({
        value: O,
        type: o_.PERCENT
      })), T = A.reduce((O, {
        value: R
      }) => O.add(R), new Kc(0));
      return {
        id: c,
        isValidPercent: new Kc(T).equals(1),
        cells: [_, ...A]
      };
    });
  }
  static fromRows(e) {
    return e.map(({
      id: n,
      cells: [r, ...i]
    }) => ({
      id: n,
      time: r.value,
      fractions: i.map(({
        value: a
      }) => a)
    })).sort((n, r) => n.time - r.time);
  }
}
const s_ = () => Math.random().toString(36).substr(2, 10), gK = (t, e) => Number((t + e).toFixed(2)), DV = (t, e) => {
  if (t.length < 2)
    return t;
  const [n, ...r] = t;
  if (!n)
    return t;
  const i = [n];
  return r.forEach((a) => {
    const s = i[i.length - 1];
    if (!s) {
      i.push(a);
      return;
    }
    a.time === s.time ? i.push({
      ...a,
      time: gK(a.time, e)
    }) : i.push(a);
  }), i;
}, m8e = (t) => new Set(t).size !== t.length;
class R4 {
  static insertRow(e, n, r) {
    const i = e[n - 1];
    if (!i)
      return e;
    const a = gK(i.time, r), s = [...i.fractions], c = {
      time: a,
      fractions: s,
      id: s_()
    }, d = [...e];
    return d.splice(n, 0, c), DV(d, r);
  }
  static insertFirstRow(e, n) {
    const i = [{
      time: 0,
      fractions: [0.5, 0.5],
      id: s_()
    }, ...e];
    return DV(i, n);
  }
  static validateGradient(e, n, r) {
    const i = e.map((c) => c.time);
    return i.some((c) => c < 0) ? {
      isValid: !1,
      error: yb.NEGATIVE_TIME
    } : i.some((c) => !new Kc(c).mod(r).equals(0)) ? {
      isValid: !1,
      error: yb.INVALID_TIME_STEP
    } : m8e(i) ? {
      isValid: !1,
      error: yb.DUPLICATE_TIME
    } : Math.max(...i) > n ? {
      isValid: !1,
      error: yb.MAX_ALLOWED_TIME
    } : e.some(({
      fractions: c
    }) => !c.reduce((f, g) => f.add(g), new Kc(0)).equals(1)) ? {
      isValid: !1,
      error: yb.PERCENTS_NOT_100
    } : {
      isValid: !0
    };
  }
}
const NV = [{
  id: 1,
  title: "Time",
  dataType: "min",
  hint: "Sets time (from start) at which gradient table entry will be enabled."
}, {
  id: 2,
  title: "A",
  dataType: "%",
  hint: "Sets portion of Pump A solvent for that interval. "
}, {
  id: 3,
  title: "B",
  dataType: "%",
  hint: "Sets portion of Pump B solvent for that interval."
}], g8e = "Add row", v8e = "Adds another row to gradient table.", y8e = /* @__PURE__ */ new Set(["-", "+", "e", "E", "."]), b8e = (t) => {
  const e = ve.c(14), {
    value: n,
    isDisabled: r,
    onChange: i
  } = t;
  let a;
  e[0] !== n ? (a = Math.round(n * 100), e[0] = n, e[1] = a) : a = e[1];
  const s = String(a), [c, d] = I.useState(s);
  let f, g;
  e[2] !== s ? (f = () => {
    d(s);
  }, g = [s], e[2] = s, e[3] = f, e[4] = g) : (f = e[3], g = e[4]), I.useEffect(f, g);
  let m;
  e[5] === Symbol.for("react.memo_cache_sentinel") ? (m = (R) => {
    const N = R.target.value;
    N !== "" && !/^(0|[1-9]\d*)$/.test(N) || d(N);
  }, e[5] = m) : m = e[5];
  const b = m;
  let w;
  e[6] !== c || e[7] !== i || e[8] !== n ? (w = () => {
    const R = Number(c), N = Math.min(100, Math.max(0, isNaN(R) ? 0 : R));
    d(String(N)), N !== Math.round(n * 100) && i(N / 100);
  }, e[6] = c, e[7] = i, e[8] = n, e[9] = w) : w = e[9];
  const _ = w, A = w8e, T = x8e;
  let O;
  return e[10] !== _ || e[11] !== r || e[12] !== c ? (O = /* @__PURE__ */ C.jsx("input", { type: "number", min: 0, max: 100, step: 1, value: c, disabled: r, onChange: b, onBlur: _, onFocus: A, onKeyDown: T, className: "twd-text-sm twd-bg-transparent twd-text-neutral-900 disabled:twd-bg-transparent disabled:twd-text-neutral-500 twd-h-9 twd-w-full twd-rounded twd-border-0 twd-px-3 twd-text-right twd-transition twd-duration-150 focus:twd-outline-none [&::-webkit-inner-spin-button]:twd-appearance-none [&::-webkit-outer-spin-button]:twd-appearance-none [-moz-appearance:textfield]" }), e[10] = _, e[11] = r, e[12] = c, e[13] = O) : O = e[13], O;
};
function w8e(t) {
  t.target.select();
}
function x8e(t) {
  y8e.has(t.key) && t.preventDefault();
}
const S8e = /^(0(\.\d*)?|[1-9]\d*\.?\d*)$|^$/, E8e = /* @__PURE__ */ new Set(["-", "+", "e", "E"]), MV = (t) => t.toFixed(2).replace(/\.0*$/, "").replace(/\.$/, ""), _8e = (t, e) => {
  if (e <= 0)
    return t;
  const r = 10 ** (e.toString().split(".")[1] ?? "").length, i = Math.round(e * r), a = Math.round(t * r);
  return Math.floor(a / i) * (i / r);
}, vK = (t) => {
  const e = ve.c(21), {
    value: n,
    step: r,
    maxTime: i,
    isUnique: a,
    isDisabled: s,
    onChange: c
  } = t, d = a === void 0 ? !0 : a;
  let f;
  e[0] !== n ? (f = MV(n), e[0] = n, e[1] = f) : f = e[1];
  const g = f, [m, b] = I.useState(g);
  let w, _;
  e[2] !== g ? (w = () => {
    b(g);
  }, _ = [g], e[2] = g, e[3] = w, e[4] = _) : (w = e[3], _ = e[4]), I.useEffect(w, _);
  const A = Number(m), T = A < 0 ? "Value must be greater than or equal to 0" : A > i ? "Value must be less than or equal to run time" : void 0, O = d && n >= 0 && n <= i, R = A >= 0 && A <= i || m === "" || isNaN(A), N = O && R;
  let M;
  e[5] !== m || e[6] !== c || e[7] !== r || e[8] !== n ? (M = () => {
    const Y = Number(m);
    if (!isNaN(Y) && Y >= 0) {
      const ee = _8e(Y, r);
      b(MV(ee)), ee !== n && c(ee);
    }
  }, e[5] = m, e[6] = c, e[7] = r, e[8] = n, e[9] = M) : M = e[9];
  const P = M, z = A8e;
  let F;
  e[10] === Symbol.for("react.memo_cache_sentinel") ? (F = (Y) => {
    const ee = Y.target.value;
    S8e.test(ee) && b(ee);
  }, e[10] = F) : F = e[10];
  const $ = F, G = C8e, H = !N && "twd-text-error";
  let Z;
  e[11] !== H ? (Z = un("twd-text-sm twd-bg-transparent twd-text-neutral-900 disabled:twd-bg-transparent disabled:twd-text-neutral-500 twd-h-9 twd-w-full twd-rounded twd-border-0 twd-px-3 twd-text-right twd-transition twd-duration-150 focus:twd-outline-none [&::-webkit-inner-spin-button]:twd-appearance-none [&::-webkit-outer-spin-button]:twd-appearance-none [-moz-appearance:textfield]", H), e[11] = H, e[12] = Z) : Z = e[12];
  let V;
  return e[13] !== T || e[14] !== P || e[15] !== s || e[16] !== m || e[17] !== i || e[18] !== r || e[19] !== Z ? (V = /* @__PURE__ */ C.jsx("input", { type: "number", step: r, max: i, min: 0, value: m, disabled: s, title: T, className: Z, onChange: $, onKeyDown: G, onBlur: P, onFocus: z }), e[13] = T, e[14] = P, e[15] = s, e[16] = m, e[17] = i, e[18] = r, e[19] = Z, e[20] = V) : V = e[20], V;
};
function A8e(t) {
  t.target.select();
}
function C8e(t) {
  E8e.has(t.key) && t.preventDefault();
}
const yK = (t) => {
  const e = ve.c(4), {
    onAdd: n,
    isDisabled: r
  } = t;
  if (r === void 0 ? !1 : r)
    return null;
  let a, s;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ C.jsx("span", { className: "twd-relative twd-left-px twd-bg-primary twd-flex twd-h-4 twd-w-4 twd-items-center twd-justify-center twd-rounded-full", children: /* @__PURE__ */ C.jsx(q0, { size: "md", className: "twd-text-white" }) }), s = /* @__PURE__ */ C.jsx("span", { className: "twd-bg-primary twd-h-0.5 twd-flex-1 twd-rounded-full" }), e[0] = a, e[1] = s) : (a = e[0], s = e[1]);
  let c;
  return e[2] !== n ? (c = /* @__PURE__ */ C.jsxs("div", { onClick: n, className: "twd-absolute twd-left-0 -twd-top-2 twd-flex twd-w-full twd-items-center twd-py-1 twd-text-left twd-opacity-0 twd-transition twd-duration-150 hover:twd-opacity-100 focus:twd-outline-none group-hover:twd-opacity-100 twd-h-4 twd-cursor-pointer", children: [
    a,
    s
  ] }), e[2] = n, e[3] = c) : c = e[3], c;
}, T8e = (t) => {
  const e = ve.c(11), {
    cell: n,
    step: r,
    maxTime: i,
    isDisabled: a,
    onChange: s
  } = t;
  switch (n.type) {
    case o_.TIME: {
      let c;
      return e[0] !== n.isUnique || e[1] !== n.value || e[2] !== a || e[3] !== i || e[4] !== s || e[5] !== r ? (c = /* @__PURE__ */ C.jsx(vK, { value: n.value, step: r, maxTime: i, isUnique: n.isUnique, isDisabled: a, onChange: s }), e[0] = n.isUnique, e[1] = n.value, e[2] = a, e[3] = i, e[4] = s, e[5] = r, e[6] = c) : c = e[6], c;
    }
    case o_.PERCENT: {
      let c;
      return e[7] !== n.value || e[8] !== a || e[9] !== s ? (c = /* @__PURE__ */ C.jsx(b8e, { value: n.value, isDisabled: a, onChange: s }), e[7] = n.value, e[8] = a, e[9] = s, e[10] = c) : c = e[10], c;
    }
    default:
      return null;
  }
}, {
  Table: O8e,
  TableBody: R8e,
  TableCell: HC,
  TableHead: bK,
  TableHeader: D8e,
  TableRow: yN
} = LW, N8e = uK(yN), M8e = (t) => {
  const e = ve.c(71), {
    value: n,
    step: r,
    maxTime: i,
    isDisabled: a,
    error: s,
    onChange: c
  } = t;
  let d;
  e[0] !== n ? (d = n ?? [], e[0] = n, e[1] = d) : d = e[1];
  const f = d;
  let g;
  e[2] !== f ? (g = f.length > 0 ? hD.toRows(f) : [], e[2] = f, e[3] = g) : g = e[3];
  const m = g;
  let b;
  e[4] !== c ? (b = (te) => {
    c(te);
  }, e[4] = c, e[5] = b) : b = e[5];
  const w = b;
  let _, A;
  e[6] !== f || e[7] !== a || e[8] !== w || e[9] !== r ? (_ = () => {
    if (f.length === 0 && !a) {
      const te = R4.insertFirstRow(f, r);
      w(te);
    }
  }, A = [f, a, w, r], e[6] = f, e[7] = a, e[8] = w, e[9] = r, e[10] = _, e[11] = A) : (_ = e[10], A = e[11]), I.useEffect(_, A);
  let T;
  e[12] !== f || e[13] !== w || e[14] !== r ? (T = (te) => {
    const ae = R4.insertRow(f, te, r);
    w(ae);
  }, e[12] = f, e[13] = w, e[14] = r, e[15] = T) : T = e[15];
  const O = T;
  let R;
  e[16] !== f || e[17] !== w || e[18] !== r ? (R = () => {
    const te = R4.insertFirstRow(f, r);
    w(te);
  }, e[16] = f, e[17] = w, e[18] = r, e[19] = R) : R = e[19];
  const N = R;
  let M;
  e[20] !== N ? (M = () => {
    N();
  }, e[20] = N, e[21] = M) : M = e[21];
  const P = M;
  let z;
  e[22] !== P || e[23] !== O || e[24] !== m.length ? (z = () => {
    m.length > 0 ? O(m.length) : P();
  }, e[22] = P, e[23] = O, e[24] = m.length, e[25] = z) : z = e[25];
  const F = z;
  let $;
  e[26] !== m || e[27] !== w ? ($ = (te) => {
    const ae = m.filter((de) => de.id !== te), le = hD.fromRows(ae);
    w(le);
  }, e[26] = m, e[27] = w, e[28] = $) : $ = e[28];
  const G = $;
  let H;
  e[29] !== m || e[30] !== w ? (H = (te) => {
    const {
      indexRow: ae,
      indexCell: le,
      value: de
    } = te, _e = m.map(k8e), ue = _e[ae];
    if (!ue)
      return;
    if (le > 0) {
      const Me = ue.cells[0], Ce = ue.cells[1], Ue = ue.cells[2];
      if (!Ce || !Ue || !Me)
        return;
      const rt = Math.min(Math.max(de, 0), 1), it = new Kc(1).minus(rt).toNumber();
      ue.cells = [Me, {
        ...Ce,
        value: le === 1 ? rt : it
      }, {
        ...Ue,
        value: le === 2 ? rt : it
      }];
    } else {
      if (de < 0)
        return;
      const Me = ue.cells[le];
      if (!Me)
        return;
      ue.cells[le] = {
        ...Me,
        value: de
      };
    }
    const Ne = hD.fromRows(_e);
    w(Ne);
  }, e[29] = m, e[30] = w, e[31] = H) : H = e[31];
  const Z = H;
  if (m.length === 0 && a) {
    let te;
    return e[32] === Symbol.for("react.memo_cache_sentinel") ? (te = /* @__PURE__ */ C.jsx("div", { className: "twd-text-sm twd-text-neutral-500 twd-py-4 twd-text-center", children: "No data" }), e[32] = te) : te = e[32], te;
  }
  let V;
  e[33] === Symbol.for("react.memo_cache_sentinel") ? (V = NV.map(j8e), e[33] = V) : V = e[33];
  let Y;
  e[34] !== a ? (Y = !a && /* @__PURE__ */ C.jsx(bK, { className: "twd-h-4 twd-w-10" }), e[34] = a, e[35] = Y) : Y = e[35];
  let ee;
  e[36] !== Y ? (ee = /* @__PURE__ */ C.jsx(D8e, { children: /* @__PURE__ */ C.jsxs(yN, { className: "twd-h-[34px] hover:twd-bg-transparent", children: [
    V,
    Y
  ] }) }), e[36] = Y, e[37] = ee) : ee = e[37];
  let K;
  if (e[38] !== G || e[39] !== Z || e[40] !== O || e[41] !== a || e[42] !== i || e[43] !== m || e[44] !== r) {
    let te;
    e[46] !== G || e[47] !== Z || e[48] !== O || e[49] !== a || e[50] !== i || e[51] !== m.length || e[52] !== r ? (te = (ae, le) => {
      const {
        id: de,
        cells: _e,
        isValidPercent: ue
      } = ae;
      return /* @__PURE__ */ C.jsxs(N8e, { layout: !0, layoutId: String(de), initial: {
        opacity: 0,
        y: -10
      }, animate: {
        opacity: 1,
        y: 0
      }, exit: {
        opacity: 0,
        height: 0
      }, transition: {
        layout: {
          duration: 0.2,
          ease: "easeInOut"
        },
        height: {
          duration: 0.2,
          ease: "easeInOut"
        }
      }, className: un("twd-h-[34px] twd-relative twd-overflow-hidden", le % 2 === 0 ? "twd-bg-secondary-light3 hover:twd-bg-secondary-light4" : "twd-bg-transparent hover:twd-bg-transparent", !ue && "twd-text-error"), children: [
        _e.map((Se, Ne) => /* @__PURE__ */ C.jsxs(HC, { className: "twd-p-0", children: [
          Ne === 0 && /* @__PURE__ */ C.jsx(yK, { onAdd: () => O(le), isDisabled: a }),
          /* @__PURE__ */ C.jsx(T8e, { cell: Se, step: r, maxTime: i, isDisabled: le === 0 && Ne === 0 || a, onChange: (Me) => Z({
            indexCell: Ne,
            indexRow: le,
            value: Me
          }) })
        ] }, `${de}-${Ne}`)),
        !a && !(m.length !== 1 && le !== 0) && /* @__PURE__ */ C.jsx(HC, { className: "twd-p-0 twd-w-10" }),
        !a && m.length !== 1 && le !== 0 && /* @__PURE__ */ C.jsx(HC, { className: "twd-p-0", children: /* @__PURE__ */ C.jsx(cl, { icon: /* @__PURE__ */ C.jsx(C_, { size: "md" }), onClick: () => G(de) }) })
      ] }, de);
    }, e[46] = G, e[47] = Z, e[48] = O, e[49] = a, e[50] = i, e[51] = m.length, e[52] = r, e[53] = te) : te = e[53], K = m.map(te), e[38] = G, e[39] = Z, e[40] = O, e[41] = a, e[42] = i, e[43] = m, e[44] = r, e[45] = K;
  } else
    K = e[45];
  let U;
  e[54] !== K ? (U = /* @__PURE__ */ C.jsx(LQ, { mode: "popLayout", children: K }), e[54] = K, e[55] = U) : U = e[55];
  let q;
  e[56] !== F || e[57] !== a || e[58] !== m.length ? (q = !a && /* @__PURE__ */ C.jsx(yN, { className: "twd-h-[34px] hover:twd-bg-transparent", children: /* @__PURE__ */ C.jsx(HC, { colSpan: NV.length + 1, className: "twd-p-0", children: /* @__PURE__ */ C.jsx(nu, { message: v8e, placement: "bottom", children: /* @__PURE__ */ C.jsx("button", { type: "button", onClick: F, className: un("twd-flex twd-h-8 twd-w-full twd-items-center twd-justify-between twd-rounded twd-px-5 twd-text-sm twd-text-secondary-contrast focus:twd-outline-none", m.length % 2 === 0 ? "twd-bg-secondary-light3 hover:twd-bg-secondary-light4" : "twd-bg-transparent hover:twd-bg-transparent"), children: /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-items-center twd-space-x-4", children: [
    /* @__PURE__ */ C.jsx(q0, { size: "md" }),
    /* @__PURE__ */ C.jsx("span", { children: g8e })
  ] }) }) }) }) }), e[56] = F, e[57] = a, e[58] = m.length, e[59] = q) : q = e[59];
  let W;
  e[60] !== U || e[61] !== q ? (W = /* @__PURE__ */ C.jsxs(R8e, { children: [
    U,
    q
  ] }), e[60] = U, e[61] = q, e[62] = W) : W = e[62];
  let ie;
  e[63] !== ee || e[64] !== W ? (ie = /* @__PURE__ */ C.jsxs(O8e, { children: [
    ee,
    W
  ] }), e[63] = ee, e[64] = W, e[65] = ie) : ie = e[65];
  let J;
  e[66] !== s ? (J = s && /* @__PURE__ */ C.jsx("div", { className: "twd-text-error twd-mt-2 twd-text-left", children: s }), e[66] = s, e[67] = J) : J = e[67];
  let B;
  return e[68] !== ie || e[69] !== J ? (B = /* @__PURE__ */ C.jsxs("div", { className: "twd-w-full twd-space-y-2", children: [
    ie,
    J
  ] }), e[68] = ie, e[69] = J, e[70] = B) : B = e[70], B;
};
function I8e(t) {
  return {
    ...t
  };
}
function k8e(t) {
  return {
    ...t,
    cells: t.cells.map(I8e)
  };
}
function j8e(t) {
  return /* @__PURE__ */ C.jsx(bK, { className: "twd-text-right twd-h-[34px] twd-text-secondary", children: /* @__PURE__ */ C.jsx(nu, { message: t.hint, children: /* @__PURE__ */ C.jsxs("span", { children: [
    /* @__PURE__ */ C.jsx("span", { className: "twd-font-bold", children: t.title }),
    /* @__PURE__ */ C.jsxs("span", { className: "twd-italic twd-ml-1", children: [
      ", ",
      t.dataType
    ] })
  ] }) }) }, t.id);
}
const P8e = (t) => {
  const e = ve.c(8), {
    control: n,
    name: r,
    step: i,
    maxTime: a,
    isDisabled: s
  } = t, c = r;
  let d;
  e[0] !== s || e[1] !== a || e[2] !== i ? (d = (g) => {
    const {
      field: m,
      fieldState: b
    } = g, {
      value: w,
      onChange: _
    } = m, {
      error: A
    } = b;
    return /* @__PURE__ */ C.jsx(M8e, { value: w, onChange: _, step: i, maxTime: a, isDisabled: s, error: A?.message });
  }, e[0] = s, e[1] = a, e[2] = i, e[3] = d) : d = e[3];
  let f;
  return e[4] !== n || e[5] !== c || e[6] !== d ? (f = /* @__PURE__ */ C.jsx($I, { control: n, name: c, render: d }), e[4] = n, e[5] = c, e[6] = d, e[7] = f) : f = e[7], f;
};
class U1 {
  static sortRowsByTime(e) {
    return [...e].sort((n, r) => n.time - r.time);
  }
  static toRows(e) {
    return e.map((n, r) => ({
      ...n,
      id: `${n.time}-${n.position}-${r}`
    }));
  }
  static fromRows(e) {
    return this.sortRowsByTime(e).map(({
      time: n,
      position: r
    }) => ({
      time: n,
      position: r
    }));
  }
}
const L8e = (t) => Number((t + KE).toFixed(2)), B8e = (t) => t === 1 ? 2 : 1;
class pD {
  static insertFirstRow(e) {
    return e.length > 0 ? e : [{
      id: s_(),
      time: 0,
      position: 1
    }];
  }
  static insertRow(e, n) {
    const r = e[n - 1];
    if (!r)
      return {
        isInserted: !1,
        data: e
      };
    const a = e[n]?.time, s = L8e(r.time);
    if (a != null && s >= a)
      return {
        isInserted: !1,
        data: e
      };
    const c = {
      id: s_(),
      time: s,
      position: B8e(r.position)
    }, d = [...e];
    return d.splice(n, 0, c), {
      isInserted: !0,
      data: d
    };
  }
}
const IV = [{
  id: 1,
  title: "Time",
  dataType: "min",
  hint: "Sets time from run start when valve position should change."
}, {
  id: 2,
  title: "Position",
  dataType: "",
  hint: "Sets valve position for the selected time."
}], z8e = "Add row", F8e = "Adds another row to valve position plan.", V8e = `Cannot add a row between selected rows: minimum time step is ${KE} min.`, U8e = (t) => {
  const e = ve.c(8), {
    value: n,
    isDisabled: r,
    onChange: i
  } = t;
  let a;
  e[0] !== i ? (a = (g) => {
    const m = oQ.safeParse(Number(g.target.value));
    if (!m.success)
      throw new Error(`Invalid valve position: ${g.target.value}`);
    i(m.data);
  }, e[0] = i, e[1] = a) : a = e[1];
  const s = a;
  let c, d;
  e[2] === Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ C.jsx("option", { value: 1, children: "Position 1" }), d = /* @__PURE__ */ C.jsx("option", { value: 2, children: "Position 2" }), e[2] = c, e[3] = d) : (c = e[2], d = e[3]);
  let f;
  return e[4] !== s || e[5] !== r || e[6] !== n ? (f = /* @__PURE__ */ C.jsxs("select", { value: n, disabled: r, className: "twd-text-sm twd-bg-transparent twd-text-neutral-900 disabled:twd-bg-transparent disabled:twd-text-neutral-500 twd-h-9 twd-w-full twd-rounded twd-border-0 twd-px-3 twd-text-right twd-transition twd-duration-150 focus:twd-outline-none", onChange: s, children: [
    c,
    d
  ] }), e[4] = s, e[5] = r, e[6] = n, e[7] = f) : f = e[7], f;
}, {
  Table: $8e,
  TableBody: H8e,
  TableCell: VS,
  TableHead: wK,
  TableHeader: q8e,
  TableRow: bN
} = LW, G8e = uK(bN), Y8e = (t) => {
  const e = ve.c(69), {
    value: n,
    maxTime: r,
    isDisabled: i,
    error: a,
    onChange: s
  } = t, {
    showErrorNotification: c
  } = nd();
  let d;
  e[0] !== n ? (d = n ?? [], e[0] = n, e[1] = d) : d = e[1];
  const f = d;
  let g;
  e[2] !== f ? (g = U1.toRows(f), e[2] = f, e[3] = g) : g = e[3];
  const m = g;
  let b;
  e[4] !== s ? (b = (J) => {
    s(J);
  }, e[4] = s, e[5] = b) : b = e[5];
  const w = b;
  let _;
  e[6] !== i || e[7] !== f.length || e[8] !== w ? (_ = () => {
    if (f.length === 0 && !i) {
      const J = pD.insertFirstRow([]), B = U1.fromRows(J);
      w(B);
    }
  }, e[6] = i, e[7] = f.length, e[8] = w, e[9] = _) : _ = e[9];
  let A;
  e[10] !== i || e[11] !== f || e[12] !== w ? (A = [i, f, w], e[10] = i, e[11] = f, e[12] = w, e[13] = A) : A = e[13], I.useEffect(_, A);
  let T;
  e[14] !== m || e[15] !== w || e[16] !== c ? (T = (J) => {
    const B = pD.insertRow(m, J);
    if (!B.isInserted) {
      c(V8e);
      return;
    }
    const te = U1.fromRows(B.data);
    w(te);
  }, e[14] = m, e[15] = w, e[16] = c, e[17] = T) : T = e[17];
  const O = T;
  let R;
  e[18] !== m || e[19] !== w ? (R = () => {
    const J = pD.insertRow(m, m.length);
    if (!J.isInserted)
      return;
    const B = U1.fromRows(J.data);
    w(B);
  }, e[18] = m, e[19] = w, e[20] = R) : R = e[20];
  const N = R;
  let M;
  e[21] !== m || e[22] !== w ? (M = (J) => {
    if (m.length <= 1)
      return;
    const B = m.filter((ae) => ae.id !== J);
    if (B.length === 0)
      return;
    const te = U1.fromRows(B);
    w(te);
  }, e[21] = m, e[22] = w, e[23] = M) : M = e[23];
  const P = M;
  let z;
  e[24] !== m || e[25] !== w ? (z = (J, B) => {
    if (B < 0)
      return;
    const te = new Kc(KE);
    if (!new Kc(B).mod(te).equals(0))
      return;
    const ae = m.map((de, _e) => _e === J ? {
      ...de,
      time: B
    } : de), le = U1.fromRows(ae);
    w(le);
  }, e[24] = m, e[25] = w, e[26] = z) : z = e[26];
  const F = z;
  let $;
  e[27] !== m || e[28] !== w ? ($ = (J, B) => {
    const te = m.map((le, de) => de === J ? {
      ...le,
      position: B
    } : le), ae = U1.fromRows(te);
    w(ae);
  }, e[27] = m, e[28] = w, e[29] = $) : $ = e[29];
  const G = $;
  if (m.length === 0 && i) {
    let J;
    return e[30] === Symbol.for("react.memo_cache_sentinel") ? (J = /* @__PURE__ */ C.jsx("div", { className: "twd-text-sm twd-text-neutral-500 twd-py-4 twd-text-center", children: "No data" }), e[30] = J) : J = e[30], J;
  }
  let H;
  e[31] === Symbol.for("react.memo_cache_sentinel") ? (H = IV.map(X8e), e[31] = H) : H = e[31];
  let Z;
  e[32] !== i ? (Z = !i && /* @__PURE__ */ C.jsx(wK, { className: "twd-h-4 twd-w-10" }), e[32] = i, e[33] = Z) : Z = e[33];
  let V;
  e[34] !== Z ? (V = /* @__PURE__ */ C.jsx(q8e, { children: /* @__PURE__ */ C.jsxs(bN, { className: "twd-h-[34px] hover:twd-bg-transparent", children: [
    H,
    Z
  ] }) }), e[34] = Z, e[35] = V) : V = e[35];
  let Y;
  if (e[36] !== P || e[37] !== O || e[38] !== i || e[39] !== r || e[40] !== m || e[41] !== G || e[42] !== F) {
    let J;
    e[44] !== P || e[45] !== O || e[46] !== i || e[47] !== r || e[48] !== m.length || e[49] !== G || e[50] !== F ? (J = (B, te) => /* @__PURE__ */ C.jsxs(G8e, { layout: !0, layoutId: String(B.id), initial: {
      opacity: 0,
      y: -10
    }, animate: {
      opacity: 1,
      y: 0
    }, exit: {
      opacity: 0,
      height: 0
    }, transition: {
      layout: {
        duration: 0.2,
        ease: "easeInOut"
      },
      height: {
        duration: 0.2,
        ease: "easeInOut"
      }
    }, className: un("twd-h-[34px] twd-relative twd-overflow-hidden", te % 2 === 0 ? "twd-bg-secondary-light3 hover:twd-bg-secondary-light4" : "twd-bg-transparent hover:twd-bg-transparent"), children: [
      /* @__PURE__ */ C.jsxs(VS, { className: "twd-p-0", children: [
        te === 0 && /* @__PURE__ */ C.jsx("span", { className: "twd-absolute twd-left-3 twd-top-2 twd-max-w-[45%] twd-truncate twd-text-sm twd-italic twd-text-secondary", children: "initial position" }),
        te !== 0 && /* @__PURE__ */ C.jsx(yK, { onAdd: () => O(te), isDisabled: i }),
        /* @__PURE__ */ C.jsx(vK, { value: B.time, step: KE, maxTime: r, isDisabled: te === 0 || i, onChange: (ae) => F(te, ae) })
      ] }),
      /* @__PURE__ */ C.jsx(VS, { className: "twd-p-0", children: /* @__PURE__ */ C.jsx(U8e, { value: B.position, isDisabled: i, onChange: (ae) => G(te, ae) }) }),
      !i && !(m.length !== 1 && te !== 0) && /* @__PURE__ */ C.jsx(VS, { className: "twd-p-0 twd-w-10" }),
      !i && m.length !== 1 && te !== 0 && /* @__PURE__ */ C.jsx(VS, { className: "twd-p-0", children: /* @__PURE__ */ C.jsx(cl, { icon: /* @__PURE__ */ C.jsx(C_, { size: "md" }), onClick: () => P(B.id) }) })
    ] }, B.id), e[44] = P, e[45] = O, e[46] = i, e[47] = r, e[48] = m.length, e[49] = G, e[50] = F, e[51] = J) : J = e[51], Y = m.map(J), e[36] = P, e[37] = O, e[38] = i, e[39] = r, e[40] = m, e[41] = G, e[42] = F, e[43] = Y;
  } else
    Y = e[43];
  let ee;
  e[52] !== Y ? (ee = /* @__PURE__ */ C.jsx(LQ, { mode: "popLayout", children: Y }), e[52] = Y, e[53] = ee) : ee = e[53];
  let K;
  e[54] !== N || e[55] !== i || e[56] !== m.length ? (K = !i && /* @__PURE__ */ C.jsx(bN, { className: "twd-h-[34px] hover:twd-bg-transparent", children: /* @__PURE__ */ C.jsx(VS, { colSpan: IV.length + 1, className: "twd-p-0", children: /* @__PURE__ */ C.jsx(nu, { message: F8e, placement: "bottom", children: /* @__PURE__ */ C.jsx("button", { type: "button", onClick: N, className: un("twd-flex twd-h-8 twd-w-full twd-items-center twd-justify-between twd-rounded twd-px-5 twd-text-sm twd-text-secondary-contrast focus:twd-outline-none", m.length % 2 === 0 ? "twd-bg-secondary-light3 hover:twd-bg-secondary-light4" : "twd-bg-transparent hover:twd-bg-transparent"), children: /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-items-center twd-space-x-4", children: [
    /* @__PURE__ */ C.jsx(q0, { size: "md" }),
    /* @__PURE__ */ C.jsx("span", { children: z8e })
  ] }) }) }) }) }), e[54] = N, e[55] = i, e[56] = m.length, e[57] = K) : K = e[57];
  let U;
  e[58] !== ee || e[59] !== K ? (U = /* @__PURE__ */ C.jsxs(H8e, { children: [
    ee,
    K
  ] }), e[58] = ee, e[59] = K, e[60] = U) : U = e[60];
  let q;
  e[61] !== V || e[62] !== U ? (q = /* @__PURE__ */ C.jsxs($8e, { children: [
    V,
    U
  ] }), e[61] = V, e[62] = U, e[63] = q) : q = e[63];
  let W;
  e[64] !== a ? (W = a && /* @__PURE__ */ C.jsx("div", { className: "twd-text-error twd-mt-2 twd-text-left", children: a }), e[64] = a, e[65] = W) : W = e[65];
  let ie;
  return e[66] !== q || e[67] !== W ? (ie = /* @__PURE__ */ C.jsxs("div", { className: "twd-w-full twd-space-y-2", children: [
    q,
    W
  ] }), e[66] = q, e[67] = W, e[68] = ie) : ie = e[68], ie;
};
function X8e(t) {
  return /* @__PURE__ */ C.jsx(wK, { className: "twd-text-right twd-h-[34px] twd-text-secondary", children: /* @__PURE__ */ C.jsx(nu, { message: t.hint, children: /* @__PURE__ */ C.jsxs("span", { children: [
    /* @__PURE__ */ C.jsx("span", { className: "twd-font-bold", children: t.title }),
    t.dataType !== "" && /* @__PURE__ */ C.jsxs("span", { className: "twd-italic twd-ml-1", children: [
      ", ",
      t.dataType
    ] })
  ] }) }) }, t.id);
}
const W8e = (t) => {
  const e = ve.c(7), {
    control: n,
    name: r,
    maxTime: i,
    isDisabled: a
  } = t, s = r;
  let c;
  e[0] !== a || e[1] !== i ? (c = (f) => {
    const {
      field: g,
      fieldState: m
    } = f, {
      value: b,
      onChange: w
    } = g, {
      error: _
    } = m;
    return /* @__PURE__ */ C.jsx(Y8e, { value: b, onChange: w, maxTime: i, isDisabled: a, error: _?.message });
  }, e[0] = a, e[1] = i, e[2] = c) : c = e[2];
  let d;
  return e[3] !== n || e[4] !== s || e[5] !== c ? (d = /* @__PURE__ */ C.jsx($I, { control: n, name: s, render: c }), e[3] = n, e[4] = s, e[5] = c, e[6] = d) : d = e[6], d;
}, xK = 0.05, SK = "Volume of sample that will be collected (in μL). Maximum: 50 μL.", kV = (t) => YT(t, {
  exclude: ["D", "D2", "D3", "D4"]
});
var X7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "UpdateFavoriteStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "methodId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "isFavorite" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "method" }, name: { kind: "Name", value: "updateMethod" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "pk_columns" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "methodId" } } }] } }, { kind: "Argument", name: { kind: "Name", value: "_set" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "favorite" }, value: { kind: "Variable", name: { kind: "Name", value: "isFavorite" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 174 } };
X7.loc.source = { body: `mutation UpdateFavoriteStatus($methodId: Int!, $isFavorite: Boolean!) {
  method: updateMethod(pk_columns: { id: $methodId }, _set: { favorite: $isFavorite }) {
    id
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function D4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    D4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    D4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    D4(r, e);
  });
}
var wN = {};
(function() {
  X7.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      D4(e, n), wN[e.name.value] = n;
    }
  });
})();
function jV(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function Q8e(t, e) {
  var n = {
    kind: t.kind,
    definitions: [jV(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = wN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = wN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = jV(t, c);
    d && n.definitions.push(d);
  }), n;
}
const PV = Q8e(X7, "UpdateFavoriteStatus");
var W7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "UpdateArchivingStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "methodId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "isArchived" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "method" }, name: { kind: "Name", value: "updateMethod" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "pk_columns" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "methodId" } } }] } }, { kind: "Argument", name: { kind: "Name", value: "_set" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "archived" }, value: { kind: "Variable", name: { kind: "Name", value: "isArchived" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 175 } };
W7.loc.source = { body: `mutation UpdateArchivingStatus($methodId: Int!, $isArchived: Boolean!) {
  method: updateMethod(pk_columns: { id: $methodId }, _set: { archived: $isArchived }) {
    id
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function N4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    N4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    N4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    N4(r, e);
  });
}
var xN = {};
(function() {
  W7.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      N4(e, n), xN[e.name.value] = n;
    }
  });
})();
function LV(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function Z8e(t, e) {
  var n = {
    kind: t.kind,
    definitions: [LV(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = xN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = xN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = LV(t, c);
    d && n.definitions.push(d);
  }), n;
}
const BV = Z8e(W7, "UpdateArchivingStatus"), Vg = {
  createMethod(t) {
    return lo.httpClientForCloud.post("methods/", kV(t));
  },
  editMethod(t, e) {
    return lo.httpClientForCloud.put(`methods/${t}/`, kV(e));
  },
  addMethodToFavorites(t) {
    return lo.httpClientForHasura.fetch(PV, {
      methodId: t,
      isFavorite: !0
    });
  },
  removeMethodFromFavorites(t) {
    return lo.httpClientForHasura.fetch(PV, {
      methodId: t,
      isFavorite: !1
    });
  },
  archiveMethod(t) {
    return lo.httpClientForHasura.fetch(BV, {
      methodId: t,
      isArchived: !0
    });
  },
  restoreMethod(t) {
    return lo.httpClientForHasura.fetch(BV, {
      methodId: t,
      isArchived: !1
    });
  },
  getMethodDefaultValues() {
    return fetch("https://get.chrom.app/method_default_values.json").then((t) => t.json());
  }
}, K8e = "ArchiveMethod", J8e = (t) => {
  const e = ve.c(2);
  let n;
  return e[0] !== t ? (n = {
    mutationKey: [K8e, t],
    mutationFn: async () => Vg.archiveMethod(t),
    onSuccess() {
    }
  }, e[0] = t, e[1] = n) : n = e[1], Ei(n);
}, eNe = "RestoreMethod", tNe = (t) => {
  const e = ve.c(2);
  let n;
  return e[0] !== t ? (n = {
    mutationKey: [eNe, t],
    mutationFn: async () => Vg.restoreMethod(t),
    onSuccess() {
    }
  }, e[0] = t, e[1] = n) : n = e[1], Ei(n);
}, a5 = S5((t) => ({
  status: {
    isArchived: !1,
    isInFavorites: !1
  },
  initMethodStatus: (e) => t({
    status: e
  }),
  setIsArchived: (e) => t((n) => ({
    status: {
      ...n.status,
      isArchived: e
    }
  })),
  setIsInFavorites: (e) => t((n) => ({
    status: {
      ...n.status,
      isInFavorites: e
    }
  }))
})), nNe = (t) => {
  const e = ve.c(12), {
    isArchived: n,
    methodId: r
  } = t, {
    mutateAsync: i,
    isPending: a
  } = J8e(r), {
    mutateAsync: s,
    isPending: c
  } = tNe(r), d = a5(rNe);
  let f;
  e[0] !== i || e[1] !== n || e[2] !== s || e[3] !== d ? (f = async () => {
    if (n) {
      await s(), d(!1);
      return;
    }
    await i(), d(!0);
  }, e[0] = i, e[1] = n, e[2] = s, e[3] = d, e[4] = f) : f = e[4];
  const g = f, m = n ? c : a;
  let b;
  e[5] !== n ? (b = n ? /* @__PURE__ */ C.jsx(xI, { size: "lg" }) : /* @__PURE__ */ C.jsx(Yb, { size: "lg" }), e[5] = n, e[6] = b) : b = e[6];
  const w = b, _ = n ? "Restore" : "Archive";
  let A;
  return e[7] !== w || e[8] !== m || e[9] !== g || e[10] !== _ ? (A = /* @__PURE__ */ C.jsx(Vt, { variant: "transparent", isLoading: m, onClick: g, icon: w, className: "twd-text-primary", children: _ }), e[7] = w, e[8] = m, e[9] = g, e[10] = _, e[11] = A) : A = e[11], A;
};
function rNe(t) {
  return t.setIsArchived;
}
const iNe = "AddMethodToFavorites", aNe = (t) => {
  const e = ve.c(2);
  let n;
  return e[0] !== t ? (n = {
    mutationKey: [iNe, t],
    mutationFn: async () => Vg.addMethodToFavorites(t),
    onSuccess() {
    }
  }, e[0] = t, e[1] = n) : n = e[1], Ei(n);
}, oNe = "RemoveMethodFromFavorites", sNe = (t) => {
  const e = ve.c(2);
  let n;
  return e[0] !== t ? (n = {
    mutationKey: [oNe, t],
    mutationFn: async () => Vg.removeMethodFromFavorites(t),
    onSuccess() {
    }
  }, e[0] = t, e[1] = n) : n = e[1], Ei(n);
}, lNe = (t) => {
  const e = ve.c(12), {
    isInFavorites: n,
    methodId: r
  } = t, {
    mutateAsync: i,
    isPending: a
  } = aNe(r), {
    mutateAsync: s,
    isPending: c
  } = sNe(r), d = a5(cNe);
  let f;
  e[0] !== i || e[1] !== n || e[2] !== s || e[3] !== d ? (f = async () => {
    if (n) {
      await s(), d(!1);
      return;
    }
    await i(), d(!0);
  }, e[0] = i, e[1] = n, e[2] = s, e[3] = d, e[4] = f) : f = e[4];
  const g = f, m = n ? c : a;
  let b;
  e[5] !== n ? (b = n ? /* @__PURE__ */ C.jsx(wI, { size: "lg" }) : /* @__PURE__ */ C.jsx(RY, { size: "lg" }), e[5] = n, e[6] = b) : b = e[6];
  const w = b, _ = n ? "Remove" : "Favorite";
  let A;
  return e[7] !== w || e[8] !== m || e[9] !== g || e[10] !== _ ? (A = /* @__PURE__ */ C.jsx(Vt, { variant: "transparent", onClick: g, isLoading: m, icon: w, className: "twd-text-primary", children: _ }), e[7] = w, e[8] = m, e[9] = g, e[10] = _, e[11] = A) : A = e[11], A;
};
function cNe(t) {
  return t.setIsInFavorites;
}
const EK = (t) => {
  const e = ve.c(9), {
    methodId: n,
    isFormDisabled: r,
    isArchived: i,
    isInFavorites: a
  } = t;
  if (r || n == null)
    return null;
  let s;
  e[0] !== i || e[1] !== n ? (s = i != null && n != null && /* @__PURE__ */ C.jsx(nNe, { isArchived: i, methodId: n }), e[0] = i, e[1] = n, e[2] = s) : s = e[2];
  let c;
  e[3] !== a || e[4] !== n ? (c = a != null && n != null && /* @__PURE__ */ C.jsx(lNe, { isInFavorites: a, methodId: n }), e[3] = a, e[4] = n, e[5] = c) : c = e[5];
  let d;
  return e[6] !== s || e[7] !== c ? (d = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-flex-col twd-items-start twd-gap-1 twd-min-w-[90px]", children: [
    s,
    c
  ] }), e[6] = s, e[7] = c, e[8] = d) : d = e[8], d;
}, uNe = Re.div`
  twd-space-y-3
`, dNe = Re.div`
  twd-flex
  twd-items-center
  twd-text-lg
`, db = (t) => {
  const e = ve.c(11), {
    title: n,
    children: r,
    icon: i,
    hint: a
  } = t;
  let s;
  e[0] !== i || e[1] !== n ? (s = i ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    i,
    /* @__PURE__ */ C.jsx("span", { children: n })
  ] }) : n, e[0] = i, e[1] = n, e[2] = s) : s = e[2];
  const c = s;
  let d;
  e[3] !== c ? (d = /* @__PURE__ */ C.jsx("span", { className: "twd-flex twd-items-center twd-gap-1", children: c }), e[3] = c, e[4] = d) : d = e[4];
  const f = d;
  let g;
  e[5] !== a || e[6] !== f ? (g = /* @__PURE__ */ C.jsx(dNe, { children: a ? /* @__PURE__ */ C.jsx(nu, { message: a, placement: "top-start", children: f }) : f }), e[5] = a, e[6] = f, e[7] = g) : g = e[7];
  let m;
  return e[8] !== r || e[9] !== g ? (m = /* @__PURE__ */ C.jsxs(uNe, { children: [
    g,
    r
  ] }), e[8] = r, e[9] = g, e[10] = m) : m = e[10], m;
}, Ug = Xe({
  major: Ve(),
  minor: Ve()
}), Q7 = Dg({
  WASHING: "wash",
  SHAKING: "shake"
});
Q7.enum;
const fNe = Xe({
  id: Je(),
  tray: Ve(),
  serial: Je(),
  operations: Xr(Q7),
  supportedTrays: gg(Ve()),
  firmwareVersion: Ug
}), hNe = Xe({
  id: Je(),
  tray: Ve(),
  serial: Je(),
  // vialInUse: null,
  operations: Xr(Q7),
  injectionTray: Ve(),
  // supportedTrays: z.record(z.number()),
  supportedInjectionTrays: gg(Ve()),
  firmwareVersion: Ug
}), pNe = gg(Xe({
  nm: Ve().nullable(),
  name: Je()
}).nullable()).transform((t) => Object.fromEntries(Object.entries(t).filter(([, e]) => e?.nm != null))).pipe(gg(Xe({
  nm: Ve(),
  name: Je()
}))), mNe = Xe({
  id: Je(),
  mps: Ve(),
  period: Ve(),
  serial: Je(),
  measurements: pNe,
  firmwareVersion: Ug
}), gNe = Xe({
  mps: Ve(),
  period: Ve()
}).or(Ve()), zV = Xe({
  id: Je(),
  type: Je(),
  serial: Je(),
  solvents: Ve().optional(),
  pressureSensor: Sr(),
  firmwareVersion: Ug,
  pressureSensorVersion: Je().optional(),
  amount: Ve()
}), vNe = Xe({
  a: zV,
  b: zV
}), yNe = Xe({
  id: Je(),
  type: Je(),
  pumps: vNe.optional(),
  serial: Je(),
  solvents: Ve().optional(),
  pressureSensor: Sr(),
  firmwareVersion: Ug,
  pressureSensorVersion: Je().optional()
}), bNe = Xe({
  id: Je(),
  serial: Je(),
  firmwareVersion: Ug
}), wNe = Xe({
  id: Je(),
  serial: Je(),
  firmwareVersion: Ug
}), xNe = Xe({
  phaseContainers: Xe({
    a: Xe({
      amount: Ve().nullable(),
      volume: Ve().nullable()
    }).optional(),
    b: Xe({
      amount: Ve().nullable(),
      volume: Ve().nullable()
    }).optional()
  }).nullable()
}), SNe = Xe({
  amount: Ve(),
  volume: Ve()
}), ENe = Xe({
  id: Je(),
  name: Je(),
  serial: Je()
});
Xe({
  // device: z.string(),
  alltesta: Xe({
    serialDevices: Xr(ENe)
  }).nullable(),
  // phase_rfid: z.string().nullable(),
  pump: yNe.nullable(),
  // pressure: null,
  autosampler: fNe.nullable(),
  autosamplerFractionCollector: hNe.nullable(),
  fractionCollectorValve: wNe.nullable(),
  valveLoop: bNe.nullable(),
  // valve: null,
  analogSignal: gNe.nullable(),
  phase: xNe,
  detector: mNe.nullable(),
  waste: SNe.nullable()
});
const Z7 = Dg({
  ALLTESTA: "slc",
  CROMITE: "cmt"
}), FV = Z7.enum, _Ne = Xe({
  injectionId: Ve().nullable().optional()
});
Xe({
  id: Je(),
  name: Je(),
  model: Z7.nullable().optional(),
  isOnline: Sr().nullable().optional(),
  lastOnline: Je().nullable().optional(),
  state: _Ne.nullable().optional()
});
const ew = S5((t) => ({
  isEditMode: !1,
  enableEditMode: () => t({
    isEditMode: !0
  }),
  disableEditMode: () => t({
    isEditMode: !1
  }),
  setEditMode: (e) => t({
    isEditMode: e
  })
})), hO = (t) => {
  try {
    const e = t instanceof Date ? t : new Date(t);
    return Number.isNaN(e.getTime()) ? String(t) : e.toLocaleString();
  } catch {
    return String(t);
  }
}, ANe = (t) => t.replace(/(\.\d*?[1-9])0+$/, "$1").replace(/\.0+$/, ""), _K = (t, e, n = Kc.ROUND_DOWN) => {
  if (typeof t == "string" && t.trim() === "")
    return t;
  try {
    const r = new Kc(t), i = ANe(e == null ? r.toFixed() : r.toDecimalPlaces(e, n).toFixed(e));
    return i === "-0" || i === "" ? "0" : i;
  } catch {
    return String(t);
  }
}, CNe = (t) => _K(t), Ms = (t, e = 3) => _K(t, e), vr = (t) => {
  const e = `[${t}]`;
  return {
    debug: (...n) => {
      console.debug(e, ...n);
    },
    info: (...n) => {
      console.info(e, ...n);
    },
    warn: (...n) => {
      console.warn(e, ...n);
    },
    error: (...n) => {
      console.error(e, ...n);
    }
  };
}, TNe = __("twd-inline-flex twd-h-5 twd-items-center twd-rounded-sm twd-px-2 twd-text-xs twd-font-bold twd-text-secondary-contrast twd-whitespace-nowrap", {
  variants: {
    variant: {
      online: "twd-bg-success twd-text-white",
      working: "twd-bg-process twd-text-white",
      unknown: "twd-bg-secondary-light3 twd-text-secondary-contrast",
      offline: "twd-bg-secondary-light3 twd-text-secondary-contrast"
    }
  },
  defaultVariants: {
    variant: "offline"
  }
}), ONe = vr("DeviceOnlineStatus"), RNe = (t) => {
  const e = ve.c(11), {
    device: n,
    isSmallerOnAdaptive: r,
    className: i
  } = t, a = r === void 0 ? !0 : r;
  n.state == null && ONe.warn("Device state is missing", {
    deviceId: n.id
  });
  const s = n.state?.injectionId != null, c = n.isOnline, d = n.lastOnline;
  let f;
  e: {
    if (s) {
      f = "working";
      break e;
    }
    if (c == null) {
      f = "unknown";
      break e;
    }
    f = c ? "online" : "offline";
  }
  const g = f, m = c === !1 && !!d;
  let b;
  e[0] !== i || e[1] !== g ? (b = TNe({
    variant: g,
    className: i
  }), e[0] = i, e[1] = g, e[2] = b) : b = e[2];
  let w;
  e[3] !== m || e[4] !== c || e[5] !== a || e[6] !== d ? (w = c ? "• Online" : c == null ? "• ?" : m ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    "• Offline",
    /* @__PURE__ */ C.jsxs("span", { className: Xc("twd-ml-1", a && "twd-hidden xs:twd-inline"), children: [
      "since ",
      hO(d)
    ] })
  ] }) : "• Offline", e[3] = m, e[4] = c, e[5] = a, e[6] = d, e[7] = w) : w = e[7];
  let _;
  return e[8] !== b || e[9] !== w ? (_ = /* @__PURE__ */ C.jsx("span", { className: b, children: w }), e[8] = b, e[9] = w, e[10] = _) : _ = e[10], _;
}, DNe = (t) => {
  const e = t.replace(/-/g, "").toUpperCase();
  return e.length <= 4 ? e : `${e.slice(0, 4)}-${e.slice(4)}`;
}, NNe = Re.div`
  twd-inline-flex
  twd-items-center
  twd-whitespace-nowrap
  twd-text-secondary
`, MNe = Re.span`
  twd-mr-2
`, INe = (t) => {
  const e = ve.c(4), {
    device: n
  } = t;
  let r;
  e[0] !== n.id ? (r = n.id ? DNe(n.id) : "Not connected", e[0] = n.id, e[1] = r) : r = e[1];
  const i = r;
  let a;
  return e[2] !== i ? (a = /* @__PURE__ */ C.jsx(NNe, { children: /* @__PURE__ */ C.jsx(MNe, { children: i }) }), e[2] = i, e[3] = a) : a = e[3], a;
}, kNe = Re.span`
  twd-inline-flex
  twd-whitespace-nowrap
  twd-font-bold
`, jNe = (t) => {
  switch (t) {
    case FV.CROMITE:
      return "Cromite";
    case FV.ALLTESTA:
      return "Alltesta";
    default:
      return "Unknown type";
  }
}, PNe = (t) => {
  const e = ve.c(4), {
    model: n
  } = t;
  let r;
  e[0] !== n ? (r = jNe(n), e[0] = n, e[1] = r) : r = e[1];
  let i;
  return e[2] !== r ? (i = /* @__PURE__ */ C.jsx(kNe, { children: r }), e[2] = r, e[3] = i) : i = e[3], i;
}, LNe = Xe({
  isOnline: Sr().nullable(),
  lastOnline: Je().nullable().optional(),
  model: Z7.nullable().optional()
}), BNe = Xe({
  injectionId: Ve().nullable().optional()
}), zNe = Xe({
  id: Je(),
  name: Je(),
  hardware: LNe,
  state: BNe.nullable().optional()
}), FNe = Xe({
  devices: Xr(zNe)
});
var K7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "Devices" }, variableDefinitions: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "devices" }, name: { kind: "Name", value: "devicesPrivate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order_by" }, value: { kind: "ListValue", values: [{ kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "hardware" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "online" }, value: { kind: "EnumValue", value: "desc" } }] } }] }, { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "EnumValue", value: "asc" } }] }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "hardware" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "isOnline" }, name: { kind: "Name", value: "online" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "lastOnline" }, name: { kind: "Name", value: "date_last_online" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "model" }, arguments: [], directives: [] }] } }, { kind: "Field", name: { kind: "Name", value: "state" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "injection_id" }, arguments: [], directives: [] }] } }] } }] } }], loc: { start: 0, end: 299 } };
K7.loc.source = { body: `query Devices {
    devices: devicesPrivate(order_by: [{hardware: {online: desc}}, {name: asc}]) {
        id
        name
        hardware {
            isOnline: online
            lastOnline: date_last_online
            model
        }
        state {
            injection_id
        }
    }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function M4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    M4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    M4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    M4(r, e);
  });
}
var SN = {};
(function() {
  K7.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      M4(e, n), SN[e.name.value] = n;
    }
  });
})();
function VV(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function VNe(t, e) {
  var n = {
    kind: t.kind,
    definitions: [VV(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = SN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = SN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = VV(t, c);
    d && n.definitions.push(d);
  }), n;
}
const UNe = VNe(K7, "Devices"), $Ne = {
  getDevices() {
    return lo.httpClientForHasura.fetch(UNe);
  }
}, HNe = vr("useSubscribeDevices"), J7 = ["Devices"], UV = 1e4, qNe = 1e3, GNe = (t) => t?.devices?.length && t.devices.some((n) => n.hardware?.isOnline == null) ? qNe : UV, YNe = () => {
  const t = ve.c(9);
  let e;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    queryKey: J7,
    queryFn: XNe,
    refetchInterval: WNe,
    refetchIntervalInBackground: !0,
    refetchOnMount: !1,
    refetchOnWindowFocus: !1,
    refetchOnReconnect: !1
  }, t[0] = e) : e = t[0];
  const {
    data: n,
    isLoading: r,
    isFetching: i,
    error: a
  } = kh(e);
  let s;
  if (t[1] !== n) {
    e: {
      if (n == null) {
        let b;
        t[3] === Symbol.for("react.memo_cache_sentinel") ? (b = {
          devices: null,
          validationError: null
        }, t[3] = b) : b = t[3], s = b;
        break e;
      }
      try {
        s = {
          devices: qt(FNe, n).devices.map(QNe),
          validationError: null
        };
      } catch (b) {
        const w = b;
        HNe.error("Devices DTO validation failed", w), s = {
          devices: null,
          validationError: new iw("Schema parse error", {
            cause: w,
            props: {
              source: "devices"
            }
          })
        };
      }
    }
    t[1] = n, t[2] = s;
  } else
    s = t[2];
  const {
    devices: c,
    validationError: d
  } = s, f = a ? String(a) : null, g = d ?? f;
  let m;
  return t[4] !== c || t[5] !== i || t[6] !== r || t[7] !== g ? (m = {
    data: c,
    isLoading: r,
    isFetching: i,
    error: g
  }, t[4] = c, t[5] = i, t[6] = r, t[7] = g, t[8] = m) : m = t[8], m;
};
async function XNe() {
  return await $Ne.getDevices();
}
function WNe(t) {
  return GNe(t.state.data ?? null);
}
function QNe(t) {
  return {
    id: t.id,
    name: t.name,
    model: t.hardware.model ?? null,
    isOnline: t.hardware.isOnline,
    lastOnline: t.hardware.lastOnline ?? null,
    state: t.state ?? null
  };
}
var AK = {}, CK = {}, ek = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(n) {
    if (n = `${n}`, n === "0")
      return "0";
    if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(n))
      return n.replace(/^[+-]?/, (i) => i === "-" ? "" : "-");
    let r = [
      "var",
      "calc",
      "min",
      "max",
      "clamp"
    ];
    for (const i of r)
      if (n.includes(`${i}(`))
        return `calc(${n} * -1)`;
  }
})(ek);
var TK = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  const e = [
    "preflight",
    "container",
    "accessibility",
    "pointerEvents",
    "visibility",
    "position",
    "inset",
    "isolation",
    "zIndex",
    "order",
    "gridColumn",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRow",
    "gridRowStart",
    "gridRowEnd",
    "float",
    "clear",
    "margin",
    "boxSizing",
    "lineClamp",
    "display",
    "aspectRatio",
    "size",
    "height",
    "maxHeight",
    "minHeight",
    "width",
    "minWidth",
    "maxWidth",
    "flex",
    "flexShrink",
    "flexGrow",
    "flexBasis",
    "tableLayout",
    "captionSide",
    "borderCollapse",
    "borderSpacing",
    "transformOrigin",
    "translate",
    "rotate",
    "skew",
    "scale",
    "transform",
    "animation",
    "cursor",
    "touchAction",
    "userSelect",
    "resize",
    "scrollSnapType",
    "scrollSnapAlign",
    "scrollSnapStop",
    "scrollMargin",
    "scrollPadding",
    "listStylePosition",
    "listStyleType",
    "listStyleImage",
    "appearance",
    "columns",
    "breakBefore",
    "breakInside",
    "breakAfter",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridTemplateColumns",
    "gridTemplateRows",
    "flexDirection",
    "flexWrap",
    "placeContent",
    "placeItems",
    "alignContent",
    "alignItems",
    "justifyContent",
    "justifyItems",
    "gap",
    "space",
    "divideWidth",
    "divideStyle",
    "divideColor",
    "divideOpacity",
    "placeSelf",
    "alignSelf",
    "justifySelf",
    "overflow",
    "overscrollBehavior",
    "scrollBehavior",
    "textOverflow",
    "hyphens",
    "whitespace",
    "textWrap",
    "wordBreak",
    "borderRadius",
    "borderWidth",
    "borderStyle",
    "borderColor",
    "borderOpacity",
    "backgroundColor",
    "backgroundOpacity",
    "backgroundImage",
    "gradientColorStops",
    "boxDecorationBreak",
    "backgroundSize",
    "backgroundAttachment",
    "backgroundClip",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundOrigin",
    "fill",
    "stroke",
    "strokeWidth",
    "objectFit",
    "objectPosition",
    "padding",
    "textAlign",
    "textIndent",
    "verticalAlign",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "textTransform",
    "fontStyle",
    "fontVariantNumeric",
    "lineHeight",
    "letterSpacing",
    "textColor",
    "textOpacity",
    "textDecoration",
    "textDecorationColor",
    "textDecorationStyle",
    "textDecorationThickness",
    "textUnderlineOffset",
    "fontSmoothing",
    "placeholderColor",
    "placeholderOpacity",
    "caretColor",
    "accentColor",
    "opacity",
    "backgroundBlendMode",
    "mixBlendMode",
    "boxShadow",
    "boxShadowColor",
    "outlineStyle",
    "outlineWidth",
    "outlineOffset",
    "outlineColor",
    "ringWidth",
    "ringColor",
    "ringOpacity",
    "ringOffsetWidth",
    "ringOffsetColor",
    "blur",
    "brightness",
    "contrast",
    "dropShadow",
    "grayscale",
    "hueRotate",
    "invert",
    "saturate",
    "sepia",
    "filter",
    "backdropBlur",
    "backdropBrightness",
    "backdropContrast",
    "backdropGrayscale",
    "backdropHueRotate",
    "backdropInvert",
    "backdropOpacity",
    "backdropSaturate",
    "backdropSepia",
    "backdropFilter",
    "transitionProperty",
    "transitionDelay",
    "transitionDuration",
    "transitionTimingFunction",
    "willChange",
    "contain",
    "content",
    "forcedColorAdjust"
  ];
})(TK);
var OK = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(n, r) {
    return n === void 0 ? r : Array.isArray(n) ? n : [
      ...new Set(r.filter((a) => n !== !1 && n[a] !== !1).concat(Object.keys(n).filter((a) => n[a] !== !1)))
    ];
  }
})(OK);
var RK = {}, pO = {}, tk = { exports: {} }, Cn = String, DK = function() {
  return { isColorSupported: !1, reset: Cn, bold: Cn, dim: Cn, italic: Cn, underline: Cn, inverse: Cn, hidden: Cn, strikethrough: Cn, black: Cn, red: Cn, green: Cn, yellow: Cn, blue: Cn, magenta: Cn, cyan: Cn, white: Cn, gray: Cn, bgBlack: Cn, bgRed: Cn, bgGreen: Cn, bgYellow: Cn, bgBlue: Cn, bgMagenta: Cn, bgCyan: Cn, bgWhite: Cn, blackBright: Cn, redBright: Cn, greenBright: Cn, yellowBright: Cn, blueBright: Cn, magentaBright: Cn, cyanBright: Cn, whiteBright: Cn, bgBlackBright: Cn, bgRedBright: Cn, bgGreenBright: Cn, bgYellowBright: Cn, bgBlueBright: Cn, bgMagentaBright: Cn, bgCyanBright: Cn, bgWhiteBright: Cn };
};
tk.exports = DK();
tk.exports.createColors = DK;
var NK = tk.exports;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(d, f) {
    for (var g in f)
      Object.defineProperty(d, g, {
        enumerable: !0,
        get: f[g]
      });
  }
  e(t, {
    dim: function() {
      return s;
    },
    default: function() {
      return c;
    }
  });
  const n = /* @__PURE__ */ r(NK);
  function r(d) {
    return d && d.__esModule ? d : {
      default: d
    };
  }
  let i = /* @__PURE__ */ new Set();
  function a(d, f, g) {
    typeof process < "u" && process.env.JEST_WORKER_ID || g && i.has(g) || (g && i.add(g), console.warn(""), f.forEach((m) => console.warn(d, "-", m)));
  }
  function s(d) {
    return n.default.dim(d);
  }
  const c = {
    info(d, f) {
      a(n.default.bold(n.default.cyan("info")), ...Array.isArray(d) ? [
        d
      ] : [
        f,
        d
      ]);
    },
    warn(d, f) {
      a(n.default.bold(n.default.yellow("warn")), ...Array.isArray(d) ? [
        d
      ] : [
        f,
        d
      ]);
    },
    risk(d, f) {
      a(n.default.bold(n.default.magenta("risk")), ...Array.isArray(d) ? [
        d
      ] : [
        f,
        d
      ]);
    }
  };
})(pO);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const e = /* @__PURE__ */ n(pO);
  function n(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  function r({ version: a, from: s, to: c }) {
    e.default.warn(`${s}-color-renamed`, [
      `As of Tailwind CSS ${a}, \`${s}\` has been renamed to \`${c}\`.`,
      "Update your configuration file to silence this warning."
    ]);
  }
  const i = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    get lightBlue() {
      return r({
        version: "v2.2",
        from: "lightBlue",
        to: "sky"
      }), this.sky;
    },
    get warmGray() {
      return r({
        version: "v3.0",
        from: "warmGray",
        to: "stone"
      }), this.stone;
    },
    get trueGray() {
      return r({
        version: "v3.0",
        from: "trueGray",
        to: "neutral"
      }), this.neutral;
    },
    get coolGray() {
      return r({
        version: "v3.0",
        from: "coolGray",
        to: "gray"
      }), this.gray;
    },
    get blueGray() {
      return r({
        version: "v3.0",
        from: "blueGray",
        to: "slate"
      }), this.slate;
    }
  };
})(RK);
var MK = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "defaults", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(n, ...r) {
    for (let s of r) {
      for (let c in s) {
        var i;
        !(n == null || (i = n.hasOwnProperty) === null || i === void 0) && i.call(n, c) || (n[c] = s[c]);
      }
      for (let c of Object.getOwnPropertySymbols(s)) {
        var a;
        !(n == null || (a = n.hasOwnProperty) === null || a === void 0) && a.call(n, c) || (n[c] = s[c]);
      }
    }
    return n;
  }
})(MK);
var IK = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "toPath", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(n) {
    if (Array.isArray(n))
      return n;
    let r = n.split("[").length - 1, i = n.split("]").length - 1;
    if (r !== i)
      throw new Error(`Path is invalid. Has unbalanced brackets: ${n}`);
    return n.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
  }
})(IK);
var kK = {}, mO = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(m, b) {
    for (var w in b)
      Object.defineProperty(m, w, {
        enumerable: !0,
        get: b[w]
      });
  }
  e(t, {
    flagEnabled: function() {
      return c;
    },
    issueFlagNotices: function() {
      return f;
    },
    default: function() {
      return g;
    }
  });
  const n = /* @__PURE__ */ i(NK), r = /* @__PURE__ */ i(pO);
  function i(m) {
    return m && m.__esModule ? m : {
      default: m
    };
  }
  let a = {
    optimizeUniversalDefaults: !1,
    generalizedModifiers: !0,
    disableColorOpacityUtilitiesByDefault: !1,
    relativeContentPathsByDefault: !1
  }, s = {
    future: [
      "hoverOnlyWhenSupported",
      "respectDefaultRingColorOpacity",
      "disableColorOpacityUtilitiesByDefault",
      "relativeContentPathsByDefault"
    ],
    experimental: [
      "optimizeUniversalDefaults",
      "generalizedModifiers"
    ]
  };
  function c(m, b) {
    if (s.future.includes(b)) {
      var w, _, A;
      return m.future === "all" || ((A = (_ = m == null || (w = m.future) === null || w === void 0 ? void 0 : w[b]) !== null && _ !== void 0 ? _ : a[b]) !== null && A !== void 0 ? A : !1);
    }
    if (s.experimental.includes(b)) {
      var T, O, R;
      return m.experimental === "all" || ((R = (O = m == null || (T = m.experimental) === null || T === void 0 ? void 0 : T[b]) !== null && O !== void 0 ? O : a[b]) !== null && R !== void 0 ? R : !1);
    }
    return !1;
  }
  function d(m) {
    if (m.experimental === "all")
      return s.experimental;
    var b;
    return Object.keys((b = m?.experimental) !== null && b !== void 0 ? b : {}).filter((w) => s.experimental.includes(w) && m.experimental[w]);
  }
  function f(m) {
    if (process.env.JEST_WORKER_ID === void 0 && d(m).length > 0) {
      let b = d(m).map((w) => n.default.yellow(w)).join(", ");
      r.default.warn("experimental-flags-enabled", [
        `You have enabled experimental features: ${b}`,
        "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
      ]);
    }
  }
  const g = s;
})(mO);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "normalizeConfig", {
    enumerable: !0,
    get: function() {
      return a;
    }
  });
  const e = mO, n = /* @__PURE__ */ i(pO);
  function r(s) {
    if (typeof WeakMap != "function")
      return null;
    var c = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap();
    return (r = function(f) {
      return f ? d : c;
    })(s);
  }
  function i(s, c) {
    if (!c && s && s.__esModule)
      return s;
    if (s === null || typeof s != "object" && typeof s != "function")
      return {
        default: s
      };
    var d = r(c);
    if (d && d.has(s))
      return d.get(s);
    var f = {}, g = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var m in s)
      if (m !== "default" && Object.prototype.hasOwnProperty.call(s, m)) {
        var b = g ? Object.getOwnPropertyDescriptor(s, m) : null;
        b && (b.get || b.set) ? Object.defineProperty(f, m, b) : f[m] = s[m];
      }
    return f.default = s, d && d.set(s, f), f;
  }
  function a(s) {
    if ((() => {
      if (s.purge || !s.content || !Array.isArray(s.content) && !(typeof s.content == "object" && s.content !== null))
        return !1;
      if (Array.isArray(s.content))
        return s.content.every((f) => typeof f == "string" ? !0 : !(typeof f?.raw != "string" || f?.extension && typeof f?.extension != "string"));
      if (typeof s.content == "object" && s.content !== null) {
        if (Object.keys(s.content).some((f) => ![
          "files",
          "relative",
          "extract",
          "transform"
        ].includes(f)))
          return !1;
        if (Array.isArray(s.content.files)) {
          if (!s.content.files.every((f) => typeof f == "string" ? !0 : !(typeof f?.raw != "string" || f?.extension && typeof f?.extension != "string")))
            return !1;
          if (typeof s.content.extract == "object") {
            for (let f of Object.values(s.content.extract))
              if (typeof f != "function")
                return !1;
          } else if (!(s.content.extract === void 0 || typeof s.content.extract == "function"))
            return !1;
          if (typeof s.content.transform == "object") {
            for (let f of Object.values(s.content.transform))
              if (typeof f != "function")
                return !1;
          } else if (!(s.content.transform === void 0 || typeof s.content.transform == "function"))
            return !1;
          if (typeof s.content.relative != "boolean" && typeof s.content.relative < "u")
            return !1;
        }
        return !0;
      }
      return !1;
    })() || n.default.warn("purge-deprecation", [
      "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
      "Update your configuration file to eliminate this warning.",
      "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
    ]), s.safelist = (() => {
      var f;
      let { content: g, purge: m, safelist: b } = s;
      return Array.isArray(b) ? b : Array.isArray(g?.safelist) ? g.safelist : Array.isArray(m?.safelist) ? m.safelist : Array.isArray(m == null || (f = m.options) === null || f === void 0 ? void 0 : f.safelist) ? m.options.safelist : [];
    })(), s.blocklist = (() => {
      let { blocklist: f } = s;
      if (Array.isArray(f)) {
        if (f.every((g) => typeof g == "string"))
          return f;
        n.default.warn("blocklist-invalid", [
          "The `blocklist` option must be an array of strings.",
          "https://tailwindcss.com/docs/content-configuration#discarding-classes"
        ]);
      }
      return [];
    })(), typeof s.prefix == "function")
      n.default.warn("prefix-function", [
        "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
        "Update `prefix` in your configuration to be a string to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
      ]), s.prefix = "";
    else {
      var d;
      s.prefix = (d = s.prefix) !== null && d !== void 0 ? d : "";
    }
    s.content = {
      relative: (() => {
        let { content: f } = s;
        return f?.relative ? f.relative : (0, e.flagEnabled)(s, "relativeContentPathsByDefault");
      })(),
      files: (() => {
        let { content: f, purge: g } = s;
        return Array.isArray(g) ? g : Array.isArray(g?.content) ? g.content : Array.isArray(f) ? f : Array.isArray(f?.content) ? f.content : Array.isArray(f?.files) ? f.files : [];
      })(),
      extract: (() => {
        let f = (() => {
          var b, w, _, A, T, O, R, N, M, P;
          return !((b = s.purge) === null || b === void 0) && b.extract ? s.purge.extract : !((w = s.content) === null || w === void 0) && w.extract ? s.content.extract : !((_ = s.purge) === null || _ === void 0 || (A = _.extract) === null || A === void 0) && A.DEFAULT ? s.purge.extract.DEFAULT : !((T = s.content) === null || T === void 0 || (O = T.extract) === null || O === void 0) && O.DEFAULT ? s.content.extract.DEFAULT : !((R = s.purge) === null || R === void 0 || (N = R.options) === null || N === void 0) && N.extractors ? s.purge.options.extractors : !((M = s.content) === null || M === void 0 || (P = M.options) === null || P === void 0) && P.extractors ? s.content.options.extractors : {};
        })(), g = {}, m = (() => {
          var b, w, _, A;
          if (!((b = s.purge) === null || b === void 0 || (w = b.options) === null || w === void 0) && w.defaultExtractor)
            return s.purge.options.defaultExtractor;
          if (!((_ = s.content) === null || _ === void 0 || (A = _.options) === null || A === void 0) && A.defaultExtractor)
            return s.content.options.defaultExtractor;
        })();
        if (m !== void 0 && (g.DEFAULT = m), typeof f == "function")
          g.DEFAULT = f;
        else if (Array.isArray(f))
          for (let { extensions: b, extractor: w } of f ?? [])
            for (let _ of b)
              g[_] = w;
        else
          typeof f == "object" && f !== null && Object.assign(g, f);
        return g;
      })(),
      transform: (() => {
        let f = (() => {
          var m, b, w, _, A, T;
          return !((m = s.purge) === null || m === void 0) && m.transform ? s.purge.transform : !((b = s.content) === null || b === void 0) && b.transform ? s.content.transform : !((w = s.purge) === null || w === void 0 || (_ = w.transform) === null || _ === void 0) && _.DEFAULT ? s.purge.transform.DEFAULT : !((A = s.content) === null || A === void 0 || (T = A.transform) === null || T === void 0) && T.DEFAULT ? s.content.transform.DEFAULT : {};
        })(), g = {};
        return typeof f == "function" ? g.DEFAULT = f : typeof f == "object" && f !== null && Object.assign(g, f), g;
      })()
    };
    for (let f of s.content.files)
      if (typeof f == "string" && /{([^,]*?)}/g.test(f)) {
        n.default.warn("invalid-glob-braces", [
          `The glob pattern ${(0, n.dim)(f)} in your Tailwind CSS configuration is invalid.`,
          `Update it to ${(0, n.dim)(f.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
        ]);
        break;
      }
    return s;
  }
})(kK);
var jK = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(n) {
    if (Object.prototype.toString.call(n) !== "[object Object]")
      return !1;
    const r = Object.getPrototypeOf(n);
    return r === null || Object.getPrototypeOf(r) === null;
  }
})(jK);
var PK = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(n) {
    return Array.isArray(n) ? n.map((r) => e(r)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([r, i]) => [
      r,
      e(i)
    ])) : n;
  }
})(PK);
var LK = {}, BK = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(n) {
    return n.replace(/\\,/g, "\\2c ");
  }
})(BK);
var nk = {}, rk = {}, zK = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  const e = {
    aliceblue: [
      240,
      248,
      255
    ],
    antiquewhite: [
      250,
      235,
      215
    ],
    aqua: [
      0,
      255,
      255
    ],
    aquamarine: [
      127,
      255,
      212
    ],
    azure: [
      240,
      255,
      255
    ],
    beige: [
      245,
      245,
      220
    ],
    bisque: [
      255,
      228,
      196
    ],
    black: [
      0,
      0,
      0
    ],
    blanchedalmond: [
      255,
      235,
      205
    ],
    blue: [
      0,
      0,
      255
    ],
    blueviolet: [
      138,
      43,
      226
    ],
    brown: [
      165,
      42,
      42
    ],
    burlywood: [
      222,
      184,
      135
    ],
    cadetblue: [
      95,
      158,
      160
    ],
    chartreuse: [
      127,
      255,
      0
    ],
    chocolate: [
      210,
      105,
      30
    ],
    coral: [
      255,
      127,
      80
    ],
    cornflowerblue: [
      100,
      149,
      237
    ],
    cornsilk: [
      255,
      248,
      220
    ],
    crimson: [
      220,
      20,
      60
    ],
    cyan: [
      0,
      255,
      255
    ],
    darkblue: [
      0,
      0,
      139
    ],
    darkcyan: [
      0,
      139,
      139
    ],
    darkgoldenrod: [
      184,
      134,
      11
    ],
    darkgray: [
      169,
      169,
      169
    ],
    darkgreen: [
      0,
      100,
      0
    ],
    darkgrey: [
      169,
      169,
      169
    ],
    darkkhaki: [
      189,
      183,
      107
    ],
    darkmagenta: [
      139,
      0,
      139
    ],
    darkolivegreen: [
      85,
      107,
      47
    ],
    darkorange: [
      255,
      140,
      0
    ],
    darkorchid: [
      153,
      50,
      204
    ],
    darkred: [
      139,
      0,
      0
    ],
    darksalmon: [
      233,
      150,
      122
    ],
    darkseagreen: [
      143,
      188,
      143
    ],
    darkslateblue: [
      72,
      61,
      139
    ],
    darkslategray: [
      47,
      79,
      79
    ],
    darkslategrey: [
      47,
      79,
      79
    ],
    darkturquoise: [
      0,
      206,
      209
    ],
    darkviolet: [
      148,
      0,
      211
    ],
    deeppink: [
      255,
      20,
      147
    ],
    deepskyblue: [
      0,
      191,
      255
    ],
    dimgray: [
      105,
      105,
      105
    ],
    dimgrey: [
      105,
      105,
      105
    ],
    dodgerblue: [
      30,
      144,
      255
    ],
    firebrick: [
      178,
      34,
      34
    ],
    floralwhite: [
      255,
      250,
      240
    ],
    forestgreen: [
      34,
      139,
      34
    ],
    fuchsia: [
      255,
      0,
      255
    ],
    gainsboro: [
      220,
      220,
      220
    ],
    ghostwhite: [
      248,
      248,
      255
    ],
    gold: [
      255,
      215,
      0
    ],
    goldenrod: [
      218,
      165,
      32
    ],
    gray: [
      128,
      128,
      128
    ],
    green: [
      0,
      128,
      0
    ],
    greenyellow: [
      173,
      255,
      47
    ],
    grey: [
      128,
      128,
      128
    ],
    honeydew: [
      240,
      255,
      240
    ],
    hotpink: [
      255,
      105,
      180
    ],
    indianred: [
      205,
      92,
      92
    ],
    indigo: [
      75,
      0,
      130
    ],
    ivory: [
      255,
      255,
      240
    ],
    khaki: [
      240,
      230,
      140
    ],
    lavender: [
      230,
      230,
      250
    ],
    lavenderblush: [
      255,
      240,
      245
    ],
    lawngreen: [
      124,
      252,
      0
    ],
    lemonchiffon: [
      255,
      250,
      205
    ],
    lightblue: [
      173,
      216,
      230
    ],
    lightcoral: [
      240,
      128,
      128
    ],
    lightcyan: [
      224,
      255,
      255
    ],
    lightgoldenrodyellow: [
      250,
      250,
      210
    ],
    lightgray: [
      211,
      211,
      211
    ],
    lightgreen: [
      144,
      238,
      144
    ],
    lightgrey: [
      211,
      211,
      211
    ],
    lightpink: [
      255,
      182,
      193
    ],
    lightsalmon: [
      255,
      160,
      122
    ],
    lightseagreen: [
      32,
      178,
      170
    ],
    lightskyblue: [
      135,
      206,
      250
    ],
    lightslategray: [
      119,
      136,
      153
    ],
    lightslategrey: [
      119,
      136,
      153
    ],
    lightsteelblue: [
      176,
      196,
      222
    ],
    lightyellow: [
      255,
      255,
      224
    ],
    lime: [
      0,
      255,
      0
    ],
    limegreen: [
      50,
      205,
      50
    ],
    linen: [
      250,
      240,
      230
    ],
    magenta: [
      255,
      0,
      255
    ],
    maroon: [
      128,
      0,
      0
    ],
    mediumaquamarine: [
      102,
      205,
      170
    ],
    mediumblue: [
      0,
      0,
      205
    ],
    mediumorchid: [
      186,
      85,
      211
    ],
    mediumpurple: [
      147,
      112,
      219
    ],
    mediumseagreen: [
      60,
      179,
      113
    ],
    mediumslateblue: [
      123,
      104,
      238
    ],
    mediumspringgreen: [
      0,
      250,
      154
    ],
    mediumturquoise: [
      72,
      209,
      204
    ],
    mediumvioletred: [
      199,
      21,
      133
    ],
    midnightblue: [
      25,
      25,
      112
    ],
    mintcream: [
      245,
      255,
      250
    ],
    mistyrose: [
      255,
      228,
      225
    ],
    moccasin: [
      255,
      228,
      181
    ],
    navajowhite: [
      255,
      222,
      173
    ],
    navy: [
      0,
      0,
      128
    ],
    oldlace: [
      253,
      245,
      230
    ],
    olive: [
      128,
      128,
      0
    ],
    olivedrab: [
      107,
      142,
      35
    ],
    orange: [
      255,
      165,
      0
    ],
    orangered: [
      255,
      69,
      0
    ],
    orchid: [
      218,
      112,
      214
    ],
    palegoldenrod: [
      238,
      232,
      170
    ],
    palegreen: [
      152,
      251,
      152
    ],
    paleturquoise: [
      175,
      238,
      238
    ],
    palevioletred: [
      219,
      112,
      147
    ],
    papayawhip: [
      255,
      239,
      213
    ],
    peachpuff: [
      255,
      218,
      185
    ],
    peru: [
      205,
      133,
      63
    ],
    pink: [
      255,
      192,
      203
    ],
    plum: [
      221,
      160,
      221
    ],
    powderblue: [
      176,
      224,
      230
    ],
    purple: [
      128,
      0,
      128
    ],
    rebeccapurple: [
      102,
      51,
      153
    ],
    red: [
      255,
      0,
      0
    ],
    rosybrown: [
      188,
      143,
      143
    ],
    royalblue: [
      65,
      105,
      225
    ],
    saddlebrown: [
      139,
      69,
      19
    ],
    salmon: [
      250,
      128,
      114
    ],
    sandybrown: [
      244,
      164,
      96
    ],
    seagreen: [
      46,
      139,
      87
    ],
    seashell: [
      255,
      245,
      238
    ],
    sienna: [
      160,
      82,
      45
    ],
    silver: [
      192,
      192,
      192
    ],
    skyblue: [
      135,
      206,
      235
    ],
    slateblue: [
      106,
      90,
      205
    ],
    slategray: [
      112,
      128,
      144
    ],
    slategrey: [
      112,
      128,
      144
    ],
    snow: [
      255,
      250,
      250
    ],
    springgreen: [
      0,
      255,
      127
    ],
    steelblue: [
      70,
      130,
      180
    ],
    tan: [
      210,
      180,
      140
    ],
    teal: [
      0,
      128,
      128
    ],
    thistle: [
      216,
      191,
      216
    ],
    tomato: [
      255,
      99,
      71
    ],
    turquoise: [
      64,
      224,
      208
    ],
    violet: [
      238,
      130,
      238
    ],
    wheat: [
      245,
      222,
      179
    ],
    white: [
      255,
      255,
      255
    ],
    whitesmoke: [
      245,
      245,
      245
    ],
    yellow: [
      255,
      255,
      0
    ],
    yellowgreen: [
      154,
      205,
      50
    ]
  };
})(zK);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(_, A) {
    for (var T in A)
      Object.defineProperty(_, T, {
        enumerable: !0,
        get: A[T]
      });
  }
  e(t, {
    parseColor: function() {
      return b;
    },
    formatColor: function() {
      return w;
    }
  });
  const n = /* @__PURE__ */ r(zK);
  function r(_) {
    return _ && _.__esModule ? _ : {
      default: _
    };
  }
  let i = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, a = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, s = /(?:\d+|\d*\.\d+)%?/, c = /(?:\s*,\s*|\s+)/, d = /\s*[,/]\s*/, f = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, g = new RegExp(`^(rgba?)\\(\\s*(${s.source}|${f.source})(?:${c.source}(${s.source}|${f.source}))?(?:${c.source}(${s.source}|${f.source}))?(?:${d.source}(${s.source}|${f.source}))?\\s*\\)$`), m = new RegExp(`^(hsla?)\\(\\s*((?:${s.source})(?:deg|rad|grad|turn)?|${f.source})(?:${c.source}(${s.source}|${f.source}))?(?:${c.source}(${s.source}|${f.source}))?(?:${d.source}(${s.source}|${f.source}))?\\s*\\)$`);
  function b(_, { loose: A = !1 } = {}) {
    var T, O;
    if (typeof _ != "string")
      return null;
    if (_ = _.trim(), _ === "transparent")
      return {
        mode: "rgb",
        color: [
          "0",
          "0",
          "0"
        ],
        alpha: "0"
      };
    if (_ in n.default)
      return {
        mode: "rgb",
        color: n.default[_].map((z) => z.toString())
      };
    let R = _.replace(a, (z, F, $, G, H) => [
      "#",
      F,
      F,
      $,
      $,
      G,
      G,
      H ? H + H : ""
    ].join("")).match(i);
    if (R !== null)
      return {
        mode: "rgb",
        color: [
          parseInt(R[1], 16),
          parseInt(R[2], 16),
          parseInt(R[3], 16)
        ].map((z) => z.toString()),
        alpha: R[4] ? (parseInt(R[4], 16) / 255).toString() : void 0
      };
    var N;
    let M = (N = _.match(g)) !== null && N !== void 0 ? N : _.match(m);
    if (M === null)
      return null;
    let P = [
      M[2],
      M[3],
      M[4]
    ].filter(Boolean).map((z) => z.toString());
    return P.length === 2 && P[0].startsWith("var(") ? {
      mode: M[1],
      color: [
        P[0]
      ],
      alpha: P[1]
    } : !A && P.length !== 3 || P.length < 3 && !P.some((z) => /^var\(.*?\)$/.test(z)) ? null : {
      mode: M[1],
      color: P,
      alpha: (T = M[5]) === null || T === void 0 || (O = T.toString) === null || O === void 0 ? void 0 : O.call(T)
    };
  }
  function w({ mode: _, color: A, alpha: T }) {
    let O = T !== void 0;
    return _ === "rgba" || _ === "hsla" ? `${_}(${A.join(", ")}${O ? `, ${T}` : ""})` : `${_}(${A.join(" ")}${O ? ` / ${T}` : ""})`;
  }
})(rk);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(a, s) {
    for (var c in s)
      Object.defineProperty(a, c, {
        enumerable: !0,
        get: s[c]
      });
  }
  e(t, {
    withAlphaValue: function() {
      return r;
    },
    default: function() {
      return i;
    }
  });
  const n = rk;
  function r(a, s, c) {
    if (typeof a == "function")
      return a({
        opacityValue: s
      });
    let d = (0, n.parseColor)(a, {
      loose: !0
    });
    return d === null ? c : (0, n.formatColor)({
      ...d,
      alpha: s
    });
  }
  function i({ color: a, property: s, variable: c }) {
    let d = [].concat(s);
    if (typeof a == "function")
      return {
        [c]: "1",
        ...Object.fromEntries(d.map((g) => [
          g,
          a({
            opacityVariable: c,
            opacityValue: `var(${c}, 1)`
          })
        ]))
      };
    const f = (0, n.parseColor)(a);
    return f === null ? Object.fromEntries(d.map((g) => [
      g,
      a
    ])) : f.alpha !== void 0 ? Object.fromEntries(d.map((g) => [
      g,
      a
    ])) : {
      [c]: "1",
      ...Object.fromEntries(d.map((g) => [
        g,
        (0, n.formatColor)({
          ...f,
          alpha: `var(${c}, 1)`
        })
      ]))
    };
  }
})(nk);
var ik = {}, FK = {}, gO = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "splitAtTopLevelOnly", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(n, r) {
    let i = [], a = [], s = 0, c = !1;
    for (let d = 0; d < n.length; d++) {
      let f = n[d];
      i.length === 0 && f === r[0] && !c && (r.length === 1 || n.slice(d, d + r.length) === r) && (a.push(n.slice(s, d)), s = d + r.length), c = c ? !1 : f === "\\", f === "(" || f === "[" || f === "{" ? i.push(f) : (f === ")" && i[i.length - 1] === "(" || f === "]" && i[i.length - 1] === "[" || f === "}" && i[i.length - 1] === "{") && i.pop();
    }
    return a.push(n.slice(s)), a;
  }
})(gO);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(d, f) {
    for (var g in f)
      Object.defineProperty(d, g, {
        enumerable: !0,
        get: f[g]
      });
  }
  e(t, {
    parseBoxShadowValue: function() {
      return s;
    },
    formatBoxShadowValue: function() {
      return c;
    }
  });
  const n = gO;
  let r = /* @__PURE__ */ new Set([
    "inset",
    "inherit",
    "initial",
    "revert",
    "unset"
  ]), i = /\ +(?![^(]*\))/g, a = /^-?(\d+|\.\d+)(.*?)$/g;
  function s(d) {
    return (0, n.splitAtTopLevelOnly)(d, ",").map((g) => {
      let m = g.trim(), b = {
        raw: m
      }, w = m.split(i), _ = /* @__PURE__ */ new Set();
      for (let A of w)
        a.lastIndex = 0, !_.has("KEYWORD") && r.has(A) ? (b.keyword = A, _.add("KEYWORD")) : a.test(A) ? _.has("X") ? _.has("Y") ? _.has("BLUR") ? _.has("SPREAD") || (b.spread = A, _.add("SPREAD")) : (b.blur = A, _.add("BLUR")) : (b.y = A, _.add("Y")) : (b.x = A, _.add("X")) : b.color ? (b.unknown || (b.unknown = []), b.unknown.push(A)) : b.color = A;
      return b.valid = b.x !== void 0 && b.y !== void 0, b;
    });
  }
  function c(d) {
    return d.map((f) => f.valid ? [
      f.keyword,
      f.x,
      f.y,
      f.blur,
      f.spread,
      f.color
    ].filter(Boolean).join(" ") : f.raw).join(", ");
  }
})(FK);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(q, W) {
    for (var ie in W)
      Object.defineProperty(q, ie, {
        enumerable: !0,
        get: W[ie]
      });
  }
  e(t, {
    normalize: function() {
      return d;
    },
    normalizeAttributeSelectors: function() {
      return f;
    },
    url: function() {
      return m;
    },
    number: function() {
      return b;
    },
    percentage: function() {
      return w;
    },
    length: function() {
      return T;
    },
    lineWidth: function() {
      return R;
    },
    shadow: function() {
      return N;
    },
    color: function() {
      return M;
    },
    image: function() {
      return P;
    },
    gradient: function() {
      return F;
    },
    position: function() {
      return G;
    },
    familyName: function() {
      return H;
    },
    genericName: function() {
      return V;
    },
    absoluteSize: function() {
      return ee;
    },
    relativeSize: function() {
      return U;
    }
  });
  const n = rk, r = FK, i = gO;
  let a = [
    "min",
    "max",
    "clamp",
    "calc"
  ];
  function s(q) {
    return a.some((W) => new RegExp(`^${W}\\(.*\\)`).test(q));
  }
  const c = /* @__PURE__ */ new Set([
    // Concrete properties
    "scroll-timeline-name",
    "timeline-scope",
    "view-timeline-name",
    "font-palette",
    "anchor-name",
    "anchor-scope",
    "position-anchor",
    "position-try-options",
    // Shorthand properties
    "scroll-timeline",
    "animation-timeline",
    "view-timeline",
    "position-try"
  ]);
  function d(q, W = null, ie = !0) {
    let J = W && c.has(W.property);
    return q.startsWith("--") && !J ? `var(${q})` : q.includes("url(") ? q.split(/(url\(.*?\))/g).filter(Boolean).map((B) => /^url\(.*?\)$/.test(B) ? B : d(B, W, !1)).join("") : (q = q.replace(/([^\\])_+/g, (B, te) => te + " ".repeat(B.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), ie && (q = q.trim()), q = g(q), q);
  }
  function f(q) {
    return q.includes("=") && (q = q.replace(/(=.*)/g, (W, ie) => {
      if (ie[1] === "'" || ie[1] === '"')
        return ie;
      if (ie.length > 2) {
        let J = ie[ie.length - 1];
        if (ie[ie.length - 2] === " " && (J === "i" || J === "I" || J === "s" || J === "S"))
          return `="${ie.slice(1, -2)}" ${ie[ie.length - 1]}`;
      }
      return `="${ie.slice(1)}"`;
    })), q;
  }
  function g(q) {
    let W = [
      "theme"
    ], ie = [
      "min-content",
      "max-content",
      "fit-content",
      // Env
      "safe-area-inset-top",
      "safe-area-inset-right",
      "safe-area-inset-bottom",
      "safe-area-inset-left",
      "titlebar-area-x",
      "titlebar-area-y",
      "titlebar-area-width",
      "titlebar-area-height",
      "keyboard-inset-top",
      "keyboard-inset-right",
      "keyboard-inset-bottom",
      "keyboard-inset-left",
      "keyboard-inset-width",
      "keyboard-inset-height",
      "radial-gradient",
      "linear-gradient",
      "conic-gradient",
      "repeating-radial-gradient",
      "repeating-linear-gradient",
      "repeating-conic-gradient",
      "anchor-size"
    ];
    return q.replace(/(calc|min|max|clamp)\(.+\)/g, (J) => {
      let B = "";
      function te() {
        let ae = B.trimEnd();
        return ae[ae.length - 1];
      }
      for (let ae = 0; ae < J.length; ae++) {
        let le = function(ue) {
          return ue.split("").every((Se, Ne) => J[ae + Ne] === Se);
        }, de = function(ue) {
          let Se = 1 / 0;
          for (let Me of ue) {
            let Ce = J.indexOf(Me, ae);
            Ce !== -1 && Ce < Se && (Se = Ce);
          }
          let Ne = J.slice(ae, Se);
          return ae += Ne.length - 1, Ne;
        }, _e = J[ae];
        if (le("var"))
          B += de([
            ")",
            ","
          ]);
        else if (ie.some((ue) => le(ue))) {
          let ue = ie.find((Se) => le(Se));
          B += ue, ae += ue.length - 1;
        } else
          W.some((ue) => le(ue)) ? B += de([
            ")"
          ]) : le("[") ? B += de([
            "]"
          ]) : [
            "+",
            "-",
            "*",
            "/"
          ].includes(_e) && ![
            "(",
            "+",
            "-",
            "*",
            "/",
            ","
          ].includes(te()) ? B += ` ${_e} ` : B += _e;
      }
      return B.replace(/\s+/g, " ");
    });
  }
  function m(q) {
    return q.startsWith("url(");
  }
  function b(q) {
    return !isNaN(Number(q)) || s(q);
  }
  function w(q) {
    return q.endsWith("%") && b(q.slice(0, -1)) || s(q);
  }
  let A = `(?:${[
    "cm",
    "mm",
    "Q",
    "in",
    "pc",
    "pt",
    "px",
    "em",
    "ex",
    "ch",
    "rem",
    "lh",
    "rlh",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "vb",
    "vi",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax"
  ].join("|")})`;
  function T(q) {
    return q === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${A}$`).test(q) || s(q);
  }
  let O = /* @__PURE__ */ new Set([
    "thin",
    "medium",
    "thick"
  ]);
  function R(q) {
    return O.has(q);
  }
  function N(q) {
    let W = (0, r.parseBoxShadowValue)(d(q));
    for (let ie of W)
      if (!ie.valid)
        return !1;
    return !0;
  }
  function M(q) {
    let W = 0;
    return (0, i.splitAtTopLevelOnly)(q, "_").every((J) => (J = d(J), J.startsWith("var(") ? !0 : (0, n.parseColor)(J, {
      loose: !0
    }) !== null ? (W++, !0) : !1)) ? W > 0 : !1;
  }
  function P(q) {
    let W = 0;
    return (0, i.splitAtTopLevelOnly)(q, ",").every((J) => (J = d(J), J.startsWith("var(") ? !0 : m(J) || F(J) || [
      "element(",
      "image(",
      "cross-fade(",
      "image-set("
    ].some((B) => J.startsWith(B)) ? (W++, !0) : !1)) ? W > 0 : !1;
  }
  let z = /* @__PURE__ */ new Set([
    "conic-gradient",
    "linear-gradient",
    "radial-gradient",
    "repeating-conic-gradient",
    "repeating-linear-gradient",
    "repeating-radial-gradient"
  ]);
  function F(q) {
    q = d(q);
    for (let W of z)
      if (q.startsWith(`${W}(`))
        return !0;
    return !1;
  }
  let $ = /* @__PURE__ */ new Set([
    "center",
    "top",
    "right",
    "bottom",
    "left"
  ]);
  function G(q) {
    let W = 0;
    return (0, i.splitAtTopLevelOnly)(q, "_").every((J) => (J = d(J), J.startsWith("var(") ? !0 : $.has(J) || T(J) || w(J) ? (W++, !0) : !1)) ? W > 0 : !1;
  }
  function H(q) {
    let W = 0;
    return (0, i.splitAtTopLevelOnly)(q, ",").every((J) => (J = d(J), J.startsWith("var(") ? !0 : J.includes(" ") && !/(['"])([^"']+)\1/g.test(J) || /^\d/g.test(J) ? !1 : (W++, !0))) ? W > 0 : !1;
  }
  let Z = /* @__PURE__ */ new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "math",
    "emoji",
    "fangsong"
  ]);
  function V(q) {
    return Z.has(q);
  }
  let Y = /* @__PURE__ */ new Set([
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "xx-large",
    "xxx-large"
  ]);
  function ee(q) {
    return Y.has(q);
  }
  let K = /* @__PURE__ */ new Set([
    "larger",
    "smaller"
  ]);
  function U(q) {
    return K.has(q);
  }
})(ik);
var VK = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "backgroundSize", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const e = ik, n = gO;
  function r(i) {
    let a = [
      "cover",
      "contain"
    ];
    return (0, n.splitAtTopLevelOnly)(i, ",").every((s) => {
      let c = (0, n.splitAtTopLevelOnly)(s, "_").filter(Boolean);
      return c.length === 1 && a.includes(c[0]) ? !0 : c.length !== 1 && c.length !== 2 ? !1 : c.every((d) => (0, e.length)(d) || (0, e.percentage)(d) || d === "auto");
    });
  }
})(VK);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function e(G, H) {
    for (var Z in H)
      Object.defineProperty(G, Z, {
        enumerable: !0,
        get: H[Z]
      });
  }
  e(t, {
    updateAllClasses: function() {
      return f;
    },
    asValue: function() {
      return b;
    },
    parseColorFormat: function() {
      return A;
    },
    asColor: function() {
      return O;
    },
    asLookupValue: function() {
      return R;
    },
    typeMap: function() {
      return M;
    },
    coerceValue: function() {
      return F;
    },
    getMatchingTypes: function() {
      return $;
    }
  });
  const n = /* @__PURE__ */ d(BK), r = nk, i = ik, a = /* @__PURE__ */ d(ek), s = VK, c = mO;
  function d(G) {
    return G && G.__esModule ? G : {
      default: G
    };
  }
  function f(G, H) {
    G.walkClasses((Z) => {
      Z.value = H(Z.value), Z.raws && Z.raws.value && (Z.raws.value = (0, n.default)(Z.raws.value));
    });
  }
  function g(G, H) {
    if (!w(G))
      return;
    let Z = G.slice(1, -1);
    if (H(Z))
      return (0, i.normalize)(Z);
  }
  function m(G, H = {}, Z) {
    let V = H[G];
    if (V !== void 0)
      return (0, a.default)(V);
    if (w(G)) {
      let Y = g(G, Z);
      return Y === void 0 ? void 0 : (0, a.default)(Y);
    }
  }
  function b(G, H = {}, { validate: Z = () => !0 } = {}) {
    var V;
    let Y = (V = H.values) === null || V === void 0 ? void 0 : V[G];
    return Y !== void 0 ? Y : H.supportsNegativeValues && G.startsWith("-") ? m(G.slice(1), H.values, Z) : g(G, Z);
  }
  function w(G) {
    return G.startsWith("[") && G.endsWith("]");
  }
  function _(G) {
    let H = G.lastIndexOf("/"), Z = G.lastIndexOf("[", H), V = G.indexOf("]", H);
    return G[H - 1] === "]" || G[H + 1] === "[" || Z !== -1 && V !== -1 && Z < H && H < V && (H = G.lastIndexOf("/", Z)), H === -1 || H === G.length - 1 ? [
      G,
      void 0
    ] : w(G) && !G.includes("]/[") ? [
      G,
      void 0
    ] : [
      G.slice(0, H),
      G.slice(H + 1)
    ];
  }
  function A(G) {
    if (typeof G == "string" && G.includes("<alpha-value>")) {
      let H = G;
      return ({ opacityValue: Z = 1 }) => H.replace(/<alpha-value>/g, Z);
    }
    return G;
  }
  function T(G) {
    return (0, i.normalize)(G.slice(1, -1));
  }
  function O(G, H = {}, { tailwindConfig: Z = {} } = {}) {
    var V;
    if (((V = H.values) === null || V === void 0 ? void 0 : V[G]) !== void 0) {
      var Y;
      return A((Y = H.values) === null || Y === void 0 ? void 0 : Y[G]);
    }
    let [ee, K] = _(G);
    if (K !== void 0) {
      var U, q, W, ie;
      let J = (ie = (U = H.values) === null || U === void 0 ? void 0 : U[ee]) !== null && ie !== void 0 ? ie : w(ee) ? ee.slice(1, -1) : void 0;
      return J === void 0 ? void 0 : (J = A(J), w(K) ? (0, r.withAlphaValue)(J, T(K)) : ((q = Z.theme) === null || q === void 0 || (W = q.opacity) === null || W === void 0 ? void 0 : W[K]) === void 0 ? void 0 : (0, r.withAlphaValue)(J, Z.theme.opacity[K]));
    }
    return b(G, H, {
      validate: i.color
    });
  }
  function R(G, H = {}) {
    var Z;
    return (Z = H.values) === null || Z === void 0 ? void 0 : Z[G];
  }
  function N(G) {
    return (H, Z) => b(H, Z, {
      validate: G
    });
  }
  let M = {
    any: b,
    color: O,
    url: N(i.url),
    image: N(i.image),
    length: N(i.length),
    percentage: N(i.percentage),
    position: N(i.position),
    lookup: R,
    "generic-name": N(i.genericName),
    "family-name": N(i.familyName),
    number: N(i.number),
    "line-width": N(i.lineWidth),
    "absolute-size": N(i.absoluteSize),
    "relative-size": N(i.relativeSize),
    shadow: N(i.shadow),
    size: N(s.backgroundSize)
  }, P = Object.keys(M);
  function z(G, H) {
    let Z = G.indexOf(H);
    return Z === -1 ? [
      void 0,
      G
    ] : [
      G.slice(0, Z),
      G.slice(Z + 1)
    ];
  }
  function F(G, H, Z, V) {
    if (Z.values && H in Z.values)
      for (let { type: ee } of G ?? []) {
        let K = M[ee](H, Z, {
          tailwindConfig: V
        });
        if (K !== void 0)
          return [
            K,
            ee,
            null
          ];
      }
    if (w(H)) {
      let ee = H.slice(1, -1), [K, U] = z(ee, ":");
      if (!/^[\w-_]+$/g.test(K))
        U = ee;
      else if (K !== void 0 && !P.includes(K))
        return [];
      if (U.length > 0 && P.includes(K))
        return [
          b(`[${U}]`, Z),
          K,
          null
        ];
    }
    let Y = $(G, H, Z, V);
    for (let ee of Y)
      return ee;
    return [];
  }
  function* $(G, H, Z, V) {
    let Y = (0, c.flagEnabled)(V, "generalizedModifiers"), [ee, K] = _(H);
    if (Y && Z.modifiers != null && (Z.modifiers === "any" || typeof Z.modifiers == "object" && (K && w(K) || K in Z.modifiers)) || (ee = H, K = void 0), K !== void 0 && ee === "" && (ee = "DEFAULT"), K !== void 0 && typeof Z.modifiers == "object") {
      var q, W;
      let ie = (W = (q = Z.modifiers) === null || q === void 0 ? void 0 : q[K]) !== null && W !== void 0 ? W : null;
      ie !== null ? K = ie : w(K) && (K = T(K));
    }
    for (let { type: ie } of G ?? []) {
      let J = M[ie](ee, Z, {
        tailwindConfig: V
      });
      J !== void 0 && (yield [
        J,
        ie,
        K ?? null
      ]);
    }
  }
})(LK);
var UK = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(n) {
    return typeof n == "function" ? n({}) : n;
  }
})(UK);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return Z;
    }
  });
  const e = /* @__PURE__ */ w(ek), n = /* @__PURE__ */ w(TK), r = /* @__PURE__ */ w(OK), i = /* @__PURE__ */ w(RK), a = MK, s = IK, c = kK, d = /* @__PURE__ */ w(jK), f = PK, g = LK, m = nk, b = /* @__PURE__ */ w(UK);
  function w(V) {
    return V && V.__esModule ? V : {
      default: V
    };
  }
  function _(V) {
    return typeof V == "function";
  }
  function A(V, ...Y) {
    let ee = Y.pop();
    for (let K of Y)
      for (let U in K) {
        let q = ee(V[U], K[U]);
        q === void 0 ? (0, d.default)(V[U]) && (0, d.default)(K[U]) ? V[U] = A({}, V[U], K[U], ee) : V[U] = K[U] : V[U] = q;
      }
    return V;
  }
  const T = {
    colors: i.default,
    negative(V) {
      return Object.keys(V).filter((Y) => V[Y] !== "0").reduce((Y, ee) => {
        let K = (0, e.default)(V[ee]);
        return K !== void 0 && (Y[`-${ee}`] = K), Y;
      }, {});
    },
    breakpoints(V) {
      return Object.keys(V).filter((Y) => typeof V[Y] == "string").reduce((Y, ee) => ({
        ...Y,
        [`screen-${ee}`]: V[ee]
      }), {});
    }
  };
  function O(V, ...Y) {
    return _(V) ? V(...Y) : V;
  }
  function R(V) {
    return V.reduce((Y, { extend: ee }) => A(Y, ee, (K, U) => K === void 0 ? [
      U
    ] : Array.isArray(K) ? [
      U,
      ...K
    ] : [
      U,
      K
    ]), {});
  }
  function N(V) {
    return {
      ...V.reduce((Y, ee) => (0, a.defaults)(Y, ee), {}),
      // In order to resolve n config objects, we combine all of their `extend` properties
      // into arrays instead of objects so they aren't overridden.
      extend: R(V)
    };
  }
  function M(V, Y) {
    if (Array.isArray(V) && (0, d.default)(V[0]))
      return V.concat(Y);
    if (Array.isArray(Y) && (0, d.default)(Y[0]) && (0, d.default)(V))
      return [
        V,
        ...Y
      ];
    if (Array.isArray(Y))
      return Y;
  }
  function P({ extend: V, ...Y }) {
    return A(Y, V, (ee, K) => !_(ee) && !K.some(_) ? A({}, ee, ...K, M) : (U, q) => A({}, ...[
      ee,
      ...K
    ].map((W) => O(W, U, q)), M));
  }
  function* z(V) {
    let Y = (0, s.toPath)(V);
    if (Y.length === 0 || (yield Y, Array.isArray(V)))
      return;
    let ee = /^(.*?)\s*\/\s*([^/]+)$/, K = V.match(ee);
    if (K !== null) {
      let [, U, q] = K, W = (0, s.toPath)(U);
      W.alpha = q, yield W;
    }
  }
  function F(V) {
    const Y = (ee, K) => {
      for (const U of z(ee)) {
        let q = 0, W = V;
        for (; W != null && q < U.length; )
          W = W[U[q++]], W = _(W) && (U.alpha === void 0 || q <= U.length - 1) ? W(Y, T) : W;
        if (W !== void 0) {
          if (U.alpha !== void 0) {
            let ie = (0, g.parseColorFormat)(W);
            return (0, m.withAlphaValue)(ie, U.alpha, (0, b.default)(ie));
          }
          return (0, d.default)(W) ? (0, f.cloneDeep)(W) : W;
        }
      }
      return K;
    };
    return Object.assign(Y, {
      theme: Y,
      ...T
    }), Object.keys(V).reduce((ee, K) => (ee[K] = _(V[K]) ? V[K](Y, T) : V[K], ee), {});
  }
  function $(V) {
    let Y = [];
    return V.forEach((ee) => {
      Y = [
        ...Y,
        ee
      ];
      var K;
      const U = (K = ee?.plugins) !== null && K !== void 0 ? K : [];
      U.length !== 0 && U.forEach((q) => {
        q.__isOptionsFunction && (q = q());
        var W;
        Y = [
          ...Y,
          ...$([
            (W = q?.config) !== null && W !== void 0 ? W : {}
          ])
        ];
      });
    }), Y;
  }
  function G(V) {
    return [
      ...V
    ].reduceRight((ee, K) => _(K) ? K({
      corePlugins: ee
    }) : (0, r.default)(K, ee), n.default);
  }
  function H(V) {
    return [
      ...V
    ].reduceRight((ee, K) => [
      ...ee,
      ...K
    ], []);
  }
  function Z(V) {
    let Y = [
      ...$(V),
      {
        prefix: "",
        important: !1,
        separator: ":"
      }
    ];
    var ee, K;
    return (0, c.normalizeConfig)((0, a.defaults)({
      theme: F(P(N(Y.map((U) => (ee = U?.theme) !== null && ee !== void 0 ? ee : {})))),
      corePlugins: G(Y.map((U) => U.corePlugins)),
      plugins: H(V.map((U) => (K = U?.plugins) !== null && K !== void 0 ? K : []))
    }, ...Y));
  }
})(CK);
var $K = {}, ZNe = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: t }) => ({
      ...t("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: t }) => t("blur"),
    backdropBrightness: ({ theme: t }) => t("brightness"),
    backdropContrast: ({ theme: t }) => t("contrast"),
    backdropGrayscale: ({ theme: t }) => t("grayscale"),
    backdropHueRotate: ({ theme: t }) => t("hueRotate"),
    backdropInvert: ({ theme: t }) => t("invert"),
    backdropOpacity: ({ theme: t }) => t("opacity"),
    backdropSaturate: ({ theme: t }) => t("saturate"),
    backdropSepia: ({ theme: t }) => t("sepia"),
    backgroundColor: ({ theme: t }) => t("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: t }) => t("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: t }) => ({
      ...t("colors"),
      DEFAULT: t("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: t }) => t("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: t }) => ({
      ...t("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: t }) => t("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: t }) => t("colors"),
    colors: ({ colors: t }) => ({
      inherit: t.inherit,
      current: t.current,
      transparent: t.transparent,
      black: t.black,
      white: t.white,
      slate: t.slate,
      gray: t.gray,
      zinc: t.zinc,
      neutral: t.neutral,
      stone: t.stone,
      red: t.red,
      orange: t.orange,
      amber: t.amber,
      yellow: t.yellow,
      lime: t.lime,
      green: t.green,
      emerald: t.emerald,
      teal: t.teal,
      cyan: t.cyan,
      sky: t.sky,
      blue: t.blue,
      indigo: t.indigo,
      violet: t.violet,
      purple: t.purple,
      fuchsia: t.fuchsia,
      pink: t.pink,
      rose: t.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: t }) => t("borderColor"),
    divideOpacity: ({ theme: t }) => t("borderOpacity"),
    divideWidth: ({ theme: t }) => t("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: t }) => ({
      none: "none",
      ...t("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: t }) => t("spacing"),
    gradientColorStops: ({ theme: t }) => t("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridTemplateColumns: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    height: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: t }) => ({
      ...t("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: t, breakpoints: e }) => ({
      ...t("spacing"),
      none: "none",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...e(t("screens"))
    }),
    minHeight: ({ theme: t }) => ({
      ...t("spacing"),
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    minWidth: ({ theme: t }) => ({
      ...t("spacing"),
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      15: "0.15",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      35: "0.35",
      40: "0.4",
      45: "0.45",
      50: "0.5",
      55: "0.55",
      60: "0.6",
      65: "0.65",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      85: "0.85",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: t }) => t("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: t }) => t("spacing"),
    placeholderColor: ({ theme: t }) => t("colors"),
    placeholderOpacity: ({ theme: t }) => t("opacity"),
    ringColor: ({ theme: t }) => ({
      DEFAULT: t("colors.blue.500", "#3b82f6"),
      ...t("colors")
    }),
    ringOffsetColor: ({ theme: t }) => t("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: t }) => ({
      DEFAULT: "0.5",
      ...t("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: t }) => ({
      ...t("spacing")
    }),
    scrollPadding: ({ theme: t }) => t("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: t }) => ({
      ...t("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: t }) => ({
      none: "none",
      ...t("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: t }) => t("colors"),
    textDecorationColor: ({ theme: t }) => t("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: t }) => ({
      ...t("spacing")
    }),
    textOpacity: ({ theme: t }) => t("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: t }) => ({
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    size: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    width: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      svw: "100svw",
      lvw: "100lvw",
      dvw: "100dvw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const e = /* @__PURE__ */ r(ZNe), n = mO;
  function r(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  function i(a) {
    var s;
    const c = ((s = a?.presets) !== null && s !== void 0 ? s : [
      e.default
    ]).slice().reverse().flatMap((g) => i(g instanceof Function ? g() : g)), d = {
      // Add experimental configs here...
      respectDefaultRingColorOpacity: {
        theme: {
          ringColor: ({ theme: g }) => ({
            DEFAULT: "#3b82f67f",
            ...g("colors")
          })
        }
      },
      disableColorOpacityUtilitiesByDefault: {
        corePlugins: {
          backgroundOpacity: !1,
          borderOpacity: !1,
          divideOpacity: !1,
          placeholderOpacity: !1,
          ringOpacity: !1,
          textOpacity: !1
        }
      }
    }, f = Object.keys(d).filter((g) => (0, n.flagEnabled)(a, g)).map((g) => d[g]);
    return [
      a,
      ...f,
      ...c
    ];
  }
})($K);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const e = /* @__PURE__ */ r(CK), n = /* @__PURE__ */ r($K);
  function r(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  function i(...a) {
    let [, ...s] = (0, n.default)(a[0]);
    return (0, e.default)([
      ...a,
      ...s
    ]);
  }
})(AK);
let mD = AK;
var KNe = (mD.__esModule ? mD : { default: mD }).default;
const JNe = /* @__PURE__ */ J0(KNe), eMe = {
  content: [],
  theme: {
    screens: mue
  }
}, tMe = JNe(eMe), HK = tMe.theme?.screens;
if (!HK)
  throw new Error('[viewport] Tailwind config does not provide "theme.screens".');
const nMe = (t) => {
  const e = HK[t];
  if (!e)
    throw new Error(`[viewport] Unknown screen "${t}" requested.`);
  return e;
}, rMe = (t, e) => {
  const n = nMe(t);
  if (typeof n == "string")
    return e === "up" ? `(min-width: ${n})` : `(max-width: ${n})`;
  if (e === "up") {
    if (n.min)
      return `(min-width: ${n.min})`;
    if (n.max)
      return `(max-width: ${n.max})`;
  } else {
    if (n.max)
      return `(max-width: ${n.max})`;
    if (n.min)
      return `(min-width: ${n.min})`;
  }
  throw new Error(`[viewport] Unable to build media query for screen "${t}".`);
}, iMe = (t, e) => {
  const n = ve.c(5);
  let r;
  n[0] !== e ? (r = e === void 0 ? {} : e, n[0] = e, n[1] = r) : r = n[1];
  const {
    direction: i,
    defaultState: a
  } = r, s = i === void 0 ? "up" : i;
  let c;
  return n[2] !== s || n[3] !== t ? (c = rMe(t, s), n[2] = s, n[3] = t, n[4] = c) : c = n[4], Exe(c, a);
}, qK = (t, e) => {
  const n = ve.c(2);
  let r;
  return n[0] !== e ? (r = {
    direction: "down",
    defaultState: e
  }, n[0] = e, n[1] = r) : r = n[1], iMe(t, r);
}, aMe = Re.div`
  twd-space-y-4
`, oMe = Re.div`
  twd-flex
  twd-items-center
  twd-gap-3
`, sMe = Re.div`
  twd-space-y-6
`, US = Re.div`
  twd-flex
  twd-space-x-2
`, {
  IconTimer: lMe,
  IconArrowForward: $V,
  IconFlare: cMe,
  IconGroupWork: uMe,
  IconSettingsApplications: dMe
} = l1e, fMe = (t) => {
  const e = ve.c(98), {
    control: n,
    setValue: r,
    onSampleAmountChange: i,
    isArchived: a,
    isInFavorites: s,
    methodId: c,
    configuration: d,
    overriddenFields: f
  } = t;
  let g;
  e[0] !== n ? (g = {
    control: n,
    name: "runTimeMin"
  }, e[0] = n, e[1] = g) : g = e[1];
  const m = Wb(g);
  let b;
  e[2] !== n ? (b = {
    control: n,
    name: "washAfterInjectionVial"
  }, e[2] = n, e[3] = b) : b = e[3];
  const w = Wb(b);
  let _;
  e[4] !== d ? (_ = fw(d), e[4] = d, e[5] = _) : _ = e[5];
  const {
    hasDetector: A,
    isValvePositionPlanSupported: T,
    hasGradient: O,
    hasAutosampler: R,
    deviceType: N
  } = _, M = N === Bb.CROMITE;
  let P;
  e[6] !== d ? (P = d7(d), e[6] = d, e[7] = P) : P = e[7];
  const z = P;
  let F;
  e[8] !== n ? (F = {
    control: n
  }, e[8] = n, e[9] = F) : F = e[9];
  const {
    disabled: $
  } = UI(F), G = qK("sm");
  let H;
  e[10] !== f ? (H = ($e) => f?.includes($e) ?? !1, e[10] = f, e[11] = H) : H = e[11];
  const Z = H, V = w == null || w === "", Y = G ? "md" : "lg";
  let ee;
  e[12] !== n || e[13] !== Y ? (ee = /* @__PURE__ */ C.jsx(Zr, { name: "name", control: n, size: Y, label: "Method name", isFullWidth: !0 }), e[12] = n, e[13] = Y, e[14] = ee) : ee = e[14];
  let K;
  e[15] !== a || e[16] !== $ || e[17] !== s || e[18] !== c ? (K = /* @__PURE__ */ C.jsx(EK, { methodId: c, isFormDisabled: $, isArchived: a, isInFavorites: s }), e[15] = a, e[16] = $, e[17] = s, e[18] = c, e[19] = K) : K = e[19];
  let U;
  e[20] !== ee || e[21] !== K ? (U = /* @__PURE__ */ C.jsxs(oMe, { children: [
    ee,
    K
  ] }), e[20] = ee, e[21] = K, e[22] = U) : U = e[22];
  let q;
  e[23] === Symbol.for("react.memo_cache_sentinel") ? (q = /* @__PURE__ */ C.jsx(lMe, {}), e[23] = q) : q = e[23];
  let W;
  e[24] !== n ? (W = /* @__PURE__ */ C.jsx(Zr, { name: "comment", label: "Description", control: n, isFullWidth: !0, hint: "Space to leave comments on your method [optional]." }), e[24] = n, e[25] = W) : W = e[25];
  let ie;
  e[26] === Symbol.for("react.memo_cache_sentinel") ? (ie = [0.25, 0.5, 1, 2, 3, 4, 5, 8, 10, 15, 20, 25], e[26] = ie) : ie = e[26];
  let J;
  e[27] !== Z ? (J = Z("runTimeMin"), e[27] = Z, e[28] = J) : J = e[28];
  let B;
  e[29] !== n || e[30] !== J ? (B = /* @__PURE__ */ C.jsx(Uc, { name: "runTimeMin", label: "Run time, min", control: n, hints: ie, type: "float", isFullWidth: !0, isWarning: J, hint: "How long (in min) your method will run. Since the total working volume of the pump is 5.0 mL, the maximum time possible is 5.0/Flow rate. For a gradient system with two pumps the total volume is 10 mL, the maximum time possible is 10.0/Flow rate." }), e[29] = n, e[30] = J, e[31] = B) : B = e[31];
  let te;
  e[32] !== W || e[33] !== B ? (te = /* @__PURE__ */ C.jsxs(db, { title: "General", icon: q, children: [
    W,
    B
  ] }), e[32] = W, e[33] = B, e[34] = te) : te = e[34];
  let ae;
  e[35] === Symbol.for("react.memo_cache_sentinel") ? (ae = /* @__PURE__ */ C.jsx($V, {}), e[35] = ae) : ae = e[35];
  let le;
  e[36] !== n ? (le = /* @__PURE__ */ C.jsx(Zr, { name: "solventA", label: "A phase", control: n, isFullWidth: !0, hint: "Mobile Phase in Pump A. Ex. MeCN/H2O/H2SO4 - 10/90/.2%." }), e[36] = n, e[37] = le) : le = e[37];
  let de;
  e[38] !== n || e[39] !== O ? (de = O && /* @__PURE__ */ C.jsx(C.Fragment, { children: /* @__PURE__ */ C.jsx(Zr, { name: "solventB", label: "B phase", control: n, isFullWidth: !0, hint: "Mobile Phase in Pump B. Ex. MeCN/H2O/H2SO4 - 90/10/.2%." }) }), e[38] = n, e[39] = O, e[40] = de) : de = e[40];
  let _e;
  e[41] === Symbol.for("react.memo_cache_sentinel") ? (_e = [0.7, 1, 1.3, 1.5, 2], e[41] = _e) : _e = e[41];
  let ue;
  e[42] !== n ? (ue = /* @__PURE__ */ C.jsx(Uc, { name: "flowRateMlPerMin", label: "Flow rate, mL/min", control: n, hints: _e, type: "float", isFullWidth: !0, hint: "How quickly the pump will push the mobile phase through the system (in mL/min). For a standard column with an internal diameter (ID) of 3.2 mm, a flow rate between 0.5 - 0.7 mL/min is recommended for most operations. For a 2.1 mm ID column, a flow rate between 0.2-0.4 mL/min is recommended. Note: The faster the flow rate, the higher the internal pressure. The system can operate with up to 3000 psi pressure.", className: "twd-flex-1" }), e[42] = n, e[43] = ue) : ue = e[43];
  let Se;
  e[44] === Symbol.for("react.memo_cache_sentinel") ? (Se = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 5, 6, 7, 8], e[44] = Se) : Se = e[44];
  let Ne;
  e[45] !== n ? (Ne = /* @__PURE__ */ C.jsx(Uc, { name: "refillFlowRateMlPerMin", label: "Refill flow rate, mL/min", control: n, hints: Se, type: "float", isFullWidth: !0, hint: "How quickly the pump(s) will refill after completing an injection. 8 mL/min is the maximum speed. Sometimes slow refill flow rate works better preventing bubbles formation in the pump.", className: "twd-flex-1" }), e[45] = n, e[46] = Ne) : Ne = e[46];
  let Me;
  e[47] !== ue || e[48] !== Ne ? (Me = /* @__PURE__ */ C.jsxs(US, { children: [
    ue,
    Ne
  ] }), e[47] = ue, e[48] = Ne, e[49] = Me) : Me = e[49];
  let Ce;
  e[50] !== n ? (Ce = /* @__PURE__ */ C.jsx(US, { children: /* @__PURE__ */ C.jsx(Zr, { name: "pressureMin", label: "Pressure min, psi", control: n, isFullWidth: !0, type: "integer", hint: "Minimum pressure for the system (in psi). It is recommended to set it at least 100 psi." }) }), e[50] = n, e[51] = Ce) : Ce = e[51];
  let Ue;
  e[52] !== le || e[53] !== de || e[54] !== Me || e[55] !== Ce ? (Ue = /* @__PURE__ */ C.jsxs(db, { title: "Pump", icon: ae, children: [
    le,
    de,
    Me,
    Ce
  ] }), e[52] = le, e[53] = de, e[54] = Me, e[55] = Ce, e[56] = Ue) : Ue = e[56];
  let rt;
  e[57] !== n || e[58] !== O || e[59] !== $ || e[60] !== m ? (rt = O && /* @__PURE__ */ C.jsx(db, { title: "Gradient", icon: /* @__PURE__ */ C.jsx($V, {}), hint: "When enabled in a two-pump gradient set-up, this table specifies  how and when each pump operates.", children: /* @__PURE__ */ C.jsx(P8e, { control: n, name: "gradient", maxTime: Number(m) ?? 0, step: xK, isDisabled: $ }) }), e[57] = n, e[58] = O, e[59] = $, e[60] = m, e[61] = rt) : rt = e[61];
  let it;
  e[62] !== n || e[63] !== z || e[64] !== A ? (it = A && /* @__PURE__ */ C.jsxs(db, { title: "Detector", icon: /* @__PURE__ */ C.jsx(cMe, {}), children: [
    /* @__PURE__ */ C.jsxs(Qb, { name: "detectorSingleChannel", label: "Channel mode", control: n, hint: "Sets the default viewing channel for the detector. These can be changed during and after the injection.", isFullWidth: !0, children: [
      /* @__PURE__ */ C.jsx("option", { value: "", children: "Multi Channel: All" }),
      z != null && Object.entries(z).map(hMe)
    ] }),
    /* @__PURE__ */ C.jsx(Uc, { name: "calibrationDelaySec", label: "Calibration delay, s", control: n, hints: [1, 5, 10, 30, 60, 300, 600], type: "integer", className: "twd-flex-1" })
  ] }), e[62] = n, e[63] = z, e[64] = A, e[65] = it) : it = e[65];
  let Ft;
  e[66] === Symbol.for("react.memo_cache_sentinel") ? (Ft = /* @__PURE__ */ C.jsx(uMe, {}), e[66] = Ft) : Ft = e[66];
  let wt;
  e[67] === Symbol.for("react.memo_cache_sentinel") ? (wt = [1, 2, 3, 5, 10], e[67] = wt) : wt = e[67];
  let Ot;
  e[68] !== Z ? (Ot = Z("injectionUl"), e[68] = Z, e[69] = Ot) : Ot = e[69];
  let On;
  e[70] !== n || e[71] !== i || e[72] !== Ot ? (On = /* @__PURE__ */ C.jsx(US, { children: /* @__PURE__ */ C.jsx(Uc, { name: "injectionUl", label: "Sample amount, μl", control: n, hints: wt, type: "integer", hint: SK, className: "twd-flex-1", isWarning: Ot, onValueChange: i }) }), e[70] = n, e[71] = i, e[72] = Ot, e[73] = On) : On = e[73];
  let Ct;
  e[74] !== n || e[75] !== R || e[76] !== M || e[77] !== V || e[78] !== r ? (Ct = R ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsxs(US, { children: [
      /* @__PURE__ */ C.jsx(Uc, { name: "needleDepthMm", label: "Offset from vial bottom, mm", control: n, hints: [10, 15, 20, 25], type: "integer", hint: "Offset from the bottom of the sample vial where the autosampler's needle will stop (in mm) [optional]. Max 30 mm. The default value is 0 mm. 0 mm means the needle reaches the vial bottom.", className: "twd-flex-1" }),
      /* @__PURE__ */ C.jsx(Uc, { name: "syringeRefillSpeed", label: "Intake rate, μl/min", control: n, hints: [50, 100, 150, 200, 300, 500, 1e3], type: "integer", hint: "Sets how quickly the syringe pump will aspirate the sample from the vial [optional]. If no value is entered, the default speed is 1000 μl\\Min. Range: 10-1000 μl\\Min.", className: "twd-flex-1" })
    ] }),
    /* @__PURE__ */ C.jsx(Zr, { name: "shakingDurationSec", label: "Shaking before injection, s", control: n, isFullWidth: !0, type: "float", hint: "Sets how long the shaking mode before injection will last (in seconds)." }),
    /* @__PURE__ */ C.jsxs(Qb, { name: "washAfterInjectionVial", label: "Needle wash after injection", control: n, isFullWidth: !0, hint: "Select whether the autosampler should wash the needle after each injection in all wash vials or in one specific wash vial. If injection time is equal to the run time then no needle wash is possible after injection.", onChange: ($e) => {
      $e === "" && r("washAfterInjectionTimeSec", "", {
        shouldDirty: !0,
        shouldValidate: !0
      });
    }, children: [
      /* @__PURE__ */ C.jsx("option", { value: "", children: "Disabled" }),
      /* @__PURE__ */ C.jsx("option", { value: 0, children: "Wash in all vials" }),
      /* @__PURE__ */ C.jsx("option", { value: 1, children: "Wash in vial 1" }),
      /* @__PURE__ */ C.jsx("option", { value: 2, children: "Wash in vial 2" }),
      /* @__PURE__ */ C.jsx("option", { value: 3, children: "Wash in vial 3" }),
      /* @__PURE__ */ C.jsx("option", { value: 4, children: "Wash in vial 4" })
    ] }),
    !V && /* @__PURE__ */ C.jsx(Uc, { name: "washAfterInjectionTimeSec", label: "Needle wash time, s", control: n, hints: [1, 3, 5, 10, 15, 30], type: "float", isFullWidth: !0, hint: "Optional duration for washing the needle in each selected wash vial. If empty, the device firmware chooses the wash duration." })
  ] }) : M ? /* @__PURE__ */ C.jsx(US, { children: /* @__PURE__ */ C.jsx(Uc, { name: "syringeRefillSpeed", label: "Intake rate, μl/min", control: n, hints: [50, 100, 150, 200, 300, 500, 1e3], type: "integer", hint: "Sets how quickly the syringe pump will aspirate the sample from the vial [optional]. If no value is entered, the default speed is 1000 μl\\Min. Range: 10-1000 μl\\Min.", className: "twd-flex-1" }) }) : null, e[74] = n, e[75] = R, e[76] = M, e[77] = V, e[78] = r, e[79] = Ct) : Ct = e[79];
  let se;
  e[80] !== On || e[81] !== Ct ? (se = /* @__PURE__ */ C.jsxs(db, { title: "Injection", icon: Ft, children: [
    On,
    Ct
  ] }), e[80] = On, e[81] = Ct, e[82] = se) : se = e[82];
  let ge;
  e[83] !== n || e[84] !== $ || e[85] !== T || e[86] !== m ? (ge = T && /* @__PURE__ */ C.jsx(db, { title: "Valve", icon: /* @__PURE__ */ C.jsx(dMe, {}), children: /* @__PURE__ */ C.jsx(W8e, { control: n, name: "valvePositionPlan", maxTime: Number(m) ?? 0, isDisabled: $ }) }), e[83] = n, e[84] = $, e[85] = T, e[86] = m, e[87] = ge) : ge = e[87];
  let Te;
  e[88] !== te || e[89] !== Ue || e[90] !== rt || e[91] !== it || e[92] !== se || e[93] !== ge ? (Te = /* @__PURE__ */ C.jsxs(sMe, { className: "twd-mt-6", children: [
    te,
    Ue,
    rt,
    it,
    se,
    ge
  ] }), e[88] = te, e[89] = Ue, e[90] = rt, e[91] = it, e[92] = se, e[93] = ge, e[94] = Te) : Te = e[94];
  let He;
  return e[95] !== U || e[96] !== Te ? (He = /* @__PURE__ */ C.jsxs(aMe, { className: "twd-@container/state-title", children: [
    U,
    Te
  ] }), e[95] = U, e[96] = Te, e[97] = He) : He = e[97], He;
};
function hMe(t) {
  const [e, n] = t;
  return /* @__PURE__ */ C.jsxs("option", { value: e, children: [
    "Single Channel: ",
    e,
    ": ",
    n,
    " nm"
  ] }, e);
}
const pMe = Re.div`
  twd-space-y-4
`, mMe = Re.div`
  twd-flex
  twd-items-center
  twd-gap-3
`, gMe = Re.div`
  twd-space-y-6
`, vMe = (t) => {
  const e = ve.c(61), {
    control: n,
    isArchived: r,
    isInFavorites: i,
    methodId: a,
    configuration: s,
    onShowAdvanced: c,
    onSampleAmountChange: d,
    overriddenFields: f
  } = t;
  let g;
  e[0] !== s ? (g = fw(s), e[0] = s, e[1] = g) : g = e[1];
  const {
    hasGradient: m,
    hasDetector: b
  } = g;
  let w;
  e[2] !== s ? (w = d7(s), e[2] = s, e[3] = w) : w = e[3];
  const _ = w;
  let A;
  e[4] !== n ? (A = {
    control: n
  }, e[4] = n, e[5] = A) : A = e[5];
  const {
    disabled: T
  } = UI(A), O = qK("sm");
  let R;
  e[6] !== f ? (R = (ae) => f?.includes(ae) ?? !1, e[6] = f, e[7] = R) : R = e[7];
  const N = R, M = O ? "md" : "lg";
  let P;
  e[8] !== n || e[9] !== M ? (P = /* @__PURE__ */ C.jsx(Zr, { name: "name", control: n, size: M, label: "Method name", isFullWidth: !0 }), e[8] = n, e[9] = M, e[10] = P) : P = e[10];
  let z;
  e[11] !== r || e[12] !== T || e[13] !== i || e[14] !== a ? (z = /* @__PURE__ */ C.jsx(EK, { methodId: a, isFormDisabled: T, isArchived: r, isInFavorites: i }), e[11] = r, e[12] = T, e[13] = i, e[14] = a, e[15] = z) : z = e[15];
  let F;
  e[16] !== P || e[17] !== z ? (F = /* @__PURE__ */ C.jsxs(mMe, { children: [
    P,
    z
  ] }), e[16] = P, e[17] = z, e[18] = F) : F = e[18];
  let $;
  e[19] !== n ? ($ = /* @__PURE__ */ C.jsx(Zr, { name: "comment", label: "Description", control: n, isFullWidth: !0, hint: "Space to leave comments on your method [optional]." }), e[19] = n, e[20] = $) : $ = e[20];
  let G;
  e[21] === Symbol.for("react.memo_cache_sentinel") ? (G = [0.25, 0.5, 1, 2, 3, 4, 5, 8, 10, 15, 20, 25], e[21] = G) : G = e[21];
  let H;
  e[22] !== N ? (H = N("runTimeMin"), e[22] = N, e[23] = H) : H = e[23];
  let Z;
  e[24] !== n || e[25] !== H ? (Z = /* @__PURE__ */ C.jsx(Uc, { name: "runTimeMin", label: "Run time, min", control: n, hints: G, type: "float", isFullWidth: !0, isWarning: H, hint: "How long (in min) your method will run. Since the total working volume of the pump is 5.0 mL, the maximum time possible is 5.0/Flow rate. For a gradient system with two pumps the total volume is 10 mL, the maximum time possible is 10.0/Flow rate." }), e[24] = n, e[25] = H, e[26] = Z) : Z = e[26];
  let V;
  e[27] !== n ? (V = /* @__PURE__ */ C.jsx(Zr, { name: "solventA", label: "A phase", control: n, isFullWidth: !0, hint: "Mobile Phase in Pump A. Ex. MeCN/H2O/H2SO4 - 10/90/.2%." }), e[27] = n, e[28] = V) : V = e[28];
  let Y;
  e[29] !== n || e[30] !== m ? (Y = m && /* @__PURE__ */ C.jsx(Zr, { name: "solventB", label: "B phase", control: n, isFullWidth: !0, hint: "Mobile Phase in Pump B. Ex. MeCN/H2O/H2SO4 - 90/10/.2%." }), e[29] = n, e[30] = m, e[31] = Y) : Y = e[31];
  let ee;
  e[32] === Symbol.for("react.memo_cache_sentinel") ? (ee = [0.7, 1, 1.3, 1.5, 2], e[32] = ee) : ee = e[32];
  let K;
  e[33] !== n ? (K = /* @__PURE__ */ C.jsx(Uc, { name: "flowRateMlPerMin", label: "Flow rate, mL/min", control: n, hints: ee, type: "float", isFullWidth: !0, hint: "How quickly the pump will push the mobile phase through the system (in mL/min). For a standard column with an internal diameter (ID) of 3.2 mm, a flow rate between 0.5 - 0.7 mL/min is recommended for most operations. For a 2.1 mm ID column, a flow rate between 0.2-0.4 mL/min is recommended. Note: The faster the flow rate, the higher the internal pressure. The system can operate with up to 3000 psi pressure." }), e[33] = n, e[34] = K) : K = e[34];
  let U;
  e[35] === Symbol.for("react.memo_cache_sentinel") ? (U = [1, 2, 3, 5, 10], e[35] = U) : U = e[35];
  let q;
  e[36] !== N ? (q = N("injectionUl"), e[36] = N, e[37] = q) : q = e[37];
  let W;
  e[38] !== n || e[39] !== d || e[40] !== q ? (W = /* @__PURE__ */ C.jsx(Uc, { name: "injectionUl", label: "Sample amount, μl", control: n, hints: U, type: "integer", hint: SK, isFullWidth: !0, isWarning: q, onValueChange: d }), e[38] = n, e[39] = d, e[40] = q, e[41] = W) : W = e[41];
  let ie;
  e[42] !== n || e[43] !== _ || e[44] !== b ? (ie = b && /* @__PURE__ */ C.jsxs(Qb, { name: "detectorSingleChannel", label: "Channel mode", control: n, hint: "Sets the default viewing channel for the detector. These can be changed during and after the injection.", isFullWidth: !0, children: [
    /* @__PURE__ */ C.jsx("option", { value: "", children: "Multi Channel: All" }),
    _ != null && Object.entries(_).map(yMe)
  ] }), e[42] = n, e[43] = _, e[44] = b, e[45] = ie) : ie = e[45];
  let J;
  e[46] !== T || e[47] !== c ? (J = !T && /* @__PURE__ */ C.jsx("div", { className: "twd-mt-4", children: /* @__PURE__ */ C.jsx(Vt, { variant: "primary", onClick: c, className: "twd-mb-2", children: "Turn on advanced mode" }) }), e[46] = T, e[47] = c, e[48] = J) : J = e[48];
  let B;
  e[49] !== Z || e[50] !== V || e[51] !== Y || e[52] !== K || e[53] !== W || e[54] !== ie || e[55] !== J || e[56] !== $ ? (B = /* @__PURE__ */ C.jsxs(gMe, { className: "twd-mt-6", children: [
    $,
    Z,
    V,
    Y,
    K,
    W,
    ie,
    J
  ] }), e[49] = Z, e[50] = V, e[51] = Y, e[52] = K, e[53] = W, e[54] = ie, e[55] = J, e[56] = $, e[57] = B) : B = e[57];
  let te;
  return e[58] !== B || e[59] !== F ? (te = /* @__PURE__ */ C.jsxs(pMe, { className: "twd-@container/state-title", children: [
    F,
    B
  ] }), e[58] = B, e[59] = F, e[60] = te) : te = e[60], te;
};
function yMe(t) {
  const [e, n] = t;
  return /* @__PURE__ */ C.jsxs("option", { value: e, children: [
    "Single Channel: ",
    e,
    ": ",
    n,
    " nm"
  ] }, e);
}
const bMe = ({
  portal: t,
  onMethodImport: e
}) => {
  const n = I.useRef(null), [r, i] = I.useState(!1), [a, s] = I.useState(!1), [c, d] = I.useState(null), [f, g] = I.useState(!1), m = () => {
    i(!0);
  }, b = (T) => {
    d(T), s(!0), i(!1);
  }, w = () => {
    i(!1);
  }, _ = () => {
    d(null), s(!1);
  }, A = async (T) => {
    if (c != null) {
      g(!0);
      try {
        const O = await lSe(c);
        e(O), d(null), s(!1), T();
      } catch (O) {
        console.error(O);
      } finally {
        g(!1);
      }
    }
  };
  return I.useEffect(() => {
    r && n.current?.focusInput();
  }, [r]), /* @__PURE__ */ C.jsx(C.Fragment, { children: t && Wc.createPortal(r ? /* @__PURE__ */ C.jsx(nSe, { methodId: null, onChange: b, onClose: w, placeholder: "Import from method...", className: "twd-min-w-[240px]", ref: n }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsx(Vt, { variant: "primary", padding: "lg", onClick: m, children: "Import" }),
    /* @__PURE__ */ C.jsx(qu, { open: a, onOpenChange: s, title: "Are you sure?", description: /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      "Applying this preset will replace the current form values with those from the imported method. Your unsaved progress will be lost.",
      /* @__PURE__ */ C.jsx("br", {}),
      /* @__PURE__ */ C.jsx("br", {}),
      "If the imported method’s configuration differs, some fields may remain unchanged. Review all values to ensure they meet your expectations.",
      /* @__PURE__ */ C.jsx("br", {}),
      /* @__PURE__ */ C.jsx("br", {}),
      "You can use Reset button anytime to restore the form to its initial state."
    ] }), confirmLabel: "Apply", cancelLabel: "Cancel", onCancel: _, confirmButton: ({
      disabled: T,
      close: O
    }) => /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", isLoading: f, isDisabled: T || f, onClick: () => A(O), children: "Import" }) })
  ] }), t) });
}, wMe = (t) => {
  const e = ve.c(8), {
    onTurnOff: n
  } = t, [r, i] = I.useState(!1);
  let a;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (a = () => {
    i(!0);
  }, e[0] = a) : a = e[0];
  const s = a;
  let c;
  e[1] !== n ? (c = () => {
    n();
  }, e[1] = n, e[2] = c) : c = e[2];
  const d = c;
  let f;
  e[3] === Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ C.jsx(Vt, { variant: "primary", onClick: s, children: "Turn off advanced mode" }), e[3] = f) : f = e[3];
  let g;
  e[4] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    "Turning off advanced mode will switch to the simplified form view. All parameters that are only displayed in Advanced Mode will be reset to their default values.",
    /* @__PURE__ */ C.jsx("br", {}),
    /* @__PURE__ */ C.jsx("br", {}),
    "You can turn advanced mode back on at any time to access all configuration options."
  ] }), e[4] = g) : g = e[4];
  let m;
  return e[5] !== d || e[6] !== r ? (m = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    f,
    /* @__PURE__ */ C.jsx(qu, { open: r, onOpenChange: i, title: "Are you sure?", description: g, confirmLabel: "Turn off", cancelLabel: "Cancel", onConfirm: d })
  ] }), e[5] = d, e[6] = r, e[7] = m) : m = e[7], m;
}, xMe = lQ, SMe = "EditMethod", EMe = (t) => {
  const e = ve.c(2);
  let n;
  return e[0] !== t ? (n = {
    mutationKey: [SMe, t],
    mutationFn: async (r) => {
      if (t == null)
        throw new Error("Method id is not provided");
      const i = await Vg.editMethod(t, r);
      return qt(xMe, i, Y0);
    }
  }, e[0] = t, e[1] = n) : n = e[1], Ei(n);
}, _Me = "CreateMethod", AMe = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationKey: [_Me],
    mutationFn: CMe
  }, t[0] = e) : e = t[0], Ei(e);
};
async function CMe(t) {
  const e = await Vg.createMethod(t);
  return console.log("CreateMethod response", e), qt(lQ, e, Y0);
}
const TMe = uQ.partial(), HV = Xe({
  injectionUl: Ve().optional(),
  syringeRefillSpeed: Ve().optional()
}), OMe = Xe({
  common: TMe,
  cromite: HV.optional(),
  alltesta: HV.optional()
}), zb = Object.entries, RMe = Object.keys, EN = bi.notEmptyNumericString.and(Je().or(Ve().positive())), GK = Xe({
  name: bi.notEmptyString,
  runTimeMin: EN,
  comment: Je(),
  flowRateMlPerMin: EN,
  solventA: Je().optional(),
  solventB: Je().optional(),
  injectionUl: bi.notEmptyNumericString.refine((t) => Number(t) >= 0 && Number(t) <= 50, "Sample amount must be greater than or equal to 0 and less than or equal to 50 μL"),
  detectorSingleChannel: cQ,
  isAdvancedMode: Sr()
}), YK = Xe({
  shakingDurationSec: bi.numericString,
  gradient: QI,
  refillFlowRateMlPerMin: EN,
  pressureMin: bi.numericString,
  needleDepthMm: bi.numericString,
  washAfterInjectionVial: bi.numericString,
  washAfterInjectionTimeSec: bi.numericString,
  syringeRefillSpeed: bi.numericString,
  calibrationDelaySec: bi.numericString,
  valvePositionPlan: KI.nullable(),
  // This field is not existed in the form. Not sure that we still need to send it
  pressureReachSec: bi.numericString
}), qV = GK.merge(YK).superRefine((t, e) => {
  if (t.isAdvancedMode && t.gradient != null) {
    const n = Number(t.runTimeMin);
    if (Number.isFinite(n)) {
      const r = R4.validateGradient(t.gradient ?? [], n, xK);
      r.isValid || e.addIssue({
        code: at.custom,
        path: ["gradient"],
        message: r.error ?? "Invalid gradient"
      });
    }
  }
  if (t.isAdvancedMode) {
    const n = Number(t.runTimeMin);
    if (Number.isFinite(n)) {
      const r = jMe(t.valvePositionPlan, n);
      r != null && e.addIssue({
        code: at.custom,
        path: ["valvePositionPlan"],
        message: r
      });
    }
  }
}), DMe = qV.superRefine((t, e) => {
  if (t.isAdvancedMode) {
    const n = qV.safeParse(t);
    n.success || n.error.issues.forEach((r) => {
      e.addIssue(r);
    });
  } else {
    const n = GK.safeParse(t);
    n.success || n.error.issues.forEach((r) => {
      e.addIssue(r);
    });
  }
}), NMe = () => {
  const t = YK.shape;
  return RMe(t);
}, MMe = (t) => ({
  name: t.name,
  runTimeMin: t.runTimeMin,
  comment: t.comment,
  flowRateMlPerMin: t.flowRateMlPerMin,
  solventA: t.solventA,
  solventB: t.solventB,
  injectionUl: t.injectionUl,
  detectorSingleChannel: t.detectorSingleChannel,
  isAdvancedMode: t.isAdvancedMode
}), XK = () => [{
  time: 0,
  fractions: [0.5, 0.5],
  id: s_()
}], WK = (t) => ({
  name: t.name ?? "",
  runTimeMin: t.runTimeMin ?? "",
  shakingDurationSec: t.shakingDurationSec ?? "",
  gradient: t.gradient ?? XK(),
  comment: t.comment ?? "",
  flowRateMlPerMin: t.flowRateMlPerMin ?? "",
  refillFlowRateMlPerMin: t.refillFlowRateMlPerMin ?? "",
  solventA: t.solvents?.a.name ?? "",
  solventB: t.solvents?.b.name ?? "",
  pressureMin: t.pressureMin ?? "",
  injectionUl: t.injectionUl ?? "",
  needleDepthMm: t.needleDepthMm ?? "",
  washAfterInjectionVial: t.washAfterInjectionVial?.toString() ?? "",
  washAfterInjectionTimeSec: t.washAfterInjectionTimeSec ?? "",
  syringeRefillSpeed: t.syringeRefillSpeed ?? "",
  calibrationDelaySec: t.calibrationDelaySec ?? "",
  valvePositionPlan: t.valvePositionPlan,
  detectorSingleChannel: t.detectorSingleChannel ?? JI.ALL,
  pressureReachSec: t.pressureReachSec ?? "",
  isAdvancedMode: t.isAdvancedMode ?? !1
}), IMe = (t, e) => {
  const n = {
    ...t
  };
  for (const [r, i] of zb(e))
    i != null && (typeof i == "number" ? n[r] = i.toString() : n[r] = i);
  return n;
}, kMe = (t, e) => {
  const {
    isValvePositionPlanSupported: n
  } = fw(e), r = aQ(e) ? Bb.ALLTESTA : e.deviceType, i = r === Bb.ALLTESTA ? "alltesta" : r === Bb.CROMITE ? "cromite" : null, a = i != null ? t[i] : {}, s = {
    ...t.common,
    ...a
  };
  return {
    name: "New Method",
    runTimeMin: s.runTimeMin?.toString() ?? "",
    shakingDurationSec: s.shakingDurationSec?.toString() ?? "",
    gradient: s.gradient ?? XK(),
    comment: s.comment ?? "",
    flowRateMlPerMin: s.flowRateMlPerMin?.toString() ?? "",
    refillFlowRateMlPerMin: s.refillFlowRateMlPerMin?.toString() ?? "",
    solventA: s.solvents?.a.name ?? "",
    solventB: s.solvents?.b.name ?? "",
    pressureMin: s.pressureMin?.toString() ?? "",
    injectionUl: s.injectionUl?.toString() ?? "",
    needleDepthMm: s.needleDepthMm?.toString() ?? "",
    washAfterInjectionVial: s.washAfterInjectionVial?.toString() ?? (s.washAfterInjection === !0 ? "0" : ""),
    washAfterInjectionTimeSec: s.washAfterInjectionTimeSec?.toString() ?? "",
    syringeRefillSpeed: s.syringeRefillSpeed?.toString() ?? "",
    calibrationDelaySec: s.calibrationDelaySec?.toString() ?? "",
    valvePositionPlan: n ? Bxe() : null,
    detectorSingleChannel: s.detectorSingleChannel ?? JI.ALL,
    pressureReachSec: s.pressureReachSec?.toString() ?? "",
    isAdvancedMode: !1
  };
}, jMe = (t, e) => {
  if (t == null)
    return null;
  if (t.length === 0)
    return "Valve position plan requires at least one instruction";
  const n = new Kc(KE), r = new Kc(e), i = t.map((c) => new Kc(c.time));
  if (!i[0]?.equals(0))
    return "First valve position plan time should be 0";
  if (i.some((c) => c.lessThan(0)))
    return "Time should not be negative";
  if (i.some((c) => !c.mod(n).equals(0)))
    return "Time should use 0.1 minute step";
  if (new Set(i.map((c) => c.toString())).size !== i.length)
    return "Time values should be unique";
  const s = [...i].sort((c, d) => c.comparedTo(d));
  for (let c = 1; c < s.length; c += 1) {
    const d = s[c - 1], f = s[c];
    if (!(d == null || f == null) && f.minus(d).lessThan(n))
      return "Time values should be at least 0.1 minutes apart";
  }
  return i.some((c) => c.greaterThan(r)) ? "Time should be less than or equal to run time" : null;
}, PMe = "MethodDefaultValues", LMe = (t) => {
  const e = ve.c(9);
  let n;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (n = {
    queryKey: [PMe],
    queryFn: BMe,
    staleTime: ole
  }, e[0] = n) : n = e[0];
  const {
    data: r,
    isLoading: i,
    error: a,
    refetch: s
  } = kh(n);
  let c;
  e[1] !== t || e[2] !== r ? (c = r != null ? kMe(r, t) : null, e[1] = t, e[2] = r, e[3] = c) : c = e[3];
  const f = c ?? null;
  let g;
  return e[4] !== a || e[5] !== i || e[6] !== s || e[7] !== f ? (g = {
    data: f,
    isLoading: i,
    error: a,
    refetch: s
  }, e[4] = a, e[5] = i, e[6] = s, e[7] = f, e[8] = g) : g = e[8], g;
};
async function BMe() {
  const t = await Vg.getMethodDefaultValues();
  return qt(OMe, t);
}
const zMe = (t) => (e) => {
  e.stopPropagation(), t(e);
}, {
  serverErrorForFormField: ro
} = bi, QK = Xe({
  error: Je().optional(),
  name: ro,
  runTimeMin: ro,
  shakingDurationSec: ro,
  gradient: ro,
  comment: ro,
  flowRateMlPerMin: ro,
  refillFlowRateMlPerMin: ro,
  solventA: ro,
  solventB: ro,
  pressureMin: ro,
  injectionUl: ro,
  needleDepthMm: ro,
  washAfterInjectionVial: ro,
  washAfterInjectionTimeSec: ro,
  syringeRefillSpeed: ro,
  calibrationDelaySec: ro,
  valvePositionPlan: ro,
  detectorSingleChannel: ro,
  message: Xr(Je()).optional()
}).partial(), FMe = QK;
var ZK = vQ, VMe = "Expected a function";
function ak(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(VMe);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], a = n.cache;
    if (a.has(i))
      return a.get(i);
    var s = t.apply(this, r);
    return n.cache = a.set(i, s) || a, s;
  };
  return n.cache = new (ak.Cache || ZK)(), n;
}
ak.Cache = ZK;
var UMe = ak;
const $Me = /* @__PURE__ */ J0(UMe), I4 = 6e4, KK = 1e3, HMe = 5e3;
class Bu extends Error {
}
const JK = () => HMe, gD = /* @__PURE__ */ new Map(), GV = (t) => {
  if (t === "" || t == null)
    return null;
  if (typeof t == "number")
    return Number.isFinite(t) ? t : null;
  const e = Number(t);
  return Number.isFinite(e) ? e : null;
}, qMe = (t) => !!(t?.id && typeof t.time == "number" && Number.isFinite(t.time) && Array.isArray(t.fractions) && t.fractions.length > 0), GMe = (t) => {
  if (!Array.isArray(t))
    return null;
  const e = t.filter(qMe);
  return e.length === 0 ? [] : e.map((n) => ({
    id: n.id,
    time: n.time,
    minutes: n.time,
    fractions: [...n.fractions]
  }));
}, YMe = (t) => ({
  flow_rate_ml_per_min: GV(t.flowRateMlPerMin),
  run_time_min: GV(t.runTimeMin),
  gradient: GMe(t.gradient)
}), XMe = (t) => {
  const {
    pumpCount: e,
    hasGradient: n,
    hasAutosampler: r
  } = fw(t);
  return {
    pumpCount: e,
    hasGradient: n,
    hasAutosampler: r
  };
}, WMe = (t) => {
  const e = Math.max(1, t);
  return {
    pumps: Array(e).fill(0),
    estimatedAmount: 0,
    availableAmount: JK(),
    isExceeded: !1
  };
}, QMe = (t) => {
  if (!Array.isArray(t) || t.length === 0)
    return 1;
  const e = t[0]?.fractions ?? [];
  return e.length > 0 ? e.length : 1;
}, ZMe = (t, {
  hasGradient: e
}) => {
  if (t == null)
    throw new Bu("Method is required");
  const {
    flow_rate_ml_per_min: n,
    run_time_min: r,
    gradient: i
  } = t, a = Array.isArray(i) ? i : [];
  if (n == null || typeof n != "number" || !Number.isFinite(n) || n <= 0)
    throw new Bu("Invalid flow rate");
  if (r == null || typeof r != "number" || !Number.isFinite(r) || r <= 0)
    throw new Bu("Invalid run time");
  if (e && a.length === 0)
    throw new Bu("Gradient steps must not be empty for gradient methods");
  const s = a.map((c, d) => {
    if (!c)
      throw new Bu(`Gradient step ${d} is null or undefined`);
    const f = c.time ?? c.minutes;
    if (f == null)
      throw new Bu(`Gradient step ${d} has invalid time`);
    if (!Array.isArray(c.fractions))
      throw new Bu(`Gradient step ${d} has invalid fractions`);
    const g = c.fractions.map((m, b) => {
      if (m == null || !Number.isFinite(m))
        throw new Bu(`Gradient step ${d}, fraction ${b} is invalid`);
      return m;
    });
    return {
      id: c.id ?? "",
      time: f,
      minutes: f,
      fractions: g
    };
  });
  return {
    flow_rate_ml_per_min: n,
    run_time_min: r,
    gradient: s
  };
}, KMe = (t, e) => {
  const n = JSON.stringify({
    gradientSteps: t,
    pumpIndex: e
  });
  if (gD.has(n)) {
    const i = gD.get(n);
    if (i)
      return i;
  }
  if (!Array.isArray(t) || t.length === 0)
    return [];
  const r = t.flatMap((i) => {
    const a = i.time ?? i.minutes, s = i.fractions[e];
    return a == null || s == null ? [] : [{
      timeMs: Math.round(a * I4),
      fraction: s
    }];
  }).sort((i, a) => i.timeMs - a.timeMs);
  return gD.set(n, r), r;
}, qC = (t, e, n = 1) => t * e * n * KK, JMe = (t, e, n, r, i) => (n - e) * t * ((i + r) / 2) * KK, eIe = ({
  flowRate: t,
  runTimeMin: e,
  gradient: n
}) => {
  const i = (() => {
    if (!n.length)
      return qC(t, e);
    const [s, ...c] = n;
    if (s == null)
      return qC(t, e);
    if (c.length === 0) {
      if (s.timeMs !== 0)
        throw new Bu("Gradient table must start at 0 ms");
      return qC(t, e, s.fraction);
    }
    if (s.timeMs !== 0)
      throw new Bu("Gradient table must start at 0 ms");
    const d = {
      total: 0,
      prev: s
    }, {
      total: f,
      prev: g
    } = c.reduce((w, _) => {
      if (_.timeMs === w.prev.timeMs)
        return {
          ...w,
          prev: _
        };
      const A = w.prev.timeMs / I4, T = _.timeMs / I4, O = JMe(t, A, T, w.prev.fraction, _.fraction);
      return {
        total: w.total + O,
        prev: _
      };
    }, d), m = g.timeMs / I4;
    return e > m ? f + qC(t, e - m, g.fraction) : f;
  })(), a = Math.ceil(i);
  return Number.isFinite(a) && a >= 0 ? a : 0;
}, tIe = ({
  method: t,
  pumpCount: e,
  hasGradient: n
}) => JSON.stringify({
  flow_rate_ml_per_min: t?.flow_rate_ml_per_min,
  run_time_min: t?.run_time_min,
  gradient: t?.gradient,
  pumpCount: e,
  hasGradient: n
}), nIe = ({
  method: t,
  pumpCount: e,
  hasGradient: n
}) => {
  try {
    const r = ZMe(t, {
      hasGradient: n
    }), i = r.flow_rate_ml_per_min, a = r.run_time_min, s = Math.max(1, Math.min(e, QMe(r.gradient))), c = r.gradient, d = Array.from({
      length: s
    }, (b, w) => {
      const _ = n ? KMe(c, w) : [];
      return eIe({
        flowRate: i,
        runTimeMin: a,
        gradient: _
      });
    }), f = JK(), g = d.reduce((b, w) => b + w, 0), m = d.some((b) => b > f);
    return {
      pumps: d,
      estimatedAmount: g,
      availableAmount: f,
      isExceeded: m
    };
  } catch (r) {
    if (r instanceof Bu)
      return WMe(e);
    throw r;
  }
}, rIe = $Me((t) => nIe(t), tIe), l_ = (t) => Number.isFinite(t) ? t >= 1e3 ? (t / 1e3).toFixed(2).replace(/\.00$/, "") + " mL" : `${Math.round(t)} µL` : "0", YV = {
  pumps: [0],
  estimatedAmount: 0,
  availableAmount: 0,
  isExceeded: !1
}, iIe = (t, e) => {
  const n = ve.c(12);
  let r;
  e: {
    if (e == null) {
      let f;
      n[0] === Symbol.for("react.memo_cache_sentinel") ? (f = {
        solventUsage: YV,
        hasGradient: !1,
        pumpCount: 1,
        availableLabel: l_(YV.availableAmount)
      }, n[0] = f) : f = n[0], r = f;
      break e;
    }
    let i, a, s, c;
    if (n[1] !== e || n[2] !== t) {
      const f = XMe(e), g = YMe(t), m = rIe({
        method: g,
        pumpCount: f.pumpCount,
        hasGradient: f.hasGradient
      });
      i = m, a = f.hasGradient, s = f.pumpCount, c = l_(m.availableAmount), n[1] = e, n[2] = t, n[3] = i, n[4] = a, n[5] = s, n[6] = c;
    } else
      i = n[3], a = n[4], s = n[5], c = n[6];
    let d;
    n[7] !== i || n[8] !== a || n[9] !== s || n[10] !== c ? (d = {
      solventUsage: i,
      hasGradient: a,
      pumpCount: s,
      availableLabel: c
    }, n[7] = i, n[8] = a, n[9] = s, n[10] = c, n[11] = d) : d = n[11], r = d;
  }
  return r;
}, aIe = Re.div`
  twd-text-sm
  twd-w-full
  twd-rounded-lg
  twd-border
  twd-border-error
  twd-bg-error-light2
  twd-p-4
  twd-text-secondary-contrast
  twd-shadow-sm
`, oIe = Re.header`
  twd-flex
  twd-items-center
  twd-gap-2
  twd-font-semibold
  twd-text-error
`, sIe = Re(MY)`
  twd-text-error
`, lIe = Re.p`
  twd-text-sm
  twd-mt-2
  twd-text-secondary-contrast
`, cIe = Re.div`
  twd-text-xs
  twd-mt-3
  twd-flex
  twd-flex-wrap
  twd-gap-4
  twd-text-secondary-contrast
`, uIe = Re.div``, dIe = Re.footer`
  twd-text-xs
  twd-mt-4
  twd-flex
  twd-items-center
  twd-gap-2
  twd-border-t
  twd-border-error/20
  twd-pt-3
  twd-text-error-dark
`, fIe = Re(DY)`
  twd-flex-shrink-0
  twd-text-error-dark
`, eJ = I.forwardRef((t, e) => {
  const n = ve.c(26), {
    solventUsage: r,
    hasGradient: i,
    availableLabel: a
  } = t;
  if (!r?.isExceeded)
    return null;
  let s, c, d;
  if (n[0] !== r.availableAmount || n[1] !== r.pumps) {
    let N;
    n[5] !== r.availableAmount ? (N = (M, P) => M > r.availableAmount ? P + 1 : null, n[5] = r.availableAmount, n[6] = N) : N = n[6], s = r.pumps.map(N).filter(hIe), c = s.length === 1, d = s.map(pIe).join(", "), n[0] = r.availableAmount, n[1] = r.pumps, n[2] = s, n[3] = c, n[4] = d;
  } else
    s = n[2], c = n[3], d = n[4];
  const f = d, g = c ? s[0] : null, m = g == null ? 0 : r.pumps[g - 1] ?? 0, b = i ? "Adjust the gradient or flow settings so each pump stays within the allowed volume." : "Edit the method parameters to meet this limit.";
  let w;
  n[7] === Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ C.jsxs(oIe, { children: [
    /* @__PURE__ */ C.jsx(sIe, { "aria-hidden": "true" }),
    /* @__PURE__ */ C.jsx("span", { children: "Estimated solvent volume exceeded" })
  ] }), n[7] = w) : w = n[7];
  let _;
  n[8] !== a || n[9] !== m || n[10] !== f || n[11] !== i || n[12] !== c || n[13] !== r.estimatedAmount ? (_ = /* @__PURE__ */ C.jsx(lIe, { children: i ? c ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    f,
    " requires ",
    /* @__PURE__ */ C.jsx("strong", { children: l_(m) }),
    ", which is above the",
    " ",
    /* @__PURE__ */ C.jsx("strong", { children: a }),
    " limit per pump."
  ] }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    f,
    " require more than the ",
    /* @__PURE__ */ C.jsx("strong", { children: a }),
    " limit allowed for each pump."
  ] }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    "This method requires ",
    /* @__PURE__ */ C.jsx("strong", { children: l_(r.estimatedAmount) }),
    ", which is above the",
    " ",
    /* @__PURE__ */ C.jsx("strong", { children: a }),
    " limit."
  ] }) }), n[8] = a, n[9] = m, n[10] = f, n[11] = i, n[12] = c, n[13] = r.estimatedAmount, n[14] = _) : _ = n[14];
  let A;
  n[15] !== i || n[16] !== r.pumps ? (A = i && /* @__PURE__ */ C.jsx(cIe, { children: r.pumps.map(mIe) }), n[15] = i, n[16] = r.pumps, n[17] = A) : A = n[17];
  let T;
  n[18] === Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ C.jsx(fIe, { "aria-hidden": "true" }), n[18] = T) : T = n[18];
  let O;
  n[19] !== b ? (O = /* @__PURE__ */ C.jsxs(dIe, { children: [
    T,
    /* @__PURE__ */ C.jsx("span", { children: b })
  ] }), n[19] = b, n[20] = O) : O = n[20];
  let R;
  return n[21] !== e || n[22] !== _ || n[23] !== A || n[24] !== O ? (R = /* @__PURE__ */ C.jsxs(aIe, { ref: e, role: "alert", "aria-live": "polite", children: [
    w,
    _,
    A,
    O
  ] }), n[21] = e, n[22] = _, n[23] = A, n[24] = O, n[25] = R) : R = n[25], R;
});
eJ.displayName = "SolventUsageError";
function hIe(t) {
  return t != null;
}
function pIe(t) {
  return `Pump ${t}`;
}
function mIe(t, e) {
  return /* @__PURE__ */ C.jsxs(uIe, { children: [
    "Pump ",
    e + 1,
    ": ",
    /* @__PURE__ */ C.jsx("strong", { children: l_(t) })
  ] }, `pump-${e}`);
}
const gIe = lf.subclass("MethodImportDefaultsNotLoadedError"), tJ = lf.subclass("MethodImportDefaultsIncompleteError"), vIe = {
  hasGradient: ["gradient", "solventB"],
  hasDetector: ["detectorSingleChannel", "calibrationDelaySec"],
  isValvePositionPlanSupported: ["valvePositionPlan"],
  hasAutosampler: ["needleDepthMm", "washAfterInjectionVial", "washAfterInjectionTimeSec", "syringeRefillSpeed", "shakingDurationSec"]
}, yIe = (t) => {
  const e = /* @__PURE__ */ new Set();
  return zb(t).forEach(([n, r]) => {
    r || vIe[n].forEach((i) => e.add(i));
  }), e;
}, bIe = (t, e) => {
  zb(e).forEach(([n]) => {
    if (t[n] === void 0)
      throw new tJ("Default method values are incomplete", {
        props: {
          field: n
        }
      });
  });
}, wIe = (t, e, n) => {
  t[e] = n;
}, xIe = (t, e, n) => {
  const r = {
    ...t
  };
  return yIe(n).forEach((a) => {
    const s = e[a];
    if (s === void 0)
      throw new tJ("Default method values are incomplete", {
        props: {
          field: a
        }
      });
    wIe(r, a, s);
  }), r;
}, SIe = ({
  importedMethod: t,
  defaults: e,
  capabilities: n
}) => {
  const r = WK(t);
  return bIe(e, r), xIe(r, e, n);
}, EIe = Re.form`
  twd-relative
`, _Ie = Re.div`
  twd-my-4
  twd-ml-auto
  twd-flex
  twd-justify-end
  twd-space-x-2
`, nJ = ({
  onCreate: t,
  onEdit: e,
  method: n,
  isArchived: r,
  isInFavorites: i,
  className: a,
  hasModalStyles: s,
  presetSelectorPortal: c,
  deviceId: d,
  configuration: f,
  advancedModeActionsPortal: g,
  isReadOnly: m = !1,
  methodOverride: b,
  onDirtyStateChange: w
}) => {
  const _ = n != null, [A, T] = I.useState(n ?? null), [O, R] = I.useState(!1);
  I.useEffect(() => {
    if (!O) {
      T(n ?? null);
      return;
    }
    n?.id != null && n.id !== A?.id && (T(n), R(!1));
  }, [n, A?.id, O]);
  const {
    mutateAsync: N
  } = EMe(n?.id), {
    mutateAsync: M,
    isPending: P
  } = AMe(), z = es(), {
    isLoading: F,
    data: $
  } = LMe(f), {
    hasGradient: G,
    hasDetector: H,
    isValvePositionPlanSupported: Z,
    hasAutosampler: V
  } = I.useMemo(() => fw(f), [f]), Y = I.useMemo(() => b == null ? [] : Object.entries(b).filter(([, ge]) => ge != null).map(([ge]) => ge), [b]), ee = I.useMemo(() => {
    const ge = A != null ? WK(A) : $ ?? void 0;
    return ge != null && b != null ? IMe(ge, b) : ge;
  }, [A, $, b]), K = I.useMemo(() => td(DMe.superRefine((ge, Te) => {
    const He = ge.detectorSingleChannel;
    He !== "" && d7(f)[He] == null && Te.addIssue({
      code: "custom",
      path: ["detectorSingleChannel"],
      message: "Selected detector channel is unavailable."
    });
  })), [f]), {
    handleSubmit: U,
    control: q,
    formState: W,
    setError: ie,
    reset: J,
    getValues: B,
    setValue: te,
    clearErrors: ae,
    trigger: le
  } = ed({
    defaultValues: ee,
    resolver: K,
    disabled: m
  }), de = Wb({
    control: q,
    name: "isAdvancedMode"
  }) ?? !1;
  Jbe();
  const _e = Wb({
    control: q
  }), ue = I.useMemo(() => ({
    flowRateMlPerMin: _e?.flowRateMlPerMin ?? null,
    runTimeMin: _e?.runTimeMin ?? null,
    gradient: _e?.gradient ?? null
  }), [_e]), Se = I.useRef(null), {
    solventUsage: Ne,
    hasGradient: Me,
    availableLabel: Ce
  } = iIe(ue, f), Ue = ZW(de);
  I.useEffect(() => {
    F || $ == null || Ue == null || Ue === de || (ae(), de || NMe().forEach((Te) => te(Te, $[Te], {
      shouldDirty: !0,
      shouldValidate: !0
    })));
  }, [de, $, ae, te, F, Ue]), I.useEffect(() => {
    ee == null || O || (J(ee), R(!0));
  }, [ee, O, J]);
  const rt = I.useCallback(() => {
    const ge = B();
    if (ge.isAdvancedMode ?? !1)
      return ge;
    {
      const He = MMe(ge);
      if ($ == null)
        throw new Error("Default values from server are not loaded");
      return {
        ...$,
        ...He
      };
    }
  }, [$, B]), it = I.useCallback(() => Ne.isExceeded ? (Se.current?.scrollIntoView({
    behavior: "smooth",
    block: "center"
  }), !1) : !0, [Ne.isExceeded]), Ft = I.useCallback(() => U(async () => {
    if (it())
      try {
        const ge = rt(), Te = await M(Q6(ge, f, d));
        t?.(Te);
      } catch (ge) {
        z(ge, (Te, He) => {
          const $e = qt(QK, Te.data.payload), {
            error: Ze,
            message: ct,
            ...Mt
          } = $e;
          if (Ze)
            return void He(ks(Ze));
          ct && He(String(ct)), zb(Mt).forEach(([Rt, sn]) => {
            sn && ie(Rt, {
              message: sn
            }, {
              shouldFocus: !0
            });
          });
        });
      }
  })(), [f, M, d, z, rt, U, t, ie, it]), wt = I.useCallback((ge) => {
    if ($ == null)
      throw new gIe("Default method values are not loaded");
    const Te = SIe({
      importedMethod: ge,
      defaults: $,
      capabilities: {
        hasGradient: G,
        hasDetector: H,
        isValvePositionPlanSupported: Z,
        hasAutosampler: V
      }
    });
    zb(Te).forEach(([He, $e]) => {
      te(He, $e, {
        shouldDirty: !0,
        shouldTouch: !0,
        shouldValidate: !0
      });
    });
  }, [$, V, H, G, Z, te]), Ot = W.isDirty;
  I.useEffect(() => {
    w?.(Ot);
  }, [Ot, w]);
  const On = I.useCallback(async () => {
    if (it())
      try {
        const ge = rt();
        if (_) {
          const Te = await N(Q6(ge, f, d));
          e?.(Te);
        } else {
          const Te = await M(Q6(ge, f, d));
          t?.(Te);
        }
      } catch (ge) {
        z(ge, (Te, He) => {
          const $e = qt(FMe, Te.data.payload), {
            error: Ze,
            message: ct,
            ...Mt
          } = $e;
          if (Ze)
            return void He(ks(Ze));
          ct && He(String(ct)), zb(Mt).forEach(([Rt, sn]) => {
            sn && ie(Rt, {
              message: sn
            }, {
              shouldFocus: !0
            });
          });
        });
      }
  }, [it, rt, _, N, f, d, e, M, t, z, ie]), Ct = I.useMemo(() => Object.keys(W.dirtyFields).length === 1 ? W.dirtyFields.name ?? !1 : !1, [W]), se = !m && de && g != null ? Wc.createPortal(/* @__PURE__ */ C.jsx(wMe, { onTurnOff: () => te("isAdvancedMode", !1, {
    shouldDirty: !0,
    shouldValidate: !0
  }) }), g) : null;
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    se,
    !m && !F && c != null && /* @__PURE__ */ C.jsx(bMe, { portal: c, onMethodImport: wt }),
    /* @__PURE__ */ C.jsxs(EIe, { onSubmit: zMe(m ? () => {
    } : U(On)), className: a, children: [
      F && /* @__PURE__ */ C.jsx(kye, { message: _ ? "Loading" : "Loading default values" }),
      /* @__PURE__ */ C.jsx(y4, { $isInModal: s, children: de ? /* @__PURE__ */ C.jsx(fMe, { control: q, setValue: te, onSampleAmountChange: () => void le("injectionUl"), isArchived: r, isInFavorites: i, methodId: n?.id, configuration: f, overriddenFields: Y }) : /* @__PURE__ */ C.jsx(vMe, { control: q, onSampleAmountChange: () => void le("injectionUl"), isArchived: r, isInFavorites: i, methodId: n?.id, configuration: f, overriddenFields: Y, onShowAdvanced: () => te("isAdvancedMode", !0, {
        shouldDirty: !0,
        shouldValidate: !0
      }) }) }),
      Ne.isExceeded && /* @__PURE__ */ C.jsxs(y4, { $isInModal: s, children: [
        /* @__PURE__ */ C.jsx("br", {}),
        /* @__PURE__ */ C.jsx(eJ, { ref: Se, solventUsage: Ne, hasGradient: Me, availableLabel: Ce })
      ] }),
      m ? /* @__PURE__ */ C.jsx("div", { className: "twd-mb-4" }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
        s && /* @__PURE__ */ C.jsx(Hye, {}),
        /* @__PURE__ */ C.jsx(y4, { $isInModal: s, children: /* @__PURE__ */ C.jsxs(_Ie, { children: [
          /* @__PURE__ */ C.jsx(Vt, { isDisabled: !Ot, variant: "secondary", onClick: () => {
            J();
          }, children: "Revert" }),
          _ && /* @__PURE__ */ C.jsx(Vt, { variant: "accent", onClick: Ft, isLoading: P, children: "Save as new" }),
          _ ? /* @__PURE__ */ C.jsx(nu, { message: ks("method.only_method_is_changeable"), isDisabled: n?.isEditable, placement: "top-start", children: /* @__PURE__ */ C.jsx("div", { children: /* @__PURE__ */ C.jsx(Vt, { isDisabled: !n?.isEditable && !Ct || !Ot, variant: "primaryContained", isSubmit: !0, isLoading: W.isSubmitting, children: "Save" }) }) }) : /* @__PURE__ */ C.jsx(Vt, { variant: "accent", isSubmit: !0, isLoading: W.isSubmitting, children: "Save as new" })
        ] }) })
      ] })
    ] })
  ] });
}, XV = Re(y4)`
  twd-mb-2
`, AIe = Re.div`
  twd-flex
  twd-flex-col
  twd-pt-4
`, CIe = Re.div`
  twd-relative
  twd-flex
`, TIe = Re(nJ)`
  twd-w-full
  twd-min-w-0
  twd-max-w-full
`, OIe = Re(nJ)`
  twd-w-full
  twd-max-w-full
`, rJ = (t) => {
  const e = ve.c(36), {
    method: n,
    deviceId: r,
    deviceConfiguration: i,
    isReadOnly: a,
    methodOverride: s,
    isInModal: c,
    presetSelectorPortal: d,
    advancedModeActionsPortal: f,
    onCreate: g,
    onEdit: m,
    onDirtyStateChange: b,
    headerContent: w
  } = t, _ = a === void 0 ? !0 : a, A = c === void 0 ? !1 : c, T = d === void 0 ? null : d, O = f === void 0 ? null : f;
  let R;
  e[0] !== s ? (R = s != null && Object.values(s).some(RIe), e[0] = s, e[1] = R) : R = e[1];
  const N = R, M = a5(DIe), P = a5(NIe), z = n == null ? void 0 : P.isArchived, F = n == null ? void 0 : P.isInFavorites;
  let $;
  e[2] !== M || e[3] !== n ? ($ = () => {
    n?.id != null && M({
      isArchived: n.isArchived,
      isInFavorites: n.isFavorite
    });
  }, e[2] = M, e[3] = n, e[4] = $) : $ = e[4];
  const G = n?.id, H = n?.isArchived, Z = n?.isFavorite;
  let V;
  e[5] !== M || e[6] !== G || e[7] !== H || e[8] !== Z ? (V = [M, G, H, Z], e[5] = M, e[6] = G, e[7] = H, e[8] = Z, e[9] = V) : V = e[9], I.useLayoutEffect($, V);
  const Y = A ? TIe : OIe;
  let ee;
  e[10] !== z || e[11] !== A ? (ee = z === !0 && /* @__PURE__ */ C.jsx(XV, { $isInModal: A, children: /* @__PURE__ */ C.jsx(ZE, { variant: "error", children: "This method is archived. It can not be selected for the injections" }) }), e[10] = z, e[11] = A, e[12] = ee) : ee = e[12];
  let K;
  e[13] !== N || e[14] !== A ? (K = N && /* @__PURE__ */ C.jsx(XV, { $isInModal: A, children: /* @__PURE__ */ C.jsx(ZE, { variant: "warning", children: "This method was overridden for this injection. Modified fields are highlighted." }) }), e[13] = N, e[14] = A, e[15] = K) : K = e[15];
  let U;
  e[16] !== Y || e[17] !== O || e[18] !== i || e[19] !== r || e[20] !== z || e[21] !== F || e[22] !== A || e[23] !== _ || e[24] !== n || e[25] !== s || e[26] !== g || e[27] !== b || e[28] !== m || e[29] !== T ? (U = /* @__PURE__ */ C.jsx(CIe, { children: /* @__PURE__ */ C.jsx(Y, { hasModalStyles: A, method: n, methodOverride: s, deviceId: r, configuration: i, isArchived: z, isInFavorites: F, presetSelectorPortal: T, advancedModeActionsPortal: O, onCreate: g, onEdit: m, isReadOnly: _, onDirtyStateChange: b }) }), e[16] = Y, e[17] = O, e[18] = i, e[19] = r, e[20] = z, e[21] = F, e[22] = A, e[23] = _, e[24] = n, e[25] = s, e[26] = g, e[27] = b, e[28] = m, e[29] = T, e[30] = U) : U = e[30];
  let q;
  return e[31] !== w || e[32] !== ee || e[33] !== K || e[34] !== U ? (q = /* @__PURE__ */ C.jsxs(AIe, { children: [
    w,
    ee,
    K,
    U
  ] }), e[31] = w, e[32] = ee, e[33] = K, e[34] = U, e[35] = q) : q = e[35], q;
};
function RIe(t) {
  return t != null;
}
function DIe(t) {
  return t.initMethodStatus;
}
function NIe(t) {
  return t.status;
}
const MIe = "You have unsaved changes. Are you sure you want to close?", IIe = (t) => {
  const e = ve.c(38), {
    isOpen: n,
    onClose: r,
    method: i,
    deviceId: a,
    deviceConfiguration: s,
    onCreate: c,
    onEdit: d,
    isReadOnly: f,
    methodOverride: g
  } = t, m = f === void 0 ? !1 : f;
  let b;
  e[0] !== n || e[1] !== i ? (b = () => n ? i ?? null : null, e[0] = n, e[1] = i, e[2] = b) : b = e[2];
  const [w, _] = I.useState(b);
  let A;
  e[3] !== s || e[4] !== n ? (A = () => n ? cF(s) : null, e[3] = s, e[4] = n, e[5] = A) : A = e[5];
  const [T, O] = I.useState(A), R = ZW(n), [N, M] = I.useState(null), [P, z] = I.useState(null), F = I.useRef(!1);
  let $, G;
  e[6] !== s || e[7] !== n || e[8] !== i || e[9] !== R ? ($ = () => {
    if (n && R === !1) {
      F.current = !1, _(i ?? null), O(cF(s));
      return;
    }
    !n && R === !0 && (F.current = !1, _(null), O(null));
  }, G = [s, n, i, R], e[6] = s, e[7] = n, e[8] = i, e[9] = R, e[10] = $, e[11] = G) : ($ = e[10], G = e[11]), I.useLayoutEffect($, G);
  let H;
  e[12] === Symbol.for("react.memo_cache_sentinel") ? (H = (ie) => {
    F.current = ie;
  }, e[12] = H) : H = e[12];
  const Z = H;
  let V;
  e[13] !== r ? (V = () => {
    F.current && !window.confirm(MIe) || r();
  }, e[13] = r, e[14] = V) : V = e[14];
  const Y = V;
  let ee;
  e[15] !== w ? (ee = w != null && /* @__PURE__ */ C.jsx(PI, { id: w.id, className: "twd-font-normal" }), e[15] = w, e[16] = ee) : ee = e[16];
  let K;
  e[17] !== ee ? (K = /* @__PURE__ */ C.jsxs("div", { children: [
    "Method ",
    ee
  ] }), e[17] = ee, e[18] = K) : K = e[18];
  let U;
  e[19] !== m ? (U = m ? /* @__PURE__ */ C.jsx("div", { className: "twd-text-sm twd-text-warning", children: "You cannot edit this method because it's already used" }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsx("div", { ref: z }),
    /* @__PURE__ */ C.jsx("div", { ref: M })
  ] }), e[19] = m, e[20] = U) : U = e[20];
  let q;
  e[21] !== P || e[22] !== a || e[23] !== m || e[24] !== T || e[25] !== w || e[26] !== g || e[27] !== r || e[28] !== c || e[29] !== d || e[30] !== N ? (q = T != null ? /* @__PURE__ */ C.jsx(rJ, { method: w, deviceId: a, methodOverride: g, deviceConfiguration: T, isInModal: !0, presetSelectorPortal: N, advancedModeActionsPortal: P, isReadOnly: m, onCreate: (ie) => {
    c?.(ie), r();
  }, onEdit: (ie) => {
    d?.(ie), r();
  }, onDirtyStateChange: Z }) : /* @__PURE__ */ C.jsx(C.Fragment, {}), e[21] = P, e[22] = a, e[23] = m, e[24] = T, e[25] = w, e[26] = g, e[27] = r, e[28] = c, e[29] = d, e[30] = N, e[31] = q) : q = e[31];
  let W;
  return e[32] !== Y || e[33] !== n || e[34] !== U || e[35] !== q || e[36] !== K ? (W = /* @__PURE__ */ C.jsx(Ph, { isOpen: n, onClose: Y, hasPadding: !1, title: "Method", headerLeft: K, headerRight: U, className: "twd-w-full", children: q }), e[32] = Y, e[33] = n, e[34] = U, e[35] = q, e[36] = K, e[37] = W) : W = e[37], W;
}, kIe = (t) => {
  const e = ve.c(16), {
    method: n,
    deviceConfiguration: r,
    isReadOnly: i,
    methodOverride: a
  } = t, s = i === void 0 ? !0 : i;
  let c;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ C.jsx("h4", { className: "twd-m-0", children: "Method" }), e[0] = c) : c = e[0];
  let d;
  e[1] !== n ? (d = n != null && /* @__PURE__ */ C.jsx(PI, { id: n.id, className: "twd-font-normal" }), e[1] = n, e[2] = d) : d = e[2];
  let f;
  e[3] !== d ? (f = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-items-center twd-gap-2", children: [
    c,
    d
  ] }), e[3] = d, e[4] = f) : f = e[4];
  let g;
  e[5] !== s ? (g = s && /* @__PURE__ */ C.jsx("div", { className: "twd-text-sm twd-text-warning", children: "You cannot edit this method because it's already used" }), e[5] = s, e[6] = g) : g = e[6];
  let m;
  e[7] !== f || e[8] !== g ? (m = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-items-center twd-justify-between twd-mb-4", children: [
    f,
    g
  ] }), e[7] = f, e[8] = g, e[9] = m) : m = e[9];
  let b;
  return e[10] !== r || e[11] !== s || e[12] !== n || e[13] !== a || e[14] !== m ? (b = /* @__PURE__ */ C.jsx(rJ, { method: n, methodOverride: a, deviceConfiguration: r, isInModal: !1, isReadOnly: s, headerContent: m }), e[10] = r, e[11] = s, e[12] = n, e[13] = a, e[14] = m, e[15] = b) : b = e[15], b;
}, LGe = (t) => {
  const e = ve.c(20), {
    isOpen: n,
    onClose: r,
    onCreate: i,
    onEdit: a,
    method: s,
    methodOverride: c,
    deviceId: d,
    deviceConfiguration: f,
    isReadOnly: g
  } = t;
  let m;
  e[0] !== s ? (m = s != null ? qt(N_, {
    ...s,
    is_editable: s.editable,
    is_favorite: s.favorite,
    is_archived: s.archived
  }, Y0) : null, e[0] = s, e[1] = m) : m = e[1];
  const b = m;
  let w;
  e[2] !== c ? (w = c != null && typeof c == "object" && !Array.isArray(c) ? qt(dQ, c) : null, e[2] = c, e[3] = w) : w = e[3];
  const _ = w;
  let A;
  e[4] !== f ? (A = qt(J5, f, Y0), e[4] = f, e[5] = A) : A = e[5];
  const T = A;
  let O;
  e[6] !== i ? (O = (F) => {
    i(YT(F, {
      exclude: ["D", "D2", "D3", "D4"]
    }));
  }, e[6] = i, e[7] = O) : O = e[7];
  const R = O;
  let N;
  e[8] !== a ? (N = (F) => {
    a(YT(F, {
      exclude: ["D", "D2", "D3", "D4"]
    }));
  }, e[8] = a, e[9] = N) : N = e[9];
  const M = N, P = !!g;
  let z;
  return e[10] !== R || e[11] !== M || e[12] !== d || e[13] !== n || e[14] !== r || e[15] !== T || e[16] !== b || e[17] !== _ || e[18] !== P ? (z = /* @__PURE__ */ C.jsx(IIe, { isOpen: n, onClose: r, onCreate: R, onEdit: M, method: b, methodOverride: _, deviceId: d, deviceConfiguration: T, isReadOnly: P }), e[10] = R, e[11] = M, e[12] = d, e[13] = n, e[14] = r, e[15] = T, e[16] = b, e[17] = _, e[18] = P, e[19] = z) : z = e[19], z;
}, BGe = (t) => {
  const e = ve.c(11), {
    method: n,
    methodOverride: r,
    deviceConfiguration: i,
    isReadOnly: a
  } = t, s = a === void 0 ? !0 : a;
  let c;
  e[0] !== n ? (c = n != null ? qt(N_, {
    ...n,
    is_editable: n.editable,
    is_favorite: n.favorite,
    is_archived: n.archived
  }, Y0) : null, e[0] = n, e[1] = c) : c = e[1];
  const d = c;
  let f;
  e[2] !== r ? (f = r != null && typeof r == "object" && !Array.isArray(r) ? qt(dQ, r) : null, e[2] = r, e[3] = f) : f = e[3];
  const g = f;
  let m;
  e[4] !== i ? (m = qt(J5, i, Y0), e[4] = i, e[5] = m) : m = e[5];
  const b = m, w = !!s;
  let _;
  return e[6] !== b || e[7] !== d || e[8] !== g || e[9] !== w ? (_ = /* @__PURE__ */ C.jsx(kIe, { method: d, methodOverride: g, deviceConfiguration: b, isReadOnly: w }), e[6] = b, e[7] = d, e[8] = g, e[9] = w, e[10] = _) : _ = e[10], _;
}, iJ = Xe({
  sequenceId: Ve()
}), jIe = Xe({
  sequenceCompounds: Xr(iJ)
}), aJ = Xe({
  id: Ve(),
  name: Je(),
  archived: Sr()
}), PIe = aJ.extend({
  compound: jIe.nullable()
}), LIe = Xe({
  calibrationId: Ve(),
  createdAt: Je(),
  calibration: PIe
});
var ok = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "subscription", name: { kind: "Name", value: "SequenceCalibrations" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "sequenceId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sequence_calibration" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "where" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "sequence_id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_eq" }, value: { kind: "Variable", name: { kind: "Name", value: "sequenceId" } } }] } }] } }, { kind: "Argument", name: { kind: "Name", value: "order_by" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "created_at" }, value: { kind: "EnumValue", value: "desc" } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "calibration_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "created_at" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "calibration" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "archived" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "compound" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sequence_compounds" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sequence_id" }, arguments: [], directives: [] }] } }] } }] } }] } }] } }], loc: { start: 0, end: 354 } };
ok.loc.source = { body: `subscription SequenceCalibrations($sequenceId: Int!) {
  sequence_calibration(
    where: { sequence_id: { _eq: $sequenceId } }
    order_by: { created_at: desc }
  ) {
    calibration_id
    created_at
    calibration {
      id
      name
      archived
      compound {
        sequence_compounds {
          sequence_id
        }
      }
    }
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function k4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    k4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    k4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    k4(r, e);
  });
}
var _N = {};
(function() {
  ok.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      k4(e, n), _N[e.name.value] = n;
    }
  });
})();
function WV(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function BIe(t, e) {
  var n = {
    kind: t.kind,
    definitions: [WV(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = _N[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = _N[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = WV(t, c);
    d && n.definitions.push(d);
  }), n;
}
const zIe = BIe(ok, "SequenceCalibrations"), FIe = Xe({
  sequenceCalibration: Xr(LIe)
}), VIe = (t) => {
  const e = ve.c(13), n = t ?? -1;
  let r;
  e[0] !== n ? (r = {
    sequenceId: n
  }, e[0] = n, e[1] = r) : r = e[1];
  const i = r, {
    data: a,
    isLoading: s,
    isFetching: c,
    error: d
  } = Z5("SequenceCalibrations", zIe, i);
  let f;
  if (e[2] !== a || e[3] !== t) {
    e: {
      if (t == null || a == null) {
        let _;
        e[5] === Symbol.for("react.memo_cache_sentinel") ? (_ = {
          calibrations: [],
          parseError: null
        }, e[5] = _) : _ = e[5], f = _;
        break e;
      }
      try {
        f = {
          calibrations: qt(FIe, a).sequenceCalibration,
          parseError: null
        };
      } catch (_) {
        const A = _;
        console.error("Failed to parse sequence calibrations", A);
        let T;
        e[6] === Symbol.for("react.memo_cache_sentinel") ? (T = [], e[6] = T) : T = e[6], f = {
          calibrations: T,
          parseError: new iw("Schema parse error", {
            cause: A,
            props: {
              source: "sequence calibrations"
            }
          })
        };
      }
    }
    e[2] = a, e[3] = t, e[4] = f;
  } else
    f = e[4];
  const {
    calibrations: g,
    parseError: m
  } = f;
  if (t == null) {
    let _;
    return e[7] === Symbol.for("react.memo_cache_sentinel") ? (_ = {
      data: [],
      isLoading: !1,
      isFetching: !1,
      error: null
    }, e[7] = _) : _ = e[7], _;
  }
  const b = d ?? m;
  let w;
  return e[8] !== g || e[9] !== c || e[10] !== s || e[11] !== b ? (w = {
    data: g,
    isLoading: s,
    isFetching: c,
    error: b
  }, e[8] = g, e[9] = c, e[10] = s, e[11] = b, e[12] = w) : w = e[12], w;
}, oJ = Xe({
  id: Ve(),
  name: Je(),
  sequenceCompounds: Xr(iJ)
}), sJ = Xe({
  id: Ve(),
  peakDetectionStart: Ve(),
  peakDetectionEnd: Ve(),
  createdAt: Je()
}), UIe = aJ.extend({
  compoundId: Ve(),
  compound: oJ.nullable(),
  calibrationCompound: sJ.nullable()
}), $Ie = Xe({
  calibration: UIe.nullable()
});
var sk = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "subscription", name: { kind: "Name", value: "CalibrationByPk" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "calId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "calibration" }, name: { kind: "Name", value: "calibration_by_pk" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "calId" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "archived" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "compound_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "compound" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "sequence_compounds" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sequence_id" }, arguments: [], directives: [] }] } }] } }, { kind: "Field", name: { kind: "Name", value: "calibration_compound" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "peak_detection_start" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "peak_detection_end" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "created_at" }, arguments: [], directives: [] }] } }] } }] } }], loc: { start: 0, end: 350 } };
sk.loc.source = { body: `subscription CalibrationByPk($calId: Int!) {
  calibration: calibration_by_pk(id: $calId) {
    id
    name
    archived
    compound_id
    compound {
      id
      name
      sequence_compounds {
        sequence_id
      }
    }
    calibration_compound {
      id
      peak_detection_start
      peak_detection_end
      created_at
    }
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function j4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    j4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    j4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    j4(r, e);
  });
}
var AN = {};
(function() {
  sk.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      j4(e, n), AN[e.name.value] = n;
    }
  });
})();
function QV(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function HIe(t, e) {
  var n = {
    kind: t.kind,
    definitions: [QV(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = AN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = AN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = QV(t, c);
    d && n.definitions.push(d);
  }), n;
}
const qIe = HIe(sk, "CalibrationByPk"), vO = (t) => {
  const e = I.useMemo(() => ({
    calId: t
  }), [t]), {
    data: n,
    isLoading: r,
    isFetching: i,
    error: a
  } = Z5("CalibrationByPk", qIe, e), {
    resolvedData: s,
    parseError: c
  } = I.useMemo(() => {
    if (n == null)
      return {
        resolvedData: {
          calibration: null,
          calibrationId: null,
          calibrationCompound: null
        },
        parseError: null
      };
    try {
      const f = qt($Ie, n).calibration;
      if (!f)
        return {
          resolvedData: {
            calibration: null,
            calibrationId: null,
            calibrationCompound: null
          },
          parseError: null
        };
      const g = {
        id: f.id,
        name: f.name,
        archived: f.archived,
        compound: f.compound ? {
          sequenceCompounds: f.compound.sequenceCompounds ?? []
        } : null
      }, m = f.calibrationCompound ? {
        ...f.calibrationCompound,
        compoundId: f.compoundId,
        compound: f.compound
      } : null;
      return {
        resolvedData: {
          calibration: g,
          calibrationId: f.id,
          calibrationCompound: m
        },
        parseError: null
      };
    } catch (d) {
      return console.error("Failed to parse calibration data", d), {
        resolvedData: {
          calibration: null,
          calibrationId: null,
          calibrationCompound: null
        },
        parseError: new iw("Schema parse error", {
          cause: d,
          props: {
            source: "calibration data"
          }
        })
      };
    }
  }, [n]);
  return {
    data: s,
    isLoading: r,
    isFetching: i,
    error: a ?? c
  };
}, GIe = Xe({
  id: Ve(),
  area: Ve().nullable(),
  apex: Ve().nullable()
}), YIe = Xe({
  injectionId: Ve()
}), XIe = Xe({
  id: Ve(),
  levelId: Ve(),
  measurementId: Ve(),
  compoundId: Ve(),
  peakId: Ve(),
  included: Sr(),
  excludeReason: Je().nullable(),
  createdAt: Je(),
  measurement: YIe,
  peak: GIe.nullable()
}).transform((t) => ({
  ...t,
  area: t.peak?.area ?? null,
  rt: t.peak?.apex ?? null,
  injectionId: t.measurement.injectionId
})), WIe = Xe({
  id: Ve(),
  archived: Sr(),
  injectionsAggregate: Xe({
    aggregate: Xe({
      count: Ve()
    }).nullable()
  }).nullable()
}), QIe = Xe({
  id: Ve(),
  levelOrder: Ve(),
  nominalConcentration: Ve(),
  unit: Je(),
  standardId: Ve().nullable(),
  sample: WIe.nullable(),
  points: Xr(XIe)
});
var lk = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "subscription", name: { kind: "Name", value: "CalibrationLevels" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "calId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "calibration_level" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "where" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "calibration_id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_eq" }, value: { kind: "Variable", name: { kind: "Name", value: "calId" } } }] } }] } }, { kind: "Argument", name: { kind: "Name", value: "order_by" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "level_order" }, value: { kind: "EnumValue", value: "asc" } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "level_order" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "nominal_concentration" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "unit" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "standard_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "sample" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "archived" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "injections_aggregate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "where" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "state" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_in" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "REA", block: !1 }, { kind: "StringValue", value: "FAI", block: !1 }] } }] } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "aggregate" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" }, arguments: [], directives: [] }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order_by" }, value: { kind: "ListValue", values: [{ kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "measurement" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "injection_id" }, value: { kind: "EnumValue", value: "asc" } }] } }] }, { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "EnumValue", value: "asc" } }] }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "level_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "measurement_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "compound_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "peak_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "included" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "exclude_reason" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "created_at" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "measurement" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "injection_id" }, arguments: [], directives: [] }] } }, { kind: "Field", name: { kind: "Name", value: "peak" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "area" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "apex" }, arguments: [], directives: [] }] } }] } }] } }] } }], loc: { start: 0, end: 715 } };
lk.loc.source = { body: `subscription CalibrationLevels($calId: Int!) {
  calibration_level(where: { calibration_id: { _eq: $calId } }, order_by: { level_order: asc }) {
    id
    level_order
    nominal_concentration
    unit
    standard_id
    sample {
      id
      archived
      injections_aggregate(where: { state: { _in: ["REA", "FAI"] } }) {
        aggregate {
          count
        }
      }
    }
    points(order_by: [{ measurement: { injection_id: asc } }, { id: asc }]) {
      id
      level_id
      measurement_id
      compound_id
      peak_id
      included
      exclude_reason
      created_at
      measurement {
        injection_id
      }
      peak {
        id
        area
        apex
      }
    }
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function P4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    P4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    P4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    P4(r, e);
  });
}
var CN = {};
(function() {
  lk.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      P4(e, n), CN[e.name.value] = n;
    }
  });
})();
function ZV(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function ZIe(t, e) {
  var n = {
    kind: t.kind,
    definitions: [ZV(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = CN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = CN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = ZV(t, c);
    d && n.definitions.push(d);
  }), n;
}
const KIe = ZIe(lk, "CalibrationLevels"), JIe = Xe({
  calibrationLevel: Xr(QIe)
}), lJ = (t) => {
  const e = ve.c(13), n = t ?? -1;
  let r;
  e[0] !== n ? (r = {
    calId: n
  }, e[0] = n, e[1] = r) : r = e[1];
  const i = r, {
    data: a,
    isLoading: s,
    isFetching: c,
    error: d
  } = Z5("CalibrationLevels", KIe, i);
  let f;
  if (e[2] !== t || e[3] !== a) {
    e: {
      if (t == null || a == null) {
        let _;
        e[5] === Symbol.for("react.memo_cache_sentinel") ? (_ = {
          levels: [],
          parseError: null
        }, e[5] = _) : _ = e[5], f = _;
        break e;
      }
      try {
        f = {
          levels: qt(JIe, a).calibrationLevel.map(e7e),
          parseError: null
        };
      } catch (_) {
        const A = _;
        console.error("Failed to parse calibration levels", A);
        let T;
        e[6] === Symbol.for("react.memo_cache_sentinel") ? (T = [], e[6] = T) : T = e[6], f = {
          levels: T,
          parseError: new iw("Schema parse error", {
            cause: A,
            props: {
              source: "calibration levels"
            }
          })
        };
      }
    }
    e[2] = t, e[3] = a, e[4] = f;
  } else
    f = e[4];
  const {
    levels: g,
    parseError: m
  } = f;
  if (t == null) {
    let _;
    return e[7] === Symbol.for("react.memo_cache_sentinel") ? (_ = {
      data: [],
      isLoading: !1,
      isFetching: !1,
      error: null
    }, e[7] = _) : _ = e[7], _;
  }
  const b = d ?? m;
  let w;
  return e[8] !== c || e[9] !== s || e[10] !== g || e[11] !== b ? (w = {
    data: g,
    isLoading: s,
    isFetching: c,
    error: b
  }, e[8] = c, e[9] = s, e[10] = g, e[11] = b, e[12] = w) : w = e[12], w;
};
function e7e(t) {
  return {
    ...t,
    sample: t.sample ? {
      ...t.sample,
      completedInjectionCount: t.sample.injectionsAggregate?.aggregate?.count ?? 0
    } : null
  };
}
const t7e = yM([Je(), gg(q$())]), n7e = Xe({
  id: Ve(),
  compoundId: Ve(),
  model: Je(),
  weighting: Je(),
  forceZero: Sr(),
  coefficientsJson: t7e,
  r2: Ve().nullable(),
  bOverM: Ve().nullable(),
  createdAt: Je()
});
var ck = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "subscription", name: { kind: "Name", value: "CalibrationCurvesLatest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "calId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "calibration_curve" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "where" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "calibration_id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_eq" }, value: { kind: "Variable", name: { kind: "Name", value: "calId" } } }] } }] } }, { kind: "Argument", name: { kind: "Name", value: "order_by" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "created_at" }, value: { kind: "EnumValue", value: "desc" } }] } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "IntValue", value: "1" } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "compound_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "model" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "weighting" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "force_zero" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "coefficients_json" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "r2" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "b_over_m" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "created_at" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 300 } };
ck.loc.source = { body: `subscription CalibrationCurvesLatest($calId: Int!) {
  calibration_curve(
    where: { calibration_id: { _eq: $calId } }
    order_by: { created_at: desc }
    limit: 1
  ) {
    id
    compound_id
    model
    weighting
    force_zero
    coefficients_json
    r2
    b_over_m
    created_at
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function L4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    L4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    L4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    L4(r, e);
  });
}
var TN = {};
(function() {
  ck.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      L4(e, n), TN[e.name.value] = n;
    }
  });
})();
function KV(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function r7e(t, e) {
  var n = {
    kind: t.kind,
    definitions: [KV(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = TN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = TN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = KV(t, c);
    d && n.definitions.push(d);
  }), n;
}
const i7e = r7e(ck, "CalibrationCurvesLatest"), a7e = Xe({
  calibrationCurve: Xr(n7e)
}), uk = (t) => {
  const e = I.useMemo(() => ({
    calId: t
  }), [t]), {
    data: n,
    isLoading: r,
    isFetching: i,
    error: a
  } = Z5("CalibrationCurvesLatest", i7e, e), {
    latestCurve: s,
    parseError: c
  } = I.useMemo(() => {
    if (n == null)
      return {
        latestCurve: null,
        parseError: null
      };
    try {
      return {
        latestCurve: qt(a7e, n).calibrationCurve[0] ?? null,
        parseError: null
      };
    } catch (d) {
      return console.error("Failed to parse calibration curve", d), {
        latestCurve: null,
        parseError: new iw("Schema parse error", {
          cause: d,
          props: {
            source: "calibration curve"
          }
        })
      };
    }
  }, [n]);
  return {
    data: s,
    isLoading: r,
    isFetching: i,
    error: a ?? c
  };
};
sJ.extend({
  compoundId: Ve(),
  compound: oJ.nullable()
});
const JV = (t) => {
  const e = ve.c(5), {
    className: n,
    color: r
  } = t;
  let i;
  e[0] !== r ? (i = /* @__PURE__ */ C.jsx("path", { d: "M10 10H0V0C0 5.52285 4.47715 10 10 10Z", fill: r }), e[0] = r, e[1] = i) : i = e[1];
  let a;
  return e[2] !== n || e[3] !== i ? (a = /* @__PURE__ */ C.jsx("svg", { className: n, width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: i }), e[2] = n, e[3] = i, e[4] = a) : a = e[4], a;
}, o7e = (t) => {
  const e = ve.c(33), {
    sequenceId: n,
    selectedCalibrationId: r,
    onSelectedCalibrationChange: i
  } = t, a = VIe(n);
  let s;
  e[0] !== a.data ? (s = a.data ?? [], e[0] = a.data, e[1] = s) : s = e[1];
  const c = s;
  let d;
  e[2] !== c ? (d = [...c].sort(s7e), e[2] = c, e[3] = d) : d = e[3];
  const f = d, [g, m] = I.useState(!1);
  let b;
  e[4] !== f ? (b = f.filter(l7e), e[4] = f, e[5] = b) : b = e[5];
  const w = b, _ = f.filter(c7e);
  let A;
  e: {
    if (r == null) {
      A = null;
      break e;
    }
    let U;
    e[6] !== f || e[7] !== r ? (U = f.find((q) => q.calibrationId === r) ?? null, e[6] = f, e[7] = r, e[8] = U) : U = e[8], A = U;
  }
  const T = A, O = I.useRef(null), R = I.useRef(null);
  let N;
  e[9] === Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ new Set(), e[9] = N) : N = e[9];
  const M = I.useRef(N);
  let P;
  e[10] !== w[0] || e[11] !== f || e[12] !== i || e[13] !== T || e[14] !== r ? (P = () => {
    const U = f.length > 0, q = r != null && T != null, W = new Set(f.map(u7e)), ie = M.current, J = ie.size === 0, B = () => {
      M.current = W;
    };
    if (!J && U) {
      const le = f.find((de) => !ie.has(de.calibrationId)) ?? null;
      if (le != null && le.calibrationId !== r) {
        const de = {
          calibrationId: le.calibrationId,
          isArchived: le.calibration?.archived ?? !1
        }, _e = de.isArchived;
        if (O.current !== de.calibrationId || R.current !== _e) {
          O.current = de.calibrationId, R.current = _e, i(de), B();
          return;
        }
      }
    }
    if (!q && U) {
      const le = w[0] ?? f[0];
      if (le == null) {
        B();
        return;
      }
      const de = {
        calibrationId: le.calibrationId,
        isArchived: le.calibration?.archived ?? !1
      }, _e = de.isArchived;
      if (O.current === de.calibrationId && R.current === _e)
        return;
      O.current = de.calibrationId, R.current = _e, i(de), B();
      return;
    }
    if (!U) {
      if (O.current == null) {
        B();
        return;
      }
      O.current = null, R.current = null, i(null), B();
      return;
    }
    const te = T?.calibrationId ?? null, ae = T?.calibration?.archived ?? null;
    if (O.current === te && R.current === ae) {
      B();
      return;
    }
    if (O.current = te, T == null) {
      i(null), B();
      return;
    }
    R.current = ae, i({
      calibrationId: T.calibrationId,
      isArchived: T.calibration?.archived ?? !1
    }), B();
  }, e[10] = w[0], e[11] = f, e[12] = i, e[13] = T, e[14] = r, e[15] = P) : P = e[15];
  let z;
  e[16] !== w || e[17] !== f || e[18] !== i || e[19] !== T || e[20] !== r ? (z = [f, w, i, T, r], e[16] = w, e[17] = f, e[18] = i, e[19] = T, e[20] = r, e[21] = z) : z = e[21], I.useEffect(P, z);
  let F;
  e[22] !== T?.calibration?.archived ? (F = () => {
    T?.calibration?.archived && m(!0);
  }, e[22] = T?.calibration?.archived, e[23] = F) : F = e[23];
  let $;
  e[24] !== T ? ($ = [T], e[24] = T, e[25] = $) : $ = e[25], I.useEffect(F, $);
  const [G, H] = I.useState(null);
  let Z;
  e[26] !== f || e[27] !== i ? (Z = (U) => {
    if (!U)
      return;
    const q = Number(U), W = f.find((ie) => ie.calibrationId === q) ?? null;
    i(W == null ? {
      calibrationId: q,
      isArchived: !1
    } : {
      calibrationId: W.calibrationId,
      isArchived: W.calibration?.archived ?? !1
    });
  }, e[26] = f, e[27] = i, e[28] = Z) : Z = e[28];
  const V = Z;
  let Y;
  e[29] !== V || e[30] !== G || e[31] !== r ? (Y = (U, q) => /* @__PURE__ */ C.jsx("div", { className: "twd-overflow-hidden twd-pb-2", children: /* @__PURE__ */ C.jsx("div", { className: "twd-flex twd-items-end twd-h-[42px] twd-pt-2 twd-w-auto twd-select-none twd-border-b twd-border-secondary-light2 twd-shadow", children: /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-items-end twd-flex-1 twd-overflow-x-auto twd-no-scrollbar twd-px-[10px]", children: [
    U.map((W, ie) => {
      const J = W.calibration?.name ? `${W.calibration.name} #${W.calibrationId}` : `Calibration #${W.calibrationId}`, B = W.calibrationId === r, te = ie < U.length - 1 && G === ie + 1, ae = G === ie, le = U[ie + 1]?.calibrationId === r, de = ie !== U.length - 1 && !B && !le && !ae && !te;
      return /* @__PURE__ */ C.jsxs("div", { onClick: () => V(String(W.calibrationId)), onMouseEnter: () => H(ie), onMouseLeave: () => H(null), className: `twd-relative twd-group twd-flex twd-items-center twd-h-[34px] twd-min-w-[80px] twd-w-fit twd-cursor-pointer twd-text-xs twd-transition-all twd-duration-100 twd-ease-out ${B ? "twd-z-9" : "twd-z-0"}`, title: `Attached ${hO(W.createdAt)}`, children: [
        B && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          /* @__PURE__ */ C.jsx("div", { className: "twd-absolute -twd-left-[10px] twd-bottom-0 twd-w-[10px] twd-h-[10px]", children: /* @__PURE__ */ C.jsx(JV, { className: "twd-w-full twd-h-full twd-transform -twd-scale-x-100", color: "#E9E9E9" }) }),
          /* @__PURE__ */ C.jsx("div", { className: "twd-absolute twd-inset-0 twd-bg-secondary-light2 twd-rounded-t-lg twd-w-full twd-h-full" }),
          /* @__PURE__ */ C.jsx("div", { className: "twd-absolute -twd-right-[10px] twd-bottom-0 twd-w-[10px] twd-h-[10px]", children: /* @__PURE__ */ C.jsx(JV, { className: "twd-w-full twd-h-full", color: "#E9E9E9" }) })
        ] }),
        !B && /* @__PURE__ */ C.jsx("div", { className: "twd-absolute twd-inset-x-1 twd-inset-y-1 twd-rounded-md twd-bg-transparent group-hover:twd-bg-secondary-contrast/5 twd-transition-colors" }),
        /* @__PURE__ */ C.jsx("div", { className: `twd-relative twd-z-9 twd-flex twd-items-center twd-justify-between twd-w-full twd-px-3 twd-pr-2 twd-h-full ${B ? "twd-text-foreground" : "twd-text-muted-foreground group-hover:twd-text-foreground"}`, children: /* @__PURE__ */ C.jsx("div", { className: "twd-flex twd-items-center twd-gap-2 twd-overflow-hidden twd-flex-1", children: /* @__PURE__ */ C.jsx("span", { className: "twd-whitespace-nowrap twd-text-[12px] twd-font-medium twd-leading-none twd-pt-[1px]", title: J, children: W.calibration?.name ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          W.calibration.name,
          " ",
          /* @__PURE__ */ C.jsxs("span", { className: "twd-text-secondary twd-opacity-70", children: [
            "#",
            W.calibrationId
          ] })
        ] }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          "Calibration ",
          /* @__PURE__ */ C.jsxs("span", { className: "twd-text-secondary twd-opacity-70", children: [
            "#",
            W.calibrationId
          ] })
        ] }) }) }) }),
        de && /* @__PURE__ */ C.jsx("div", { className: "twd-absolute twd-right-0 twd-top-1/2 -twd-translate-y-1/2 twd-w-px twd-h-4 twd-bg-secondary/30" })
      ] }, W.calibrationId);
    }),
    q && /* @__PURE__ */ C.jsx("div", { className: "twd-flex-shrink-0 twd-ml-auto twd-pl-1 md:twd-pl-4", children: q })
  ] }) }) }), e[29] = V, e[30] = G, e[31] = r, e[32] = Y) : Y = e[32];
  const ee = Y;
  return (() => {
    const U = w.length > 0, q = _.length > 0;
    if (!U && !q)
      return /* @__PURE__ */ C.jsx("div", { className: "twd-flex twd-flex-col twd-items-start twd-gap-2", children: /* @__PURE__ */ C.jsx("div", { className: "twd-text-secondary", children: "Create a new standard to generate a calibration" }) });
    const W = g ? [...w, ..._] : w, ie = q && /* @__PURE__ */ C.jsx("div", { className: "twd-pb-1.5", children: /* @__PURE__ */ C.jsxs(Vt, { variant: "primary", onClick: () => m(d7e), className: "twd-text-secondary twd-h-auto twd-font-normal twd-text-[11px] twd-px-2 twd-py-1 twd-bg-transparent hover:twd-bg-secondary-contrast/5", children: [
      g ? "Hide" : "Show",
      " archived (",
      _.length,
      ")"
    ] }) });
    return /* @__PURE__ */ C.jsx("div", { className: "twd-flex twd-flex-col twd-w-full", children: ee(W, ie) });
  })();
};
function s7e(t, e) {
  return new Date(e.createdAt).getTime() - new Date(t.createdAt).getTime();
}
function l7e(t) {
  return !(t.calibration?.archived ?? !1);
}
function c7e(t) {
  return t.calibration?.archived ?? !1;
}
function u7e(t) {
  return t.calibrationId;
}
function d7e(t) {
  return !t;
}
const f7e = Xe({
  name: bi.notEmptyString
});
var dk = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "UpdateCalibrationName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "calibrationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "name" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "update_calibration_by_pk" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "pk_columns" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "calibrationId" } } }] } }, { kind: "Argument", name: { kind: "Name", value: "_set" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "name" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 181 } };
dk.loc.source = { body: `mutation UpdateCalibrationName($calibrationId: Int!, $name: String!) {
  update_calibration_by_pk(pk_columns: { id: $calibrationId }, _set: { name: $name }) {
    id
    name
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function B4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    B4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    B4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    B4(r, e);
  });
}
var ON = {};
(function() {
  dk.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      B4(e, n), ON[e.name.value] = n;
    }
  });
})();
function eU(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function h7e(t, e) {
  var n = {
    kind: t.kind,
    definitions: [eU(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = ON[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = ON[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = eU(t, c);
    d && n.definitions.push(d);
  }), n;
}
const p7e = h7e(dk, "UpdateCalibrationName"), m7e = {
  updateCalibrationName(t, e) {
    return lo.httpClientForHasura.fetch(p7e, {
      calibrationId: t,
      name: e
    });
  }
}, g7e = Xe({
  id: Ve(),
  name: Je()
}), v7e = Xe({
  updateCalibrationByPk: g7e.nullable()
}), y7e = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationFn: b7e
  }, t[0] = e) : e = t[0], Ei(e);
};
async function b7e(t) {
  const {
    calibrationId: e,
    name: n
  } = t, r = await m7e.updateCalibrationName(e, n);
  return qt(v7e, r);
}
const w7e = (t) => {
  const e = ve.c(40), {
    isOpen: n,
    calibrationId: r,
    currentName: i,
    onClose: a
  } = t, s = i ?? `Calibration ${r}`, c = es(), d = y7e(), f = i ?? "";
  let g;
  e[0] !== f ? (g = {
    name: f
  }, e[0] = f, e[1] = g) : g = e[1];
  let m;
  e[2] === Symbol.for("react.memo_cache_sentinel") ? (m = td(f7e), e[2] = m) : m = e[2];
  let b;
  e[3] !== g ? (b = {
    defaultValues: g,
    resolver: m,
    mode: "onChange"
  }, e[3] = g, e[4] = b) : b = e[4];
  const {
    control: w,
    handleSubmit: _,
    formState: A,
    reset: T
  } = ed(b);
  let O, R;
  e[5] !== i || e[6] !== n || e[7] !== T ? (O = () => {
    n && T({
      name: i ?? ""
    });
  }, R = [i, n, T], e[5] = i, e[6] = n, e[7] = T, e[8] = O, e[9] = R) : (O = e[8], R = e[9]), I.useEffect(O, R);
  let N;
  e[10] !== r || e[11] !== c || e[12] !== a || e[13] !== d ? (N = async (ee) => {
    const {
      name: K
    } = ee;
    try {
      await d.mutateAsync({
        calibrationId: r,
        name: K.trim()
      }), a();
    } catch (U) {
      c(U);
    }
  }, e[10] = r, e[11] = c, e[12] = a, e[13] = d, e[14] = N) : N = e[14];
  let M;
  e[15] !== _ || e[16] !== N ? (M = _(N), e[15] = _, e[16] = N, e[17] = M) : M = e[17];
  const P = M;
  let z;
  e[18] !== a || e[19] !== d.isPending ? (z = /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", onClick: a, isDisabled: d.isPending, children: "Cancel" }), e[18] = a, e[19] = d.isPending, e[20] = z) : z = e[20];
  const F = !A.isValid || !A.isDirty;
  let $;
  e[21] !== P || e[22] !== F || e[23] !== d.isPending ? ($ = /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", onClick: P, isLoading: d.isPending, isDisabled: F, children: "Rename" }), e[21] = P, e[22] = F, e[23] = d.isPending, e[24] = $) : $ = e[24];
  let G;
  e[25] !== $ || e[26] !== z ? (G = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-w-full twd-justify-end twd-gap-2", children: [
    z,
    $
  ] }), e[25] = $, e[26] = z, e[27] = G) : G = e[27];
  let H;
  e[28] !== w || e[29] !== s ? (H = /* @__PURE__ */ C.jsx(Zr, { name: "name", control: w, label: "Name", placeholder: s, isFullWidth: !0 }), e[28] = w, e[29] = s, e[30] = H) : H = e[30];
  let Z;
  e[31] === Symbol.for("react.memo_cache_sentinel") ? (Z = /* @__PURE__ */ C.jsx("button", { type: "submit", className: "twd-hidden" }), e[31] = Z) : Z = e[31];
  let V;
  e[32] !== P || e[33] !== H ? (V = /* @__PURE__ */ C.jsxs("form", { className: "twd-flex twd-flex-col twd-gap-4", onSubmit: P, children: [
    H,
    Z
  ] }), e[32] = P, e[33] = H, e[34] = V) : V = e[34];
  let Y;
  return e[35] !== n || e[36] !== a || e[37] !== G || e[38] !== V ? (Y = /* @__PURE__ */ C.jsx(Ph, { isOpen: n, onClose: a, title: "Rename calibration", footer: G, children: V }), e[35] = n, e[36] = a, e[37] = G, e[38] = V, e[39] = Y) : Y = e[39], Y;
}, x7e = (t) => {
  const e = ve.c(12), {
    calibrationId: n,
    calibrationName: r,
    className: i
  } = t, [a, s] = I.useState(!1);
  let c;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (c = (A) => {
    A.stopPropagation(), s(!0);
  }, e[0] = c) : c = e[0];
  const d = c;
  let f;
  e[1] === Symbol.for("react.memo_cache_sentinel") ? (f = () => {
    s(!1);
  }, e[1] = f) : f = e[1];
  const g = f;
  let m;
  e[2] === Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ C.jsx(lw, {}), e[2] = m) : m = e[2];
  let b;
  e[3] !== i ? (b = /* @__PURE__ */ C.jsx(Vt, { variant: "primary", icon: m, onClick: d, className: i, children: "Rename" }), e[3] = i, e[4] = b) : b = e[4];
  let w;
  e[5] !== n || e[6] !== r || e[7] !== a ? (w = /* @__PURE__ */ C.jsx(w7e, { isOpen: a, onClose: g, calibrationId: n, currentName: r }), e[5] = n, e[6] = r, e[7] = a, e[8] = w) : w = e[8];
  let _;
  return e[9] !== b || e[10] !== w ? (_ = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    b,
    w
  ] }), e[9] = b, e[10] = w, e[11] = _) : _ = e[11], _;
};
var fk = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "ArchiveCalibration" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "calibrationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "archived" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "update_calibration_by_pk" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "pk_columns" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "calibrationId" } } }] } }, { kind: "Argument", name: { kind: "Name", value: "_set" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "archived" }, value: { kind: "Variable", name: { kind: "Name", value: "archived" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "archived" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 195 } };
fk.loc.source = { body: `mutation ArchiveCalibration($calibrationId: Int!, $archived: Boolean!) {
  update_calibration_by_pk(pk_columns: { id: $calibrationId }, _set: { archived: $archived }) {
    id
    archived
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function z4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    z4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    z4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    z4(r, e);
  });
}
var RN = {};
(function() {
  fk.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      z4(e, n), RN[e.name.value] = n;
    }
  });
})();
function tU(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function S7e(t, e) {
  var n = {
    kind: t.kind,
    definitions: [tU(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = RN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = RN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = tU(t, c);
    d && n.definitions.push(d);
  }), n;
}
const E7e = S7e(fk, "ArchiveCalibration"), _7e = {
  updateCalibrationArchiveStatus(t, e) {
    return lo.httpClientForHasura.fetch(E7e, {
      calibrationId: t,
      archived: e
    });
  }
}, A7e = Xe({
  id: Ve(),
  archived: Sr()
}), C7e = Xe({
  updateCalibrationByPk: A7e.nullable()
}), cJ = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationFn: T7e
  }, t[0] = e) : e = t[0], Ei(e);
};
async function T7e(t) {
  const {
    calibrationId: e,
    archived: n
  } = t, r = await _7e.updateCalibrationArchiveStatus(e, n);
  return qt(C7e, r);
}
const O7e = (t) => {
  const e = ve.c(16), {
    calibrationId: n,
    className: r
  } = t, [i, a] = I.useState(!1), s = cJ();
  let c;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (c = (T) => {
    T.stopPropagation(), a(!0);
  }, e[0] = c) : c = e[0];
  const d = c;
  let f;
  e[1] !== s || e[2] !== n ? (f = () => {
    s.mutate({
      calibrationId: n,
      archived: !0
    });
  }, e[1] = s, e[2] = n, e[3] = f) : f = e[3];
  const g = f;
  let m;
  e[4] === Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ C.jsx(Yb, {}), e[4] = m) : m = e[4];
  let b;
  e[5] !== s.isPending || e[6] !== r ? (b = /* @__PURE__ */ C.jsx(Vt, { variant: "primary", icon: m, onClick: d, className: r, isLoading: s.isPending, children: "Archive" }), e[5] = s.isPending, e[6] = r, e[7] = b) : b = e[7];
  let w;
  e[8] === Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ C.jsx(C.Fragment, { children: "Archiving will exclude this calibration from processing and all results will be recalculated." }), e[8] = w) : w = e[8];
  let _;
  e[9] !== s.isPending || e[10] !== g || e[11] !== i ? (_ = /* @__PURE__ */ C.jsx(qu, { open: i, onOpenChange: a, title: "Archive calibration?", description: w, confirmLabel: "Archive", loading: s.isPending, onConfirm: g }), e[9] = s.isPending, e[10] = g, e[11] = i, e[12] = _) : _ = e[12];
  let A;
  return e[13] !== b || e[14] !== _ ? (A = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    b,
    _
  ] }), e[13] = b, e[14] = _, e[15] = A) : A = e[15], A;
}, R7e = (t) => {
  const e = ve.c(16), {
    calibrationId: n,
    className: r
  } = t, [i, a] = I.useState(!1), s = cJ();
  let c;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (c = (T) => {
    T.stopPropagation(), a(!0);
  }, e[0] = c) : c = e[0];
  const d = c;
  let f;
  e[1] !== s || e[2] !== n ? (f = () => {
    s.mutate({
      calibrationId: n,
      archived: !1
    });
  }, e[1] = s, e[2] = n, e[3] = f) : f = e[3];
  const g = f;
  let m;
  e[4] === Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ C.jsx(xI, {}), e[4] = m) : m = e[4];
  let b;
  e[5] !== s.isPending || e[6] !== r ? (b = /* @__PURE__ */ C.jsx(Vt, { variant: "primary", icon: m, onClick: d, className: r, isLoading: s.isPending, children: "Restore" }), e[5] = s.isPending, e[6] = r, e[7] = b) : b = e[7];
  let w;
  e[8] === Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    "Restoring will make this calibration available for editing and it will be used for processing. ",
    /* @__PURE__ */ C.jsx("br", {}),
    " ",
    "Sequence results will be recalculated."
  ] }), e[8] = w) : w = e[8];
  let _;
  e[9] !== s.isPending || e[10] !== g || e[11] !== i ? (_ = /* @__PURE__ */ C.jsx(qu, { open: i, onOpenChange: a, title: "Restore calibration?", description: w, confirmLabel: "Restore", loading: s.isPending, onConfirm: g }), e[9] = s.isPending, e[10] = g, e[11] = i, e[12] = _) : _ = e[12];
  let A;
  return e[13] !== b || e[14] !== _ ? (A = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    b,
    _
  ] }), e[13] = b, e[14] = _, e[15] = A) : A = e[15], A;
}, D7e = (t) => {
  const e = ve.c(14), {
    calibrationId: n
  } = t, {
    data: r
  } = vO(n), i = r?.calibration ?? null;
  if (!i)
    return null;
  const a = i.archived;
  let s;
  e[0] !== i.id || e[1] !== i.name || e[2] !== a ? (s = !a && /* @__PURE__ */ C.jsx(x7e, { calibrationId: i.id, calibrationName: i.name }), e[0] = i.id, e[1] = i.name, e[2] = a, e[3] = s) : s = e[3];
  let c;
  e[4] !== i.id || e[5] !== a ? (c = !a && /* @__PURE__ */ C.jsx(O7e, { calibrationId: i.id }), e[4] = i.id, e[5] = a, e[6] = c) : c = e[6];
  let d;
  e[7] !== i.id || e[8] !== a ? (d = a && /* @__PURE__ */ C.jsx(R7e, { calibrationId: i.id }), e[7] = i.id, e[8] = a, e[9] = d) : d = e[9];
  let f;
  return e[10] !== s || e[11] !== c || e[12] !== d ? (f = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-flex-wrap twd-gap-2", children: [
    s,
    c,
    d
  ] }), e[10] = s, e[11] = c, e[12] = d, e[13] = f) : f = e[13], f;
}, N7e = Xe({
  slope: Ve().nullable().optional(),
  intercept: Ve().nullable().optional()
}).passthrough(), M7e = (t) => {
  let e = t;
  if (typeof t == "string")
    try {
      e = JSON.parse(t);
    } catch {
      return null;
    }
  const n = N7e.safeParse(e);
  return n.success ? n.data : null;
}, uJ = (t) => M7e(t.coefficientsJson)?.slope ?? null, Fb = S5((t, e) => ({
  registered: /* @__PURE__ */ new Set(),
  ready: /* @__PURE__ */ new Set(),
  hasNotifiedAllReady: !1,
  register: (n) => {
    e().registered.has(n) || t((i) => ({
      registered: new Set(i.registered).add(n)
    }));
  },
  unregister: (n) => {
    t((r) => {
      if (!r.registered.has(n))
        return {};
      const a = new Set(r.registered);
      a.delete(n);
      const s = new Set(r.ready);
      return s.delete(n), {
        registered: a,
        ready: s
      };
    });
  },
  markReady: (n) => {
    t((r) => r.ready.has(n) ? {} : r.registered.has(n) ? {
      ready: new Set(r.ready).add(n)
    } : {});
  }
})), B_ = (t) => {
  const e = ve.c(10), n = Fb(k7e), r = Fb(j7e), i = Fb(P7e);
  let a, s;
  e[0] !== t || e[1] !== n || e[2] !== r ? (a = () => (n(t), () => r(t)), s = [t, n, r], e[0] = t, e[1] = n, e[2] = r, e[3] = a, e[4] = s) : (a = e[3], s = e[4]), I.useEffect(a, s);
  let c;
  e[5] !== t || e[6] !== i ? (c = () => {
    i(t);
  }, e[5] = t, e[6] = i, e[7] = c) : c = e[7];
  const d = c;
  let f;
  return e[8] !== d ? (f = {
    markReady: d
  }, e[8] = d, e[9] = f) : f = e[9], f;
}, I7e = (t) => {
  const e = I.useRef(t);
  e.current = t, I.useEffect(() => {
    if (!t)
      return;
    if (Fb.getState().hasNotifiedAllReady) {
      try {
        t();
      } catch {
      }
      return;
    }
    const r = Fb.subscribe((i) => {
      const {
        registered: a,
        ready: s,
        hasNotifiedAllReady: c
      } = i;
      if (c)
        return;
      if (a.size > 0 && a.size === s.size && e.current) {
        Fb.setState({
          hasNotifiedAllReady: !0
        });
        try {
          e.current();
        } catch {
        }
      }
    });
    return () => {
      r();
    };
  }, [t]);
};
function k7e(t) {
  return t.register;
}
function j7e(t) {
  return t.unregister;
}
function P7e(t) {
  return t.markReady;
}
const dJ = (t) => {
  const e = ve.c(54), {
    calibrationId: n
  } = t, {
    data: r,
    isLoading: i
  } = uk(n), {
    markReady: a
  } = B_(`latest-curve-${n}`);
  let s, c;
  if (e[0] !== i || e[1] !== a ? (s = () => {
    i || a();
  }, c = [i, a], e[0] = i, e[1] = a, e[2] = s, e[3] = c) : (s = e[2], c = e[3]), I.useEffect(s, c), i) {
    let H;
    return e[4] === Symbol.for("react.memo_cache_sentinel") ? (H = /* @__PURE__ */ C.jsx(aa, { message: "Loading latest curve" }), e[4] = H) : H = e[4], H;
  }
  if (r == null) {
    let H;
    return e[5] === Symbol.for("react.memo_cache_sentinel") ? (H = /* @__PURE__ */ C.jsx("div", { className: "twd-text-secondary", children: "No curve yet." }), e[5] = H) : H = e[5], H;
  }
  let d, f, g, m, b, w, _, A, T, O, R;
  if (e[6] !== r) {
    const H = uJ(r);
    R = "twd-rounded-md twd-border twd-border-border twd-bg-white", m = Pg, e[18] === Symbol.for("react.memo_cache_sentinel") ? (O = /* @__PURE__ */ C.jsx(Lg, { children: /* @__PURE__ */ C.jsxs("tr", { children: [
      /* @__PURE__ */ C.jsx(wi, { children: "Model" }),
      /* @__PURE__ */ C.jsx(wi, { children: "Weighting" }),
      /* @__PURE__ */ C.jsx(wi, { children: "Force Zero" }),
      /* @__PURE__ */ C.jsx(wi, { children: "R²" }),
      /* @__PURE__ */ C.jsx(wi, { children: "Slope (k)" }),
      /* @__PURE__ */ C.jsx(wi, { children: "Created" })
    ] }) }), e[18] = O) : O = e[18], g = Bg, f = rf;
    const Z = r.model ?? "—";
    e[19] !== Z ? (w = /* @__PURE__ */ C.jsx(Ir, { children: Z }), e[19] = Z, e[20] = w) : w = e[20];
    const V = r.weighting ?? "—";
    e[21] !== V ? (_ = /* @__PURE__ */ C.jsx(Ir, { children: V }), e[21] = V, e[22] = _) : _ = e[22], e[23] !== r.forceZero ? (A = /* @__PURE__ */ C.jsx(Ir, { children: r.forceZero ? /* @__PURE__ */ C.jsx(P5, {}) : /* @__PURE__ */ C.jsx(SI, {}) }), e[23] = r.forceZero, e[24] = A) : A = e[24];
    let Y;
    e[25] !== r.r2 ? (Y = r.r2 != null ? Ms(r.r2, 3) : "—", e[25] = r.r2, e[26] = Y) : Y = e[26], e[27] !== Y ? (T = /* @__PURE__ */ C.jsx(Ir, { children: Y }), e[27] = Y, e[28] = T) : T = e[28], d = Ir, b = H != null ? Ms(H, 3) : "—", e[6] = r, e[7] = d, e[8] = f, e[9] = g, e[10] = m, e[11] = b, e[12] = w, e[13] = _, e[14] = A, e[15] = T, e[16] = O, e[17] = R;
  } else
    d = e[7], f = e[8], g = e[9], m = e[10], b = e[11], w = e[12], _ = e[13], A = e[14], T = e[15], O = e[16], R = e[17];
  let N;
  e[29] !== d || e[30] !== b ? (N = /* @__PURE__ */ C.jsx(d, { children: b }), e[29] = d, e[30] = b, e[31] = N) : N = e[31];
  let M;
  e[32] !== r.createdAt ? (M = hO(r.createdAt), e[32] = r.createdAt, e[33] = M) : M = e[33];
  let P;
  e[34] !== M ? (P = /* @__PURE__ */ C.jsx(Ir, { children: M }), e[34] = M, e[35] = P) : P = e[35];
  let z;
  e[36] !== f || e[37] !== N || e[38] !== P || e[39] !== w || e[40] !== _ || e[41] !== A || e[42] !== T ? (z = /* @__PURE__ */ C.jsxs(f, { children: [
    w,
    _,
    A,
    T,
    N,
    P
  ] }), e[36] = f, e[37] = N, e[38] = P, e[39] = w, e[40] = _, e[41] = A, e[42] = T, e[43] = z) : z = e[43];
  let F;
  e[44] !== g || e[45] !== z ? (F = /* @__PURE__ */ C.jsx(g, { children: z }), e[44] = g, e[45] = z, e[46] = F) : F = e[46];
  let $;
  e[47] !== m || e[48] !== F || e[49] !== O ? ($ = /* @__PURE__ */ C.jsxs(m, { children: [
    O,
    F
  ] }), e[47] = m, e[48] = F, e[49] = O, e[50] = $) : $ = e[50];
  let G;
  return e[51] !== $ || e[52] !== R ? (G = /* @__PURE__ */ C.jsx("div", { className: R, children: $ }), e[51] = $, e[52] = R, e[53] = G) : G = e[53], G;
}, L7e = (t) => {
  const e = ve.c(63), {
    point: n,
    onToggle: r,
    onShowMeasurement: i,
    highlightedPointId: a,
    onPointHighlight: s
  } = t, c = n.included, d = typeof i == "function" && n.measurementId != null, f = c ? "Turning off will exclude this point from calibration" : !c && n.excludeReason != null ? n.excludeReason : null;
  let g;
  e[0] !== d || e[1] !== i || e[2] !== n.measurementId ? (g = () => {
    !d || n.measurementId == null || i?.(n.measurementId);
  }, e[0] = d, e[1] = i, e[2] = n.measurementId, e[3] = g) : g = e[3];
  const m = g, b = c ? "" : "twd-opacity-60 twd-line-through", w = c && a === n.id;
  let _;
  e[4] !== c || e[5] !== s || e[6] !== n.id ? (_ = () => {
    if (!c) {
      s(null);
      return;
    }
    s(n.id);
  }, e[4] = c, e[5] = s, e[6] = n.id, e[7] = _) : _ = e[7];
  const A = _;
  let T;
  e[8] !== c || e[9] !== s ? (T = () => {
    if (!c) {
      s(null);
      return;
    }
    s(null);
  }, e[8] = c, e[9] = s, e[10] = T) : T = e[10];
  const O = T;
  let R;
  e[11] !== m ? (R = (ae) => {
    ae.stopPropagation(), m();
  }, e[11] = m, e[12] = R) : R = e[12];
  const N = R, M = w && "twd-bg-muted/50";
  let P;
  e[13] !== M ? (P = Xc("twd-group", M), e[13] = M, e[14] = P) : P = e[14];
  let z;
  e[15] === Symbol.for("react.memo_cache_sentinel") ? (z = /* @__PURE__ */ C.jsx(Ir, { colSpan: 2 }), e[15] = z) : z = e[15];
  let F;
  e[16] !== b ? (F = Xc(b), e[16] = b, e[17] = F) : F = e[17];
  let $;
  e[18] !== n.area ? ($ = n.area != null ? Ms(n.area, 3) : "—", e[18] = n.area, e[19] = $) : $ = e[19];
  let G;
  e[20] !== F || e[21] !== $ ? (G = /* @__PURE__ */ C.jsx(Ir, { className: F, children: $ }), e[20] = F, e[21] = $, e[22] = G) : G = e[22];
  let H;
  e[23] !== b ? (H = Xc(b), e[23] = b, e[24] = H) : H = e[24];
  let Z;
  e[25] !== n.rt ? (Z = n.rt != null ? Ms(n.rt, 3) : "—", e[25] = n.rt, e[26] = Z) : Z = e[26];
  let V;
  e[27] !== H || e[28] !== Z ? (V = /* @__PURE__ */ C.jsx(Ir, { className: H, children: Z }), e[27] = H, e[28] = Z, e[29] = V) : V = e[29];
  let Y;
  e[30] !== b ? (Y = Xc(b), e[30] = b, e[31] = Y) : Y = e[31];
  let ee;
  e[32] !== r || e[33] !== n ? (ee = () => r(n), e[32] = r, e[33] = n, e[34] = ee) : ee = e[34];
  let K;
  e[35] !== f || e[36] !== c || e[37] !== ee ? (K = /* @__PURE__ */ C.jsx("div", { className: "print:twd-hidden", children: /* @__PURE__ */ C.jsx(Kbe, { isChecked: c, onChange: ee, hint: f, hintPlacement: "top-start" }) }), e[35] = f, e[36] = c, e[37] = ee, e[38] = K) : K = e[38];
  let U;
  e[39] !== c ? (U = /* @__PURE__ */ C.jsx("div", { className: "twd-hidden print:twd-block", children: c ? /* @__PURE__ */ C.jsx(P5, { className: "twd-h-5 twd-w-5" }) : /* @__PURE__ */ C.jsx(SI, { className: "twd-h-5 twd-w-5" }) }), e[39] = c, e[40] = U) : U = e[40];
  let q;
  e[41] !== K || e[42] !== U ? (q = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-items-center twd-gap-2", children: [
    K,
    U
  ] }), e[41] = K, e[42] = U, e[43] = q) : q = e[43];
  let W;
  e[44] !== Y || e[45] !== q ? (W = /* @__PURE__ */ C.jsx(Ir, { className: Y, children: q }), e[44] = Y, e[45] = q, e[46] = W) : W = e[46];
  let ie;
  e[47] !== b ? (ie = Xc(b, "twd-text-right print:twd-hidden"), e[47] = b, e[48] = ie) : ie = e[48];
  let J;
  e[49] !== d || e[50] !== N ? (J = d ? /* @__PURE__ */ C.jsx(cl, { icon: /* @__PURE__ */ C.jsx(T_, {}), onClick: N }) : "—", e[49] = d, e[50] = N, e[51] = J) : J = e[51];
  let B;
  e[52] !== ie || e[53] !== J ? (B = /* @__PURE__ */ C.jsx(Ir, { className: ie, children: J }), e[52] = ie, e[53] = J, e[54] = B) : B = e[54];
  let te;
  return e[55] !== A || e[56] !== O || e[57] !== G || e[58] !== V || e[59] !== W || e[60] !== B || e[61] !== P ? (te = /* @__PURE__ */ C.jsxs(rf, { className: P, onMouseEnter: A, onMouseLeave: O, children: [
    z,
    G,
    V,
    W,
    B
  ] }), e[55] = A, e[56] = O, e[57] = G, e[58] = V, e[59] = W, e[60] = B, e[61] = P, e[62] = te) : te = e[62], te;
};
var hk = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "UpdateCalibrationPointIncluded" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pointId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "included" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "excludeReason" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "update_calibration_point_by_pk" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "pk_columns" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "pointId" } } }] } }, { kind: "Argument", name: { kind: "Name", value: "_set" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "included" }, value: { kind: "Variable", name: { kind: "Name", value: "included" } } }, { kind: "ObjectField", name: { kind: "Name", value: "exclude_reason" }, value: { kind: "Variable", name: { kind: "Name", value: "excludeReason" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "included" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "exclude_reason" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 287 } };
hk.loc.source = { body: `mutation UpdateCalibrationPointIncluded($pointId: Int!, $included: Boolean!, $excludeReason: String) {
  update_calibration_point_by_pk(
    pk_columns: { id: $pointId }
    _set: { included: $included, exclude_reason: $excludeReason }
  ) {
    id
    included
    exclude_reason
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function F4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    F4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    F4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    F4(r, e);
  });
}
var DN = {};
(function() {
  hk.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      F4(e, n), DN[e.name.value] = n;
    }
  });
})();
function nU(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function B7e(t, e) {
  var n = {
    kind: t.kind,
    definitions: [nU(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = DN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = DN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = nU(t, c);
    d && n.definitions.push(d);
  }), n;
}
const z7e = B7e(hk, "UpdateCalibrationPointIncluded"), F7e = {
  updatePointIncluded(t, e, n) {
    return lo.httpClientForHasura.fetch(z7e, {
      pointId: t,
      included: e,
      excludeReason: n
    });
  }
}, V7e = Xe({
  id: Ve(),
  included: Sr(),
  excludeReason: Je().nullable()
}), U7e = Xe({
  updateCalibrationPointByPk: V7e.nullable()
}), $7e = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationFn: H7e
  }, t[0] = e) : e = t[0], Ei(e);
};
async function H7e(t) {
  const {
    pointId: e,
    included: n,
    excludeReason: r
  } = t, i = await F7e.updatePointIncluded(e, n, r);
  return qt(U7e, i);
}
const q7e = () => {
  const t = ve.c(5), e = es(), n = $7e();
  let r;
  t[0] !== e || t[1] !== n ? (r = async (s) => {
    const c = !(s.included ?? !1);
    let d = null;
    if (!c) {
      const f = window.prompt("Reason for excluding this point (optional):");
      if (f === null)
        return;
      d = f.length > 0 ? f : null;
    }
    try {
      await n.mutateAsync({
        pointId: s.id,
        included: c,
        excludeReason: d
      });
    } catch (f) {
      e(f);
    }
  }, t[0] = e, t[1] = n, t[2] = r) : r = t[2];
  const i = r;
  let a;
  return t[3] !== i ? (a = {
    togglePointIncluded: i
  }, t[3] = i, t[4] = a) : a = t[4], a;
}, G7e = x5((t) => {
  if (typeof t == "string") {
    const e = Number(t);
    return Number.isNaN(e) ? t : e;
  }
  return t;
}, Ve({
  required_error: "Nominal concentration is required"
}).positive("Nominal concentration must be positive")), Y7e = Xe({
  nominalConcentration: G7e,
  unit: y_(AM)
});
var pk = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "UpdateCalibrationLevel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "levelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "nominalConcentration" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "float8" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "unit" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "update_calibration_level_by_pk" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "pk_columns" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "levelId" } } }] } }, { kind: "Argument", name: { kind: "Name", value: "_set" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "nominal_concentration" }, value: { kind: "Variable", name: { kind: "Name", value: "nominalConcentration" } } }, { kind: "ObjectField", name: { kind: "Name", value: "unit" }, value: { kind: "Variable", name: { kind: "Name", value: "unit" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "nominal_concentration" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "unit" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 291 } };
pk.loc.source = { body: `mutation UpdateCalibrationLevel($levelId: Int!, $nominalConcentration: float8!, $unit: String!) {
  update_calibration_level_by_pk(
    pk_columns: { id: $levelId }
    _set: { nominal_concentration: $nominalConcentration, unit: $unit }
  ) {
    id
    nominal_concentration
    unit
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function V4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    V4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    V4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    V4(r, e);
  });
}
var NN = {};
(function() {
  pk.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      V4(e, n), NN[e.name.value] = n;
    }
  });
})();
function rU(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function X7e(t, e) {
  var n = {
    kind: t.kind,
    definitions: [rU(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = NN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = NN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = rU(t, c);
    d && n.definitions.push(d);
  }), n;
}
const W7e = X7e(pk, "UpdateCalibrationLevel"), Q7e = {
  updateCalibrationLevel(t, e, n) {
    return lo.httpClientForHasura.fetch(W7e, {
      levelId: t,
      nominalConcentration: e,
      unit: n
    }, {
      operationId: "updateCalibrationLevel"
    });
  }
}, Z7e = Xe({
  id: Ve(),
  nominalConcentration: Ve(),
  unit: Je()
}), K7e = Xe({
  updateCalibrationLevelByPk: Z7e.nullable()
}), J7e = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationFn: eke
  }, t[0] = e) : e = t[0], Ei(e);
};
async function eke(t) {
  const {
    levelId: e,
    nominalConcentration: n,
    unit: r
  } = t, i = await Q7e.updateCalibrationLevel(e, n, r);
  return qt(K7e, i);
}
const GC = vr("EditLevelModal"), tke = (t) => {
  const e = ve.c(49), {
    isOpen: n,
    levelId: r,
    currentNominalConcentration: i,
    currentUnit: a,
    onClose: s
  } = t, c = i ?? 0;
  let d;
  e: {
    if (typeof a == "string" && ile(a)) {
      d = a;
      break e;
    }
    d = rle;
  }
  const f = d, g = es(), m = J7e(), b = i ?? 0;
  let w;
  e[0] !== f || e[1] !== b ? (w = {
    nominalConcentration: b,
    unit: f
  }, e[0] = f, e[1] = b, e[2] = w) : w = e[2];
  let _;
  e[3] === Symbol.for("react.memo_cache_sentinel") ? (_ = td(Y7e), e[3] = _) : _ = e[3];
  let A;
  e[4] !== w ? (A = {
    defaultValues: w,
    resolver: _,
    mode: "onChange"
  }, e[4] = w, e[5] = A) : A = e[5];
  const {
    control: T,
    handleSubmit: O,
    reset: R,
    formState: N
  } = ed(A), {
    isDirty: M,
    isValid: P
  } = N;
  let z, F;
  e[6] !== i || e[7] !== n || e[8] !== r || e[9] !== f || e[10] !== R ? (z = () => {
    n && (R({
      nominalConcentration: i ?? 0,
      unit: f
    }), GC.debug("Modal opened, form reset", {
      levelId: r
    }));
  }, F = [i, f, n, r, R], e[6] = i, e[7] = n, e[8] = r, e[9] = f, e[10] = R, e[11] = z, e[12] = F) : (z = e[11], F = e[12]), I.useEffect(z, F);
  let $;
  e[13] !== g || e[14] !== r || e[15] !== s || e[16] !== m ? ($ = async (te) => {
    const {
      nominalConcentration: ae,
      unit: le
    } = te;
    GC.info("Submitting level update", {
      levelId: r,
      nominalConcentration: ae,
      unit: le
    });
    try {
      await m.mutateAsync({
        levelId: r,
        nominalConcentration: ae,
        unit: le.trim()
      }), GC.info("Level updated successfully", {
        levelId: r
      }), s();
    } catch (de) {
      const _e = de;
      GC.error("Failed to update level", _e), g(_e);
    }
  }, e[13] = g, e[14] = r, e[15] = s, e[16] = m, e[17] = $) : $ = e[17];
  let G;
  e[18] !== O || e[19] !== $ ? (G = O($), e[18] = O, e[19] = $, e[20] = G) : G = e[20];
  const H = G;
  let Z;
  e[21] !== s || e[22] !== m.isPending ? (Z = /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", onClick: s, isDisabled: m.isPending, children: "Cancel" }), e[21] = s, e[22] = m.isPending, e[23] = Z) : Z = e[23];
  const V = !P || !M;
  let Y;
  e[24] !== H || e[25] !== V || e[26] !== m.isPending ? (Y = /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", onClick: H, isLoading: m.isPending, isDisabled: V, children: "Save" }), e[24] = H, e[25] = V, e[26] = m.isPending, e[27] = Y) : Y = e[27];
  let ee;
  e[28] !== Z || e[29] !== Y ? (ee = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-w-full twd-justify-end twd-gap-2", children: [
    Z,
    Y
  ] }), e[28] = Z, e[29] = Y, e[30] = ee) : ee = e[30];
  let K;
  e[31] !== c ? (K = c.toString(), e[31] = c, e[32] = K) : K = e[32];
  let U;
  e[33] !== T || e[34] !== K ? (U = /* @__PURE__ */ C.jsx(Zr, { name: "nominalConcentration", control: T, label: "Nominal concentration", placeholder: K, type: "float", isFullWidth: !0 }), e[33] = T, e[34] = K, e[35] = U) : U = e[35];
  let q;
  e[36] === Symbol.for("react.memo_cache_sentinel") ? (q = AM.map(nke), e[36] = q) : q = e[36];
  let W;
  e[37] !== T ? (W = /* @__PURE__ */ C.jsx(Qb, { name: "unit", control: T, label: "Unit", isFullWidth: !0, children: q }), e[37] = T, e[38] = W) : W = e[38];
  let ie;
  e[39] === Symbol.for("react.memo_cache_sentinel") ? (ie = /* @__PURE__ */ C.jsx("button", { type: "submit", className: "twd-hidden" }), e[39] = ie) : ie = e[39];
  let J;
  e[40] !== H || e[41] !== U || e[42] !== W ? (J = /* @__PURE__ */ C.jsxs("form", { className: "twd-flex twd-flex-row twd-gap-4", onSubmit: H, children: [
    U,
    W,
    ie
  ] }), e[40] = H, e[41] = U, e[42] = W, e[43] = J) : J = e[43];
  let B;
  return e[44] !== n || e[45] !== s || e[46] !== ee || e[47] !== J ? (B = /* @__PURE__ */ C.jsx(Ph, { isOpen: n, onClose: s, title: "Edit level", footer: ee, children: J }), e[44] = n, e[45] = s, e[46] = ee, e[47] = J, e[48] = B) : B = e[48], B;
};
function nke(t) {
  return /* @__PURE__ */ C.jsx("option", { value: t, children: t }, t);
}
const vD = vr("EditLevelButton"), rke = (t) => {
  const e = ve.c(23), {
    levelId: n,
    nominalConcentration: r,
    unit: i,
    className: a,
    isDisabled: s,
    disabledHint: c
  } = t, d = s === void 0 ? !1 : s, [f, g] = I.useState(!1);
  let m;
  e[0] !== d || e[1] !== n ? (m = (P) => {
    if (P.stopPropagation(), d) {
      vD.debug("Edit button clicked but disabled", {
        levelId: n
      });
      return;
    }
    vD.debug("Edit button clicked", {
      levelId: n
    }), g(!0);
  }, e[0] = d, e[1] = n, e[2] = m) : m = e[2];
  const b = m;
  let w;
  e[3] !== n ? (w = () => {
    vD.debug("Closing edit modal", {
      levelId: n
    }), g(!1);
  }, e[3] = n, e[4] = w) : w = e[4];
  const _ = w;
  let A;
  e[5] === Symbol.for("react.memo_cache_sentinel") ? (A = /* @__PURE__ */ C.jsx(lw, {}), e[5] = A) : A = e[5];
  let T;
  e[6] !== a || e[7] !== b || e[8] !== d ? (T = /* @__PURE__ */ C.jsx(cl, { icon: A, onClick: b, className: a, isDisabled: d }), e[6] = a, e[7] = b, e[8] = d, e[9] = T) : T = e[9];
  const O = T;
  let R;
  e[10] !== O || e[11] !== c || e[12] !== d ? (R = d && c != null ? /* @__PURE__ */ C.jsx(nu, { message: c, isDisabled: !1, children: O }) : O, e[10] = O, e[11] = c, e[12] = d, e[13] = R) : R = e[13];
  let N;
  e[14] !== _ || e[15] !== f || e[16] !== n || e[17] !== r || e[18] !== i ? (N = /* @__PURE__ */ C.jsx(tke, { isOpen: f, onClose: _, levelId: n, currentNominalConcentration: r, currentUnit: i }), e[14] = _, e[15] = f, e[16] = n, e[17] = r, e[18] = i, e[19] = N) : N = e[19];
  let M;
  return e[20] !== R || e[21] !== N ? (M = /* @__PURE__ */ C.jsxs("div", { className: "print:twd-hidden", children: [
    R,
    N
  ] }), e[20] = R, e[21] = N, e[22] = M) : M = e[22], M;
}, fJ = (t) => {
  const e = ve.c(24), {
    calibrationId: n,
    onShowMeasurement: r,
    onShowStandard: i,
    highlightedPointId: a,
    onPointHighlight: s
  } = t, c = q7e(), {
    data: d,
    isLoading: f
  } = lJ(n);
  let g;
  e[0] !== d ? (g = d ?? [], e[0] = d, e[1] = g) : g = e[1];
  const m = g, b = f, {
    markReady: w
  } = B_(`levels-and-points-${n}`);
  let _, A;
  if (e[2] !== b || e[3] !== w ? (_ = () => {
    b || w();
  }, A = [b, w], e[2] = b, e[3] = w, e[4] = _, e[5] = A) : (_ = e[4], A = e[5]), I.useEffect(_, A), b && m.length === 0) {
    let N;
    return e[6] === Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ C.jsx(aa, { message: "Loading levels and points" }), e[6] = N) : N = e[6], N;
  }
  if (m.length === 0) {
    let N;
    return e[7] === Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ C.jsx("div", { className: "twd-text-secondary", children: "No levels or points yet." }), e[7] = N) : N = e[7], N;
  }
  let T;
  e[8] === Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ C.jsx(Lg, { children: /* @__PURE__ */ C.jsxs("tr", { children: [
    /* @__PURE__ */ C.jsx(wi, { children: "Level" }),
    /* @__PURE__ */ C.jsx(wi, { children: "Concentration" }),
    /* @__PURE__ */ C.jsx(wi, { children: "Area" }),
    /* @__PURE__ */ C.jsx(wi, { children: "RT" }),
    /* @__PURE__ */ C.jsx(wi, { children: "Use in calibration" }),
    /* @__PURE__ */ C.jsx(wi, { className: "print:twd-hidden" })
  ] }) }), e[8] = T) : T = e[8];
  let O;
  if (e[9] !== a || e[10] !== m || e[11] !== s || e[12] !== r || e[13] !== i || e[14] !== c) {
    let N;
    e[16] !== a || e[17] !== s || e[18] !== r || e[19] !== i || e[20] !== c ? (N = (M) => {
      const P = typeof i == "function" && M.standardId != null, z = () => {
        !P || M.standardId == null || i?.(M.standardId);
      }, F = (G) => {
        G.stopPropagation(), z();
      }, $ = M.sample?.archived === !0;
      return /* @__PURE__ */ C.jsxs(De.Fragment, { children: [
        /* @__PURE__ */ C.jsxs(rf, { className: "twd-border-b twd-border-border twd-bg-muted/5", children: [
          /* @__PURE__ */ C.jsx(Ir, { className: "twd-font-semibold", children: M.levelOrder ?? "—" }),
          /* @__PURE__ */ C.jsx(Ir, { className: "twd-font-semibold", children: `${M.nominalConcentration != null ? CNe(M.nominalConcentration) : "—"} ${M.unit ?? "—"}` }),
          /* @__PURE__ */ C.jsx(Ir, { colSpan: 3 }),
          /* @__PURE__ */ C.jsx(Ir, { children: /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-items-center twd-justify-end twd-gap-1", children: [
            /* @__PURE__ */ C.jsx(rke, { levelId: M.id, nominalConcentration: M.nominalConcentration, unit: M.unit }),
            P ? /* @__PURE__ */ C.jsx("div", { className: "print:twd-hidden", children: /* @__PURE__ */ C.jsx(cl, { icon: /* @__PURE__ */ C.jsx(T_, {}), onClick: F }) }) : /* @__PURE__ */ C.jsx("span", { className: "twd-text-secondary", children: "—" })
          ] }) })
        ] }),
        M.points.length === 0 ? /* @__PURE__ */ C.jsx(rf, { children: /* @__PURE__ */ C.jsx(Ir, { colSpan: 6, className: "twd-text-center twd-py-3 twd-text-secondary", children: $ ? "Standard is archived. Its results are excluded from this calibration." : "No points yet for this level." }) }) : M.points.map((G) => /* @__PURE__ */ C.jsx(L7e, { point: G, onToggle: c.togglePointIncluded, onShowMeasurement: r, highlightedPointId: a, onPointHighlight: s }, G.id))
      ] }, `level-${M.id}`);
    }, e[16] = a, e[17] = s, e[18] = r, e[19] = i, e[20] = c, e[21] = N) : N = e[21], O = m.map(N), e[9] = a, e[10] = m, e[11] = s, e[12] = r, e[13] = i, e[14] = c, e[15] = O;
  } else
    O = e[15];
  let R;
  return e[22] !== O ? (R = /* @__PURE__ */ C.jsx("div", { className: "twd-overflow-auto twd-rounded-md twd-border twd-border-border twd-bg-white", children: /* @__PURE__ */ C.jsxs(Pg, { children: [
    T,
    /* @__PURE__ */ C.jsx(Bg, { children: O })
  ] }) }), e[22] = O, e[23] = R) : R = e[23], R;
}, iU = bi.notEmptyNumericString.and(Je().or(Ve().positive())), ike = Xe({
  start: iU,
  end: iU
}).refine((t) => Number(t.end) >= Number(t.start), {
  message: "End must be greater than start",
  path: ["end"]
});
var mk = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "UpdateCalibrationCompoundInterval" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "peak_detection_start" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "float8" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "peak_detection_end" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "float8" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "update_calibration_compound_by_pk" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "pk_columns" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }] } }, { kind: "Argument", name: { kind: "Name", value: "_set" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "peak_detection_start" }, value: { kind: "Variable", name: { kind: "Name", value: "peak_detection_start" } } }, { kind: "ObjectField", name: { kind: "Name", value: "peak_detection_end" }, value: { kind: "Variable", name: { kind: "Name", value: "peak_detection_end" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "calibration_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "peak_detection_start" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "peak_detection_end" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 389 } };
mk.loc.source = { body: `mutation UpdateCalibrationCompoundInterval(
  $id: Int!
  $peak_detection_start: float8!
  $peak_detection_end: float8!
) {
  update_calibration_compound_by_pk(
    pk_columns: { id: $id }
    _set: {
      peak_detection_start: $peak_detection_start
      peak_detection_end: $peak_detection_end
    }
  ) {
    id
    calibration_id
    peak_detection_start
    peak_detection_end
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function U4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    U4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    U4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    U4(r, e);
  });
}
var MN = {};
(function() {
  mk.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      U4(e, n), MN[e.name.value] = n;
    }
  });
})();
function aU(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function ake(t, e) {
  var n = {
    kind: t.kind,
    definitions: [aU(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = MN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = MN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = aU(t, c);
    d && n.definitions.push(d);
  }), n;
}
const oke = ake(mk, "UpdateCalibrationCompoundInterval"), ske = {
  updateInterval(t, e, n) {
    return lo.httpClientForHasura.fetch(oke, {
      id: t,
      peak_detection_start: e,
      peak_detection_end: n
    });
  }
}, lke = Xe({
  id: Ve(),
  calibrationId: Ve(),
  peakDetectionStart: Ve(),
  peakDetectionEnd: Ve()
}), cke = Xe({
  updateCalibrationCompoundByPk: lke.nullable()
}), uke = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationFn: dke
  }, t[0] = e) : e = t[0], Ei(e);
};
async function dke(t) {
  const e = await ske.updateInterval(t.id, t.peak_detection_start, t.peak_detection_end);
  return qt(cke, e);
}
const oU = {
  start: "0",
  end: "0"
}, fke = (t) => (t ?? 0) / 60, sU = (t) => Ms(fke(t), 3), lU = (t) => Number(t) * 60, hke = (t) => {
  const e = ve.c(18), {
    compound: n
  } = t, r = es(), {
    showDefaultNotification: i,
    showErrorNotification: a
  } = nd(), s = uke(), [c, d] = I.useState(oU), f = n ? `${n.id}-${n.peakDetectionStart}-${n.peakDetectionEnd}` : "none";
  let g;
  e[0] !== n ? (g = () => {
    if (n == null) {
      d(oU);
      return;
    }
    const T = {
      start: sU(n.peakDetectionStart),
      end: sU(n.peakDetectionEnd)
    };
    d(T);
  }, e[0] = n, e[1] = g) : g = e[1];
  let m;
  e[2] !== n || e[3] !== f ? (m = [n, f], e[2] = n, e[3] = f, e[4] = m) : m = e[4], I.useEffect(g, m);
  let b;
  e[5] !== n || e[6] !== r || e[7] !== i || e[8] !== a || e[9] !== s ? (b = async (T) => {
    if (n)
      try {
        await s.mutateAsync({
          id: n.id,
          peak_detection_start: lU(T.start),
          peak_detection_end: lU(T.end)
        }), d({
          start: T.start.toString(),
          end: T.end.toString()
        }), i("Detection interval updated. Recalculation will run automatically.");
      } catch (O) {
        const R = O;
        a("Failed to update detection interval"), r(R);
      }
  }, e[5] = n, e[6] = r, e[7] = i, e[8] = a, e[9] = s, e[10] = b) : b = e[10];
  const w = b;
  let _;
  e[11] !== n ? (_ = n ? [n] : [], e[11] = n, e[12] = _) : _ = e[12];
  let A;
  return e[13] !== c || e[14] !== w || e[15] !== _ || e[16] !== s.isPending ? (A = {
    calibrationCompounds: _,
    interval: c,
    saveInterval: w,
    isSavingInterval: s.isPending
  }, e[13] = c, e[14] = w, e[15] = _, e[16] = s.isPending, e[17] = A) : A = e[17], A;
}, pke = Re.div`
  twd-w-full
`, mke = Re.form`
  twd-flex
  twd-flex-col
  twd-gap-4
`, gke = Re.div`
  twd-grid
  twd-gap-4
  md:twd-grid-cols-2
`, vke = Re.div`
  twd-flex
  twd-w-full
  twd-justify-end
  twd-gap-2
`, yD = vr("EditDetectionIntervalModal"), yke = (t) => {
  const e = ve.c(39), {
    isOpen: n,
    calibrationCompound: r,
    initialInterval: i,
    onClose: a
  } = t;
  let s;
  e[0] !== r ? (s = {
    compound: r
  }, e[0] = r, e[1] = s) : s = e[1];
  const c = hke(s);
  let d;
  e[2] === Symbol.for("react.memo_cache_sentinel") ? (d = td(ike), e[2] = d) : d = e[2];
  let f;
  e[3] !== i ? (f = {
    defaultValues: i,
    resolver: d,
    mode: "onChange"
  }, e[3] = i, e[4] = f) : f = e[4];
  const {
    control: g,
    handleSubmit: m,
    reset: b,
    formState: w
  } = ed(f);
  let _, A;
  e[5] !== r.id || e[6] !== c.interval || e[7] !== n || e[8] !== b ? (_ = () => {
    n && (b(c.interval), yD.debug("Detection interval modal opened, form reset", {
      calibrationCompoundId: r.id
    }));
  }, A = [r.id, c.interval, n, b], e[5] = r.id, e[6] = c.interval, e[7] = n, e[8] = b, e[9] = _, e[10] = A) : (_ = e[9], A = e[10]), I.useEffect(_, A);
  let T;
  e[11] !== r.id || e[12] !== c || e[13] !== a ? (T = async (Z) => {
    yD.info("Saving detection interval", {
      calibrationCompoundId: r.id
    }), await c.saveInterval(Z), yD.info("Detection interval saved", {
      calibrationCompoundId: r.id
    }), a();
  }, e[11] = r.id, e[12] = c, e[13] = a, e[14] = T) : T = e[14];
  let O;
  e[15] !== m || e[16] !== T ? (O = m(T), e[15] = m, e[16] = T, e[17] = O) : O = e[17];
  const R = O;
  let N;
  e[18] !== c.isSavingInterval || e[19] !== a ? (N = /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", onClick: a, isDisabled: c.isSavingInterval, children: "Cancel" }), e[18] = c.isSavingInterval, e[19] = a, e[20] = N) : N = e[20];
  const M = !w.isValid;
  let P;
  e[21] !== c.isSavingInterval || e[22] !== R || e[23] !== M ? (P = /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", onClick: R, isLoading: c.isSavingInterval, isDisabled: M, children: "Save" }), e[21] = c.isSavingInterval, e[22] = R, e[23] = M, e[24] = P) : P = e[24];
  let z;
  e[25] !== P || e[26] !== N ? (z = /* @__PURE__ */ C.jsxs(vke, { children: [
    N,
    P
  ] }), e[25] = P, e[26] = N, e[27] = z) : z = e[27];
  let F;
  e[28] !== g ? (F = /* @__PURE__ */ C.jsxs(gke, { children: [
    /* @__PURE__ */ C.jsx(Zr, { name: "start", control: g, label: "Start (min)", type: "float", isFullWidth: !0 }),
    /* @__PURE__ */ C.jsx(Zr, { name: "end", control: g, label: "End (min)", type: "float", isFullWidth: !0 })
  ] }), e[28] = g, e[29] = F) : F = e[29];
  let $;
  e[30] === Symbol.for("react.memo_cache_sentinel") ? ($ = /* @__PURE__ */ C.jsx("button", { type: "submit", className: "twd-hidden" }), e[30] = $) : $ = e[30];
  let G;
  e[31] !== R || e[32] !== F ? (G = /* @__PURE__ */ C.jsxs(mke, { onSubmit: R, autoComplete: "off", children: [
    F,
    $
  ] }), e[31] = R, e[32] = F, e[33] = G) : G = e[33];
  let H;
  return e[34] !== n || e[35] !== a || e[36] !== z || e[37] !== G ? (H = /* @__PURE__ */ C.jsx(pke, { children: /* @__PURE__ */ C.jsx(Ph, { isOpen: n, onClose: a, title: "Edit detection interval", footer: z, children: G }) }), e[34] = n, e[35] = a, e[36] = z, e[37] = G, e[38] = H) : H = e[38], H;
}, bke = Re.div`
  twd-inline-flex
  print:twd-hidden
`, cU = vr("EditDetectionIntervalButton"), wke = (t) => {
  const e = ve.c(15), {
    calibrationCompound: n,
    currentInterval: r
  } = t, [i, a] = I.useState(!1);
  let s;
  e[0] !== n.id ? (s = (_) => {
    _.stopPropagation(), cU.debug("Opening detection interval modal", {
      calibrationCompoundId: n.id
    }), a(!0);
  }, e[0] = n.id, e[1] = s) : s = e[1];
  const c = s;
  let d;
  e[2] !== n.id ? (d = () => {
    cU.debug("Closing detection interval modal", {
      calibrationCompoundId: n.id
    }), a(!1);
  }, e[2] = n.id, e[3] = d) : d = e[3];
  const f = d;
  let g;
  e[4] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ C.jsx(lw, { className: "twd-h-4 twd-w-4" }), e[4] = g) : g = e[4];
  let m;
  e[5] !== c ? (m = /* @__PURE__ */ C.jsx(cl, { icon: g, onClick: c }), e[5] = c, e[6] = m) : m = e[6];
  let b;
  e[7] !== n || e[8] !== r || e[9] !== f || e[10] !== i ? (b = /* @__PURE__ */ C.jsx(yke, { isOpen: i, calibrationCompound: n, initialInterval: r, onClose: f }), e[7] = n, e[8] = r, e[9] = f, e[10] = i, e[11] = b) : b = e[11];
  let w;
  return e[12] !== m || e[13] !== b ? (w = /* @__PURE__ */ C.jsxs(bke, { children: [
    m,
    b
  ] }), e[12] = m, e[13] = b, e[14] = w) : w = e[14], w;
}, bD = Re.div`
  twd-w-full
`, xke = Re.div`
  twd-overflow-x-auto
  twd-rounded-md
  twd-border
  twd-border-border
  twd-bg-white
`, Ske = Re.div`
  twd-text-secondary
`, wD = vr("DetectionInterval"), hJ = (t) => {
  const e = ve.c(11), {
    calibrationId: n
  } = t, {
    data: r,
    isLoading: i
  } = vO(n), a = r?.calibrationCompound ?? null, {
    markReady: s
  } = B_(`detection-interval-${n}`);
  let c;
  e[0] !== a ? (c = a == null ? [] : [{
    id: a.id,
    start: Ms(a.peakDetectionStart / 60, 3),
    end: Ms(a.peakDetectionEnd / 60, 3),
    window: Ms((a.peakDetectionEnd - a.peakDetectionStart) / 60, 3),
    interval: {
      start: Ms(a.peakDetectionStart / 60, 3),
      end: Ms(a.peakDetectionEnd / 60, 3)
    },
    calibrationCompound: a
  }], e[0] = a, e[1] = c) : c = e[1];
  const d = c;
  let f, g;
  if (e[2] !== i || e[3] !== s ? (f = () => {
    i || s();
  }, g = [i, s], e[2] = i, e[3] = s, e[4] = f, e[5] = g) : (f = e[4], g = e[5]), I.useEffect(f, g), wD.debug("Detection interval data resolved", {
    calibrationId: n,
    hasCompound: a != null
  }), i && d.length === 0) {
    wD.debug("Detection interval loading");
    let w;
    return e[6] === Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ C.jsx(bD, { children: /* @__PURE__ */ C.jsx(aa, { message: "Loading detection interval" }) }), e[6] = w) : w = e[6], w;
  }
  if (d.length === 0) {
    wD.warn("Detection interval not configured", {
      calibrationId: n
    });
    let w;
    return e[7] === Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ C.jsx(bD, { children: /* @__PURE__ */ C.jsx(Ske, { children: "No detection interval configured." }) }), e[7] = w) : w = e[7], w;
  }
  let m;
  e[8] === Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ C.jsx(Lg, { children: /* @__PURE__ */ C.jsxs("tr", { children: [
    /* @__PURE__ */ C.jsx(wi, { children: "Start (min)" }),
    /* @__PURE__ */ C.jsx(wi, { children: "End (min)" }),
    /* @__PURE__ */ C.jsx(wi, { children: "Window (min)" }),
    /* @__PURE__ */ C.jsx(wi, { className: "print:twd-hidden" })
  ] }) }), e[8] = m) : m = e[8];
  let b;
  return e[9] !== d ? (b = /* @__PURE__ */ C.jsx(bD, { children: /* @__PURE__ */ C.jsx(xke, { children: /* @__PURE__ */ C.jsxs(Pg, { children: [
    m,
    /* @__PURE__ */ C.jsx(Bg, { children: d.map(Eke) })
  ] }) }) }), e[9] = d, e[10] = b) : b = e[10], b;
};
function Eke(t) {
  return /* @__PURE__ */ C.jsxs(rf, { children: [
    /* @__PURE__ */ C.jsx(Ir, { children: t.start }),
    /* @__PURE__ */ C.jsx(Ir, { children: t.end }),
    /* @__PURE__ */ C.jsx(Ir, { children: t.window }),
    /* @__PURE__ */ C.jsx(Ir, { className: "twd-text-right print:twd-hidden", children: /* @__PURE__ */ C.jsx(wke, { calibrationCompound: t.calibrationCompound, currentInterval: t.interval }) })
  ] }, t.id);
}
const _ke = Xe({
  name: bi.notEmptyString
});
var gk = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "UpdateCompoundName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "name" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "update_compounds_by_pk" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "pk_columns" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }] } }, { kind: "Argument", name: { kind: "Name", value: "_set" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "name" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 154 } };
gk.loc.source = { body: `mutation UpdateCompoundName($id: Int!, $name: String!) {
  update_compounds_by_pk(pk_columns: { id: $id }, _set: { name: $name }) {
    id
    name
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function $4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    $4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    $4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    $4(r, e);
  });
}
var IN = {};
(function() {
  gk.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      $4(e, n), IN[e.name.value] = n;
    }
  });
})();
function uU(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function Ake(t, e) {
  var n = {
    kind: t.kind,
    definitions: [uU(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = IN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = IN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = uU(t, c);
    d && n.definitions.push(d);
  }), n;
}
const Cke = Ake(gk, "UpdateCompoundName"), Tke = {
  updateCompoundName(t, e) {
    return lo.httpClientForHasura.fetch(Cke, {
      id: t,
      name: e
    });
  }
}, Oke = Xe({
  id: Ve(),
  name: Je()
}), Rke = Xe({
  updateCompoundsByPk: Oke.nullable()
}), Dke = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationFn: Nke
  }, t[0] = e) : e = t[0], Ei(e);
};
async function Nke(t) {
  const {
    compoundId: e,
    name: n
  } = t, r = await Tke.updateCompoundName(e, n);
  return qt(Rke, r);
}
const YC = vr("EditCompoundModal"), Mke = (t) => {
  const e = ve.c(41), {
    isOpen: n,
    compoundId: r,
    currentName: i,
    onClose: a
  } = t, s = i ?? `Compound ${r}`, c = es(), d = Dke(), f = i ?? "";
  let g;
  e[0] !== f ? (g = {
    name: f
  }, e[0] = f, e[1] = g) : g = e[1];
  let m;
  e[2] === Symbol.for("react.memo_cache_sentinel") ? (m = td(_ke), e[2] = m) : m = e[2];
  let b;
  e[3] !== g ? (b = {
    defaultValues: g,
    resolver: m,
    mode: "onChange"
  }, e[3] = g, e[4] = b) : b = e[4];
  const {
    control: w,
    handleSubmit: _,
    formState: A,
    reset: T
  } = ed(b);
  let O, R;
  e[5] !== r || e[6] !== i || e[7] !== n || e[8] !== T ? (O = () => {
    n && (T({
      name: i ?? ""
    }), YC.debug("Compound modal opened, form reset", {
      compoundId: r
    }));
  }, R = [r, i, n, T], e[5] = r, e[6] = i, e[7] = n, e[8] = T, e[9] = O, e[10] = R) : (O = e[9], R = e[10]), I.useEffect(O, R);
  let N;
  e[11] !== r || e[12] !== c || e[13] !== a || e[14] !== d ? (N = async (ee) => {
    const {
      name: K
    } = ee;
    try {
      YC.info("Updating compound name", {
        compoundId: r
      }), await d.mutateAsync({
        compoundId: r,
        name: K.trim()
      }), YC.info("Compound name updated", {
        compoundId: r
      }), a();
    } catch (U) {
      const q = U;
      YC.error("Failed to update compound name", q), c(q);
    }
  }, e[11] = r, e[12] = c, e[13] = a, e[14] = d, e[15] = N) : N = e[15];
  let M;
  e[16] !== _ || e[17] !== N ? (M = _(N), e[16] = _, e[17] = N, e[18] = M) : M = e[18];
  const P = M;
  let z;
  e[19] !== a || e[20] !== d.isPending ? (z = /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", onClick: a, isDisabled: d.isPending, children: "Cancel" }), e[19] = a, e[20] = d.isPending, e[21] = z) : z = e[21];
  const F = !A.isValid || !A.isDirty;
  let $;
  e[22] !== P || e[23] !== F || e[24] !== d.isPending ? ($ = /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", onClick: P, isLoading: d.isPending, isDisabled: F, children: "Save" }), e[22] = P, e[23] = F, e[24] = d.isPending, e[25] = $) : $ = e[25];
  let G;
  e[26] !== $ || e[27] !== z ? (G = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-w-full twd-justify-end twd-gap-2", children: [
    z,
    $
  ] }), e[26] = $, e[27] = z, e[28] = G) : G = e[28];
  let H;
  e[29] !== w || e[30] !== s ? (H = /* @__PURE__ */ C.jsx(Zr, { name: "name", control: w, label: "Name", placeholder: s, isFullWidth: !0 }), e[29] = w, e[30] = s, e[31] = H) : H = e[31];
  let Z;
  e[32] === Symbol.for("react.memo_cache_sentinel") ? (Z = /* @__PURE__ */ C.jsx("button", { type: "submit", className: "twd-hidden" }), e[32] = Z) : Z = e[32];
  let V;
  e[33] !== P || e[34] !== H ? (V = /* @__PURE__ */ C.jsxs("form", { className: "twd-flex twd-flex-col twd-gap-4", onSubmit: P, children: [
    H,
    Z
  ] }), e[33] = P, e[34] = H, e[35] = V) : V = e[35];
  let Y;
  return e[36] !== n || e[37] !== a || e[38] !== G || e[39] !== V ? (Y = /* @__PURE__ */ C.jsx(Ph, { isOpen: n, onClose: a, title: "Rename compound", footer: G, children: V }), e[36] = n, e[37] = a, e[38] = G, e[39] = V, e[40] = Y) : Y = e[40], Y;
}, Ike = Re.div`
  twd-inline-flex
  print:twd-hidden
`, dU = vr("EditCompoundButton"), kke = (t) => {
  const e = ve.c(15), {
    compoundId: n,
    currentName: r
  } = t, [i, a] = I.useState(!1);
  let s;
  e[0] !== n ? (s = (_) => {
    _.stopPropagation(), dU.debug("Opening compound modal", {
      compoundId: n
    }), a(!0);
  }, e[0] = n, e[1] = s) : s = e[1];
  const c = s;
  let d;
  e[2] !== n ? (d = () => {
    dU.debug("Closing compound modal", {
      compoundId: n
    }), a(!1);
  }, e[2] = n, e[3] = d) : d = e[3];
  const f = d;
  let g;
  e[4] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ C.jsx(lw, { className: "twd-h-4 twd-w-4" }), e[4] = g) : g = e[4];
  let m;
  e[5] !== c ? (m = /* @__PURE__ */ C.jsx(cl, { icon: g, onClick: c }), e[5] = c, e[6] = m) : m = e[6];
  let b;
  e[7] !== n || e[8] !== r || e[9] !== f || e[10] !== i ? (b = /* @__PURE__ */ C.jsx(Mke, { isOpen: i, compoundId: n, currentName: r, onClose: f }), e[7] = n, e[8] = r, e[9] = f, e[10] = i, e[11] = b) : b = e[11];
  let w;
  return e[12] !== m || e[13] !== b ? (w = /* @__PURE__ */ C.jsxs(Ike, { children: [
    m,
    b
  ] }), e[12] = m, e[13] = b, e[14] = w) : w = e[14], w;
}, xD = Re.div`
  twd-w-full
`, jke = Re.div`
  twd-text-secondary
`, Pke = (t) => {
  const e = ve.c(14), {
    calibrationId: n
  } = t, {
    data: r,
    isLoading: i
  } = vO(n), a = r?.calibrationCompound ?? null, s = a?.compound ?? null, c = a?.compoundId ?? null, {
    markReady: d
  } = B_(`compound-${n}`);
  let f, g;
  if (e[0] !== i || e[1] !== d ? (f = () => {
    i || d();
  }, g = [i, d], e[0] = i, e[1] = d, e[2] = f, e[3] = g) : (f = e[2], g = e[3]), I.useEffect(f, g), i && c == null) {
    let _;
    return e[4] === Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ C.jsx(xD, { children: /* @__PURE__ */ C.jsx(aa, { message: "Loading compound" }) }), e[4] = _) : _ = e[4], _;
  }
  if (c == null || s == null) {
    let _;
    return e[5] === Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ C.jsx(xD, { children: /* @__PURE__ */ C.jsx(jke, { children: "No compound configured." }) }), e[5] = _) : _ = e[5], _;
  }
  let m;
  e[6] !== s.name ? (m = /* @__PURE__ */ C.jsx("div", { children: s.name }), e[6] = s.name, e[7] = m) : m = e[7];
  let b;
  e[8] !== s.name || e[9] !== c ? (b = /* @__PURE__ */ C.jsx(kke, { compoundId: c, currentName: s.name }), e[8] = s.name, e[9] = c, e[10] = b) : b = e[10];
  let w;
  return e[11] !== m || e[12] !== b ? (w = /* @__PURE__ */ C.jsx(xD, { children: /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-items-center twd-gap-2", children: [
    m,
    b
  ] }) }), e[11] = m, e[12] = b, e[13] = w) : w = e[13], w;
}, Lke = Xe({
  id: Ve(),
  name: Je().nullable(),
  archived: Sr().nullable(),
  primaryMeasurementId: Ve().nullable()
}), Bke = Xe({
  id: Ve(),
  mps: Ve().nullable(),
  type: Je().nullable(),
  dataUrl: Je().nullable().optional(),
  processedDataUrl: Je().nullable(),
  injection: Lke.nullable(),
  data: Xr(Ve()).nullable().optional()
}), zke = Xe({
  measurement: Xr(Bke)
});
var vk = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "subscription", name: { kind: "Name", value: "CalibrationMeasurementData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "measurementIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "measurement" }, name: { kind: "Name", value: "siebox_measurement" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "where" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_in" }, value: { kind: "Variable", name: { kind: "Name", value: "measurementIds" } } }] } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "mps" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "type" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "processed_data_url" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "injection" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "archived" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "primary_measurement_id" }, arguments: [], directives: [] }] } }] } }] } }], loc: { start: 0, end: 284 } };
vk.loc.source = { body: `subscription CalibrationMeasurementData($measurementIds: [Int!]!) {
  measurement: siebox_measurement(where: { id: { _in: $measurementIds } }) {
    id
    mps
    type
    processed_data_url
    injection {
      id
      name
      archived
      primary_measurement_id
    }
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function H4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    H4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    H4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    H4(r, e);
  });
}
var kN = {};
(function() {
  vk.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      H4(e, n), kN[e.name.value] = n;
    }
  });
})();
function fU(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function Fke(t, e) {
  var n = {
    kind: t.kind,
    definitions: [fU(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = kN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = kN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = fU(t, c);
    d && n.definitions.push(d);
  }), n;
}
const Vke = Fke(vk, "CalibrationMeasurementData"), fb = /* @__PURE__ */ new Map(), hU = (t) => t.processedDataUrl ?? t.dataUrl ?? null, Uke = (t) => t === ".bin" ? "f16" : t === ".f32.bin" ? "f32" : null, $ke = (t) => {
  try {
    return new URL(t).pathname.split("/").pop() ?? "";
  } catch {
    return "";
  }
}, Hke = (t, e) => t === "f32" ? new Float32Array(e) : t === "f16" ? e.byteLength % 4 === 0 ? new Float32Array(e) : new Float32Array(0) : e.byteLength % 4 === 0 ? new Float32Array(e) : new Float32Array(0), pJ = (t) => t.includes("localhost") && window.location.href.includes("/share/#/reports/") ? t.replace("localhost", "host.docker.internal") : t, qke = async (t, e) => {
  try {
    const n = pJ(t), r = await fetch(n, {
      signal: e
    });
    if (!r.ok)
      throw new Error(`Failed to load data from ${t}`);
    const i = await r.arrayBuffer(), s = $ke(n).match(/(\.[0-9a-z]+)+$/i)?.[0] ?? "", c = Uke(s), d = Hke(c, i);
    return d.length === 0 ? null : Array.from(d);
  } catch (n) {
    if (n instanceof Error && n.name === "AbortError")
      throw n;
    return console.error("Failed to load binary data:", n), null;
  }
}, Gke = (t) => {
  if (Array.isArray(t))
    return t.map((e) => typeof e == "number" ? e : Number(e) || 0);
  if (t && typeof t == "object") {
    const e = t, n = e.data ?? e.values;
    if (Array.isArray(n))
      return n.map((r) => typeof r == "number" ? r : Number(r) || 0);
  }
  return null;
}, Yke = (t) => {
  const e = ve.c(35), n = t.length > 0;
  let r;
  e[0] !== n || e[1] !== t ? (r = n ? t : [-1], e[0] = n, e[1] = t, e[2] = r) : r = e[2];
  const i = r;
  let a;
  e[3] !== i ? (a = {
    measurementIds: i
  }, e[3] = i, e[4] = a) : a = e[4];
  const c = Q5("CalibrationMeasurementData", Vke, a);
  let d;
  if (e[5] !== n || e[6] !== c.data) {
    e: {
      if (!n) {
        let U;
        e[8] === Symbol.for("react.memo_cache_sentinel") ? (U = {
          measurements: [],
          parseError: null
        }, e[8] = U) : U = e[8], d = U;
        break e;
      }
      if (!c.data) {
        let U;
        e[9] === Symbol.for("react.memo_cache_sentinel") ? (U = {
          measurements: [],
          parseError: null
        }, e[9] = U) : U = e[9], d = U;
        break e;
      }
      try {
        d = {
          measurements: qt(zke, c.data).measurement,
          parseError: null
        };
      } catch (U) {
        const q = U;
        console.error("Failed to parse calibration measurements", q);
        let W;
        e[10] === Symbol.for("react.memo_cache_sentinel") ? (W = [], e[10] = W) : W = e[10], d = {
          measurements: W,
          parseError: new iw("Schema parse error", {
            cause: q,
            props: {
              source: "calibration measurements"
            }
          })
        };
      }
    }
    e[5] = n, e[6] = c.data, e[7] = d;
  } else
    d = e[7];
  const {
    measurements: f,
    parseError: g
  } = d;
  let m;
  e[11] === Symbol.for("react.memo_cache_sentinel") ? (m = {}, e[11] = m) : m = e[11];
  const [b, w] = I.useState(m);
  let _;
  e[12] === Symbol.for("react.memo_cache_sentinel") ? (_ = {}, e[12] = _) : _ = e[12];
  const [A, T] = I.useState(_);
  let O;
  e[13] === Symbol.for("react.memo_cache_sentinel") ? (O = /* @__PURE__ */ new Map(), e[13] = O) : O = e[13];
  const R = I.useRef(O);
  let N, M;
  e[14] !== n || e[15] !== f ? (N = () => {
    if (!n) {
      w({}), T({}), R.current.clear();
      return;
    }
    w((q) => {
      const W = {};
      return f.forEach((ie) => {
        const J = fb.get(ie.id);
        if (J?.data != null) {
          W[ie.id] = J.data;
          return;
        }
        const B = q[ie.id];
        B != null && (W[ie.id] = B);
      }), W;
    }), T((q) => {
      const W = {};
      return f.forEach((ie) => {
        const J = hU(ie), B = fb.get(ie.id);
        B?.data != null ? W[ie.id] = J && B.signature !== J ? "loading" : "loaded" : J ? W[ie.id] = "loading" : W[ie.id] = "failed";
      }), W;
    });
    const U = new Set(f.map(Xke));
    R.current.forEach((q, W) => {
      U.has(W) || R.current.delete(W);
    });
  }, M = [n, f], e[14] = n, e[15] = f, e[16] = N, e[17] = M) : (N = e[16], M = e[17]), I.useEffect(N, M);
  let P, z;
  e[18] !== n || e[19] !== f ? (P = () => {
    if (!n || f.length === 0)
      return;
    const U = [];
    return f.forEach((q) => {
      const W = hU(q);
      if (!W) {
        T((ae) => ({
          ...ae,
          [q.id]: "failed"
        })), w((ae) => ({
          ...ae,
          [q.id]: null
        })), fb.delete(q.id), R.current.delete(q.id);
        return;
      }
      const ie = fb.get(q.id);
      if (ie?.data != null && ie.signature === W || R.current.get(q.id) === W)
        return;
      R.current.set(q.id, W), T((ae) => ({
        ...ae,
        [q.id]: "loading"
      }));
      const B = new AbortController();
      U.push(B);
      const te = (ae) => {
        R.current.delete(q.id), ae != null ? (fb.set(q.id, {
          signature: W,
          data: ae
        }), w((le) => ({
          ...le,
          [q.id]: ae
        })), T((le) => ({
          ...le,
          [q.id]: "loaded"
        }))) : (fb.delete(q.id), w((le) => ({
          ...le,
          [q.id]: null
        })), T((le) => ({
          ...le,
          [q.id]: "failed"
        })));
      };
      qke(W, B.signal).then((ae) => {
        if (ae && ae.length > 0) {
          te(ae);
          return;
        }
        const le = pJ(W);
        return fetch(le, {
          signal: B.signal
        }).then((de) => {
          if (!de.ok)
            throw new Error(`Failed to load measurement ${q.id}`);
          return de.json();
        }).then((de) => {
          const _e = Gke(de);
          te(_e);
        });
      }).catch((ae) => {
        if (ae instanceof Error && ae.name === "AbortError") {
          R.current.delete(q.id);
          return;
        }
        console.error(`Failed to fetch data for measurement ${q.id}:`, ae), te(null);
      });
    }), () => {
      U.forEach(Wke);
    };
  }, z = [n, f], e[18] = n, e[19] = f, e[20] = P, e[21] = z) : (P = e[20], z = e[21]), I.useEffect(P, z);
  let F;
  if (e[22] !== A || e[23] !== f || e[24] !== b) {
    let U;
    e[26] !== A || e[27] !== b ? (U = (q) => ({
      ...q,
      data: b[q.id] ?? null,
      dataStatus: A[q.id] ?? "idle"
    }), e[26] = A, e[27] = b, e[28] = U) : U = e[28], F = f.map(U), e[22] = A, e[23] = f, e[24] = b, e[25] = F;
  } else
    F = e[25];
  const $ = F, G = Object.values(A).some(Qke), Z = n && (c.isLoading || c.isFetching || f.length === 0) || G, V = n ? c.isLoading : !1, Y = n ? c.isFetching : !1, ee = c.error ?? g;
  let K;
  return e[29] !== Z || e[30] !== $ || e[31] !== V || e[32] !== Y || e[33] !== ee ? (K = {
    data: $,
    isLoading: V,
    isFetching: Y,
    isDataLoading: Z,
    error: ee
  }, e[29] = Z, e[30] = $, e[31] = V, e[32] = Y, e[33] = ee, e[34] = K) : K = e[34], K;
};
function Xke(t) {
  return t.id;
}
function Wke(t) {
  return t.abort();
}
function Qke(t) {
  return t === "loading";
}
const Zke = (t) => {
  const e = ve.c(21), n = lJ(t), r = uk(t);
  let i;
  e[0] !== n.data ? (i = n.data ?? [], e[0] = n.data, e[1] = i) : i = e[1];
  const a = i;
  let s;
  if (e[2] !== a) {
    const M = /* @__PURE__ */ new Set();
    a.forEach((P) => {
      P.points.filter(Kke).forEach((z) => {
        z.measurementId != null && M.add(z.measurementId);
      });
    }), s = Array.from(M.values()), e[2] = a, e[3] = s;
  } else
    s = e[3];
  const d = Yke(s);
  let f;
  e[4] !== d.data ? (f = /* @__PURE__ */ new Map(), (d.data ?? []).forEach((P) => {
    f.set(P.id, P);
  }), e[4] = d.data, e[5] = f) : f = e[5];
  const g = f;
  let m;
  if (e[6] !== a || e[7] !== g) {
    let M;
    e[9] !== g ? (M = (P) => {
      const z = P.nominalConcentration ?? null, F = P.unit ?? null;
      return {
        id: P.id,
        levelOrder: P.levelOrder ?? null,
        amount: z,
        unit: F,
        injections: P.points.filter(Jke).map(($) => {
          const G = $.measurementId != null ? g.get($.measurementId) ?? null : null, H = G?.injection ?? null;
          return {
            id: H?.id ?? $.id,
            pointId: $.id,
            measurementId: $.measurementId ?? null,
            amount: z,
            unit: F,
            area: $.area ?? null,
            retentionTime: $.rt ?? null,
            included: $.included ?? !1,
            archived: !!H?.archived,
            name: H?.name ?? `Injection ${$.id}`,
            primaryMeasurementId: H?.primaryMeasurementId ?? G?.id ?? $.measurementId ?? null,
            measurement: G
          };
        })
      };
    }, e[9] = g, e[10] = M) : M = e[10], m = a.map(M), e[6] = a, e[7] = g, e[8] = m;
  } else
    m = e[8];
  const b = m;
  let w;
  if (e[11] !== a) {
    e: {
      for (const M of a)
        if (M.unit) {
          w = M.unit;
          break e;
        }
      w = null;
    }
    e[11] = a, e[12] = w;
  } else
    w = e[12];
  const _ = w;
  let A;
  e: {
    if (!r.data) {
      A = null;
      break e;
    }
    let M;
    e[13] !== r.data ? (M = uJ(r.data), e[13] = r.data, e[14] = M) : M = e[14], A = M;
  }
  const T = A, O = !!(n.isLoading || r.isLoading || d.isLoading || n.isFetching || r.isFetching || d.isFetching), R = d.isDataLoading ?? !1;
  let N;
  return e[15] !== O || e[16] !== T || e[17] !== b || e[18] !== R || e[19] !== _ ? (N = {
    standards: b,
    k: T,
    unit: _,
    isLoading: O,
    isChromatogramsLoading: R
  }, e[15] = O, e[16] = T, e[17] = b, e[18] = R, e[19] = _, e[20] = N) : N = e[20], N;
};
function Kke(t) {
  return t.included === !0;
}
function Jke(t) {
  return t.included === !0;
}
const jN = {}, mJ = [];
function Tn(t, e) {
  if (Array.isArray(t)) {
    for (const n of t)
      Tn(n, e);
    return;
  }
  if (typeof t == "object") {
    for (const n in t)
      Tn(n, t[n]);
    return;
  }
  gJ(Object.getOwnPropertyNames(e)), jN[t] = Object.assign(jN[t] || {}, e);
}
function ul(t) {
  return jN[t] || {};
}
function e9e() {
  return [...new Set(mJ)];
}
function gJ(t) {
  mJ.push(...t);
}
function yk(t, e) {
  let n;
  const r = t.length, i = [];
  for (n = 0; n < r; n++)
    i.push(e(t[n]));
  return i;
}
function t9e(t, e) {
  let n;
  const r = t.length, i = [];
  for (n = 0; n < r; n++)
    e(t[n]) && i.push(t[n]);
  return i;
}
function SD(t) {
  return t % 360 * Math.PI / 180;
}
function n9e(t) {
  return t.replace(/([A-Z])/g, function(e, n) {
    return "-" + n.toLowerCase();
  });
}
function vJ(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function Ew(t, e, n, r) {
  return (e == null || n == null) && (r = r || t.bbox(), e == null ? e = r.width / r.height * n : n == null && (n = r.height / r.width * e)), {
    width: e,
    height: n
  };
}
function PN(t, e) {
  const n = t.origin;
  let r = t.ox != null ? t.ox : t.originX != null ? t.originX : "center", i = t.oy != null ? t.oy : t.originY != null ? t.originY : "center";
  n != null && ([r, i] = Array.isArray(n) ? n : typeof n == "object" ? [n.x, n.y] : [n, n]);
  const a = typeof r == "string", s = typeof i == "string";
  if (a || s) {
    const { height: c, width: d, x: f, y: g } = e.bbox();
    a && (r = r.includes("left") ? f : r.includes("right") ? f + d : f + d / 2), s && (i = i.includes("top") ? g : i.includes("bottom") ? g + c : g + c / 2);
  }
  return [r, i];
}
const r9e = /* @__PURE__ */ new Set(["desc", "metadata", "title"]), LN = (t) => r9e.has(t.nodeName), yJ = (t, e, n = {}) => {
  const r = { ...e };
  for (const i in r)
    r[i].valueOf() === n[i] && delete r[i];
  Object.keys(r).length ? t.node.setAttribute("data-svgjs", JSON.stringify(r)) : (t.node.removeAttribute("data-svgjs"), t.node.removeAttribute("svgjs:data"));
}, bk = "http://www.w3.org/2000/svg", i9e = "http://www.w3.org/1999/xhtml", ED = "http://www.w3.org/2000/xmlns/", z_ = "http://www.w3.org/1999/xlink", rr = {
  window: typeof window > "u" ? null : window,
  document: typeof document > "u" ? null : document
};
function a9e() {
  return rr.window;
}
class wk {
  // constructor (node/*, {extensions = []} */) {
  //   // this.tags = []
  //   //
  //   // for (let extension of extensions) {
  //   //   extension.setup.call(this, node)
  //   //   this.tags.push(extension.name)
  //   // }
  // }
}
const dg = {}, xk = "___SYMBOL___ROOT___";
function c_(t, e = bk) {
  return rr.document.createElementNS(e, t);
}
function Is(t, e = !1) {
  if (t instanceof wk)
    return t;
  if (typeof t == "object")
    return _D(t);
  if (t == null)
    return new dg[xk]();
  if (typeof t == "string" && t.trim().charAt(0) !== "<")
    return _D(rr.document.querySelector(t));
  const n = e ? rr.document.createElement("div") : c_("svg");
  return n.innerHTML = t.trim(), t = _D(n.firstElementChild), n.removeChild(n.firstElementChild), t;
}
function _i(t, e) {
  return e && (e instanceof rr.window.Node || e.ownerDocument && e instanceof e.ownerDocument.defaultView.Node) ? e : c_(t);
}
function qc(t) {
  if (!t)
    return null;
  if (t.instance instanceof wk)
    return t.instance;
  if (t.nodeName === "#document-fragment")
    return new dg.Fragment(t);
  let e = vJ(t.nodeName || "Dom");
  return e === "LinearGradient" || e === "RadialGradient" ? e = "Gradient" : dg[e] || (e = "Dom"), new dg[e](t);
}
let _D = qc;
function ir(t, e = t.name, n = !1) {
  return dg[e] = t, n && (dg[xk] = t), gJ(Object.getOwnPropertyNames(t.prototype)), t;
}
function o9e(t) {
  return dg[t];
}
let s9e = 1e3;
function bJ(t) {
  return "Svgjs" + vJ(t) + s9e++;
}
function wJ(t) {
  for (let e = t.children.length - 1; e >= 0; e--)
    wJ(t.children[e]);
  return t.id && (t.id = bJ(t.nodeName)), t;
}
function Gn(t, e) {
  let n, r;
  for (t = Array.isArray(t) ? t : [t], r = t.length - 1; r >= 0; r--)
    for (n in e)
      t[r].prototype[n] = e[n];
}
function Si(t) {
  return function(...e) {
    const n = e[e.length - 1];
    return n && n.constructor === Object && !(n instanceof Array) ? t.apply(this, e.slice(0, -1)).attr(n) : t.apply(this, e);
  };
}
function l9e() {
  return this.parent().children();
}
function c9e() {
  return this.parent().index(this);
}
function u9e() {
  return this.siblings()[this.position() + 1];
}
function d9e() {
  return this.siblings()[this.position() - 1];
}
function f9e() {
  const t = this.position();
  return this.parent().add(this.remove(), t + 1), this;
}
function h9e() {
  const t = this.position();
  return this.parent().add(this.remove(), t ? t - 1 : 0), this;
}
function p9e() {
  return this.parent().add(this.remove()), this;
}
function m9e() {
  return this.parent().add(this.remove(), 0), this;
}
function g9e(t) {
  t = Is(t), t.remove();
  const e = this.position();
  return this.parent().add(t, e), this;
}
function v9e(t) {
  t = Is(t), t.remove();
  const e = this.position();
  return this.parent().add(t, e + 1), this;
}
function y9e(t) {
  return t = Is(t), t.before(this), this;
}
function b9e(t) {
  return t = Is(t), t.after(this), this;
}
Tn("Dom", {
  siblings: l9e,
  position: c9e,
  next: u9e,
  prev: d9e,
  forward: f9e,
  backward: h9e,
  front: p9e,
  back: m9e,
  before: g9e,
  after: v9e,
  insertBefore: y9e,
  insertAfter: b9e
});
const xJ = /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i, w9e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, x9e = /rgb\((\d+),(\d+),(\d+)\)/, S9e = /(#[a-z_][a-z0-9\-_]*)/i, E9e = /\)\s*,?\s*/, _9e = /\s/g, pU = /^#[a-f0-9]{3}$|^#[a-f0-9]{6}$/i, mU = /^rgb\(/, gU = /^(\s+)?$/, vU = /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, A9e = /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i, Bh = /[\s,]+/, Sk = /[MLHVCSQTAZ]/i;
function C9e() {
  const t = this.attr("class");
  return t == null ? [] : t.trim().split(Bh);
}
function T9e(t) {
  return this.classes().indexOf(t) !== -1;
}
function O9e(t) {
  if (!this.hasClass(t)) {
    const e = this.classes();
    e.push(t), this.attr("class", e.join(" "));
  }
  return this;
}
function R9e(t) {
  return this.hasClass(t) && this.attr(
    "class",
    this.classes().filter(function(e) {
      return e !== t;
    }).join(" ")
  ), this;
}
function D9e(t) {
  return this.hasClass(t) ? this.removeClass(t) : this.addClass(t);
}
Tn("Dom", {
  classes: C9e,
  hasClass: T9e,
  addClass: O9e,
  removeClass: R9e,
  toggleClass: D9e
});
function N9e(t, e) {
  const n = {};
  if (arguments.length === 0)
    return this.node.style.cssText.split(/\s*;\s*/).filter(function(r) {
      return !!r.length;
    }).forEach(function(r) {
      const i = r.split(/\s*:\s*/);
      n[i[0]] = i[1];
    }), n;
  if (arguments.length < 2) {
    if (Array.isArray(t)) {
      for (const r of t) {
        const i = r;
        n[r] = this.node.style.getPropertyValue(i);
      }
      return n;
    }
    if (typeof t == "string")
      return this.node.style.getPropertyValue(t);
    if (typeof t == "object")
      for (const r in t)
        this.node.style.setProperty(
          r,
          t[r] == null || gU.test(t[r]) ? "" : t[r]
        );
  }
  return arguments.length === 2 && this.node.style.setProperty(
    t,
    e == null || gU.test(e) ? "" : e
  ), this;
}
function M9e() {
  return this.css("display", "");
}
function I9e() {
  return this.css("display", "none");
}
function k9e() {
  return this.css("display") !== "none";
}
Tn("Dom", {
  css: N9e,
  show: M9e,
  hide: I9e,
  visible: k9e
});
function j9e(t, e, n) {
  if (t == null)
    return this.data(
      yk(
        t9e(
          this.node.attributes,
          (r) => r.nodeName.indexOf("data-") === 0
        ),
        (r) => r.nodeName.slice(5)
      )
    );
  if (t instanceof Array) {
    const r = {};
    for (const i of t)
      r[i] = this.data(i);
    return r;
  } else if (typeof t == "object")
    for (e in t)
      this.data(e, t[e]);
  else if (arguments.length < 2)
    try {
      return JSON.parse(this.attr("data-" + t));
    } catch {
      return this.attr("data-" + t);
    }
  else
    this.attr(
      "data-" + t,
      e === null ? null : n === !0 || typeof e == "string" || typeof e == "number" ? e : JSON.stringify(e)
    );
  return this;
}
Tn("Dom", { data: j9e });
function P9e(t, e) {
  if (typeof arguments[0] == "object")
    for (const n in t)
      this.remember(n, t[n]);
  else {
    if (arguments.length === 1)
      return this.memory()[t];
    this.memory()[t] = e;
  }
  return this;
}
function L9e() {
  if (arguments.length === 0)
    this._memory = {};
  else
    for (let t = arguments.length - 1; t >= 0; t--)
      delete this.memory()[arguments[t]];
  return this;
}
function B9e() {
  return this._memory = this._memory || {};
}
Tn("Dom", { remember: P9e, forget: L9e, memory: B9e });
function z9e(t) {
  return t.length === 4 ? [
    "#",
    t.substring(1, 2),
    t.substring(1, 2),
    t.substring(2, 3),
    t.substring(2, 3),
    t.substring(3, 4),
    t.substring(3, 4)
  ].join("") : t;
}
function F9e(t) {
  const e = Math.round(t), r = Math.max(0, Math.min(255, e)).toString(16);
  return r.length === 1 ? "0" + r : r;
}
function hb(t, e) {
  for (let n = e.length; n--; )
    if (t[e[n]] == null)
      return !1;
  return !0;
}
function V9e(t, e) {
  const n = hb(t, "rgb") ? { _a: t.r, _b: t.g, _c: t.b, _d: 0, space: "rgb" } : hb(t, "xyz") ? { _a: t.x, _b: t.y, _c: t.z, _d: 0, space: "xyz" } : hb(t, "hsl") ? { _a: t.h, _b: t.s, _c: t.l, _d: 0, space: "hsl" } : hb(t, "lab") ? { _a: t.l, _b: t.a, _c: t.b, _d: 0, space: "lab" } : hb(t, "lch") ? { _a: t.l, _b: t.c, _c: t.h, _d: 0, space: "lch" } : hb(t, "cmyk") ? { _a: t.c, _b: t.m, _c: t.y, _d: t.k, space: "cmyk" } : { _a: 0, _b: 0, _c: 0, space: "rgb" };
  return n.space = e || n.space, n;
}
function U9e(t) {
  return t === "lab" || t === "xyz" || t === "lch";
}
function AD(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
class zr {
  constructor(...e) {
    this.init(...e);
  }
  // Test if given value is a color
  static isColor(e) {
    return e && (e instanceof zr || this.isRgb(e) || this.test(e));
  }
  // Test if given value is an rgb object
  static isRgb(e) {
    return e && typeof e.r == "number" && typeof e.g == "number" && typeof e.b == "number";
  }
  /*
  Generating random colors
  */
  static random(e = "vibrant", n) {
    const { random: r, round: i, sin: a, PI: s } = Math;
    if (e === "vibrant") {
      const c = 24 * r() + 57, d = (83 - 45) * r() + 45, f = 360 * r();
      return new zr(c, d, f, "lch");
    } else if (e === "sine") {
      n = n ?? r();
      const c = i(80 * a(2 * s * n / 0.5 + 0.01) + 150), d = i(50 * a(2 * s * n / 0.5 + 4.6) + 200), f = i(100 * a(2 * s * n / 0.5 + 2.3) + 150);
      return new zr(c, d, f);
    } else if (e === "pastel") {
      const c = 8 * r() + 86, d = (26 - 9) * r() + 9, f = 360 * r();
      return new zr(c, d, f, "lch");
    } else if (e === "dark") {
      const c = 10 + 10 * r(), d = (125 - 75) * r() + 86, f = 360 * r();
      return new zr(c, d, f, "lch");
    } else if (e === "rgb") {
      const c = 255 * r(), d = 255 * r(), f = 255 * r();
      return new zr(c, d, f);
    } else if (e === "lab") {
      const c = 100 * r(), d = 256 * r() - 128, f = 256 * r() - 128;
      return new zr(c, d, f, "lab");
    } else if (e === "grey") {
      const c = 255 * r();
      return new zr(c, c, c);
    } else
      throw new Error("Unsupported random color mode");
  }
  // Test if given value is a color string
  static test(e) {
    return typeof e == "string" && (pU.test(e) || mU.test(e));
  }
  cmyk() {
    const { _a: e, _b: n, _c: r } = this.rgb(), [i, a, s] = [e, n, r].map((b) => b / 255), c = Math.min(1 - i, 1 - a, 1 - s);
    if (c === 1)
      return new zr(0, 0, 0, 1, "cmyk");
    const d = (1 - i - c) / (1 - c), f = (1 - a - c) / (1 - c), g = (1 - s - c) / (1 - c);
    return new zr(d, f, g, c, "cmyk");
  }
  hsl() {
    const { _a: e, _b: n, _c: r } = this.rgb(), [i, a, s] = [e, n, r].map((A) => A / 255), c = Math.max(i, a, s), d = Math.min(i, a, s), f = (c + d) / 2, g = c === d, m = c - d, b = g ? 0 : f > 0.5 ? m / (2 - c - d) : m / (c + d), w = g ? 0 : c === i ? ((a - s) / m + (a < s ? 6 : 0)) / 6 : c === a ? ((s - i) / m + 2) / 6 : c === s ? ((i - a) / m + 4) / 6 : 0;
    return new zr(360 * w, 100 * b, 100 * f, "hsl");
  }
  init(e = 0, n = 0, r = 0, i = 0, a = "rgb") {
    if (e = e || 0, this.space)
      for (const m in this.space)
        delete this[this.space[m]];
    if (typeof e == "number")
      a = typeof i == "string" ? i : a, i = typeof i == "string" ? 0 : i, Object.assign(this, { _a: e, _b: n, _c: r, _d: i, space: a });
    else if (e instanceof Array)
      this.space = n || (typeof e[3] == "string" ? e[3] : e[4]) || "rgb", Object.assign(this, { _a: e[0], _b: e[1], _c: e[2], _d: e[3] || 0 });
    else if (e instanceof Object) {
      const m = V9e(e, n);
      Object.assign(this, m);
    } else if (typeof e == "string")
      if (mU.test(e)) {
        const m = e.replace(_9e, ""), [b, w, _] = x9e.exec(m).slice(1, 4).map((A) => parseInt(A));
        Object.assign(this, { _a: b, _b: w, _c: _, _d: 0, space: "rgb" });
      } else if (pU.test(e)) {
        const m = (A) => parseInt(A, 16), [, b, w, _] = w9e.exec(z9e(e)).map(m);
        Object.assign(this, { _a: b, _b: w, _c: _, _d: 0, space: "rgb" });
      } else
        throw Error("Unsupported string format, can't construct Color");
    const { _a: s, _b: c, _c: d, _d: f } = this, g = this.space === "rgb" ? { r: s, g: c, b: d } : this.space === "xyz" ? { x: s, y: c, z: d } : this.space === "hsl" ? { h: s, s: c, l: d } : this.space === "lab" ? { l: s, a: c, b: d } : this.space === "lch" ? { l: s, c, h: d } : this.space === "cmyk" ? { c: s, m: c, y: d, k: f } : {};
    Object.assign(this, g);
  }
  lab() {
    const { x: e, y: n, z: r } = this.xyz(), i = 116 * n - 16, a = 500 * (e - n), s = 200 * (n - r);
    return new zr(i, a, s, "lab");
  }
  lch() {
    const { l: e, a: n, b: r } = this.lab(), i = Math.sqrt(n ** 2 + r ** 2);
    let a = 180 * Math.atan2(r, n) / Math.PI;
    return a < 0 && (a *= -1, a = 360 - a), new zr(e, i, a, "lch");
  }
  /*
  Conversion Methods
  */
  rgb() {
    if (this.space === "rgb")
      return this;
    if (U9e(this.space)) {
      let { x: e, y: n, z: r } = this;
      if (this.space === "lab" || this.space === "lch") {
        let { l: w, a: _, b: A } = this;
        if (this.space === "lch") {
          const { c: z, h: F } = this, $ = Math.PI / 180;
          _ = z * Math.cos($ * F), A = z * Math.sin($ * F);
        }
        const T = (w + 16) / 116, O = _ / 500 + T, R = T - A / 200, N = 16 / 116, M = 8856e-6, P = 7.787;
        e = 0.95047 * (O ** 3 > M ? O ** 3 : (O - N) / P), n = 1 * (T ** 3 > M ? T ** 3 : (T - N) / P), r = 1.08883 * (R ** 3 > M ? R ** 3 : (R - N) / P);
      }
      const i = e * 3.2406 + n * -1.5372 + r * -0.4986, a = e * -0.9689 + n * 1.8758 + r * 0.0415, s = e * 0.0557 + n * -0.204 + r * 1.057, c = Math.pow, d = 31308e-7, f = i > d ? 1.055 * c(i, 1 / 2.4) - 0.055 : 12.92 * i, g = a > d ? 1.055 * c(a, 1 / 2.4) - 0.055 : 12.92 * a, m = s > d ? 1.055 * c(s, 1 / 2.4) - 0.055 : 12.92 * s;
      return new zr(255 * f, 255 * g, 255 * m);
    } else if (this.space === "hsl") {
      let { h: e, s: n, l: r } = this;
      if (e /= 360, n /= 100, r /= 100, n === 0)
        return r *= 255, new zr(r, r, r);
      const i = r < 0.5 ? r * (1 + n) : r + n - r * n, a = 2 * r - i, s = 255 * AD(a, i, e + 1 / 3), c = 255 * AD(a, i, e), d = 255 * AD(a, i, e - 1 / 3);
      return new zr(s, c, d);
    } else if (this.space === "cmyk") {
      const { c: e, m: n, y: r, k: i } = this, a = 255 * (1 - Math.min(1, e * (1 - i) + i)), s = 255 * (1 - Math.min(1, n * (1 - i) + i)), c = 255 * (1 - Math.min(1, r * (1 - i) + i));
      return new zr(a, s, c);
    } else
      return this;
  }
  toArray() {
    const { _a: e, _b: n, _c: r, _d: i, space: a } = this;
    return [e, n, r, i, a];
  }
  toHex() {
    const [e, n, r] = this._clamped().map(F9e);
    return `#${e}${n}${r}`;
  }
  toRgb() {
    const [e, n, r] = this._clamped();
    return `rgb(${e},${n},${r})`;
  }
  toString() {
    return this.toHex();
  }
  xyz() {
    const { _a: e, _b: n, _c: r } = this.rgb(), [i, a, s] = [e, n, r].map((O) => O / 255), c = i > 0.04045 ? Math.pow((i + 0.055) / 1.055, 2.4) : i / 12.92, d = a > 0.04045 ? Math.pow((a + 0.055) / 1.055, 2.4) : a / 12.92, f = s > 0.04045 ? Math.pow((s + 0.055) / 1.055, 2.4) : s / 12.92, g = (c * 0.4124 + d * 0.3576 + f * 0.1805) / 0.95047, m = (c * 0.2126 + d * 0.7152 + f * 0.0722) / 1, b = (c * 0.0193 + d * 0.1192 + f * 0.9505) / 1.08883, w = g > 8856e-6 ? Math.pow(g, 1 / 3) : 7.787 * g + 16 / 116, _ = m > 8856e-6 ? Math.pow(m, 1 / 3) : 7.787 * m + 16 / 116, A = b > 8856e-6 ? Math.pow(b, 1 / 3) : 7.787 * b + 16 / 116;
    return new zr(w, _, A, "xyz");
  }
  /*
  Input and Output methods
  */
  _clamped() {
    const { _a: e, _b: n, _c: r } = this.rgb(), { max: i, min: a, round: s } = Math, c = (d) => i(0, a(s(d), 255));
    return [e, n, r].map(c);
  }
  /*
  Constructing colors
  */
}
let $a = class SJ {
  // Initialize
  constructor(...e) {
    this.init(...e);
  }
  // Clone point
  clone() {
    return new SJ(this);
  }
  init(e, n) {
    const r = { x: 0, y: 0 }, i = Array.isArray(e) ? { x: e[0], y: e[1] } : typeof e == "object" ? { x: e.x, y: e.y } : { x: e, y: n };
    return this.x = i.x == null ? r.x : i.x, this.y = i.y == null ? r.y : i.y, this;
  }
  toArray() {
    return [this.x, this.y];
  }
  transform(e) {
    return this.clone().transformO(e);
  }
  // Transform point with matrix
  transformO(e) {
    $t.isMatrixLike(e) || (e = new $t(e));
    const { x: n, y: r } = this;
    return this.x = e.a * n + e.c * r + e.e, this.y = e.b * n + e.d * r + e.f, this;
  }
};
function $9e(t, e) {
  return new $a(t, e).transformO(this.screenCTM().inverseO());
}
function pb(t, e, n) {
  return Math.abs(e - t) < (n || 1e-6);
}
class $t {
  constructor(...e) {
    this.init(...e);
  }
  static formatTransforms(e) {
    const n = e.flip === "both" || e.flip === !0, r = e.flip && (n || e.flip === "x") ? -1 : 1, i = e.flip && (n || e.flip === "y") ? -1 : 1, a = e.skew && e.skew.length ? e.skew[0] : isFinite(e.skew) ? e.skew : isFinite(e.skewX) ? e.skewX : 0, s = e.skew && e.skew.length ? e.skew[1] : isFinite(e.skew) ? e.skew : isFinite(e.skewY) ? e.skewY : 0, c = e.scale && e.scale.length ? e.scale[0] * r : isFinite(e.scale) ? e.scale * r : isFinite(e.scaleX) ? e.scaleX * r : r, d = e.scale && e.scale.length ? e.scale[1] * i : isFinite(e.scale) ? e.scale * i : isFinite(e.scaleY) ? e.scaleY * i : i, f = e.shear || 0, g = e.rotate || e.theta || 0, m = new $a(
      e.origin || e.around || e.ox || e.originX,
      e.oy || e.originY
    ), b = m.x, w = m.y, _ = new $a(
      e.position || e.px || e.positionX || NaN,
      e.py || e.positionY || NaN
    ), A = _.x, T = _.y, O = new $a(
      e.translate || e.tx || e.translateX,
      e.ty || e.translateY
    ), R = O.x, N = O.y, M = new $a(
      e.relative || e.rx || e.relativeX,
      e.ry || e.relativeY
    ), P = M.x, z = M.y;
    return {
      scaleX: c,
      scaleY: d,
      skewX: a,
      skewY: s,
      shear: f,
      theta: g,
      rx: P,
      ry: z,
      tx: R,
      ty: N,
      ox: b,
      oy: w,
      px: A,
      py: T
    };
  }
  static fromArray(e) {
    return { a: e[0], b: e[1], c: e[2], d: e[3], e: e[4], f: e[5] };
  }
  static isMatrixLike(e) {
    return e.a != null || e.b != null || e.c != null || e.d != null || e.e != null || e.f != null;
  }
  // left matrix, right matrix, target matrix which is overwritten
  static matrixMultiply(e, n, r) {
    const i = e.a * n.a + e.c * n.b, a = e.b * n.a + e.d * n.b, s = e.a * n.c + e.c * n.d, c = e.b * n.c + e.d * n.d, d = e.e + e.a * n.e + e.c * n.f, f = e.f + e.b * n.e + e.d * n.f;
    return r.a = i, r.b = a, r.c = s, r.d = c, r.e = d, r.f = f, r;
  }
  around(e, n, r) {
    return this.clone().aroundO(e, n, r);
  }
  // Transform around a center point
  aroundO(e, n, r) {
    const i = e || 0, a = n || 0;
    return this.translateO(-i, -a).lmultiplyO(r).translateO(i, a);
  }
  // Clones this matrix
  clone() {
    return new $t(this);
  }
  // Decomposes this matrix into its affine parameters
  decompose(e = 0, n = 0) {
    const r = this.a, i = this.b, a = this.c, s = this.d, c = this.e, d = this.f, f = r * s - i * a, g = f > 0 ? 1 : -1, m = g * Math.sqrt(r * r + i * i), b = Math.atan2(g * i, g * r), w = 180 / Math.PI * b, _ = Math.cos(b), A = Math.sin(b), T = (r * a + i * s) / f, O = a * m / (T * r - i) || s * m / (T * i + r), R = c - e + e * _ * m + n * (T * _ * m - A * O), N = d - n + e * A * m + n * (T * A * m + _ * O);
    return {
      // Return the affine parameters
      scaleX: m,
      scaleY: O,
      shear: T,
      rotate: w,
      translateX: R,
      translateY: N,
      originX: e,
      originY: n,
      // Return the matrix parameters
      a: this.a,
      b: this.b,
      c: this.c,
      d: this.d,
      e: this.e,
      f: this.f
    };
  }
  // Check if two matrices are equal
  equals(e) {
    if (e === this)
      return !0;
    const n = new $t(e);
    return pb(this.a, n.a) && pb(this.b, n.b) && pb(this.c, n.c) && pb(this.d, n.d) && pb(this.e, n.e) && pb(this.f, n.f);
  }
  // Flip matrix on x or y, at a given offset
  flip(e, n) {
    return this.clone().flipO(e, n);
  }
  flipO(e, n) {
    return e === "x" ? this.scaleO(-1, 1, n, 0) : e === "y" ? this.scaleO(1, -1, 0, n) : this.scaleO(-1, -1, e, n || e);
  }
  // Initialize
  init(e) {
    const n = $t.fromArray([1, 0, 0, 1, 0, 0]);
    return e = e instanceof df ? e.matrixify() : typeof e == "string" ? $t.fromArray(e.split(Bh).map(parseFloat)) : Array.isArray(e) ? $t.fromArray(e) : typeof e == "object" && $t.isMatrixLike(e) ? e : typeof e == "object" ? new $t().transform(e) : arguments.length === 6 ? $t.fromArray([].slice.call(arguments)) : n, this.a = e.a != null ? e.a : n.a, this.b = e.b != null ? e.b : n.b, this.c = e.c != null ? e.c : n.c, this.d = e.d != null ? e.d : n.d, this.e = e.e != null ? e.e : n.e, this.f = e.f != null ? e.f : n.f, this;
  }
  inverse() {
    return this.clone().inverseO();
  }
  // Inverses matrix
  inverseO() {
    const e = this.a, n = this.b, r = this.c, i = this.d, a = this.e, s = this.f, c = e * i - n * r;
    if (!c)
      throw new Error("Cannot invert " + this);
    const d = i / c, f = -n / c, g = -r / c, m = e / c, b = -(d * a + g * s), w = -(f * a + m * s);
    return this.a = d, this.b = f, this.c = g, this.d = m, this.e = b, this.f = w, this;
  }
  lmultiply(e) {
    return this.clone().lmultiplyO(e);
  }
  lmultiplyO(e) {
    const n = this, r = e instanceof $t ? e : new $t(e);
    return $t.matrixMultiply(r, n, this);
  }
  // Left multiplies by the given matrix
  multiply(e) {
    return this.clone().multiplyO(e);
  }
  multiplyO(e) {
    const n = this, r = e instanceof $t ? e : new $t(e);
    return $t.matrixMultiply(n, r, this);
  }
  // Rotate matrix
  rotate(e, n, r) {
    return this.clone().rotateO(e, n, r);
  }
  rotateO(e, n = 0, r = 0) {
    e = SD(e);
    const i = Math.cos(e), a = Math.sin(e), { a: s, b: c, c: d, d: f, e: g, f: m } = this;
    return this.a = s * i - c * a, this.b = c * i + s * a, this.c = d * i - f * a, this.d = f * i + d * a, this.e = g * i - m * a + r * a - n * i + n, this.f = m * i + g * a - n * a - r * i + r, this;
  }
  // Scale matrix
  scale() {
    return this.clone().scaleO(...arguments);
  }
  scaleO(e, n = e, r = 0, i = 0) {
    arguments.length === 3 && (i = r, r = n, n = e);
    const { a, b: s, c, d, e: f, f: g } = this;
    return this.a = a * e, this.b = s * n, this.c = c * e, this.d = d * n, this.e = f * e - r * e + r, this.f = g * n - i * n + i, this;
  }
  // Shear matrix
  shear(e, n, r) {
    return this.clone().shearO(e, n, r);
  }
  // eslint-disable-next-line no-unused-vars
  shearO(e, n = 0, r = 0) {
    const { a: i, b: a, c: s, d: c, e: d, f } = this;
    return this.a = i + a * e, this.c = s + c * e, this.e = d + f * e - r * e, this;
  }
  // Skew Matrix
  skew() {
    return this.clone().skewO(...arguments);
  }
  skewO(e, n = e, r = 0, i = 0) {
    arguments.length === 3 && (i = r, r = n, n = e), e = SD(e), n = SD(n);
    const a = Math.tan(e), s = Math.tan(n), { a: c, b: d, c: f, d: g, e: m, f: b } = this;
    return this.a = c + d * a, this.b = d + c * s, this.c = f + g * a, this.d = g + f * s, this.e = m + b * a - i * a, this.f = b + m * s - r * s, this;
  }
  // SkewX
  skewX(e, n, r) {
    return this.skew(e, 0, n, r);
  }
  // SkewY
  skewY(e, n, r) {
    return this.skew(0, e, n, r);
  }
  toArray() {
    return [this.a, this.b, this.c, this.d, this.e, this.f];
  }
  // Convert matrix to string
  toString() {
    return "matrix(" + this.a + "," + this.b + "," + this.c + "," + this.d + "," + this.e + "," + this.f + ")";
  }
  // Transform a matrix into another matrix by manipulating the space
  transform(e) {
    if ($t.isMatrixLike(e))
      return new $t(e).multiplyO(this);
    const n = $t.formatTransforms(e), r = this, { x: i, y: a } = new $a(n.ox, n.oy).transform(r), s = new $t().translateO(n.rx, n.ry).lmultiplyO(r).translateO(-i, -a).scaleO(n.scaleX, n.scaleY).skewO(n.skewX, n.skewY).shearO(n.shear).rotateO(n.theta).translateO(i, a);
    if (isFinite(n.px) || isFinite(n.py)) {
      const c = new $a(i, a).transform(s), d = isFinite(n.px) ? n.px - c.x : 0, f = isFinite(n.py) ? n.py - c.y : 0;
      s.translateO(d, f);
    }
    return s.translateO(n.tx, n.ty), s;
  }
  // Translate matrix
  translate(e, n) {
    return this.clone().translateO(e, n);
  }
  translateO(e, n) {
    return this.e += e || 0, this.f += n || 0, this;
  }
  valueOf() {
    return {
      a: this.a,
      b: this.b,
      c: this.c,
      d: this.d,
      e: this.e,
      f: this.f
    };
  }
}
function H9e() {
  return new $t(this.node.getCTM());
}
function q9e() {
  try {
    if (typeof this.isRoot == "function" && !this.isRoot()) {
      const t = this.rect(1, 1), e = t.node.getScreenCTM();
      return t.remove(), new $t(e);
    }
    return new $t(this.node.getScreenCTM());
  } catch {
    return console.warn(
      `Cannot get CTM from SVG node ${this.node.nodeName}. Is the element rendered?`
    ), new $t();
  }
}
ir($t, "Matrix");
function M0() {
  if (!M0.nodes) {
    const t = Is().size(2, 0);
    t.node.style.cssText = [
      "opacity: 0",
      "position: absolute",
      "left: -100%",
      "top: -100%",
      "overflow: hidden"
    ].join(";"), t.attr("focusable", "false"), t.attr("aria-hidden", "true");
    const e = t.path().node;
    M0.nodes = { svg: t, path: e };
  }
  if (!M0.nodes.svg.node.parentNode) {
    const t = rr.document.body || rr.document.documentElement;
    M0.nodes.svg.addTo(t);
  }
  return M0.nodes;
}
function EJ(t) {
  return !t.width && !t.height && !t.x && !t.y;
}
function G9e(t) {
  return t === rr.document || (rr.document.documentElement.contains || function(e) {
    for (; e.parentNode; )
      e = e.parentNode;
    return e === rr.document;
  }).call(rr.document.documentElement, t);
}
class Po {
  constructor(...e) {
    this.init(...e);
  }
  addOffset() {
    return this.x += rr.window.pageXOffset, this.y += rr.window.pageYOffset, new Po(this);
  }
  init(e) {
    const n = [0, 0, 0, 0];
    return e = typeof e == "string" ? e.split(Bh).map(parseFloat) : Array.isArray(e) ? e : typeof e == "object" ? [
      e.left != null ? e.left : e.x,
      e.top != null ? e.top : e.y,
      e.width,
      e.height
    ] : arguments.length === 4 ? [].slice.call(arguments) : n, this.x = e[0] || 0, this.y = e[1] || 0, this.width = this.w = e[2] || 0, this.height = this.h = e[3] || 0, this.x2 = this.x + this.w, this.y2 = this.y + this.h, this.cx = this.x + this.w / 2, this.cy = this.y + this.h / 2, this;
  }
  isNulled() {
    return EJ(this);
  }
  // Merge rect box with another, return a new instance
  merge(e) {
    const n = Math.min(this.x, e.x), r = Math.min(this.y, e.y), i = Math.max(this.x + this.width, e.x + e.width) - n, a = Math.max(this.y + this.height, e.y + e.height) - r;
    return new Po(n, r, i, a);
  }
  toArray() {
    return [this.x, this.y, this.width, this.height];
  }
  toString() {
    return this.x + " " + this.y + " " + this.width + " " + this.height;
  }
  transform(e) {
    e instanceof $t || (e = new $t(e));
    let n = 1 / 0, r = -1 / 0, i = 1 / 0, a = -1 / 0;
    return [
      new $a(this.x, this.y),
      new $a(this.x2, this.y),
      new $a(this.x, this.y2),
      new $a(this.x2, this.y2)
    ].forEach(function(c) {
      c = c.transform(e), n = Math.min(n, c.x), r = Math.max(r, c.x), i = Math.min(i, c.y), a = Math.max(a, c.y);
    }), new Po(n, i, r - n, a - i);
  }
}
function _J(t, e, n) {
  let r;
  try {
    if (r = e(t.node), EJ(r) && !G9e(t.node))
      throw new Error("Element not in the dom");
  } catch {
    r = n(t);
  }
  return r;
}
function Y9e() {
  const n = _J(this, (i) => i.getBBox(), (i) => {
    try {
      const a = i.clone().addTo(M0().svg).show(), s = a.node.getBBox();
      return a.remove(), s;
    } catch (a) {
      throw new Error(
        `Getting bbox of element "${i.node.nodeName}" is not possible: ${a.toString()}`
      );
    }
  });
  return new Po(n);
}
function X9e(t) {
  const r = _J(this, (a) => a.getBoundingClientRect(), (a) => {
    throw new Error(
      `Getting rbox of element "${a.node.nodeName}" is not possible`
    );
  }), i = new Po(r);
  return t ? i.transform(t.screenCTM().inverseO()) : i.addOffset();
}
function W9e(t, e) {
  const n = this.bbox();
  return t > n.x && e > n.y && t < n.x + n.width && e < n.y + n.height;
}
Tn({
  viewbox: {
    viewbox(t, e, n, r) {
      return t == null ? new Po(this.attr("viewBox")) : this.attr("viewBox", new Po(t, e, n, r));
    },
    zoom(t, e) {
      let { width: n, height: r } = this.attr(["width", "height"]);
      if ((!n && !r || typeof n == "string" || typeof r == "string") && (n = this.node.clientWidth, r = this.node.clientHeight), !n || !r)
        throw new Error(
          "Impossible to get absolute width and height. Please provide an absolute width and height attribute on the zooming element"
        );
      const i = this.viewbox(), a = n / i.width, s = r / i.height, c = Math.min(a, s);
      if (t == null)
        return c;
      let d = c / t;
      d === 1 / 0 && (d = Number.MAX_SAFE_INTEGER / 100), e = e || new $a(n / 2 / a + i.x, r / 2 / s + i.y);
      const f = new Po(i).transform(
        new $t({ scale: d, origin: e })
      );
      return this.viewbox(f);
    }
  }
});
ir(Po, "Box");
class Tg extends Array {
  constructor(e = [], ...n) {
    if (super(e, ...n), typeof e == "number")
      return this;
    this.length = 0, this.push(...e);
  }
}
Gn([Tg], {
  each(t, ...e) {
    return typeof t == "function" ? this.map((n, r, i) => t.call(n, n, r, i)) : this.map((n) => n[t](...e));
  },
  toArray() {
    return Array.prototype.concat.apply([], this);
  }
});
const Q9e = ["toArray", "constructor", "each"];
Tg.extend = function(t) {
  t = t.reduce((e, n) => (Q9e.includes(n) || n[0] === "_" || (n in Array.prototype && (e["$" + n] = Array.prototype[n]), e[n] = function(...r) {
    return this.each(n, ...r);
  }), e), {}), Gn([Tg], t);
};
function _w(t, e) {
  return new Tg(
    yk((e || rr.document).querySelectorAll(t), function(n) {
      return qc(n);
    })
  );
}
function Z9e(t) {
  return _w(t, this.node);
}
function K9e(t) {
  return qc(this.node.querySelector(t));
}
let J9e = 0;
const AJ = {};
function CJ(t) {
  let e = t.getEventHolder();
  return e === rr.window && (e = AJ), e.events || (e.events = {}), e.events;
}
function Ek(t) {
  return t.getEventTarget();
}
function eje(t) {
  let e = t.getEventHolder();
  e === rr.window && (e = AJ), e.events && (e.events = {});
}
function BN(t, e, n, r, i) {
  const a = n.bind(r || t), s = Is(t), c = CJ(s), d = Ek(s);
  e = Array.isArray(e) ? e : e.split(Bh), n._svgjsListenerId || (n._svgjsListenerId = ++J9e), e.forEach(function(f) {
    const g = f.split(".")[0], m = f.split(".")[1] || "*";
    c[g] = c[g] || {}, c[g][m] = c[g][m] || {}, c[g][m][n._svgjsListenerId] = a, d.addEventListener(g, a, i || !1);
  });
}
function Tb(t, e, n, r) {
  const i = Is(t), a = CJ(i), s = Ek(i);
  typeof n == "function" && (n = n._svgjsListenerId, !n) || (e = Array.isArray(e) ? e : (e || "").split(Bh), e.forEach(function(c) {
    const d = c && c.split(".")[0], f = c && c.split(".")[1];
    let g, m;
    if (n)
      a[d] && a[d][f || "*"] && (s.removeEventListener(
        d,
        a[d][f || "*"][n],
        r || !1
      ), delete a[d][f || "*"][n]);
    else if (d && f) {
      if (a[d] && a[d][f]) {
        for (m in a[d][f])
          Tb(s, [d, f].join("."), m);
        delete a[d][f];
      }
    } else if (f)
      for (c in a)
        for (g in a[c])
          f === g && Tb(s, [c, f].join("."));
    else if (d) {
      if (a[d]) {
        for (g in a[d])
          Tb(s, [d, g].join("."));
        delete a[d];
      }
    } else {
      for (c in a)
        Tb(s, c);
      eje(i);
    }
  }));
}
function tje(t, e, n, r) {
  const i = Ek(t);
  return e instanceof rr.window.Event || (e = new rr.window.CustomEvent(e, {
    detail: n,
    cancelable: !0,
    ...r
  })), i.dispatchEvent(e), e;
}
class F_ extends wk {
  addEventListener() {
  }
  dispatch(e, n, r) {
    return tje(this, e, n, r);
  }
  dispatchEvent(e) {
    const n = this.getEventHolder().events;
    if (!n)
      return !0;
    const r = n[e.type];
    for (const i in r)
      for (const a in r[i])
        r[i][a](e);
    return !e.defaultPrevented;
  }
  // Fire given event
  fire(e, n, r) {
    return this.dispatch(e, n, r), this;
  }
  getEventHolder() {
    return this;
  }
  getEventTarget() {
    return this;
  }
  // Unbind event from listener
  off(e, n, r) {
    return Tb(this, e, n, r), this;
  }
  // Bind given event to listener
  on(e, n, r, i) {
    return BN(this, e, n, r, i), this;
  }
  removeEventListener() {
  }
}
ir(F_, "EventTarget");
function yU() {
}
const iE = {
  duration: 400,
  ease: ">",
  delay: 0
}, nje = {
  // fill and stroke
  "fill-opacity": 1,
  "stroke-opacity": 1,
  "stroke-width": 0,
  "stroke-linejoin": "miter",
  "stroke-linecap": "butt",
  fill: "#000000",
  stroke: "#000000",
  opacity: 1,
  // position
  x: 0,
  y: 0,
  cx: 0,
  cy: 0,
  // size
  width: 0,
  height: 0,
  // radius
  r: 0,
  rx: 0,
  ry: 0,
  // gradient
  offset: 0,
  "stop-opacity": 1,
  "stop-color": "#000000",
  // text
  "text-anchor": "start"
};
class tw extends Array {
  constructor(...e) {
    super(...e), this.init(...e);
  }
  clone() {
    return new this.constructor(this);
  }
  init(e) {
    return typeof e == "number" ? this : (this.length = 0, this.push(...this.parse(e)), this);
  }
  // Parse whitespace separated string
  parse(e = []) {
    return e instanceof Array ? e : e.trim().split(Bh).map(parseFloat);
  }
  toArray() {
    return Array.prototype.concat.apply([], this);
  }
  toSet() {
    return new Set(this);
  }
  toString() {
    return this.join(" ");
  }
  // Flattens the array if needed
  valueOf() {
    const e = [];
    return e.push(...this), e;
  }
}
class fn {
  // Initialize
  constructor(...e) {
    this.init(...e);
  }
  convert(e) {
    return new fn(this.value, e);
  }
  // Divide number
  divide(e) {
    return e = new fn(e), new fn(this / e, this.unit || e.unit);
  }
  init(e, n) {
    return n = Array.isArray(e) ? e[1] : n, e = Array.isArray(e) ? e[0] : e, this.value = 0, this.unit = n || "", typeof e == "number" ? this.value = isNaN(e) ? 0 : isFinite(e) ? e : e < 0 ? -34e37 : 34e37 : typeof e == "string" ? (n = e.match(xJ), n && (this.value = parseFloat(n[1]), n[5] === "%" ? this.value /= 100 : n[5] === "s" && (this.value *= 1e3), this.unit = n[5])) : e instanceof fn && (this.value = e.valueOf(), this.unit = e.unit), this;
  }
  // Subtract number
  minus(e) {
    return e = new fn(e), new fn(this - e, this.unit || e.unit);
  }
  // Add number
  plus(e) {
    return e = new fn(e), new fn(this + e, this.unit || e.unit);
  }
  // Multiply number
  times(e) {
    return e = new fn(e), new fn(this * e, this.unit || e.unit);
  }
  toArray() {
    return [this.value, this.unit];
  }
  toJSON() {
    return this.toString();
  }
  toString() {
    return (this.unit === "%" ? ~~(this.value * 1e8) / 1e6 : this.unit === "s" ? this.value / 1e3 : this.value) + this.unit;
  }
  valueOf() {
    return this.value;
  }
}
const rje = /* @__PURE__ */ new Set([
  "fill",
  "stroke",
  "color",
  "bgcolor",
  "stop-color",
  "flood-color",
  "lighting-color"
]), TJ = [];
function ije(t) {
  TJ.push(t);
}
function aje(t, e, n) {
  if (t == null) {
    t = {}, e = this.node.attributes;
    for (const r of e)
      t[r.nodeName] = vU.test(r.nodeValue) ? parseFloat(r.nodeValue) : r.nodeValue;
    return t;
  } else {
    if (t instanceof Array)
      return t.reduce((r, i) => (r[i] = this.attr(i), r), {});
    if (typeof t == "object" && t.constructor === Object)
      for (e in t)
        this.attr(e, t[e]);
    else if (e === null)
      this.node.removeAttribute(t);
    else {
      if (e == null)
        return e = this.node.getAttribute(t), e == null ? nje[t] : vU.test(e) ? parseFloat(e) : e;
      e = TJ.reduce((r, i) => i(t, r, this), e), typeof e == "number" ? e = new fn(e) : rje.has(t) && zr.isColor(e) ? e = new zr(e) : e.constructor === Array && (e = new tw(e)), t === "leading" ? this.leading && this.leading(e) : typeof n == "string" ? this.node.setAttributeNS(n, t, e.toString()) : this.node.setAttribute(t, e.toString()), this.rebuild && (t === "font-size" || t === "x") && this.rebuild();
    }
  }
  return this;
}
class Z0 extends F_ {
  constructor(e, n) {
    super(), this.node = e, this.type = e.nodeName, n && e !== n && this.attr(n);
  }
  // Add given element at a position
  add(e, n) {
    return e = Is(e), e.removeNamespace && this.node instanceof rr.window.SVGElement && e.removeNamespace(), n == null ? this.node.appendChild(e.node) : e.node !== this.node.childNodes[n] && this.node.insertBefore(e.node, this.node.childNodes[n]), this;
  }
  // Add element to given container and return self
  addTo(e, n) {
    return Is(e).put(this, n);
  }
  // Returns all child elements
  children() {
    return new Tg(
      yk(this.node.children, function(e) {
        return qc(e);
      })
    );
  }
  // Remove all elements in this container
  clear() {
    for (; this.node.hasChildNodes(); )
      this.node.removeChild(this.node.lastChild);
    return this;
  }
  // Clone element
  clone(e = !0, n = !0) {
    this.writeDataToDom();
    let r = this.node.cloneNode(e);
    return n && (r = wJ(r)), new this.constructor(r);
  }
  // Iterates over all children and invokes a given block
  each(e, n) {
    const r = this.children();
    let i, a;
    for (i = 0, a = r.length; i < a; i++)
      e.apply(r[i], [i, r]), n && r[i].each(e, n);
    return this;
  }
  element(e, n) {
    return this.put(new Z0(c_(e), n));
  }
  // Get first child
  first() {
    return qc(this.node.firstChild);
  }
  // Get a element at the given index
  get(e) {
    return qc(this.node.childNodes[e]);
  }
  getEventHolder() {
    return this.node;
  }
  getEventTarget() {
    return this.node;
  }
  // Checks if the given element is a child
  has(e) {
    return this.index(e) >= 0;
  }
  html(e, n) {
    return this.xml(e, n, i9e);
  }
  // Get / set id
  id(e) {
    return typeof e > "u" && !this.node.id && (this.node.id = bJ(this.type)), this.attr("id", e);
  }
  // Gets index of given element
  index(e) {
    return [].slice.call(this.node.childNodes).indexOf(e.node);
  }
  // Get the last child
  last() {
    return qc(this.node.lastChild);
  }
  // matches the element vs a css selector
  matches(e) {
    const n = this.node, r = n.matches || n.matchesSelector || n.msMatchesSelector || n.mozMatchesSelector || n.webkitMatchesSelector || n.oMatchesSelector || null;
    return r && r.call(n, e);
  }
  // Returns the parent element instance
  parent(e) {
    let n = this;
    if (!n.node.parentNode)
      return null;
    if (n = qc(n.node.parentNode), !e)
      return n;
    do
      if (typeof e == "string" ? n.matches(e) : n instanceof e)
        return n;
    while (n = qc(n.node.parentNode));
    return n;
  }
  // Basically does the same as `add()` but returns the added element instead
  put(e, n) {
    return e = Is(e), this.add(e, n), e;
  }
  // Add element to given container and return container
  putIn(e, n) {
    return Is(e).add(this, n);
  }
  // Remove element
  remove() {
    return this.parent() && this.parent().removeElement(this), this;
  }
  // Remove a given child
  removeElement(e) {
    return this.node.removeChild(e.node), this;
  }
  // Replace this with element
  replace(e) {
    return e = Is(e), this.node.parentNode && this.node.parentNode.replaceChild(e.node, this.node), e;
  }
  round(e = 2, n = null) {
    const r = 10 ** e, i = this.attr(n);
    for (const a in i)
      typeof i[a] == "number" && (i[a] = Math.round(i[a] * r) / r);
    return this.attr(i), this;
  }
  // Import / Export raw svg
  svg(e, n) {
    return this.xml(e, n, bk);
  }
  // Return id on string conversion
  toString() {
    return this.id();
  }
  words(e) {
    return this.node.textContent = e, this;
  }
  wrap(e) {
    const n = this.parent();
    if (!n)
      return this.addTo(e);
    const r = n.index(this);
    return n.put(e, r).put(this);
  }
  // write svgjs data to the dom
  writeDataToDom() {
    return this.each(function() {
      this.writeDataToDom();
    }), this;
  }
  // Import / Export raw svg
  xml(e, n, r) {
    if (typeof e == "boolean" && (r = n, n = e, e = null), e == null || typeof e == "function") {
      n = n ?? !0, this.writeDataToDom();
      let c = this;
      if (e != null) {
        if (c = qc(c.node.cloneNode(!0)), n) {
          const d = e(c);
          if (c = d || c, d === !1)
            return "";
        }
        c.each(function() {
          const d = e(this), f = d || this;
          d === !1 ? this.remove() : d && this !== f && this.replace(f);
        }, !0);
      }
      return n ? c.node.outerHTML : c.node.innerHTML;
    }
    n = n ?? !1;
    const i = c_("wrapper", r), a = rr.document.createDocumentFragment();
    i.innerHTML = e;
    for (let c = i.children.length; c--; )
      a.appendChild(i.firstElementChild);
    const s = this.parent();
    return n ? this.replace(a) && s : this.add(a);
  }
}
Gn(Z0, { attr: aje, find: Z9e, findOne: K9e });
ir(Z0, "Dom");
let df = class extends Z0 {
  constructor(e, n) {
    super(e, n), this.dom = {}, this.node.instance = this, (e.hasAttribute("data-svgjs") || e.hasAttribute("svgjs:data")) && this.setData(
      JSON.parse(e.getAttribute("data-svgjs")) ?? JSON.parse(e.getAttribute("svgjs:data")) ?? {}
    );
  }
  // Move element by its center
  center(e, n) {
    return this.cx(e).cy(n);
  }
  // Move by center over x-axis
  cx(e) {
    return e == null ? this.x() + this.width() / 2 : this.x(e - this.width() / 2);
  }
  // Move by center over y-axis
  cy(e) {
    return e == null ? this.y() + this.height() / 2 : this.y(e - this.height() / 2);
  }
  // Get defs
  defs() {
    const e = this.root();
    return e && e.defs();
  }
  // Relative move over x and y axes
  dmove(e, n) {
    return this.dx(e).dy(n);
  }
  // Relative move over x axis
  dx(e = 0) {
    return this.x(new fn(e).plus(this.x()));
  }
  // Relative move over y axis
  dy(e = 0) {
    return this.y(new fn(e).plus(this.y()));
  }
  getEventHolder() {
    return this;
  }
  // Set height of element
  height(e) {
    return this.attr("height", e);
  }
  // Move element to given x and y values
  move(e, n) {
    return this.x(e).y(n);
  }
  // return array of all ancestors of given type up to the root svg
  parents(e = this.root()) {
    const n = typeof e == "string";
    n || (e = Is(e));
    const r = new Tg();
    let i = this;
    for (; (i = i.parent()) && i.node !== rr.document && i.nodeName !== "#document-fragment" && (r.push(i), !(!n && i.node === e.node || n && i.matches(e))); )
      if (i.node === this.root().node)
        return null;
    return r;
  }
  // Get referenced element form attribute value
  reference(e) {
    if (e = this.attr(e), !e)
      return null;
    const n = (e + "").match(S9e);
    return n ? Is(n[1]) : null;
  }
  // Get parent document
  root() {
    const e = this.parent(o9e(xk));
    return e && e.root();
  }
  // set given data to the elements data property
  setData(e) {
    return this.dom = e, this;
  }
  // Set element size to given width and height
  size(e, n) {
    const r = Ew(this, e, n);
    return this.width(new fn(r.width)).height(new fn(r.height));
  }
  // Set width of element
  width(e) {
    return this.attr("width", e);
  }
  // write svgjs data to the dom
  writeDataToDom() {
    return yJ(this, this.dom), super.writeDataToDom();
  }
  // Move over x-axis
  x(e) {
    return this.attr("x", e);
  }
  // Move over y-axis
  y(e) {
    return this.attr("y", e);
  }
};
Gn(df, {
  bbox: Y9e,
  rbox: X9e,
  inside: W9e,
  point: $9e,
  ctm: H9e,
  screenCTM: q9e
});
ir(df, "Element");
const $S = {
  stroke: [
    "color",
    "width",
    "opacity",
    "linecap",
    "linejoin",
    "miterlimit",
    "dasharray",
    "dashoffset"
  ],
  fill: ["color", "opacity", "rule"],
  prefix: function(t, e) {
    return e === "color" ? t : t + "-" + e;
  }
};
["fill", "stroke"].forEach(function(t) {
  const e = {};
  let n;
  e[t] = function(r) {
    if (typeof r > "u")
      return this.attr(t);
    if (typeof r == "string" || r instanceof zr || zr.isRgb(r) || r instanceof df)
      this.attr(t, r);
    else
      for (n = $S[t].length - 1; n >= 0; n--)
        r[$S[t][n]] != null && this.attr($S.prefix(t, $S[t][n]), r[$S[t][n]]);
    return this;
  }, Tn(["Element", "Runner"], e);
});
Tn(["Element", "Runner"], {
  // Let the user set the matrix directly
  matrix: function(t, e, n, r, i, a) {
    return t == null ? new $t(this) : this.attr("transform", new $t(t, e, n, r, i, a));
  },
  // Map rotation to transform
  rotate: function(t, e, n) {
    return this.transform({ rotate: t, ox: e, oy: n }, !0);
  },
  // Map skew to transform
  skew: function(t, e, n, r) {
    return arguments.length === 1 || arguments.length === 3 ? this.transform({ skew: t, ox: e, oy: n }, !0) : this.transform({ skew: [t, e], ox: n, oy: r }, !0);
  },
  shear: function(t, e, n) {
    return this.transform({ shear: t, ox: e, oy: n }, !0);
  },
  // Map scale to transform
  scale: function(t, e, n, r) {
    return arguments.length === 1 || arguments.length === 3 ? this.transform({ scale: t, ox: e, oy: n }, !0) : this.transform({ scale: [t, e], ox: n, oy: r }, !0);
  },
  // Map translate to transform
  translate: function(t, e) {
    return this.transform({ translate: [t, e] }, !0);
  },
  // Map relative translations to transform
  relative: function(t, e) {
    return this.transform({ relative: [t, e] }, !0);
  },
  // Map flip to transform
  flip: function(t = "both", e = "center") {
    return "xybothtrue".indexOf(t) === -1 && (e = t, t = "both"), this.transform({ flip: t, origin: e }, !0);
  },
  // Opacity
  opacity: function(t) {
    return this.attr("opacity", t);
  }
});
Tn("radius", {
  // Add x and y radius
  radius: function(t, e = t) {
    return (this._element || this).type === "radialGradient" ? this.attr("r", new fn(t)) : this.rx(t).ry(e);
  }
});
Tn("Path", {
  // Get path length
  length: function() {
    return this.node.getTotalLength();
  },
  // Get point at length
  pointAt: function(t) {
    return new $a(this.node.getPointAtLength(t));
  }
});
Tn(["Element", "Runner"], {
  // Set font
  font: function(t, e) {
    if (typeof t == "object") {
      for (e in t)
        this.font(e, t[e]);
      return this;
    }
    return t === "leading" ? this.leading(e) : t === "anchor" ? this.attr("text-anchor", e) : t === "size" || t === "family" || t === "weight" || t === "stretch" || t === "variant" || t === "style" ? this.attr("font-" + t, e) : this.attr(t, e);
  }
});
const oje = [
  "click",
  "dblclick",
  "mousedown",
  "mouseup",
  "mouseover",
  "mouseout",
  "mousemove",
  "mouseenter",
  "mouseleave",
  "touchstart",
  "touchmove",
  "touchleave",
  "touchend",
  "touchcancel",
  "contextmenu",
  "wheel",
  "pointerdown",
  "pointermove",
  "pointerup",
  "pointerleave",
  "pointercancel"
].reduce(function(t, e) {
  const n = function(r) {
    return r === null ? this.off(e) : this.on(e, r), this;
  };
  return t[e] = n, t;
}, {});
Tn("Element", oje);
function sje() {
  return this.attr("transform", null);
}
function lje() {
  return (this.attr("transform") || "").split(E9e).slice(0, -1).map(function(e) {
    const n = e.trim().split("(");
    return [
      n[0],
      n[1].split(Bh).map(function(r) {
        return parseFloat(r);
      })
    ];
  }).reverse().reduce(function(e, n) {
    return n[0] === "matrix" ? e.lmultiply($t.fromArray(n[1])) : e[n[0]].apply(e, n[1]);
  }, new $t());
}
function cje(t, e) {
  if (this === t)
    return this;
  if (LN(this.node))
    return this.addTo(t, e);
  const n = this.screenCTM(), r = t.screenCTM().inverse();
  return this.addTo(t, e).untransform().transform(r.multiply(n)), this;
}
function uje(t) {
  return this.toParent(this.root(), t);
}
function dje(t, e) {
  if (t == null || typeof t == "string") {
    const i = new $t(this).decompose();
    return t == null ? i : i[t];
  }
  $t.isMatrixLike(t) || (t = { ...t, origin: PN(t, this) });
  const n = e === !0 ? this : e || !1, r = new $t(n).transform(t);
  return this.attr("transform", r);
}
Tn("Element", {
  untransform: sje,
  matrixify: lje,
  toParent: cje,
  toRoot: uje,
  transform: dje
});
class dl extends df {
  flatten() {
    return this.each(function() {
      if (this instanceof dl)
        return this.flatten().ungroup();
    }), this;
  }
  ungroup(e = this.parent(), n = e.index(this)) {
    return n = n === -1 ? e.children().length : n, this.each(function(r, i) {
      return i[i.length - r - 1].toParent(e, n);
    }), this.remove();
  }
}
ir(dl, "Container");
class _k extends dl {
  constructor(e, n = e) {
    super(_i("defs", e), n);
  }
  flatten() {
    return this;
  }
  ungroup() {
    return this;
  }
}
ir(_k, "Defs");
class Zl extends df {
}
ir(Zl, "Shape");
function Ak(t) {
  return this.attr("rx", t);
}
function Ck(t) {
  return this.attr("ry", t);
}
function OJ(t) {
  return t == null ? this.cx() - this.rx() : this.cx(t + this.rx());
}
function RJ(t) {
  return t == null ? this.cy() - this.ry() : this.cy(t + this.ry());
}
function DJ(t) {
  return this.attr("cx", t);
}
function NJ(t) {
  return this.attr("cy", t);
}
function MJ(t) {
  return t == null ? this.rx() * 2 : this.rx(new fn(t).divide(2));
}
function IJ(t) {
  return t == null ? this.ry() * 2 : this.ry(new fn(t).divide(2));
}
const fje = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cx: DJ,
  cy: NJ,
  height: IJ,
  rx: Ak,
  ry: Ck,
  width: MJ,
  x: OJ,
  y: RJ
}, Symbol.toStringTag, { value: "Module" }));
class yO extends Zl {
  constructor(e, n = e) {
    super(_i("ellipse", e), n);
  }
  size(e, n) {
    const r = Ew(this, e, n);
    return this.rx(new fn(r.width).divide(2)).ry(
      new fn(r.height).divide(2)
    );
  }
}
Gn(yO, fje);
Tn("Container", {
  // Create an ellipse
  ellipse: Si(function(t = 0, e = t) {
    return this.put(new yO()).size(t, e).move(0, 0);
  })
});
ir(yO, "Ellipse");
class kJ extends Z0 {
  constructor(e = rr.document.createDocumentFragment()) {
    super(e);
  }
  // Import / Export raw xml
  xml(e, n, r) {
    if (typeof e == "boolean" && (r = n, n = e, e = null), e == null || typeof e == "function") {
      const i = new Z0(c_("wrapper", r));
      return i.add(this.node.cloneNode(!0)), i.xml(!1, r);
    }
    return super.xml(e, !1, r);
  }
}
ir(kJ, "Fragment");
function jJ(t, e) {
  return (this._element || this).type === "radialGradient" ? this.attr({ fx: new fn(t), fy: new fn(e) }) : this.attr({ x1: new fn(t), y1: new fn(e) });
}
function PJ(t, e) {
  return (this._element || this).type === "radialGradient" ? this.attr({ cx: new fn(t), cy: new fn(e) }) : this.attr({ x2: new fn(t), y2: new fn(e) });
}
const hje = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  from: jJ,
  to: PJ
}, Symbol.toStringTag, { value: "Module" }));
class V_ extends dl {
  constructor(e, n) {
    super(
      _i(e + "Gradient", typeof e == "string" ? null : e),
      n
    );
  }
  // custom attr to handle transform
  attr(e, n, r) {
    return e === "transform" && (e = "gradientTransform"), super.attr(e, n, r);
  }
  bbox() {
    return new Po();
  }
  targets() {
    return _w("svg [fill*=" + this.id() + "]");
  }
  // Alias string conversion to fill
  toString() {
    return this.url();
  }
  // Update gradient
  update(e) {
    return this.clear(), typeof e == "function" && e.call(this, this), this;
  }
  // Return the fill id
  url() {
    return "url(#" + this.id() + ")";
  }
}
Gn(V_, hje);
Tn({
  Container: {
    // Create gradient element in defs
    gradient(...t) {
      return this.defs().gradient(...t);
    }
  },
  // define gradient
  Defs: {
    gradient: Si(function(t, e) {
      return this.put(new V_(t)).update(e);
    })
  }
});
ir(V_, "Gradient");
class u_ extends dl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("pattern", e), n);
  }
  // custom attr to handle transform
  attr(e, n, r) {
    return e === "transform" && (e = "patternTransform"), super.attr(e, n, r);
  }
  bbox() {
    return new Po();
  }
  targets() {
    return _w("svg [fill*=" + this.id() + "]");
  }
  // Alias string conversion to fill
  toString() {
    return this.url();
  }
  // Update pattern by rebuilding
  update(e) {
    return this.clear(), typeof e == "function" && e.call(this, this), this;
  }
  // Return the fill id
  url() {
    return "url(#" + this.id() + ")";
  }
}
Tn({
  Container: {
    // Create pattern element in defs
    pattern(...t) {
      return this.defs().pattern(...t);
    }
  },
  Defs: {
    pattern: Si(function(t, e, n) {
      return this.put(new u_()).update(n).attr({
        x: 0,
        y: 0,
        width: t,
        height: e,
        patternUnits: "userSpaceOnUse"
      });
    })
  }
});
ir(u_, "Pattern");
let bO = class extends Zl {
  constructor(e, n = e) {
    super(_i("image", e), n);
  }
  // (re)load image
  load(e, n) {
    if (!e)
      return this;
    const r = new rr.window.Image();
    return BN(
      r,
      "load",
      function(i) {
        const a = this.parent(u_);
        this.width() === 0 && this.height() === 0 && this.size(r.width, r.height), a instanceof u_ && a.width() === 0 && a.height() === 0 && a.size(this.width(), this.height()), typeof n == "function" && n.call(this, i);
      },
      this
    ), BN(r, "load error", function() {
      Tb(r);
    }), this.attr("href", r.src = e, z_);
  }
};
ije(function(t, e, n) {
  return (t === "fill" || t === "stroke") && A9e.test(e) && (e = n.root().defs().image(e)), e instanceof bO && (e = n.root().defs().pattern(0, 0, (r) => {
    r.add(e);
  })), e;
});
Tn({
  Container: {
    // create image element, load image and set its size
    image: Si(function(t, e) {
      return this.put(new bO()).size(0, 0).load(t, e);
    })
  }
});
ir(bO, "Image");
class K0 extends tw {
  // Get bounding box of points
  bbox() {
    let e = -1 / 0, n = -1 / 0, r = 1 / 0, i = 1 / 0;
    return this.forEach(function(a) {
      e = Math.max(a[0], e), n = Math.max(a[1], n), r = Math.min(a[0], r), i = Math.min(a[1], i);
    }), new Po(r, i, e - r, n - i);
  }
  // Move point string
  move(e, n) {
    const r = this.bbox();
    if (e -= r.x, n -= r.y, !isNaN(e) && !isNaN(n))
      for (let i = this.length - 1; i >= 0; i--)
        this[i] = [this[i][0] + e, this[i][1] + n];
    return this;
  }
  // Parse point string and flat array
  parse(e = [0, 0]) {
    const n = [];
    e instanceof Array ? e = Array.prototype.concat.apply([], e) : e = e.trim().split(Bh).map(parseFloat), e.length % 2 !== 0 && e.pop();
    for (let r = 0, i = e.length; r < i; r = r + 2)
      n.push([e[r], e[r + 1]]);
    return n;
  }
  // Resize poly string
  size(e, n) {
    let r;
    const i = this.bbox();
    for (r = this.length - 1; r >= 0; r--)
      i.width && (this[r][0] = (this[r][0] - i.x) * e / i.width + i.x), i.height && (this[r][1] = (this[r][1] - i.y) * n / i.height + i.y);
    return this;
  }
  // Convert array to line object
  toLine() {
    return {
      x1: this[0][0],
      y1: this[0][1],
      x2: this[1][0],
      y2: this[1][1]
    };
  }
  // Convert array to string
  toString() {
    const e = [];
    for (let n = 0, r = this.length; n < r; n++)
      e.push(this[n].join(","));
    return e.join(" ");
  }
  transform(e) {
    return this.clone().transformO(e);
  }
  // transform points with matrix (similar to Point.transform)
  transformO(e) {
    $t.isMatrixLike(e) || (e = new $t(e));
    for (let n = this.length; n--; ) {
      const [r, i] = this[n];
      this[n][0] = e.a * r + e.c * i + e.e, this[n][1] = e.b * r + e.d * i + e.f;
    }
    return this;
  }
}
const pje = K0;
function mje(t) {
  return t == null ? this.bbox().x : this.move(t, this.bbox().y);
}
function gje(t) {
  return t == null ? this.bbox().y : this.move(this.bbox().x, t);
}
function vje(t) {
  const e = this.bbox();
  return t == null ? e.width : this.size(t, e.height);
}
function yje(t) {
  const e = this.bbox();
  return t == null ? e.height : this.size(e.width, t);
}
const Tk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MorphArray: pje,
  height: yje,
  width: vje,
  x: mje,
  y: gje
}, Symbol.toStringTag, { value: "Module" }));
class d_ extends Zl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("line", e), n);
  }
  // Get array
  array() {
    return new K0([
      [this.attr("x1"), this.attr("y1")],
      [this.attr("x2"), this.attr("y2")]
    ]);
  }
  // Move by left top corner
  move(e, n) {
    return this.attr(this.array().move(e, n).toLine());
  }
  // Overwrite native plot() method
  plot(e, n, r, i) {
    return e == null ? this.array() : (typeof n < "u" ? e = { x1: e, y1: n, x2: r, y2: i } : e = new K0(e).toLine(), this.attr(e));
  }
  // Set element size to given width and height
  size(e, n) {
    const r = Ew(this, e, n);
    return this.attr(this.array().size(r.width, r.height).toLine());
  }
}
Gn(d_, Tk);
Tn({
  Container: {
    // Create a line element
    line: Si(function(...t) {
      return d_.prototype.plot.apply(
        this.put(new d_()),
        t[0] != null ? t : [0, 0, 0, 0]
      );
    })
  }
});
ir(d_, "Line");
class o5 extends dl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("marker", e), n);
  }
  // Set height of element
  height(e) {
    return this.attr("markerHeight", e);
  }
  orient(e) {
    return this.attr("orient", e);
  }
  // Set marker refX and refY
  ref(e, n) {
    return this.attr("refX", e).attr("refY", n);
  }
  // Return the fill id
  toString() {
    return "url(#" + this.id() + ")";
  }
  // Update marker
  update(e) {
    return this.clear(), typeof e == "function" && e.call(this, this), this;
  }
  // Set width of element
  width(e) {
    return this.attr("markerWidth", e);
  }
}
Tn({
  Container: {
    marker(...t) {
      return this.defs().marker(...t);
    }
  },
  Defs: {
    // Create marker
    marker: Si(function(t, e, n) {
      return this.put(new o5()).size(t, e).ref(t / 2, e / 2).viewbox(0, 0, t, e).attr("orient", "auto").update(n);
    })
  },
  marker: {
    // Create and attach markers
    marker(t, e, n, r) {
      let i = ["marker"];
      return t !== "all" && i.push(t), i = i.join("-"), t = arguments[1] instanceof o5 ? arguments[1] : this.defs().marker(e, n, r), this.attr(i, t);
    }
  }
});
ir(o5, "Marker");
function Ob(t, e) {
  return function(n) {
    return n == null ? this[t] : (this[t] = n, e && e.call(this), this);
  };
}
const bje = {
  "-": function(t) {
    return t;
  },
  "<>": function(t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
  },
  ">": function(t) {
    return Math.sin(t * Math.PI / 2);
  },
  "<": function(t) {
    return -Math.cos(t * Math.PI / 2) + 1;
  },
  bezier: function(t, e, n, r) {
    return function(i) {
      return i < 0 ? t > 0 ? e / t * i : n > 0 ? r / n * i : 0 : i > 1 ? n < 1 ? (1 - r) / (1 - n) * i + (r - n) / (1 - n) : t < 1 ? (1 - e) / (1 - t) * i + (e - t) / (1 - t) : 1 : 3 * i * (1 - i) ** 2 * e + 3 * i ** 2 * (1 - i) * r + i ** 3;
    };
  },
  // see https://www.w3.org/TR/css-easing-1/#step-timing-function-algo
  steps: function(t, e = "end") {
    e = e.split("-").reverse()[0];
    let n = t;
    return e === "none" ? --n : e === "both" && ++n, (r, i = !1) => {
      let a = Math.floor(r * t);
      const s = r * a % 1 === 0;
      return (e === "start" || e === "both") && ++a, i && s && --a, r >= 0 && a < 0 && (a = 0), r <= 1 && a > n && (a = n), a / n;
    };
  }
};
class Ok {
  done() {
    return !1;
  }
}
class zN extends Ok {
  constructor(e = iE.ease) {
    super(), this.ease = bje[e] || e;
  }
  step(e, n, r) {
    return typeof e != "number" ? r < 1 ? e : n : e + (n - e) * this.ease(r);
  }
}
class s5 extends Ok {
  constructor(e) {
    super(), this.stepper = e;
  }
  done(e) {
    return e.done;
  }
  step(e, n, r, i) {
    return this.stepper(e, n, r, i);
  }
}
function bU() {
  const t = (this._duration || 500) / 1e3, e = this._overshoot || 0, n = 1e-10, r = Math.PI, i = Math.log(e / 100 + n), a = -i / Math.sqrt(r * r + i * i), s = 3.9 / (a * t);
  this.d = 2 * a * s, this.k = s * s;
}
class wje extends s5 {
  constructor(e = 500, n = 0) {
    super(), this.duration(e).overshoot(n);
  }
  step(e, n, r, i) {
    if (typeof e == "string")
      return e;
    if (i.done = r === 1 / 0, r === 1 / 0)
      return n;
    if (r === 0)
      return e;
    r > 100 && (r = 16), r /= 1e3;
    const a = i.velocity || 0, s = -this.d * a - this.k * (e - n), c = e + a * r + s * r * r / 2;
    return i.velocity = a + s * r, i.done = Math.abs(n - c) + Math.abs(a) < 2e-3, i.done ? n : c;
  }
}
Gn(wje, {
  duration: Ob("_duration", bU),
  overshoot: Ob("_overshoot", bU)
});
class xje extends s5 {
  constructor(e = 0.1, n = 0.01, r = 0, i = 1e3) {
    super(), this.p(e).i(n).d(r).windup(i);
  }
  step(e, n, r, i) {
    if (typeof e == "string")
      return e;
    if (i.done = r === 1 / 0, r === 1 / 0)
      return n;
    if (r === 0)
      return e;
    const a = n - e;
    let s = (i.integral || 0) + a * r;
    const c = (a - (i.error || 0)) / r, d = this._windup;
    return d !== !1 && (s = Math.max(-d, Math.min(s, d))), i.error = a, i.integral = s, i.done = Math.abs(a) < 1e-3, i.done ? n : e + (this.P * a + this.I * s + this.D * c);
  }
}
Gn(xje, {
  windup: Ob("_windup"),
  p: Ob("P"),
  i: Ob("I"),
  d: Ob("D")
});
const Sje = {
  M: 2,
  L: 2,
  H: 1,
  V: 1,
  C: 6,
  S: 4,
  Q: 4,
  T: 2,
  A: 7,
  Z: 0
}, FN = {
  M: function(t, e, n) {
    return e.x = n.x = t[0], e.y = n.y = t[1], ["M", e.x, e.y];
  },
  L: function(t, e) {
    return e.x = t[0], e.y = t[1], ["L", t[0], t[1]];
  },
  H: function(t, e) {
    return e.x = t[0], ["H", t[0]];
  },
  V: function(t, e) {
    return e.y = t[0], ["V", t[0]];
  },
  C: function(t, e) {
    return e.x = t[4], e.y = t[5], ["C", t[0], t[1], t[2], t[3], t[4], t[5]];
  },
  S: function(t, e) {
    return e.x = t[2], e.y = t[3], ["S", t[0], t[1], t[2], t[3]];
  },
  Q: function(t, e) {
    return e.x = t[2], e.y = t[3], ["Q", t[0], t[1], t[2], t[3]];
  },
  T: function(t, e) {
    return e.x = t[0], e.y = t[1], ["T", t[0], t[1]];
  },
  Z: function(t, e, n) {
    return e.x = n.x, e.y = n.y, ["Z"];
  },
  A: function(t, e) {
    return e.x = t[5], e.y = t[6], ["A", t[0], t[1], t[2], t[3], t[4], t[5], t[6]];
  }
}, CD = "mlhvqtcsaz".split("");
for (let t = 0, e = CD.length; t < e; ++t)
  FN[CD[t]] = function(n) {
    return function(r, i, a) {
      if (n === "H")
        r[0] = r[0] + i.x;
      else if (n === "V")
        r[0] = r[0] + i.y;
      else if (n === "A")
        r[5] = r[5] + i.x, r[6] = r[6] + i.y;
      else
        for (let s = 0, c = r.length; s < c; ++s)
          r[s] = r[s] + (s % 2 ? i.y : i.x);
      return FN[n](r, i, a);
    };
  }(CD[t].toUpperCase());
function Eje(t) {
  const e = t.segment[0];
  return FN[e](t.segment.slice(1), t.p, t.p0);
}
function VN(t) {
  return t.segment.length && t.segment.length - 1 === Sje[t.segment[0].toUpperCase()];
}
function _je(t, e) {
  t.inNumber && Q1(t, !1);
  const n = Sk.test(e);
  if (n)
    t.segment = [e];
  else {
    const r = t.lastCommand, i = r.toLowerCase(), a = r === i;
    t.segment = [i === "m" ? a ? "l" : "L" : r];
  }
  return t.inSegment = !0, t.lastCommand = t.segment[0], n;
}
function Q1(t, e) {
  if (!t.inNumber)
    throw new Error("Parser Error");
  t.number && t.segment.push(parseFloat(t.number)), t.inNumber = e, t.number = "", t.pointSeen = !1, t.hasExponent = !1, VN(t) && UN(t);
}
function UN(t) {
  t.inSegment = !1, t.absolute && (t.segment = Eje(t)), t.segments.push(t.segment);
}
function Aje(t) {
  if (!t.segment.length)
    return !1;
  const e = t.segment[0].toUpperCase() === "A", n = t.segment.length;
  return e && (n === 4 || n === 5);
}
function Cje(t) {
  return t.lastToken.toUpperCase() === "E";
}
const Tje = /* @__PURE__ */ new Set([" ", ",", "	", `
`, "\r", "\f"]);
function Oje(t, e = !0) {
  let n = 0, r = "";
  const i = {
    segment: [],
    inNumber: !1,
    number: "",
    lastToken: "",
    inSegment: !1,
    segments: [],
    pointSeen: !1,
    hasExponent: !1,
    absolute: e,
    p0: new $a(),
    p: new $a()
  };
  for (; i.lastToken = r, r = t.charAt(n++); )
    if (!(!i.inSegment && _je(i, r))) {
      if (r === ".") {
        if (i.pointSeen || i.hasExponent) {
          Q1(i, !1), --n;
          continue;
        }
        i.inNumber = !0, i.pointSeen = !0, i.number += r;
        continue;
      }
      if (!isNaN(parseInt(r))) {
        if (i.number === "0" || Aje(i)) {
          i.inNumber = !0, i.number = r, Q1(i, !0);
          continue;
        }
        i.inNumber = !0, i.number += r;
        continue;
      }
      if (Tje.has(r)) {
        i.inNumber && Q1(i, !1);
        continue;
      }
      if (r === "-" || r === "+") {
        if (i.inNumber && !Cje(i)) {
          Q1(i, !1), --n;
          continue;
        }
        i.number += r, i.inNumber = !0;
        continue;
      }
      if (r.toUpperCase() === "E") {
        i.number += r, i.hasExponent = !0;
        continue;
      }
      if (Sk.test(r)) {
        if (i.inNumber)
          Q1(i, !1);
        else if (VN(i))
          UN(i);
        else
          throw new Error("parser Error");
        --n;
      }
    }
  return i.inNumber && Q1(i, !1), i.inSegment && VN(i) && UN(i), i.segments;
}
function Rje(t) {
  let e = "";
  for (let n = 0, r = t.length; n < r; n++)
    e += t[n][0], t[n][1] != null && (e += t[n][1], t[n][2] != null && (e += " ", e += t[n][2], t[n][3] != null && (e += " ", e += t[n][3], e += " ", e += t[n][4], t[n][5] != null && (e += " ", e += t[n][5], e += " ", e += t[n][6], t[n][7] != null && (e += " ", e += t[n][7])))));
  return e + " ";
}
class Og extends tw {
  // Get bounding box of path
  bbox() {
    return M0().path.setAttribute("d", this.toString()), new Po(M0.nodes.path.getBBox());
  }
  // Move path string
  move(e, n) {
    const r = this.bbox();
    if (e -= r.x, n -= r.y, !isNaN(e) && !isNaN(n))
      for (let i, a = this.length - 1; a >= 0; a--)
        i = this[a][0], i === "M" || i === "L" || i === "T" ? (this[a][1] += e, this[a][2] += n) : i === "H" ? this[a][1] += e : i === "V" ? this[a][1] += n : i === "C" || i === "S" || i === "Q" ? (this[a][1] += e, this[a][2] += n, this[a][3] += e, this[a][4] += n, i === "C" && (this[a][5] += e, this[a][6] += n)) : i === "A" && (this[a][6] += e, this[a][7] += n);
    return this;
  }
  // Absolutize and parse path to array
  parse(e = "M0 0") {
    return Array.isArray(e) && (e = Array.prototype.concat.apply([], e).toString()), Oje(e);
  }
  // Resize path string
  size(e, n) {
    const r = this.bbox();
    let i, a;
    for (r.width = r.width === 0 ? 1 : r.width, r.height = r.height === 0 ? 1 : r.height, i = this.length - 1; i >= 0; i--)
      a = this[i][0], a === "M" || a === "L" || a === "T" ? (this[i][1] = (this[i][1] - r.x) * e / r.width + r.x, this[i][2] = (this[i][2] - r.y) * n / r.height + r.y) : a === "H" ? this[i][1] = (this[i][1] - r.x) * e / r.width + r.x : a === "V" ? this[i][1] = (this[i][1] - r.y) * n / r.height + r.y : a === "C" || a === "S" || a === "Q" ? (this[i][1] = (this[i][1] - r.x) * e / r.width + r.x, this[i][2] = (this[i][2] - r.y) * n / r.height + r.y, this[i][3] = (this[i][3] - r.x) * e / r.width + r.x, this[i][4] = (this[i][4] - r.y) * n / r.height + r.y, a === "C" && (this[i][5] = (this[i][5] - r.x) * e / r.width + r.x, this[i][6] = (this[i][6] - r.y) * n / r.height + r.y)) : a === "A" && (this[i][1] = this[i][1] * e / r.width, this[i][2] = this[i][2] * n / r.height, this[i][6] = (this[i][6] - r.x) * e / r.width + r.x, this[i][7] = (this[i][7] - r.y) * n / r.height + r.y);
    return this;
  }
  // Convert array to string
  toString() {
    return Rje(this);
  }
}
const LJ = (t) => {
  const e = typeof t;
  return e === "number" ? fn : e === "string" ? zr.isColor(t) ? zr : Bh.test(t) ? Sk.test(t) ? Og : tw : xJ.test(t) ? fn : $N : Rk.indexOf(t.constructor) > -1 ? t.constructor : Array.isArray(t) ? tw : e === "object" ? f_ : $N;
};
class Z1 {
  constructor(e) {
    this._stepper = e || new zN("-"), this._from = null, this._to = null, this._type = null, this._context = null, this._morphObj = null;
  }
  at(e) {
    return this._morphObj.morph(
      this._from,
      this._to,
      e,
      this._stepper,
      this._context
    );
  }
  done() {
    return this._context.map(this._stepper.done).reduce(function(n, r) {
      return n && r;
    }, !0);
  }
  from(e) {
    return e == null ? this._from : (this._from = this._set(e), this);
  }
  stepper(e) {
    return e == null ? this._stepper : (this._stepper = e, this);
  }
  to(e) {
    return e == null ? this._to : (this._to = this._set(e), this);
  }
  type(e) {
    return e == null ? this._type : (this._type = e, this);
  }
  _set(e) {
    this._type || this.type(LJ(e));
    let n = new this._type(e);
    return this._type === zr && (n = this._to ? n[this._to[4]]() : this._from ? n[this._from[4]]() : n), this._type === f_ && (n = this._to ? n.align(this._to) : this._from ? n.align(this._from) : n), n = n.toConsumable(), this._morphObj = this._morphObj || new this._type(), this._context = this._context || Array.apply(null, Array(n.length)).map(Object).map(function(r) {
      return r.done = !0, r;
    }), n;
  }
}
class $N {
  constructor(...e) {
    this.init(...e);
  }
  init(e) {
    return e = Array.isArray(e) ? e[0] : e, this.value = e, this;
  }
  toArray() {
    return [this.value];
  }
  valueOf() {
    return this.value;
  }
}
class U_ {
  constructor(...e) {
    this.init(...e);
  }
  init(e) {
    return Array.isArray(e) && (e = {
      scaleX: e[0],
      scaleY: e[1],
      shear: e[2],
      rotate: e[3],
      translateX: e[4],
      translateY: e[5],
      originX: e[6],
      originY: e[7]
    }), Object.assign(this, U_.defaults, e), this;
  }
  toArray() {
    const e = this;
    return [
      e.scaleX,
      e.scaleY,
      e.shear,
      e.rotate,
      e.translateX,
      e.translateY,
      e.originX,
      e.originY
    ];
  }
}
U_.defaults = {
  scaleX: 1,
  scaleY: 1,
  shear: 0,
  rotate: 0,
  translateX: 0,
  translateY: 0,
  originX: 0,
  originY: 0
};
const Dje = (t, e) => t[0] < e[0] ? -1 : t[0] > e[0] ? 1 : 0;
class f_ {
  constructor(...e) {
    this.init(...e);
  }
  align(e) {
    const n = this.values;
    for (let r = 0, i = n.length; r < i; ++r) {
      if (n[r + 1] === e[r + 1]) {
        if (n[r + 1] === zr && e[r + 7] !== n[r + 7]) {
          const c = e[r + 7], d = new zr(this.values.splice(r + 3, 5))[c]().toArray();
          this.values.splice(r + 3, 0, ...d);
        }
        r += n[r + 2] + 2;
        continue;
      }
      if (!e[r + 1])
        return this;
      const a = new e[r + 1]().toArray(), s = n[r + 2] + 3;
      n.splice(
        r,
        s,
        e[r],
        e[r + 1],
        e[r + 2],
        ...a
      ), r += n[r + 2] + 2;
    }
    return this;
  }
  init(e) {
    if (this.values = [], Array.isArray(e)) {
      this.values = e.slice();
      return;
    }
    e = e || {};
    const n = [];
    for (const r in e) {
      const i = LJ(e[r]), a = new i(e[r]).toArray();
      n.push([r, i, a.length, ...a]);
    }
    return n.sort(Dje), this.values = n.reduce((r, i) => r.concat(i), []), this;
  }
  toArray() {
    return this.values;
  }
  valueOf() {
    const e = {}, n = this.values;
    for (; n.length; ) {
      const r = n.shift(), i = n.shift(), a = n.shift(), s = n.splice(0, a);
      e[r] = new i(s);
    }
    return e;
  }
}
const Rk = [$N, U_, f_];
function Nje(t = []) {
  Rk.push(...[].concat(t));
}
function Mje() {
  Gn(Rk, {
    to(t) {
      return new Z1().type(this.constructor).from(this.toArray()).to(t);
    },
    fromArray(t) {
      return this.init(t), this;
    },
    toConsumable() {
      return this.toArray();
    },
    morph(t, e, n, r, i) {
      const a = function(s, c) {
        return r.step(s, e[c], n, i[c], i);
      };
      return this.fromArray(t.map(a));
    }
  });
}
class Aw extends Zl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("path", e), n);
  }
  // Get array
  array() {
    return this._array || (this._array = new Og(this.attr("d")));
  }
  // Clear array cache
  clear() {
    return delete this._array, this;
  }
  // Set height of element
  height(e) {
    return e == null ? this.bbox().height : this.size(this.bbox().width, e);
  }
  // Move by left top corner
  move(e, n) {
    return this.attr("d", this.array().move(e, n));
  }
  // Plot new path
  plot(e) {
    return e == null ? this.array() : this.clear().attr(
      "d",
      typeof e == "string" ? e : this._array = new Og(e)
    );
  }
  // Set element size to given width and height
  size(e, n) {
    const r = Ew(this, e, n);
    return this.attr("d", this.array().size(r.width, r.height));
  }
  // Set width of element
  width(e) {
    return e == null ? this.bbox().width : this.size(e, this.bbox().height);
  }
  // Move by left top corner over x-axis
  x(e) {
    return e == null ? this.bbox().x : this.move(e, this.bbox().y);
  }
  // Move by left top corner over y-axis
  y(e) {
    return e == null ? this.bbox().y : this.move(this.bbox().x, e);
  }
}
Aw.prototype.MorphArray = Og;
Tn({
  Container: {
    // Create a wrapped path element
    path: Si(function(t) {
      return this.put(new Aw()).plot(t || new Og());
    })
  }
});
ir(Aw, "Path");
function Ije() {
  return this._array || (this._array = new K0(this.attr("points")));
}
function kje() {
  return delete this._array, this;
}
function jje(t, e) {
  return this.attr("points", this.array().move(t, e));
}
function Pje(t) {
  return t == null ? this.array() : this.clear().attr(
    "points",
    typeof t == "string" ? t : this._array = new K0(t)
  );
}
function Lje(t, e) {
  const n = Ew(this, t, e);
  return this.attr("points", this.array().size(n.width, n.height));
}
const BJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  array: Ije,
  clear: kje,
  move: jje,
  plot: Pje,
  size: Lje
}, Symbol.toStringTag, { value: "Module" }));
class $_ extends Zl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("polygon", e), n);
  }
}
Tn({
  Container: {
    // Create a wrapped polygon element
    polygon: Si(function(t) {
      return this.put(new $_()).plot(t || new K0());
    })
  }
});
Gn($_, Tk);
Gn($_, BJ);
ir($_, "Polygon");
class H_ extends Zl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("polyline", e), n);
  }
}
Tn({
  Container: {
    // Create a wrapped polygon element
    polyline: Si(function(t) {
      return this.put(new H_()).plot(t || new K0());
    })
  }
});
Gn(H_, Tk);
Gn(H_, BJ);
ir(H_, "Polyline");
let wO = class extends Zl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("rect", e), n);
  }
};
Gn(wO, { rx: Ak, ry: Ck });
Tn({
  Container: {
    // Create a rect element
    rect: Si(function(t, e) {
      return this.put(new wO()).size(t, e);
    })
  }
});
ir(wO, "Rect");
class TD {
  constructor() {
    this._first = null, this._last = null;
  }
  // Shows us the first item in the list
  first() {
    return this._first && this._first.value;
  }
  // Shows us the last item in the list
  last() {
    return this._last && this._last.value;
  }
  push(e) {
    const n = typeof e.next < "u" ? e : { value: e, next: null, prev: null };
    return this._last ? (n.prev = this._last, this._last.next = n, this._last = n) : (this._last = n, this._first = n), n;
  }
  // Removes the item that was returned from the push
  remove(e) {
    e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e === this._last && (this._last = e.prev), e === this._first && (this._first = e.next), e.prev = null, e.next = null;
  }
  shift() {
    const e = this._first;
    return e ? (this._first = e.next, this._first && (this._first.prev = null), this._last = this._first ? this._last : null, e.value) : null;
  }
}
const Nr = {
  nextDraw: null,
  frames: new TD(),
  timeouts: new TD(),
  immediates: new TD(),
  timer: () => rr.window.performance || rr.window.Date,
  transforms: [],
  frame(t) {
    const e = Nr.frames.push({ run: t });
    return Nr.nextDraw === null && (Nr.nextDraw = rr.window.requestAnimationFrame(Nr._draw)), e;
  },
  timeout(t, e) {
    e = e || 0;
    const n = Nr.timer().now() + e, r = Nr.timeouts.push({ run: t, time: n });
    return Nr.nextDraw === null && (Nr.nextDraw = rr.window.requestAnimationFrame(Nr._draw)), r;
  },
  immediate(t) {
    const e = Nr.immediates.push(t);
    return Nr.nextDraw === null && (Nr.nextDraw = rr.window.requestAnimationFrame(Nr._draw)), e;
  },
  cancelFrame(t) {
    t != null && Nr.frames.remove(t);
  },
  clearTimeout(t) {
    t != null && Nr.timeouts.remove(t);
  },
  cancelImmediate(t) {
    t != null && Nr.immediates.remove(t);
  },
  _draw(t) {
    let e = null;
    const n = Nr.timeouts.last();
    for (; (e = Nr.timeouts.shift()) && (t >= e.time ? e.run() : Nr.timeouts.push(e), e !== n); )
      ;
    let r = null;
    const i = Nr.frames.last();
    for (; r !== i && (r = Nr.frames.shift()); )
      r.run(t);
    let a = null;
    for (; a = Nr.immediates.shift(); )
      a();
    Nr.nextDraw = Nr.timeouts.first() || Nr.frames.first() ? rr.window.requestAnimationFrame(Nr._draw) : null;
  }
}, Bje = function(t) {
  const e = t.start, n = t.runner.duration(), r = e + n;
  return {
    start: e,
    duration: n,
    end: r,
    runner: t.runner
  };
}, zje = function() {
  const t = rr.window;
  return (t.performance || t.Date).now();
};
class zJ extends F_ {
  // Construct a new timeline on the given element
  constructor(e = zje) {
    super(), this._timeSource = e, this.terminate();
  }
  active() {
    return !!this._nextFrame;
  }
  finish() {
    return this.time(this.getEndTimeOfTimeline() + 1), this.pause();
  }
  // Calculates the end of the timeline
  getEndTime() {
    const e = this.getLastRunnerInfo(), n = e ? e.runner.duration() : 0;
    return (e ? e.start : this._time) + n;
  }
  getEndTimeOfTimeline() {
    const e = this._runners.map((n) => n.start + n.runner.duration());
    return Math.max(0, ...e);
  }
  getLastRunnerInfo() {
    return this.getRunnerInfoById(this._lastRunnerId);
  }
  getRunnerInfoById(e) {
    return this._runners[this._runnerIds.indexOf(e)] || null;
  }
  pause() {
    return this._paused = !0, this._continue();
  }
  persist(e) {
    return e == null ? this._persist : (this._persist = e, this);
  }
  play() {
    return this._paused = !1, this.updateTime()._continue();
  }
  reverse(e) {
    const n = this.speed();
    if (e == null)
      return this.speed(-n);
    const r = Math.abs(n);
    return this.speed(e ? -r : r);
  }
  // schedules a runner on the timeline
  schedule(e, n, r) {
    if (e == null)
      return this._runners.map(Bje);
    let i = 0;
    const a = this.getEndTime();
    if (n = n || 0, r == null || r === "last" || r === "after")
      i = a;
    else if (r === "absolute" || r === "start")
      i = n, n = 0;
    else if (r === "now")
      i = this._time;
    else if (r === "relative") {
      const d = this.getRunnerInfoById(e.id);
      d && (i = d.start + n, n = 0);
    } else if (r === "with-last") {
      const d = this.getLastRunnerInfo();
      i = d ? d.start : this._time;
    } else
      throw new Error('Invalid value for the "when" parameter');
    e.unschedule(), e.timeline(this);
    const s = e.persist(), c = {
      persist: s === null ? this._persist : s,
      start: i + n,
      runner: e
    };
    return this._lastRunnerId = e.id, this._runners.push(c), this._runners.sort((d, f) => d.start - f.start), this._runnerIds = this._runners.map((d) => d.runner.id), this.updateTime()._continue(), this;
  }
  seek(e) {
    return this.time(this._time + e);
  }
  source(e) {
    return e == null ? this._timeSource : (this._timeSource = e, this);
  }
  speed(e) {
    return e == null ? this._speed : (this._speed = e, this);
  }
  stop() {
    return this.time(0), this.pause();
  }
  time(e) {
    return e == null ? this._time : (this._time = e, this._continue(!0));
  }
  // Remove the runner from this timeline
  unschedule(e) {
    const n = this._runnerIds.indexOf(e.id);
    return n < 0 ? this : (this._runners.splice(n, 1), this._runnerIds.splice(n, 1), e.timeline(null), this);
  }
  // Makes sure, that after pausing the time doesn't jump
  updateTime() {
    return this.active() || (this._lastSourceTime = this._timeSource()), this;
  }
  // Checks if we are running and continues the animation
  _continue(e = !1) {
    return Nr.cancelFrame(this._nextFrame), this._nextFrame = null, e ? this._stepImmediate() : this._paused ? this : (this._nextFrame = Nr.frame(this._step), this);
  }
  _stepFn(e = !1) {
    const n = this._timeSource();
    let r = n - this._lastSourceTime;
    e && (r = 0);
    const i = this._speed * r + (this._time - this._lastStepTime);
    this._lastSourceTime = n, e || (this._time += i, this._time = this._time < 0 ? 0 : this._time), this._lastStepTime = this._time, this.fire("time", this._time);
    for (let s = this._runners.length; s--; ) {
      const c = this._runners[s], d = c.runner;
      this._time - c.start <= 0 && d.reset();
    }
    let a = !1;
    for (let s = 0, c = this._runners.length; s < c; s++) {
      const d = this._runners[s], f = d.runner;
      let g = i;
      const m = this._time - d.start;
      if (m <= 0) {
        a = !0;
        continue;
      } else
        m < g && (g = m);
      if (!f.active())
        continue;
      f.step(g).done ? d.persist !== !0 && f.duration() - f.time() + this._time + d.persist < this._time && (f.unschedule(), --s, --c) : a = !0;
    }
    return a && !(this._speed < 0 && this._time === 0) || this._runnerIds.length && this._speed < 0 && this._time > 0 ? this._continue() : (this.pause(), this.fire("finished")), this;
  }
  terminate() {
    this._startTime = 0, this._speed = 1, this._persist = 0, this._nextFrame = null, this._paused = !0, this._runners = [], this._runnerIds = [], this._lastRunnerId = -1, this._time = 0, this._lastSourceTime = 0, this._lastStepTime = 0, this._step = this._stepFn.bind(this, !1), this._stepImmediate = this._stepFn.bind(this, !0);
  }
}
Tn({
  Element: {
    timeline: function(t) {
      return t == null ? (this._timeline = this._timeline || new zJ(), this._timeline) : (this._timeline = t, this);
    }
  }
});
class Xl extends F_ {
  constructor(e) {
    super(), this.id = Xl.id++, e = e ?? iE.duration, e = typeof e == "function" ? new s5(e) : e, this._element = null, this._timeline = null, this.done = !1, this._queue = [], this._duration = typeof e == "number" && e, this._isDeclarative = e instanceof s5, this._stepper = this._isDeclarative ? e : new zN(), this._history = {}, this.enabled = !0, this._time = 0, this._lastTime = 0, this._reseted = !0, this.transforms = new $t(), this.transformId = 1, this._haveReversed = !1, this._reverse = !1, this._loopsDone = 0, this._swing = !1, this._wait = 0, this._times = 1, this._frameId = null, this._persist = this._isDeclarative ? !0 : null;
  }
  static sanitise(e, n, r) {
    let i = 1, a = !1, s = 0;
    return e = e ?? iE.duration, n = n ?? iE.delay, r = r || "last", typeof e == "object" && !(e instanceof Ok) && (n = e.delay ?? n, r = e.when ?? r, a = e.swing || a, i = e.times ?? i, s = e.wait ?? s, e = e.duration ?? iE.duration), {
      duration: e,
      delay: n,
      swing: a,
      times: i,
      wait: s,
      when: r
    };
  }
  active(e) {
    return e == null ? this.enabled : (this.enabled = e, this);
  }
  /*
  Private Methods
  ===============
  Methods that shouldn't be used externally
  */
  addTransform(e) {
    return this.transforms.lmultiplyO(e), this;
  }
  after(e) {
    return this.on("finished", e);
  }
  animate(e, n, r) {
    const i = Xl.sanitise(e, n, r), a = new Xl(i.duration);
    return this._timeline && a.timeline(this._timeline), this._element && a.element(this._element), a.loop(i).schedule(i.delay, i.when);
  }
  clearTransform() {
    return this.transforms = new $t(), this;
  }
  // TODO: Keep track of all transformations so that deletion is faster
  clearTransformsFromQueue() {
    (!this.done || !this._timeline || !this._timeline._runnerIds.includes(this.id)) && (this._queue = this._queue.filter((e) => !e.isTransform));
  }
  delay(e) {
    return this.animate(0, e);
  }
  duration() {
    return this._times * (this._wait + this._duration) - this._wait;
  }
  during(e) {
    return this.queue(null, e);
  }
  ease(e) {
    return this._stepper = new zN(e), this;
  }
  /*
  Runner Definitions
  ==================
  These methods help us define the runtime behaviour of the Runner or they
  help us make new runners from the current runner
  */
  element(e) {
    return e == null ? this._element : (this._element = e, e._prepareRunner(), this);
  }
  finish() {
    return this.step(1 / 0);
  }
  loop(e, n, r) {
    return typeof e == "object" && (n = e.swing, r = e.wait, e = e.times), this._times = e || 1 / 0, this._swing = n || !1, this._wait = r || 0, this._times === !0 && (this._times = 1 / 0), this;
  }
  loops(e) {
    const n = this._duration + this._wait;
    if (e == null) {
      const s = Math.floor(this._time / n), d = (this._time - s * n) / this._duration;
      return Math.min(s + d, this._times);
    }
    const r = Math.floor(e), i = e % 1, a = n * r + this._duration * i;
    return this.time(a);
  }
  persist(e) {
    return e == null ? this._persist : (this._persist = e, this);
  }
  position(e) {
    const n = this._time, r = this._duration, i = this._wait, a = this._times, s = this._swing, c = this._reverse;
    let d;
    if (e == null) {
      const b = function(_) {
        const A = s * Math.floor(_ % (2 * (i + r)) / (i + r)), T = A && !c || !A && c, O = Math.pow(-1, T) * (_ % (i + r)) / r + T;
        return Math.max(Math.min(O, 1), 0);
      }, w = a * (i + r) - i;
      return d = n <= 0 ? Math.round(b(1e-5)) : n < w ? b(n) : Math.round(b(w - 1e-5)), d;
    }
    const f = Math.floor(this.loops()), g = s && f % 2 === 0;
    return d = f + (g && !c || c && g ? e : 1 - e), this.loops(d);
  }
  progress(e) {
    return e == null ? Math.min(1, this._time / this.duration()) : this.time(e * this.duration());
  }
  /*
  Basic Functionality
  ===================
  These methods allow us to attach basic functions to the runner directly
  */
  queue(e, n, r, i) {
    return this._queue.push({
      initialiser: e || yU,
      runner: n || yU,
      retarget: r,
      isTransform: i,
      initialised: !1,
      finished: !1
    }), this.timeline() && this.timeline()._continue(), this;
  }
  reset() {
    return this._reseted ? this : (this.time(0), this._reseted = !0, this);
  }
  reverse(e) {
    return this._reverse = e ?? !this._reverse, this;
  }
  schedule(e, n, r) {
    if (e instanceof zJ || (r = n, n = e, e = this.timeline()), !e)
      throw Error("Runner cannot be scheduled without timeline");
    return e.schedule(this, n, r), this;
  }
  step(e) {
    if (!this.enabled)
      return this;
    e = e ?? 16, this._time += e;
    const n = this.position(), r = this._lastPosition !== n && this._time >= 0;
    this._lastPosition = n;
    const i = this.duration(), a = this._lastTime <= 0 && this._time > 0, s = this._lastTime < i && this._time >= i;
    this._lastTime = this._time, a && this.fire("start", this);
    const c = this._isDeclarative;
    this.done = !c && !s && this._time >= i, this._reseted = !1;
    let d = !1;
    return (r || c) && (this._initialise(r), this.transforms = new $t(), d = this._run(c ? e : n), this.fire("step", this)), this.done = this.done || d && c, s && this.fire("finished", this), this;
  }
  /*
  Runner animation methods
  ========================
  Control how the animation plays
  */
  time(e) {
    if (e == null)
      return this._time;
    const n = e - this._time;
    return this.step(n), this;
  }
  timeline(e) {
    return typeof e > "u" ? this._timeline : (this._timeline = e, this);
  }
  unschedule() {
    const e = this.timeline();
    return e && e.unschedule(this), this;
  }
  // Run each initialise function in the runner if required
  _initialise(e) {
    if (!(!e && !this._isDeclarative))
      for (let n = 0, r = this._queue.length; n < r; ++n) {
        const i = this._queue[n], a = this._isDeclarative || !i.initialised && e;
        e = !i.finished, a && e && (i.initialiser.call(this), i.initialised = !0);
      }
  }
  // Save a morpher to the morpher list so that we can retarget it later
  _rememberMorpher(e, n) {
    if (this._history[e] = {
      morpher: n,
      caller: this._queue[this._queue.length - 1]
    }, this._isDeclarative) {
      const r = this.timeline();
      r && r.play();
    }
  }
  // Try to set the target for a morpher if the morpher exists, otherwise
  // Run each run function for the position or dt given
  _run(e) {
    let n = !0;
    for (let r = 0, i = this._queue.length; r < i; ++r) {
      const a = this._queue[r], s = a.runner.call(this, e);
      a.finished = a.finished || s === !0, n = n && a.finished;
    }
    return n;
  }
  // do nothing and return false
  _tryRetarget(e, n, r) {
    if (this._history[e]) {
      if (!this._history[e].caller.initialised) {
        const a = this._queue.indexOf(this._history[e].caller);
        return this._queue.splice(a, 1), !1;
      }
      this._history[e].caller.retarget ? this._history[e].caller.retarget.call(this, n, r) : this._history[e].morpher.to(n), this._history[e].caller.finished = !1;
      const i = this.timeline();
      return i && i.play(), !0;
    }
    return !1;
  }
}
Xl.id = 0;
class l5 {
  constructor(e = new $t(), n = -1, r = !0) {
    this.transforms = e, this.id = n, this.done = r;
  }
  clearTransformsFromQueue() {
  }
}
Gn([Xl, l5], {
  mergeWith(t) {
    return new l5(
      t.transforms.lmultiply(this.transforms),
      t.id
    );
  }
});
const FJ = (t, e) => t.lmultiplyO(e), VJ = (t) => t.transforms;
function Fje() {
  const e = this._transformationRunners.runners.map(VJ).reduce(FJ, new $t());
  this.transform(e), this._transformationRunners.merge(), this._transformationRunners.length() === 1 && (this._frameId = null);
}
class Vje {
  constructor() {
    this.runners = [], this.ids = [];
  }
  add(e) {
    if (this.runners.includes(e))
      return;
    const n = e.id + 1;
    return this.runners.push(e), this.ids.push(n), this;
  }
  clearBefore(e) {
    const n = this.ids.indexOf(e + 1) || 1;
    return this.ids.splice(0, n, 0), this.runners.splice(0, n, new l5()).forEach((r) => r.clearTransformsFromQueue()), this;
  }
  edit(e, n) {
    const r = this.ids.indexOf(e + 1);
    return this.ids.splice(r, 1, e + 1), this.runners.splice(r, 1, n), this;
  }
  getByID(e) {
    return this.runners[this.ids.indexOf(e + 1)];
  }
  length() {
    return this.ids.length;
  }
  merge() {
    let e = null;
    for (let n = 0; n < this.runners.length; ++n) {
      const r = this.runners[n];
      if (e && r.done && e.done && // don't merge runner when persisted on timeline
      (!r._timeline || !r._timeline._runnerIds.includes(r.id)) && (!e._timeline || !e._timeline._runnerIds.includes(e.id))) {
        this.remove(r.id);
        const a = r.mergeWith(e);
        this.edit(e.id, a), e = a, --n;
      } else
        e = r;
    }
    return this;
  }
  remove(e) {
    const n = this.ids.indexOf(e + 1);
    return this.ids.splice(n, 1), this.runners.splice(n, 1), this;
  }
}
Tn({
  Element: {
    animate(t, e, n) {
      const r = Xl.sanitise(t, e, n), i = this.timeline();
      return new Xl(r.duration).loop(r).element(this).timeline(i.play()).schedule(r.delay, r.when);
    },
    delay(t, e) {
      return this.animate(0, t, e);
    },
    // this function searches for all runners on the element and deletes the ones
    // which run before the current one. This is because absolute transformations
    // overwrite anything anyway so there is no need to waste time computing
    // other runners
    _clearTransformRunnersBefore(t) {
      this._transformationRunners.clearBefore(t.id);
    },
    _currentTransform(t) {
      return this._transformationRunners.runners.filter((e) => e.id <= t.id).map(VJ).reduce(FJ, new $t());
    },
    _addRunner(t) {
      this._transformationRunners.add(t), Nr.cancelImmediate(this._frameId), this._frameId = Nr.immediate(Fje.bind(this));
    },
    _prepareRunner() {
      this._frameId == null && (this._transformationRunners = new Vje().add(
        new l5(new $t(this))
      ));
    }
  }
});
const Uje = (t, e) => t.filter((n) => !e.includes(n));
Gn(Xl, {
  attr(t, e) {
    return this.styleAttr("attr", t, e);
  },
  // Add animatable styles
  css(t, e) {
    return this.styleAttr("css", t, e);
  },
  styleAttr(t, e, n) {
    if (typeof e == "string")
      return this.styleAttr(t, { [e]: n });
    let r = e;
    if (this._tryRetarget(t, r))
      return this;
    let i = new Z1(this._stepper).to(r), a = Object.keys(r);
    return this.queue(
      function() {
        i = i.from(this.element()[t](a));
      },
      function(s) {
        return this.element()[t](i.at(s).valueOf()), i.done();
      },
      function(s) {
        const c = Object.keys(s), d = Uje(c, a);
        if (d.length) {
          const g = this.element()[t](d), m = new f_(i.from()).valueOf();
          Object.assign(m, g), i.from(m);
        }
        const f = new f_(i.to()).valueOf();
        Object.assign(f, s), i.to(f), a = c, r = s;
      }
    ), this._rememberMorpher(t, i), this;
  },
  zoom(t, e) {
    if (this._tryRetarget("zoom", t, e))
      return this;
    let n = new Z1(this._stepper).to(new fn(t));
    return this.queue(
      function() {
        n = n.from(this.element().zoom());
      },
      function(r) {
        return this.element().zoom(n.at(r), e), n.done();
      },
      function(r, i) {
        e = i, n.to(r);
      }
    ), this._rememberMorpher("zoom", n), this;
  },
  /**
   ** absolute transformations
   **/
  //
  // M v -----|-----(D M v = F v)------|----->  T v
  //
  // 1. define the final state (T) and decompose it (once)
  //    t = [tx, ty, the, lam, sy, sx]
  // 2. on every frame: pull the current state of all previous transforms
  //    (M - m can change)
  //   and then write this as m = [tx0, ty0, the0, lam0, sy0, sx0]
  // 3. Find the interpolated matrix F(pos) = m + pos * (t - m)
  //   - Note F(0) = M
  //   - Note F(1) = T
  // 4. Now you get the delta matrix as a result: D = F * inv(M)
  transform(t, e, n) {
    if (e = t.relative || e, this._isDeclarative && !e && this._tryRetarget("transform", t))
      return this;
    const r = $t.isMatrixLike(t);
    n = t.affine != null ? t.affine : n ?? !r;
    const i = new Z1(this._stepper).type(
      n ? U_ : $t
    );
    let a, s, c, d, f;
    function g() {
      s = s || this.element(), a = a || PN(t, s), f = new $t(e ? void 0 : s), s._addRunner(this), e || s._clearTransformRunnersBefore(this);
    }
    function m(w) {
      e || this.clearTransform();
      const { x: _, y: A } = new $a(a).transform(
        s._currentTransform(this)
      );
      let T = new $t({ ...t, origin: [_, A] }), O = this._isDeclarative && c ? c : f;
      if (n) {
        T = T.decompose(_, A), O = O.decompose(_, A);
        const N = T.rotate, M = O.rotate, P = [N - 360, N, N + 360], z = P.map((G) => Math.abs(G - M)), F = Math.min(...z), $ = z.indexOf(F);
        T.rotate = P[$];
      }
      e && (r || (T.rotate = t.rotate || 0), this._isDeclarative && d && (O.rotate = d)), i.from(O), i.to(T);
      const R = i.at(w);
      return d = R.rotate, c = new $t(R), this.addTransform(c), s._addRunner(this), i.done();
    }
    function b(w) {
      (w.origin || "center").toString() !== (t.origin || "center").toString() && (a = PN(w, s)), t = { ...w, origin: a };
    }
    return this.queue(g, m, b, !0), this._isDeclarative && this._rememberMorpher("transform", i), this;
  },
  // Animatable x-axis
  x(t) {
    return this._queueNumber("x", t);
  },
  // Animatable y-axis
  y(t) {
    return this._queueNumber("y", t);
  },
  ax(t) {
    return this._queueNumber("ax", t);
  },
  ay(t) {
    return this._queueNumber("ay", t);
  },
  dx(t = 0) {
    return this._queueNumberDelta("x", t);
  },
  dy(t = 0) {
    return this._queueNumberDelta("y", t);
  },
  dmove(t, e) {
    return this.dx(t).dy(e);
  },
  _queueNumberDelta(t, e) {
    if (e = new fn(e), this._tryRetarget(t, e))
      return this;
    const n = new Z1(this._stepper).to(e);
    let r = null;
    return this.queue(
      function() {
        r = this.element()[t](), n.from(r), n.to(r + e);
      },
      function(i) {
        return this.element()[t](n.at(i)), n.done();
      },
      function(i) {
        n.to(r + new fn(i));
      }
    ), this._rememberMorpher(t, n), this;
  },
  _queueObject(t, e) {
    if (this._tryRetarget(t, e))
      return this;
    const n = new Z1(this._stepper).to(e);
    return this.queue(
      function() {
        n.from(this.element()[t]());
      },
      function(r) {
        return this.element()[t](n.at(r)), n.done();
      }
    ), this._rememberMorpher(t, n), this;
  },
  _queueNumber(t, e) {
    return this._queueObject(t, new fn(e));
  },
  // Animatable center x-axis
  cx(t) {
    return this._queueNumber("cx", t);
  },
  // Animatable center y-axis
  cy(t) {
    return this._queueNumber("cy", t);
  },
  // Add animatable move
  move(t, e) {
    return this.x(t).y(e);
  },
  amove(t, e) {
    return this.ax(t).ay(e);
  },
  // Add animatable center
  center(t, e) {
    return this.cx(t).cy(e);
  },
  // Add animatable size
  size(t, e) {
    let n;
    return (!t || !e) && (n = this._element.bbox()), t || (t = n.width / n.height * e), e || (e = n.height / n.width * t), this.width(t).height(e);
  },
  // Add animatable width
  width(t) {
    return this._queueNumber("width", t);
  },
  // Add animatable height
  height(t) {
    return this._queueNumber("height", t);
  },
  // Add animatable plot
  plot(t, e, n, r) {
    if (arguments.length === 4)
      return this.plot([t, e, n, r]);
    if (this._tryRetarget("plot", t))
      return this;
    const i = new Z1(this._stepper).type(this._element.MorphArray).to(t);
    return this.queue(
      function() {
        i.from(this._element.array());
      },
      function(a) {
        return this._element.plot(i.at(a)), i.done();
      }
    ), this._rememberMorpher("plot", i), this;
  },
  // Add leading method
  leading(t) {
    return this._queueNumber("leading", t);
  },
  // Add animatable viewbox
  viewbox(t, e, n, r) {
    return this._queueObject("viewbox", new Po(t, e, n, r));
  },
  update(t) {
    return typeof t != "object" ? this.update({
      offset: arguments[0],
      color: arguments[1],
      opacity: arguments[2]
    }) : (t.opacity != null && this.attr("stop-opacity", t.opacity), t.color != null && this.attr("stop-color", t.color), t.offset != null && this.attr("offset", t.offset), this);
  }
});
Gn(Xl, { rx: Ak, ry: Ck, from: jJ, to: PJ });
ir(Xl, "Runner");
class Dk extends dl {
  constructor(e, n = e) {
    super(_i("svg", e), n), this.namespace();
  }
  // Creates and returns defs element
  defs() {
    return this.isRoot() ? qc(this.node.querySelector("defs")) || this.put(new _k()) : this.root().defs();
  }
  isRoot() {
    return !this.node.parentNode || !(this.node.parentNode instanceof rr.window.SVGElement) && this.node.parentNode.nodeName !== "#document-fragment";
  }
  // Add namespaces
  namespace() {
    return this.isRoot() ? this.attr({ xmlns: bk, version: "1.1" }).attr(
      "xmlns:xlink",
      z_,
      ED
    ) : this.root().namespace();
  }
  removeNamespace() {
    return this.attr({ xmlns: null, version: null }).attr("xmlns:xlink", null, ED).attr("xmlns:svgjs", null, ED);
  }
  // Check if this is a root svg
  // If not, call root() from this element
  root() {
    return this.isRoot() ? this : super.root();
  }
}
Tn({
  Container: {
    // Create nested svg document
    nested: Si(function() {
      return this.put(new Dk());
    })
  }
});
ir(Dk, "Svg", !0);
let Nk = class extends dl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("symbol", e), n);
  }
};
Tn({
  Container: {
    symbol: Si(function() {
      return this.put(new Nk());
    })
  }
});
ir(Nk, "Symbol");
function $je(t) {
  return this._build === !1 && this.clear(), this.node.appendChild(rr.document.createTextNode(t)), this;
}
function Hje() {
  return this.node.getComputedTextLength();
}
function qje(t, e = this.bbox()) {
  return t == null ? e.x : this.attr("x", this.attr("x") + t - e.x);
}
function Gje(t, e = this.bbox()) {
  return t == null ? e.y : this.attr("y", this.attr("y") + t - e.y);
}
function Yje(t, e, n = this.bbox()) {
  return this.x(t, n).y(e, n);
}
function Xje(t, e = this.bbox()) {
  return t == null ? e.cx : this.attr("x", this.attr("x") + t - e.cx);
}
function Wje(t, e = this.bbox()) {
  return t == null ? e.cy : this.attr("y", this.attr("y") + t - e.cy);
}
function Qje(t, e, n = this.bbox()) {
  return this.cx(t, n).cy(e, n);
}
function Zje(t) {
  return this.attr("x", t);
}
function Kje(t) {
  return this.attr("y", t);
}
function Jje(t, e) {
  return this.ax(t).ay(e);
}
function ePe(t) {
  return this._build = !!t, this;
}
const UJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  amove: Jje,
  ax: Zje,
  ay: Kje,
  build: ePe,
  center: Qje,
  cx: Xje,
  cy: Wje,
  length: Hje,
  move: Yje,
  plain: $je,
  x: qje,
  y: Gje
}, Symbol.toStringTag, { value: "Module" }));
class Gu extends Zl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("text", e), n), this.dom.leading = this.dom.leading ?? new fn(1.3), this._rebuild = !0, this._build = !1;
  }
  // Set / get leading
  leading(e) {
    return e == null ? this.dom.leading : (this.dom.leading = new fn(e), this.rebuild());
  }
  // Rebuild appearance type
  rebuild(e) {
    if (typeof e == "boolean" && (this._rebuild = e), this._rebuild) {
      const n = this;
      let r = 0;
      const i = this.dom.leading;
      this.each(function(a) {
        if (LN(this.node))
          return;
        const s = rr.window.getComputedStyle(this.node).getPropertyValue("font-size"), c = i * new fn(s);
        this.dom.newLined && (this.attr("x", n.attr("x")), this.text() === `
` ? r += c : (this.attr("dy", a ? c + r : 0), r = 0));
      }), this.fire("rebuild");
    }
    return this;
  }
  // overwrite method from parent to set data properly
  setData(e) {
    return this.dom = e, this.dom.leading = new fn(e.leading || 1.3), this;
  }
  writeDataToDom() {
    return yJ(this, this.dom, { leading: 1.3 }), this;
  }
  // Set the text content
  text(e) {
    if (e === void 0) {
      const n = this.node.childNodes;
      let r = 0;
      e = "";
      for (let i = 0, a = n.length; i < a; ++i) {
        if (n[i].nodeName === "textPath" || LN(n[i])) {
          i === 0 && (r = i + 1);
          continue;
        }
        i !== r && n[i].nodeType !== 3 && qc(n[i]).dom.newLined === !0 && (e += `
`), e += n[i].textContent;
      }
      return e;
    }
    if (this.clear().build(!0), typeof e == "function")
      e.call(this, this);
    else {
      e = (e + "").split(`
`);
      for (let n = 0, r = e.length; n < r; n++)
        this.newLine(e[n]);
    }
    return this.build(!1).rebuild();
  }
}
Gn(Gu, UJ);
Tn({
  Container: {
    // Create text element
    text: Si(function(t = "") {
      return this.put(new Gu()).text(t);
    }),
    // Create plain text element
    plain: Si(function(t = "") {
      return this.put(new Gu()).plain(t);
    })
  }
});
ir(Gu, "Text");
class xO extends Zl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("tspan", e), n), this._build = !1;
  }
  // Shortcut dx
  dx(e) {
    return this.attr("dx", e);
  }
  // Shortcut dy
  dy(e) {
    return this.attr("dy", e);
  }
  // Create new line
  newLine() {
    this.dom.newLined = !0;
    const e = this.parent();
    if (!(e instanceof Gu))
      return this;
    const n = e.index(this), r = rr.window.getComputedStyle(this.node).getPropertyValue("font-size"), i = e.dom.leading * new fn(r);
    return this.dy(n ? i : 0).attr("x", e.x());
  }
  // Set text content
  text(e) {
    return e == null ? this.node.textContent + (this.dom.newLined ? `
` : "") : (typeof e == "function" ? (this.clear().build(!0), e.call(this, this), this.build(!1)) : this.plain(e), this);
  }
}
Gn(xO, UJ);
Tn({
  Tspan: {
    tspan: Si(function(t = "") {
      const e = new xO();
      return this._build || this.clear(), this.put(e).text(t);
    })
  },
  Text: {
    newLine: function(t = "") {
      return this.tspan(t).newLine();
    }
  }
});
ir(xO, "Tspan");
class Mk extends Zl {
  constructor(e, n = e) {
    super(_i("circle", e), n);
  }
  radius(e) {
    return this.attr("r", e);
  }
  // Radius x value
  rx(e) {
    return this.attr("r", e);
  }
  // Alias radius x value
  ry(e) {
    return this.rx(e);
  }
  size(e) {
    return this.radius(new fn(e).divide(2));
  }
}
Gn(Mk, { x: OJ, y: RJ, cx: DJ, cy: NJ, width: MJ, height: IJ });
Tn({
  Container: {
    // Create circle element
    circle: Si(function(t = 0) {
      return this.put(new Mk()).size(t).move(0, 0);
    })
  }
});
ir(Mk, "Circle");
class HN extends dl {
  constructor(e, n = e) {
    super(_i("clipPath", e), n);
  }
  // Unclip all clipped elements and remove itself
  remove() {
    return this.targets().forEach(function(e) {
      e.unclip();
    }), super.remove();
  }
  targets() {
    return _w("svg [clip-path*=" + this.id() + "]");
  }
}
Tn({
  Container: {
    // Create clipping element
    clip: Si(function() {
      return this.defs().put(new HN());
    })
  },
  Element: {
    // Distribute clipPath to svg element
    clipper() {
      return this.reference("clip-path");
    },
    clipWith(t) {
      const e = t instanceof HN ? t : this.parent().clip().add(t);
      return this.attr("clip-path", "url(#" + e.id() + ")");
    },
    // Unclip element
    unclip() {
      return this.attr("clip-path", null);
    }
  }
});
ir(HN, "ClipPath");
class $J extends df {
  constructor(e, n = e) {
    super(_i("foreignObject", e), n);
  }
}
Tn({
  Container: {
    foreignObject: Si(function(t, e) {
      return this.put(new $J()).size(t, e);
    })
  }
});
ir($J, "ForeignObject");
function tPe(t, e) {
  return this.children().forEach((n) => {
    let r;
    try {
      r = n.node instanceof a9e().SVGSVGElement ? new Po(n.attr(["x", "y", "width", "height"])) : n.bbox();
    } catch {
      return;
    }
    const i = new $t(n), a = i.translate(t, e).transform(i.inverse()), s = new $a(r.x, r.y).transform(a);
    n.move(s.x, s.y);
  }), this;
}
function nPe(t) {
  return this.dmove(t, 0);
}
function rPe(t) {
  return this.dmove(0, t);
}
function iPe(t, e = this.bbox()) {
  return t == null ? e.height : this.size(e.width, t, e);
}
function aPe(t = 0, e = 0, n = this.bbox()) {
  const r = t - n.x, i = e - n.y;
  return this.dmove(r, i);
}
function oPe(t, e, n = this.bbox()) {
  const r = Ew(this, t, e, n), i = r.width / n.width, a = r.height / n.height;
  return this.children().forEach((s) => {
    const c = new $a(n).transform(new $t(s).inverse());
    s.scale(i, a, c.x, c.y);
  }), this;
}
function sPe(t, e = this.bbox()) {
  return t == null ? e.width : this.size(t, e.height, e);
}
function lPe(t, e = this.bbox()) {
  return t == null ? e.x : this.move(t, e.y, e);
}
function cPe(t, e = this.bbox()) {
  return t == null ? e.y : this.move(e.x, t, e);
}
const HJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  dmove: tPe,
  dx: nPe,
  dy: rPe,
  height: iPe,
  move: aPe,
  size: oPe,
  width: sPe,
  x: lPe,
  y: cPe
}, Symbol.toStringTag, { value: "Module" }));
class Ik extends dl {
  constructor(e, n = e) {
    super(_i("g", e), n);
  }
}
Gn(Ik, HJ);
Tn({
  Container: {
    // Create a group element
    group: Si(function() {
      return this.put(new Ik());
    })
  }
});
ir(Ik, "G");
class c5 extends dl {
  constructor(e, n = e) {
    super(_i("a", e), n);
  }
  // Link target attribute
  target(e) {
    return this.attr("target", e);
  }
  // Link url
  to(e) {
    return this.attr("href", e, z_);
  }
}
Gn(c5, HJ);
Tn({
  Container: {
    // Create a hyperlink element
    link: Si(function(t) {
      return this.put(new c5()).to(t);
    })
  },
  Element: {
    unlink() {
      const t = this.linker();
      if (!t)
        return this;
      const e = t.parent();
      if (!e)
        return this.remove();
      const n = e.index(t);
      return e.add(this, n), t.remove(), this;
    },
    linkTo(t) {
      let e = this.linker();
      return e || (e = new c5(), this.wrap(e)), typeof t == "function" ? t.call(e, e) : e.to(t), this;
    },
    linker() {
      const t = this.parent();
      return t && t.node.nodeName.toLowerCase() === "a" ? t : null;
    }
  }
});
ir(c5, "A");
class qN extends dl {
  // Initialize node
  constructor(e, n = e) {
    super(_i("mask", e), n);
  }
  // Unmask all masked elements and remove itself
  remove() {
    return this.targets().forEach(function(e) {
      e.unmask();
    }), super.remove();
  }
  targets() {
    return _w("svg [mask*=" + this.id() + "]");
  }
}
Tn({
  Container: {
    mask: Si(function() {
      return this.defs().put(new qN());
    })
  },
  Element: {
    // Distribute mask to svg element
    masker() {
      return this.reference("mask");
    },
    maskWith(t) {
      const e = t instanceof qN ? t : this.parent().mask().add(t);
      return this.attr("mask", "url(#" + e.id() + ")");
    },
    // Unmask element
    unmask() {
      return this.attr("mask", null);
    }
  }
});
ir(qN, "Mask");
class qJ extends df {
  constructor(e, n = e) {
    super(_i("stop", e), n);
  }
  // add color stops
  update(e) {
    return (typeof e == "number" || e instanceof fn) && (e = {
      offset: arguments[0],
      color: arguments[1],
      opacity: arguments[2]
    }), e.opacity != null && this.attr("stop-opacity", e.opacity), e.color != null && this.attr("stop-color", e.color), e.offset != null && this.attr("offset", new fn(e.offset)), this;
  }
}
Tn({
  Gradient: {
    // Add a color stop
    stop: function(t, e, n) {
      return this.put(new qJ()).update(t, e, n);
    }
  }
});
ir(qJ, "Stop");
function uPe(t, e) {
  if (!t)
    return "";
  if (!e)
    return t;
  let n = t + "{";
  for (const r in e)
    n += n9e(r) + ":" + e[r] + ";";
  return n += "}", n;
}
class GN extends df {
  constructor(e, n = e) {
    super(_i("style", e), n);
  }
  addText(e = "") {
    return this.node.textContent += e, this;
  }
  font(e, n, r = {}) {
    return this.rule("@font-face", {
      fontFamily: e,
      src: n,
      ...r
    });
  }
  rule(e, n) {
    return this.addText(uPe(e, n));
  }
}
Tn("Dom", {
  style(t, e) {
    return this.put(new GN()).rule(t, e);
  },
  fontface(t, e, n) {
    return this.put(new GN()).font(t, e, n);
  }
});
ir(GN, "Style");
class kk extends Gu {
  // Initialize node
  constructor(e, n = e) {
    super(_i("textPath", e), n);
  }
  // return the array of the path track element
  array() {
    const e = this.track();
    return e ? e.array() : null;
  }
  // Plot path if any
  plot(e) {
    const n = this.track();
    let r = null;
    return n && (r = n.plot(e)), e == null ? r : this;
  }
  // Get the path element
  track() {
    return this.reference("href");
  }
}
Tn({
  Container: {
    textPath: Si(function(t, e) {
      return t instanceof Gu || (t = this.text(t)), t.path(e);
    })
  },
  Text: {
    // Create path for text to run on
    path: Si(function(t, e = !0) {
      const n = new kk();
      t instanceof Aw || (t = this.defs().path(t)), n.attr("href", "#" + t, z_);
      let r;
      if (e)
        for (; r = this.node.firstChild; )
          n.node.appendChild(r);
      return this.put(n);
    }),
    // Get the textPath children
    textPath() {
      return this.findOne("textPath");
    }
  },
  Path: {
    // creates a textPath from this path
    text: Si(function(t) {
      return t instanceof Gu || (t = new Gu().addTo(this.parent()).text(t)), t.path(this);
    }),
    targets() {
      return _w("svg textPath").filter((t) => (t.attr("href") || "").includes(this.id()));
    }
  }
});
kk.prototype.MorphArray = Og;
ir(kk, "TextPath");
class GJ extends Zl {
  constructor(e, n = e) {
    super(_i("use", e), n);
  }
  // Use element as a reference
  use(e, n) {
    return this.attr("href", (n || "") + "#" + e, z_);
  }
}
Tn({
  Container: {
    // Create a use element
    use: Si(function(t, e) {
      return this.put(new GJ()).use(t, e);
    })
  }
});
ir(GJ, "Use");
const YJ = Is;
Gn([Dk, Nk, bO, u_, o5], ul("viewbox"));
Gn([d_, H_, $_, Aw], ul("marker"));
Gn(Gu, ul("Text"));
Gn(Aw, ul("Path"));
Gn(_k, ul("Defs"));
Gn([Gu, xO], ul("Tspan"));
Gn([wO, yO, V_, Xl], ul("radius"));
Gn(F_, ul("EventTarget"));
Gn(Z0, ul("Dom"));
Gn(df, ul("Element"));
Gn(Zl, ul("Shape"));
Gn([dl, kJ], ul("Container"));
Gn(V_, ul("Gradient"));
Gn(Xl, ul("Runner"));
Tg.extend(e9e());
Nje([
  fn,
  zr,
  Po,
  $t,
  tw,
  K0,
  Og,
  $a
]);
Mje();
const u5 = [1e-3, 0.01, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8], d5 = [0.01, 0.1, 0.2, 0.1, 0.2, 0.5, 1, 2, 3, 4, 5, 10, 20, 25, 50, 100], Ba = {
  background: "rgba(239,239,239,0.13)",
  axis: "rgb(226, 232, 240)",
  scale: "#000000bb",
  grid: "#00000044",
  text: "#a8a8a8",
  labels: "#a8a8a8",
  line: "#f06",
  lineInactive: "rgba(255,0,102,0.15)",
  dot: "#312aa4",
  dotActive: "#f06"
}, dPe = 9999.999, fPe = 9999.998, hPe = (t) => {
  const e = ve.c(20), {
    standards: n,
    k: r,
    unit: i,
    highlightedPointId: a,
    onPointHighlight: s
  } = t, c = I.useRef(null), d = I.useRef(null);
  let f;
  e[0] !== n ? (f = n.flatMap(gPe), e[0] = n, e[1] = f) : f = e[1];
  const g = f;
  let m;
  e: {
    if (r == null || Number.isNaN(r) || r <= 0) {
      m = 1;
      break e;
    }
    m = r;
  }
  const b = m;
  let w, _;
  e[2] !== g ? (w = 1e-3, _ = 1e-3, g.forEach((V) => {
    V.archived || (w = Math.max(w, V.amount), _ = Math.max(_, V.area));
  }), e[2] = g, e[3] = w, e[4] = _) : (w = e[3], _ = e[4]);
  let A = b ?? 1;
  (A <= 0 || Number.isNaN(A)) && (A = 1);
  let T = w, O = _;
  T = Math.max(T, O * A), O = Math.max(O, T / A) * 1.25;
  const R = O * A;
  let N;
  e[5] !== R || e[6] !== O ? (N = {
    xMax: R,
    yMax: O
  }, e[5] = R, e[6] = O, e[7] = N) : N = e[7];
  const M = N;
  let P;
  e[8] !== M || e[9] !== a || e[10] !== g || e[11] !== s || e[12] !== i ? (P = () => {
    const V = c.current;
    if (V == null)
      return;
    d.current == null && (d.current = YJ().addTo(V).attr("overflow", "visible").size("100%", "100%"));
    const Y = d.current, ee = V.getBoundingClientRect(), K = ee.width, U = ee.height;
    if (!Y || K <= 0 || U <= 0)
      return;
    const q = M.xMax, W = M.yMax;
    if (q - 0 <= 0 || W - 0 <= 0)
      return;
    Y.clear(), Y.rect(K, U).fill(Ba.background);
    const ie = Ba.axis, J = Ba.grid, B = Ba.text;
    Y.line(0, 0, 0, U).stroke({
      width: 1,
      color: ie
    });
    let te = (W - 0) / 10;
    for (let ue = 0; ue < u5.length; ue = ue + 1, ue) {
      const Se = u5[ue];
      if (Se == null)
        break;
      if (te <= Se) {
        te = Se;
        break;
      }
    }
    const ae = Math.round(0 / te) * te;
    for (let ue = ae; ue <= W; ue = ue + te, ue) {
      const Se = Math.round(U - (ue - 0) * U / (W - 0));
      Y.text(Ms(ue, 3)).move(3, Se - 14).font({
        family: "PT Sans, Helvetica",
        size: 13,
        anchor: "left",
        leading: "1.5em",
        fill: B
      }), Y.line(0, Se, K, Se).stroke({
        width: 0.5,
        color: J
      });
    }
    Y.text("Peak area, mAU×min").move(40, 2).font({
      family: "PT Sans, Helvetica",
      size: 13,
      anchor: "left",
      leading: "1.5em",
      fill: B
    }), Y.line(0, U, K, U).stroke({
      width: 1,
      color: ie
    });
    const le = q - 0;
    let de = 1;
    if (le / 15 > 1 || le / 8 < 1) {
      de = le / 12;
      for (let ue = 0; ue < d5.length; ue = ue + 1, ue) {
        const Se = d5[ue];
        if (Se == null)
          break;
        if (de < Se) {
          de = Se;
          break;
        }
      }
    }
    const _e = Math.round(0 / de) * de;
    for (let ue = _e; ue < q; ue = ue + de, ue) {
      const Se = Math.round((ue - 0) * K / (q - 0));
      Math.abs(ue) < 1e-4 || (Y.text(Ms(ue, 3)).move(Se + 2, U).font({
        family: "PT Sans, Helvetica",
        size: 13,
        anchor: "left",
        leading: "1.5em",
        fill: B
      }), Y.line(Se, 0, Se, U).stroke({
        width: 0.5,
        color: J
      }));
    }
    Y.text(`Concentration, ${i ?? ""}`).move(K - 120, U - 30).font({
      family: "PT Sans, Helvetica",
      size: 13,
      anchor: "left",
      leading: "1.5em",
      fill: B
    }), Y.line(0, U, K, 0).fill(Ba.dot).stroke({
      color: Ba.dot,
      width: 2,
      linecap: "round",
      linejoin: "round"
    }), g.forEach((ue) => {
      if (ue.archived)
        return;
      const {
        amount: Se,
        area: Ne
      } = ue, Me = (Se - 0) * K / (q - 0), Ce = U - (Ne - 0) * U / (W - 0), Ue = a === ue.pointId ? Ba.dotActive : Ba.dot, rt = Y.group().fill(Ue), it = Y.circle(17).move(Me - 8, Ce - 8).stroke({
        color: "#ffffff",
        width: 1.75
      }), Ft = Y.text(ue.name).move(Me - 3, Ce - 9).font({
        family: "PT Sans, Helvetica",
        size: 13,
        anchor: "left",
        leading: "1.5em",
        fill: "#ffffff"
      });
      rt.data("id", ue.id).add(it).add(Ft), rt.on("mouseenter", () => {
        s?.(ue.pointId);
      }), rt.on("mouseleave", () => {
        s?.(null);
      });
    });
  }, e[8] = M, e[9] = a, e[10] = g, e[11] = s, e[12] = i, e[13] = P) : P = e[13];
  const z = P;
  let F, $;
  e[14] !== z ? (F = () => {
    const V = c.current;
    if (V == null)
      return;
    z();
    const Y = new ResizeObserver(() => {
      z();
    });
    return Y.observe(V), () => {
      Y.disconnect();
    };
  }, $ = [z], e[14] = z, e[15] = F, e[16] = $) : (F = e[15], $ = e[16]), I.useEffect(F, $);
  let G, H;
  e[17] === Symbol.for("react.memo_cache_sentinel") ? (G = () => () => {
    d.current?.clear(), d.current?.remove(), d.current = null;
  }, H = [], e[17] = G, e[18] = H) : (G = e[17], H = e[18]), I.useEffect(G, H);
  let Z;
  return e[19] === Symbol.for("react.memo_cache_sentinel") ? (Z = /* @__PURE__ */ C.jsx("div", { ref: c, className: "twd-h-[300px] twd-w-full twd-select-none" }), e[19] = Z) : Z = e[19], Z;
};
function pPe(t) {
  return t.amount != null && t.area != null;
}
function mPe(t) {
  return {
    id: t.id,
    pointId: t.pointId,
    amount: t.amount ?? 0,
    area: t.area ?? 0,
    archived: t.archived,
    name: t.name
  };
}
function gPe(t) {
  return t.injections.filter(pPe).map(mPe);
}
const vPe = (t) => {
  const e = ve.c(40), {
    standards: n,
    highlightedPointId: r,
    isLoading: i,
    onRendered: a
  } = t, s = I.useRef(null), c = I.useRef(null), d = I.useRef(null);
  let f;
  e[0] !== n ? (f = n.flatMap(bPe).filter(wPe), e[0] = n, e[1] = f) : f = e[1];
  const g = f;
  let m;
  e[2] !== g ? (m = g.map(SPe).filter(EPe), e[2] = g, e[3] = m) : m = e[3];
  const b = m;
  let w;
  e: {
    if (b.length === 0) {
      w = null;
      break e;
    }
    let K, U, q;
    e[4] !== b ? (q = 1 / 0, U = -1 / 0, K = 0, b.forEach((ie) => {
      ie.sanitizedData.forEach((te) => {
        Number.isFinite(te) && (q = Math.min(q, te), U = Math.max(U, te));
      });
      const J = ie.mps > 0 ? ie.mps : 1, B = ie.sanitizedData.length / J / 60;
      K = Math.max(K, B);
    }), !Number.isFinite(q) || !Number.isFinite(U) ? (q = 0, U = 1) : q === U && (U = q + 1), K <= 0 && (K = 1), e[4] = b, e[5] = K, e[6] = U, e[7] = q) : (K = e[5], U = e[6], q = e[7]);
    let W;
    e[8] !== K || e[9] !== U || e[10] !== q ? (W = {
      xs: 0,
      xe: K,
      ys: q,
      ye: U
    }, e[8] = K, e[9] = U, e[10] = q, e[11] = W) : W = e[11], w = W;
  }
  const _ = w;
  let A;
  e[12] !== _ || e[13] !== b || e[14] !== r || e[15] !== a ? (A = () => {
    const K = s.current;
    if (K == null)
      return;
    c.current == null && (c.current = YJ().addTo(K).attr("overflow", "visible").size("100%", "100%"));
    const U = c.current, q = K.getBoundingClientRect(), W = q.width, ie = q.height;
    if (U.clear(), !_ || b.length === 0 || W <= 0 || ie <= 0)
      return;
    const {
      xs: J,
      xe: B,
      ys: te,
      ye: ae
    } = _;
    if (B - J <= 0 || ae - te <= 0)
      return;
    U.rect(W, ie).fill(Ba.background), U.line(0, 0, 0, ie).stroke({
      width: 1,
      color: Ba.axis
    });
    let le = (ae - te) / 10;
    for (let rt = 0; rt < u5.length; rt = rt + 1, rt) {
      const it = u5[rt];
      if (it == null)
        break;
      if (le <= it) {
        le = it;
        break;
      }
    }
    const de = Math.round(te / le) * le;
    for (let rt = de; rt <= ae; rt = rt + le, rt) {
      const it = Math.round(ie - (rt - te) * ie / (ae - te));
      U.text(Ms(rt, 3)).move(3, it - 14).font({
        family: "PT Sans, Helvetica",
        size: 12,
        anchor: "left",
        leading: "1.5em",
        fill: Ba.labels
      }), U.line(0, it, W, it).stroke({
        width: 0.5,
        color: Ba.grid
      });
    }
    U.text("Signal, mAU").move(40, 2).font({
      family: "PT Sans, Helvetica",
      size: 13,
      anchor: "left",
      leading: "1.5em",
      fill: Ba.labels
    }), U.line(0, ie, W, ie).stroke({
      width: 1,
      color: Ba.axis
    });
    let ue = (B - J) / 12 || 1;
    for (let rt = 0; rt < d5.length; rt = rt + 1, rt) {
      const it = d5[rt];
      if (it == null)
        break;
      if (ue < it) {
        ue = it;
        break;
      }
    }
    const Se = Math.round(J / ue) * ue;
    for (let rt = Se; rt <= B; rt = rt + ue, rt) {
      const it = Math.round((rt - J) * W / (B - J));
      Math.abs(rt) < 1e-4 || (U.text(Ms(rt, 3)).move(it + 2, ie).font({
        family: "PT Sans, Helvetica",
        size: 13,
        anchor: "left",
        leading: "1.5em",
        fill: Ba.labels
      }), U.line(it, 0, it, ie).stroke({
        width: 0.5,
        color: Ba.grid
      }));
    }
    U.text("Time, min").move(W - 100, ie - 30).font({
      family: "PT Sans, Helvetica",
      size: 13,
      anchor: "left",
      leading: "1.5em",
      fill: Ba.labels
    }), b.forEach((rt) => {
      const {
        sanitizedData: it,
        mps: Ft
      } = rt;
      if (it.length === 0)
        return;
      const wt = Ft > 0 ? Ft : 1, Ot = it.map((He, $e) => {
        const ct = ($e / wt / 60 - J) * W / (B - J), Mt = ie - (He - te) * ie / (ae - te);
        return [ct, Mt];
      }), On = r === rt.pointId, Ct = r == null || On, se = Ct ? 0.95 : 0.2, ge = Ct ? 2.4 : 1.6, Te = Ct ? Ba.line : Ba.lineInactive;
      U.polyline(Ot).fill("none").stroke({
        color: Te,
        width: ge,
        opacity: se,
        linecap: "round",
        linejoin: "round"
      });
    });
    const Ne = K.querySelector("svg"), Me = K.getBoundingClientRect(), Ce = Ne instanceof SVGGraphicsElement ? (() => {
      try {
        return Ne.getBBox();
      } catch {
        return null;
      }
    })() : null;
    !(Me.width > 0 && Me.height > 0 && Ce != null && Ce.width > 0 && Ce.height > 0) || a == null || (d.current != null && cancelAnimationFrame(d.current), d.current = requestAnimationFrame(() => {
      d.current = null, a();
    }));
  }, e[12] = _, e[13] = b, e[14] = r, e[15] = a, e[16] = A) : A = e[16];
  const T = A;
  let O;
  e[17] !== b.length || e[18] !== T ? (O = () => {
    const K = s.current;
    if (K == null)
      return;
    if (b.length === 0) {
      c.current?.clear(), c.current?.remove(), c.current = null;
      return;
    }
    T();
    const U = new ResizeObserver(() => {
      T();
    });
    return U.observe(K), () => {
      U.disconnect();
    };
  }, e[17] = b.length, e[18] = T, e[19] = O) : O = e[19];
  let R;
  e[20] !== b || e[21] !== T ? (R = [b, T], e[20] = b, e[21] = T, e[22] = R) : R = e[22], I.useEffect(O, R);
  let N, M;
  if (e[23] === Symbol.for("react.memo_cache_sentinel") ? (N = () => () => {
    d.current != null && (cancelAnimationFrame(d.current), d.current = null), c.current?.clear(), c.current?.remove(), c.current = null;
  }, M = [], e[23] = N, e[24] = M) : (N = e[23], M = e[24]), I.useEffect(N, M), g.length === 0) {
    let K;
    return e[25] === Symbol.for("react.memo_cache_sentinel") ? (K = /* @__PURE__ */ C.jsx("div", { className: "twd-flex twd-h-full twd-items-center twd-justify-center twd-text-secondary", children: "No chromatograms yet." }), e[25] = K) : K = e[25], K;
  }
  const P = b.length > 0;
  let z;
  e[26] !== g ? (z = g.some(_Pe), e[26] = g, e[27] = z) : z = e[27];
  const $ = i || z, G = !P && $;
  let H;
  e[28] === Symbol.for("react.memo_cache_sentinel") ? (H = /* @__PURE__ */ C.jsx("div", { ref: s, className: "twd-h-full twd-w-full twd-select-none" }), e[28] = H) : H = e[28];
  let Z;
  e[29] !== P || e[30] !== G ? (Z = !P && /* @__PURE__ */ C.jsx("div", { className: "twd-absolute twd-inset-0 twd-flex twd-items-center twd-justify-center", children: G ? /* @__PURE__ */ C.jsx(aa, { message: "Loading chromatograms" }) : /* @__PURE__ */ C.jsx("div", { className: "twd-text-secondary", children: "Chromatogram data is unavailable." }) }), e[29] = P, e[30] = G, e[31] = Z) : Z = e[31];
  let V;
  e[32] !== Z ? (V = /* @__PURE__ */ C.jsxs("div", { className: "twd-relative twd-h-full twd-w-full", children: [
    H,
    Z
  ] }), e[32] = Z, e[33] = V) : V = e[33];
  let Y;
  e[34] !== $ || e[35] !== P ? (Y = $ && P && /* @__PURE__ */ C.jsx("span", { className: "twd-text-xs twd-text-secondary", children: "Loading chromatogram data…" }), e[34] = $, e[35] = P, e[36] = Y) : Y = e[36];
  let ee;
  return e[37] !== V || e[38] !== Y ? (ee = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-h-[300px] twd-w-full twd-flex-col twd-gap-2", children: [
    V,
    Y
  ] }), e[37] = V, e[38] = Y, e[39] = ee) : ee = e[39], ee;
};
function yPe(t) {
  const e = t.measurement;
  return e ? {
    injectionId: t.id,
    pointId: t.pointId,
    name: t.name,
    mps: e.mps ?? 1,
    data: e.data ?? null
  } : null;
}
function bPe(t) {
  return t.injections.map(yPe);
}
function wPe(t) {
  return t != null;
}
function xPe(t) {
  return t === dPe || t === fPe ? 0 : t;
}
function SPe(t) {
  if (t.data == null)
    return null;
  const e = t.data.map(xPe);
  return e.length === 0 ? null : {
    injectionId: t.injectionId,
    pointId: t.pointId,
    name: t.name,
    mps: t.mps,
    sanitizedData: e
  };
}
function EPe(t) {
  return t != null;
}
function _Pe(t) {
  return t.data == null;
}
const XJ = (t) => {
  const e = ve.c(31), {
    calibrationId: n,
    highlightedPointId: r,
    onPointHighlight: i
  } = t, a = Zke(n), {
    markReady: s
  } = B_(`visualization-${n}`), c = I.useRef(!1), d = a.standards.length > 0, f = a.standards.some(CPe);
  let g;
  e[0] !== a.standards ? (g = a.standards.some(OPe), e[0] = a.standards, e[1] = g) : g = e[1];
  const m = g, b = f || m, w = !a.isLoading && !a.isChromatogramsLoading, _ = w && m, A = w && !m;
  let T;
  e[2] === Symbol.for("react.memo_cache_sentinel") ? (T = () => {
    c.current = !1;
  }, e[2] = T) : T = e[2];
  let O;
  e[3] !== n ? (O = [n], e[3] = n, e[4] = O) : O = e[4], I.useEffect(T, O);
  let R;
  e[5] !== s ? (R = () => {
    c.current || (c.current = !0, s());
  }, e[5] = s, e[6] = R) : R = e[6];
  const N = R;
  let M;
  e[7] !== N || e[8] !== _ ? (M = () => {
    _ && N();
  }, e[7] = N, e[8] = _, e[9] = M) : M = e[9];
  const P = M;
  let z, F;
  if (e[10] !== A || e[11] !== N ? (z = () => {
    A && N();
  }, F = [A, N], e[10] = A, e[11] = N, e[12] = z, e[13] = F) : (z = e[12], F = e[13]), I.useEffect(z, F), n == null) {
    let V;
    return e[14] === Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ C.jsx("div", { className: "twd-text-secondary", children: "Select an attached calibration to see the visualization." }), e[14] = V) : V = e[14], V;
  }
  if (!d) {
    let V;
    return e[15] === Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ C.jsx("div", { className: "twd-text-secondary", children: "No standards available yet." }), e[15] = V) : V = e[15], V;
  }
  if (!b) {
    let V;
    return e[16] === Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ C.jsx("div", { className: "twd-text-secondary", children: "Insufficient data for visualization" }), e[16] = V) : V = e[16], V;
  }
  let $;
  e[17] === Symbol.for("react.memo_cache_sentinel") ? ($ = /* @__PURE__ */ C.jsx(aa, { message: "Loading visualization data" }), e[17] = $) : $ = e[17];
  let G;
  e[18] !== r || e[19] !== i || e[20] !== a.k || e[21] !== a.standards || e[22] !== a.unit ? (G = /* @__PURE__ */ C.jsx("div", { className: "twd-flex-1 twd-min-w-[240px] twd-pb-4", children: /* @__PURE__ */ C.jsx(hPe, { standards: a.standards, k: a.k, unit: a.unit, highlightedPointId: r, onPointHighlight: i }) }), e[18] = r, e[19] = i, e[20] = a.k, e[21] = a.standards, e[22] = a.unit, e[23] = G) : G = e[23];
  let H;
  e[24] !== P || e[25] !== r || e[26] !== a.standards ? (H = /* @__PURE__ */ C.jsx("div", { className: "twd-flex-1 twd-min-w-[240px] twd-pb-4", children: /* @__PURE__ */ C.jsx(vPe, { standards: a.standards, highlightedPointId: r, isLoading: !1, onRendered: P }) }), e[24] = P, e[25] = r, e[26] = a.standards, e[27] = H) : H = e[27];
  let Z;
  return e[28] !== G || e[29] !== H ? (Z = /* @__PURE__ */ C.jsx(I.Suspense, { fallback: $, children: /* @__PURE__ */ C.jsx("div", { className: "twd-space-y-4", children: /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-flex-wrap twd-gap-2 md:twd-gap-4", children: [
    G,
    H
  ] }) }) }), e[28] = G, e[29] = H, e[30] = Z) : Z = e[30], Z;
};
function APe(t) {
  return t.amount != null && t.area != null;
}
function CPe(t) {
  return t.injections.some(APe);
}
function TPe(t) {
  return t.measurement != null && t.measurement.data != null && t.measurement.data.length > 0;
}
function OPe(t) {
  return t.injections.some(TPe);
}
const RPe = (t) => {
  const e = ve.c(8), n = uk(t), r = n.data?.createdAt ?? null;
  let i;
  e: {
    if (r == null) {
      i = null;
      break e;
    }
    let g;
    e[0] !== r ? (g = new Date(r).getTime(), e[0] = r, e[1] = g) : g = e[1], i = g;
  }
  const a = i;
  let s;
  e: {
    if (a == null) {
      s = null;
      break e;
    }
    let g;
    e[2] !== a ? (g = hO(a), e[2] = a, e[3] = g) : g = e[3], s = g;
  }
  const c = s, d = t != null && n.isLoading;
  let f;
  return e[4] !== c || e[5] !== d || e[6] !== a ? (f = {
    lastUpdated: a,
    formattedLastUpdated: c,
    isLoading: d
  }, e[4] = c, e[5] = d, e[6] = a, e[7] = f) : f = e[7], f;
}, WJ = (t) => {
  const e = ve.c(3), {
    calibrationId: n
  } = t, {
    formattedLastUpdated: r,
    isLoading: i
  } = RPe(n);
  if (i) {
    let s;
    return e[0] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ C.jsx(aa, { message: "Loading last updated" }), e[0] = s) : s = e[0], s;
  }
  if (r == null)
    return null;
  let a;
  return e[1] !== r ? (a = /* @__PURE__ */ C.jsxs("span", { className: "twd-text-sm twd-font-normal twd-text-secondary", children: [
    "Updated ",
    r
  ] }), e[1] = r, e[2] = a) : a = e[2], a;
}, DPe = Re.div``, Ah = (t) => {
  const e = ve.c(8), {
    title: n,
    children: r,
    action: i
  } = t;
  let a;
  e[0] !== n ? (a = /* @__PURE__ */ C.jsx("h5", { className: "twd-text-base twd-font-semibold twd-text-secondary-contrast", children: n }), e[0] = n, e[1] = a) : a = e[1];
  let s;
  e[2] !== i || e[3] !== a ? (s = /* @__PURE__ */ C.jsxs("div", { className: "twd-mb-2 twd-flex twd-items-center twd-gap-2", children: [
    a,
    i
  ] }), e[2] = i, e[3] = a, e[4] = s) : s = e[4];
  let c;
  return e[5] !== r || e[6] !== s ? (c = /* @__PURE__ */ C.jsxs(DPe, { children: [
    s,
    r
  ] }), e[5] = r, e[6] = s, e[7] = c) : c = e[7], c;
}, NPe = (t) => {
  const e = ve.c(29), {
    sequenceId: n,
    calibrationId: r,
    onShowMeasurement: i,
    onShowStandard: a,
    onChangeCalibration: s
  } = t, [c, d] = I.useState(null), f = r, g = c?.calibrationId === r ? c?.isArchived ?? !1 : !1, [m, b] = I.useState(null), w = f != null && !g;
  let _;
  e[0] !== r || e[1] !== s ? (_ = (G) => {
    d(G);
    const H = G?.calibrationId ?? null;
    if (H == null) {
      s?.(null);
      return;
    }
    H !== r && s?.(H);
  }, e[0] = r, e[1] = s, e[2] = _) : _ = e[2];
  const A = _;
  let T;
  e[3] === Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ C.jsx("h2", { className: "twd-text-lg twd-font-semibold twd-text-secondary-contrast", children: "Calibrations" }), e[3] = T) : T = e[3];
  let O;
  e[4] !== f ? (O = f != null && /* @__PURE__ */ C.jsx(I.Suspense, { children: /* @__PURE__ */ C.jsx(WJ, { calibrationId: f }) }), e[4] = f, e[5] = O) : O = e[5];
  let R;
  e[6] !== O ? (R = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-w-full twd-min-h-7 twd-items-center twd-justify-between", children: [
    T,
    O
  ] }), e[6] = O, e[7] = R) : R = e[7];
  let N;
  e[8] === Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ C.jsx(aa, { message: "Loading attached calibrations..." }), e[8] = N) : N = e[8];
  let M;
  e[9] !== r || e[10] !== A || e[11] !== n ? (M = /* @__PURE__ */ C.jsx(I.Suspense, { fallback: N, children: /* @__PURE__ */ C.jsx(o7e, { sequenceId: n, selectedCalibrationId: r, onSelectedCalibrationChange: A }) }), e[9] = r, e[10] = A, e[11] = n, e[12] = M) : M = e[12];
  let P;
  e[13] !== g || e[14] !== f ? (P = f != null && g && /* @__PURE__ */ C.jsx("div", { className: "twd-rounded-md twd-bg-secondary-light2 twd-p-4 twd-text-sm twd-text-secondary-contrast", children: "The selected calibration is archived. Restore it to edit detection intervals and see the calibration results." }), e[13] = g, e[14] = f, e[15] = P) : P = e[15];
  let z;
  e[16] !== w || e[17] !== m || e[18] !== i || e[19] !== a || e[20] !== f ? (z = f != null && /* @__PURE__ */ C.jsx(I.Suspense, { fallback: /* @__PURE__ */ C.jsx(aa, { message: "Loading calibration sections..." }), children: /* @__PURE__ */ C.jsxs("div", { className: "twd-space-y-5", children: [
    /* @__PURE__ */ C.jsx(D7e, { calibrationId: f }),
    w && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(Ah, { title: "Compound", children: /* @__PURE__ */ C.jsx(Pke, { calibrationId: f }) }),
      /* @__PURE__ */ C.jsx(Ah, { title: "Detection Interval", children: /* @__PURE__ */ C.jsx(hJ, { calibrationId: f }) }),
      /* @__PURE__ */ C.jsx(Ah, { title: "Latest Curve", children: /* @__PURE__ */ C.jsx(dJ, { calibrationId: f }) }),
      /* @__PURE__ */ C.jsx(Ah, { title: "Visualization", children: /* @__PURE__ */ C.jsx(XJ, { calibrationId: f, highlightedPointId: m, onPointHighlight: b }) }),
      /* @__PURE__ */ C.jsx(Ah, { title: "Levels & Points", children: /* @__PURE__ */ C.jsx(fJ, { calibrationId: f, onShowMeasurement: i, onShowStandard: a, highlightedPointId: m, onPointHighlight: b }) })
    ] })
  ] }) }), e[16] = w, e[17] = m, e[18] = i, e[19] = a, e[20] = f, e[21] = z) : z = e[21];
  let F;
  e[22] !== M || e[23] !== P || e[24] !== z ? (F = /* @__PURE__ */ C.jsxs("div", { className: "twd-space-y-3 twd-pb-6", children: [
    M,
    P,
    z
  ] }), e[22] = M, e[23] = P, e[24] = z, e[25] = F) : F = e[25];
  let $;
  return e[26] !== R || e[27] !== F ? ($ = /* @__PURE__ */ C.jsxs("section", { className: "twd-p-4 twd-space-y-2 twd-min-h-96", children: [
    R,
    F
  ] }), e[26] = R, e[27] = F, e[28] = $) : $ = e[28], $;
}, $Ge = (t) => {
  const e = ve.c(6);
  let n;
  return e[0] !== t.calibrationId || e[1] !== t.onChangeCalibration || e[2] !== t.onShowMeasurement || e[3] !== t.onShowStandard || e[4] !== t.sequenceId ? (n = /* @__PURE__ */ C.jsx(NPe, { sequenceId: t.sequenceId, calibrationId: t.calibrationId, onShowMeasurement: t.onShowMeasurement, onShowStandard: t.onShowStandard, onChangeCalibration: t.onChangeCalibration }), e[0] = t.calibrationId, e[1] = t.onChangeCalibration, e[2] = t.onShowMeasurement, e[3] = t.onShowStandard, e[4] = t.sequenceId, e[5] = n) : n = e[5], n;
}, MPe = Re.section`
  twd-w-full
  twd-space-y-6
  twd-rounded-lg
  twd-bg-white
`, IPe = Re.div`
  twd-flex
  twd-flex-col
  twd-gap-1
  md:twd-flex-row
  md:twd-items-center
  md:twd-justify-between
`, kPe = Re.h3`
  twd-text-lg
  twd-font-semibold
  twd-text-secondary-contrast
`, jPe = Re.p`
  twd-text-sm
  twd-text-secondary
`, mb = vr("CalibrationReportWidget"), PPe = (t) => {
  const e = ve.c(45), {
    calibrationId: n,
    sequenceId: r,
    onReportReady: i
  } = t, [a, s] = I.useState(null), c = I.useRef(!1);
  let d, f;
  e[0] !== n ? (d = () => {
    c.current = !1, mb.debug("Resetting report ready flag due to calibration change", {
      calibrationId: n
    });
  }, f = [n], e[0] = n, e[1] = d, e[2] = f) : (d = e[1], f = e[2]), I.useEffect(d, f);
  let g;
  e[3] !== n || e[4] !== i ? (g = () => {
    if (!c.current && i) {
      c.current = !0, mb.info("All report components are ready, calling onReportReady", {
        calibrationId: n
      });
      try {
        i(), mb.debug("onReportReady callback executed successfully", {
          calibrationId: n
        });
      } catch (ie) {
        const J = ie;
        mb.error("Error in onReportReady callback", {
          error: J,
          calibrationId: n
        });
      }
    } else
      mb.debug("onReportReady skipped", {
        calibrationId: n,
        hasCalled: c.current,
        hasCallback: !!i
      });
  }, e[3] = n, e[4] = i, e[5] = g) : g = e[5], I7e(g);
  const {
    data: b,
    isLoading: w
  } = vO(n), A = (b?.calibrationCompound ?? null)?.compound?.name ?? "Calibration", T = LPe, O = BPe;
  mb.debug("Rendering calibration report", {
    calibrationId: n,
    compoundName: A,
    sequenceId: r
  });
  let R;
  e[6] !== A ? (R = /* @__PURE__ */ C.jsx(kPe, { children: A }), e[6] = A, e[7] = R) : R = e[7];
  let N;
  e[8] !== n ? (N = /* @__PURE__ */ C.jsxs(jPe, { children: [
    "Calibration #",
    n
  ] }), e[8] = n, e[9] = N) : N = e[9];
  let M;
  e[10] !== R || e[11] !== N ? (M = /* @__PURE__ */ C.jsxs("div", { children: [
    R,
    N
  ] }), e[10] = R, e[11] = N, e[12] = M) : M = e[12];
  let P;
  e[13] !== n ? (P = n != null && /* @__PURE__ */ C.jsx(WJ, { calibrationId: n }), e[13] = n, e[14] = P) : P = e[14];
  let z;
  e[15] !== P ? (z = /* @__PURE__ */ C.jsx("div", { children: P }), e[15] = P, e[16] = z) : z = e[16];
  let F;
  e[17] !== M || e[18] !== z ? (F = /* @__PURE__ */ C.jsxs(IPe, { children: [
    M,
    z
  ] }), e[17] = M, e[18] = z, e[19] = F) : F = e[19];
  let $;
  e[20] !== w ? ($ = w && /* @__PURE__ */ C.jsx("div", { className: "twd-rounded-md twd-bg-secondary-light2 twd-p-4", children: /* @__PURE__ */ C.jsx(aa, { message: "Loading calibration overview" }) }), e[20] = w, e[21] = $) : $ = e[21];
  let G;
  e[22] === Symbol.for("react.memo_cache_sentinel") ? (G = /* @__PURE__ */ C.jsx(aa, { message: "Loading detection interval..." }), e[22] = G) : G = e[22];
  let H;
  e[23] !== n ? (H = /* @__PURE__ */ C.jsx(I.Suspense, { fallback: G, children: /* @__PURE__ */ C.jsx(Ah, { title: "Detection Interval", children: /* @__PURE__ */ C.jsx(hJ, { calibrationId: n }) }) }), e[23] = n, e[24] = H) : H = e[24];
  let Z;
  e[25] === Symbol.for("react.memo_cache_sentinel") ? (Z = /* @__PURE__ */ C.jsx(aa, { message: "Loading latest curve..." }), e[25] = Z) : Z = e[25];
  let V;
  e[26] !== n ? (V = /* @__PURE__ */ C.jsx(I.Suspense, { fallback: Z, children: /* @__PURE__ */ C.jsx(Ah, { title: "Latest Curve", children: /* @__PURE__ */ C.jsx(dJ, { calibrationId: n }) }) }), e[26] = n, e[27] = V) : V = e[27];
  let Y;
  e[28] === Symbol.for("react.memo_cache_sentinel") ? (Y = /* @__PURE__ */ C.jsx(aa, { message: "Loading visualization..." }), e[28] = Y) : Y = e[28];
  let ee;
  e[29] !== n || e[30] !== a ? (ee = /* @__PURE__ */ C.jsx(I.Suspense, { fallback: Y, children: /* @__PURE__ */ C.jsx(Ah, { title: "Visualization", children: /* @__PURE__ */ C.jsx(XJ, { calibrationId: n, highlightedPointId: a, onPointHighlight: s }) }) }), e[29] = n, e[30] = a, e[31] = ee) : ee = e[31];
  let K;
  e[32] === Symbol.for("react.memo_cache_sentinel") ? (K = /* @__PURE__ */ C.jsx(aa, { message: "Loading levels and points..." }), e[32] = K) : K = e[32];
  let U;
  e[33] !== n || e[34] !== a ? (U = /* @__PURE__ */ C.jsx(I.Suspense, { fallback: K, children: /* @__PURE__ */ C.jsx(Ah, { title: "Levels & Points", children: /* @__PURE__ */ C.jsx(fJ, { calibrationId: n, onShowMeasurement: T, onShowStandard: O, highlightedPointId: a, onPointHighlight: s }) }) }), e[33] = n, e[34] = a, e[35] = U) : U = e[35];
  let q;
  e[36] !== H || e[37] !== V || e[38] !== ee || e[39] !== U ? (q = /* @__PURE__ */ C.jsxs("div", { className: "twd-space-y-6", children: [
    H,
    V,
    ee,
    U
  ] }), e[36] = H, e[37] = V, e[38] = ee, e[39] = U, e[40] = q) : q = e[40];
  let W;
  return e[41] !== $ || e[42] !== q || e[43] !== F ? (W = /* @__PURE__ */ C.jsxs(MPe, { children: [
    F,
    $,
    q
  ] }), e[41] = $, e[42] = q, e[43] = F, e[44] = W) : W = e[44], W;
};
function LPe() {
}
function BPe() {
}
const HGe = (t) => {
  const e = ve.c(4);
  let n;
  return e[0] !== t.calibrationId || e[1] !== t.onReportReady || e[2] !== t.sequenceId ? (n = /* @__PURE__ */ C.jsx(PPe, { calibrationId: t.calibrationId, sequenceId: t.sequenceId, onReportReady: t.onReportReady }), e[0] = t.calibrationId, e[1] = t.onReportReady, e[2] = t.sequenceId, e[3] = n) : n = e[3], n;
}, QJ = Xe({
  id: Ve(),
  name: Je().nullable()
}).nullable(), zPe = Xe({
  id: Ve(),
  amount: Ve().nullable(),
  unit: Je().nullable(),
  compound: QJ
}), FPe = Xe({
  id: Ve(),
  calcConcentration: Ve().nullable(),
  unit: Je().nullable(),
  compound: QJ
}), VPe = Xe({
  id: Ve(),
  estimations: Xr(zPe).optional().default([]),
  calibrationResults: Xr(FPe).optional().default([])
}), UPe = Xe({
  id: Ve(),
  name: Je().nullable(),
  type: Je().nullable()
}).nullable(), $Pe = Xe({
  id: Ve(),
  name: Je().nullable(),
  sample: UPe
}), HPe = Xe({
  id: Ve(),
  injection: $Pe,
  peaks: Xr(VPe).optional().default([])
});
var SO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "subscription", name: { kind: "Name", value: "SequenceMeasurements" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "sequenceId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "measurements" }, name: { kind: "Name", value: "siebox_measurement" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "where" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "injection" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "sample" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "sequence_id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_eq" }, value: { kind: "Variable", name: { kind: "Name", value: "sequenceId" } } }] } }] } }] } }] } }, { kind: "Argument", name: { kind: "Name", value: "order_by" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "EnumValue", value: "asc" } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "injection" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "sample" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "type" }, arguments: [], directives: [] }] } }] } }, { kind: "Field", name: { kind: "Name", value: "peaks" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order_by" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "apex" }, value: { kind: "EnumValue", value: "asc" } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", alias: { kind: "Name", value: "estimations" }, name: { kind: "Name", value: "compoundestimations" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "amount" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "unit" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "compound" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "calibrationResults" }, name: { kind: "Name", value: "calibration_results" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "calc_concentration" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "unit" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "compound" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }] } }] } }] } }] } }] } }], loc: { start: 0, end: 675 } };
SO.loc.source = { body: `subscription SequenceMeasurements($sequenceId: Int!) {
  measurements: siebox_measurement(
    where: { injection: { sample: { sequence_id: { _eq: $sequenceId } } } }
    order_by: { id: asc }
  ) {
    id
    injection {
      id
      name
      sample {
        id
        name
        type
      }
    }
    peaks(order_by: { apex: asc }) {
      id
      estimations: compoundestimations {
        id
        amount
        unit
        compound {
          id
          name
        }
      }
      calibrationResults: calibration_results {
        id
        calc_concentration
        unit
        compound {
          id
          name
        }
      }
    }
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function q4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    q4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    q4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    q4(r, e);
  });
}
var YN = {};
(function() {
  SO.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      q4(e, n), YN[e.name.value] = n;
    }
  });
})();
function wU(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function qPe(t, e) {
  var n = {
    kind: t.kind,
    definitions: [wU(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = YN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = YN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = wU(t, c);
    d && n.definitions.push(d);
  }), n;
}
qPe(SO, "SequenceMeasurements");
const GPe = Xe({
  measurements: Xr(HPe)
}), YPe = (t) => {
  const e = ve.c(16), {
    sequenceId: n
  } = t;
  let r;
  e[0] !== n ? (r = {
    sequenceId: n
  }, e[0] = n, e[1] = r) : r = e[1];
  const i = r, {
    data: a,
    isLoading: s,
    isFetching: c,
    error: d
  } = Q5("SequenceMeasurements", SO, i);
  let f;
  e: {
    if (a == null) {
      let T;
      e[2] === Symbol.for("react.memo_cache_sentinel") ? (T = {
        measurements: [],
        parseError: null
      }, e[2] = T) : T = e[2], f = T;
      break e;
    }
    try {
      let T;
      e[3] !== a ? (T = qt(GPe, a), e[3] = a, e[4] = T) : T = e[4];
      const O = T;
      let R;
      e[5] !== O.measurements ? (R = {
        measurements: O.measurements,
        parseError: null
      }, e[5] = O.measurements, e[6] = R) : R = e[6], f = R;
    } catch (T) {
      console.error("Failed to parse sequence measurements", T);
      let R;
      e[7] === Symbol.for("react.memo_cache_sentinel") ? (R = {
        measurements: [],
        parseError: "Unable to parse sequence measurements."
      }, e[7] = R) : R = e[7], f = R;
    }
  }
  const {
    measurements: g,
    parseError: m
  } = f;
  let b;
  e[8] !== g ? (b = XPe(g), e[8] = g, e[9] = b) : b = e[9];
  const w = b, _ = d ?? m;
  let A;
  return e[10] !== c || e[11] !== s || e[12] !== g || e[13] !== _ || e[14] !== w ? (A = {
    measurements: g,
    tableData: w,
    isLoading: s,
    isFetching: c,
    error: _
  }, e[10] = c, e[11] = s, e[12] = g, e[13] = _, e[14] = w, e[15] = A) : A = e[15], A;
}, XPe = (t) => {
  if (t.length === 0)
    return {
      samples: [],
      compounds: []
    };
  const e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Map();
  for (const i of t) {
    const a = i.injection.sample;
    if (!a || a.type !== "sample")
      continue;
    let s = n.get(a.id);
    s || (s = {
      id: a.id,
      name: a.name,
      injections: /* @__PURE__ */ new Map()
    }, n.set(a.id, s));
    let c = s.injections.get(i.injection.id);
    c || (c = {
      id: i.injection.id,
      name: i.injection.name,
      compounds: {}
    }, s.injections.set(i.injection.id, c)), i.peaks.forEach((d) => {
      WPe(d).forEach((f) => {
        if (!f.compoundName)
          return;
        e.add(f.compoundName);
        const g = QPe(f.amount, f.unit), m = c.compounds[f.compoundName] ?? [];
        m.push(g), c.compounds[f.compoundName] = m;
      });
    });
  }
  return {
    samples: Array.from(n.values()).map((i) => ({
      id: i.id,
      name: i.name,
      injections: Array.from(i.injections.values())
    })),
    compounds: Array.from(e)
  };
}, WPe = (t) => t.calibrationResults.length > 0 ? t.calibrationResults.map((e) => ({
  compoundName: e.compound?.name ?? null,
  amount: e.calcConcentration,
  unit: e.unit
})) : t.estimations.map((e) => ({
  compoundName: e.compound?.name ?? null,
  amount: e.amount,
  unit: e.unit
})), QPe = (t, e) => {
  if (t == null)
    return "-";
  const n = Ms(t, 3);
  return e ? `${n} ${e}` : n;
}, ZPe = (t) => {
  const e = ve.c(20), {
    sequenceId: n,
    onShowInjection: r
  } = t;
  let i;
  e[0] !== n ? (i = {
    sequenceId: n
  }, e[0] = n, e[1] = i) : i = e[1];
  const {
    tableData: a,
    isLoading: s,
    error: c
  } = YPe(i), d = typeof r == "function";
  let f;
  e[2] !== d || e[3] !== r ? (f = (w, _) => {
    d && r?.({
      sampleId: w,
      injectionId: _
    });
  }, e[2] = d, e[3] = r, e[4] = f) : f = e[4];
  const g = f;
  if (s) {
    let w;
    return e[5] === Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ C.jsx(aa, { message: "Loading results" }), e[5] = w) : w = e[5], w;
  }
  if (c) {
    let w;
    return e[6] !== c ? (w = /* @__PURE__ */ C.jsx("div", { className: "twd-text-red-500", children: c }), e[6] = c, e[7] = w) : w = e[7], w;
  }
  if (!a.samples.length || !a.compounds.length) {
    let w;
    return e[8] === Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ C.jsx("div", { className: "twd-text-secondary", children: "No results yet." }), e[8] = w) : w = e[8], w;
  }
  let m;
  if (e[9] !== d || e[10] !== g || e[11] !== a.compounds || e[12] !== a.samples) {
    let w;
    e[14] !== d || e[15] !== g || e[16] !== a.compounds ? (w = (_) => /* @__PURE__ */ C.jsxs("div", { className: "twd-space-y-2", children: [
      /* @__PURE__ */ C.jsxs("div", { className: "twd-text-sm twd-font-bold twd-text-secondary-contrast", children: [
        "Sample: ",
        _.name ?? `#${_.id}`
      ] }),
      /* @__PURE__ */ C.jsx("div", { className: "twd-rounded-md twd-border twd-border-border twd-bg-white twd-overflow-x-auto", children: /* @__PURE__ */ C.jsxs(Pg, { children: [
        /* @__PURE__ */ C.jsx(Lg, { children: /* @__PURE__ */ C.jsxs("tr", { children: [
          /* @__PURE__ */ C.jsx(wi, { children: "Injection" }),
          a.compounds.map(KPe),
          d && /* @__PURE__ */ C.jsx(wi, {})
        ] }) }),
        /* @__PURE__ */ C.jsx(Bg, { children: _.injections.map((A) => /* @__PURE__ */ C.jsxs(rf, { children: [
          /* @__PURE__ */ C.jsx(Ir, { children: A.name ?? `#${A.id}` }),
          a.compounds.map((T) => {
            const O = A.compounds[T];
            return !O || O.length === 0 ? /* @__PURE__ */ C.jsx(Ir, { children: "-" }, `${A.id}-${T}`) : /* @__PURE__ */ C.jsx(Ir, { className: "twd-whitespace-nowrap", children: O.map(JPe) }, `${A.id}-${T}`);
          }),
          d && /* @__PURE__ */ C.jsx(Ir, { className: "twd-text-right", children: /* @__PURE__ */ C.jsx(cl, { icon: /* @__PURE__ */ C.jsx(T_, { className: "twd-h-4 twd-w-4" }), onClick: () => g(_.id, A.id) }) })
        ] }, A.id)) })
      ] }) })
    ] }, _.id), e[14] = d, e[15] = g, e[16] = a.compounds, e[17] = w) : w = e[17], m = a.samples.map(w), e[9] = d, e[10] = g, e[11] = a.compounds, e[12] = a.samples, e[13] = m;
  } else
    m = e[13];
  let b;
  return e[18] !== m ? (b = /* @__PURE__ */ C.jsx("div", { className: "twd-space-y-6", children: m }), e[18] = m, e[19] = b) : b = e[19], b;
};
function KPe(t) {
  return /* @__PURE__ */ C.jsx(wi, { children: t }, t);
}
function JPe(t, e) {
  return /* @__PURE__ */ C.jsxs("span", { children: [
    e > 0 && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      ";",
      /* @__PURE__ */ C.jsx("br", {})
    ] }),
    e > 0 && " ",
    t
  ] }, `${t}-${e}`);
}
const eLe = Re.div``, tLe = (t) => {
  const e = ve.c(5), {
    onShowReportGenerator: n
  } = t;
  let r;
  e[0] !== n ? (r = () => {
    n();
  }, e[0] = n, e[1] = r) : r = e[1];
  const i = r;
  let a;
  e[2] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ C.jsx(LY, { size: "md" }), e[2] = a) : a = e[2];
  let s;
  return e[3] !== i ? (s = /* @__PURE__ */ C.jsx(eLe, { children: /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", icon: a, onClick: i, children: "Get detailed report" }) }), e[3] = i, e[4] = s) : s = e[4], s;
}, nLe = Re.div`
  twd-flex
  twd-justify-start
`, rLe = (t) => {
  const e = ve.c(9), {
    sequenceId: n,
    onShowInjection: r,
    onShowReportGenerator: i
  } = t;
  let a;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ C.jsx("h2", { className: "twd-text-lg twd-font-semibold twd-text-secondary-contrast", children: "Results" }), e[0] = a) : a = e[0];
  let s;
  e[1] !== i ? (s = /* @__PURE__ */ C.jsx(nLe, { children: /* @__PURE__ */ C.jsx(tLe, { onShowReportGenerator: i }) }), e[1] = i, e[2] = s) : s = e[2];
  let c;
  e[3] !== r || e[4] !== n ? (c = /* @__PURE__ */ C.jsx(ZPe, { sequenceId: n, onShowInjection: r }), e[3] = r, e[4] = n, e[5] = c) : c = e[5];
  let d;
  return e[6] !== s || e[7] !== c ? (d = /* @__PURE__ */ C.jsxs("section", { className: "twd-p-4 twd-space-y-6", children: [
    a,
    s,
    c
  ] }), e[6] = s, e[7] = c, e[8] = d) : d = e[8], d;
}, qGe = (t) => {
  const e = ve.c(4), {
    sequenceId: n,
    onShowInjection: r,
    onShowReportGenerator: i
  } = t;
  let a;
  return e[0] !== r || e[1] !== i || e[2] !== n ? (a = /* @__PURE__ */ C.jsx(rLe, { sequenceId: n, onShowInjection: r, onShowReportGenerator: i }), e[0] = r, e[1] = i, e[2] = n, e[3] = a) : a = e[3], a;
};
var EO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "subscription", name: { kind: "Name", value: "ReportBySequenceId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "sequenceId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "report" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "where" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "sequence_id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_eq" }, value: { kind: "Variable", name: { kind: "Name", value: "sequenceId" } } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "template" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_eq" }, value: { kind: "StringValue", value: "sequence", block: !1 } }] } }] } }, { kind: "Argument", name: { kind: "Name", value: "order_by" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "created_at" }, value: { kind: "EnumValue", value: "desc" } }] } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "IntValue", value: "1" } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "status" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "url" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 244 } };
EO.loc.source = { body: `subscription ReportBySequenceId($sequenceId: Int!) {
  report(
    where: {
      sequence_id: { _eq: $sequenceId }
      template: { _eq: "sequence" }
    }
    order_by: { created_at: desc }
    limit: 1
  ) {
    id
    status
    url
  }
}
`, name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function G4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    G4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    G4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    G4(r, e);
  });
}
var XN = {};
(function() {
  EO.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      G4(e, n), XN[e.name.value] = n;
    }
  });
})();
function xU(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function iLe(t, e) {
  var n = {
    kind: t.kind,
    definitions: [xU(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = XN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = XN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = xU(t, c);
    d && n.definitions.push(d);
  }), n;
}
iLe(EO, "ReportBySequenceId");
const aLe = Xe({
  id: Ve(),
  status: y_(["queued", "running", "succeeded", "failed"]),
  url: X$(Je())
}), oLe = Xe({
  report: Xr(aLe)
}), sLe = ({
  sequenceId: t
}) => {
  const e = I.useMemo(() => ({
    sequenceId: t
  }), [t]), {
    data: n,
    isLoading: r,
    isFetching: i,
    error: a
  } = Q5("ReportBySequenceId", EO, e), {
    report: s,
    parseError: c
  } = I.useMemo(() => {
    if (n == null)
      return {
        report: null,
        parseError: null
      };
    try {
      return {
        report: qt(oLe, n).report[0] ?? null,
        parseError: null
      };
    } catch (d) {
      return console.error("Failed to parse sequence report", d), {
        report: null,
        parseError: "Unable to parse sequence report."
      };
    }
  }, [n]);
  return {
    report: s,
    isLoading: r,
    isFetching: i,
    error: a ?? c
  };
};
var _O = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "CreateReport" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "template" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "params" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "jsonb" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "token" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "sequenceId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "injectionId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "delete_report" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "where" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_and" }, value: { kind: "ListValue", values: [{ kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "injection_id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_eq" }, value: { kind: "Variable", name: { kind: "Name", value: "injectionId" } } }] } }] }, { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "sequence_id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_eq" }, value: { kind: "Variable", name: { kind: "Name", value: "sequenceId" } } }] } }] }, { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "template" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "_eq" }, value: { kind: "Variable", name: { kind: "Name", value: "template" } } }] } }] }] } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "returning" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "report" }, name: { kind: "Name", value: "insert_report_one" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "injection_id" }, value: { kind: "Variable", name: { kind: "Name", value: "injectionId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "sequence_id" }, value: { kind: "Variable", name: { kind: "Name", value: "sequenceId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "token" }, value: { kind: "Variable", name: { kind: "Name", value: "token" } } }, { kind: "ObjectField", name: { kind: "Name", value: "template" }, value: { kind: "Variable", name: { kind: "Name", value: "template" } } }, { kind: "ObjectField", name: { kind: "Name", value: "params" }, value: { kind: "Variable", name: { kind: "Name", value: "params" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "sequence_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "injection_id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "template" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "status" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 615 } };
_O.loc.source = { body: "mutation CreateReport(\r  $template: String!\r  $params: jsonb!\r  $token: String!\r  $sequenceId: Int\r  $injectionId: Int\r) {\r  delete_report(\r    where: {\r      _and: [\r        { injection_id: { _eq: $injectionId } }\r        { sequence_id: { _eq: $sequenceId } }\r        { template: { _eq: $template } }\r      ]\r    }\r  ) {\r    returning {\r      id\r    }\r  }\r\r  report: insert_report_one(\r    object: {\r      injection_id: $injectionId\r      sequence_id: $sequenceId\r      token: $token\r      template: $template\r      params: $params\r    }\r  ) {\r    id\r    sequence_id\r    injection_id\r    template\r    status\r  }\r}\r", name: "GraphQL request", locationOffset: { line: 1, column: 1 } };
function Y4(t, e) {
  if (t.kind === "FragmentSpread")
    e.add(t.name.value);
  else if (t.kind === "VariableDefinition") {
    var n = t.type;
    n.kind === "NamedType" && e.add(n.name.value);
  }
  t.selectionSet && t.selectionSet.selections.forEach(function(r) {
    Y4(r, e);
  }), t.variableDefinitions && t.variableDefinitions.forEach(function(r) {
    Y4(r, e);
  }), t.definitions && t.definitions.forEach(function(r) {
    Y4(r, e);
  });
}
var WN = {};
(function() {
  _O.definitions.forEach(function(e) {
    if (e.name) {
      var n = /* @__PURE__ */ new Set();
      Y4(e, n), WN[e.name.value] = n;
    }
  });
})();
function SU(t, e) {
  for (var n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    if (r.name && r.name.value == e)
      return r;
  }
}
function lLe(t, e) {
  var n = {
    kind: t.kind,
    definitions: [SU(t, e)]
  };
  t.hasOwnProperty("loc") && (n.loc = t.loc);
  var r = WN[e] || /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (r.forEach(function(c) {
    a.add(c);
  }); a.size > 0; ) {
    var s = a;
    a = /* @__PURE__ */ new Set(), s.forEach(function(c) {
      if (!i.has(c)) {
        i.add(c);
        var d = WN[c] || /* @__PURE__ */ new Set();
        d.forEach(function(f) {
          a.add(f);
        });
      }
    });
  }
  return i.forEach(function(c) {
    var d = SU(t, c);
    d && n.definitions.push(d);
  }), n;
}
lLe(_O, "CreateReport");
const cLe = "sequence", uLe = {
  async createReport({
    sequenceId: t,
    injectionId: e,
    params: n
  }) {
    await co.refreshAccessToken();
    const r = await co.getOrRefreshAccessToken(), i = await lo.httpClientForHasura.fetch(_O, {
      template: cLe,
      params: n,
      token: r,
      sequenceId: t,
      injectionId: e
    });
    if (!i.report)
      throw new Error("Report creation failed!");
    return i.report;
  }
}, dLe = "sequence/create-report", fLe = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationKey: [dLe],
    mutationFn: hLe
  }, t[0] = e) : e = t[0], Ei(e);
};
async function hLe(t) {
  const {
    sequenceId: e,
    reportType: n,
    timeZone: r,
    locale: i
  } = t;
  return uLe.createReport({
    sequenceId: e,
    params: {
      reportType: n,
      timeZone: r,
      locale: i
    }
  });
}
const pLe = (t) => 1 - Math.pow(1 - t, 3), ZJ = I.forwardRef(({
  isAutostart: t = !0,
  maxFake: e = 90,
  durationToMaxFake: n = 1e5,
  completeDuration: r = 500,
  easing: i = pLe,
  className: a
}, s) => {
  const [c, d] = I.useState(0), f = I.useRef(null), g = I.useRef(0), m = I.useRef(0), b = I.useRef(0), w = I.useRef(0), _ = I.useRef("idle"), A = I.useCallback(() => {
    f.current != null && (cancelAnimationFrame(f.current), f.current = null);
  }, []);
  I.useEffect(() => {
    b.current = c;
  }, [c]);
  const T = I.useCallback(() => {
    if (_.current !== "running")
      return;
    const M = performance.now(), P = Math.max(0, M - g.current), z = n === 0 ? 1 : Math.min(1, P / n), F = e * i(z);
    Math.abs(b.current - F) > 0.01 && d(F), z < 1 && F < e ? f.current = requestAnimationFrame(T) : (d(e), _.current = "holding");
  }, [n, i, e]), O = I.useCallback(() => {
    const M = performance.now(), P = r === 0 ? 1 : Math.min(1, (M - m.current) / r), z = i(P), F = w.current + (100 - w.current) * z;
    d(F), P < 1 ? f.current = requestAnimationFrame(O) : (d(100), _.current = "done", f.current = null);
  }, [r, i]), R = I.useCallback(() => {
    A(), g.current = performance.now(), _.current = "running", d(0), f.current = requestAnimationFrame(T);
  }, [A, T]), N = I.useCallback(() => {
    _.current === "done" || _.current === "completing" || (A(), _.current = "completing", m.current = performance.now(), w.current = b.current, f.current = requestAnimationFrame(O));
  }, [O, A]);
  return I.useImperativeHandle(s, () => ({
    start: R,
    complete: N
  }), [R, N]), I.useEffect(() => (t && R(), () => {
    A();
  }), [t, R, A]), /* @__PURE__ */ C.jsx("div", { role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": Math.round(c), className: Xc("twd-select-none twd-w-48", a), children: /* @__PURE__ */ C.jsx("div", { className: "twd-h-2 twd-w-full twd-overflow-hidden twd-rounded twd-border twd-border-secondary-light twd-bg-white", children: /* @__PURE__ */ C.jsx("div", { className: "twd-h-full twd-w-full twd-origin-left twd-bg-primary twd-transition-transform twd-duration-75 twd-ease-linear", style: {
    transform: `scaleX(${Math.min(1, c / 100)})`
  } }) }) });
});
ZJ.displayName = "FakeLoader";
const mLe = (t, e) => {
  if (t) {
    const r = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(t);
    if (r)
      return decodeURIComponent(r[1] ?? r[2] ?? "report.pdf");
  }
  const n = e.split("/").pop();
  return n && n.length > 0 ? n : "report.pdf";
}, gLe = ({
  report: t
}) => {
  const [e, n] = I.useState(!1), r = t?.status ?? null, i = t?.url ?? null, a = t != null, s = r === "queued" || r === "running", c = r === "failed", d = r === "succeeded", f = I.useCallback(() => {
    i && window.open(i, "_blank", "noopener,noreferrer");
  }, [i]), g = I.useCallback(async () => {
    if (i)
      try {
        n(!0);
        const m = await fetch(i), b = await m.blob(), w = mLe(m.headers.get("content-disposition"), i);
        eQ(b, w);
      } catch (m) {
        console.warn("Failed to download sequence report", m), window.open(i, "_blank", "noopener,noreferrer");
      } finally {
        n(!1);
      }
  }, [i]);
  return a ? /* @__PURE__ */ C.jsx("div", { className: un("twd-rounded-lg twd-border twd-bg-secondary-light4 twd-p-4 twd-text-sm twd-text-secondary-contrast", "twd-space-y-3", {
    "twd-border-success twd-bg-success/10": d,
    "twd-border-error twd-bg-error-light2": c
  }), children: /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-flex-col twd-gap-4 md:twd-flex-row md:twd-items-center md:twd-justify-between", children: [
    /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-min-w-0 twd-items-center twd-gap-3", children: [
      s && /* @__PURE__ */ C.jsx(O_, { size: "sm" }),
      /* @__PURE__ */ C.jsxs("span", { className: un("twd-truncate", {
        "twd-text-success": d,
        "twd-text-error": c
      }), children: [
        s && "Report is being generated…",
        c && "Report generation failed. Please try again",
        d && /* @__PURE__ */ C.jsx("strong", { children: "Report is generated" }),
        !s && !c && !d && r && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
          "Ordered report status: ",
          /* @__PURE__ */ C.jsx("strong", { children: r })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-flex-col twd-gap-3 md:twd-items-end", children: [
      s && /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-flex-col twd-gap-2 md:twd-items-end", children: [
        /* @__PURE__ */ C.jsx("span", { className: "twd-text-xs", children: "This may take a few minutes" }),
        /* @__PURE__ */ C.jsx(ZJ, { className: "twd-w-48" })
      ] }),
      !s && i && /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-flex-wrap twd-justify-end twd-gap-2", children: [
        /* @__PURE__ */ C.jsx(Vt, { variant: "primary", padding: "lg", onClick: f, children: "Open" }),
        /* @__PURE__ */ C.jsx(Vt, { variant: "primary", padding: "lg", onClick: g, isLoading: e, isDisabled: e, children: "Download" })
      ] })
    ] })
  ] }) }) : null;
}, f5 = [{
  id: "resultsOnly",
  title: "Default"
}, {
  id: "full",
  title: "All data combined (raw + processed + results)"
}, {
  id: "processedData",
  title: "Processed data with results"
}, {
  id: "rawData",
  title: "Raw data from device"
}], KJ = f5.find((t) => t.id === "resultsOnly"), vLe = f5.find((t) => t.id === "full"), EU = (t) => t ? KJ : vLe, yLe = {
  rawData: "The report will only contain the raw data from the device. If you want to see the processed version, select another report type.",
  resultsOnly: "The report will only contain the results of the experiment. If you wish to include chromatograms, please select a different report type."
}, bLe = (t) => {
  const e = ve.c(45), {
    sequenceId: n,
    isCalibrationMode: r
  } = t;
  let i;
  e[0] !== r ? (i = () => EU(r), e[0] = r, e[1] = i) : i = e[1];
  const [a, s] = I.useState(i), [c, d] = I.useState(!1), {
    showErrorNotification: f
  } = nd();
  let g, m;
  e[2] !== r ? (g = () => {
    s(EU(r));
  }, m = [r], e[2] = r, e[3] = g, e[4] = m) : (g = e[3], m = e[4]), I.useEffect(g, m);
  let b;
  e: {
    if (r) {
      b = f5;
      break e;
    }
    let J;
    e[5] === Symbol.for("react.memo_cache_sentinel") ? (J = f5.filter(wLe), e[5] = J) : J = e[5], b = J;
  }
  const w = b;
  let _;
  e[6] !== n ? (_ = {
    sequenceId: n
  }, e[6] = n, e[7] = _) : _ = e[7];
  const {
    report: A
  } = sLe(_), T = fLe();
  let O;
  e[8] !== T || e[9] !== a.id || e[10] !== n || e[11] !== f ? (O = async () => {
    const J = Intl.DateTimeFormat().resolvedOptions().timeZone, B = typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
      await T.mutateAsync({
        sequenceId: n,
        reportType: a.id,
        timeZone: J,
        locale: B
      });
    } catch (te) {
      const ae = te;
      throw console.warn("Unable to create a sequence report", ae), f("Unable to create a report!"), ae;
    }
  }, e[8] = T, e[9] = a.id, e[10] = n, e[11] = f, e[12] = O) : O = e[12];
  const R = O;
  let N;
  e[13] !== A || e[14] !== R ? (N = () => {
    if (A) {
      d(!0);
      return;
    }
    R().catch(xLe);
  }, e[13] = A, e[14] = R, e[15] = N) : N = e[15];
  const M = N;
  let P;
  e[16] !== R ? (P = () => {
    d(!1), R().catch(SLe);
  }, e[16] = R, e[17] = P) : P = e[17];
  const z = P;
  let F;
  e[18] !== w ? (F = (J) => {
    const B = w.find((te) => te.id === J);
    B && s(B);
  }, e[18] = w, e[19] = F) : F = e[19];
  const $ = F, G = yLe[a.id];
  let H;
  e[20] !== A ? (H = /* @__PURE__ */ C.jsx(gLe, { report: A }), e[20] = A, e[21] = H) : H = e[21];
  let Z;
  e[22] === Symbol.for("react.memo_cache_sentinel") ? (Z = /* @__PURE__ */ C.jsxs("div", { children: [
    /* @__PURE__ */ C.jsx("p", { className: "twd-text-xs twd-uppercase twd-text-secondary", children: "Format" }),
    /* @__PURE__ */ C.jsx("p", { className: "twd-text-lg twd-font-semibold twd-text-secondary-contrast", children: "PDF" })
  ] }), e[22] = Z) : Z = e[22];
  let V;
  e[23] !== T.isPending || e[24] !== M ? (V = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-flex-col twd-gap-4 md:twd-flex-row md:twd-items-center md:twd-justify-between", children: [
    Z,
    /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", padding: "xl", onClick: M, isLoading: T.isPending, children: "Generate Report" })
  ] }), e[23] = T.isPending, e[24] = M, e[25] = V) : V = e[25];
  const Y = a.id;
  let ee;
  e[26] !== w ? (ee = w.map(ELe), e[26] = w, e[27] = ee) : ee = e[27];
  let K;
  e[28] !== $ || e[29] !== a.id || e[30] !== ee ? (K = /* @__PURE__ */ C.jsx(TW, { value: Y, label: "Report type", onChange: $, className: "twd-w-full", isFullWidth: !0, children: ee }), e[28] = $, e[29] = a.id, e[30] = ee, e[31] = K) : K = e[31];
  let U;
  e[32] !== G ? (U = G && /* @__PURE__ */ C.jsx("div", { className: "twd-rounded-md twd-bg-info/10 twd-p-3 twd-text-sm twd-text-secondary-contrast", children: G }), e[32] = G, e[33] = U) : U = e[33];
  let q;
  e[34] !== V || e[35] !== K || e[36] !== U ? (q = /* @__PURE__ */ C.jsxs("div", { className: "twd-rounded-lg twd-border twd-border-secondary-light twd-bg-white twd-p-4 twd-space-y-4", children: [
    V,
    K,
    U
  ] }), e[34] = V, e[35] = K, e[36] = U, e[37] = q) : q = e[37];
  let W;
  e[38] !== z || e[39] !== c ? (W = /* @__PURE__ */ C.jsx(qu, { open: c, onOpenChange: d, title: "Generate new report?", description: "A report already exists for this sequence. Generating will create a new report and the previous report will be lost.", onConfirm: z, confirmLabel: "Generate new", cancelLabel: "Cancel" }), e[38] = z, e[39] = c, e[40] = W) : W = e[40];
  let ie;
  return e[41] !== H || e[42] !== q || e[43] !== W ? (ie = /* @__PURE__ */ C.jsxs("div", { className: "twd-space-y-4", children: [
    H,
    q,
    W
  ] }), e[41] = H, e[42] = q, e[43] = W, e[44] = ie) : ie = e[44], ie;
};
function wLe(t) {
  return t.id !== KJ.id;
}
function xLe() {
}
function SLe() {
}
function ELe(t) {
  return /* @__PURE__ */ C.jsx("option", { value: t.id, children: t.title }, t.id);
}
const _Le = (t) => {
  const e = ve.c(4), {
    sequenceId: n,
    isCalibrationMode: r
  } = t;
  let i;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ C.jsx("h2", { className: "twd-text-lg twd-font-semibold twd-text-secondary-contrast", children: "Reports" }), e[0] = i) : i = e[0];
  let a;
  return e[1] !== r || e[2] !== n ? (a = /* @__PURE__ */ C.jsxs("section", { className: "twd-space-y-6 twd-p-4", children: [
    i,
    /* @__PURE__ */ C.jsx(bLe, { sequenceId: n, isCalibrationMode: r })
  ] }), e[1] = r, e[2] = n, e[3] = a) : a = e[3], a;
}, GGe = (t) => {
  const e = ve.c(3), {
    sequenceId: n,
    isCalibrationMode: r
  } = t;
  let i;
  return e[0] !== r || e[1] !== n ? (i = /* @__PURE__ */ C.jsx(_Le, { sequenceId: n, isCalibrationMode: r }), e[0] = r, e[1] = n, e[2] = i) : i = e[2], i;
}, ALe = Xe({
  statusCode: Ve()
}), CLe = vr("apiRemoveDevice"), TLe = async (t) => {
  CLe.info("Removing device", {
    deviceId: t
  });
  const e = await Ya.ky.delete(`my/hardware/${t}/`);
  return qt(ALe, {
    statusCode: e.status
  });
}, OLe = vr("useRemoveDevice"), RLe = "RemoveDevice", DLe = () => {
  const t = ve.c(4), e = Ju(), {
    showSuccessNotification: n
  } = nd();
  let r;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (r = [RLe], t[0] = r) : r = t[0];
  let i;
  return t[1] !== e || t[2] !== n ? (i = {
    mutationKey: r,
    mutationFn: NLe,
    onSuccess: async () => {
      n("Device removed"), await e.invalidateQueries({
        queryKey: J7
      });
    }
  }, t[1] = e, t[2] = n, t[3] = i) : i = t[3], Ei(i);
};
async function NLe(t) {
  return OLe.info("Requesting device removal", {
    deviceId: t
  }), TLe(t);
}
const MLe = vr("RemoveDeviceButton"), ILe = (t) => {
  const e = ve.c(15), {
    deviceId: n
  } = t, {
    mutateAsync: r,
    isPending: i
  } = DLe(), a = es(), [s, c] = I.useState(!1);
  let d;
  e[0] !== n || e[1] !== a || e[2] !== r ? (d = async () => {
    try {
      MLe.info("Removing device from button", {
        deviceId: n
      }), await r(n);
    } catch (A) {
      a(A);
    }
  }, e[0] = n, e[1] = a, e[2] = r, e[3] = d) : d = e[3];
  const f = d;
  let g, m;
  e[4] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ C.jsx(Yb, {}), m = (A) => {
    A.preventDefault(), A.stopPropagation(), c(!0);
  }, e[4] = g, e[5] = m) : (g = e[4], m = e[5]);
  let b;
  e[6] !== i ? (b = /* @__PURE__ */ C.jsx(Vt, { variant: "error", isDisabled: i, icon: g, onClick: m, "data-test-id": "btn-remove-device", children: "Delete" }), e[6] = i, e[7] = b) : b = e[7];
  let w;
  e[8] !== f || e[9] !== s || e[10] !== i ? (w = /* @__PURE__ */ C.jsx(qu, { open: s, onOpenChange: c, title: "Remove device?", description: "This action will disconnect the device from your organization.", confirmLabel: "Remove", cancelLabel: "Cancel", onConfirm: f, loading: i }), e[8] = f, e[9] = s, e[10] = i, e[11] = w) : w = e[11];
  let _;
  return e[12] !== b || e[13] !== w ? (_ = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    b,
    w
  ] }), e[12] = b, e[13] = w, e[14] = _) : _ = e[14], _;
}, kLe = Xr(Je()), SE = vr("useDevicesList"), jLe = () => {
  const t = _h.get(Vd.DEVICES_ORDER);
  if (t == null)
    return [];
  const e = kLe.safeParse(t);
  return e.success ? e.data : (SE.warn("Invalid devices order in storage", e.error), []);
}, PLe = (t, e) => {
  const n = t.some((i) => !e.includes(i.id));
  return {
    sortedDevices: [...t].sort((i, a) => {
      const s = e.indexOf(i.id), c = e.indexOf(a.id);
      return s === -1 && c === -1 ? i.isOnline == null || a.isOnline == null ? i.isOnline == null && a.isOnline == null ? 0 : i.isOnline == null ? 1 : -1 : i.isOnline && !a.isOnline ? -1 : !i.isOnline && a.isOnline ? 1 : 0 : s === -1 ? -1 : c === -1 || s > c ? 1 : -1;
    }),
    hasUnknownDevices: n
  };
}, JJ = () => {
  const t = ve.c(11), {
    data: e,
    isLoading: n,
    error: r
  } = YNe(), [i, a] = I.useState(null), [s, c] = I.useState(!1);
  let d, f;
  t[0] !== e || t[1] !== s ? (d = () => {
    if (e == null || s)
      return;
    const T = jLe(), {
      sortedDevices: O,
      hasUnknownDevices: R
    } = PLe(e, T);
    a(O), R && (_h.set(Vd.DEVICES_ORDER, O.map(LLe)), SE.debug("Stored devices order updated with unknown devices"));
  }, f = [e, s], t[0] = e, t[1] = s, t[2] = d, t[3] = f) : (d = t[2], f = t[3]), I.useEffect(d, f);
  const g = zLe;
  let m;
  t[4] === Symbol.for("react.memo_cache_sentinel") ? (m = () => {
    SE.debug("Devices drag started"), c(!0);
  }, t[4] = m) : m = t[4];
  const b = m;
  let w;
  t[5] === Symbol.for("react.memo_cache_sentinel") ? (w = (T) => {
    g(T), a(T), c(!1), SE.debug("Devices drag finished");
  }, t[5] = w) : w = t[5];
  const _ = w;
  let A;
  return t[6] !== i || t[7] !== r || t[8] !== s || t[9] !== n ? (A = {
    devices: i,
    isLoading: n,
    error: r,
    isDragging: s,
    startDrag: b,
    finishDrag: _
  }, t[6] = i, t[7] = r, t[8] = s, t[9] = n, t[10] = A) : A = t[10], A;
};
function LLe(t) {
  return t.id;
}
function BLe(t) {
  return t.id;
}
function zLe(t) {
  _h.set(Vd.DEVICES_ORDER, t.map(BLe)), SE.debug("Stored devices order updated");
}
function FLe() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return I.useMemo(
    () => (r) => {
      e.forEach((i) => i(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  );
}
const AO = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function Cw(t) {
  const e = Object.prototype.toString.call(t);
  return e === "[object Window]" || // In Electron context the Window object serializes to [object global]
  e === "[object global]";
}
function jk(t) {
  return "nodeType" in t;
}
function fl(t) {
  var e, n;
  return t ? Cw(t) ? t : jk(t) && (e = (n = t.ownerDocument) == null ? void 0 : n.defaultView) != null ? e : window : window;
}
function Pk(t) {
  const {
    Document: e
  } = fl(t);
  return t instanceof e;
}
function q_(t) {
  return Cw(t) ? !1 : t instanceof fl(t).HTMLElement;
}
function eee(t) {
  return t instanceof fl(t).SVGElement;
}
function Tw(t) {
  return t ? Cw(t) ? t.document : jk(t) ? Pk(t) ? t : q_(t) || eee(t) ? t.ownerDocument : document : document : document;
}
const of = AO ? I.useLayoutEffect : I.useEffect;
function Lk(t) {
  const e = I.useRef(t);
  return of(() => {
    e.current = t;
  }), I.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return e.current == null ? void 0 : e.current(...r);
  }, []);
}
function VLe() {
  const t = I.useRef(null), e = I.useCallback((r, i) => {
    t.current = setInterval(r, i);
  }, []), n = I.useCallback(() => {
    t.current !== null && (clearInterval(t.current), t.current = null);
  }, []);
  return [e, n];
}
function h_(t, e) {
  e === void 0 && (e = [t]);
  const n = I.useRef(t);
  return of(() => {
    n.current !== t && (n.current = t);
  }, e), n;
}
function G_(t, e) {
  const n = I.useRef();
  return I.useMemo(
    () => {
      const r = t(n.current);
      return n.current = r, r;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...e]
  );
}
function h5(t) {
  const e = Lk(t), n = I.useRef(null), r = I.useCallback(
    (i) => {
      i !== n.current && e?.(i, n.current), n.current = i;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
function QN(t) {
  const e = I.useRef();
  return I.useEffect(() => {
    e.current = t;
  }, [t]), e.current;
}
let OD = {};
function Y_(t, e) {
  return I.useMemo(() => {
    if (e)
      return e;
    const n = OD[t] == null ? 0 : OD[t] + 1;
    return OD[t] = n, t + "-" + n;
  }, [t, e]);
}
function tee(t) {
  return function(e) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return r.reduce((a, s) => {
      const c = Object.entries(s);
      for (const [d, f] of c) {
        const g = a[d];
        g != null && (a[d] = g + t * f);
      }
      return a;
    }, {
      ...e
    });
  };
}
const Vb = /* @__PURE__ */ tee(1), p5 = /* @__PURE__ */ tee(-1);
function ULe(t) {
  return "clientX" in t && "clientY" in t;
}
function Bk(t) {
  if (!t)
    return !1;
  const {
    KeyboardEvent: e
  } = fl(t.target);
  return e && t instanceof e;
}
function $Le(t) {
  if (!t)
    return !1;
  const {
    TouchEvent: e
  } = fl(t.target);
  return e && t instanceof e;
}
function ZN(t) {
  if ($Le(t)) {
    if (t.touches && t.touches.length) {
      const {
        clientX: e,
        clientY: n
      } = t.touches[0];
      return {
        x: e,
        y: n
      };
    } else if (t.changedTouches && t.changedTouches.length) {
      const {
        clientX: e,
        clientY: n
      } = t.changedTouches[0];
      return {
        x: e,
        y: n
      };
    }
  }
  return ULe(t) ? {
    x: t.clientX,
    y: t.clientY
  } : null;
}
const p_ = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(t) {
      if (!t)
        return;
      const {
        x: e,
        y: n
      } = t;
      return "translate3d(" + (e ? Math.round(e) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(t) {
      if (!t)
        return;
      const {
        scaleX: e,
        scaleY: n
      } = t;
      return "scaleX(" + e + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(t) {
      if (t)
        return [p_.Translate.toString(t), p_.Scale.toString(t)].join(" ");
    }
  },
  Transition: {
    toString(t) {
      let {
        property: e,
        duration: n,
        easing: r
      } = t;
      return e + " " + n + "ms " + r;
    }
  }
}), _U = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function HLe(t) {
  return t.matches(_U) ? t : t.querySelector(_U);
}
const qLe = {
  display: "none"
};
function GLe(t) {
  let {
    id: e,
    value: n
  } = t;
  return De.createElement("div", {
    id: e,
    style: qLe
  }, n);
}
function YLe(t) {
  let {
    id: e,
    announcement: n,
    ariaLiveType: r = "assertive"
  } = t;
  const i = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return De.createElement("div", {
    id: e,
    style: i,
    role: "status",
    "aria-live": r,
    "aria-atomic": !0
  }, n);
}
function XLe() {
  const [t, e] = I.useState("");
  return {
    announce: I.useCallback((r) => {
      r != null && e(r);
    }, []),
    announcement: t
  };
}
const nee = /* @__PURE__ */ I.createContext(null);
function WLe(t) {
  const e = I.useContext(nee);
  I.useEffect(() => {
    if (!e)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return e(t);
  }, [t, e]);
}
function QLe() {
  const [t] = I.useState(() => /* @__PURE__ */ new Set()), e = I.useCallback((r) => (t.add(r), () => t.delete(r)), [t]);
  return [I.useCallback((r) => {
    let {
      type: i,
      event: a
    } = r;
    t.forEach((s) => {
      var c;
      return (c = s[i]) == null ? void 0 : c.call(s, a);
    });
  }, [t]), e];
}
const ZLe = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, KLe = {
  onDragStart(t) {
    let {
      active: e
    } = t;
    return "Picked up draggable item " + e.id + ".";
  },
  onDragOver(t) {
    let {
      active: e,
      over: n
    } = t;
    return n ? "Draggable item " + e.id + " was moved over droppable area " + n.id + "." : "Draggable item " + e.id + " is no longer over a droppable area.";
  },
  onDragEnd(t) {
    let {
      active: e,
      over: n
    } = t;
    return n ? "Draggable item " + e.id + " was dropped over droppable area " + n.id : "Draggable item " + e.id + " was dropped.";
  },
  onDragCancel(t) {
    let {
      active: e
    } = t;
    return "Dragging was cancelled. Draggable item " + e.id + " was dropped.";
  }
};
function JLe(t) {
  let {
    announcements: e = KLe,
    container: n,
    hiddenTextDescribedById: r,
    screenReaderInstructions: i = ZLe
  } = t;
  const {
    announce: a,
    announcement: s
  } = XLe(), c = Y_("DndLiveRegion"), [d, f] = I.useState(!1);
  if (I.useEffect(() => {
    f(!0);
  }, []), WLe(I.useMemo(() => ({
    onDragStart(m) {
      let {
        active: b
      } = m;
      a(e.onDragStart({
        active: b
      }));
    },
    onDragMove(m) {
      let {
        active: b,
        over: w
      } = m;
      e.onDragMove && a(e.onDragMove({
        active: b,
        over: w
      }));
    },
    onDragOver(m) {
      let {
        active: b,
        over: w
      } = m;
      a(e.onDragOver({
        active: b,
        over: w
      }));
    },
    onDragEnd(m) {
      let {
        active: b,
        over: w
      } = m;
      a(e.onDragEnd({
        active: b,
        over: w
      }));
    },
    onDragCancel(m) {
      let {
        active: b,
        over: w
      } = m;
      a(e.onDragCancel({
        active: b,
        over: w
      }));
    }
  }), [a, e])), !d)
    return null;
  const g = De.createElement(De.Fragment, null, De.createElement(GLe, {
    id: r,
    value: i.draggable
  }), De.createElement(YLe, {
    id: c,
    announcement: s
  }));
  return n ? Wc.createPortal(g, n) : g;
}
var Va;
(function(t) {
  t.DragStart = "dragStart", t.DragMove = "dragMove", t.DragEnd = "dragEnd", t.DragCancel = "dragCancel", t.DragOver = "dragOver", t.RegisterDroppable = "registerDroppable", t.SetDroppableDisabled = "setDroppableDisabled", t.UnregisterDroppable = "unregisterDroppable";
})(Va || (Va = {}));
function m5() {
}
function eBe(t, e) {
  return I.useMemo(
    () => ({
      sensor: t,
      options: e ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, e]
  );
}
function tBe() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return I.useMemo(
    () => [...e].filter((r) => r != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...e]
  );
}
const Qu = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function nBe(t, e) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function rBe(t, e) {
  let {
    data: {
      value: n
    }
  } = t, {
    data: {
      value: r
    }
  } = e;
  return n - r;
}
function iBe(t, e) {
  let {
    data: {
      value: n
    }
  } = t, {
    data: {
      value: r
    }
  } = e;
  return r - n;
}
function aBe(t, e) {
  if (!t || t.length === 0)
    return null;
  const [n] = t;
  return e ? n[e] : n;
}
function AU(t, e, n) {
  return e === void 0 && (e = t.left), n === void 0 && (n = t.top), {
    x: e + t.width * 0.5,
    y: n + t.height * 0.5
  };
}
const oBe = (t) => {
  let {
    collisionRect: e,
    droppableRects: n,
    droppableContainers: r
  } = t;
  const i = AU(e, e.left, e.top), a = [];
  for (const s of r) {
    const {
      id: c
    } = s, d = n.get(c);
    if (d) {
      const f = nBe(AU(d), i);
      a.push({
        id: c,
        data: {
          droppableContainer: s,
          value: f
        }
      });
    }
  }
  return a.sort(rBe);
};
function sBe(t, e) {
  const n = Math.max(e.top, t.top), r = Math.max(e.left, t.left), i = Math.min(e.left + e.width, t.left + t.width), a = Math.min(e.top + e.height, t.top + t.height), s = i - r, c = a - n;
  if (r < i && n < a) {
    const d = e.width * e.height, f = t.width * t.height, g = s * c, m = g / (d + f - g);
    return Number(m.toFixed(4));
  }
  return 0;
}
const lBe = (t) => {
  let {
    collisionRect: e,
    droppableRects: n,
    droppableContainers: r
  } = t;
  const i = [];
  for (const a of r) {
    const {
      id: s
    } = a, c = n.get(s);
    if (c) {
      const d = sBe(c, e);
      d > 0 && i.push({
        id: s,
        data: {
          droppableContainer: a,
          value: d
        }
      });
    }
  }
  return i.sort(iBe);
};
function cBe(t, e, n) {
  return {
    ...t,
    scaleX: e && n ? e.width / n.width : 1,
    scaleY: e && n ? e.height / n.height : 1
  };
}
function ree(t, e) {
  return t && e ? {
    x: t.left - e.left,
    y: t.top - e.top
  } : Qu;
}
function uBe(t) {
  return function(n) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return i.reduce((s, c) => ({
      ...s,
      top: s.top + t * c.y,
      bottom: s.bottom + t * c.y,
      left: s.left + t * c.x,
      right: s.right + t * c.x
    }), {
      ...n
    });
  };
}
const dBe = /* @__PURE__ */ uBe(1);
function fBe(t) {
  if (t.startsWith("matrix3d(")) {
    const e = t.slice(9, -1).split(/, /);
    return {
      x: +e[12],
      y: +e[13],
      scaleX: +e[0],
      scaleY: +e[5]
    };
  } else if (t.startsWith("matrix(")) {
    const e = t.slice(7, -1).split(/, /);
    return {
      x: +e[4],
      y: +e[5],
      scaleX: +e[0],
      scaleY: +e[3]
    };
  }
  return null;
}
function hBe(t, e, n) {
  const r = fBe(e);
  if (!r)
    return t;
  const {
    scaleX: i,
    scaleY: a,
    x: s,
    y: c
  } = r, d = t.left - s - (1 - i) * parseFloat(n), f = t.top - c - (1 - a) * parseFloat(n.slice(n.indexOf(" ") + 1)), g = i ? t.width / i : t.width, m = a ? t.height / a : t.height;
  return {
    width: g,
    height: m,
    top: f,
    right: d + g,
    bottom: f + m,
    left: d
  };
}
const pBe = {
  ignoreTransform: !1
};
function Ow(t, e) {
  e === void 0 && (e = pBe);
  let n = t.getBoundingClientRect();
  if (e.ignoreTransform) {
    const {
      transform: f,
      transformOrigin: g
    } = fl(t).getComputedStyle(t);
    f && (n = hBe(n, f, g));
  }
  const {
    top: r,
    left: i,
    width: a,
    height: s,
    bottom: c,
    right: d
  } = n;
  return {
    top: r,
    left: i,
    width: a,
    height: s,
    bottom: c,
    right: d
  };
}
function CU(t) {
  return Ow(t, {
    ignoreTransform: !0
  });
}
function mBe(t) {
  const e = t.innerWidth, n = t.innerHeight;
  return {
    top: 0,
    left: 0,
    right: e,
    bottom: n,
    width: e,
    height: n
  };
}
function gBe(t, e) {
  return e === void 0 && (e = fl(t).getComputedStyle(t)), e.position === "fixed";
}
function vBe(t, e) {
  e === void 0 && (e = fl(t).getComputedStyle(t));
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((i) => {
    const a = e[i];
    return typeof a == "string" ? n.test(a) : !1;
  });
}
function zk(t, e) {
  const n = [];
  function r(i) {
    if (e != null && n.length >= e || !i)
      return n;
    if (Pk(i) && i.scrollingElement != null && !n.includes(i.scrollingElement))
      return n.push(i.scrollingElement), n;
    if (!q_(i) || eee(i) || n.includes(i))
      return n;
    const a = fl(t).getComputedStyle(i);
    return i !== t && vBe(i, a) && n.push(i), gBe(i, a) ? n : r(i.parentNode);
  }
  return t ? r(t) : n;
}
function iee(t) {
  const [e] = zk(t, 1);
  return e ?? null;
}
function RD(t) {
  return !AO || !t ? null : Cw(t) ? t : jk(t) ? Pk(t) || t === Tw(t).scrollingElement ? window : q_(t) ? t : null : null;
}
function aee(t) {
  return Cw(t) ? t.scrollX : t.scrollLeft;
}
function oee(t) {
  return Cw(t) ? t.scrollY : t.scrollTop;
}
function KN(t) {
  return {
    x: aee(t),
    y: oee(t)
  };
}
var so;
(function(t) {
  t[t.Forward = 1] = "Forward", t[t.Backward = -1] = "Backward";
})(so || (so = {}));
function see(t) {
  return !AO || !t ? !1 : t === document.scrollingElement;
}
function lee(t) {
  const e = {
    x: 0,
    y: 0
  }, n = see(t) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: t.clientHeight,
    width: t.clientWidth
  }, r = {
    x: t.scrollWidth - n.width,
    y: t.scrollHeight - n.height
  }, i = t.scrollTop <= e.y, a = t.scrollLeft <= e.x, s = t.scrollTop >= r.y, c = t.scrollLeft >= r.x;
  return {
    isTop: i,
    isLeft: a,
    isBottom: s,
    isRight: c,
    maxScroll: r,
    minScroll: e
  };
}
const yBe = {
  x: 0.2,
  y: 0.2
};
function bBe(t, e, n, r, i) {
  let {
    top: a,
    left: s,
    right: c,
    bottom: d
  } = n;
  r === void 0 && (r = 10), i === void 0 && (i = yBe);
  const {
    isTop: f,
    isBottom: g,
    isLeft: m,
    isRight: b
  } = lee(t), w = {
    x: 0,
    y: 0
  }, _ = {
    x: 0,
    y: 0
  }, A = {
    height: e.height * i.y,
    width: e.width * i.x
  };
  return !f && a <= e.top + A.height ? (w.y = so.Backward, _.y = r * Math.abs((e.top + A.height - a) / A.height)) : !g && d >= e.bottom - A.height && (w.y = so.Forward, _.y = r * Math.abs((e.bottom - A.height - d) / A.height)), !b && c >= e.right - A.width ? (w.x = so.Forward, _.x = r * Math.abs((e.right - A.width - c) / A.width)) : !m && s <= e.left + A.width && (w.x = so.Backward, _.x = r * Math.abs((e.left + A.width - s) / A.width)), {
    direction: w,
    speed: _
  };
}
function wBe(t) {
  if (t === document.scrollingElement) {
    const {
      innerWidth: a,
      innerHeight: s
    } = window;
    return {
      top: 0,
      left: 0,
      right: a,
      bottom: s,
      width: a,
      height: s
    };
  }
  const {
    top: e,
    left: n,
    right: r,
    bottom: i
  } = t.getBoundingClientRect();
  return {
    top: e,
    left: n,
    right: r,
    bottom: i,
    width: t.clientWidth,
    height: t.clientHeight
  };
}
function cee(t) {
  return t.reduce((e, n) => Vb(e, KN(n)), Qu);
}
function xBe(t) {
  return t.reduce((e, n) => e + aee(n), 0);
}
function SBe(t) {
  return t.reduce((e, n) => e + oee(n), 0);
}
function EBe(t, e) {
  if (e === void 0 && (e = Ow), !t)
    return;
  const {
    top: n,
    left: r,
    bottom: i,
    right: a
  } = e(t);
  iee(t) && (i <= 0 || a <= 0 || n >= window.innerHeight || r >= window.innerWidth) && t.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const _Be = [["x", ["left", "right"], xBe], ["y", ["top", "bottom"], SBe]];
class Fk {
  constructor(e, n) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const r = zk(n), i = cee(r);
    this.rect = {
      ...e
    }, this.width = e.width, this.height = e.height;
    for (const [a, s, c] of _Be)
      for (const d of s)
        Object.defineProperty(this, d, {
          get: () => {
            const f = c(r), g = i[a] - f;
            return this.rect[d] + g;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class EE {
  constructor(e) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((n) => {
        var r;
        return (r = this.target) == null ? void 0 : r.removeEventListener(...n);
      });
    }, this.target = e;
  }
  add(e, n, r) {
    var i;
    (i = this.target) == null || i.addEventListener(e, n, r), this.listeners.push([e, n, r]);
  }
}
function ABe(t) {
  const {
    EventTarget: e
  } = fl(t);
  return t instanceof e ? t : Tw(t);
}
function DD(t, e) {
  const n = Math.abs(t.x), r = Math.abs(t.y);
  return typeof e == "number" ? Math.sqrt(n ** 2 + r ** 2) > e : "x" in e && "y" in e ? n > e.x && r > e.y : "x" in e ? n > e.x : "y" in e ? r > e.y : !1;
}
var Gc;
(function(t) {
  t.Click = "click", t.DragStart = "dragstart", t.Keydown = "keydown", t.ContextMenu = "contextmenu", t.Resize = "resize", t.SelectionChange = "selectionchange", t.VisibilityChange = "visibilitychange";
})(Gc || (Gc = {}));
function TU(t) {
  t.preventDefault();
}
function CBe(t) {
  t.stopPropagation();
}
var xr;
(function(t) {
  t.Space = "Space", t.Down = "ArrowDown", t.Right = "ArrowRight", t.Left = "ArrowLeft", t.Up = "ArrowUp", t.Esc = "Escape", t.Enter = "Enter", t.Tab = "Tab";
})(xr || (xr = {}));
const uee = {
  start: [xr.Space, xr.Enter],
  cancel: [xr.Esc],
  end: [xr.Space, xr.Enter, xr.Tab]
}, TBe = (t, e) => {
  let {
    currentCoordinates: n
  } = e;
  switch (t.code) {
    case xr.Right:
      return {
        ...n,
        x: n.x + 25
      };
    case xr.Left:
      return {
        ...n,
        x: n.x - 25
      };
    case xr.Down:
      return {
        ...n,
        y: n.y + 25
      };
    case xr.Up:
      return {
        ...n,
        y: n.y - 25
      };
  }
};
class dee {
  constructor(e) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = e;
    const {
      event: {
        target: n
      }
    } = e;
    this.props = e, this.listeners = new EE(Tw(n)), this.windowListeners = new EE(fl(n)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(Gc.Resize, this.handleCancel), this.windowListeners.add(Gc.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(Gc.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: e,
      onStart: n
    } = this.props, r = e.node.current;
    r && EBe(r), n(Qu);
  }
  handleKeyDown(e) {
    if (Bk(e)) {
      const {
        active: n,
        context: r,
        options: i
      } = this.props, {
        keyboardCodes: a = uee,
        coordinateGetter: s = TBe,
        scrollBehavior: c = "smooth"
      } = i, {
        code: d
      } = e;
      if (a.end.includes(d)) {
        this.handleEnd(e);
        return;
      }
      if (a.cancel.includes(d)) {
        this.handleCancel(e);
        return;
      }
      const {
        collisionRect: f
      } = r.current, g = f ? {
        x: f.left,
        y: f.top
      } : Qu;
      this.referenceCoordinates || (this.referenceCoordinates = g);
      const m = s(e, {
        active: n,
        context: r.current,
        currentCoordinates: g
      });
      if (m) {
        const b = p5(m, g), w = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: _
        } = r.current;
        for (const A of _) {
          const T = e.code, {
            isTop: O,
            isRight: R,
            isLeft: N,
            isBottom: M,
            maxScroll: P,
            minScroll: z
          } = lee(A), F = wBe(A), $ = {
            x: Math.min(T === xr.Right ? F.right - F.width / 2 : F.right, Math.max(T === xr.Right ? F.left : F.left + F.width / 2, m.x)),
            y: Math.min(T === xr.Down ? F.bottom - F.height / 2 : F.bottom, Math.max(T === xr.Down ? F.top : F.top + F.height / 2, m.y))
          }, G = T === xr.Right && !R || T === xr.Left && !N, H = T === xr.Down && !M || T === xr.Up && !O;
          if (G && $.x !== m.x) {
            const Z = A.scrollLeft + b.x, V = T === xr.Right && Z <= P.x || T === xr.Left && Z >= z.x;
            if (V && !b.y) {
              A.scrollTo({
                left: Z,
                behavior: c
              });
              return;
            }
            V ? w.x = A.scrollLeft - Z : w.x = T === xr.Right ? A.scrollLeft - P.x : A.scrollLeft - z.x, w.x && A.scrollBy({
              left: -w.x,
              behavior: c
            });
            break;
          } else if (H && $.y !== m.y) {
            const Z = A.scrollTop + b.y, V = T === xr.Down && Z <= P.y || T === xr.Up && Z >= z.y;
            if (V && !b.x) {
              A.scrollTo({
                top: Z,
                behavior: c
              });
              return;
            }
            V ? w.y = A.scrollTop - Z : w.y = T === xr.Down ? A.scrollTop - P.y : A.scrollTop - z.y, w.y && A.scrollBy({
              top: -w.y,
              behavior: c
            });
            break;
          }
        }
        this.handleMove(e, Vb(p5(m, this.referenceCoordinates), w));
      }
    }
  }
  handleMove(e, n) {
    const {
      onMove: r
    } = this.props;
    e.preventDefault(), r(n);
  }
  handleEnd(e) {
    const {
      onEnd: n
    } = this.props;
    e.preventDefault(), this.detach(), n();
  }
  handleCancel(e) {
    const {
      onCancel: n
    } = this.props;
    e.preventDefault(), this.detach(), n();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
dee.activators = [{
  eventName: "onKeyDown",
  handler: (t, e, n) => {
    let {
      keyboardCodes: r = uee,
      onActivation: i
    } = e, {
      active: a
    } = n;
    const {
      code: s
    } = t.nativeEvent;
    if (r.start.includes(s)) {
      const c = a.activatorNode.current;
      return c && t.target !== c ? !1 : (t.preventDefault(), i?.({
        event: t.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function OU(t) {
  return !!(t && "distance" in t);
}
function RU(t) {
  return !!(t && "delay" in t);
}
class Vk {
  constructor(e, n, r) {
    var i;
    r === void 0 && (r = ABe(e.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = e, this.events = n;
    const {
      event: a
    } = e, {
      target: s
    } = a;
    this.props = e, this.events = n, this.document = Tw(s), this.documentListeners = new EE(this.document), this.listeners = new EE(r), this.windowListeners = new EE(fl(s)), this.initialCoordinates = (i = ZN(a)) != null ? i : Qu, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: e,
      props: {
        options: {
          activationConstraint: n,
          bypassActivationConstraint: r
        }
      }
    } = this;
    if (this.listeners.add(e.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(e.end.name, this.handleEnd), e.cancel && this.listeners.add(e.cancel.name, this.handleCancel), this.windowListeners.add(Gc.Resize, this.handleCancel), this.windowListeners.add(Gc.DragStart, TU), this.windowListeners.add(Gc.VisibilityChange, this.handleCancel), this.windowListeners.add(Gc.ContextMenu, TU), this.documentListeners.add(Gc.Keydown, this.handleKeydown), n) {
      if (r != null && r({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (RU(n)) {
        this.timeoutId = setTimeout(this.handleStart, n.delay), this.handlePending(n);
        return;
      }
      if (OU(n)) {
        this.handlePending(n);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(e, n) {
    const {
      active: r,
      onPending: i
    } = this.props;
    i(r, e, this.initialCoordinates, n);
  }
  handleStart() {
    const {
      initialCoordinates: e
    } = this, {
      onStart: n
    } = this.props;
    e && (this.activated = !0, this.documentListeners.add(Gc.Click, CBe, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(Gc.SelectionChange, this.removeTextSelection), n(e));
  }
  handleMove(e) {
    var n;
    const {
      activated: r,
      initialCoordinates: i,
      props: a
    } = this, {
      onMove: s,
      options: {
        activationConstraint: c
      }
    } = a;
    if (!i)
      return;
    const d = (n = ZN(e)) != null ? n : Qu, f = p5(i, d);
    if (!r && c) {
      if (OU(c)) {
        if (c.tolerance != null && DD(f, c.tolerance))
          return this.handleCancel();
        if (DD(f, c.distance))
          return this.handleStart();
      }
      if (RU(c) && DD(f, c.tolerance))
        return this.handleCancel();
      this.handlePending(c, f);
      return;
    }
    e.cancelable && e.preventDefault(), s(d);
  }
  handleEnd() {
    const {
      onAbort: e,
      onEnd: n
    } = this.props;
    this.detach(), this.activated || e(this.props.active), n();
  }
  handleCancel() {
    const {
      onAbort: e,
      onCancel: n
    } = this.props;
    this.detach(), this.activated || e(this.props.active), n();
  }
  handleKeydown(e) {
    e.code === xr.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var e;
    (e = this.document.getSelection()) == null || e.removeAllRanges();
  }
}
const OBe = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class Uk extends Vk {
  constructor(e) {
    const {
      event: n
    } = e, r = Tw(n.target);
    super(e, OBe, r);
  }
}
Uk.activators = [{
  eventName: "onPointerDown",
  handler: (t, e) => {
    let {
      nativeEvent: n
    } = t, {
      onActivation: r
    } = e;
    return !n.isPrimary || n.button !== 0 ? !1 : (r?.({
      event: n
    }), !0);
  }
}];
const RBe = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var JN;
(function(t) {
  t[t.RightClick = 2] = "RightClick";
})(JN || (JN = {}));
class DBe extends Vk {
  constructor(e) {
    super(e, RBe, Tw(e.event.target));
  }
}
DBe.activators = [{
  eventName: "onMouseDown",
  handler: (t, e) => {
    let {
      nativeEvent: n
    } = t, {
      onActivation: r
    } = e;
    return n.button === JN.RightClick ? !1 : (r?.({
      event: n
    }), !0);
  }
}];
const ND = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class NBe extends Vk {
  constructor(e) {
    super(e, ND);
  }
  static setup() {
    return window.addEventListener(ND.move.name, e, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(ND.move.name, e);
    };
    function e() {
    }
  }
}
NBe.activators = [{
  eventName: "onTouchStart",
  handler: (t, e) => {
    let {
      nativeEvent: n
    } = t, {
      onActivation: r
    } = e;
    const {
      touches: i
    } = n;
    return i.length > 1 ? !1 : (r?.({
      event: n
    }), !0);
  }
}];
var _E;
(function(t) {
  t[t.Pointer = 0] = "Pointer", t[t.DraggableRect = 1] = "DraggableRect";
})(_E || (_E = {}));
var g5;
(function(t) {
  t[t.TreeOrder = 0] = "TreeOrder", t[t.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(g5 || (g5 = {}));
function MBe(t) {
  let {
    acceleration: e,
    activator: n = _E.Pointer,
    canScroll: r,
    draggingRect: i,
    enabled: a,
    interval: s = 5,
    order: c = g5.TreeOrder,
    pointerCoordinates: d,
    scrollableAncestors: f,
    scrollableAncestorRects: g,
    delta: m,
    threshold: b
  } = t;
  const w = kBe({
    delta: m,
    disabled: !a
  }), [_, A] = VLe(), T = I.useRef({
    x: 0,
    y: 0
  }), O = I.useRef({
    x: 0,
    y: 0
  }), R = I.useMemo(() => {
    switch (n) {
      case _E.Pointer:
        return d ? {
          top: d.y,
          bottom: d.y,
          left: d.x,
          right: d.x
        } : null;
      case _E.DraggableRect:
        return i;
    }
  }, [n, i, d]), N = I.useRef(null), M = I.useCallback(() => {
    const z = N.current;
    if (!z)
      return;
    const F = T.current.x * O.current.x, $ = T.current.y * O.current.y;
    z.scrollBy(F, $);
  }, []), P = I.useMemo(() => c === g5.TreeOrder ? [...f].reverse() : f, [c, f]);
  I.useEffect(
    () => {
      if (!a || !f.length || !R) {
        A();
        return;
      }
      for (const z of P) {
        if (r?.(z) === !1)
          continue;
        const F = f.indexOf(z), $ = g[F];
        if (!$)
          continue;
        const {
          direction: G,
          speed: H
        } = bBe(z, $, R, e, b);
        for (const Z of ["x", "y"])
          w[Z][G[Z]] || (H[Z] = 0, G[Z] = 0);
        if (H.x > 0 || H.y > 0) {
          A(), N.current = z, _(M, s), T.current = H, O.current = G;
          return;
        }
      }
      T.current = {
        x: 0,
        y: 0
      }, O.current = {
        x: 0,
        y: 0
      }, A();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      e,
      M,
      r,
      A,
      a,
      s,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(R),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(w),
      _,
      f,
      P,
      g,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(b)
    ]
  );
}
const IBe = {
  x: {
    [so.Backward]: !1,
    [so.Forward]: !1
  },
  y: {
    [so.Backward]: !1,
    [so.Forward]: !1
  }
};
function kBe(t) {
  let {
    delta: e,
    disabled: n
  } = t;
  const r = QN(e);
  return G_((i) => {
    if (n || !r || !i)
      return IBe;
    const a = {
      x: Math.sign(e.x - r.x),
      y: Math.sign(e.y - r.y)
    };
    return {
      x: {
        [so.Backward]: i.x[so.Backward] || a.x === -1,
        [so.Forward]: i.x[so.Forward] || a.x === 1
      },
      y: {
        [so.Backward]: i.y[so.Backward] || a.y === -1,
        [so.Forward]: i.y[so.Forward] || a.y === 1
      }
    };
  }, [n, e, r]);
}
function jBe(t, e) {
  const n = e != null ? t.get(e) : void 0, r = n ? n.node.current : null;
  return G_((i) => {
    var a;
    return e == null ? null : (a = r ?? i) != null ? a : null;
  }, [r, e]);
}
function PBe(t, e) {
  return I.useMemo(() => t.reduce((n, r) => {
    const {
      sensor: i
    } = r, a = i.activators.map((s) => ({
      eventName: s.eventName,
      handler: e(s.handler, r)
    }));
    return [...n, ...a];
  }, []), [t, e]);
}
var m_;
(function(t) {
  t[t.Always = 0] = "Always", t[t.BeforeDragging = 1] = "BeforeDragging", t[t.WhileDragging = 2] = "WhileDragging";
})(m_ || (m_ = {}));
var eM;
(function(t) {
  t.Optimized = "optimized";
})(eM || (eM = {}));
const DU = /* @__PURE__ */ new Map();
function LBe(t, e) {
  let {
    dragging: n,
    dependencies: r,
    config: i
  } = e;
  const [a, s] = I.useState(null), {
    frequency: c,
    measure: d,
    strategy: f
  } = i, g = I.useRef(t), m = T(), b = h_(m), w = I.useCallback(function(O) {
    O === void 0 && (O = []), !b.current && s((R) => R === null ? O : R.concat(O.filter((N) => !R.includes(N))));
  }, [b]), _ = I.useRef(null), A = G_((O) => {
    if (m && !n)
      return DU;
    if (!O || O === DU || g.current !== t || a != null) {
      const R = /* @__PURE__ */ new Map();
      for (let N of t) {
        if (!N)
          continue;
        if (a && a.length > 0 && !a.includes(N.id) && N.rect.current) {
          R.set(N.id, N.rect.current);
          continue;
        }
        const M = N.node.current, P = M ? new Fk(d(M), M) : null;
        N.rect.current = P, P && R.set(N.id, P);
      }
      return R;
    }
    return O;
  }, [t, a, n, m, d]);
  return I.useEffect(() => {
    g.current = t;
  }, [t]), I.useEffect(
    () => {
      m || w();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, m]
  ), I.useEffect(
    () => {
      a && a.length > 0 && s(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(a)]
  ), I.useEffect(
    () => {
      m || typeof c != "number" || _.current !== null || (_.current = setTimeout(() => {
        w(), _.current = null;
      }, c));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [c, m, w, ...r]
  ), {
    droppableRects: A,
    measureDroppableContainers: w,
    measuringScheduled: a != null
  };
  function T() {
    switch (f) {
      case m_.Always:
        return !1;
      case m_.BeforeDragging:
        return n;
      default:
        return !n;
    }
  }
}
function fee(t, e) {
  return G_((n) => t ? n || (typeof e == "function" ? e(t) : t) : null, [e, t]);
}
function BBe(t, e) {
  return fee(t, e);
}
function zBe(t) {
  let {
    callback: e,
    disabled: n
  } = t;
  const r = Lk(e), i = I.useMemo(() => {
    if (n || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: a
    } = window;
    return new a(r);
  }, [r, n]);
  return I.useEffect(() => () => i?.disconnect(), [i]), i;
}
function CO(t) {
  let {
    callback: e,
    disabled: n
  } = t;
  const r = Lk(e), i = I.useMemo(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: a
      } = window;
      return new a(r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return I.useEffect(() => () => i?.disconnect(), [i]), i;
}
function FBe(t) {
  return new Fk(Ow(t), t);
}
function NU(t, e, n) {
  e === void 0 && (e = FBe);
  const [r, i] = I.useState(null);
  function a() {
    i((d) => {
      if (!t)
        return null;
      if (t.isConnected === !1) {
        var f;
        return (f = d ?? n) != null ? f : null;
      }
      const g = e(t);
      return JSON.stringify(d) === JSON.stringify(g) ? d : g;
    });
  }
  const s = zBe({
    callback(d) {
      if (t)
        for (const f of d) {
          const {
            type: g,
            target: m
          } = f;
          if (g === "childList" && m instanceof HTMLElement && m.contains(t)) {
            a();
            break;
          }
        }
    }
  }), c = CO({
    callback: a
  });
  return of(() => {
    a(), t ? (c?.observe(t), s?.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (c?.disconnect(), s?.disconnect());
  }, [t]), r;
}
function VBe(t) {
  const e = fee(t);
  return ree(t, e);
}
const MU = [];
function UBe(t) {
  const e = I.useRef(t), n = G_((r) => t ? r && r !== MU && t && e.current && t.parentNode === e.current.parentNode ? r : zk(t) : MU, [t]);
  return I.useEffect(() => {
    e.current = t;
  }, [t]), n;
}
function $Be(t) {
  const [e, n] = I.useState(null), r = I.useRef(t), i = I.useCallback((a) => {
    const s = RD(a.target);
    s && n((c) => c ? (c.set(s, KN(s)), new Map(c)) : null);
  }, []);
  return I.useEffect(() => {
    const a = r.current;
    if (t !== a) {
      s(a);
      const c = t.map((d) => {
        const f = RD(d);
        return f ? (f.addEventListener("scroll", i, {
          passive: !0
        }), [f, KN(f)]) : null;
      }).filter((d) => d != null);
      n(c.length ? new Map(c) : null), r.current = t;
    }
    return () => {
      s(t), s(a);
    };
    function s(c) {
      c.forEach((d) => {
        const f = RD(d);
        f?.removeEventListener("scroll", i);
      });
    }
  }, [i, t]), I.useMemo(() => t.length ? e ? Array.from(e.values()).reduce((a, s) => Vb(a, s), Qu) : cee(t) : Qu, [t, e]);
}
function IU(t, e) {
  e === void 0 && (e = []);
  const n = I.useRef(null);
  return I.useEffect(
    () => {
      n.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), I.useEffect(() => {
    const r = t !== Qu;
    r && !n.current && (n.current = t), !r && n.current && (n.current = null);
  }, [t]), n.current ? p5(t, n.current) : Qu;
}
function HBe(t) {
  I.useEffect(
    () => {
      if (!AO)
        return;
      const e = t.map((n) => {
        let {
          sensor: r
        } = n;
        return r.setup == null ? void 0 : r.setup();
      });
      return () => {
        for (const n of e)
          n?.();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t.map((e) => {
      let {
        sensor: n
      } = e;
      return n;
    })
  );
}
function qBe(t, e) {
  return I.useMemo(() => t.reduce((n, r) => {
    let {
      eventName: i,
      handler: a
    } = r;
    return n[i] = (s) => {
      a(s, e);
    }, n;
  }, {}), [t, e]);
}
function hee(t) {
  return I.useMemo(() => t ? mBe(t) : null, [t]);
}
const kU = [];
function GBe(t, e) {
  e === void 0 && (e = Ow);
  const [n] = t, r = hee(n ? fl(n) : null), [i, a] = I.useState(kU);
  function s() {
    a(() => t.length ? t.map((d) => see(d) ? r : new Fk(e(d), d)) : kU);
  }
  const c = CO({
    callback: s
  });
  return of(() => {
    c?.disconnect(), s(), t.forEach((d) => c?.observe(d));
  }, [t]), i;
}
function YBe(t) {
  if (!t)
    return null;
  if (t.children.length > 1)
    return t;
  const e = t.children[0];
  return q_(e) ? e : t;
}
function XBe(t) {
  let {
    measure: e
  } = t;
  const [n, r] = I.useState(null), i = I.useCallback((f) => {
    for (const {
      target: g
    } of f)
      if (q_(g)) {
        r((m) => {
          const b = e(g);
          return m ? {
            ...m,
            width: b.width,
            height: b.height
          } : b;
        });
        break;
      }
  }, [e]), a = CO({
    callback: i
  }), s = I.useCallback((f) => {
    const g = YBe(f);
    a?.disconnect(), g && a?.observe(g), r(g ? e(g) : null);
  }, [e, a]), [c, d] = h5(s);
  return I.useMemo(() => ({
    nodeRef: c,
    rect: n,
    setRef: d
  }), [n, c, d]);
}
const WBe = [{
  sensor: Uk,
  options: {}
}, {
  sensor: dee,
  options: {}
}], QBe = {
  current: {}
}, X4 = {
  draggable: {
    measure: CU
  },
  droppable: {
    measure: CU,
    strategy: m_.WhileDragging,
    frequency: eM.Optimized
  },
  dragOverlay: {
    measure: Ow
  }
};
class AE extends Map {
  get(e) {
    var n;
    return e != null && (n = super.get(e)) != null ? n : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((e) => {
      let {
        disabled: n
      } = e;
      return !n;
    });
  }
  getNodeFor(e) {
    var n, r;
    return (n = (r = this.get(e)) == null ? void 0 : r.node.current) != null ? n : void 0;
  }
}
const ZBe = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new AE(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: m5
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: X4,
  measureDroppableContainers: m5,
  windowRect: null,
  measuringScheduled: !1
}, KBe = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: m5,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: m5
}, TO = /* @__PURE__ */ I.createContext(KBe), pee = /* @__PURE__ */ I.createContext(ZBe);
function JBe() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new AE()
    }
  };
}
function eze(t, e) {
  switch (e.type) {
    case Va.DragStart:
      return {
        ...t,
        draggable: {
          ...t.draggable,
          initialCoordinates: e.initialCoordinates,
          active: e.active
        }
      };
    case Va.DragMove:
      return t.draggable.active == null ? t : {
        ...t,
        draggable: {
          ...t.draggable,
          translate: {
            x: e.coordinates.x - t.draggable.initialCoordinates.x,
            y: e.coordinates.y - t.draggable.initialCoordinates.y
          }
        }
      };
    case Va.DragEnd:
    case Va.DragCancel:
      return {
        ...t,
        draggable: {
          ...t.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Va.RegisterDroppable: {
      const {
        element: n
      } = e, {
        id: r
      } = n, i = new AE(t.droppable.containers);
      return i.set(r, n), {
        ...t,
        droppable: {
          ...t.droppable,
          containers: i
        }
      };
    }
    case Va.SetDroppableDisabled: {
      const {
        id: n,
        key: r,
        disabled: i
      } = e, a = t.droppable.containers.get(n);
      if (!a || r !== a.key)
        return t;
      const s = new AE(t.droppable.containers);
      return s.set(n, {
        ...a,
        disabled: i
      }), {
        ...t,
        droppable: {
          ...t.droppable,
          containers: s
        }
      };
    }
    case Va.UnregisterDroppable: {
      const {
        id: n,
        key: r
      } = e, i = t.droppable.containers.get(n);
      if (!i || r !== i.key)
        return t;
      const a = new AE(t.droppable.containers);
      return a.delete(n), {
        ...t,
        droppable: {
          ...t.droppable,
          containers: a
        }
      };
    }
    default:
      return t;
  }
}
function tze(t) {
  let {
    disabled: e
  } = t;
  const {
    active: n,
    activatorEvent: r,
    draggableNodes: i
  } = I.useContext(TO), a = QN(r), s = QN(n?.id);
  return I.useEffect(() => {
    if (!e && !r && a && s != null) {
      if (!Bk(a) || document.activeElement === a.target)
        return;
      const c = i.get(s);
      if (!c)
        return;
      const {
        activatorNode: d,
        node: f
      } = c;
      if (!d.current && !f.current)
        return;
      requestAnimationFrame(() => {
        for (const g of [d.current, f.current]) {
          if (!g)
            continue;
          const m = HLe(g);
          if (m) {
            m.focus();
            break;
          }
        }
      });
    }
  }, [r, e, i, s, a]), null;
}
function nze(t, e) {
  let {
    transform: n,
    ...r
  } = e;
  return t != null && t.length ? t.reduce((i, a) => a({
    transform: i,
    ...r
  }), n) : n;
}
function rze(t) {
  return I.useMemo(
    () => ({
      draggable: {
        ...X4.draggable,
        ...t?.draggable
      },
      droppable: {
        ...X4.droppable,
        ...t?.droppable
      },
      dragOverlay: {
        ...X4.dragOverlay,
        ...t?.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t?.draggable, t?.droppable, t?.dragOverlay]
  );
}
function ize(t) {
  let {
    activeNode: e,
    measure: n,
    initialRect: r,
    config: i = !0
  } = t;
  const a = I.useRef(!1), {
    x: s,
    y: c
  } = typeof i == "boolean" ? {
    x: i,
    y: i
  } : i;
  of(() => {
    if (!s && !c || !e) {
      a.current = !1;
      return;
    }
    if (a.current || !r)
      return;
    const f = e?.node.current;
    if (!f || f.isConnected === !1)
      return;
    const g = n(f), m = ree(g, r);
    if (s || (m.x = 0), c || (m.y = 0), a.current = !0, Math.abs(m.x) > 0 || Math.abs(m.y) > 0) {
      const b = iee(f);
      b && b.scrollBy({
        top: m.y,
        left: m.x
      });
    }
  }, [e, s, c, r, n]);
}
const mee = /* @__PURE__ */ I.createContext({
  ...Qu,
  scaleX: 1,
  scaleY: 1
});
var T0;
(function(t) {
  t[t.Uninitialized = 0] = "Uninitialized", t[t.Initializing = 1] = "Initializing", t[t.Initialized = 2] = "Initialized";
})(T0 || (T0 = {}));
const aze = /* @__PURE__ */ I.memo(function(e) {
  var n, r, i, a;
  let {
    id: s,
    accessibility: c,
    autoScroll: d = !0,
    children: f,
    sensors: g = WBe,
    collisionDetection: m = lBe,
    measuring: b,
    modifiers: w,
    ..._
  } = e;
  const A = I.useReducer(eze, void 0, JBe), [T, O] = A, [R, N] = QLe(), [M, P] = I.useState(T0.Uninitialized), z = M === T0.Initialized, {
    draggable: {
      active: F,
      nodes: $,
      translate: G
    },
    droppable: {
      containers: H
    }
  } = T, Z = F != null ? $.get(F) : null, V = I.useRef({
    initial: null,
    translated: null
  }), Y = I.useMemo(() => {
    var lt;
    return F != null ? {
      id: F,
      // It's possible for the active node to unmount while dragging
      data: (lt = Z?.data) != null ? lt : QBe,
      rect: V
    } : null;
  }, [F, Z]), ee = I.useRef(null), [K, U] = I.useState(null), [q, W] = I.useState(null), ie = h_(_, Object.values(_)), J = Y_("DndDescribedBy", s), B = I.useMemo(() => H.getEnabled(), [H]), te = rze(b), {
    droppableRects: ae,
    measureDroppableContainers: le,
    measuringScheduled: de
  } = LBe(B, {
    dragging: z,
    dependencies: [G.x, G.y],
    config: te.droppable
  }), _e = jBe($, F), ue = I.useMemo(() => q ? ZN(q) : null, [q]), Se = st(), Ne = BBe(_e, te.draggable.measure);
  ize({
    activeNode: F != null ? $.get(F) : null,
    config: Se.layoutShiftCompensation,
    initialRect: Ne,
    measure: te.draggable.measure
  });
  const Me = NU(_e, te.draggable.measure, Ne), Ce = NU(_e ? _e.parentElement : null), Ue = I.useRef({
    activatorEvent: null,
    active: null,
    activeNode: _e,
    collisionRect: null,
    collisions: null,
    droppableRects: ae,
    draggableNodes: $,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: H,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), rt = H.getNodeFor((n = Ue.current.over) == null ? void 0 : n.id), it = XBe({
    measure: te.dragOverlay.measure
  }), Ft = (r = it.nodeRef.current) != null ? r : _e, wt = z ? (i = it.rect) != null ? i : Me : null, Ot = !!(it.nodeRef.current && it.rect), On = VBe(Ot ? null : Me), Ct = hee(Ft ? fl(Ft) : null), se = UBe(z ? rt ?? _e : null), ge = GBe(se), Te = nze(w, {
    transform: {
      x: G.x - On.x,
      y: G.y - On.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: q,
    active: Y,
    activeNodeRect: Me,
    containerNodeRect: Ce,
    draggingNodeRect: wt,
    over: Ue.current.over,
    overlayNodeRect: it.rect,
    scrollableAncestors: se,
    scrollableAncestorRects: ge,
    windowRect: Ct
  }), He = ue ? Vb(ue, G) : null, $e = $Be(se), Ze = IU($e), ct = IU($e, [Me]), Mt = Vb(Te, Ze), Rt = wt ? dBe(wt, Te) : null, sn = Y && Rt ? m({
    active: Y,
    collisionRect: Rt,
    droppableRects: ae,
    droppableContainers: B,
    pointerCoordinates: He
  }) : null, In = aBe(sn, "id"), [hn, Wn] = I.useState(null), ar = Ot ? Te : Vb(Te, ct), kn = cBe(ar, (a = hn?.rect) != null ? a : null, Me), yr = I.useRef(null), or = I.useCallback(
    (lt, bt) => {
      let {
        sensor: Ke,
        options: ut
      } = bt;
      if (ee.current == null)
        return;
      const ft = $.get(ee.current);
      if (!ft)
        return;
      const en = lt.nativeEvent, sr = new Ke({
        active: ee.current,
        activeNode: ft,
        event: en,
        options: ut,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: Ue,
        onAbort(vn) {
          if (!$.get(vn))
            return;
          const {
            onDragAbort: Un
          } = ie.current, tn = {
            id: vn
          };
          Un?.(tn), R({
            type: "onDragAbort",
            event: tn
          });
        },
        onPending(vn, Ai, Un, tn) {
          if (!$.get(vn))
            return;
          const {
            onDragPending: Hi
          } = ie.current, Ta = {
            id: vn,
            constraint: Ai,
            initialCoordinates: Un,
            offset: tn
          };
          Hi?.(Ta), R({
            type: "onDragPending",
            event: Ta
          });
        },
        onStart(vn) {
          const Ai = ee.current;
          if (Ai == null)
            return;
          const Un = $.get(Ai);
          if (!Un)
            return;
          const {
            onDragStart: tn
          } = ie.current, $i = {
            activatorEvent: en,
            active: {
              id: Ai,
              data: Un.data,
              rect: V
            }
          };
          Wc.unstable_batchedUpdates(() => {
            tn?.($i), P(T0.Initializing), O({
              type: Va.DragStart,
              initialCoordinates: vn,
              active: Ai
            }), R({
              type: "onDragStart",
              event: $i
            }), U(yr.current), W(en);
          });
        },
        onMove(vn) {
          O({
            type: Va.DragMove,
            coordinates: vn
          });
        },
        onEnd: jn(Va.DragEnd),
        onCancel: jn(Va.DragCancel)
      });
      yr.current = sr;
      function jn(vn) {
        return async function() {
          const {
            active: Un,
            collisions: tn,
            over: $i,
            scrollAdjustedTranslate: Hi
          } = Ue.current;
          let Ta = null;
          if (Un && Hi) {
            const {
              cancelDrop: ns
            } = ie.current;
            Ta = {
              activatorEvent: en,
              active: Un,
              collisions: tn,
              delta: Hi,
              over: $i
            }, vn === Va.DragEnd && typeof ns == "function" && await Promise.resolve(ns(Ta)) && (vn = Va.DragCancel);
          }
          ee.current = null, Wc.unstable_batchedUpdates(() => {
            O({
              type: vn
            }), P(T0.Uninitialized), Wn(null), U(null), W(null), yr.current = null;
            const ns = vn === Va.DragEnd ? "onDragEnd" : "onDragCancel";
            if (Ta) {
              const la = ie.current[ns];
              la?.(Ta), R({
                type: ns,
                event: Ta
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [$]
  ), sa = I.useCallback((lt, bt) => (Ke, ut) => {
    const ft = Ke.nativeEvent, en = $.get(ut);
    if (
      // Another sensor is already instantiating
      ee.current !== null || // No active draggable
      !en || // Event has already been captured
      ft.dndKit || ft.defaultPrevented
    )
      return;
    const sr = {
      active: en
    };
    lt(Ke, bt.options, sr) === !0 && (ft.dndKit = {
      capturedBy: bt.sensor
    }, ee.current = ut, or(Ke, bt));
  }, [$, or]), re = PBe(g, sa);
  HBe(g), of(() => {
    Me && M === T0.Initializing && P(T0.Initialized);
  }, [Me, M]), I.useEffect(
    () => {
      const {
        onDragMove: lt
      } = ie.current, {
        active: bt,
        activatorEvent: Ke,
        collisions: ut,
        over: ft
      } = Ue.current;
      if (!bt || !Ke)
        return;
      const en = {
        active: bt,
        activatorEvent: Ke,
        collisions: ut,
        delta: {
          x: Mt.x,
          y: Mt.y
        },
        over: ft
      };
      Wc.unstable_batchedUpdates(() => {
        lt?.(en), R({
          type: "onDragMove",
          event: en
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Mt.x, Mt.y]
  ), I.useEffect(
    () => {
      const {
        active: lt,
        activatorEvent: bt,
        collisions: Ke,
        droppableContainers: ut,
        scrollAdjustedTranslate: ft
      } = Ue.current;
      if (!lt || ee.current == null || !bt || !ft)
        return;
      const {
        onDragOver: en
      } = ie.current, sr = ut.get(In), jn = sr && sr.rect.current ? {
        id: sr.id,
        rect: sr.rect.current,
        data: sr.data,
        disabled: sr.disabled
      } : null, vn = {
        active: lt,
        activatorEvent: bt,
        collisions: Ke,
        delta: {
          x: ft.x,
          y: ft.y
        },
        over: jn
      };
      Wc.unstable_batchedUpdates(() => {
        Wn(jn), en?.(vn), R({
          type: "onDragOver",
          event: vn
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [In]
  ), of(() => {
    Ue.current = {
      activatorEvent: q,
      active: Y,
      activeNode: _e,
      collisionRect: Rt,
      collisions: sn,
      droppableRects: ae,
      draggableNodes: $,
      draggingNode: Ft,
      draggingNodeRect: wt,
      droppableContainers: H,
      over: hn,
      scrollableAncestors: se,
      scrollAdjustedTranslate: Mt
    }, V.current = {
      initial: wt,
      translated: Rt
    };
  }, [Y, _e, sn, Rt, $, Ft, wt, ae, H, hn, se, Mt]), MBe({
    ...Se,
    delta: G,
    draggingRect: Rt,
    pointerCoordinates: He,
    scrollableAncestors: se,
    scrollableAncestorRects: ge
  });
  const Ae = I.useMemo(() => ({
    active: Y,
    activeNode: _e,
    activeNodeRect: Me,
    activatorEvent: q,
    collisions: sn,
    containerNodeRect: Ce,
    dragOverlay: it,
    draggableNodes: $,
    droppableContainers: H,
    droppableRects: ae,
    over: hn,
    measureDroppableContainers: le,
    scrollableAncestors: se,
    scrollableAncestorRects: ge,
    measuringConfiguration: te,
    measuringScheduled: de,
    windowRect: Ct
  }), [Y, _e, Me, q, sn, Ce, it, $, H, ae, hn, le, se, ge, te, de, Ct]), nt = I.useMemo(() => ({
    activatorEvent: q,
    activators: re,
    active: Y,
    activeNodeRect: Me,
    ariaDescribedById: {
      draggable: J
    },
    dispatch: O,
    draggableNodes: $,
    over: hn,
    measureDroppableContainers: le
  }), [q, re, Y, Me, O, J, $, hn, le]);
  return De.createElement(nee.Provider, {
    value: N
  }, De.createElement(TO.Provider, {
    value: nt
  }, De.createElement(pee.Provider, {
    value: Ae
  }, De.createElement(mee.Provider, {
    value: kn
  }, f)), De.createElement(tze, {
    disabled: c?.restoreFocus === !1
  })), De.createElement(JLe, {
    ...c,
    hiddenTextDescribedById: J
  }));
  function st() {
    const lt = K?.autoScrollEnabled === !1, bt = typeof d == "object" ? d.enabled === !1 : d === !1, Ke = z && !lt && !bt;
    return typeof d == "object" ? {
      ...d,
      enabled: Ke
    } : {
      enabled: Ke
    };
  }
}), oze = /* @__PURE__ */ I.createContext(null), jU = "button", sze = "Draggable";
function lze(t) {
  let {
    id: e,
    data: n,
    disabled: r = !1,
    attributes: i
  } = t;
  const a = Y_(sze), {
    activators: s,
    activatorEvent: c,
    active: d,
    activeNodeRect: f,
    ariaDescribedById: g,
    draggableNodes: m,
    over: b
  } = I.useContext(TO), {
    role: w = jU,
    roleDescription: _ = "draggable",
    tabIndex: A = 0
  } = i ?? {}, T = d?.id === e, O = I.useContext(T ? mee : oze), [R, N] = h5(), [M, P] = h5(), z = qBe(s, e), F = h_(n);
  of(
    () => (m.set(e, {
      id: e,
      key: a,
      node: R,
      activatorNode: M,
      data: F
    }), () => {
      const G = m.get(e);
      G && G.key === a && m.delete(e);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [m, e]
  );
  const $ = I.useMemo(() => ({
    role: w,
    tabIndex: A,
    "aria-disabled": r,
    "aria-pressed": T && w === jU ? !0 : void 0,
    "aria-roledescription": _,
    "aria-describedby": g.draggable
  }), [r, w, A, T, _, g.draggable]);
  return {
    active: d,
    activatorEvent: c,
    activeNodeRect: f,
    attributes: $,
    isDragging: T,
    listeners: r ? void 0 : z,
    node: R,
    over: b,
    setNodeRef: N,
    setActivatorNodeRef: P,
    transform: O
  };
}
function cze() {
  return I.useContext(pee);
}
const uze = "Droppable", dze = {
  timeout: 25
};
function fze(t) {
  let {
    data: e,
    disabled: n = !1,
    id: r,
    resizeObserverConfig: i
  } = t;
  const a = Y_(uze), {
    active: s,
    dispatch: c,
    over: d,
    measureDroppableContainers: f
  } = I.useContext(TO), g = I.useRef({
    disabled: n
  }), m = I.useRef(!1), b = I.useRef(null), w = I.useRef(null), {
    disabled: _,
    updateMeasurementsFor: A,
    timeout: T
  } = {
    ...dze,
    ...i
  }, O = h_(A ?? r), R = I.useCallback(
    () => {
      if (!m.current) {
        m.current = !0;
        return;
      }
      w.current != null && clearTimeout(w.current), w.current = setTimeout(() => {
        f(Array.isArray(O.current) ? O.current : [O.current]), w.current = null;
      }, T);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [T]
  ), N = CO({
    callback: R,
    disabled: _ || !s
  }), M = I.useCallback(($, G) => {
    N && (G && (N.unobserve(G), m.current = !1), $ && N.observe($));
  }, [N]), [P, z] = h5(M), F = h_(e);
  return I.useEffect(() => {
    !N || !P.current || (N.disconnect(), m.current = !1, N.observe(P.current));
  }, [P, N]), I.useEffect(
    () => (c({
      type: Va.RegisterDroppable,
      element: {
        id: r,
        key: a,
        disabled: n,
        node: P,
        rect: b,
        data: F
      }
    }), () => c({
      type: Va.UnregisterDroppable,
      key: a,
      id: r
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r]
  ), I.useEffect(() => {
    n !== g.current.disabled && (c({
      type: Va.SetDroppableDisabled,
      id: r,
      key: a,
      disabled: n
    }), g.current.disabled = n);
  }, [r, a, n, c]), {
    active: s,
    rect: b,
    isOver: d?.id === r,
    node: P,
    over: d,
    setNodeRef: z
  };
}
function $k(t, e, n) {
  const r = t.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(e, 1)[0]), r;
}
function hze(t, e) {
  return t.reduce((n, r, i) => {
    const a = e.get(r);
    return a && (n[i] = a), n;
  }, Array(t.length));
}
function XC(t) {
  return t !== null && t >= 0;
}
function pze(t, e) {
  if (t === e)
    return !0;
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function mze(t) {
  return typeof t == "boolean" ? {
    draggable: t,
    droppable: t
  } : t;
}
const gee = (t) => {
  let {
    rects: e,
    activeIndex: n,
    overIndex: r,
    index: i
  } = t;
  const a = $k(e, r, n), s = e[i], c = a[i];
  return !c || !s ? null : {
    x: c.left - s.left,
    y: c.top - s.top,
    scaleX: c.width / s.width,
    scaleY: c.height / s.height
  };
}, WC = {
  scaleX: 1,
  scaleY: 1
}, gze = (t) => {
  var e;
  let {
    activeIndex: n,
    activeNodeRect: r,
    index: i,
    rects: a,
    overIndex: s
  } = t;
  const c = (e = a[n]) != null ? e : r;
  if (!c)
    return null;
  if (i === n) {
    const f = a[s];
    return f ? {
      x: 0,
      y: n < s ? f.top + f.height - (c.top + c.height) : f.top - c.top,
      ...WC
    } : null;
  }
  const d = vze(a, i, n);
  return i > n && i <= s ? {
    x: 0,
    y: -c.height - d,
    ...WC
  } : i < n && i >= s ? {
    x: 0,
    y: c.height + d,
    ...WC
  } : {
    x: 0,
    y: 0,
    ...WC
  };
};
function vze(t, e, n) {
  const r = t[e], i = t[e - 1], a = t[e + 1];
  return r ? n < e ? i ? r.top - (i.top + i.height) : a ? a.top - (r.top + r.height) : 0 : a ? a.top - (r.top + r.height) : i ? r.top - (i.top + i.height) : 0 : 0;
}
const vee = "Sortable", yee = /* @__PURE__ */ De.createContext({
  activeIndex: -1,
  containerId: vee,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: gee,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function yze(t) {
  let {
    children: e,
    id: n,
    items: r,
    strategy: i = gee,
    disabled: a = !1
  } = t;
  const {
    active: s,
    dragOverlay: c,
    droppableRects: d,
    over: f,
    measureDroppableContainers: g
  } = cze(), m = Y_(vee, n), b = c.rect !== null, w = I.useMemo(() => r.map((z) => typeof z == "object" && "id" in z ? z.id : z), [r]), _ = s != null, A = s ? w.indexOf(s.id) : -1, T = f ? w.indexOf(f.id) : -1, O = I.useRef(w), R = !pze(w, O.current), N = T !== -1 && A === -1 || R, M = mze(a);
  of(() => {
    R && _ && g(w);
  }, [R, w, _, g]), I.useEffect(() => {
    O.current = w;
  }, [w]);
  const P = I.useMemo(
    () => ({
      activeIndex: A,
      containerId: m,
      disabled: M,
      disableTransforms: N,
      items: w,
      overIndex: T,
      useDragOverlay: b,
      sortedRects: hze(w, d),
      strategy: i
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [A, m, M.draggable, M.droppable, N, w, T, d, b, i]
  );
  return De.createElement(yee.Provider, {
    value: P
  }, e);
}
const bze = (t) => {
  let {
    id: e,
    items: n,
    activeIndex: r,
    overIndex: i
  } = t;
  return $k(n, r, i).indexOf(e);
}, wze = (t) => {
  let {
    containerId: e,
    isSorting: n,
    wasDragging: r,
    index: i,
    items: a,
    newIndex: s,
    previousItems: c,
    previousContainerId: d,
    transition: f
  } = t;
  return !f || !r || c !== a && i === s ? !1 : n ? !0 : s !== i && e === d;
}, xze = {
  duration: 200,
  easing: "ease"
}, bee = "transform", Sze = /* @__PURE__ */ p_.Transition.toString({
  property: bee,
  duration: 0,
  easing: "linear"
}), Eze = {
  roleDescription: "sortable"
};
function _ze(t) {
  let {
    disabled: e,
    index: n,
    node: r,
    rect: i
  } = t;
  const [a, s] = I.useState(null), c = I.useRef(n);
  return of(() => {
    if (!e && n !== c.current && r.current) {
      const d = i.current;
      if (d) {
        const f = Ow(r.current, {
          ignoreTransform: !0
        }), g = {
          x: d.left - f.left,
          y: d.top - f.top,
          scaleX: d.width / f.width,
          scaleY: d.height / f.height
        };
        (g.x || g.y) && s(g);
      }
    }
    n !== c.current && (c.current = n);
  }, [e, n, r, i]), I.useEffect(() => {
    a && s(null);
  }, [a]), a;
}
function Aze(t) {
  let {
    animateLayoutChanges: e = wze,
    attributes: n,
    disabled: r,
    data: i,
    getNewIndex: a = bze,
    id: s,
    strategy: c,
    resizeObserverConfig: d,
    transition: f = xze
  } = t;
  const {
    items: g,
    containerId: m,
    activeIndex: b,
    disabled: w,
    disableTransforms: _,
    sortedRects: A,
    overIndex: T,
    useDragOverlay: O,
    strategy: R
  } = I.useContext(yee), N = Cze(r, w), M = g.indexOf(s), P = I.useMemo(() => ({
    sortable: {
      containerId: m,
      index: M,
      items: g
    },
    ...i
  }), [m, i, M, g]), z = I.useMemo(() => g.slice(g.indexOf(s)), [g, s]), {
    rect: F,
    node: $,
    isOver: G,
    setNodeRef: H
  } = fze({
    id: s,
    data: P,
    disabled: N.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: z,
      ...d
    }
  }), {
    active: Z,
    activatorEvent: V,
    activeNodeRect: Y,
    attributes: ee,
    setNodeRef: K,
    listeners: U,
    isDragging: q,
    over: W,
    setActivatorNodeRef: ie,
    transform: J
  } = lze({
    id: s,
    data: P,
    attributes: {
      ...Eze,
      ...n
    },
    disabled: N.draggable
  }), B = FLe(H, K), te = !!Z, ae = te && !_ && XC(b) && XC(T), le = !O && q, de = le && ae ? J : null, ue = ae ? de ?? (c ?? R)({
    rects: A,
    activeNodeRect: Y,
    activeIndex: b,
    overIndex: T,
    index: M
  }) : null, Se = XC(b) && XC(T) ? a({
    id: s,
    items: g,
    activeIndex: b,
    overIndex: T
  }) : M, Ne = Z?.id, Me = I.useRef({
    activeId: Ne,
    items: g,
    newIndex: Se,
    containerId: m
  }), Ce = g !== Me.current.items, Ue = e({
    active: Z,
    containerId: m,
    isDragging: q,
    isSorting: te,
    id: s,
    index: M,
    items: g,
    newIndex: Me.current.newIndex,
    previousItems: Me.current.items,
    previousContainerId: Me.current.containerId,
    transition: f,
    wasDragging: Me.current.activeId != null
  }), rt = _ze({
    disabled: !Ue,
    index: M,
    node: $,
    rect: F
  });
  return I.useEffect(() => {
    te && Me.current.newIndex !== Se && (Me.current.newIndex = Se), m !== Me.current.containerId && (Me.current.containerId = m), g !== Me.current.items && (Me.current.items = g);
  }, [te, Se, m, g]), I.useEffect(() => {
    if (Ne === Me.current.activeId)
      return;
    if (Ne && !Me.current.activeId) {
      Me.current.activeId = Ne;
      return;
    }
    const Ft = setTimeout(() => {
      Me.current.activeId = Ne;
    }, 50);
    return () => clearTimeout(Ft);
  }, [Ne]), {
    active: Z,
    activeIndex: b,
    attributes: ee,
    data: P,
    rect: F,
    index: M,
    newIndex: Se,
    items: g,
    isOver: G,
    isSorting: te,
    isDragging: q,
    listeners: U,
    node: $,
    overIndex: T,
    over: W,
    setNodeRef: B,
    setActivatorNodeRef: ie,
    setDroppableNodeRef: H,
    setDraggableNodeRef: K,
    transform: rt ?? ue,
    transition: it()
  };
  function it() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      rt || // Or to prevent items jumping to back to their "new" position when items change
      Ce && Me.current.newIndex === M
    )
      return Sze;
    if (!(le && !Bk(V) || !f) && (te || Ue))
      return p_.Transition.toString({
        ...f,
        property: bee
      });
  }
}
function Cze(t, e) {
  var n, r;
  return typeof t == "boolean" ? {
    draggable: t,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = t?.draggable) != null ? n : e.draggable,
    droppable: (r = t?.droppable) != null ? r : e.droppable
  };
}
xr.Down, xr.Right, xr.Up, xr.Left;
const wee = Re.div`
  twd-rounded-sm
  twd-bg-white
  twd-shadow-[0_2px_8px_0_rgb(0_0_0_/_10%),_0_3px_20px_0_rgb(0_0_0_/_9%)]
`, Tze = Re(wee)`
  twd-overflow-hidden
  twd-p-0
`, Oze = Re(fhe)`
  twd-flex
  twd-min-h-20
  twd-w-full
  twd-justify-between
  twd-gap-2
  twd-rounded-sm
  twd-p-2
  twd-text-secondary-contrast
  twd-no-underline
  hover:twd-bg-secondary-light3
  md:twd-p-4
  active:[&:not(:focus-within)]:twd-bg-secondary-light
  ${({
  $isEditable: t
}) => t ? "twd-cursor-default" : "twd-cursor-pointer"}
`, Rze = Re.div`
  twd-flex
  twd-min-h-20
  twd-cursor-move
  twd-justify-between
  twd-gap-2
  twd-rounded-sm
  twd-p-2
  twd-text-secondary-contrast
  md:twd-p-4
`, Dze = Re.div`
  twd-flex
  twd-flex-col
  twd-justify-center
  twd-gap-1
`, Nze = Re.div`
  twd-hyphens-auto
  twd-break-words
`, Mze = Re.h2`
  twd-mb-1
  twd-inline
  twd-hyphens-auto
  twd-break-words
  twd-text-xl
  twd-font-bold
  twd-text-primary
`, Ize = Re.div`
  twd-flex
  twd-items-center
  twd-gap-2
`, kze = Re.div`
  twd-flex
  twd-flex-wrap
  twd-items-center
  twd-justify-end
  twd-gap-2
`, jze = Re(IY)`
  twd-mb-[5px]
  twd-inline-block
  twd-align-text-bottom
  twd-text-primary
`, Pze = (t) => {
  const e = ve.c(28), {
    device: n,
    isEditable: r,
    renderRemoveButton: i
  } = t, a = r === void 0 ? !1 : r;
  let s;
  e[0] !== n.id || e[1] !== i ? (s = i ? i(n.id) : null, e[0] = n.id, e[1] = i, e[2] = s) : s = e[2];
  const c = s;
  let d;
  e[3] === Symbol.for("react.memo_cache_sentinel") ? (d = /* @__PURE__ */ C.jsx(jze, { size: "md" }), e[3] = d) : d = e[3];
  let f;
  e[4] !== n.name ? (f = /* @__PURE__ */ C.jsx(Nze, { children: /* @__PURE__ */ C.jsxs(Mze, { children: [
    d,
    " ",
    n.name
  ] }) }), e[4] = n.name, e[5] = f) : f = e[5];
  let g;
  e[6] !== n.model ? (g = /* @__PURE__ */ C.jsx(PNe, { model: n.model }), e[6] = n.model, e[7] = g) : g = e[7];
  let m;
  e[8] !== n ? (m = /* @__PURE__ */ C.jsx(INe, { device: n }), e[8] = n, e[9] = m) : m = e[9];
  let b;
  e[10] !== g || e[11] !== m ? (b = /* @__PURE__ */ C.jsxs(Ize, { children: [
    g,
    m
  ] }), e[10] = g, e[11] = m, e[12] = b) : b = e[12];
  let w;
  e[13] !== f || e[14] !== b ? (w = /* @__PURE__ */ C.jsxs(Dze, { children: [
    f,
    b
  ] }), e[13] = f, e[14] = b, e[15] = w) : w = e[15];
  let _;
  e[16] !== n ? (_ = /* @__PURE__ */ C.jsx(RNe, { device: n }), e[16] = n, e[17] = _) : _ = e[17];
  const A = a ? c : null;
  let T;
  e[18] !== A || e[19] !== _ ? (T = /* @__PURE__ */ C.jsxs(kze, { children: [
    _,
    A
  ] }), e[18] = A, e[19] = _, e[20] = T) : T = e[20];
  let O;
  e[21] !== T || e[22] !== w ? (O = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    w,
    T
  ] }), e[21] = T, e[22] = w, e[23] = O) : O = e[23];
  const R = O;
  let N;
  return e[24] !== R || e[25] !== n.id || e[26] !== a ? (N = /* @__PURE__ */ C.jsx(Tze, { children: a ? /* @__PURE__ */ C.jsx(Rze, { "data-test-id": "device-card", children: R }) : /* @__PURE__ */ C.jsx(Oze, { to: `/devices/${n.id}`, $isEditable: a, "data-test-id": "device-card", children: R }) }), e[24] = R, e[25] = n.id, e[26] = a, e[27] = N) : N = e[27], N;
}, MD = vr("DeviceList"), Lze = Re.div`
  twd-flex
  twd-flex-col
  twd-gap-2
`, Bze = Re.div`
  twd-w-full
`, zze = (t) => {
  const e = ve.c(22), {
    device: n,
    isEditable: r,
    renderRemoveButton: i
  } = t, a = !r;
  let s;
  e[0] !== n.id || e[1] !== a ? (s = {
    id: n.id,
    disabled: a
  }, e[0] = n.id, e[1] = a, e[2] = s) : s = e[2];
  const {
    attributes: c,
    listeners: d,
    setNodeRef: f,
    transform: g,
    transition: m,
    isDragging: b
  } = Aze(s);
  let w;
  e[3] !== g ? (w = p_.Transform.toString(g), e[3] = g, e[4] = w) : w = e[4];
  const _ = b ? 0.6 : 1;
  let A;
  e[5] !== w || e[6] !== _ || e[7] !== m ? (A = {
    transform: w,
    transition: m,
    opacity: _
  }, e[5] = w, e[6] = _, e[7] = m, e[8] = A) : A = e[8];
  const T = A;
  let O;
  e[9] !== c || e[10] !== r || e[11] !== d ? (O = r ? {
    ...c,
    ...d
  } : {}, e[9] = c, e[10] = r, e[11] = d, e[12] = O) : O = e[12];
  let R;
  e[13] !== n || e[14] !== r || e[15] !== i ? (R = /* @__PURE__ */ C.jsx(Pze, { device: n, isEditable: r, renderRemoveButton: i }), e[13] = n, e[14] = r, e[15] = i, e[16] = R) : R = e[16];
  let N;
  return e[17] !== f || e[18] !== T || e[19] !== O || e[20] !== R ? (N = /* @__PURE__ */ C.jsx(Bze, { ref: f, style: T, ...O, children: R }), e[17] = f, e[18] = T, e[19] = O, e[20] = R, e[21] = N) : N = e[21], N;
}, Fze = (t) => {
  const e = ve.c(23), {
    devices: n,
    isEditable: r,
    onDragStart: i,
    onDragEnd: a,
    renderRemoveButton: s
  } = t;
  let c;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (c = {
    activationConstraint: {
      distance: 5
    }
  }, e[0] = c) : c = e[0];
  const d = tBe(eBe(Uk, c));
  let f;
  e[1] !== n || e[2] !== a ? (f = (O) => {
    const {
      active: R,
      over: N
    } = O;
    if (!N || R.id === N.id) {
      MD.debug("Drag ended without reorder"), a(n);
      return;
    }
    const M = n.findIndex((F) => F.id === R.id), P = n.findIndex((F) => F.id === N.id);
    if (M === -1 || P === -1) {
      MD.warn("Drag indices not found", {
        activeId: R.id,
        overId: N.id
      }), a(n);
      return;
    }
    const z = $k(n, M, P);
    MD.info("Devices reordered", {
      oldIndex: M,
      newIndex: P
    }), a(z);
  }, e[1] = n, e[2] = a, e[3] = f) : f = e[3];
  const g = f;
  let m;
  e[4] !== n ? (m = n.map(Vze), e[4] = n, e[5] = m) : m = e[5];
  const b = m;
  let w;
  if (e[6] !== n || e[7] !== r || e[8] !== s) {
    let O;
    e[10] !== r || e[11] !== s ? (O = (R) => /* @__PURE__ */ C.jsx(zze, { device: R, isEditable: r, renderRemoveButton: s }, R.id), e[10] = r, e[11] = s, e[12] = O) : O = e[12], w = n.map(O), e[6] = n, e[7] = r, e[8] = s, e[9] = w;
  } else
    w = e[9];
  let _;
  e[13] !== w ? (_ = /* @__PURE__ */ C.jsx(Lze, { children: w }), e[13] = w, e[14] = _) : _ = e[14];
  let A;
  e[15] !== b || e[16] !== _ ? (A = /* @__PURE__ */ C.jsx(yze, { items: b, strategy: gze, children: _ }), e[15] = b, e[16] = _, e[17] = A) : A = e[17];
  let T;
  return e[18] !== g || e[19] !== i || e[20] !== d || e[21] !== A ? (T = /* @__PURE__ */ C.jsx(aze, { sensors: d, collisionDetection: oBe, onDragStart: i, onDragEnd: g, children: A }), e[18] = g, e[19] = i, e[20] = d, e[21] = A, e[22] = T) : T = e[22], T;
};
function Vze(t) {
  return t.id;
}
const Uze = "data:image/png;base64,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", $ze = vr("EmptyState"), Hze = Re.div`
  twd-flex
  twd-w-full
  twd-flex-col
  twd-items-center
  twd-justify-center
  twd-text-center
  twd-text-secondary
`, qze = Re.img`
  twd-h-[58.8px]
  twd-w-[96px]
  twd-opacity-50
`, Gze = Re.div`
  twd-mt-4
  twd-max-w-xl
  twd-text-sm
  twd-text-secondary-contrast
`, Yze = (t) => {
  const e = ve.c(6), {
    isEditMode: n
  } = t;
  let r;
  e[0] !== n ? (r = () => {
    $ze.debug("Empty state mounted", {
      isEditMode: n
    });
  }, e[0] = n, e[1] = r) : r = e[1], XI(r);
  let i, a;
  e[2] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ C.jsx(qze, { src: Uze, alt: "No devices" }), a = /* @__PURE__ */ C.jsx("div", { className: "twd-mt-2 twd-text-base twd-text-secondary-contrast", children: "No devices" }), e[2] = i, e[3] = a) : (i = e[2], a = e[3]);
  let s;
  return e[4] !== n ? (s = /* @__PURE__ */ C.jsxs(Hze, { "data-test-id": "message-no-devices", children: [
    i,
    a,
    /* @__PURE__ */ C.jsx(Gze, { children: n ? /* @__PURE__ */ C.jsxs("div", { children: [
      "To add your device - ",
      /* @__PURE__ */ C.jsx("b", { children: "find serial and key at the bottom" }),
      " of your Alltesta or Cromite. Enter both below.",
      /* @__PURE__ */ C.jsx("br", {}),
      /* @__PURE__ */ C.jsx("br", {}),
      "If you don't have ",
      /* @__PURE__ */ C.jsx("a", { href: "/hardware", children: "Alltesta - order it here." })
    ] }) : /* @__PURE__ */ C.jsxs("div", { children: [
      "Device is a ",
      /* @__PURE__ */ C.jsx("b", { children: "Alltesta" }),
      " or ",
      /* @__PURE__ */ C.jsx("b", { children: "Cromite" }),
      ".",
      /* @__PURE__ */ C.jsx("br", {}),
      "To add your device click the button above.",
      /* @__PURE__ */ C.jsx("br", {}),
      /* @__PURE__ */ C.jsx("br", {}),
      /* @__PURE__ */ C.jsxs("a", { href: "/hardware", children: [
        /* @__PURE__ */ C.jsx("b", { children: "To order" }),
        " equipment compatible with HPLC.Cloud go here."
      ] })
    ] }) })
  ] }), e[4] = n, e[5] = s) : s = e[5], s;
}, Xze = Re.div`
  twd-flex
  twd-flex-col
  twd-gap-4
`, Wze = Re.div`
  twd-flex
  twd-items-center
  twd-justify-center
  twd-py-8
`, Qze = (t) => {
  const e = ve.c(16), {
    renderAddDevice: n
  } = t, {
    devices: r,
    isLoading: i,
    error: a,
    startDrag: s,
    finishDrag: c
  } = JJ(), d = ew(Zze), f = ew(Kze), g = Jze, m = (r?.length ?? 0) > 0, b = a instanceof Error ? a.message : a;
  if (r == null) {
    if (a != null) {
      let T;
      return e[0] !== b ? (T = /* @__PURE__ */ C.jsxs(ZE, { variant: "error", children: [
        "Failed to load devices: ",
        b
      ] }), e[0] = b, e[1] = T) : T = e[1], T;
    }
    if (i) {
      let T;
      return e[2] === Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ C.jsx(Wze, { children: /* @__PURE__ */ C.jsx(O_, { size: "md" }) }), e[2] = T) : T = e[2], T;
    }
  }
  let w;
  e[3] !== f || e[4] !== m || e[5] !== d || e[6] !== n ? (w = d && n?.({
    hasDevices: m,
    onAdded: f
  }), e[3] = f, e[4] = m, e[5] = d, e[6] = n, e[7] = w) : w = e[7];
  let _;
  e[8] !== r || e[9] !== c || e[10] !== d || e[11] !== s ? (_ = r && r.length > 0 ? /* @__PURE__ */ C.jsx(Fze, { devices: r, isEditable: d, onDragStart: s, onDragEnd: c, renderRemoveButton: g }) : /* @__PURE__ */ C.jsx(Yze, { isEditMode: d }), e[8] = r, e[9] = c, e[10] = d, e[11] = s, e[12] = _) : _ = e[12];
  let A;
  return e[13] !== w || e[14] !== _ ? (A = /* @__PURE__ */ C.jsxs(Xze, { children: [
    w,
    _
  ] }), e[13] = w, e[14] = _, e[15] = A) : A = e[15], A;
};
function Zze(t) {
  return t.isEditMode;
}
function Kze(t) {
  return t.disableEditMode;
}
function Jze(t) {
  return /* @__PURE__ */ C.jsx(ILe, { deviceId: t });
}
const eFe = /^[0-9a-zA-Z]{4}-?[0-9a-zA-Z]{4}$/, tFe = /^[0-9a-zA-Z]{2}$/, nFe = Xe({
  serial: Je().min(1, "Serial is required").regex(eFe, "Serial must be in XXXX-XXXX format"),
  key: Je().min(1, "Key is required").regex(tFe, "Key must be 2 characters")
}), rFe = Xe({
  serial: Je(),
  key: Je(),
  force: Sr().optional()
}), iFe = Xe({
  statusCode: Ve()
}), aFe = vr("apiAddDevice"), oFe = async (t) => {
  const e = qt(rFe, t);
  aFe.info("Adding device", {
    serial: e.serial,
    force: e.force
  });
  const n = await Ya.ky.put(`my/hardware/${e.serial}/`, {
    json: {
      key: e.key
    },
    searchParams: e.force ? {
      force: "true"
    } : void 0
  });
  return qt(iFe, {
    statusCode: n.status
  });
}, sFe = vr("useAddDevice"), lFe = "AddDevice", cFe = () => {
  const t = ve.c(3), e = Ju();
  let n;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = [lFe], t[0] = n) : n = t[0];
  let r;
  return t[1] !== e ? (r = {
    mutationKey: n,
    mutationFn: uFe,
    onSuccess: async () => {
      await e.invalidateQueries({
        queryKey: J7
      });
    }
  }, t[1] = e, t[2] = r) : r = t[2], Ei(r);
};
async function uFe(t) {
  const {
    serial: e,
    key: n,
    force: r
  } = t;
  return sFe.info("Requesting device add", {
    serial: e,
    force: r
  }), oFe({
    serial: e,
    key: n,
    force: r
  });
}
const dFe = Xe({
  organizationName: Je()
});
function fFe(t, e) {
  var n = Object.setPrototypeOf;
  n ? n(t, e) : t.__proto__ = e;
}
function hFe(t, e) {
  e === void 0 && (e = t.constructor);
  var n = Error.captureStackTrace;
  n && n(t, e);
}
var pFe = function() {
  var t = function(n, r) {
    return t = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function(i, a) {
      i.__proto__ = a;
    } || function(i, a) {
      for (var s in a)
        Object.prototype.hasOwnProperty.call(a, s) && (i[s] = a[s]);
    }, t(n, r);
  };
  return function(e, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), mFe = function(t) {
  pFe(e, t);
  function e(n, r) {
    var i = this.constructor, a = t.call(this, n, r) || this;
    return Object.defineProperty(a, "name", {
      value: i.name,
      enumerable: !1,
      configurable: !0
    }), fFe(a, i.prototype), hFe(a), a;
  }
  return e;
}(Error), gFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), hl = (
  /** @class */
  function(t) {
    gFe(e, t);
    function e(n) {
      n === void 0 && (n = void 0);
      var r = t.call(this, n) || this;
      return r.message = n, r;
    }
    return e.prototype.getKind = function() {
      var n = this.constructor;
      return n.kind;
    }, e.kind = "Exception", e;
  }(mFe)
), vFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ju = (
  /** @class */
  function(t) {
    vFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.kind = "ArgumentException", e;
  }(hl)
), yFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Yt = (
  /** @class */
  function(t) {
    yFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.kind = "IllegalArgumentException", e;
  }(hl)
), bFe = (
  /** @class */
  function() {
    function t(e) {
      if (this.binarizer = e, e === null)
        throw new Yt("Binarizer must be non-null.");
    }
    return t.prototype.getWidth = function() {
      return this.binarizer.getWidth();
    }, t.prototype.getHeight = function() {
      return this.binarizer.getHeight();
    }, t.prototype.getBlackRow = function(e, n) {
      return this.binarizer.getBlackRow(e, n);
    }, t.prototype.getBlackMatrix = function() {
      return (this.matrix === null || this.matrix === void 0) && (this.matrix = this.binarizer.getBlackMatrix()), this.matrix;
    }, t.prototype.isCropSupported = function() {
      return this.binarizer.getLuminanceSource().isCropSupported();
    }, t.prototype.crop = function(e, n, r, i) {
      var a = this.binarizer.getLuminanceSource().crop(e, n, r, i);
      return new t(this.binarizer.createBinarizer(a));
    }, t.prototype.isRotateSupported = function() {
      return this.binarizer.getLuminanceSource().isRotateSupported();
    }, t.prototype.rotateCounterClockwise = function() {
      var e = this.binarizer.getLuminanceSource().rotateCounterClockwise();
      return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.rotateCounterClockwise45 = function() {
      var e = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
      return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.toString = function() {
      try {
        return this.getBlackMatrix().toString();
      } catch {
        return "";
      }
    }, t;
  }()
), wFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), uo = (
  /** @class */
  function(t) {
    wFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.getChecksumInstance = function() {
      return new e();
    }, e.kind = "ChecksumException", e;
  }(hl)
), xFe = (
  /** @class */
  function() {
    function t(e) {
      this.source = e;
    }
    return t.prototype.getLuminanceSource = function() {
      return this.source;
    }, t.prototype.getWidth = function() {
      return this.source.getWidth();
    }, t.prototype.getHeight = function() {
      return this.source.getHeight();
    }, t;
  }()
), si = (
  /** @class */
  function() {
    function t() {
    }
    return t.arraycopy = function(e, n, r, i, a) {
      for (; a--; )
        r[i++] = e[n++];
    }, t.currentTimeMillis = function() {
      return Date.now();
    }, t;
  }()
), SFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Hk = (
  /** @class */
  function(t) {
    SFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.kind = "IndexOutOfBoundsException", e;
  }(hl)
), EFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), PU = (
  /** @class */
  function(t) {
    EFe(e, t);
    function e(n, r) {
      n === void 0 && (n = void 0), r === void 0 && (r = void 0);
      var i = t.call(this, r) || this;
      return i.index = n, i.message = r, i;
    }
    return e.kind = "ArrayIndexOutOfBoundsException", e;
  }(Hk)
), _Fe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, qa = (
  /** @class */
  function() {
    function t() {
    }
    return t.fill = function(e, n) {
      for (var r = 0, i = e.length; r < i; r++)
        e[r] = n;
    }, t.fillWithin = function(e, n, r, i) {
      t.rangeCheck(e.length, n, r);
      for (var a = n; a < r; a++)
        e[a] = i;
    }, t.rangeCheck = function(e, n, r) {
      if (n > r)
        throw new Yt("fromIndex(" + n + ") > toIndex(" + r + ")");
      if (n < 0)
        throw new PU(n);
      if (r > e)
        throw new PU(r);
    }, t.asList = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      return e;
    }, t.create = function(e, n, r) {
      var i = Array.from({ length: e });
      return i.map(function(a) {
        return Array.from({ length: n }).fill(r);
      });
    }, t.createInt32Array = function(e, n, r) {
      var i = Array.from({ length: e });
      return i.map(function(a) {
        return Int32Array.from({ length: n }).fill(r);
      });
    }, t.equals = function(e, n) {
      if (!e || !n || !e.length || !n.length || e.length !== n.length)
        return !1;
      for (var r = 0, i = e.length; r < i; r++)
        if (e[r] !== n[r])
          return !1;
      return !0;
    }, t.hashCode = function(e) {
      var n, r;
      if (e === null)
        return 0;
      var i = 1;
      try {
        for (var a = _Fe(e), s = a.next(); !s.done; s = a.next()) {
          var c = s.value;
          i = 31 * i + c;
        }
      } catch (d) {
        n = { error: d };
      } finally {
        try {
          s && !s.done && (r = a.return) && r.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return i;
    }, t.fillUint8Array = function(e, n) {
      for (var r = 0; r !== e.length; r++)
        e[r] = n;
    }, t.copyOf = function(e, n) {
      return e.slice(0, n);
    }, t.copyOfUint8Array = function(e, n) {
      if (e.length <= n) {
        var r = new Uint8Array(n);
        return r.set(e), r;
      }
      return e.slice(0, n);
    }, t.copyOfRange = function(e, n, r) {
      var i = r - n, a = new Int32Array(i);
      return si.arraycopy(e, n, a, 0, i), a;
    }, t.binarySearch = function(e, n, r) {
      r === void 0 && (r = t.numberComparator);
      for (var i = 0, a = e.length - 1; i <= a; ) {
        var s = a + i >> 1, c = r(n, e[s]);
        if (c > 0)
          i = s + 1;
        else if (c < 0)
          a = s - 1;
        else
          return s;
      }
      return -i - 1;
    }, t.numberComparator = function(e, n) {
      return e - n;
    }, t;
  }()
), Vn = (
  /** @class */
  function() {
    function t() {
    }
    return t.numberOfTrailingZeros = function(e) {
      var n;
      if (e === 0)
        return 32;
      var r = 31;
      return n = e << 16, n !== 0 && (r -= 16, e = n), n = e << 8, n !== 0 && (r -= 8, e = n), n = e << 4, n !== 0 && (r -= 4, e = n), n = e << 2, n !== 0 && (r -= 2, e = n), r - (e << 1 >>> 31);
    }, t.numberOfLeadingZeros = function(e) {
      if (e === 0)
        return 32;
      var n = 1;
      return e >>> 16 || (n += 16, e <<= 16), e >>> 24 || (n += 8, e <<= 8), e >>> 28 || (n += 4, e <<= 4), e >>> 30 || (n += 2, e <<= 2), n -= e >>> 31, n;
    }, t.toHexString = function(e) {
      return e.toString(16);
    }, t.toBinaryString = function(e) {
      return String(parseInt(String(e), 2));
    }, t.bitCount = function(e) {
      return e = e - (e >>> 1 & 1431655765), e = (e & 858993459) + (e >>> 2 & 858993459), e = e + (e >>> 4) & 252645135, e = e + (e >>> 8), e = e + (e >>> 16), e & 63;
    }, t.truncDivision = function(e, n) {
      return Math.trunc(e / n);
    }, t.parseInt = function(e, n) {
      return n === void 0 && (n = void 0), parseInt(e, n);
    }, t.MIN_VALUE_32_BITS = -2147483648, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
  }()
), fo = (
  /** @class */
  function() {
    function t(e, n) {
      e === void 0 ? (this.size = 0, this.bits = new Int32Array(1)) : (this.size = e, n == null ? this.bits = t.makeArray(e) : this.bits = n);
    }
    return t.prototype.getSize = function() {
      return this.size;
    }, t.prototype.getSizeInBytes = function() {
      return Math.floor((this.size + 7) / 8);
    }, t.prototype.ensureCapacity = function(e) {
      if (e > this.bits.length * 32) {
        var n = t.makeArray(e);
        si.arraycopy(this.bits, 0, n, 0, this.bits.length), this.bits = n;
      }
    }, t.prototype.get = function(e) {
      return (this.bits[Math.floor(e / 32)] & 1 << (e & 31)) !== 0;
    }, t.prototype.set = function(e) {
      this.bits[Math.floor(e / 32)] |= 1 << (e & 31);
    }, t.prototype.flip = function(e) {
      this.bits[Math.floor(e / 32)] ^= 1 << (e & 31);
    }, t.prototype.getNextSet = function(e) {
      var n = this.size;
      if (e >= n)
        return n;
      var r = this.bits, i = Math.floor(e / 32), a = r[i];
      a &= ~((1 << (e & 31)) - 1);
      for (var s = r.length; a === 0; ) {
        if (++i === s)
          return n;
        a = r[i];
      }
      var c = i * 32 + Vn.numberOfTrailingZeros(a);
      return c > n ? n : c;
    }, t.prototype.getNextUnset = function(e) {
      var n = this.size;
      if (e >= n)
        return n;
      var r = this.bits, i = Math.floor(e / 32), a = ~r[i];
      a &= ~((1 << (e & 31)) - 1);
      for (var s = r.length; a === 0; ) {
        if (++i === s)
          return n;
        a = ~r[i];
      }
      var c = i * 32 + Vn.numberOfTrailingZeros(a);
      return c > n ? n : c;
    }, t.prototype.setBulk = function(e, n) {
      this.bits[Math.floor(e / 32)] = n;
    }, t.prototype.setRange = function(e, n) {
      if (n < e || e < 0 || n > this.size)
        throw new Yt();
      if (n !== e) {
        n--;
        for (var r = Math.floor(e / 32), i = Math.floor(n / 32), a = this.bits, s = r; s <= i; s++) {
          var c = s > r ? 0 : e & 31, d = s < i ? 31 : n & 31, f = (2 << d) - (1 << c);
          a[s] |= f;
        }
      }
    }, t.prototype.clear = function() {
      for (var e = this.bits.length, n = this.bits, r = 0; r < e; r++)
        n[r] = 0;
    }, t.prototype.isRange = function(e, n, r) {
      if (n < e || e < 0 || n > this.size)
        throw new Yt();
      if (n === e)
        return !0;
      n--;
      for (var i = Math.floor(e / 32), a = Math.floor(n / 32), s = this.bits, c = i; c <= a; c++) {
        var d = c > i ? 0 : e & 31, f = c < a ? 31 : n & 31, g = (2 << f) - (1 << d) & 4294967295;
        if ((s[c] & g) !== (r ? g : 0))
          return !1;
      }
      return !0;
    }, t.prototype.appendBit = function(e) {
      this.ensureCapacity(this.size + 1), e && (this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 31)), this.size++;
    }, t.prototype.appendBits = function(e, n) {
      if (n < 0 || n > 32)
        throw new Yt("Num bits must be between 0 and 32");
      this.ensureCapacity(this.size + n);
      for (var r = n; r > 0; r--)
        this.appendBit((e >> r - 1 & 1) === 1);
    }, t.prototype.appendBitArray = function(e) {
      var n = e.size;
      this.ensureCapacity(this.size + n);
      for (var r = 0; r < n; r++)
        this.appendBit(e.get(r));
    }, t.prototype.xor = function(e) {
      if (this.size !== e.size)
        throw new Yt("Sizes don't match");
      for (var n = this.bits, r = 0, i = n.length; r < i; r++)
        n[r] ^= e.bits[r];
    }, t.prototype.toBytes = function(e, n, r, i) {
      for (var a = 0; a < i; a++) {
        for (var s = 0, c = 0; c < 8; c++)
          this.get(e) && (s |= 1 << 7 - c), e++;
        n[r + a] = /*(byte)*/
        s;
      }
    }, t.prototype.getBitArray = function() {
      return this.bits;
    }, t.prototype.reverse = function() {
      for (var e = new Int32Array(this.bits.length), n = Math.floor((this.size - 1) / 32), r = n + 1, i = this.bits, a = 0; a < r; a++) {
        var s = i[a];
        s = s >> 1 & 1431655765 | (s & 1431655765) << 1, s = s >> 2 & 858993459 | (s & 858993459) << 2, s = s >> 4 & 252645135 | (s & 252645135) << 4, s = s >> 8 & 16711935 | (s & 16711935) << 8, s = s >> 16 & 65535 | (s & 65535) << 16, e[n - a] = /*(int)*/
        s;
      }
      if (this.size !== r * 32) {
        for (var c = r * 32 - this.size, d = e[0] >>> c, a = 1; a < r; a++) {
          var f = e[a];
          d |= f << 32 - c, e[a - 1] = d, d = f >>> c;
        }
        e[r - 1] = d;
      }
      this.bits = e;
    }, t.makeArray = function(e) {
      return new Int32Array(Math.floor((e + 31) / 32));
    }, t.prototype.equals = function(e) {
      if (!(e instanceof t))
        return !1;
      var n = e;
      return this.size === n.size && qa.equals(this.bits, n.bits);
    }, t.prototype.hashCode = function() {
      return 31 * this.size + qa.hashCode(this.bits);
    }, t.prototype.toString = function() {
      for (var e = "", n = 0, r = this.size; n < r; n++)
        n & 7 || (e += " "), e += this.get(n) ? "X" : ".";
      return e;
    }, t.prototype.clone = function() {
      return new t(this.size, this.bits.slice());
    }, t.prototype.toArray = function() {
      for (var e = [], n = 0, r = this.size; n < r; n++)
        e.push(this.get(n));
      return e;
    }, t;
  }()
), tM;
(function(t) {
  t[t.OTHER = 0] = "OTHER", t[t.PURE_BARCODE = 1] = "PURE_BARCODE", t[t.POSSIBLE_FORMATS = 2] = "POSSIBLE_FORMATS", t[t.TRY_HARDER = 3] = "TRY_HARDER", t[t.CHARACTER_SET = 4] = "CHARACTER_SET", t[t.ALLOWED_LENGTHS = 5] = "ALLOWED_LENGTHS", t[t.ASSUME_CODE_39_CHECK_DIGIT = 6] = "ASSUME_CODE_39_CHECK_DIGIT", t[t.ASSUME_GS1 = 7] = "ASSUME_GS1", t[t.RETURN_CODABAR_START_END = 8] = "RETURN_CODABAR_START_END", t[t.NEED_RESULT_POINT_CALLBACK = 9] = "NEED_RESULT_POINT_CALLBACK", t[t.ALLOWED_EAN_EXTENSIONS = 10] = "ALLOWED_EAN_EXTENSIONS";
})(tM || (tM = {}));
const Ui = tM;
var AFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ht = (
  /** @class */
  function(t) {
    AFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.getFormatInstance = function() {
      return new e();
    }, e.kind = "FormatException", e;
  }(hl)
), CFe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Pr;
(function(t) {
  t[t.Cp437 = 0] = "Cp437", t[t.ISO8859_1 = 1] = "ISO8859_1", t[t.ISO8859_2 = 2] = "ISO8859_2", t[t.ISO8859_3 = 3] = "ISO8859_3", t[t.ISO8859_4 = 4] = "ISO8859_4", t[t.ISO8859_5 = 5] = "ISO8859_5", t[t.ISO8859_6 = 6] = "ISO8859_6", t[t.ISO8859_7 = 7] = "ISO8859_7", t[t.ISO8859_8 = 8] = "ISO8859_8", t[t.ISO8859_9 = 9] = "ISO8859_9", t[t.ISO8859_10 = 10] = "ISO8859_10", t[t.ISO8859_11 = 11] = "ISO8859_11", t[t.ISO8859_13 = 12] = "ISO8859_13", t[t.ISO8859_14 = 13] = "ISO8859_14", t[t.ISO8859_15 = 14] = "ISO8859_15", t[t.ISO8859_16 = 15] = "ISO8859_16", t[t.SJIS = 16] = "SJIS", t[t.Cp1250 = 17] = "Cp1250", t[t.Cp1251 = 18] = "Cp1251", t[t.Cp1252 = 19] = "Cp1252", t[t.Cp1256 = 20] = "Cp1256", t[t.UnicodeBigUnmarked = 21] = "UnicodeBigUnmarked", t[t.UTF8 = 22] = "UTF8", t[t.ASCII = 23] = "ASCII", t[t.Big5 = 24] = "Big5", t[t.GB18030 = 25] = "GB18030", t[t.EUC_KR = 26] = "EUC_KR";
})(Pr || (Pr = {}));
var Ha = (
  /** @class */
  function() {
    function t(e, n, r) {
      for (var i, a, s = [], c = 3; c < arguments.length; c++)
        s[c - 3] = arguments[c];
      this.valueIdentifier = e, this.name = r, typeof n == "number" ? this.values = Int32Array.from([n]) : this.values = n, this.otherEncodingNames = s, t.VALUE_IDENTIFIER_TO_ECI.set(e, this), t.NAME_TO_ECI.set(r, this);
      for (var d = this.values, f = 0, g = d.length; f !== g; f++) {
        var m = d[f];
        t.VALUES_TO_ECI.set(m, this);
      }
      try {
        for (var b = CFe(s), w = b.next(); !w.done; w = b.next()) {
          var _ = w.value;
          t.NAME_TO_ECI.set(_, this);
        }
      } catch (A) {
        i = { error: A };
      } finally {
        try {
          w && !w.done && (a = b.return) && a.call(b);
        } finally {
          if (i)
            throw i.error;
        }
      }
    }
    return t.prototype.getValueIdentifier = function() {
      return this.valueIdentifier;
    }, t.prototype.getName = function() {
      return this.name;
    }, t.prototype.getValue = function() {
      return this.values[0];
    }, t.getCharacterSetECIByValue = function(e) {
      if (e < 0 || e >= 900)
        throw new ht("incorect value");
      var n = t.VALUES_TO_ECI.get(e);
      if (n === void 0)
        throw new ht("incorect value");
      return n;
    }, t.getCharacterSetECIByName = function(e) {
      var n = t.NAME_TO_ECI.get(e);
      if (n === void 0)
        throw new ht("incorect value");
      return n;
    }, t.prototype.equals = function(e) {
      if (!(e instanceof t))
        return !1;
      var n = e;
      return this.getName() === n.getName();
    }, t.VALUE_IDENTIFIER_TO_ECI = /* @__PURE__ */ new Map(), t.VALUES_TO_ECI = /* @__PURE__ */ new Map(), t.NAME_TO_ECI = /* @__PURE__ */ new Map(), t.Cp437 = new t(Pr.Cp437, Int32Array.from([0, 2]), "Cp437"), t.ISO8859_1 = new t(Pr.ISO8859_1, Int32Array.from([1, 3]), "ISO-8859-1", "ISO88591", "ISO8859_1"), t.ISO8859_2 = new t(Pr.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2"), t.ISO8859_3 = new t(Pr.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3"), t.ISO8859_4 = new t(Pr.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4"), t.ISO8859_5 = new t(Pr.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5"), t.ISO8859_6 = new t(Pr.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6"), t.ISO8859_7 = new t(Pr.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7"), t.ISO8859_8 = new t(Pr.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8"), t.ISO8859_9 = new t(Pr.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9"), t.ISO8859_10 = new t(Pr.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10"), t.ISO8859_11 = new t(Pr.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11"), t.ISO8859_13 = new t(Pr.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13"), t.ISO8859_14 = new t(Pr.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14"), t.ISO8859_15 = new t(Pr.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15"), t.ISO8859_16 = new t(Pr.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16"), t.SJIS = new t(Pr.SJIS, 20, "SJIS", "Shift_JIS"), t.Cp1250 = new t(Pr.Cp1250, 21, "Cp1250", "windows-1250"), t.Cp1251 = new t(Pr.Cp1251, 22, "Cp1251", "windows-1251"), t.Cp1252 = new t(Pr.Cp1252, 23, "Cp1252", "windows-1252"), t.Cp1256 = new t(Pr.Cp1256, 24, "Cp1256", "windows-1256"), t.UnicodeBigUnmarked = new t(Pr.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig"), t.UTF8 = new t(Pr.UTF8, 26, "UTF8", "UTF-8"), t.ASCII = new t(Pr.ASCII, Int32Array.from([27, 170]), "ASCII", "US-ASCII"), t.Big5 = new t(Pr.Big5, 28, "Big5"), t.GB18030 = new t(Pr.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK"), t.EUC_KR = new t(Pr.EUC_KR, 30, "EUC_KR", "EUC-KR"), t;
  }()
), TFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), W4 = (
  /** @class */
  function(t) {
    TFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.kind = "UnsupportedOperationException", e;
  }(hl)
), Jc = (
  /** @class */
  function() {
    function t() {
    }
    return t.decode = function(e, n) {
      var r = this.encodingName(n);
      return this.customDecoder ? this.customDecoder(e, r) : typeof TextDecoder > "u" || this.shouldDecodeOnFallback(r) ? this.decodeFallback(e, r) : new TextDecoder(r).decode(e);
    }, t.shouldDecodeOnFallback = function(e) {
      return !t.isBrowser() && e === "ISO-8859-1";
    }, t.encode = function(e, n) {
      var r = this.encodingName(n);
      return this.customEncoder ? this.customEncoder(e, r) : typeof TextEncoder > "u" ? this.encodeFallback(e) : new TextEncoder().encode(e);
    }, t.isBrowser = function() {
      return typeof window < "u" && {}.toString.call(window) === "[object Window]";
    }, t.encodingName = function(e) {
      return typeof e == "string" ? e : e.getName();
    }, t.encodingCharacterSet = function(e) {
      return e instanceof Ha ? e : Ha.getCharacterSetECIByName(e);
    }, t.decodeFallback = function(e, n) {
      var r = this.encodingCharacterSet(n);
      if (t.isDecodeFallbackSupported(r)) {
        for (var i = "", a = 0, s = e.length; a < s; a++) {
          var c = e[a].toString(16);
          c.length < 2 && (c = "0" + c), i += "%" + c;
        }
        return decodeURIComponent(i);
      }
      if (r.equals(Ha.UnicodeBigUnmarked))
        return String.fromCharCode.apply(null, new Uint16Array(e.buffer));
      throw new W4("Encoding " + this.encodingName(n) + " not supported by fallback.");
    }, t.isDecodeFallbackSupported = function(e) {
      return e.equals(Ha.UTF8) || e.equals(Ha.ISO8859_1) || e.equals(Ha.ASCII);
    }, t.encodeFallback = function(e) {
      for (var n = btoa(unescape(encodeURIComponent(e))), r = n.split(""), i = [], a = 0; a < r.length; a++)
        i.push(r[a].charCodeAt(0));
      return new Uint8Array(i);
    }, t;
  }()
), tr = (
  /** @class */
  function() {
    function t() {
    }
    return t.castAsNonUtf8Char = function(e, n) {
      n === void 0 && (n = null);
      var r = n ? n.getName() : this.ISO88591;
      return Jc.decode(new Uint8Array([e]), r);
    }, t.guessEncoding = function(e, n) {
      if (n != null && n.get(Ui.CHARACTER_SET) !== void 0)
        return n.get(Ui.CHARACTER_SET).toString();
      for (var r = e.length, i = !0, a = !0, s = !0, c = 0, d = 0, f = 0, g = 0, m = 0, b = 0, w = 0, _ = 0, A = 0, T = 0, O = 0, R = e.length > 3 && e[0] === /*(byte) */
      239 && e[1] === /*(byte) */
      187 && e[2] === /*(byte) */
      191, N = 0; N < r && (i || a || s); N++) {
        var M = e[N] & 255;
        s && (c > 0 ? M & 128 ? c-- : s = !1 : M & 128 && (M & 64 ? (c++, M & 32 ? (c++, M & 16 ? (c++, M & 8 ? s = !1 : g++) : f++) : d++) : s = !1)), i && (M > 127 && M < 160 ? i = !1 : M > 159 && (M < 192 || M === 215 || M === 247) && O++), a && (m > 0 ? M < 64 || M === 127 || M > 252 ? a = !1 : m-- : M === 128 || M === 160 || M > 239 ? a = !1 : M > 160 && M < 224 ? (b++, _ = 0, w++, w > A && (A = w)) : M > 127 ? (m++, w = 0, _++, _ > T && (T = _)) : (w = 0, _ = 0));
      }
      return s && c > 0 && (s = !1), a && m > 0 && (a = !1), s && (R || d + f + g > 0) ? t.UTF8 : a && (t.ASSUME_SHIFT_JIS || A >= 3 || T >= 3) ? t.SHIFT_JIS : i && a ? A === 2 && b === 2 || O * 10 >= r ? t.SHIFT_JIS : t.ISO88591 : i ? t.ISO88591 : a ? t.SHIFT_JIS : s ? t.UTF8 : t.PLATFORM_DEFAULT_ENCODING;
    }, t.format = function(e) {
      for (var n = [], r = 1; r < arguments.length; r++)
        n[r - 1] = arguments[r];
      var i = -1;
      function a(c, d, f, g, m, b) {
        if (c === "%%")
          return "%";
        if (n[++i] !== void 0) {
          c = g ? parseInt(g.substr(1)) : void 0;
          var w = m ? parseInt(m.substr(1)) : void 0, _;
          switch (b) {
            case "s":
              _ = n[i];
              break;
            case "c":
              _ = n[i][0];
              break;
            case "f":
              _ = parseFloat(n[i]).toFixed(c);
              break;
            case "p":
              _ = parseFloat(n[i]).toPrecision(c);
              break;
            case "e":
              _ = parseFloat(n[i]).toExponential(c);
              break;
            case "x":
              _ = parseInt(n[i]).toString(w || 16);
              break;
            case "d":
              _ = parseFloat(parseInt(n[i], w || 10).toPrecision(c)).toFixed(0);
              break;
          }
          _ = typeof _ == "object" ? JSON.stringify(_) : (+_).toString(w);
          for (var A = parseInt(f), T = f && f[0] + "" == "0" ? "0" : " "; _.length < A; )
            _ = d !== void 0 ? _ + T : T + _;
          return _;
        }
      }
      var s = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
      return e.replace(s, a);
    }, t.getBytes = function(e, n) {
      return Jc.encode(e, n);
    }, t.getCharCode = function(e, n) {
      return n === void 0 && (n = 0), e.charCodeAt(n);
    }, t.getCharAt = function(e) {
      return String.fromCharCode(e);
    }, t.SHIFT_JIS = Ha.SJIS.getName(), t.GB2312 = "GB2312", t.ISO88591 = Ha.ISO8859_1.getName(), t.EUC_JP = "EUC_JP", t.UTF8 = Ha.UTF8.getName(), t.PLATFORM_DEFAULT_ENCODING = t.UTF8, t.ASSUME_SHIFT_JIS = !1, t;
  }()
), Bn = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = ""), this.value = e;
    }
    return t.prototype.enableDecoding = function(e) {
      return this.encoding = e, this;
    }, t.prototype.append = function(e) {
      return typeof e == "string" ? this.value += e.toString() : this.encoding ? this.value += tr.castAsNonUtf8Char(e, this.encoding) : this.value += String.fromCharCode(e), this;
    }, t.prototype.appendChars = function(e, n, r) {
      for (var i = n; n < n + r; i++)
        this.append(e[i]);
      return this;
    }, t.prototype.length = function() {
      return this.value.length;
    }, t.prototype.charAt = function(e) {
      return this.value.charAt(e);
    }, t.prototype.deleteCharAt = function(e) {
      this.value = this.value.substr(0, e) + this.value.substring(e + 1);
    }, t.prototype.setCharAt = function(e, n) {
      this.value = this.value.substr(0, e) + n + this.value.substr(e + 1);
    }, t.prototype.substring = function(e, n) {
      return this.value.substring(e, n);
    }, t.prototype.setLengthToZero = function() {
      this.value = "";
    }, t.prototype.toString = function() {
      return this.value;
    }, t.prototype.insert = function(e, n) {
      this.value = this.value.substring(0, e) + n + this.value.substring(e);
    }, t;
  }()
), sf = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      if (this.width = e, this.height = n, this.rowSize = r, this.bits = i, n == null && (n = e), this.height = n, e < 1 || n < 1)
        throw new Yt("Both dimensions must be greater than 0");
      r == null && (r = Math.floor((e + 31) / 32)), this.rowSize = r, i == null && (this.bits = new Int32Array(this.rowSize * this.height));
    }
    return t.parseFromBooleanArray = function(e) {
      for (var n = e.length, r = e[0].length, i = new t(r, n), a = 0; a < n; a++)
        for (var s = e[a], c = 0; c < r; c++)
          s[c] && i.set(c, a);
      return i;
    }, t.parseFromString = function(e, n, r) {
      if (e === null)
        throw new Yt("stringRepresentation cannot be null");
      for (var i = new Array(e.length), a = 0, s = 0, c = -1, d = 0, f = 0; f < e.length; )
        if (e.charAt(f) === `
` || e.charAt(f) === "\r") {
          if (a > s) {
            if (c === -1)
              c = a - s;
            else if (a - s !== c)
              throw new Yt("row lengths do not match");
            s = a, d++;
          }
          f++;
        } else if (e.substring(f, f + n.length) === n)
          f += n.length, i[a] = !0, a++;
        else if (e.substring(f, f + r.length) === r)
          f += r.length, i[a] = !1, a++;
        else
          throw new Yt("illegal character encountered: " + e.substring(f));
      if (a > s) {
        if (c === -1)
          c = a - s;
        else if (a - s !== c)
          throw new Yt("row lengths do not match");
        d++;
      }
      for (var g = new t(c, d), m = 0; m < a; m++)
        i[m] && g.set(Math.floor(m % c), Math.floor(m / c));
      return g;
    }, t.prototype.get = function(e, n) {
      var r = n * this.rowSize + Math.floor(e / 32);
      return (this.bits[r] >>> (e & 31) & 1) !== 0;
    }, t.prototype.set = function(e, n) {
      var r = n * this.rowSize + Math.floor(e / 32);
      this.bits[r] |= 1 << (e & 31) & 4294967295;
    }, t.prototype.unset = function(e, n) {
      var r = n * this.rowSize + Math.floor(e / 32);
      this.bits[r] &= ~(1 << (e & 31) & 4294967295);
    }, t.prototype.flip = function(e, n) {
      var r = n * this.rowSize + Math.floor(e / 32);
      this.bits[r] ^= 1 << (e & 31) & 4294967295;
    }, t.prototype.xor = function(e) {
      if (this.width !== e.getWidth() || this.height !== e.getHeight() || this.rowSize !== e.getRowSize())
        throw new Yt("input matrix dimensions do not match");
      for (var n = new fo(Math.floor(this.width / 32) + 1), r = this.rowSize, i = this.bits, a = 0, s = this.height; a < s; a++)
        for (var c = a * r, d = e.getRow(a, n).getBitArray(), f = 0; f < r; f++)
          i[c + f] ^= d[f];
    }, t.prototype.clear = function() {
      for (var e = this.bits, n = e.length, r = 0; r < n; r++)
        e[r] = 0;
    }, t.prototype.setRegion = function(e, n, r, i) {
      if (n < 0 || e < 0)
        throw new Yt("Left and top must be nonnegative");
      if (i < 1 || r < 1)
        throw new Yt("Height and width must be at least 1");
      var a = e + r, s = n + i;
      if (s > this.height || a > this.width)
        throw new Yt("The region must fit inside the matrix");
      for (var c = this.rowSize, d = this.bits, f = n; f < s; f++)
        for (var g = f * c, m = e; m < a; m++)
          d[g + Math.floor(m / 32)] |= 1 << (m & 31) & 4294967295;
    }, t.prototype.getRow = function(e, n) {
      n == null || n.getSize() < this.width ? n = new fo(this.width) : n.clear();
      for (var r = this.rowSize, i = this.bits, a = e * r, s = 0; s < r; s++)
        n.setBulk(s * 32, i[a + s]);
      return n;
    }, t.prototype.setRow = function(e, n) {
      si.arraycopy(n.getBitArray(), 0, this.bits, e * this.rowSize, this.rowSize);
    }, t.prototype.rotate180 = function() {
      for (var e = this.getWidth(), n = this.getHeight(), r = new fo(e), i = new fo(e), a = 0, s = Math.floor((n + 1) / 2); a < s; a++)
        r = this.getRow(a, r), i = this.getRow(n - 1 - a, i), r.reverse(), i.reverse(), this.setRow(a, i), this.setRow(n - 1 - a, r);
    }, t.prototype.getEnclosingRectangle = function() {
      for (var e = this.width, n = this.height, r = this.rowSize, i = this.bits, a = e, s = n, c = -1, d = -1, f = 0; f < n; f++)
        for (var g = 0; g < r; g++) {
          var m = i[f * r + g];
          if (m !== 0) {
            if (f < s && (s = f), f > d && (d = f), g * 32 < a) {
              for (var b = 0; !(m << 31 - b & 4294967295); )
                b++;
              g * 32 + b < a && (a = g * 32 + b);
            }
            if (g * 32 + 31 > c) {
              for (var b = 31; !(m >>> b); )
                b--;
              g * 32 + b > c && (c = g * 32 + b);
            }
          }
        }
      return c < a || d < s ? null : Int32Array.from([a, s, c - a + 1, d - s + 1]);
    }, t.prototype.getTopLeftOnBit = function() {
      for (var e = this.rowSize, n = this.bits, r = 0; r < n.length && n[r] === 0; )
        r++;
      if (r === n.length)
        return null;
      for (var i = r / e, a = r % e * 32, s = n[r], c = 0; !(s << 31 - c & 4294967295); )
        c++;
      return a += c, Int32Array.from([a, i]);
    }, t.prototype.getBottomRightOnBit = function() {
      for (var e = this.rowSize, n = this.bits, r = n.length - 1; r >= 0 && n[r] === 0; )
        r--;
      if (r < 0)
        return null;
      for (var i = Math.floor(r / e), a = Math.floor(r % e) * 32, s = n[r], c = 31; !(s >>> c); )
        c--;
      return a += c, Int32Array.from([a, i]);
    }, t.prototype.getWidth = function() {
      return this.width;
    }, t.prototype.getHeight = function() {
      return this.height;
    }, t.prototype.getRowSize = function() {
      return this.rowSize;
    }, t.prototype.equals = function(e) {
      if (!(e instanceof t))
        return !1;
      var n = e;
      return this.width === n.width && this.height === n.height && this.rowSize === n.rowSize && qa.equals(this.bits, n.bits);
    }, t.prototype.hashCode = function() {
      var e = this.width;
      return e = 31 * e + this.width, e = 31 * e + this.height, e = 31 * e + this.rowSize, e = 31 * e + qa.hashCode(this.bits), e;
    }, t.prototype.toString = function(e, n, r) {
      return e === void 0 && (e = "X "), n === void 0 && (n = "  "), r === void 0 && (r = `
`), this.buildToString(e, n, r);
    }, t.prototype.buildToString = function(e, n, r) {
      for (var i = new Bn(), a = 0, s = this.height; a < s; a++) {
        for (var c = 0, d = this.width; c < d; c++)
          i.append(this.get(c, a) ? e : n);
        i.append(r);
      }
      return i.toString();
    }, t.prototype.clone = function() {
      return new t(this.width, this.height, this.rowSize, this.bits.slice());
    }, t;
  }()
), OFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ye = (
  /** @class */
  function(t) {
    OFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.getNotFoundInstance = function() {
      return new e();
    }, e.kind = "NotFoundException", e;
  }(hl)
), RFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), DFe = (
  /** @class */
  function(t) {
    RFe(e, t);
    function e(n) {
      var r = t.call(this, n) || this;
      return r.luminances = e.EMPTY, r.buckets = new Int32Array(e.LUMINANCE_BUCKETS), r;
    }
    return e.prototype.getBlackRow = function(n, r) {
      var i = this.getLuminanceSource(), a = i.getWidth();
      r == null || r.getSize() < a ? r = new fo(a) : r.clear(), this.initArrays(a);
      for (var s = i.getRow(n, this.luminances), c = this.buckets, d = 0; d < a; d++)
        c[(s[d] & 255) >> e.LUMINANCE_SHIFT]++;
      var f = e.estimateBlackPoint(c);
      if (a < 3)
        for (var d = 0; d < a; d++)
          (s[d] & 255) < f && r.set(d);
      else
        for (var g = s[0] & 255, m = s[1] & 255, d = 1; d < a - 1; d++) {
          var b = s[d + 1] & 255;
          (m * 4 - g - b) / 2 < f && r.set(d), g = m, m = b;
        }
      return r;
    }, e.prototype.getBlackMatrix = function() {
      var n = this.getLuminanceSource(), r = n.getWidth(), i = n.getHeight(), a = new sf(r, i);
      this.initArrays(r);
      for (var s = this.buckets, c = 1; c < 5; c++)
        for (var d = Math.floor(i * c / 5), f = n.getRow(d, this.luminances), g = Math.floor(r * 4 / 5), m = Math.floor(r / 5); m < g; m++) {
          var b = f[m] & 255;
          s[b >> e.LUMINANCE_SHIFT]++;
        }
      for (var w = e.estimateBlackPoint(s), _ = n.getMatrix(), c = 0; c < i; c++)
        for (var A = c * r, m = 0; m < r; m++) {
          var b = _[A + m] & 255;
          b < w && a.set(m, c);
        }
      return a;
    }, e.prototype.createBinarizer = function(n) {
      return new e(n);
    }, e.prototype.initArrays = function(n) {
      this.luminances.length < n && (this.luminances = new Uint8ClampedArray(n));
      for (var r = this.buckets, i = 0; i < e.LUMINANCE_BUCKETS; i++)
        r[i] = 0;
    }, e.estimateBlackPoint = function(n) {
      for (var r = n.length, i = 0, a = 0, s = 0, c = 0; c < r; c++)
        n[c] > s && (a = c, s = n[c]), n[c] > i && (i = n[c]);
      for (var d = 0, f = 0, c = 0; c < r; c++) {
        var g = c - a, m = n[c] * g * g;
        m > f && (d = c, f = m);
      }
      if (a > d) {
        var b = a;
        a = d, d = b;
      }
      if (d - a <= r / 16)
        throw new Ye();
      for (var w = d - 1, _ = -1, c = d - 1; c > a; c--) {
        var A = c - a, m = A * A * (d - c) * (i - n[c]);
        m > _ && (w = c, _ = m);
      }
      return w << e.LUMINANCE_SHIFT;
    }, e.LUMINANCE_BITS = 5, e.LUMINANCE_SHIFT = 8 - e.LUMINANCE_BITS, e.LUMINANCE_BUCKETS = 1 << e.LUMINANCE_BITS, e.EMPTY = Uint8ClampedArray.from([0]), e;
  }(xFe)
), NFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), MFe = (
  /** @class */
  function(t) {
    NFe(e, t);
    function e(n) {
      var r = t.call(this, n) || this;
      return r.matrix = null, r;
    }
    return e.prototype.getBlackMatrix = function() {
      if (this.matrix !== null)
        return this.matrix;
      var n = this.getLuminanceSource(), r = n.getWidth(), i = n.getHeight();
      if (r >= e.MINIMUM_DIMENSION && i >= e.MINIMUM_DIMENSION) {
        var a = n.getMatrix(), s = r >> e.BLOCK_SIZE_POWER;
        r & e.BLOCK_SIZE_MASK && s++;
        var c = i >> e.BLOCK_SIZE_POWER;
        i & e.BLOCK_SIZE_MASK && c++;
        var d = e.calculateBlackPoints(a, s, c, r, i), f = new sf(r, i);
        e.calculateThresholdForBlock(a, s, c, r, i, d, f), this.matrix = f;
      } else
        this.matrix = t.prototype.getBlackMatrix.call(this);
      return this.matrix;
    }, e.prototype.createBinarizer = function(n) {
      return new e(n);
    }, e.calculateThresholdForBlock = function(n, r, i, a, s, c, d) {
      for (var f = s - e.BLOCK_SIZE, g = a - e.BLOCK_SIZE, m = 0; m < i; m++) {
        var b = m << e.BLOCK_SIZE_POWER;
        b > f && (b = f);
        for (var w = e.cap(m, 2, i - 3), _ = 0; _ < r; _++) {
          var A = _ << e.BLOCK_SIZE_POWER;
          A > g && (A = g);
          for (var T = e.cap(_, 2, r - 3), O = 0, R = -2; R <= 2; R++) {
            var N = c[w + R];
            O += N[T - 2] + N[T - 1] + N[T] + N[T + 1] + N[T + 2];
          }
          var M = O / 25;
          e.thresholdBlock(n, A, b, M, a, d);
        }
      }
    }, e.cap = function(n, r, i) {
      return n < r ? r : n > i ? i : n;
    }, e.thresholdBlock = function(n, r, i, a, s, c) {
      for (var d = 0, f = i * s + r; d < e.BLOCK_SIZE; d++, f += s)
        for (var g = 0; g < e.BLOCK_SIZE; g++)
          (n[f + g] & 255) <= a && c.set(r + g, i + d);
    }, e.calculateBlackPoints = function(n, r, i, a, s) {
      for (var c = s - e.BLOCK_SIZE, d = a - e.BLOCK_SIZE, f = new Array(i), g = 0; g < i; g++) {
        f[g] = new Int32Array(r);
        var m = g << e.BLOCK_SIZE_POWER;
        m > c && (m = c);
        for (var b = 0; b < r; b++) {
          var w = b << e.BLOCK_SIZE_POWER;
          w > d && (w = d);
          for (var _ = 0, A = 255, T = 0, O = 0, R = m * a + w; O < e.BLOCK_SIZE; O++, R += a) {
            for (var N = 0; N < e.BLOCK_SIZE; N++) {
              var M = n[R + N] & 255;
              _ += M, M < A && (A = M), M > T && (T = M);
            }
            if (T - A > e.MIN_DYNAMIC_RANGE)
              for (O++, R += a; O < e.BLOCK_SIZE; O++, R += a)
                for (var N = 0; N < e.BLOCK_SIZE; N++)
                  _ += n[R + N] & 255;
          }
          var P = _ >> e.BLOCK_SIZE_POWER * 2;
          if (T - A <= e.MIN_DYNAMIC_RANGE && (P = A / 2, g > 0 && b > 0)) {
            var z = (f[g - 1][b] + 2 * f[g][b - 1] + f[g - 1][b - 1]) / 4;
            A < z && (P = z);
          }
          f[g][b] = P;
        }
      }
      return f;
    }, e.BLOCK_SIZE_POWER = 3, e.BLOCK_SIZE = 1 << e.BLOCK_SIZE_POWER, e.BLOCK_SIZE_MASK = e.BLOCK_SIZE - 1, e.MINIMUM_DIMENSION = e.BLOCK_SIZE * 5, e.MIN_DYNAMIC_RANGE = 24, e;
  }(DFe)
), OO = (
  /** @class */
  function() {
    function t(e, n) {
      this.width = e, this.height = n;
    }
    return t.prototype.getWidth = function() {
      return this.width;
    }, t.prototype.getHeight = function() {
      return this.height;
    }, t.prototype.isCropSupported = function() {
      return !1;
    }, t.prototype.crop = function(e, n, r, i) {
      throw new W4("This luminance source does not support cropping.");
    }, t.prototype.isRotateSupported = function() {
      return !1;
    }, t.prototype.rotateCounterClockwise = function() {
      throw new W4("This luminance source does not support rotation by 90 degrees.");
    }, t.prototype.rotateCounterClockwise45 = function() {
      throw new W4("This luminance source does not support rotation by 45 degrees.");
    }, t.prototype.toString = function() {
      for (var e = new Uint8ClampedArray(this.width), n = new Bn(), r = 0; r < this.height; r++) {
        for (var i = this.getRow(r, e), a = 0; a < this.width; a++) {
          var s = i[a] & 255, c = void 0;
          s < 64 ? c = "#" : s < 128 ? c = "+" : s < 192 ? c = "." : c = " ", n.append(c);
        }
        n.append(`
`);
      }
      return n.toString();
    }, t;
  }()
), IFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), qk = (
  /** @class */
  function(t) {
    IFe(e, t);
    function e(n) {
      var r = t.call(this, n.getWidth(), n.getHeight()) || this;
      return r.delegate = n, r;
    }
    return e.prototype.getRow = function(n, r) {
      for (var i = this.delegate.getRow(n, r), a = this.getWidth(), s = 0; s < a; s++)
        i[s] = /*(byte)*/
        255 - (i[s] & 255);
      return i;
    }, e.prototype.getMatrix = function() {
      for (var n = this.delegate.getMatrix(), r = this.getWidth() * this.getHeight(), i = new Uint8ClampedArray(r), a = 0; a < r; a++)
        i[a] = /*(byte)*/
        255 - (n[a] & 255);
      return i;
    }, e.prototype.isCropSupported = function() {
      return this.delegate.isCropSupported();
    }, e.prototype.crop = function(n, r, i, a) {
      return new e(this.delegate.crop(n, r, i, a));
    }, e.prototype.isRotateSupported = function() {
      return this.delegate.isRotateSupported();
    }, e.prototype.invert = function() {
      return this.delegate;
    }, e.prototype.rotateCounterClockwise = function() {
      return new e(this.delegate.rotateCounterClockwise());
    }, e.prototype.rotateCounterClockwise45 = function() {
      return new e(this.delegate.rotateCounterClockwise45());
    }, e;
  }(OO)
), kFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), jFe = (
  /** @class */
  function(t) {
    kFe(e, t);
    function e(n) {
      var r = t.call(this, n.width, n.height) || this;
      return r.canvas = n, r.tempCanvasElement = null, r.buffer = e.makeBufferFromCanvasImageData(n), r;
    }
    return e.makeBufferFromCanvasImageData = function(n) {
      var r = n.getContext("2d").getImageData(0, 0, n.width, n.height);
      return e.toGrayscaleBuffer(r.data, n.width, n.height);
    }, e.toGrayscaleBuffer = function(n, r, i) {
      var a = new Uint8ClampedArray(r * i);
      if (e.FRAME_INDEX = !e.FRAME_INDEX, e.FRAME_INDEX)
        for (var s = 0, c = 0, d = n.length; s < d; s += 4, c++) {
          var f = void 0, g = n[s + 3];
          if (g === 0)
            f = 255;
          else {
            var m = n[s], b = n[s + 1], w = n[s + 2];
            f = 306 * m + 601 * b + 117 * w + 512 >> 10;
          }
          a[c] = f;
        }
      else
        for (var s = 0, c = 0, _ = n.length; s < _; s += 4, c++) {
          var f = void 0, g = n[s + 3];
          if (g === 0)
            f = 255;
          else {
            var m = n[s], b = n[s + 1], w = n[s + 2];
            f = 306 * m + 601 * b + 117 * w + 512 >> 10;
          }
          a[c] = 255 - f;
        }
      return a;
    }, e.prototype.getRow = function(n, r) {
      if (n < 0 || n >= this.getHeight())
        throw new Yt("Requested row is outside the image: " + n);
      var i = this.getWidth(), a = n * i;
      return r === null ? r = this.buffer.slice(a, a + i) : (r.length < i && (r = new Uint8ClampedArray(i)), r.set(this.buffer.slice(a, a + i))), r;
    }, e.prototype.getMatrix = function() {
      return this.buffer;
    }, e.prototype.isCropSupported = function() {
      return !0;
    }, e.prototype.crop = function(n, r, i, a) {
      return t.prototype.crop.call(this, n, r, i, a), this;
    }, e.prototype.isRotateSupported = function() {
      return !0;
    }, e.prototype.rotateCounterClockwise = function() {
      return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
      return this.rotate(-45), this;
    }, e.prototype.getTempCanvasElement = function() {
      if (this.tempCanvasElement === null) {
        var n = this.canvas.ownerDocument.createElement("canvas");
        n.width = this.canvas.width, n.height = this.canvas.height, this.tempCanvasElement = n;
      }
      return this.tempCanvasElement;
    }, e.prototype.rotate = function(n) {
      var r = this.getTempCanvasElement(), i = r.getContext("2d"), a = n * e.DEGREE_TO_RADIANS, s = this.canvas.width, c = this.canvas.height, d = Math.ceil(Math.abs(Math.cos(a)) * s + Math.abs(Math.sin(a)) * c), f = Math.ceil(Math.abs(Math.sin(a)) * s + Math.abs(Math.cos(a)) * c);
      return r.width = d, r.height = f, i.translate(d / 2, f / 2), i.rotate(a), i.drawImage(this.canvas, s / -2, c / -2), this.buffer = e.makeBufferFromCanvasImageData(r), this;
    }, e.prototype.invert = function() {
      return new qk(this);
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e.FRAME_INDEX = !0, e;
  }(OO)
), PFe = (
  /** @class */
  function() {
    function t(e, n, r) {
      this.deviceId = e, this.label = n, this.kind = "videoinput", this.groupId = r || void 0;
    }
    return t.prototype.toJSON = function() {
      return {
        kind: this.kind,
        groupId: this.groupId,
        deviceId: this.deviceId,
        label: this.label
      };
    }, t;
  }()
), Ts = globalThis && globalThis.__awaiter || function(t, e, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(s) {
      s(a);
    });
  }
  return new (n || (n = Promise))(function(a, s) {
    function c(g) {
      try {
        f(r.next(g));
      } catch (m) {
        s(m);
      }
    }
    function d(g) {
      try {
        f(r.throw(g));
      } catch (m) {
        s(m);
      }
    }
    function f(g) {
      g.done ? a(g.value) : i(g.value).then(c, d);
    }
    f((r = r.apply(t, e || [])).next());
  });
}, Os = globalThis && globalThis.__generator || function(t, e) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, s;
  return s = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function c(f) {
    return function(g) {
      return d([f, g]);
    };
  }
  function d(f) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (a = f[0] & 2 ? i.return : f[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, f[1])).done)
          return a;
        switch (i = 0, a && (f = [f[0] & 2, a.value]), f[0]) {
          case 0:
          case 1:
            a = f;
            break;
          case 4:
            return n.label++, { value: f[1], done: !1 };
          case 5:
            n.label++, i = f[1], f = [0];
            continue;
          case 7:
            f = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              n = 0;
              continue;
            }
            if (f[0] === 3 && (!a || f[1] > a[0] && f[1] < a[3])) {
              n.label = f[1];
              break;
            }
            if (f[0] === 6 && n.label < a[1]) {
              n.label = a[1], a = f;
              break;
            }
            if (a && n.label < a[2]) {
              n.label = a[2], n.ops.push(f);
              break;
            }
            a[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        f = e.call(t, n);
      } catch (g) {
        f = [6, g], i = 0;
      } finally {
        r = a = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}, LFe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Rw = (
  /** @class */
  function() {
    function t(e, n, r) {
      n === void 0 && (n = 500), this.reader = e, this.timeBetweenScansMillis = n, this._hints = r, this._stopContinuousDecode = !1, this._stopAsyncDecode = !1, this._timeBetweenDecodingAttempts = 0;
    }
    return Object.defineProperty(t.prototype, "hasNavigator", {
      /**
       * If navigator is present.
       */
      get: function() {
        return typeof navigator < "u";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "isMediaDevicesSuported", {
      /**
       * If mediaDevices under navigator is supported.
       */
      get: function() {
        return this.hasNavigator && !!navigator.mediaDevices;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "canEnumerateDevices", {
      /**
       * If enumerateDevices under navigator is supported.
       */
      get: function() {
        return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "timeBetweenDecodingAttempts", {
      /** Time between two decoding tries in milli seconds. */
      get: function() {
        return this._timeBetweenDecodingAttempts;
      },
      /**
       * Change the time span the decoder waits between two decoding tries.
       *
       * @param {number} millis Time between two decoding tries in milli seconds.
       */
      set: function(e) {
        this._timeBetweenDecodingAttempts = e < 0 ? 0 : e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "hints", {
      /**
       * Sets the hints.
       */
      get: function() {
        return this._hints;
      },
      /**
       * Sets the hints.
       */
      set: function(e) {
        this._hints = e || null;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.listVideoInputDevices = function() {
      return Ts(this, void 0, void 0, function() {
        var e, n, r, i, a, s, c, d, f, g, m, b;
        return Os(this, function(w) {
          switch (w.label) {
            case 0:
              if (!this.hasNavigator)
                throw new Error("Can't enumerate devices, navigator is not present.");
              if (!this.canEnumerateDevices)
                throw new Error("Can't enumerate devices, method not supported.");
              return [4, navigator.mediaDevices.enumerateDevices()];
            case 1:
              e = w.sent(), n = [];
              try {
                for (r = LFe(e), i = r.next(); !i.done; i = r.next())
                  a = i.value, s = a.kind === "video" ? "videoinput" : a.kind, s === "videoinput" && (c = a.deviceId || a.id, d = a.label || "Video device " + (n.length + 1), f = a.groupId, g = { deviceId: c, label: d, kind: s, groupId: f }, n.push(g));
              } catch (_) {
                m = { error: _ };
              } finally {
                try {
                  i && !i.done && (b = r.return) && b.call(r);
                } finally {
                  if (m)
                    throw m.error;
                }
              }
              return [2, n];
          }
        });
      });
    }, t.prototype.getVideoInputDevices = function() {
      return Ts(this, void 0, void 0, function() {
        var e;
        return Os(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.listVideoInputDevices()];
            case 1:
              return e = n.sent(), [2, e.map(function(r) {
                return new PFe(r.deviceId, r.label);
              })];
          }
        });
      });
    }, t.prototype.findDeviceById = function(e) {
      return Ts(this, void 0, void 0, function() {
        var n;
        return Os(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.listVideoInputDevices()];
            case 1:
              return n = r.sent(), n ? [2, n.find(function(i) {
                return i.deviceId === e;
              })] : [2, null];
          }
        });
      });
    }, t.prototype.decodeFromInputVideoDevice = function(e, n) {
      return Ts(this, void 0, void 0, function() {
        return Os(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.decodeOnceFromVideoDevice(e, n)];
            case 1:
              return [2, r.sent()];
          }
        });
      });
    }, t.prototype.decodeOnceFromVideoDevice = function(e, n) {
      return Ts(this, void 0, void 0, function() {
        var r, i;
        return Os(this, function(a) {
          switch (a.label) {
            case 0:
              return this.reset(), e ? r = { deviceId: { exact: e } } : r = { facingMode: "environment" }, i = { video: r }, [4, this.decodeOnceFromConstraints(i, n)];
            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, t.prototype.decodeOnceFromConstraints = function(e, n) {
      return Ts(this, void 0, void 0, function() {
        var r;
        return Os(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, navigator.mediaDevices.getUserMedia(e)];
            case 1:
              return r = i.sent(), [4, this.decodeOnceFromStream(r, n)];
            case 2:
              return [2, i.sent()];
          }
        });
      });
    }, t.prototype.decodeOnceFromStream = function(e, n) {
      return Ts(this, void 0, void 0, function() {
        var r, i;
        return Os(this, function(a) {
          switch (a.label) {
            case 0:
              return this.reset(), [4, this.attachStreamToVideo(e, n)];
            case 1:
              return r = a.sent(), [4, this.decodeOnce(r)];
            case 2:
              return i = a.sent(), [2, i];
          }
        });
      });
    }, t.prototype.decodeFromInputVideoDeviceContinuously = function(e, n, r) {
      return Ts(this, void 0, void 0, function() {
        return Os(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.decodeFromVideoDevice(e, n, r)];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, t.prototype.decodeFromVideoDevice = function(e, n, r) {
      return Ts(this, void 0, void 0, function() {
        var i, a;
        return Os(this, function(s) {
          switch (s.label) {
            case 0:
              return e ? i = { deviceId: { exact: e } } : i = { facingMode: "environment" }, a = { video: i }, [4, this.decodeFromConstraints(a, n, r)];
            case 1:
              return [2, s.sent()];
          }
        });
      });
    }, t.prototype.decodeFromConstraints = function(e, n, r) {
      return Ts(this, void 0, void 0, function() {
        var i;
        return Os(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, navigator.mediaDevices.getUserMedia(e)];
            case 1:
              return i = a.sent(), [4, this.decodeFromStream(i, n, r)];
            case 2:
              return [2, a.sent()];
          }
        });
      });
    }, t.prototype.decodeFromStream = function(e, n, r) {
      return Ts(this, void 0, void 0, function() {
        var i;
        return Os(this, function(a) {
          switch (a.label) {
            case 0:
              return this.reset(), [4, this.attachStreamToVideo(e, n)];
            case 1:
              return i = a.sent(), [4, this.decodeContinuously(i, r)];
            case 2:
              return [2, a.sent()];
          }
        });
      });
    }, t.prototype.stopAsyncDecode = function() {
      this._stopAsyncDecode = !0;
    }, t.prototype.stopContinuousDecode = function() {
      this._stopContinuousDecode = !0;
    }, t.prototype.attachStreamToVideo = function(e, n) {
      return Ts(this, void 0, void 0, function() {
        var r;
        return Os(this, function(i) {
          switch (i.label) {
            case 0:
              return r = this.prepareVideoElement(n), this.addVideoSource(r, e), this.videoElement = r, this.stream = e, [4, this.playVideoOnLoadAsync(r)];
            case 1:
              return i.sent(), [2, r];
          }
        });
      });
    }, t.prototype.playVideoOnLoadAsync = function(e) {
      var n = this;
      return new Promise(function(r, i) {
        return n.playVideoOnLoad(e, function() {
          return r();
        });
      });
    }, t.prototype.playVideoOnLoad = function(e, n) {
      var r = this;
      this.videoEndedListener = function() {
        return r.stopStreams();
      }, this.videoCanPlayListener = function() {
        return r.tryPlayVideo(e);
      }, e.addEventListener("ended", this.videoEndedListener), e.addEventListener("canplay", this.videoCanPlayListener), e.addEventListener("playing", n), this.tryPlayVideo(e);
    }, t.prototype.isVideoPlaying = function(e) {
      return e.currentTime > 0 && !e.paused && !e.ended && e.readyState > 2;
    }, t.prototype.tryPlayVideo = function(e) {
      return Ts(this, void 0, void 0, function() {
        return Os(this, function(n) {
          switch (n.label) {
            case 0:
              if (this.isVideoPlaying(e))
                return console.warn("Trying to play video that is already playing."), [
                  2
                  /*return*/
                ];
              n.label = 1;
            case 1:
              return n.trys.push([1, 3, , 4]), [4, e.play()];
            case 2:
              return n.sent(), [3, 4];
            case 3:
              return n.sent(), console.warn("It was not possible to play the video."), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getMediaElement = function(e, n) {
      var r = document.getElementById(e);
      if (!r)
        throw new ju("element with id '" + e + "' not found");
      if (r.nodeName.toLowerCase() !== n.toLowerCase())
        throw new ju("element with id '" + e + "' must be an " + n + " element");
      return r;
    }, t.prototype.decodeFromImage = function(e, n) {
      if (!e && !n)
        throw new ju("either imageElement with a src set or an url must be provided");
      return n && !e ? this.decodeFromImageUrl(n) : this.decodeFromImageElement(e);
    }, t.prototype.decodeFromVideo = function(e, n) {
      if (!e && !n)
        throw new ju("Either an element with a src set or an URL must be provided");
      return n && !e ? this.decodeFromVideoUrl(n) : this.decodeFromVideoElement(e);
    }, t.prototype.decodeFromVideoContinuously = function(e, n, r) {
      if (e === void 0 && n === void 0)
        throw new ju("Either an element with a src set or an URL must be provided");
      return n && !e ? this.decodeFromVideoUrlContinuously(n, r) : this.decodeFromVideoElementContinuously(e, r);
    }, t.prototype.decodeFromImageElement = function(e) {
      if (!e)
        throw new ju("An image element must be provided.");
      this.reset();
      var n = this.prepareImageElement(e);
      this.imageElement = n;
      var r;
      return this.isImageLoaded(n) ? r = this.decodeOnce(n, !1, !0) : r = this._decodeOnLoadImage(n), r;
    }, t.prototype.decodeFromVideoElement = function(e) {
      var n = this._decodeFromVideoElementSetup(e);
      return this._decodeOnLoadVideo(n);
    }, t.prototype.decodeFromVideoElementContinuously = function(e, n) {
      var r = this._decodeFromVideoElementSetup(e);
      return this._decodeOnLoadVideoContinuously(r, n);
    }, t.prototype._decodeFromVideoElementSetup = function(e) {
      if (!e)
        throw new ju("A video element must be provided.");
      this.reset();
      var n = this.prepareVideoElement(e);
      return this.videoElement = n, n;
    }, t.prototype.decodeFromImageUrl = function(e) {
      if (!e)
        throw new ju("An URL must be provided.");
      this.reset();
      var n = this.prepareImageElement();
      this.imageElement = n;
      var r = this._decodeOnLoadImage(n);
      return n.src = e, r;
    }, t.prototype.decodeFromVideoUrl = function(e) {
      if (!e)
        throw new ju("An URL must be provided.");
      this.reset();
      var n = this.prepareVideoElement(), r = this.decodeFromVideoElement(n);
      return n.src = e, r;
    }, t.prototype.decodeFromVideoUrlContinuously = function(e, n) {
      if (!e)
        throw new ju("An URL must be provided.");
      this.reset();
      var r = this.prepareVideoElement(), i = this.decodeFromVideoElementContinuously(r, n);
      return r.src = e, i;
    }, t.prototype._decodeOnLoadImage = function(e) {
      var n = this;
      return new Promise(function(r, i) {
        n.imageLoadedListener = function() {
          return n.decodeOnce(e, !1, !0).then(r, i);
        }, e.addEventListener("load", n.imageLoadedListener);
      });
    }, t.prototype._decodeOnLoadVideo = function(e) {
      return Ts(this, void 0, void 0, function() {
        return Os(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.playVideoOnLoadAsync(e)];
            case 1:
              return n.sent(), [4, this.decodeOnce(e)];
            case 2:
              return [2, n.sent()];
          }
        });
      });
    }, t.prototype._decodeOnLoadVideoContinuously = function(e, n) {
      return Ts(this, void 0, void 0, function() {
        return Os(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.playVideoOnLoadAsync(e)];
            case 1:
              return r.sent(), this.decodeContinuously(e, n), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.isImageLoaded = function(e) {
      return !(!e.complete || e.naturalWidth === 0);
    }, t.prototype.prepareImageElement = function(e) {
      var n;
      return typeof e > "u" && (n = document.createElement("img"), n.width = 200, n.height = 200), typeof e == "string" && (n = this.getMediaElement(e, "img")), e instanceof HTMLImageElement && (n = e), n;
    }, t.prototype.prepareVideoElement = function(e) {
      var n;
      return !e && typeof document < "u" && (n = document.createElement("video"), n.width = 200, n.height = 200), typeof e == "string" && (n = this.getMediaElement(e, "video")), e instanceof HTMLVideoElement && (n = e), n.setAttribute("autoplay", "true"), n.setAttribute("muted", "true"), n.setAttribute("playsinline", "true"), n;
    }, t.prototype.decodeOnce = function(e, n, r) {
      var i = this;
      n === void 0 && (n = !0), r === void 0 && (r = !0), this._stopAsyncDecode = !1;
      var a = function(s, c) {
        if (i._stopAsyncDecode) {
          c(new Ye("Video stream has ended before any code could be detected.")), i._stopAsyncDecode = void 0;
          return;
        }
        try {
          var d = i.decode(e);
          s(d);
        } catch (b) {
          var f = n && b instanceof Ye, g = b instanceof uo || b instanceof ht, m = g && r;
          if (f || m)
            return setTimeout(a, i._timeBetweenDecodingAttempts, s, c);
          c(b);
        }
      };
      return new Promise(function(s, c) {
        return a(s, c);
      });
    }, t.prototype.decodeContinuously = function(e, n) {
      var r = this;
      this._stopContinuousDecode = !1;
      var i = function() {
        if (r._stopContinuousDecode) {
          r._stopContinuousDecode = void 0;
          return;
        }
        try {
          var a = r.decode(e);
          n(a, null), setTimeout(i, r.timeBetweenScansMillis);
        } catch (d) {
          n(null, d);
          var s = d instanceof uo || d instanceof ht, c = d instanceof Ye;
          (s || c) && setTimeout(i, r._timeBetweenDecodingAttempts);
        }
      };
      i();
    }, t.prototype.decode = function(e) {
      var n = this.createBinaryBitmap(e);
      return this.decodeBitmap(n);
    }, t.prototype.createBinaryBitmap = function(e) {
      this.getCaptureCanvasContext(e), e instanceof HTMLVideoElement ? this.drawFrameOnCanvas(e) : this.drawImageOnCanvas(e);
      var n = this.getCaptureCanvas(e), r = new jFe(n), i = new MFe(r);
      return new bFe(i);
    }, t.prototype.getCaptureCanvasContext = function(e) {
      if (!this.captureCanvasContext) {
        var n = this.getCaptureCanvas(e), r = void 0;
        try {
          r = n.getContext("2d", { willReadFrequently: !0 });
        } catch {
          r = n.getContext("2d");
        }
        this.captureCanvasContext = r;
      }
      return this.captureCanvasContext;
    }, t.prototype.getCaptureCanvas = function(e) {
      if (!this.captureCanvas) {
        var n = this.createCaptureCanvas(e);
        this.captureCanvas = n;
      }
      return this.captureCanvas;
    }, t.prototype.drawFrameOnCanvas = function(e, n, r) {
      n === void 0 && (n = {
        sx: 0,
        sy: 0,
        sWidth: e.videoWidth,
        sHeight: e.videoHeight,
        dx: 0,
        dy: 0,
        dWidth: e.videoWidth,
        dHeight: e.videoHeight
      }), r === void 0 && (r = this.captureCanvasContext), r.drawImage(e, n.sx, n.sy, n.sWidth, n.sHeight, n.dx, n.dy, n.dWidth, n.dHeight);
    }, t.prototype.drawImageOnCanvas = function(e, n, r) {
      n === void 0 && (n = {
        sx: 0,
        sy: 0,
        sWidth: e.naturalWidth,
        sHeight: e.naturalHeight,
        dx: 0,
        dy: 0,
        dWidth: e.naturalWidth,
        dHeight: e.naturalHeight
      }), r === void 0 && (r = this.captureCanvasContext), r.drawImage(e, n.sx, n.sy, n.sWidth, n.sHeight, n.dx, n.dy, n.dWidth, n.dHeight);
    }, t.prototype.decodeBitmap = function(e) {
      return this.reader.decode(e, this._hints);
    }, t.prototype.createCaptureCanvas = function(e) {
      if (typeof document > "u")
        return this._destroyCaptureCanvas(), null;
      var n = document.createElement("canvas"), r, i;
      return typeof e < "u" && (e instanceof HTMLVideoElement ? (r = e.videoWidth, i = e.videoHeight) : e instanceof HTMLImageElement && (r = e.naturalWidth || e.width, i = e.naturalHeight || e.height)), n.style.width = r + "px", n.style.height = i + "px", n.width = r, n.height = i, n;
    }, t.prototype.stopStreams = function() {
      this.stream && (this.stream.getVideoTracks().forEach(function(e) {
        return e.stop();
      }), this.stream = void 0), this._stopAsyncDecode === !1 && this.stopAsyncDecode(), this._stopContinuousDecode === !1 && this.stopContinuousDecode();
    }, t.prototype.reset = function() {
      this.stopStreams(), this._destroyVideoElement(), this._destroyImageElement(), this._destroyCaptureCanvas();
    }, t.prototype._destroyVideoElement = function() {
      this.videoElement && (typeof this.videoEndedListener < "u" && this.videoElement.removeEventListener("ended", this.videoEndedListener), typeof this.videoPlayingEventListener < "u" && this.videoElement.removeEventListener("playing", this.videoPlayingEventListener), typeof this.videoCanPlayListener < "u" && this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener), this.cleanVideoSource(this.videoElement), this.videoElement = void 0);
    }, t.prototype._destroyImageElement = function() {
      this.imageElement && (this.imageLoadedListener !== void 0 && this.imageElement.removeEventListener("load", this.imageLoadedListener), this.imageElement.src = void 0, this.imageElement.removeAttribute("src"), this.imageElement = void 0);
    }, t.prototype._destroyCaptureCanvas = function() {
      this.captureCanvasContext = void 0, this.captureCanvas = void 0;
    }, t.prototype.addVideoSource = function(e, n) {
      try {
        e.srcObject = n;
      } catch {
        e.src = URL.createObjectURL(n);
      }
    }, t.prototype.cleanVideoSource = function(e) {
      try {
        e.srcObject = null;
      } catch {
        e.src = "";
      }
      this.videoElement.removeAttribute("src");
    }, t;
  }()
), ts = (
  /** @class */
  function() {
    function t(e, n, r, i, a, s) {
      r === void 0 && (r = n == null ? 0 : 8 * n.length), s === void 0 && (s = si.currentTimeMillis()), this.text = e, this.rawBytes = n, this.numBits = r, this.resultPoints = i, this.format = a, this.timestamp = s, this.text = e, this.rawBytes = n, r == null ? this.numBits = n == null ? 0 : 8 * n.length : this.numBits = r, this.resultPoints = i, this.format = a, this.resultMetadata = null, s == null ? this.timestamp = si.currentTimeMillis() : this.timestamp = s;
    }
    return t.prototype.getText = function() {
      return this.text;
    }, t.prototype.getRawBytes = function() {
      return this.rawBytes;
    }, t.prototype.getNumBits = function() {
      return this.numBits;
    }, t.prototype.getResultPoints = function() {
      return this.resultPoints;
    }, t.prototype.getBarcodeFormat = function() {
      return this.format;
    }, t.prototype.getResultMetadata = function() {
      return this.resultMetadata;
    }, t.prototype.putMetadata = function(e, n) {
      this.resultMetadata === null && (this.resultMetadata = /* @__PURE__ */ new Map()), this.resultMetadata.set(e, n);
    }, t.prototype.putAllMetadata = function(e) {
      e !== null && (this.resultMetadata === null ? this.resultMetadata = e : this.resultMetadata = new Map(e));
    }, t.prototype.addResultPoints = function(e) {
      var n = this.resultPoints;
      if (n === null)
        this.resultPoints = e;
      else if (e !== null && e.length > 0) {
        var r = new Array(n.length + e.length);
        si.arraycopy(n, 0, r, 0, n.length), si.arraycopy(e, 0, r, n.length, e.length), this.resultPoints = r;
      }
    }, t.prototype.getTimestamp = function() {
      return this.timestamp;
    }, t.prototype.toString = function() {
      return this.text;
    }, t;
  }()
), nM;
(function(t) {
  t[t.AZTEC = 0] = "AZTEC", t[t.CODABAR = 1] = "CODABAR", t[t.CODE_39 = 2] = "CODE_39", t[t.CODE_93 = 3] = "CODE_93", t[t.CODE_128 = 4] = "CODE_128", t[t.DATA_MATRIX = 5] = "DATA_MATRIX", t[t.EAN_8 = 6] = "EAN_8", t[t.EAN_13 = 7] = "EAN_13", t[t.ITF = 8] = "ITF", t[t.MAXICODE = 9] = "MAXICODE", t[t.PDF_417 = 10] = "PDF_417", t[t.QR_CODE = 11] = "QR_CODE", t[t.RSS_14 = 12] = "RSS_14", t[t.RSS_EXPANDED = 13] = "RSS_EXPANDED", t[t.UPC_A = 14] = "UPC_A", t[t.UPC_E = 15] = "UPC_E", t[t.UPC_EAN_EXTENSION = 16] = "UPC_EAN_EXTENSION";
})(nM || (nM = {}));
const Ht = nM;
var rM;
(function(t) {
  t[t.OTHER = 0] = "OTHER", t[t.ORIENTATION = 1] = "ORIENTATION", t[t.BYTE_SEGMENTS = 2] = "BYTE_SEGMENTS", t[t.ERROR_CORRECTION_LEVEL = 3] = "ERROR_CORRECTION_LEVEL", t[t.ISSUE_NUMBER = 4] = "ISSUE_NUMBER", t[t.SUGGESTED_PRICE = 5] = "SUGGESTED_PRICE", t[t.POSSIBLE_COUNTRY = 6] = "POSSIBLE_COUNTRY", t[t.UPC_EAN_EXTENSION = 7] = "UPC_EAN_EXTENSION", t[t.PDF417_EXTRA_METADATA = 8] = "PDF417_EXTRA_METADATA", t[t.STRUCTURED_APPEND_SEQUENCE = 9] = "STRUCTURED_APPEND_SEQUENCE", t[t.STRUCTURED_APPEND_PARITY = 10] = "STRUCTURED_APPEND_PARITY";
})(rM || (rM = {}));
const jo = rM;
var RO = (
  /** @class */
  function() {
    function t(e, n, r, i, a, s) {
      a === void 0 && (a = -1), s === void 0 && (s = -1), this.rawBytes = e, this.text = n, this.byteSegments = r, this.ecLevel = i, this.structuredAppendSequenceNumber = a, this.structuredAppendParity = s, this.numBits = e == null ? 0 : 8 * e.length;
    }
    return t.prototype.getRawBytes = function() {
      return this.rawBytes;
    }, t.prototype.getNumBits = function() {
      return this.numBits;
    }, t.prototype.setNumBits = function(e) {
      this.numBits = e;
    }, t.prototype.getText = function() {
      return this.text;
    }, t.prototype.getByteSegments = function() {
      return this.byteSegments;
    }, t.prototype.getECLevel = function() {
      return this.ecLevel;
    }, t.prototype.getErrorsCorrected = function() {
      return this.errorsCorrected;
    }, t.prototype.setErrorsCorrected = function(e) {
      this.errorsCorrected = e;
    }, t.prototype.getErasures = function() {
      return this.erasures;
    }, t.prototype.setErasures = function(e) {
      this.erasures = e;
    }, t.prototype.getOther = function() {
      return this.other;
    }, t.prototype.setOther = function(e) {
      this.other = e;
    }, t.prototype.hasStructuredAppend = function() {
      return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
    }, t.prototype.getStructuredAppendParity = function() {
      return this.structuredAppendParity;
    }, t.prototype.getStructuredAppendSequenceNumber = function() {
      return this.structuredAppendSequenceNumber;
    }, t;
  }()
), aE = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.exp = function(e) {
      return this.expTable[e];
    }, t.prototype.log = function(e) {
      if (e === 0)
        throw new Yt();
      return this.logTable[e];
    }, t.addOrSubtract = function(e, n) {
      return e ^ n;
    }, t;
  }()
), B0 = (
  /** @class */
  function() {
    function t(e, n) {
      if (n.length === 0)
        throw new Yt();
      this.field = e;
      var r = n.length;
      if (r > 1 && n[0] === 0) {
        for (var i = 1; i < r && n[i] === 0; )
          i++;
        i === r ? this.coefficients = Int32Array.from([0]) : (this.coefficients = new Int32Array(r - i), si.arraycopy(n, i, this.coefficients, 0, this.coefficients.length));
      } else
        this.coefficients = n;
    }
    return t.prototype.getCoefficients = function() {
      return this.coefficients;
    }, t.prototype.getDegree = function() {
      return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
      return this.coefficients[0] === 0;
    }, t.prototype.getCoefficient = function(e) {
      return this.coefficients[this.coefficients.length - 1 - e];
    }, t.prototype.evaluateAt = function(e) {
      if (e === 0)
        return this.getCoefficient(0);
      var n = this.coefficients, r;
      if (e === 1) {
        r = 0;
        for (var i = 0, a = n.length; i !== a; i++) {
          var s = n[i];
          r = aE.addOrSubtract(r, s);
        }
        return r;
      }
      r = n[0];
      for (var c = n.length, d = this.field, i = 1; i < c; i++)
        r = aE.addOrSubtract(d.multiply(e, r), n[i]);
      return r;
    }, t.prototype.addOrSubtract = function(e) {
      if (!this.field.equals(e.field))
        throw new Yt("GenericGFPolys do not have same GenericGF field");
      if (this.isZero())
        return e;
      if (e.isZero())
        return this;
      var n = this.coefficients, r = e.coefficients;
      if (n.length > r.length) {
        var i = n;
        n = r, r = i;
      }
      var a = new Int32Array(r.length), s = r.length - n.length;
      si.arraycopy(r, 0, a, 0, s);
      for (var c = s; c < r.length; c++)
        a[c] = aE.addOrSubtract(n[c - s], r[c]);
      return new t(this.field, a);
    }, t.prototype.multiply = function(e) {
      if (!this.field.equals(e.field))
        throw new Yt("GenericGFPolys do not have same GenericGF field");
      if (this.isZero() || e.isZero())
        return this.field.getZero();
      for (var n = this.coefficients, r = n.length, i = e.coefficients, a = i.length, s = new Int32Array(r + a - 1), c = this.field, d = 0; d < r; d++)
        for (var f = n[d], g = 0; g < a; g++)
          s[d + g] = aE.addOrSubtract(s[d + g], c.multiply(f, i[g]));
      return new t(c, s);
    }, t.prototype.multiplyScalar = function(e) {
      if (e === 0)
        return this.field.getZero();
      if (e === 1)
        return this;
      for (var n = this.coefficients.length, r = this.field, i = new Int32Array(n), a = this.coefficients, s = 0; s < n; s++)
        i[s] = r.multiply(a[s], e);
      return new t(r, i);
    }, t.prototype.multiplyByMonomial = function(e, n) {
      if (e < 0)
        throw new Yt();
      if (n === 0)
        return this.field.getZero();
      for (var r = this.coefficients, i = r.length, a = new Int32Array(i + e), s = this.field, c = 0; c < i; c++)
        a[c] = s.multiply(r[c], n);
      return new t(s, a);
    }, t.prototype.divide = function(e) {
      if (!this.field.equals(e.field))
        throw new Yt("GenericGFPolys do not have same GenericGF field");
      if (e.isZero())
        throw new Yt("Divide by 0");
      for (var n = this.field, r = n.getZero(), i = this, a = e.getCoefficient(e.getDegree()), s = n.inverse(a); i.getDegree() >= e.getDegree() && !i.isZero(); ) {
        var c = i.getDegree() - e.getDegree(), d = n.multiply(i.getCoefficient(i.getDegree()), s), f = e.multiplyByMonomial(c, d), g = n.buildMonomial(c, d);
        r = r.addOrSubtract(g), i = i.addOrSubtract(f);
      }
      return [r, i];
    }, t.prototype.toString = function() {
      for (var e = "", n = this.getDegree(); n >= 0; n--) {
        var r = this.getCoefficient(n);
        if (r !== 0) {
          if (r < 0 ? (e += " - ", r = -r) : e.length > 0 && (e += " + "), n === 0 || r !== 1) {
            var i = this.field.log(r);
            i === 0 ? e += "1" : i === 1 ? e += "a" : (e += "a^", e += i);
          }
          n !== 0 && (n === 1 ? e += "x" : (e += "x^", e += n));
        }
      }
      return e;
    }, t;
  }()
), BFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), xee = (
  /** @class */
  function(t) {
    BFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.kind = "ArithmeticException", e;
  }(hl)
), zFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), sl = (
  /** @class */
  function(t) {
    zFe(e, t);
    function e(n, r, i) {
      var a = t.call(this) || this;
      a.primitive = n, a.size = r, a.generatorBase = i;
      for (var s = new Int32Array(r), c = 1, d = 0; d < r; d++)
        s[d] = c, c *= 2, c >= r && (c ^= n, c &= r - 1);
      a.expTable = s;
      for (var f = new Int32Array(r), d = 0; d < r - 1; d++)
        f[s[d]] = d;
      return a.logTable = f, a.zero = new B0(a, Int32Array.from([0])), a.one = new B0(a, Int32Array.from([1])), a;
    }
    return e.prototype.getZero = function() {
      return this.zero;
    }, e.prototype.getOne = function() {
      return this.one;
    }, e.prototype.buildMonomial = function(n, r) {
      if (n < 0)
        throw new Yt();
      if (r === 0)
        return this.zero;
      var i = new Int32Array(n + 1);
      return i[0] = r, new B0(this, i);
    }, e.prototype.inverse = function(n) {
      if (n === 0)
        throw new xee();
      return this.expTable[this.size - this.logTable[n] - 1];
    }, e.prototype.multiply = function(n, r) {
      return n === 0 || r === 0 ? 0 : this.expTable[(this.logTable[n] + this.logTable[r]) % (this.size - 1)];
    }, e.prototype.getSize = function() {
      return this.size;
    }, e.prototype.getGeneratorBase = function() {
      return this.generatorBase;
    }, e.prototype.toString = function() {
      return "GF(0x" + Vn.toHexString(this.primitive) + "," + this.size + ")";
    }, e.prototype.equals = function(n) {
      return n === this;
    }, e.AZTEC_DATA_12 = new e(4201, 4096, 1), e.AZTEC_DATA_10 = new e(1033, 1024, 1), e.AZTEC_DATA_6 = new e(67, 64, 1), e.AZTEC_PARAM = new e(19, 16, 1), e.QR_CODE_FIELD_256 = new e(285, 256, 0), e.DATA_MATRIX_FIELD_256 = new e(301, 256, 1), e.AZTEC_DATA_8 = e.DATA_MATRIX_FIELD_256, e.MAXICODE_FIELD_64 = e.AZTEC_DATA_6, e;
  }(aE)
), FFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), QC = (
  /** @class */
  function(t) {
    FFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.kind = "ReedSolomonException", e;
  }(hl)
), VFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), X_ = (
  /** @class */
  function(t) {
    VFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.kind = "IllegalStateException", e;
  }(hl)
), DO = (
  /** @class */
  function() {
    function t(e) {
      this.field = e;
    }
    return t.prototype.decode = function(e, n) {
      for (var r = this.field, i = new B0(r, e), a = new Int32Array(n), s = !0, c = 0; c < n; c++) {
        var d = i.evaluateAt(r.exp(c + r.getGeneratorBase()));
        a[a.length - 1 - c] = d, d !== 0 && (s = !1);
      }
      if (!s)
        for (var f = new B0(r, a), g = this.runEuclideanAlgorithm(r.buildMonomial(n, 1), f, n), m = g[0], b = g[1], w = this.findErrorLocations(m), _ = this.findErrorMagnitudes(b, w), c = 0; c < w.length; c++) {
          var A = e.length - 1 - r.log(w[c]);
          if (A < 0)
            throw new QC("Bad error location");
          e[A] = sl.addOrSubtract(e[A], _[c]);
        }
    }, t.prototype.runEuclideanAlgorithm = function(e, n, r) {
      if (e.getDegree() < n.getDegree()) {
        var i = e;
        e = n, n = i;
      }
      for (var a = this.field, s = e, c = n, d = a.getZero(), f = a.getOne(); c.getDegree() >= (r / 2 | 0); ) {
        var g = s, m = d;
        if (s = c, d = f, s.isZero())
          throw new QC("r_{i-1} was zero");
        c = g;
        for (var b = a.getZero(), w = s.getCoefficient(s.getDegree()), _ = a.inverse(w); c.getDegree() >= s.getDegree() && !c.isZero(); ) {
          var A = c.getDegree() - s.getDegree(), T = a.multiply(c.getCoefficient(c.getDegree()), _);
          b = b.addOrSubtract(a.buildMonomial(A, T)), c = c.addOrSubtract(s.multiplyByMonomial(A, T));
        }
        if (f = b.multiply(d).addOrSubtract(m), c.getDegree() >= s.getDegree())
          throw new X_("Division algorithm failed to reduce polynomial?");
      }
      var O = f.getCoefficient(0);
      if (O === 0)
        throw new QC("sigmaTilde(0) was zero");
      var R = a.inverse(O), N = f.multiplyScalar(R), M = c.multiplyScalar(R);
      return [N, M];
    }, t.prototype.findErrorLocations = function(e) {
      var n = e.getDegree();
      if (n === 1)
        return Int32Array.from([e.getCoefficient(1)]);
      for (var r = new Int32Array(n), i = 0, a = this.field, s = 1; s < a.getSize() && i < n; s++)
        e.evaluateAt(s) === 0 && (r[i] = a.inverse(s), i++);
      if (i !== n)
        throw new QC("Error locator degree does not match number of roots");
      return r;
    }, t.prototype.findErrorMagnitudes = function(e, n) {
      for (var r = n.length, i = new Int32Array(r), a = this.field, s = 0; s < r; s++) {
        for (var c = a.inverse(n[s]), d = 1, f = 0; f < r; f++)
          if (s !== f) {
            var g = a.multiply(n[f], c), m = g & 1 ? g & -2 : g | 1;
            d = a.multiply(d, m);
          }
        i[s] = a.multiply(e.evaluateAt(c), a.inverse(d)), a.getGeneratorBase() !== 0 && (i[s] = a.multiply(i[s], c));
      }
      return i;
    }, t;
  }()
), No;
(function(t) {
  t[t.UPPER = 0] = "UPPER", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.DIGIT = 3] = "DIGIT", t[t.PUNCT = 4] = "PUNCT", t[t.BINARY = 5] = "BINARY";
})(No || (No = {}));
var LU = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.decode = function(e) {
      this.ddata = e;
      var n = e.getBits(), r = this.extractBits(n), i = this.correctBits(r), a = t.convertBoolArrayToByteArray(i), s = t.getEncodedData(i), c = new RO(a, s, null, null);
      return c.setNumBits(i.length), c;
    }, t.highLevelDecode = function(e) {
      return this.getEncodedData(e);
    }, t.getEncodedData = function(e) {
      for (var n = e.length, r = No.UPPER, i = No.UPPER, a = "", s = 0; s < n; )
        if (i === No.BINARY) {
          if (n - s < 5)
            break;
          var c = t.readCode(e, s, 5);
          if (s += 5, c === 0) {
            if (n - s < 11)
              break;
            c = t.readCode(e, s, 11) + 31, s += 11;
          }
          for (var d = 0; d < c; d++) {
            if (n - s < 8) {
              s = n;
              break;
            }
            var f = t.readCode(e, s, 8);
            a += /*(char)*/
            tr.castAsNonUtf8Char(f), s += 8;
          }
          i = r;
        } else {
          var g = i === No.DIGIT ? 4 : 5;
          if (n - s < g)
            break;
          var f = t.readCode(e, s, g);
          s += g;
          var m = t.getCharacter(i, f);
          m.startsWith("CTRL_") ? (r = i, i = t.getTable(m.charAt(5)), m.charAt(6) === "L" && (r = i)) : (a += m, i = r);
        }
      return a;
    }, t.getTable = function(e) {
      switch (e) {
        case "L":
          return No.LOWER;
        case "P":
          return No.PUNCT;
        case "M":
          return No.MIXED;
        case "D":
          return No.DIGIT;
        case "B":
          return No.BINARY;
        case "U":
        default:
          return No.UPPER;
      }
    }, t.getCharacter = function(e, n) {
      switch (e) {
        case No.UPPER:
          return t.UPPER_TABLE[n];
        case No.LOWER:
          return t.LOWER_TABLE[n];
        case No.MIXED:
          return t.MIXED_TABLE[n];
        case No.PUNCT:
          return t.PUNCT_TABLE[n];
        case No.DIGIT:
          return t.DIGIT_TABLE[n];
        default:
          throw new X_("Bad table");
      }
    }, t.prototype.correctBits = function(e) {
      var n, r;
      this.ddata.getNbLayers() <= 2 ? (r = 6, n = sl.AZTEC_DATA_6) : this.ddata.getNbLayers() <= 8 ? (r = 8, n = sl.AZTEC_DATA_8) : this.ddata.getNbLayers() <= 22 ? (r = 10, n = sl.AZTEC_DATA_10) : (r = 12, n = sl.AZTEC_DATA_12);
      var i = this.ddata.getNbDatablocks(), a = e.length / r;
      if (a < i)
        throw new ht();
      for (var s = e.length % r, c = new Int32Array(a), d = 0; d < a; d++, s += r)
        c[d] = t.readCode(e, s, r);
      try {
        var f = new DO(n);
        f.decode(c, a - i);
      } catch (T) {
        throw new ht(T);
      }
      for (var g = (1 << r) - 1, m = 0, d = 0; d < i; d++) {
        var b = c[d];
        if (b === 0 || b === g)
          throw new ht();
        (b === 1 || b === g - 1) && m++;
      }
      for (var w = new Array(i * r - m), _ = 0, d = 0; d < i; d++) {
        var b = c[d];
        if (b === 1 || b === g - 1)
          w.fill(b > 1, _, _ + r - 1), _ += r - 1;
        else
          for (var A = r - 1; A >= 0; --A)
            w[_++] = (b & 1 << A) !== 0;
      }
      return w;
    }, t.prototype.extractBits = function(e) {
      var n = this.ddata.isCompact(), r = this.ddata.getNbLayers(), i = (n ? 11 : 14) + r * 4, a = new Int32Array(i), s = new Array(this.totalBitsInLayer(r, n));
      if (n)
        for (var c = 0; c < a.length; c++)
          a[c] = c;
      else
        for (var d = i + 1 + 2 * Vn.truncDivision(Vn.truncDivision(i, 2) - 1, 15), f = i / 2, g = Vn.truncDivision(d, 2), c = 0; c < f; c++) {
          var m = c + Vn.truncDivision(c, 15);
          a[f - c - 1] = g - m - 1, a[f + c] = g + m + 1;
        }
      for (var c = 0, b = 0; c < r; c++) {
        for (var w = (r - c) * 4 + (n ? 9 : 12), _ = c * 2, A = i - 1 - _, T = 0; T < w; T++)
          for (var O = T * 2, R = 0; R < 2; R++)
            s[b + O + R] = e.get(a[_ + R], a[_ + T]), s[b + 2 * w + O + R] = e.get(a[_ + T], a[A - R]), s[b + 4 * w + O + R] = e.get(a[A - R], a[A - T]), s[b + 6 * w + O + R] = e.get(a[A - T], a[_ + R]);
        b += w * 8;
      }
      return s;
    }, t.readCode = function(e, n, r) {
      for (var i = 0, a = n; a < n + r; a++)
        i <<= 1, e[a] && (i |= 1);
      return i;
    }, t.readByte = function(e, n) {
      var r = e.length - n;
      return r >= 8 ? t.readCode(e, n, 8) : t.readCode(e, n, r) << 8 - r;
    }, t.convertBoolArrayToByteArray = function(e) {
      for (var n = new Uint8Array((e.length + 7) / 8), r = 0; r < n.length; r++)
        n[r] = t.readByte(e, 8 * r);
      return n;
    }, t.prototype.totalBitsInLayer = function(e, n) {
      return ((n ? 88 : 112) + 16 * e) * e;
    }, t.UPPER_TABLE = [
      "CTRL_PS",
      " ",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "CTRL_LL",
      "CTRL_ML",
      "CTRL_DL",
      "CTRL_BS"
    ], t.LOWER_TABLE = [
      "CTRL_PS",
      " ",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
      "CTRL_US",
      "CTRL_ML",
      "CTRL_DL",
      "CTRL_BS"
    ], t.MIXED_TABLE = [
      // Module parse failed: Octal literal in strict mode (50:29)
      // so number string were scaped
      "CTRL_PS",
      " ",
      "\\1",
      "\\2",
      "\\3",
      "\\4",
      "\\5",
      "\\6",
      "\\7",
      "\b",
      "	",
      `
`,
      "\\13",
      "\f",
      "\r",
      "\\33",
      "\\34",
      "\\35",
      "\\36",
      "\\37",
      "@",
      "\\",
      "^",
      "_",
      "`",
      "|",
      "~",
      "\\177",
      "CTRL_LL",
      "CTRL_UL",
      "CTRL_PL",
      "CTRL_BS"
    ], t.PUNCT_TABLE = [
      "",
      "\r",
      `\r
`,
      ". ",
      ", ",
      ": ",
      "!",
      '"',
      "#",
      "$",
      "%",
      "&",
      "'",
      "(",
      ")",
      "*",
      "+",
      ",",
      "-",
      ".",
      "/",
      ":",
      ";",
      "<",
      "=",
      ">",
      "?",
      "[",
      "]",
      "{",
      "}",
      "CTRL_UL"
    ], t.DIGIT_TABLE = [
      "CTRL_PS",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ",",
      ".",
      "CTRL_UL",
      "CTRL_US"
    ], t;
  }()
), gr = (
  /** @class */
  function() {
    function t() {
    }
    return t.round = function(e) {
      return isNaN(e) ? 0 : e <= Number.MIN_SAFE_INTEGER ? Number.MIN_SAFE_INTEGER : e >= Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : (
        /*(int) */
        e + (e < 0 ? -0.5 : 0.5) | 0
      );
    }, t.distance = function(e, n, r, i) {
      var a = e - r, s = n - i;
      return (
        /*(float) */
        Math.sqrt(a * a + s * s)
      );
    }, t.sum = function(e) {
      for (var n = 0, r = 0, i = e.length; r !== i; r++) {
        var a = e[r];
        n += a;
      }
      return n;
    }, t;
  }()
), iM = (
  /** @class */
  function() {
    function t() {
    }
    return t.floatToIntBits = function(e) {
      return e;
    }, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
  }()
), kt = (
  /** @class */
  function() {
    function t(e, n) {
      this.x = e, this.y = n;
    }
    return t.prototype.getX = function() {
      return this.x;
    }, t.prototype.getY = function() {
      return this.y;
    }, t.prototype.equals = function(e) {
      if (e instanceof t) {
        var n = e;
        return this.x === n.x && this.y === n.y;
      }
      return !1;
    }, t.prototype.hashCode = function() {
      return 31 * iM.floatToIntBits(this.x) + iM.floatToIntBits(this.y);
    }, t.prototype.toString = function() {
      return "(" + this.x + "," + this.y + ")";
    }, t.orderBestPatterns = function(e) {
      var n = this.distance(e[0], e[1]), r = this.distance(e[1], e[2]), i = this.distance(e[0], e[2]), a, s, c;
      if (r >= n && r >= i ? (s = e[0], a = e[1], c = e[2]) : i >= r && i >= n ? (s = e[1], a = e[0], c = e[2]) : (s = e[2], a = e[0], c = e[1]), this.crossProductZ(a, s, c) < 0) {
        var d = a;
        a = c, c = d;
      }
      e[0] = a, e[1] = s, e[2] = c;
    }, t.distance = function(e, n) {
      return gr.distance(e.x, e.y, n.x, n.y);
    }, t.crossProductZ = function(e, n, r) {
      var i = n.x, a = n.y;
      return (r.x - i) * (e.y - a) - (r.y - a) * (e.x - i);
    }, t;
  }()
), Gk = (
  /** @class */
  function() {
    function t(e, n) {
      this.bits = e, this.points = n;
    }
    return t.prototype.getBits = function() {
      return this.bits;
    }, t.prototype.getPoints = function() {
      return this.points;
    }, t;
  }()
), UFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), $Fe = (
  /** @class */
  function(t) {
    UFe(e, t);
    function e(n, r, i, a, s) {
      var c = t.call(this, n, r) || this;
      return c.compact = i, c.nbDatablocks = a, c.nbLayers = s, c;
    }
    return e.prototype.getNbLayers = function() {
      return this.nbLayers;
    }, e.prototype.getNbDatablocks = function() {
      return this.nbDatablocks;
    }, e.prototype.isCompact = function() {
      return this.compact;
    }, e;
  }(Gk)
), aM = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      this.image = e, this.height = e.getHeight(), this.width = e.getWidth(), n == null && (n = t.INIT_SIZE), r == null && (r = e.getWidth() / 2 | 0), i == null && (i = e.getHeight() / 2 | 0);
      var a = n / 2 | 0;
      if (this.leftInit = r - a, this.rightInit = r + a, this.upInit = i - a, this.downInit = i + a, this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width)
        throw new Ye();
    }
    return t.prototype.detect = function() {
      for (var e = this.leftInit, n = this.rightInit, r = this.upInit, i = this.downInit, a = !1, s = !0, c = !1, d = !1, f = !1, g = !1, m = !1, b = this.width, w = this.height; s; ) {
        s = !1;
        for (var _ = !0; (_ || !d) && n < b; )
          _ = this.containsBlackPoint(r, i, n, !1), _ ? (n++, s = !0, d = !0) : d || n++;
        if (n >= b) {
          a = !0;
          break;
        }
        for (var A = !0; (A || !f) && i < w; )
          A = this.containsBlackPoint(e, n, i, !0), A ? (i++, s = !0, f = !0) : f || i++;
        if (i >= w) {
          a = !0;
          break;
        }
        for (var T = !0; (T || !g) && e >= 0; )
          T = this.containsBlackPoint(r, i, e, !1), T ? (e--, s = !0, g = !0) : g || e--;
        if (e < 0) {
          a = !0;
          break;
        }
        for (var O = !0; (O || !m) && r >= 0; )
          O = this.containsBlackPoint(e, n, r, !0), O ? (r--, s = !0, m = !0) : m || r--;
        if (r < 0) {
          a = !0;
          break;
        }
        s && (c = !0);
      }
      if (!a && c) {
        for (var R = n - e, N = null, M = 1; N === null && M < R; M++)
          N = this.getBlackPointOnSegment(e, i - M, e + M, i);
        if (N == null)
          throw new Ye();
        for (var P = null, M = 1; P === null && M < R; M++)
          P = this.getBlackPointOnSegment(e, r + M, e + M, r);
        if (P == null)
          throw new Ye();
        for (var z = null, M = 1; z === null && M < R; M++)
          z = this.getBlackPointOnSegment(n, r + M, n - M, r);
        if (z == null)
          throw new Ye();
        for (var F = null, M = 1; F === null && M < R; M++)
          F = this.getBlackPointOnSegment(n, i - M, n - M, i);
        if (F == null)
          throw new Ye();
        return this.centerEdges(F, N, z, P);
      } else
        throw new Ye();
    }, t.prototype.getBlackPointOnSegment = function(e, n, r, i) {
      for (var a = gr.round(gr.distance(e, n, r, i)), s = (r - e) / a, c = (i - n) / a, d = this.image, f = 0; f < a; f++) {
        var g = gr.round(e + f * s), m = gr.round(n + f * c);
        if (d.get(g, m))
          return new kt(g, m);
      }
      return null;
    }, t.prototype.centerEdges = function(e, n, r, i) {
      var a = e.getX(), s = e.getY(), c = n.getX(), d = n.getY(), f = r.getX(), g = r.getY(), m = i.getX(), b = i.getY(), w = t.CORR;
      return a < this.width / 2 ? [
        new kt(m - w, b + w),
        new kt(c + w, d + w),
        new kt(f - w, g - w),
        new kt(a + w, s - w)
      ] : [
        new kt(m + w, b + w),
        new kt(c + w, d - w),
        new kt(f - w, g + w),
        new kt(a - w, s - w)
      ];
    }, t.prototype.containsBlackPoint = function(e, n, r, i) {
      var a = this.image;
      if (i) {
        for (var s = e; s <= n; s++)
          if (a.get(s, r))
            return !0;
      } else
        for (var c = e; c <= n; c++)
          if (a.get(r, c))
            return !0;
      return !1;
    }, t.INIT_SIZE = 10, t.CORR = 1, t;
  }()
), BU = (
  /** @class */
  function() {
    function t() {
    }
    return t.checkAndNudgePoints = function(e, n) {
      for (var r = e.getWidth(), i = e.getHeight(), a = !0, s = 0; s < n.length && a; s += 2) {
        var c = Math.floor(n[s]), d = Math.floor(n[s + 1]);
        if (c < -1 || c > r || d < -1 || d > i)
          throw new Ye();
        a = !1, c === -1 ? (n[s] = 0, a = !0) : c === r && (n[s] = r - 1, a = !0), d === -1 ? (n[s + 1] = 0, a = !0) : d === i && (n[s + 1] = i - 1, a = !0);
      }
      a = !0;
      for (var s = n.length - 2; s >= 0 && a; s -= 2) {
        var c = Math.floor(n[s]), d = Math.floor(n[s + 1]);
        if (c < -1 || c > r || d < -1 || d > i)
          throw new Ye();
        a = !1, c === -1 ? (n[s] = 0, a = !0) : c === r && (n[s] = r - 1, a = !0), d === -1 ? (n[s + 1] = 0, a = !0) : d === i && (n[s + 1] = i - 1, a = !0);
      }
    }, t;
  }()
), See = (
  /** @class */
  function() {
    function t(e, n, r, i, a, s, c, d, f) {
      this.a11 = e, this.a21 = n, this.a31 = r, this.a12 = i, this.a22 = a, this.a32 = s, this.a13 = c, this.a23 = d, this.a33 = f;
    }
    return t.quadrilateralToQuadrilateral = function(e, n, r, i, a, s, c, d, f, g, m, b, w, _, A, T) {
      var O = t.quadrilateralToSquare(e, n, r, i, a, s, c, d), R = t.squareToQuadrilateral(f, g, m, b, w, _, A, T);
      return R.times(O);
    }, t.prototype.transformPoints = function(e) {
      for (var n = e.length, r = this.a11, i = this.a12, a = this.a13, s = this.a21, c = this.a22, d = this.a23, f = this.a31, g = this.a32, m = this.a33, b = 0; b < n; b += 2) {
        var w = e[b], _ = e[b + 1], A = a * w + d * _ + m;
        e[b] = (r * w + s * _ + f) / A, e[b + 1] = (i * w + c * _ + g) / A;
      }
    }, t.prototype.transformPointsWithValues = function(e, n) {
      for (var r = this.a11, i = this.a12, a = this.a13, s = this.a21, c = this.a22, d = this.a23, f = this.a31, g = this.a32, m = this.a33, b = e.length, w = 0; w < b; w++) {
        var _ = e[w], A = n[w], T = a * _ + d * A + m;
        e[w] = (r * _ + s * A + f) / T, n[w] = (i * _ + c * A + g) / T;
      }
    }, t.squareToQuadrilateral = function(e, n, r, i, a, s, c, d) {
      var f = e - r + a - c, g = n - i + s - d;
      if (f === 0 && g === 0)
        return new t(r - e, a - r, e, i - n, s - i, n, 0, 0, 1);
      var m = r - a, b = c - a, w = i - s, _ = d - s, A = m * _ - b * w, T = (f * _ - b * g) / A, O = (m * g - f * w) / A;
      return new t(r - e + T * r, c - e + O * c, e, i - n + T * i, d - n + O * d, n, T, O, 1);
    }, t.quadrilateralToSquare = function(e, n, r, i, a, s, c, d) {
      return t.squareToQuadrilateral(e, n, r, i, a, s, c, d).buildAdjoint();
    }, t.prototype.buildAdjoint = function() {
      return new t(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
    }, t.prototype.times = function(e) {
      return new t(this.a11 * e.a11 + this.a21 * e.a12 + this.a31 * e.a13, this.a11 * e.a21 + this.a21 * e.a22 + this.a31 * e.a23, this.a11 * e.a31 + this.a21 * e.a32 + this.a31 * e.a33, this.a12 * e.a11 + this.a22 * e.a12 + this.a32 * e.a13, this.a12 * e.a21 + this.a22 * e.a22 + this.a32 * e.a23, this.a12 * e.a31 + this.a22 * e.a32 + this.a32 * e.a33, this.a13 * e.a11 + this.a23 * e.a12 + this.a33 * e.a13, this.a13 * e.a21 + this.a23 * e.a22 + this.a33 * e.a23, this.a13 * e.a31 + this.a23 * e.a32 + this.a33 * e.a33);
    }, t;
  }()
), HFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), qFe = (
  /** @class */
  function(t) {
    HFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.sampleGrid = function(n, r, i, a, s, c, d, f, g, m, b, w, _, A, T, O, R, N, M) {
      var P = See.quadrilateralToQuadrilateral(a, s, c, d, f, g, m, b, w, _, A, T, O, R, N, M);
      return this.sampleGridWithTransform(n, r, i, P);
    }, e.prototype.sampleGridWithTransform = function(n, r, i, a) {
      if (r <= 0 || i <= 0)
        throw new Ye();
      for (var s = new sf(r, i), c = new Float32Array(2 * r), d = 0; d < i; d++) {
        for (var f = c.length, g = d + 0.5, m = 0; m < f; m += 2)
          c[m] = m / 2 + 0.5, c[m + 1] = g;
        a.transformPoints(c), BU.checkAndNudgePoints(n, c);
        try {
          for (var m = 0; m < f; m += 2)
            n.get(Math.floor(c[m]), Math.floor(c[m + 1])) && s.set(m / 2, d);
        } catch {
          throw new Ye();
        }
      }
      return s;
    }, e;
  }(BU)
), Yk = (
  /** @class */
  function() {
    function t() {
    }
    return t.setGridSampler = function(e) {
      t.gridSampler = e;
    }, t.getInstance = function() {
      return t.gridSampler;
    }, t.gridSampler = new qFe(), t;
  }()
), tl = (
  /** @class */
  function() {
    function t(e, n) {
      this.x = e, this.y = n;
    }
    return t.prototype.toResultPoint = function() {
      return new kt(this.getX(), this.getY());
    }, t.prototype.getX = function() {
      return this.x;
    }, t.prototype.getY = function() {
      return this.y;
    }, t;
  }()
), GFe = (
  /** @class */
  function() {
    function t(e) {
      this.EXPECTED_CORNER_BITS = new Int32Array([
        3808,
        476,
        2107,
        1799
      ]), this.image = e;
    }
    return t.prototype.detect = function() {
      return this.detectMirror(!1);
    }, t.prototype.detectMirror = function(e) {
      var n = this.getMatrixCenter(), r = this.getBullsEyeCorners(n);
      if (e) {
        var i = r[0];
        r[0] = r[2], r[2] = i;
      }
      this.extractParameters(r);
      var a = this.sampleGrid(this.image, r[this.shift % 4], r[(this.shift + 1) % 4], r[(this.shift + 2) % 4], r[(this.shift + 3) % 4]), s = this.getMatrixCornerPoints(r);
      return new $Fe(a, s, this.compact, this.nbDataBlocks, this.nbLayers);
    }, t.prototype.extractParameters = function(e) {
      if (!this.isValidPoint(e[0]) || !this.isValidPoint(e[1]) || !this.isValidPoint(e[2]) || !this.isValidPoint(e[3]))
        throw new Ye();
      var n = 2 * this.nbCenterLayers, r = new Int32Array([
        this.sampleLine(e[0], e[1], n),
        this.sampleLine(e[1], e[2], n),
        this.sampleLine(e[2], e[3], n),
        this.sampleLine(e[3], e[0], n)
        // Top
      ]);
      this.shift = this.getRotation(r, n);
      for (var i = 0, a = 0; a < 4; a++) {
        var s = r[(this.shift + a) % 4];
        this.compact ? (i <<= 7, i += s >> 1 & 127) : (i <<= 10, i += (s >> 2 & 992) + (s >> 1 & 31));
      }
      var c = this.getCorrectedParameterData(i, this.compact);
      this.compact ? (this.nbLayers = (c >> 6) + 1, this.nbDataBlocks = (c & 63) + 1) : (this.nbLayers = (c >> 11) + 1, this.nbDataBlocks = (c & 2047) + 1);
    }, t.prototype.getRotation = function(e, n) {
      var r = 0;
      e.forEach(function(a, s, c) {
        var d = (a >> n - 2 << 1) + (a & 1);
        r = (r << 3) + d;
      }), r = ((r & 1) << 11) + (r >> 1);
      for (var i = 0; i < 4; i++)
        if (Vn.bitCount(r ^ this.EXPECTED_CORNER_BITS[i]) <= 2)
          return i;
      throw new Ye();
    }, t.prototype.getCorrectedParameterData = function(e, n) {
      var r, i;
      n ? (r = 7, i = 2) : (r = 10, i = 4);
      for (var a = r - i, s = new Int32Array(r), c = r - 1; c >= 0; --c)
        s[c] = e & 15, e >>= 4;
      try {
        var d = new DO(sl.AZTEC_PARAM);
        d.decode(s, a);
      } catch {
        throw new Ye();
      }
      for (var f = 0, c = 0; c < i; c++)
        f = (f << 4) + s[c];
      return f;
    }, t.prototype.getBullsEyeCorners = function(e) {
      var n = e, r = e, i = e, a = e, s = !0;
      for (this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++) {
        var c = this.getFirstDifferent(n, s, 1, -1), d = this.getFirstDifferent(r, s, 1, 1), f = this.getFirstDifferent(i, s, -1, 1), g = this.getFirstDifferent(a, s, -1, -1);
        if (this.nbCenterLayers > 2) {
          var m = this.distancePoint(g, c) * this.nbCenterLayers / (this.distancePoint(a, n) * (this.nbCenterLayers + 2));
          if (m < 0.75 || m > 1.25 || !this.isWhiteOrBlackRectangle(c, d, f, g))
            break;
        }
        n = c, r = d, i = f, a = g, s = !s;
      }
      if (this.nbCenterLayers !== 5 && this.nbCenterLayers !== 7)
        throw new Ye();
      this.compact = this.nbCenterLayers === 5;
      var b = new kt(n.getX() + 0.5, n.getY() - 0.5), w = new kt(r.getX() + 0.5, r.getY() + 0.5), _ = new kt(i.getX() - 0.5, i.getY() + 0.5), A = new kt(a.getX() - 0.5, a.getY() - 0.5);
      return this.expandSquare([b, w, _, A], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
    }, t.prototype.getMatrixCenter = function() {
      var e, n, r, i;
      try {
        var a = new aM(this.image).detect();
        e = a[0], n = a[1], r = a[2], i = a[3];
      } catch {
        var s = this.image.getWidth() / 2, c = this.image.getHeight() / 2;
        e = this.getFirstDifferent(new tl(s + 7, c - 7), !1, 1, -1).toResultPoint(), n = this.getFirstDifferent(new tl(s + 7, c + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new tl(s - 7, c + 7), !1, -1, 1).toResultPoint(), i = this.getFirstDifferent(new tl(s - 7, c - 7), !1, -1, -1).toResultPoint();
      }
      var d = gr.round((e.getX() + i.getX() + n.getX() + r.getX()) / 4), f = gr.round((e.getY() + i.getY() + n.getY() + r.getY()) / 4);
      try {
        var a = new aM(this.image, 15, d, f).detect();
        e = a[0], n = a[1], r = a[2], i = a[3];
      } catch {
        e = this.getFirstDifferent(new tl(d + 7, f - 7), !1, 1, -1).toResultPoint(), n = this.getFirstDifferent(new tl(d + 7, f + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new tl(d - 7, f + 7), !1, -1, 1).toResultPoint(), i = this.getFirstDifferent(new tl(d - 7, f - 7), !1, -1, -1).toResultPoint();
      }
      return d = gr.round((e.getX() + i.getX() + n.getX() + r.getX()) / 4), f = gr.round((e.getY() + i.getY() + n.getY() + r.getY()) / 4), new tl(d, f);
    }, t.prototype.getMatrixCornerPoints = function(e) {
      return this.expandSquare(e, 2 * this.nbCenterLayers, this.getDimension());
    }, t.prototype.sampleGrid = function(e, n, r, i, a) {
      var s = Yk.getInstance(), c = this.getDimension(), d = c / 2 - this.nbCenterLayers, f = c / 2 + this.nbCenterLayers;
      return s.sampleGrid(
        e,
        c,
        c,
        d,
        d,
        // topleft
        f,
        d,
        // topright
        f,
        f,
        // bottomright
        d,
        f,
        // bottomleft
        n.getX(),
        n.getY(),
        r.getX(),
        r.getY(),
        i.getX(),
        i.getY(),
        a.getX(),
        a.getY()
      );
    }, t.prototype.sampleLine = function(e, n, r) {
      for (var i = 0, a = this.distanceResultPoint(e, n), s = a / r, c = e.getX(), d = e.getY(), f = s * (n.getX() - e.getX()) / a, g = s * (n.getY() - e.getY()) / a, m = 0; m < r; m++)
        this.image.get(gr.round(c + m * f), gr.round(d + m * g)) && (i |= 1 << r - m - 1);
      return i;
    }, t.prototype.isWhiteOrBlackRectangle = function(e, n, r, i) {
      var a = 3;
      e = new tl(e.getX() - a, e.getY() + a), n = new tl(n.getX() - a, n.getY() - a), r = new tl(r.getX() + a, r.getY() - a), i = new tl(i.getX() + a, i.getY() + a);
      var s = this.getColor(i, e);
      if (s === 0)
        return !1;
      var c = this.getColor(e, n);
      return c !== s || (c = this.getColor(n, r), c !== s) ? !1 : (c = this.getColor(r, i), c === s);
    }, t.prototype.getColor = function(e, n) {
      for (var r = this.distancePoint(e, n), i = (n.getX() - e.getX()) / r, a = (n.getY() - e.getY()) / r, s = 0, c = e.getX(), d = e.getY(), f = this.image.get(e.getX(), e.getY()), g = Math.ceil(r), m = 0; m < g; m++)
        c += i, d += a, this.image.get(gr.round(c), gr.round(d)) !== f && s++;
      var b = s / r;
      return b > 0.1 && b < 0.9 ? 0 : b <= 0.1 === f ? 1 : -1;
    }, t.prototype.getFirstDifferent = function(e, n, r, i) {
      for (var a = e.getX() + r, s = e.getY() + i; this.isValid(a, s) && this.image.get(a, s) === n; )
        a += r, s += i;
      for (a -= r, s -= i; this.isValid(a, s) && this.image.get(a, s) === n; )
        a += r;
      for (a -= r; this.isValid(a, s) && this.image.get(a, s) === n; )
        s += i;
      return s -= i, new tl(a, s);
    }, t.prototype.expandSquare = function(e, n, r) {
      var i = r / (2 * n), a = e[0].getX() - e[2].getX(), s = e[0].getY() - e[2].getY(), c = (e[0].getX() + e[2].getX()) / 2, d = (e[0].getY() + e[2].getY()) / 2, f = new kt(c + i * a, d + i * s), g = new kt(c - i * a, d - i * s);
      a = e[1].getX() - e[3].getX(), s = e[1].getY() - e[3].getY(), c = (e[1].getX() + e[3].getX()) / 2, d = (e[1].getY() + e[3].getY()) / 2;
      var m = new kt(c + i * a, d + i * s), b = new kt(c - i * a, d - i * s), w = [f, m, g, b];
      return w;
    }, t.prototype.isValid = function(e, n) {
      return e >= 0 && e < this.image.getWidth() && n > 0 && n < this.image.getHeight();
    }, t.prototype.isValidPoint = function(e) {
      var n = gr.round(e.getX()), r = gr.round(e.getY());
      return this.isValid(n, r);
    }, t.prototype.distancePoint = function(e, n) {
      return gr.distance(e.getX(), e.getY(), n.getX(), n.getY());
    }, t.prototype.distanceResultPoint = function(e, n) {
      return gr.distance(e.getX(), e.getY(), n.getX(), n.getY());
    }, t.prototype.getDimension = function() {
      return this.compact ? 4 * this.nbLayers + 11 : this.nbLayers <= 4 ? 4 * this.nbLayers + 15 : 4 * this.nbLayers + 2 * (Vn.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
    }, t;
  }()
), oM = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.decode = function(e, n) {
      n === void 0 && (n = null);
      var r = null, i = new GFe(e.getBlackMatrix()), a = null, s = null;
      try {
        var c = i.detectMirror(!1);
        a = c.getPoints(), this.reportFoundResultPoints(n, a), s = new LU().decode(c);
      } catch (m) {
        r = m;
      }
      if (s == null)
        try {
          var c = i.detectMirror(!0);
          a = c.getPoints(), this.reportFoundResultPoints(n, a), s = new LU().decode(c);
        } catch (m) {
          throw r ?? m;
        }
      var d = new ts(s.getText(), s.getRawBytes(), s.getNumBits(), a, Ht.AZTEC, si.currentTimeMillis()), f = s.getByteSegments();
      f != null && d.putMetadata(jo.BYTE_SEGMENTS, f);
      var g = s.getECLevel();
      return g != null && d.putMetadata(jo.ERROR_CORRECTION_LEVEL, g), d;
    }, t.prototype.reportFoundResultPoints = function(e, n) {
      if (e != null) {
        var r = e.get(Ui.NEED_RESULT_POINT_CALLBACK);
        r != null && n.forEach(function(i, a, s) {
          r.foundPossibleResultPoint(i);
        });
      }
    }, t.prototype.reset = function() {
    }, t;
  }()
), YFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}();
(function(t) {
  YFe(e, t);
  function e(n) {
    return n === void 0 && (n = 500), t.call(this, new oM(), n) || this;
  }
  return e;
})(Rw);
var Ga = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.decode = function(e, n) {
      try {
        return this.doDecode(e, n);
      } catch {
        var r = n && n.get(Ui.TRY_HARDER) === !0;
        if (r && e.isRotateSupported()) {
          var i = e.rotateCounterClockwise(), a = this.doDecode(i, n), s = a.getResultMetadata(), c = 270;
          s !== null && s.get(jo.ORIENTATION) === !0 && (c = c + s.get(jo.ORIENTATION) % 360), a.putMetadata(jo.ORIENTATION, c);
          var d = a.getResultPoints();
          if (d !== null)
            for (var f = i.getHeight(), g = 0; g < d.length; g++)
              d[g] = new kt(f - d[g].getY() - 1, d[g].getX());
          return a;
        } else
          throw new Ye();
      }
    }, t.prototype.reset = function() {
    }, t.prototype.doDecode = function(e, n) {
      var r = e.getWidth(), i = e.getHeight(), a = new fo(r), s = n && n.get(Ui.TRY_HARDER) === !0, c = Math.max(1, i >> (s ? 8 : 5)), d;
      s ? d = i : d = 15;
      for (var f = Math.trunc(i / 2), g = 0; g < d; g++) {
        var m = Math.trunc((g + 1) / 2), b = (g & 1) === 0, w = f + c * (b ? m : -m);
        if (w < 0 || w >= i)
          break;
        try {
          a = e.getBlackRow(w, a);
        } catch {
          continue;
        }
        for (var _ = function(R) {
          if (R === 1 && (a.reverse(), n && n.get(Ui.NEED_RESULT_POINT_CALLBACK) === !0)) {
            var N = /* @__PURE__ */ new Map();
            n.forEach(function(z, F) {
              return N.set(F, z);
            }), N.delete(Ui.NEED_RESULT_POINT_CALLBACK), n = N;
          }
          try {
            var M = A.decodeRow(w, a, n);
            if (R === 1) {
              M.putMetadata(jo.ORIENTATION, 180);
              var P = M.getResultPoints();
              P !== null && (P[0] = new kt(r - P[0].getX() - 1, P[0].getY()), P[1] = new kt(r - P[1].getX() - 1, P[1].getY()));
            }
            return { value: M };
          } catch {
          }
        }, A = this, T = 0; T < 2; T++) {
          var O = _(T);
          if (typeof O == "object")
            return O.value;
        }
      }
      throw new Ye();
    }, t.recordPattern = function(e, n, r) {
      for (var i = r.length, a = 0; a < i; a++)
        r[a] = 0;
      var s = e.getSize();
      if (n >= s)
        throw new Ye();
      for (var c = !e.get(n), d = 0, f = n; f < s; ) {
        if (e.get(f) !== c)
          r[d]++;
        else {
          if (++d === i)
            break;
          r[d] = 1, c = !c;
        }
        f++;
      }
      if (!(d === i || d === i - 1 && f === s))
        throw new Ye();
    }, t.recordPatternInReverse = function(e, n, r) {
      for (var i = r.length, a = e.get(n); n > 0 && i >= 0; )
        e.get(--n) !== a && (i--, a = !a);
      if (i >= 0)
        throw new Ye();
      t.recordPattern(e, n + 1, r);
    }, t.patternMatchVariance = function(e, n, r) {
      for (var i = e.length, a = 0, s = 0, c = 0; c < i; c++)
        a += e[c], s += n[c];
      if (a < s)
        return Number.POSITIVE_INFINITY;
      var d = a / s;
      r *= d;
      for (var f = 0, g = 0; g < i; g++) {
        var m = e[g], b = n[g] * d, w = m > b ? m - b : b - m;
        if (w > r)
          return Number.POSITIVE_INFINITY;
        f += w;
      }
      return f / a;
    }, t;
  }()
), XFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), zU = (
  /** @class */
  function(t) {
    XFe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.findStartPattern = function(n) {
      for (var r = n.getSize(), i = n.getNextSet(0), a = 0, s = Int32Array.from([0, 0, 0, 0, 0, 0]), c = i, d = !1, f = 6, g = i; g < r; g++)
        if (n.get(g) !== d)
          s[a]++;
        else {
          if (a === f - 1) {
            for (var m = e.MAX_AVG_VARIANCE, b = -1, w = e.CODE_START_A; w <= e.CODE_START_C; w++) {
              var _ = Ga.patternMatchVariance(s, e.CODE_PATTERNS[w], e.MAX_INDIVIDUAL_VARIANCE);
              _ < m && (m = _, b = w);
            }
            if (b >= 0 && n.isRange(Math.max(0, c - (g - c) / 2), c, !1))
              return Int32Array.from([c, g, b]);
            c += s[0] + s[1], s = s.slice(2, s.length - 1), s[a - 1] = 0, s[a] = 0, a--;
          } else
            a++;
          s[a] = 1, d = !d;
        }
      throw new Ye();
    }, e.decodeCode = function(n, r, i) {
      Ga.recordPattern(n, i, r);
      for (var a = e.MAX_AVG_VARIANCE, s = -1, c = 0; c < e.CODE_PATTERNS.length; c++) {
        var d = e.CODE_PATTERNS[c], f = this.patternMatchVariance(r, d, e.MAX_INDIVIDUAL_VARIANCE);
        f < a && (a = f, s = c);
      }
      if (s >= 0)
        return s;
      throw new Ye();
    }, e.prototype.decodeRow = function(n, r, i) {
      var a = i && i.get(Ui.ASSUME_GS1) === !0, s = e.findStartPattern(r), c = s[2], d = 0, f = new Uint8Array(20);
      f[d++] = c;
      var g;
      switch (c) {
        case e.CODE_START_A:
          g = e.CODE_CODE_A;
          break;
        case e.CODE_START_B:
          g = e.CODE_CODE_B;
          break;
        case e.CODE_START_C:
          g = e.CODE_CODE_C;
          break;
        default:
          throw new ht();
      }
      for (var m = !1, b = !1, w = "", _ = s[0], A = s[1], T = Int32Array.from([0, 0, 0, 0, 0, 0]), O = 0, R = 0, N = c, M = 0, P = !0, z = !1, F = !1; !m; ) {
        var $ = b;
        switch (b = !1, O = R, R = e.decodeCode(r, T, A), f[d++] = R, R !== e.CODE_STOP && (P = !0), R !== e.CODE_STOP && (M++, N += M * R), _ = A, A += T.reduce(function(q, W) {
          return q + W;
        }, 0), R) {
          case e.CODE_START_A:
          case e.CODE_START_B:
          case e.CODE_START_C:
            throw new ht();
        }
        switch (g) {
          case e.CODE_CODE_A:
            if (R < 64)
              F === z ? w += String.fromCharCode(" ".charCodeAt(0) + R) : w += String.fromCharCode(" ".charCodeAt(0) + R + 128), F = !1;
            else if (R < 96)
              F === z ? w += String.fromCharCode(R - 64) : w += String.fromCharCode(R + 64), F = !1;
            else
              switch (R !== e.CODE_STOP && (P = !1), R) {
                case e.CODE_FNC_1:
                  a && (w.length === 0 ? w += "]C1" : w += String.fromCharCode(29));
                  break;
                case e.CODE_FNC_2:
                case e.CODE_FNC_3:
                  break;
                case e.CODE_FNC_4_A:
                  !z && F ? (z = !0, F = !1) : z && F ? (z = !1, F = !1) : F = !0;
                  break;
                case e.CODE_SHIFT:
                  b = !0, g = e.CODE_CODE_B;
                  break;
                case e.CODE_CODE_B:
                  g = e.CODE_CODE_B;
                  break;
                case e.CODE_CODE_C:
                  g = e.CODE_CODE_C;
                  break;
                case e.CODE_STOP:
                  m = !0;
                  break;
              }
            break;
          case e.CODE_CODE_B:
            if (R < 96)
              F === z ? w += String.fromCharCode(" ".charCodeAt(0) + R) : w += String.fromCharCode(" ".charCodeAt(0) + R + 128), F = !1;
            else
              switch (R !== e.CODE_STOP && (P = !1), R) {
                case e.CODE_FNC_1:
                  a && (w.length === 0 ? w += "]C1" : w += String.fromCharCode(29));
                  break;
                case e.CODE_FNC_2:
                case e.CODE_FNC_3:
                  break;
                case e.CODE_FNC_4_B:
                  !z && F ? (z = !0, F = !1) : z && F ? (z = !1, F = !1) : F = !0;
                  break;
                case e.CODE_SHIFT:
                  b = !0, g = e.CODE_CODE_A;
                  break;
                case e.CODE_CODE_A:
                  g = e.CODE_CODE_A;
                  break;
                case e.CODE_CODE_C:
                  g = e.CODE_CODE_C;
                  break;
                case e.CODE_STOP:
                  m = !0;
                  break;
              }
            break;
          case e.CODE_CODE_C:
            if (R < 100)
              R < 10 && (w += "0"), w += R;
            else
              switch (R !== e.CODE_STOP && (P = !1), R) {
                case e.CODE_FNC_1:
                  a && (w.length === 0 ? w += "]C1" : w += String.fromCharCode(29));
                  break;
                case e.CODE_CODE_A:
                  g = e.CODE_CODE_A;
                  break;
                case e.CODE_CODE_B:
                  g = e.CODE_CODE_B;
                  break;
                case e.CODE_STOP:
                  m = !0;
                  break;
              }
            break;
        }
        $ && (g = g === e.CODE_CODE_A ? e.CODE_CODE_B : e.CODE_CODE_A);
      }
      var G = A - _;
      if (A = r.getNextUnset(A), !r.isRange(A, Math.min(r.getSize(), A + (A - _) / 2), !1))
        throw new Ye();
      if (N -= M * O, N % 103 !== O)
        throw new uo();
      var H = w.length;
      if (H === 0)
        throw new Ye();
      H > 0 && P && (g === e.CODE_CODE_C ? w = w.substring(0, H - 2) : w = w.substring(0, H - 1));
      for (var Z = (s[1] + s[0]) / 2, V = _ + G / 2, Y = f.length, ee = new Uint8Array(Y), K = 0; K < Y; K++)
        ee[K] = f[K];
      var U = [new kt(Z, n), new kt(V, n)];
      return new ts(w, ee, 0, U, Ht.CODE_128, (/* @__PURE__ */ new Date()).getTime());
    }, e.CODE_PATTERNS = [
      Int32Array.from([2, 1, 2, 2, 2, 2]),
      Int32Array.from([2, 2, 2, 1, 2, 2]),
      Int32Array.from([2, 2, 2, 2, 2, 1]),
      Int32Array.from([1, 2, 1, 2, 2, 3]),
      Int32Array.from([1, 2, 1, 3, 2, 2]),
      Int32Array.from([1, 3, 1, 2, 2, 2]),
      Int32Array.from([1, 2, 2, 2, 1, 3]),
      Int32Array.from([1, 2, 2, 3, 1, 2]),
      Int32Array.from([1, 3, 2, 2, 1, 2]),
      Int32Array.from([2, 2, 1, 2, 1, 3]),
      Int32Array.from([2, 2, 1, 3, 1, 2]),
      Int32Array.from([2, 3, 1, 2, 1, 2]),
      Int32Array.from([1, 1, 2, 2, 3, 2]),
      Int32Array.from([1, 2, 2, 1, 3, 2]),
      Int32Array.from([1, 2, 2, 2, 3, 1]),
      Int32Array.from([1, 1, 3, 2, 2, 2]),
      Int32Array.from([1, 2, 3, 1, 2, 2]),
      Int32Array.from([1, 2, 3, 2, 2, 1]),
      Int32Array.from([2, 2, 3, 2, 1, 1]),
      Int32Array.from([2, 2, 1, 1, 3, 2]),
      Int32Array.from([2, 2, 1, 2, 3, 1]),
      Int32Array.from([2, 1, 3, 2, 1, 2]),
      Int32Array.from([2, 2, 3, 1, 1, 2]),
      Int32Array.from([3, 1, 2, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 2, 2, 2]),
      Int32Array.from([3, 2, 1, 1, 2, 2]),
      Int32Array.from([3, 2, 1, 2, 2, 1]),
      Int32Array.from([3, 1, 2, 2, 1, 2]),
      Int32Array.from([3, 2, 2, 1, 1, 2]),
      Int32Array.from([3, 2, 2, 2, 1, 1]),
      Int32Array.from([2, 1, 2, 1, 2, 3]),
      Int32Array.from([2, 1, 2, 3, 2, 1]),
      Int32Array.from([2, 3, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 1, 3, 2, 3]),
      Int32Array.from([1, 3, 1, 1, 2, 3]),
      Int32Array.from([1, 3, 1, 3, 2, 1]),
      Int32Array.from([1, 1, 2, 3, 1, 3]),
      Int32Array.from([1, 3, 2, 1, 1, 3]),
      Int32Array.from([1, 3, 2, 3, 1, 1]),
      Int32Array.from([2, 1, 1, 3, 1, 3]),
      Int32Array.from([2, 3, 1, 1, 1, 3]),
      Int32Array.from([2, 3, 1, 3, 1, 1]),
      Int32Array.from([1, 1, 2, 1, 3, 3]),
      Int32Array.from([1, 1, 2, 3, 3, 1]),
      Int32Array.from([1, 3, 2, 1, 3, 1]),
      Int32Array.from([1, 1, 3, 1, 2, 3]),
      Int32Array.from([1, 1, 3, 3, 2, 1]),
      Int32Array.from([1, 3, 3, 1, 2, 1]),
      Int32Array.from([3, 1, 3, 1, 2, 1]),
      Int32Array.from([2, 1, 1, 3, 3, 1]),
      Int32Array.from([2, 3, 1, 1, 3, 1]),
      Int32Array.from([2, 1, 3, 1, 1, 3]),
      Int32Array.from([2, 1, 3, 3, 1, 1]),
      Int32Array.from([2, 1, 3, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 2, 3]),
      Int32Array.from([3, 1, 1, 3, 2, 1]),
      Int32Array.from([3, 3, 1, 1, 2, 1]),
      Int32Array.from([3, 1, 2, 1, 1, 3]),
      Int32Array.from([3, 1, 2, 3, 1, 1]),
      Int32Array.from([3, 3, 2, 1, 1, 1]),
      Int32Array.from([3, 1, 4, 1, 1, 1]),
      Int32Array.from([2, 2, 1, 4, 1, 1]),
      Int32Array.from([4, 3, 1, 1, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 2, 4]),
      Int32Array.from([1, 1, 1, 4, 2, 2]),
      Int32Array.from([1, 2, 1, 1, 2, 4]),
      Int32Array.from([1, 2, 1, 4, 2, 1]),
      Int32Array.from([1, 4, 1, 1, 2, 2]),
      Int32Array.from([1, 4, 1, 2, 2, 1]),
      Int32Array.from([1, 1, 2, 2, 1, 4]),
      Int32Array.from([1, 1, 2, 4, 1, 2]),
      Int32Array.from([1, 2, 2, 1, 1, 4]),
      Int32Array.from([1, 2, 2, 4, 1, 1]),
      Int32Array.from([1, 4, 2, 1, 1, 2]),
      Int32Array.from([1, 4, 2, 2, 1, 1]),
      Int32Array.from([2, 4, 1, 2, 1, 1]),
      Int32Array.from([2, 2, 1, 1, 1, 4]),
      Int32Array.from([4, 1, 3, 1, 1, 1]),
      Int32Array.from([2, 4, 1, 1, 1, 2]),
      Int32Array.from([1, 3, 4, 1, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 4, 2]),
      Int32Array.from([1, 2, 1, 1, 4, 2]),
      Int32Array.from([1, 2, 1, 2, 4, 1]),
      Int32Array.from([1, 1, 4, 2, 1, 2]),
      Int32Array.from([1, 2, 4, 1, 1, 2]),
      Int32Array.from([1, 2, 4, 2, 1, 1]),
      Int32Array.from([4, 1, 1, 2, 1, 2]),
      Int32Array.from([4, 2, 1, 1, 1, 2]),
      Int32Array.from([4, 2, 1, 2, 1, 1]),
      Int32Array.from([2, 1, 2, 1, 4, 1]),
      Int32Array.from([2, 1, 4, 1, 2, 1]),
      Int32Array.from([4, 1, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 1, 1, 4, 3]),
      Int32Array.from([1, 1, 1, 3, 4, 1]),
      Int32Array.from([1, 3, 1, 1, 4, 1]),
      Int32Array.from([1, 1, 4, 1, 1, 3]),
      Int32Array.from([1, 1, 4, 3, 1, 1]),
      Int32Array.from([4, 1, 1, 1, 1, 3]),
      Int32Array.from([4, 1, 1, 3, 1, 1]),
      Int32Array.from([1, 1, 3, 1, 4, 1]),
      Int32Array.from([1, 1, 4, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 4, 1]),
      Int32Array.from([4, 1, 1, 1, 3, 1]),
      Int32Array.from([2, 1, 1, 4, 1, 2]),
      Int32Array.from([2, 1, 1, 2, 1, 4]),
      Int32Array.from([2, 1, 1, 2, 3, 2]),
      Int32Array.from([2, 3, 3, 1, 1, 1, 2])
    ], e.MAX_AVG_VARIANCE = 0.25, e.MAX_INDIVIDUAL_VARIANCE = 0.7, e.CODE_SHIFT = 98, e.CODE_CODE_C = 99, e.CODE_CODE_B = 100, e.CODE_CODE_A = 101, e.CODE_FNC_1 = 102, e.CODE_FNC_2 = 97, e.CODE_FNC_3 = 96, e.CODE_FNC_4_A = 101, e.CODE_FNC_4_B = 100, e.CODE_START_A = 103, e.CODE_START_B = 104, e.CODE_START_C = 105, e.CODE_STOP = 106, e;
  }(Ga)
), WFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ID = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, FU = (
  /** @class */
  function(t) {
    WFe(e, t);
    function e(n, r) {
      n === void 0 && (n = !1), r === void 0 && (r = !1);
      var i = t.call(this) || this;
      return i.usingCheckDigit = n, i.extendedMode = r, i.decodeRowResult = "", i.counters = new Int32Array(9), i;
    }
    return e.prototype.decodeRow = function(n, r, i) {
      var a, s, c, d, f = this.counters;
      f.fill(0), this.decodeRowResult = "";
      var g = e.findAsteriskPattern(r, f), m = r.getNextSet(g[1]), b = r.getSize(), w, _;
      do {
        e.recordPattern(r, m, f);
        var A = e.toNarrowWidePattern(f);
        if (A < 0)
          throw new Ye();
        w = e.patternToChar(A), this.decodeRowResult += w, _ = m;
        try {
          for (var T = (a = void 0, ID(f)), O = T.next(); !O.done; O = T.next()) {
            var R = O.value;
            m += R;
          }
        } catch (Y) {
          a = { error: Y };
        } finally {
          try {
            O && !O.done && (s = T.return) && s.call(T);
          } finally {
            if (a)
              throw a.error;
          }
        }
        m = r.getNextSet(m);
      } while (w !== "*");
      this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
      var N = 0;
      try {
        for (var M = ID(f), P = M.next(); !P.done; P = M.next()) {
          var R = P.value;
          N += R;
        }
      } catch (Y) {
        c = { error: Y };
      } finally {
        try {
          P && !P.done && (d = M.return) && d.call(M);
        } finally {
          if (c)
            throw c.error;
        }
      }
      var z = m - _ - N;
      if (m !== b && z * 2 < N)
        throw new Ye();
      if (this.usingCheckDigit) {
        for (var F = this.decodeRowResult.length - 1, $ = 0, G = 0; G < F; G++)
          $ += e.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(G));
        if (this.decodeRowResult.charAt(F) !== e.ALPHABET_STRING.charAt($ % 43))
          throw new uo();
        this.decodeRowResult = this.decodeRowResult.substring(0, F);
      }
      if (this.decodeRowResult.length === 0)
        throw new Ye();
      var H;
      this.extendedMode ? H = e.decodeExtended(this.decodeRowResult) : H = this.decodeRowResult;
      var Z = (g[1] + g[0]) / 2, V = _ + N / 2;
      return new ts(H, null, 0, [new kt(Z, n), new kt(V, n)], Ht.CODE_39, (/* @__PURE__ */ new Date()).getTime());
    }, e.findAsteriskPattern = function(n, r) {
      for (var i = n.getSize(), a = n.getNextSet(0), s = 0, c = a, d = !1, f = r.length, g = a; g < i; g++)
        if (n.get(g) !== d)
          r[s]++;
        else {
          if (s === f - 1) {
            if (this.toNarrowWidePattern(r) === e.ASTERISK_ENCODING && n.isRange(Math.max(0, c - Math.floor((g - c) / 2)), c, !1))
              return [c, g];
            c += r[0] + r[1], r.copyWithin(0, 2, 2 + s - 1), r[s - 1] = 0, r[s] = 0, s--;
          } else
            s++;
          r[s] = 1, d = !d;
        }
      throw new Ye();
    }, e.toNarrowWidePattern = function(n) {
      var r, i, a = n.length, s = 0, c;
      do {
        var d = 2147483647;
        try {
          for (var f = (r = void 0, ID(n)), g = f.next(); !g.done; g = f.next()) {
            var m = g.value;
            m < d && m > s && (d = m);
          }
        } catch (A) {
          r = { error: A };
        } finally {
          try {
            g && !g.done && (i = f.return) && i.call(f);
          } finally {
            if (r)
              throw r.error;
          }
        }
        s = d, c = 0;
        for (var b = 0, w = 0, _ = 0; _ < a; _++) {
          var m = n[_];
          m > s && (w |= 1 << a - 1 - _, c++, b += m);
        }
        if (c === 3) {
          for (var _ = 0; _ < a && c > 0; _++) {
            var m = n[_];
            if (m > s && (c--, m * 2 >= b))
              return -1;
          }
          return w;
        }
      } while (c > 3);
      return -1;
    }, e.patternToChar = function(n) {
      for (var r = 0; r < e.CHARACTER_ENCODINGS.length; r++)
        if (e.CHARACTER_ENCODINGS[r] === n)
          return e.ALPHABET_STRING.charAt(r);
      if (n === e.ASTERISK_ENCODING)
        return "*";
      throw new Ye();
    }, e.decodeExtended = function(n) {
      for (var r = n.length, i = "", a = 0; a < r; a++) {
        var s = n.charAt(a);
        if (s === "+" || s === "$" || s === "%" || s === "/") {
          var c = n.charAt(a + 1), d = "\0";
          switch (s) {
            case "+":
              if (c >= "A" && c <= "Z")
                d = String.fromCharCode(c.charCodeAt(0) + 32);
              else
                throw new ht();
              break;
            case "$":
              if (c >= "A" && c <= "Z")
                d = String.fromCharCode(c.charCodeAt(0) - 64);
              else
                throw new ht();
              break;
            case "%":
              if (c >= "A" && c <= "E")
                d = String.fromCharCode(c.charCodeAt(0) - 38);
              else if (c >= "F" && c <= "J")
                d = String.fromCharCode(c.charCodeAt(0) - 11);
              else if (c >= "K" && c <= "O")
                d = String.fromCharCode(c.charCodeAt(0) + 16);
              else if (c >= "P" && c <= "T")
                d = String.fromCharCode(c.charCodeAt(0) + 43);
              else if (c === "U")
                d = "\0";
              else if (c === "V")
                d = "@";
              else if (c === "W")
                d = "`";
              else if (c === "X" || c === "Y" || c === "Z")
                d = "";
              else
                throw new ht();
              break;
            case "/":
              if (c >= "A" && c <= "O")
                d = String.fromCharCode(c.charCodeAt(0) - 32);
              else if (c === "Z")
                d = ":";
              else
                throw new ht();
              break;
          }
          i += d, a++;
        } else
          i += s;
      }
      return i;
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%", e.CHARACTER_ENCODINGS = [
      52,
      289,
      97,
      352,
      49,
      304,
      112,
      37,
      292,
      100,
      265,
      73,
      328,
      25,
      280,
      88,
      13,
      268,
      76,
      28,
      259,
      67,
      322,
      19,
      274,
      82,
      7,
      262,
      70,
      22,
      385,
      193,
      448,
      145,
      400,
      208,
      133,
      388,
      196,
      168,
      162,
      138,
      42
      // /-%
    ], e.ASTERISK_ENCODING = 148, e;
  }(Ga)
), QFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), kD = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, VU = (
  /** @class */
  function(t) {
    QFe(e, t);
    function e() {
      var n = t.call(this) || this;
      return n.decodeRowResult = "", n.counters = new Int32Array(6), n;
    }
    return e.prototype.decodeRow = function(n, r, i) {
      var a, s, c, d, f = this.findAsteriskPattern(r), g = r.getNextSet(f[1]), m = r.getSize(), b = this.counters;
      b.fill(0), this.decodeRowResult = "";
      var w, _;
      do {
        e.recordPattern(r, g, b);
        var A = this.toPattern(b);
        if (A < 0)
          throw new Ye();
        w = this.patternToChar(A), this.decodeRowResult += w, _ = g;
        try {
          for (var T = (a = void 0, kD(b)), O = T.next(); !O.done; O = T.next()) {
            var R = O.value;
            g += R;
          }
        } catch (G) {
          a = { error: G };
        } finally {
          try {
            O && !O.done && (s = T.return) && s.call(T);
          } finally {
            if (a)
              throw a.error;
          }
        }
        g = r.getNextSet(g);
      } while (w !== "*");
      this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
      var N = 0;
      try {
        for (var M = kD(b), P = M.next(); !P.done; P = M.next()) {
          var R = P.value;
          N += R;
        }
      } catch (G) {
        c = { error: G };
      } finally {
        try {
          P && !P.done && (d = M.return) && d.call(M);
        } finally {
          if (c)
            throw c.error;
        }
      }
      if (g === m || !r.get(g))
        throw new Ye();
      if (this.decodeRowResult.length < 2)
        throw new Ye();
      this.checkChecksums(this.decodeRowResult), this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 2);
      var z = this.decodeExtended(this.decodeRowResult), F = (f[1] + f[0]) / 2, $ = _ + N / 2;
      return new ts(z, null, 0, [new kt(F, n), new kt($, n)], Ht.CODE_93, (/* @__PURE__ */ new Date()).getTime());
    }, e.prototype.findAsteriskPattern = function(n) {
      var r = n.getSize(), i = n.getNextSet(0);
      this.counters.fill(0);
      for (var a = this.counters, s = i, c = !1, d = a.length, f = 0, g = i; g < r; g++)
        if (n.get(g) !== c)
          a[f]++;
        else {
          if (f === d - 1) {
            if (this.toPattern(a) === e.ASTERISK_ENCODING)
              return new Int32Array([s, g]);
            s += a[0] + a[1], a.copyWithin(0, 2, 2 + f - 1), a[f - 1] = 0, a[f] = 0, f--;
          } else
            f++;
          a[f] = 1, c = !c;
        }
      throw new Ye();
    }, e.prototype.toPattern = function(n) {
      var r, i, a = 0;
      try {
        for (var s = kD(n), c = s.next(); !c.done; c = s.next()) {
          var d = c.value;
          a += d;
        }
      } catch (_) {
        r = { error: _ };
      } finally {
        try {
          c && !c.done && (i = s.return) && i.call(s);
        } finally {
          if (r)
            throw r.error;
        }
      }
      for (var f = 0, g = n.length, m = 0; m < g; m++) {
        var b = Math.round(n[m] * 9 / a);
        if (b < 1 || b > 4)
          return -1;
        if (m & 1)
          f <<= b;
        else
          for (var w = 0; w < b; w++)
            f = f << 1 | 1;
      }
      return f;
    }, e.prototype.patternToChar = function(n) {
      for (var r = 0; r < e.CHARACTER_ENCODINGS.length; r++)
        if (e.CHARACTER_ENCODINGS[r] === n)
          return e.ALPHABET_STRING.charAt(r);
      throw new Ye();
    }, e.prototype.decodeExtended = function(n) {
      for (var r = n.length, i = "", a = 0; a < r; a++) {
        var s = n.charAt(a);
        if (s >= "a" && s <= "d") {
          if (a >= r - 1)
            throw new ht();
          var c = n.charAt(a + 1), d = "\0";
          switch (s) {
            case "d":
              if (c >= "A" && c <= "Z")
                d = String.fromCharCode(c.charCodeAt(0) + 32);
              else
                throw new ht();
              break;
            case "a":
              if (c >= "A" && c <= "Z")
                d = String.fromCharCode(c.charCodeAt(0) - 64);
              else
                throw new ht();
              break;
            case "b":
              if (c >= "A" && c <= "E")
                d = String.fromCharCode(c.charCodeAt(0) - 38);
              else if (c >= "F" && c <= "J")
                d = String.fromCharCode(c.charCodeAt(0) - 11);
              else if (c >= "K" && c <= "O")
                d = String.fromCharCode(c.charCodeAt(0) + 16);
              else if (c >= "P" && c <= "T")
                d = String.fromCharCode(c.charCodeAt(0) + 43);
              else if (c === "U")
                d = "\0";
              else if (c === "V")
                d = "@";
              else if (c === "W")
                d = "`";
              else if (c >= "X" && c <= "Z")
                d = String.fromCharCode(127);
              else
                throw new ht();
              break;
            case "c":
              if (c >= "A" && c <= "O")
                d = String.fromCharCode(c.charCodeAt(0) - 32);
              else if (c === "Z")
                d = ":";
              else
                throw new ht();
              break;
          }
          i += d, a++;
        } else
          i += s;
      }
      return i;
    }, e.prototype.checkChecksums = function(n) {
      var r = n.length;
      this.checkOneChecksum(n, r - 2, 20), this.checkOneChecksum(n, r - 1, 15);
    }, e.prototype.checkOneChecksum = function(n, r, i) {
      for (var a = 1, s = 0, c = r - 1; c >= 0; c--)
        s += a * e.ALPHABET_STRING.indexOf(n.charAt(c)), ++a > i && (a = 1);
      if (n.charAt(r) !== e.ALPHABET_STRING[s % 47])
        throw new uo();
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%abcd*", e.CHARACTER_ENCODINGS = [
      276,
      328,
      324,
      322,
      296,
      292,
      290,
      336,
      274,
      266,
      424,
      420,
      418,
      404,
      402,
      394,
      360,
      356,
      354,
      308,
      282,
      344,
      332,
      326,
      300,
      278,
      436,
      434,
      428,
      422,
      406,
      410,
      364,
      358,
      310,
      314,
      302,
      468,
      466,
      458,
      366,
      374,
      430,
      294,
      474,
      470,
      306,
      350
    ], e.ASTERISK_ENCODING = e.CHARACTER_ENCODINGS[47], e;
  }(Ga)
), ZFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), KFe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, UU = (
  /** @class */
  function(t) {
    ZFe(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.narrowLineWidth = -1, n;
    }
    return e.prototype.decodeRow = function(n, r, i) {
      var a, s, c = this.decodeStart(r), d = this.decodeEnd(r), f = new Bn();
      e.decodeMiddle(r, c[1], d[0], f);
      var g = f.toString(), m = null;
      i != null && (m = i.get(Ui.ALLOWED_LENGTHS)), m == null && (m = e.DEFAULT_ALLOWED_LENGTHS);
      var b = g.length, w = !1, _ = 0;
      try {
        for (var A = KFe(m), T = A.next(); !T.done; T = A.next()) {
          var O = T.value;
          if (b === O) {
            w = !0;
            break;
          }
          O > _ && (_ = O);
        }
      } catch (M) {
        a = { error: M };
      } finally {
        try {
          T && !T.done && (s = A.return) && s.call(A);
        } finally {
          if (a)
            throw a.error;
        }
      }
      if (!w && b > _ && (w = !0), !w)
        throw new ht();
      var R = [new kt(c[1], n), new kt(d[0], n)], N = new ts(
        g,
        null,
        // no natural byte representation for these barcodes
        0,
        R,
        Ht.ITF,
        (/* @__PURE__ */ new Date()).getTime()
      );
      return N;
    }, e.decodeMiddle = function(n, r, i, a) {
      var s = new Int32Array(10), c = new Int32Array(5), d = new Int32Array(5);
      for (s.fill(0), c.fill(0), d.fill(0); r < i; ) {
        Ga.recordPattern(n, r, s);
        for (var f = 0; f < 5; f++) {
          var g = 2 * f;
          c[f] = s[g], d[f] = s[g + 1];
        }
        var m = e.decodeDigit(c);
        a.append(m.toString()), m = this.decodeDigit(d), a.append(m.toString()), s.forEach(function(b) {
          r += b;
        });
      }
    }, e.prototype.decodeStart = function(n) {
      var r = e.skipWhiteSpace(n), i = e.findGuardPattern(n, r, e.START_PATTERN);
      return this.narrowLineWidth = (i[1] - i[0]) / 4, this.validateQuietZone(n, i[0]), i;
    }, e.prototype.validateQuietZone = function(n, r) {
      var i = this.narrowLineWidth * 10;
      i = i < r ? i : r;
      for (var a = r - 1; i > 0 && a >= 0 && !n.get(a); a--)
        i--;
      if (i !== 0)
        throw new Ye();
    }, e.skipWhiteSpace = function(n) {
      var r = n.getSize(), i = n.getNextSet(0);
      if (i === r)
        throw new Ye();
      return i;
    }, e.prototype.decodeEnd = function(n) {
      n.reverse();
      try {
        var r = e.skipWhiteSpace(n), i = void 0;
        try {
          i = e.findGuardPattern(n, r, e.END_PATTERN_REVERSED[0]);
        } catch (s) {
          s instanceof Ye && (i = e.findGuardPattern(n, r, e.END_PATTERN_REVERSED[1]));
        }
        this.validateQuietZone(n, i[0]);
        var a = i[0];
        return i[0] = n.getSize() - i[1], i[1] = n.getSize() - a, i;
      } finally {
        n.reverse();
      }
    }, e.findGuardPattern = function(n, r, i) {
      var a = i.length, s = new Int32Array(a), c = n.getSize(), d = !1, f = 0, g = r;
      s.fill(0);
      for (var m = r; m < c; m++)
        if (n.get(m) !== d)
          s[f]++;
        else {
          if (f === a - 1) {
            if (Ga.patternMatchVariance(s, i, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE)
              return [g, m];
            g += s[0] + s[1], si.arraycopy(s, 2, s, 0, f - 1), s[f - 1] = 0, s[f] = 0, f--;
          } else
            f++;
          s[f] = 1, d = !d;
        }
      throw new Ye();
    }, e.decodeDigit = function(n) {
      for (var r = e.MAX_AVG_VARIANCE, i = -1, a = e.PATTERNS.length, s = 0; s < a; s++) {
        var c = e.PATTERNS[s], d = Ga.patternMatchVariance(n, c, e.MAX_INDIVIDUAL_VARIANCE);
        d < r ? (r = d, i = s) : d === r && (i = -1);
      }
      if (i >= 0)
        return i % 10;
      throw new Ye();
    }, e.PATTERNS = [
      Int32Array.from([1, 1, 2, 2, 1]),
      Int32Array.from([2, 1, 1, 1, 2]),
      Int32Array.from([1, 2, 1, 1, 2]),
      Int32Array.from([2, 2, 1, 1, 1]),
      Int32Array.from([1, 1, 2, 1, 2]),
      Int32Array.from([2, 1, 2, 1, 1]),
      Int32Array.from([1, 2, 2, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 2]),
      Int32Array.from([2, 1, 1, 2, 1]),
      Int32Array.from([1, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 3, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 3]),
      Int32Array.from([1, 3, 1, 1, 3]),
      Int32Array.from([3, 3, 1, 1, 1]),
      Int32Array.from([1, 1, 3, 1, 3]),
      Int32Array.from([3, 1, 3, 1, 1]),
      Int32Array.from([1, 3, 3, 1, 1]),
      Int32Array.from([1, 1, 1, 3, 3]),
      Int32Array.from([3, 1, 1, 3, 1]),
      Int32Array.from([1, 3, 1, 3, 1])
      // 9
    ], e.MAX_AVG_VARIANCE = 0.38, e.MAX_INDIVIDUAL_VARIANCE = 0.5, e.DEFAULT_ALLOWED_LENGTHS = [6, 8, 10, 12, 14], e.START_PATTERN = Int32Array.from([1, 1, 1, 1]), e.END_PATTERN_REVERSED = [
      Int32Array.from([1, 1, 2]),
      Int32Array.from([1, 1, 3])
      // 3x
    ], e;
  }(Ga)
), JFe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), nw = (
  /** @class */
  function(t) {
    JFe(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.decodeRowStringBuffer = "", n;
    }
    return e.findStartGuardPattern = function(n) {
      for (var r = !1, i, a = 0, s = Int32Array.from([0, 0, 0]); !r; ) {
        s = Int32Array.from([0, 0, 0]), i = e.findGuardPattern(n, a, !1, this.START_END_PATTERN, s);
        var c = i[0];
        a = i[1];
        var d = c - (a - c);
        d >= 0 && (r = n.isRange(d, c, !1));
      }
      return i;
    }, e.checkChecksum = function(n) {
      return e.checkStandardUPCEANChecksum(n);
    }, e.checkStandardUPCEANChecksum = function(n) {
      var r = n.length;
      if (r === 0)
        return !1;
      var i = parseInt(n.charAt(r - 1), 10);
      return e.getStandardUPCEANChecksum(n.substring(0, r - 1)) === i;
    }, e.getStandardUPCEANChecksum = function(n) {
      for (var r = n.length, i = 0, a = r - 1; a >= 0; a -= 2) {
        var s = n.charAt(a).charCodeAt(0) - "0".charCodeAt(0);
        if (s < 0 || s > 9)
          throw new ht();
        i += s;
      }
      i *= 3;
      for (var a = r - 2; a >= 0; a -= 2) {
        var s = n.charAt(a).charCodeAt(0) - "0".charCodeAt(0);
        if (s < 0 || s > 9)
          throw new ht();
        i += s;
      }
      return (1e3 - i) % 10;
    }, e.decodeEnd = function(n, r) {
      return e.findGuardPattern(n, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e.findGuardPatternWithoutCounters = function(n, r, i, a) {
      return this.findGuardPattern(n, r, i, a, new Int32Array(a.length));
    }, e.findGuardPattern = function(n, r, i, a, s) {
      var c = n.getSize();
      r = i ? n.getNextUnset(r) : n.getNextSet(r);
      for (var d = 0, f = r, g = a.length, m = i, b = r; b < c; b++)
        if (n.get(b) !== m)
          s[d]++;
        else {
          if (d === g - 1) {
            if (Ga.patternMatchVariance(s, a, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE)
              return Int32Array.from([f, b]);
            f += s[0] + s[1];
            for (var w = s.slice(2, s.length), _ = 0; _ < d - 1; _++)
              s[_] = w[_];
            s[d - 1] = 0, s[d] = 0, d--;
          } else
            d++;
          s[d] = 1, m = !m;
        }
      throw new Ye();
    }, e.decodeDigit = function(n, r, i, a) {
      this.recordPattern(n, i, r);
      for (var s = this.MAX_AVG_VARIANCE, c = -1, d = a.length, f = 0; f < d; f++) {
        var g = a[f], m = Ga.patternMatchVariance(r, g, e.MAX_INDIVIDUAL_VARIANCE);
        m < s && (s = m, c = f);
      }
      if (c >= 0)
        return c;
      throw new Ye();
    }, e.MAX_AVG_VARIANCE = 0.48, e.MAX_INDIVIDUAL_VARIANCE = 0.7, e.START_END_PATTERN = Int32Array.from([1, 1, 1]), e.MIDDLE_PATTERN = Int32Array.from([1, 1, 1, 1, 1]), e.END_PATTERN = Int32Array.from([1, 1, 1, 1, 1, 1]), e.L_PATTERNS = [
      Int32Array.from([3, 2, 1, 1]),
      Int32Array.from([2, 2, 2, 1]),
      Int32Array.from([2, 1, 2, 2]),
      Int32Array.from([1, 4, 1, 1]),
      Int32Array.from([1, 1, 3, 2]),
      Int32Array.from([1, 2, 3, 1]),
      Int32Array.from([1, 1, 1, 4]),
      Int32Array.from([1, 3, 1, 2]),
      Int32Array.from([1, 2, 1, 3]),
      Int32Array.from([3, 1, 1, 2])
    ], e;
  }(Ga)
), eVe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, tVe = (
  /** @class */
  function() {
    function t() {
      this.CHECK_DIGIT_ENCODINGS = [24, 20, 18, 17, 12, 6, 3, 10, 9, 5], this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, n, r) {
      var i = this.decodeRowStringBuffer, a = this.decodeMiddle(n, r, i), s = i.toString(), c = t.parseExtensionString(s), d = [
        new kt((r[0] + r[1]) / 2, e),
        new kt(a, e)
      ], f = new ts(s, null, 0, d, Ht.UPC_EAN_EXTENSION, (/* @__PURE__ */ new Date()).getTime());
      return c != null && f.putAllMetadata(c), f;
    }, t.prototype.decodeMiddle = function(e, n, r) {
      var i, a, s = this.decodeMiddleCounters;
      s[0] = 0, s[1] = 0, s[2] = 0, s[3] = 0;
      for (var c = e.getSize(), d = n[1], f = 0, g = 0; g < 5 && d < c; g++) {
        var m = nw.decodeDigit(e, s, d, nw.L_AND_G_PATTERNS);
        r += String.fromCharCode("0".charCodeAt(0) + m % 10);
        try {
          for (var b = (i = void 0, eVe(s)), w = b.next(); !w.done; w = b.next()) {
            var _ = w.value;
            d += _;
          }
        } catch (T) {
          i = { error: T };
        } finally {
          try {
            w && !w.done && (a = b.return) && a.call(b);
          } finally {
            if (i)
              throw i.error;
          }
        }
        m >= 10 && (f |= 1 << 4 - g), g !== 4 && (d = e.getNextSet(d), d = e.getNextUnset(d));
      }
      if (r.length !== 5)
        throw new Ye();
      var A = this.determineCheckDigit(f);
      if (t.extensionChecksum(r.toString()) !== A)
        throw new Ye();
      return d;
    }, t.extensionChecksum = function(e) {
      for (var n = e.length, r = 0, i = n - 2; i >= 0; i -= 2)
        r += e.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
      r *= 3;
      for (var i = n - 1; i >= 0; i -= 2)
        r += e.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
      return r *= 3, r % 10;
    }, t.prototype.determineCheckDigit = function(e) {
      for (var n = 0; n < 10; n++)
        if (e === this.CHECK_DIGIT_ENCODINGS[n])
          return n;
      throw new Ye();
    }, t.parseExtensionString = function(e) {
      if (e.length !== 5)
        return null;
      var n = t.parseExtension5String(e);
      return n == null ? null : /* @__PURE__ */ new Map([[jo.SUGGESTED_PRICE, n]]);
    }, t.parseExtension5String = function(e) {
      var n;
      switch (e.charAt(0)) {
        case "0":
          n = "£";
          break;
        case "5":
          n = "$";
          break;
        case "9":
          switch (e) {
            case "90000":
              return null;
            case "99991":
              return "0.00";
            case "99990":
              return "Used";
          }
          n = "";
          break;
        default:
          n = "";
          break;
      }
      var r = parseInt(e.substring(1)), i = (r / 100).toString(), a = r % 100, s = a < 10 ? "0" + a : a.toString();
      return n + i + "." + s;
    }, t;
  }()
), nVe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, rVe = (
  /** @class */
  function() {
    function t() {
      this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, n, r) {
      var i = this.decodeRowStringBuffer, a = this.decodeMiddle(n, r, i), s = i.toString(), c = t.parseExtensionString(s), d = [
        new kt((r[0] + r[1]) / 2, e),
        new kt(a, e)
      ], f = new ts(s, null, 0, d, Ht.UPC_EAN_EXTENSION, (/* @__PURE__ */ new Date()).getTime());
      return c != null && f.putAllMetadata(c), f;
    }, t.prototype.decodeMiddle = function(e, n, r) {
      var i, a, s = this.decodeMiddleCounters;
      s[0] = 0, s[1] = 0, s[2] = 0, s[3] = 0;
      for (var c = e.getSize(), d = n[1], f = 0, g = 0; g < 2 && d < c; g++) {
        var m = nw.decodeDigit(e, s, d, nw.L_AND_G_PATTERNS);
        r += String.fromCharCode("0".charCodeAt(0) + m % 10);
        try {
          for (var b = (i = void 0, nVe(s)), w = b.next(); !w.done; w = b.next()) {
            var _ = w.value;
            d += _;
          }
        } catch (A) {
          i = { error: A };
        } finally {
          try {
            w && !w.done && (a = b.return) && a.call(b);
          } finally {
            if (i)
              throw i.error;
          }
        }
        m >= 10 && (f |= 1 << 1 - g), g !== 1 && (d = e.getNextSet(d), d = e.getNextUnset(d));
      }
      if (r.length !== 2)
        throw new Ye();
      if (parseInt(r.toString()) % 4 !== f)
        throw new Ye();
      return d;
    }, t.parseExtensionString = function(e) {
      return e.length !== 2 ? null : /* @__PURE__ */ new Map([[jo.ISSUE_NUMBER, parseInt(e)]]);
    }, t;
  }()
), iVe = (
  /** @class */
  function() {
    function t() {
    }
    return t.decodeRow = function(e, n, r) {
      var i = nw.findGuardPattern(n, r, !1, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
      try {
        var a = new tVe();
        return a.decodeRow(e, n, i);
      } catch {
        var s = new rVe();
        return s.decodeRow(e, n, i);
      }
    }, t.EXTENSION_START_PATTERN = Int32Array.from([1, 1, 2]), t;
  }()
), aVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Fa = (
  /** @class */
  function(t) {
    aVe(e, t);
    function e() {
      var n = t.call(this) || this;
      n.decodeRowStringBuffer = "", e.L_AND_G_PATTERNS = e.L_PATTERNS.map(function(c) {
        return Int32Array.from(c);
      });
      for (var r = 10; r < 20; r++) {
        for (var i = e.L_PATTERNS[r - 10], a = new Int32Array(i.length), s = 0; s < i.length; s++)
          a[s] = i[i.length - s - 1];
        e.L_AND_G_PATTERNS[r] = a;
      }
      return n;
    }
    return e.prototype.decodeRow = function(n, r, i) {
      var a = e.findStartGuardPattern(r), s = i == null ? null : i.get(Ui.NEED_RESULT_POINT_CALLBACK);
      if (s != null) {
        var c = new kt((a[0] + a[1]) / 2, n);
        s.foundPossibleResultPoint(c);
      }
      var d = this.decodeMiddle(r, a, this.decodeRowStringBuffer), f = d.rowOffset, g = d.resultString;
      if (s != null) {
        var m = new kt(f, n);
        s.foundPossibleResultPoint(m);
      }
      var b = e.decodeEnd(r, f);
      if (s != null) {
        var w = new kt((b[0] + b[1]) / 2, n);
        s.foundPossibleResultPoint(w);
      }
      var _ = b[1], A = _ + (_ - b[0]);
      if (A >= r.getSize() || !r.isRange(_, A, !1))
        throw new Ye();
      var T = g.toString();
      if (T.length < 8)
        throw new ht();
      if (!e.checkChecksum(T))
        throw new uo();
      var O = (a[1] + a[0]) / 2, R = (b[1] + b[0]) / 2, N = this.getBarcodeFormat(), M = [new kt(O, n), new kt(R, n)], P = new ts(T, null, 0, M, N, (/* @__PURE__ */ new Date()).getTime()), z = 0;
      try {
        var F = iVe.decodeRow(n, r, b[1]);
        P.putMetadata(jo.UPC_EAN_EXTENSION, F.getText()), P.putAllMetadata(F.getResultMetadata()), P.addResultPoints(F.getResultPoints()), z = F.getText().length;
      } catch {
      }
      var $ = i == null ? null : i.get(Ui.ALLOWED_EAN_EXTENSIONS);
      if ($ != null) {
        var G = !1;
        for (var H in $)
          if (z.toString() === H) {
            G = !0;
            break;
          }
        if (!G)
          throw new Ye();
      }
      return N === Ht.EAN_13 || Ht.UPC_A, P;
    }, e.checkChecksum = function(n) {
      return e.checkStandardUPCEANChecksum(n);
    }, e.checkStandardUPCEANChecksum = function(n) {
      var r = n.length;
      if (r === 0)
        return !1;
      var i = parseInt(n.charAt(r - 1), 10);
      return e.getStandardUPCEANChecksum(n.substring(0, r - 1)) === i;
    }, e.getStandardUPCEANChecksum = function(n) {
      for (var r = n.length, i = 0, a = r - 1; a >= 0; a -= 2) {
        var s = n.charAt(a).charCodeAt(0) - "0".charCodeAt(0);
        if (s < 0 || s > 9)
          throw new ht();
        i += s;
      }
      i *= 3;
      for (var a = r - 2; a >= 0; a -= 2) {
        var s = n.charAt(a).charCodeAt(0) - "0".charCodeAt(0);
        if (s < 0 || s > 9)
          throw new ht();
        i += s;
      }
      return (1e3 - i) % 10;
    }, e.decodeEnd = function(n, r) {
      return e.findGuardPattern(n, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e;
  }(nw)
), oVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), $U = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, sM = (
  /** @class */
  function(t) {
    oVe(e, t);
    function e() {
      var n = t.call(this) || this;
      return n.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), n;
    }
    return e.prototype.decodeMiddle = function(n, r, i) {
      var a, s, c, d, f = this.decodeMiddleCounters;
      f[0] = 0, f[1] = 0, f[2] = 0, f[3] = 0;
      for (var g = n.getSize(), m = r[1], b = 0, w = 0; w < 6 && m < g; w++) {
        var _ = Fa.decodeDigit(n, f, m, Fa.L_AND_G_PATTERNS);
        i += String.fromCharCode("0".charCodeAt(0) + _ % 10);
        try {
          for (var A = (a = void 0, $U(f)), T = A.next(); !T.done; T = A.next()) {
            var O = T.value;
            m += O;
          }
        } catch (P) {
          a = { error: P };
        } finally {
          try {
            T && !T.done && (s = A.return) && s.call(A);
          } finally {
            if (a)
              throw a.error;
          }
        }
        _ >= 10 && (b |= 1 << 5 - w);
      }
      i = e.determineFirstDigit(i, b);
      var R = Fa.findGuardPattern(n, m, !0, Fa.MIDDLE_PATTERN, new Int32Array(Fa.MIDDLE_PATTERN.length).fill(0));
      m = R[1];
      for (var w = 0; w < 6 && m < g; w++) {
        var _ = Fa.decodeDigit(n, f, m, Fa.L_PATTERNS);
        i += String.fromCharCode("0".charCodeAt(0) + _);
        try {
          for (var N = (c = void 0, $U(f)), M = N.next(); !M.done; M = N.next()) {
            var O = M.value;
            m += O;
          }
        } catch (F) {
          c = { error: F };
        } finally {
          try {
            M && !M.done && (d = N.return) && d.call(N);
          } finally {
            if (c)
              throw c.error;
          }
        }
      }
      return { rowOffset: m, resultString: i };
    }, e.prototype.getBarcodeFormat = function() {
      return Ht.EAN_13;
    }, e.determineFirstDigit = function(n, r) {
      for (var i = 0; i < 10; i++)
        if (r === this.FIRST_DIGIT_ENCODINGS[i])
          return n = String.fromCharCode("0".charCodeAt(0) + i) + n, n;
      throw new Ye();
    }, e.FIRST_DIGIT_ENCODINGS = [0, 11, 13, 14, 19, 25, 28, 21, 22, 26], e;
  }(Fa)
), sVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), HU = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, qU = (
  /** @class */
  function(t) {
    sVe(e, t);
    function e() {
      var n = t.call(this) || this;
      return n.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), n;
    }
    return e.prototype.decodeMiddle = function(n, r, i) {
      var a, s, c, d, f = this.decodeMiddleCounters;
      f[0] = 0, f[1] = 0, f[2] = 0, f[3] = 0;
      for (var g = n.getSize(), m = r[1], b = 0; b < 4 && m < g; b++) {
        var w = Fa.decodeDigit(n, f, m, Fa.L_PATTERNS);
        i += String.fromCharCode("0".charCodeAt(0) + w);
        try {
          for (var _ = (a = void 0, HU(f)), A = _.next(); !A.done; A = _.next()) {
            var T = A.value;
            m += T;
          }
        } catch (M) {
          a = { error: M };
        } finally {
          try {
            A && !A.done && (s = _.return) && s.call(_);
          } finally {
            if (a)
              throw a.error;
          }
        }
      }
      var O = Fa.findGuardPattern(n, m, !0, Fa.MIDDLE_PATTERN, new Int32Array(Fa.MIDDLE_PATTERN.length).fill(0));
      m = O[1];
      for (var b = 0; b < 4 && m < g; b++) {
        var w = Fa.decodeDigit(n, f, m, Fa.L_PATTERNS);
        i += String.fromCharCode("0".charCodeAt(0) + w);
        try {
          for (var R = (c = void 0, HU(f)), N = R.next(); !N.done; N = R.next()) {
            var T = N.value;
            m += T;
          }
        } catch (z) {
          c = { error: z };
        } finally {
          try {
            N && !N.done && (d = R.return) && d.call(R);
          } finally {
            if (c)
              throw c.error;
          }
        }
      }
      return { rowOffset: m, resultString: i };
    }, e.prototype.getBarcodeFormat = function() {
      return Ht.EAN_8;
    }, e;
  }(Fa)
), lVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), GU = (
  /** @class */
  function(t) {
    lVe(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.ean13Reader = new sM(), n;
    }
    return e.prototype.getBarcodeFormat = function() {
      return Ht.UPC_A;
    }, e.prototype.decode = function(n, r) {
      return this.maybeReturnResult(this.ean13Reader.decode(n));
    }, e.prototype.decodeRow = function(n, r, i) {
      return this.maybeReturnResult(this.ean13Reader.decodeRow(n, r, i));
    }, e.prototype.decodeMiddle = function(n, r, i) {
      return this.ean13Reader.decodeMiddle(n, r, i);
    }, e.prototype.maybeReturnResult = function(n) {
      var r = n.getText();
      if (r.charAt(0) === "0") {
        var i = new ts(r.substring(1), null, null, n.getResultPoints(), Ht.UPC_A);
        return n.getResultMetadata() != null && i.putAllMetadata(n.getResultMetadata()), i;
      } else
        throw new Ye();
    }, e.prototype.reset = function() {
      this.ean13Reader.reset();
    }, e;
  }(Fa)
), cVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), uVe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, YU = (
  /** @class */
  function(t) {
    cVe(e, t);
    function e() {
      var n = t.call(this) || this;
      return n.decodeMiddleCounters = new Int32Array(4), n;
    }
    return e.prototype.decodeMiddle = function(n, r, i) {
      var a, s, c = this.decodeMiddleCounters.map(function(T) {
        return T;
      });
      c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0;
      for (var d = n.getSize(), f = r[1], g = 0, m = 0; m < 6 && f < d; m++) {
        var b = e.decodeDigit(n, c, f, e.L_AND_G_PATTERNS);
        i += String.fromCharCode("0".charCodeAt(0) + b % 10);
        try {
          for (var w = (a = void 0, uVe(c)), _ = w.next(); !_.done; _ = w.next()) {
            var A = _.value;
            f += A;
          }
        } catch (T) {
          a = { error: T };
        } finally {
          try {
            _ && !_.done && (s = w.return) && s.call(w);
          } finally {
            if (a)
              throw a.error;
          }
        }
        b >= 10 && (g |= 1 << 5 - m);
      }
      return e.determineNumSysAndCheckDigit(new Bn(i), g), f;
    }, e.prototype.decodeEnd = function(n, r) {
      return e.findGuardPatternWithoutCounters(n, r, !0, e.MIDDLE_END_PATTERN);
    }, e.prototype.checkChecksum = function(n) {
      return Fa.checkChecksum(e.convertUPCEtoUPCA(n));
    }, e.determineNumSysAndCheckDigit = function(n, r) {
      for (var i = 0; i <= 1; i++)
        for (var a = 0; a < 10; a++)
          if (r === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[i][a]) {
            n.insert(
              0,
              /*(char)*/
              "0" + i
            ), n.append(
              /*(char)*/
              "0" + a
            );
            return;
          }
      throw Ye.getNotFoundInstance();
    }, e.prototype.getBarcodeFormat = function() {
      return Ht.UPC_E;
    }, e.convertUPCEtoUPCA = function(n) {
      var r = n.slice(1, 7).split("").map(function(s) {
        return s.charCodeAt(0);
      }), i = new Bn(
        /*12*/
      );
      i.append(n.charAt(0));
      var a = r[5];
      switch (a) {
        case 0:
        case 1:
        case 2:
          i.appendChars(r, 0, 2), i.append(a), i.append("0000"), i.appendChars(r, 2, 3);
          break;
        case 3:
          i.appendChars(r, 0, 3), i.append("00000"), i.appendChars(r, 3, 2);
          break;
        case 4:
          i.appendChars(r, 0, 4), i.append("00000"), i.append(r[4]);
          break;
        default:
          i.appendChars(r, 0, 5), i.append("0000"), i.append(a);
          break;
      }
      return n.length >= 8 && i.append(n.charAt(7)), i.toString();
    }, e.MIDDLE_END_PATTERN = Int32Array.from([1, 1, 1, 1, 1, 1]), e.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
      Int32Array.from([56, 52, 50, 49, 44, 38, 35, 42, 41, 37]),
      Int32Array.from([7, 11, 13, 14, 19, 25, 28, 21, 22, 1])
    ], e;
  }(Fa)
), dVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), XU = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, jD = (
  /** @class */
  function(t) {
    dVe(e, t);
    function e(n) {
      var r = t.call(this) || this, i = n == null ? null : n.get(Ui.POSSIBLE_FORMATS), a = [];
      return i != null && (i.indexOf(Ht.EAN_13) > -1 && a.push(new sM()), i.indexOf(Ht.UPC_A) > -1 && a.push(new GU()), i.indexOf(Ht.EAN_8) > -1 && a.push(new qU()), i.indexOf(Ht.UPC_E) > -1 && a.push(new YU())), a.length === 0 && (a.push(new sM()), a.push(new GU()), a.push(new qU()), a.push(new YU())), r.readers = a, r;
    }
    return e.prototype.decodeRow = function(n, r, i) {
      var a, s;
      try {
        for (var c = XU(this.readers), d = c.next(); !d.done; d = c.next()) {
          var f = d.value;
          try {
            var g = f.decodeRow(n, r, i), m = g.getBarcodeFormat() === Ht.EAN_13 && g.getText().charAt(0) === "0", b = i == null ? null : i.get(Ui.POSSIBLE_FORMATS), w = b == null || b.includes(Ht.UPC_A);
            if (m && w) {
              var _ = g.getRawBytes(), A = new ts(g.getText().substring(1), _, _ ? _.length : null, g.getResultPoints(), Ht.UPC_A);
              return A.putAllMetadata(g.getResultMetadata()), A;
            }
            return g;
          } catch {
          }
        }
      } catch (T) {
        a = { error: T };
      } finally {
        try {
          d && !d.done && (s = c.return) && s.call(c);
        } finally {
          if (a)
            throw a.error;
        }
      }
      throw new Ye();
    }, e.prototype.reset = function() {
      var n, r;
      try {
        for (var i = XU(this.readers), a = i.next(); !a.done; a = i.next()) {
          var s = a.value;
          s.reset();
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (r = i.return) && r.call(i);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, e;
  }(Ga)
), fVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), hVe = (
  /** @class */
  function(t) {
    fVe(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.CODA_BAR_CHAR_SET = {
        nnnnnww: "0",
        nnnnwwn: "1",
        nnnwnnw: "2",
        wwnnnnn: "3",
        nnwnnwn: "4",
        wnnnnwn: "5",
        nwnnnnw: "6",
        nwnnwnn: "7",
        nwwnnnn: "8",
        wnnwnnn: "9",
        nnnwwnn: "-",
        nnwwnnn: "$",
        wnnnwnw: ":",
        wnwnnnw: "/",
        wnwnwnn: ".",
        nnwwwww: "+",
        nnwwnwn: "A",
        nwnwnnw: "B",
        nnnwnww: "C",
        nnnwwwn: "D"
      }, n;
    }
    return e.prototype.decodeRow = function(n, r, i) {
      var a = this.getValidRowData(r);
      if (!a)
        throw new Ye();
      var s = this.codaBarDecodeRow(a.row);
      if (!s)
        throw new Ye();
      return new ts(s, null, 0, [new kt(a.left, n), new kt(a.right, n)], Ht.CODABAR, (/* @__PURE__ */ new Date()).getTime());
    }, e.prototype.getValidRowData = function(n) {
      var r = n.toArray(), i = r.indexOf(!0);
      if (i === -1)
        return null;
      var a = r.lastIndexOf(!0);
      if (a <= i)
        return null;
      r = r.slice(i, a + 1);
      for (var s = [], c = r[0], d = 1, f = 1; f < r.length; f++)
        r[f] === c ? d++ : (c = r[f], s.push(d), d = 1);
      return s.push(d), s.length < 23 && (s.length + 1) % 8 !== 0 ? null : { row: s, left: i, right: a };
    }, e.prototype.codaBarDecodeRow = function(n) {
      for (var r = [], i = Math.ceil(n.reduce(function(d, f) {
        return (d + f) / 2;
      }, 0)); n.length > 0; ) {
        var a = n.splice(0, 8).splice(0, 7), s = a.map(function(d) {
          return d < i ? "n" : "w";
        }).join("");
        if (this.CODA_BAR_CHAR_SET[s] === void 0)
          return null;
        r.push(this.CODA_BAR_CHAR_SET[s]);
      }
      var c = r.join("");
      return this.validCodaBarString(c) ? c : null;
    }, e.prototype.validCodaBarString = function(n) {
      var r = /^[A-D].{1,}[A-D]$/;
      return r.test(n);
    }, e;
  }(Ga)
), pVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), mVe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, K1 = (
  /** @class */
  function(t) {
    pVe(e, t);
    function e() {
      var n = t.call(this) || this;
      return n.decodeFinderCounters = new Int32Array(4), n.dataCharacterCounters = new Int32Array(8), n.oddRoundingErrors = new Array(4), n.evenRoundingErrors = new Array(4), n.oddCounts = new Array(n.dataCharacterCounters.length / 2), n.evenCounts = new Array(n.dataCharacterCounters.length / 2), n;
    }
    return e.prototype.getDecodeFinderCounters = function() {
      return this.decodeFinderCounters;
    }, e.prototype.getDataCharacterCounters = function() {
      return this.dataCharacterCounters;
    }, e.prototype.getOddRoundingErrors = function() {
      return this.oddRoundingErrors;
    }, e.prototype.getEvenRoundingErrors = function() {
      return this.evenRoundingErrors;
    }, e.prototype.getOddCounts = function() {
      return this.oddCounts;
    }, e.prototype.getEvenCounts = function() {
      return this.evenCounts;
    }, e.prototype.parseFinderValue = function(n, r) {
      for (var i = 0; i < r.length; i++)
        if (Ga.patternMatchVariance(n, r[i], e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE)
          return i;
      throw new Ye();
    }, e.count = function(n) {
      return gr.sum(new Int32Array(n));
    }, e.increment = function(n, r) {
      for (var i = 0, a = r[0], s = 1; s < n.length; s++)
        r[s] > a && (a = r[s], i = s);
      n[i]++;
    }, e.decrement = function(n, r) {
      for (var i = 0, a = r[0], s = 1; s < n.length; s++)
        r[s] < a && (a = r[s], i = s);
      n[i]--;
    }, e.isFinderPattern = function(n) {
      var r, i, a = n[0] + n[1], s = a + n[2] + n[3], c = a / s;
      if (c >= e.MIN_FINDER_PATTERN_RATIO && c <= e.MAX_FINDER_PATTERN_RATIO) {
        var d = Number.MAX_SAFE_INTEGER, f = Number.MIN_SAFE_INTEGER;
        try {
          for (var g = mVe(n), m = g.next(); !m.done; m = g.next()) {
            var b = m.value;
            b > f && (f = b), b < d && (d = b);
          }
        } catch (w) {
          r = { error: w };
        } finally {
          try {
            m && !m.done && (i = g.return) && i.call(g);
          } finally {
            if (r)
              throw r.error;
          }
        }
        return f < 10 * d;
      }
      return !1;
    }, e.MAX_AVG_VARIANCE = 0.2, e.MAX_INDIVIDUAL_VARIANCE = 0.45, e.MIN_FINDER_PATTERN_RATIO = 9.5 / 12, e.MAX_FINDER_PATTERN_RATIO = 12.5 / 14, e;
  }(Ga)
), v5 = (
  /** @class */
  function() {
    function t(e, n) {
      this.value = e, this.checksumPortion = n;
    }
    return t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.getChecksumPortion = function() {
      return this.checksumPortion;
    }, t.prototype.toString = function() {
      return this.value + "(" + this.checksumPortion + ")";
    }, t.prototype.equals = function(e) {
      if (!(e instanceof t))
        return !1;
      var n = e;
      return this.value === n.value && this.checksumPortion === n.checksumPortion;
    }, t.prototype.hashCode = function() {
      return this.value ^ this.checksumPortion;
    }, t;
  }()
), Eee = (
  /** @class */
  function() {
    function t(e, n, r, i, a) {
      this.value = e, this.startEnd = n, this.value = e, this.startEnd = n, this.resultPoints = new Array(), this.resultPoints.push(new kt(r, a)), this.resultPoints.push(new kt(i, a));
    }
    return t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.getStartEnd = function() {
      return this.startEnd;
    }, t.prototype.getResultPoints = function() {
      return this.resultPoints;
    }, t.prototype.equals = function(e) {
      if (!(e instanceof t))
        return !1;
      var n = e;
      return this.value === n.value;
    }, t.prototype.hashCode = function() {
      return this.value;
    }, t;
  }()
), gVe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Rb = (
  /** @class */
  function() {
    function t() {
    }
    return t.getRSSvalue = function(e, n, r) {
      var i, a, s = 0;
      try {
        for (var c = gVe(e), d = c.next(); !d.done; d = c.next()) {
          var f = d.value;
          s += f;
        }
      } catch (R) {
        i = { error: R };
      } finally {
        try {
          d && !d.done && (a = c.return) && a.call(c);
        } finally {
          if (i)
            throw i.error;
        }
      }
      for (var g = 0, m = 0, b = e.length, w = 0; w < b - 1; w++) {
        var _ = void 0;
        for (_ = 1, m |= 1 << w; _ < e[w]; _++, m &= ~(1 << w)) {
          var A = t.combins(s - _ - 1, b - w - 2);
          if (r && m === 0 && s - _ - (b - w - 1) >= b - w - 1 && (A -= t.combins(s - _ - (b - w), b - w - 2)), b - w - 1 > 1) {
            for (var T = 0, O = s - _ - (b - w - 2); O > n; O--)
              T += t.combins(s - _ - O - 1, b - w - 3);
            A -= T * (b - 1 - w);
          } else
            s - _ > n && A--;
          g += A;
        }
        s -= _;
      }
      return g;
    }, t.combins = function(e, n) {
      var r, i;
      e - n > n ? (i = n, r = e - n) : (i = e - n, r = n);
      for (var a = 1, s = 1, c = e; c > r; c--)
        a *= c, s <= i && (a /= s, s++);
      for (; s <= i; )
        a /= s, s++;
      return a;
    }, t;
  }()
), vVe = (
  /** @class */
  function() {
    function t() {
    }
    return t.buildBitArray = function(e) {
      var n = e.length * 2 - 1;
      e[e.length - 1].getRightChar() == null && (n -= 1);
      for (var r = 12 * n, i = new fo(r), a = 0, s = e[0], c = s.getRightChar().getValue(), d = 11; d >= 0; --d)
        c & 1 << d && i.set(a), a++;
      for (var d = 1; d < e.length; ++d) {
        for (var f = e[d], g = f.getLeftChar().getValue(), m = 11; m >= 0; --m)
          g & 1 << m && i.set(a), a++;
        if (f.getRightChar() !== null)
          for (var b = f.getRightChar().getValue(), m = 11; m >= 0; --m)
            b & 1 << m && i.set(a), a++;
      }
      return i;
    }, t;
  }()
), $1 = (
  /** @class */
  function() {
    function t(e, n) {
      n ? this.decodedInformation = null : (this.finished = e, this.decodedInformation = n);
    }
    return t.prototype.getDecodedInformation = function() {
      return this.decodedInformation;
    }, t.prototype.isFinished = function() {
      return this.finished;
    }, t;
  }()
), Xk = (
  /** @class */
  function() {
    function t(e) {
      this.newPosition = e;
    }
    return t.prototype.getNewPosition = function() {
      return this.newPosition;
    }, t;
  }()
), yVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ku = (
  /** @class */
  function(t) {
    yVe(e, t);
    function e(n, r) {
      var i = t.call(this, n) || this;
      return i.value = r, i;
    }
    return e.prototype.getValue = function() {
      return this.value;
    }, e.prototype.isFNC1 = function() {
      return this.value === e.FNC1;
    }, e.FNC1 = "$", e;
  }(Xk)
), bVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), H1 = (
  /** @class */
  function(t) {
    bVe(e, t);
    function e(n, r, i) {
      var a = t.call(this, n) || this;
      return i ? (a.remaining = !0, a.remainingValue = a.remainingValue) : (a.remaining = !1, a.remainingValue = 0), a.newString = r, a;
    }
    return e.prototype.getNewString = function() {
      return this.newString;
    }, e.prototype.isRemaining = function() {
      return this.remaining;
    }, e.prototype.getRemainingValue = function() {
      return this.remainingValue;
    }, e;
  }(Xk)
), wVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), gb = (
  /** @class */
  function(t) {
    wVe(e, t);
    function e(n, r, i) {
      var a = t.call(this, n) || this;
      if (r < 0 || r > 10 || i < 0 || i > 10)
        throw new ht();
      return a.firstDigit = r, a.secondDigit = i, a;
    }
    return e.prototype.getFirstDigit = function() {
      return this.firstDigit;
    }, e.prototype.getSecondDigit = function() {
      return this.secondDigit;
    }, e.prototype.getValue = function() {
      return this.firstDigit * 10 + this.secondDigit;
    }, e.prototype.isFirstDigitFNC1 = function() {
      return this.firstDigit === e.FNC1;
    }, e.prototype.isSecondDigitFNC1 = function() {
      return this.secondDigit === e.FNC1;
    }, e.prototype.isAnyFNC1 = function() {
      return this.firstDigit === e.FNC1 || this.secondDigit === e.FNC1;
    }, e.FNC1 = 10, e;
  }(Xk)
), ZC = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, xVe = (
  /** @class */
  function() {
    function t() {
    }
    return t.parseFieldsInGeneralPurpose = function(e) {
      var n, r, i, a, s, c, d, f;
      if (!e)
        return null;
      if (e.length < 2)
        throw new Ye();
      var g = e.substring(0, 2);
      try {
        for (var m = ZC(t.TWO_DIGIT_DATA_LENGTH), b = m.next(); !b.done; b = m.next()) {
          var w = b.value;
          if (w[0] === g)
            return w[1] === t.VARIABLE_LENGTH ? t.processVariableAI(2, w[2], e) : t.processFixedAI(2, w[1], e);
        }
      } catch (z) {
        n = { error: z };
      } finally {
        try {
          b && !b.done && (r = m.return) && r.call(m);
        } finally {
          if (n)
            throw n.error;
        }
      }
      if (e.length < 3)
        throw new Ye();
      var _ = e.substring(0, 3);
      try {
        for (var A = ZC(t.THREE_DIGIT_DATA_LENGTH), T = A.next(); !T.done; T = A.next()) {
          var w = T.value;
          if (w[0] === _)
            return w[1] === t.VARIABLE_LENGTH ? t.processVariableAI(3, w[2], e) : t.processFixedAI(3, w[1], e);
        }
      } catch (z) {
        i = { error: z };
      } finally {
        try {
          T && !T.done && (a = A.return) && a.call(A);
        } finally {
          if (i)
            throw i.error;
        }
      }
      try {
        for (var O = ZC(t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH), R = O.next(); !R.done; R = O.next()) {
          var w = R.value;
          if (w[0] === _)
            return w[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, w[2], e) : t.processFixedAI(4, w[1], e);
        }
      } catch (z) {
        s = { error: z };
      } finally {
        try {
          R && !R.done && (c = O.return) && c.call(O);
        } finally {
          if (s)
            throw s.error;
        }
      }
      if (e.length < 4)
        throw new Ye();
      var N = e.substring(0, 4);
      try {
        for (var M = ZC(t.FOUR_DIGIT_DATA_LENGTH), P = M.next(); !P.done; P = M.next()) {
          var w = P.value;
          if (w[0] === N)
            return w[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, w[2], e) : t.processFixedAI(4, w[1], e);
        }
      } catch (z) {
        d = { error: z };
      } finally {
        try {
          P && !P.done && (f = M.return) && f.call(M);
        } finally {
          if (d)
            throw d.error;
        }
      }
      throw new Ye();
    }, t.processFixedAI = function(e, n, r) {
      if (r.length < e)
        throw new Ye();
      var i = r.substring(0, e);
      if (r.length < e + n)
        throw new Ye();
      var a = r.substring(e, e + n), s = r.substring(e + n), c = "(" + i + ")" + a, d = t.parseFieldsInGeneralPurpose(s);
      return d == null ? c : c + d;
    }, t.processVariableAI = function(e, n, r) {
      var i = r.substring(0, e), a;
      r.length < e + n ? a = r.length : a = e + n;
      var s = r.substring(e, a), c = r.substring(a), d = "(" + i + ")" + s, f = t.parseFieldsInGeneralPurpose(c);
      return f == null ? d : d + f;
    }, t.VARIABLE_LENGTH = [], t.TWO_DIGIT_DATA_LENGTH = [
      ["00", 18],
      ["01", 14],
      ["02", 14],
      ["10", t.VARIABLE_LENGTH, 20],
      ["11", 6],
      ["12", 6],
      ["13", 6],
      ["15", 6],
      ["17", 6],
      ["20", 2],
      ["21", t.VARIABLE_LENGTH, 20],
      ["22", t.VARIABLE_LENGTH, 29],
      ["30", t.VARIABLE_LENGTH, 8],
      ["37", t.VARIABLE_LENGTH, 8],
      // internal company codes
      ["90", t.VARIABLE_LENGTH, 30],
      ["91", t.VARIABLE_LENGTH, 30],
      ["92", t.VARIABLE_LENGTH, 30],
      ["93", t.VARIABLE_LENGTH, 30],
      ["94", t.VARIABLE_LENGTH, 30],
      ["95", t.VARIABLE_LENGTH, 30],
      ["96", t.VARIABLE_LENGTH, 30],
      ["97", t.VARIABLE_LENGTH, 3],
      ["98", t.VARIABLE_LENGTH, 30],
      ["99", t.VARIABLE_LENGTH, 30]
    ], t.THREE_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["240", t.VARIABLE_LENGTH, 30],
      ["241", t.VARIABLE_LENGTH, 30],
      ["242", t.VARIABLE_LENGTH, 6],
      ["250", t.VARIABLE_LENGTH, 30],
      ["251", t.VARIABLE_LENGTH, 30],
      ["253", t.VARIABLE_LENGTH, 17],
      ["254", t.VARIABLE_LENGTH, 20],
      ["400", t.VARIABLE_LENGTH, 30],
      ["401", t.VARIABLE_LENGTH, 30],
      ["402", 17],
      ["403", t.VARIABLE_LENGTH, 30],
      ["410", 13],
      ["411", 13],
      ["412", 13],
      ["413", 13],
      ["414", 13],
      ["420", t.VARIABLE_LENGTH, 20],
      ["421", t.VARIABLE_LENGTH, 15],
      ["422", 3],
      ["423", t.VARIABLE_LENGTH, 15],
      ["424", 3],
      ["425", 3],
      ["426", 3]
    ], t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["310", 6],
      ["311", 6],
      ["312", 6],
      ["313", 6],
      ["314", 6],
      ["315", 6],
      ["316", 6],
      ["320", 6],
      ["321", 6],
      ["322", 6],
      ["323", 6],
      ["324", 6],
      ["325", 6],
      ["326", 6],
      ["327", 6],
      ["328", 6],
      ["329", 6],
      ["330", 6],
      ["331", 6],
      ["332", 6],
      ["333", 6],
      ["334", 6],
      ["335", 6],
      ["336", 6],
      ["340", 6],
      ["341", 6],
      ["342", 6],
      ["343", 6],
      ["344", 6],
      ["345", 6],
      ["346", 6],
      ["347", 6],
      ["348", 6],
      ["349", 6],
      ["350", 6],
      ["351", 6],
      ["352", 6],
      ["353", 6],
      ["354", 6],
      ["355", 6],
      ["356", 6],
      ["357", 6],
      ["360", 6],
      ["361", 6],
      ["362", 6],
      ["363", 6],
      ["364", 6],
      ["365", 6],
      ["366", 6],
      ["367", 6],
      ["368", 6],
      ["369", 6],
      ["390", t.VARIABLE_LENGTH, 15],
      ["391", t.VARIABLE_LENGTH, 18],
      ["392", t.VARIABLE_LENGTH, 15],
      ["393", t.VARIABLE_LENGTH, 18],
      ["703", t.VARIABLE_LENGTH, 30]
    ], t.FOUR_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["7001", 13],
      ["7002", t.VARIABLE_LENGTH, 30],
      ["7003", 10],
      ["8001", 14],
      ["8002", t.VARIABLE_LENGTH, 20],
      ["8003", t.VARIABLE_LENGTH, 30],
      ["8004", t.VARIABLE_LENGTH, 30],
      ["8005", 6],
      ["8006", 18],
      ["8007", t.VARIABLE_LENGTH, 30],
      ["8008", t.VARIABLE_LENGTH, 12],
      ["8018", 18],
      ["8020", t.VARIABLE_LENGTH, 25],
      ["8100", 6],
      ["8101", 10],
      ["8102", 2],
      ["8110", t.VARIABLE_LENGTH, 70],
      ["8200", t.VARIABLE_LENGTH, 70]
    ], t;
  }()
), Q4 = (
  /** @class */
  function() {
    function t(e) {
      this.buffer = new Bn(), this.information = e;
    }
    return t.prototype.decodeAllCodes = function(e, n) {
      var r = n, i = null;
      do {
        var a = this.decodeGeneralPurposeField(r, i), s = xVe.parseFieldsInGeneralPurpose(a.getNewString());
        if (s != null && e.append(s), a.isRemaining() ? i = "" + a.getRemainingValue() : i = null, r === a.getNewPosition())
          break;
        r = a.getNewPosition();
      } while (!0);
      return e.toString();
    }, t.prototype.isStillNumeric = function(e) {
      if (e + 7 > this.information.getSize())
        return e + 4 <= this.information.getSize();
      for (var n = e; n < e + 3; ++n)
        if (this.information.get(n))
          return !0;
      return this.information.get(e + 3);
    }, t.prototype.decodeNumeric = function(e) {
      if (e + 7 > this.information.getSize()) {
        var n = this.extractNumericValueFromBitArray(e, 4);
        return n === 0 ? new gb(this.information.getSize(), gb.FNC1, gb.FNC1) : new gb(this.information.getSize(), n - 1, gb.FNC1);
      }
      var r = this.extractNumericValueFromBitArray(e, 7), i = (r - 8) / 11, a = (r - 8) % 11;
      return new gb(e + 7, i, a);
    }, t.prototype.extractNumericValueFromBitArray = function(e, n) {
      return t.extractNumericValueFromBitArray(this.information, e, n);
    }, t.extractNumericValueFromBitArray = function(e, n, r) {
      for (var i = 0, a = 0; a < r; ++a)
        e.get(n + a) && (i |= 1 << r - a - 1);
      return i;
    }, t.prototype.decodeGeneralPurposeField = function(e, n) {
      this.buffer.setLengthToZero(), n != null && this.buffer.append(n), this.current.setPosition(e);
      var r = this.parseBlocks();
      return r != null && r.isRemaining() ? new H1(this.current.getPosition(), this.buffer.toString(), r.getRemainingValue()) : new H1(this.current.getPosition(), this.buffer.toString());
    }, t.prototype.parseBlocks = function() {
      var e, n;
      do {
        var r = this.current.getPosition();
        this.current.isAlpha() ? (n = this.parseAlphaBlock(), e = n.isFinished()) : this.current.isIsoIec646() ? (n = this.parseIsoIec646Block(), e = n.isFinished()) : (n = this.parseNumericBlock(), e = n.isFinished());
        var i = r !== this.current.getPosition();
        if (!i && !e)
          break;
      } while (!e);
      return n.getDecodedInformation();
    }, t.prototype.parseNumericBlock = function() {
      for (; this.isStillNumeric(this.current.getPosition()); ) {
        var e = this.decodeNumeric(this.current.getPosition());
        if (this.current.setPosition(e.getNewPosition()), e.isFirstDigitFNC1()) {
          var n = void 0;
          return e.isSecondDigitFNC1() ? n = new H1(this.current.getPosition(), this.buffer.toString()) : n = new H1(this.current.getPosition(), this.buffer.toString(), e.getSecondDigit()), new $1(!0, n);
        }
        if (this.buffer.append(e.getFirstDigit()), e.isSecondDigitFNC1()) {
          var n = new H1(this.current.getPosition(), this.buffer.toString());
          return new $1(!0, n);
        }
        this.buffer.append(e.getSecondDigit());
      }
      return this.isNumericToAlphaNumericLatch(this.current.getPosition()) && (this.current.setAlpha(), this.current.incrementPosition(4)), new $1(!1);
    }, t.prototype.parseIsoIec646Block = function() {
      for (; this.isStillIsoIec646(this.current.getPosition()); ) {
        var e = this.decodeIsoIec646(this.current.getPosition());
        if (this.current.setPosition(e.getNewPosition()), e.isFNC1()) {
          var n = new H1(this.current.getPosition(), this.buffer.toString());
          return new $1(!0, n);
        }
        this.buffer.append(e.getValue());
      }
      return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setAlpha()), new $1(!1);
    }, t.prototype.parseAlphaBlock = function() {
      for (; this.isStillAlpha(this.current.getPosition()); ) {
        var e = this.decodeAlphanumeric(this.current.getPosition());
        if (this.current.setPosition(e.getNewPosition()), e.isFNC1()) {
          var n = new H1(this.current.getPosition(), this.buffer.toString());
          return new $1(!0, n);
        }
        this.buffer.append(e.getValue());
      }
      return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setIsoIec646()), new $1(!1);
    }, t.prototype.isStillIsoIec646 = function(e) {
      if (e + 5 > this.information.getSize())
        return !1;
      var n = this.extractNumericValueFromBitArray(e, 5);
      if (n >= 5 && n < 16)
        return !0;
      if (e + 7 > this.information.getSize())
        return !1;
      var r = this.extractNumericValueFromBitArray(e, 7);
      if (r >= 64 && r < 116)
        return !0;
      if (e + 8 > this.information.getSize())
        return !1;
      var i = this.extractNumericValueFromBitArray(e, 8);
      return i >= 232 && i < 253;
    }, t.prototype.decodeIsoIec646 = function(e) {
      var n = this.extractNumericValueFromBitArray(e, 5);
      if (n === 15)
        return new ku(e + 5, ku.FNC1);
      if (n >= 5 && n < 15)
        return new ku(e + 5, "0" + (n - 5));
      var r = this.extractNumericValueFromBitArray(e, 7);
      if (r >= 64 && r < 90)
        return new ku(e + 7, "" + (r + 1));
      if (r >= 90 && r < 116)
        return new ku(e + 7, "" + (r + 7));
      var i = this.extractNumericValueFromBitArray(e, 8), a;
      switch (i) {
        case 232:
          a = "!";
          break;
        case 233:
          a = '"';
          break;
        case 234:
          a = "%";
          break;
        case 235:
          a = "&";
          break;
        case 236:
          a = "'";
          break;
        case 237:
          a = "(";
          break;
        case 238:
          a = ")";
          break;
        case 239:
          a = "*";
          break;
        case 240:
          a = "+";
          break;
        case 241:
          a = ",";
          break;
        case 242:
          a = "-";
          break;
        case 243:
          a = ".";
          break;
        case 244:
          a = "/";
          break;
        case 245:
          a = ":";
          break;
        case 246:
          a = ";";
          break;
        case 247:
          a = "<";
          break;
        case 248:
          a = "=";
          break;
        case 249:
          a = ">";
          break;
        case 250:
          a = "?";
          break;
        case 251:
          a = "_";
          break;
        case 252:
          a = " ";
          break;
        default:
          throw new ht();
      }
      return new ku(e + 8, a);
    }, t.prototype.isStillAlpha = function(e) {
      if (e + 5 > this.information.getSize())
        return !1;
      var n = this.extractNumericValueFromBitArray(e, 5);
      if (n >= 5 && n < 16)
        return !0;
      if (e + 6 > this.information.getSize())
        return !1;
      var r = this.extractNumericValueFromBitArray(e, 6);
      return r >= 16 && r < 63;
    }, t.prototype.decodeAlphanumeric = function(e) {
      var n = this.extractNumericValueFromBitArray(e, 5);
      if (n === 15)
        return new ku(e + 5, ku.FNC1);
      if (n >= 5 && n < 15)
        return new ku(e + 5, "0" + (n - 5));
      var r = this.extractNumericValueFromBitArray(e, 6);
      if (r >= 32 && r < 58)
        return new ku(e + 6, "" + (r + 33));
      var i;
      switch (r) {
        case 58:
          i = "*";
          break;
        case 59:
          i = ",";
          break;
        case 60:
          i = "-";
          break;
        case 61:
          i = ".";
          break;
        case 62:
          i = "/";
          break;
        default:
          throw new X_("Decoding invalid alphanumeric value: " + r);
      }
      return new ku(e + 6, i);
    }, t.prototype.isAlphaTo646ToAlphaLatch = function(e) {
      if (e + 1 > this.information.getSize())
        return !1;
      for (var n = 0; n < 5 && n + e < this.information.getSize(); ++n)
        if (n === 2) {
          if (!this.information.get(e + 2))
            return !1;
        } else if (this.information.get(e + n))
          return !1;
      return !0;
    }, t.prototype.isAlphaOr646ToNumericLatch = function(e) {
      if (e + 3 > this.information.getSize())
        return !1;
      for (var n = e; n < e + 3; ++n)
        if (this.information.get(n))
          return !1;
      return !0;
    }, t.prototype.isNumericToAlphaNumericLatch = function(e) {
      if (e + 1 > this.information.getSize())
        return !1;
      for (var n = 0; n < 4 && n + e < this.information.getSize(); ++n)
        if (this.information.get(e + n))
          return !1;
      return !0;
    }, t;
  }()
), _ee = (
  /** @class */
  function() {
    function t(e) {
      this.information = e, this.generalDecoder = new Q4(e);
    }
    return t.prototype.getInformation = function() {
      return this.information;
    }, t.prototype.getGeneralDecoder = function() {
      return this.generalDecoder;
    }, t;
  }()
), SVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Vu = (
  /** @class */
  function(t) {
    SVe(e, t);
    function e(n) {
      return t.call(this, n) || this;
    }
    return e.prototype.encodeCompressedGtin = function(n, r) {
      n.append("(01)");
      var i = n.length();
      n.append("9"), this.encodeCompressedGtinWithoutAI(n, r, i);
    }, e.prototype.encodeCompressedGtinWithoutAI = function(n, r, i) {
      for (var a = 0; a < 4; ++a) {
        var s = this.getGeneralDecoder().extractNumericValueFromBitArray(r + 10 * a, 10);
        s / 100 === 0 && n.append("0"), s / 10 === 0 && n.append("0"), n.append(s);
      }
      e.appendCheckDigit(n, i);
    }, e.appendCheckDigit = function(n, r) {
      for (var i = 0, a = 0; a < 13; a++) {
        var s = n.charAt(a + r).charCodeAt(0) - "0".charCodeAt(0);
        i += a & 1 ? s : 3 * s;
      }
      i = 10 - i % 10, i === 10 && (i = 0), n.append(i);
    }, e.GTIN_SIZE = 40, e;
  }(_ee)
), EVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), _Ve = (
  /** @class */
  function(t) {
    EVe(e, t);
    function e(n) {
      return t.call(this, n) || this;
    }
    return e.prototype.parseInformation = function() {
      var n = new Bn();
      n.append("(01)");
      var r = n.length(), i = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE, 4);
      return n.append(i), this.encodeCompressedGtinWithoutAI(n, e.HEADER_SIZE + 4, r), this.getGeneralDecoder().decodeAllCodes(n, e.HEADER_SIZE + 44);
    }, e.HEADER_SIZE = 1 + 1 + 2, e;
  }(Vu)
), AVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), CVe = (
  /** @class */
  function(t) {
    AVe(e, t);
    function e(n) {
      return t.call(this, n) || this;
    }
    return e.prototype.parseInformation = function() {
      var n = new Bn();
      return this.getGeneralDecoder().decodeAllCodes(n, e.HEADER_SIZE);
    }, e.HEADER_SIZE = 2 + 1 + 2, e;
  }(_ee)
), TVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Z4 = (
  /** @class */
  function(t) {
    TVe(e, t);
    function e(n) {
      return t.call(this, n) || this;
    }
    return e.prototype.encodeCompressedWeight = function(n, r, i) {
      var a = this.getGeneralDecoder().extractNumericValueFromBitArray(r, i);
      this.addWeightCode(n, a);
      for (var s = this.checkWeight(a), c = 1e5, d = 0; d < 5; ++d)
        s / c === 0 && n.append("0"), c /= 10;
      n.append(s);
    }, e;
  }(Vu)
), OVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Aee = (
  /** @class */
  function(t) {
    OVe(e, t);
    function e(n) {
      return t.call(this, n) || this;
    }
    return e.prototype.parseInformation = function() {
      if (this.getInformation().getSize() !== e.HEADER_SIZE + Z4.GTIN_SIZE + e.WEIGHT_SIZE)
        throw new Ye();
      var n = new Bn();
      return this.encodeCompressedGtin(n, e.HEADER_SIZE), this.encodeCompressedWeight(n, e.HEADER_SIZE + Z4.GTIN_SIZE, e.WEIGHT_SIZE), n.toString();
    }, e.HEADER_SIZE = 4 + 1, e.WEIGHT_SIZE = 15, e;
  }(Z4)
), RVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), DVe = (
  /** @class */
  function(t) {
    RVe(e, t);
    function e(n) {
      return t.call(this, n) || this;
    }
    return e.prototype.addWeightCode = function(n, r) {
      n.append("(3103)");
    }, e.prototype.checkWeight = function(n) {
      return n;
    }, e;
  }(Aee)
), NVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), MVe = (
  /** @class */
  function(t) {
    NVe(e, t);
    function e(n) {
      return t.call(this, n) || this;
    }
    return e.prototype.addWeightCode = function(n, r) {
      r < 1e4 ? n.append("(3202)") : n.append("(3203)");
    }, e.prototype.checkWeight = function(n) {
      return n < 1e4 ? n : n - 1e4;
    }, e;
  }(Aee)
), IVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), kVe = (
  /** @class */
  function(t) {
    IVe(e, t);
    function e(n) {
      return t.call(this, n) || this;
    }
    return e.prototype.parseInformation = function() {
      if (this.getInformation().getSize() < e.HEADER_SIZE + Vu.GTIN_SIZE)
        throw new Ye();
      var n = new Bn();
      this.encodeCompressedGtin(n, e.HEADER_SIZE);
      var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + Vu.GTIN_SIZE, e.LAST_DIGIT_SIZE);
      n.append("(392"), n.append(r), n.append(")");
      var i = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + Vu.GTIN_SIZE + e.LAST_DIGIT_SIZE, null);
      return n.append(i.getNewString()), n.toString();
    }, e.HEADER_SIZE = 5 + 1 + 2, e.LAST_DIGIT_SIZE = 2, e;
  }(Vu)
), jVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), PVe = (
  /** @class */
  function(t) {
    jVe(e, t);
    function e(n) {
      return t.call(this, n) || this;
    }
    return e.prototype.parseInformation = function() {
      if (this.getInformation().getSize() < e.HEADER_SIZE + Vu.GTIN_SIZE)
        throw new Ye();
      var n = new Bn();
      this.encodeCompressedGtin(n, e.HEADER_SIZE);
      var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + Vu.GTIN_SIZE, e.LAST_DIGIT_SIZE);
      n.append("(393"), n.append(r), n.append(")");
      var i = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + Vu.GTIN_SIZE + e.LAST_DIGIT_SIZE, e.FIRST_THREE_DIGITS_SIZE);
      i / 100 === 0 && n.append("0"), i / 10 === 0 && n.append("0"), n.append(i);
      var a = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + Vu.GTIN_SIZE + e.LAST_DIGIT_SIZE + e.FIRST_THREE_DIGITS_SIZE, null);
      return n.append(a.getNewString()), n.toString();
    }, e.HEADER_SIZE = 5 + 1 + 2, e.LAST_DIGIT_SIZE = 2, e.FIRST_THREE_DIGITS_SIZE = 10, e;
  }(Vu)
), LVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), w0 = (
  /** @class */
  function(t) {
    LVe(e, t);
    function e(n, r, i) {
      var a = t.call(this, n) || this;
      return a.dateCode = i, a.firstAIdigits = r, a;
    }
    return e.prototype.parseInformation = function() {
      if (this.getInformation().getSize() !== e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE + e.DATE_SIZE)
        throw new Ye();
      var n = new Bn();
      return this.encodeCompressedGtin(n, e.HEADER_SIZE), this.encodeCompressedWeight(n, e.HEADER_SIZE + e.GTIN_SIZE, e.WEIGHT_SIZE), this.encodeCompressedDate(n, e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE), n.toString();
    }, e.prototype.encodeCompressedDate = function(n, r) {
      var i = this.getGeneralDecoder().extractNumericValueFromBitArray(r, e.DATE_SIZE);
      if (i !== 38400) {
        n.append("("), n.append(this.dateCode), n.append(")");
        var a = i % 32;
        i /= 32;
        var s = i % 12 + 1;
        i /= 12;
        var c = i;
        c / 10 === 0 && n.append("0"), n.append(c), s / 10 === 0 && n.append("0"), n.append(s), a / 10 === 0 && n.append("0"), n.append(a);
      }
    }, e.prototype.addWeightCode = function(n, r) {
      n.append("("), n.append(this.firstAIdigits), n.append(r / 1e5), n.append(")");
    }, e.prototype.checkWeight = function(n) {
      return n % 1e5;
    }, e.HEADER_SIZE = 7 + 1, e.WEIGHT_SIZE = 20, e.DATE_SIZE = 16, e;
  }(Z4)
);
function BVe(t) {
  try {
    if (t.get(1))
      return new _Ve(t);
    if (!t.get(2))
      return new CVe(t);
    var e = Q4.extractNumericValueFromBitArray(t, 1, 4);
    switch (e) {
      case 4:
        return new DVe(t);
      case 5:
        return new MVe(t);
    }
    var n = Q4.extractNumericValueFromBitArray(t, 1, 5);
    switch (n) {
      case 12:
        return new kVe(t);
      case 13:
        return new PVe(t);
    }
    var r = Q4.extractNumericValueFromBitArray(t, 1, 7);
    switch (r) {
      case 56:
        return new w0(t, "310", "11");
      case 57:
        return new w0(t, "320", "11");
      case 58:
        return new w0(t, "310", "13");
      case 59:
        return new w0(t, "320", "13");
      case 60:
        return new w0(t, "310", "15");
      case 61:
        return new w0(t, "320", "15");
      case 62:
        return new w0(t, "310", "17");
      case 63:
        return new w0(t, "320", "17");
    }
  } catch (i) {
    throw console.log(i), new X_("unknown decoder: " + t);
  }
}
var WU = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      this.leftchar = e, this.rightchar = n, this.finderpattern = r, this.maybeLast = i;
    }
    return t.prototype.mayBeLast = function() {
      return this.maybeLast;
    }, t.prototype.getLeftChar = function() {
      return this.leftchar;
    }, t.prototype.getRightChar = function() {
      return this.rightchar;
    }, t.prototype.getFinderPattern = function() {
      return this.finderpattern;
    }, t.prototype.mustBeLast = function() {
      return this.rightchar == null;
    }, t.prototype.toString = function() {
      return "[ " + this.leftchar + ", " + this.rightchar + " : " + (this.finderpattern == null ? "null" : this.finderpattern.getValue()) + " ]";
    }, t.equals = function(e, n) {
      return e instanceof t ? t.equalsOrNull(e.leftchar, n.leftchar) && t.equalsOrNull(e.rightchar, n.rightchar) && t.equalsOrNull(e.finderpattern, n.finderpattern) : !1;
    }, t.equalsOrNull = function(e, n) {
      return e === null ? n === null : t.equals(e, n);
    }, t.prototype.hashCode = function() {
      var e = this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
      return e;
    }, t;
  }()
), zVe = (
  /** @class */
  function() {
    function t(e, n, r) {
      this.pairs = e, this.rowNumber = n, this.wasReversed = r;
    }
    return t.prototype.getPairs = function() {
      return this.pairs;
    }, t.prototype.getRowNumber = function() {
      return this.rowNumber;
    }, t.prototype.isReversed = function() {
      return this.wasReversed;
    }, t.prototype.isEquivalent = function(e) {
      return this.checkEqualitity(this, e);
    }, t.prototype.toString = function() {
      return "{ " + this.pairs + " }";
    }, t.prototype.equals = function(e, n) {
      return e instanceof t ? this.checkEqualitity(e, n) && e.wasReversed === n.wasReversed : !1;
    }, t.prototype.checkEqualitity = function(e, n) {
      if (!(!e || !n)) {
        var r;
        return e.forEach(function(i, a) {
          n.forEach(function(s) {
            i.getLeftChar().getValue() === s.getLeftChar().getValue() && i.getRightChar().getValue() === s.getRightChar().getValue() && i.getFinderPatter().getValue() === s.getFinderPatter().getValue() && (r = !0);
          });
        }), r;
      }
    }, t;
  }()
), FVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), x0 = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, VVe = (
  /** @class */
  function(t) {
    FVe(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.pairs = new Array(e.MAX_PAIRS), n.rows = new Array(), n.startEnd = [2], n;
    }
    return e.prototype.decodeRow = function(n, r, i) {
      this.pairs.length = 0, this.startFromEven = !1;
      try {
        return e.constructResult(this.decodeRow2pairs(n, r));
      } catch {
      }
      return this.pairs.length = 0, this.startFromEven = !0, e.constructResult(this.decodeRow2pairs(n, r));
    }, e.prototype.reset = function() {
      this.pairs.length = 0, this.rows.length = 0;
    }, e.prototype.decodeRow2pairs = function(n, r) {
      for (var i = !1; !i; )
        try {
          this.pairs.push(this.retrieveNextPair(r, this.pairs, n));
        } catch (c) {
          if (c instanceof Ye) {
            if (!this.pairs.length)
              throw new Ye();
            i = !0;
          }
        }
      if (this.checkChecksum())
        return this.pairs;
      var a;
      if (this.rows.length ? a = !0 : a = !1, this.storeRow(n, !1), a) {
        var s = this.checkRowsBoolean(!1);
        if (s != null || (s = this.checkRowsBoolean(!0), s != null))
          return s;
      }
      throw new Ye();
    }, e.prototype.checkRowsBoolean = function(n) {
      if (this.rows.length > 25)
        return this.rows.length = 0, null;
      this.pairs.length = 0, n && (this.rows = this.rows.reverse());
      var r = null;
      try {
        r = this.checkRows(new Array(), 0);
      } catch (i) {
        console.log(i);
      }
      return n && (this.rows = this.rows.reverse()), r;
    }, e.prototype.checkRows = function(n, r) {
      for (var i, a, s = r; s < this.rows.length; s++) {
        var c = this.rows[s];
        this.pairs.length = 0;
        try {
          for (var d = (i = void 0, x0(n)), f = d.next(); !f.done; f = d.next()) {
            var g = f.value;
            this.pairs.push(g.getPairs());
          }
        } catch (b) {
          i = { error: b };
        } finally {
          try {
            f && !f.done && (a = d.return) && a.call(d);
          } finally {
            if (i)
              throw i.error;
          }
        }
        if (this.pairs.push(c.getPairs()), !!e.isValidSequence(this.pairs)) {
          if (this.checkChecksum())
            return this.pairs;
          var m = new Array(n);
          m.push(c);
          try {
            return this.checkRows(m, s + 1);
          } catch (b) {
            console.log(b);
          }
        }
      }
      throw new Ye();
    }, e.isValidSequence = function(n) {
      var r, i;
      try {
        for (var a = x0(e.FINDER_PATTERN_SEQUENCES), s = a.next(); !s.done; s = a.next()) {
          var c = s.value;
          if (!(n.length > c.length)) {
            for (var d = !0, f = 0; f < n.length; f++)
              if (n[f].getFinderPattern().getValue() !== c[f]) {
                d = !1;
                break;
              }
            if (d)
              return !0;
          }
        }
      } catch (g) {
        r = { error: g };
      } finally {
        try {
          s && !s.done && (i = a.return) && i.call(a);
        } finally {
          if (r)
            throw r.error;
        }
      }
      return !1;
    }, e.prototype.storeRow = function(n, r) {
      for (var i = 0, a = !1, s = !1; i < this.rows.length; ) {
        var c = this.rows[i];
        if (c.getRowNumber() > n) {
          s = c.isEquivalent(this.pairs);
          break;
        }
        a = c.isEquivalent(this.pairs), i++;
      }
      s || a || e.isPartialRow(this.pairs, this.rows) || (this.rows.push(i, new zVe(this.pairs, n, r)), this.removePartialRows(this.pairs, this.rows));
    }, e.prototype.removePartialRows = function(n, r) {
      var i, a, s, c, d, f;
      try {
        for (var g = x0(r), m = g.next(); !m.done; m = g.next()) {
          var b = m.value;
          if (b.getPairs().length !== n.length) {
            var w = !0;
            try {
              for (var _ = (s = void 0, x0(b.getPairs())), A = _.next(); !A.done; A = _.next()) {
                var T = A.value, O = !1;
                try {
                  for (var R = (d = void 0, x0(n)), N = R.next(); !N.done; N = R.next()) {
                    var M = N.value;
                    if (WU.equals(T, M)) {
                      O = !0;
                      break;
                    }
                  }
                } catch (P) {
                  d = { error: P };
                } finally {
                  try {
                    N && !N.done && (f = R.return) && f.call(R);
                  } finally {
                    if (d)
                      throw d.error;
                  }
                }
                O || (w = !1);
              }
            } catch (P) {
              s = { error: P };
            } finally {
              try {
                A && !A.done && (c = _.return) && c.call(_);
              } finally {
                if (s)
                  throw s.error;
              }
            }
          }
        }
      } catch (P) {
        i = { error: P };
      } finally {
        try {
          m && !m.done && (a = g.return) && a.call(g);
        } finally {
          if (i)
            throw i.error;
        }
      }
    }, e.isPartialRow = function(n, r) {
      var i, a, s, c, d, f;
      try {
        for (var g = x0(r), m = g.next(); !m.done; m = g.next()) {
          var b = m.value, w = !0;
          try {
            for (var _ = (s = void 0, x0(n)), A = _.next(); !A.done; A = _.next()) {
              var T = A.value, O = !1;
              try {
                for (var R = (d = void 0, x0(b.getPairs())), N = R.next(); !N.done; N = R.next()) {
                  var M = N.value;
                  if (T.equals(M)) {
                    O = !0;
                    break;
                  }
                }
              } catch (P) {
                d = { error: P };
              } finally {
                try {
                  N && !N.done && (f = R.return) && f.call(R);
                } finally {
                  if (d)
                    throw d.error;
                }
              }
              if (!O) {
                w = !1;
                break;
              }
            }
          } catch (P) {
            s = { error: P };
          } finally {
            try {
              A && !A.done && (c = _.return) && c.call(_);
            } finally {
              if (s)
                throw s.error;
            }
          }
          if (w)
            return !0;
        }
      } catch (P) {
        i = { error: P };
      } finally {
        try {
          m && !m.done && (a = g.return) && a.call(g);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return !1;
    }, e.prototype.getRows = function() {
      return this.rows;
    }, e.constructResult = function(n) {
      var r = vVe.buildBitArray(n), i = BVe(r), a = i.parseInformation(), s = n[0].getFinderPattern().getResultPoints(), c = n[n.length - 1].getFinderPattern().getResultPoints(), d = [s[0], s[1], c[0], c[1]];
      return new ts(a, null, null, d, Ht.RSS_EXPANDED, null);
    }, e.prototype.checkChecksum = function() {
      var n = this.pairs.get(0), r = n.getLeftChar(), i = n.getRightChar();
      if (i === null)
        return !1;
      for (var a = i.getChecksumPortion(), s = 2, c = 1; c < this.pairs.size(); ++c) {
        var d = this.pairs.get(c);
        a += d.getLeftChar().getChecksumPortion(), s++;
        var f = d.getRightChar();
        f != null && (a += f.getChecksumPortion(), s++);
      }
      a %= 211;
      var g = 211 * (s - 4) + a;
      return g === r.getValue();
    }, e.getNextSecondBar = function(n, r) {
      var i;
      return n.get(r) ? (i = n.getNextUnset(r), i = n.getNextSet(i)) : (i = n.getNextSet(r), i = n.getNextUnset(i)), i;
    }, e.prototype.retrieveNextPair = function(n, r, i) {
      var a = r.length % 2 === 0;
      this.startFromEven && (a = !a);
      var s, c = !0, d = -1;
      do
        this.findNextPair(n, r, d), s = this.parseFoundFinderPattern(n, i, a), s === null ? d = e.getNextSecondBar(n, this.startEnd[0]) : c = !1;
      while (c);
      var f = this.decodeDataCharacter(n, s, a, !0);
      if (!this.isEmptyPair(r) && r[r.length - 1].mustBeLast())
        throw new Ye();
      var g;
      try {
        g = this.decodeDataCharacter(n, s, a, !1);
      } catch (m) {
        g = null, console.log(m);
      }
      return new WU(f, g, s, !0);
    }, e.prototype.isEmptyPair = function(n) {
      return n.length === 0;
    }, e.prototype.findNextPair = function(n, r, i) {
      var a = this.getDecodeFinderCounters();
      a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
      var s = n.getSize(), c;
      if (i >= 0)
        c = i;
      else if (this.isEmptyPair(r))
        c = 0;
      else {
        var d = r[r.length - 1];
        c = d.getFinderPattern().getStartEnd()[1];
      }
      var f = r.length % 2 !== 0;
      this.startFromEven && (f = !f);
      for (var g = !1; c < s && (g = !n.get(c), !!g); )
        c++;
      for (var m = 0, b = c, w = c; w < s; w++)
        if (n.get(w) !== g)
          a[m]++;
        else {
          if (m === 3) {
            if (f && e.reverseCounters(a), e.isFinderPattern(a)) {
              this.startEnd[0] = b, this.startEnd[1] = w;
              return;
            }
            f && e.reverseCounters(a), b += a[0] + a[1], a[0] = a[2], a[1] = a[3], a[2] = 0, a[3] = 0, m--;
          } else
            m++;
          a[m] = 1, g = !g;
        }
      throw new Ye();
    }, e.reverseCounters = function(n) {
      for (var r = n.length, i = 0; i < r / 2; ++i) {
        var a = n[i];
        n[i] = n[r - i - 1], n[r - i - 1] = a;
      }
    }, e.prototype.parseFoundFinderPattern = function(n, r, i) {
      var a, s, c;
      if (i) {
        for (var d = this.startEnd[0] - 1; d >= 0 && !n.get(d); )
          d--;
        d++, a = this.startEnd[0] - d, s = d, c = this.startEnd[1];
      } else
        s = this.startEnd[0], c = n.getNextUnset(this.startEnd[1] + 1), a = c - this.startEnd[1];
      var f = this.getDecodeFinderCounters();
      si.arraycopy(f, 0, f, 1, f.length - 1), f[0] = a;
      var g;
      try {
        g = this.parseFinderValue(f, e.FINDER_PATTERNS);
      } catch {
        return null;
      }
      return new Eee(g, [s, c], s, c, r);
    }, e.prototype.decodeDataCharacter = function(n, r, i, a) {
      for (var s = this.getDataCharacterCounters(), c = 0; c < s.length; c++)
        s[c] = 0;
      if (a)
        e.recordPatternInReverse(n, r.getStartEnd()[0], s);
      else {
        e.recordPattern(n, r.getStartEnd()[1], s);
        for (var d = 0, f = s.length - 1; d < f; d++, f--) {
          var g = s[d];
          s[d] = s[f], s[f] = g;
        }
      }
      var m = 17, b = gr.sum(new Int32Array(s)) / m, w = (r.getStartEnd()[1] - r.getStartEnd()[0]) / 15;
      if (Math.abs(b - w) / w > 0.3)
        throw new Ye();
      for (var _ = this.getOddCounts(), A = this.getEvenCounts(), T = this.getOddRoundingErrors(), O = this.getEvenRoundingErrors(), d = 0; d < s.length; d++) {
        var R = 1 * s[d] / b, N = R + 0.5;
        if (N < 1) {
          if (R < 0.3)
            throw new Ye();
          N = 1;
        } else if (N > 8) {
          if (R > 8.7)
            throw new Ye();
          N = 8;
        }
        var M = d / 2;
        d & 1 ? (A[M] = N, O[M] = R - N) : (_[M] = N, T[M] = R - N);
      }
      this.adjustOddEvenCounts(m);
      for (var P = 4 * r.getValue() + (i ? 0 : 2) + (a ? 0 : 1) - 1, z = 0, F = 0, d = _.length - 1; d >= 0; d--) {
        if (e.isNotA1left(r, i, a)) {
          var $ = e.WEIGHTS[P][2 * d];
          F += _[d] * $;
        }
        z += _[d];
      }
      for (var G = 0, d = A.length - 1; d >= 0; d--)
        if (e.isNotA1left(r, i, a)) {
          var $ = e.WEIGHTS[P][2 * d + 1];
          G += A[d] * $;
        }
      var H = F + G;
      if (z & 1 || z > 13 || z < 4)
        throw new Ye();
      var Z = (13 - z) / 2, V = e.SYMBOL_WIDEST[Z], Y = 9 - V, ee = Rb.getRSSvalue(_, V, !0), K = Rb.getRSSvalue(A, Y, !1), U = e.EVEN_TOTAL_SUBSET[Z], q = e.GSUM[Z], W = ee * U + K + q;
      return new v5(W, H);
    }, e.isNotA1left = function(n, r, i) {
      return !(n.getValue() === 0 && r && i);
    }, e.prototype.adjustOddEvenCounts = function(n) {
      var r = gr.sum(new Int32Array(this.getOddCounts())), i = gr.sum(new Int32Array(this.getEvenCounts())), a = !1, s = !1;
      r > 13 ? s = !0 : r < 4 && (a = !0);
      var c = !1, d = !1;
      i > 13 ? d = !0 : i < 4 && (c = !0);
      var f = r + i - n, g = (r & 1) === 1, m = (i & 1) === 0;
      if (f === 1)
        if (g) {
          if (m)
            throw new Ye();
          s = !0;
        } else {
          if (!m)
            throw new Ye();
          d = !0;
        }
      else if (f === -1)
        if (g) {
          if (m)
            throw new Ye();
          a = !0;
        } else {
          if (!m)
            throw new Ye();
          c = !0;
        }
      else if (f === 0) {
        if (g) {
          if (!m)
            throw new Ye();
          r < i ? (a = !0, d = !0) : (s = !0, c = !0);
        } else if (m)
          throw new Ye();
      } else
        throw new Ye();
      if (a) {
        if (s)
          throw new Ye();
        e.increment(this.getOddCounts(), this.getOddRoundingErrors());
      }
      if (s && e.decrement(this.getOddCounts(), this.getOddRoundingErrors()), c) {
        if (d)
          throw new Ye();
        e.increment(this.getEvenCounts(), this.getOddRoundingErrors());
      }
      d && e.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.SYMBOL_WIDEST = [7, 5, 4, 3, 1], e.EVEN_TOTAL_SUBSET = [4, 20, 52, 104, 204], e.GSUM = [0, 348, 1388, 2948, 3988], e.FINDER_PATTERNS = [
      Int32Array.from([1, 8, 4, 1]),
      Int32Array.from([3, 6, 4, 1]),
      Int32Array.from([3, 4, 6, 1]),
      Int32Array.from([3, 2, 8, 1]),
      Int32Array.from([2, 6, 5, 1]),
      Int32Array.from([2, 2, 9, 1])
    ], e.WEIGHTS = [
      [1, 3, 9, 27, 81, 32, 96, 77],
      [20, 60, 180, 118, 143, 7, 21, 63],
      [189, 145, 13, 39, 117, 140, 209, 205],
      [193, 157, 49, 147, 19, 57, 171, 91],
      [62, 186, 136, 197, 169, 85, 44, 132],
      [185, 133, 188, 142, 4, 12, 36, 108],
      [113, 128, 173, 97, 80, 29, 87, 50],
      [150, 28, 84, 41, 123, 158, 52, 156],
      [46, 138, 203, 187, 139, 206, 196, 166],
      [76, 17, 51, 153, 37, 111, 122, 155],
      [43, 129, 176, 106, 107, 110, 119, 146],
      [16, 48, 144, 10, 30, 90, 59, 177],
      [109, 116, 137, 200, 178, 112, 125, 164],
      [70, 210, 208, 202, 184, 130, 179, 115],
      [134, 191, 151, 31, 93, 68, 204, 190],
      [148, 22, 66, 198, 172, 94, 71, 2],
      [6, 18, 54, 162, 64, 192, 154, 40],
      [120, 149, 25, 75, 14, 42, 126, 167],
      [79, 26, 78, 23, 69, 207, 199, 175],
      [103, 98, 83, 38, 114, 131, 182, 124],
      [161, 61, 183, 127, 170, 88, 53, 159],
      [55, 165, 73, 8, 24, 72, 5, 15],
      [45, 135, 194, 160, 58, 174, 100, 89]
    ], e.FINDER_PAT_A = 0, e.FINDER_PAT_B = 1, e.FINDER_PAT_C = 2, e.FINDER_PAT_D = 3, e.FINDER_PAT_E = 4, e.FINDER_PAT_F = 5, e.FINDER_PATTERN_SEQUENCES = [
      [e.FINDER_PAT_A, e.FINDER_PAT_A],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_B,
        e.FINDER_PAT_B
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_C,
        e.FINDER_PAT_B,
        e.FINDER_PAT_D
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_E,
        e.FINDER_PAT_B,
        e.FINDER_PAT_D,
        e.FINDER_PAT_C
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_E,
        e.FINDER_PAT_B,
        e.FINDER_PAT_D,
        e.FINDER_PAT_D,
        e.FINDER_PAT_F
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_E,
        e.FINDER_PAT_B,
        e.FINDER_PAT_D,
        e.FINDER_PAT_E,
        e.FINDER_PAT_F,
        e.FINDER_PAT_F
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_A,
        e.FINDER_PAT_B,
        e.FINDER_PAT_B,
        e.FINDER_PAT_C,
        e.FINDER_PAT_C,
        e.FINDER_PAT_D,
        e.FINDER_PAT_D
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_A,
        e.FINDER_PAT_B,
        e.FINDER_PAT_B,
        e.FINDER_PAT_C,
        e.FINDER_PAT_C,
        e.FINDER_PAT_D,
        e.FINDER_PAT_E,
        e.FINDER_PAT_E
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_A,
        e.FINDER_PAT_B,
        e.FINDER_PAT_B,
        e.FINDER_PAT_C,
        e.FINDER_PAT_C,
        e.FINDER_PAT_D,
        e.FINDER_PAT_E,
        e.FINDER_PAT_F,
        e.FINDER_PAT_F
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_A,
        e.FINDER_PAT_B,
        e.FINDER_PAT_B,
        e.FINDER_PAT_C,
        e.FINDER_PAT_D,
        e.FINDER_PAT_D,
        e.FINDER_PAT_E,
        e.FINDER_PAT_E,
        e.FINDER_PAT_F,
        e.FINDER_PAT_F
      ]
    ], e.MAX_PAIRS = 11, e;
  }(K1)
), UVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), $Ve = (
  /** @class */
  function(t) {
    UVe(e, t);
    function e(n, r, i) {
      var a = t.call(this, n, r) || this;
      return a.count = 0, a.finderPattern = i, a;
    }
    return e.prototype.getFinderPattern = function() {
      return this.finderPattern;
    }, e.prototype.getCount = function() {
      return this.count;
    }, e.prototype.incrementCount = function() {
      this.count++;
    }, e;
  }(v5)
), HVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), PD = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, QU = (
  /** @class */
  function(t) {
    HVe(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.possibleLeftPairs = [], n.possibleRightPairs = [], n;
    }
    return e.prototype.decodeRow = function(n, r, i) {
      var a, s, c, d, f = this.decodePair(r, !1, n, i);
      e.addOrTally(this.possibleLeftPairs, f), r.reverse();
      var g = this.decodePair(r, !0, n, i);
      e.addOrTally(this.possibleRightPairs, g), r.reverse();
      try {
        for (var m = PD(this.possibleLeftPairs), b = m.next(); !b.done; b = m.next()) {
          var w = b.value;
          if (w.getCount() > 1)
            try {
              for (var _ = (c = void 0, PD(this.possibleRightPairs)), A = _.next(); !A.done; A = _.next()) {
                var T = A.value;
                if (T.getCount() > 1 && e.checkChecksum(w, T))
                  return e.constructResult(w, T);
              }
            } catch (O) {
              c = { error: O };
            } finally {
              try {
                A && !A.done && (d = _.return) && d.call(_);
              } finally {
                if (c)
                  throw c.error;
              }
            }
        }
      } catch (O) {
        a = { error: O };
      } finally {
        try {
          b && !b.done && (s = m.return) && s.call(m);
        } finally {
          if (a)
            throw a.error;
        }
      }
      throw new Ye();
    }, e.addOrTally = function(n, r) {
      var i, a;
      if (r != null) {
        var s = !1;
        try {
          for (var c = PD(n), d = c.next(); !d.done; d = c.next()) {
            var f = d.value;
            if (f.getValue() === r.getValue()) {
              f.incrementCount(), s = !0;
              break;
            }
          }
        } catch (g) {
          i = { error: g };
        } finally {
          try {
            d && !d.done && (a = c.return) && a.call(c);
          } finally {
            if (i)
              throw i.error;
          }
        }
        s || n.push(r);
      }
    }, e.prototype.reset = function() {
      this.possibleLeftPairs.length = 0, this.possibleRightPairs.length = 0;
    }, e.constructResult = function(n, r) {
      for (var i = 4537077 * n.getValue() + r.getValue(), a = new String(i).toString(), s = new Bn(), c = 13 - a.length; c > 0; c--)
        s.append("0");
      s.append(a);
      for (var d = 0, c = 0; c < 13; c++) {
        var f = s.charAt(c).charCodeAt(0) - "0".charCodeAt(0);
        d += c & 1 ? f : 3 * f;
      }
      d = 10 - d % 10, d === 10 && (d = 0), s.append(d.toString());
      var g = n.getFinderPattern().getResultPoints(), m = r.getFinderPattern().getResultPoints();
      return new ts(s.toString(), null, 0, [g[0], g[1], m[0], m[1]], Ht.RSS_14, (/* @__PURE__ */ new Date()).getTime());
    }, e.checkChecksum = function(n, r) {
      var i = (n.getChecksumPortion() + 16 * r.getChecksumPortion()) % 79, a = 9 * n.getFinderPattern().getValue() + r.getFinderPattern().getValue();
      return a > 72 && a--, a > 8 && a--, i === a;
    }, e.prototype.decodePair = function(n, r, i, a) {
      try {
        var s = this.findFinderPattern(n, r), c = this.parseFoundFinderPattern(n, i, r, s), d = a == null ? null : a.get(Ui.NEED_RESULT_POINT_CALLBACK);
        if (d != null) {
          var f = (s[0] + s[1]) / 2;
          r && (f = n.getSize() - 1 - f), d.foundPossibleResultPoint(new kt(f, i));
        }
        var g = this.decodeDataCharacter(n, c, !0), m = this.decodeDataCharacter(n, c, !1);
        return new $Ve(1597 * g.getValue() + m.getValue(), g.getChecksumPortion() + 4 * m.getChecksumPortion(), c);
      } catch {
        return null;
      }
    }, e.prototype.decodeDataCharacter = function(n, r, i) {
      for (var a = this.getDataCharacterCounters(), s = 0; s < a.length; s++)
        a[s] = 0;
      if (i)
        Ga.recordPatternInReverse(n, r.getStartEnd()[0], a);
      else {
        Ga.recordPattern(n, r.getStartEnd()[1] + 1, a);
        for (var c = 0, d = a.length - 1; c < d; c++, d--) {
          var f = a[c];
          a[c] = a[d], a[d] = f;
        }
      }
      for (var g = i ? 16 : 15, m = gr.sum(new Int32Array(a)) / g, b = this.getOddCounts(), w = this.getEvenCounts(), _ = this.getOddRoundingErrors(), A = this.getEvenRoundingErrors(), c = 0; c < a.length; c++) {
        var T = a[c] / m, O = Math.floor(T + 0.5);
        O < 1 ? O = 1 : O > 8 && (O = 8);
        var R = Math.floor(c / 2);
        c & 1 ? (w[R] = O, A[R] = T - O) : (b[R] = O, _[R] = T - O);
      }
      this.adjustOddEvenCounts(i, g);
      for (var N = 0, M = 0, c = b.length - 1; c >= 0; c--)
        M *= 9, M += b[c], N += b[c];
      for (var P = 0, z = 0, c = w.length - 1; c >= 0; c--)
        P *= 9, P += w[c], z += w[c];
      var F = M + 3 * P;
      if (i) {
        if (N & 1 || N > 12 || N < 4)
          throw new Ye();
        var $ = (12 - N) / 2, G = e.OUTSIDE_ODD_WIDEST[$], H = 9 - G, Z = Rb.getRSSvalue(b, G, !1), V = Rb.getRSSvalue(w, H, !0), Y = e.OUTSIDE_EVEN_TOTAL_SUBSET[$], ee = e.OUTSIDE_GSUM[$];
        return new v5(Z * Y + V + ee, F);
      } else {
        if (z & 1 || z > 10 || z < 4)
          throw new Ye();
        var $ = (10 - z) / 2, G = e.INSIDE_ODD_WIDEST[$], H = 9 - G, Z = Rb.getRSSvalue(b, G, !0), V = Rb.getRSSvalue(w, H, !1), K = e.INSIDE_ODD_TOTAL_SUBSET[$], ee = e.INSIDE_GSUM[$];
        return new v5(V * K + Z + ee, F);
      }
    }, e.prototype.findFinderPattern = function(n, r) {
      var i = this.getDecodeFinderCounters();
      i[0] = 0, i[1] = 0, i[2] = 0, i[3] = 0;
      for (var a = n.getSize(), s = !1, c = 0; c < a && (s = !n.get(c), r !== s); )
        c++;
      for (var d = 0, f = c, g = c; g < a; g++)
        if (n.get(g) !== s)
          i[d]++;
        else {
          if (d === 3) {
            if (K1.isFinderPattern(i))
              return [f, g];
            f += i[0] + i[1], i[0] = i[2], i[1] = i[3], i[2] = 0, i[3] = 0, d--;
          } else
            d++;
          i[d] = 1, s = !s;
        }
      throw new Ye();
    }, e.prototype.parseFoundFinderPattern = function(n, r, i, a) {
      for (var s = n.get(a[0]), c = a[0] - 1; c >= 0 && s !== n.get(c); )
        c--;
      c++;
      var d = a[0] - c, f = this.getDecodeFinderCounters(), g = new Int32Array(f.length);
      si.arraycopy(f, 0, g, 1, f.length - 1), g[0] = d;
      var m = this.parseFinderValue(g, e.FINDER_PATTERNS), b = c, w = a[1];
      return i && (b = n.getSize() - 1 - b, w = n.getSize() - 1 - w), new Eee(m, [c, a[1]], b, w, r);
    }, e.prototype.adjustOddEvenCounts = function(n, r) {
      var i = gr.sum(new Int32Array(this.getOddCounts())), a = gr.sum(new Int32Array(this.getEvenCounts())), s = !1, c = !1, d = !1, f = !1;
      n ? (i > 12 ? c = !0 : i < 4 && (s = !0), a > 12 ? f = !0 : a < 4 && (d = !0)) : (i > 11 ? c = !0 : i < 5 && (s = !0), a > 10 ? f = !0 : a < 4 && (d = !0));
      var g = i + a - r, m = (i & 1) === (n ? 1 : 0), b = (a & 1) === 1;
      if (g === 1)
        if (m) {
          if (b)
            throw new Ye();
          c = !0;
        } else {
          if (!b)
            throw new Ye();
          f = !0;
        }
      else if (g === -1)
        if (m) {
          if (b)
            throw new Ye();
          s = !0;
        } else {
          if (!b)
            throw new Ye();
          d = !0;
        }
      else if (g === 0) {
        if (m) {
          if (!b)
            throw new Ye();
          i < a ? (s = !0, f = !0) : (c = !0, d = !0);
        } else if (b)
          throw new Ye();
      } else
        throw new Ye();
      if (s) {
        if (c)
          throw new Ye();
        K1.increment(this.getOddCounts(), this.getOddRoundingErrors());
      }
      if (c && K1.decrement(this.getOddCounts(), this.getOddRoundingErrors()), d) {
        if (f)
          throw new Ye();
        K1.increment(this.getEvenCounts(), this.getOddRoundingErrors());
      }
      f && K1.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.OUTSIDE_EVEN_TOTAL_SUBSET = [1, 10, 34, 70, 126], e.INSIDE_ODD_TOTAL_SUBSET = [4, 20, 48, 81], e.OUTSIDE_GSUM = [0, 161, 961, 2015, 2715], e.INSIDE_GSUM = [0, 336, 1036, 1516], e.OUTSIDE_ODD_WIDEST = [8, 6, 4, 3, 1], e.INSIDE_ODD_WIDEST = [2, 4, 6, 8], e.FINDER_PATTERNS = [
      Int32Array.from([3, 8, 2, 1]),
      Int32Array.from([3, 5, 5, 1]),
      Int32Array.from([3, 3, 7, 1]),
      Int32Array.from([3, 1, 9, 1]),
      Int32Array.from([2, 7, 4, 1]),
      Int32Array.from([2, 5, 6, 1]),
      Int32Array.from([2, 3, 8, 1]),
      Int32Array.from([1, 5, 7, 1]),
      Int32Array.from([1, 3, 9, 1])
    ], e;
  }(K1)
), qVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), oE = (
  /** @class */
  function(t) {
    qVe(e, t);
    function e(n) {
      var r = t.call(this) || this;
      r.readers = [];
      var i = n ? n.get(Ui.POSSIBLE_FORMATS) : null, a = n && n.get(Ui.ASSUME_CODE_39_CHECK_DIGIT) !== void 0;
      return i && ((i.includes(Ht.EAN_13) || i.includes(Ht.UPC_A) || i.includes(Ht.EAN_8) || i.includes(Ht.UPC_E)) && r.readers.push(new jD(n)), i.includes(Ht.CODE_39) && r.readers.push(new FU(a)), i.includes(Ht.CODE_93) && r.readers.push(new VU()), i.includes(Ht.CODE_128) && r.readers.push(new zU()), i.includes(Ht.ITF) && r.readers.push(new UU()), i.includes(Ht.CODABAR) && r.readers.push(new hVe()), i.includes(Ht.RSS_14) && r.readers.push(new QU()), i.includes(Ht.RSS_EXPANDED) && (console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk."), r.readers.push(new VVe()))), r.readers.length === 0 && (r.readers.push(new jD(n)), r.readers.push(new FU()), r.readers.push(new VU()), r.readers.push(new jD(n)), r.readers.push(new zU()), r.readers.push(new UU()), r.readers.push(new QU())), r;
    }
    return e.prototype.decodeRow = function(n, r, i) {
      for (var a = 0; a < this.readers.length; a++)
        try {
          return this.readers[a].decodeRow(n, r, i);
        } catch {
        }
      throw new Ye();
    }, e.prototype.reset = function() {
      this.readers.forEach(function(n) {
        return n.reset();
      });
    }, e;
  }(Ga)
), GVe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}();
(function(t) {
  GVe(e, t);
  function e(n, r) {
    return n === void 0 && (n = 500), t.call(this, new oE(r), n, r) || this;
  }
  return e;
})(Rw);
var ZU = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Dr = (
  /** @class */
  function() {
    function t(e, n, r) {
      this.ecCodewords = e, this.ecBlocks = [n], r && this.ecBlocks.push(r);
    }
    return t.prototype.getECCodewords = function() {
      return this.ecCodewords;
    }, t.prototype.getECBlocks = function() {
      return this.ecBlocks;
    }, t;
  }()
), br = (
  /** @class */
  function() {
    function t(e, n) {
      this.count = e, this.dataCodewords = n;
    }
    return t.prototype.getCount = function() {
      return this.count;
    }, t.prototype.getDataCodewords = function() {
      return this.dataCodewords;
    }, t;
  }()
), YVe = (
  /** @class */
  function() {
    function t(e, n, r, i, a, s) {
      var c, d;
      this.versionNumber = e, this.symbolSizeRows = n, this.symbolSizeColumns = r, this.dataRegionSizeRows = i, this.dataRegionSizeColumns = a, this.ecBlocks = s;
      var f = 0, g = s.getECCodewords(), m = s.getECBlocks();
      try {
        for (var b = ZU(m), w = b.next(); !w.done; w = b.next()) {
          var _ = w.value;
          f += _.getCount() * (_.getDataCodewords() + g);
        }
      } catch (A) {
        c = { error: A };
      } finally {
        try {
          w && !w.done && (d = b.return) && d.call(b);
        } finally {
          if (c)
            throw c.error;
        }
      }
      this.totalCodewords = f;
    }
    return t.prototype.getVersionNumber = function() {
      return this.versionNumber;
    }, t.prototype.getSymbolSizeRows = function() {
      return this.symbolSizeRows;
    }, t.prototype.getSymbolSizeColumns = function() {
      return this.symbolSizeColumns;
    }, t.prototype.getDataRegionSizeRows = function() {
      return this.dataRegionSizeRows;
    }, t.prototype.getDataRegionSizeColumns = function() {
      return this.dataRegionSizeColumns;
    }, t.prototype.getTotalCodewords = function() {
      return this.totalCodewords;
    }, t.prototype.getECBlocks = function() {
      return this.ecBlocks;
    }, t.getVersionForDimensions = function(e, n) {
      var r, i;
      if (e & 1 || n & 1)
        throw new ht();
      try {
        for (var a = ZU(t.VERSIONS), s = a.next(); !s.done; s = a.next()) {
          var c = s.value;
          if (c.symbolSizeRows === e && c.symbolSizeColumns === n)
            return c;
        }
      } catch (d) {
        r = { error: d };
      } finally {
        try {
          s && !s.done && (i = a.return) && i.call(a);
        } finally {
          if (r)
            throw r.error;
        }
      }
      throw new ht();
    }, t.prototype.toString = function() {
      return "" + this.versionNumber;
    }, t.buildVersions = function() {
      return [
        new t(1, 10, 10, 8, 8, new Dr(5, new br(1, 3))),
        new t(2, 12, 12, 10, 10, new Dr(7, new br(1, 5))),
        new t(3, 14, 14, 12, 12, new Dr(10, new br(1, 8))),
        new t(4, 16, 16, 14, 14, new Dr(12, new br(1, 12))),
        new t(5, 18, 18, 16, 16, new Dr(14, new br(1, 18))),
        new t(6, 20, 20, 18, 18, new Dr(18, new br(1, 22))),
        new t(7, 22, 22, 20, 20, new Dr(20, new br(1, 30))),
        new t(8, 24, 24, 22, 22, new Dr(24, new br(1, 36))),
        new t(9, 26, 26, 24, 24, new Dr(28, new br(1, 44))),
        new t(10, 32, 32, 14, 14, new Dr(36, new br(1, 62))),
        new t(11, 36, 36, 16, 16, new Dr(42, new br(1, 86))),
        new t(12, 40, 40, 18, 18, new Dr(48, new br(1, 114))),
        new t(13, 44, 44, 20, 20, new Dr(56, new br(1, 144))),
        new t(14, 48, 48, 22, 22, new Dr(68, new br(1, 174))),
        new t(15, 52, 52, 24, 24, new Dr(42, new br(2, 102))),
        new t(16, 64, 64, 14, 14, new Dr(56, new br(2, 140))),
        new t(17, 72, 72, 16, 16, new Dr(36, new br(4, 92))),
        new t(18, 80, 80, 18, 18, new Dr(48, new br(4, 114))),
        new t(19, 88, 88, 20, 20, new Dr(56, new br(4, 144))),
        new t(20, 96, 96, 22, 22, new Dr(68, new br(4, 174))),
        new t(21, 104, 104, 24, 24, new Dr(56, new br(6, 136))),
        new t(22, 120, 120, 18, 18, new Dr(68, new br(6, 175))),
        new t(23, 132, 132, 20, 20, new Dr(62, new br(8, 163))),
        new t(24, 144, 144, 22, 22, new Dr(62, new br(8, 156), new br(2, 155))),
        new t(25, 8, 18, 6, 16, new Dr(7, new br(1, 5))),
        new t(26, 8, 32, 6, 14, new Dr(11, new br(1, 10))),
        new t(27, 12, 26, 10, 24, new Dr(14, new br(1, 16))),
        new t(28, 12, 36, 10, 16, new Dr(18, new br(1, 22))),
        new t(29, 16, 36, 14, 16, new Dr(24, new br(1, 32))),
        new t(30, 16, 48, 14, 22, new Dr(28, new br(1, 49)))
      ];
    }, t.VERSIONS = t.buildVersions(), t;
  }()
), XVe = (
  /** @class */
  function() {
    function t(e) {
      var n = e.getHeight();
      if (n < 8 || n > 144 || n & 1)
        throw new ht();
      this.version = t.readVersion(e), this.mappingBitMatrix = this.extractDataRegion(e), this.readMappingMatrix = new sf(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
    }
    return t.prototype.getVersion = function() {
      return this.version;
    }, t.readVersion = function(e) {
      var n = e.getHeight(), r = e.getWidth();
      return YVe.getVersionForDimensions(n, r);
    }, t.prototype.readCodewords = function() {
      var e = new Int8Array(this.version.getTotalCodewords()), n = 0, r = 4, i = 0, a = this.mappingBitMatrix.getHeight(), s = this.mappingBitMatrix.getWidth(), c = !1, d = !1, f = !1, g = !1;
      do
        if (r === a && i === 0 && !c)
          e[n++] = this.readCorner1(a, s) & 255, r -= 2, i += 2, c = !0;
        else if (r === a - 2 && i === 0 && s & 3 && !d)
          e[n++] = this.readCorner2(a, s) & 255, r -= 2, i += 2, d = !0;
        else if (r === a + 4 && i === 2 && !(s & 7) && !f)
          e[n++] = this.readCorner3(a, s) & 255, r -= 2, i += 2, f = !0;
        else if (r === a - 2 && i === 0 && (s & 7) === 4 && !g)
          e[n++] = this.readCorner4(a, s) & 255, r -= 2, i += 2, g = !0;
        else {
          do
            r < a && i >= 0 && !this.readMappingMatrix.get(i, r) && (e[n++] = this.readUtah(r, i, a, s) & 255), r -= 2, i += 2;
          while (r >= 0 && i < s);
          r += 1, i += 3;
          do
            r >= 0 && i < s && !this.readMappingMatrix.get(i, r) && (e[n++] = this.readUtah(r, i, a, s) & 255), r += 2, i -= 2;
          while (r < a && i >= 0);
          r += 3, i += 1;
        }
      while (r < a || i < s);
      if (n !== this.version.getTotalCodewords())
        throw new ht();
      return e;
    }, t.prototype.readModule = function(e, n, r, i) {
      return e < 0 && (e += r, n += 4 - (r + 4 & 7)), n < 0 && (n += i, e += 4 - (i + 4 & 7)), this.readMappingMatrix.set(n, e), this.mappingBitMatrix.get(n, e);
    }, t.prototype.readUtah = function(e, n, r, i) {
      var a = 0;
      return this.readModule(e - 2, n - 2, r, i) && (a |= 1), a <<= 1, this.readModule(e - 2, n - 1, r, i) && (a |= 1), a <<= 1, this.readModule(e - 1, n - 2, r, i) && (a |= 1), a <<= 1, this.readModule(e - 1, n - 1, r, i) && (a |= 1), a <<= 1, this.readModule(e - 1, n, r, i) && (a |= 1), a <<= 1, this.readModule(e, n - 2, r, i) && (a |= 1), a <<= 1, this.readModule(e, n - 1, r, i) && (a |= 1), a <<= 1, this.readModule(e, n, r, i) && (a |= 1), a;
    }, t.prototype.readCorner1 = function(e, n) {
      var r = 0;
      return this.readModule(e - 1, 0, e, n) && (r |= 1), r <<= 1, this.readModule(e - 1, 1, e, n) && (r |= 1), r <<= 1, this.readModule(e - 1, 2, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 2, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 1, e, n) && (r |= 1), r <<= 1, this.readModule(1, n - 1, e, n) && (r |= 1), r <<= 1, this.readModule(2, n - 1, e, n) && (r |= 1), r <<= 1, this.readModule(3, n - 1, e, n) && (r |= 1), r;
    }, t.prototype.readCorner2 = function(e, n) {
      var r = 0;
      return this.readModule(e - 3, 0, e, n) && (r |= 1), r <<= 1, this.readModule(e - 2, 0, e, n) && (r |= 1), r <<= 1, this.readModule(e - 1, 0, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 4, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 3, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 2, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 1, e, n) && (r |= 1), r <<= 1, this.readModule(1, n - 1, e, n) && (r |= 1), r;
    }, t.prototype.readCorner3 = function(e, n) {
      var r = 0;
      return this.readModule(e - 1, 0, e, n) && (r |= 1), r <<= 1, this.readModule(e - 1, n - 1, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 3, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 2, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 1, e, n) && (r |= 1), r <<= 1, this.readModule(1, n - 3, e, n) && (r |= 1), r <<= 1, this.readModule(1, n - 2, e, n) && (r |= 1), r <<= 1, this.readModule(1, n - 1, e, n) && (r |= 1), r;
    }, t.prototype.readCorner4 = function(e, n) {
      var r = 0;
      return this.readModule(e - 3, 0, e, n) && (r |= 1), r <<= 1, this.readModule(e - 2, 0, e, n) && (r |= 1), r <<= 1, this.readModule(e - 1, 0, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 2, e, n) && (r |= 1), r <<= 1, this.readModule(0, n - 1, e, n) && (r |= 1), r <<= 1, this.readModule(1, n - 1, e, n) && (r |= 1), r <<= 1, this.readModule(2, n - 1, e, n) && (r |= 1), r <<= 1, this.readModule(3, n - 1, e, n) && (r |= 1), r;
    }, t.prototype.extractDataRegion = function(e) {
      var n = this.version.getSymbolSizeRows(), r = this.version.getSymbolSizeColumns();
      if (e.getHeight() !== n)
        throw new Yt("Dimension of bitMatrix must match the version size");
      for (var i = this.version.getDataRegionSizeRows(), a = this.version.getDataRegionSizeColumns(), s = n / i | 0, c = r / a | 0, d = s * i, f = c * a, g = new sf(f, d), m = 0; m < s; ++m)
        for (var b = m * i, w = 0; w < c; ++w)
          for (var _ = w * a, A = 0; A < i; ++A)
            for (var T = m * (i + 2) + 1 + A, O = b + A, R = 0; R < a; ++R) {
              var N = w * (a + 2) + 1 + R;
              if (e.get(N, T)) {
                var M = _ + R;
                g.set(M, O);
              }
            }
      return g;
    }, t;
  }()
), KU = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, WVe = (
  /** @class */
  function() {
    function t(e, n) {
      this.numDataCodewords = e, this.codewords = n;
    }
    return t.getDataBlocks = function(e, n) {
      var r, i, a, s, c = n.getECBlocks(), d = 0, f = c.getECBlocks();
      try {
        for (var g = KU(f), m = g.next(); !m.done; m = g.next()) {
          var b = m.value;
          d += b.getCount();
        }
      } catch (ee) {
        r = { error: ee };
      } finally {
        try {
          m && !m.done && (i = g.return) && i.call(g);
        } finally {
          if (r)
            throw r.error;
        }
      }
      var w = new Array(d), _ = 0;
      try {
        for (var A = KU(f), T = A.next(); !T.done; T = A.next())
          for (var b = T.value, O = 0; O < b.getCount(); O++) {
            var R = b.getDataCodewords(), N = c.getECCodewords() + R;
            w[_++] = new t(R, new Uint8Array(N));
          }
      } catch (ee) {
        a = { error: ee };
      } finally {
        try {
          T && !T.done && (s = A.return) && s.call(A);
        } finally {
          if (a)
            throw a.error;
        }
      }
      for (var M = w[0].codewords.length, P = M - c.getECCodewords(), z = P - 1, F = 0, O = 0; O < z; O++)
        for (var $ = 0; $ < _; $++)
          w[$].codewords[O] = e[F++];
      for (var G = n.getVersionNumber() === 24, H = G ? 8 : _, $ = 0; $ < H; $++)
        w[$].codewords[P - 1] = e[F++];
      for (var Z = w[0].codewords.length, O = P; O < Z; O++)
        for (var $ = 0; $ < _; $++) {
          var V = G ? ($ + 8) % _ : $, Y = G && V > 7 ? O - 1 : O;
          w[V].codewords[Y] = e[F++];
        }
      if (F !== e.length)
        throw new Yt();
      return w;
    }, t.prototype.getNumDataCodewords = function() {
      return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
      return this.codewords;
    }, t;
  }()
), Cee = (
  /** @class */
  function() {
    function t(e) {
      this.bytes = e, this.byteOffset = 0, this.bitOffset = 0;
    }
    return t.prototype.getBitOffset = function() {
      return this.bitOffset;
    }, t.prototype.getByteOffset = function() {
      return this.byteOffset;
    }, t.prototype.readBits = function(e) {
      if (e < 1 || e > 32 || e > this.available())
        throw new Yt("" + e);
      var n = 0, r = this.bitOffset, i = this.byteOffset, a = this.bytes;
      if (r > 0) {
        var s = 8 - r, c = e < s ? e : s, d = s - c, f = 255 >> 8 - c << d;
        n = (a[i] & f) >> d, e -= c, r += c, r === 8 && (r = 0, i++);
      }
      if (e > 0) {
        for (; e >= 8; )
          n = n << 8 | a[i] & 255, i++, e -= 8;
        if (e > 0) {
          var d = 8 - e, f = 255 >> d << d;
          n = n << e | (a[i] & f) >> d, r += e;
        }
      }
      return this.bitOffset = r, this.byteOffset = i, n;
    }, t.prototype.available = function() {
      return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    }, t;
  }()
), Pa;
(function(t) {
  t[t.PAD_ENCODE = 0] = "PAD_ENCODE", t[t.ASCII_ENCODE = 1] = "ASCII_ENCODE", t[t.C40_ENCODE = 2] = "C40_ENCODE", t[t.TEXT_ENCODE = 3] = "TEXT_ENCODE", t[t.ANSIX12_ENCODE = 4] = "ANSIX12_ENCODE", t[t.EDIFACT_ENCODE = 5] = "EDIFACT_ENCODE", t[t.BASE256_ENCODE = 6] = "BASE256_ENCODE";
})(Pa || (Pa = {}));
var QVe = (
  /** @class */
  function() {
    function t() {
    }
    return t.decode = function(e) {
      var n = new Cee(e), r = new Bn(), i = new Bn(), a = new Array(), s = Pa.ASCII_ENCODE;
      do
        if (s === Pa.ASCII_ENCODE)
          s = this.decodeAsciiSegment(n, r, i);
        else {
          switch (s) {
            case Pa.C40_ENCODE:
              this.decodeC40Segment(n, r);
              break;
            case Pa.TEXT_ENCODE:
              this.decodeTextSegment(n, r);
              break;
            case Pa.ANSIX12_ENCODE:
              this.decodeAnsiX12Segment(n, r);
              break;
            case Pa.EDIFACT_ENCODE:
              this.decodeEdifactSegment(n, r);
              break;
            case Pa.BASE256_ENCODE:
              this.decodeBase256Segment(n, r, a);
              break;
            default:
              throw new ht();
          }
          s = Pa.ASCII_ENCODE;
        }
      while (s !== Pa.PAD_ENCODE && n.available() > 0);
      return i.length() > 0 && r.append(i.toString()), new RO(e, r.toString(), a.length === 0 ? null : a, null);
    }, t.decodeAsciiSegment = function(e, n, r) {
      var i = !1;
      do {
        var a = e.readBits(8);
        if (a === 0)
          throw new ht();
        if (a <= 128)
          return i && (a += 128), n.append(String.fromCharCode(a - 1)), Pa.ASCII_ENCODE;
        if (a === 129)
          return Pa.PAD_ENCODE;
        if (a <= 229) {
          var s = a - 130;
          s < 10 && n.append("0"), n.append("" + s);
        } else
          switch (a) {
            case 230:
              return Pa.C40_ENCODE;
            case 231:
              return Pa.BASE256_ENCODE;
            case 232:
              n.append(String.fromCharCode(29));
              break;
            case 233:
            case 234:
              break;
            case 235:
              i = !0;
              break;
            case 236:
              n.append("[)>05"), r.insert(0, "");
              break;
            case 237:
              n.append("[)>06"), r.insert(0, "");
              break;
            case 238:
              return Pa.ANSIX12_ENCODE;
            case 239:
              return Pa.TEXT_ENCODE;
            case 240:
              return Pa.EDIFACT_ENCODE;
            case 241:
              break;
            default:
              if (a !== 254 || e.available() !== 0)
                throw new ht();
              break;
          }
      } while (e.available() > 0);
      return Pa.ASCII_ENCODE;
    }, t.decodeC40Segment = function(e, n) {
      var r = !1, i = [], a = 0;
      do {
        if (e.available() === 8)
          return;
        var s = e.readBits(8);
        if (s === 254)
          return;
        this.parseTwoBytes(s, e.readBits(8), i);
        for (var c = 0; c < 3; c++) {
          var d = i[c];
          switch (a) {
            case 0:
              if (d < 3)
                a = d + 1;
              else if (d < this.C40_BASIC_SET_CHARS.length) {
                var f = this.C40_BASIC_SET_CHARS[d];
                r ? (n.append(String.fromCharCode(f.charCodeAt(0) + 128)), r = !1) : n.append(f);
              } else
                throw new ht();
              break;
            case 1:
              r ? (n.append(String.fromCharCode(d + 128)), r = !1) : n.append(String.fromCharCode(d)), a = 0;
              break;
            case 2:
              if (d < this.C40_SHIFT2_SET_CHARS.length) {
                var f = this.C40_SHIFT2_SET_CHARS[d];
                r ? (n.append(String.fromCharCode(f.charCodeAt(0) + 128)), r = !1) : n.append(f);
              } else
                switch (d) {
                  case 27:
                    n.append(String.fromCharCode(29));
                    break;
                  case 30:
                    r = !0;
                    break;
                  default:
                    throw new ht();
                }
              a = 0;
              break;
            case 3:
              r ? (n.append(String.fromCharCode(d + 224)), r = !1) : n.append(String.fromCharCode(d + 96)), a = 0;
              break;
            default:
              throw new ht();
          }
        }
      } while (e.available() > 0);
    }, t.decodeTextSegment = function(e, n) {
      var r = !1, i = [], a = 0;
      do {
        if (e.available() === 8)
          return;
        var s = e.readBits(8);
        if (s === 254)
          return;
        this.parseTwoBytes(s, e.readBits(8), i);
        for (var c = 0; c < 3; c++) {
          var d = i[c];
          switch (a) {
            case 0:
              if (d < 3)
                a = d + 1;
              else if (d < this.TEXT_BASIC_SET_CHARS.length) {
                var f = this.TEXT_BASIC_SET_CHARS[d];
                r ? (n.append(String.fromCharCode(f.charCodeAt(0) + 128)), r = !1) : n.append(f);
              } else
                throw new ht();
              break;
            case 1:
              r ? (n.append(String.fromCharCode(d + 128)), r = !1) : n.append(String.fromCharCode(d)), a = 0;
              break;
            case 2:
              if (d < this.TEXT_SHIFT2_SET_CHARS.length) {
                var f = this.TEXT_SHIFT2_SET_CHARS[d];
                r ? (n.append(String.fromCharCode(f.charCodeAt(0) + 128)), r = !1) : n.append(f);
              } else
                switch (d) {
                  case 27:
                    n.append(String.fromCharCode(29));
                    break;
                  case 30:
                    r = !0;
                    break;
                  default:
                    throw new ht();
                }
              a = 0;
              break;
            case 3:
              if (d < this.TEXT_SHIFT3_SET_CHARS.length) {
                var f = this.TEXT_SHIFT3_SET_CHARS[d];
                r ? (n.append(String.fromCharCode(f.charCodeAt(0) + 128)), r = !1) : n.append(f), a = 0;
              } else
                throw new ht();
              break;
            default:
              throw new ht();
          }
        }
      } while (e.available() > 0);
    }, t.decodeAnsiX12Segment = function(e, n) {
      var r = [];
      do {
        if (e.available() === 8)
          return;
        var i = e.readBits(8);
        if (i === 254)
          return;
        this.parseTwoBytes(i, e.readBits(8), r);
        for (var a = 0; a < 3; a++) {
          var s = r[a];
          switch (s) {
            case 0:
              n.append("\r");
              break;
            case 1:
              n.append("*");
              break;
            case 2:
              n.append(">");
              break;
            case 3:
              n.append(" ");
              break;
            default:
              if (s < 14)
                n.append(String.fromCharCode(s + 44));
              else if (s < 40)
                n.append(String.fromCharCode(s + 51));
              else
                throw new ht();
              break;
          }
        }
      } while (e.available() > 0);
    }, t.parseTwoBytes = function(e, n, r) {
      var i = (e << 8) + n - 1, a = Math.floor(i / 1600);
      r[0] = a, i -= a * 1600, a = Math.floor(i / 40), r[1] = a, r[2] = i - a * 40;
    }, t.decodeEdifactSegment = function(e, n) {
      do {
        if (e.available() <= 16)
          return;
        for (var r = 0; r < 4; r++) {
          var i = e.readBits(6);
          if (i === 31) {
            var a = 8 - e.getBitOffset();
            a !== 8 && e.readBits(a);
            return;
          }
          i & 32 || (i |= 64), n.append(String.fromCharCode(i));
        }
      } while (e.available() > 0);
    }, t.decodeBase256Segment = function(e, n, r) {
      var i = 1 + e.getByteOffset(), a = this.unrandomize255State(e.readBits(8), i++), s;
      if (a === 0 ? s = e.available() / 8 | 0 : a < 250 ? s = a : s = 250 * (a - 249) + this.unrandomize255State(e.readBits(8), i++), s < 0)
        throw new ht();
      for (var c = new Uint8Array(s), d = 0; d < s; d++) {
        if (e.available() < 8)
          throw new ht();
        c[d] = this.unrandomize255State(e.readBits(8), i++);
      }
      r.push(c);
      try {
        n.append(Jc.decode(c, tr.ISO88591));
      } catch (f) {
        throw new X_("Platform does not support required encoding: " + f.message);
      }
    }, t.unrandomize255State = function(e, n) {
      var r = 149 * n % 255 + 1, i = e - r;
      return i >= 0 ? i : i + 256;
    }, t.C40_BASIC_SET_CHARS = [
      "*",
      "*",
      "*",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z"
    ], t.C40_SHIFT2_SET_CHARS = [
      "!",
      '"',
      "#",
      "$",
      "%",
      "&",
      "'",
      "(",
      ")",
      "*",
      "+",
      ",",
      "-",
      ".",
      "/",
      ":",
      ";",
      "<",
      "=",
      ">",
      "?",
      "@",
      "[",
      "\\",
      "]",
      "^",
      "_"
    ], t.TEXT_BASIC_SET_CHARS = [
      "*",
      "*",
      "*",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    ], t.TEXT_SHIFT2_SET_CHARS = t.C40_SHIFT2_SET_CHARS, t.TEXT_SHIFT3_SET_CHARS = [
      "`",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "{",
      "|",
      "}",
      "~",
      String.fromCharCode(127)
    ], t;
  }()
), ZVe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, KVe = (
  /** @class */
  function() {
    function t() {
      this.rsDecoder = new DO(sl.DATA_MATRIX_FIELD_256);
    }
    return t.prototype.decode = function(e) {
      var n, r, i = new XVe(e), a = i.getVersion(), s = i.readCodewords(), c = WVe.getDataBlocks(s, a), d = 0;
      try {
        for (var f = ZVe(c), g = f.next(); !g.done; g = f.next()) {
          var m = g.value;
          d += m.getNumDataCodewords();
        }
      } catch (N) {
        n = { error: N };
      } finally {
        try {
          g && !g.done && (r = f.return) && r.call(f);
        } finally {
          if (n)
            throw n.error;
        }
      }
      for (var b = new Uint8Array(d), w = c.length, _ = 0; _ < w; _++) {
        var A = c[_], T = A.getCodewords(), O = A.getNumDataCodewords();
        this.correctErrors(T, O);
        for (var R = 0; R < O; R++)
          b[R * w + _] = T[R];
      }
      return QVe.decode(b);
    }, t.prototype.correctErrors = function(e, n) {
      var r = new Int32Array(e);
      try {
        this.rsDecoder.decode(r, e.length - n);
      } catch {
        throw new uo();
      }
      for (var i = 0; i < n; i++)
        e[i] = r[i];
    }, t;
  }()
), JVe = (
  /** @class */
  function() {
    function t(e) {
      this.image = e, this.rectangleDetector = new aM(this.image);
    }
    return t.prototype.detect = function() {
      var e = this.rectangleDetector.detect(), n = this.detectSolid1(e);
      if (n = this.detectSolid2(n), n[3] = this.correctTopRight(n), !n[3])
        throw new Ye();
      n = this.shiftToModuleCenter(n);
      var r = n[0], i = n[1], a = n[2], s = n[3], c = this.transitionsBetween(r, s) + 1, d = this.transitionsBetween(a, s) + 1;
      (c & 1) === 1 && (c += 1), (d & 1) === 1 && (d += 1), 4 * c < 7 * d && 4 * d < 7 * c && (c = d = Math.max(c, d));
      var f = t.sampleGrid(this.image, r, i, a, s, c, d);
      return new Gk(f, [r, i, a, s]);
    }, t.shiftPoint = function(e, n, r) {
      var i = (n.getX() - e.getX()) / (r + 1), a = (n.getY() - e.getY()) / (r + 1);
      return new kt(e.getX() + i, e.getY() + a);
    }, t.moveAway = function(e, n, r) {
      var i = e.getX(), a = e.getY();
      return i < n ? i -= 1 : i += 1, a < r ? a -= 1 : a += 1, new kt(i, a);
    }, t.prototype.detectSolid1 = function(e) {
      var n = e[0], r = e[1], i = e[3], a = e[2], s = this.transitionsBetween(n, r), c = this.transitionsBetween(r, i), d = this.transitionsBetween(i, a), f = this.transitionsBetween(a, n), g = s, m = [a, n, r, i];
      return g > c && (g = c, m[0] = n, m[1] = r, m[2] = i, m[3] = a), g > d && (g = d, m[0] = r, m[1] = i, m[2] = a, m[3] = n), g > f && (m[0] = i, m[1] = a, m[2] = n, m[3] = r), m;
    }, t.prototype.detectSolid2 = function(e) {
      var n = e[0], r = e[1], i = e[2], a = e[3], s = this.transitionsBetween(n, a), c = t.shiftPoint(r, i, (s + 1) * 4), d = t.shiftPoint(i, r, (s + 1) * 4), f = this.transitionsBetween(c, n), g = this.transitionsBetween(d, a);
      return f < g ? (e[0] = n, e[1] = r, e[2] = i, e[3] = a) : (e[0] = r, e[1] = i, e[2] = a, e[3] = n), e;
    }, t.prototype.correctTopRight = function(e) {
      var n = e[0], r = e[1], i = e[2], a = e[3], s = this.transitionsBetween(n, a), c = this.transitionsBetween(r, a), d = t.shiftPoint(n, r, (c + 1) * 4), f = t.shiftPoint(i, r, (s + 1) * 4);
      s = this.transitionsBetween(d, a), c = this.transitionsBetween(f, a);
      var g = new kt(a.getX() + (i.getX() - r.getX()) / (s + 1), a.getY() + (i.getY() - r.getY()) / (s + 1)), m = new kt(a.getX() + (n.getX() - r.getX()) / (c + 1), a.getY() + (n.getY() - r.getY()) / (c + 1));
      if (!this.isValid(g))
        return this.isValid(m) ? m : null;
      if (!this.isValid(m))
        return g;
      var b = this.transitionsBetween(d, g) + this.transitionsBetween(f, g), w = this.transitionsBetween(d, m) + this.transitionsBetween(f, m);
      return b > w ? g : m;
    }, t.prototype.shiftToModuleCenter = function(e) {
      var n = e[0], r = e[1], i = e[2], a = e[3], s = this.transitionsBetween(n, a) + 1, c = this.transitionsBetween(i, a) + 1, d = t.shiftPoint(n, r, c * 4), f = t.shiftPoint(i, r, s * 4);
      s = this.transitionsBetween(d, a) + 1, c = this.transitionsBetween(f, a) + 1, (s & 1) === 1 && (s += 1), (c & 1) === 1 && (c += 1);
      var g = (n.getX() + r.getX() + i.getX() + a.getX()) / 4, m = (n.getY() + r.getY() + i.getY() + a.getY()) / 4;
      n = t.moveAway(n, g, m), r = t.moveAway(r, g, m), i = t.moveAway(i, g, m), a = t.moveAway(a, g, m);
      var b, w;
      return d = t.shiftPoint(n, r, c * 4), d = t.shiftPoint(d, a, s * 4), b = t.shiftPoint(r, n, c * 4), b = t.shiftPoint(b, i, s * 4), f = t.shiftPoint(i, a, c * 4), f = t.shiftPoint(f, r, s * 4), w = t.shiftPoint(a, i, c * 4), w = t.shiftPoint(w, n, s * 4), [d, b, f, w];
    }, t.prototype.isValid = function(e) {
      return e.getX() >= 0 && e.getX() < this.image.getWidth() && e.getY() > 0 && e.getY() < this.image.getHeight();
    }, t.sampleGrid = function(e, n, r, i, a, s, c) {
      var d = Yk.getInstance();
      return d.sampleGrid(e, s, c, 0.5, 0.5, s - 0.5, 0.5, s - 0.5, c - 0.5, 0.5, c - 0.5, n.getX(), n.getY(), a.getX(), a.getY(), i.getX(), i.getY(), r.getX(), r.getY());
    }, t.prototype.transitionsBetween = function(e, n) {
      var r = Math.trunc(e.getX()), i = Math.trunc(e.getY()), a = Math.trunc(n.getX()), s = Math.trunc(n.getY()), c = Math.abs(s - i) > Math.abs(a - r);
      if (c) {
        var d = r;
        r = i, i = d, d = a, a = s, s = d;
      }
      for (var f = Math.abs(a - r), g = Math.abs(s - i), m = -f / 2, b = i < s ? 1 : -1, w = r < a ? 1 : -1, _ = 0, A = this.image.get(c ? i : r, c ? r : i), T = r, O = i; T !== a; T += w) {
        var R = this.image.get(c ? O : T, c ? T : O);
        if (R !== A && (_++, A = R), m += g, m > 0) {
          if (O === s)
            break;
          O += b, m -= f;
        }
      }
      return _;
    }, t;
  }()
), lM = (
  /** @class */
  function() {
    function t() {
      this.decoder = new KVe();
    }
    return t.prototype.decode = function(e, n) {
      n === void 0 && (n = null);
      var r, i;
      if (n != null && n.has(Ui.PURE_BARCODE)) {
        var a = t.extractPureBits(e.getBlackMatrix());
        r = this.decoder.decode(a), i = t.NO_POINTS;
      } else {
        var s = new JVe(e.getBlackMatrix()).detect();
        r = this.decoder.decode(s.getBits()), i = s.getPoints();
      }
      var c = r.getRawBytes(), d = new ts(r.getText(), c, 8 * c.length, i, Ht.DATA_MATRIX, si.currentTimeMillis()), f = r.getByteSegments();
      f != null && d.putMetadata(jo.BYTE_SEGMENTS, f);
      var g = r.getECLevel();
      return g != null && d.putMetadata(jo.ERROR_CORRECTION_LEVEL, g), d;
    }, t.prototype.reset = function() {
    }, t.extractPureBits = function(e) {
      var n = e.getTopLeftOnBit(), r = e.getBottomRightOnBit();
      if (n == null || r == null)
        throw new Ye();
      var i = this.moduleSize(n, e), a = n[1], s = r[1], c = n[0], d = r[0], f = (d - c + 1) / i, g = (s - a + 1) / i;
      if (f <= 0 || g <= 0)
        throw new Ye();
      var m = i / 2;
      a += m, c += m;
      for (var b = new sf(f, g), w = 0; w < g; w++)
        for (var _ = a + w * i, A = 0; A < f; A++)
          e.get(c + A * i, _) && b.set(A, w);
      return b;
    }, t.moduleSize = function(e, n) {
      for (var r = n.getWidth(), i = e[0], a = e[1]; i < r && n.get(i, a); )
        i++;
      if (i === r)
        throw new Ye();
      var s = i - e[0];
      if (s === 0)
        throw new Ye();
      return s;
    }, t.NO_POINTS = [], t;
  }()
), eUe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}();
(function(t) {
  eUe(e, t);
  function e(n) {
    return n === void 0 && (n = 500), t.call(this, new lM(), n) || this;
  }
  return e;
})(Rw);
var Db;
(function(t) {
  t[t.L = 0] = "L", t[t.M = 1] = "M", t[t.Q = 2] = "Q", t[t.H = 3] = "H";
})(Db || (Db = {}));
var tUe = (
  /** @class */
  function() {
    function t(e, n, r) {
      this.value = e, this.stringValue = n, this.bits = r, t.FOR_BITS.set(r, this), t.FOR_VALUE.set(e, this);
    }
    return t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.getBits = function() {
      return this.bits;
    }, t.fromString = function(e) {
      switch (e) {
        case "L":
          return t.L;
        case "M":
          return t.M;
        case "Q":
          return t.Q;
        case "H":
          return t.H;
        default:
          throw new ju(e + "not available");
      }
    }, t.prototype.toString = function() {
      return this.stringValue;
    }, t.prototype.equals = function(e) {
      if (!(e instanceof t))
        return !1;
      var n = e;
      return this.value === n.value;
    }, t.forBits = function(e) {
      if (e < 0 || e >= t.FOR_BITS.size)
        throw new Yt();
      return t.FOR_BITS.get(e);
    }, t.FOR_BITS = /* @__PURE__ */ new Map(), t.FOR_VALUE = /* @__PURE__ */ new Map(), t.L = new t(Db.L, "L", 1), t.M = new t(Db.M, "M", 0), t.Q = new t(Db.Q, "Q", 3), t.H = new t(Db.H, "H", 2), t;
  }()
), nUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Tee = (
  /** @class */
  function() {
    function t(e) {
      this.errorCorrectionLevel = tUe.forBits(e >> 3 & 3), this.dataMask = /*(byte) */
      e & 7;
    }
    return t.numBitsDiffering = function(e, n) {
      return Vn.bitCount(e ^ n);
    }, t.decodeFormatInformation = function(e, n) {
      var r = t.doDecodeFormatInformation(e, n);
      return r !== null ? r : t.doDecodeFormatInformation(e ^ t.FORMAT_INFO_MASK_QR, n ^ t.FORMAT_INFO_MASK_QR);
    }, t.doDecodeFormatInformation = function(e, n) {
      var r, i, a = Number.MAX_SAFE_INTEGER, s = 0;
      try {
        for (var c = nUe(t.FORMAT_INFO_DECODE_LOOKUP), d = c.next(); !d.done; d = c.next()) {
          var f = d.value, g = f[0];
          if (g === e || g === n)
            return new t(f[1]);
          var m = t.numBitsDiffering(e, g);
          m < a && (s = f[1], a = m), e !== n && (m = t.numBitsDiffering(n, g), m < a && (s = f[1], a = m));
        }
      } catch (b) {
        r = { error: b };
      } finally {
        try {
          d && !d.done && (i = c.return) && i.call(c);
        } finally {
          if (r)
            throw r.error;
        }
      }
      return a <= 3 ? new t(s) : null;
    }, t.prototype.getErrorCorrectionLevel = function() {
      return this.errorCorrectionLevel;
    }, t.prototype.getDataMask = function() {
      return this.dataMask;
    }, t.prototype.hashCode = function() {
      return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
    }, t.prototype.equals = function(e) {
      if (!(e instanceof t))
        return !1;
      var n = e;
      return this.errorCorrectionLevel === n.errorCorrectionLevel && this.dataMask === n.dataMask;
    }, t.FORMAT_INFO_MASK_QR = 21522, t.FORMAT_INFO_DECODE_LOOKUP = [
      Int32Array.from([21522, 0]),
      Int32Array.from([20773, 1]),
      Int32Array.from([24188, 2]),
      Int32Array.from([23371, 3]),
      Int32Array.from([17913, 4]),
      Int32Array.from([16590, 5]),
      Int32Array.from([20375, 6]),
      Int32Array.from([19104, 7]),
      Int32Array.from([30660, 8]),
      Int32Array.from([29427, 9]),
      Int32Array.from([32170, 10]),
      Int32Array.from([30877, 11]),
      Int32Array.from([26159, 12]),
      Int32Array.from([25368, 13]),
      Int32Array.from([27713, 14]),
      Int32Array.from([26998, 15]),
      Int32Array.from([5769, 16]),
      Int32Array.from([5054, 17]),
      Int32Array.from([7399, 18]),
      Int32Array.from([6608, 19]),
      Int32Array.from([1890, 20]),
      Int32Array.from([597, 21]),
      Int32Array.from([3340, 22]),
      Int32Array.from([2107, 23]),
      Int32Array.from([13663, 24]),
      Int32Array.from([12392, 25]),
      Int32Array.from([16177, 26]),
      Int32Array.from([14854, 27]),
      Int32Array.from([9396, 28]),
      Int32Array.from([8579, 29]),
      Int32Array.from([11994, 30]),
      Int32Array.from([11245, 31])
    ], t;
  }()
), rUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, je = (
  /** @class */
  function() {
    function t(e) {
      for (var n = [], r = 1; r < arguments.length; r++)
        n[r - 1] = arguments[r];
      this.ecCodewordsPerBlock = e, this.ecBlocks = n;
    }
    return t.prototype.getECCodewordsPerBlock = function() {
      return this.ecCodewordsPerBlock;
    }, t.prototype.getNumBlocks = function() {
      var e, n, r = 0, i = this.ecBlocks;
      try {
        for (var a = rUe(i), s = a.next(); !s.done; s = a.next()) {
          var c = s.value;
          r += c.getCount();
        }
      } catch (d) {
        e = { error: d };
      } finally {
        try {
          s && !s.done && (n = a.return) && n.call(a);
        } finally {
          if (e)
            throw e.error;
        }
      }
      return r;
    }, t.prototype.getTotalECCodewords = function() {
      return this.ecCodewordsPerBlock * this.getNumBlocks();
    }, t.prototype.getECBlocks = function() {
      return this.ecBlocks;
    }, t;
  }()
), ce = (
  /** @class */
  function() {
    function t(e, n) {
      this.count = e, this.dataCodewords = n;
    }
    return t.prototype.getCount = function() {
      return this.count;
    }, t.prototype.getDataCodewords = function() {
      return this.dataCodewords;
    }, t;
  }()
), iUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, fg = (
  /** @class */
  function() {
    function t(e, n) {
      for (var r, i, a = [], s = 2; s < arguments.length; s++)
        a[s - 2] = arguments[s];
      this.versionNumber = e, this.alignmentPatternCenters = n, this.ecBlocks = a;
      var c = 0, d = a[0].getECCodewordsPerBlock(), f = a[0].getECBlocks();
      try {
        for (var g = iUe(f), m = g.next(); !m.done; m = g.next()) {
          var b = m.value;
          c += b.getCount() * (b.getDataCodewords() + d);
        }
      } catch (w) {
        r = { error: w };
      } finally {
        try {
          m && !m.done && (i = g.return) && i.call(g);
        } finally {
          if (r)
            throw r.error;
        }
      }
      this.totalCodewords = c;
    }
    return t.prototype.getVersionNumber = function() {
      return this.versionNumber;
    }, t.prototype.getAlignmentPatternCenters = function() {
      return this.alignmentPatternCenters;
    }, t.prototype.getTotalCodewords = function() {
      return this.totalCodewords;
    }, t.prototype.getDimensionForVersion = function() {
      return 17 + 4 * this.versionNumber;
    }, t.prototype.getECBlocksForLevel = function(e) {
      return this.ecBlocks[e.getValue()];
    }, t.getProvisionalVersionForDimension = function(e) {
      if (e % 4 !== 1)
        throw new ht();
      try {
        return this.getVersionForNumber((e - 17) / 4);
      } catch {
        throw new ht();
      }
    }, t.getVersionForNumber = function(e) {
      if (e < 1 || e > 40)
        throw new Yt();
      return t.VERSIONS[e - 1];
    }, t.decodeVersionInformation = function(e) {
      for (var n = Number.MAX_SAFE_INTEGER, r = 0, i = 0; i < t.VERSION_DECODE_INFO.length; i++) {
        var a = t.VERSION_DECODE_INFO[i];
        if (a === e)
          return t.getVersionForNumber(i + 7);
        var s = Tee.numBitsDiffering(e, a);
        s < n && (r = i + 7, n = s);
      }
      return n <= 3 ? t.getVersionForNumber(r) : null;
    }, t.prototype.buildFunctionPattern = function() {
      var e = this.getDimensionForVersion(), n = new sf(e);
      n.setRegion(0, 0, 9, 9), n.setRegion(e - 8, 0, 8, 9), n.setRegion(0, e - 8, 9, 8);
      for (var r = this.alignmentPatternCenters.length, i = 0; i < r; i++)
        for (var a = this.alignmentPatternCenters[i] - 2, s = 0; s < r; s++)
          i === 0 && (s === 0 || s === r - 1) || i === r - 1 && s === 0 || n.setRegion(this.alignmentPatternCenters[s] - 2, a, 5, 5);
      return n.setRegion(6, 9, 1, e - 17), n.setRegion(9, 6, e - 17, 1), this.versionNumber > 6 && (n.setRegion(e - 11, 0, 3, 6), n.setRegion(0, e - 11, 6, 3)), n;
    }, t.prototype.toString = function() {
      return "" + this.versionNumber;
    }, t.VERSION_DECODE_INFO = Int32Array.from([
      31892,
      34236,
      39577,
      42195,
      48118,
      51042,
      55367,
      58893,
      63784,
      68472,
      70749,
      76311,
      79154,
      84390,
      87683,
      92361,
      96236,
      102084,
      102881,
      110507,
      110734,
      117786,
      119615,
      126325,
      127568,
      133589,
      136944,
      141498,
      145311,
      150283,
      152622,
      158308,
      161089,
      167017
    ]), t.VERSIONS = [
      new t(1, new Int32Array(0), new je(7, new ce(1, 19)), new je(10, new ce(1, 16)), new je(13, new ce(1, 13)), new je(17, new ce(1, 9))),
      new t(2, Int32Array.from([6, 18]), new je(10, new ce(1, 34)), new je(16, new ce(1, 28)), new je(22, new ce(1, 22)), new je(28, new ce(1, 16))),
      new t(3, Int32Array.from([6, 22]), new je(15, new ce(1, 55)), new je(26, new ce(1, 44)), new je(18, new ce(2, 17)), new je(22, new ce(2, 13))),
      new t(4, Int32Array.from([6, 26]), new je(20, new ce(1, 80)), new je(18, new ce(2, 32)), new je(26, new ce(2, 24)), new je(16, new ce(4, 9))),
      new t(5, Int32Array.from([6, 30]), new je(26, new ce(1, 108)), new je(24, new ce(2, 43)), new je(18, new ce(2, 15), new ce(2, 16)), new je(22, new ce(2, 11), new ce(2, 12))),
      new t(6, Int32Array.from([6, 34]), new je(18, new ce(2, 68)), new je(16, new ce(4, 27)), new je(24, new ce(4, 19)), new je(28, new ce(4, 15))),
      new t(7, Int32Array.from([6, 22, 38]), new je(20, new ce(2, 78)), new je(18, new ce(4, 31)), new je(18, new ce(2, 14), new ce(4, 15)), new je(26, new ce(4, 13), new ce(1, 14))),
      new t(8, Int32Array.from([6, 24, 42]), new je(24, new ce(2, 97)), new je(22, new ce(2, 38), new ce(2, 39)), new je(22, new ce(4, 18), new ce(2, 19)), new je(26, new ce(4, 14), new ce(2, 15))),
      new t(9, Int32Array.from([6, 26, 46]), new je(30, new ce(2, 116)), new je(22, new ce(3, 36), new ce(2, 37)), new je(20, new ce(4, 16), new ce(4, 17)), new je(24, new ce(4, 12), new ce(4, 13))),
      new t(10, Int32Array.from([6, 28, 50]), new je(18, new ce(2, 68), new ce(2, 69)), new je(26, new ce(4, 43), new ce(1, 44)), new je(24, new ce(6, 19), new ce(2, 20)), new je(28, new ce(6, 15), new ce(2, 16))),
      new t(11, Int32Array.from([6, 30, 54]), new je(20, new ce(4, 81)), new je(30, new ce(1, 50), new ce(4, 51)), new je(28, new ce(4, 22), new ce(4, 23)), new je(24, new ce(3, 12), new ce(8, 13))),
      new t(12, Int32Array.from([6, 32, 58]), new je(24, new ce(2, 92), new ce(2, 93)), new je(22, new ce(6, 36), new ce(2, 37)), new je(26, new ce(4, 20), new ce(6, 21)), new je(28, new ce(7, 14), new ce(4, 15))),
      new t(13, Int32Array.from([6, 34, 62]), new je(26, new ce(4, 107)), new je(22, new ce(8, 37), new ce(1, 38)), new je(24, new ce(8, 20), new ce(4, 21)), new je(22, new ce(12, 11), new ce(4, 12))),
      new t(14, Int32Array.from([6, 26, 46, 66]), new je(30, new ce(3, 115), new ce(1, 116)), new je(24, new ce(4, 40), new ce(5, 41)), new je(20, new ce(11, 16), new ce(5, 17)), new je(24, new ce(11, 12), new ce(5, 13))),
      new t(15, Int32Array.from([6, 26, 48, 70]), new je(22, new ce(5, 87), new ce(1, 88)), new je(24, new ce(5, 41), new ce(5, 42)), new je(30, new ce(5, 24), new ce(7, 25)), new je(24, new ce(11, 12), new ce(7, 13))),
      new t(16, Int32Array.from([6, 26, 50, 74]), new je(24, new ce(5, 98), new ce(1, 99)), new je(28, new ce(7, 45), new ce(3, 46)), new je(24, new ce(15, 19), new ce(2, 20)), new je(30, new ce(3, 15), new ce(13, 16))),
      new t(17, Int32Array.from([6, 30, 54, 78]), new je(28, new ce(1, 107), new ce(5, 108)), new je(28, new ce(10, 46), new ce(1, 47)), new je(28, new ce(1, 22), new ce(15, 23)), new je(28, new ce(2, 14), new ce(17, 15))),
      new t(18, Int32Array.from([6, 30, 56, 82]), new je(30, new ce(5, 120), new ce(1, 121)), new je(26, new ce(9, 43), new ce(4, 44)), new je(28, new ce(17, 22), new ce(1, 23)), new je(28, new ce(2, 14), new ce(19, 15))),
      new t(19, Int32Array.from([6, 30, 58, 86]), new je(28, new ce(3, 113), new ce(4, 114)), new je(26, new ce(3, 44), new ce(11, 45)), new je(26, new ce(17, 21), new ce(4, 22)), new je(26, new ce(9, 13), new ce(16, 14))),
      new t(20, Int32Array.from([6, 34, 62, 90]), new je(28, new ce(3, 107), new ce(5, 108)), new je(26, new ce(3, 41), new ce(13, 42)), new je(30, new ce(15, 24), new ce(5, 25)), new je(28, new ce(15, 15), new ce(10, 16))),
      new t(21, Int32Array.from([6, 28, 50, 72, 94]), new je(28, new ce(4, 116), new ce(4, 117)), new je(26, new ce(17, 42)), new je(28, new ce(17, 22), new ce(6, 23)), new je(30, new ce(19, 16), new ce(6, 17))),
      new t(22, Int32Array.from([6, 26, 50, 74, 98]), new je(28, new ce(2, 111), new ce(7, 112)), new je(28, new ce(17, 46)), new je(30, new ce(7, 24), new ce(16, 25)), new je(24, new ce(34, 13))),
      new t(23, Int32Array.from([6, 30, 54, 78, 102]), new je(30, new ce(4, 121), new ce(5, 122)), new je(28, new ce(4, 47), new ce(14, 48)), new je(30, new ce(11, 24), new ce(14, 25)), new je(30, new ce(16, 15), new ce(14, 16))),
      new t(24, Int32Array.from([6, 28, 54, 80, 106]), new je(30, new ce(6, 117), new ce(4, 118)), new je(28, new ce(6, 45), new ce(14, 46)), new je(30, new ce(11, 24), new ce(16, 25)), new je(30, new ce(30, 16), new ce(2, 17))),
      new t(25, Int32Array.from([6, 32, 58, 84, 110]), new je(26, new ce(8, 106), new ce(4, 107)), new je(28, new ce(8, 47), new ce(13, 48)), new je(30, new ce(7, 24), new ce(22, 25)), new je(30, new ce(22, 15), new ce(13, 16))),
      new t(26, Int32Array.from([6, 30, 58, 86, 114]), new je(28, new ce(10, 114), new ce(2, 115)), new je(28, new ce(19, 46), new ce(4, 47)), new je(28, new ce(28, 22), new ce(6, 23)), new je(30, new ce(33, 16), new ce(4, 17))),
      new t(27, Int32Array.from([6, 34, 62, 90, 118]), new je(30, new ce(8, 122), new ce(4, 123)), new je(28, new ce(22, 45), new ce(3, 46)), new je(30, new ce(8, 23), new ce(26, 24)), new je(30, new ce(12, 15), new ce(28, 16))),
      new t(28, Int32Array.from([6, 26, 50, 74, 98, 122]), new je(30, new ce(3, 117), new ce(10, 118)), new je(28, new ce(3, 45), new ce(23, 46)), new je(30, new ce(4, 24), new ce(31, 25)), new je(30, new ce(11, 15), new ce(31, 16))),
      new t(29, Int32Array.from([6, 30, 54, 78, 102, 126]), new je(30, new ce(7, 116), new ce(7, 117)), new je(28, new ce(21, 45), new ce(7, 46)), new je(30, new ce(1, 23), new ce(37, 24)), new je(30, new ce(19, 15), new ce(26, 16))),
      new t(30, Int32Array.from([6, 26, 52, 78, 104, 130]), new je(30, new ce(5, 115), new ce(10, 116)), new je(28, new ce(19, 47), new ce(10, 48)), new je(30, new ce(15, 24), new ce(25, 25)), new je(30, new ce(23, 15), new ce(25, 16))),
      new t(31, Int32Array.from([6, 30, 56, 82, 108, 134]), new je(30, new ce(13, 115), new ce(3, 116)), new je(28, new ce(2, 46), new ce(29, 47)), new je(30, new ce(42, 24), new ce(1, 25)), new je(30, new ce(23, 15), new ce(28, 16))),
      new t(32, Int32Array.from([6, 34, 60, 86, 112, 138]), new je(30, new ce(17, 115)), new je(28, new ce(10, 46), new ce(23, 47)), new je(30, new ce(10, 24), new ce(35, 25)), new je(30, new ce(19, 15), new ce(35, 16))),
      new t(33, Int32Array.from([6, 30, 58, 86, 114, 142]), new je(30, new ce(17, 115), new ce(1, 116)), new je(28, new ce(14, 46), new ce(21, 47)), new je(30, new ce(29, 24), new ce(19, 25)), new je(30, new ce(11, 15), new ce(46, 16))),
      new t(34, Int32Array.from([6, 34, 62, 90, 118, 146]), new je(30, new ce(13, 115), new ce(6, 116)), new je(28, new ce(14, 46), new ce(23, 47)), new je(30, new ce(44, 24), new ce(7, 25)), new je(30, new ce(59, 16), new ce(1, 17))),
      new t(35, Int32Array.from([6, 30, 54, 78, 102, 126, 150]), new je(30, new ce(12, 121), new ce(7, 122)), new je(28, new ce(12, 47), new ce(26, 48)), new je(30, new ce(39, 24), new ce(14, 25)), new je(30, new ce(22, 15), new ce(41, 16))),
      new t(36, Int32Array.from([6, 24, 50, 76, 102, 128, 154]), new je(30, new ce(6, 121), new ce(14, 122)), new je(28, new ce(6, 47), new ce(34, 48)), new je(30, new ce(46, 24), new ce(10, 25)), new je(30, new ce(2, 15), new ce(64, 16))),
      new t(37, Int32Array.from([6, 28, 54, 80, 106, 132, 158]), new je(30, new ce(17, 122), new ce(4, 123)), new je(28, new ce(29, 46), new ce(14, 47)), new je(30, new ce(49, 24), new ce(10, 25)), new je(30, new ce(24, 15), new ce(46, 16))),
      new t(38, Int32Array.from([6, 32, 58, 84, 110, 136, 162]), new je(30, new ce(4, 122), new ce(18, 123)), new je(28, new ce(13, 46), new ce(32, 47)), new je(30, new ce(48, 24), new ce(14, 25)), new je(30, new ce(42, 15), new ce(32, 16))),
      new t(39, Int32Array.from([6, 26, 54, 82, 110, 138, 166]), new je(30, new ce(20, 117), new ce(4, 118)), new je(28, new ce(40, 47), new ce(7, 48)), new je(30, new ce(43, 24), new ce(22, 25)), new je(30, new ce(10, 15), new ce(67, 16))),
      new t(40, Int32Array.from([6, 30, 58, 86, 114, 142, 170]), new je(30, new ce(19, 118), new ce(6, 119)), new je(28, new ce(18, 47), new ce(31, 48)), new je(30, new ce(34, 24), new ce(34, 25)), new je(30, new ce(20, 15), new ce(61, 16)))
    ], t;
  }()
), io;
(function(t) {
  t[t.DATA_MASK_000 = 0] = "DATA_MASK_000", t[t.DATA_MASK_001 = 1] = "DATA_MASK_001", t[t.DATA_MASK_010 = 2] = "DATA_MASK_010", t[t.DATA_MASK_011 = 3] = "DATA_MASK_011", t[t.DATA_MASK_100 = 4] = "DATA_MASK_100", t[t.DATA_MASK_101 = 5] = "DATA_MASK_101", t[t.DATA_MASK_110 = 6] = "DATA_MASK_110", t[t.DATA_MASK_111 = 7] = "DATA_MASK_111";
})(io || (io = {}));
var JU = (
  /** @class */
  function() {
    function t(e, n) {
      this.value = e, this.isMasked = n;
    }
    return t.prototype.unmaskBitMatrix = function(e, n) {
      for (var r = 0; r < n; r++)
        for (var i = 0; i < n; i++)
          this.isMasked(r, i) && e.flip(i, r);
    }, t.values = /* @__PURE__ */ new Map([
      /**
       * 000: mask bits for which (x + y) mod 2 == 0
       */
      [io.DATA_MASK_000, new t(io.DATA_MASK_000, function(e, n) {
        return (e + n & 1) === 0;
      })],
      /**
       * 001: mask bits for which x mod 2 == 0
       */
      [io.DATA_MASK_001, new t(io.DATA_MASK_001, function(e, n) {
        return (e & 1) === 0;
      })],
      /**
       * 010: mask bits for which y mod 3 == 0
       */
      [io.DATA_MASK_010, new t(io.DATA_MASK_010, function(e, n) {
        return n % 3 === 0;
      })],
      /**
       * 011: mask bits for which (x + y) mod 3 == 0
       */
      [io.DATA_MASK_011, new t(io.DATA_MASK_011, function(e, n) {
        return (e + n) % 3 === 0;
      })],
      /**
       * 100: mask bits for which (x/2 + y/3) mod 2 == 0
       */
      [io.DATA_MASK_100, new t(io.DATA_MASK_100, function(e, n) {
        return (Math.floor(e / 2) + Math.floor(n / 3) & 1) === 0;
      })],
      /**
       * 101: mask bits for which xy mod 2 + xy mod 3 == 0
       * equivalently, such that xy mod 6 == 0
       */
      [io.DATA_MASK_101, new t(io.DATA_MASK_101, function(e, n) {
        return e * n % 6 === 0;
      })],
      /**
       * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
       * equivalently, such that xy mod 6 < 3
       */
      [io.DATA_MASK_110, new t(io.DATA_MASK_110, function(e, n) {
        return e * n % 6 < 3;
      })],
      /**
       * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
       * equivalently, such that (x + y + xy mod 3) mod 2 == 0
       */
      [io.DATA_MASK_111, new t(io.DATA_MASK_111, function(e, n) {
        return (e + n + e * n % 3 & 1) === 0;
      })]
    ]), t;
  }()
), aUe = (
  /** @class */
  function() {
    function t(e) {
      var n = e.getHeight();
      if (n < 21 || (n & 3) !== 1)
        throw new ht();
      this.bitMatrix = e;
    }
    return t.prototype.readFormatInformation = function() {
      if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== void 0)
        return this.parsedFormatInfo;
      for (var e = 0, n = 0; n < 6; n++)
        e = this.copyBit(n, 8, e);
      e = this.copyBit(7, 8, e), e = this.copyBit(8, 8, e), e = this.copyBit(8, 7, e);
      for (var r = 5; r >= 0; r--)
        e = this.copyBit(8, r, e);
      for (var i = this.bitMatrix.getHeight(), a = 0, s = i - 7, r = i - 1; r >= s; r--)
        a = this.copyBit(8, r, a);
      for (var n = i - 8; n < i; n++)
        a = this.copyBit(n, 8, a);
      if (this.parsedFormatInfo = Tee.decodeFormatInformation(e, a), this.parsedFormatInfo !== null)
        return this.parsedFormatInfo;
      throw new ht();
    }, t.prototype.readVersion = function() {
      if (this.parsedVersion !== null && this.parsedVersion !== void 0)
        return this.parsedVersion;
      var e = this.bitMatrix.getHeight(), n = Math.floor((e - 17) / 4);
      if (n <= 6)
        return fg.getVersionForNumber(n);
      for (var r = 0, i = e - 11, a = 5; a >= 0; a--)
        for (var s = e - 9; s >= i; s--)
          r = this.copyBit(s, a, r);
      var c = fg.decodeVersionInformation(r);
      if (c !== null && c.getDimensionForVersion() === e)
        return this.parsedVersion = c, c;
      r = 0;
      for (var s = 5; s >= 0; s--)
        for (var a = e - 9; a >= i; a--)
          r = this.copyBit(s, a, r);
      if (c = fg.decodeVersionInformation(r), c !== null && c.getDimensionForVersion() === e)
        return this.parsedVersion = c, c;
      throw new ht();
    }, t.prototype.copyBit = function(e, n, r) {
      var i = this.isMirror ? this.bitMatrix.get(n, e) : this.bitMatrix.get(e, n);
      return i ? r << 1 | 1 : r << 1;
    }, t.prototype.readCodewords = function() {
      var e = this.readFormatInformation(), n = this.readVersion(), r = JU.values.get(e.getDataMask()), i = this.bitMatrix.getHeight();
      r.unmaskBitMatrix(this.bitMatrix, i);
      for (var a = n.buildFunctionPattern(), s = !0, c = new Uint8Array(n.getTotalCodewords()), d = 0, f = 0, g = 0, m = i - 1; m > 0; m -= 2) {
        m === 6 && m--;
        for (var b = 0; b < i; b++)
          for (var w = s ? i - 1 - b : b, _ = 0; _ < 2; _++)
            a.get(m - _, w) || (g++, f <<= 1, this.bitMatrix.get(m - _, w) && (f |= 1), g === 8 && (c[d++] = /*(byte) */
            f, g = 0, f = 0));
        s = !s;
      }
      if (d !== n.getTotalCodewords())
        throw new ht();
      return c;
    }, t.prototype.remask = function() {
      if (this.parsedFormatInfo !== null) {
        var e = JU.values[this.parsedFormatInfo.getDataMask()], n = this.bitMatrix.getHeight();
        e.unmaskBitMatrix(this.bitMatrix, n);
      }
    }, t.prototype.setMirror = function(e) {
      this.parsedVersion = null, this.parsedFormatInfo = null, this.isMirror = e;
    }, t.prototype.mirror = function() {
      for (var e = this.bitMatrix, n = 0, r = e.getWidth(); n < r; n++)
        for (var i = n + 1, a = e.getHeight(); i < a; i++)
          e.get(n, i) !== e.get(i, n) && (e.flip(i, n), e.flip(n, i));
    }, t;
  }()
), e$ = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, oUe = (
  /** @class */
  function() {
    function t(e, n) {
      this.numDataCodewords = e, this.codewords = n;
    }
    return t.getDataBlocks = function(e, n, r) {
      var i, a, s, c;
      if (e.length !== n.getTotalCodewords())
        throw new Yt();
      var d = n.getECBlocksForLevel(r), f = 0, g = d.getECBlocks();
      try {
        for (var m = e$(g), b = m.next(); !b.done; b = m.next()) {
          var w = b.value;
          f += w.getCount();
        }
      } catch (Y) {
        i = { error: Y };
      } finally {
        try {
          b && !b.done && (a = m.return) && a.call(m);
        } finally {
          if (i)
            throw i.error;
        }
      }
      var _ = new Array(f), A = 0;
      try {
        for (var T = e$(g), O = T.next(); !O.done; O = T.next())
          for (var w = O.value, R = 0; R < w.getCount(); R++) {
            var N = w.getDataCodewords(), M = d.getECCodewordsPerBlock() + N;
            _[A++] = new t(N, new Uint8Array(M));
          }
      } catch (Y) {
        s = { error: Y };
      } finally {
        try {
          O && !O.done && (c = T.return) && c.call(T);
        } finally {
          if (s)
            throw s.error;
        }
      }
      for (var P = _[0].codewords.length, z = _.length - 1; z >= 0; ) {
        var F = _[z].codewords.length;
        if (F === P)
          break;
        z--;
      }
      z++;
      for (var $ = P - d.getECCodewordsPerBlock(), G = 0, R = 0; R < $; R++)
        for (var H = 0; H < A; H++)
          _[H].codewords[R] = e[G++];
      for (var H = z; H < A; H++)
        _[H].codewords[$] = e[G++];
      for (var Z = _[0].codewords.length, R = $; R < Z; R++)
        for (var H = 0; H < A; H++) {
          var V = H < z ? R : R + 1;
          _[H].codewords[V] = e[G++];
        }
      return _;
    }, t.prototype.getNumDataCodewords = function() {
      return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
      return this.codewords;
    }, t;
  }()
), Vc;
(function(t) {
  t[t.TERMINATOR = 0] = "TERMINATOR", t[t.NUMERIC = 1] = "NUMERIC", t[t.ALPHANUMERIC = 2] = "ALPHANUMERIC", t[t.STRUCTURED_APPEND = 3] = "STRUCTURED_APPEND", t[t.BYTE = 4] = "BYTE", t[t.ECI = 5] = "ECI", t[t.KANJI = 6] = "KANJI", t[t.FNC1_FIRST_POSITION = 7] = "FNC1_FIRST_POSITION", t[t.FNC1_SECOND_POSITION = 8] = "FNC1_SECOND_POSITION", t[t.HANZI = 9] = "HANZI";
})(Vc || (Vc = {}));
var vi = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      this.value = e, this.stringValue = n, this.characterCountBitsForVersions = r, this.bits = i, t.FOR_BITS.set(i, this), t.FOR_VALUE.set(e, this);
    }
    return t.forBits = function(e) {
      var n = t.FOR_BITS.get(e);
      if (n === void 0)
        throw new Yt();
      return n;
    }, t.prototype.getCharacterCountBits = function(e) {
      var n = e.getVersionNumber(), r;
      return n <= 9 ? r = 0 : n <= 26 ? r = 1 : r = 2, this.characterCountBitsForVersions[r];
    }, t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.getBits = function() {
      return this.bits;
    }, t.prototype.equals = function(e) {
      if (!(e instanceof t))
        return !1;
      var n = e;
      return this.value === n.value;
    }, t.prototype.toString = function() {
      return this.stringValue;
    }, t.FOR_BITS = /* @__PURE__ */ new Map(), t.FOR_VALUE = /* @__PURE__ */ new Map(), t.TERMINATOR = new t(Vc.TERMINATOR, "TERMINATOR", Int32Array.from([0, 0, 0]), 0), t.NUMERIC = new t(Vc.NUMERIC, "NUMERIC", Int32Array.from([10, 12, 14]), 1), t.ALPHANUMERIC = new t(Vc.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([9, 11, 13]), 2), t.STRUCTURED_APPEND = new t(Vc.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([0, 0, 0]), 3), t.BYTE = new t(Vc.BYTE, "BYTE", Int32Array.from([8, 16, 16]), 4), t.ECI = new t(Vc.ECI, "ECI", Int32Array.from([0, 0, 0]), 7), t.KANJI = new t(Vc.KANJI, "KANJI", Int32Array.from([8, 10, 12]), 8), t.FNC1_FIRST_POSITION = new t(Vc.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([0, 0, 0]), 5), t.FNC1_SECOND_POSITION = new t(Vc.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([0, 0, 0]), 9), t.HANZI = new t(Vc.HANZI, "HANZI", Int32Array.from([8, 10, 12]), 13), t;
  }()
), sUe = (
  /** @class */
  function() {
    function t() {
    }
    return t.decode = function(e, n, r, i) {
      var a = new Cee(e), s = new Bn(), c = new Array(), d = -1, f = -1;
      try {
        var g = null, m = !1, b = void 0;
        do {
          if (a.available() < 4)
            b = vi.TERMINATOR;
          else {
            var w = a.readBits(4);
            b = vi.forBits(w);
          }
          switch (b) {
            case vi.TERMINATOR:
              break;
            case vi.FNC1_FIRST_POSITION:
            case vi.FNC1_SECOND_POSITION:
              m = !0;
              break;
            case vi.STRUCTURED_APPEND:
              if (a.available() < 16)
                throw new ht();
              d = a.readBits(8), f = a.readBits(8);
              break;
            case vi.ECI:
              var _ = t.parseECIValue(a);
              if (g = Ha.getCharacterSetECIByValue(_), g === null)
                throw new ht();
              break;
            case vi.HANZI:
              var A = a.readBits(4), T = a.readBits(b.getCharacterCountBits(n));
              A === t.GB2312_SUBSET && t.decodeHanziSegment(a, s, T);
              break;
            default:
              var O = a.readBits(b.getCharacterCountBits(n));
              switch (b) {
                case vi.NUMERIC:
                  t.decodeNumericSegment(a, s, O);
                  break;
                case vi.ALPHANUMERIC:
                  t.decodeAlphanumericSegment(a, s, O, m);
                  break;
                case vi.BYTE:
                  t.decodeByteSegment(a, s, O, g, c, i);
                  break;
                case vi.KANJI:
                  t.decodeKanjiSegment(a, s, O);
                  break;
                default:
                  throw new ht();
              }
              break;
          }
        } while (b !== vi.TERMINATOR);
      } catch {
        throw new ht();
      }
      return new RO(e, s.toString(), c.length === 0 ? null : c, r === null ? null : r.toString(), d, f);
    }, t.decodeHanziSegment = function(e, n, r) {
      if (r * 13 > e.available())
        throw new ht();
      for (var i = new Uint8Array(2 * r), a = 0; r > 0; ) {
        var s = e.readBits(13), c = s / 96 << 8 & 4294967295 | s % 96;
        c < 959 ? c += 41377 : c += 42657, i[a] = /*(byte) */
        c >> 8 & 255, i[a + 1] = /*(byte) */
        c & 255, a += 2, r--;
      }
      try {
        n.append(Jc.decode(i, tr.GB2312));
      } catch (d) {
        throw new ht(d);
      }
    }, t.decodeKanjiSegment = function(e, n, r) {
      if (r * 13 > e.available())
        throw new ht();
      for (var i = new Uint8Array(2 * r), a = 0; r > 0; ) {
        var s = e.readBits(13), c = s / 192 << 8 & 4294967295 | s % 192;
        c < 7936 ? c += 33088 : c += 49472, i[a] = /*(byte) */
        c >> 8, i[a + 1] = /*(byte) */
        c, a += 2, r--;
      }
      try {
        n.append(Jc.decode(i, tr.SHIFT_JIS));
      } catch (d) {
        throw new ht(d);
      }
    }, t.decodeByteSegment = function(e, n, r, i, a, s) {
      if (8 * r > e.available())
        throw new ht();
      for (var c = new Uint8Array(r), d = 0; d < r; d++)
        c[d] = /*(byte) */
        e.readBits(8);
      var f;
      i === null ? f = tr.guessEncoding(c, s) : f = i.getName();
      try {
        n.append(Jc.decode(c, f));
      } catch (g) {
        throw new ht(g);
      }
      a.push(c);
    }, t.toAlphaNumericChar = function(e) {
      if (e >= t.ALPHANUMERIC_CHARS.length)
        throw new ht();
      return t.ALPHANUMERIC_CHARS[e];
    }, t.decodeAlphanumericSegment = function(e, n, r, i) {
      for (var a = n.length(); r > 1; ) {
        if (e.available() < 11)
          throw new ht();
        var s = e.readBits(11);
        n.append(t.toAlphaNumericChar(Math.floor(s / 45))), n.append(t.toAlphaNumericChar(s % 45)), r -= 2;
      }
      if (r === 1) {
        if (e.available() < 6)
          throw new ht();
        n.append(t.toAlphaNumericChar(e.readBits(6)));
      }
      if (i)
        for (var c = a; c < n.length(); c++)
          n.charAt(c) === "%" && (c < n.length() - 1 && n.charAt(c + 1) === "%" ? n.deleteCharAt(c + 1) : n.setCharAt(c, String.fromCharCode(29)));
    }, t.decodeNumericSegment = function(e, n, r) {
      for (; r >= 3; ) {
        if (e.available() < 10)
          throw new ht();
        var i = e.readBits(10);
        if (i >= 1e3)
          throw new ht();
        n.append(t.toAlphaNumericChar(Math.floor(i / 100))), n.append(t.toAlphaNumericChar(Math.floor(i / 10) % 10)), n.append(t.toAlphaNumericChar(i % 10)), r -= 3;
      }
      if (r === 2) {
        if (e.available() < 7)
          throw new ht();
        var a = e.readBits(7);
        if (a >= 100)
          throw new ht();
        n.append(t.toAlphaNumericChar(Math.floor(a / 10))), n.append(t.toAlphaNumericChar(a % 10));
      } else if (r === 1) {
        if (e.available() < 4)
          throw new ht();
        var s = e.readBits(4);
        if (s >= 10)
          throw new ht();
        n.append(t.toAlphaNumericChar(s));
      }
    }, t.parseECIValue = function(e) {
      var n = e.readBits(8);
      if (!(n & 128))
        return n & 127;
      if ((n & 192) === 128) {
        var r = e.readBits(8);
        return (n & 63) << 8 & 4294967295 | r;
      }
      if ((n & 224) === 192) {
        var i = e.readBits(16);
        return (n & 31) << 16 & 4294967295 | i;
      }
      throw new ht();
    }, t.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", t.GB2312_SUBSET = 1, t;
  }()
), Oee = (
  /** @class */
  function() {
    function t(e) {
      this.mirrored = e;
    }
    return t.prototype.isMirrored = function() {
      return this.mirrored;
    }, t.prototype.applyMirroredCorrection = function(e) {
      if (!(!this.mirrored || e === null || e.length < 3)) {
        var n = e[0];
        e[0] = e[2], e[2] = n;
      }
    }, t;
  }()
), t$ = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, lUe = (
  /** @class */
  function() {
    function t() {
      this.rsDecoder = new DO(sl.QR_CODE_FIELD_256);
    }
    return t.prototype.decodeBooleanArray = function(e, n) {
      return this.decodeBitMatrix(sf.parseFromBooleanArray(e), n);
    }, t.prototype.decodeBitMatrix = function(e, n) {
      var r = new aUe(e), i = null;
      try {
        return this.decodeBitMatrixParser(r, n);
      } catch (s) {
        i = s;
      }
      try {
        r.remask(), r.setMirror(!0), r.readVersion(), r.readFormatInformation(), r.mirror();
        var a = this.decodeBitMatrixParser(r, n);
        return a.setOther(new Oee(!0)), a;
      } catch (s) {
        throw i !== null ? i : s;
      }
    }, t.prototype.decodeBitMatrixParser = function(e, n) {
      var r, i, a, s, c = e.readVersion(), d = e.readFormatInformation().getErrorCorrectionLevel(), f = e.readCodewords(), g = oUe.getDataBlocks(f, c, d), m = 0;
      try {
        for (var b = t$(g), w = b.next(); !w.done; w = b.next()) {
          var _ = w.value;
          m += _.getNumDataCodewords();
        }
      } catch (z) {
        r = { error: z };
      } finally {
        try {
          w && !w.done && (i = b.return) && i.call(b);
        } finally {
          if (r)
            throw r.error;
        }
      }
      var A = new Uint8Array(m), T = 0;
      try {
        for (var O = t$(g), R = O.next(); !R.done; R = O.next()) {
          var _ = R.value, N = _.getCodewords(), M = _.getNumDataCodewords();
          this.correctErrors(N, M);
          for (var P = 0; P < M; P++)
            A[T++] = N[P];
        }
      } catch (z) {
        a = { error: z };
      } finally {
        try {
          R && !R.done && (s = O.return) && s.call(O);
        } finally {
          if (a)
            throw a.error;
        }
      }
      return sUe.decode(A, c, d, n);
    }, t.prototype.correctErrors = function(e, n) {
      var r = new Int32Array(e);
      try {
        this.rsDecoder.decode(r, e.length - n);
      } catch {
        throw new uo();
      }
      for (var i = 0; i < n; i++)
        e[i] = /*(byte) */
        r[i];
    }, t;
  }()
), cUe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), uUe = (
  /** @class */
  function(t) {
    cUe(e, t);
    function e(n, r, i) {
      var a = t.call(this, n, r) || this;
      return a.estimatedModuleSize = i, a;
    }
    return e.prototype.aboutEquals = function(n, r, i) {
      if (Math.abs(r - this.getY()) <= n && Math.abs(i - this.getX()) <= n) {
        var a = Math.abs(n - this.estimatedModuleSize);
        return a <= 1 || a <= this.estimatedModuleSize;
      }
      return !1;
    }, e.prototype.combineEstimate = function(n, r, i) {
      var a = (this.getX() + r) / 2, s = (this.getY() + n) / 2, c = (this.estimatedModuleSize + i) / 2;
      return new e(a, s, c);
    }, e;
  }(kt)
), dUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, fUe = (
  /** @class */
  function() {
    function t(e, n, r, i, a, s, c) {
      this.image = e, this.startX = n, this.startY = r, this.width = i, this.height = a, this.moduleSize = s, this.resultPointCallback = c, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(3);
    }
    return t.prototype.find = function() {
      for (var e = this.startX, n = this.height, r = this.width, i = e + r, a = this.startY + n / 2, s = new Int32Array(3), c = this.image, d = 0; d < n; d++) {
        var f = a + (d & 1 ? -Math.floor((d + 1) / 2) : Math.floor((d + 1) / 2));
        s[0] = 0, s[1] = 0, s[2] = 0;
        for (var g = e; g < i && !c.get(g, f); )
          g++;
        for (var m = 0; g < i; ) {
          if (c.get(g, f))
            if (m === 1)
              s[1]++;
            else if (m === 2) {
              if (this.foundPatternCross(s)) {
                var b = this.handlePossibleCenter(s, f, g);
                if (b !== null)
                  return b;
              }
              s[0] = s[2], s[1] = 1, s[2] = 0, m = 1;
            } else
              s[++m]++;
          else
            m === 1 && m++, s[m]++;
          g++;
        }
        if (this.foundPatternCross(s)) {
          var b = this.handlePossibleCenter(s, f, i);
          if (b !== null)
            return b;
        }
      }
      if (this.possibleCenters.length !== 0)
        return this.possibleCenters[0];
      throw new Ye();
    }, t.centerFromEnd = function(e, n) {
      return n - e[2] - e[1] / 2;
    }, t.prototype.foundPatternCross = function(e) {
      for (var n = this.moduleSize, r = n / 2, i = 0; i < 3; i++)
        if (Math.abs(n - e[i]) >= r)
          return !1;
      return !0;
    }, t.prototype.crossCheckVertical = function(e, n, r, i) {
      var a = this.image, s = a.getHeight(), c = this.crossCheckStateCount;
      c[0] = 0, c[1] = 0, c[2] = 0;
      for (var d = e; d >= 0 && a.get(n, d) && c[1] <= r; )
        c[1]++, d--;
      if (d < 0 || c[1] > r)
        return NaN;
      for (; d >= 0 && !a.get(n, d) && c[0] <= r; )
        c[0]++, d--;
      if (c[0] > r)
        return NaN;
      for (d = e + 1; d < s && a.get(n, d) && c[1] <= r; )
        c[1]++, d++;
      if (d === s || c[1] > r)
        return NaN;
      for (; d < s && !a.get(n, d) && c[2] <= r; )
        c[2]++, d++;
      if (c[2] > r)
        return NaN;
      var f = c[0] + c[1] + c[2];
      return 5 * Math.abs(f - i) >= 2 * i ? NaN : this.foundPatternCross(c) ? t.centerFromEnd(c, d) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, n, r) {
      var i, a, s = e[0] + e[1] + e[2], c = t.centerFromEnd(e, r), d = this.crossCheckVertical(
        n,
        /*(int) */
        c,
        2 * e[1],
        s
      );
      if (!isNaN(d)) {
        var f = (e[0] + e[1] + e[2]) / 3;
        try {
          for (var g = dUe(this.possibleCenters), m = g.next(); !m.done; m = g.next()) {
            var b = m.value;
            if (b.aboutEquals(f, d, c))
              return b.combineEstimate(d, c, f);
          }
        } catch (_) {
          i = { error: _ };
        } finally {
          try {
            m && !m.done && (a = g.return) && a.call(g);
          } finally {
            if (i)
              throw i.error;
          }
        }
        var w = new uUe(c, d, f);
        this.possibleCenters.push(w), this.resultPointCallback !== null && this.resultPointCallback !== void 0 && this.resultPointCallback.foundPossibleResultPoint(w);
      }
      return null;
    }, t;
  }()
), hUe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), pUe = (
  /** @class */
  function(t) {
    hUe(e, t);
    function e(n, r, i, a) {
      var s = t.call(this, n, r) || this;
      return s.estimatedModuleSize = i, s.count = a, a === void 0 && (s.count = 1), s;
    }
    return e.prototype.getEstimatedModuleSize = function() {
      return this.estimatedModuleSize;
    }, e.prototype.getCount = function() {
      return this.count;
    }, e.prototype.aboutEquals = function(n, r, i) {
      if (Math.abs(r - this.getY()) <= n && Math.abs(i - this.getX()) <= n) {
        var a = Math.abs(n - this.estimatedModuleSize);
        return a <= 1 || a <= this.estimatedModuleSize;
      }
      return !1;
    }, e.prototype.combineEstimate = function(n, r, i) {
      var a = this.count + 1, s = (this.count * this.getX() + r) / a, c = (this.count * this.getY() + n) / a, d = (this.count * this.estimatedModuleSize + i) / a;
      return new e(s, c, d, a);
    }, e;
  }(kt)
), mUe = (
  /** @class */
  function() {
    function t(e) {
      this.bottomLeft = e[0], this.topLeft = e[1], this.topRight = e[2];
    }
    return t.prototype.getBottomLeft = function() {
      return this.bottomLeft;
    }, t.prototype.getTopLeft = function() {
      return this.topLeft;
    }, t.prototype.getTopRight = function() {
      return this.topRight;
    }, t;
  }()
), HS = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, gUe = (
  /** @class */
  function() {
    function t(e, n) {
      this.image = e, this.resultPointCallback = n, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(5), this.resultPointCallback = n;
    }
    return t.prototype.getImage = function() {
      return this.image;
    }, t.prototype.getPossibleCenters = function() {
      return this.possibleCenters;
    }, t.prototype.find = function(e) {
      var n = e != null && e.get(Ui.TRY_HARDER) !== void 0, r = e != null && e.get(Ui.PURE_BARCODE) !== void 0, i = this.image, a = i.getHeight(), s = i.getWidth(), c = Math.floor(3 * a / (4 * t.MAX_MODULES));
      (c < t.MIN_SKIP || n) && (c = t.MIN_SKIP);
      for (var d = !1, f = new Int32Array(5), g = c - 1; g < a && !d; g += c) {
        f[0] = 0, f[1] = 0, f[2] = 0, f[3] = 0, f[4] = 0;
        for (var m = 0, b = 0; b < s; b++)
          if (i.get(b, g))
            (m & 1) === 1 && m++, f[m]++;
          else if (m & 1)
            f[m]++;
          else if (m === 4)
            if (t.foundPatternCross(f)) {
              var w = this.handlePossibleCenter(f, g, b, r);
              if (w === !0)
                if (c = 2, this.hasSkipped === !0)
                  d = this.haveMultiplyConfirmedCenters();
                else {
                  var _ = this.findRowSkip();
                  _ > f[2] && (g += _ - f[2] - c, b = s - 1);
                }
              else {
                f[0] = f[2], f[1] = f[3], f[2] = f[4], f[3] = 1, f[4] = 0, m = 3;
                continue;
              }
              m = 0, f[0] = 0, f[1] = 0, f[2] = 0, f[3] = 0, f[4] = 0;
            } else
              f[0] = f[2], f[1] = f[3], f[2] = f[4], f[3] = 1, f[4] = 0, m = 3;
          else
            f[++m]++;
        if (t.foundPatternCross(f)) {
          var w = this.handlePossibleCenter(f, g, s, r);
          w === !0 && (c = f[0], this.hasSkipped && (d = this.haveMultiplyConfirmedCenters()));
        }
      }
      var A = this.selectBestPatterns();
      return kt.orderBestPatterns(A), new mUe(A);
    }, t.centerFromEnd = function(e, n) {
      return n - e[4] - e[3] - e[2] / 2;
    }, t.foundPatternCross = function(e) {
      for (var n = 0, r = 0; r < 5; r++) {
        var i = e[r];
        if (i === 0)
          return !1;
        n += i;
      }
      if (n < 7)
        return !1;
      var a = n / 7, s = a / 2;
      return Math.abs(a - e[0]) < s && Math.abs(a - e[1]) < s && Math.abs(3 * a - e[2]) < 3 * s && Math.abs(a - e[3]) < s && Math.abs(a - e[4]) < s;
    }, t.prototype.getCrossCheckStateCount = function() {
      var e = this.crossCheckStateCount;
      return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e;
    }, t.prototype.crossCheckDiagonal = function(e, n, r, i) {
      for (var a = this.getCrossCheckStateCount(), s = 0, c = this.image; e >= s && n >= s && c.get(n - s, e - s); )
        a[2]++, s++;
      if (e < s || n < s)
        return !1;
      for (; e >= s && n >= s && !c.get(n - s, e - s) && a[1] <= r; )
        a[1]++, s++;
      if (e < s || n < s || a[1] > r)
        return !1;
      for (; e >= s && n >= s && c.get(n - s, e - s) && a[0] <= r; )
        a[0]++, s++;
      if (a[0] > r)
        return !1;
      var d = c.getHeight(), f = c.getWidth();
      for (s = 1; e + s < d && n + s < f && c.get(n + s, e + s); )
        a[2]++, s++;
      if (e + s >= d || n + s >= f)
        return !1;
      for (; e + s < d && n + s < f && !c.get(n + s, e + s) && a[3] < r; )
        a[3]++, s++;
      if (e + s >= d || n + s >= f || a[3] >= r)
        return !1;
      for (; e + s < d && n + s < f && c.get(n + s, e + s) && a[4] < r; )
        a[4]++, s++;
      if (a[4] >= r)
        return !1;
      var g = a[0] + a[1] + a[2] + a[3] + a[4];
      return Math.abs(g - i) < 2 * i && t.foundPatternCross(a);
    }, t.prototype.crossCheckVertical = function(e, n, r, i) {
      for (var a = this.image, s = a.getHeight(), c = this.getCrossCheckStateCount(), d = e; d >= 0 && a.get(n, d); )
        c[2]++, d--;
      if (d < 0)
        return NaN;
      for (; d >= 0 && !a.get(n, d) && c[1] <= r; )
        c[1]++, d--;
      if (d < 0 || c[1] > r)
        return NaN;
      for (; d >= 0 && a.get(n, d) && c[0] <= r; )
        c[0]++, d--;
      if (c[0] > r)
        return NaN;
      for (d = e + 1; d < s && a.get(n, d); )
        c[2]++, d++;
      if (d === s)
        return NaN;
      for (; d < s && !a.get(n, d) && c[3] < r; )
        c[3]++, d++;
      if (d === s || c[3] >= r)
        return NaN;
      for (; d < s && a.get(n, d) && c[4] < r; )
        c[4]++, d++;
      if (c[4] >= r)
        return NaN;
      var f = c[0] + c[1] + c[2] + c[3] + c[4];
      return 5 * Math.abs(f - i) >= 2 * i ? NaN : t.foundPatternCross(c) ? t.centerFromEnd(c, d) : NaN;
    }, t.prototype.crossCheckHorizontal = function(e, n, r, i) {
      for (var a = this.image, s = a.getWidth(), c = this.getCrossCheckStateCount(), d = e; d >= 0 && a.get(d, n); )
        c[2]++, d--;
      if (d < 0)
        return NaN;
      for (; d >= 0 && !a.get(d, n) && c[1] <= r; )
        c[1]++, d--;
      if (d < 0 || c[1] > r)
        return NaN;
      for (; d >= 0 && a.get(d, n) && c[0] <= r; )
        c[0]++, d--;
      if (c[0] > r)
        return NaN;
      for (d = e + 1; d < s && a.get(d, n); )
        c[2]++, d++;
      if (d === s)
        return NaN;
      for (; d < s && !a.get(d, n) && c[3] < r; )
        c[3]++, d++;
      if (d === s || c[3] >= r)
        return NaN;
      for (; d < s && a.get(d, n) && c[4] < r; )
        c[4]++, d++;
      if (c[4] >= r)
        return NaN;
      var f = c[0] + c[1] + c[2] + c[3] + c[4];
      return 5 * Math.abs(f - i) >= i ? NaN : t.foundPatternCross(c) ? t.centerFromEnd(c, d) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, n, r, i) {
      var a = e[0] + e[1] + e[2] + e[3] + e[4], s = t.centerFromEnd(e, r), c = this.crossCheckVertical(
        n,
        /*(int) */
        Math.floor(s),
        e[2],
        a
      );
      if (!isNaN(c) && (s = this.crossCheckHorizontal(
        /*(int) */
        Math.floor(s),
        /*(int) */
        Math.floor(c),
        e[2],
        a
      ), !isNaN(s) && (!i || this.crossCheckDiagonal(
        /*(int) */
        Math.floor(c),
        /*(int) */
        Math.floor(s),
        e[2],
        a
      )))) {
        for (var d = a / 7, f = !1, g = this.possibleCenters, m = 0, b = g.length; m < b; m++) {
          var w = g[m];
          if (w.aboutEquals(d, c, s)) {
            g[m] = w.combineEstimate(c, s, d), f = !0;
            break;
          }
        }
        if (!f) {
          var _ = new pUe(s, c, d);
          g.push(_), this.resultPointCallback !== null && this.resultPointCallback !== void 0 && this.resultPointCallback.foundPossibleResultPoint(_);
        }
        return !0;
      }
      return !1;
    }, t.prototype.findRowSkip = function() {
      var e, n, r = this.possibleCenters.length;
      if (r <= 1)
        return 0;
      var i = null;
      try {
        for (var a = HS(this.possibleCenters), s = a.next(); !s.done; s = a.next()) {
          var c = s.value;
          if (c.getCount() >= t.CENTER_QUORUM)
            if (i == null)
              i = c;
            else
              return this.hasSkipped = !0, /*(int) */
              Math.floor((Math.abs(i.getX() - c.getX()) - Math.abs(i.getY() - c.getY())) / 2);
        }
      } catch (d) {
        e = { error: d };
      } finally {
        try {
          s && !s.done && (n = a.return) && n.call(a);
        } finally {
          if (e)
            throw e.error;
        }
      }
      return 0;
    }, t.prototype.haveMultiplyConfirmedCenters = function() {
      var e, n, r, i, a = 0, s = 0, c = this.possibleCenters.length;
      try {
        for (var d = HS(this.possibleCenters), f = d.next(); !f.done; f = d.next()) {
          var g = f.value;
          g.getCount() >= t.CENTER_QUORUM && (a++, s += g.getEstimatedModuleSize());
        }
      } catch (A) {
        e = { error: A };
      } finally {
        try {
          f && !f.done && (n = d.return) && n.call(d);
        } finally {
          if (e)
            throw e.error;
        }
      }
      if (a < 3)
        return !1;
      var m = s / c, b = 0;
      try {
        for (var w = HS(this.possibleCenters), _ = w.next(); !_.done; _ = w.next()) {
          var g = _.value;
          b += Math.abs(g.getEstimatedModuleSize() - m);
        }
      } catch (A) {
        r = { error: A };
      } finally {
        try {
          _ && !_.done && (i = w.return) && i.call(w);
        } finally {
          if (r)
            throw r.error;
        }
      }
      return b <= 0.05 * s;
    }, t.prototype.selectBestPatterns = function() {
      var e, n, r, i, a = this.possibleCenters.length;
      if (a < 3)
        throw new Ye();
      var s = this.possibleCenters, c;
      if (a > 3) {
        var d = 0, f = 0;
        try {
          for (var g = HS(this.possibleCenters), m = g.next(); !m.done; m = g.next()) {
            var b = m.value, w = b.getEstimatedModuleSize();
            d += w, f += w * w;
          }
        } catch (P) {
          e = { error: P };
        } finally {
          try {
            m && !m.done && (n = g.return) && n.call(g);
          } finally {
            if (e)
              throw e.error;
          }
        }
        c = d / a;
        var _ = Math.sqrt(f / a - c * c);
        s.sort(
          /**
           * <p>Orders by furthest from average</p>
           */
          // FurthestFromAverageComparator implements Comparator<FinderPattern>
          function(P, z) {
            var F = Math.abs(z.getEstimatedModuleSize() - c), $ = Math.abs(P.getEstimatedModuleSize() - c);
            return F < $ ? -1 : F > $ ? 1 : 0;
          }
        );
        for (var A = Math.max(0.2 * c, _), T = 0; T < s.length && s.length > 3; T++) {
          var O = s[T];
          Math.abs(O.getEstimatedModuleSize() - c) > A && (s.splice(T, 1), T--);
        }
      }
      if (s.length > 3) {
        var d = 0;
        try {
          for (var R = HS(s), N = R.next(); !N.done; N = R.next()) {
            var M = N.value;
            d += M.getEstimatedModuleSize();
          }
        } catch (z) {
          r = { error: z };
        } finally {
          try {
            N && !N.done && (i = R.return) && i.call(R);
          } finally {
            if (r)
              throw r.error;
          }
        }
        c = d / s.length, s.sort(
          /**
           * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
           */
          // CenterComparator implements Comparator<FinderPattern>
          function(z, F) {
            if (F.getCount() === z.getCount()) {
              var $ = Math.abs(F.getEstimatedModuleSize() - c), G = Math.abs(z.getEstimatedModuleSize() - c);
              return $ < G ? 1 : $ > G ? -1 : 0;
            } else
              return F.getCount() - z.getCount();
          }
        ), s.splice(3);
      }
      return [
        s[0],
        s[1],
        s[2]
      ];
    }, t.CENTER_QUORUM = 2, t.MIN_SKIP = 3, t.MAX_MODULES = 57, t;
  }()
), vUe = (
  /** @class */
  function() {
    function t(e) {
      this.image = e;
    }
    return t.prototype.getImage = function() {
      return this.image;
    }, t.prototype.getResultPointCallback = function() {
      return this.resultPointCallback;
    }, t.prototype.detect = function(e) {
      this.resultPointCallback = e == null ? null : (
        /*(ResultPointCallback) */
        e.get(Ui.NEED_RESULT_POINT_CALLBACK)
      );
      var n = new gUe(this.image, this.resultPointCallback), r = n.find(e);
      return this.processFinderPatternInfo(r);
    }, t.prototype.processFinderPatternInfo = function(e) {
      var n = e.getTopLeft(), r = e.getTopRight(), i = e.getBottomLeft(), a = this.calculateModuleSize(n, r, i);
      if (a < 1)
        throw new Ye("No pattern found in proccess finder.");
      var s = t.computeDimension(n, r, i, a), c = fg.getProvisionalVersionForDimension(s), d = c.getDimensionForVersion() - 7, f = null;
      if (c.getAlignmentPatternCenters().length > 0)
        for (var g = r.getX() - n.getX() + i.getX(), m = r.getY() - n.getY() + i.getY(), b = 1 - 3 / d, w = (
          /*(int) */
          Math.floor(n.getX() + b * (g - n.getX()))
        ), _ = (
          /*(int) */
          Math.floor(n.getY() + b * (m - n.getY()))
        ), A = 4; A <= 16; A <<= 1)
          try {
            f = this.findAlignmentInRegion(a, w, _, A);
            break;
          } catch (N) {
            if (!(N instanceof Ye))
              throw N;
          }
      var T = t.createTransform(n, r, i, f, s), O = t.sampleGrid(this.image, T, s), R;
      return f === null ? R = [i, n, r] : R = [i, n, r, f], new Gk(O, R);
    }, t.createTransform = function(e, n, r, i, a) {
      var s = a - 3.5, c, d, f, g;
      return i !== null ? (c = i.getX(), d = i.getY(), f = s - 3, g = f) : (c = n.getX() - e.getX() + r.getX(), d = n.getY() - e.getY() + r.getY(), f = s, g = s), See.quadrilateralToQuadrilateral(3.5, 3.5, s, 3.5, f, g, 3.5, s, e.getX(), e.getY(), n.getX(), n.getY(), c, d, r.getX(), r.getY());
    }, t.sampleGrid = function(e, n, r) {
      var i = Yk.getInstance();
      return i.sampleGridWithTransform(e, r, r, n);
    }, t.computeDimension = function(e, n, r, i) {
      var a = gr.round(kt.distance(e, n) / i), s = gr.round(kt.distance(e, r) / i), c = Math.floor((a + s) / 2) + 7;
      switch (c & 3) {
        case 0:
          c++;
          break;
        case 2:
          c--;
          break;
        case 3:
          throw new Ye("Dimensions could be not found.");
      }
      return c;
    }, t.prototype.calculateModuleSize = function(e, n, r) {
      return (this.calculateModuleSizeOneWay(e, n) + this.calculateModuleSizeOneWay(e, r)) / 2;
    }, t.prototype.calculateModuleSizeOneWay = function(e, n) {
      var r = this.sizeOfBlackWhiteBlackRunBothWays(
        /*(int) */
        Math.floor(e.getX()),
        /*(int) */
        Math.floor(e.getY()),
        /*(int) */
        Math.floor(n.getX()),
        /*(int) */
        Math.floor(n.getY())
      ), i = this.sizeOfBlackWhiteBlackRunBothWays(
        /*(int) */
        Math.floor(n.getX()),
        /*(int) */
        Math.floor(n.getY()),
        /*(int) */
        Math.floor(e.getX()),
        /*(int) */
        Math.floor(e.getY())
      );
      return isNaN(r) ? i / 7 : isNaN(i) ? r / 7 : (r + i) / 14;
    }, t.prototype.sizeOfBlackWhiteBlackRunBothWays = function(e, n, r, i) {
      var a = this.sizeOfBlackWhiteBlackRun(e, n, r, i), s = 1, c = e - (r - e);
      c < 0 ? (s = e / /*(float) */
      (e - c), c = 0) : c >= this.image.getWidth() && (s = (this.image.getWidth() - 1 - e) / /*(float) */
      (c - e), c = this.image.getWidth() - 1);
      var d = (
        /*(int) */
        Math.floor(n - (i - n) * s)
      );
      return s = 1, d < 0 ? (s = n / /*(float) */
      (n - d), d = 0) : d >= this.image.getHeight() && (s = (this.image.getHeight() - 1 - n) / /*(float) */
      (d - n), d = this.image.getHeight() - 1), c = /*(int) */
      Math.floor(e + (c - e) * s), a += this.sizeOfBlackWhiteBlackRun(e, n, c, d), a - 1;
    }, t.prototype.sizeOfBlackWhiteBlackRun = function(e, n, r, i) {
      var a = Math.abs(i - n) > Math.abs(r - e);
      if (a) {
        var s = e;
        e = n, n = s, s = r, r = i, i = s;
      }
      for (var c = Math.abs(r - e), d = Math.abs(i - n), f = -c / 2, g = e < r ? 1 : -1, m = n < i ? 1 : -1, b = 0, w = r + g, _ = e, A = n; _ !== w; _ += g) {
        var T = a ? A : _, O = a ? _ : A;
        if (b === 1 === this.image.get(T, O)) {
          if (b === 2)
            return gr.distance(_, A, e, n);
          b++;
        }
        if (f += d, f > 0) {
          if (A === i)
            break;
          A += m, f -= c;
        }
      }
      return b === 2 ? gr.distance(r + g, i, e, n) : NaN;
    }, t.prototype.findAlignmentInRegion = function(e, n, r, i) {
      var a = (
        /*(int) */
        Math.floor(i * e)
      ), s = Math.max(0, n - a), c = Math.min(this.image.getWidth() - 1, n + a);
      if (c - s < e * 3)
        throw new Ye("Alignment top exceeds estimated module size.");
      var d = Math.max(0, r - a), f = Math.min(this.image.getHeight() - 1, r + a);
      if (f - d < e * 3)
        throw new Ye("Alignment bottom exceeds estimated module size.");
      var g = new fUe(this.image, s, d, c - s, f - d, e, this.resultPointCallback);
      return g.find();
    }, t;
  }()
), cM = (
  /** @class */
  function() {
    function t() {
      this.decoder = new lUe();
    }
    return t.prototype.getDecoder = function() {
      return this.decoder;
    }, t.prototype.decode = function(e, n) {
      var r, i;
      if (n != null && n.get(Ui.PURE_BARCODE) !== void 0) {
        var a = t.extractPureBits(e.getBlackMatrix());
        r = this.decoder.decodeBitMatrix(a, n), i = t.NO_POINTS;
      } else {
        var s = new vUe(e.getBlackMatrix()).detect(n);
        r = this.decoder.decodeBitMatrix(s.getBits(), n), i = s.getPoints();
      }
      r.getOther() instanceof Oee && r.getOther().applyMirroredCorrection(i);
      var c = new ts(r.getText(), r.getRawBytes(), void 0, i, Ht.QR_CODE, void 0), d = r.getByteSegments();
      d !== null && c.putMetadata(jo.BYTE_SEGMENTS, d);
      var f = r.getECLevel();
      return f !== null && c.putMetadata(jo.ERROR_CORRECTION_LEVEL, f), r.hasStructuredAppend() && (c.putMetadata(jo.STRUCTURED_APPEND_SEQUENCE, r.getStructuredAppendSequenceNumber()), c.putMetadata(jo.STRUCTURED_APPEND_PARITY, r.getStructuredAppendParity())), c;
    }, t.prototype.reset = function() {
    }, t.extractPureBits = function(e) {
      var n = e.getTopLeftOnBit(), r = e.getBottomRightOnBit();
      if (n === null || r === null)
        throw new Ye();
      var i = this.moduleSize(n, e), a = n[1], s = r[1], c = n[0], d = r[0];
      if (c >= d || a >= s)
        throw new Ye();
      if (s - a !== d - c && (d = c + (s - a), d >= e.getWidth()))
        throw new Ye();
      var f = Math.round((d - c + 1) / i), g = Math.round((s - a + 1) / i);
      if (f <= 0 || g <= 0)
        throw new Ye();
      if (g !== f)
        throw new Ye();
      var m = (
        /*(int) */
        Math.floor(i / 2)
      );
      a += m, c += m;
      var b = c + /*(int) */
      Math.floor((f - 1) * i) - d;
      if (b > 0) {
        if (b > m)
          throw new Ye();
        c -= b;
      }
      var w = a + /*(int) */
      Math.floor((g - 1) * i) - s;
      if (w > 0) {
        if (w > m)
          throw new Ye();
        a -= w;
      }
      for (var _ = new sf(f, g), A = 0; A < g; A++)
        for (var T = a + /*(int) */
        Math.floor(A * i), O = 0; O < f; O++)
          e.get(c + /*(int) */
          Math.floor(O * i), T) && _.set(O, A);
      return _;
    }, t.moduleSize = function(e, n) {
      for (var r = n.getHeight(), i = n.getWidth(), a = e[0], s = e[1], c = !0, d = 0; a < i && s < r; ) {
        if (c !== n.get(a, s)) {
          if (++d === 5)
            break;
          c = !c;
        }
        a++, s++;
      }
      if (a === i || s === r)
        throw new Ye();
      return (a - e[0]) / 7;
    }, t.NO_POINTS = new Array(), t;
  }()
), yUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, dr = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.PDF417Common = function() {
    }, t.getBitCountSum = function(e) {
      return gr.sum(e);
    }, t.toIntArray = function(e) {
      var n, r;
      if (e == null || !e.length)
        return t.EMPTY_INT_ARRAY;
      var i = new Int32Array(e.length), a = 0;
      try {
        for (var s = yUe(e), c = s.next(); !c.done; c = s.next()) {
          var d = c.value;
          i[a++] = d;
        }
      } catch (f) {
        n = { error: f };
      } finally {
        try {
          c && !c.done && (r = s.return) && r.call(s);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return i;
    }, t.getCodeword = function(e) {
      var n = qa.binarySearch(t.SYMBOL_TABLE, e & 262143);
      return n < 0 ? -1 : (t.CODEWORD_TABLE[n] - 1) % t.NUMBER_OF_CODEWORDS;
    }, t.NUMBER_OF_CODEWORDS = 929, t.MAX_CODEWORDS_IN_BARCODE = t.NUMBER_OF_CODEWORDS - 1, t.MIN_ROWS_IN_BARCODE = 3, t.MAX_ROWS_IN_BARCODE = 90, t.MODULES_IN_CODEWORD = 17, t.MODULES_IN_STOP_PATTERN = 18, t.BARS_IN_MODULE = 8, t.EMPTY_INT_ARRAY = new Int32Array([]), t.SYMBOL_TABLE = Int32Array.from([
      66142,
      66170,
      66206,
      66236,
      66290,
      66292,
      66350,
      66382,
      66396,
      66454,
      66470,
      66476,
      66594,
      66600,
      66614,
      66626,
      66628,
      66632,
      66640,
      66654,
      66662,
      66668,
      66682,
      66690,
      66718,
      66720,
      66748,
      66758,
      66776,
      66798,
      66802,
      66804,
      66820,
      66824,
      66832,
      66846,
      66848,
      66876,
      66880,
      66936,
      66950,
      66956,
      66968,
      66992,
      67006,
      67022,
      67036,
      67042,
      67044,
      67048,
      67062,
      67118,
      67150,
      67164,
      67214,
      67228,
      67256,
      67294,
      67322,
      67350,
      67366,
      67372,
      67398,
      67404,
      67416,
      67438,
      67474,
      67476,
      67490,
      67492,
      67496,
      67510,
      67618,
      67624,
      67650,
      67656,
      67664,
      67678,
      67686,
      67692,
      67706,
      67714,
      67716,
      67728,
      67742,
      67744,
      67772,
      67782,
      67788,
      67800,
      67822,
      67826,
      67828,
      67842,
      67848,
      67870,
      67872,
      67900,
      67904,
      67960,
      67974,
      67992,
      68016,
      68030,
      68046,
      68060,
      68066,
      68068,
      68072,
      68086,
      68104,
      68112,
      68126,
      68128,
      68156,
      68160,
      68216,
      68336,
      68358,
      68364,
      68376,
      68400,
      68414,
      68448,
      68476,
      68494,
      68508,
      68536,
      68546,
      68548,
      68552,
      68560,
      68574,
      68582,
      68588,
      68654,
      68686,
      68700,
      68706,
      68708,
      68712,
      68726,
      68750,
      68764,
      68792,
      68802,
      68804,
      68808,
      68816,
      68830,
      68838,
      68844,
      68858,
      68878,
      68892,
      68920,
      68976,
      68990,
      68994,
      68996,
      69e3,
      69008,
      69022,
      69024,
      69052,
      69062,
      69068,
      69080,
      69102,
      69106,
      69108,
      69142,
      69158,
      69164,
      69190,
      69208,
      69230,
      69254,
      69260,
      69272,
      69296,
      69310,
      69326,
      69340,
      69386,
      69394,
      69396,
      69410,
      69416,
      69430,
      69442,
      69444,
      69448,
      69456,
      69470,
      69478,
      69484,
      69554,
      69556,
      69666,
      69672,
      69698,
      69704,
      69712,
      69726,
      69754,
      69762,
      69764,
      69776,
      69790,
      69792,
      69820,
      69830,
      69836,
      69848,
      69870,
      69874,
      69876,
      69890,
      69918,
      69920,
      69948,
      69952,
      70008,
      70022,
      70040,
      70064,
      70078,
      70094,
      70108,
      70114,
      70116,
      70120,
      70134,
      70152,
      70174,
      70176,
      70264,
      70384,
      70412,
      70448,
      70462,
      70496,
      70524,
      70542,
      70556,
      70584,
      70594,
      70600,
      70608,
      70622,
      70630,
      70636,
      70664,
      70672,
      70686,
      70688,
      70716,
      70720,
      70776,
      70896,
      71136,
      71180,
      71192,
      71216,
      71230,
      71264,
      71292,
      71360,
      71416,
      71452,
      71480,
      71536,
      71550,
      71554,
      71556,
      71560,
      71568,
      71582,
      71584,
      71612,
      71622,
      71628,
      71640,
      71662,
      71726,
      71732,
      71758,
      71772,
      71778,
      71780,
      71784,
      71798,
      71822,
      71836,
      71864,
      71874,
      71880,
      71888,
      71902,
      71910,
      71916,
      71930,
      71950,
      71964,
      71992,
      72048,
      72062,
      72066,
      72068,
      72080,
      72094,
      72096,
      72124,
      72134,
      72140,
      72152,
      72174,
      72178,
      72180,
      72206,
      72220,
      72248,
      72304,
      72318,
      72416,
      72444,
      72456,
      72464,
      72478,
      72480,
      72508,
      72512,
      72568,
      72588,
      72600,
      72624,
      72638,
      72654,
      72668,
      72674,
      72676,
      72680,
      72694,
      72726,
      72742,
      72748,
      72774,
      72780,
      72792,
      72814,
      72838,
      72856,
      72880,
      72894,
      72910,
      72924,
      72930,
      72932,
      72936,
      72950,
      72966,
      72972,
      72984,
      73008,
      73022,
      73056,
      73084,
      73102,
      73116,
      73144,
      73156,
      73160,
      73168,
      73182,
      73190,
      73196,
      73210,
      73226,
      73234,
      73236,
      73250,
      73252,
      73256,
      73270,
      73282,
      73284,
      73296,
      73310,
      73318,
      73324,
      73346,
      73348,
      73352,
      73360,
      73374,
      73376,
      73404,
      73414,
      73420,
      73432,
      73454,
      73498,
      73518,
      73522,
      73524,
      73550,
      73564,
      73570,
      73572,
      73576,
      73590,
      73800,
      73822,
      73858,
      73860,
      73872,
      73886,
      73888,
      73916,
      73944,
      73970,
      73972,
      73992,
      74014,
      74016,
      74044,
      74048,
      74104,
      74118,
      74136,
      74160,
      74174,
      74210,
      74212,
      74216,
      74230,
      74244,
      74256,
      74270,
      74272,
      74360,
      74480,
      74502,
      74508,
      74544,
      74558,
      74592,
      74620,
      74638,
      74652,
      74680,
      74690,
      74696,
      74704,
      74726,
      74732,
      74782,
      74784,
      74812,
      74992,
      75232,
      75288,
      75326,
      75360,
      75388,
      75456,
      75512,
      75576,
      75632,
      75646,
      75650,
      75652,
      75664,
      75678,
      75680,
      75708,
      75718,
      75724,
      75736,
      75758,
      75808,
      75836,
      75840,
      75896,
      76016,
      76256,
      76736,
      76824,
      76848,
      76862,
      76896,
      76924,
      76992,
      77048,
      77296,
      77340,
      77368,
      77424,
      77438,
      77536,
      77564,
      77572,
      77576,
      77584,
      77600,
      77628,
      77632,
      77688,
      77702,
      77708,
      77720,
      77744,
      77758,
      77774,
      77788,
      77870,
      77902,
      77916,
      77922,
      77928,
      77966,
      77980,
      78008,
      78018,
      78024,
      78032,
      78046,
      78060,
      78074,
      78094,
      78136,
      78192,
      78206,
      78210,
      78212,
      78224,
      78238,
      78240,
      78268,
      78278,
      78284,
      78296,
      78322,
      78324,
      78350,
      78364,
      78448,
      78462,
      78560,
      78588,
      78600,
      78622,
      78624,
      78652,
      78656,
      78712,
      78726,
      78744,
      78768,
      78782,
      78798,
      78812,
      78818,
      78820,
      78824,
      78838,
      78862,
      78876,
      78904,
      78960,
      78974,
      79072,
      79100,
      79296,
      79352,
      79368,
      79376,
      79390,
      79392,
      79420,
      79424,
      79480,
      79600,
      79628,
      79640,
      79664,
      79678,
      79712,
      79740,
      79772,
      79800,
      79810,
      79812,
      79816,
      79824,
      79838,
      79846,
      79852,
      79894,
      79910,
      79916,
      79942,
      79948,
      79960,
      79982,
      79988,
      80006,
      80024,
      80048,
      80062,
      80078,
      80092,
      80098,
      80100,
      80104,
      80134,
      80140,
      80176,
      80190,
      80224,
      80252,
      80270,
      80284,
      80312,
      80328,
      80336,
      80350,
      80358,
      80364,
      80378,
      80390,
      80396,
      80408,
      80432,
      80446,
      80480,
      80508,
      80576,
      80632,
      80654,
      80668,
      80696,
      80752,
      80766,
      80776,
      80784,
      80798,
      80800,
      80828,
      80844,
      80856,
      80878,
      80882,
      80884,
      80914,
      80916,
      80930,
      80932,
      80936,
      80950,
      80962,
      80968,
      80976,
      80990,
      80998,
      81004,
      81026,
      81028,
      81040,
      81054,
      81056,
      81084,
      81094,
      81100,
      81112,
      81134,
      81154,
      81156,
      81160,
      81168,
      81182,
      81184,
      81212,
      81216,
      81272,
      81286,
      81292,
      81304,
      81328,
      81342,
      81358,
      81372,
      81380,
      81384,
      81398,
      81434,
      81454,
      81458,
      81460,
      81486,
      81500,
      81506,
      81508,
      81512,
      81526,
      81550,
      81564,
      81592,
      81602,
      81604,
      81608,
      81616,
      81630,
      81638,
      81644,
      81702,
      81708,
      81722,
      81734,
      81740,
      81752,
      81774,
      81778,
      81780,
      82050,
      82078,
      82080,
      82108,
      82180,
      82184,
      82192,
      82206,
      82208,
      82236,
      82240,
      82296,
      82316,
      82328,
      82352,
      82366,
      82402,
      82404,
      82408,
      82440,
      82448,
      82462,
      82464,
      82492,
      82496,
      82552,
      82672,
      82694,
      82700,
      82712,
      82736,
      82750,
      82784,
      82812,
      82830,
      82882,
      82884,
      82888,
      82896,
      82918,
      82924,
      82952,
      82960,
      82974,
      82976,
      83004,
      83008,
      83064,
      83184,
      83424,
      83468,
      83480,
      83504,
      83518,
      83552,
      83580,
      83648,
      83704,
      83740,
      83768,
      83824,
      83838,
      83842,
      83844,
      83848,
      83856,
      83872,
      83900,
      83910,
      83916,
      83928,
      83950,
      83984,
      84e3,
      84028,
      84032,
      84088,
      84208,
      84448,
      84928,
      85040,
      85054,
      85088,
      85116,
      85184,
      85240,
      85488,
      85560,
      85616,
      85630,
      85728,
      85756,
      85764,
      85768,
      85776,
      85790,
      85792,
      85820,
      85824,
      85880,
      85894,
      85900,
      85912,
      85936,
      85966,
      85980,
      86048,
      86080,
      86136,
      86256,
      86496,
      86976,
      88160,
      88188,
      88256,
      88312,
      88560,
      89056,
      89200,
      89214,
      89312,
      89340,
      89536,
      89592,
      89608,
      89616,
      89632,
      89664,
      89720,
      89840,
      89868,
      89880,
      89904,
      89952,
      89980,
      89998,
      90012,
      90040,
      90190,
      90204,
      90254,
      90268,
      90296,
      90306,
      90308,
      90312,
      90334,
      90382,
      90396,
      90424,
      90480,
      90494,
      90500,
      90504,
      90512,
      90526,
      90528,
      90556,
      90566,
      90572,
      90584,
      90610,
      90612,
      90638,
      90652,
      90680,
      90736,
      90750,
      90848,
      90876,
      90884,
      90888,
      90896,
      90910,
      90912,
      90940,
      90944,
      91e3,
      91014,
      91020,
      91032,
      91056,
      91070,
      91086,
      91100,
      91106,
      91108,
      91112,
      91126,
      91150,
      91164,
      91192,
      91248,
      91262,
      91360,
      91388,
      91584,
      91640,
      91664,
      91678,
      91680,
      91708,
      91712,
      91768,
      91888,
      91928,
      91952,
      91966,
      92e3,
      92028,
      92046,
      92060,
      92088,
      92098,
      92100,
      92104,
      92112,
      92126,
      92134,
      92140,
      92188,
      92216,
      92272,
      92384,
      92412,
      92608,
      92664,
      93168,
      93200,
      93214,
      93216,
      93244,
      93248,
      93304,
      93424,
      93664,
      93720,
      93744,
      93758,
      93792,
      93820,
      93888,
      93944,
      93980,
      94008,
      94064,
      94078,
      94084,
      94088,
      94096,
      94110,
      94112,
      94140,
      94150,
      94156,
      94168,
      94246,
      94252,
      94278,
      94284,
      94296,
      94318,
      94342,
      94348,
      94360,
      94384,
      94398,
      94414,
      94428,
      94440,
      94470,
      94476,
      94488,
      94512,
      94526,
      94560,
      94588,
      94606,
      94620,
      94648,
      94658,
      94660,
      94664,
      94672,
      94686,
      94694,
      94700,
      94714,
      94726,
      94732,
      94744,
      94768,
      94782,
      94816,
      94844,
      94912,
      94968,
      94990,
      95004,
      95032,
      95088,
      95102,
      95112,
      95120,
      95134,
      95136,
      95164,
      95180,
      95192,
      95214,
      95218,
      95220,
      95244,
      95256,
      95280,
      95294,
      95328,
      95356,
      95424,
      95480,
      95728,
      95758,
      95772,
      95800,
      95856,
      95870,
      95968,
      95996,
      96008,
      96016,
      96030,
      96032,
      96060,
      96064,
      96120,
      96152,
      96176,
      96190,
      96220,
      96226,
      96228,
      96232,
      96290,
      96292,
      96296,
      96310,
      96322,
      96324,
      96328,
      96336,
      96350,
      96358,
      96364,
      96386,
      96388,
      96392,
      96400,
      96414,
      96416,
      96444,
      96454,
      96460,
      96472,
      96494,
      96498,
      96500,
      96514,
      96516,
      96520,
      96528,
      96542,
      96544,
      96572,
      96576,
      96632,
      96646,
      96652,
      96664,
      96688,
      96702,
      96718,
      96732,
      96738,
      96740,
      96744,
      96758,
      96772,
      96776,
      96784,
      96798,
      96800,
      96828,
      96832,
      96888,
      97008,
      97030,
      97036,
      97048,
      97072,
      97086,
      97120,
      97148,
      97166,
      97180,
      97208,
      97220,
      97224,
      97232,
      97246,
      97254,
      97260,
      97326,
      97330,
      97332,
      97358,
      97372,
      97378,
      97380,
      97384,
      97398,
      97422,
      97436,
      97464,
      97474,
      97476,
      97480,
      97488,
      97502,
      97510,
      97516,
      97550,
      97564,
      97592,
      97648,
      97666,
      97668,
      97672,
      97680,
      97694,
      97696,
      97724,
      97734,
      97740,
      97752,
      97774,
      97830,
      97836,
      97850,
      97862,
      97868,
      97880,
      97902,
      97906,
      97908,
      97926,
      97932,
      97944,
      97968,
      97998,
      98012,
      98018,
      98020,
      98024,
      98038,
      98618,
      98674,
      98676,
      98838,
      98854,
      98874,
      98892,
      98904,
      98926,
      98930,
      98932,
      98968,
      99006,
      99042,
      99044,
      99048,
      99062,
      99166,
      99194,
      99246,
      99286,
      99350,
      99366,
      99372,
      99386,
      99398,
      99416,
      99438,
      99442,
      99444,
      99462,
      99504,
      99518,
      99534,
      99548,
      99554,
      99556,
      99560,
      99574,
      99590,
      99596,
      99608,
      99632,
      99646,
      99680,
      99708,
      99726,
      99740,
      99768,
      99778,
      99780,
      99784,
      99792,
      99806,
      99814,
      99820,
      99834,
      99858,
      99860,
      99874,
      99880,
      99894,
      99906,
      99920,
      99934,
      99962,
      99970,
      99972,
      99976,
      99984,
      99998,
      1e5,
      100028,
      100038,
      100044,
      100056,
      100078,
      100082,
      100084,
      100142,
      100174,
      100188,
      100246,
      100262,
      100268,
      100306,
      100308,
      100390,
      100396,
      100410,
      100422,
      100428,
      100440,
      100462,
      100466,
      100468,
      100486,
      100504,
      100528,
      100542,
      100558,
      100572,
      100578,
      100580,
      100584,
      100598,
      100620,
      100656,
      100670,
      100704,
      100732,
      100750,
      100792,
      100802,
      100808,
      100816,
      100830,
      100838,
      100844,
      100858,
      100888,
      100912,
      100926,
      100960,
      100988,
      101056,
      101112,
      101148,
      101176,
      101232,
      101246,
      101250,
      101252,
      101256,
      101264,
      101278,
      101280,
      101308,
      101318,
      101324,
      101336,
      101358,
      101362,
      101364,
      101410,
      101412,
      101416,
      101430,
      101442,
      101448,
      101456,
      101470,
      101478,
      101498,
      101506,
      101508,
      101520,
      101534,
      101536,
      101564,
      101580,
      101618,
      101620,
      101636,
      101640,
      101648,
      101662,
      101664,
      101692,
      101696,
      101752,
      101766,
      101784,
      101838,
      101858,
      101860,
      101864,
      101934,
      101938,
      101940,
      101966,
      101980,
      101986,
      101988,
      101992,
      102030,
      102044,
      102072,
      102082,
      102084,
      102088,
      102096,
      102138,
      102166,
      102182,
      102188,
      102214,
      102220,
      102232,
      102254,
      102282,
      102290,
      102292,
      102306,
      102308,
      102312,
      102326,
      102444,
      102458,
      102470,
      102476,
      102488,
      102514,
      102516,
      102534,
      102552,
      102576,
      102590,
      102606,
      102620,
      102626,
      102632,
      102646,
      102662,
      102668,
      102704,
      102718,
      102752,
      102780,
      102798,
      102812,
      102840,
      102850,
      102856,
      102864,
      102878,
      102886,
      102892,
      102906,
      102936,
      102974,
      103008,
      103036,
      103104,
      103160,
      103224,
      103280,
      103294,
      103298,
      103300,
      103312,
      103326,
      103328,
      103356,
      103366,
      103372,
      103384,
      103406,
      103410,
      103412,
      103472,
      103486,
      103520,
      103548,
      103616,
      103672,
      103920,
      103992,
      104048,
      104062,
      104160,
      104188,
      104194,
      104196,
      104200,
      104208,
      104224,
      104252,
      104256,
      104312,
      104326,
      104332,
      104344,
      104368,
      104382,
      104398,
      104412,
      104418,
      104420,
      104424,
      104482,
      104484,
      104514,
      104520,
      104528,
      104542,
      104550,
      104570,
      104578,
      104580,
      104592,
      104606,
      104608,
      104636,
      104652,
      104690,
      104692,
      104706,
      104712,
      104734,
      104736,
      104764,
      104768,
      104824,
      104838,
      104856,
      104910,
      104930,
      104932,
      104936,
      104968,
      104976,
      104990,
      104992,
      105020,
      105024,
      105080,
      105200,
      105240,
      105278,
      105312,
      105372,
      105410,
      105412,
      105416,
      105424,
      105446,
      105518,
      105524,
      105550,
      105564,
      105570,
      105572,
      105576,
      105614,
      105628,
      105656,
      105666,
      105672,
      105680,
      105702,
      105722,
      105742,
      105756,
      105784,
      105840,
      105854,
      105858,
      105860,
      105864,
      105872,
      105888,
      105932,
      105970,
      105972,
      106006,
      106022,
      106028,
      106054,
      106060,
      106072,
      106100,
      106118,
      106124,
      106136,
      106160,
      106174,
      106190,
      106210,
      106212,
      106216,
      106250,
      106258,
      106260,
      106274,
      106276,
      106280,
      106306,
      106308,
      106312,
      106320,
      106334,
      106348,
      106394,
      106414,
      106418,
      106420,
      106566,
      106572,
      106610,
      106612,
      106630,
      106636,
      106648,
      106672,
      106686,
      106722,
      106724,
      106728,
      106742,
      106758,
      106764,
      106776,
      106800,
      106814,
      106848,
      106876,
      106894,
      106908,
      106936,
      106946,
      106948,
      106952,
      106960,
      106974,
      106982,
      106988,
      107032,
      107056,
      107070,
      107104,
      107132,
      107200,
      107256,
      107292,
      107320,
      107376,
      107390,
      107394,
      107396,
      107400,
      107408,
      107422,
      107424,
      107452,
      107462,
      107468,
      107480,
      107502,
      107506,
      107508,
      107544,
      107568,
      107582,
      107616,
      107644,
      107712,
      107768,
      108016,
      108060,
      108088,
      108144,
      108158,
      108256,
      108284,
      108290,
      108292,
      108296,
      108304,
      108318,
      108320,
      108348,
      108352,
      108408,
      108422,
      108428,
      108440,
      108464,
      108478,
      108494,
      108508,
      108514,
      108516,
      108520,
      108592,
      108640,
      108668,
      108736,
      108792,
      109040,
      109536,
      109680,
      109694,
      109792,
      109820,
      110016,
      110072,
      110084,
      110088,
      110096,
      110112,
      110140,
      110144,
      110200,
      110320,
      110342,
      110348,
      110360,
      110384,
      110398,
      110432,
      110460,
      110478,
      110492,
      110520,
      110532,
      110536,
      110544,
      110558,
      110658,
      110686,
      110714,
      110722,
      110724,
      110728,
      110736,
      110750,
      110752,
      110780,
      110796,
      110834,
      110836,
      110850,
      110852,
      110856,
      110864,
      110878,
      110880,
      110908,
      110912,
      110968,
      110982,
      111e3,
      111054,
      111074,
      111076,
      111080,
      111108,
      111112,
      111120,
      111134,
      111136,
      111164,
      111168,
      111224,
      111344,
      111372,
      111422,
      111456,
      111516,
      111554,
      111556,
      111560,
      111568,
      111590,
      111632,
      111646,
      111648,
      111676,
      111680,
      111736,
      111856,
      112096,
      112152,
      112224,
      112252,
      112320,
      112440,
      112514,
      112516,
      112520,
      112528,
      112542,
      112544,
      112588,
      112686,
      112718,
      112732,
      112782,
      112796,
      112824,
      112834,
      112836,
      112840,
      112848,
      112870,
      112890,
      112910,
      112924,
      112952,
      113008,
      113022,
      113026,
      113028,
      113032,
      113040,
      113054,
      113056,
      113100,
      113138,
      113140,
      113166,
      113180,
      113208,
      113264,
      113278,
      113376,
      113404,
      113416,
      113424,
      113440,
      113468,
      113472,
      113560,
      113614,
      113634,
      113636,
      113640,
      113686,
      113702,
      113708,
      113734,
      113740,
      113752,
      113778,
      113780,
      113798,
      113804,
      113816,
      113840,
      113854,
      113870,
      113890,
      113892,
      113896,
      113926,
      113932,
      113944,
      113968,
      113982,
      114016,
      114044,
      114076,
      114114,
      114116,
      114120,
      114128,
      114150,
      114170,
      114194,
      114196,
      114210,
      114212,
      114216,
      114242,
      114244,
      114248,
      114256,
      114270,
      114278,
      114306,
      114308,
      114312,
      114320,
      114334,
      114336,
      114364,
      114380,
      114420,
      114458,
      114478,
      114482,
      114484,
      114510,
      114524,
      114530,
      114532,
      114536,
      114842,
      114866,
      114868,
      114970,
      114994,
      114996,
      115042,
      115044,
      115048,
      115062,
      115130,
      115226,
      115250,
      115252,
      115278,
      115292,
      115298,
      115300,
      115304,
      115318,
      115342,
      115394,
      115396,
      115400,
      115408,
      115422,
      115430,
      115436,
      115450,
      115478,
      115494,
      115514,
      115526,
      115532,
      115570,
      115572,
      115738,
      115758,
      115762,
      115764,
      115790,
      115804,
      115810,
      115812,
      115816,
      115830,
      115854,
      115868,
      115896,
      115906,
      115912,
      115920,
      115934,
      115942,
      115948,
      115962,
      115996,
      116024,
      116080,
      116094,
      116098,
      116100,
      116104,
      116112,
      116126,
      116128,
      116156,
      116166,
      116172,
      116184,
      116206,
      116210,
      116212,
      116246,
      116262,
      116268,
      116282,
      116294,
      116300,
      116312,
      116334,
      116338,
      116340,
      116358,
      116364,
      116376,
      116400,
      116414,
      116430,
      116444,
      116450,
      116452,
      116456,
      116498,
      116500,
      116514,
      116520,
      116534,
      116546,
      116548,
      116552,
      116560,
      116574,
      116582,
      116588,
      116602,
      116654,
      116694,
      116714,
      116762,
      116782,
      116786,
      116788,
      116814,
      116828,
      116834,
      116836,
      116840,
      116854,
      116878,
      116892,
      116920,
      116930,
      116936,
      116944,
      116958,
      116966,
      116972,
      116986,
      117006,
      117048,
      117104,
      117118,
      117122,
      117124,
      117136,
      117150,
      117152,
      117180,
      117190,
      117196,
      117208,
      117230,
      117234,
      117236,
      117304,
      117360,
      117374,
      117472,
      117500,
      117506,
      117508,
      117512,
      117520,
      117536,
      117564,
      117568,
      117624,
      117638,
      117644,
      117656,
      117680,
      117694,
      117710,
      117724,
      117730,
      117732,
      117736,
      117750,
      117782,
      117798,
      117804,
      117818,
      117830,
      117848,
      117874,
      117876,
      117894,
      117936,
      117950,
      117966,
      117986,
      117988,
      117992,
      118022,
      118028,
      118040,
      118064,
      118078,
      118112,
      118140,
      118172,
      118210,
      118212,
      118216,
      118224,
      118238,
      118246,
      118266,
      118306,
      118312,
      118338,
      118352,
      118366,
      118374,
      118394,
      118402,
      118404,
      118408,
      118416,
      118430,
      118432,
      118460,
      118476,
      118514,
      118516,
      118574,
      118578,
      118580,
      118606,
      118620,
      118626,
      118628,
      118632,
      118678,
      118694,
      118700,
      118730,
      118738,
      118740,
      118830,
      118834,
      118836,
      118862,
      118876,
      118882,
      118884,
      118888,
      118902,
      118926,
      118940,
      118968,
      118978,
      118980,
      118984,
      118992,
      119006,
      119014,
      119020,
      119034,
      119068,
      119096,
      119152,
      119166,
      119170,
      119172,
      119176,
      119184,
      119198,
      119200,
      119228,
      119238,
      119244,
      119256,
      119278,
      119282,
      119284,
      119324,
      119352,
      119408,
      119422,
      119520,
      119548,
      119554,
      119556,
      119560,
      119568,
      119582,
      119584,
      119612,
      119616,
      119672,
      119686,
      119692,
      119704,
      119728,
      119742,
      119758,
      119772,
      119778,
      119780,
      119784,
      119798,
      119920,
      119934,
      120032,
      120060,
      120256,
      120312,
      120324,
      120328,
      120336,
      120352,
      120384,
      120440,
      120560,
      120582,
      120588,
      120600,
      120624,
      120638,
      120672,
      120700,
      120718,
      120732,
      120760,
      120770,
      120772,
      120776,
      120784,
      120798,
      120806,
      120812,
      120870,
      120876,
      120890,
      120902,
      120908,
      120920,
      120946,
      120948,
      120966,
      120972,
      120984,
      121008,
      121022,
      121038,
      121058,
      121060,
      121064,
      121078,
      121100,
      121112,
      121136,
      121150,
      121184,
      121212,
      121244,
      121282,
      121284,
      121288,
      121296,
      121318,
      121338,
      121356,
      121368,
      121392,
      121406,
      121440,
      121468,
      121536,
      121592,
      121656,
      121730,
      121732,
      121736,
      121744,
      121758,
      121760,
      121804,
      121842,
      121844,
      121890,
      121922,
      121924,
      121928,
      121936,
      121950,
      121958,
      121978,
      121986,
      121988,
      121992,
      122e3,
      122014,
      122016,
      122044,
      122060,
      122098,
      122100,
      122116,
      122120,
      122128,
      122142,
      122144,
      122172,
      122176,
      122232,
      122246,
      122264,
      122318,
      122338,
      122340,
      122344,
      122414,
      122418,
      122420,
      122446,
      122460,
      122466,
      122468,
      122472,
      122510,
      122524,
      122552,
      122562,
      122564,
      122568,
      122576,
      122598,
      122618,
      122646,
      122662,
      122668,
      122694,
      122700,
      122712,
      122738,
      122740,
      122762,
      122770,
      122772,
      122786,
      122788,
      122792,
      123018,
      123026,
      123028,
      123042,
      123044,
      123048,
      123062,
      123098,
      123146,
      123154,
      123156,
      123170,
      123172,
      123176,
      123190,
      123202,
      123204,
      123208,
      123216,
      123238,
      123244,
      123258,
      123290,
      123314,
      123316,
      123402,
      123410,
      123412,
      123426,
      123428,
      123432,
      123446,
      123458,
      123464,
      123472,
      123486,
      123494,
      123500,
      123514,
      123522,
      123524,
      123528,
      123536,
      123552,
      123580,
      123590,
      123596,
      123608,
      123630,
      123634,
      123636,
      123674,
      123698,
      123700,
      123740,
      123746,
      123748,
      123752,
      123834,
      123914,
      123922,
      123924,
      123938,
      123944,
      123958,
      123970,
      123976,
      123984,
      123998,
      124006,
      124012,
      124026,
      124034,
      124036,
      124048,
      124062,
      124064,
      124092,
      124102,
      124108,
      124120,
      124142,
      124146,
      124148,
      124162,
      124164,
      124168,
      124176,
      124190,
      124192,
      124220,
      124224,
      124280,
      124294,
      124300,
      124312,
      124336,
      124350,
      124366,
      124380,
      124386,
      124388,
      124392,
      124406,
      124442,
      124462,
      124466,
      124468,
      124494,
      124508,
      124514,
      124520,
      124558,
      124572,
      124600,
      124610,
      124612,
      124616,
      124624,
      124646,
      124666,
      124694,
      124710,
      124716,
      124730,
      124742,
      124748,
      124760,
      124786,
      124788,
      124818,
      124820,
      124834,
      124836,
      124840,
      124854,
      124946,
      124948,
      124962,
      124964,
      124968,
      124982,
      124994,
      124996,
      125e3,
      125008,
      125022,
      125030,
      125036,
      125050,
      125058,
      125060,
      125064,
      125072,
      125086,
      125088,
      125116,
      125126,
      125132,
      125144,
      125166,
      125170,
      125172,
      125186,
      125188,
      125192,
      125200,
      125216,
      125244,
      125248,
      125304,
      125318,
      125324,
      125336,
      125360,
      125374,
      125390,
      125404,
      125410,
      125412,
      125416,
      125430,
      125444,
      125448,
      125456,
      125472,
      125504,
      125560,
      125680,
      125702,
      125708,
      125720,
      125744,
      125758,
      125792,
      125820,
      125838,
      125852,
      125880,
      125890,
      125892,
      125896,
      125904,
      125918,
      125926,
      125932,
      125978,
      125998,
      126002,
      126004,
      126030,
      126044,
      126050,
      126052,
      126056,
      126094,
      126108,
      126136,
      126146,
      126148,
      126152,
      126160,
      126182,
      126202,
      126222,
      126236,
      126264,
      126320,
      126334,
      126338,
      126340,
      126344,
      126352,
      126366,
      126368,
      126412,
      126450,
      126452,
      126486,
      126502,
      126508,
      126522,
      126534,
      126540,
      126552,
      126574,
      126578,
      126580,
      126598,
      126604,
      126616,
      126640,
      126654,
      126670,
      126684,
      126690,
      126692,
      126696,
      126738,
      126754,
      126756,
      126760,
      126774,
      126786,
      126788,
      126792,
      126800,
      126814,
      126822,
      126828,
      126842,
      126894,
      126898,
      126900,
      126934,
      127126,
      127142,
      127148,
      127162,
      127178,
      127186,
      127188,
      127254,
      127270,
      127276,
      127290,
      127302,
      127308,
      127320,
      127342,
      127346,
      127348,
      127370,
      127378,
      127380,
      127394,
      127396,
      127400,
      127450,
      127510,
      127526,
      127532,
      127546,
      127558,
      127576,
      127598,
      127602,
      127604,
      127622,
      127628,
      127640,
      127664,
      127678,
      127694,
      127708,
      127714,
      127716,
      127720,
      127734,
      127754,
      127762,
      127764,
      127778,
      127784,
      127810,
      127812,
      127816,
      127824,
      127838,
      127846,
      127866,
      127898,
      127918,
      127922,
      127924,
      128022,
      128038,
      128044,
      128058,
      128070,
      128076,
      128088,
      128110,
      128114,
      128116,
      128134,
      128140,
      128152,
      128176,
      128190,
      128206,
      128220,
      128226,
      128228,
      128232,
      128246,
      128262,
      128268,
      128280,
      128304,
      128318,
      128352,
      128380,
      128398,
      128412,
      128440,
      128450,
      128452,
      128456,
      128464,
      128478,
      128486,
      128492,
      128506,
      128522,
      128530,
      128532,
      128546,
      128548,
      128552,
      128566,
      128578,
      128580,
      128584,
      128592,
      128606,
      128614,
      128634,
      128642,
      128644,
      128648,
      128656,
      128670,
      128672,
      128700,
      128716,
      128754,
      128756,
      128794,
      128814,
      128818,
      128820,
      128846,
      128860,
      128866,
      128868,
      128872,
      128886,
      128918,
      128934,
      128940,
      128954,
      128978,
      128980,
      129178,
      129198,
      129202,
      129204,
      129238,
      129258,
      129306,
      129326,
      129330,
      129332,
      129358,
      129372,
      129378,
      129380,
      129384,
      129398,
      129430,
      129446,
      129452,
      129466,
      129482,
      129490,
      129492,
      129562,
      129582,
      129586,
      129588,
      129614,
      129628,
      129634,
      129636,
      129640,
      129654,
      129678,
      129692,
      129720,
      129730,
      129732,
      129736,
      129744,
      129758,
      129766,
      129772,
      129814,
      129830,
      129836,
      129850,
      129862,
      129868,
      129880,
      129902,
      129906,
      129908,
      129930,
      129938,
      129940,
      129954,
      129956,
      129960,
      129974,
      130010
    ]), t.CODEWORD_TABLE = Int32Array.from([
      2627,
      1819,
      2622,
      2621,
      1813,
      1812,
      2729,
      2724,
      2723,
      2779,
      2774,
      2773,
      902,
      896,
      908,
      868,
      865,
      861,
      859,
      2511,
      873,
      871,
      1780,
      835,
      2493,
      825,
      2491,
      842,
      837,
      844,
      1764,
      1762,
      811,
      810,
      809,
      2483,
      807,
      2482,
      806,
      2480,
      815,
      814,
      813,
      812,
      2484,
      817,
      816,
      1745,
      1744,
      1742,
      1746,
      2655,
      2637,
      2635,
      2626,
      2625,
      2623,
      2628,
      1820,
      2752,
      2739,
      2737,
      2728,
      2727,
      2725,
      2730,
      2785,
      2783,
      2778,
      2777,
      2775,
      2780,
      787,
      781,
      747,
      739,
      736,
      2413,
      754,
      752,
      1719,
      692,
      689,
      681,
      2371,
      678,
      2369,
      700,
      697,
      694,
      703,
      1688,
      1686,
      642,
      638,
      2343,
      631,
      2341,
      627,
      2338,
      651,
      646,
      643,
      2345,
      654,
      652,
      1652,
      1650,
      1647,
      1654,
      601,
      599,
      2322,
      596,
      2321,
      594,
      2319,
      2317,
      611,
      610,
      608,
      606,
      2324,
      603,
      2323,
      615,
      614,
      612,
      1617,
      1616,
      1614,
      1612,
      616,
      1619,
      1618,
      2575,
      2538,
      2536,
      905,
      901,
      898,
      909,
      2509,
      2507,
      2504,
      870,
      867,
      864,
      860,
      2512,
      875,
      872,
      1781,
      2490,
      2489,
      2487,
      2485,
      1748,
      836,
      834,
      832,
      830,
      2494,
      827,
      2492,
      843,
      841,
      839,
      845,
      1765,
      1763,
      2701,
      2676,
      2674,
      2653,
      2648,
      2656,
      2634,
      2633,
      2631,
      2629,
      1821,
      2638,
      2636,
      2770,
      2763,
      2761,
      2750,
      2745,
      2753,
      2736,
      2735,
      2733,
      2731,
      1848,
      2740,
      2738,
      2786,
      2784,
      591,
      588,
      576,
      569,
      566,
      2296,
      1590,
      537,
      534,
      526,
      2276,
      522,
      2274,
      545,
      542,
      539,
      548,
      1572,
      1570,
      481,
      2245,
      466,
      2242,
      462,
      2239,
      492,
      485,
      482,
      2249,
      496,
      494,
      1534,
      1531,
      1528,
      1538,
      413,
      2196,
      406,
      2191,
      2188,
      425,
      419,
      2202,
      415,
      2199,
      432,
      430,
      427,
      1472,
      1467,
      1464,
      433,
      1476,
      1474,
      368,
      367,
      2160,
      365,
      2159,
      362,
      2157,
      2155,
      2152,
      378,
      377,
      375,
      2166,
      372,
      2165,
      369,
      2162,
      383,
      381,
      379,
      2168,
      1419,
      1418,
      1416,
      1414,
      385,
      1411,
      384,
      1423,
      1422,
      1420,
      1424,
      2461,
      802,
      2441,
      2439,
      790,
      786,
      783,
      794,
      2409,
      2406,
      2403,
      750,
      742,
      738,
      2414,
      756,
      753,
      1720,
      2367,
      2365,
      2362,
      2359,
      1663,
      693,
      691,
      684,
      2373,
      680,
      2370,
      702,
      699,
      696,
      704,
      1690,
      1687,
      2337,
      2336,
      2334,
      2332,
      1624,
      2329,
      1622,
      640,
      637,
      2344,
      634,
      2342,
      630,
      2340,
      650,
      648,
      645,
      2346,
      655,
      653,
      1653,
      1651,
      1649,
      1655,
      2612,
      2597,
      2595,
      2571,
      2568,
      2565,
      2576,
      2534,
      2529,
      2526,
      1787,
      2540,
      2537,
      907,
      904,
      900,
      910,
      2503,
      2502,
      2500,
      2498,
      1768,
      2495,
      1767,
      2510,
      2508,
      2506,
      869,
      866,
      863,
      2513,
      876,
      874,
      1782,
      2720,
      2713,
      2711,
      2697,
      2694,
      2691,
      2702,
      2672,
      2670,
      2664,
      1828,
      2678,
      2675,
      2647,
      2646,
      2644,
      2642,
      1823,
      2639,
      1822,
      2654,
      2652,
      2650,
      2657,
      2771,
      1855,
      2765,
      2762,
      1850,
      1849,
      2751,
      2749,
      2747,
      2754,
      353,
      2148,
      344,
      342,
      336,
      2142,
      332,
      2140,
      345,
      1375,
      1373,
      306,
      2130,
      299,
      2128,
      295,
      2125,
      319,
      314,
      311,
      2132,
      1354,
      1352,
      1349,
      1356,
      262,
      257,
      2101,
      253,
      2096,
      2093,
      274,
      273,
      267,
      2107,
      263,
      2104,
      280,
      278,
      275,
      1316,
      1311,
      1308,
      1320,
      1318,
      2052,
      202,
      2050,
      2044,
      2040,
      219,
      2063,
      212,
      2060,
      208,
      2055,
      224,
      221,
      2066,
      1260,
      1258,
      1252,
      231,
      1248,
      229,
      1266,
      1264,
      1261,
      1268,
      155,
      1998,
      153,
      1996,
      1994,
      1991,
      1988,
      165,
      164,
      2007,
      162,
      2006,
      159,
      2003,
      2e3,
      172,
      171,
      169,
      2012,
      166,
      2010,
      1186,
      1184,
      1182,
      1179,
      175,
      1176,
      173,
      1192,
      1191,
      1189,
      1187,
      176,
      1194,
      1193,
      2313,
      2307,
      2305,
      592,
      589,
      2294,
      2292,
      2289,
      578,
      572,
      568,
      2297,
      580,
      1591,
      2272,
      2267,
      2264,
      1547,
      538,
      536,
      529,
      2278,
      525,
      2275,
      547,
      544,
      541,
      1574,
      1571,
      2237,
      2235,
      2229,
      1493,
      2225,
      1489,
      478,
      2247,
      470,
      2244,
      465,
      2241,
      493,
      488,
      484,
      2250,
      498,
      495,
      1536,
      1533,
      1530,
      1539,
      2187,
      2186,
      2184,
      2182,
      1432,
      2179,
      1430,
      2176,
      1427,
      414,
      412,
      2197,
      409,
      2195,
      405,
      2193,
      2190,
      426,
      424,
      421,
      2203,
      418,
      2201,
      431,
      429,
      1473,
      1471,
      1469,
      1466,
      434,
      1477,
      1475,
      2478,
      2472,
      2470,
      2459,
      2457,
      2454,
      2462,
      803,
      2437,
      2432,
      2429,
      1726,
      2443,
      2440,
      792,
      789,
      785,
      2401,
      2399,
      2393,
      1702,
      2389,
      1699,
      2411,
      2408,
      2405,
      745,
      741,
      2415,
      758,
      755,
      1721,
      2358,
      2357,
      2355,
      2353,
      1661,
      2350,
      1660,
      2347,
      1657,
      2368,
      2366,
      2364,
      2361,
      1666,
      690,
      687,
      2374,
      683,
      2372,
      701,
      698,
      705,
      1691,
      1689,
      2619,
      2617,
      2610,
      2608,
      2605,
      2613,
      2593,
      2588,
      2585,
      1803,
      2599,
      2596,
      2563,
      2561,
      2555,
      1797,
      2551,
      1795,
      2573,
      2570,
      2567,
      2577,
      2525,
      2524,
      2522,
      2520,
      1786,
      2517,
      1785,
      2514,
      1783,
      2535,
      2533,
      2531,
      2528,
      1788,
      2541,
      2539,
      906,
      903,
      911,
      2721,
      1844,
      2715,
      2712,
      1838,
      1836,
      2699,
      2696,
      2693,
      2703,
      1827,
      1826,
      1824,
      2673,
      2671,
      2669,
      2666,
      1829,
      2679,
      2677,
      1858,
      1857,
      2772,
      1854,
      1853,
      1851,
      1856,
      2766,
      2764,
      143,
      1987,
      139,
      1986,
      135,
      133,
      131,
      1984,
      128,
      1983,
      125,
      1981,
      138,
      137,
      136,
      1985,
      1133,
      1132,
      1130,
      112,
      110,
      1974,
      107,
      1973,
      104,
      1971,
      1969,
      122,
      121,
      119,
      117,
      1977,
      114,
      1976,
      124,
      1115,
      1114,
      1112,
      1110,
      1117,
      1116,
      84,
      83,
      1953,
      81,
      1952,
      78,
      1950,
      1948,
      1945,
      94,
      93,
      91,
      1959,
      88,
      1958,
      85,
      1955,
      99,
      97,
      95,
      1961,
      1086,
      1085,
      1083,
      1081,
      1078,
      100,
      1090,
      1089,
      1087,
      1091,
      49,
      47,
      1917,
      44,
      1915,
      1913,
      1910,
      1907,
      59,
      1926,
      56,
      1925,
      53,
      1922,
      1919,
      66,
      64,
      1931,
      61,
      1929,
      1042,
      1040,
      1038,
      71,
      1035,
      70,
      1032,
      68,
      1048,
      1047,
      1045,
      1043,
      1050,
      1049,
      12,
      10,
      1869,
      1867,
      1864,
      1861,
      21,
      1880,
      19,
      1877,
      1874,
      1871,
      28,
      1888,
      25,
      1886,
      22,
      1883,
      982,
      980,
      977,
      974,
      32,
      30,
      991,
      989,
      987,
      984,
      34,
      995,
      994,
      992,
      2151,
      2150,
      2147,
      2146,
      2144,
      356,
      355,
      354,
      2149,
      2139,
      2138,
      2136,
      2134,
      1359,
      343,
      341,
      338,
      2143,
      335,
      2141,
      348,
      347,
      346,
      1376,
      1374,
      2124,
      2123,
      2121,
      2119,
      1326,
      2116,
      1324,
      310,
      308,
      305,
      2131,
      302,
      2129,
      298,
      2127,
      320,
      318,
      316,
      313,
      2133,
      322,
      321,
      1355,
      1353,
      1351,
      1357,
      2092,
      2091,
      2089,
      2087,
      1276,
      2084,
      1274,
      2081,
      1271,
      259,
      2102,
      256,
      2100,
      252,
      2098,
      2095,
      272,
      269,
      2108,
      266,
      2106,
      281,
      279,
      277,
      1317,
      1315,
      1313,
      1310,
      282,
      1321,
      1319,
      2039,
      2037,
      2035,
      2032,
      1203,
      2029,
      1200,
      1197,
      207,
      2053,
      205,
      2051,
      201,
      2049,
      2046,
      2043,
      220,
      218,
      2064,
      215,
      2062,
      211,
      2059,
      228,
      226,
      223,
      2069,
      1259,
      1257,
      1254,
      232,
      1251,
      230,
      1267,
      1265,
      1263,
      2316,
      2315,
      2312,
      2311,
      2309,
      2314,
      2304,
      2303,
      2301,
      2299,
      1593,
      2308,
      2306,
      590,
      2288,
      2287,
      2285,
      2283,
      1578,
      2280,
      1577,
      2295,
      2293,
      2291,
      579,
      577,
      574,
      571,
      2298,
      582,
      581,
      1592,
      2263,
      2262,
      2260,
      2258,
      1545,
      2255,
      1544,
      2252,
      1541,
      2273,
      2271,
      2269,
      2266,
      1550,
      535,
      532,
      2279,
      528,
      2277,
      546,
      543,
      549,
      1575,
      1573,
      2224,
      2222,
      2220,
      1486,
      2217,
      1485,
      2214,
      1482,
      1479,
      2238,
      2236,
      2234,
      2231,
      1496,
      2228,
      1492,
      480,
      477,
      2248,
      473,
      2246,
      469,
      2243,
      490,
      487,
      2251,
      497,
      1537,
      1535,
      1532,
      2477,
      2476,
      2474,
      2479,
      2469,
      2468,
      2466,
      2464,
      1730,
      2473,
      2471,
      2453,
      2452,
      2450,
      2448,
      1729,
      2445,
      1728,
      2460,
      2458,
      2456,
      2463,
      805,
      804,
      2428,
      2427,
      2425,
      2423,
      1725,
      2420,
      1724,
      2417,
      1722,
      2438,
      2436,
      2434,
      2431,
      1727,
      2444,
      2442,
      793,
      791,
      788,
      795,
      2388,
      2386,
      2384,
      1697,
      2381,
      1696,
      2378,
      1694,
      1692,
      2402,
      2400,
      2398,
      2395,
      1703,
      2392,
      1701,
      2412,
      2410,
      2407,
      751,
      748,
      744,
      2416,
      759,
      757,
      1807,
      2620,
      2618,
      1806,
      1805,
      2611,
      2609,
      2607,
      2614,
      1802,
      1801,
      1799,
      2594,
      2592,
      2590,
      2587,
      1804,
      2600,
      2598,
      1794,
      1793,
      1791,
      1789,
      2564,
      2562,
      2560,
      2557,
      1798,
      2554,
      1796,
      2574,
      2572,
      2569,
      2578,
      1847,
      1846,
      2722,
      1843,
      1842,
      1840,
      1845,
      2716,
      2714,
      1835,
      1834,
      1832,
      1830,
      1839,
      1837,
      2700,
      2698,
      2695,
      2704,
      1817,
      1811,
      1810,
      897,
      862,
      1777,
      829,
      826,
      838,
      1760,
      1758,
      808,
      2481,
      1741,
      1740,
      1738,
      1743,
      2624,
      1818,
      2726,
      2776,
      782,
      740,
      737,
      1715,
      686,
      679,
      695,
      1682,
      1680,
      639,
      628,
      2339,
      647,
      644,
      1645,
      1643,
      1640,
      1648,
      602,
      600,
      597,
      595,
      2320,
      593,
      2318,
      609,
      607,
      604,
      1611,
      1610,
      1608,
      1606,
      613,
      1615,
      1613,
      2328,
      926,
      924,
      892,
      886,
      899,
      857,
      850,
      2505,
      1778,
      824,
      823,
      821,
      819,
      2488,
      818,
      2486,
      833,
      831,
      828,
      840,
      1761,
      1759,
      2649,
      2632,
      2630,
      2746,
      2734,
      2732,
      2782,
      2781,
      570,
      567,
      1587,
      531,
      527,
      523,
      540,
      1566,
      1564,
      476,
      467,
      463,
      2240,
      486,
      483,
      1524,
      1521,
      1518,
      1529,
      411,
      403,
      2192,
      399,
      2189,
      423,
      416,
      1462,
      1457,
      1454,
      428,
      1468,
      1465,
      2210,
      366,
      363,
      2158,
      360,
      2156,
      357,
      2153,
      376,
      373,
      370,
      2163,
      1410,
      1409,
      1407,
      1405,
      382,
      1402,
      380,
      1417,
      1415,
      1412,
      1421,
      2175,
      2174,
      777,
      774,
      771,
      784,
      732,
      725,
      722,
      2404,
      743,
      1716,
      676,
      674,
      668,
      2363,
      665,
      2360,
      685,
      1684,
      1681,
      626,
      624,
      622,
      2335,
      620,
      2333,
      617,
      2330,
      641,
      635,
      649,
      1646,
      1644,
      1642,
      2566,
      928,
      925,
      2530,
      2527,
      894,
      891,
      888,
      2501,
      2499,
      2496,
      858,
      856,
      854,
      851,
      1779,
      2692,
      2668,
      2665,
      2645,
      2643,
      2640,
      2651,
      2768,
      2759,
      2757,
      2744,
      2743,
      2741,
      2748,
      352,
      1382,
      340,
      337,
      333,
      1371,
      1369,
      307,
      300,
      296,
      2126,
      315,
      312,
      1347,
      1342,
      1350,
      261,
      258,
      250,
      2097,
      246,
      2094,
      271,
      268,
      264,
      1306,
      1301,
      1298,
      276,
      1312,
      1309,
      2115,
      203,
      2048,
      195,
      2045,
      191,
      2041,
      213,
      209,
      2056,
      1246,
      1244,
      1238,
      225,
      1234,
      222,
      1256,
      1253,
      1249,
      1262,
      2080,
      2079,
      154,
      1997,
      150,
      1995,
      147,
      1992,
      1989,
      163,
      160,
      2004,
      156,
      2001,
      1175,
      1174,
      1172,
      1170,
      1167,
      170,
      1164,
      167,
      1185,
      1183,
      1180,
      1177,
      174,
      1190,
      1188,
      2025,
      2024,
      2022,
      587,
      586,
      564,
      559,
      556,
      2290,
      573,
      1588,
      520,
      518,
      512,
      2268,
      508,
      2265,
      530,
      1568,
      1565,
      461,
      457,
      2233,
      450,
      2230,
      446,
      2226,
      479,
      471,
      489,
      1526,
      1523,
      1520,
      397,
      395,
      2185,
      392,
      2183,
      389,
      2180,
      2177,
      410,
      2194,
      402,
      422,
      1463,
      1461,
      1459,
      1456,
      1470,
      2455,
      799,
      2433,
      2430,
      779,
      776,
      773,
      2397,
      2394,
      2390,
      734,
      728,
      724,
      746,
      1717,
      2356,
      2354,
      2351,
      2348,
      1658,
      677,
      675,
      673,
      670,
      667,
      688,
      1685,
      1683,
      2606,
      2589,
      2586,
      2559,
      2556,
      2552,
      927,
      2523,
      2521,
      2518,
      2515,
      1784,
      2532,
      895,
      893,
      890,
      2718,
      2709,
      2707,
      2689,
      2687,
      2684,
      2663,
      2662,
      2660,
      2658,
      1825,
      2667,
      2769,
      1852,
      2760,
      2758,
      142,
      141,
      1139,
      1138,
      134,
      132,
      129,
      126,
      1982,
      1129,
      1128,
      1126,
      1131,
      113,
      111,
      108,
      105,
      1972,
      101,
      1970,
      120,
      118,
      115,
      1109,
      1108,
      1106,
      1104,
      123,
      1113,
      1111,
      82,
      79,
      1951,
      75,
      1949,
      72,
      1946,
      92,
      89,
      86,
      1956,
      1077,
      1076,
      1074,
      1072,
      98,
      1069,
      96,
      1084,
      1082,
      1079,
      1088,
      1968,
      1967,
      48,
      45,
      1916,
      42,
      1914,
      39,
      1911,
      1908,
      60,
      57,
      54,
      1923,
      50,
      1920,
      1031,
      1030,
      1028,
      1026,
      67,
      1023,
      65,
      1020,
      62,
      1041,
      1039,
      1036,
      1033,
      69,
      1046,
      1044,
      1944,
      1943,
      1941,
      11,
      9,
      1868,
      7,
      1865,
      1862,
      1859,
      20,
      1878,
      16,
      1875,
      13,
      1872,
      970,
      968,
      966,
      963,
      29,
      960,
      26,
      23,
      983,
      981,
      978,
      975,
      33,
      971,
      31,
      990,
      988,
      985,
      1906,
      1904,
      1902,
      993,
      351,
      2145,
      1383,
      331,
      330,
      328,
      326,
      2137,
      323,
      2135,
      339,
      1372,
      1370,
      294,
      293,
      291,
      289,
      2122,
      286,
      2120,
      283,
      2117,
      309,
      303,
      317,
      1348,
      1346,
      1344,
      245,
      244,
      242,
      2090,
      239,
      2088,
      236,
      2085,
      2082,
      260,
      2099,
      249,
      270,
      1307,
      1305,
      1303,
      1300,
      1314,
      189,
      2038,
      186,
      2036,
      183,
      2033,
      2030,
      2026,
      206,
      198,
      2047,
      194,
      216,
      1247,
      1245,
      1243,
      1240,
      227,
      1237,
      1255,
      2310,
      2302,
      2300,
      2286,
      2284,
      2281,
      565,
      563,
      561,
      558,
      575,
      1589,
      2261,
      2259,
      2256,
      2253,
      1542,
      521,
      519,
      517,
      514,
      2270,
      511,
      533,
      1569,
      1567,
      2223,
      2221,
      2218,
      2215,
      1483,
      2211,
      1480,
      459,
      456,
      453,
      2232,
      449,
      474,
      491,
      1527,
      1525,
      1522,
      2475,
      2467,
      2465,
      2451,
      2449,
      2446,
      801,
      800,
      2426,
      2424,
      2421,
      2418,
      1723,
      2435,
      780,
      778,
      775,
      2387,
      2385,
      2382,
      2379,
      1695,
      2375,
      1693,
      2396,
      735,
      733,
      730,
      727,
      749,
      1718,
      2616,
      2615,
      2604,
      2603,
      2601,
      2584,
      2583,
      2581,
      2579,
      1800,
      2591,
      2550,
      2549,
      2547,
      2545,
      1792,
      2542,
      1790,
      2558,
      929,
      2719,
      1841,
      2710,
      2708,
      1833,
      1831,
      2690,
      2688,
      2686,
      1815,
      1809,
      1808,
      1774,
      1756,
      1754,
      1737,
      1736,
      1734,
      1739,
      1816,
      1711,
      1676,
      1674,
      633,
      629,
      1638,
      1636,
      1633,
      1641,
      598,
      1605,
      1604,
      1602,
      1600,
      605,
      1609,
      1607,
      2327,
      887,
      853,
      1775,
      822,
      820,
      1757,
      1755,
      1584,
      524,
      1560,
      1558,
      468,
      464,
      1514,
      1511,
      1508,
      1519,
      408,
      404,
      400,
      1452,
      1447,
      1444,
      417,
      1458,
      1455,
      2208,
      364,
      361,
      358,
      2154,
      1401,
      1400,
      1398,
      1396,
      374,
      1393,
      371,
      1408,
      1406,
      1403,
      1413,
      2173,
      2172,
      772,
      726,
      723,
      1712,
      672,
      669,
      666,
      682,
      1678,
      1675,
      625,
      623,
      621,
      618,
      2331,
      636,
      632,
      1639,
      1637,
      1635,
      920,
      918,
      884,
      880,
      889,
      849,
      848,
      847,
      846,
      2497,
      855,
      852,
      1776,
      2641,
      2742,
      2787,
      1380,
      334,
      1367,
      1365,
      301,
      297,
      1340,
      1338,
      1335,
      1343,
      255,
      251,
      247,
      1296,
      1291,
      1288,
      265,
      1302,
      1299,
      2113,
      204,
      196,
      192,
      2042,
      1232,
      1230,
      1224,
      214,
      1220,
      210,
      1242,
      1239,
      1235,
      1250,
      2077,
      2075,
      151,
      148,
      1993,
      144,
      1990,
      1163,
      1162,
      1160,
      1158,
      1155,
      161,
      1152,
      157,
      1173,
      1171,
      1168,
      1165,
      168,
      1181,
      1178,
      2021,
      2020,
      2018,
      2023,
      585,
      560,
      557,
      1585,
      516,
      509,
      1562,
      1559,
      458,
      447,
      2227,
      472,
      1516,
      1513,
      1510,
      398,
      396,
      393,
      390,
      2181,
      386,
      2178,
      407,
      1453,
      1451,
      1449,
      1446,
      420,
      1460,
      2209,
      769,
      764,
      720,
      712,
      2391,
      729,
      1713,
      664,
      663,
      661,
      659,
      2352,
      656,
      2349,
      671,
      1679,
      1677,
      2553,
      922,
      919,
      2519,
      2516,
      885,
      883,
      881,
      2685,
      2661,
      2659,
      2767,
      2756,
      2755,
      140,
      1137,
      1136,
      130,
      127,
      1125,
      1124,
      1122,
      1127,
      109,
      106,
      102,
      1103,
      1102,
      1100,
      1098,
      116,
      1107,
      1105,
      1980,
      80,
      76,
      73,
      1947,
      1068,
      1067,
      1065,
      1063,
      90,
      1060,
      87,
      1075,
      1073,
      1070,
      1080,
      1966,
      1965,
      46,
      43,
      40,
      1912,
      36,
      1909,
      1019,
      1018,
      1016,
      1014,
      58,
      1011,
      55,
      1008,
      51,
      1029,
      1027,
      1024,
      1021,
      63,
      1037,
      1034,
      1940,
      1939,
      1937,
      1942,
      8,
      1866,
      4,
      1863,
      1,
      1860,
      956,
      954,
      952,
      949,
      946,
      17,
      14,
      969,
      967,
      964,
      961,
      27,
      957,
      24,
      979,
      976,
      972,
      1901,
      1900,
      1898,
      1896,
      986,
      1905,
      1903,
      350,
      349,
      1381,
      329,
      327,
      324,
      1368,
      1366,
      292,
      290,
      287,
      284,
      2118,
      304,
      1341,
      1339,
      1337,
      1345,
      243,
      240,
      237,
      2086,
      233,
      2083,
      254,
      1297,
      1295,
      1293,
      1290,
      1304,
      2114,
      190,
      187,
      184,
      2034,
      180,
      2031,
      177,
      2027,
      199,
      1233,
      1231,
      1229,
      1226,
      217,
      1223,
      1241,
      2078,
      2076,
      584,
      555,
      554,
      552,
      550,
      2282,
      562,
      1586,
      507,
      506,
      504,
      502,
      2257,
      499,
      2254,
      515,
      1563,
      1561,
      445,
      443,
      441,
      2219,
      438,
      2216,
      435,
      2212,
      460,
      454,
      475,
      1517,
      1515,
      1512,
      2447,
      798,
      797,
      2422,
      2419,
      770,
      768,
      766,
      2383,
      2380,
      2376,
      721,
      719,
      717,
      714,
      731,
      1714,
      2602,
      2582,
      2580,
      2548,
      2546,
      2543,
      923,
      921,
      2717,
      2706,
      2705,
      2683,
      2682,
      2680,
      1771,
      1752,
      1750,
      1733,
      1732,
      1731,
      1735,
      1814,
      1707,
      1670,
      1668,
      1631,
      1629,
      1626,
      1634,
      1599,
      1598,
      1596,
      1594,
      1603,
      1601,
      2326,
      1772,
      1753,
      1751,
      1581,
      1554,
      1552,
      1504,
      1501,
      1498,
      1509,
      1442,
      1437,
      1434,
      401,
      1448,
      1445,
      2206,
      1392,
      1391,
      1389,
      1387,
      1384,
      359,
      1399,
      1397,
      1394,
      1404,
      2171,
      2170,
      1708,
      1672,
      1669,
      619,
      1632,
      1630,
      1628,
      1773,
      1378,
      1363,
      1361,
      1333,
      1328,
      1336,
      1286,
      1281,
      1278,
      248,
      1292,
      1289,
      2111,
      1218,
      1216,
      1210,
      197,
      1206,
      193,
      1228,
      1225,
      1221,
      1236,
      2073,
      2071,
      1151,
      1150,
      1148,
      1146,
      152,
      1143,
      149,
      1140,
      145,
      1161,
      1159,
      1156,
      1153,
      158,
      1169,
      1166,
      2017,
      2016,
      2014,
      2019,
      1582,
      510,
      1556,
      1553,
      452,
      448,
      1506,
      1500,
      394,
      391,
      387,
      1443,
      1441,
      1439,
      1436,
      1450,
      2207,
      765,
      716,
      713,
      1709,
      662,
      660,
      657,
      1673,
      1671,
      916,
      914,
      879,
      878,
      877,
      882,
      1135,
      1134,
      1121,
      1120,
      1118,
      1123,
      1097,
      1096,
      1094,
      1092,
      103,
      1101,
      1099,
      1979,
      1059,
      1058,
      1056,
      1054,
      77,
      1051,
      74,
      1066,
      1064,
      1061,
      1071,
      1964,
      1963,
      1007,
      1006,
      1004,
      1002,
      999,
      41,
      996,
      37,
      1017,
      1015,
      1012,
      1009,
      52,
      1025,
      1022,
      1936,
      1935,
      1933,
      1938,
      942,
      940,
      938,
      935,
      932,
      5,
      2,
      955,
      953,
      950,
      947,
      18,
      943,
      15,
      965,
      962,
      958,
      1895,
      1894,
      1892,
      1890,
      973,
      1899,
      1897,
      1379,
      325,
      1364,
      1362,
      288,
      285,
      1334,
      1332,
      1330,
      241,
      238,
      234,
      1287,
      1285,
      1283,
      1280,
      1294,
      2112,
      188,
      185,
      181,
      178,
      2028,
      1219,
      1217,
      1215,
      1212,
      200,
      1209,
      1227,
      2074,
      2072,
      583,
      553,
      551,
      1583,
      505,
      503,
      500,
      513,
      1557,
      1555,
      444,
      442,
      439,
      436,
      2213,
      455,
      451,
      1507,
      1505,
      1502,
      796,
      763,
      762,
      760,
      767,
      711,
      710,
      708,
      706,
      2377,
      718,
      715,
      1710,
      2544,
      917,
      915,
      2681,
      1627,
      1597,
      1595,
      2325,
      1769,
      1749,
      1747,
      1499,
      1438,
      1435,
      2204,
      1390,
      1388,
      1385,
      1395,
      2169,
      2167,
      1704,
      1665,
      1662,
      1625,
      1623,
      1620,
      1770,
      1329,
      1282,
      1279,
      2109,
      1214,
      1207,
      1222,
      2068,
      2065,
      1149,
      1147,
      1144,
      1141,
      146,
      1157,
      1154,
      2013,
      2011,
      2008,
      2015,
      1579,
      1549,
      1546,
      1495,
      1487,
      1433,
      1431,
      1428,
      1425,
      388,
      1440,
      2205,
      1705,
      658,
      1667,
      1664,
      1119,
      1095,
      1093,
      1978,
      1057,
      1055,
      1052,
      1062,
      1962,
      1960,
      1005,
      1003,
      1e3,
      997,
      38,
      1013,
      1010,
      1932,
      1930,
      1927,
      1934,
      941,
      939,
      936,
      933,
      6,
      930,
      3,
      951,
      948,
      944,
      1889,
      1887,
      1884,
      1881,
      959,
      1893,
      1891,
      35,
      1377,
      1360,
      1358,
      1327,
      1325,
      1322,
      1331,
      1277,
      1275,
      1272,
      1269,
      235,
      1284,
      2110,
      1205,
      1204,
      1201,
      1198,
      182,
      1195,
      179,
      1213,
      2070,
      2067,
      1580,
      501,
      1551,
      1548,
      440,
      437,
      1497,
      1494,
      1490,
      1503,
      761,
      709,
      707,
      1706,
      913,
      912,
      2198,
      1386,
      2164,
      2161,
      1621,
      1766,
      2103,
      1208,
      2058,
      2054,
      1145,
      1142,
      2005,
      2002,
      1999,
      2009,
      1488,
      1429,
      1426,
      2200,
      1698,
      1659,
      1656,
      1975,
      1053,
      1957,
      1954,
      1001,
      998,
      1924,
      1921,
      1918,
      1928,
      937,
      934,
      931,
      1879,
      1876,
      1873,
      1870,
      945,
      1885,
      1882,
      1323,
      1273,
      1270,
      2105,
      1202,
      1199,
      1196,
      1211,
      2061,
      2057,
      1576,
      1543,
      1540,
      1484,
      1481,
      1478,
      1491,
      1700
    ]), t;
  }()
), bUe = (
  /** @class */
  function() {
    function t(e, n) {
      this.bits = e, this.points = n;
    }
    return t.prototype.getBits = function() {
      return this.bits;
    }, t.prototype.getPoints = function() {
      return this.points;
    }, t;
  }()
), wUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, xUe = (
  /** @class */
  function() {
    function t() {
    }
    return t.detectMultiple = function(e, n, r) {
      var i = e.getBlackMatrix(), a = t.detect(r, i);
      return a.length || (i = i.clone(), i.rotate180(), a = t.detect(r, i)), new bUe(i, a);
    }, t.detect = function(e, n) {
      for (var r, i, a = new Array(), s = 0, c = 0, d = !1; s < n.getHeight(); ) {
        var f = t.findVertices(n, s, c);
        if (f[0] == null && f[3] == null) {
          if (!d)
            break;
          d = !1, c = 0;
          try {
            for (var g = (r = void 0, wUe(a)), m = g.next(); !m.done; m = g.next()) {
              var b = m.value;
              b[1] != null && (s = Math.trunc(Math.max(s, b[1].getY()))), b[3] != null && (s = Math.max(s, Math.trunc(b[3].getY())));
            }
          } catch (w) {
            r = { error: w };
          } finally {
            try {
              m && !m.done && (i = g.return) && i.call(g);
            } finally {
              if (r)
                throw r.error;
            }
          }
          s += t.ROW_STEP;
          continue;
        }
        if (d = !0, a.push(f), !e)
          break;
        f[2] != null ? (c = Math.trunc(f[2].getX()), s = Math.trunc(f[2].getY())) : (c = Math.trunc(f[4].getX()), s = Math.trunc(f[4].getY()));
      }
      return a;
    }, t.findVertices = function(e, n, r) {
      var i = e.getHeight(), a = e.getWidth(), s = new Array(8);
      return t.copyToResult(s, t.findRowsWithPattern(e, i, a, n, r, t.START_PATTERN), t.INDEXES_START_PATTERN), s[4] != null && (r = Math.trunc(s[4].getX()), n = Math.trunc(s[4].getY())), t.copyToResult(s, t.findRowsWithPattern(e, i, a, n, r, t.STOP_PATTERN), t.INDEXES_STOP_PATTERN), s;
    }, t.copyToResult = function(e, n, r) {
      for (var i = 0; i < r.length; i++)
        e[r[i]] = n[i];
    }, t.findRowsWithPattern = function(e, n, r, i, a, s) {
      for (var c = new Array(4), d = !1, f = new Int32Array(s.length); i < n; i += t.ROW_STEP) {
        var g = t.findGuardPattern(e, a, i, r, !1, s, f);
        if (g != null) {
          for (; i > 0; ) {
            var m = t.findGuardPattern(e, a, --i, r, !1, s, f);
            if (m != null)
              g = m;
            else {
              i++;
              break;
            }
          }
          c[0] = new kt(g[0], i), c[1] = new kt(g[1], i), d = !0;
          break;
        }
      }
      var b = i + 1;
      if (d) {
        for (var w = 0, m = Int32Array.from([Math.trunc(c[0].getX()), Math.trunc(c[1].getX())]); b < n; b++) {
          var g = t.findGuardPattern(e, m[0], b, r, !1, s, f);
          if (g != null && Math.abs(m[0] - g[0]) < t.MAX_PATTERN_DRIFT && Math.abs(m[1] - g[1]) < t.MAX_PATTERN_DRIFT)
            m = g, w = 0;
          else {
            if (w > t.SKIPPED_ROW_COUNT_MAX)
              break;
            w++;
          }
        }
        b -= w + 1, c[2] = new kt(m[0], b), c[3] = new kt(m[1], b);
      }
      return b - i < t.BARCODE_MIN_HEIGHT && qa.fill(c, null), c;
    }, t.findGuardPattern = function(e, n, r, i, a, s, c) {
      qa.fillWithin(c, 0, c.length, 0);
      for (var d = n, f = 0; e.get(d, r) && d > 0 && f++ < t.MAX_PIXEL_DRIFT; )
        d--;
      for (var g = d, m = 0, b = s.length, w = a; g < i; g++) {
        var _ = e.get(g, r);
        if (_ !== w)
          c[m]++;
        else {
          if (m === b - 1) {
            if (t.patternMatchVariance(c, s, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE)
              return new Int32Array([d, g]);
            d += c[0] + c[1], si.arraycopy(c, 2, c, 0, m - 1), c[m - 1] = 0, c[m] = 0, m--;
          } else
            m++;
          c[m] = 1, w = !w;
        }
      }
      return m === b - 1 && t.patternMatchVariance(c, s, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE ? new Int32Array([d, g - 1]) : null;
    }, t.patternMatchVariance = function(e, n, r) {
      for (var i = e.length, a = 0, s = 0, c = 0; c < i; c++)
        a += e[c], s += n[c];
      if (a < s)
        return (
          /*Float.POSITIVE_INFINITY*/
          1 / 0
        );
      var d = a / s;
      r *= d;
      for (var f = 0, g = 0; g < i; g++) {
        var m = e[g], b = n[g] * d, w = m > b ? m - b : b - m;
        if (w > r)
          return (
            /*Float.POSITIVE_INFINITY*/
            1 / 0
          );
        f += w;
      }
      return f / a;
    }, t.INDEXES_START_PATTERN = Int32Array.from([0, 4, 1, 5]), t.INDEXES_STOP_PATTERN = Int32Array.from([6, 2, 7, 3]), t.MAX_AVG_VARIANCE = 0.42, t.MAX_INDIVIDUAL_VARIANCE = 0.8, t.START_PATTERN = Int32Array.from([8, 1, 1, 1, 1, 1, 1, 3]), t.STOP_PATTERN = Int32Array.from([7, 1, 1, 3, 1, 1, 1, 2, 1]), t.MAX_PIXEL_DRIFT = 3, t.MAX_PATTERN_DRIFT = 5, t.SKIPPED_ROW_COUNT_MAX = 25, t.ROW_STEP = 5, t.BARCODE_MIN_HEIGHT = 10, t;
  }()
), SUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ag = (
  /** @class */
  function() {
    function t(e, n) {
      if (n.length === 0)
        throw new Yt();
      this.field = e;
      var r = (
        /*int*/
        n.length
      );
      if (r > 1 && n[0] === 0) {
        for (var i = (
          /*int*/
          1
        ); i < r && n[i] === 0; )
          i++;
        i === r ? this.coefficients = new Int32Array([0]) : (this.coefficients = new Int32Array(r - i), si.arraycopy(n, i, this.coefficients, 0, this.coefficients.length));
      } else
        this.coefficients = n;
    }
    return t.prototype.getCoefficients = function() {
      return this.coefficients;
    }, t.prototype.getDegree = function() {
      return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
      return this.coefficients[0] === 0;
    }, t.prototype.getCoefficient = function(e) {
      return this.coefficients[this.coefficients.length - 1 - e];
    }, t.prototype.evaluateAt = function(e) {
      var n, r;
      if (e === 0)
        return this.getCoefficient(0);
      if (e === 1) {
        var i = (
          /*int*/
          0
        );
        try {
          for (var a = SUe(this.coefficients), s = a.next(); !s.done; s = a.next()) {
            var c = s.value;
            i = this.field.add(i, c);
          }
        } catch (m) {
          n = { error: m };
        } finally {
          try {
            s && !s.done && (r = a.return) && r.call(a);
          } finally {
            if (n)
              throw n.error;
          }
        }
        return i;
      }
      for (var d = (
        /*int*/
        this.coefficients[0]
      ), f = (
        /*int*/
        this.coefficients.length
      ), g = 1; g < f; g++)
        d = this.field.add(this.field.multiply(e, d), this.coefficients[g]);
      return d;
    }, t.prototype.add = function(e) {
      if (!this.field.equals(e.field))
        throw new Yt("ModulusPolys do not have same ModulusGF field");
      if (this.isZero())
        return e;
      if (e.isZero())
        return this;
      var n = this.coefficients, r = e.coefficients;
      if (n.length > r.length) {
        var i = n;
        n = r, r = i;
      }
      var a = new Int32Array(r.length), s = (
        /*int*/
        r.length - n.length
      );
      si.arraycopy(r, 0, a, 0, s);
      for (var c = s; c < r.length; c++)
        a[c] = this.field.add(n[c - s], r[c]);
      return new t(this.field, a);
    }, t.prototype.subtract = function(e) {
      if (!this.field.equals(e.field))
        throw new Yt("ModulusPolys do not have same ModulusGF field");
      return e.isZero() ? this : this.add(e.negative());
    }, t.prototype.multiply = function(e) {
      return e instanceof t ? this.multiplyOther(e) : this.multiplyScalar(e);
    }, t.prototype.multiplyOther = function(e) {
      if (!this.field.equals(e.field))
        throw new Yt("ModulusPolys do not have same ModulusGF field");
      if (this.isZero() || e.isZero())
        return new t(this.field, new Int32Array([0]));
      for (var n = this.coefficients, r = (
        /*int*/
        n.length
      ), i = e.coefficients, a = (
        /*int*/
        i.length
      ), s = new Int32Array(r + a - 1), c = 0; c < r; c++)
        for (var d = (
          /*int*/
          n[c]
        ), f = 0; f < a; f++)
          s[c + f] = this.field.add(s[c + f], this.field.multiply(d, i[f]));
      return new t(this.field, s);
    }, t.prototype.negative = function() {
      for (var e = (
        /*int*/
        this.coefficients.length
      ), n = new Int32Array(e), r = 0; r < e; r++)
        n[r] = this.field.subtract(0, this.coefficients[r]);
      return new t(this.field, n);
    }, t.prototype.multiplyScalar = function(e) {
      if (e === 0)
        return new t(this.field, new Int32Array([0]));
      if (e === 1)
        return this;
      for (var n = (
        /*int*/
        this.coefficients.length
      ), r = new Int32Array(n), i = 0; i < n; i++)
        r[i] = this.field.multiply(this.coefficients[i], e);
      return new t(this.field, r);
    }, t.prototype.multiplyByMonomial = function(e, n) {
      if (e < 0)
        throw new Yt();
      if (n === 0)
        return new t(this.field, new Int32Array([0]));
      for (var r = (
        /*int*/
        this.coefficients.length
      ), i = new Int32Array(r + e), a = 0; a < r; a++)
        i[a] = this.field.multiply(this.coefficients[a], n);
      return new t(this.field, i);
    }, t.prototype.toString = function() {
      for (var e = new Bn(
        /*8 * this.getDegree()*/
      ), n = this.getDegree(); n >= 0; n--) {
        var r = (
          /*int*/
          this.getCoefficient(n)
        );
        r !== 0 && (r < 0 ? (e.append(" - "), r = -r) : e.length() > 0 && e.append(" + "), (n === 0 || r !== 1) && e.append(r), n !== 0 && (n === 1 ? e.append("x") : (e.append("x^"), e.append(n))));
      }
      return e.toString();
    }, t;
  }()
), EUe = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.add = function(e, n) {
      return (e + n) % this.modulus;
    }, t.prototype.subtract = function(e, n) {
      return (this.modulus + e - n) % this.modulus;
    }, t.prototype.exp = function(e) {
      return this.expTable[e];
    }, t.prototype.log = function(e) {
      if (e === 0)
        throw new Yt();
      return this.logTable[e];
    }, t.prototype.inverse = function(e) {
      if (e === 0)
        throw new xee();
      return this.expTable[this.modulus - this.logTable[e] - 1];
    }, t.prototype.multiply = function(e, n) {
      return e === 0 || n === 0 ? 0 : this.expTable[(this.logTable[e] + this.logTable[n]) % (this.modulus - 1)];
    }, t.prototype.getSize = function() {
      return this.modulus;
    }, t.prototype.equals = function(e) {
      return e === this;
    }, t;
  }()
), _Ue = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), AUe = (
  /** @class */
  function(t) {
    _Ue(e, t);
    function e(n, r) {
      var i = t.call(this) || this;
      i.modulus = n, i.expTable = new Int32Array(n), i.logTable = new Int32Array(n);
      for (var a = (
        /*int*/
        1
      ), s = 0; s < n; s++)
        i.expTable[s] = a, a = a * r % n;
      for (var s = 0; s < n - 1; s++)
        i.logTable[i.expTable[s]] = s;
      return i.zero = new ag(i, new Int32Array([0])), i.one = new ag(i, new Int32Array([1])), i;
    }
    return e.prototype.getZero = function() {
      return this.zero;
    }, e.prototype.getOne = function() {
      return this.one;
    }, e.prototype.buildMonomial = function(n, r) {
      if (n < 0)
        throw new Yt();
      if (r === 0)
        return this.zero;
      var i = new Int32Array(n + 1);
      return i[0] = r, new ag(this, i);
    }, e.PDF417_GF = new e(dr.NUMBER_OF_CODEWORDS, 3), e;
  }(EUe)
), CUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, TUe = (
  /** @class */
  function() {
    function t() {
      this.field = AUe.PDF417_GF;
    }
    return t.prototype.decode = function(e, n, r) {
      for (var i, a, s = new ag(this.field, e), c = new Int32Array(n), d = !1, f = n; f > 0; f--) {
        var g = s.evaluateAt(this.field.exp(f));
        c[n - f] = g, g !== 0 && (d = !0);
      }
      if (!d)
        return 0;
      var m = this.field.getOne();
      if (r != null)
        try {
          for (var b = CUe(r), w = b.next(); !w.done; w = b.next()) {
            var _ = w.value, A = this.field.exp(e.length - 1 - _), T = new ag(this.field, new Int32Array([this.field.subtract(0, A), 1]));
            m = m.multiply(T);
          }
        } catch ($) {
          i = { error: $ };
        } finally {
          try {
            w && !w.done && (a = b.return) && a.call(b);
          } finally {
            if (i)
              throw i.error;
          }
        }
      for (var O = new ag(this.field, c), R = this.runEuclideanAlgorithm(this.field.buildMonomial(n, 1), O, n), N = R[0], M = R[1], P = this.findErrorLocations(N), z = this.findErrorMagnitudes(M, N, P), f = 0; f < P.length; f++) {
        var F = e.length - 1 - this.field.log(P[f]);
        if (F < 0)
          throw uo.getChecksumInstance();
        e[F] = this.field.subtract(e[F], z[f]);
      }
      return P.length;
    }, t.prototype.runEuclideanAlgorithm = function(e, n, r) {
      if (e.getDegree() < n.getDegree()) {
        var i = e;
        e = n, n = i;
      }
      for (var a = e, s = n, c = this.field.getZero(), d = this.field.getOne(); s.getDegree() >= Math.round(r / 2); ) {
        var f = a, g = c;
        if (a = s, c = d, a.isZero())
          throw uo.getChecksumInstance();
        s = f;
        for (var m = this.field.getZero(), b = a.getCoefficient(a.getDegree()), w = this.field.inverse(b); s.getDegree() >= a.getDegree() && !s.isZero(); ) {
          var _ = s.getDegree() - a.getDegree(), A = this.field.multiply(s.getCoefficient(s.getDegree()), w);
          m = m.add(this.field.buildMonomial(_, A)), s = s.subtract(a.multiplyByMonomial(_, A));
        }
        d = m.multiply(c).subtract(g).negative();
      }
      var T = d.getCoefficient(0);
      if (T === 0)
        throw uo.getChecksumInstance();
      var O = this.field.inverse(T), R = d.multiply(O), N = s.multiply(O);
      return [R, N];
    }, t.prototype.findErrorLocations = function(e) {
      for (var n = e.getDegree(), r = new Int32Array(n), i = 0, a = 1; a < this.field.getSize() && i < n; a++)
        e.evaluateAt(a) === 0 && (r[i] = this.field.inverse(a), i++);
      if (i !== n)
        throw uo.getChecksumInstance();
      return r;
    }, t.prototype.findErrorMagnitudes = function(e, n, r) {
      for (var i = n.getDegree(), a = new Int32Array(i), s = 1; s <= i; s++)
        a[i - s] = this.field.multiply(s, n.getCoefficient(s));
      for (var c = new ag(this.field, a), d = r.length, f = new Int32Array(d), s = 0; s < d; s++) {
        var g = this.field.inverse(r[s]), m = this.field.subtract(0, e.evaluateAt(g)), b = this.field.inverse(c.evaluateAt(g));
        f[s] = this.field.multiply(m, b);
      }
      return f;
    }, t;
  }()
), uM = (
  /** @class */
  function() {
    function t(e, n, r, i, a) {
      e instanceof t ? this.constructor_2(e) : this.constructor_1(e, n, r, i, a);
    }
    return t.prototype.constructor_1 = function(e, n, r, i, a) {
      var s = n == null || r == null, c = i == null || a == null;
      if (s && c)
        throw new Ye();
      s ? (n = new kt(0, i.getY()), r = new kt(0, a.getY())) : c && (i = new kt(e.getWidth() - 1, n.getY()), a = new kt(e.getWidth() - 1, r.getY())), this.image = e, this.topLeft = n, this.bottomLeft = r, this.topRight = i, this.bottomRight = a, this.minX = Math.trunc(Math.min(n.getX(), r.getX())), this.maxX = Math.trunc(Math.max(i.getX(), a.getX())), this.minY = Math.trunc(Math.min(n.getY(), i.getY())), this.maxY = Math.trunc(Math.max(r.getY(), a.getY()));
    }, t.prototype.constructor_2 = function(e) {
      this.image = e.image, this.topLeft = e.getTopLeft(), this.bottomLeft = e.getBottomLeft(), this.topRight = e.getTopRight(), this.bottomRight = e.getBottomRight(), this.minX = e.getMinX(), this.maxX = e.getMaxX(), this.minY = e.getMinY(), this.maxY = e.getMaxY();
    }, t.merge = function(e, n) {
      return e == null ? n : n == null ? e : new t(e.image, e.topLeft, e.bottomLeft, n.topRight, n.bottomRight);
    }, t.prototype.addMissingRows = function(e, n, r) {
      var i = this.topLeft, a = this.bottomLeft, s = this.topRight, c = this.bottomRight;
      if (e > 0) {
        var d = r ? this.topLeft : this.topRight, f = Math.trunc(d.getY() - e);
        f < 0 && (f = 0);
        var g = new kt(d.getX(), f);
        r ? i = g : s = g;
      }
      if (n > 0) {
        var m = r ? this.bottomLeft : this.bottomRight, b = Math.trunc(m.getY() + n);
        b >= this.image.getHeight() && (b = this.image.getHeight() - 1);
        var w = new kt(m.getX(), b);
        r ? a = w : c = w;
      }
      return new t(this.image, i, a, s, c);
    }, t.prototype.getMinX = function() {
      return this.minX;
    }, t.prototype.getMaxX = function() {
      return this.maxX;
    }, t.prototype.getMinY = function() {
      return this.minY;
    }, t.prototype.getMaxY = function() {
      return this.maxY;
    }, t.prototype.getTopLeft = function() {
      return this.topLeft;
    }, t.prototype.getTopRight = function() {
      return this.topRight;
    }, t.prototype.getBottomLeft = function() {
      return this.bottomLeft;
    }, t.prototype.getBottomRight = function() {
      return this.bottomRight;
    }, t;
  }()
), OUe = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      this.columnCount = e, this.errorCorrectionLevel = i, this.rowCountUpperPart = n, this.rowCountLowerPart = r, this.rowCount = n + r;
    }
    return t.prototype.getColumnCount = function() {
      return this.columnCount;
    }, t.prototype.getErrorCorrectionLevel = function() {
      return this.errorCorrectionLevel;
    }, t.prototype.getRowCount = function() {
      return this.rowCount;
    }, t.prototype.getRowCountUpperPart = function() {
      return this.rowCountUpperPart;
    }, t.prototype.getRowCountLowerPart = function() {
      return this.rowCountLowerPart;
    }, t;
  }()
), Wk = (
  /** @class */
  function() {
    function t() {
      this.buffer = "";
    }
    return t.form = function(e, n) {
      var r = -1;
      function i(s, c, d, f, g, m) {
        if (s === "%%")
          return "%";
        if (n[++r] !== void 0) {
          s = f ? parseInt(f.substr(1)) : void 0;
          var b = g ? parseInt(g.substr(1)) : void 0, w;
          switch (m) {
            case "s":
              w = n[r];
              break;
            case "c":
              w = n[r][0];
              break;
            case "f":
              w = parseFloat(n[r]).toFixed(s);
              break;
            case "p":
              w = parseFloat(n[r]).toPrecision(s);
              break;
            case "e":
              w = parseFloat(n[r]).toExponential(s);
              break;
            case "x":
              w = parseInt(n[r]).toString(b || 16);
              break;
            case "d":
              w = parseFloat(parseInt(n[r], b || 10).toPrecision(s)).toFixed(0);
              break;
          }
          w = typeof w == "object" ? JSON.stringify(w) : (+w).toString(b);
          for (var _ = parseInt(d), A = d && d[0] + "" == "0" ? "0" : " "; w.length < _; )
            w = c !== void 0 ? w + A : A + w;
          return w;
        }
      }
      var a = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
      return e.replace(a, i);
    }, t.prototype.format = function(e) {
      for (var n = [], r = 1; r < arguments.length; r++)
        n[r - 1] = arguments[r];
      this.buffer += t.form(e, n);
    }, t.prototype.toString = function() {
      return this.buffer;
    }, t;
  }()
), RUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ree = (
  /** @class */
  function() {
    function t(e) {
      this.boundingBox = new uM(e), this.codewords = new Array(e.getMaxY() - e.getMinY() + 1);
    }
    return t.prototype.getCodewordNearby = function(e) {
      var n = this.getCodeword(e);
      if (n != null)
        return n;
      for (var r = 1; r < t.MAX_NEARBY_DISTANCE; r++) {
        var i = this.imageRowToCodewordIndex(e) - r;
        if (i >= 0 && (n = this.codewords[i], n != null) || (i = this.imageRowToCodewordIndex(e) + r, i < this.codewords.length && (n = this.codewords[i], n != null)))
          return n;
      }
      return null;
    }, t.prototype.imageRowToCodewordIndex = function(e) {
      return e - this.boundingBox.getMinY();
    }, t.prototype.setCodeword = function(e, n) {
      this.codewords[this.imageRowToCodewordIndex(e)] = n;
    }, t.prototype.getCodeword = function(e) {
      return this.codewords[this.imageRowToCodewordIndex(e)];
    }, t.prototype.getBoundingBox = function() {
      return this.boundingBox;
    }, t.prototype.getCodewords = function() {
      return this.codewords;
    }, t.prototype.toString = function() {
      var e, n, r = new Wk(), i = 0;
      try {
        for (var a = RUe(this.codewords), s = a.next(); !s.done; s = a.next()) {
          var c = s.value;
          if (c == null) {
            r.format("%3d:    |   %n", i++);
            continue;
          }
          r.format("%3d: %3d|%3d%n", i++, c.getRowNumber(), c.getValue());
        }
      } catch (d) {
        e = { error: d };
      } finally {
        try {
          s && !s.done && (n = a.return) && n.call(a);
        } finally {
          if (e)
            throw e.error;
        }
      }
      return r.toString();
    }, t.MAX_NEARBY_DISTANCE = 5, t;
  }()
), DUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, NUe = globalThis && globalThis.__read || function(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var r = n.call(t), i, a = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; )
      a.push(i.value);
  } catch (c) {
    s = { error: c };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return a;
}, sE = (
  /** @class */
  function() {
    function t() {
      this.values = /* @__PURE__ */ new Map();
    }
    return t.prototype.setValue = function(e) {
      e = Math.trunc(e);
      var n = this.values.get(e);
      n == null && (n = 0), n++, this.values.set(e, n);
    }, t.prototype.getValue = function() {
      var e, n, r = -1, i = new Array(), a = function(m, b) {
        var w = {
          getKey: function() {
            return m;
          },
          getValue: function() {
            return b;
          }
        };
        w.getValue() > r ? (r = w.getValue(), i = [], i.push(w.getKey())) : w.getValue() === r && i.push(w.getKey());
      };
      try {
        for (var s = DUe(this.values.entries()), c = s.next(); !c.done; c = s.next()) {
          var d = NUe(c.value, 2), f = d[0], g = d[1];
          a(f, g);
        }
      } catch (m) {
        e = { error: m };
      } finally {
        try {
          c && !c.done && (n = s.return) && n.call(s);
        } finally {
          if (e)
            throw e.error;
        }
      }
      return dr.toIntArray(i);
    }, t.prototype.getConfidence = function(e) {
      return this.values.get(e);
    }, t;
  }()
), MUe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), LD = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, n$ = (
  /** @class */
  function(t) {
    MUe(e, t);
    function e(n, r) {
      var i = t.call(this, n) || this;
      return i._isLeft = r, i;
    }
    return e.prototype.setRowNumbers = function() {
      var n, r;
      try {
        for (var i = LD(this.getCodewords()), a = i.next(); !a.done; a = i.next()) {
          var s = a.value;
          s?.setRowNumberAsRowIndicatorColumn();
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (r = i.return) && r.call(i);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, e.prototype.adjustCompleteIndicatorColumnRowNumbers = function(n) {
      var r = this.getCodewords();
      this.setRowNumbers(), this.removeIncorrectCodewords(r, n);
      for (var i = this.getBoundingBox(), a = this._isLeft ? i.getTopLeft() : i.getTopRight(), s = this._isLeft ? i.getBottomLeft() : i.getBottomRight(), c = this.imageRowToCodewordIndex(Math.trunc(a.getY())), d = this.imageRowToCodewordIndex(Math.trunc(s.getY())), f = -1, g = 1, m = 0, b = c; b < d; b++)
        if (r[b] != null) {
          var w = r[b], _ = w.getRowNumber() - f;
          if (_ === 0)
            m++;
          else if (_ === 1)
            g = Math.max(g, m), m = 1, f = w.getRowNumber();
          else if (_ < 0 || w.getRowNumber() >= n.getRowCount() || _ > b)
            r[b] = null;
          else {
            var A = void 0;
            g > 2 ? A = (g - 2) * _ : A = _;
            for (var T = A >= b, O = 1; O <= A && !T; O++)
              T = r[b - O] != null;
            T ? r[b] = null : (f = w.getRowNumber(), m = 1);
          }
        }
    }, e.prototype.getRowHeights = function() {
      var n, r, i = this.getBarcodeMetadata();
      if (i == null)
        return null;
      this.adjustIncompleteIndicatorColumnRowNumbers(i);
      var a = new Int32Array(i.getRowCount());
      try {
        for (var s = LD(this.getCodewords()), c = s.next(); !c.done; c = s.next()) {
          var d = c.value;
          if (d != null) {
            var f = d.getRowNumber();
            if (f >= a.length)
              continue;
            a[f]++;
          }
        }
      } catch (g) {
        n = { error: g };
      } finally {
        try {
          c && !c.done && (r = s.return) && r.call(s);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return a;
    }, e.prototype.adjustIncompleteIndicatorColumnRowNumbers = function(n) {
      for (var r = this.getBoundingBox(), i = this._isLeft ? r.getTopLeft() : r.getTopRight(), a = this._isLeft ? r.getBottomLeft() : r.getBottomRight(), s = this.imageRowToCodewordIndex(Math.trunc(i.getY())), c = this.imageRowToCodewordIndex(Math.trunc(a.getY())), d = this.getCodewords(), f = -1, g = s; g < c; g++)
        if (d[g] != null) {
          var m = d[g];
          m.setRowNumberAsRowIndicatorColumn();
          var b = m.getRowNumber() - f;
          b === 0 || (b === 1 ? f = m.getRowNumber() : m.getRowNumber() >= n.getRowCount() ? d[g] = null : f = m.getRowNumber());
        }
    }, e.prototype.getBarcodeMetadata = function() {
      var n, r, i = this.getCodewords(), a = new sE(), s = new sE(), c = new sE(), d = new sE();
      try {
        for (var f = LD(i), g = f.next(); !g.done; g = f.next()) {
          var m = g.value;
          if (m != null) {
            m.setRowNumberAsRowIndicatorColumn();
            var b = m.getValue() % 30, w = m.getRowNumber();
            switch (this._isLeft || (w += 2), w % 3) {
              case 0:
                s.setValue(b * 3 + 1);
                break;
              case 1:
                d.setValue(b / 3), c.setValue(b % 3);
                break;
              case 2:
                a.setValue(b + 1);
                break;
            }
          }
        }
      } catch (A) {
        n = { error: A };
      } finally {
        try {
          g && !g.done && (r = f.return) && r.call(f);
        } finally {
          if (n)
            throw n.error;
        }
      }
      if (a.getValue().length === 0 || s.getValue().length === 0 || c.getValue().length === 0 || d.getValue().length === 0 || a.getValue()[0] < 1 || s.getValue()[0] + c.getValue()[0] < dr.MIN_ROWS_IN_BARCODE || s.getValue()[0] + c.getValue()[0] > dr.MAX_ROWS_IN_BARCODE)
        return null;
      var _ = new OUe(a.getValue()[0], s.getValue()[0], c.getValue()[0], d.getValue()[0]);
      return this.removeIncorrectCodewords(i, _), _;
    }, e.prototype.removeIncorrectCodewords = function(n, r) {
      for (var i = 0; i < n.length; i++) {
        var a = n[i];
        if (n[i] != null) {
          var s = a.getValue() % 30, c = a.getRowNumber();
          if (c > r.getRowCount()) {
            n[i] = null;
            continue;
          }
          switch (this._isLeft || (c += 2), c % 3) {
            case 0:
              s * 3 + 1 !== r.getRowCountUpperPart() && (n[i] = null);
              break;
            case 1:
              (Math.trunc(s / 3) !== r.getErrorCorrectionLevel() || s % 3 !== r.getRowCountLowerPart()) && (n[i] = null);
              break;
            case 2:
              s + 1 !== r.getColumnCount() && (n[i] = null);
              break;
          }
        }
      }
    }, e.prototype.isLeft = function() {
      return this._isLeft;
    }, e.prototype.toString = function() {
      return "IsLeft: " + this._isLeft + `
` + t.prototype.toString.call(this);
    }, e;
  }(Ree)
), IUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, kUe = (
  /** @class */
  function() {
    function t(e, n) {
      this.ADJUST_ROW_NUMBER_SKIP = 2, this.barcodeMetadata = e, this.barcodeColumnCount = e.getColumnCount(), this.boundingBox = n, this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
    }
    return t.prototype.getDetectionResultColumns = function() {
      this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]), this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
      var e = dr.MAX_CODEWORDS_IN_BARCODE, n;
      do
        n = e, e = this.adjustRowNumbersAndGetCount();
      while (e > 0 && e < n);
      return this.detectionResultColumns;
    }, t.prototype.adjustIndicatorColumnRowNumbers = function(e) {
      e?.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
    }, t.prototype.adjustRowNumbersAndGetCount = function() {
      var e = this.adjustRowNumbersByRow();
      if (e === 0)
        return 0;
      for (var n = 1; n < this.barcodeColumnCount + 1; n++)
        for (var r = this.detectionResultColumns[n].getCodewords(), i = 0; i < r.length; i++)
          r[i] != null && (r[i].hasValidRowNumber() || this.adjustRowNumbers(n, i, r));
      return e;
    }, t.prototype.adjustRowNumbersByRow = function() {
      this.adjustRowNumbersFromBothRI();
      var e = this.adjustRowNumbersFromLRI();
      return e + this.adjustRowNumbersFromRRI();
    }, t.prototype.adjustRowNumbersFromBothRI = function() {
      if (!(this.detectionResultColumns[0] == null || this.detectionResultColumns[this.barcodeColumnCount + 1] == null)) {
        for (var e = this.detectionResultColumns[0].getCodewords(), n = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), r = 0; r < e.length; r++)
          if (e[r] != null && n[r] != null && e[r].getRowNumber() === n[r].getRowNumber())
            for (var i = 1; i <= this.barcodeColumnCount; i++) {
              var a = this.detectionResultColumns[i].getCodewords()[r];
              a != null && (a.setRowNumber(e[r].getRowNumber()), a.hasValidRowNumber() || (this.detectionResultColumns[i].getCodewords()[r] = null));
            }
      }
    }, t.prototype.adjustRowNumbersFromRRI = function() {
      if (this.detectionResultColumns[this.barcodeColumnCount + 1] == null)
        return 0;
      for (var e = 0, n = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), r = 0; r < n.length; r++)
        if (n[r] != null)
          for (var i = n[r].getRowNumber(), a = 0, s = this.barcodeColumnCount + 1; s > 0 && a < this.ADJUST_ROW_NUMBER_SKIP; s--) {
            var c = this.detectionResultColumns[s].getCodewords()[r];
            c != null && (a = t.adjustRowNumberIfValid(i, a, c), c.hasValidRowNumber() || e++);
          }
      return e;
    }, t.prototype.adjustRowNumbersFromLRI = function() {
      if (this.detectionResultColumns[0] == null)
        return 0;
      for (var e = 0, n = this.detectionResultColumns[0].getCodewords(), r = 0; r < n.length; r++)
        if (n[r] != null)
          for (var i = n[r].getRowNumber(), a = 0, s = 1; s < this.barcodeColumnCount + 1 && a < this.ADJUST_ROW_NUMBER_SKIP; s++) {
            var c = this.detectionResultColumns[s].getCodewords()[r];
            c != null && (a = t.adjustRowNumberIfValid(i, a, c), c.hasValidRowNumber() || e++);
          }
      return e;
    }, t.adjustRowNumberIfValid = function(e, n, r) {
      return r == null || r.hasValidRowNumber() || (r.isValidRowNumber(e) ? (r.setRowNumber(e), n = 0) : ++n), n;
    }, t.prototype.adjustRowNumbers = function(e, n, r) {
      var i, a;
      if (this.detectionResultColumns[e - 1] != null) {
        var s = r[n], c = this.detectionResultColumns[e - 1].getCodewords(), d = c;
        this.detectionResultColumns[e + 1] != null && (d = this.detectionResultColumns[e + 1].getCodewords());
        var f = new Array(14);
        f[2] = c[n], f[3] = d[n], n > 0 && (f[0] = r[n - 1], f[4] = c[n - 1], f[5] = d[n - 1]), n > 1 && (f[8] = r[n - 2], f[10] = c[n - 2], f[11] = d[n - 2]), n < r.length - 1 && (f[1] = r[n + 1], f[6] = c[n + 1], f[7] = d[n + 1]), n < r.length - 2 && (f[9] = r[n + 2], f[12] = c[n + 2], f[13] = d[n + 2]);
        try {
          for (var g = IUe(f), m = g.next(); !m.done; m = g.next()) {
            var b = m.value;
            if (t.adjustRowNumber(s, b))
              return;
          }
        } catch (w) {
          i = { error: w };
        } finally {
          try {
            m && !m.done && (a = g.return) && a.call(g);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    }, t.adjustRowNumber = function(e, n) {
      return n == null ? !1 : n.hasValidRowNumber() && n.getBucket() === e.getBucket() ? (e.setRowNumber(n.getRowNumber()), !0) : !1;
    }, t.prototype.getBarcodeColumnCount = function() {
      return this.barcodeColumnCount;
    }, t.prototype.getBarcodeRowCount = function() {
      return this.barcodeMetadata.getRowCount();
    }, t.prototype.getBarcodeECLevel = function() {
      return this.barcodeMetadata.getErrorCorrectionLevel();
    }, t.prototype.setBoundingBox = function(e) {
      this.boundingBox = e;
    }, t.prototype.getBoundingBox = function() {
      return this.boundingBox;
    }, t.prototype.setDetectionResultColumn = function(e, n) {
      this.detectionResultColumns[e] = n;
    }, t.prototype.getDetectionResultColumn = function(e) {
      return this.detectionResultColumns[e];
    }, t.prototype.toString = function() {
      var e = this.detectionResultColumns[0];
      e == null && (e = this.detectionResultColumns[this.barcodeColumnCount + 1]);
      for (var n = new Wk(), r = 0; r < e.getCodewords().length; r++) {
        n.format("CW %3d:", r);
        for (var i = 0; i < this.barcodeColumnCount + 2; i++) {
          if (this.detectionResultColumns[i] == null) {
            n.format("    |   ");
            continue;
          }
          var a = this.detectionResultColumns[i].getCodewords()[r];
          if (a == null) {
            n.format("    |   ");
            continue;
          }
          n.format(" %3d|%3d", a.getRowNumber(), a.getValue());
        }
        n.format("%n");
      }
      return n.toString();
    }, t;
  }()
), jUe = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      this.rowNumber = t.BARCODE_ROW_UNKNOWN, this.startX = Math.trunc(e), this.endX = Math.trunc(n), this.bucket = Math.trunc(r), this.value = Math.trunc(i);
    }
    return t.prototype.hasValidRowNumber = function() {
      return this.isValidRowNumber(this.rowNumber);
    }, t.prototype.isValidRowNumber = function(e) {
      return e !== t.BARCODE_ROW_UNKNOWN && this.bucket === e % 3 * 3;
    }, t.prototype.setRowNumberAsRowIndicatorColumn = function() {
      this.rowNumber = Math.trunc(Math.trunc(this.value / 30) * 3 + Math.trunc(this.bucket / 3));
    }, t.prototype.getWidth = function() {
      return this.endX - this.startX;
    }, t.prototype.getStartX = function() {
      return this.startX;
    }, t.prototype.getEndX = function() {
      return this.endX;
    }, t.prototype.getBucket = function() {
      return this.bucket;
    }, t.prototype.getValue = function() {
      return this.value;
    }, t.prototype.getRowNumber = function() {
      return this.rowNumber;
    }, t.prototype.setRowNumber = function(e) {
      this.rowNumber = e;
    }, t.prototype.toString = function() {
      return this.rowNumber + "|" + this.value;
    }, t.BARCODE_ROW_UNKNOWN = -1, t;
  }()
), PUe = (
  /** @class */
  function() {
    function t() {
    }
    return t.initialize = function() {
      for (var e = 0; e < dr.SYMBOL_TABLE.length; e++)
        for (var n = dr.SYMBOL_TABLE[e], r = n & 1, i = 0; i < dr.BARS_IN_MODULE; i++) {
          for (var a = 0; (n & 1) === r; )
            a += 1, n >>= 1;
          r = n & 1, t.RATIOS_TABLE[e] || (t.RATIOS_TABLE[e] = new Array(dr.BARS_IN_MODULE)), t.RATIOS_TABLE[e][dr.BARS_IN_MODULE - i - 1] = Math.fround(a / dr.MODULES_IN_CODEWORD);
        }
      this.bSymbolTableReady = !0;
    }, t.getDecodedValue = function(e) {
      var n = t.getDecodedCodewordValue(t.sampleBitCounts(e));
      return n !== -1 ? n : t.getClosestDecodedValue(e);
    }, t.sampleBitCounts = function(e) {
      for (var n = gr.sum(e), r = new Int32Array(dr.BARS_IN_MODULE), i = 0, a = 0, s = 0; s < dr.MODULES_IN_CODEWORD; s++) {
        var c = n / (2 * dr.MODULES_IN_CODEWORD) + s * n / dr.MODULES_IN_CODEWORD;
        a + e[i] <= c && (a += e[i], i++), r[i]++;
      }
      return r;
    }, t.getDecodedCodewordValue = function(e) {
      var n = t.getBitValue(e);
      return dr.getCodeword(n) === -1 ? -1 : n;
    }, t.getBitValue = function(e) {
      for (var n = (
        /*long*/
        0
      ), r = 0; r < e.length; r++)
        for (var i = 0; i < e[r]; i++)
          n = n << 1 | (r % 2 === 0 ? 1 : 0);
      return Math.trunc(n);
    }, t.getClosestDecodedValue = function(e) {
      var n = gr.sum(e), r = new Array(dr.BARS_IN_MODULE);
      if (n > 1)
        for (var i = 0; i < r.length; i++)
          r[i] = Math.fround(e[i] / n);
      var a = iM.MAX_VALUE, s = -1;
      this.bSymbolTableReady || t.initialize();
      for (var c = 0; c < t.RATIOS_TABLE.length; c++) {
        for (var d = 0, f = t.RATIOS_TABLE[c], g = 0; g < dr.BARS_IN_MODULE; g++) {
          var m = Math.fround(f[g] - r[g]);
          if (d += Math.fround(m * m), d >= a)
            break;
        }
        d < a && (a = d, s = dr.SYMBOL_TABLE[c]);
      }
      return s;
    }, t.bSymbolTableReady = !1, t.RATIOS_TABLE = new Array(dr.SYMBOL_TABLE.length).map(function(e) {
      return new Array(dr.BARS_IN_MODULE);
    }), t;
  }()
), LUe = (
  /** @class */
  function() {
    function t() {
      this.segmentCount = -1, this.fileSize = -1, this.timestamp = -1, this.checksum = -1;
    }
    return t.prototype.getSegmentIndex = function() {
      return this.segmentIndex;
    }, t.prototype.setSegmentIndex = function(e) {
      this.segmentIndex = e;
    }, t.prototype.getFileId = function() {
      return this.fileId;
    }, t.prototype.setFileId = function(e) {
      this.fileId = e;
    }, t.prototype.getOptionalData = function() {
      return this.optionalData;
    }, t.prototype.setOptionalData = function(e) {
      this.optionalData = e;
    }, t.prototype.isLastSegment = function() {
      return this.lastSegment;
    }, t.prototype.setLastSegment = function(e) {
      this.lastSegment = e;
    }, t.prototype.getSegmentCount = function() {
      return this.segmentCount;
    }, t.prototype.setSegmentCount = function(e) {
      this.segmentCount = e;
    }, t.prototype.getSender = function() {
      return this.sender || null;
    }, t.prototype.setSender = function(e) {
      this.sender = e;
    }, t.prototype.getAddressee = function() {
      return this.addressee || null;
    }, t.prototype.setAddressee = function(e) {
      this.addressee = e;
    }, t.prototype.getFileName = function() {
      return this.fileName;
    }, t.prototype.setFileName = function(e) {
      this.fileName = e;
    }, t.prototype.getFileSize = function() {
      return this.fileSize;
    }, t.prototype.setFileSize = function(e) {
      this.fileSize = e;
    }, t.prototype.getChecksum = function() {
      return this.checksum;
    }, t.prototype.setChecksum = function(e) {
      this.checksum = e;
    }, t.prototype.getTimestamp = function() {
      return this.timestamp;
    }, t.prototype.setTimestamp = function(e) {
      this.timestamp = e;
    }, t;
  }()
), r$ = (
  /** @class */
  function() {
    function t() {
    }
    return t.parseLong = function(e, n) {
      return n === void 0 && (n = void 0), parseInt(e, n);
    }, t;
  }()
), BUe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), zUe = (
  /** @class */
  function(t) {
    BUe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.kind = "NullPointerException", e;
  }(hl)
), FUe = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.writeBytes = function(e) {
      this.writeBytesOffset(e, 0, e.length);
    }, t.prototype.writeBytesOffset = function(e, n, r) {
      if (e == null)
        throw new zUe();
      if (n < 0 || n > e.length || r < 0 || n + r > e.length || n + r < 0)
        throw new Hk();
      if (r === 0)
        return;
      for (var i = 0; i < r; i++)
        this.write(e[n + i]);
    }, t.prototype.flush = function() {
    }, t.prototype.close = function() {
    }, t;
  }()
), VUe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), UUe = (
  /** @class */
  function(t) {
    VUe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(hl)
), $Ue = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), HUe = (
  /** @class */
  function(t) {
    $Ue(e, t);
    function e(n) {
      n === void 0 && (n = 32);
      var r = t.call(this) || this;
      if (r.count = 0, n < 0)
        throw new Yt("Negative initial size: " + n);
      return r.buf = new Uint8Array(n), r;
    }
    return e.prototype.ensureCapacity = function(n) {
      n - this.buf.length > 0 && this.grow(n);
    }, e.prototype.grow = function(n) {
      var r = this.buf.length, i = r << 1;
      if (i - n < 0 && (i = n), i < 0) {
        if (n < 0)
          throw new UUe();
        i = Vn.MAX_VALUE;
      }
      this.buf = qa.copyOfUint8Array(this.buf, i);
    }, e.prototype.write = function(n) {
      this.ensureCapacity(this.count + 1), this.buf[this.count] = /*(byte)*/
      n, this.count += 1;
    }, e.prototype.writeBytesOffset = function(n, r, i) {
      if (r < 0 || r > n.length || i < 0 || r + i - n.length > 0)
        throw new Hk();
      this.ensureCapacity(this.count + i), si.arraycopy(n, r, this.buf, this.count, i), this.count += i;
    }, e.prototype.writeTo = function(n) {
      n.writeBytesOffset(this.buf, 0, this.count);
    }, e.prototype.reset = function() {
      this.count = 0;
    }, e.prototype.toByteArray = function() {
      return qa.copyOfUint8Array(this.buf, this.count);
    }, e.prototype.size = function() {
      return this.count;
    }, e.prototype.toString = function(n) {
      return n ? typeof n == "string" ? this.toString_string(n) : this.toString_number(n) : this.toString_void();
    }, e.prototype.toString_void = function() {
      return new String(
        this.buf
        /*, 0, this.count*/
      ).toString();
    }, e.prototype.toString_string = function(n) {
      return new String(
        this.buf
        /*, 0, this.count, charsetName*/
      ).toString();
    }, e.prototype.toString_number = function(n) {
      return new String(
        this.buf
        /*, hibyte, 0, this.count*/
      ).toString();
    }, e.prototype.close = function() {
    }, e;
  }(FUe)
), Yr;
(function(t) {
  t[t.ALPHA = 0] = "ALPHA", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.PUNCT = 3] = "PUNCT", t[t.ALPHA_SHIFT = 4] = "ALPHA_SHIFT", t[t.PUNCT_SHIFT = 5] = "PUNCT_SHIFT";
})(Yr || (Yr = {}));
function Dee() {
  if (typeof window < "u")
    return window.BigInt || null;
  if (typeof global < "u")
    return global.BigInt || null;
  if (typeof self < "u")
    return self.BigInt || null;
  throw new Error("Can't search globals for BigInt!");
}
var KC;
function O0(t) {
  if (typeof KC > "u" && (KC = Dee()), KC === null)
    throw new Error("BigInt is not supported!");
  return KC(t);
}
function qUe() {
  var t = [];
  t[0] = O0(1);
  var e = O0(900);
  t[1] = e;
  for (var n = 2; n < 16; n++)
    t[n] = t[n - 1] * e;
  return t;
}
var GUe = (
  /** @class */
  function() {
    function t() {
    }
    return t.decode = function(e, n) {
      var r = new Bn(""), i = Ha.ISO8859_1;
      r.enableDecoding(i);
      for (var a = 1, s = e[a++], c = new LUe(); a < e[0]; ) {
        switch (s) {
          case t.TEXT_COMPACTION_MODE_LATCH:
            a = t.textCompaction(e, a, r);
            break;
          case t.BYTE_COMPACTION_MODE_LATCH:
          case t.BYTE_COMPACTION_MODE_LATCH_6:
            a = t.byteCompaction(s, e, i, a, r);
            break;
          case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
            r.append(
              /*(char)*/
              e[a++]
            );
            break;
          case t.NUMERIC_COMPACTION_MODE_LATCH:
            a = t.numericCompaction(e, a, r);
            break;
          case t.ECI_CHARSET:
            Ha.getCharacterSetECIByValue(e[a++]);
            break;
          case t.ECI_GENERAL_PURPOSE:
            a += 2;
            break;
          case t.ECI_USER_DEFINED:
            a++;
            break;
          case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
            a = t.decodeMacroBlock(e, a, c);
            break;
          case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
          case t.MACRO_PDF417_TERMINATOR:
            throw new ht();
          default:
            a--, a = t.textCompaction(e, a, r);
            break;
        }
        if (a < e.length)
          s = e[a++];
        else
          throw ht.getFormatInstance();
      }
      if (r.length() === 0)
        throw ht.getFormatInstance();
      var d = new RO(null, r.toString(), null, n);
      return d.setOther(c), d;
    }, t.decodeMacroBlock = function(e, n, r) {
      if (n + t.NUMBER_OF_SEQUENCE_CODEWORDS > e[0])
        throw ht.getFormatInstance();
      for (var i = new Int32Array(t.NUMBER_OF_SEQUENCE_CODEWORDS), a = 0; a < t.NUMBER_OF_SEQUENCE_CODEWORDS; a++, n++)
        i[a] = e[n];
      r.setSegmentIndex(Vn.parseInt(t.decodeBase900toBase10(i, t.NUMBER_OF_SEQUENCE_CODEWORDS)));
      var s = new Bn();
      n = t.textCompaction(e, n, s), r.setFileId(s.toString());
      var c = -1;
      for (e[n] === t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD && (c = n + 1); n < e[0]; )
        switch (e[n]) {
          case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
            switch (n++, e[n]) {
              case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                var d = new Bn();
                n = t.textCompaction(e, n + 1, d), r.setFileName(d.toString());
                break;
              case t.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                var f = new Bn();
                n = t.textCompaction(e, n + 1, f), r.setSender(f.toString());
                break;
              case t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                var g = new Bn();
                n = t.textCompaction(e, n + 1, g), r.setAddressee(g.toString());
                break;
              case t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                var m = new Bn();
                n = t.numericCompaction(e, n + 1, m), r.setSegmentCount(Vn.parseInt(m.toString()));
                break;
              case t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                var b = new Bn();
                n = t.numericCompaction(e, n + 1, b), r.setTimestamp(r$.parseLong(b.toString()));
                break;
              case t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                var w = new Bn();
                n = t.numericCompaction(e, n + 1, w), r.setChecksum(Vn.parseInt(w.toString()));
                break;
              case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                var _ = new Bn();
                n = t.numericCompaction(e, n + 1, _), r.setFileSize(r$.parseLong(_.toString()));
                break;
              default:
                throw ht.getFormatInstance();
            }
            break;
          case t.MACRO_PDF417_TERMINATOR:
            n++, r.setLastSegment(!0);
            break;
          default:
            throw ht.getFormatInstance();
        }
      if (c !== -1) {
        var A = n - c;
        r.isLastSegment() && A--, r.setOptionalData(qa.copyOfRange(e, c, c + A));
      }
      return n;
    }, t.textCompaction = function(e, n, r) {
      for (var i = new Int32Array((e[0] - n) * 2), a = new Int32Array((e[0] - n) * 2), s = 0, c = !1; n < e[0] && !c; ) {
        var d = e[n++];
        if (d < t.TEXT_COMPACTION_MODE_LATCH)
          i[s] = d / 30, i[s + 1] = d % 30, s += 2;
        else
          switch (d) {
            case t.TEXT_COMPACTION_MODE_LATCH:
              i[s++] = t.TEXT_COMPACTION_MODE_LATCH;
              break;
            case t.BYTE_COMPACTION_MODE_LATCH:
            case t.BYTE_COMPACTION_MODE_LATCH_6:
            case t.NUMERIC_COMPACTION_MODE_LATCH:
            case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
            case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
            case t.MACRO_PDF417_TERMINATOR:
              n--, c = !0;
              break;
            case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
              i[s] = t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE, d = e[n++], a[s] = d, s++;
              break;
          }
      }
      return t.decodeTextCompaction(i, a, s, r), n;
    }, t.decodeTextCompaction = function(e, n, r, i) {
      for (var a = Yr.ALPHA, s = Yr.ALPHA, c = 0; c < r; ) {
        var d = e[c], f = (
          /*char*/
          ""
        );
        switch (a) {
          case Yr.ALPHA:
            if (d < 26)
              f = /*(char)('A' + subModeCh) */
              String.fromCharCode(65 + d);
            else
              switch (d) {
                case 26:
                  f = " ";
                  break;
                case t.LL:
                  a = Yr.LOWER;
                  break;
                case t.ML:
                  a = Yr.MIXED;
                  break;
                case t.PS:
                  s = a, a = Yr.PUNCT_SHIFT;
                  break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  i.append(
                    /*(char)*/
                    n[c]
                  );
                  break;
                case t.TEXT_COMPACTION_MODE_LATCH:
                  a = Yr.ALPHA;
                  break;
              }
            break;
          case Yr.LOWER:
            if (d < 26)
              f = /*(char)('a' + subModeCh)*/
              String.fromCharCode(97 + d);
            else
              switch (d) {
                case 26:
                  f = " ";
                  break;
                case t.AS:
                  s = a, a = Yr.ALPHA_SHIFT;
                  break;
                case t.ML:
                  a = Yr.MIXED;
                  break;
                case t.PS:
                  s = a, a = Yr.PUNCT_SHIFT;
                  break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  i.append(
                    /*(char)*/
                    n[c]
                  );
                  break;
                case t.TEXT_COMPACTION_MODE_LATCH:
                  a = Yr.ALPHA;
                  break;
              }
            break;
          case Yr.MIXED:
            if (d < t.PL)
              f = t.MIXED_CHARS[d];
            else
              switch (d) {
                case t.PL:
                  a = Yr.PUNCT;
                  break;
                case 26:
                  f = " ";
                  break;
                case t.LL:
                  a = Yr.LOWER;
                  break;
                case t.AL:
                  a = Yr.ALPHA;
                  break;
                case t.PS:
                  s = a, a = Yr.PUNCT_SHIFT;
                  break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  i.append(
                    /*(char)*/
                    n[c]
                  );
                  break;
                case t.TEXT_COMPACTION_MODE_LATCH:
                  a = Yr.ALPHA;
                  break;
              }
            break;
          case Yr.PUNCT:
            if (d < t.PAL)
              f = t.PUNCT_CHARS[d];
            else
              switch (d) {
                case t.PAL:
                  a = Yr.ALPHA;
                  break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  i.append(
                    /*(char)*/
                    n[c]
                  );
                  break;
                case t.TEXT_COMPACTION_MODE_LATCH:
                  a = Yr.ALPHA;
                  break;
              }
            break;
          case Yr.ALPHA_SHIFT:
            if (a = s, d < 26)
              f = /*(char)('A' + subModeCh)*/
              String.fromCharCode(65 + d);
            else
              switch (d) {
                case 26:
                  f = " ";
                  break;
                case t.TEXT_COMPACTION_MODE_LATCH:
                  a = Yr.ALPHA;
                  break;
              }
            break;
          case Yr.PUNCT_SHIFT:
            if (a = s, d < t.PAL)
              f = t.PUNCT_CHARS[d];
            else
              switch (d) {
                case t.PAL:
                  a = Yr.ALPHA;
                  break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  i.append(
                    /*(char)*/
                    n[c]
                  );
                  break;
                case t.TEXT_COMPACTION_MODE_LATCH:
                  a = Yr.ALPHA;
                  break;
              }
            break;
        }
        f !== "" && i.append(f), c++;
      }
    }, t.byteCompaction = function(e, n, r, i, a) {
      var s = new HUe(), c = 0, d = (
        /*long*/
        0
      ), f = !1;
      switch (e) {
        case t.BYTE_COMPACTION_MODE_LATCH:
          for (var g = new Int32Array(6), m = n[i++]; i < n[0] && !f; )
            switch (g[c++] = m, d = 900 * d + m, m = n[i++], m) {
              case t.TEXT_COMPACTION_MODE_LATCH:
              case t.BYTE_COMPACTION_MODE_LATCH:
              case t.NUMERIC_COMPACTION_MODE_LATCH:
              case t.BYTE_COMPACTION_MODE_LATCH_6:
              case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
              case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
              case t.MACRO_PDF417_TERMINATOR:
                i--, f = !0;
                break;
              default:
                if (c % 5 === 0 && c > 0) {
                  for (var b = 0; b < 6; ++b)
                    s.write(
                      /*(byte)*/
                      Number(O0(d) >> O0(8 * (5 - b)))
                    );
                  d = 0, c = 0;
                }
                break;
            }
          i === n[0] && m < t.TEXT_COMPACTION_MODE_LATCH && (g[c++] = m);
          for (var w = 0; w < c; w++)
            s.write(
              /*(byte)*/
              g[w]
            );
          break;
        case t.BYTE_COMPACTION_MODE_LATCH_6:
          for (; i < n[0] && !f; ) {
            var _ = n[i++];
            if (_ < t.TEXT_COMPACTION_MODE_LATCH)
              c++, d = 900 * d + _;
            else
              switch (_) {
                case t.TEXT_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                  i--, f = !0;
                  break;
              }
            if (c % 5 === 0 && c > 0) {
              for (var b = 0; b < 6; ++b)
                s.write(
                  /*(byte)*/
                  Number(O0(d) >> O0(8 * (5 - b)))
                );
              d = 0, c = 0;
            }
          }
          break;
      }
      return a.append(Jc.decode(s.toByteArray(), r)), i;
    }, t.numericCompaction = function(e, n, r) {
      for (var i = 0, a = !1, s = new Int32Array(t.MAX_NUMERIC_CODEWORDS); n < e[0] && !a; ) {
        var c = e[n++];
        if (n === e[0] && (a = !0), c < t.TEXT_COMPACTION_MODE_LATCH)
          s[i] = c, i++;
        else
          switch (c) {
            case t.TEXT_COMPACTION_MODE_LATCH:
            case t.BYTE_COMPACTION_MODE_LATCH:
            case t.BYTE_COMPACTION_MODE_LATCH_6:
            case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
            case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
            case t.MACRO_PDF417_TERMINATOR:
              n--, a = !0;
              break;
          }
        (i % t.MAX_NUMERIC_CODEWORDS === 0 || c === t.NUMERIC_COMPACTION_MODE_LATCH || a) && i > 0 && (r.append(t.decodeBase900toBase10(s, i)), i = 0);
      }
      return n;
    }, t.decodeBase900toBase10 = function(e, n) {
      for (var r = O0(0), i = 0; i < n; i++)
        r += t.EXP900[n - i - 1] * O0(e[i]);
      var a = r.toString();
      if (a.charAt(0) !== "1")
        throw new ht();
      return a.substring(1);
    }, t.TEXT_COMPACTION_MODE_LATCH = 900, t.BYTE_COMPACTION_MODE_LATCH = 901, t.NUMERIC_COMPACTION_MODE_LATCH = 902, t.BYTE_COMPACTION_MODE_LATCH_6 = 924, t.ECI_USER_DEFINED = 925, t.ECI_GENERAL_PURPOSE = 926, t.ECI_CHARSET = 927, t.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928, t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923, t.MACRO_PDF417_TERMINATOR = 922, t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913, t.MAX_NUMERIC_CODEWORDS = 15, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0, t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1, t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2, t.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3, t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5, t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6, t.PL = 25, t.LL = 27, t.AS = 27, t.ML = 28, t.AL = 28, t.PS = 29, t.PAL = 29, t.PUNCT_CHARS = `;<>@[\\]_\`~!\r	,:
-.$/"|*()?{}'`, t.MIXED_CHARS = "0123456789&\r	,:#-.$/+%*=^", t.EXP900 = Dee() ? qUe() : [], t.NUMBER_OF_SEQUENCE_CODEWORDS = 2, t;
  }()
), qS = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, YUe = (
  /** @class */
  function() {
    function t() {
    }
    return t.decode = function(e, n, r, i, a, s, c) {
      for (var d = new uM(e, n, r, i, a), f = null, g = null, m, b = !0; ; b = !1) {
        if (n != null && (f = t.getRowIndicatorColumn(e, d, n, !0, s, c)), i != null && (g = t.getRowIndicatorColumn(e, d, i, !1, s, c)), m = t.merge(f, g), m == null)
          throw Ye.getNotFoundInstance();
        var w = m.getBoundingBox();
        if (b && w != null && (w.getMinY() < d.getMinY() || w.getMaxY() > d.getMaxY()))
          d = w;
        else
          break;
      }
      m.setBoundingBox(d);
      var _ = m.getBarcodeColumnCount() + 1;
      m.setDetectionResultColumn(0, f), m.setDetectionResultColumn(_, g);
      for (var A = f != null, T = 1; T <= _; T++) {
        var O = A ? T : _ - T;
        if (m.getDetectionResultColumn(O) === /* null */
        void 0) {
          var R = void 0;
          O === 0 || O === _ ? R = new n$(d, O === 0) : R = new Ree(d), m.setDetectionResultColumn(O, R);
          for (var N = -1, M = N, P = d.getMinY(); P <= d.getMaxY(); P++) {
            if (N = t.getStartColumn(m, O, P, A), N < 0 || N > d.getMaxX()) {
              if (M === -1)
                continue;
              N = M;
            }
            var z = t.detectCodeword(e, d.getMinX(), d.getMaxX(), A, N, P, s, c);
            z != null && (R.setCodeword(P, z), M = N, s = Math.min(s, z.getWidth()), c = Math.max(c, z.getWidth()));
          }
        }
      }
      return t.createDecoderResult(m);
    }, t.merge = function(e, n) {
      if (e == null && n == null)
        return null;
      var r = t.getBarcodeMetadata(e, n);
      if (r == null)
        return null;
      var i = uM.merge(t.adjustBoundingBox(e), t.adjustBoundingBox(n));
      return new kUe(r, i);
    }, t.adjustBoundingBox = function(e) {
      var n, r;
      if (e == null)
        return null;
      var i = e.getRowHeights();
      if (i == null)
        return null;
      var a = t.getMax(i), s = 0;
      try {
        for (var c = qS(i), d = c.next(); !d.done; d = c.next()) {
          var f = d.value;
          if (s += a - f, f > 0)
            break;
        }
      } catch (w) {
        n = { error: w };
      } finally {
        try {
          d && !d.done && (r = c.return) && r.call(c);
        } finally {
          if (n)
            throw n.error;
        }
      }
      for (var g = e.getCodewords(), m = 0; s > 0 && g[m] == null; m++)
        s--;
      for (var b = 0, m = i.length - 1; m >= 0 && (b += a - i[m], !(i[m] > 0)); m--)
        ;
      for (var m = g.length - 1; b > 0 && g[m] == null; m--)
        b--;
      return e.getBoundingBox().addMissingRows(s, b, e.isLeft());
    }, t.getMax = function(e) {
      var n, r, i = -1;
      try {
        for (var a = qS(e), s = a.next(); !s.done; s = a.next()) {
          var c = s.value;
          i = Math.max(i, c);
        }
      } catch (d) {
        n = { error: d };
      } finally {
        try {
          s && !s.done && (r = a.return) && r.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return i;
    }, t.getBarcodeMetadata = function(e, n) {
      var r;
      if (e == null || (r = e.getBarcodeMetadata()) == null)
        return n == null ? null : n.getBarcodeMetadata();
      var i;
      return n == null || (i = n.getBarcodeMetadata()) == null ? r : r.getColumnCount() !== i.getColumnCount() && r.getErrorCorrectionLevel() !== i.getErrorCorrectionLevel() && r.getRowCount() !== i.getRowCount() ? null : r;
    }, t.getRowIndicatorColumn = function(e, n, r, i, a, s) {
      for (var c = new n$(n, i), d = 0; d < 2; d++)
        for (var f = d === 0 ? 1 : -1, g = Math.trunc(Math.trunc(r.getX())), m = Math.trunc(Math.trunc(r.getY())); m <= n.getMaxY() && m >= n.getMinY(); m += f) {
          var b = t.detectCodeword(e, 0, e.getWidth(), i, g, m, a, s);
          b != null && (c.setCodeword(m, b), i ? g = b.getStartX() : g = b.getEndX());
        }
      return c;
    }, t.adjustCodewordCount = function(e, n) {
      var r = n[0][1], i = r.getValue(), a = e.getBarcodeColumnCount() * e.getBarcodeRowCount() - t.getNumberOfECCodeWords(e.getBarcodeECLevel());
      if (i.length === 0) {
        if (a < 1 || a > dr.MAX_CODEWORDS_IN_BARCODE)
          throw Ye.getNotFoundInstance();
        r.setValue(a);
      } else
        i[0] !== a && r.setValue(a);
    }, t.createDecoderResult = function(e) {
      var n = t.createBarcodeMatrix(e);
      t.adjustCodewordCount(e, n);
      for (var r = new Array(), i = new Int32Array(e.getBarcodeRowCount() * e.getBarcodeColumnCount()), a = (
        /*List<int[]>*/
        []
      ), s = (
        /*Collection<Integer>*/
        new Array()
      ), c = 0; c < e.getBarcodeRowCount(); c++)
        for (var d = 0; d < e.getBarcodeColumnCount(); d++) {
          var f = n[c][d + 1].getValue(), g = c * e.getBarcodeColumnCount() + d;
          f.length === 0 ? r.push(g) : f.length === 1 ? i[g] = f[0] : (s.push(g), a.push(f));
        }
      for (var m = new Array(a.length), b = 0; b < m.length; b++)
        m[b] = a[b];
      return t.createDecoderResultFromAmbiguousValues(e.getBarcodeECLevel(), i, dr.toIntArray(r), dr.toIntArray(s), m);
    }, t.createDecoderResultFromAmbiguousValues = function(e, n, r, i, a) {
      for (var s = new Int32Array(i.length), c = 100; c-- > 0; ) {
        for (var d = 0; d < s.length; d++)
          n[i[d]] = a[d][s[d]];
        try {
          return t.decodeCodewords(n, e, r);
        } catch (g) {
          var f = g instanceof uo;
          if (!f)
            throw g;
        }
        if (s.length === 0)
          throw uo.getChecksumInstance();
        for (var d = 0; d < s.length; d++)
          if (s[d] < a[d].length - 1) {
            s[d]++;
            break;
          } else if (s[d] = 0, d === s.length - 1)
            throw uo.getChecksumInstance();
      }
      throw uo.getChecksumInstance();
    }, t.createBarcodeMatrix = function(e) {
      for (var n, r, i, a, s = Array.from({ length: e.getBarcodeRowCount() }, function() {
        return new Array(e.getBarcodeColumnCount() + 2);
      }), c = 0; c < s.length; c++)
        for (var d = 0; d < s[c].length; d++)
          s[c][d] = new sE();
      var f = 0;
      try {
        for (var g = qS(e.getDetectionResultColumns()), m = g.next(); !m.done; m = g.next()) {
          var b = m.value;
          if (b != null)
            try {
              for (var w = (i = void 0, qS(b.getCodewords())), _ = w.next(); !_.done; _ = w.next()) {
                var A = _.value;
                if (A != null) {
                  var T = A.getRowNumber();
                  if (T >= 0) {
                    if (T >= s.length)
                      continue;
                    s[T][f].setValue(A.getValue());
                  }
                }
              }
            } catch (O) {
              i = { error: O };
            } finally {
              try {
                _ && !_.done && (a = w.return) && a.call(w);
              } finally {
                if (i)
                  throw i.error;
              }
            }
          f++;
        }
      } catch (O) {
        n = { error: O };
      } finally {
        try {
          m && !m.done && (r = g.return) && r.call(g);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return s;
    }, t.isValidBarcodeColumn = function(e, n) {
      return n >= 0 && n <= e.getBarcodeColumnCount() + 1;
    }, t.getStartColumn = function(e, n, r, i) {
      var a, s, c = i ? 1 : -1, d = null;
      if (t.isValidBarcodeColumn(e, n - c) && (d = e.getDetectionResultColumn(n - c).getCodeword(r)), d != null)
        return i ? d.getEndX() : d.getStartX();
      if (d = e.getDetectionResultColumn(n).getCodewordNearby(r), d != null)
        return i ? d.getStartX() : d.getEndX();
      if (t.isValidBarcodeColumn(e, n - c) && (d = e.getDetectionResultColumn(n - c).getCodewordNearby(r)), d != null)
        return i ? d.getEndX() : d.getStartX();
      for (var f = 0; t.isValidBarcodeColumn(e, n - c); ) {
        n -= c;
        try {
          for (var g = (a = void 0, qS(e.getDetectionResultColumn(n).getCodewords())), m = g.next(); !m.done; m = g.next()) {
            var b = m.value;
            if (b != null)
              return (i ? b.getEndX() : b.getStartX()) + c * f * (b.getEndX() - b.getStartX());
          }
        } catch (w) {
          a = { error: w };
        } finally {
          try {
            m && !m.done && (s = g.return) && s.call(g);
          } finally {
            if (a)
              throw a.error;
          }
        }
        f++;
      }
      return i ? e.getBoundingBox().getMinX() : e.getBoundingBox().getMaxX();
    }, t.detectCodeword = function(e, n, r, i, a, s, c, d) {
      a = t.adjustCodewordStartColumn(e, n, r, i, a, s);
      var f = t.getModuleBitCount(e, n, r, i, a, s);
      if (f == null)
        return null;
      var g, m = gr.sum(f);
      if (i)
        g = a + m;
      else {
        for (var b = 0; b < f.length / 2; b++) {
          var w = f[b];
          f[b] = f[f.length - 1 - b], f[f.length - 1 - b] = w;
        }
        g = a, a = g - m;
      }
      if (!t.checkCodewordSkew(m, c, d))
        return null;
      var _ = PUe.getDecodedValue(f), A = dr.getCodeword(_);
      return A === -1 ? null : new jUe(a, g, t.getCodewordBucketNumber(_), A);
    }, t.getModuleBitCount = function(e, n, r, i, a, s) {
      for (var c = a, d = new Int32Array(8), f = 0, g = i ? 1 : -1, m = i; (i ? c < r : c >= n) && f < d.length; )
        e.get(c, s) === m ? (d[f]++, c += g) : (f++, m = !m);
      return f === d.length || c === (i ? r : n) && f === d.length - 1 ? d : null;
    }, t.getNumberOfECCodeWords = function(e) {
      return 2 << e;
    }, t.adjustCodewordStartColumn = function(e, n, r, i, a, s) {
      for (var c = a, d = i ? -1 : 1, f = 0; f < 2; f++) {
        for (; (i ? c >= n : c < r) && i === e.get(c, s); ) {
          if (Math.abs(a - c) > t.CODEWORD_SKEW_SIZE)
            return a;
          c += d;
        }
        d = -d, i = !i;
      }
      return c;
    }, t.checkCodewordSkew = function(e, n, r) {
      return n - t.CODEWORD_SKEW_SIZE <= e && e <= r + t.CODEWORD_SKEW_SIZE;
    }, t.decodeCodewords = function(e, n, r) {
      if (e.length === 0)
        throw ht.getFormatInstance();
      var i = 1 << n + 1, a = t.correctErrors(e, r, i);
      t.verifyCodewordCount(e, i);
      var s = GUe.decode(e, "" + n);
      return s.setErrorsCorrected(a), s.setErasures(r.length), s;
    }, t.correctErrors = function(e, n, r) {
      if (n != null && n.length > r / 2 + t.MAX_ERRORS || r < 0 || r > t.MAX_EC_CODEWORDS)
        throw uo.getChecksumInstance();
      return t.errorCorrection.decode(e, r, n);
    }, t.verifyCodewordCount = function(e, n) {
      if (e.length < 4)
        throw ht.getFormatInstance();
      var r = e[0];
      if (r > e.length)
        throw ht.getFormatInstance();
      if (r === 0)
        if (n < e.length)
          e[0] = e.length - n;
        else
          throw ht.getFormatInstance();
    }, t.getBitCountForCodeword = function(e) {
      for (var n = new Int32Array(8), r = 0, i = n.length - 1; !((e & 1) !== r && (r = e & 1, i--, i < 0)); )
        n[i]++, e >>= 1;
      return n;
    }, t.getCodewordBucketNumber = function(e) {
      return e instanceof Int32Array ? this.getCodewordBucketNumber_Int32Array(e) : this.getCodewordBucketNumber_number(e);
    }, t.getCodewordBucketNumber_number = function(e) {
      return t.getCodewordBucketNumber(t.getBitCountForCodeword(e));
    }, t.getCodewordBucketNumber_Int32Array = function(e) {
      return (e[0] - e[2] + e[4] - e[6] + 9) % 9;
    }, t.toString = function(e) {
      for (var n = new Wk(), r = 0; r < e.length; r++) {
        n.format("Row %2d: ", r);
        for (var i = 0; i < e[r].length; i++) {
          var a = e[r][i];
          a.getValue().length === 0 ? n.format("        ", null) : n.format("%4d(%2d)", a.getValue()[0], a.getConfidence(a.getValue()[0]));
        }
        n.format("%n");
      }
      return n.toString();
    }, t.CODEWORD_SKEW_SIZE = 2, t.MAX_ERRORS = 3, t.MAX_EC_CODEWORDS = 512, t.errorCorrection = new TUe(), t;
  }()
), XUe = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, dM = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.decode = function(e, n) {
      n === void 0 && (n = null);
      var r = t.decode(e, n, !1);
      if (r == null || r.length === 0 || r[0] == null)
        throw Ye.getNotFoundInstance();
      return r[0];
    }, t.prototype.decodeMultiple = function(e, n) {
      n === void 0 && (n = null);
      try {
        return t.decode(e, n, !0);
      } catch (r) {
        throw r instanceof ht || r instanceof uo ? Ye.getNotFoundInstance() : r;
      }
    }, t.decode = function(e, n, r) {
      var i, a, s = new Array(), c = xUe.detectMultiple(e, n, r);
      try {
        for (var d = XUe(c.getPoints()), f = d.next(); !f.done; f = d.next()) {
          var g = f.value, m = YUe.decode(c.getBits(), g[4], g[5], g[6], g[7], t.getMinCodewordWidth(g), t.getMaxCodewordWidth(g)), b = new ts(m.getText(), m.getRawBytes(), void 0, g, Ht.PDF_417);
          b.putMetadata(jo.ERROR_CORRECTION_LEVEL, m.getECLevel());
          var w = m.getOther();
          w != null && b.putMetadata(jo.PDF417_EXTRA_METADATA, w), s.push(b);
        }
      } catch (_) {
        i = { error: _ };
      } finally {
        try {
          f && !f.done && (a = d.return) && a.call(d);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return s.map(function(_) {
        return _;
      });
    }, t.getMaxWidth = function(e, n) {
      return e == null || n == null ? 0 : Math.trunc(Math.abs(e.getX() - n.getX()));
    }, t.getMinWidth = function(e, n) {
      return e == null || n == null ? Vn.MAX_VALUE : Math.trunc(Math.abs(e.getX() - n.getX()));
    }, t.getMaxCodewordWidth = function(e) {
      return Math.floor(Math.max(Math.max(t.getMaxWidth(e[0], e[4]), t.getMaxWidth(e[6], e[2]) * dr.MODULES_IN_CODEWORD / dr.MODULES_IN_STOP_PATTERN), Math.max(t.getMaxWidth(e[1], e[5]), t.getMaxWidth(e[7], e[3]) * dr.MODULES_IN_CODEWORD / dr.MODULES_IN_STOP_PATTERN)));
    }, t.getMinCodewordWidth = function(e) {
      return Math.floor(Math.min(Math.min(t.getMinWidth(e[0], e[4]), t.getMinWidth(e[6], e[2]) * dr.MODULES_IN_CODEWORD / dr.MODULES_IN_STOP_PATTERN), Math.min(t.getMinWidth(e[1], e[5]), t.getMinWidth(e[7], e[3]) * dr.MODULES_IN_CODEWORD / dr.MODULES_IN_STOP_PATTERN)));
    }, t.prototype.reset = function() {
    }, t;
  }()
), WUe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), i$ = (
  /** @class */
  function(t) {
    WUe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.kind = "ReaderException", e;
  }(hl)
), a$ = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, QUe = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.decode = function(e, n) {
      return this.setHints(n), this.decodeInternal(e);
    }, t.prototype.decodeWithState = function(e) {
      return (this.readers === null || this.readers === void 0) && this.setHints(null), this.decodeInternal(e);
    }, t.prototype.setHints = function(e) {
      this.hints = e;
      var n = e != null && e.get(Ui.TRY_HARDER) !== void 0, r = e == null ? null : e.get(Ui.POSSIBLE_FORMATS), i = new Array();
      if (r != null) {
        var a = r.some(function(s) {
          return s === Ht.UPC_A || s === Ht.UPC_E || s === Ht.EAN_13 || s === Ht.EAN_8 || s === Ht.CODABAR || s === Ht.CODE_39 || s === Ht.CODE_93 || s === Ht.CODE_128 || s === Ht.ITF || s === Ht.RSS_14 || s === Ht.RSS_EXPANDED;
        });
        a && !n && i.push(new oE(e)), r.includes(Ht.QR_CODE) && i.push(new cM()), r.includes(Ht.DATA_MATRIX) && i.push(new lM()), r.includes(Ht.AZTEC) && i.push(new oM()), r.includes(Ht.PDF_417) && i.push(new dM()), a && n && i.push(new oE(e));
      }
      i.length === 0 && (n || i.push(new oE(e)), i.push(new cM()), i.push(new lM()), i.push(new oM()), i.push(new dM()), n && i.push(new oE(e))), this.readers = i;
    }, t.prototype.reset = function() {
      var e, n;
      if (this.readers !== null)
        try {
          for (var r = a$(this.readers), i = r.next(); !i.done; i = r.next()) {
            var a = i.value;
            a.reset();
          }
        } catch (s) {
          e = { error: s };
        } finally {
          try {
            i && !i.done && (n = r.return) && n.call(r);
          } finally {
            if (e)
              throw e.error;
          }
        }
    }, t.prototype.decodeInternal = function(e) {
      var n, r;
      if (this.readers === null)
        throw new i$("No readers where selected, nothing can be read.");
      try {
        for (var i = a$(this.readers), a = i.next(); !a.done; a = i.next()) {
          var s = a.value;
          try {
            return s.decode(e, this.hints);
          } catch (c) {
            if (c instanceof i$)
              continue;
          }
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (r = i.return) && r.call(i);
        } finally {
          if (n)
            throw n.error;
        }
      }
      throw new Ye("No MultiFormat Readers were able to detect the code.");
    }, t;
  }()
), ZUe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), KUe = (
  /** @class */
  function(t) {
    ZUe(e, t);
    function e(n, r) {
      n === void 0 && (n = null), r === void 0 && (r = 500);
      var i = this, a = new QUe();
      return a.setHints(n), i = t.call(this, a, r) || this, i;
    }
    return e.prototype.decodeBitmap = function(n) {
      return this.reader.decodeWithState(n);
    }, e;
  }(Rw)
), JUe = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}();
(function(t) {
  JUe(e, t);
  function e(n) {
    return n === void 0 && (n = 500), t.call(this, new dM(), n) || this;
  }
  return e;
})(Rw);
var e$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}();
(function(t) {
  e$e(e, t);
  function e(n) {
    return n === void 0 && (n = 500), t.call(this, new cM(), n) || this;
  }
  return e;
})(Rw);
var fM;
(function(t) {
  t[t.ERROR_CORRECTION = 0] = "ERROR_CORRECTION", t[t.CHARACTER_SET = 1] = "CHARACTER_SET", t[t.DATA_MATRIX_SHAPE = 2] = "DATA_MATRIX_SHAPE", t[t.DATA_MATRIX_COMPACT = 3] = "DATA_MATRIX_COMPACT", t[t.MIN_SIZE = 4] = "MIN_SIZE", t[t.MAX_SIZE = 5] = "MAX_SIZE", t[t.MARGIN = 6] = "MARGIN", t[t.PDF417_COMPACT = 7] = "PDF417_COMPACT", t[t.PDF417_COMPACTION = 8] = "PDF417_COMPACTION", t[t.PDF417_DIMENSIONS = 9] = "PDF417_DIMENSIONS", t[t.AZTEC_LAYERS = 10] = "AZTEC_LAYERS", t[t.QR_VERSION = 11] = "QR_VERSION", t[t.GS1_FORMAT = 12] = "GS1_FORMAT", t[t.FORCE_C40 = 13] = "FORCE_C40";
})(fM || (fM = {}));
const JC = fM;
var Nee = (
  /** @class */
  function() {
    function t(e) {
      this.field = e, this.cachedGenerators = [], this.cachedGenerators.push(new B0(e, Int32Array.from([1])));
    }
    return t.prototype.buildGenerator = function(e) {
      var n = this.cachedGenerators;
      if (e >= n.length)
        for (var r = n[n.length - 1], i = this.field, a = n.length; a <= e; a++) {
          var s = r.multiply(new B0(i, Int32Array.from([1, i.exp(a - 1 + i.getGeneratorBase())])));
          n.push(s), r = s;
        }
      return n[e];
    }, t.prototype.encode = function(e, n) {
      if (n === 0)
        throw new Yt("No error correction bytes");
      var r = e.length - n;
      if (r <= 0)
        throw new Yt("No data bytes provided");
      var i = this.buildGenerator(n), a = new Int32Array(r);
      si.arraycopy(e, 0, a, 0, r);
      var s = new B0(this.field, a);
      s = s.multiplyByMonomial(n, 1);
      for (var c = s.divide(i)[1], d = c.getCoefficients(), f = n - d.length, g = 0; g < f; g++)
        e[r + g] = 0;
      si.arraycopy(d, 0, e, r + f, d.length);
    }, t;
  }()
), lE = (
  /** @class */
  function() {
    function t() {
    }
    return t.applyMaskPenaltyRule1 = function(e) {
      return t.applyMaskPenaltyRule1Internal(e, !0) + t.applyMaskPenaltyRule1Internal(e, !1);
    }, t.applyMaskPenaltyRule2 = function(e) {
      for (var n = 0, r = e.getArray(), i = e.getWidth(), a = e.getHeight(), s = 0; s < a - 1; s++)
        for (var c = r[s], d = 0; d < i - 1; d++) {
          var f = c[d];
          f === c[d + 1] && f === r[s + 1][d] && f === r[s + 1][d + 1] && n++;
        }
      return t.N2 * n;
    }, t.applyMaskPenaltyRule3 = function(e) {
      for (var n = 0, r = e.getArray(), i = e.getWidth(), a = e.getHeight(), s = 0; s < a; s++)
        for (var c = 0; c < i; c++) {
          var d = r[s];
          c + 6 < i && d[c] === 1 && d[c + 1] === 0 && d[c + 2] === 1 && d[c + 3] === 1 && d[c + 4] === 1 && d[c + 5] === 0 && d[c + 6] === 1 && (t.isWhiteHorizontal(d, c - 4, c) || t.isWhiteHorizontal(d, c + 7, c + 11)) && n++, s + 6 < a && r[s][c] === 1 && r[s + 1][c] === 0 && r[s + 2][c] === 1 && r[s + 3][c] === 1 && r[s + 4][c] === 1 && r[s + 5][c] === 0 && r[s + 6][c] === 1 && (t.isWhiteVertical(r, c, s - 4, s) || t.isWhiteVertical(r, c, s + 7, s + 11)) && n++;
        }
      return n * t.N3;
    }, t.isWhiteHorizontal = function(e, n, r) {
      n = Math.max(n, 0), r = Math.min(r, e.length);
      for (var i = n; i < r; i++)
        if (e[i] === 1)
          return !1;
      return !0;
    }, t.isWhiteVertical = function(e, n, r, i) {
      r = Math.max(r, 0), i = Math.min(i, e.length);
      for (var a = r; a < i; a++)
        if (e[a][n] === 1)
          return !1;
      return !0;
    }, t.applyMaskPenaltyRule4 = function(e) {
      for (var n = 0, r = e.getArray(), i = e.getWidth(), a = e.getHeight(), s = 0; s < a; s++)
        for (var c = r[s], d = 0; d < i; d++)
          c[d] === 1 && n++;
      var f = e.getHeight() * e.getWidth(), g = Math.floor(Math.abs(n * 2 - f) * 10 / f);
      return g * t.N4;
    }, t.getDataMaskBit = function(e, n, r) {
      var i, a;
      switch (e) {
        case 0:
          i = r + n & 1;
          break;
        case 1:
          i = r & 1;
          break;
        case 2:
          i = n % 3;
          break;
        case 3:
          i = (r + n) % 3;
          break;
        case 4:
          i = Math.floor(r / 2) + Math.floor(n / 3) & 1;
          break;
        case 5:
          a = r * n, i = (a & 1) + a % 3;
          break;
        case 6:
          a = r * n, i = (a & 1) + a % 3 & 1;
          break;
        case 7:
          a = r * n, i = a % 3 + (r + n & 1) & 1;
          break;
        default:
          throw new Yt("Invalid mask pattern: " + e);
      }
      return i === 0;
    }, t.applyMaskPenaltyRule1Internal = function(e, n) {
      for (var r = 0, i = n ? e.getHeight() : e.getWidth(), a = n ? e.getWidth() : e.getHeight(), s = e.getArray(), c = 0; c < i; c++) {
        for (var d = 0, f = -1, g = 0; g < a; g++) {
          var m = n ? s[c][g] : s[g][c];
          m === f ? d++ : (d >= 5 && (r += t.N1 + (d - 5)), d = 1, f = m);
        }
        d >= 5 && (r += t.N1 + (d - 5));
      }
      return r;
    }, t.N1 = 3, t.N2 = 3, t.N3 = 40, t.N4 = 10, t;
  }()
), t$e = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, n$e = (
  /** @class */
  function() {
    function t(e, n) {
      this.width = e, this.height = n;
      for (var r = new Array(n), i = 0; i !== n; i++)
        r[i] = new Uint8Array(e);
      this.bytes = r;
    }
    return t.prototype.getHeight = function() {
      return this.height;
    }, t.prototype.getWidth = function() {
      return this.width;
    }, t.prototype.get = function(e, n) {
      return this.bytes[n][e];
    }, t.prototype.getArray = function() {
      return this.bytes;
    }, t.prototype.setNumber = function(e, n, r) {
      this.bytes[n][e] = r;
    }, t.prototype.setBoolean = function(e, n, r) {
      this.bytes[n][e] = /*(byte) */
      r ? 1 : 0;
    }, t.prototype.clear = function(e) {
      var n, r;
      try {
        for (var i = t$e(this.bytes), a = i.next(); !a.done; a = i.next()) {
          var s = a.value;
          qa.fill(s, e);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (r = i.return) && r.call(i);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, t.prototype.equals = function(e) {
      if (!(e instanceof t))
        return !1;
      var n = e;
      if (this.width !== n.width || this.height !== n.height)
        return !1;
      for (var r = 0, i = this.height; r < i; ++r)
        for (var a = this.bytes[r], s = n.bytes[r], c = 0, d = this.width; c < d; ++c)
          if (a[c] !== s[c])
            return !1;
      return !0;
    }, t.prototype.toString = function() {
      for (var e = new Bn(), n = 0, r = this.height; n < r; ++n) {
        for (var i = this.bytes[n], a = 0, s = this.width; a < s; ++a)
          switch (i[a]) {
            case 0:
              e.append(" 0");
              break;
            case 1:
              e.append(" 1");
              break;
            default:
              e.append("  ");
              break;
          }
        e.append(`
`);
      }
      return e.toString();
    }, t;
  }()
), hM = (
  /** @class */
  function() {
    function t() {
      this.maskPattern = -1;
    }
    return t.prototype.getMode = function() {
      return this.mode;
    }, t.prototype.getECLevel = function() {
      return this.ecLevel;
    }, t.prototype.getVersion = function() {
      return this.version;
    }, t.prototype.getMaskPattern = function() {
      return this.maskPattern;
    }, t.prototype.getMatrix = function() {
      return this.matrix;
    }, t.prototype.toString = function() {
      var e = new Bn();
      return e.append(`<<
`), e.append(" mode: "), e.append(this.mode ? this.mode.toString() : "null"), e.append(`
 ecLevel: `), e.append(this.ecLevel ? this.ecLevel.toString() : "null"), e.append(`
 version: `), e.append(this.version ? this.version.toString() : "null"), e.append(`
 maskPattern: `), e.append(this.maskPattern.toString()), this.matrix ? (e.append(`
 matrix:
`), e.append(this.matrix.toString())) : e.append(`
 matrix: null
`), e.append(`>>
`), e.toString();
    }, t.prototype.setMode = function(e) {
      this.mode = e;
    }, t.prototype.setECLevel = function(e) {
      this.ecLevel = e;
    }, t.prototype.setVersion = function(e) {
      this.version = e;
    }, t.prototype.setMaskPattern = function(e) {
      this.maskPattern = e;
    }, t.prototype.setMatrix = function(e) {
      this.matrix = e;
    }, t.isValidMaskPattern = function(e) {
      return e >= 0 && e < t.NUM_MASK_PATTERNS;
    }, t.NUM_MASK_PATTERNS = 8, t;
  }()
), r$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), mi = (
  /** @class */
  function(t) {
    r$e(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.kind = "WriterException", e;
  }(hl)
), o$ = (
  /** @class */
  function() {
    function t() {
    }
    return t.clearMatrix = function(e) {
      e.clear(
        /*(byte) */
        /*-1*/
        255
      );
    }, t.buildMatrix = function(e, n, r, i, a) {
      t.clearMatrix(a), t.embedBasicPatterns(r, a), t.embedTypeInfo(n, i, a), t.maybeEmbedVersionInfo(r, a), t.embedDataBits(e, i, a);
    }, t.embedBasicPatterns = function(e, n) {
      t.embedPositionDetectionPatternsAndSeparators(n), t.embedDarkDotAtLeftBottomCorner(n), t.maybeEmbedPositionAdjustmentPatterns(e, n), t.embedTimingPatterns(n);
    }, t.embedTypeInfo = function(e, n, r) {
      var i = new fo();
      t.makeTypeInfoBits(e, n, i);
      for (var a = 0, s = i.getSize(); a < s; ++a) {
        var c = i.get(i.getSize() - 1 - a), d = t.TYPE_INFO_COORDINATES[a], f = d[0], g = d[1];
        if (r.setBoolean(f, g, c), a < 8) {
          var m = r.getWidth() - a - 1, b = 8;
          r.setBoolean(m, b, c);
        } else {
          var m = 8, b = r.getHeight() - 7 + (a - 8);
          r.setBoolean(m, b, c);
        }
      }
    }, t.maybeEmbedVersionInfo = function(e, n) {
      if (!(e.getVersionNumber() < 7)) {
        var r = new fo();
        t.makeVersionInfoBits(e, r);
        for (var i = 6 * 3 - 1, a = 0; a < 6; ++a)
          for (var s = 0; s < 3; ++s) {
            var c = r.get(i);
            i--, n.setBoolean(a, n.getHeight() - 11 + s, c), n.setBoolean(n.getHeight() - 11 + s, a, c);
          }
      }
    }, t.embedDataBits = function(e, n, r) {
      for (var i = 0, a = -1, s = r.getWidth() - 1, c = r.getHeight() - 1; s > 0; ) {
        for (s === 6 && (s -= 1); c >= 0 && c < r.getHeight(); ) {
          for (var d = 0; d < 2; ++d) {
            var f = s - d;
            if (t.isEmpty(r.get(f, c))) {
              var g = void 0;
              i < e.getSize() ? (g = e.get(i), ++i) : g = !1, n !== 255 && lE.getDataMaskBit(n, f, c) && (g = !g), r.setBoolean(f, c, g);
            }
          }
          c += a;
        }
        a = -a, c += a, s -= 2;
      }
      if (i !== e.getSize())
        throw new mi("Not all bits consumed: " + i + "/" + e.getSize());
    }, t.findMSBSet = function(e) {
      return 32 - Vn.numberOfLeadingZeros(e);
    }, t.calculateBCHCode = function(e, n) {
      if (n === 0)
        throw new Yt("0 polynomial");
      var r = t.findMSBSet(n);
      for (e <<= r - 1; t.findMSBSet(e) >= r; )
        e ^= n << t.findMSBSet(e) - r;
      return e;
    }, t.makeTypeInfoBits = function(e, n, r) {
      if (!hM.isValidMaskPattern(n))
        throw new mi("Invalid mask pattern");
      var i = e.getBits() << 3 | n;
      r.appendBits(i, 5);
      var a = t.calculateBCHCode(i, t.TYPE_INFO_POLY);
      r.appendBits(a, 10);
      var s = new fo();
      if (s.appendBits(t.TYPE_INFO_MASK_PATTERN, 15), r.xor(s), r.getSize() !== 15)
        throw new mi("should not happen but we got: " + r.getSize());
    }, t.makeVersionInfoBits = function(e, n) {
      n.appendBits(e.getVersionNumber(), 6);
      var r = t.calculateBCHCode(e.getVersionNumber(), t.VERSION_INFO_POLY);
      if (n.appendBits(r, 12), n.getSize() !== 18)
        throw new mi("should not happen but we got: " + n.getSize());
    }, t.isEmpty = function(e) {
      return e === 255;
    }, t.embedTimingPatterns = function(e) {
      for (var n = 8; n < e.getWidth() - 8; ++n) {
        var r = (n + 1) % 2;
        t.isEmpty(e.get(n, 6)) && e.setNumber(n, 6, r), t.isEmpty(e.get(6, n)) && e.setNumber(6, n, r);
      }
    }, t.embedDarkDotAtLeftBottomCorner = function(e) {
      if (e.get(8, e.getHeight() - 8) === 0)
        throw new mi();
      e.setNumber(8, e.getHeight() - 8, 1);
    }, t.embedHorizontalSeparationPattern = function(e, n, r) {
      for (var i = 0; i < 8; ++i) {
        if (!t.isEmpty(r.get(e + i, n)))
          throw new mi();
        r.setNumber(e + i, n, 0);
      }
    }, t.embedVerticalSeparationPattern = function(e, n, r) {
      for (var i = 0; i < 7; ++i) {
        if (!t.isEmpty(r.get(e, n + i)))
          throw new mi();
        r.setNumber(e, n + i, 0);
      }
    }, t.embedPositionAdjustmentPattern = function(e, n, r) {
      for (var i = 0; i < 5; ++i)
        for (var a = t.POSITION_ADJUSTMENT_PATTERN[i], s = 0; s < 5; ++s)
          r.setNumber(e + s, n + i, a[s]);
    }, t.embedPositionDetectionPattern = function(e, n, r) {
      for (var i = 0; i < 7; ++i)
        for (var a = t.POSITION_DETECTION_PATTERN[i], s = 0; s < 7; ++s)
          r.setNumber(e + s, n + i, a[s]);
    }, t.embedPositionDetectionPatternsAndSeparators = function(e) {
      var n = t.POSITION_DETECTION_PATTERN[0].length;
      t.embedPositionDetectionPattern(0, 0, e), t.embedPositionDetectionPattern(e.getWidth() - n, 0, e), t.embedPositionDetectionPattern(0, e.getWidth() - n, e);
      var r = 8;
      t.embedHorizontalSeparationPattern(0, r - 1, e), t.embedHorizontalSeparationPattern(e.getWidth() - r, r - 1, e), t.embedHorizontalSeparationPattern(0, e.getWidth() - r, e);
      var i = 7;
      t.embedVerticalSeparationPattern(i, 0, e), t.embedVerticalSeparationPattern(e.getHeight() - i - 1, 0, e), t.embedVerticalSeparationPattern(i, e.getHeight() - i, e);
    }, t.maybeEmbedPositionAdjustmentPatterns = function(e, n) {
      if (!(e.getVersionNumber() < 2))
        for (var r = e.getVersionNumber() - 1, i = t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[r], a = 0, s = i.length; a !== s; a++) {
          var c = i[a];
          if (c >= 0)
            for (var d = 0; d !== s; d++) {
              var f = i[d];
              f >= 0 && t.isEmpty(n.get(f, c)) && t.embedPositionAdjustmentPattern(f - 2, c - 2, n);
            }
        }
    }, t.POSITION_DETECTION_PATTERN = Array.from([
      Int32Array.from([1, 1, 1, 1, 1, 1, 1]),
      Int32Array.from([1, 0, 0, 0, 0, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 0, 0, 0, 0, 1]),
      Int32Array.from([1, 1, 1, 1, 1, 1, 1])
    ]), t.POSITION_ADJUSTMENT_PATTERN = Array.from([
      Int32Array.from([1, 1, 1, 1, 1]),
      Int32Array.from([1, 0, 0, 0, 1]),
      Int32Array.from([1, 0, 1, 0, 1]),
      Int32Array.from([1, 0, 0, 0, 1]),
      Int32Array.from([1, 1, 1, 1, 1])
    ]), t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
      Int32Array.from([-1, -1, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 18, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 22, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 26, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 30, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 34, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 22, 38, -1, -1, -1, -1]),
      Int32Array.from([6, 24, 42, -1, -1, -1, -1]),
      Int32Array.from([6, 26, 46, -1, -1, -1, -1]),
      Int32Array.from([6, 28, 50, -1, -1, -1, -1]),
      Int32Array.from([6, 30, 54, -1, -1, -1, -1]),
      Int32Array.from([6, 32, 58, -1, -1, -1, -1]),
      Int32Array.from([6, 34, 62, -1, -1, -1, -1]),
      Int32Array.from([6, 26, 46, 66, -1, -1, -1]),
      Int32Array.from([6, 26, 48, 70, -1, -1, -1]),
      Int32Array.from([6, 26, 50, 74, -1, -1, -1]),
      Int32Array.from([6, 30, 54, 78, -1, -1, -1]),
      Int32Array.from([6, 30, 56, 82, -1, -1, -1]),
      Int32Array.from([6, 30, 58, 86, -1, -1, -1]),
      Int32Array.from([6, 34, 62, 90, -1, -1, -1]),
      Int32Array.from([6, 28, 50, 72, 94, -1, -1]),
      Int32Array.from([6, 26, 50, 74, 98, -1, -1]),
      Int32Array.from([6, 30, 54, 78, 102, -1, -1]),
      Int32Array.from([6, 28, 54, 80, 106, -1, -1]),
      Int32Array.from([6, 32, 58, 84, 110, -1, -1]),
      Int32Array.from([6, 30, 58, 86, 114, -1, -1]),
      Int32Array.from([6, 34, 62, 90, 118, -1, -1]),
      Int32Array.from([6, 26, 50, 74, 98, 122, -1]),
      Int32Array.from([6, 30, 54, 78, 102, 126, -1]),
      Int32Array.from([6, 26, 52, 78, 104, 130, -1]),
      Int32Array.from([6, 30, 56, 82, 108, 134, -1]),
      Int32Array.from([6, 34, 60, 86, 112, 138, -1]),
      Int32Array.from([6, 30, 58, 86, 114, 142, -1]),
      Int32Array.from([6, 34, 62, 90, 118, 146, -1]),
      Int32Array.from([6, 30, 54, 78, 102, 126, 150]),
      Int32Array.from([6, 24, 50, 76, 102, 128, 154]),
      Int32Array.from([6, 28, 54, 80, 106, 132, 158]),
      Int32Array.from([6, 32, 58, 84, 110, 136, 162]),
      Int32Array.from([6, 26, 54, 82, 110, 138, 166]),
      Int32Array.from([6, 30, 58, 86, 114, 142, 170])
    ]), t.TYPE_INFO_COORDINATES = Array.from([
      Int32Array.from([8, 0]),
      Int32Array.from([8, 1]),
      Int32Array.from([8, 2]),
      Int32Array.from([8, 3]),
      Int32Array.from([8, 4]),
      Int32Array.from([8, 5]),
      Int32Array.from([8, 7]),
      Int32Array.from([8, 8]),
      Int32Array.from([7, 8]),
      Int32Array.from([5, 8]),
      Int32Array.from([4, 8]),
      Int32Array.from([3, 8]),
      Int32Array.from([2, 8]),
      Int32Array.from([1, 8]),
      Int32Array.from([0, 8])
    ]), t.VERSION_INFO_POLY = 7973, t.TYPE_INFO_POLY = 1335, t.TYPE_INFO_MASK_PATTERN = 21522, t;
  }()
), i$e = (
  /** @class */
  function() {
    function t(e, n) {
      this.dataBytes = e, this.errorCorrectionBytes = n;
    }
    return t.prototype.getDataBytes = function() {
      return this.dataBytes;
    }, t.prototype.getErrorCorrectionBytes = function() {
      return this.errorCorrectionBytes;
    }, t;
  }()
), s$ = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function() {
  function t() {
  }
  return t.calculateMaskPenalty = function(e) {
    return lE.applyMaskPenaltyRule1(e) + lE.applyMaskPenaltyRule2(e) + lE.applyMaskPenaltyRule3(e) + lE.applyMaskPenaltyRule4(e);
  }, t.encode = function(e, n, r) {
    r === void 0 && (r = null);
    var i = t.DEFAULT_BYTE_MODE_ENCODING, a = r !== null && r.get(JC.CHARACTER_SET) !== void 0;
    a && (i = r.get(JC.CHARACTER_SET).toString());
    var s = this.chooseMode(e, i), c = new fo();
    if (s === vi.BYTE && (a || t.DEFAULT_BYTE_MODE_ENCODING !== i)) {
      var d = Ha.getCharacterSetECIByName(i);
      d !== void 0 && this.appendECI(d, c);
    }
    this.appendModeInfo(s, c);
    var f = new fo();
    this.appendBytes(e, s, f, i);
    var g;
    if (r !== null && r.get(JC.QR_VERSION) !== void 0) {
      var m = Number.parseInt(r.get(JC.QR_VERSION).toString(), 10);
      g = fg.getVersionForNumber(m);
      var b = this.calculateBitsNeeded(s, c, f, g);
      if (!this.willFit(b, g, n))
        throw new mi("Data too big for requested version");
    } else
      g = this.recommendVersion(n, s, c, f);
    var w = new fo();
    w.appendBitArray(c);
    var _ = s === vi.BYTE ? f.getSizeInBytes() : e.length;
    this.appendLengthInfo(_, g, s, w), w.appendBitArray(f);
    var A = g.getECBlocksForLevel(n), T = g.getTotalCodewords() - A.getTotalECCodewords();
    this.terminateBits(T, w);
    var O = this.interleaveWithECBytes(w, g.getTotalCodewords(), T, A.getNumBlocks()), R = new hM();
    R.setECLevel(n), R.setMode(s), R.setVersion(g);
    var N = g.getDimensionForVersion(), M = new n$e(N, N), P = this.chooseMaskPattern(O, n, g, M);
    return R.setMaskPattern(P), o$.buildMatrix(O, n, g, P, M), R.setMatrix(M), R;
  }, t.recommendVersion = function(e, n, r, i) {
    var a = this.calculateBitsNeeded(n, r, i, fg.getVersionForNumber(1)), s = this.chooseVersion(a, e), c = this.calculateBitsNeeded(n, r, i, s);
    return this.chooseVersion(c, e);
  }, t.calculateBitsNeeded = function(e, n, r, i) {
    return n.getSize() + e.getCharacterCountBits(i) + r.getSize();
  }, t.getAlphanumericCode = function(e) {
    return e < t.ALPHANUMERIC_TABLE.length ? t.ALPHANUMERIC_TABLE[e] : -1;
  }, t.chooseMode = function(e, n) {
    if (n === void 0 && (n = null), Ha.SJIS.getName() === n && this.isOnlyDoubleByteKanji(e))
      return vi.KANJI;
    for (var r = !1, i = !1, a = 0, s = e.length; a < s; ++a) {
      var c = e.charAt(a);
      if (t.isDigit(c))
        r = !0;
      else if (this.getAlphanumericCode(c.charCodeAt(0)) !== -1)
        i = !0;
      else
        return vi.BYTE;
    }
    return i ? vi.ALPHANUMERIC : r ? vi.NUMERIC : vi.BYTE;
  }, t.isOnlyDoubleByteKanji = function(e) {
    var n;
    try {
      n = Jc.encode(e, Ha.SJIS);
    } catch {
      return !1;
    }
    var r = n.length;
    if (r % 2 !== 0)
      return !1;
    for (var i = 0; i < r; i += 2) {
      var a = n[i] & 255;
      if ((a < 129 || a > 159) && (a < 224 || a > 235))
        return !1;
    }
    return !0;
  }, t.chooseMaskPattern = function(e, n, r, i) {
    for (var a = Number.MAX_SAFE_INTEGER, s = -1, c = 0; c < hM.NUM_MASK_PATTERNS; c++) {
      o$.buildMatrix(e, n, r, c, i);
      var d = this.calculateMaskPenalty(i);
      d < a && (a = d, s = c);
    }
    return s;
  }, t.chooseVersion = function(e, n) {
    for (var r = 1; r <= 40; r++) {
      var i = fg.getVersionForNumber(r);
      if (t.willFit(e, i, n))
        return i;
    }
    throw new mi("Data too big");
  }, t.willFit = function(e, n, r) {
    var i = n.getTotalCodewords(), a = n.getECBlocksForLevel(r), s = a.getTotalECCodewords(), c = i - s, d = (e + 7) / 8;
    return c >= d;
  }, t.terminateBits = function(e, n) {
    var r = e * 8;
    if (n.getSize() > r)
      throw new mi("data bits cannot fit in the QR Code" + n.getSize() + " > " + r);
    for (var i = 0; i < 4 && n.getSize() < r; ++i)
      n.appendBit(!1);
    var a = n.getSize() & 7;
    if (a > 0)
      for (var i = a; i < 8; i++)
        n.appendBit(!1);
    for (var s = e - n.getSizeInBytes(), i = 0; i < s; ++i)
      n.appendBits(i & 1 ? 17 : 236, 8);
    if (n.getSize() !== r)
      throw new mi("Bits size does not equal capacity");
  }, t.getNumDataBytesAndNumECBytesForBlockID = function(e, n, r, i, a, s) {
    if (i >= r)
      throw new mi("Block ID too large");
    var c = e % r, d = r - c, f = Math.floor(e / r), g = f + 1, m = Math.floor(n / r), b = m + 1, w = f - m, _ = g - b;
    if (w !== _)
      throw new mi("EC bytes mismatch");
    if (r !== d + c)
      throw new mi("RS blocks mismatch");
    if (e !== (m + w) * d + (b + _) * c)
      throw new mi("Total bytes mismatch");
    i < d ? (a[0] = m, s[0] = w) : (a[0] = b, s[0] = _);
  }, t.interleaveWithECBytes = function(e, n, r, i) {
    var a, s, c, d;
    if (e.getSizeInBytes() !== r)
      throw new mi("Number of bits and data bytes does not match");
    for (var f = 0, g = 0, m = 0, b = new Array(), w = 0; w < i; ++w) {
      var _ = new Int32Array(1), A = new Int32Array(1);
      t.getNumDataBytesAndNumECBytesForBlockID(n, r, i, w, _, A);
      var T = _[0], O = new Uint8Array(T);
      e.toBytes(8 * f, O, 0, T);
      var R = t.generateECBytes(O, A[0]);
      b.push(new i$e(O, R)), g = Math.max(g, T), m = Math.max(m, R.length), f += _[0];
    }
    if (r !== f)
      throw new mi("Data bytes does not match offset");
    for (var N = new fo(), w = 0; w < g; ++w)
      try {
        for (var M = (a = void 0, s$(b)), P = M.next(); !P.done; P = M.next()) {
          var z = P.value, O = z.getDataBytes();
          w < O.length && N.appendBits(O[w], 8);
        }
      } catch (H) {
        a = { error: H };
      } finally {
        try {
          P && !P.done && (s = M.return) && s.call(M);
        } finally {
          if (a)
            throw a.error;
        }
      }
    for (var w = 0; w < m; ++w)
      try {
        for (var F = (c = void 0, s$(b)), $ = F.next(); !$.done; $ = F.next()) {
          var z = $.value, R = z.getErrorCorrectionBytes();
          w < R.length && N.appendBits(R[w], 8);
        }
      } catch (H) {
        c = { error: H };
      } finally {
        try {
          $ && !$.done && (d = F.return) && d.call(F);
        } finally {
          if (c)
            throw c.error;
        }
      }
    if (n !== N.getSizeInBytes())
      throw new mi("Interleaving error: " + n + " and " + N.getSizeInBytes() + " differ.");
    return N;
  }, t.generateECBytes = function(e, n) {
    for (var r = e.length, i = new Int32Array(r + n), a = 0; a < r; a++)
      i[a] = e[a] & 255;
    new Nee(sl.QR_CODE_FIELD_256).encode(i, n);
    for (var s = new Uint8Array(n), a = 0; a < n; a++)
      s[a] = /*(byte) */
      i[r + a];
    return s;
  }, t.appendModeInfo = function(e, n) {
    n.appendBits(e.getBits(), 4);
  }, t.appendLengthInfo = function(e, n, r, i) {
    var a = r.getCharacterCountBits(n);
    if (e >= 1 << a)
      throw new mi(e + " is bigger than " + ((1 << a) - 1));
    i.appendBits(e, a);
  }, t.appendBytes = function(e, n, r, i) {
    switch (n) {
      case vi.NUMERIC:
        t.appendNumericBytes(e, r);
        break;
      case vi.ALPHANUMERIC:
        t.appendAlphanumericBytes(e, r);
        break;
      case vi.BYTE:
        t.append8BitBytes(e, r, i);
        break;
      case vi.KANJI:
        t.appendKanjiBytes(e, r);
        break;
      default:
        throw new mi("Invalid mode: " + n);
    }
  }, t.getDigit = function(e) {
    return e.charCodeAt(0) - 48;
  }, t.isDigit = function(e) {
    var n = t.getDigit(e);
    return n >= 0 && n <= 9;
  }, t.appendNumericBytes = function(e, n) {
    for (var r = e.length, i = 0; i < r; ) {
      var a = t.getDigit(e.charAt(i));
      if (i + 2 < r) {
        var s = t.getDigit(e.charAt(i + 1)), c = t.getDigit(e.charAt(i + 2));
        n.appendBits(a * 100 + s * 10 + c, 10), i += 3;
      } else if (i + 1 < r) {
        var s = t.getDigit(e.charAt(i + 1));
        n.appendBits(a * 10 + s, 7), i += 2;
      } else
        n.appendBits(a, 4), i++;
    }
  }, t.appendAlphanumericBytes = function(e, n) {
    for (var r = e.length, i = 0; i < r; ) {
      var a = t.getAlphanumericCode(e.charCodeAt(i));
      if (a === -1)
        throw new mi();
      if (i + 1 < r) {
        var s = t.getAlphanumericCode(e.charCodeAt(i + 1));
        if (s === -1)
          throw new mi();
        n.appendBits(a * 45 + s, 11), i += 2;
      } else
        n.appendBits(a, 6), i++;
    }
  }, t.append8BitBytes = function(e, n, r) {
    var i;
    try {
      i = Jc.encode(e, r);
    } catch (d) {
      throw new mi(d);
    }
    for (var a = 0, s = i.length; a !== s; a++) {
      var c = i[a];
      n.appendBits(c, 8);
    }
  }, t.appendKanjiBytes = function(e, n) {
    var r;
    try {
      r = Jc.encode(e, Ha.SJIS);
    } catch (m) {
      throw new mi(m);
    }
    for (var i = r.length, a = 0; a < i; a += 2) {
      var s = r[a] & 255, c = r[a + 1] & 255, d = s << 8 & 4294967295 | c, f = -1;
      if (d >= 33088 && d <= 40956 ? f = d - 33088 : d >= 57408 && d <= 60351 && (f = d - 49472), f === -1)
        throw new mi("Invalid byte sequence");
      var g = (f >> 8) * 192 + (f & 255);
      n.appendBits(g, 13);
    }
  }, t.appendECI = function(e, n) {
    n.appendBits(vi.ECI.getBits(), 4), n.appendBits(e.getValue(), 8);
  }, t.ALPHANUMERIC_TABLE = Int32Array.from([
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    36,
    -1,
    -1,
    -1,
    37,
    38,
    -1,
    -1,
    -1,
    -1,
    39,
    40,
    -1,
    41,
    42,
    43,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    44,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    -1,
    -1,
    -1,
    -1,
    -1
  ]), t.DEFAULT_BYTE_MODE_ENCODING = Ha.UTF8.getName(), t;
})();
var a$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}();
(function(t) {
  a$e(e, t);
  function e(n, r, i, a, s, c, d, f) {
    var g = t.call(this, c, d) || this;
    if (g.yuvData = n, g.dataWidth = r, g.dataHeight = i, g.left = a, g.top = s, a + c > r || s + d > i)
      throw new Yt("Crop rectangle does not fit within image data.");
    return f && g.reverseHorizontal(c, d), g;
  }
  return e.prototype.getRow = function(n, r) {
    if (n < 0 || n >= this.getHeight())
      throw new Yt("Requested row is outside the image: " + n);
    var i = this.getWidth();
    (r == null || r.length < i) && (r = new Uint8ClampedArray(i));
    var a = (n + this.top) * this.dataWidth + this.left;
    return si.arraycopy(this.yuvData, a, r, 0, i), r;
  }, e.prototype.getMatrix = function() {
    var n = this.getWidth(), r = this.getHeight();
    if (n === this.dataWidth && r === this.dataHeight)
      return this.yuvData;
    var i = n * r, a = new Uint8ClampedArray(i), s = this.top * this.dataWidth + this.left;
    if (n === this.dataWidth)
      return si.arraycopy(this.yuvData, s, a, 0, i), a;
    for (var c = 0; c < r; c++) {
      var d = c * n;
      si.arraycopy(this.yuvData, s, a, d, n), s += this.dataWidth;
    }
    return a;
  }, e.prototype.isCropSupported = function() {
    return !0;
  }, e.prototype.crop = function(n, r, i, a) {
    return new e(this.yuvData, this.dataWidth, this.dataHeight, this.left + n, this.top + r, i, a, !1);
  }, e.prototype.renderThumbnail = function() {
    for (var n = this.getWidth() / e.THUMBNAIL_SCALE_FACTOR, r = this.getHeight() / e.THUMBNAIL_SCALE_FACTOR, i = new Int32Array(n * r), a = this.yuvData, s = this.top * this.dataWidth + this.left, c = 0; c < r; c++) {
      for (var d = c * n, f = 0; f < n; f++) {
        var g = a[s + f * e.THUMBNAIL_SCALE_FACTOR] & 255;
        i[d + f] = 4278190080 | g * 65793;
      }
      s += this.dataWidth * e.THUMBNAIL_SCALE_FACTOR;
    }
    return i;
  }, e.prototype.getThumbnailWidth = function() {
    return this.getWidth() / e.THUMBNAIL_SCALE_FACTOR;
  }, e.prototype.getThumbnailHeight = function() {
    return this.getHeight() / e.THUMBNAIL_SCALE_FACTOR;
  }, e.prototype.reverseHorizontal = function(n, r) {
    for (var i = this.yuvData, a = 0, s = this.top * this.dataWidth + this.left; a < r; a++, s += this.dataWidth)
      for (var c = s + n / 2, d = s, f = s + n - 1; d < c; d++, f--) {
        var g = i[d];
        i[d] = i[f], i[f] = g;
      }
  }, e.prototype.invert = function() {
    return new qk(this);
  }, e.THUMBNAIL_SCALE_FACTOR = 2, e;
})(OO);
var o$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}();
(function(t) {
  o$e(e, t);
  function e(n, r, i, a, s, c, d) {
    var f = t.call(this, r, i) || this;
    if (f.dataWidth = a, f.dataHeight = s, f.left = c, f.top = d, n.BYTES_PER_ELEMENT === 4) {
      for (var g = r * i, m = new Uint8ClampedArray(g), b = 0; b < g; b++) {
        var w = n[b], _ = w >> 16 & 255, A = w >> 7 & 510, T = w & 255;
        m[b] = /*(byte) */
        (_ + A + T) / 4 & 255;
      }
      f.luminances = m;
    } else
      f.luminances = n;
    if (a === void 0 && (f.dataWidth = r), s === void 0 && (f.dataHeight = i), c === void 0 && (f.left = 0), d === void 0 && (f.top = 0), f.left + r > f.dataWidth || f.top + i > f.dataHeight)
      throw new Yt("Crop rectangle does not fit within image data.");
    return f;
  }
  return e.prototype.getRow = function(n, r) {
    if (n < 0 || n >= this.getHeight())
      throw new Yt("Requested row is outside the image: " + n);
    var i = this.getWidth();
    (r == null || r.length < i) && (r = new Uint8ClampedArray(i));
    var a = (n + this.top) * this.dataWidth + this.left;
    return si.arraycopy(this.luminances, a, r, 0, i), r;
  }, e.prototype.getMatrix = function() {
    var n = this.getWidth(), r = this.getHeight();
    if (n === this.dataWidth && r === this.dataHeight)
      return this.luminances;
    var i = n * r, a = new Uint8ClampedArray(i), s = this.top * this.dataWidth + this.left;
    if (n === this.dataWidth)
      return si.arraycopy(this.luminances, s, a, 0, i), a;
    for (var c = 0; c < r; c++) {
      var d = c * n;
      si.arraycopy(this.luminances, s, a, d, n), s += this.dataWidth;
    }
    return a;
  }, e.prototype.isCropSupported = function() {
    return !0;
  }, e.prototype.crop = function(n, r, i, a) {
    return new e(this.luminances, i, a, this.dataWidth, this.dataHeight, this.left + n, this.top + r);
  }, e.prototype.invert = function() {
    return new qk(this);
  }, e;
})(OO);
var s$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), l$e = (
  /** @class */
  function(t) {
    s$e(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.forName = function(n) {
      return this.getCharacterSetECIByName(n);
    }, e;
  }(Ha)
), c$e = (
  /** @class */
  function() {
    function t() {
    }
    return t.ISO_8859_1 = Ha.ISO8859_1, t;
  }()
), pM, u$e = 301, d$e = function(t, e) {
  for (var n = 1, r = 0; r < 255; r++)
    e[r] = n, t[n] = r, n *= 2, n >= 256 && (n ^= u$e);
  return {
    LOG: t,
    ALOG: e
  };
};
pM = d$e([], []), pM.LOG;
pM.ALOG;
var l$;
(function(t) {
  t[t.FORCE_NONE = 0] = "FORCE_NONE", t[t.FORCE_SQUARE = 1] = "FORCE_SQUARE", t[t.FORCE_RECTANGLE = 2] = "FORCE_RECTANGLE";
})(l$ || (l$ = {}));
var c$ = 129, Mee = 230, f$e = 231, h$e = 235, p$e = 236, m$e = 237, g$e = 238, v$e = 239, y$e = 240, BD = 254, b$e = 254, u$ = "[)>05", d$ = "[)>06", f$ = "", Br = 0, Mo = 1, Rs = 2, La = 3, ao = 4, Qo = 5, w$e = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getEncodingMode = function() {
      return Br;
    }, t.prototype.encode = function(e) {
      var n = Uu.determineConsecutiveDigitCount(e.getMessage(), e.pos);
      if (n >= 2)
        e.writeCodeword(this.encodeASCIIDigits(e.getMessage().charCodeAt(e.pos), e.getMessage().charCodeAt(e.pos + 1))), e.pos += 2;
      else {
        var r = e.getCurrentChar(), i = Uu.lookAheadTest(e.getMessage(), e.pos, this.getEncodingMode());
        if (i !== this.getEncodingMode())
          switch (i) {
            case Qo:
              e.writeCodeword(f$e), e.signalEncoderChange(Qo);
              return;
            case Mo:
              e.writeCodeword(Mee), e.signalEncoderChange(Mo);
              return;
            case La:
              e.writeCodeword(g$e), e.signalEncoderChange(La);
              break;
            case Rs:
              e.writeCodeword(v$e), e.signalEncoderChange(Rs);
              break;
            case ao:
              e.writeCodeword(y$e), e.signalEncoderChange(ao);
              break;
            default:
              throw new Error("Illegal mode: " + i);
          }
        else
          Uu.isExtendedASCII(r) ? (e.writeCodeword(h$e), e.writeCodeword(r - 128 + 1), e.pos++) : (e.writeCodeword(r + 1), e.pos++);
      }
    }, t.prototype.encodeASCIIDigits = function(e, n) {
      if (Uu.isDigit(e) && Uu.isDigit(n)) {
        var r = (e - 48) * 10 + (n - 48);
        return r + 130;
      }
      throw new Error("not digits: " + e + n);
    }, t;
  }()
), x$e = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getEncodingMode = function() {
      return Qo;
    }, t.prototype.encode = function(e) {
      var n = new Bn();
      for (n.append(0); e.hasMoreCharacters(); ) {
        var r = e.getCurrentChar();
        n.append(r), e.pos++;
        var i = Uu.lookAheadTest(e.getMessage(), e.pos, this.getEncodingMode());
        if (i !== this.getEncodingMode()) {
          e.signalEncoderChange(Br);
          break;
        }
      }
      var a = n.length() - 1, s = 1, c = e.getCodewordCount() + a + s;
      e.updateSymbolInfo(c);
      var d = e.getSymbolInfo().getDataCapacity() - c > 0;
      if (e.hasMoreCharacters() || d)
        if (a <= 249)
          n.setCharAt(0, tr.getCharAt(a));
        else if (a <= 1555)
          n.setCharAt(0, tr.getCharAt(Math.floor(a / 250) + 249)), n.insert(1, tr.getCharAt(a % 250));
        else
          throw new Error("Message length not in valid ranges: " + a);
      for (var f = 0, r = n.length(); f < r; f++)
        e.writeCodeword(this.randomize255State(n.charAt(f).charCodeAt(0), e.getCodewordCount() + 1));
    }, t.prototype.randomize255State = function(e, n) {
      var r = 149 * n % 255 + 1, i = e + r;
      return i <= 255 ? i : i - 256;
    }, t;
  }()
), Qk = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getEncodingMode = function() {
      return Mo;
    }, t.prototype.encodeMaximal = function(e) {
      for (var n = new Bn(), r = 0, i = e.pos, a = 0; e.hasMoreCharacters(); ) {
        var s = e.getCurrentChar();
        e.pos++, r = this.encodeChar(s, n), n.length() % 3 === 0 && (i = e.pos, a = n.length());
      }
      if (a !== n.length()) {
        var c = Math.floor(n.length() / 3 * 2), d = Math.floor(e.getCodewordCount() + c + 1);
        e.updateSymbolInfo(d);
        var f = e.getSymbolInfo().getDataCapacity() - d, g = Math.floor(n.length() % 3);
        (g === 2 && f !== 2 || g === 1 && (r > 3 || f !== 1)) && (e.pos = i);
      }
      n.length() > 0 && e.writeCodeword(Mee), this.handleEOD(e, n);
    }, t.prototype.encode = function(e) {
      for (var n = new Bn(); e.hasMoreCharacters(); ) {
        var r = e.getCurrentChar();
        e.pos++;
        var i = this.encodeChar(r, n), a = Math.floor(n.length() / 3) * 2, s = e.getCodewordCount() + a;
        e.updateSymbolInfo(s);
        var c = e.getSymbolInfo().getDataCapacity() - s;
        if (!e.hasMoreCharacters()) {
          var d = new Bn();
          for (n.length() % 3 === 2 && c !== 2 && (i = this.backtrackOneCharacter(e, n, d, i)); n.length() % 3 === 1 && (i > 3 || c !== 1); )
            i = this.backtrackOneCharacter(e, n, d, i);
          break;
        }
        var f = n.length();
        if (f % 3 === 0) {
          var g = Uu.lookAheadTest(e.getMessage(), e.pos, this.getEncodingMode());
          if (g !== this.getEncodingMode()) {
            e.signalEncoderChange(Br);
            break;
          }
        }
      }
      this.handleEOD(e, n);
    }, t.prototype.backtrackOneCharacter = function(e, n, r, i) {
      var a = n.length(), s = n.toString().substring(0, a - i);
      n.setLengthToZero(), n.append(s), e.pos--;
      var c = e.getCurrentChar();
      return i = this.encodeChar(c, r), e.resetSymbolInfo(), i;
    }, t.prototype.writeNextTriplet = function(e, n) {
      e.writeCodewords(this.encodeToCodewords(n.toString()));
      var r = n.toString().substring(3);
      n.setLengthToZero(), n.append(r);
    }, t.prototype.handleEOD = function(e, n) {
      var r = Math.floor(n.length() / 3 * 2), i = n.length() % 3, a = e.getCodewordCount() + r;
      e.updateSymbolInfo(a);
      var s = e.getSymbolInfo().getDataCapacity() - a;
      if (i === 2) {
        for (n.append("\0"); n.length() >= 3; )
          this.writeNextTriplet(e, n);
        e.hasMoreCharacters() && e.writeCodeword(BD);
      } else if (s === 1 && i === 1) {
        for (; n.length() >= 3; )
          this.writeNextTriplet(e, n);
        e.hasMoreCharacters() && e.writeCodeword(BD), e.pos--;
      } else if (i === 0) {
        for (; n.length() >= 3; )
          this.writeNextTriplet(e, n);
        (s > 0 || e.hasMoreCharacters()) && e.writeCodeword(BD);
      } else
        throw new Error("Unexpected case. Please report!");
      e.signalEncoderChange(Br);
    }, t.prototype.encodeChar = function(e, n) {
      if (e === " ".charCodeAt(0))
        return n.append(3), 1;
      if (e >= "0".charCodeAt(0) && e <= "9".charCodeAt(0))
        return n.append(e - 48 + 4), 1;
      if (e >= "A".charCodeAt(0) && e <= "Z".charCodeAt(0))
        return n.append(e - 65 + 14), 1;
      if (e < " ".charCodeAt(0))
        return n.append(0), n.append(e), 2;
      if (e <= "/".charCodeAt(0))
        return n.append(1), n.append(e - 33), 2;
      if (e <= "@".charCodeAt(0))
        return n.append(1), n.append(e - 58 + 15), 2;
      if (e <= "_".charCodeAt(0))
        return n.append(1), n.append(e - 91 + 22), 2;
      if (e <= 127)
        return n.append(2), n.append(e - 96), 2;
      n.append("1");
      var r = 2;
      return r += this.encodeChar(e - 128, n), r;
    }, t.prototype.encodeToCodewords = function(e) {
      var n = 1600 * e.charCodeAt(0) + 40 * e.charCodeAt(1) + e.charCodeAt(2) + 1, r = n / 256, i = n % 256, a = new Bn();
      return a.append(r), a.append(i), a.toString();
    }, t;
  }()
), S$e = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getEncodingMode = function() {
      return ao;
    }, t.prototype.encode = function(e) {
      for (var n = new Bn(); e.hasMoreCharacters(); ) {
        var r = e.getCurrentChar();
        this.encodeChar(r, n), e.pos++;
        var i = n.length();
        if (i >= 4) {
          e.writeCodewords(this.encodeToCodewords(n.toString()));
          var a = n.toString().substring(4);
          n.setLengthToZero(), n.append(a);
          var s = Uu.lookAheadTest(e.getMessage(), e.pos, this.getEncodingMode());
          if (s !== this.getEncodingMode()) {
            e.signalEncoderChange(Br);
            break;
          }
        }
      }
      n.append(tr.getCharAt(31)), this.handleEOD(e, n);
    }, t.prototype.handleEOD = function(e, n) {
      try {
        var r = n.length();
        if (r === 0)
          return;
        if (r === 1) {
          e.updateSymbolInfo();
          var i = e.getSymbolInfo().getDataCapacity() - e.getCodewordCount(), a = e.getRemainingCharacters();
          if (a > i && (e.updateSymbolInfo(e.getCodewordCount() + 1), i = e.getSymbolInfo().getDataCapacity() - e.getCodewordCount()), a <= i && i <= 2)
            return;
        }
        if (r > 4)
          throw new Error("Count must not exceed 4");
        var s = r - 1, c = this.encodeToCodewords(n.toString()), d = !e.hasMoreCharacters(), f = d && s <= 2;
        if (s <= 2) {
          e.updateSymbolInfo(e.getCodewordCount() + s);
          var i = e.getSymbolInfo().getDataCapacity() - e.getCodewordCount();
          i >= 3 && (f = !1, e.updateSymbolInfo(e.getCodewordCount() + c.length));
        }
        f ? (e.resetSymbolInfo(), e.pos -= s) : e.writeCodewords(c);
      } finally {
        e.signalEncoderChange(Br);
      }
    }, t.prototype.encodeChar = function(e, n) {
      e >= " ".charCodeAt(0) && e <= "?".charCodeAt(0) ? n.append(e) : e >= "@".charCodeAt(0) && e <= "^".charCodeAt(0) ? n.append(tr.getCharAt(e - 64)) : Uu.illegalCharacter(tr.getCharAt(e));
    }, t.prototype.encodeToCodewords = function(e) {
      var n = e.length;
      if (n === 0)
        throw new Error("StringBuilder must not be empty");
      var r = e.charAt(0).charCodeAt(0), i = n >= 2 ? e.charAt(1).charCodeAt(0) : 0, a = n >= 3 ? e.charAt(2).charCodeAt(0) : 0, s = n >= 4 ? e.charAt(3).charCodeAt(0) : 0, c = (r << 18) + (i << 12) + (a << 6) + s, d = c >> 16 & 255, f = c >> 8 & 255, g = c & 255, m = new Bn();
      return m.append(d), n >= 2 && m.append(f), n >= 3 && m.append(g), m.toString();
    }, t;
  }()
), E$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), _$e = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, wr = (
  /** @class */
  function() {
    function t(e, n, r, i, a, s, c, d) {
      c === void 0 && (c = 0), d === void 0 && (d = 0), this.rectangular = e, this.dataCapacity = n, this.errorCodewords = r, this.matrixWidth = i, this.matrixHeight = a, this.dataRegions = s, this.rsBlockData = c, this.rsBlockError = d;
    }
    return t.lookup = function(e, n, r, i, a) {
      var s, c;
      n === void 0 && (n = 0), r === void 0 && (r = null), i === void 0 && (i = null), a === void 0 && (a = !0);
      try {
        for (var d = _$e(C$e), f = d.next(); !f.done; f = d.next()) {
          var g = f.value;
          if (!(n === 1 && g.rectangular) && !(n === 2 && !g.rectangular) && !(r != null && (g.getSymbolWidth() < r.getWidth() || g.getSymbolHeight() < r.getHeight())) && !(i != null && (g.getSymbolWidth() > i.getWidth() || g.getSymbolHeight() > i.getHeight())) && e <= g.dataCapacity)
            return g;
        }
      } catch (m) {
        s = { error: m };
      } finally {
        try {
          f && !f.done && (c = d.return) && c.call(d);
        } finally {
          if (s)
            throw s.error;
        }
      }
      if (a)
        throw new Error("Can't find a symbol arrangement that matches the message. Data codewords: " + e);
      return null;
    }, t.prototype.getHorizontalDataRegions = function() {
      switch (this.dataRegions) {
        case 1:
          return 1;
        case 2:
        case 4:
          return 2;
        case 16:
          return 4;
        case 36:
          return 6;
        default:
          throw new Error("Cannot handle this number of data regions");
      }
    }, t.prototype.getVerticalDataRegions = function() {
      switch (this.dataRegions) {
        case 1:
        case 2:
          return 1;
        case 4:
          return 2;
        case 16:
          return 4;
        case 36:
          return 6;
        default:
          throw new Error("Cannot handle this number of data regions");
      }
    }, t.prototype.getSymbolDataWidth = function() {
      return this.getHorizontalDataRegions() * this.matrixWidth;
    }, t.prototype.getSymbolDataHeight = function() {
      return this.getVerticalDataRegions() * this.matrixHeight;
    }, t.prototype.getSymbolWidth = function() {
      return this.getSymbolDataWidth() + this.getHorizontalDataRegions() * 2;
    }, t.prototype.getSymbolHeight = function() {
      return this.getSymbolDataHeight() + this.getVerticalDataRegions() * 2;
    }, t.prototype.getCodewordCount = function() {
      return this.dataCapacity + this.errorCodewords;
    }, t.prototype.getInterleavedBlockCount = function() {
      return this.rsBlockData ? this.dataCapacity / this.rsBlockData : 1;
    }, t.prototype.getDataCapacity = function() {
      return this.dataCapacity;
    }, t.prototype.getErrorCodewords = function() {
      return this.errorCodewords;
    }, t.prototype.getDataLengthForInterleavedBlock = function(e) {
      return this.rsBlockData;
    }, t.prototype.getErrorLengthForInterleavedBlock = function(e) {
      return this.rsBlockError;
    }, t;
  }()
), A$e = (
  /** @class */
  function(t) {
    E$e(e, t);
    function e() {
      return t.call(this, !1, 1558, 620, 22, 22, 36, -1, 62) || this;
    }
    return e.prototype.getInterleavedBlockCount = function() {
      return 10;
    }, e.prototype.getDataLengthForInterleavedBlock = function(n) {
      return n <= 8 ? 156 : 155;
    }, e;
  }(wr)
), C$e = [
  new wr(!1, 3, 5, 8, 8, 1),
  new wr(!1, 5, 7, 10, 10, 1),
  /*rect*/
  new wr(!0, 5, 7, 16, 6, 1),
  new wr(!1, 8, 10, 12, 12, 1),
  /*rect*/
  new wr(!0, 10, 11, 14, 6, 2),
  new wr(!1, 12, 12, 14, 14, 1),
  /*rect*/
  new wr(!0, 16, 14, 24, 10, 1),
  new wr(!1, 18, 14, 16, 16, 1),
  new wr(!1, 22, 18, 18, 18, 1),
  /*rect*/
  new wr(!0, 22, 18, 16, 10, 2),
  new wr(!1, 30, 20, 20, 20, 1),
  /*rect*/
  new wr(!0, 32, 24, 16, 14, 2),
  new wr(!1, 36, 24, 22, 22, 1),
  new wr(!1, 44, 28, 24, 24, 1),
  /*rect*/
  new wr(!0, 49, 28, 22, 14, 2),
  new wr(!1, 62, 36, 14, 14, 4),
  new wr(!1, 86, 42, 16, 16, 4),
  new wr(!1, 114, 48, 18, 18, 4),
  new wr(!1, 144, 56, 20, 20, 4),
  new wr(!1, 174, 68, 22, 22, 4),
  new wr(!1, 204, 84, 24, 24, 4, 102, 42),
  new wr(!1, 280, 112, 14, 14, 16, 140, 56),
  new wr(!1, 368, 144, 16, 16, 16, 92, 36),
  new wr(!1, 456, 192, 18, 18, 16, 114, 48),
  new wr(!1, 576, 224, 20, 20, 16, 144, 56),
  new wr(!1, 696, 272, 22, 22, 16, 174, 68),
  new wr(!1, 816, 336, 24, 24, 16, 136, 56),
  new wr(!1, 1050, 408, 18, 18, 36, 175, 68),
  new wr(!1, 1304, 496, 20, 20, 36, 163, 62),
  new A$e()
], T$e = (
  /** @class */
  function() {
    function t(e) {
      this.msg = e, this.pos = 0, this.skipAtEnd = 0;
      for (var n = e.split("").map(function(c) {
        return c.charCodeAt(0);
      }), r = new Bn(), i = 0, a = n.length; i < a; i++) {
        var s = String.fromCharCode(n[i] & 255);
        if (s === "?" && e.charAt(i) !== "?")
          throw new Error("Message contains characters outside ISO-8859-1 encoding.");
        r.append(s);
      }
      this.msg = r.toString(), this.shape = 0, this.codewords = new Bn(), this.newEncoding = -1;
    }
    return t.prototype.setSymbolShape = function(e) {
      this.shape = e;
    }, t.prototype.setSizeConstraints = function(e, n) {
      this.minSize = e, this.maxSize = n;
    }, t.prototype.getMessage = function() {
      return this.msg;
    }, t.prototype.setSkipAtEnd = function(e) {
      this.skipAtEnd = e;
    }, t.prototype.getCurrentChar = function() {
      return this.msg.charCodeAt(this.pos);
    }, t.prototype.getCurrent = function() {
      return this.msg.charCodeAt(this.pos);
    }, t.prototype.getCodewords = function() {
      return this.codewords;
    }, t.prototype.writeCodewords = function(e) {
      this.codewords.append(e);
    }, t.prototype.writeCodeword = function(e) {
      this.codewords.append(e);
    }, t.prototype.getCodewordCount = function() {
      return this.codewords.length();
    }, t.prototype.getNewEncoding = function() {
      return this.newEncoding;
    }, t.prototype.signalEncoderChange = function(e) {
      this.newEncoding = e;
    }, t.prototype.resetEncoderSignal = function() {
      this.newEncoding = -1;
    }, t.prototype.hasMoreCharacters = function() {
      return this.pos < this.getTotalMessageCharCount();
    }, t.prototype.getTotalMessageCharCount = function() {
      return this.msg.length - this.skipAtEnd;
    }, t.prototype.getRemainingCharacters = function() {
      return this.getTotalMessageCharCount() - this.pos;
    }, t.prototype.getSymbolInfo = function() {
      return this.symbolInfo;
    }, t.prototype.updateSymbolInfo = function(e) {
      e === void 0 && (e = this.getCodewordCount()), (this.symbolInfo == null || e > this.symbolInfo.getDataCapacity()) && (this.symbolInfo = wr.lookup(e, this.shape, this.minSize, this.maxSize, !0));
    }, t.prototype.resetSymbolInfo = function() {
      this.symbolInfo = null;
    }, t;
  }()
), O$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), R$e = (
  /** @class */
  function(t) {
    O$e(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.getEncodingMode = function() {
      return La;
    }, e.prototype.encode = function(n) {
      for (var r = new Bn(); n.hasMoreCharacters(); ) {
        var i = n.getCurrentChar();
        n.pos++, this.encodeChar(i, r);
        var a = r.length();
        if (a % 3 === 0) {
          this.writeNextTriplet(n, r);
          var s = Uu.lookAheadTest(n.getMessage(), n.pos, this.getEncodingMode());
          if (s !== this.getEncodingMode()) {
            n.signalEncoderChange(Br);
            break;
          }
        }
      }
      this.handleEOD(n, r);
    }, e.prototype.encodeChar = function(n, r) {
      switch (n) {
        case 13:
          r.append(0);
          break;
        case "*".charCodeAt(0):
          r.append(1);
          break;
        case ">".charCodeAt(0):
          r.append(2);
          break;
        case " ".charCodeAt(0):
          r.append(3);
          break;
        default:
          n >= "0".charCodeAt(0) && n <= "9".charCodeAt(0) ? r.append(n - 48 + 4) : n >= "A".charCodeAt(0) && n <= "Z".charCodeAt(0) ? r.append(n - 65 + 14) : Uu.illegalCharacter(tr.getCharAt(n));
          break;
      }
      return 1;
    }, e.prototype.handleEOD = function(n, r) {
      n.updateSymbolInfo();
      var i = n.getSymbolInfo().getDataCapacity() - n.getCodewordCount(), a = r.length();
      n.pos -= a, (n.getRemainingCharacters() > 1 || i > 1 || n.getRemainingCharacters() !== i) && n.writeCodeword(b$e), n.getNewEncoding() < 0 && n.signalEncoderChange(Br);
    }, e;
  }(Qk)
), D$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), N$e = (
  /** @class */
  function(t) {
    D$e(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.getEncodingMode = function() {
      return Rs;
    }, e.prototype.encodeChar = function(n, r) {
      if (n === " ".charCodeAt(0))
        return r.append(3), 1;
      if (n >= "0".charCodeAt(0) && n <= "9".charCodeAt(0))
        return r.append(n - 48 + 4), 1;
      if (n >= "a".charCodeAt(0) && n <= "z".charCodeAt(0))
        return r.append(n - 97 + 14), 1;
      if (n < " ".charCodeAt(0))
        return r.append(0), r.append(n), 2;
      if (n <= "/".charCodeAt(0))
        return r.append(1), r.append(n - 33), 2;
      if (n <= "@".charCodeAt(0))
        return r.append(1), r.append(n - 58 + 15), 2;
      if (n >= "[".charCodeAt(0) && n <= "_".charCodeAt(0))
        return r.append(1), r.append(n - 91 + 22), 2;
      if (n === "`".charCodeAt(0))
        return r.append(2), r.append(0), 2;
      if (n <= "Z".charCodeAt(0))
        return r.append(2), r.append(n - 65 + 1), 2;
      if (n <= 127)
        return r.append(2), r.append(n - 123 + 27), 2;
      r.append("1");
      var i = 2;
      return i += this.encodeChar(n - 128, r), i;
    }, e;
  }(Qk)
), M$e = (
  /** @class */
  function() {
    function t() {
    }
    return t.randomize253State = function(e) {
      var n = 149 * e % 253 + 1, r = c$ + n;
      return r <= 254 ? r : r - 254;
    }, t.encodeHighLevel = function(e, n, r, i, a) {
      n === void 0 && (n = 0), r === void 0 && (r = null), i === void 0 && (i = null), a === void 0 && (a = !1);
      var s = new Qk(), c = [
        new w$e(),
        s,
        new N$e(),
        new R$e(),
        new S$e(),
        new x$e()
      ], d = new T$e(e);
      d.setSymbolShape(n), d.setSizeConstraints(r, i), e.startsWith(u$) && e.endsWith(f$) ? (d.writeCodeword(p$e), d.setSkipAtEnd(2), d.pos += u$.length) : e.startsWith(d$) && e.endsWith(f$) && (d.writeCodeword(m$e), d.setSkipAtEnd(2), d.pos += d$.length);
      var f = Br;
      for (a && (s.encodeMaximal(d), f = d.getNewEncoding(), d.resetEncoderSignal()); d.hasMoreCharacters(); )
        c[f].encode(d), d.getNewEncoding() >= 0 && (f = d.getNewEncoding(), d.resetEncoderSignal());
      var g = d.getCodewordCount();
      d.updateSymbolInfo();
      var m = d.getSymbolInfo().getDataCapacity();
      g < m && f !== Br && f !== Qo && f !== ao && d.writeCodeword("þ");
      var b = d.getCodewords();
      for (b.length() < m && b.append(c$); b.length() < m; )
        b.append(this.randomize253State(b.length() + 1));
      return d.getCodewords().toString();
    }, t.lookAheadTest = function(e, n, r) {
      var i = this.lookAheadTestIntern(e, n, r);
      if (r === La && i === La) {
        for (var a = Math.min(n + 3, e.length), s = n; s < a; s++)
          if (!this.isNativeX12(e.charCodeAt(s)))
            return Br;
      } else if (r === ao && i === ao) {
        for (var a = Math.min(n + 4, e.length), s = n; s < a; s++)
          if (!this.isNativeEDIFACT(e.charCodeAt(s)))
            return Br;
      }
      return i;
    }, t.lookAheadTestIntern = function(e, n, r) {
      if (n >= e.length)
        return r;
      var i;
      r === Br ? i = [0, 1, 1, 1, 1, 1.25] : (i = [1, 2, 2, 2, 2, 2.25], i[r] = 0);
      for (var a = 0, s = new Uint8Array(6), c = []; ; ) {
        if (n + a === e.length) {
          qa.fill(s, 0), qa.fill(c, 0);
          var d = this.findMinimums(i, c, Vn.MAX_VALUE, s), f = this.getMinimumCount(s);
          if (c[Br] === d)
            return Br;
          if (f === 1) {
            if (s[Qo] > 0)
              return Qo;
            if (s[ao] > 0)
              return ao;
            if (s[Rs] > 0)
              return Rs;
            if (s[La] > 0)
              return La;
          }
          return Mo;
        }
        var g = e.charCodeAt(n + a);
        if (a++, this.isDigit(g) ? i[Br] += 0.5 : this.isExtendedASCII(g) ? (i[Br] = Math.ceil(i[Br]), i[Br] += 2) : (i[Br] = Math.ceil(i[Br]), i[Br]++), this.isNativeC40(g) ? i[Mo] += 2 / 3 : this.isExtendedASCII(g) ? i[Mo] += 8 / 3 : i[Mo] += 4 / 3, this.isNativeText(g) ? i[Rs] += 2 / 3 : this.isExtendedASCII(g) ? i[Rs] += 8 / 3 : i[Rs] += 4 / 3, this.isNativeX12(g) ? i[La] += 2 / 3 : this.isExtendedASCII(g) ? i[La] += 13 / 3 : i[La] += 10 / 3, this.isNativeEDIFACT(g) ? i[ao] += 3 / 4 : this.isExtendedASCII(g) ? i[ao] += 17 / 4 : i[ao] += 13 / 4, this.isSpecialB256(g) ? i[Qo] += 4 : i[Qo]++, a >= 4) {
          if (qa.fill(s, 0), qa.fill(c, 0), this.findMinimums(i, c, Vn.MAX_VALUE, s), c[Br] < this.min(c[Qo], c[Mo], c[Rs], c[La], c[ao]))
            return Br;
          if (c[Qo] < c[Br] || c[Qo] + 1 < this.min(c[Mo], c[Rs], c[La], c[ao]))
            return Qo;
          if (c[ao] + 1 < this.min(c[Qo], c[Mo], c[Rs], c[La], c[Br]))
            return ao;
          if (c[Rs] + 1 < this.min(c[Qo], c[Mo], c[ao], c[La], c[Br]))
            return Rs;
          if (c[La] + 1 < this.min(c[Qo], c[Mo], c[ao], c[Rs], c[Br]))
            return La;
          if (c[Mo] + 1 < this.min(c[Br], c[Qo], c[ao], c[Rs])) {
            if (c[Mo] < c[La])
              return Mo;
            if (c[Mo] === c[La]) {
              for (var m = n + a + 1; m < e.length; ) {
                var b = e.charCodeAt(m);
                if (this.isX12TermSep(b))
                  return La;
                if (!this.isNativeX12(b))
                  break;
                m++;
              }
              return Mo;
            }
          }
        }
      }
    }, t.min = function(e, n, r, i, a) {
      var s = Math.min(e, Math.min(n, Math.min(r, i)));
      return a === void 0 ? s : Math.min(s, a);
    }, t.findMinimums = function(e, n, r, i) {
      for (var a = 0; a < 6; a++) {
        var s = n[a] = Math.ceil(e[a]);
        r > s && (r = s, qa.fill(i, 0)), r === s && (i[a] = i[a] + 1);
      }
      return r;
    }, t.getMinimumCount = function(e) {
      for (var n = 0, r = 0; r < 6; r++)
        n += e[r];
      return n || 0;
    }, t.isDigit = function(e) {
      return e >= "0".charCodeAt(0) && e <= "9".charCodeAt(0);
    }, t.isExtendedASCII = function(e) {
      return e >= 128 && e <= 255;
    }, t.isNativeC40 = function(e) {
      return e === " ".charCodeAt(0) || e >= "0".charCodeAt(0) && e <= "9".charCodeAt(0) || e >= "A".charCodeAt(0) && e <= "Z".charCodeAt(0);
    }, t.isNativeText = function(e) {
      return e === " ".charCodeAt(0) || e >= "0".charCodeAt(0) && e <= "9".charCodeAt(0) || e >= "a".charCodeAt(0) && e <= "z".charCodeAt(0);
    }, t.isNativeX12 = function(e) {
      return this.isX12TermSep(e) || e === " ".charCodeAt(0) || e >= "0".charCodeAt(0) && e <= "9".charCodeAt(0) || e >= "A".charCodeAt(0) && e <= "Z".charCodeAt(0);
    }, t.isX12TermSep = function(e) {
      return e === 13 || // CR
      e === "*".charCodeAt(0) || e === ">".charCodeAt(0);
    }, t.isNativeEDIFACT = function(e) {
      return e >= " ".charCodeAt(0) && e <= "^".charCodeAt(0);
    }, t.isSpecialB256 = function(e) {
      return !1;
    }, t.determineConsecutiveDigitCount = function(e, n) {
      n === void 0 && (n = 0);
      for (var r = e.length, i = n; i < r && this.isDigit(e.charCodeAt(i)); )
        i++;
      return i - n;
    }, t.illegalCharacter = function(e) {
      var n = Vn.toHexString(e.charCodeAt(0));
      throw n = "0000".substring(0, 4 - n.length) + n, new Error("Illegal character: " + e + " (0x" + n + ")");
    }, t;
  }()
);
const Uu = M$e;
var zD = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, h$ = (
  /** @class */
  function() {
    function t(e) {
      this.charset = e, this.name = e.name;
    }
    return t.prototype.canEncode = function(e) {
      try {
        return Jc.encode(e, this.charset) != null;
      } catch {
        return !1;
      }
    }, t;
  }()
), I$e = (
  /** @class */
  function() {
    function t(e, n, r) {
      var i, a, s, c, d, f;
      this.ENCODERS = [
        "IBM437",
        "ISO-8859-2",
        "ISO-8859-3",
        "ISO-8859-4",
        "ISO-8859-5",
        "ISO-8859-6",
        "ISO-8859-7",
        "ISO-8859-8",
        "ISO-8859-9",
        "ISO-8859-10",
        "ISO-8859-11",
        "ISO-8859-13",
        "ISO-8859-14",
        "ISO-8859-15",
        "ISO-8859-16",
        "windows-1250",
        "windows-1251",
        "windows-1252",
        "windows-1256",
        "Shift_JIS"
      ].map(function(G) {
        return new h$(l$e.forName(G));
      }), this.encoders = [];
      var g = [];
      g.push(new h$(c$e.ISO_8859_1));
      for (var m = n != null && n.name.startsWith("UTF"), b = 0; b < e.length; b++) {
        var w = !1;
        try {
          for (var _ = (i = void 0, zD(g)), A = _.next(); !A.done; A = _.next()) {
            var T = A.value, O = e.charAt(b), R = O.charCodeAt(0);
            if (R === r || T.canEncode(O)) {
              w = !0;
              break;
            }
          }
        } catch (G) {
          i = { error: G };
        } finally {
          try {
            A && !A.done && (a = _.return) && a.call(_);
          } finally {
            if (i)
              throw i.error;
          }
        }
        if (!w)
          try {
            for (var N = (s = void 0, zD(this.ENCODERS)), M = N.next(); !M.done; M = N.next()) {
              var T = M.value;
              if (T.canEncode(e.charAt(b))) {
                g.push(T), w = !0;
                break;
              }
            }
          } catch (G) {
            s = { error: G };
          } finally {
            try {
              M && !M.done && (c = N.return) && c.call(N);
            } finally {
              if (s)
                throw s.error;
            }
          }
        w || (m = !0);
      }
      if (g.length === 1 && !m)
        this.encoders = [g[0]];
      else {
        this.encoders = [];
        var P = 0;
        try {
          for (var z = zD(g), F = z.next(); !F.done; F = z.next()) {
            var T = F.value;
            this.encoders[P++] = T;
          }
        } catch (G) {
          d = { error: G };
        } finally {
          try {
            F && !F.done && (f = z.return) && f.call(z);
          } finally {
            if (d)
              throw d.error;
          }
        }
      }
      var $ = -1;
      if (n != null) {
        for (var b = 0; b < this.encoders.length; b++)
          if (this.encoders[b] != null && n.name === this.encoders[b].name) {
            $ = b;
            break;
          }
      }
      this.priorityEncoderIndex = $;
    }
    return t.prototype.length = function() {
      return this.encoders.length;
    }, t.prototype.getCharsetName = function(e) {
      if (!(e < this.length()))
        throw new Error("index must be less than length");
      return this.encoders[e].name;
    }, t.prototype.getCharset = function(e) {
      if (!(e < this.length()))
        throw new Error("index must be less than length");
      return this.encoders[e].charset;
    }, t.prototype.getECIValue = function(e) {
      return this.encoders[e].charset.getValueIdentifier();
    }, t.prototype.getPriorityEncoderIndex = function() {
      return this.priorityEncoderIndex;
    }, t.prototype.canEncode = function(e, n) {
      if (!(n < this.length()))
        throw new Error("index must be less than length");
      return !0;
    }, t.prototype.encode = function(e, n) {
      if (!(n < this.length()))
        throw new Error("index must be less than length");
      return Jc.encode(tr.getCharAt(e), this.encoders[n].name);
    }, t;
  }()
), k$e = 3, j$e = (
  /** @class */
  function() {
    function t(e, n, r) {
      this.fnc1 = r;
      var i = new I$e(e, n, r);
      if (i.length() === 1)
        for (var a = 0; a < this.bytes.length; a++) {
          var s = e.charAt(a).charCodeAt(0);
          this.bytes[a] = s === r ? 1e3 : s;
        }
      else
        this.bytes = this.encodeMinimally(e, i, r);
    }
    return t.prototype.getFNC1Character = function() {
      return this.fnc1;
    }, t.prototype.length = function() {
      return this.bytes.length;
    }, t.prototype.haveNCharacters = function(e, n) {
      if (e + n - 1 >= this.bytes.length)
        return !1;
      for (var r = 0; r < n; r++)
        if (this.isECI(e + r))
          return !1;
      return !0;
    }, t.prototype.charAt = function(e) {
      if (e < 0 || e >= this.length())
        throw new Error("" + e);
      if (this.isECI(e))
        throw new Error("value at " + e + " is not a character but an ECI");
      return this.isFNC1(e) ? this.fnc1 : this.bytes[e];
    }, t.prototype.subSequence = function(e, n) {
      if (e < 0 || e > n || n > this.length())
        throw new Error("" + e);
      for (var r = new Bn(), i = e; i < n; i++) {
        if (this.isECI(i))
          throw new Error("value at " + i + " is not a character but an ECI");
        r.append(this.charAt(i));
      }
      return r.toString();
    }, t.prototype.isECI = function(e) {
      if (e < 0 || e >= this.length())
        throw new Error("" + e);
      return this.bytes[e] > 255 && this.bytes[e] <= 999;
    }, t.prototype.isFNC1 = function(e) {
      if (e < 0 || e >= this.length())
        throw new Error("" + e);
      return this.bytes[e] === 1e3;
    }, t.prototype.getECIValue = function(e) {
      if (e < 0 || e >= this.length())
        throw new Error("" + e);
      if (!this.isECI(e))
        throw new Error("value at " + e + " is not an ECI but a character");
      return this.bytes[e] - 256;
    }, t.prototype.addEdge = function(e, n, r) {
      (e[n][r.encoderIndex] == null || e[n][r.encoderIndex].cachedTotalSize > r.cachedTotalSize) && (e[n][r.encoderIndex] = r);
    }, t.prototype.addEdges = function(e, n, r, i, a, s) {
      var c = e.charAt(i).charCodeAt(0), d = 0, f = n.length();
      n.getPriorityEncoderIndex() >= 0 && (c === s || n.canEncode(c, n.getPriorityEncoderIndex())) && (d = n.getPriorityEncoderIndex(), f = d + 1);
      for (var g = d; g < f; g++)
        (c === s || n.canEncode(c, g)) && this.addEdge(r, i + 1, new p$(c, n, g, a, s));
    }, t.prototype.encodeMinimally = function(e, n, r) {
      var i = e.length, a = new p$[i + 1][n.length()]();
      this.addEdges(e, n, a, 0, null, r);
      for (var s = 1; s <= i; s++) {
        for (var c = 0; c < n.length(); c++)
          a[s][c] != null && s < i && this.addEdges(e, n, a, s, a[s][c], r);
        for (var c = 0; c < n.length(); c++)
          a[s - 1][c] = null;
      }
      for (var d = -1, f = Vn.MAX_VALUE, c = 0; c < n.length(); c++)
        if (a[i][c] != null) {
          var g = a[i][c];
          g.cachedTotalSize < f && (f = g.cachedTotalSize, d = c);
        }
      if (d < 0)
        throw new Error('Failed to encode "' + e + '"');
      for (var m = [], b = a[i][d]; b != null; ) {
        if (b.isFNC1())
          m.unshift(1e3);
        else
          for (var w = n.encode(b.c, b.encoderIndex), s = w.length - 1; s >= 0; s--)
            m.unshift(w[s] & 255);
        var _ = b.previous === null ? 0 : b.previous.encoderIndex;
        _ !== b.encoderIndex && m.unshift(256 + n.getECIValue(b.encoderIndex)), b = b.previous;
      }
      for (var A = [], s = 0; s < A.length; s++)
        A[s] = m[s];
      return A;
    }, t;
  }()
), p$ = (
  /** @class */
  function() {
    function t(e, n, r, i, a) {
      this.c = e, this.encoderSet = n, this.encoderIndex = r, this.previous = i, this.fnc1 = a, this.c = e === a ? 1e3 : e;
      var s = this.isFNC1() ? 1 : n.encode(e, r).length, c = i === null ? 0 : i.encoderIndex;
      c !== r && (s += k$e), i != null && (s += i.cachedTotalSize), this.cachedTotalSize = s;
    }
    return t.prototype.isFNC1 = function() {
      return this.c === 1e3;
    }, t;
  }()
), P$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}();
globalThis && globalThis.__values;
var L$e = globalThis && globalThis.__read || function(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var r = n.call(t), i, a = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; )
      a.push(i.value);
  } catch (c) {
    s = { error: c };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return a;
};
globalThis && globalThis.__spread;
var m$;
(function(t) {
  t[t.ASCII = 0] = "ASCII", t[t.C40 = 1] = "C40", t[t.TEXT = 2] = "TEXT", t[t.X12 = 3] = "X12", t[t.EDF = 4] = "EDF", t[t.B256 = 5] = "B256";
})(m$ || (m$ = {}));
(function(t) {
  P$e(e, t);
  function e(n, r, i, a, s) {
    var c = t.call(this, n, r, i) || this;
    return c.shape = a, c.macroId = s, c;
  }
  return e.prototype.getMacroId = function() {
    return this.macroId;
  }, e.prototype.getShapeHint = function() {
    return this.shape;
  }, e;
})(j$e);
var B$e = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.isCompact = function() {
      return this.compact;
    }, t.prototype.setCompact = function(e) {
      this.compact = e;
    }, t.prototype.getSize = function() {
      return this.size;
    }, t.prototype.setSize = function(e) {
      this.size = e;
    }, t.prototype.getLayers = function() {
      return this.layers;
    }, t.prototype.setLayers = function(e) {
      this.layers = e;
    }, t.prototype.getCodeWords = function() {
      return this.codeWords;
    }, t.prototype.setCodeWords = function(e) {
      this.codeWords = e;
    }, t.prototype.getMatrix = function() {
      return this.matrix;
    }, t.prototype.setMatrix = function(e) {
      this.matrix = e;
    }, t;
  }()
), g$ = (
  /** @class */
  function() {
    function t() {
    }
    return t.singletonList = function(e) {
      return [e];
    }, t.min = function(e, n) {
      return e.sort(n)[0];
    }, t;
  }()
), z$e = (
  /** @class */
  function() {
    function t(e) {
      this.previous = e;
    }
    return t.prototype.getPrevious = function() {
      return this.previous;
    }, t;
  }()
), F$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Zk = (
  /** @class */
  function(t) {
    F$e(e, t);
    function e(n, r, i) {
      var a = t.call(this, n) || this;
      return a.value = r, a.bitCount = i, a;
    }
    return e.prototype.appendTo = function(n, r) {
      n.appendBits(this.value, this.bitCount);
    }, e.prototype.add = function(n, r) {
      return new e(this, n, r);
    }, e.prototype.addBinaryShift = function(n, r) {
      return console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token"), new e(this, n, r);
    }, e.prototype.toString = function() {
      var n = this.value & (1 << this.bitCount) - 1;
      return n |= 1 << this.bitCount, "<" + Vn.toBinaryString(n | 1 << this.bitCount).substring(1) + ">";
    }, e;
  }(z$e)
), V$e = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i)
        i.hasOwnProperty(a) && (r[a] = i[a]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), U$e = (
  /** @class */
  function(t) {
    V$e(e, t);
    function e(n, r, i) {
      var a = t.call(this, n, 0, 0) || this;
      return a.binaryShiftStart = r, a.binaryShiftByteCount = i, a;
    }
    return e.prototype.appendTo = function(n, r) {
      for (var i = 0; i < this.binaryShiftByteCount; i++)
        (i === 0 || i === 31 && this.binaryShiftByteCount <= 62) && (n.appendBits(31, 5), this.binaryShiftByteCount > 62 ? n.appendBits(this.binaryShiftByteCount - 31, 16) : i === 0 ? n.appendBits(Math.min(this.binaryShiftByteCount, 31), 5) : n.appendBits(this.binaryShiftByteCount - 31, 5)), n.appendBits(r[this.binaryShiftStart + i], 8);
    }, e.prototype.addBinaryShift = function(n, r) {
      return new e(this, n, r);
    }, e.prototype.toString = function() {
      return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
    }, e;
  }(Zk)
);
function $$e(t, e, n) {
  return new U$e(t, e, n);
}
function GS(t, e, n) {
  return new Zk(t, e, n);
}
var H$e = [
  "UPPER",
  "LOWER",
  "DIGIT",
  "MIXED",
  "PUNCT"
], z0 = 0, y5 = 1, Qc = 2, Iee = 3, Yd = 4, q$e = new Zk(null, 0, 0), FD = [
  Int32Array.from([
    0,
    (5 << 16) + 28,
    (5 << 16) + 30,
    (5 << 16) + 29,
    655360 + 928 + 30
    // UPPER -> MIXED -> PUNCT
  ]),
  Int32Array.from([
    (9 << 16) + 480 + 14,
    0,
    (5 << 16) + 30,
    (5 << 16) + 29,
    655360 + 928 + 30
    // LOWER -> MIXED -> PUNCT
  ]),
  Int32Array.from([
    (4 << 16) + 14,
    (9 << 16) + 448 + 28,
    0,
    (9 << 16) + 448 + 29,
    917504 + 14336 + 928 + 30
    // DIGIT -> UPPER -> MIXED -> PUNCT
  ]),
  Int32Array.from([
    (5 << 16) + 29,
    (5 << 16) + 28,
    655360 + 928 + 30,
    0,
    (5 << 16) + 30
    // MIXED -> PUNCT
  ]),
  Int32Array.from([
    (5 << 16) + 31,
    655360 + 992 + 28,
    655360 + 992 + 30,
    655360 + 992 + 29,
    0
  ])
], G$e = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Y$e(t) {
  var e, n;
  try {
    for (var r = G$e(t), i = r.next(); !i.done; i = r.next()) {
      var a = i.value;
      qa.fill(a, -1);
    }
  } catch (s) {
    e = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return t[z0][Yd] = 0, t[y5][Yd] = 0, t[y5][z0] = 28, t[Iee][Yd] = 0, t[Qc][Yd] = 0, t[Qc][z0] = 15, t;
}
var kee = Y$e(qa.createInt32Array(6, 6)), X$e = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, W$e = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      this.token = e, this.mode = n, this.binaryShiftByteCount = r, this.bitCount = i;
    }
    return t.prototype.getMode = function() {
      return this.mode;
    }, t.prototype.getToken = function() {
      return this.token;
    }, t.prototype.getBinaryShiftByteCount = function() {
      return this.binaryShiftByteCount;
    }, t.prototype.getBitCount = function() {
      return this.bitCount;
    }, t.prototype.latchAndAppend = function(e, n) {
      var r = this.bitCount, i = this.token;
      if (e !== this.mode) {
        var a = FD[this.mode][e];
        i = GS(i, a & 65535, a >> 16), r += a >> 16;
      }
      var s = e === Qc ? 4 : 5;
      return i = GS(i, n, s), new t(i, e, 0, r + s);
    }, t.prototype.shiftAndAppend = function(e, n) {
      var r = this.token, i = this.mode === Qc ? 4 : 5;
      return r = GS(r, kee[this.mode][e], i), r = GS(r, n, 5), new t(r, this.mode, 0, this.bitCount + i + 5);
    }, t.prototype.addBinaryShiftChar = function(e) {
      var n = this.token, r = this.mode, i = this.bitCount;
      if (this.mode === Yd || this.mode === Qc) {
        var a = FD[r][z0];
        n = GS(n, a & 65535, a >> 16), i += a >> 16, r = z0;
      }
      var s = this.binaryShiftByteCount === 0 || this.binaryShiftByteCount === 31 ? 18 : this.binaryShiftByteCount === 62 ? 9 : 8, c = new t(n, r, this.binaryShiftByteCount + 1, i + s);
      return c.binaryShiftByteCount === 2047 + 31 && (c = c.endBinaryShift(e + 1)), c;
    }, t.prototype.endBinaryShift = function(e) {
      if (this.binaryShiftByteCount === 0)
        return this;
      var n = this.token;
      return n = $$e(n, e - this.binaryShiftByteCount, this.binaryShiftByteCount), new t(n, this.mode, 0, this.bitCount);
    }, t.prototype.isBetterThanOrEqualTo = function(e) {
      var n = this.bitCount + (FD[this.mode][e.mode] >> 16);
      return this.binaryShiftByteCount < e.binaryShiftByteCount ? n += t.calculateBinaryShiftCost(e) - t.calculateBinaryShiftCost(this) : this.binaryShiftByteCount > e.binaryShiftByteCount && e.binaryShiftByteCount > 0 && (n += 10), n <= e.bitCount;
    }, t.prototype.toBitArray = function(e) {
      for (var n, r, i = [], a = this.endBinaryShift(e.length).token; a !== null; a = a.getPrevious())
        i.unshift(a);
      var s = new fo();
      try {
        for (var c = X$e(i), d = c.next(); !d.done; d = c.next()) {
          var f = d.value;
          f.appendTo(s, e);
        }
      } catch (g) {
        n = { error: g };
      } finally {
        try {
          d && !d.done && (r = c.return) && r.call(c);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return s;
    }, t.prototype.toString = function() {
      return tr.format("%s bits=%d bytes=%d", H$e[this.mode], this.bitCount, this.binaryShiftByteCount);
    }, t.calculateBinaryShiftCost = function(e) {
      return e.binaryShiftByteCount > 62 ? 21 : e.binaryShiftByteCount > 31 ? 20 : e.binaryShiftByteCount > 0 ? 10 : 0;
    }, t.INITIAL_STATE = new t(q$e, z0, 0, 0), t;
  }()
);
function Q$e(t) {
  var e = tr.getCharCode(" "), n = tr.getCharCode("."), r = tr.getCharCode(",");
  t[z0][e] = 1;
  for (var i = tr.getCharCode("Z"), a = tr.getCharCode("A"), s = a; s <= i; s++)
    t[z0][s] = s - a + 2;
  t[y5][e] = 1;
  for (var c = tr.getCharCode("z"), d = tr.getCharCode("a"), s = d; s <= c; s++)
    t[y5][s] = s - d + 2;
  t[Qc][e] = 1;
  for (var f = tr.getCharCode("9"), g = tr.getCharCode("0"), s = g; s <= f; s++)
    t[Qc][s] = s - g + 2;
  t[Qc][r] = 12, t[Qc][n] = 13;
  for (var m = [
    "\0",
    " ",
    "",
    "",
    "",
    "",
    "",
    "",
    "\x07",
    "\b",
    "	",
    `
`,
    "\v",
    "\f",
    "\r",
    "\x1B",
    "",
    "",
    "",
    "",
    "@",
    "\\",
    "^",
    "_",
    "`",
    "|",
    "~",
    ""
  ], b = 0; b < m.length; b++)
    t[Iee][tr.getCharCode(m[b])] = b;
  for (var w = [
    "\0",
    "\r",
    "\0",
    "\0",
    "\0",
    "\0",
    "!",
    "'",
    "#",
    "$",
    "%",
    "&",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "[",
    "]",
    "{",
    "}"
  ], b = 0; b < w.length; b++)
    tr.getCharCode(w[b]) > 0 && (t[Yd][tr.getCharCode(w[b])] = b);
  return t;
}
var VD = Q$e(qa.createInt32Array(5, 256)), e4 = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Z$e = (
  /** @class */
  function() {
    function t(e) {
      this.text = e;
    }
    return t.prototype.encode = function() {
      for (var e = tr.getCharCode(" "), n = tr.getCharCode(`
`), r = g$.singletonList(W$e.INITIAL_STATE), i = 0; i < this.text.length; i++) {
        var a = void 0, s = i + 1 < this.text.length ? this.text[i + 1] : 0;
        switch (this.text[i]) {
          case tr.getCharCode("\r"):
            a = s === n ? 2 : 0;
            break;
          case tr.getCharCode("."):
            a = s === e ? 3 : 0;
            break;
          case tr.getCharCode(","):
            a = s === e ? 4 : 0;
            break;
          case tr.getCharCode(":"):
            a = s === e ? 5 : 0;
            break;
          default:
            a = 0;
        }
        a > 0 ? (r = t.updateStateListForPair(r, i, a), i++) : r = this.updateStateListForChar(r, i);
      }
      var c = g$.min(r, function(d, f) {
        return d.getBitCount() - f.getBitCount();
      });
      return c.toBitArray(this.text);
    }, t.prototype.updateStateListForChar = function(e, n) {
      var r, i, a = [];
      try {
        for (var s = e4(e), c = s.next(); !c.done; c = s.next()) {
          var d = c.value;
          this.updateStateForChar(d, n, a);
        }
      } catch (f) {
        r = { error: f };
      } finally {
        try {
          c && !c.done && (i = s.return) && i.call(s);
        } finally {
          if (r)
            throw r.error;
        }
      }
      return t.simplifyStates(a);
    }, t.prototype.updateStateForChar = function(e, n, r) {
      for (var i = this.text[n] & 255, a = VD[e.getMode()][i] > 0, s = null, c = 0; c <= Yd; c++) {
        var d = VD[c][i];
        if (d > 0) {
          if (s == null && (s = e.endBinaryShift(n)), !a || c === e.getMode() || c === Qc) {
            var f = s.latchAndAppend(c, d);
            r.push(f);
          }
          if (!a && kee[e.getMode()][c] >= 0) {
            var g = s.shiftAndAppend(c, d);
            r.push(g);
          }
        }
      }
      if (e.getBinaryShiftByteCount() > 0 || VD[e.getMode()][i] === 0) {
        var m = e.addBinaryShiftChar(n);
        r.push(m);
      }
    }, t.updateStateListForPair = function(e, n, r) {
      var i, a, s = [];
      try {
        for (var c = e4(e), d = c.next(); !d.done; d = c.next()) {
          var f = d.value;
          this.updateStateForPair(f, n, r, s);
        }
      } catch (g) {
        i = { error: g };
      } finally {
        try {
          d && !d.done && (a = c.return) && a.call(c);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return this.simplifyStates(s);
    }, t.updateStateForPair = function(e, n, r, i) {
      var a = e.endBinaryShift(n);
      if (i.push(a.latchAndAppend(Yd, r)), e.getMode() !== Yd && i.push(a.shiftAndAppend(Yd, r)), r === 3 || r === 4) {
        var s = a.latchAndAppend(Qc, 16 - r).latchAndAppend(Qc, 1);
        i.push(s);
      }
      if (e.getBinaryShiftByteCount() > 0) {
        var c = e.addBinaryShiftChar(n).addBinaryShiftChar(n + 1);
        i.push(c);
      }
    }, t.simplifyStates = function(e) {
      var n, r, i, a, s = [];
      try {
        for (var c = e4(e), d = c.next(); !d.done; d = c.next()) {
          var f = d.value, g = !0, m = function(T) {
            if (T.isBetterThanOrEqualTo(f))
              return g = !1, "break";
            f.isBetterThanOrEqualTo(T) && (s = s.filter(function(O) {
              return O !== T;
            }));
          };
          try {
            for (var b = (i = void 0, e4(s)), w = b.next(); !w.done; w = b.next()) {
              var _ = w.value, A = m(_);
              if (A === "break")
                break;
            }
          } catch (T) {
            i = { error: T };
          } finally {
            try {
              w && !w.done && (a = b.return) && a.call(b);
            } finally {
              if (i)
                throw i.error;
            }
          }
          g && s.push(f);
        }
      } catch (T) {
        n = { error: T };
      } finally {
        try {
          d && !d.done && (r = c.return) && r.call(c);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return s;
    }, t;
  }()
), K$e = globalThis && globalThis.__values || function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function() {
  function t() {
  }
  return t.encodeBytes = function(e) {
    return t.encode(e, t.DEFAULT_EC_PERCENT, t.DEFAULT_AZTEC_LAYERS);
  }, t.encode = function(e, n, r) {
    var i = new Z$e(e).encode(), a = Vn.truncDivision(i.getSize() * n, 100) + 11, s = i.getSize() + a, c, d, f, g, m;
    if (r !== t.DEFAULT_AZTEC_LAYERS) {
      if (c = r < 0, d = Math.abs(r), d > (c ? t.MAX_NB_BITS_COMPACT : t.MAX_NB_BITS))
        throw new Yt(tr.format("Illegal value %s for layers", r));
      f = t.totalBitsInLayer(d, c), g = t.WORD_SIZE[d];
      var b = f - f % g;
      if (m = t.stuffBits(i, g), m.getSize() + a > b)
        throw new Yt("Data to large for user specified layer");
      if (c && m.getSize() > g * 64)
        throw new Yt("Data to large for user specified layer");
    } else {
      g = 0, m = null;
      for (var w = 0; ; w++) {
        if (w > t.MAX_NB_BITS)
          throw new Yt("Data too large for an Aztec code");
        if (c = w <= 3, d = c ? w + 1 : w, f = t.totalBitsInLayer(d, c), !(s > f)) {
          (m == null || g !== t.WORD_SIZE[d]) && (g = t.WORD_SIZE[d], m = t.stuffBits(i, g));
          var b = f - f % g;
          if (!(c && m.getSize() > g * 64) && m.getSize() + a <= b)
            break;
        }
      }
    }
    var _ = t.generateCheckWords(m, f, g), A = m.getSize() / g, T = t.generateModeMessage(c, d, A), O = (c ? 11 : 14) + d * 4, R = new Int32Array(O), N;
    if (c) {
      N = O;
      for (var w = 0; w < R.length; w++)
        R[w] = w;
    } else {
      N = O + 1 + 2 * Vn.truncDivision(Vn.truncDivision(O, 2) - 1, 15);
      for (var M = Vn.truncDivision(O, 2), P = Vn.truncDivision(N, 2), w = 0; w < M; w++) {
        var z = w + Vn.truncDivision(w, 15);
        R[M - w - 1] = P - z - 1, R[M + w] = P + z + 1;
      }
    }
    for (var F = new sf(N), w = 0, $ = 0; w < d; w++) {
      for (var G = (d - w) * 4 + (c ? 9 : 12), H = 0; H < G; H++)
        for (var Z = H * 2, V = 0; V < 2; V++)
          _.get($ + Z + V) && F.set(R[w * 2 + V], R[w * 2 + H]), _.get($ + G * 2 + Z + V) && F.set(R[w * 2 + H], R[O - 1 - w * 2 - V]), _.get($ + G * 4 + Z + V) && F.set(R[O - 1 - w * 2 - V], R[O - 1 - w * 2 - H]), _.get($ + G * 6 + Z + V) && F.set(R[O - 1 - w * 2 - H], R[w * 2 + V]);
      $ += G * 8;
    }
    if (t.drawModeMessage(F, c, N, T), c)
      t.drawBullsEye(F, Vn.truncDivision(N, 2), 5);
    else {
      t.drawBullsEye(F, Vn.truncDivision(N, 2), 7);
      for (var w = 0, H = 0; w < Vn.truncDivision(O, 2) - 1; w += 15, H += 16)
        for (var V = Vn.truncDivision(N, 2) & 1; V < N; V += 2)
          F.set(Vn.truncDivision(N, 2) - H, V), F.set(Vn.truncDivision(N, 2) + H, V), F.set(V, Vn.truncDivision(N, 2) - H), F.set(V, Vn.truncDivision(N, 2) + H);
    }
    var Y = new B$e();
    return Y.setCompact(c), Y.setSize(N), Y.setLayers(d), Y.setCodeWords(A), Y.setMatrix(F), Y;
  }, t.drawBullsEye = function(e, n, r) {
    for (var i = 0; i < r; i += 2)
      for (var a = n - i; a <= n + i; a++)
        e.set(a, n - i), e.set(a, n + i), e.set(n - i, a), e.set(n + i, a);
    e.set(n - r, n - r), e.set(n - r + 1, n - r), e.set(n - r, n - r + 1), e.set(n + r, n - r), e.set(n + r, n - r + 1), e.set(n + r, n + r - 1);
  }, t.generateModeMessage = function(e, n, r) {
    var i = new fo();
    return e ? (i.appendBits(n - 1, 2), i.appendBits(r - 1, 6), i = t.generateCheckWords(i, 28, 4)) : (i.appendBits(n - 1, 5), i.appendBits(r - 1, 11), i = t.generateCheckWords(i, 40, 4)), i;
  }, t.drawModeMessage = function(e, n, r, i) {
    var a = Vn.truncDivision(r, 2);
    if (n)
      for (var s = 0; s < 7; s++) {
        var c = a - 3 + s;
        i.get(s) && e.set(c, a - 5), i.get(s + 7) && e.set(a + 5, c), i.get(20 - s) && e.set(c, a + 5), i.get(27 - s) && e.set(a - 5, c);
      }
    else
      for (var s = 0; s < 10; s++) {
        var c = a - 5 + s + Vn.truncDivision(s, 5);
        i.get(s) && e.set(c, a - 7), i.get(s + 10) && e.set(a + 7, c), i.get(29 - s) && e.set(c, a + 7), i.get(39 - s) && e.set(a - 7, c);
      }
  }, t.generateCheckWords = function(e, n, r) {
    var i, a, s = e.getSize() / r, c = new Nee(t.getGF(r)), d = Vn.truncDivision(n, r), f = t.bitsToWords(e, r, d);
    c.encode(f, d - s);
    var g = n % r, m = new fo();
    m.appendBits(0, g);
    try {
      for (var b = K$e(Array.from(f)), w = b.next(); !w.done; w = b.next()) {
        var _ = w.value;
        m.appendBits(_, r);
      }
    } catch (A) {
      i = { error: A };
    } finally {
      try {
        w && !w.done && (a = b.return) && a.call(b);
      } finally {
        if (i)
          throw i.error;
      }
    }
    return m;
  }, t.bitsToWords = function(e, n, r) {
    var i = new Int32Array(r), a, s;
    for (a = 0, s = e.getSize() / n; a < s; a++) {
      for (var c = 0, d = 0; d < n; d++)
        c |= e.get(a * n + d) ? 1 << n - d - 1 : 0;
      i[a] = c;
    }
    return i;
  }, t.getGF = function(e) {
    switch (e) {
      case 4:
        return sl.AZTEC_PARAM;
      case 6:
        return sl.AZTEC_DATA_6;
      case 8:
        return sl.AZTEC_DATA_8;
      case 10:
        return sl.AZTEC_DATA_10;
      case 12:
        return sl.AZTEC_DATA_12;
      default:
        throw new Yt("Unsupported word size " + e);
    }
  }, t.stuffBits = function(e, n) {
    for (var r = new fo(), i = e.getSize(), a = (1 << n) - 2, s = 0; s < i; s += n) {
      for (var c = 0, d = 0; d < n; d++)
        (s + d >= i || e.get(s + d)) && (c |= 1 << n - 1 - d);
      (c & a) === a ? (r.appendBits(c & a, n), s--) : c & a ? r.appendBits(c, n) : (r.appendBits(c | 1, n), s--);
    }
    return r;
  }, t.totalBitsInLayer = function(e, n) {
    return ((n ? 88 : 112) + 16 * e) * e;
  }, t.DEFAULT_EC_PERCENT = 33, t.DEFAULT_AZTEC_LAYERS = 0, t.MAX_NB_BITS = 32, t.MAX_NB_BITS_COMPACT = 4, t.WORD_SIZE = Int32Array.from([
    4,
    6,
    6,
    8,
    8,
    8,
    8,
    8,
    8,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12
  ]), t;
})();
var J$e = {
  audio: !1,
  video: { facingMode: "environment" }
}, eHe = 300, tHe = function(t) {
  var e = t === void 0 ? {} : t, n = e.timeBetweenDecodingAttempts, r = n === void 0 ? eHe : n, i = e.hints;
  return I.useMemo(function() {
    var a = new KUe(i);
    return a.timeBetweenDecodingAttempts = r, a;
  }, [i, r]);
}, v$ = globalThis && globalThis.__awaiter || function(t, e, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(s) {
      s(a);
    });
  }
  return new (n || (n = Promise))(function(a, s) {
    function c(g) {
      try {
        f(r.next(g));
      } catch (m) {
        s(m);
      }
    }
    function d(g) {
      try {
        f(r.throw(g));
      } catch (m) {
        s(m);
      }
    }
    function f(g) {
      g.done ? a(g.value) : i(g.value).then(c, d);
    }
    f((r = r.apply(t, e || [])).next());
  });
}, y$ = globalThis && globalThis.__generator || function(t, e) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, s;
  return s = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function c(f) {
    return function(g) {
      return d([f, g]);
    };
  }
  function d(f) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (a = f[0] & 2 ? i.return : f[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, f[1])).done)
          return a;
        switch (i = 0, a && (f = [f[0] & 2, a.value]), f[0]) {
          case 0:
          case 1:
            a = f;
            break;
          case 4:
            return n.label++, { value: f[1], done: !1 };
          case 5:
            n.label++, i = f[1], f = [0];
            continue;
          case 7:
            f = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              n = 0;
              continue;
            }
            if (f[0] === 3 && (!a || f[1] > a[0] && f[1] < a[3])) {
              n.label = f[1];
              break;
            }
            if (f[0] === 6 && n.label < a[1]) {
              n.label = a[1], a = f;
              break;
            }
            if (a && n.label < a[2]) {
              n.label = a[2], n.ops.push(f);
              break;
            }
            a[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        f = e.call(t, n);
      } catch (g) {
        f = [6, g], i = 0;
      } finally {
        r = a = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}, nHe = function(t) {
  var e = t.resetStream, n = I.useState(!1), r = n[0], i = n[1], a = I.useState(null), s = a[0], c = a[1], d = I.useRef(null), f = I.useRef(e), g = I.useCallback(function(w) {
    d.current = w, c(typeof w.getCapabilities == "function" ? w.getCapabilities().torch !== void 0 : !1);
  }, []), m = I.useCallback(function() {
    return v$(void 0, void 0, void 0, function() {
      return y$(this, function(w) {
        switch (w.label) {
          case 0:
            return !d.current || !s ? [
              2
              /*return*/
            ] : [4, d.current.applyConstraints({
              advanced: [{ torch: !0 }]
            })];
          case 1:
            return w.sent(), i(!0), [
              2
              /*return*/
            ];
        }
      });
    });
  }, [s]), b = I.useCallback(function() {
    return v$(void 0, void 0, void 0, function() {
      return y$(this, function(w) {
        switch (w.label) {
          case 0:
            return !d.current || !s ? [
              2
              /*return*/
            ] : (d.current = null, c(null), i(!1), [4, f.current()]);
          case 1:
            return w.sent(), [
              2
              /*return*/
            ];
        }
      });
    });
  }, [s]);
  return I.useEffect(function() {
    f.current = e;
  }, [e]), { init: g, isOn: r, isAvailable: s, on: m, off: b };
}, rHe = function(t, e) {
  return JSON.stringify(t) === JSON.stringify(e);
}, b$ = globalThis && globalThis.__awaiter || function(t, e, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(s) {
      s(a);
    });
  }
  return new (n || (n = Promise))(function(a, s) {
    function c(g) {
      try {
        f(r.next(g));
      } catch (m) {
        s(m);
      }
    }
    function d(g) {
      try {
        f(r.throw(g));
      } catch (m) {
        s(m);
      }
    }
    function f(g) {
      g.done ? a(g.value) : i(g.value).then(c, d);
    }
    f((r = r.apply(t, e || [])).next());
  });
}, w$ = globalThis && globalThis.__generator || function(t, e) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, s;
  return s = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function c(f) {
    return function(g) {
      return d([f, g]);
    };
  }
  function d(f) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (a = f[0] & 2 ? i.return : f[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, f[1])).done)
          return a;
        switch (i = 0, a && (f = [f[0] & 2, a.value]), f[0]) {
          case 0:
          case 1:
            a = f;
            break;
          case 4:
            return n.label++, { value: f[1], done: !1 };
          case 5:
            n.label++, i = f[1], f = [0];
            continue;
          case 7:
            f = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              n = 0;
              continue;
            }
            if (f[0] === 3 && (!a || f[1] > a[0] && f[1] < a[3])) {
              n.label = f[1];
              break;
            }
            if (f[0] === 6 && n.label < a[1]) {
              n.label = a[1], a = f;
              break;
            }
            if (a && n.label < a[2]) {
              n.label = a[2], n.ops.push(f);
              break;
            }
            a[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        f = e.call(t, n);
      } catch (g) {
        f = [6, g], i = 0;
      } finally {
        r = a = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}, iHe = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, aHe = function(t) {
  t === void 0 && (t = {});
  var e = t.paused, n = e === void 0 ? !1 : e, r = t.hints, i = t.timeBetweenDecodingAttempts, a = t.onDecodeResult, s = a === void 0 ? function() {
  } : a, c = t.onDecodeError, d = c === void 0 ? function() {
  } : c, f = t.onError, g = f === void 0 ? function() {
  } : f, m = "deviceId" in t ? t.deviceId : void 0, b = I.useState("constraints" in t ? t.constraints : void 0), w = b[0], _ = b[1], A = I.useRef(s), T = I.useRef(d), O = I.useRef(g), R = I.useRef(null), N = tHe({
    hints: r,
    timeBetweenDecodingAttempts: i
  }), M = nHe({
    resetStream: function() {
      return b$(void 0, void 0, void 0, function() {
        return w$(this, function(H) {
          switch (H.label) {
            case 0:
              return G(), [4, $()];
            case 1:
              return H.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }
  }), P = M.init, z = iHe(M, ["init"]), F = I.useCallback(function(H, Z) {
    H && A.current(H), Z && T.current(Z);
  }, []), $ = I.useCallback(function() {
    return b$(void 0, void 0, void 0, function() {
      var H, Z, V;
      return w$(this, function(Y) {
        switch (Y.label) {
          case 0:
            if (!R.current)
              return [
                2
                /*return*/
              ];
            if (n)
              return [
                2
                /*return*/
              ];
            Y.label = 1;
          case 1:
            return Y.trys.push([1, 6, , 7]), m ? [4, N.decodeFromVideoDevice(m, R.current, F)] : [3, 3];
          case 2:
            return Y.sent(), [3, 5];
          case 3:
            return [4, N.decodeFromConstraints(w ?? J$e, R.current, F)];
          case 4:
            Y.sent(), Y.label = 5;
          case 5:
            return [3, 7];
          case 6:
            return H = Y.sent(), O.current(H), [
              2
              /*return*/
            ];
          case 7:
            return R.current ? (Z = R.current.srcObject, V = Z.getVideoTracks()[0], V && P(V), [
              2
              /*return*/
            ]) : [
              2
              /*return*/
            ];
        }
      });
    });
  }, [N, m, w, n, F, P]), G = I.useCallback(function() {
    N.reset();
  }, [N]);
  return I.useEffect(function() {
    A.current = s;
  }, [s]), I.useEffect(function() {
    T.current = d;
  }, [d]), I.useEffect(function() {
    O.current = g;
  }, [g]), I.useEffect(function() {
    var H = rHe(w, t.constraints);
    H || _(t.constraints);
  }, [w, t]), I.useEffect(function() {
    return $(), function() {
      G();
    };
  }, [$, G]), {
    ref: R,
    torch: z
  };
};
const UD = vr("QrReader"), oHe = Re.div`
  twd-flex
  twd-flex-col
  twd-gap-3
`, sHe = Re.div`
  twd-aspect-square
  twd-w-full
  twd-self-center
  twd-overflow-hidden
  twd-rounded-lg
  twd-border
  twd-border-secondary-light
  md:twd-aspect-auto
  md:twd-h-[500px]
  md:twd-w-[500px]
`, lHe = Re.video`
  twd-h-full
  twd-w-full
  twd-object-cover
`, cHe = Re.div`
  twd-text-sm
  twd-text-error
`, uHe = /* @__PURE__ */ new Set(["NotFoundException", "ChecksumException", "FormatException", "IndexSizeError"]), x$ = (t) => {
  switch (t) {
    case "NotAllowedError":
      return "browser.qr.NotAllowedError";
    case "NotFoundError":
      return "browser.qr.NotFoundError";
    case "InsecureContextError":
      return "browser.qr.InsecureContextError";
    case "NotSupportedError":
      return "browser.qr.NotSupportedError";
    case "NotReadableError":
      return "browser.qr.NotReadableError";
    case "OverconstrainedError":
      return "browser.qr.OverconstrainedError";
    default:
      return "browser.qr.UnknownError";
  }
}, dHe = ({
  onData: t
}) => {
  const [e, n] = I.useState(null), [r, i] = I.useState(null), a = I.useRef(null), s = I.useMemo(() => ({
    video: r ? {
      deviceId: {
        exact: r
      }
    } : {
      facingMode: {
        ideal: "environment"
      }
    },
    audio: !1
  }), [r]);
  I.useEffect(() => {
    let d = !0;
    return (async () => {
      if (navigator?.mediaDevices?.enumerateDevices)
        try {
          const m = (await navigator.mediaDevices.enumerateDevices()).filter((_) => _.kind === "videoinput");
          if (!m.length)
            return;
          const w = m.find((_) => /back|rear|environment/i.test(_.label)) ?? m[0];
          d && w?.deviceId && i(w.deviceId);
        } catch (g) {
          UD.info("QR scan device enumeration error", g);
        }
    })(), () => {
      d = !1;
    };
  }, []);
  const {
    ref: c
  } = aHe({
    constraints: s,
    onDecodeResult(d) {
      const f = d.getText();
      !f || a.current === f || (a.current = f, n(null), t(f));
    },
    onDecodeError(d) {
      uHe.has(d.name) || (e || n(ks(x$(d.name))), UD.info("QR scan decode error", d));
    },
    onError(d) {
      const f = d instanceof Error ? d.name : "UnknownError";
      n(ks(x$(f))), UD.info("QR scan error", d);
    }
  });
  return /* @__PURE__ */ C.jsxs(oHe, { children: [
    e && /* @__PURE__ */ C.jsx(cHe, { children: e }),
    /* @__PURE__ */ C.jsx(sHe, { children: /* @__PURE__ */ C.jsx(lHe, { ref: c, muted: !0, playsInline: !0, autoPlay: !0 }) })
  ] });
}, S$ = vr("ScanQrModal"), fHe = Re.div`
  twd-text-sm
  twd-flex
  twd-flex-col
  twd-gap-4
  twd-text-secondary-contrast
`, hHe = Re.div`
  twd-text-sm
  twd-text-secondary
`, pHe = (t) => {
  const e = ve.c(17), {
    isOpen: n,
    onClose: r,
    onData: i
  } = t;
  let a;
  e[0] !== r ? (a = () => {
    S$.info("Closing QR scan modal"), r();
  }, e[0] = r, e[1] = a) : a = e[1];
  const s = a;
  let c;
  e[2] !== r || e[3] !== i ? (c = (_) => {
    S$.info("QR data scanned"), i(_), r();
  }, e[2] = r, e[3] = i, e[4] = c) : c = e[4];
  const d = c;
  let f;
  e[5] !== d ? (f = /* @__PURE__ */ C.jsx(dHe, { onData: d }), e[5] = d, e[6] = f) : f = e[6];
  let g;
  e[7] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ C.jsx(hHe, { children: "Scan the provided QR code with your camera to fill the form." }), e[7] = g) : g = e[7];
  let m;
  e[8] !== s ? (m = /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", onClick: s, children: "Close" }), e[8] = s, e[9] = m) : m = e[9];
  let b;
  e[10] !== f || e[11] !== m ? (b = /* @__PURE__ */ C.jsxs(fHe, { children: [
    f,
    g,
    m
  ] }), e[10] = f, e[11] = m, e[12] = b) : b = e[12];
  let w;
  return e[13] !== s || e[14] !== n || e[15] !== b ? (w = /* @__PURE__ */ C.jsx(Ph, { isOpen: n, title: "QR scanner", onClose: s, children: b }), e[13] = s, e[14] = n, e[15] = b, e[16] = w) : w = e[16], w;
}, mHe = (t) => t.replace(/[^0-9a-zA-Z]/g, "").toUpperCase(), gHe = (t) => {
  const e = mHe(t);
  return e.length !== 8 ? null : `${e.slice(0, 4)}-${e.slice(4)}`;
}, vHe = (t) => t.replace(/[^0-9a-zA-Z]/g, "").toUpperCase(), yHe = (t) => {
  const e = t.trim();
  if (!e)
    return null;
  try {
    const r = new URL(e).pathname.split("/").filter(Boolean);
    if (r.length >= 2) {
      const i = r[r.length - 2], a = r[r.length - 1];
      if (i && a)
        return {
          serial: i,
          key: a
        };
    }
  } catch {
    return null;
  }
  return null;
}, bHe = (t) => {
  const e = yHe(t);
  if (!e)
    return null;
  const n = gHe(e.serial), r = vHe(e.key);
  return !n || r.length !== 2 ? null : {
    serial: n,
    key: r
  };
}, E$ = vr("ScanQrButton"), wHe = (t) => {
  const e = ve.c(9), {
    onData: n,
    onInvalid: r
  } = t, [i, a] = I.useState(!1);
  let s;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (s = () => {
    E$.info("Opening QR scan modal"), a(!0);
  }, e[0] = s) : s = e[0];
  const c = s;
  let d;
  e[1] === Symbol.for("react.memo_cache_sentinel") ? (d = () => {
    a(!1);
  }, e[1] = d) : d = e[1];
  const f = d;
  let g;
  e[2] !== n || e[3] !== r ? (g = (_) => {
    const A = bHe(_);
    if (!A) {
      E$.warn("Failed to parse QR payload"), r?.();
      return;
    }
    n(A), a(!1);
  }, e[2] = n, e[3] = r, e[4] = g) : g = e[4];
  const m = g;
  let b;
  e[5] === Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", onClick: c, icon: /* @__PURE__ */ C.jsx(kY, { size: "sm" }), children: "Scan QR code" }), e[5] = b) : b = e[5];
  let w;
  return e[6] !== m || e[7] !== i ? (w = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    b,
    /* @__PURE__ */ C.jsx(pHe, { isOpen: i, onClose: f, onData: m })
  ] }), e[6] = m, e[7] = i, e[8] = w) : w = e[8], w;
}, t4 = vr("AddDeviceForm"), xHe = lf.subclass("AddDeviceFormError"), SHe = Re.div`
  twd-flex
  twd-flex-col
  twd-gap-4
`, EHe = Re(wee)`
  twd-p-4
`, _He = Re.form`
  twd-flex
  twd-flex-col
  twd-gap-3
`, AHe = Re.div`
  twd-flex
  twd-flex-col
  twd-gap-3
  sm:twd-flex-row
  sm:twd-flex-wrap
`, CHe = Re.div`
  twd-flex
  twd-flex-wrap
  twd-items-center
  twd-gap-2
`, THe = Re.button`
  twd-flex
  twd-w-full
  twd-items-center
  twd-gap-2
  twd-rounded-sm
  twd-border-2
  twd-border-dashed
  twd-border-secondary-light
  twd-bg-transparent
  twd-px-6
  twd-py-4
  twd-text-left
  twd-text-secondary
  hover:twd-border-primary
  hover:twd-text-primary
`, jee = (t) => t.replace(/[^0-9a-zA-Z]/g, "").toUpperCase().slice(0, 8), _$ = (t) => {
  const e = jee(t);
  return e.length <= 4 ? e : `${e.slice(0, 4)}-${e.slice(4)}`;
}, $D = (t) => t.replace(/[^0-9a-zA-Z]/g, "").toUpperCase().slice(0, 2), OHe = (t) => {
  const e = new URLSearchParams(window.location.search);
  t.forEach((i) => e.delete(i));
  const n = e.toString(), r = n ? `${window.location.pathname}?${n}` : window.location.pathname;
  window.history.replaceState(null, "", r);
}, RHe = ({
  hasDevices: t,
  onAdded: e
}) => {
  const [n, r] = I.useState(!t), [i, a] = I.useState(!1), [s, c] = I.useState(null), [d, f] = I.useState(null), [g, m] = I.useState(!1), {
    mutateAsync: b,
    isPending: w
  } = cFe(), _ = es(), {
    showDefaultNotification: A,
    showSuccessNotification: T,
    showErrorNotification: O
  } = nd(), {
    control: R,
    handleSubmit: N,
    formState: M,
    setValue: P,
    reset: z
  } = ed({
    defaultValues: {
      serial: "",
      key: ""
    },
    resolver: td(nFe),
    mode: "onSubmit",
    reValidateMode: "onChange"
  });
  XI(() => {
    const Y = new URLSearchParams(window.location.search), ee = Y.get("serial"), K = Y.get("key");
    (ee || K) && (t4.debug("Prefilling form from query params"), r(!0), a(!0), P("serial", _$(ee ?? ""), {
      shouldValidate: !0
    }), P("key", $D(K ?? ""), {
      shouldValidate: !0
    }), OHe(["serial", "key"]));
  }), I.useEffect(() => {
    !i || !M.isValid || M.isSubmitting || w || (a(!1), N(async (Y) => H(Y, !1))());
  }, [M.isSubmitting, M.isValid, N, i]);
  const F = () => {
    t4.info("Showing add device form"), r(!0);
  }, $ = () => {
    t4.info("Hiding add device form"), r(!1), z();
  }, G = (Y, ee) => {
    c(ee), f(Y), m(!0);
  }, H = async (Y, ee) => {
    const K = jee(Y.serial).toLowerCase(), U = $D(Y.key).toLowerCase();
    try {
      const q = await b({
        serial: K,
        key: U,
        force: ee
      });
      if ($(), q.statusCode === UE.NO_CONTENT) {
        A("This device already added");
        return;
      }
      T("Device added successfully. It will appear in your device list shortly."), e?.();
    } catch (q) {
      if (q instanceof Ng && q.data.code === UE.CONFLICT)
        try {
          const W = qt(dFe, q.data.payload);
          G(W.organizationName, Y);
          return;
        } catch (W) {
          t4.error("Failed to parse owner dialog payload", W);
        }
      _(q);
    }
  }, Z = async () => {
    if (s == null)
      throw new xHe("Missing form values for owner change");
    m(!1), await H(s, !0);
  }, V = (Y) => {
    r(!0), P("serial", Y.serial, {
      shouldValidate: !0
    }), P("key", Y.key, {
      shouldValidate: !0
    });
  };
  return n ? /* @__PURE__ */ C.jsxs(SHe, { children: [
    /* @__PURE__ */ C.jsx(EHe, { children: /* @__PURE__ */ C.jsxs(_He, { onSubmit: N((Y) => H(Y, !1)), children: [
      /* @__PURE__ */ C.jsxs(AHe, { children: [
        /* @__PURE__ */ C.jsx(Zr, { label: "Serial", placeholder: "XXXX-XXXX", name: "serial", control: R, className: "twd-min-w-64", onValueChange: _$, autoComplete: "off", "data-test-id": "input-device-serial" }),
        /* @__PURE__ */ C.jsx(Zr, { label: "Key", placeholder: "**", name: "key", control: R, className: "twd-min-w-64", onValueChange: $D, autoComplete: "off", "data-test-id": "input-device-key" })
      ] }),
      /* @__PURE__ */ C.jsxs(CHe, { children: [
        /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", isSubmit: !0, isDisabled: w, isLoading: w, icon: /* @__PURE__ */ C.jsx(q0, { size: "sm" }), children: "Add device" }),
        /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", onClick: $, children: "Cancel" }),
        /* @__PURE__ */ C.jsx(wHe, { onData: V, onInvalid: () => O("QR code is invalid") })
      ] })
    ] }) }),
    /* @__PURE__ */ C.jsx(qu, { open: g, onOpenChange: m, title: "Change device owner?", description: `This device is currently assigned to the organization named "${d ?? "unknown"}". Would you like to remove it from their organization and add it to yours?`, confirmLabel: "Yes", cancelLabel: "No", onConfirm: Z, loading: w })
  ] }) : /* @__PURE__ */ C.jsxs(THe, { type: "button", onClick: F, "data-test-id": "btn-show-device-form", children: [
    /* @__PURE__ */ C.jsx(q0, { size: "sm" }),
    /* @__PURE__ */ C.jsx("span", { children: "Add device" })
  ] });
}, DHe = Re.div`
  twd-my-4
`, NHe = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ C.jsx(DHe, { children: /* @__PURE__ */ C.jsx(Qze, { renderAddDevice: MHe }) }), t[0] = e) : e = t[0], e;
};
function MHe(t) {
  const {
    hasDevices: e,
    onAdded: n
  } = t;
  return /* @__PURE__ */ C.jsx(RHe, { hasDevices: e, onAdded: n });
}
const IHe = vr("EnableDeviceEditModeButton"), A$ = ({
  label: t = "Add/Remove/Move devices",
  variant: e = "transparent",
  icon: n = /* @__PURE__ */ C.jsx(zY, { size: "sm" }),
  dataTestId: r
}) => {
  const i = ew((s) => s.enableEditMode), a = () => {
    IHe.info("Start editing devices"), i();
  };
  return /* @__PURE__ */ C.jsx(Vt, { variant: e, onClick: a, icon: n, "data-test-id": r, children: t });
}, kHe = vr("DisableDeviceEditModeButton"), jHe = ({
  label: t = "Finish editing",
  variant: e = "transparent",
  icon: n = /* @__PURE__ */ C.jsx(NY, { size: "sm" }),
  dataTestId: r
}) => {
  const i = ew((s) => s.disableEditMode), a = () => {
    kHe.info("Stop editing devices"), i();
  };
  return /* @__PURE__ */ C.jsx(Vt, { variant: e, onClick: a, icon: n, "data-test-id": r, children: t });
}, PHe = Xe({
  serial: Je(),
  key: Je()
}), LHe = vr("apiGetDeviceKey"), BHe = async (t) => {
  LHe.info("Getting device key", {
    serial: t
  });
  const e = await Ya.get("v2/staff/hardware-key", {
    queryParams: {
      serial: t
    }
  });
  return qt(PHe, e);
}, zHe = (t) => t instanceof Ng ? ks(t.data.message) : ks("server_error"), FHe = () => {
  const t = DM(), [e, n] = I.useState(!1);
  if (!t.isSuperuser)
    return null;
  const r = async () => {
    const a = window.prompt("Enter device address")?.trim();
    if (a) {
      n(!0);
      try {
        const s = await BHe(a);
        window.alert(`Device key for ${s.serial}: ${s.key}`);
      } catch (s) {
        window.alert(zHe(s));
      } finally {
        n(!1);
      }
    }
  };
  return /* @__PURE__ */ C.jsx(Vt, { variant: "primary", icon: /* @__PURE__ */ C.jsx(EI, { size: "sm" }), isLoading: e, onClick: r, title: "Get device key", children: "Get device key" });
}, VHe = (t) => {
  const e = ve.c(13), {
    title: n,
    actions: r,
    children: i,
    className: a
  } = t;
  let s;
  e[0] !== a ? (s = un("twd-flex twd-items-center twd-justify-between twd-px-0", a), e[0] = a, e[1] = s) : s = e[1];
  let c;
  e[2] !== n ? (c = /* @__PURE__ */ C.jsx("h1", { className: "twd-text-2xl sm:twd-text-[41px] sm:twd-py-[20px]", children: n }), e[2] = n, e[3] = c) : c = e[3];
  let d;
  e[4] !== i || e[5] !== c ? (d = /* @__PURE__ */ C.jsxs("div", { className: "twd-flex-1", children: [
    c,
    i
  ] }), e[4] = i, e[5] = c, e[6] = d) : d = e[6];
  let f;
  e[7] !== r ? (f = r ? /* @__PURE__ */ C.jsx("div", { className: "twd-flex twd-flex-row twd-items-center", children: r }) : null, e[7] = r, e[8] = f) : f = e[8];
  let g;
  return e[9] !== s || e[10] !== d || e[11] !== f ? (g = /* @__PURE__ */ C.jsxs("div", { className: s, children: [
    d,
    f
  ] }), e[9] = s, e[10] = d, e[11] = f, e[12] = g) : g = e[12], g;
}, UHe = vr("DevicesPage"), $He = () => {
  const t = ve.c(11);
  KW("HPLC Cloud: Devices");
  const e = ew(HHe), n = ew(qHe), {
    devices: r
  } = JJ(), i = (r?.length ?? 0) > 0;
  let a;
  t[0] !== i || t[1] !== e ? (a = e ? /* @__PURE__ */ C.jsx(jHe, { variant: "primary" }) : i ? /* @__PURE__ */ C.jsx(A$, { variant: "primary" }) : /* @__PURE__ */ C.jsx(A$, { label: "Add device", variant: "primaryContained", icon: /* @__PURE__ */ C.jsx(q0, { size: "sm" }), dataTestId: "btn-device-settings" }), t[0] = i, t[1] = e, t[2] = a) : a = t[2];
  const s = a;
  let c;
  t[3] !== n ? (c = () => {
    const b = new URLSearchParams(window.location.search), w = b.get("serial"), _ = b.get("key");
    (w || _) && (UHe.debug("Opening edit mode from query params"), n());
  }, t[3] = n, t[4] = c) : c = t[4], XI(c);
  let d;
  t[5] === Symbol.for("react.memo_cache_sentinel") ? (d = /* @__PURE__ */ C.jsx(FHe, {}), t[5] = d) : d = t[5];
  let f;
  t[6] !== s ? (f = /* @__PURE__ */ C.jsx(VHe, { title: "Devices", actions: /* @__PURE__ */ C.jsxs("div", { className: "twd-flex twd-items-center twd-gap-2", children: [
    d,
    s
  ] }) }), t[6] = s, t[7] = f) : f = t[7];
  let g;
  t[8] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ C.jsx(NHe, {}), t[8] = g) : g = t[8];
  let m;
  return t[9] !== f ? (m = /* @__PURE__ */ C.jsxs(JW, { $hasGutterOnMobile: !0, children: [
    f,
    g
  ] }), t[9] = f, t[10] = m) : m = t[10], m;
};
function HHe(t) {
  return t.isEditMode;
}
function qHe(t) {
  return t.enableEditMode;
}
const YGe = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ C.jsx($He, {}), t[0] = e) : e = t[0], e;
}, $g = y_(["admin", "assistant"]), NO = Xe({
  id: Ve(),
  organizationId: Ve(),
  email: Je(),
  role: $g,
  status: y_(["pending", "accepted", "revoked", "expired"]),
  expiresAt: Je(),
  createdBy: Ve(),
  createdAt: Je(),
  acceptedBy: Ve().nullable(),
  acceptedAt: Je().nullable(),
  revokedBy: Ve().nullable(),
  revokedAt: Je().nullable()
}), zh = {
  current: ["organization", "current"],
  members: ["organization", "members"],
  invitations: ["organization", "invitations"]
}, GHe = vr("refreshTokensAndRedirect"), Pee = async (t = "/app/devices") => {
  try {
    await co.refreshAccessToken();
  } catch (e) {
    throw GHe.error("Failed to refresh tokens after organization change", {
      error: e
    }), e;
  }
  window.location.href = t;
}, YHe = Xe({
  email: bi.notEmptyString.email(),
  role: $g
}), XHe = Xe({
  name: bi.trimmedNotEmptyString
}), Lee = lf.subclass("OrganizationLeaveSessionRefreshError"), Bee = async () => {
  try {
    await Pee();
  } catch (t) {
    throw new Lee(ks(qb.leaveSessionRefreshFailed), {
      cause: t
    });
  }
}, Kk = Xe({
  id: Ve(),
  name: Je().nullable(),
  ownerId: Ve().nullable()
}), Jk = Xe({
  memberId: Ve(),
  userId: Ve(),
  organizationId: Ve(),
  role: $g
}), WHe = Xe({
  organization: Kk
}), QHe = Xe({
  member: Jk
}), ZHe = Xe({
  member: Jk,
  organization: Kk,
  requiresTokenRefresh: Sr()
}), zee = Xe({
  invitation: NO,
  token: Je()
}), KHe = Xe({
  invitation: NO
}), JHe = Xe({
  member: Jk,
  organization: Kk,
  requiresTokenRefresh: Sr()
}), eqe = async (t) => {
  const e = await Ya.patch("v2/organizations/current", {
    name: t
  });
  return qt(WHe, e);
}, tqe = async (t, e) => {
  const n = await Ya.patch(`v2/organizations/current/members/${t}/role`, {
    role: e
  });
  return qt(QHe, n);
}, nqe = async (t) => {
  const e = await Ya.delete(`v2/organizations/current/members/${t}`);
  return qt(ZHe, e);
}, rqe = async (t, e) => {
  const n = await Ya.post("v2/organizations/current/invitations/email", {
    email: t,
    role: e
  });
  return qt(zee, n);
}, iqe = async (t) => {
  const e = await Ya.post(`v2/organizations/current/invitations/${t}/resend`, {});
  return qt(zee, e);
}, aqe = async (t) => {
  const e = await Ya.post(`v2/organizations/current/invitations/${t}/revoke`, {});
  return qt(KHe, e);
}, oqe = async () => {
  const t = await Ya.post("v2/organizations/current/switch-personal", {});
  return qt(JHe, t);
}, sqe = () => {
  const t = ve.c(2), e = Ju();
  let n;
  return t[0] !== e ? (n = {
    mutationFn: lqe,
    onSettled: () => {
      e.invalidateQueries({
        queryKey: zh.invitations
      });
    }
  }, t[0] = e, t[1] = n) : n = t[1], Ei(n);
};
function lqe(t) {
  const {
    email: e,
    role: n
  } = t;
  return rqe(e, n);
}
const cqe = () => {
  const t = ve.c(2), e = Ju();
  let n;
  return t[0] !== e ? (n = {
    mutationFn: uqe,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: zh.members
      });
    }
  }, t[0] = e, t[1] = n) : n = t[1], Ei(n);
};
function uqe(t) {
  const {
    memberId: e
  } = t;
  return nqe(e);
}
const dqe = () => {
  const t = ve.c(2), e = Ju();
  let n;
  return t[0] !== e ? (n = {
    mutationFn: fqe,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: zh.current
      });
    }
  }, t[0] = e, t[1] = n) : n = t[1], Ei(n);
};
function fqe(t) {
  const {
    name: e
  } = t;
  return eqe(e);
}
const hqe = () => {
  const t = ve.c(2), e = Ju();
  let n;
  return t[0] !== e ? (n = {
    mutationFn: pqe,
    onSettled: () => {
      e.invalidateQueries({
        queryKey: zh.invitations
      });
    }
  }, t[0] = e, t[1] = n) : n = t[1], Ei(n);
};
function pqe(t) {
  const {
    invitationId: e
  } = t;
  return iqe(e);
}
const mqe = () => {
  const t = ve.c(2), e = Ju();
  let n;
  return t[0] !== e ? (n = {
    mutationFn: gqe,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: zh.invitations
      });
    }
  }, t[0] = e, t[1] = n) : n = t[1], Ei(n);
};
function gqe(t) {
  const {
    invitationId: e
  } = t;
  return aqe(e);
}
const vqe = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationFn: oqe,
    onSuccess: yqe
  }, t[0] = e) : e = t[0], Ei(e);
};
async function yqe(t) {
  t.requiresTokenRefresh && await Bee();
}
const bqe = () => {
  const t = ve.c(2), e = Ju();
  let n;
  return t[0] !== e ? (n = {
    mutationFn: wqe,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: zh.members
      });
    }
  }, t[0] = e, t[1] = n) : n = t[1], Ei(n);
};
function wqe(t) {
  const {
    memberId: e,
    role: n
  } = t;
  return tqe(e, n);
}
const xqe = Xe({
  memberId: Ve(),
  userId: Ve(),
  organizationId: Ve(),
  role: $g,
  email: Je(),
  username: Je()
}), Sqe = Xe({
  members: Xr(xqe)
}), Eqe = Xe({
  invitations: Xr(NO)
}), _qe = async () => {
  const t = await Ya.get("v2/organizations/current/members");
  return qt(Sqe, t).members;
}, Aqe = async () => {
  const t = await Ya.get("v2/organizations/current/invitations");
  return qt(Eqe, t).invitations;
}, Cqe = () => {
  const t = ve.c(5);
  let e;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    queryKey: zh.members,
    queryFn: _qe
  }, t[0] = e) : e = t[0];
  const {
    data: n,
    isLoading: r,
    error: i
  } = kh(e), a = n ?? null;
  let s;
  return t[1] !== i || t[2] !== r || t[3] !== a ? (s = {
    data: a,
    isLoading: r,
    error: i
  }, t[1] = i, t[2] = r, t[3] = a, t[4] = s) : s = t[4], s;
}, Tqe = () => {
  const t = ve.c(5);
  let e;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    queryKey: zh.invitations,
    queryFn: Aqe
  }, t[0] = e) : e = t[0];
  const {
    data: n,
    isLoading: r,
    error: i
  } = kh(e), a = n ?? null;
  let s;
  return t[1] !== i || t[2] !== r || t[3] !== a ? (s = {
    data: a,
    isLoading: r,
    error: i
  }, t[1] = i, t[2] = r, t[3] = a, t[4] = s) : s = t[4], s;
}, Oqe = Re.div`
  twd-flex
  twd-items-center
  twd-gap-2
`, C$ = Re.h2`
  twd-text-xl
  twd-font-bold
`, Rqe = Re.form`
  twd-flex
  twd-flex-col
  twd-gap-4
`, Dqe = Re.div`
  twd-flex
  twd-flex-col
  twd-gap-2
`, Nqe = (t) => {
  const e = ve.c(51), {
    name: n,
    canEdit: r
  } = t, [i, a] = I.useState(!1), {
    mutateAsync: s,
    isPending: c
  } = dqe(), d = es(), {
    showDefaultNotification: f
  } = nd(), g = n ?? "";
  let m;
  e[0] !== g ? (m = {
    name: g
  }, e[0] = g, e[1] = m) : m = e[1];
  let b;
  e[2] === Symbol.for("react.memo_cache_sentinel") ? (b = td(XHe), e[2] = b) : b = e[2];
  let w;
  e[3] !== m ? (w = {
    defaultValues: m,
    resolver: b
  }, e[3] = m, e[4] = w) : w = e[4];
  const {
    control: _,
    formState: A,
    handleSubmit: T,
    reset: O
  } = ed(w), {
    isDirty: R
  } = A;
  if (!r) {
    const J = n ?? "Organization";
    let B;
    return e[5] !== J ? (B = /* @__PURE__ */ C.jsx(C$, { children: J }), e[5] = J, e[6] = B) : B = e[6], B;
  }
  const N = n ?? "Organization";
  let M;
  e[7] !== N ? (M = /* @__PURE__ */ C.jsx(C$, { children: N }), e[7] = N, e[8] = M) : M = e[8];
  let P;
  e[9] === Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsx(lw, { className: "twd-h-4 twd-w-4" }),
    /* @__PURE__ */ C.jsx("span", { className: "twd-sr-only", children: "Rename organization" })
  ] }), e[9] = P) : P = e[9];
  let z;
  e[10] !== n || e[11] !== O ? (z = /* @__PURE__ */ C.jsx(nu, { message: "Rename organization", children: /* @__PURE__ */ C.jsx(cl, { icon: P, onClick: () => {
    O({
      name: n ?? ""
    }), a(!0);
  } }) }), e[10] = n, e[11] = O, e[12] = z) : z = e[12];
  let F;
  e[13] !== M || e[14] !== z ? (F = /* @__PURE__ */ C.jsxs(Oqe, { children: [
    M,
    z
  ] }), e[13] = M, e[14] = z, e[15] = F) : F = e[15];
  let $;
  e[16] !== n || e[17] !== O ? ($ = () => {
    O({
      name: n ?? ""
    }), a(!1);
  }, e[16] = n, e[17] = O, e[18] = $) : $ = e[18];
  let G;
  e[19] !== d || e[20] !== s || e[21] !== f ? (G = async (J) => {
    try {
      await s({
        name: J.name
      }), f("Organization name was changed!"), a(!1);
    } catch (B) {
      d(B);
    }
  }, e[19] = d, e[20] = s, e[21] = f, e[22] = G) : G = e[22];
  let H;
  e[23] !== T || e[24] !== G ? (H = T(G), e[23] = T, e[24] = G, e[25] = H) : H = e[25];
  let Z;
  e[26] !== _ ? (Z = /* @__PURE__ */ C.jsx(Zr, { name: "name", label: "Organization name", control: _, className: "twd-w-80 twd-max-w-full" }), e[26] = _, e[27] = Z) : Z = e[27];
  const V = !R;
  let Y;
  e[28] !== c || e[29] !== V ? (Y = /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", padding: "sm", isSubmit: !0, isLoading: c, isDisabled: V, children: "Save" }), e[28] = c, e[29] = V, e[30] = Y) : Y = e[30];
  let ee;
  e[31] !== n || e[32] !== O ? (ee = () => {
    O({
      name: n ?? ""
    }), a(!1);
  }, e[31] = n, e[32] = O, e[33] = ee) : ee = e[33];
  let K;
  e[34] !== c || e[35] !== ee ? (K = /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", padding: "sm", isDisabled: c, onClick: ee, children: "Cancel" }), e[34] = c, e[35] = ee, e[36] = K) : K = e[36];
  let U;
  e[37] !== Y || e[38] !== K ? (U = /* @__PURE__ */ C.jsxs(Dqe, { children: [
    Y,
    K
  ] }), e[37] = Y, e[38] = K, e[39] = U) : U = e[39];
  let q;
  e[40] !== H || e[41] !== Z || e[42] !== U ? (q = /* @__PURE__ */ C.jsxs(Rqe, { "aria-label": "Rename organization", onSubmit: H, children: [
    Z,
    U
  ] }), e[40] = H, e[41] = Z, e[42] = U, e[43] = q) : q = e[43];
  let W;
  e[44] !== i || e[45] !== $ || e[46] !== q ? (W = /* @__PURE__ */ C.jsx(Ph, { isOpen: i, title: "Rename organization", onClose: $, children: q }), e[44] = i, e[45] = $, e[46] = q, e[47] = W) : W = e[47];
  let ie;
  return e[48] !== F || e[49] !== W ? (ie = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    F,
    W
  ] }), e[48] = F, e[49] = W, e[50] = ie) : ie = e[50], ie;
}, Mqe = Re.div`
  twd-max-w-xs
  twd-space-y-4
`, Iqe = Re.div`
  twd-flex
  twd-items-center
  twd-gap-2
`, kqe = Re.div`
  twd-flex
  twd-h-8
  twd-w-8
  twd-items-center
  twd-justify-center
  twd-rounded-full
  twd-bg-success
  twd-bg-opacity-10
  twd-text-success
`, jqe = Re.div`
  twd-font-bold
`, Pqe = Re.div`
  twd-text-xs
  twd-font-bold
  twd-uppercase
  twd-text-muted-foreground
`, Lqe = Re.div`
  twd-space-y-1
`, Bqe = Re.div`
  twd-break-all
  twd-rounded
  twd-bg-secondary-light4
  twd-p-2
  twd-font-mono
  twd-text-xs
`, T$ = Re.div`
  twd-text-sm
  twd-text-muted-foreground
`, zqe = Re.div`
  twd-flex
  twd-flex-col
  twd-gap-2
`, Fqe = (t) => `${window.location.origin}/app/invitation-to-organization/${t}/`, Fee = (t) => {
  const e = ve.c(28), {
    token: n,
    expiresAt: r,
    message: i,
    onInviteAnother: a
  } = t, s = es(), {
    showDefaultNotification: c
  } = nd();
  let d;
  e[0] !== n ? (d = Fqe(n), e[0] = n, e[1] = d) : d = e[1];
  const f = d;
  let g;
  e[2] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ C.jsxs(Iqe, { children: [
    /* @__PURE__ */ C.jsx(kqe, { children: /* @__PURE__ */ C.jsx(P5, { className: "twd-h-5 twd-w-5" }) }),
    /* @__PURE__ */ C.jsx(jqe, { children: "Invitation sent" })
  ] }), e[2] = g) : g = e[2];
  let m;
  e[3] !== i ? (m = /* @__PURE__ */ C.jsx(T$, { children: i }), e[3] = i, e[4] = m) : m = e[4];
  let b;
  e[5] === Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ C.jsx(Pqe, { children: "Invitation link" }), e[5] = b) : b = e[5];
  let w;
  e[6] !== f ? (w = /* @__PURE__ */ C.jsx(Bqe, { children: f }), e[6] = f, e[7] = w) : w = e[7];
  let _;
  e[8] !== r ? (_ = new Date(r).toLocaleString(), e[8] = r, e[9] = _) : _ = e[9];
  let A;
  e[10] !== _ ? (A = /* @__PURE__ */ C.jsxs(T$, { children: [
    "Expires ",
    _,
    "."
  ] }), e[10] = _, e[11] = A) : A = e[11];
  let T;
  e[12] !== w || e[13] !== A ? (T = /* @__PURE__ */ C.jsxs(Lqe, { children: [
    b,
    w,
    A
  ] }), e[12] = w, e[13] = A, e[14] = T) : T = e[14];
  let O;
  e[15] !== s || e[16] !== f || e[17] !== c ? (O = /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", onClick: async () => {
    try {
      await navigator.clipboard.writeText(f), c("Invitation link was copied to the clipboard");
    } catch (P) {
      s(P);
    }
  }, children: "Copy link" }), e[15] = s, e[16] = f, e[17] = c, e[18] = O) : O = e[18];
  let R;
  e[19] !== a ? (R = a != null && /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", onClick: a, children: "Invite another member" }), e[19] = a, e[20] = R) : R = e[20];
  let N;
  e[21] !== R || e[22] !== O ? (N = /* @__PURE__ */ C.jsxs(zqe, { children: [
    O,
    R
  ] }), e[21] = R, e[22] = O, e[23] = N) : N = e[23];
  let M;
  return e[24] !== N || e[25] !== m || e[26] !== T ? (M = /* @__PURE__ */ C.jsxs(Mqe, { children: [
    g,
    m,
    T,
    N
  ] }), e[24] = N, e[25] = m, e[26] = T, e[27] = M) : M = e[27], M;
}, Vqe = Re.div`
  twd-space-y-2
`, Uqe = Re.form`
  twd-flex
  twd-max-w-xs
  twd-flex-col
  twd-items-stretch
  twd-gap-2
`, $qe = () => {
  const t = ve.c(22), [e, n] = I.useState(!1), [r, i] = I.useState(null), {
    mutateAsync: a,
    isPending: s
  } = sqe(), c = es();
  let d;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (d = {
    defaultValues: {
      email: "",
      role: "assistant"
    },
    resolver: td(YHe)
  }, t[0] = d) : d = t[0];
  const {
    handleSubmit: f,
    control: g,
    reset: m
  } = ed(d);
  let b;
  t[1] !== m ? (b = () => {
    n(!1), i(null), m();
  }, t[1] = m, t[2] = b) : b = t[2];
  const w = b;
  let _;
  t[3] === Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ C.jsx(q0, { size: "sm" }), t[3] = _) : _ = t[3];
  let A;
  t[4] !== m ? (A = /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", padding: "sm", icon: _, onClick: () => {
    m(), i(null), n(!0);
  }, children: "Invite Member" }), t[4] = m, t[5] = A) : A = t[5];
  const T = r != null ? "Invitation sent" : "Invite a member";
  let O;
  t[6] !== g || t[7] !== a || t[8] !== r || t[9] !== c || t[10] !== f || t[11] !== s || t[12] !== m ? (O = /* @__PURE__ */ C.jsx(Vqe, { children: r != null ? /* @__PURE__ */ C.jsx(Fee, { token: r.token, expiresAt: r.invitation.expiresAt, message: "The invitation email has been sent. You can copy the invitation link below and send it manually if needed.", onInviteAnother: () => {
    i(null), m();
  } }) : /* @__PURE__ */ C.jsxs(Uqe, { onSubmit: f(async (M) => {
    try {
      const P = M.email.trim(), z = await a({
        email: P,
        role: M.role
      });
      i(z), m();
    } catch (P) {
      c(P);
    }
  }), children: [
    /* @__PURE__ */ C.jsx(Zr, { name: "email", label: "Email", control: g }),
    /* @__PURE__ */ C.jsxs(Qb, { name: "role", label: "Role", control: g, isFullWidth: !0, children: [
      /* @__PURE__ */ C.jsx("option", { value: "assistant", children: "Assistant" }),
      /* @__PURE__ */ C.jsx("option", { value: "admin", children: "Administrator" })
    ] }),
    /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", isSubmit: !0, isLoading: s, children: "Invite" })
  ] }) }), t[6] = g, t[7] = a, t[8] = r, t[9] = c, t[10] = f, t[11] = s, t[12] = m, t[13] = O) : O = t[13];
  let R;
  t[14] !== w || t[15] !== e || t[16] !== T || t[17] !== O ? (R = /* @__PURE__ */ C.jsx(Ph, { isOpen: e, title: T, onClose: w, children: O }), t[14] = w, t[15] = e, t[16] = T, t[17] = O, t[18] = R) : R = t[18];
  let N;
  return t[19] !== A || t[20] !== R ? (N = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    A,
    R
  ] }), t[19] = A, t[20] = R, t[21] = N) : N = t[21], N;
}, Hqe = Re.span`
  twd-font-medium
`, qqe = Re.span`
  twd-ml-1
  twd-text-muted-foreground
`, Gqe = Re.span`
  twd-text-sm
  twd-text-muted-foreground
`, Vee = Re.span`
  twd-px-2
`, Yqe = {
  admin: "Administrator",
  assistant: "Assistant"
}, Xqe = (t) => {
  const e = ve.c(6), {
    rows: n
  } = t;
  let r;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ C.jsx(wi, { children: "Email" }), e[0] = r) : r = e[0];
  let i;
  e[1] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ C.jsx(Lg, { children: /* @__PURE__ */ C.jsxs(rf, { className: "hover:twd-bg-transparent", children: [
    r,
    /* @__PURE__ */ C.jsx(wi, { children: /* @__PURE__ */ C.jsx(Vee, { children: "Role" }) }),
    /* @__PURE__ */ C.jsx(wi, { children: "Status" }),
    /* @__PURE__ */ C.jsx(wi, {})
  ] }) }), e[1] = i) : i = e[1];
  let a;
  e[2] !== n ? (a = n.map(Wqe), e[2] = n, e[3] = a) : a = e[3];
  let s;
  return e[4] !== a ? (s = /* @__PURE__ */ C.jsxs(Pg, { className: "twd-whitespace-nowrap", children: [
    i,
    /* @__PURE__ */ C.jsx(Bg, { children: a })
  ] }), e[4] = a, e[5] = s) : s = e[5], s;
};
function Wqe(t) {
  return /* @__PURE__ */ C.jsxs(rf, { children: [
    /* @__PURE__ */ C.jsxs(Ir, { children: [
      /* @__PURE__ */ C.jsx(Hqe, { children: t.email }),
      t.isOwnerRow === !0 && /* @__PURE__ */ C.jsx(qqe, { children: "(owner)" })
    ] }),
    /* @__PURE__ */ C.jsx(Ir, { children: t.roleControl ?? /* @__PURE__ */ C.jsx(Vee, { children: Yqe[t.role] }) }),
    /* @__PURE__ */ C.jsxs(Ir, { children: [
      t.status,
      t.meta != null && /* @__PURE__ */ C.jsxs(Gqe, { children: [
        " · ",
        t.meta
      ] })
    ] }),
    /* @__PURE__ */ C.jsx(Ir, { children: t.actions })
  ] }, t.key);
}
const O$ = Re.div`
  twd-relative
  twd-min-h-12
  twd-space-y-2
`, Qqe = Re.h3`
  twd-text-lg
  twd-font-bold
`, Zqe = Re.select`
  twd-rounded
  twd-px-1
  twd-py-0.5
`, Kqe = "Resend Email", Jqe = (t, e) => t === e ? "owner" : "member", eGe = (t) => {
  const e = ve.c(50), {
    currentUserId: n,
    organizationOwnerId: r
  } = t, [i, a] = I.useState(null), {
    data: s,
    isLoading: c,
    error: d
  } = Cqe(), {
    data: f,
    isLoading: g,
    error: m
  } = Tqe(), {
    mutateAsync: b
  } = bqe(), {
    mutateAsync: w
  } = cqe(), {
    mutateAsync: _,
    isPending: A
  } = hqe(), {
    mutateAsync: T
  } = mqe(), O = es(), {
    showDefaultNotification: R
  } = nd();
  if (c || g) {
    let K;
    return e[0] === Symbol.for("react.memo_cache_sentinel") ? (K = /* @__PURE__ */ C.jsx(O$, { children: /* @__PURE__ */ C.jsx(aa, {}) }), e[0] = K) : K = e[0], K;
  }
  if (d != null || m != null) {
    let K;
    return e[1] === Symbol.for("react.memo_cache_sentinel") ? (K = /* @__PURE__ */ C.jsx("div", { role: "alert", children: /* @__PURE__ */ C.jsx(ZE, { variant: "error", children: "Unable to load organization members and invitations." }) }), e[1] = K) : K = e[1], K;
  }
  let N, M, P, z;
  if (e[2] !== n || e[3] !== O || e[4] !== f || e[5] !== A || e[6] !== s || e[7] !== r || e[8] !== w || e[9] !== _ || e[10] !== T || e[11] !== R || e[12] !== b) {
    let K;
    e[17] !== n ? (K = (J, B) => +(B.userId === n) - +(J.userId === n), e[17] = n, e[18] = K) : K = e[18];
    let U;
    e[19] !== n || e[20] !== O || e[21] !== r || e[22] !== w || e[23] !== R || e[24] !== b ? (U = (J) => {
      const B = J.userId === n;
      return {
        key: `member-${J.memberId}`,
        email: J.email,
        role: J.role,
        status: Jqe(J.userId, r),
        isOwnerRow: B,
        roleControl: B ? null : /* @__PURE__ */ C.jsxs(Zqe, { value: J.role, onChange: async (te) => {
          try {
            await b({
              memberId: J.memberId,
              role: te.target.value
            }), R("Role has been changed! The member must sign in again to apply it.");
          } catch (ae) {
            O(ae);
          }
        }, children: [
          /* @__PURE__ */ C.jsx("option", { value: "admin", children: "Administrator" }),
          /* @__PURE__ */ C.jsx("option", { value: "assistant", children: "Assistant" })
        ] }),
        actions: B ? null : /* @__PURE__ */ C.jsx(qu, { title: "Remove member?", description: "The member will lose access to all devices and projects of the organization.", confirmLabel: "Remove", confirmVariant: "error", trigger: /* @__PURE__ */ C.jsx(cl, { icon: /* @__PURE__ */ C.jsx(Yb, { className: "twd-h-4 twd-w-4" }), className: "twd-text-error", title: "Remove member", "aria-label": "Remove member" }), onConfirm: async () => {
          try {
            await w({
              memberId: J.memberId
            }), R("Member was removed!");
          } catch (te) {
            O(te);
          }
        } })
      };
    }, e[19] = n, e[20] = O, e[21] = r, e[22] = w, e[23] = R, e[24] = b, e[25] = U) : U = e[25];
    const q = [...s ?? []].sort(K).map(U);
    let W;
    e[26] !== O || e[27] !== A || e[28] !== _ || e[29] !== T || e[30] !== R ? (W = (J) => ({
      key: `invitation-${J.id}`,
      email: J.email,
      role: J.role,
      status: "invited",
      meta: `expires ${new Date(J.expiresAt).toLocaleString()}`,
      actions: /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
        /* @__PURE__ */ C.jsx(qu, { title: "Resend invitation?", description: "A new invitation link will be sent. The current link will stop working.", confirmLabel: "Resend", trigger: /* @__PURE__ */ C.jsx(Vt, { icon: /* @__PURE__ */ C.jsx(OY, { className: "twd-h-4 twd-w-4" }), isDisabled: A, children: Kqe }), loading: A, onConfirm: async () => {
          try {
            const B = await _({
              invitationId: J.id
            });
            a(B), R("The invitation email has been sent again.");
          } catch (B) {
            O(B);
          }
        } }),
        /* @__PURE__ */ C.jsx(qu, { title: "Revoke invitation?", description: "The invitation link will stop working.", confirmLabel: "Revoke", confirmVariant: "error", trigger: /* @__PURE__ */ C.jsx(cl, { icon: /* @__PURE__ */ C.jsx(Yb, { className: "twd-h-4 twd-w-4" }), className: "twd-text-error", title: "Revoke invitation", "aria-label": "Revoke invitation" }), onConfirm: async () => {
          try {
            await T({
              invitationId: J.id
            }), R("Invitation was revoked!");
          } catch (B) {
            O(B);
          }
        } })
      ] })
    }), e[26] = O, e[27] = A, e[28] = _, e[29] = T, e[30] = R, e[31] = W) : W = e[31];
    const ie = (f ?? []).map(W);
    M = O$, e[32] === Symbol.for("react.memo_cache_sentinel") ? (z = /* @__PURE__ */ C.jsx(Qqe, { children: "Members" }), e[32] = z) : z = e[32], N = Xqe, P = [...q, ...ie], e[2] = n, e[3] = O, e[4] = f, e[5] = A, e[6] = s, e[7] = r, e[8] = w, e[9] = _, e[10] = T, e[11] = R, e[12] = b, e[13] = N, e[14] = M, e[15] = P, e[16] = z;
  } else
    N = e[13], M = e[14], P = e[15], z = e[16];
  let F;
  e[33] !== N || e[34] !== P ? (F = /* @__PURE__ */ C.jsx(N, { rows: P }), e[33] = N, e[34] = P, e[35] = F) : F = e[35];
  let $;
  e[36] !== M || e[37] !== z || e[38] !== F ? ($ = /* @__PURE__ */ C.jsxs(M, { children: [
    z,
    F
  ] }), e[36] = M, e[37] = z, e[38] = F, e[39] = $) : $ = e[39];
  let G;
  e[40] === Symbol.for("react.memo_cache_sentinel") ? (G = /* @__PURE__ */ C.jsx($qe, {}), e[40] = G) : G = e[40];
  const H = i != null;
  let Z;
  e[41] === Symbol.for("react.memo_cache_sentinel") ? (Z = () => a(null), e[41] = Z) : Z = e[41];
  let V;
  e[42] !== i ? (V = i == null ? /* @__PURE__ */ C.jsx(C.Fragment, {}) : /* @__PURE__ */ C.jsx(Fee, { token: i.token, expiresAt: i.invitation.expiresAt, message: "The invitation email has been sent again. You can copy the new invitation link below and send it manually if needed." }), e[42] = i, e[43] = V) : V = e[43];
  let Y;
  e[44] !== H || e[45] !== V ? (Y = /* @__PURE__ */ C.jsx(Ph, { isOpen: H, title: "Invitation sent", onClose: Z, children: V }), e[44] = H, e[45] = V, e[46] = Y) : Y = e[46];
  let ee;
  return e[47] !== $ || e[48] !== Y ? (ee = /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    $,
    G,
    Y
  ] }), e[47] = $, e[48] = Y, e[49] = ee) : ee = e[49], ee;
}, HD = vr("LeaveOrganization"), tGe = Re.div`
  twd-space-y-3
  twd-rounded
  twd-border
  twd-p-4
`, nGe = Re.h3`
  twd-text-lg
  twd-font-bold
`, rGe = Re.div`
  twd-rounded
  twd-bg-destructive/10
  twd-p-3
`, iGe = () => {
  const [t, e] = I.useState(!1), [n, r] = I.useState(!1), [i, a] = I.useState(!1), {
    mutateAsync: s,
    isPending: c
  } = vqe(), d = es(), f = async () => {
    a(!0);
    try {
      await Bee();
    } catch (g) {
      HD.error("Personal organization session refresh retry failed", {
        error: g
      });
    } finally {
      a(!1);
    }
  };
  return n ? /* @__PURE__ */ C.jsxs(tGe, { children: [
    /* @__PURE__ */ C.jsx(nGe, { children: "Organization left" }),
    /* @__PURE__ */ C.jsx(rGe, { children: ks(qb.leaveSessionRefreshFailed) }),
    /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", isLoading: i, onClick: f, children: "Retry session refresh" })
  ] }) : /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsx(nu, { message: "If you leave the organization, you will be redirected to your default (personal) organization.", children: /* @__PURE__ */ C.jsx(Vt, { variant: "error", isDisabled: c, onClick: () => e(!0), children: "Leave organization" }) }),
    /* @__PURE__ */ C.jsx(qu, { open: t, onOpenChange: e, title: "Leave organization?", description: "You will lose access to the devices and projects of this organization and will be redirected to your default (personal) organization.", confirmLabel: "Leave", confirmVariant: "error", loading: c, onConfirm: async () => {
      try {
        await s();
      } catch (g) {
        if (g instanceof Lee) {
          HD.error("Organization left but session refresh failed", {
            error: g
          }), r(!0);
          return;
        }
        try {
          d(g);
        } catch (m) {
          HD.error("Failed to leave organization", {
            error: m
          });
        }
      }
    } })
  ] });
}, aGe = (t) => t.organizationOwnerId != null && t.userId === t.organizationOwnerId, oGe = Xe({
  memberId: Ve(),
  userId: Ve(),
  organizationId: Ve(),
  role: $g,
  organizationName: Je().nullable(),
  organizationOwnerId: Ve().nullable()
}), sGe = Xe({
  context: oGe
}), lGe = async () => {
  const t = await Ya.get("v2/organizations/current");
  return qt(sGe, t).context;
}, cGe = () => {
  const t = ve.c(5);
  let e;
  t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    queryKey: zh.current,
    queryFn: lGe
  }, t[0] = e) : e = t[0];
  const {
    data: n,
    isLoading: r,
    error: i
  } = kh(e), a = n ?? null;
  let s;
  return t[1] !== i || t[2] !== r || t[3] !== a ? (s = {
    data: a,
    isLoading: r,
    error: i
  }, t[1] = i, t[2] = r, t[3] = a, t[4] = s) : s = t[4], s;
}, uGe = Re.div`
  twd-space-y-6
`, dGe = () => {
  const t = ve.c(14), {
    data: e,
    isLoading: n,
    error: r
  } = cGe();
  if (n) {
    let f;
    return t[0] === Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ C.jsx(aa, { className: "twd-flex twd-min-h-64 twd-flex-col twd-items-center twd-justify-center" }), t[0] = f) : f = t[0], f;
  }
  if (r != null || e == null) {
    let f;
    return t[1] === Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ C.jsx(ZE, { variant: "error", children: "Can not get your organization!" }), t[1] = f) : f = t[1], f;
  }
  let i;
  t[2] !== e ? (i = aGe(e), t[2] = e, t[3] = i) : i = t[3];
  const a = i;
  let s;
  t[4] !== a || t[5] !== e.organizationName ? (s = /* @__PURE__ */ C.jsx(Nqe, { name: e.organizationName, canEdit: a }), t[4] = a, t[5] = e.organizationName, t[6] = s) : s = t[6];
  let c;
  t[7] !== a || t[8] !== e.organizationOwnerId || t[9] !== e.userId ? (c = a ? /* @__PURE__ */ C.jsx(eGe, { currentUserId: e.userId, organizationOwnerId: e.organizationOwnerId }) : /* @__PURE__ */ C.jsx(iGe, {}), t[7] = a, t[8] = e.organizationOwnerId, t[9] = e.userId, t[10] = c) : c = t[10];
  let d;
  return t[11] !== s || t[12] !== c ? (d = /* @__PURE__ */ C.jsxs(uGe, { children: [
    s,
    c
  ] }), t[11] = s, t[12] = c, t[13] = d) : d = t[13], d;
}, XGe = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ C.jsx(dGe, {}), t[0] = e) : e = t[0], e;
}, Uee = lf.subclass("InvitationSessionRefreshError"), $ee = async () => {
  try {
    await Pee();
  } catch (t) {
    throw new Uee(ks(qb.joinSessionRefreshFailed), {
      cause: t
    });
  }
}, fGe = Xe({
  organizationName: Je().nullable(),
  email: Je(),
  role: $g,
  expiresAt: Je()
}), hGe = Xe({
  memberId: Ve(),
  userId: Ve(),
  organizationId: Ve(),
  role: $g
}), pGe = Xe({
  preview: fGe
}), mGe = Xe({
  invitation: NO,
  member: hGe,
  requiresTokenRefresh: Sr()
}), b5 = vr("apiOrganizationJoin"), gGe = async (t) => {
  b5.debug("Requesting organization invitation preview");
  const e = await Ya.get("v2/organization-invitations/preview", {
    headers: {
      "is-guest-request": "true"
    },
    queryParams: {
      token: t
    }
  }), n = qt(pGe, e).preview;
  return b5.debug("Organization invitation preview received"), n;
}, vGe = async (t) => {
  b5.info("Accepting organization invitation");
  const e = await Ya.post("v2/organization-invitations/accept", {
    token: t
  }), n = qt(mGe, e);
  return b5.info("Organization invitation accepted", {
    memberId: n.member.memberId,
    organizationId: n.member.organizationId
  }), n;
}, Hee = vr("useAcceptInvitation"), yGe = () => {
  const t = ve.c(1);
  let e;
  return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = {
    mutationFn: bGe,
    onSuccess: wGe,
    onError: xGe
  }, t[0] = e) : e = t[0], Ei(e);
};
function bGe(t) {
  const {
    token: e
  } = t;
  return vGe(e);
}
async function wGe(t) {
  t.requiresTokenRefresh && (Hee.info("Refreshing tokens after organization invitation acceptance"), await $ee());
}
function xGe(t) {
  Hee.error("Failed to accept organization invitation", {
    error: t
  });
}
const SGe = vr("useInvitationPreview"), EGe = (t) => {
  const e = ve.c(6);
  let n;
  e[0] !== t ? (n = {
    queryKey: ["organization", "invitation-preview", t],
    queryFn: async () => {
      try {
        return await gGe(t);
      } catch (d) {
        const f = d;
        throw SGe.warn("Failed to load organization invitation preview", {
          error: f
        }), f;
      }
    },
    retry: !1
  }, e[0] = t, e[1] = n) : n = e[1];
  const {
    data: r,
    isLoading: i,
    error: a
  } = kh(n), s = r ?? null;
  let c;
  return e[2] !== a || e[3] !== i || e[4] !== s ? (c = {
    data: s,
    isLoading: i,
    error: a
  }, e[2] = a, e[3] = i, e[4] = s, e[5] = c) : c = e[5], c;
}, YS = vr("JoinOrganization"), qD = Re.div`
  twd-mx-auto
  twd-max-w-md
  twd-space-y-4
  twd-rounded
  twd-border
  twd-p-6
`, GD = Re.h2`
  twd-text-xl
  twd-font-bold
`, _Ge = Re.div`
  twd-space-y-2
`, R$ = Re.div`
  twd-flex
  twd-justify-between
  twd-gap-2
`, D$ = Re.span`
  twd-text-muted-foreground
`, N$ = Re.div`
  twd-flex
  twd-gap-2
`, YD = Re.div`
  twd-rounded
  twd-bg-destructive/10
  twd-p-3
`, AGe = ({
  token: t
}) => {
  const [e, n] = I.useState(null), [r, i] = I.useState(!1), [a, s] = I.useState(!1), {
    data: c,
    isLoading: d,
    error: f
  } = EGe(t), {
    mutateAsync: g,
    isPending: m
  } = yGe(), b = es(), w = kG(), _ = co.getUserId() != null;
  if (d)
    return /* @__PURE__ */ C.jsx(aa, { className: "twd-flex twd-min-h-64 twd-flex-col twd-items-center twd-justify-center" });
  if (f != null || c == null)
    return /* @__PURE__ */ C.jsxs(qD, { children: [
      /* @__PURE__ */ C.jsx(GD, { children: "Invitation" }),
      /* @__PURE__ */ C.jsx(YD, { children: "This invitation is invalid, expired, or was revoked." })
    ] });
  const A = async () => {
    if (!_) {
      YS.info("Redirecting anonymous invitation visitor to login");
      const O = encodeURIComponent(window.location.href);
      w(`/auth/login?referer=${O}`);
      return;
    }
    n(null);
    try {
      await g({
        token: t
      });
    } catch (O) {
      if (O instanceof Uee) {
        YS.error("Invitation accepted but session refresh failed", {
          error: O
        }), i(!0);
        return;
      }
      if (O instanceof Ng && O.data.code === UE.NOT_FOUND) {
        YS.warn("Invitation was not found during acceptance"), n("This invitation is no longer valid, or it may have been issued for a different account.");
        return;
      }
      YS.error("Invitation acceptance failed", {
        error: O
      }), b(O);
    }
  }, T = async () => {
    s(!0);
    try {
      await $ee();
    } catch (O) {
      YS.error("Invitation session refresh retry failed", {
        error: O
      });
    } finally {
      s(!1);
    }
  };
  return r ? /* @__PURE__ */ C.jsxs(qD, { children: [
    /* @__PURE__ */ C.jsx(GD, { children: "Invitation accepted" }),
    /* @__PURE__ */ C.jsx(YD, { children: ks(qb.joinSessionRefreshFailed) }),
    /* @__PURE__ */ C.jsx(N$, { children: /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", isLoading: a, onClick: T, children: "Retry session refresh" }) })
  ] }) : /* @__PURE__ */ C.jsxs(qD, { children: [
    /* @__PURE__ */ C.jsxs(GD, { children: [
      "Invitation to ",
      c.organizationName ?? "organization"
    ] }),
    /* @__PURE__ */ C.jsxs(_Ge, { children: [
      /* @__PURE__ */ C.jsxs(R$, { children: [
        /* @__PURE__ */ C.jsx(D$, { children: "Invited email" }),
        /* @__PURE__ */ C.jsx("span", { children: c.email })
      ] }),
      /* @__PURE__ */ C.jsxs(R$, { children: [
        /* @__PURE__ */ C.jsx(D$, { children: "Role" }),
        /* @__PURE__ */ C.jsx("span", { children: c.role })
      ] })
    ] }),
    e != null && /* @__PURE__ */ C.jsx(YD, { children: e }),
    /* @__PURE__ */ C.jsxs(N$, { children: [
      /* @__PURE__ */ C.jsx(Vt, { variant: "primaryContained", isLoading: m, onClick: A, children: "Accept" }),
      /* @__PURE__ */ C.jsx(Vt, { variant: "secondary", isDisabled: m, onClick: () => w("/devices"), children: "Decline" })
    ] })
  ] });
}, CGe = (t) => {
  const e = ve.c(2), {
    token: n
  } = t;
  let r;
  return e[0] !== n ? (r = /* @__PURE__ */ C.jsx(AGe, { token: n }), e[0] = n, e[1] = r) : r = e[1], r;
}, WGe = (t) => {
  const e = ve.c(2), {
    token: n
  } = t;
  let r;
  return e[0] !== n ? (r = /* @__PURE__ */ C.jsx(CGe, { token: n }), e[0] = n, e[1] = r) : r = e[1], r;
};
export {
  MGe as Account,
  $Ge as CalibrationPanel,
  HGe as CalibrationReport,
  YGe as DevicesPage,
  IGe as Faq,
  LGe as MethodModal,
  BGe as MethodPreview,
  XGe as Organization,
  WGe as OrganizationJoin,
  Do as ReactManager,
  lhe as RenderingEnvironmentProvider,
  GGe as SequenceReport,
  qGe as SequenceResults,
  kGe as WifiCredentialsGenerator,
  nI as useRenderingEnvironment
};
